(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["Zakeke"] = factory(require("react"), require("styled-components"));
	else
		root["Zakeke"] = factory(root["react"], root["styled-components"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_styled_components__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../../../../node_modules/axios/index.js":
/*!**************************************************!*\
  !*** ../../../../../node_modules/axios/index.js ***!
  \**************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! ./lib/axios */ "../../../../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../../../../node_modules/axios/lib/adapters/xhr.js":
/*!*************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/adapters/xhr.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "../../../../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "../../../../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "../../../../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "../../../../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "../../../../../node_modules/axios/lib/core/createError.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "../../../../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/axios.js":
/*!******************************************************!*\
  !*** ../../../../../node_modules/axios/lib/axios.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "../../../../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "../../../../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__(/*! ./defaults */ "../../../../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "../../../../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "../../../../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "../../../../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "../../../../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/cancel/Cancel.js":
/*!**************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/cancel/Cancel.js ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/cancel/CancelToken.js":
/*!*******************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/cancel/CancelToken.js ***!
  \*******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "../../../../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/cancel/isCancel.js":
/*!****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/cancel/isCancel.js ***!
  \****************************************************************/
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/Axios.js":
/*!***********************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/Axios.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var defaults = __webpack_require__(/*! ./../defaults */ "../../../../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "../../../../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "../../../../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/InterceptorManager.js":
/*!************************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/InterceptorManager.js ***!
  \************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/createError.js":
/*!*****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/createError.js ***!
  \*****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "../../../../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/dispatchRequest.js":
/*!*********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/dispatchRequest.js ***!
  \*********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "../../../../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "../../../../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "../../../../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ "../../../../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ "../../../../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/enhanceError.js":
/*!******************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/enhanceError.js ***!
  \******************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/settle.js":
/*!************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/settle.js ***!
  \************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "../../../../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/core/transformData.js":
/*!*******************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/core/transformData.js ***!
  \*******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/defaults.js":
/*!*********************************************************!*\
  !*** ../../../../../node_modules/axios/lib/defaults.js ***!
  \*********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "../../../../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "../../../../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "../../../../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/bind.js":
/*!*************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/bind.js ***!
  \*************************************************************/
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/buildURL.js":
/*!*****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/buildURL.js ***!
  \*****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/combineURLs.js":
/*!********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/combineURLs.js ***!
  \********************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/cookies.js":
/*!****************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/cookies.js ***!
  \****************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!**********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \**********************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!************************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/*!****************************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \****************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "../../../../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/parseHeaders.js":
/*!*********************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/parseHeaders.js ***!
  \*********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/helpers/spread.js":
/*!***************************************************************!*\
  !*** ../../../../../node_modules/axios/lib/helpers/spread.js ***!
  \***************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../../../../node_modules/axios/lib/utils.js":
/*!******************************************************!*\
  !*** ../../../../../node_modules/axios/lib/utils.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "../../../../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__(/*! is-buffer */ "../../../../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../../../../node_modules/is-buffer/index.js":
/*!******************************************************!*\
  !*** ../../../../../node_modules/is-buffer/index.js ***!
  \******************************************************/
/***/ ((module) => {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ "../../../../../node_modules/lodash/lodash.js":
/*!****************************************************!*\
  !*** ../../../../../node_modules/lodash/lodash.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx":
/*!*********************************************************************!*\
  !*** ../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DesignPriceCalculatorRuleBased: () => (/* binding */ DesignPriceCalculatorRuleBased),
/* harmony export */   DesignPriceCalculatorRuleFactory: () => (/* binding */ DesignPriceCalculatorRuleFactory)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../../../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../../../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/rectangle */ "../../utils/rectangle.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var PricingElements = /*#__PURE__*/function (PricingElements) {
  PricingElements[PricingElements["Tutti"] = 1] = "Tutti";
  PricingElements[PricingElements["AllElementsNoTemplateItems"] = 18] = "AllElementsNoTemplateItems";
  PricingElements[PricingElements["AllTexts"] = 8] = "AllTexts";
  PricingElements[PricingElements["AllCustomText"] = 9] = "AllCustomText";
  PricingElements[PricingElements["SingleElement"] = 10] = "SingleElement";
  PricingElements[PricingElements["AllImages"] = 11] = "AllImages";
  PricingElements[PricingElements["UploadedImages"] = 12] = "UploadedImages";
  PricingElements[PricingElements["AllTextArt"] = 13] = "AllTextArt";
  PricingElements[PricingElements["AllCustomTextArt"] = 14] = "AllCustomTextArt";
  PricingElements[PricingElements["AllCustomElements"] = 15] = "AllCustomElements";
  PricingElements[PricingElements["ClipartImages"] = 16] = "ClipartImages";
  PricingElements[PricingElements["TemplatesImages"] = 17] = "TemplatesImages";
  PricingElements[PricingElements["OnlyVectorImages"] = 19] = "OnlyVectorImages";
  PricingElements[PricingElements["OnlyRasterImages"] = 20] = "OnlyRasterImages";
  return PricingElements;
}(PricingElements || {});
var operatorsFunctions = function operatorsFunctions(operator) {
  var _find;
  var func = (_find = [{
    operator: '>',
    func: function func(a, b) {
      return a > b;
    }
  }, {
    operator: '<',
    func: function func(a, b) {
      return a < b;
    }
  }, {
    operator: '=',
    func: function func(a, b) {
      return a == b;
    }
  }, {
    operator: '>=',
    func: function func(a, b) {
      return a >= b;
    }
  }, {
    operator: '<=',
    func: function func(a, b) {
      return a <= b;
    }
  }, {
    operator: '!=',
    func: function func(a, b) {
      return a != b;
    }
  }].find(function (of) {
    return of.operator == operator;
  })) === null || _find === void 0 ? void 0 : _find.func;
  if (func == null) throw new Error("Function  for operator ".concat(operator, " not found"));
  return func;
};
// type PricingRuleConditionsModel = Pick<pricing_model['rules'][0], 'conditions'>;
// type PricingRuleConditionModel = Pick<PricingRuleConditionsModel[0],''>;

var DesignPriceCalculatorRuleFactory = /*#__PURE__*/_createClass(function DesignPriceCalculatorRuleFactory() {
  _classCallCheck(this, DesignPriceCalculatorRuleFactory);
});
_defineProperty(DesignPriceCalculatorRuleFactory, "create", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(product, apiUrl, token, isOwin, cloudFlareApiUrl, clientLang) {
    var calculator;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          calculator = new DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl, clientLang);
          _context2.next = 3;
          return calculator.init(product)["catch"](function (e) {
            return console.log(e);
          });
        case 3:
          return _context2.abrupt("return", calculator);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}());
var DesignPriceCalculatorRuleBased = /*#__PURE__*/_createClass(function DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl, clientLang) {
  var _this = this;
  _classCallCheck(this, DesignPriceCalculatorRuleBased);
  _defineProperty(this, "colorID", -1);
  _defineProperty(this, "config", {
    isOwin: true,
    apiUrl: 'https://test-api.zakeke.com/api/graphql',
    cloudFlareApiUrl: null,
    token: 'Gw6IL2Q7e66r3osC16_T6XSlsrnuUAHmw59Y3-qJv2LaPPV-nuzDkC0eOGAU8ef_i94HLlu8vDVXpk9MAWBtwrXWN7_XizPAeIfKXArfol19Ek7wmZMR3zRQWwHChqPmYDJMrI3WeCIQGRJxsR7q8hh5xywTqdOwVi6LT7_8-qP9jkc_tdBUPiMUrT6HI1i1ygnEGEk6Eoa97zvbVGRE3NRt-W5nXKGv4_INB_VBdpOihHVXIzl7PtchqPyBr7AaW5Hdrbh_KoFwEhLTcTixXpxfzOcjecbyqFHw20fNFlg2ny6Cb375i7hpnFWD7Q4lj9xI3R6jbkpFHsQEFfBK-UF1f9vli0liCWQ3WdAYGQEmUYx7QjCy240GuR_cK6c28JHoabSGQdW91K7KEAug4o19nokKfzbWoZM7WD4T4RVXNB_ob_gjeYKsK7EJIt6qGiPpnJEbSeFCjz1EhE31Jw6MO-oawNSASxgYk1D6Z3XkLw1G',
    clientLang: null
  });
  _defineProperty(this, "init", function (product) {
    _this.product = product;
    return new Promise(function (resolve, reject) {
      try {
        _this.getPricings(product, function (pricings, properties) {
          _this.pricings = pricings;
          _this.properties = properties;
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  });
  _defineProperty(this, "getPricings", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(product, callback) {
      var query, axiosConfig, requestData, responseCF, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.pricings) {
              _context.next = 4;
              break;
            }
            callback(_this.pricings, _this.properties);
            _context.next = 30;
            break;
          case 4:
            query = {
              name: 'pricingsConfigurationQuery',
              query: "query pricingsQuery($first: Int!, $productID: Long!, $languageCulture: String) {\n                                    pricingProperties { propertyID functionName }\n                                    pricingsDetailed(first: $first, productID: $productID, isForFrontEnd: true, languageCulture: $languageCulture) {\n                                        edges {\n                                            node {\n                                                id\n                                                description\n                                                infoPricingText\n                                                priceDescriptionEnabled\n                                                priceStructure\n                                                products {\n                                                    productID\n                                                }\n                                                printTypes {\n                                                    printTypeID\n                                                }\n                                                rules {\n                                                    ruleID\n                                                    propertyID\n                                                    allMatchType\n                                                    elementID\n                                                    elementTitle\n                                                    isSetupPrice\n                                                    priceType\n                                                    targets {\n                                                        area\n                                                        color\n                                                        side\n                                                        targetID\n                                                    }\n                                                    conditions {\n                                                        conditionID\n                                                        formula\n                                                        position\n                                                        priceToAdd\n                                                        quantity\n                                                    }\n                                                }\n                                            }\n                                        }\n                                    }\n                                }",
              variables: {
                first: 50,
                productID: product.get('modelID'),
                languageCulture: _this.config.clientLang
              }
            };
            axiosConfig = {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              }
            };
            if (_this.config.isOwin) {
              axiosConfig['headers']['Authorization'] = 'Bearer ' + _this.config.token;
            } else {
              axiosConfig['headers']['X-Auth-Token'] = _this.config.token;
            }
            requestData = {
              type: 'POST',
              url: Zakeke.config.graphqlUrl,
              data: JSON.stringify(query),
              contentType: 'application/json',
              dataType: 'json'
            };
            if (_this.config.isOwin) {
              requestData['Authorization'] = 'Bearer ' + _this.config.token;
            } else {
              requestData['X-Auth-Token'] = _this.config.token;
            }
            _context.prev = 9;
            if (!(typeof _this.config.cloudFlareApiUrl !== 'undefined' && _this.config.cloudFlareApiUrl !== null && _this.config.cloudFlareApiUrl !== '')) {
              _context.next = 16;
              break;
            }
            _context.next = 13;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(_this.config.cloudFlareApiUrl, query, axiosConfig);
          case 13:
            responseCF = _context.sent;
            callback(responseCF.data.data.pricingsDetailed.edges.map(function (edge) {
              return edge.node;
            }), responseCF.data.data.pricingProperties);
            return _context.abrupt("return");
          case 16:
            _context.next = 20;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
          case 20:
            _context.prev = 20;
            _context.next = 23;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(Zakeke.config.graphqlUrl, query, axiosConfig);
          case 23:
            response = _context.sent;
            callback(response.data.data.pricingsDetailed.edges.map(function (edge) {
              return edge.node;
            }), response.data.data.pricingProperties);
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](20);
            console.log(_context.t1);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 18], [20, 27]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getPricing", function (design) {
    if (_this.pricings) {
      // let pricings;
      var pricingAndSideIDs;
      var pricing = _this.pricings.find(function (pricing) {
        return pricing.products.find(function (p) {
          return p.productID == _this.product.get('modelID');
        });
      });
      if (pricing && _this.colorID !== -1) {
        var sides = _this.product.get('colors').find(function (color) {
          return color.get('colorID') === _this.colorID;
        }).get('sides').map(function (side) {
          return side.get('sideID');
        });
        pricingAndSideIDs = [[pricing, sides]];
      }
      //se non trovo il pricing associato al prodotto cerco quello associato al print type

      if (!pricing && _this.colorID !== -1) {
        // if (this.colorID !== -1) {
        var sidesIDs = _this.product.get('colors').find(function (color) {
          return color.get('colorID') === _this.colorID;
        }).get('sides').map(function (side) {
          return side.get('sideID');
        });
        var sideIDsAndPrintTypesID = sidesIDs.map(function (sideID) {
          var sidePrintType = design.get('sidesPrintTypes').find(function (sPT) {
            return sPT.get('sideID') === sideID;
          });
          return [sideID, sidePrintType ? sidePrintType.get('printTypeID') : design.get('printTypeID')];
        });
        var pricingSidesMapping = new Map();
        var notRegroupedPricingAndSideIDs = [sideIDsAndPrintTypesID.map(function (sidePT) {
          var _this$pricings;
          return [sidePT[0], ((_this$pricings = _this.pricings) === null || _this$pricings === void 0 ? void 0 : _this$pricings.find(function (pricing) {
            return pricing.printTypes.find(function (p) {
              return p.printTypeID === sidePT[1];
            });
          })) || null];
        })];
        notRegroupedPricingAndSideIDs[0].forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            sideID = _ref3[0],
            pricing = _ref3[1];
          if (!pricingSidesMapping.get(pricing)) pricingSidesMapping.set(pricing, [sideID]);else {
            var value = pricingSidesMapping.get(pricing);
            value.push(sideID);
            pricingSidesMapping.set(pricing, value);
          }
        });
        pricingAndSideIDs = Array.from(pricingSidesMapping);
      }

      // if (pricingAndSideIDs) {
      // 	let firstPrice = pricingAndSideIDs[0];
      // 	if (firstPrice) this.pricing = firstPrice[0];
      // }

      return pricingAndSideIDs;
    }
  });
  _defineProperty(this, "distinct", function (value, index, self) {
    return self.indexOf(value) === index;
  });
  _defineProperty(this, "ElementSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0,
      items: pContext.items
    };

    //qui dentro il mio context contiene già tutti gli item di tipo text, image o textart (eventualmente saranno già filtrati dagli
    //elements della rule. In ogni caso il calcolo della size in cm sarà lo stesso:
    //quidni basta fare width / side.ppcm e sai i cm (width viene preso dal json del designitem)
    //e height / side.ppcm;
    //poi confronto i valore ottenuti ognuno col valore corrispondente dell'action (che quindi in questo caso ha 2 valori)

    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (formula.values == null || formula.values.length == 0) throw 'ElementSize invalid value';
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var width = myJson.data.transformsData.dimensions.width;
      var height = myJson.data.transformsData.dimensions.height;

      //qui dentro tutti i designItemAreas del'item stanno per forza sullo stesso lato, quindi basta prendere il primo
      var sideID = item.get('areas').at(0).get('sideID');
      var modelSide = pContext.sides.find(function (s) {
        return s.get('sideID') == sideID;
      });
      if (width != null && height != null && modelSide != null && modelSide.get('ppcm') > 0) {
        var itemWidth = width / modelSide.get('ppcm');
        var itemHeight = height / modelSide.get('ppcm');
        var itemArea = itemHeight * itemWidth;
        if (operatorsFunctions(formula.operator)(itemArea, formula.values[0])) {
          result.result = true;
          result.multiplier += 1;
          result.items = result.items.filter(function (x) {
            return x != item;
          });
        }
      }
    });
    return result;
  });
  _defineProperty(this, "NumberOfElementsSimplifiedFunction", function (pContext, formula) {
    return {
      result: pContext.items.length > 0,
      multiplier: pContext.items.length,
      items: pContext.items
    };
  });
  _defineProperty(this, "LinesLengthFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller

    //per ora sono escluse le textart
    var result = {
      result: false,
      multiplier: 0
    };

    //qui dentro il mio context contiene già item di tipo text (o di custom text)
    //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = '';
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();
      if (isTextArt != null && isTextArt) testo = item.get('textArt').get('text');
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
        //zero fine riga significa una riga
        var numLines = testo.split('\n').length;
        if (operatorsFunctions(formula.operator)(numLines, formula.values[0])) {
          result.result = true;
          result.multiplier += 1;
        }
      }
    });
    return result;
  });
  _defineProperty(this, "AmountOfElementsFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller

    var result = {
      result: false,
      multiplier: 0
    };

    ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
    //result.MatchedItems = items;
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (operatorsFunctions(formula.operator)(pContext.items.length, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "AmountOfUsedColorsFunction", function (pContext, formula) {
    /*, i colori sono univoci ma per elemento: devi calcolare quelli per design:
      
              esempio:
      
              immagine1 = ['rosso', 'verde']
              immagine2 = ['verde', 'giallo']
      
              effettivamente hai usato 3 colori, rosso, verde e giallo.
           */
    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
    ////a prescindere dal risultato

    // let colors: string[] = [];

    // pContext.items.forEach(item => {
    //     if (item.get('itemColors') && !isEmpty(item.get('itemColors')))
    //         colors.push(item.get('itemColors'));
    // });

    var colors = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniq)(pContext.items.filter(function (item) {
      return item.get('itemColors') && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(item.get('itemColors'));
    }).flatMap(function (item) {
      return item.get('itemColors');
    }));
    if (operatorsFunctions(formula.operator)(colors.filter(_this.distinct).length, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "CanvasSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
      var areas = pContext.sides.flatMap(function (s) {
        return s.get('areas').models;
      });
      var customizedAreas = [];

      //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
      areas.forEach(function (area) {
        //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
        if (pContext.items.filter(function (i) {
          return i.get('areas').filter(function (a) {
            return a.get('colorID') == area.getColorID() && a.get('sideID') == area.getSideID() && a.get('areaID') == area.get('areaID');
          }).length > 0;
        }).length > 0) {
          customizedAreas = [].concat(_toConsumableArray(customizedAreas), [area]);
        }
      });

      //a questo punto , per ogni area mi calcolo le misure in cm (dividendo i bound dell'area per i ppcm del side a cui appartiene
      //e eseguo la funzione con l'operatore e i due values del seller
      customizedAreas.forEach(function (area) {
        var _pContext$design, _pContext$design$get;
        var width = area.get('boundsWidth');
        var height = area.get('boundsHeight');

        // If is a resizable canvas, use the current size
        var designOptions = (_pContext$design = pContext.design) === null || _pContext$design === void 0 ? void 0 : (_pContext$design$get = _pContext$design.get('options')) === null || _pContext$design$get === void 0 ? void 0 : _pContext$design$get.find(function (x) {
          return x.get('colorID') == area.getColorID() && (x.get('sideID') === area.getSideID() || x.get('sideID') === null);
        });
        if (designOptions && designOptions.get('width') && designOptions.get('height')) {
          width = designOptions.get('width');
          height = designOptions.get('height');
        }
        var modelSide = pContext.sides.find(function (s) {
          return s.get('sideID') == area.getSideID();
        });
        if (modelSide != null && modelSide.get('ppcm') > 0) {
          var areaWidth = width / modelSide.get('ppcm');
          var areaHeight = height / modelSide.get('ppcm');

          // Round 2 decs
          areaWidth = Math.round(areaWidth * 100) / 100;
          areaHeight = Math.round(areaHeight * 100) / 100;
          if (operatorsFunctions(formula.operator)(areaWidth, formula.values[0]) && operatorsFunctions(formula.operator)(areaHeight, formula.values[1])) {
            result.result = true;
            result.multiplier += 1;
          }
        }
      });
    }
    return result;
  });
  _defineProperty(this, "DesignSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };
    var itemsArea = 0;
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
      var areas = pContext.sides.flatMap(function (s) {
        return s.get('areas').models;
      });

      //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
      areas.forEach(function (area) {
        //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
        var items = pContext.items.filter(function (i) {
          return i.get('areas').filter(function (a) {
            return a.get('colorID') == area.getColorID() && a.get('sideID') == area.getSideID() && a.get('areaID') == area.get('areaID');
          }).length > 0;
        });
        // seconda versione somma delle aree di ogni item
        var modelSide = pContext.sides.find(function (s) {
          return s.get('sideID') == area.getSideID();
        });
        if (modelSide != null && modelSide.get('ppcm') > 0) {
          var itemsRectangles = items.map(function (item) {
            var json = JSON.parse(item.get('json'))[1];
            var width = json.data.transformsData.dimensions.width;
            var height = json.data.transformsData.dimensions.height;
            var xPosition = json.data.transformsData.position.x;
            var yPosition = json.data.transformsData.position.y;
            return new _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.Rectangle(width, height, xPosition - width / 2, yPosition - height / 2);
          });
          itemsArea = itemsArea + (0,_utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.rectanglesDistinctArea)(itemsRectangles, modelSide.get('ppcm'));
          console.log('itemsArea', itemsArea);
        }
      });
    }
    if (itemsArea > 0 && operatorsFunctions(formula.operator)(itemsArea, formula.values[0])) {
      result.result = true;
      result.multiplier += 1;
    }
    return result;
  });
  _defineProperty(this, "DesignTextLengthFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };

    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il totale dei caratteri di tutto il design (quindi non sul singolo item)
    //e il valore inserito nella action dal seller

    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    var totalLength = 0;
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = '';
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();else if (isTextArt != null && isTextArt) testo = item.get('textArt').get('text');
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
        totalLength += testo.trim().split(' ').join('').replace(/(\r\n|\n|\r)/gm, '').length;
      }
    });

    //questo è un caso  in cui il moltiplicatore può essere solo zero oppure uno e i matcheditems non devono influenzare
    //l'eventuale action successiva
    if (operatorsFunctions(formula.operator)(totalLength, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "CustomizedSidesFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller

    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';

    //var modelSides = ((ModelSideInfoList)pContext["sides"]).ToList();

    var customizedSides = 0;

    //elimina il foreach
    pContext.sides.forEach(function (side) {
      //dato un certo side e un certo designItem, per sapere se quel side ha elementi personalizzati

      if (pContext.items.filter(function (item) {
        return item.get('areas').filter(function (area) {
          return area.get('sideID') == side.get('sideID');
        }).length > 0;
      }).length > 0) {
        customizedSides++;
      }
    });

    // We must check that we have at last one side to check.
    // If pContext.sides.length == 0 then this mean that the current rule is not valid for this
    // variation

    if (pContext.sides.length > 0 && operatorsFunctions(formula.operator)(customizedSides, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "TextLengthFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller

    //per ora sono escluse le textart
    var result = {
      result: false,
      multiplier: 0
    };

    //qui dentro il mio context contiene già item di tipo text (o di custom text)
    //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri

    if (!formula.values || formula.values.length == 0) throw 'values missing in formula';
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      // Newtonsoft.Json.Linq.JToken myJson =
      //                    Newtonsoft.Json.JsonConvert.DeserializeObject<List<Newtonsoft.Json.Linq.JToken>>(
      //                        item.Json)[1];
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = '';
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();else if (isTextArt != null && isTextArt) testo = item.get('textArt').get('text');
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo) && operatorsFunctions(formula.operator)(testo.trim().split(' ').join('').length, formula.values[0])) {
        result.result = true;
        result.multiplier += 1;
      }
    });
    return result;
  });
  _defineProperty(this, "conditionsToConditionsGroupByFormula", function (conditions) {
    var gb = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(conditions, function (c) {
      return c !== null && c !== void 0 && c.formula ? c === null || c === void 0 ? void 0 : c.formula : '';
    });
    return Object.keys(gb).map(function (k) {
      var _gb$k$;
      return {
        formula: k,
        position: (_gb$k$ = gb[k][0]) === null || _gb$k$ === void 0 ? void 0 : _gb$k$.position,
        conditions: gb[k]
      };
    });
  });
  _defineProperty(this, "getFunctionName", function (properties, rule) {
    try {
      return properties === null || properties === void 0 ? void 0 : properties.filter(function (p) {
        return p.propertyID == rule.propertyID;
      }).map(function (p) {
        return p.functionName;
      })[0];
    } catch (error) {
      throw "function or operator don't exist in dictionaries";
    }
  });
  // clearPricings = () => {
  // 	this.pricing = undefined;
  // 	this.pricings = undefined;
  // };
  // property functions
  // functions = [
  //     {"TextLength":  this.TextLengthFunction},
  //     {"ElementSize":  this.ElementSizeFunction},
  //     {"LinesLength":  this.LinesLengthFunction},
  //     {"AmountOfElements":  this.AmountOfElementsFunction},
  //     {"AmountOfUsedColors":  this.AmountOfUsedColorsFunction},
  //     {"CanvasSize":  this.CanvasSizeFunction},
  //     {"DesignTextLength":  this.DesignTextLengthFunction},
  //     {"CustomizedSides":  this.CustomizedSidesFunction},
  //     {"DesignSizeFunction":  this.DesignSizeFunction}, new
  // ]
  _defineProperty(this, "GetContextForRule", function (rule, product, design, sidesOnWhichThePriceIsEnabled) {
    var attributeMatchColorId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var context = {
      sides: [],
      items: [],
      design: design
    };
    var allItems = design.get('designItems').toArray();
    var selectedItems = []; // Item1, item 2, Item3, Item4

    //verifichiamo prima i targets e poi gli elements
    var colorName = ''; //ci serve per i target

    var attributeColor = attributeMatchColorId ? product.get('colors').find(function (c) {
      return c.get('colorID') == attributeMatchColorId;
    }) : null;
    var colore = product.get('colors').find(function (c) {
      return c.get('colorID') == _this.colorID;
    });
    if (colore == null || colore == undefined) return context;
    colorName = attributeColor ? attributeColor.get('name') : colore.get('name');
    var sides = colore.get('sides');
    context.sides = [];
    if (rule.targets.length == 0) {
      // Se non ho target vuol dire che non sto filtrando per nulla
      //e quindi devo prendere TUTTI gli item di TUTTO il prodotto personalizzato (a prescindere da area, lato o  variante)
      selectedItems = allItems;
      context.sides = sides.toArray();
    } else {
      rule.targets.forEach(function (target) {
        var skip = false;
        var side = null;
        var currentItems = allItems;
        // Se il target filtra per variante e la mia non corrisponde, salto completamente questo target e non aggiungo nulla ai selectedtItems
        //altrimenti per ora mi tengo tutti gli items del design (che ora stanno in sideItems)
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.color) && target.color.toLowerCase() != colorName.toLowerCase()) {
          skip = true; //continue;
        } else {
          // Add sides of this color
          var _iterator = _createForOfIteratorHelper(sides.toArray()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _side = _step.value;
              if (context.sides.indexOf(_side) === -1) context.sides.push(_side);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        // se c'è un filtro per side name selezioni gli item che stanno solo su quel side
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.side)) {
          side = sides.find(function (s) {
            return s.get('name').toLowerCase() == target.side.toLowerCase();
          });
          if (side == null || !side.get('areas')) skip = true; //continue;
          else {
            var areaItems = [];

            // All items that touches the area filter
            var filter = function filter(item, area) {
              return item.get('areas').filter(function (a) {
                return a.get('modelID') == product.get('modelID') && a.get('colorID') == area.getSide().getColor().get('colorID') && a.get('sideID') == area.getSide().get('sideID') && a.get('areaID') == area.get('areaID');
              }).length > 0;
            };
            side.get('areas').forEach(function (area) {
              areaItems = areaItems.concat(allItems.filter(function (item) {
                return filter(item, area);
              }));
            });
            currentItems = areaItems;
          }
        }

        // se c'è un filtro per area name selezioni gli item che stanno su quell'area
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.area)) {
          var _areaItems = [];

          //se ci sono due lati, e un area su ogni lato con lo stesso nome. IN questo caso li voglio tutti e due gli item
          var areas = [];
          sides.forEach(function (side) {
            areas = areas.concat(side.get('areas').filter(function (a) {
              return a.get('name').toLowerCase() == target.area.toLowerCase();
            }));
          });
          areas.forEach(function (area) {
            //currentItems potrebbe essere già filtrato per lato, altrimenti contiene tutti gli item (allItems)
            _areaItems = _toConsumableArray(currentItems.filter(function (i) {
              return i.get('areas').filter(function (a) {
                return a.get('modelID') == product.get('modelID') && a.get('colorID') == area.getSide().getColor().get('colorID') && a.get('sideID') == area.getSide().get('sideID') && a.get('areaID') == area.get('areaID');
              }).length > 0;
            }));
          });

          //raggruppiamo alla fine
          currentItems = _areaItems;
        }

        //eliminiamo eventuali duplicati (raggruppa su ItemGuid perchè su cosmos (a livello di carrello siamo ancora su cosmosDb)
        //l'itemId non esiste ancora
        // currentItems = currentItems.GroupBy(c => c.ItemGuid, (key, c) => c.FirstOrDefault()).ToList();
        if (!skip) {
          selectedItems = [].concat(_toConsumableArray(selectedItems), _toConsumableArray(currentItems));
        }
      } //fine foreach target
      );
    }

    //chiedi come mettere gli id corretti nell'enumerativo degli elemnts
    if (rule.elementID == PricingElements.AllTexts) {
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt;
      });
    } else if (rule.elementID == PricingElements.AllElementsNoTemplateItems) {
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return !j.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.AllCustomText) {
      //per gestire i vecchi casi in cui isTemplateElement non c'era: i null li considero custom
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return j.data.isTemplateElement != null && !j.data.isTemplateElement && (j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt) || j.data.isTemplateElement == null && (j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt);
      });
    } else if (rule.elementID == PricingElements.AllImages) {
      selectedItems = selectedItems.filter(function (i) {
        return i.get('imageID') > 0;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.UploadedImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return true;
        }
        return false;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.ClipartImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return false;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return false;
          return true;
        }
        return false;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.TemplatesImages) {
      selectedItems = selectedItems.filter(function (p) {
        return p.get('imageID') > 0;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.SingleElement) {
      selectedItems = selectedItems.filter(function (i) {
        return i.get('name').toLowerCase() == rule.elementTitle.toLowerCase();
      });
    } else if (rule.elementID == PricingElements.AllTextArt) {
      selectedItems = selectedItems.filter(function (p) {
        var json = JSON.parse(p.get('json'))[1];
        return json.data.isTextArt != null && json.data.isTextArt;
      });
    } else if (rule.elementID == PricingElements.AllCustomTextArt) {
      //selectedtItems = selectedtItems.Where(x => x.isTexArt == true && item.isCustom);
    } else if (rule.elementID == PricingElements.AllCustomElements) {
      selectedItems = selectedItems.filter(function (p) {
        var json = JSON.parse(p.get('json'))[1];
        return p.get('imageID') > 0 && !json.data.isTemplateElement && (p.get('imageVisitorCode') || p.get('imageCustomerCode') || p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) || json.data.isTemplateElement != null && !json.data.isTemplateElement && (json.data.isText != null && json.data.isText || json.data.isTextArea != null && json.data.isTextArea || json.data.isTextOnPath != null && json.data.isTextOnPath || json.data.isTextArt != null && json.data.isTextArt) || json.data.isTemplateElement == null && (json.data.isText != null && json.data.isText || json.data.isTextArea != null && json.data.isTextArea || json.data.isTextOnPath != null && json.data.isTextOnPath || json.data.isTextArt != null && json.data.isTextArt);
      });
    } else if (rule.elementID == PricingElements.UploadedImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return true;
        }
        return false;
      });
    } else if (rule.elementID === PricingElements.OnlyVectorImages) {
      selectedItems = selectedItems.filter(function (item) {
        return item.get('imageID') > 0 && item.get('imageType') === 'Vector';
      });
    } else if (rule.elementID === PricingElements.OnlyRasterImages) {
      selectedItems = selectedItems.filter(function (item) {
        return item.get('imageID') > 0 && item.get('imageType') === 'Raster' || item.get('imageType') === 'Vector+Raster';
      });
    }

    // eseguo una distinct
    var selectedItemsGroupByItemGuild = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(selectedItems, function (c) {
      return c.get('itemGuid');
    });
    context.items = Object.keys(selectedItemsGroupByItemGuild).map(function (k) {
      return selectedItemsGroupByItemGuild[k][0];
    });
    context.items = context.items.filter(function (x) {
      if (x.get('areas').length === 0) return false;
      var sideID = x.get('areas').at(0).get('sideID');
      return sidesOnWhichThePriceIsEnabled.includes(sideID);
    });
    return context;
  });
  // controllo se ci sono pricing sul prodotto, altrimenti sui print types
  _defineProperty(this, "isUsingAmountOfColors", function (printTypeID) {
    if (_this.pricings) {
      var pricing = _this.pricings.find(function (pricing) {
        return pricing.products.find(function (p) {
          return p.productID == _this.product.get('modelID');
        });
      });
      if (pricing) return pricing.rules.find(function (r) {
        return r.propertyID == 10;
      }) != undefined;else {
        var _pricing = _this.pricings.find(function (pricing) {
          return pricing.printTypes.find(function (p) {
            return p.printTypeID === printTypeID;
          });
        });
        if (_pricing) return _pricing.rules.find(function (r) {
          return r.propertyID == 10;
        }) != undefined;
      }
    }
    return false;
  });
  _defineProperty(this, "getPremiumPhotosPrice", function (design, quantity) {
    // Aggiungo il prezzo delle immagini esterne utilizzate
    var imageItemsGroups = [];
    var price = 0;
    var _loop = function _loop() {
      var _item$get;
      var item = design.get('designItems').at(i);
      if (item.get('imageID') > 0 && item.get('imagePrice') > 0 && item.get('providerImageID') != null && ((_item$get = item.get('providerImageID')) === null || _item$get === void 0 ? void 0 : _item$get.length) > 0 && !imageItemsGroups.find(function (x) {
        return x.get('providerImageID') === item.get('providerImageID');
      })) {
        imageItemsGroups.push(item);
        var pricePerImage = item.get('imagePrice');
        if (!_this.product.get('hasAdditionalFeeOnImagesProvider')) pricePerImage = item.get('applyImagePriceForQuantity') === null || item.get('applyImagePriceForQuantity') ? item.get('imagePrice') * quantity : item.get('imagePrice');else pricePerImage = item.get('imagePrice') * quantity;
        price += pricePerImage;
      }
    };
    for (var i = 0; i < design.get('designItems').length; i++) {
      _loop();
    }
    Logger.info('Premium photo price: ', price);
    return price;
  });
  /**
   * Get Image Price
   *
   * Metodo che calcola il prezzo per le immagini nel design a cui a backoffice
   * è stato valorizzato un prezzo
   *
   * @author f.checchia
   *
   * @param design Il design in input
   * @param {number} quantity La quantità del prodotto che si sta acquistando
   *
   * @return {number} Il prezzo complessivo delle immagini per la quantità
   *
   * */
  _defineProperty(this, "getImagePrice", function (design, quantity) {
    // Aggiungo il prezzo delle immagini utilizzate
    var price = 0;
    for (var i = 0; i < design.get('designItems').length; i++) {
      var item = design.get('designItems').at(i);
      if (item.get('imageID') > 0 && item.get('imagePrice') > 0 && !item.get('providerImageID')) {
        var pricePerImage = item.get('imagePrice');
        pricePerImage = item.get('imagePrice') * quantity;
        price += pricePerImage;
      }
    }
    Logger.info('Image price: ', price);
    return price;
  });
  _defineProperty(this, "getMatchedConditions", function (design, quantity, includePercentage) {
    var attributeMatchColorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    // this.pricing = this.getPricing(design);
    var pricingsAndSidesIDs = _this.getPricing(design);

    // if (!this.pricing) return [];
    if (!pricingsAndSidesIDs) return [];
    var matchedConditions = [];

    // this.pricing.rules.forEach((rule) => {
    pricingsAndSidesIDs.forEach(function (pricingAndSidesIDs) {
      if (!pricingAndSidesIDs[0]) return;
      // this.pricing = pricingAndSidesIDs[0];

      var sideIDs = pricingAndSidesIDs[1];
      pricingAndSidesIDs[0].rules.forEach(function (rule) {
        if (!includePercentage && rule.priceType == 1) return;
        var context = _this.GetContextForRule(rule, _this.product, design, sideIDs, attributeMatchColorId);

        // If we don't have sides to check, we are in the wrong
        // variant probably, just skip it.
        if (context.sides.length === 0) return;
        var conditionsGroupByformula = _this.conditionsToConditionsGroupByFormula(rule.conditions);
        var forEachBreakException = {};
        try {
          conditionsGroupByformula.sort(function (c1, c2) {
            return c1 && c2 && c1.position > c2.position ? 1 : -1;
          }).forEach(function (conditionGroupByFormula) {
            //per ogni gruppo (le cui conditions avranno tutte la stessa formula) estraggo dalla formula l'operatore e il values e richiamo la function
            var formulaObject = JSON.parse(conditionGroupByFormula.formula);
            if (!formulaObject.operator) throw 'operator missing in formula';

            // if (!formulaObject.values || formulaObject.values.length == 0) throw ("values missing in formula");

            // conditionGroupByFormula.conditions.forEach( condition => {
            var functionName = _this.getFunctionName(_this.properties, rule) + 'Function';

            //richiama la funzione col nome preso dalla property e con l'operatore preso dalla conditions (che in questo gruppo hanno la stessa formula)
            var result = _this[functionName](context, formulaObject);

            // //sia nel caso any che all mi calcolo il prezzo da aggiungere.
            // //Nel caso any se il risultato è true non vado alla successiva condition
            if (result.result) {
              //in ogni gruppo prendo il priceToAdd della condition con la quantità più vicina alla quantità acquistata.
              var condition = conditionGroupByFormula.conditions.filter(function (g) {
                return g.quantity <= quantity;
              }).sort(function (c1, c2) {
                return c2.quantity - c1.quantity;
              })[0];

              //controlla condition: se è null vai avanti
              if (condition != null) {
                var priceToAdd = condition.priceToAdd;
                var isSetupPrice = rule.isSetupPrice;
                var multiplier = result.multiplier;
                var priceType = rule.priceType;
                matchedConditions.push({
                  priceToAdd: priceToAdd,
                  isSetupPrice: isSetupPrice,
                  multiplier: multiplier,
                  priceType: priceType
                });

                // If some itemes were not matched with this condition, we must continue to check
                // for other conditions
                var functionMatchedAllItems = !result.items || result.items.length == 0;
                if (!rule.allMatchType && result.items) context.items = result.items;
                if (!rule.allMatchType && functionMatchedAllItems) throw forEachBreakException;
              }
            }
          });
        } catch (e) {
          if (e !== forEachBreakException) throw e;
        }
      });
    });
    return matchedConditions;
  });
  _defineProperty(this, "calculate", function (design, quantity) {
    var attributeMatchColorId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var isPricingAdvancedEnabled = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var matchedConditions = [];
    var totalPriceToAdd = _this.getPremiumPhotosPrice(design, quantity);
    totalPriceToAdd += _this.getImagePrice(design, quantity);
    if (isPricingAdvancedEnabled) {
      matchedConditions = _this.getMatchedConditions(design, quantity, false, attributeMatchColorId);
      matchedConditions.forEach(function (matchedCondition) {
        var conditionPrice = matchedCondition.priceToAdd * matchedCondition.multiplier;
        if (!matchedCondition.isSetupPrice) conditionPrice *= quantity;
        totalPriceToAdd += conditionPrice;
      });
    }
    Logger.info('Total custom price: ', totalPriceToAdd);
    return totalPriceToAdd;
  });
  _defineProperty(this, "getPricingAdditionalInfo", function (printTypeID) {
    var pricing;
    if (_this.pricings) {
      pricing = _this.pricings.find(function (pricing) {
        return pricing.products.find(function (p) {
          return p.productID == _this.product.get('modelID');
        });
      });
      if (!pricing) pricing = _this.pricings.find(function (pricing) {
        return pricing.printTypes.find(function (p) {
          return p.printTypeID === printTypeID;
        });
      });
    }
    if (!pricing) return;
    return {
      description: pricing.description,
      priceDescriptionEnabled: pricing.priceDescriptionEnabled,
      infoPricingText: pricing.infoPricingText,
      priceStructure: pricing.priceStructure
    };
  });
  if (apiUrl !== undefined) this.config.apiUrl = apiUrl + 'graphql';
  if (token !== undefined) this.config.token = token;
  if (isOwin !== undefined) this.config.isOwin = isOwin;
  if (cloudFlareApiUrl) this.config.cloudFlareApiUrl = cloudFlareApiUrl + 'graphql';
  if (clientLang) this.config.clientLang = clientLang;
});

/***/ }),

/***/ "../../utils/rectangle.ts":
/*!********************************!*\
  !*** ../../utils/rectangle.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Rectangle: () => (/* binding */ Rectangle),
/* harmony export */   rectangleArea: () => (/* binding */ rectangleArea),
/* harmony export */   rectanglesDistinctArea: () => (/* binding */ rectanglesDistinctArea)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Rectangle = /*#__PURE__*/_createClass(function Rectangle(width, height, x, y) {
  var _this = this;
  _classCallCheck(this, Rectangle);
  _defineProperty(this, "maxX", function () {
    return _this.x + _this.width;
  });
  _defineProperty(this, "maxY", function () {
    return _this.y + _this.height;
  });
  _defineProperty(this, "area", function () {
    return _this.width * _this.height;
  });
  _defineProperty(this, "areaPPCM", function (ppcm) {
    return _this.width / ppcm * (_this.height / ppcm);
  });
  _defineProperty(this, "equals", function (rectangleToCompare) {
    return _this.width.toFixed(4) == rectangleToCompare.width.toFixed(4) && _this.height.toFixed(4) == rectangleToCompare.height.toFixed(4) && _this.x == rectangleToCompare.x && _this.y == rectangleToCompare.y;
  });
  this.width = width;
  this.height = height;
  this.x = x;
  this.y = y;
});
var distinct = function distinct(n, i, array) {
  return array.indexOf(n) === i;
};
var rectangleArea = function rectangleArea(r) {
  return r.width * r.height;
};
var rectangleSplitAtXPosition = function rectangleSplitAtXPosition(rectangle, x) {
  if (x <= rectangle.x || x >= rectangle.x + rectangle.width) {
    return [rectangle];
  }
  var rect1 = new Rectangle(x - rectangle.x, rectangle.height, rectangle.x, rectangle.y);
  var rect2 = new Rectangle(rectangle.maxX() - x, rectangle.height, x, rectangle.y);
  return [rect1, rect2];
};
var rectangleSplitAtYPosition = function rectangleSplitAtYPosition(rectangle, y) {
  if (y <= rectangle.y || y >= rectangle.y + rectangle.height) {
    return [rectangle];
  }
  var rect1 = new Rectangle(rectangle.width, y - rectangle.y, rectangle.x, rectangle.y);
  var rect2 = new Rectangle(rectangle.width, rectangle.maxY() - y, rectangle.x, y);
  return [rect1, rect2];
};
var rectangleIncludeXPosition = function rectangleIncludeXPosition(rectangle, x) {
  return rectangle.x < x && rectangle.maxX() > x;
};
var rectangleIncludeYPosition = function rectangleIncludeYPosition(rectangle, y) {
  return rectangle.y < y && rectangle.maxY() > y;
};
var rectangleNotIncludeXPosition = function rectangleNotIncludeXPosition(rectangle, x) {
  return rectangle.x >= x || rectangle.maxX() <= x;
};
var rectangleNotIncludeYPosition = function rectangleNotIncludeYPosition(rectangle, y) {
  return rectangle.y >= y || rectangle.maxY() <= y;
};
var rectanglesDistinctArea = function rectanglesDistinctArea(rectangles, ppcm) {
  // all x values
  var xPositions = rectangles.reduce(function (acc, rectangle) {
    return [].concat(_toConsumableArray(acc), [rectangle.x, rectangle.maxX()]);
  }, []).filter(distinct).sort(function (v1, v2) {
    return v1 - v2;
  });
  var rectanglesOutputByXPosition = _toConsumableArray(rectangles);
  xPositions.forEach(function (xPosition) {
    var rectanglesToDivide = rectanglesOutputByXPosition.filter(function (rectangle) {
      return rectangleIncludeXPosition(rectangle, xPosition);
    });
    var rectanglesToNotDivide = rectanglesOutputByXPosition.filter(function (rectangle) {
      return rectangleNotIncludeXPosition(rectangle, xPosition);
    });
    var rectanglesDivided = rectanglesToDivide.map(function (rectangle) {
      return rectangleSplitAtXPosition(rectangle, xPosition);
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []); // flatMap
    rectanglesOutputByXPosition = [].concat(_toConsumableArray(rectanglesToNotDivide), _toConsumableArray(rectanglesDivided));
  });
  var yPositions = rectanglesOutputByXPosition.reduce(function (acc, rectangle) {
    return [].concat(_toConsumableArray(acc), [rectangle.y, rectangle.maxY()]);
  }, []).filter(distinct).sort(function (v1, v2) {
    return v1 - v2;
  });
  var rectanglesOutputByYPosition = _toConsumableArray(rectanglesOutputByXPosition);
  yPositions.forEach(function (yPosition) {
    var rectanglesToDivide = rectanglesOutputByYPosition.filter(function (rectangle) {
      return rectangleIncludeYPosition(rectangle, yPosition);
    });
    var rectanglesToNotDivide = rectanglesOutputByYPosition.filter(function (rectangle) {
      return rectangleNotIncludeYPosition(rectangle, yPosition);
    });
    var rectanglesDivided = rectanglesToDivide.map(function (rectangle) {
      return rectangleSplitAtYPosition(rectangle, yPosition);
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []); // flatMap
    rectanglesOutputByYPosition = [].concat(_toConsumableArray(rectanglesToNotDivide), _toConsumableArray(rectanglesDivided));
  });
  return rectanglesOutputByYPosition.filter(function (rect, index, arr) {
    return arr.findIndex(function (r) {
      return r.equals(rect);
    }) == index;
  }) // distinct rectangle
  .reduce(function (acc, rect) {
    return ppcm ? acc + rect.areaPPCM(ppcm) : acc + rect.area();
  }, 0); // sum all rectangles area
};

/***/ }),

/***/ "./node_modules/@zakeke/zakeke-3d-core/dist/index.js":
/*!***********************************************************!*\
  !*** ./node_modules/@zakeke/zakeke-3d-core/dist/index.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AndroidAR: () => (/* binding */ Al),
/* harmony export */   AxesLayer: () => (/* binding */ ew),
/* harmony export */   BlendProceduralTexture: () => (/* binding */ Id),
/* harmony export */   BlurXProceduralTexture: () => (/* binding */ so),
/* harmony export */   BlurYProceduralTexture: () => (/* binding */ ao),
/* harmony export */   BroadcastChannelEventType: () => (/* binding */ Pw),
/* harmony export */   DAMViewerAnalyticsEventType: () => (/* binding */ Qx),
/* harmony export */   Database: () => (/* binding */ Of),
/* harmony export */   DefaultAssetUrls: () => (/* binding */ li),
/* harmony export */   DracoCompression: () => (/* binding */ Zx),
/* harmony export */   EditingMode: () => (/* binding */ qa),
/* harmony export */   EditorMeshType: () => (/* binding */ zw),
/* harmony export */   ElementSelector: () => (/* binding */ Od),
/* harmony export */   EnvironmentManager: () => (/* binding */ Yd),
/* harmony export */   EnvironmentMode: () => (/* binding */ Ar),
/* harmony export */   EventState: () => (/* binding */ iw),
/* harmony export */   ForegroundBackgroundProceduralTexture: () => (/* binding */ oo),
/* harmony export */   GlowManager: () => (/* binding */ Tx),
/* harmony export */   IS_ANDROID: () => (/* binding */ kf),
/* harmony export */   IS_IOS: () => (/* binding */ If),
/* harmony export */   IncrementalFiles: () => (/* binding */ Ex),
/* harmony export */   InfoPointsManager: () => (/* binding */ Jx),
/* harmony export */   InnerShadow: () => (/* binding */ Hx),
/* harmony export */   LightsLayer: () => (/* binding */ tw),
/* harmony export */   MaterialEditor: () => (/* binding */ og),
/* harmony export */   MaterialGroup: () => (/* binding */ Nw),
/* harmony export */   MaterialPreviewData: () => (/* binding */ Fx),
/* harmony export */   MaterialsPreview: () => (/* binding */ lo),
/* harmony export */   MeshDesignManager: () => (/* binding */ Vd),
/* harmony export */   MeshExpander: () => (/* binding */ ix),
/* harmony export */   MeshLocationsManager: () => (/* binding */ Ax),
/* harmony export */   MoveProceduralTexture: () => (/* binding */ ou),
/* harmony export */   MultiObserver: () => (/* binding */ Kd),
/* harmony export */   MultiplyProceduralTexture: () => (/* binding */ eo),
/* harmony export */   NormalMapProceduralTexture: () => (/* binding */ Bd),
/* harmony export */   Observable: () => (/* binding */ Jd),
/* harmony export */   Observer: () => (/* binding */ nw),
/* harmony export */   OpacityProceduralTexture: () => (/* binding */ vx),
/* harmony export */   OuterShadow: () => (/* binding */ Yx),
/* harmony export */   OverlayProceduralTexture: () => (/* binding */ al),
/* harmony export */   Preview3DConfigurationManager: () => (/* binding */ i1),
/* harmony export */   ProceduralNormalMap: () => (/* binding */ Vx),
/* harmony export */   SceneActionsExecutor: () => (/* binding */ Cx),
/* harmony export */   SceneDesignManager: () => (/* binding */ Gx),
/* harmony export */   SceneEditor: () => (/* binding */ Dw),
/* harmony export */   SceneHelper: () => (/* binding */ yi),
/* harmony export */   SceneToBlobs: () => (/* binding */ Kx),
/* harmony export */   SceneViewer: () => (/* binding */ mu),
/* harmony export */   SourceTaskStatus: () => (/* binding */ Rw),
/* harmony export */   StringTools: () => (/* binding */ ps),
/* harmony export */   TryOnFineTuningMazingEnvironment: () => (/* binding */ $x),
/* harmony export */   TryOnProvider: () => (/* binding */ Xd),
/* harmony export */   TryOnSettingsType: () => (/* binding */ Is),
/* harmony export */   TryOnType: () => (/* binding */ qd),
/* harmony export */   UsdzHelper: () => (/* binding */ nx),
/* harmony export */   WorkerPool: () => (/* binding */ du),
/* harmony export */   ZakekeEnvironment: () => (/* binding */ dy),
/* harmony export */   arrayContains: () => (/* binding */ aa),
/* harmony export */   changeColorLuminosity: () => (/* binding */ Nx),
/* harmony export */   chunkString: () => (/* binding */ Kw),
/* harmony export */   cropImageTransparency: () => (/* binding */ Rx),
/* harmony export */   cropImageTransparencyAsync: () => (/* binding */ qw),
/* harmony export */   dataURItoBlob: () => (/* binding */ Fd),
/* harmony export */   debounce: () => (/* binding */ Th),
/* harmony export */   defaultSceneConfig: () => (/* binding */ n1),
/* harmony export */   flipImage: () => (/* binding */ e1),
/* harmony export */   getAbsoluteUrl: () => (/* binding */ $w),
/* harmony export */   getColorBrightness: () => (/* binding */ Ox),
/* harmony export */   getColorImage: () => (/* binding */ Xw),
/* harmony export */   getContrastYIQ: () => (/* binding */ Ww),
/* harmony export */   getContrastYIQHex: () => (/* binding */ Zw),
/* harmony export */   getNavigatorQueryParams: () => (/* binding */ t1),
/* harmony export */   getRandomString: () => (/* binding */ Qw),
/* harmony export */   getStringHashCode: () => (/* binding */ Jw),
/* harmony export */   getViewport: () => (/* binding */ jw),
/* harmony export */   isAndroid: () => (/* binding */ Yw),
/* harmony export */   isColorDark: () => (/* binding */ Px),
/* harmony export */   isIPhoneX: () => (/* binding */ Hw),
/* harmony export */   isMobile: () => (/* binding */ Ix),
/* harmony export */   isPBRMaterial: () => (/* binding */ $o),
/* harmony export */   isiOS: () => (/* binding */ Gw),
/* harmony export */   removeBlanks: () => (/* binding */ zd),
/* harmony export */   resizeImageFromDataUri: () => (/* binding */ zx),
/* harmony export */   trimCanvas: () => (/* binding */ Dx),
/* harmony export */   trimImageAsync: () => (/* binding */ Fh)
/* harmony export */ });
Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
  value: function(y) {
    if (this == null)
      throw new TypeError("Array.prototype.find called on null or undefined");
    if (typeof y != "function")
      throw new TypeError("predicate must be a function");
    for (var e = Object(this), t = e.length >>> 0, r = arguments[1], o = 0; o !== t; o++)
      if (y.call(r, this[o], o, e))
        return this[o];
  }
});
Array.prototype.includes || (Array.prototype.includes = function(y) {
  if (this == null)
    throw new TypeError("Array.prototype.includes called on null or undefined");
  var e = Object(this), t = parseInt(e.length, 10) || 0;
  if (t === 0)
    return !1;
  var r = parseInt(arguments[1], 10) || 0, o;
  r >= 0 ? o = r : (o = t + r, o < 0 && (o = 0));
  for (var a; o < t; ) {
    if (a = e[o], y === a || y !== y && a !== a)
      return !0;
    o++;
  }
  return !1;
});
Array.prototype.map || (Array.prototype.map = function(y) {
  var e, t, r;
  if (this == null)
    throw new TypeError("this is null or not defined");
  var o = Object(this), a = o.length >>> 0;
  if (typeof y != "function")
    throw new TypeError(y + " is not a function");
  for (arguments.length > 1 && (e = arguments[1]), t = new Array(a), r = 0; r < a; ) {
    var u, f;
    r in o && (u = o[r], f = y.call(e, u, r, o), t[r] = f), r++;
  }
  return t;
});
String.prototype.startsWith || Object.defineProperty(String.prototype, "startsWith", {
  value: function(y, e) {
    var t = e > 0 ? e | 0 : 0;
    return this.substring(t, t + y.length) === y;
  }
});
String.prototype.endsWith || (String.prototype.endsWith = function(y, e) {
  return (e === void 0 || e > this.length) && (e = this.length), this.substring(e - y.length, e) === y;
});
var Ar = /* @__PURE__ */ ((y) => (y[y.Editor = 1] = "Editor", y[y.Viewer = 2] = "Viewer", y))(Ar || {}), qa = /* @__PURE__ */ ((y) => (y.None = "None", y.Translate = "Translate", y.Rotate = "Rotate", y.Scaling = "Scaling", y))(qa || {}), dy = /* @__PURE__ */ ((y) => (y[y.Customizer = 1] = "Customizer", y[y.Composer = 2] = "Composer", y[y.Viewer = 3] = "Viewer", y))(dy || {}), kh = typeof Float32Array < "u" ? Float32Array : Array;
Math.hypot || (Math.hypot = function() {
  for (var y = 0, e = arguments.length; e--; )
    y += arguments[e] * arguments[e];
  return Math.sqrt(y);
});
function gy() {
  var y = new kh(3);
  return kh != Float32Array && (y[0] = 0, y[1] = 0, y[2] = 0), y;
}
function bh(y) {
  var e = y[0], t = y[1], r = y[2];
  return Math.hypot(e, t, r);
}
(function() {
  var y = gy();
  return function(e, t, r, o, a, u) {
    var f, v;
    for (t || (t = 3), r || (r = 0), o ? v = Math.min(o * t + r, e.length) : v = e.length, f = r; f < v; f += t)
      y[0] = e[f], y[1] = e[f + 1], y[2] = e[f + 2], a(y, y, u), e[f] = y[0], e[f + 1] = y[1], e[f + 2] = y[2];
    return e;
  };
})();
function py(y) {
  var e = y[0], t = y[1], r = y[2], o = y[3], a = y[4], u = y[5], f = y[6], v = y[7], S = y[8], I = y[9], D = y[10], Z = y[11], M = y[12], X = y[13], Y = y[14], ie = y[15], G = e * u - t * a, te = e * f - r * a, J = e * v - o * a, he = t * f - r * u, ve = t * v - o * u, K = r * v - o * f, j = S * X - I * M, We = S * Y - D * M, ke = S * ie - Z * M, $e = I * Y - D * X, Lt = I * ie - Z * X, Be = D * ie - Z * Y;
  return G * Be - te * Lt + J * $e + he * ke - ve * We + K * j;
}
function _y(y, e, t) {
  var r = e[0], o = e[1], a = e[2], u = e[3], f = e[4], v = e[5], S = e[6], I = e[7], D = e[8], Z = e[9], M = e[10], X = e[11], Y = e[12], ie = e[13], G = e[14], te = e[15], J = t[0], he = t[1], ve = t[2], K = t[3];
  return y[0] = J * r + he * f + ve * D + K * Y, y[1] = J * o + he * v + ve * Z + K * ie, y[2] = J * a + he * S + ve * M + K * G, y[3] = J * u + he * I + ve * X + K * te, J = t[4], he = t[5], ve = t[6], K = t[7], y[4] = J * r + he * f + ve * D + K * Y, y[5] = J * o + he * v + ve * Z + K * ie, y[6] = J * a + he * S + ve * M + K * G, y[7] = J * u + he * I + ve * X + K * te, J = t[8], he = t[9], ve = t[10], K = t[11], y[8] = J * r + he * f + ve * D + K * Y, y[9] = J * o + he * v + ve * Z + K * ie, y[10] = J * a + he * S + ve * M + K * G, y[11] = J * u + he * I + ve * X + K * te, J = t[12], he = t[13], ve = t[14], K = t[15], y[12] = J * r + he * f + ve * D + K * Y, y[13] = J * o + he * v + ve * Z + K * ie, y[14] = J * a + he * S + ve * M + K * G, y[15] = J * u + he * I + ve * X + K * te, y;
}
function my(y, e) {
  var t = e[0], r = e[1], o = e[2], a = e[4], u = e[5], f = e[6], v = e[8], S = e[9], I = e[10];
  return y[0] = Math.hypot(t, r, o), y[1] = Math.hypot(a, u, f), y[2] = Math.hypot(v, S, I), y;
}
function vy(y, e) {
  var t = new kh(3);
  my(t, e);
  var r = 1 / t[0], o = 1 / t[1], a = 1 / t[2], u = e[0] * r, f = e[1] * o, v = e[2] * a, S = e[4] * r, I = e[5] * o, D = e[6] * a, Z = e[8] * r, M = e[9] * o, X = e[10] * a, Y = u + I + X, ie = 0;
  return Y > 0 ? (ie = Math.sqrt(Y + 1) * 2, y[3] = 0.25 * ie, y[0] = (D - M) / ie, y[1] = (Z - v) / ie, y[2] = (f - S) / ie) : u > I && u > X ? (ie = Math.sqrt(1 + u - I - X) * 2, y[3] = (D - M) / ie, y[0] = 0.25 * ie, y[1] = (f + S) / ie, y[2] = (Z + v) / ie) : I > X ? (ie = Math.sqrt(1 + I - u - X) * 2, y[3] = (Z - v) / ie, y[0] = (f + S) / ie, y[1] = 0.25 * ie, y[2] = (D + M) / ie) : (ie = Math.sqrt(1 + X - u - I) * 2, y[3] = (f - S) / ie, y[0] = (Z + v) / ie, y[1] = (D + M) / ie, y[2] = 0.25 * ie), y;
}
var en, hl, Ih, oa;
function Ii(y, e, t, r) {
  var o, a = arguments.length, u = a < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, t) : r;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    u = Reflect.decorate(y, e, t, r);
  else
    for (var f = y.length - 1; f >= 0; f--)
      (o = y[f]) && (u = (a < 3 ? o(u) : a > 3 ? o(e, t, u) : o(e, t)) || u);
  return a > 3 && u && Object.defineProperty(e, t, u), u;
}
(function(y) {
  y.ACCESSOR = "Accessor", y.ANIMATION = "Animation", y.ANIMATION_CHANNEL = "AnimationChannel", y.ANIMATION_SAMPLER = "AnimationSampler", y.BUFFER = "Buffer", y.CAMERA = "Camera", y.MATERIAL = "Material", y.MESH = "Mesh", y.PRIMITIVE = "Primitive", y.PRIMITIVE_TARGET = "PrimitiveTarget", y.NODE = "Node", y.ROOT = "Root", y.SCENE = "Scene", y.SKIN = "Skin", y.TEXTURE = "Texture", y.TEXTURE_INFO = "TextureInfo";
})(en || (en = {})), function(y) {
  y.INTERLEAVED = "interleaved", y.SEPARATE = "separate";
}(hl || (hl = {})), function(y) {
  y[y.R = 4096] = "R", y[y.G = 256] = "G", y[y.B = 16] = "B", y[y.A = 1] = "A";
}(Ih || (Ih = {})), function(y) {
  y.GLTF = "GLTF", y.GLB = "GLB";
}(oa || (oa = {}));
class yl {
  constructor(e, t, r) {
    if (this.t = void 0, this.i = void 0, this.h = void 0, this.o = !1, this.u = [], this.t = e, this.i = t, this.h = r, !t.canLink(r))
      throw new Error("Cannot link disconnected graphs/documents.");
  }
  getName() {
    return this.t;
  }
  getParent() {
    return this.i;
  }
  getChild() {
    return this.h;
  }
  setChild(e) {
    return this.h = e, this;
  }
  dispose() {
    this.o || (this.o = !0, this.u.forEach((e) => e()), this.u.length = 0);
  }
  onDispose(e) {
    return this.u.push(e), this;
  }
  isDisposed() {
    return this.o;
  }
}
class yy {
  constructor() {
    this.l = /* @__PURE__ */ new Set(), this.p = /* @__PURE__ */ new Set(), this.g = /* @__PURE__ */ new Map(), this.v = /* @__PURE__ */ new Map(), this.u = {};
  }
  on(e, t) {
    return this.u[e] = this.u[e] || [], this.u[e].push(t), this;
  }
  emit(e, t) {
    for (const r of this.u[e] || [])
      r(t);
    return this;
  }
  getLinks() {
    return Array.from(this.p);
  }
  listParentLinks(e) {
    return Array.from(this.v.get(e) || this.l);
  }
  listParents(e) {
    return this.listParentLinks(e).map((t) => t.getParent());
  }
  listChildLinks(e) {
    return Array.from(this.g.get(e) || this.l);
  }
  listChildren(e) {
    return this.listChildLinks(e).map((t) => t.getChild());
  }
  disconnectChildren(e) {
    return (this.g.get(e) || this.l).forEach((t) => t.dispose()), this;
  }
  disconnectParents(e, t) {
    let r = Array.from(this.v.get(e) || this.l);
    return t && (r = r.filter((o) => t(o.getParent()))), r.forEach((o) => o.dispose()), this;
  }
  swapChild(e, t, r) {
    const o = this.g.get(e) || this.l;
    return Array.from(o).filter((a) => a.getChild() === t).forEach((a) => {
      this.v.get(t).delete(a), a.setChild(r), this.v.has(r) || this.v.set(r, /* @__PURE__ */ new Set()), this.v.get(r).add(a);
    }), this;
  }
  link(e, t, r) {
    if (!r)
      return null;
    const o = new yl(e, t, r);
    return this.registerLink(o), o;
  }
  registerLink(e) {
    this.p.add(e);
    const t = e.getParent();
    this.g.has(t) || this.g.set(t, /* @__PURE__ */ new Set()), this.g.get(t).add(e);
    const r = e.getChild();
    return this.v.has(r) || this.v.set(r, /* @__PURE__ */ new Set()), this.v.get(r).add(e), e.onDispose(() => this.unlink(e)), e;
  }
  unlink(e) {
    return this.p.delete(e), this.g.get(e.getParent()).delete(e), this.v.get(e.getChild()).delete(e), this;
  }
}
function En(y, e) {
  Object.defineProperty(y, e, { get: function() {
    return this["__" + e];
  }, set: function(t) {
    const r = this["__" + e];
    r && !Array.isArray(r) && r.dispose(), t && !Array.isArray(t) && t.onDispose(() => {
      this["__" + e] = null;
    }), this["__" + e] = t;
  }, enumerable: !0 });
}
function Vn(y, e) {
}
class vr {
  static createBufferFromDataURI(e) {
    if (typeof Buffer > "u") {
      const t = atob(e.split(",")[1]), r = new Uint8Array(t.length);
      for (let o = 0; o < t.length; o++)
        r[o] = t.charCodeAt(o);
      return r.buffer;
    }
    {
      const t = e.split(",")[1], r = e.indexOf("base64") >= 0;
      return this.trim(Buffer.from(t, r ? "base64" : "utf8"));
    }
  }
  static encodeText(e) {
    return typeof TextEncoder < "u" ? new TextEncoder().encode(e).buffer : this.trim(Buffer.from(e));
  }
  static decodeText(e) {
    return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Buffer.from(e).toString("utf8");
  }
  static trim(e) {
    const { byteOffset: t, byteLength: r } = e;
    return e.buffer.slice(t, t + r);
  }
  static concat(e) {
    let t = 0;
    for (const a of e)
      t += a.byteLength;
    const r = new Uint8Array(t);
    let o = 0;
    for (const a of e)
      r.set(new Uint8Array(a), o), o += a.byteLength;
    return r.buffer;
  }
  static pad(e, t = 0) {
    const r = this.padNumber(e.byteLength);
    if (r !== e.byteLength) {
      const o = new Uint8Array(r);
      if (o.set(new Uint8Array(e)), t !== 0)
        for (let a = e.byteLength; a < r; a++)
          o[a] = t;
      return o.buffer;
    }
    return e;
  }
  static padNumber(e) {
    return 4 * Math.ceil(e / 4);
  }
  static equals(e, t) {
    if (e === t)
      return !0;
    if (e.byteLength !== t.byteLength)
      return !1;
    const r = new DataView(e), o = new DataView(t);
    let a = e.byteLength;
    for (; a--; )
      if (r.getUint8(a) !== o.getUint8(a))
        return !1;
    return !0;
  }
}
class Zo {
  static hexToFactor(e, t) {
    e = Math.floor(e);
    const r = t;
    return r[0] = (e >> 16 & 255) / 255, r[1] = (e >> 8 & 255) / 255, r[2] = (255 & e) / 255, this.convertSRGBToLinear(t, t);
  }
  static factorToHex(e) {
    const t = [...e], [r, o, a] = this.convertLinearToSRGB(e, t);
    return 255 * r << 16 ^ 255 * o << 8 ^ 255 * a << 0;
  }
  static convertSRGBToLinear(e, t) {
    const r = e, o = t;
    for (let a = 0; a < 3; a++)
      o[a] = r[a] < 0.04045 ? 0.0773993808 * r[a] : Math.pow(0.9478672986 * r[a] + 0.0521327014, 2.4);
    return t;
  }
  static convertLinearToSRGB(e, t) {
    const r = e, o = t;
    for (let a = 0; a < 3; a++)
      o[a] = r[a] < 31308e-7 ? 12.92 * r[a] : 1.055 * Math.pow(r[a], 0.41666) - 0.055;
    return t;
  }
}
class ul {
  static basename(e) {
    const t = e.split(/[\\/]/).pop();
    return t.substr(0, t.lastIndexOf("."));
  }
  static extension(e) {
    return e.indexOf("data:") !== 0 ? e.split(/[\\/]/).pop().split(/[.]/).pop() : e.indexOf("data:image/png") === 0 ? "png" : e.indexOf("data:image/jpeg") === 0 ? "jpeg" : "bin";
  }
}
class bl {
  match(e) {
    const t = new Uint8Array(e);
    return t.length >= 8 && t[0] === 137 && t[1] === 80 && t[2] === 78 && t[3] === 71 && t[4] === 13 && t[5] === 10 && t[6] === 26 && t[7] === 10;
  }
  getSize(e) {
    const t = new DataView(e);
    return vr.decodeText(e.slice(12, 16)) === bl.PNG_FRIED_CHUNK_NAME ? [t.getUint32(32, !1), t.getUint32(36, !1)] : [t.getUint32(16, !1), t.getUint32(20, !1)];
  }
  getChannels(e) {
    return 4;
  }
}
bl.PNG_FRIED_CHUNK_NAME = "CgBI";
class Ca {
  static registerFormat(e, t) {
    this.impls[e] = t;
  }
  static getMimeType(e) {
    for (const t in this.impls)
      if (this.impls[t].match(e))
        return t;
    return null;
  }
  static getSize(e, t) {
    return this.impls[t] ? this.impls[t].getSize(e) : null;
  }
  static getChannels(e, t) {
    return this.impls[t] ? this.impls[t].getChannels(e) : null;
  }
  static getMemSize(e, t) {
    if (!this.impls[t])
      return null;
    if (this.impls[t].getGPUByteLength)
      return this.impls[t].getGPUByteLength(e);
    let r = 0;
    const o = this.getSize(e, t);
    if (!o)
      return null;
    for (; o[0] > 1 || o[1] > 1; )
      r += o[0] * o[1] * 4, o[0] = Math.max(Math.floor(o[0] / 2), 1), o[1] = Math.max(Math.floor(o[1] / 2), 1);
    return r += 4, r;
  }
  static mimeTypeToExtension(e) {
    return e === "image/jpeg" ? "jpg" : e.split("/").pop();
  }
  static extensionToMimeType(e) {
    return e === "jpg" ? "image/jpeg" : `image/${e}`;
  }
}
function by(y, e) {
  if (e > y.byteLength)
    throw new TypeError("Corrupt JPG, exceeded buffer limits");
  if (y.getUint8(e) !== 255)
    throw new TypeError("Invalid JPG, marker table corrupted");
  return y;
}
Ca.impls = { "image/jpeg": new class {
  match(y) {
    const e = new Uint8Array(y);
    return e.length >= 3 && e[0] === 255 && e[1] === 216 && e[2] === 255;
  }
  getSize(y) {
    let e, t, r = new DataView(y, 4);
    for (; r.byteLength; ) {
      if (e = r.getUint16(0, !1), by(r, e), t = r.getUint8(e + 1), t === 192 || t === 193 || t === 194)
        return [r.getUint16(e + 7, !1), r.getUint16(e + 5, !1)];
      r = new DataView(y, r.byteOffset + e + 2);
    }
    throw new TypeError("Invalid JPG, no size found");
  }
  getChannels(y) {
    return 3;
  }
}(), "image/png": new bl() };
class jn {
  static identity(e) {
    return e;
  }
  static eq(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (Math.abs(e[r] - t[r]) > 1e-5)
        return !1;
    return !0;
  }
  static denormalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return e / 65535;
      case 5121:
        return e / 255;
      case 5122:
        return Math.max(e / 32767, -1);
      case 5120:
        return Math.max(e / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static normalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return Math.round(65535 * e);
      case 5121:
        return Math.round(255 * e);
      case 5122:
        return Math.round(32767 * e);
      case 5120:
        return Math.round(127 * e);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static decompose(e, t, r, o) {
    let a = bh([e[0], e[1], e[2]]);
    const u = bh([e[4], e[5], e[6]]), f = bh([e[8], e[9], e[10]]);
    py(e) < 0 && (a = -a), t[0] = e[12], t[1] = e[13], t[2] = e[14];
    const v = e.slice(), S = 1 / a, I = 1 / u, D = 1 / f;
    v[0] *= S, v[1] *= S, v[2] *= S, v[4] *= I, v[5] *= I, v[6] *= I, v[8] *= D, v[9] *= D, v[10] *= D, vy(r, v), o[0] = a, o[1] = u, o[2] = f;
  }
  static compose(e, t, r, o) {
    const a = o, u = t[0], f = t[1], v = t[2], S = t[3], I = u + u, D = f + f, Z = v + v, M = u * I, X = u * D, Y = u * Z, ie = f * D, G = f * Z, te = v * Z, J = S * I, he = S * D, ve = S * Z, K = r[0], j = r[1], We = r[2];
    return a[0] = (1 - (ie + te)) * K, a[1] = (X + ve) * K, a[2] = (Y - he) * K, a[3] = 0, a[4] = (X - ve) * j, a[5] = (1 - (M + te)) * j, a[6] = (G + J) * j, a[7] = 0, a[8] = (Y + he) * We, a[9] = (G - J) * We, a[10] = (1 - (M + ie)) * We, a[11] = 0, a[12] = e[0], a[13] = e[1], a[14] = e[2], a[15] = 1, a;
  }
}
class Dr {
  constructor(e) {
    this.verbosity = void 0, this.verbosity = e;
  }
  debug(e) {
    this.verbosity <= Dr.Verbosity.DEBUG && console.debug(e);
  }
  info(e) {
    this.verbosity <= Dr.Verbosity.INFO && console.info(e);
  }
  warn(e) {
    this.verbosity <= Dr.Verbosity.WARN && console.warn(e);
  }
  error(e) {
    this.verbosity <= Dr.Verbosity.ERROR && console.error(e);
  }
}
Dr.Verbosity = { SILENT: 4, ERROR: 3, WARN: 2, INFO: 1, DEBUG: 0 }, Dr.DEFAULT_INSTANCE = new Dr(Dr.Verbosity.INFO);
const lf = "23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ", hf = /* @__PURE__ */ new Set(), xy = function() {
  let y = "";
  for (let e = 0; e < 6; e++)
    y += lf.charAt(Math.floor(Math.random() * lf.length));
  return y;
}, wy = function() {
  for (let y = 0; y < 999; y++) {
    const e = xy();
    if (!hf.has(e))
      return hf.add(e), e;
  }
  return "";
}, kn = (y) => y;
class Ta extends class {
  constructor(e) {
    this.graph = void 0, this.o = !1, this.graph = e, this.graph = e;
  }
  canLink(e) {
    return this.graph === e.graph;
  }
  isDisposed() {
    return this.o;
  }
  dispose() {
    this.graph.disconnectChildren(this), this.graph.disconnectParents(this), this.o = !0, this.graph.emit("dispose", this);
  }
  detach() {
    return this.graph.disconnectParents(this), this;
  }
  swap(e, t) {
    return this.graph.swapChild(this, e, t), this;
  }
  addGraphChild(e, t) {
    return e.push(t), t.onDispose(() => {
      const r = e.filter((o) => o !== t);
      e.length = 0;
      for (const o of r)
        e.push(o);
    }), this;
  }
  removeGraphChild(e, t) {
    return e.filter((r) => r.getChild() === t).forEach((r) => r.dispose()), this;
  }
  clearGraphChildList(e) {
    for (; e.length > 0; )
      e[0].dispose();
    return this;
  }
  listGraphParents() {
    return this.graph.listParents(this);
  }
} {
  constructor(e, t = "") {
    super(e), this.graph = void 0, this.m = {}, this.t = "", this.graph = e, this.t = t;
  }
  getName() {
    return this.t;
  }
  setName(e) {
    return this.t = e, this;
  }
  getExtras() {
    return this.m;
  }
  setExtras(e) {
    return this.m = e, this;
  }
  clone() {
    const e = new this.constructor(this.graph).copy(this, kn);
    return this.graph.emit("clone", e), e;
  }
  copy(e, t = kn) {
    return this.t = e.t, this.m = JSON.parse(JSON.stringify(e.m)), this;
  }
  detach() {
    return this.graph.disconnectParents(this, (e) => e.propertyType !== "Root"), this;
  }
  listParents() {
    return this.listGraphParents();
  }
}
const uf = "Pass extension name (string) as lookup token, not a constructor.";
class zr extends Ta {
  constructor(...e) {
    super(...e), this.extensions = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.clearGraphChildList(this.extensions), e.extensions.forEach((r) => {
      const o = r.getChild();
      this.setExtension(o.extensionName, t(o));
    }), this;
  }
  getExtension(e) {
    if (typeof e != "string")
      throw new Error(uf);
    const t = this.extensions.find((r) => r.getChild().extensionName === e);
    return t ? t.getChild() : null;
  }
  setExtension(e, t) {
    if (typeof e != "string")
      throw new Error(uf);
    const r = this.getExtension(e);
    return r && this.removeGraphChild(this.extensions, r), t ? (t.T(this), this.addGraphChild(this.extensions, this.graph.link(e, this, t))) : this;
  }
  listExtensions() {
    return this.extensions.map((e) => e.getChild());
  }
}
Ii([Vn], zr.prototype, "extensions", void 0);
class Ai extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.ACCESSOR, this.S = null, this.M = Ai.Type.SCALAR, this.I = Ai.ComponentType.FLOAT, this.N = !1, this.C = jn.identity, this.O = jn.identity, this.buffer = null;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.M = e.M, this.I = e.I, this.N = e.N, this.C = e.C, this.O = e.O, e.S && (this.S = e.S.slice()), this.setBuffer(e.buffer ? t(e.buffer.getChild()) : null), this;
  }
  static getElementSize(e) {
    switch (e) {
      case Ai.Type.SCALAR:
        return 1;
      case Ai.Type.VEC2:
        return 2;
      case Ai.Type.VEC3:
        return 3;
      case Ai.Type.VEC4:
      case Ai.Type.MAT2:
        return 4;
      case Ai.Type.MAT3:
        return 9;
      case Ai.Type.MAT4:
        return 16;
      default:
        throw new Error("Unexpected type: " + e);
    }
  }
  static getComponentSize(e) {
    switch (e) {
      case Ai.ComponentType.BYTE:
      case Ai.ComponentType.UNSIGNED_BYTE:
        return 1;
      case Ai.ComponentType.SHORT:
      case Ai.ComponentType.UNSIGNED_SHORT:
        return 2;
      case Ai.ComponentType.UNSIGNED_INT:
      case Ai.ComponentType.FLOAT:
        return 4;
      default:
        throw new Error("Unexpected component type: " + e);
    }
  }
  getMinNormalized(e) {
    const t = this.getElementSize();
    this.getMin(e);
    for (let r = 0; r < t; r++)
      e[r] = this.O(e[r]);
    return e;
  }
  getMin(e) {
    const t = this.getCount(), r = this.getElementSize();
    for (let o = 0; o < r; o++)
      e[o] = 1 / 0;
    for (let o = 0; o < t * r; o += r)
      for (let a = 0; a < r; a++) {
        const u = this.S[o + a];
        Number.isFinite(u) && (e[a] = Math.min(e[a], u));
      }
    return e;
  }
  getMaxNormalized(e) {
    const t = this.getElementSize();
    this.getMax(e);
    for (let r = 0; r < t; r++)
      e[r] = this.O(e[r]);
    return e;
  }
  getMax(e) {
    const t = this.getCount(), r = this.getElementSize();
    for (let o = 0; o < r; o++)
      e[o] = -1 / 0;
    for (let o = 0; o < t * r; o += r)
      for (let a = 0; a < r; a++) {
        const u = this.S[o + a];
        Number.isFinite(u) && (e[a] = Math.max(e[a], u));
      }
    return e;
  }
  getCount() {
    return this.S ? this.S.length / this.getElementSize() : 0;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getElementSize() {
    return Ai.getElementSize(this.M);
  }
  getComponentSize() {
    return this.S.BYTES_PER_ELEMENT;
  }
  getComponentType() {
    return this.I;
  }
  getNormalized() {
    return this.N;
  }
  setNormalized(e) {
    return this.N = e, e ? (this.O = (t) => jn.denormalize(t, this.I), this.C = (t) => jn.normalize(t, this.I)) : (this.O = jn.identity, this.C = jn.identity), this;
  }
  getScalar(e) {
    const t = this.getElementSize();
    return this.O(this.S[e * t]);
  }
  setScalar(e, t) {
    return this.S[e * this.getElementSize()] = this.C(t), this;
  }
  getElement(e, t) {
    const r = this.getElementSize();
    for (let o = 0; o < r; o++)
      t[o] = this.O(this.S[e * r + o]);
    return t;
  }
  setElement(e, t) {
    const r = this.getElementSize();
    for (let o = 0; o < r; o++)
      this.S[e * r + o] = this.C(t[o]);
    return this;
  }
  getBuffer() {
    return this.buffer ? this.buffer.getChild() : null;
  }
  setBuffer(e) {
    return this.buffer = this.graph.link("buffer", this, e), this;
  }
  getArray() {
    return this.S;
  }
  setArray(e) {
    return this.I = e ? function(t) {
      switch (t.constructor) {
        case Float32Array:
          return Ai.ComponentType.FLOAT;
        case Uint32Array:
          return Ai.ComponentType.UNSIGNED_INT;
        case Uint16Array:
          return Ai.ComponentType.UNSIGNED_SHORT;
        case Uint8Array:
          return Ai.ComponentType.UNSIGNED_BYTE;
        case Int16Array:
          return Ai.ComponentType.SHORT;
        case Int8Array:
          return Ai.ComponentType.BYTE;
        default:
          throw new Error("Unknown accessor componentType.");
      }
    }(e) : Ai.ComponentType.FLOAT, this.S = e, this;
  }
  getByteLength() {
    return this.S ? this.S.byteLength : 0;
  }
}
Ai.Type = { SCALAR: "SCALAR", VEC2: "VEC2", VEC3: "VEC3", VEC4: "VEC4", MAT2: "MAT2", MAT3: "MAT3", MAT4: "MAT4" }, Ai.ComponentType = { BYTE: 5120, UNSIGNED_BYTE: 5121, SHORT: 5122, UNSIGNED_SHORT: 5123, UNSIGNED_INT: 5125, FLOAT: 5126 }, Ii([En], Ai.prototype, "buffer", void 0);
class cl extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.ANIMATION, this.channels = [], this.samplers = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.clearGraphChildList(this.channels), this.clearGraphChildList(this.samplers), e.channels.forEach((r) => this.addChannel(t(r.getChild()))), e.samplers.forEach((r) => this.addSampler(t(r.getChild()))), this;
  }
  addChannel(e) {
    const t = this.graph.link("channel", this, e);
    return this.addGraphChild(this.channels, t);
  }
  removeChannel(e) {
    return this.removeGraphChild(this.channels, e);
  }
  listChannels() {
    return this.channels.map((e) => e.getChild());
  }
  addSampler(e) {
    const t = this.graph.link("sampler", this, e);
    return this.addGraphChild(this.samplers, t);
  }
  removeSampler(e) {
    return this.removeGraphChild(this.samplers, e);
  }
  listSamplers() {
    return this.samplers.map((e) => e.getChild());
  }
}
Ii([Vn], cl.prototype, "channels", void 0), Ii([Vn], cl.prototype, "samplers", void 0);
class il extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = en.ANIMATION_CHANNEL, this._ = null, this.targetNode = null, this.sampler = null;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this._ = e._, this.setTargetNode(e.targetNode ? t(e.targetNode.getChild()) : null), this.setSampler(e.sampler ? t(e.sampler.getChild()) : null), this;
  }
  getTargetPath() {
    return this._;
  }
  setTargetPath(e) {
    return this._ = e, this;
  }
  getTargetNode() {
    return this.targetNode ? this.targetNode.getChild() : null;
  }
  setTargetNode(e) {
    return this.targetNode = this.graph.link("target.node", this, e), this;
  }
  getSampler() {
    return this.sampler ? this.sampler.getChild() : null;
  }
  setSampler(e) {
    return this.sampler = this.graph.link("sampler", this, e), this;
  }
}
il.TargetPath = { TRANSLATION: "translation", ROTATION: "rotation", SCALE: "scale", WEIGHTS: "weights" }, Ii([En], il.prototype, "targetNode", void 0), Ii([En], il.prototype, "sampler", void 0);
class la extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = en.ANIMATION_SAMPLER, this.L = la.Interpolation.LINEAR, this.input = null, this.output = null;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.L = e.L, this.setInput(e.input ? t(e.input.getChild()) : null), this.setOutput(e.output ? t(e.output.getChild()) : null), this;
  }
  getInterpolation() {
    return this.L;
  }
  setInterpolation(e) {
    return this.L = e, this;
  }
  getInput() {
    return this.input ? this.input.getChild() : null;
  }
  setInput(e) {
    return this.input = this.graph.link("input", this, e), this;
  }
  getOutput() {
    return this.output ? this.output.getChild() : null;
  }
  setOutput(e) {
    return this.output = this.graph.link("output", this, e), this;
  }
}
la.Interpolation = { LINEAR: "LINEAR", STEP: "STEP", CUBICSPLINE: "CUBICSPLINE" }, Ii([En], la.prototype, "input", void 0), Ii([En], la.prototype, "output", void 0);
class Zf extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.BUFFER, this.P = "";
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.P = e.P, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this;
  }
}
class ha extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.CAMERA, this.M = ha.Type.PERSPECTIVE, this.U = 0.1, this.k = 100, this.F = null, this.j = 2 * Math.PI * 50 / 360, this.D = 1, this.J = 1;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.M = e.M, this.U = e.U, this.k = e.k, this.F = e.F, this.j = e.j, this.D = e.D, this.J = e.J, this;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getZNear() {
    return this.U;
  }
  setZNear(e) {
    return this.U = e, this;
  }
  getZFar() {
    return this.k;
  }
  setZFar(e) {
    return this.k = e, this;
  }
  getAspectRatio() {
    return this.F;
  }
  setAspectRatio(e) {
    return this.F = e, this;
  }
  getYFov() {
    return this.j;
  }
  setYFov(e) {
    return this.j = e, this;
  }
  getXMag() {
    return this.D;
  }
  setXMag(e) {
    return this.D = e, this;
  }
  getYMag() {
    return this.J;
  }
  setYMag(e) {
    return this.J = e, this;
  }
}
ha.Type = { PERSPECTIVE: "perspective", ORTHOGRAPHIC: "orthographic" };
class qf extends Ta {
  constructor(e, t) {
    super(e), this.$ = void 0, this.$ = t, this.$.addExtensionProperty(this);
  }
  clone() {
    const e = new this.constructor(this.graph, this.$).copy(this, kn);
    return this.graph.emit("clone", e), e;
  }
  dispose() {
    this.$.removeExtensionProperty(this), super.dispose();
  }
  T(e) {
    if (!this.parentTypes.includes(e.propertyType))
      throw new Error(`Parent "${e.propertyType}" invalid for child "${this.propertyType}".`);
  }
}
qf.EXTENSION_NAME = void 0;
class Xf extends yl {
  constructor(...e) {
    super(...e), this.semantic = "";
  }
  copy(e) {
    return this.semantic = e.semantic, this;
  }
}
class Kf extends yl {
  copy(e) {
    return this;
  }
}
let Sy = class extends yl {
  constructor(...e) {
    super(...e), this.channels = 0;
  }
  copy(e) {
    return this.channels = e.channels, this;
  }
};
class My extends yy {
  linkAttribute(e, t, r) {
    if (!r)
      return null;
    const o = new Xf(e, t, r);
    return o.semantic = e, this.registerLink(o), o;
  }
  linkIndex(e, t, r) {
    if (!r)
      return null;
    const o = new Kf(e, t, r);
    return this.registerLink(o), o;
  }
  linkTexture(e, t, r, o) {
    if (!o)
      return null;
    const a = new Sy(e, r, o);
    return a.channels = t, this.registerLink(a), a;
  }
}
class ss extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.TEXTURE_INFO, this.V = 0, this.W = null, this.q = null, this.Y = ss.WrapMode.REPEAT, this.H = ss.WrapMode.REPEAT;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.V = e.V, this.W = e.W, this.q = e.q, this.Y = e.Y, this.H = e.H, this;
  }
  equals(e) {
    return this.getTexCoord() === e.getTexCoord() && this.getMagFilter() === e.getMagFilter() && this.getMinFilter() === e.getMinFilter() && this.getWrapS() === e.getWrapS() && this.getWrapT() === e.getWrapT();
  }
  getTexCoord() {
    return this.V;
  }
  setTexCoord(e) {
    return this.V = e, this;
  }
  getMagFilter() {
    return this.W;
  }
  setMagFilter(e) {
    return this.W = e, this;
  }
  getMinFilter() {
    return this.q;
  }
  setMinFilter(e) {
    return this.q = e, this;
  }
  getWrapS() {
    return this.Y;
  }
  setWrapS(e) {
    return this.Y = e, this;
  }
  getWrapT() {
    return this.H;
  }
  setWrapT(e) {
    return this.H = e, this;
  }
}
ss.WrapMode = { CLAMP_TO_EDGE: 33071, MIRRORED_REPEAT: 33648, REPEAT: 10497 }, ss.MagFilter = { NEAREST: 9728, LINEAR: 9729 }, ss.MinFilter = { NEAREST: 9728, LINEAR: 9729, NEAREST_MIPMAP_NEAREST: 9984, LINEAR_MIPMAP_NEAREST: 9985, NEAREST_MIPMAP_LINEAR: 9986, LINEAR_MIPMAP_LINEAR: 9987 };
const { R: qo, G: Xo, B: Ko, A: Cy } = Ih;
class tr extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.MATERIAL, this.Z = tr.AlphaMode.OPAQUE, this.K = 0.5, this.X = !1, this.tt = [1, 1, 1, 1], this.st = [0, 0, 0], this.et = 1, this.it = 1, this.rt = 1, this.nt = 1, this.baseColorTexture = null, this.baseColorTextureInfo = this.graph.link("baseColorTextureInfo", this, new ss(this.graph)), this.emissiveTexture = null, this.emissiveTextureInfo = this.graph.link("emissiveTextureInfo", this, new ss(this.graph)), this.normalTexture = null, this.normalTextureInfo = this.graph.link("normalTextureInfo", this, new ss(this.graph)), this.occlusionTexture = null, this.occlusionTextureInfo = this.graph.link("occlusionTextureInfo", this, new ss(this.graph)), this.metallicRoughnessTexture = null, this.metallicRoughnessTextureInfo = this.graph.link("metallicRoughnessTextureInfo", this, new ss(this.graph));
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.Z = e.Z, this.K = e.K, this.X = e.X, this.tt = [...e.tt], this.st = [...e.st], this.et = e.et, this.it = e.it, this.rt = e.rt, this.nt = e.nt, this.setBaseColorTexture(e.baseColorTexture ? t(e.baseColorTexture.getChild()) : null), this.baseColorTextureInfo.getChild().copy(t(e.baseColorTextureInfo.getChild()), t), this.setEmissiveTexture(e.emissiveTexture ? t(e.emissiveTexture.getChild()) : null), this.emissiveTextureInfo.getChild().copy(t(e.emissiveTextureInfo.getChild()), t), this.setNormalTexture(e.normalTexture ? t(e.normalTexture.getChild()) : null), this.normalTextureInfo.getChild().copy(t(e.normalTextureInfo.getChild()), t), this.setOcclusionTexture(e.occlusionTexture ? t(e.occlusionTexture.getChild()) : null), this.occlusionTextureInfo.getChild().copy(t(e.occlusionTextureInfo.getChild()), t), this.setMetallicRoughnessTexture(e.metallicRoughnessTexture ? t(e.metallicRoughnessTexture.getChild()) : null), this.metallicRoughnessTextureInfo.getChild().copy(t(e.metallicRoughnessTextureInfo.getChild()), t), this;
  }
  equals(e) {
    if (this.getAlphaMode() !== e.getAlphaMode() || this.getAlphaCutoff() !== e.getAlphaCutoff() || this.getDoubleSided() !== e.getDoubleSided() || !jn.eq(this.getBaseColorFactor(), e.getBaseColorFactor()) || !jn.eq(this.getEmissiveFactor(), e.getEmissiveFactor()) || this.getNormalScale() !== e.getNormalScale() || this.getOcclusionStrength() !== e.getOcclusionStrength() || this.getRoughnessFactor() !== e.getRoughnessFactor() || this.getMetallicFactor() !== e.getMetallicFactor() || (this.getBaseColorTexture() || e.getBaseColorTexture()) && (this.getBaseColorTexture() !== e.getBaseColorTexture() || this.getBaseColorTexture() && !this.getBaseColorTextureInfo().equals(e.getBaseColorTextureInfo())) || (this.getEmissiveTexture() || e.getEmissiveTexture()) && (this.getEmissiveTexture() !== e.getEmissiveTexture() || this.getEmissiveTexture() && !this.getEmissiveTextureInfo().equals(e.getEmissiveTextureInfo())) || (this.getNormalTexture() || e.getNormalTexture()) && (this.getNormalTexture() !== e.getNormalTexture() || this.getNormalTexture() && !this.getNormalTextureInfo().equals(e.getNormalTextureInfo())) || (this.getOcclusionTexture() || e.getOcclusionTexture()) && (this.getOcclusionTexture() !== e.getOcclusionTexture() || this.getOcclusionTexture() && !this.getOcclusionTextureInfo().equals(e.getOcclusionTextureInfo())) || (this.getMetallicRoughnessTexture() || e.getMetallicRoughnessTexture()) && (this.getMetallicRoughnessTexture() !== e.getMetallicRoughnessTexture() || this.getMetallicRoughnessTexture() && !this.getMetallicRoughnessTextureInfo().equals(e.getMetallicRoughnessTextureInfo())))
      return !1;
    const t = this.listExtensions(), r = e.listExtensions();
    if (t.length !== r.length)
      return !1;
    for (let o = 0; o < t.length; o++)
      if (t[o] !== r[o])
        return !1;
    return !0;
  }
  dispose() {
    this.baseColorTextureInfo.getChild().dispose(), this.emissiveTextureInfo.getChild().dispose(), this.normalTextureInfo.getChild().dispose(), this.occlusionTextureInfo.getChild().dispose(), this.metallicRoughnessTextureInfo.getChild().dispose(), super.dispose();
  }
  getDoubleSided() {
    return this.X;
  }
  setDoubleSided(e) {
    return this.X = e, this;
  }
  getAlpha() {
    return this.tt[3];
  }
  setAlpha(e) {
    return this.tt[3] = e, this;
  }
  getAlphaMode() {
    return this.Z;
  }
  setAlphaMode(e) {
    return this.Z = e, this;
  }
  getAlphaCutoff() {
    return this.K;
  }
  setAlphaCutoff(e) {
    return this.K = e, this;
  }
  getBaseColorFactor() {
    return this.tt;
  }
  setBaseColorFactor(e) {
    return this.tt = e, this;
  }
  getBaseColorHex() {
    return Zo.factorToHex(this.tt);
  }
  setBaseColorHex(e) {
    return Zo.hexToFactor(e, this.tt), this;
  }
  getBaseColorTexture() {
    return this.baseColorTexture ? this.baseColorTexture.getChild() : null;
  }
  getBaseColorTextureInfo() {
    return this.baseColorTexture ? this.baseColorTextureInfo.getChild() : null;
  }
  setBaseColorTexture(e) {
    return this.baseColorTexture = this.graph.linkTexture("baseColorTexture", qo | Xo | Ko | Cy, this, e), this;
  }
  getEmissiveFactor() {
    return this.st;
  }
  setEmissiveFactor(e) {
    return this.st = e, this;
  }
  getEmissiveHex() {
    return Zo.factorToHex(this.st);
  }
  setEmissiveHex(e) {
    return Zo.hexToFactor(e, this.st), this;
  }
  getEmissiveTexture() {
    return this.emissiveTexture ? this.emissiveTexture.getChild() : null;
  }
  getEmissiveTextureInfo() {
    return this.emissiveTexture ? this.emissiveTextureInfo.getChild() : null;
  }
  setEmissiveTexture(e) {
    return this.emissiveTexture = this.graph.linkTexture("emissiveTexture", qo | Xo | Ko, this, e), this;
  }
  getNormalScale() {
    return this.et;
  }
  setNormalScale(e) {
    return this.et = e, this;
  }
  getNormalTexture() {
    return this.normalTexture ? this.normalTexture.getChild() : null;
  }
  getNormalTextureInfo() {
    return this.normalTexture ? this.normalTextureInfo.getChild() : null;
  }
  setNormalTexture(e) {
    return this.normalTexture = this.graph.linkTexture("normalTexture", qo | Xo | Ko, this, e), this;
  }
  getOcclusionStrength() {
    return this.it;
  }
  setOcclusionStrength(e) {
    return this.it = e, this;
  }
  getOcclusionTexture() {
    return this.occlusionTexture ? this.occlusionTexture.getChild() : null;
  }
  getOcclusionTextureInfo() {
    return this.occlusionTexture ? this.occlusionTextureInfo.getChild() : null;
  }
  setOcclusionTexture(e) {
    return this.occlusionTexture = this.graph.linkTexture("occlusionTexture", qo, this, e), this;
  }
  getRoughnessFactor() {
    return this.rt;
  }
  setRoughnessFactor(e) {
    return this.rt = e, this;
  }
  getMetallicFactor() {
    return this.nt;
  }
  setMetallicFactor(e) {
    return this.nt = e, this;
  }
  getMetallicRoughnessTexture() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTexture.getChild() : null;
  }
  getMetallicRoughnessTextureInfo() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTextureInfo.getChild() : null;
  }
  setMetallicRoughnessTexture(e) {
    return this.metallicRoughnessTexture = this.graph.linkTexture("metallicRoughnessTexture", Xo | Ko, this, e), this;
  }
}
tr.AlphaMode = { OPAQUE: "OPAQUE", MASK: "MASK", BLEND: "BLEND" }, Ii([En], tr.prototype, "baseColorTexture", void 0), Ii([En], tr.prototype, "baseColorTextureInfo", void 0), Ii([En], tr.prototype, "emissiveTexture", void 0), Ii([En], tr.prototype, "emissiveTextureInfo", void 0), Ii([En], tr.prototype, "normalTexture", void 0), Ii([En], tr.prototype, "normalTextureInfo", void 0), Ii([En], tr.prototype, "occlusionTexture", void 0), Ii([En], tr.prototype, "occlusionTextureInfo", void 0), Ii([En], tr.prototype, "metallicRoughnessTexture", void 0), Ii([En], tr.prototype, "metallicRoughnessTextureInfo", void 0);
class qh extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.MESH, this.ht = [], this.primitives = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.ht = [...e.ht], this.clearGraphChildList(this.primitives), e.primitives.forEach((r) => this.addPrimitive(t(r.getChild()))), this;
  }
  addPrimitive(e) {
    return this.addGraphChild(this.primitives, this.graph.link("primitive", this, e));
  }
  removePrimitive(e) {
    return this.removeGraphChild(this.primitives, e);
  }
  listPrimitives() {
    return this.primitives.map((e) => e.getChild());
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
}
Ii([Vn], qh.prototype, "primitives", void 0);
class js extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.NODE, this.ot = [0, 0, 0], this.ut = [0, 0, 0, 1], this.ct = [1, 1, 1], this.ht = [], this.i = null, this.camera = null, this.mesh = null, this.skin = null, this.children = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.ot = [...e.ot], this.ut = [...e.ut], this.ct = [...e.ct], this.ht = [...e.ht], this.setCamera(e.camera ? t(e.camera.getChild()) : null), this.setMesh(e.mesh ? t(e.mesh.getChild()) : null), this.setSkin(e.skin ? t(e.skin.getChild()) : null), t !== kn && (this.clearGraphChildList(this.children), e.children.forEach((r) => this.addChild(t(r.getChild())))), this;
  }
  getTranslation() {
    return this.ot;
  }
  getRotation() {
    return this.ut;
  }
  getScale() {
    return this.ct;
  }
  setTranslation(e) {
    return this.ot = e, this;
  }
  setRotation(e) {
    return this.ut = e, this;
  }
  setScale(e) {
    return this.ct = e, this;
  }
  getMatrix() {
    return jn.compose(this.ot, this.ut, this.ct, []);
  }
  setMatrix(e) {
    return jn.decompose(e, this.ot, this.ut, this.ct), this;
  }
  getWorldTranslation() {
    const e = [0, 0, 0];
    return jn.decompose(this.getWorldMatrix(), e, [0, 0, 0, 1], [1, 1, 1]), e;
  }
  getWorldRotation() {
    const e = [0, 0, 0, 1];
    return jn.decompose(this.getWorldMatrix(), [0, 0, 0], e, [1, 1, 1]), e;
  }
  getWorldScale() {
    const e = [1, 1, 1];
    return jn.decompose(this.getWorldMatrix(), [0, 0, 0], [0, 0, 0, 1], e), e;
  }
  getWorldMatrix() {
    const e = [];
    for (let o = this; o instanceof js; o = o.i)
      e.push(o);
    let t;
    const r = e.pop().getMatrix();
    for (; t = e.pop(); )
      _y(r, r, t.getMatrix());
    return r;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  getParent() {
    return this.i;
  }
  getMesh() {
    return this.mesh ? this.mesh.getChild() : null;
  }
  setMesh(e) {
    return this.mesh = this.graph.link("mesh", this, e), this;
  }
  getCamera() {
    return this.camera ? this.camera.getChild() : null;
  }
  setCamera(e) {
    return this.camera = this.graph.link("camera", this, e), this;
  }
  getSkin() {
    return this.skin ? this.skin.getChild() : null;
  }
  setSkin(e) {
    return this.skin = this.graph.link("skin", this, e), this;
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
  traverse(e) {
    e(this);
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Ii([En], js.prototype, "camera", void 0), Ii([En], js.prototype, "mesh", void 0), Ii([En], js.prototype, "skin", void 0), Ii([Vn], js.prototype, "children", void 0);
class Gs extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.PRIMITIVE, this.at = Gs.Mode.TRIANGLES, this.material = null, this.indices = null, this.attributes = [], this.targets = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.at = e.at, this.setIndices(e.indices ? t(e.indices.getChild()) : null), this.setMaterial(e.material ? t(e.material.getChild()) : null), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((r) => {
      this.setAttribute(r, t(e.getAttribute(r)));
    }), this.clearGraphChildList(this.targets), e.targets.forEach((r) => this.addTarget(t(r.getChild()))), this;
  }
  getIndices() {
    return this.indices ? this.indices.getChild() : null;
  }
  setIndices(e) {
    return this.indices = this.graph.linkIndex("indices", this, e), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((r) => r.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const r = this.getAttribute(e);
    if (r && this.removeGraphChild(this.attributes, r), !t)
      return this;
    const o = this.graph.linkAttribute(e, this, t);
    return this.addGraphChild(this.attributes, o);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
  getMaterial() {
    return this.material ? this.material.getChild() : null;
  }
  setMaterial(e) {
    return this.material = this.graph.link("material", this, e), this;
  }
  getMode() {
    return this.at;
  }
  setMode(e) {
    return this.at = e, this;
  }
  listTargets() {
    return this.targets.map((e) => e.getChild());
  }
  addTarget(e) {
    return this.addGraphChild(this.targets, this.graph.link("target", this, e)), this;
  }
  removeTarget(e) {
    return this.removeGraphChild(this.targets, e);
  }
}
Gs.Mode = { POINTS: 0, LINES: 1, LINE_LOOP: 2, LINE_STRIP: 3, TRIANGLES: 4, TRIANGLE_STRIP: 5, TRIANGLE_FAN: 6 }, Ii([En], Gs.prototype, "material", void 0), Ii([En], Gs.prototype, "indices", void 0), Ii([Vn], Gs.prototype, "attributes", void 0), Ii([Vn], Gs.prototype, "targets", void 0);
class Jf extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = en.PRIMITIVE_TARGET, this.attributes = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((r) => {
      this.setAttribute(r, t(e.getAttribute(r)));
    }), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((r) => r.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const r = this.getAttribute(e);
    if (r && this.removeGraphChild(this.attributes, r), !t)
      return this;
    const o = this.graph.linkAttribute(e, this, t);
    return o.semantic = e, this.addGraphChild(this.attributes, o);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
}
Ii([Vn], Jf.prototype, "attributes", void 0);
class no extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.SCENE, this.children = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), t !== kn && (this.clearGraphChildList(this.children), e.children.forEach((r) => this.addChild(t(r.getChild())))), this;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  traverse(e) {
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Ii([Vn], no.prototype, "children", void 0);
class Ja extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.SKIN, this.skeleton = null, this.inverseBindMatrices = null, this.joints = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.setSkeleton(e.skeleton ? t(e.skeleton.getChild()) : null), this.setInverseBindMatrices(e.inverseBindMatrices ? t(e.inverseBindMatrices.getChild()) : null), this.clearGraphChildList(this.joints), e.joints.forEach((r) => this.addJoint(t(r.getChild()))), this;
  }
  getSkeleton() {
    return this.skeleton ? this.skeleton.getChild() : null;
  }
  setSkeleton(e) {
    return this.skeleton = this.graph.link("skeleton", this, e), this;
  }
  getInverseBindMatrices() {
    return this.inverseBindMatrices ? this.inverseBindMatrices.getChild() : null;
  }
  setInverseBindMatrices(e) {
    return this.inverseBindMatrices = this.graph.link("inverseBindMatrices", this, e), this;
  }
  addJoint(e) {
    const t = this.graph.link("joint", this, e);
    return this.addGraphChild(this.joints, t);
  }
  removeJoint(e) {
    return this.removeGraphChild(this.joints, e);
  }
  listJoints() {
    return this.joints.map((e) => e.getChild());
  }
}
Ii([En], Ja.prototype, "skeleton", void 0), Ii([En], Ja.prototype, "inverseBindMatrices", void 0), Ii([Vn], Ja.prototype, "joints", void 0);
class $f extends zr {
  constructor(...e) {
    super(...e), this.propertyType = en.TEXTURE, this.lt = null, this.ft = "", this.P = "";
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.ft = e.ft, this.P = e.P, e.lt && (this.lt = e.lt.slice(0)), this;
  }
  getMimeType() {
    return this.ft || Ca.extensionToMimeType(ul.extension(this.P));
  }
  setMimeType(e) {
    return this.ft = e, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this.ft = Ca.extensionToMimeType(ul.extension(e)), this;
  }
  getImage() {
    return this.lt;
  }
  setImage(e) {
    return this.lt = e, this;
  }
  getSize() {
    return this.lt ? Ca.getSize(this.lt, this.getMimeType()) : null;
  }
}
class qr extends Ta {
  constructor(e) {
    super(e), this.propertyType = en.ROOT, this.dt = { generator: "glTF-Transform v1.2.4", version: "2.0" }, this.gt = /* @__PURE__ */ new Set(), this.defaultScene = null, this.accessors = [], this.animations = [], this.buffers = [], this.cameras = [], this.materials = [], this.meshes = [], this.nodes = [], this.scenes = [], this.skins = [], this.textures = [], e.on("clone", (t) => this.wt(t));
  }
  clone() {
    throw new Error("Root cannot be cloned.");
  }
  copy(e, t = kn) {
    if (super.copy(e, t), t === kn)
      throw new Error("Root cannot be copied.");
    return Object.assign(this.dt, e.dt), e.accessors.forEach((r) => this.vt(t(r.getChild()))), e.animations.forEach((r) => this.Tt(t(r.getChild()))), e.buffers.forEach((r) => this.yt(t(r.getChild()))), e.cameras.forEach((r) => this.At(t(r.getChild()))), e.materials.forEach((r) => this.Et(t(r.getChild()))), e.meshes.forEach((r) => this.xt(t(r.getChild()))), e.nodes.forEach((r) => this.St(t(r.getChild()))), e.scenes.forEach((r) => this.Mt(t(r.getChild()))), e.skins.forEach((r) => this.It(t(r.getChild()))), e.textures.forEach((r) => this.bt(t(r.getChild()))), this.setDefaultScene(e.defaultScene ? t(e.defaultScene.getChild()) : null), this;
  }
  wt(e) {
    return e instanceof no ? this.Mt(e) : e instanceof js ? this.St(e) : e instanceof ha ? this.At(e) : e instanceof Ja ? this.It(e) : e instanceof qh ? this.xt(e) : e instanceof tr ? this.Et(e) : e instanceof $f ? this.bt(e) : e instanceof cl ? this.Tt(e) : e instanceof Ai ? this.vt(e) : e instanceof Zf && this.yt(e), this;
  }
  getAsset() {
    return this.dt;
  }
  listExtensionsUsed() {
    return Array.from(this.gt);
  }
  listExtensionsRequired() {
    return this.listExtensionsUsed().filter((e) => e.isRequired());
  }
  Rt(e) {
    return this.gt.add(e), this;
  }
  Nt(e) {
    return this.gt.delete(e), this;
  }
  Mt(e) {
    return this.addGraphChild(this.scenes, this.graph.link("scene", this, e));
  }
  listScenes() {
    return this.scenes.map((e) => e.getChild());
  }
  setDefaultScene(e) {
    return this.defaultScene = this.graph.link("scene", this, e), this;
  }
  getDefaultScene() {
    return this.defaultScene ? this.defaultScene.getChild() : null;
  }
  St(e) {
    return this.addGraphChild(this.nodes, this.graph.link("node", this, e));
  }
  listNodes() {
    return this.nodes.map((e) => e.getChild());
  }
  At(e) {
    return this.addGraphChild(this.cameras, this.graph.link("camera", this, e));
  }
  listCameras() {
    return this.cameras.map((e) => e.getChild());
  }
  It(e) {
    return this.addGraphChild(this.skins, this.graph.link("skin", this, e));
  }
  listSkins() {
    return this.skins.map((e) => e.getChild());
  }
  xt(e) {
    return this.addGraphChild(this.meshes, this.graph.link("mesh", this, e));
  }
  listMeshes() {
    return this.meshes.map((e) => e.getChild());
  }
  Et(e) {
    return this.addGraphChild(this.materials, this.graph.link("material", this, e));
  }
  listMaterials() {
    return this.materials.map((e) => e.getChild());
  }
  bt(e) {
    return this.addGraphChild(this.textures, this.graph.link("texture", this, e));
  }
  listTextures() {
    return this.textures.map((e) => e.getChild());
  }
  Tt(e) {
    return this.addGraphChild(this.animations, this.graph.link("animation", this, e));
  }
  listAnimations() {
    return this.animations.map((e) => e.getChild());
  }
  vt(e) {
    return this.addGraphChild(this.accessors, this.graph.link("accessor", this, e));
  }
  listAccessors() {
    return this.accessors.map((e) => e.getChild());
  }
  yt(e) {
    return this.addGraphChild(this.buffers, this.graph.link("buffer", this, e));
  }
  listBuffers() {
    return this.buffers.map((e) => e.getChild());
  }
}
Ii([En], qr.prototype, "defaultScene", void 0), Ii([Vn], qr.prototype, "accessors", void 0), Ii([Vn], qr.prototype, "animations", void 0), Ii([Vn], qr.prototype, "buffers", void 0), Ii([Vn], qr.prototype, "cameras", void 0), Ii([Vn], qr.prototype, "materials", void 0), Ii([Vn], qr.prototype, "meshes", void 0), Ii([Vn], qr.prototype, "nodes", void 0), Ii([Vn], qr.prototype, "scenes", void 0), Ii([Vn], qr.prototype, "skins", void 0), Ii([Vn], qr.prototype, "textures", void 0);
class Xh {
  constructor() {
    this.Ct = new My(), this.Ot = new qr(this.Ct), this._t = Dr.DEFAULT_INSTANCE;
  }
  getRoot() {
    return this.Ot;
  }
  getGraph() {
    return this.Ct;
  }
  getLogger() {
    return this._t;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  clone() {
    return new Xh().merge(this).setLogger(this._t);
  }
  merge(e) {
    const t = {};
    for (const u of e.getRoot().listExtensionsUsed()) {
      const f = this.createExtension(u.constructor);
      u.isRequired() && f.setRequired(!0), t[f.extensionName] = f;
    }
    const r = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map();
    r.add(e.Ot), o.set(e.Ot, this.Ot);
    for (const u of e.Ct.getLinks())
      for (const f of [u.getParent(), u.getChild()]) {
        if (r.has(f))
          continue;
        let v;
        if (f.propertyType === en.TEXTURE_INFO)
          v = f;
        else {
          const S = f.constructor;
          v = f instanceof qf ? new S(this.Ct, t[f.extensionName]) : new S(this.Ct);
        }
        o.set(f, v), r.add(f);
      }
    const a = (u) => {
      const f = o.get(u);
      if (!f)
        throw new Error("Could resolve property.");
      return f;
    };
    for (const u of r) {
      const f = o.get(u);
      if (!f)
        throw new Error("Could resolve property.");
      f.copy(u, a);
    }
    return this;
  }
  async transform(...e) {
    const t = e.map((r) => r.name);
    for (const r of e)
      await r(this, { stack: t });
    return this;
  }
  createExtension(e) {
    const t = e.EXTENSION_NAME;
    return this.getRoot().listExtensionsUsed().find((r) => r.extensionName === t) || new e(this);
  }
  createScene(e = "") {
    const t = new no(this.Ct, e);
    return this.Ot.Mt(t), t;
  }
  createNode(e = "") {
    const t = new js(this.Ct, e);
    return this.Ot.St(t), t;
  }
  createCamera(e = "") {
    const t = new ha(this.Ct, e);
    return this.Ot.At(t), t;
  }
  createSkin(e = "") {
    const t = new Ja(this.Ct, e);
    return this.Ot.It(t), t;
  }
  createMesh(e = "") {
    const t = new qh(this.Ct, e);
    return this.Ot.xt(t), t;
  }
  createPrimitive() {
    return new Gs(this.Ct);
  }
  createPrimitiveTarget(e = "") {
    return new Jf(this.Ct, e);
  }
  createMaterial(e = "") {
    const t = new tr(this.Ct, e);
    return this.Ot.Et(t), t;
  }
  createTexture(e = "") {
    const t = new $f(this.Ct, e);
    return this.Ot.bt(t), t;
  }
  createAnimation(e = "") {
    const t = new cl(this.Ct, e);
    return this.Ot.Tt(t), t;
  }
  createAnimationChannel(e = "") {
    return new il(this.Ct, e);
  }
  createAnimationSampler(e = "") {
    return new la(this.Ct, e);
  }
  createAccessor(e = "", t = null) {
    t || (t = this.getRoot().listBuffers()[0]);
    const r = new Ai(this.Ct, e).setBuffer(t);
    return this.Ot.vt(r), r;
  }
  createBuffer(e = "") {
    const t = new Zf(this.Ct, e);
    return this.Ot.yt(t), t;
  }
}
function Xr() {
  return (Xr = Object.assign || function(y) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (y[r] = t[r]);
    }
    return y;
  }).apply(this, arguments);
}
class Ay {
  constructor(e) {
    this.jsonDoc = void 0, this.buffers = [], this.bufferViews = [], this.bufferViewBuffers = [], this.accessors = [], this.textures = [], this.textureInfos = /* @__PURE__ */ new Map(), this.materials = [], this.meshes = [], this.cameras = [], this.nodes = [], this.skins = [], this.animations = [], this.scenes = [], this.jsonDoc = e;
  }
  setTextureInfo(e, t) {
    this.textureInfos.set(e, t), t.texCoord !== void 0 && e.setTexCoord(t.texCoord);
    const r = this.jsonDoc.json.textures[t.index];
    if (r.sampler === void 0)
      return;
    const o = this.jsonDoc.json.samplers[r.sampler];
    o.magFilter !== void 0 && e.setMagFilter(o.magFilter), o.minFilter !== void 0 && e.setMinFilter(o.minFilter), o.wrapS !== void 0 && e.setWrapS(o.wrapS), o.wrapT !== void 0 && e.setWrapT(o.wrapT);
  }
}
const Oh = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, cf = { logger: Dr.DEFAULT_INSTANCE, extensions: [], dependencies: {} };
function Jo(y, e) {
  const t = e.bufferViews[y.bufferView], r = e.jsonDoc.json.bufferViews[y.bufferView], o = Oh[y.componentType], a = Ai.getElementSize(y.type), u = o.BYTES_PER_ELEMENT;
  if (r.byteStride !== void 0 && r.byteStride !== a * u)
    return function(v, S) {
      const I = S.bufferViews[v.bufferView], D = S.jsonDoc.json.bufferViews[v.bufferView], Z = Oh[v.componentType], M = Ai.getElementSize(v.type), X = Z.BYTES_PER_ELEMENT, Y = v.byteOffset || 0, ie = new Z(v.count * M), G = new DataView(I.buffer, I.byteOffset, I.byteLength), te = D.byteStride;
      for (let J = 0; J < v.count; J++)
        for (let he = 0; he < M; he++) {
          const ve = Y + J * te + he * X;
          let K;
          switch (v.componentType) {
            case Ai.ComponentType.FLOAT:
              K = G.getFloat32(ve, !0);
              break;
            case Ai.ComponentType.UNSIGNED_INT:
              K = G.getUint32(ve, !0);
              break;
            case Ai.ComponentType.UNSIGNED_SHORT:
              K = G.getUint16(ve, !0);
              break;
            case Ai.ComponentType.UNSIGNED_BYTE:
              K = G.getUint8(ve);
              break;
            case Ai.ComponentType.SHORT:
              K = G.getInt16(ve, !0);
              break;
            case Ai.ComponentType.BYTE:
              K = G.getInt8(ve);
              break;
            default:
              throw new Error(`Unexpected componentType "${v.componentType}".`);
          }
          ie[J * M + he] = K;
        }
      return ie;
    }(y, e);
  const f = t.byteOffset + (y.byteOffset || 0);
  return new o(t.buffer.slice(f, f + y.count * a * u));
}
var $a, Qa;
(function(y) {
  y[y.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", y[y.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER";
})($a || ($a = {})), function(y) {
  y.ARRAY_BUFFER = "ARRAY_BUFFER", y.ELEMENT_ARRAY_BUFFER = "ELEMENT_ARRAY_BUFFER", y.INVERSE_BIND_MATRICES = "INVERSE_BIND_MATRICES", y.OTHER = "OTHER";
}(Qa || (Qa = {}));
class Jr {
  constructor(e, t, r) {
    this.Bt = void 0, this.jsonDoc = void 0, this.options = void 0, this.accessorIndexMap = /* @__PURE__ */ new Map(), this.bufferIndexMap = /* @__PURE__ */ new Map(), this.cameraIndexMap = /* @__PURE__ */ new Map(), this.skinIndexMap = /* @__PURE__ */ new Map(), this.materialIndexMap = /* @__PURE__ */ new Map(), this.meshIndexMap = /* @__PURE__ */ new Map(), this.nodeIndexMap = /* @__PURE__ */ new Map(), this.imageIndexMap = /* @__PURE__ */ new Map(), this.textureDefIndexMap = /* @__PURE__ */ new Map(), this.textureInfoDefMap = /* @__PURE__ */ new Map(), this.samplerDefIndexMap = /* @__PURE__ */ new Map(), this.imageBufferViews = [], this.otherBufferViews = /* @__PURE__ */ new Map(), this.otherBufferViewsIndexMap = /* @__PURE__ */ new Map(), this.extensionData = {}, this.bufferURIGenerator = void 0, this.imageURIGenerator = void 0, this.logger = void 0, this.Lt = /* @__PURE__ */ new Map(), this.accessorUsageGroupedByParent = /* @__PURE__ */ new Set(["ARRAY_BUFFER"]), this.accessorParents = /* @__PURE__ */ new Map(), this.Bt = e, this.jsonDoc = t, this.options = r;
    const o = e.getRoot(), a = o.listBuffers().length, u = o.listTextures().length;
    this.bufferURIGenerator = new ff(a > 1, r.basename), this.imageURIGenerator = new ff(u > 1, r.basename), this.logger = e.getLogger();
  }
  createTextureInfoDef(e, t) {
    const r = { magFilter: t.getMagFilter() || void 0, minFilter: t.getMinFilter() || void 0, wrapS: t.getWrapS(), wrapT: t.getWrapT() }, o = JSON.stringify(r);
    this.samplerDefIndexMap.has(o) || (this.samplerDefIndexMap.set(o, this.jsonDoc.json.samplers.length), this.jsonDoc.json.samplers.push(r));
    const a = { source: this.imageIndexMap.get(e), sampler: this.samplerDefIndexMap.get(o) }, u = JSON.stringify(a);
    this.textureDefIndexMap.has(u) || (this.textureDefIndexMap.set(u, this.jsonDoc.json.textures.length), this.jsonDoc.json.textures.push(a));
    const f = { index: this.textureDefIndexMap.get(u) };
    return t.getTexCoord() !== 0 && (f.texCoord = t.getTexCoord()), this.textureInfoDefMap.set(t, f), f;
  }
  createPropertyDef(e) {
    const t = {};
    return e.getName() && (t.name = e.getName()), Object.keys(e.getExtras()).length > 0 && (t.extras = e.getExtras()), t;
  }
  createAccessorDef(e) {
    const t = this.createPropertyDef(e);
    return t.type = e.getType(), t.componentType = e.getComponentType(), t.count = e.getCount(), this.Bt.getGraph().listParentLinks(e).some((r) => r.getName() === "POSITION" || r.getName() === "input") && (t.max = e.getMax([]).map(Math.fround), t.min = e.getMin([]).map(Math.fround)), e.getNormalized() && (t.normalized = e.getNormalized()), t;
  }
  createImageData(e, t, r) {
    if (this.options.format === oa.GLB)
      this.imageBufferViews.push(t), e.bufferView = this.jsonDoc.json.bufferViews.length, this.jsonDoc.json.bufferViews.push({ buffer: 0, byteOffset: -1, byteLength: t.byteLength });
    else {
      const o = Ca.mimeTypeToExtension(r.getMimeType());
      e.uri = this.imageURIGenerator.createURI(r, o), this.jsonDoc.resources[e.uri] = t;
    }
  }
  getAccessorUsage(e) {
    const t = this.Lt.get(e);
    if (t)
      return t;
    for (const r of this.Bt.getGraph().listParentLinks(e)) {
      if (r.getName() === "inverseBindMatrices")
        return Jr.BufferViewUsage.INVERSE_BIND_MATRICES;
      if (r instanceof Xf)
        return Jr.BufferViewUsage.ARRAY_BUFFER;
      if (r instanceof Kf)
        return Jr.BufferViewUsage.ELEMENT_ARRAY_BUFFER;
    }
    return Jr.BufferViewUsage.OTHER;
  }
  addAccessorToUsageGroup(e, t) {
    const r = this.Lt.get(e);
    if (r && r !== t)
      throw new Error(`Accessor with usage "${r}" cannot be reused as "${t}".`);
    return this.Lt.set(e, t), this;
  }
  listAccessorUsageGroups() {
    const e = {};
    for (const [t, r] of Array.from(this.Lt.entries()))
      e[r] = e[r] || [], e[r].push(t);
    return e;
  }
}
Jr.BufferViewTarget = $a, Jr.BufferViewUsage = Qa, Jr.USAGE_TO_TARGET = { [Qa.ARRAY_BUFFER]: $a.ARRAY_BUFFER, [Qa.ELEMENT_ARRAY_BUFFER]: $a.ELEMENT_ARRAY_BUFFER };
class ff {
  constructor(e, t) {
    this.multiple = void 0, this.basename = void 0, this.counter = 1, this.multiple = e, this.basename = t;
  }
  createURI(e, t) {
    return e.getURI() ? e.getURI() : this.multiple ? `${this.basename}_${this.counter++}.${t}` : `${this.basename}.${t}`;
  }
}
const { BufferViewUsage: xh } = Jr;
var fl;
(function(y) {
  y[y.JSON = 1313821514] = "JSON", y[y.BIN = 5130562] = "BIN";
})(fl || (fl = {}));
class Ty {
  constructor() {
    this._t = Dr.DEFAULT_INSTANCE, this.gt = /* @__PURE__ */ new Set(), this.Pt = {}, this.Ut = hl.INTERLEAVED;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  registerExtensions(e) {
    for (const t of e)
      this.gt.add(t), t.register();
    return this;
  }
  registerDependencies(e) {
    return Object.assign(this.Pt, e), this;
  }
  setVertexLayout(e) {
    return this.Ut = e, this;
  }
  kt(e) {
    function t(r) {
      if (r.uri && !(r.uri in e.resources) && r.uri.match(/data:/)) {
        const o = `__${wy()}.${ul.extension(r.uri)}`;
        e.resources[o] = vr.createBufferFromDataURI(r.uri), r.uri = o;
      }
    }
    (e.json.images || []).forEach((r) => {
      if (r.bufferView === void 0 && r.uri === void 0)
        throw new Error("Missing resource URI or buffer view.");
      t(r);
    }), (e.json.buffers || []).forEach(t);
  }
  readJSON(e) {
    return e = this.Ft(e), this.kt(e), (class {
      static read(t, r = cf) {
        const o = Xr({}, cf, r), { json: a } = t, u = new Xh();
        this.validate(t, o);
        const f = new Ay(t), v = a.asset, S = u.getRoot().getAsset();
        v.copyright && (S.copyright = v.copyright), v.extras && (S.extras = v.extras), a.extras !== void 0 && u.getRoot().setExtras(Xr({}, a.extras));
        const I = a.extensionsUsed || [], D = a.extensionsRequired || [];
        for (const te of o.extensions)
          if (I.includes(te.EXTENSION_NAME)) {
            const J = u.createExtension(te).setRequired(D.includes(te.EXTENSION_NAME));
            for (const he of J.readDependencies)
              J.install(he, o.dependencies[he]);
          }
        const Z = a.buffers || [];
        u.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.BUFFER)).forEach((te) => te.preread(f, en.BUFFER)), f.buffers = Z.map((te) => {
          const J = u.createBuffer(te.name);
          return te.extras && J.setExtras(te.extras), te.uri && te.uri.indexOf("__") !== 0 && J.setURI(te.uri), J;
        }), f.bufferViewBuffers = (a.bufferViews || []).map((te, J) => {
          if (!f.bufferViews[J]) {
            const he = t.json.buffers[te.buffer], ve = new Uint8Array(he.uri ? t.resources[he.uri] : t.resources["@glb.bin"], te.byteOffset || 0, te.byteLength);
            f.bufferViews[J] = ve;
          }
          return f.buffers[te.buffer];
        }), f.accessors = (a.accessors || []).map((te) => {
          const J = u.createAccessor(te.name, f.bufferViewBuffers[te.bufferView]).setType(te.type);
          if (te.extras && J.setExtras(te.extras), te.normalized !== void 0 && J.setNormalized(te.normalized), te.bufferView === void 0 && !te.sparse)
            return J;
          let he;
          return he = te.sparse !== void 0 ? function(ve, K) {
            const j = Oh[ve.componentType], We = Ai.getElementSize(ve.type);
            let ke;
            ke = ve.bufferView !== void 0 ? Jo(ve, K) : new j(ve.count * We);
            const $e = ve.sparse, Lt = $e.count, Be = Xr({}, ve, $e.indices, { count: Lt, type: "SCALAR" }), Xe = Xr({}, ve, $e.values, { count: Lt }), ue = Jo(Be, K), yt = Jo(Xe, K);
            for (let Ue = 0; Ue < Be.count; Ue++)
              for (let ot = 0; ot < We; ot++)
                ke[ue[Ue] * We + ot] = yt[Ue * We + ot];
            return ke;
          }(te, f) : Jo(te, f), J.setArray(he), J;
        });
        const M = a.images || [], X = a.textures || [];
        u.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.TEXTURE)).forEach((te) => te.preread(f, en.TEXTURE)), f.textures = M.map((te) => {
          const J = u.createTexture(te.name);
          if (te.extras && J.setExtras(te.extras), te.bufferView !== void 0) {
            const he = a.bufferViews[te.bufferView], ve = t.json.buffers[he.buffer], K = he.byteOffset || 0, j = (ve.uri ? t.resources[ve.uri] : t.resources["@glb.bin"]).slice(K, K + he.byteLength);
            J.setImage(j);
          } else
            te.uri !== void 0 && (J.setImage(t.resources[te.uri]), te.uri.indexOf("__") !== 0 && J.setURI(te.uri));
          if (te.mimeType !== void 0)
            J.setMimeType(te.mimeType);
          else if (te.uri) {
            const he = ul.extension(te.uri);
            J.setMimeType(Ca.extensionToMimeType(he));
          }
          return J;
        }), f.materials = (a.materials || []).map((te) => {
          const J = u.createMaterial(te.name);
          te.extras && J.setExtras(te.extras), te.alphaMode !== void 0 && J.setAlphaMode(te.alphaMode), te.alphaCutoff !== void 0 && J.setAlphaCutoff(te.alphaCutoff), te.doubleSided !== void 0 && J.setDoubleSided(te.doubleSided);
          const he = te.pbrMetallicRoughness || {};
          if (he.baseColorFactor !== void 0 && J.setBaseColorFactor(he.baseColorFactor), te.emissiveFactor !== void 0 && J.setEmissiveFactor(te.emissiveFactor), he.metallicFactor !== void 0 && J.setMetallicFactor(he.metallicFactor), he.roughnessFactor !== void 0 && J.setRoughnessFactor(he.roughnessFactor), he.baseColorTexture !== void 0) {
            const ve = he.baseColorTexture;
            J.setBaseColorTexture(f.textures[X[ve.index].source]), f.setTextureInfo(J.getBaseColorTextureInfo(), ve);
          }
          if (te.emissiveTexture !== void 0) {
            const ve = te.emissiveTexture;
            J.setEmissiveTexture(f.textures[X[ve.index].source]), f.setTextureInfo(J.getEmissiveTextureInfo(), ve);
          }
          if (te.normalTexture !== void 0) {
            const ve = te.normalTexture;
            J.setNormalTexture(f.textures[X[ve.index].source]), f.setTextureInfo(J.getNormalTextureInfo(), ve), te.normalTexture.scale !== void 0 && J.setNormalScale(te.normalTexture.scale);
          }
          if (te.occlusionTexture !== void 0) {
            const ve = te.occlusionTexture;
            J.setOcclusionTexture(f.textures[X[ve.index].source]), f.setTextureInfo(J.getOcclusionTextureInfo(), ve), te.occlusionTexture.strength !== void 0 && J.setOcclusionStrength(te.occlusionTexture.strength);
          }
          if (he.metallicRoughnessTexture !== void 0) {
            const ve = he.metallicRoughnessTexture;
            J.setMetallicRoughnessTexture(f.textures[X[ve.index].source]), f.setTextureInfo(J.getMetallicRoughnessTextureInfo(), ve);
          }
          return J;
        });
        const Y = a.meshes || [];
        u.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.PRIMITIVE)).forEach((te) => te.preread(f, en.PRIMITIVE)), f.meshes = Y.map((te) => {
          const J = u.createMesh(te.name);
          return te.extras && J.setExtras(te.extras), te.weights !== void 0 && J.setWeights(te.weights), (te.primitives || []).forEach((he) => {
            const ve = u.createPrimitive();
            he.extras && ve.setExtras(he.extras), he.material !== void 0 && ve.setMaterial(f.materials[he.material]), he.mode !== void 0 && ve.setMode(he.mode);
            for (const [j, We] of Object.entries(he.attributes || {}))
              ve.setAttribute(j, f.accessors[We]);
            he.indices !== void 0 && ve.setIndices(f.accessors[he.indices]);
            const K = te.extras && te.extras.targetNames || [];
            (he.targets || []).forEach((j, We) => {
              const ke = K[We] || We.toString(), $e = u.createPrimitiveTarget(ke);
              for (const [Lt, Be] of Object.entries(j))
                $e.setAttribute(Lt, f.accessors[Be]);
              ve.addTarget($e);
            }), J.addPrimitive(ve);
          }), J;
        }), f.cameras = (a.cameras || []).map((te) => {
          const J = u.createCamera(te.name).setType(te.type);
          if (te.extras && J.setExtras(te.extras), te.type === ha.Type.PERSPECTIVE) {
            const he = te.perspective;
            J.setYFov(he.yfov), J.setZNear(he.znear), he.zfar !== void 0 && J.setZFar(he.zfar), he.aspectRatio !== void 0 && J.setAspectRatio(he.aspectRatio);
          } else {
            const he = te.orthographic;
            J.setZNear(he.znear).setZFar(he.zfar).setXMag(he.xmag).setYMag(he.ymag);
          }
          return J;
        });
        const ie = a.nodes || [];
        u.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.NODE)).forEach((te) => te.preread(f, en.NODE)), f.nodes = ie.map((te) => {
          const J = u.createNode(te.name);
          if (te.extras && J.setExtras(te.extras), te.translation !== void 0 && J.setTranslation(te.translation), te.rotation !== void 0 && J.setRotation(te.rotation), te.scale !== void 0 && J.setScale(te.scale), te.matrix !== void 0) {
            const he = [0, 0, 0], ve = [0, 0, 0, 1], K = [1, 1, 1];
            jn.decompose(te.matrix, he, ve, K), J.setTranslation(he), J.setRotation(ve), J.setScale(K);
          }
          return te.weights !== void 0 && J.setWeights(te.weights), J;
        }), f.skins = (a.skins || []).map((te) => {
          const J = u.createSkin(te.name);
          te.extras && J.setExtras(te.extras), te.inverseBindMatrices !== void 0 && J.setInverseBindMatrices(f.accessors[te.inverseBindMatrices]), te.skeleton !== void 0 && J.setSkeleton(f.nodes[te.skeleton]);
          for (const he of te.joints)
            J.addJoint(f.nodes[he]);
          return J;
        }), ie.map((te, J) => {
          const he = f.nodes[J];
          (te.children || []).forEach((ve) => he.addChild(f.nodes[ve])), te.mesh !== void 0 && he.setMesh(f.meshes[te.mesh]), te.camera !== void 0 && he.setCamera(f.cameras[te.camera]), te.skin !== void 0 && he.setSkin(f.skins[te.skin]);
        }), f.animations = (a.animations || []).map((te) => {
          const J = u.createAnimation(te.name);
          te.extras && J.setExtras(te.extras);
          const he = (te.samplers || []).map((ve) => {
            const K = u.createAnimationSampler().setInput(f.accessors[ve.input]).setOutput(f.accessors[ve.output]).setInterpolation(ve.interpolation || la.Interpolation.LINEAR);
            return ve.extras && K.setExtras(ve.extras), J.addSampler(K), K;
          });
          return (te.channels || []).forEach((ve) => {
            const K = u.createAnimationChannel().setSampler(he[ve.sampler]).setTargetNode(f.nodes[ve.target.node]).setTargetPath(ve.target.path);
            ve.extras && K.setExtras(ve.extras), J.addChannel(K);
          }), J;
        });
        const G = a.scenes || [];
        return u.getRoot().listExtensionsUsed().filter((te) => te.prereadTypes.includes(en.SCENE)).forEach((te) => te.preread(f, en.SCENE)), f.scenes = G.map((te) => {
          const J = u.createScene(te.name);
          return te.extras && J.setExtras(te.extras), (te.nodes || []).map((he) => f.nodes[he]).forEach((he) => J.addChild(he)), J;
        }), a.scene !== void 0 && u.getRoot().setDefaultScene(f.scenes[a.scene]), u.getRoot().listExtensionsUsed().forEach((te) => te.read(f)), u;
      }
      static validate(t, r) {
        const o = t.json;
        if (o.asset.version !== "2.0")
          throw new Error(`Unsupported glTF version, "${o.asset.version}".`);
        if (o.extensionsRequired) {
          for (const a of o.extensionsRequired)
            if (!r.extensions.find((u) => u.EXTENSION_NAME === a))
              throw new Error(`Missing required extension, "${a}".`);
        }
        if (o.extensionsUsed)
          for (const a of o.extensionsUsed)
            r.extensions.find((u) => u.EXTENSION_NAME === a) || r.logger.warn(`Missing optional extension, "${a}".`);
      }
    }).read(e, { extensions: Array.from(this.gt), dependencies: this.Pt, logger: this._t });
  }
  writeJSON(e, t = {}) {
    if (t.format === oa.GLB && e.getRoot().listBuffers().length > 1)
      throw new Error("GLB must have 0–1 buffers.");
    return (class {
      static write(r, o) {
        const a = r.getRoot(), u = { asset: Xr({ generator: "glTF-Transform v1.2.4" }, a.getAsset()), extras: Xr({}, a.getExtras()) }, f = { json: u, resources: {} }, v = new Jr(r, f, o), S = o.logger || Dr.DEFAULT_INSTANCE, I = new Set(o.extensions.map((G) => G.EXTENSION_NAME)), D = r.getRoot().listExtensionsUsed().filter((G) => I.has(G.extensionName)), Z = r.getRoot().listExtensionsRequired().filter((G) => I.has(G.extensionName));
        D.length < r.getRoot().listExtensionsUsed().length && S.debug("Some extensions were not registered for I/O, and will not be written.");
        for (const G of D)
          for (const te of G.writeDependencies)
            G.install(te, o.dependencies[te]);
        function M(G, te, J, he) {
          const ve = [];
          let K = 0;
          for (const We of G) {
            const ke = v.createAccessorDef(We);
            ke.bufferView = u.bufferViews.length;
            const $e = vr.pad(We.getArray().buffer);
            ke.byteOffset = K, K += $e.byteLength, ve.push($e), v.accessorIndexMap.set(We, u.accessors.length), u.accessors.push(ke);
          }
          const j = { buffer: te, byteOffset: J, byteLength: vr.concat(ve).byteLength };
          return he && (j.target = he), u.bufferViews.push(j), { buffers: ve, byteLength: K };
        }
        function X(G, te, J) {
          const he = G[0].getCount();
          let ve = 0;
          for (const ke of G) {
            const $e = v.createAccessorDef(ke);
            $e.bufferView = u.bufferViews.length, $e.byteOffset = ve;
            const Lt = ke.getElementSize(), Be = ke.getComponentSize();
            ve += vr.padNumber(Lt * Be), v.accessorIndexMap.set(ke, u.accessors.length), u.accessors.push($e);
          }
          const K = he * ve, j = new ArrayBuffer(K), We = new DataView(j);
          for (let ke = 0; ke < he; ke++) {
            let $e = 0;
            for (const Lt of G) {
              const Be = Lt.getElementSize(), Xe = Lt.getComponentSize(), ue = Lt.getComponentType(), yt = Lt.getArray();
              for (let Ue = 0; Ue < Be; Ue++) {
                const ot = ke * ve + $e + Ue * Xe, Gt = yt[ke * Be + Ue];
                switch (ue) {
                  case Ai.ComponentType.FLOAT:
                    We.setFloat32(ot, Gt, !0);
                    break;
                  case Ai.ComponentType.BYTE:
                    We.setInt8(ot, Gt);
                    break;
                  case Ai.ComponentType.SHORT:
                    We.setInt16(ot, Gt, !0);
                    break;
                  case Ai.ComponentType.UNSIGNED_BYTE:
                    We.setUint8(ot, Gt);
                    break;
                  case Ai.ComponentType.UNSIGNED_SHORT:
                    We.setUint16(ot, Gt, !0);
                    break;
                  case Ai.ComponentType.UNSIGNED_INT:
                    We.setUint32(ot, Gt, !0);
                    break;
                  default:
                    throw new Error("Unexpected component type: " + ue);
                }
              }
              $e += vr.padNumber(Be * Xe);
            }
          }
          return u.bufferViews.push({ buffer: te, byteOffset: J, byteLength: K, byteStride: ve, target: Jr.BufferViewTarget.ARRAY_BUFFER }), { byteLength: K, buffers: [j] };
        }
        const Y = /* @__PURE__ */ new Map();
        for (const G of r.getGraph().getLinks()) {
          if (G.getParent() === a)
            continue;
          const te = G.getChild();
          if (te instanceof Ai) {
            const J = Y.get(te) || [];
            J.push(G), Y.set(te, J);
          }
        }
        if (u.accessors = [], u.bufferViews = [], u.samplers = [], u.textures = [], u.images = a.listTextures().map((G, te) => {
          const J = v.createPropertyDef(G);
          G.getMimeType() && (J.mimeType = G.getMimeType());
          const he = G.getImage();
          return he && v.createImageData(J, he, G), v.imageIndexMap.set(G, te), J;
        }), D.filter((G) => G.prewriteTypes.includes(en.ACCESSOR)).forEach((G) => G.prewrite(v, en.ACCESSOR)), a.listAccessors().forEach((G) => {
          const te = v.accessorUsageGroupedByParent, J = v.accessorParents;
          if (v.accessorIndexMap.has(G))
            return;
          const he = Y.get(G) || [], ve = v.getAccessorUsage(G);
          if (v.addAccessorToUsageGroup(G, ve), te.has(ve)) {
            const K = he[0].getParent(), j = J.get(K) || /* @__PURE__ */ new Set();
            j.add(G), J.set(K, j);
          }
        }), D.filter((G) => G.prewriteTypes.includes(en.BUFFER)).forEach((G) => G.prewrite(v, en.BUFFER)), (a.listAccessors().length > 0 || a.listTextures().length > 0 || v.otherBufferViews.size > 0) && a.listBuffers().length === 0)
          throw new Error("Buffer required for Document resources, but none was found.");
        u.buffers = [], a.listBuffers().forEach((G, te) => {
          const J = v.createPropertyDef(G), he = v.accessorUsageGroupedByParent, ve = v.accessorParents, K = G.listParents().filter((Be) => Be instanceof Ai), j = new Set(K), We = [], ke = u.buffers.length;
          let $e = 0;
          const Lt = v.listAccessorUsageGroups();
          for (const Be in Lt)
            if (he.has(Be))
              for (const Xe of Array.from(ve.values())) {
                const ue = Array.from(Xe).filter((yt) => j.has(yt)).filter((yt) => v.getAccessorUsage(yt) === Be);
                if (ue.length)
                  if (Be !== xh.ARRAY_BUFFER || o.vertexLayout === hl.INTERLEAVED) {
                    const yt = Be === xh.ARRAY_BUFFER ? X(ue, ke, $e) : M(ue, ke, $e);
                    $e += yt.byteLength, We.push(...yt.buffers);
                  } else
                    for (const yt of ue) {
                      const Ue = X([yt], ke, $e);
                      $e += Ue.byteLength, We.push(...Ue.buffers);
                    }
              }
            else {
              const Xe = Lt[Be].filter((yt) => j.has(yt));
              if (!Xe.length)
                continue;
              const ue = M(Xe, ke, $e, Be === xh.ELEMENT_ARRAY_BUFFER ? Jr.BufferViewTarget.ELEMENT_ARRAY_BUFFER : void 0);
              $e += ue.byteLength, We.push(...ue.buffers);
            }
          if (v.imageBufferViews.length && te === 0) {
            for (let Be = 0; Be < v.imageBufferViews.length; Be++)
              if (u.bufferViews[u.images[Be].bufferView].byteOffset = $e, $e += v.imageBufferViews[Be].byteLength, We.push(v.imageBufferViews[Be]), $e % 8) {
                const Xe = 8 - $e % 8;
                $e += Xe, We.push(new ArrayBuffer(Xe));
              }
          }
          if (v.otherBufferViews.has(G))
            for (const Be of v.otherBufferViews.get(G))
              u.bufferViews.push({ buffer: ke, byteOffset: $e, byteLength: Be.byteLength }), v.otherBufferViewsIndexMap.set(Be, u.bufferViews.length - 1), $e += Be.byteLength, We.push(Be);
          if ($e) {
            let Be;
            o.format === oa.GLB ? Be = "@glb.bin" : (Be = v.bufferURIGenerator.createURI(G, "bin"), J.uri = Be), J.byteLength = $e, f.resources[Be] = vr.concat(We);
          }
          u.buffers.push(J), v.bufferIndexMap.set(G, te);
        }), a.listAccessors().find((G) => !G.getBuffer()) && S.warn("Skipped writing one or more Accessors: no Buffer assigned."), u.materials = a.listMaterials().map((G, te) => {
          const J = v.createPropertyDef(G);
          if (G.getAlphaMode() !== tr.AlphaMode.OPAQUE && (J.alphaMode = G.getAlphaMode()), G.getAlphaMode() === tr.AlphaMode.MASK && (J.alphaCutoff = G.getAlphaCutoff()), G.getDoubleSided() && (J.doubleSided = !0), J.pbrMetallicRoughness = {}, jn.eq(G.getBaseColorFactor(), [1, 1, 1, 1]) || (J.pbrMetallicRoughness.baseColorFactor = G.getBaseColorFactor()), jn.eq(G.getEmissiveFactor(), [0, 0, 0]) || (J.emissiveFactor = G.getEmissiveFactor()), G.getRoughnessFactor() !== 1 && (J.pbrMetallicRoughness.roughnessFactor = G.getRoughnessFactor()), G.getMetallicFactor() !== 1 && (J.pbrMetallicRoughness.metallicFactor = G.getMetallicFactor()), G.getBaseColorTexture()) {
            const he = G.getBaseColorTexture(), ve = G.getBaseColorTextureInfo();
            J.pbrMetallicRoughness.baseColorTexture = v.createTextureInfoDef(he, ve);
          }
          if (G.getEmissiveTexture()) {
            const he = G.getEmissiveTexture(), ve = G.getEmissiveTextureInfo();
            J.emissiveTexture = v.createTextureInfoDef(he, ve);
          }
          if (G.getNormalTexture()) {
            const he = G.getNormalTexture(), ve = G.getNormalTextureInfo(), K = v.createTextureInfoDef(he, ve);
            G.getNormalScale() !== 1 && (K.scale = G.getNormalScale()), J.normalTexture = K;
          }
          if (G.getOcclusionTexture()) {
            const he = G.getOcclusionTexture(), ve = G.getOcclusionTextureInfo(), K = v.createTextureInfoDef(he, ve);
            G.getOcclusionStrength() !== 1 && (K.strength = G.getOcclusionStrength()), J.occlusionTexture = K;
          }
          if (G.getMetallicRoughnessTexture()) {
            const he = G.getMetallicRoughnessTexture(), ve = G.getMetallicRoughnessTextureInfo();
            J.pbrMetallicRoughness.metallicRoughnessTexture = v.createTextureInfoDef(he, ve);
          }
          return v.materialIndexMap.set(G, te), J;
        }), u.meshes = a.listMeshes().map((G, te) => {
          const J = v.createPropertyDef(G);
          let he = null;
          return J.primitives = G.listPrimitives().map((ve) => {
            const K = { attributes: {} };
            K.mode = ve.getMode();
            const j = ve.getMaterial();
            j && (K.material = v.materialIndexMap.get(j)), Object.keys(ve.getExtras()).length && (K.extras = ve.getExtras());
            const We = ve.getIndices();
            We && (K.indices = v.accessorIndexMap.get(We));
            for (const ke of ve.listSemantics())
              K.attributes[ke] = v.accessorIndexMap.get(ve.getAttribute(ke));
            for (const ke of ve.listTargets()) {
              const $e = {};
              for (const Lt of ke.listSemantics())
                $e[Lt] = v.accessorIndexMap.get(ke.getAttribute(Lt));
              K.targets = K.targets || [], K.targets.push($e);
            }
            return ve.listTargets().length && !he && (he = ve.listTargets().map((ke) => ke.getName())), K;
          }), G.getWeights().length && (J.weights = G.getWeights()), he && (J.extras = J.extras || {}, J.extras.targetNames = he), v.meshIndexMap.set(G, te), J;
        }), u.cameras = a.listCameras().map((G, te) => {
          const J = v.createPropertyDef(G);
          if (J.type = G.getType(), J.type === ha.Type.PERSPECTIVE) {
            J.perspective = { znear: G.getZNear(), zfar: G.getZFar(), yfov: G.getYFov() };
            const he = G.getAspectRatio();
            he !== null && (J.perspective.aspectRatio = he);
          } else
            J.orthographic = { znear: G.getZNear(), zfar: G.getZFar(), xmag: G.getXMag(), ymag: G.getYMag() };
          return v.cameraIndexMap.set(G, te), J;
        }), u.nodes = a.listNodes().map((G, te) => {
          const J = v.createPropertyDef(G);
          return jn.eq(G.getTranslation(), [0, 0, 0]) || (J.translation = G.getTranslation()), jn.eq(G.getRotation(), [0, 0, 0, 1]) || (J.rotation = G.getRotation()), jn.eq(G.getScale(), [1, 1, 1]) || (J.scale = G.getScale()), G.getWeights().length && (J.weights = G.getWeights()), v.nodeIndexMap.set(G, te), J;
        }), u.skins = a.listSkins().map((G, te) => {
          const J = v.createPropertyDef(G), he = G.getInverseBindMatrices();
          he && (J.inverseBindMatrices = v.accessorIndexMap.get(he));
          const ve = G.getSkeleton();
          return ve && (J.skeleton = v.nodeIndexMap.get(ve)), J.joints = G.listJoints().map((K) => v.nodeIndexMap.get(K)), v.skinIndexMap.set(G, te), J;
        }), a.listNodes().forEach((G, te) => {
          const J = u.nodes[te], he = G.getMesh();
          he && (J.mesh = v.meshIndexMap.get(he));
          const ve = G.getCamera();
          ve && (J.camera = v.cameraIndexMap.get(ve));
          const K = G.getSkin();
          K && (J.skin = v.skinIndexMap.get(K)), G.listChildren().length > 0 && (J.children = G.listChildren().map((j) => v.nodeIndexMap.get(j)));
        }), u.animations = a.listAnimations().map((G) => {
          const te = v.createPropertyDef(G), J = /* @__PURE__ */ new Map();
          return te.samplers = G.listSamplers().map((he, ve) => {
            const K = v.createPropertyDef(he);
            return K.input = v.accessorIndexMap.get(he.getInput()), K.output = v.accessorIndexMap.get(he.getOutput()), K.interpolation = he.getInterpolation(), J.set(he, ve), K;
          }), te.channels = G.listChannels().map((he) => {
            const ve = v.createPropertyDef(he);
            return ve.sampler = J.get(he.getSampler()), ve.target = { node: v.nodeIndexMap.get(he.getTargetNode()), path: he.getTargetPath() }, ve;
          }), te;
        }), u.scenes = a.listScenes().map((G) => {
          const te = v.createPropertyDef(G);
          return te.nodes = G.listChildren().map((J) => v.nodeIndexMap.get(J)), te;
        });
        const ie = a.getDefaultScene();
        return ie && (u.scene = a.listScenes().indexOf(ie)), u.extensionsUsed = D.map((G) => G.extensionName), u.extensionsRequired = Z.map((G) => G.extensionName), D.forEach((G) => G.write(v)), function(G) {
          const te = [];
          for (const J in G) {
            const he = G[J];
            (Array.isArray(he) && he.length === 0 || he === null || he === "" || he && typeof he == "object" && Object.keys(he).length === 0) && te.push(J);
          }
          for (const J of te)
            delete G[J];
        }(u), f;
      }
    }).write(e, { format: t.format || oa.GLTF, basename: t.basename || "", logger: this._t, vertexLayout: this.Ut, dependencies: Xr({}, this.Pt), extensions: Array.from(this.gt) });
  }
  Ft(e) {
    const { images: t, buffers: r } = e.json;
    return e = { json: Xr({}, e.json), resources: Xr({}, e.resources) }, t && (e.json.images = t.map((o) => Xr({}, o))), r && (e.json.buffers = r.map((o) => Xr({}, o))), e;
  }
  binaryToJSON(e) {
    const t = this.Gt(e);
    this.kt(t);
    const r = t.json;
    if (r.buffers && r.buffers.some((o) => function(a, u) {
      return u.uri !== void 0 && !(u.uri in a.resources);
    }(t, o)))
      throw new Error("Cannot resolve external buffers with binaryToJSON().");
    if (r.images && r.images.some((o) => function(a, u) {
      return u.uri !== void 0 && !(u.uri in a.resources) && u.bufferView === void 0;
    }(t, o)))
      throw new Error("Cannot resolve external images with binaryToJSON().");
    return t;
  }
  Gt(e) {
    const t = new Uint32Array(e, 0, 3);
    if (t[0] !== 1179937895)
      throw new Error("Invalid glTF asset.");
    if (t[1] !== 2)
      throw new Error(`Unsupported glTF binary version, "${t[1]}".`);
    const r = new Uint32Array(e, 12, 2);
    if (r[1] !== fl.JSON)
      throw new Error("Missing required GLB JSON chunk.");
    const o = r[0], a = vr.decodeText(e.slice(20, 20 + o)), u = JSON.parse(a), f = 20 + o;
    if (e.byteLength <= f)
      return { json: u, resources: {} };
    const v = new Uint32Array(e, f, 2);
    if (v[1] !== fl.BIN)
      throw new Error("Expected GLB BIN in second chunk.");
    return { json: u, resources: { "@glb.bin": e.slice(f + 8, f + 8 + v[0]) } };
  }
  readBinary(e) {
    return this.readJSON(this.binaryToJSON(e));
  }
  writeBinary(e) {
    const { json: t, resources: r } = this.writeJSON(e, { format: oa.GLB }), o = new Uint32Array([1179937895, 2, 12]), a = JSON.stringify(t), u = vr.pad(vr.encodeText(a), 32), f = new Uint32Array([u.byteLength, 1313821514]).buffer, v = vr.concat([f, u]);
    o[o.length - 1] += v.byteLength;
    const S = Object.values(r)[0];
    if (!S || !S.byteLength)
      return vr.concat([o.buffer, v]);
    const I = vr.pad(S, 0), D = new Uint32Array([I.byteLength, 5130562]).buffer, Z = vr.concat([D, I]);
    return o[o.length - 1] += Z.byteLength, vr.concat([o.buffer, v, Z]);
  }
}
const Ly = {};
let df = class extends Ty {
  constructor(e = Ly) {
    super(), this.qt = void 0, this.qt = e;
  }
  read(e) {
    return this.readAsJSON(e).then((t) => this.readJSON(t));
  }
  readAsJSON(e) {
    return e.match(/^data:application\/octet-stream;/) || new URL(e, window.location.href).pathname.match(/\.glb$/) ? this.Jt(e) : this.zt(e);
  }
  Wt(e, t) {
    const r = [...e.json.images || [], ...e.json.buffers || []].map((o) => {
      const a = o.uri;
      return !a || a.match(/data:/) ? Promise.resolve() : fetch(function(u, f) {
        if (!function(I) {
          return !/^(?:[a-zA-Z]+:)?\//.test(I);
        }(f))
          return f;
        const v = u.split("/"), S = f.split("/");
        v.pop();
        for (let I = 0; I < S.length; I++)
          S[I] !== "." && (S[I] === ".." ? v.pop() : v.push(S[I]));
        return v.join("/");
      }(t, a), this.qt).then((u) => u.arrayBuffer()).then((u) => {
        e.resources[a] = u;
      });
    });
    return Promise.all(r).then(() => {
    });
  }
  zt(e) {
    var t = this;
    const r = { json: {}, resources: {} };
    return fetch(e, this.qt).then((o) => o.json()).then(async function(o) {
      return r.json = o, await t.Wt(r, gf(e)), t.kt(r), r;
    });
  }
  Jt(e) {
    var t = this;
    return fetch(e, this.qt).then((r) => r.arrayBuffer()).then(async function(r) {
      const o = t.Gt(r);
      return await t.Wt(o, gf(e)), t.kt(o), o;
    });
  }
};
function gf(y) {
  const e = y.lastIndexOf("/");
  return e === -1 ? "./" : y.substr(0, e + 1);
}
var By = Object.defineProperty, Ey = (y, e, t) => e in y ? By(y, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : y[e] = t, wh = (y, e, t) => (Ey(y, typeof e != "symbol" ? e + "" : e, t), t), ky = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Iy(y) {
  return y && y.__esModule && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y;
}
function Oy(y) {
  if (y.__esModule)
    return y;
  var e = y.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(y).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(y, r);
    Object.defineProperty(t, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return y[r];
      }
    });
  }), t;
}
function Py(y) {
  throw new Error('Could not dynamically require "' + y + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Qf = { exports: {} };
const Ny = {}, Ry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ny
}, Symbol.toStringTag, { value: "Module" })), pf = /* @__PURE__ */ Oy(Ry);
/*!
 * Paper.js v0.12.17 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Thu Nov 3 21:15:36 2022 +0100
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(y) {
  (function(e, t) {
    e = e || pf;
    var r = e.window, o = e.document, a = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, n = [], s = n.slice, l = Object.create, h = Object.getOwnPropertyDescriptor, d = Object.defineProperty, m = n.forEach || function(L, A) {
        for (var U = 0, k = this.length; U < k; U++)
          L.call(A, this[U], U, this);
      }, _ = function(L, A) {
        for (var U in this)
          this.hasOwnProperty(U) && L.call(A, this[U], U, this);
      }, b = Object.assign || function(L) {
        for (var A = 1, U = arguments.length; A < U; A++) {
          var k = arguments[A];
          for (var F in k)
            k.hasOwnProperty(F) && (L[F] = k[F]);
        }
        return L;
      }, x = function(L, A, U) {
        if (L) {
          var k = h(L, "length");
          (k && typeof k.value == "number" ? m : _).call(L, A, U = U || L);
        }
        return U;
      };
      function T(L, A, U, k, F) {
        var B = {};
        function R(V, Q) {
          Q = Q || (Q = h(A, V)) && (Q.get ? Q : Q.value), typeof Q == "string" && Q[0] === "#" && (Q = L[Q.substring(1)] || Q);
          var ae = typeof Q == "function", le = Q, fe = F || ae && !Q.base ? Q && Q.get ? V in L : L[V] : null, se;
          (!F || !fe) && (ae && fe && (Q.base = fe), ae && k !== !1 && (se = V.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (B[se[3].toLowerCase() + se[4]] = se[2]), (!le || ae || !le.get || typeof le.get != "function" || !E.isPlainObject(le)) && (le = { value: le, writable: !0 }), (h(L, V) || { configurable: !0 }).configurable && (le.configurable = !0, le.enumerable = U ?? !se), d(L, V, le));
        }
        if (A) {
          for (var C in A)
            A.hasOwnProperty(C) && !i.test(C) && R(C);
          for (var C in B) {
            var P = B[C], H = L["set" + P], W = L["get" + P] || H && L["is" + P];
            W && (k === !0 || W.length === 0) && R(C, { get: W, set: H });
          }
        }
        return L;
      }
      function E() {
        for (var L = 0, A = arguments.length; L < A; L++) {
          var U = arguments[L];
          U && b(this, U);
        }
        return this;
      }
      return T(E, {
        inject: function(L) {
          if (L) {
            var A = L.statics === !0 ? L : L.statics, U = L.beans, k = L.preserve;
            A !== L && T(this.prototype, L, L.enumerable, U, k), T(this, A, null, U, k);
          }
          for (var F = 1, B = arguments.length; F < B; F++)
            this.inject(arguments[F]);
          return this;
        },
        extend: function() {
          for (var L = this, A, U, k = 0, F, B = arguments.length; k < B && !(A && U); k++)
            F = arguments[k], A = A || F.initialize, U = U || F.prototype;
          return A = A || function() {
            L.apply(this, arguments);
          }, U = A.prototype = U || l(this.prototype), d(
            U,
            "constructor",
            { value: A, writable: !0, configurable: !0 }
          ), T(A, this), arguments.length && this.inject.apply(A, arguments), A.base = L, A;
        }
      }).inject({
        enumerable: !1,
        initialize: E,
        set: E,
        inject: function() {
          for (var L = 0, A = arguments.length; L < A; L++) {
            var U = arguments[L];
            U && T(this, U, U.enumerable, U.beans, U.preserve);
          }
          return this;
        },
        extend: function() {
          var L = l(this);
          return L.inject.apply(L, arguments);
        },
        each: function(L, A) {
          return x(this, L, A);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: b,
          each: x,
          create: l,
          define: d,
          describe: h,
          clone: function(L) {
            return b(new L.constructor(), L);
          },
          isPlainObject: function(L) {
            var A = L != null && L.constructor;
            return A && (A === Object || A === E || A.name === "Object");
          },
          pick: function(L, A) {
            return L !== t ? L : A;
          },
          slice: function(L, A, U) {
            return s.call(L, A, U);
          }
        }
      });
    }();
    y.exports = a, a.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + a.each(this, function(i, n) {
          if (!/^_/.test(n)) {
            var s = typeof i;
            this.push(n + ": " + (s === "number" ? I.instance.number(i) : s === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return a.importJSON(i, this);
      },
      exportJSON: function(i) {
        return a.exportJSON(this, i);
      },
      toJSON: function() {
        return a.serialize(this);
      },
      set: function(i, n) {
        return i && a.filter(this, i, n, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var n = i.base.apply(this, arguments), s = n.prototype._class;
          return s && !a.exports[s] && (a.exports[s] = n), n;
        },
        equals: function(i, n) {
          if (i === n)
            return !0;
          if (i && i.equals)
            return i.equals(n);
          if (n && n.equals)
            return n.equals(i);
          if (i && n && typeof i == "object" && typeof n == "object") {
            if (Array.isArray(i) && Array.isArray(n)) {
              var s = i.length;
              if (s !== n.length)
                return !1;
              for (; s--; )
                if (!a.equals(i[s], n[s]))
                  return !1;
            } else {
              var l = Object.keys(i), s = l.length;
              if (s !== Object.keys(n).length)
                return !1;
              for (; s--; ) {
                var h = l[s];
                if (!(n.hasOwnProperty(h) && a.equals(i[h], n[h])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, n, s, l) {
          if (this === a) {
            var h = this.peek(i, n);
            return i.__index++, h;
          }
          var d = this.prototype, m = d._readIndex, _ = n || m && i.__index || 0, b = i.length, x = i[_];
          if (l = l || b - _, x instanceof this || s && s.readNull && x == null && l <= 1)
            return m && (i.__index = _ + 1), x && s && s.clone ? x.clone() : x;
          if (x = a.create(d), m && (x.__read = !0), x = x.initialize.apply(x, _ > 0 || _ + l < b ? a.slice(i, _, _ + l) : i) || x, m) {
            i.__index = _ + x.__read;
            var T = x.__filtered;
            T && (i.__filtered = T, x.__filtered = t), x.__read = t;
          }
          return x;
        },
        peek: function(i, n) {
          return i[i.__index = n || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, n, s, l) {
          for (var h = [], d, m = n || 0, _ = l ? m + l : i.length, b = m; b < _; b++)
            h.push(Array.isArray(d = i[b]) ? this.read(d, 0, s) : this.read(i, b, s, 1));
          return h;
        },
        readNamed: function(i, n, s, l, h) {
          var d = this.getNamed(i, n), m = d !== t;
          if (m) {
            var _ = i.__filtered;
            if (!_) {
              var b = this.getSource(i);
              _ = i.__filtered = a.create(b), _.__unfiltered = b;
            }
            _[n] = t;
          }
          return this.read(m ? [d] : i, s, l, h);
        },
        readSupported: function(i, n) {
          var s = this.getSource(i), l = this, h = !1;
          return s && Object.keys(s).forEach(function(d) {
            if (d in n) {
              var m = l.readNamed(i, d);
              m !== t && (n[d] = m), h = !0;
            }
          }), h;
        },
        getSource: function(i) {
          var n = i.__source;
          if (n === t) {
            var s = i.length === 1 && i[0];
            n = i.__source = s && a.isPlainObject(s) ? s : null;
          }
          return n;
        },
        getNamed: function(i, n) {
          var s = this.getSource(i);
          if (s)
            return n ? s[n] : i.__filtered || s;
        },
        hasNamed: function(i, n) {
          return !!this.getNamed(i, n);
        },
        filter: function(i, n, s, l) {
          var h;
          function d(T) {
            if (!(s && T in s) && !(h && T in h)) {
              var E = n[T];
              E !== t && (i[T] = E);
            }
          }
          if (l) {
            for (var m = {}, _ = 0, b, x = l.length; _ < x; _++)
              (b = l[_]) in n && (d(b), m[b] = !0);
            h = m;
          }
          return Object.keys(n.__unfiltered || n).forEach(d), i;
        },
        isPlainValue: function(i, n) {
          return a.isPlainObject(i) || Array.isArray(i) || n && typeof i == "string";
        },
        serialize: function(i, n, s, l) {
          n = n || {};
          var h = !l, d;
          if (h && (n.formatter = new I(n.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(E, L) {
              var A = "#" + E._id, U = this.references[A];
              if (!U) {
                this.length++;
                var k = L.call(E), F = E._class;
                F && k[0] !== F && k.unshift(F), this.definitions[A] = k, U = this.references[A] = [A];
              }
              return U;
            }
          }), i && i._serialize) {
            d = i._serialize(n, l);
            var m = i._class;
            m && !i._compactSerialize && (h || !s) && d[0] !== m && d.unshift(m);
          } else if (Array.isArray(i)) {
            d = [];
            for (var _ = 0, b = i.length; _ < b; _++)
              d[_] = a.serialize(i[_], n, s, l);
          } else if (a.isPlainObject(i)) {
            d = {};
            for (var x = Object.keys(i), _ = 0, b = x.length; _ < b; _++) {
              var T = x[_];
              d[T] = a.serialize(
                i[T],
                n,
                s,
                l
              );
            }
          } else
            typeof i == "number" ? d = n.formatter.number(i, n.precision) : d = i;
          return h && l.length > 0 ? [["dictionary", l.definitions], d] : d;
        },
        deserialize: function(i, n, s, l, h) {
          var d = i, m = !s, _ = m && i && i.length && i[0][0] === "dictionary";
          if (s = s || {}, Array.isArray(i)) {
            var b = i[0], x = b === "dictionary";
            if (i.length == 1 && /^#/.test(b))
              return s.dictionary[b];
            b = a.exports[b], d = [];
            for (var T = b ? 1 : 0, E = i.length; T < E; T++)
              d.push(a.deserialize(
                i[T],
                n,
                s,
                x,
                _
              ));
            if (b) {
              var L = d;
              n ? d = n(b, L, m || h) : d = new b(L);
            }
          } else if (a.isPlainObject(i)) {
            d = {}, l && (s.dictionary = d);
            for (var A in i)
              d[A] = a.deserialize(i[A], n, s);
          }
          return _ ? d[1] : d;
        },
        exportJSON: function(i, n) {
          var s = a.serialize(i, n);
          return n && n.asString == !1 ? s : JSON.stringify(s);
        },
        importJSON: function(i, n) {
          return a.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(s, l, h) {
              var d = h && n && n.constructor === s, m = d ? n : a.create(s.prototype);
              if (l.length === 1 && m instanceof K && (d || !(m instanceof We))) {
                var _ = l[0];
                a.isPlainObject(_) && (_.insert = !1, d && (l = l.concat([K.INSERT])));
              }
              return (d ? m.set : s).apply(m, l), d && (n = null), m;
            }
          );
        },
        push: function(i, n) {
          var s = n.length;
          if (s < 4096)
            i.push.apply(i, n);
          else {
            var l = i.length;
            i.length += s;
            for (var h = 0; h < s; h++)
              i[l + h] = n[h];
          }
          return i;
        },
        splice: function(i, n, s, l) {
          var h = n && n.length, d = s === t;
          s = d ? i.length : s, s > i.length && (s = i.length);
          for (var m = 0; m < h; m++)
            n[m]._index = s + m;
          if (d)
            return a.push(i, n), [];
          var _ = [s, l];
          n && a.push(_, n);
          for (var b = i.splice.apply(i, _), m = 0, x = b.length; m < x; m++)
            b[m]._index = t;
          for (var m = s + h, x = i.length; m < x; m++)
            i[m]._index = m;
          return b;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(n) {
            return n.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(n, s) {
            return s.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var u = {
      on: function(i, n) {
        if (typeof i != "string")
          a.each(i, function(d, m) {
            this.on(m, d);
          }, this);
        else {
          var s = this._eventTypes, l = s && s[i], h = this._callbacks = this._callbacks || {};
          h = h[i] = h[i] || [], h.indexOf(n) === -1 && (h.push(n), l && l.install && h.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, n) {
        if (typeof i != "string") {
          a.each(i, function(m, _) {
            this.off(_, m);
          }, this);
          return;
        }
        var s = this._eventTypes, l = s && s[i], h = this._callbacks && this._callbacks[i], d;
        return h && (!n || (d = h.indexOf(n)) !== -1 && h.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && h.splice(d, 1)), this;
      },
      once: function(i, n) {
        return this.on(i, function s() {
          n.apply(this, arguments), this.off(i, s);
        });
      },
      emit: function(i, n) {
        var s = this._callbacks && this._callbacks[i];
        if (!s)
          return !1;
        var l = a.slice(arguments, 1), h = n && n.target && !n.currentTarget;
        s = s.slice(), h && (n.currentTarget = this);
        for (var d = 0, m = s.length; d < m; d++)
          if (s[d].apply(this, l) == !1) {
            n && n.stop && n.stop();
            break;
          }
        return h && delete n.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var n = this._eventTypes, s = this._callbacks, l = i ? "install" : "uninstall";
        if (n) {
          for (var h in s)
            if (s[h].length > 0) {
              var d = n[h], m = d && d[l];
              m && m.call(this, h);
            }
        }
      },
      statics: {
        inject: function i(n) {
          var s = n._events;
          if (s) {
            var l = {};
            a.each(s, function(h, d) {
              var m = typeof h == "string", _ = m ? h : d, b = a.capitalize(_), x = _.substring(2).toLowerCase();
              l[x] = m ? {} : h, _ = "_" + _, n["get" + b] = function() {
                return this[_];
              }, n["set" + b] = function(T) {
                var E = this[_];
                E && this.off(x, E), T && this.on(x, T), this[_] = T;
              };
            }), n._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, f = a.extend({
      _class: "PaperScope",
      initialize: function i() {
        He = this, this.settings = new a({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var n = i.prototype;
        if (!this.support) {
          var s = dt.getContext(1, 1) || {};
          n.support = {
            nativeDash: "setLineDash" in s || "mozDash" in s,
            nativeBlendModes: et.nativeModes
          }, dt.release(s);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), h = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = h === "darwin" ? "mac" : h, m = n.agent = n.browser = { platform: d };
          d && (m[d] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(_, b, x, T, E) {
              if (!m.chrome) {
                var L = b === "opera" ? T : /^(node|trident)$/.test(b) ? E : x;
                m.version = L, m.versionNumber = parseFloat(L), b = { trident: "msie", jsdom: "node" }[b] || b, m.name = b, m[b] = !0;
              }
            }
          ), m.chrome && delete m.webkit, m.atom && delete m.chrome;
        }
      },
      version: "0.12.17",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, n) {
        var s = He.PaperScript.execute(i, this, n);
        return ei.updateFocus(), s;
      },
      install: function(i) {
        var n = this;
        a.each(["project", "view", "tool"], function(l) {
          a.define(i, l, {
            configurable: !0,
            get: function() {
              return n[l];
            }
          });
        });
        for (var s in this)
          !/^_/.test(s) && this[s] && (i[s] = this[s]);
      },
      setup: function(i) {
        return He = this, this.project = new ve(i), this;
      },
      createCanvas: function(i, n) {
        return dt.getCanvas(i, n);
      },
      activate: function() {
        He = this;
      },
      clear: function() {
        for (var i = this.projects, n = this.tools, s = i.length - 1; s >= 0; s--)
          i[s].remove();
        for (var s = n.length - 1; s >= 0; s--)
          n[s].remove();
      },
      remove: function() {
        this.clear(), delete f._scopes[this._id];
      },
      statics: new function() {
        function i(n) {
          return n += "Attribute", function(s, l) {
            return s[n](l) || s[n]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(n) {
            return this._scopes[n] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), v = a.extend(u, {
      initialize: function(i) {
        this._scope = He, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (a.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), S = {
      findItemBoundsCollisions: function(i, n, s) {
        function l(m) {
          for (var _ = new Array(m.length), b = 0; b < m.length; b++) {
            var x = m[b].getBounds();
            _[b] = [x.left, x.top, x.right, x.bottom];
          }
          return _;
        }
        var h = l(i), d = !n || n === i ? h : l(n);
        return this.findBoundsCollisions(h, d, s || 0);
      },
      findCurveBoundsCollisions: function(i, n, s, l) {
        function h(L) {
          for (var A = Math.min, U = Math.max, k = new Array(L.length), F = 0; F < L.length; F++) {
            var B = L[F];
            k[F] = [
              A(B[0], B[2], B[4], B[6]),
              A(B[1], B[3], B[5], B[7]),
              U(B[0], B[2], B[4], B[6]),
              U(B[1], B[3], B[5], B[7])
            ];
          }
          return k;
        }
        var d = h(i), m = !n || n === i ? d : h(n);
        if (l) {
          for (var _ = this.findBoundsCollisions(
            d,
            m,
            s || 0,
            !1,
            !0
          ), b = this.findBoundsCollisions(
            d,
            m,
            s || 0,
            !0,
            !0
          ), x = [], T = 0, E = _.length; T < E; T++)
            x[T] = { hor: _[T], ver: b[T] };
          return x;
        }
        return this.findBoundsCollisions(d, m, s || 0);
      },
      findBoundsCollisions: function(i, n, s, l, h) {
        var d = !n || i === n, m = d ? i : i.concat(n), _ = i.length, b = m.length;
        function x(Je, tt, ft) {
          for (var Ne = 0, ze = Je.length; Ne < ze; ) {
            var nt = ze + Ne >>> 1;
            m[Je[nt]][tt] < ft ? Ne = nt + 1 : ze = nt;
          }
          return Ne - 1;
        }
        for (var T = l ? 1 : 0, E = T + 2, L = l ? 0 : 1, A = L + 2, U = new Array(b), k = 0; k < b; k++)
          U[k] = k;
        U.sort(function(Je, tt) {
          return m[Je][T] - m[tt][T];
        });
        for (var F = [], B = new Array(_), k = 0; k < b; k++) {
          var R = U[k], C = m[R], P = d ? R : R - _, H = R < _, W = d || !H, V = H ? [] : null;
          if (F.length) {
            var Q = x(
              F,
              E,
              C[T] - s
            ) + 1;
            if (F.splice(0, Q), d && h) {
              V = V.concat(F);
              for (var ae = 0; ae < F.length; ae++) {
                var le = F[ae];
                B[le].push(P);
              }
            } else
              for (var fe = C[A], se = C[L], ae = 0; ae < F.length; ae++) {
                var le = F[ae], ge = m[le], me = le < _, we = d || le >= _;
                (h || (H && we || W && me) && fe >= ge[L] - s && se <= ge[A] + s) && (H && we && V.push(
                  d ? le : le - _
                ), W && me && B[le].push(P));
              }
          }
          if (H && (i === n && V.push(R), B[R] = V), F.length) {
            var Se = C[E], Ae = x(F, E, Se);
            F.splice(Ae + 1, 0, R);
          } else
            F.push(R);
        }
        for (var k = 0; k < B.length; k++) {
          var Ge = B[k];
          Ge && Ge.sort(function(tt, ft) {
            return tt - ft;
          });
        }
        return B;
      }
    }, I = a.extend({
      initialize: function(i) {
        this.precision = a.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, n, s) {
        return this.number(i) + (s || ",") + this.number(n);
      },
      point: function(i, n) {
        return this.number(i.x) + (n || ",") + this.number(i.y);
      },
      size: function(i, n) {
        return this.number(i.width) + (n || ",") + this.number(i.height);
      },
      rectangle: function(i, n) {
        return this.point(i, n) + (n || ",") + this.size(i, n);
      }
    });
    I.instance = new I();
    var D = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], n = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], s = Math.abs, l = Math.sqrt, h = Math.pow, d = Math.log2 || function(E) {
        return Math.log(E) * Math.LOG2E;
      }, m = 1e-12, _ = 112e-18;
      function b(E, L, A) {
        return E < L ? L : E > A ? A : E;
      }
      function x(E, L, A) {
        function U(Q) {
          var ae = Q * 134217729, le = Q - ae, fe = le + ae, se = Q - fe;
          return [fe, se];
        }
        var k = L * L - E * A, F = L * L + E * A;
        if (s(k) * 3 < F) {
          var B = U(E), R = U(L), C = U(A), P = L * L, H = R[0] * R[0] - P + 2 * R[0] * R[1] + R[1] * R[1], W = E * A, V = B[0] * C[0] - W + B[0] * C[1] + B[1] * C[0] + B[1] * C[1];
          k = P - W + (H - V);
        }
        return k;
      }
      function T() {
        var E = Math.max.apply(Math, arguments);
        return E && (E < 1e-8 || E > 1e8) ? h(2, -Math.round(d(E))) : 0;
      }
      return {
        EPSILON: m,
        MACHINE_EPSILON: _,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(E) {
          return E >= -m && E <= m;
        },
        isMachineZero: function(E) {
          return E >= -_ && E <= _;
        },
        clamp: b,
        integrate: function(E, L, A, U) {
          for (var k = i[U - 2], F = n[U - 2], B = (A - L) * 0.5, R = B + L, C = 0, P = U + 1 >> 1, H = U & 1 ? F[C++] * E(R) : 0; C < P; ) {
            var W = B * k[C];
            H += F[C++] * (E(R + W) + E(R - W));
          }
          return B * H;
        },
        findRoot: function(E, L, A, U, k, F, B) {
          for (var R = 0; R < F; R++) {
            var C = E(A), P = C / L(A), H = A - P;
            if (s(P) < B) {
              A = H;
              break;
            }
            C > 0 ? (k = A, A = H <= U ? (U + k) * 0.5 : H) : (U = A, A = H >= k ? (U + k) * 0.5 : H);
          }
          return b(A, U, k);
        },
        solveQuadratic: function(E, L, A, U, k, F) {
          var B, R = 1 / 0;
          if (s(E) < m) {
            if (s(L) < m)
              return s(A) < m ? -1 : 0;
            B = -A / L;
          } else {
            L *= -0.5;
            var C = x(E, L, A);
            if (C && s(C) < _) {
              var P = T(s(E), s(L), s(A));
              P && (E *= P, L *= P, A *= P, C = x(E, L, A));
            }
            if (C >= -_) {
              var H = C < 0 ? 0 : l(C), W = L + (L < 0 ? -H : H);
              W === 0 ? (B = A / E, R = -B) : (B = W / E, R = A / W);
            }
          }
          var V = 0, Q = k == null, ae = k - m, le = F + m;
          return isFinite(B) && (Q || B > ae && B < le) && (U[V++] = Q ? B : b(B, k, F)), R !== B && isFinite(R) && (Q || R > ae && R < le) && (U[V++] = Q ? R : b(R, k, F)), V;
        },
        solveCubic: function(E, L, A, U, k, F, B) {
          var R = T(s(E), s(L), s(A), s(U)), C, P, H, W, V;
          R && (E *= R, L *= R, A *= R, U *= R);
          function Q(Ae) {
            C = Ae;
            var Ge = E * C;
            P = Ge + L, H = P * C + A, W = (Ge + P) * C + H, V = H * C + U;
          }
          if (s(E) < m)
            E = L, P = A, H = U, C = 1 / 0;
          else if (s(U) < m)
            P = L, H = A, C = 0;
          else {
            Q(-(L / E) / 3);
            var ae = V / E, le = h(s(ae), 1 / 3), fe = ae < 0 ? -1 : 1, se = -W / E, ge = se > 0 ? 1.324717957244746 * Math.max(le, l(se)) : le, me = C - fe * ge;
            if (me !== C) {
              do
                Q(me), me = W === 0 ? C : C - V / W / (1 + _);
              while (fe * me > fe * C);
              s(E) * C * C > s(U / C) && (H = -U / C, P = (H - A) / C);
            }
          }
          var we = D.solveQuadratic(E, P, H, k, F, B), Se = F == null;
          return isFinite(C) && (we === 0 || we > 0 && C !== k[0] && C !== k[1]) && (Se || C > F - m && C < B + m) && (k[we++] = Se ? C : b(C, F, B)), we;
        }
      };
    }(), Z = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var n = this._pools[i];
          return n || (n = this._pools[i] = { _id: 1 }), n._id++;
        } else
          return this._id++;
      }
    }, M = a.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(i, n) {
        var s = typeof i, l = this.__read, h = 0;
        if (s === "number") {
          var d = typeof n == "number";
          this._set(i, d ? n : i), l && (h = d ? 2 : 1);
        } else if (s === "undefined" || i === null)
          this._set(0, 0), l && (h = i === null ? 1 : 0);
        else {
          var m = s === "string" ? i.split(/[\s,]+/) || [] : i;
          h = 1, Array.isArray(m) ? this._set(+m[0], +(m.length > 1 ? m[1] : m[0])) : "x" in m ? this._set(m.x || 0, m.y || 0) : "width" in m ? this._set(m.width || 0, m.height || 0) : "angle" in m ? (this._set(m.length || 0, 0), this.setAngle(m.angle || 0)) : (this._set(0, 0), h = 0);
        }
        return l && (this.__read = h), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.x = i, this.y = n, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new M(this.x, this.y);
      },
      toString: function() {
        var i = I.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [n.number(this.x), n.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var n = this._angle || 0;
          this._set(
            Math.cos(n) * i,
            Math.sin(n) * i
          );
        } else {
          var s = i / this.getLength();
          D.isZero(s) && this.getAngle(), this._set(
            this.x * s,
            this.y * s
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = M.read(arguments), n = this.getLength() * i.getLength();
          if (D.isZero(n))
            return NaN;
          var s = this.dot(i) / n;
          return Math.acos(s < -1 ? -1 : s > 1 ? 1 : s);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var n = this.getLength();
          this._set(
            Math.cos(i) * n,
            Math.sin(i) * n
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = M.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, n = M.read(i), s = n.x - this.x, l = n.y - this.y, h = s * s + l * l, d = a.read(i);
        return d ? h : Math.sqrt(h);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var n = this.getLength(), s = n !== 0 ? i / n : 0, l = new M(this.x * s, this.y * s);
        return s >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, n) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var s = n ? this.subtract(n) : this, l = Math.sin(i), h = Math.cos(i);
        return s = new M(
          s.x * h - s.y * l,
          s.x * l + s.y * h
        ), n ? s.add(n) : s;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = M.read(arguments);
        return new M(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = M.read(arguments);
        return new M(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = M.read(arguments);
        return new M(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = M.read(arguments);
        return new M(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = M.read(arguments);
        return new M(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new M(-this.x, -this.y);
      },
      isInside: function() {
        return G.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, n = M.read(i), s = a.read(i);
        return this.getDistance(n) <= s;
      },
      isCollinear: function() {
        var i = M.read(arguments);
        return M.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = M.read(arguments);
        return M.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = D.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = M.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = M.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = M.read(arguments), n = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new M(
          i.x * n,
          i.y * n
        );
      },
      statics: {
        min: function() {
          var i = arguments, n = M.read(i), s = M.read(i);
          return new M(
            Math.min(n.x, s.x),
            Math.min(n.y, s.y)
          );
        },
        max: function() {
          var i = arguments, n = M.read(i), s = M.read(i);
          return new M(
            Math.max(n.x, s.x),
            Math.max(n.y, s.y)
          );
        },
        random: function() {
          return new M(Math.random(), Math.random());
        },
        isCollinear: function(i, n, s, l) {
          return Math.abs(i * l - n * s) <= Math.sqrt((i * i + n * n) * (s * s + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, n, s, l) {
          return Math.abs(i * s + n * l) <= Math.sqrt((i * i + n * n) * (s * s + l * l)) * 1e-8;
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new M(n(this.x), n(this.y));
      };
    }, {})), X = M.extend({
      initialize: function(i, n, s, l) {
        this._x = i, this._y = n, this._owner = s, this._setter = l;
      },
      _set: function(i, n, s) {
        return this._x = i, this._y = n, s || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), Y = a.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(i, n) {
        var s = typeof i, l = this.__read, h = 0;
        if (s === "number") {
          var d = typeof n == "number";
          this._set(i, d ? n : i), l && (h = d ? 2 : 1);
        } else if (s === "undefined" || i === null)
          this._set(0, 0), l && (h = i === null ? 1 : 0);
        else {
          var m = s === "string" ? i.split(/[\s,]+/) || [] : i;
          h = 1, Array.isArray(m) ? this._set(+m[0], +(m.length > 1 ? m[1] : m[0])) : "width" in m ? this._set(m.width || 0, m.height || 0) : "x" in m ? this._set(m.x || 0, m.y || 0) : (this._set(0, 0), h = 0);
        }
        return l && (this.__read = h), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.width = i, this.height = n, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new Y(this.width, this.height);
      },
      toString: function() {
        var i = I.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.width),
          n.number(this.height)
        ];
      },
      add: function() {
        var i = Y.read(arguments);
        return new Y(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = Y.read(arguments);
        return new Y(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = Y.read(arguments);
        return new Y(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = Y.read(arguments);
        return new Y(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = Y.read(arguments);
        return new Y(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new Y(-this.width, -this.height);
      },
      isZero: function() {
        var i = D.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, n) {
          return new Y(
            Math.min(i.width, n.width),
            Math.min(i.height, n.height)
          );
        },
        max: function(i, n) {
          return new Y(
            Math.max(i.width, n.width),
            Math.max(i.height, n.height)
          );
        },
        random: function() {
          return new Y(Math.random(), Math.random());
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new Y(n(this.width), n(this.height));
      };
    }, {})), ie = Y.extend({
      initialize: function(i, n, s, l) {
        this._width = i, this._height = n, this._owner = s, this._setter = l;
      },
      _set: function(i, n, s) {
        return this._width = i, this._height = n, s || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), G = a.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(i, n, s, l) {
        var h = arguments, d = typeof i, m;
        if (d === "number" ? (this._set(i, n, s, l), m = 4) : d === "undefined" || i === null ? (this._set(0, 0, 0, 0), m = i === null ? 1 : 0) : h.length === 1 && (Array.isArray(i) ? (this._set.apply(this, i), m = 1) : i.x !== t || i.width !== t ? (this._set(
          i.x || 0,
          i.y || 0,
          i.width || 0,
          i.height || 0
        ), m = 1) : i.from === t && i.to === t && (this._set(0, 0, 0, 0), a.readSupported(h, this) && (m = 1))), m === t) {
          var _ = M.readNamed(h, "from"), b = a.peek(h), x = _.x, T = _.y, E, L;
          if (b && b.x !== t || a.hasNamed(h, "to")) {
            var A = M.readNamed(h, "to");
            E = A.x - x, L = A.y - T, E < 0 && (x = A.x, E = -E), L < 0 && (T = A.y, L = -L);
          } else {
            var U = Y.read(h);
            E = U.width, L = U.height;
          }
          this._set(x, T, E, L), m = h.__index;
        }
        var k = h.__filtered;
        return k && (this.__filtered = k), this.__read && (this.__read = m), this;
      },
      set: "#initialize",
      _set: function(i, n, s, l) {
        return this.x = i, this.y = n, this.width = s, this.height = l, this;
      },
      clone: function() {
        return new G(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var n = a.isPlainValue(i) ? G.read(arguments) : i;
        return n === this || n && this.x === n.x && this.y === n.y && this.width === n.width && this.height === n.height || !1;
      },
      toString: function() {
        var i = I.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.x),
          n.number(this.y),
          n.number(this.width),
          n.number(this.height)
        ];
      },
      getPoint: function(i) {
        var n = i ? M : X;
        return new n(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var n = i ? Y : ie;
        return new n(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = Y.read(arguments), n = this._sx, s = this._sy, l = i.width, h = i.height;
        n && (this.x += (this.width - l) * n), s && (this.y += (this.height - h) * s), this.width = l, this.height = h, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width -= this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height -= this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width = this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height = this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var n = i ? M : X;
        return new n(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = M.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(G.read(arguments)) : this._containsPoint(M.read(arguments));
      },
      _containsPoint: function(i) {
        var n = i.x, s = i.y;
        return n >= this.x && s >= this.y && n <= this.x + this.width && s <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var n = i.x, s = i.y;
        return n >= this.x && s >= this.y && n + i.width <= this.x + this.width && s + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = G.read(arguments), n = a.read(arguments) || 0;
        return i.x + i.width > this.x - n && i.y + i.height > this.y - n && i.x < this.x + this.width + n && i.y < this.y + this.height + n;
      },
      intersect: function() {
        var i = G.read(arguments), n = Math.max(this.x, i.x), s = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), h = Math.min(this.y + this.height, i.y + i.height);
        return new G(n, s, l - n, h - s);
      },
      unite: function() {
        var i = G.read(arguments), n = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), h = Math.max(this.y + this.height, i.y + i.height);
        return new G(n, s, l - n, h - s);
      },
      include: function() {
        var i = M.read(arguments), n = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), h = Math.max(this.y + this.height, i.y);
        return new G(n, s, l - n, h - s);
      },
      expand: function() {
        var i = Y.read(arguments), n = i.width, s = i.height;
        return new G(
          this.x - n / 2,
          this.y - s / 2,
          this.width + n,
          this.height + s
        );
      },
      scale: function(i, n) {
        return this.expand(
          this.width * i - this.width,
          this.height * (n === t ? i : n) - this.height
        );
      }
    }, a.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, n) {
        var s = i.join(""), l = /^[RL]/.test(s);
        n >= 4 && (i[1] += l ? "Y" : "X");
        var h = i[l ? 0 : 1], d = i[l ? 1 : 0], m = "get" + h, _ = "get" + d, b = "set" + h, x = "set" + d, T = "get" + s, E = "set" + s;
        this[T] = function(L) {
          var A = L ? M : X;
          return new A(this[m](), this[_](), this, E);
        }, this[E] = function() {
          var L = M.read(arguments);
          this[b](L.x), this[x](L.y);
        };
      },
      {
        beans: !0
      }
    )), te = G.extend(
      {
        initialize: function(i, n, s, l, h, d) {
          this._set(i, n, s, l, !0), this._owner = h, this._setter = d;
        },
        _set: function(i, n, s, l, h) {
          return this._x = i, this._y = n, this._width = s, this._height = l, h || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = G.prototype;
        return a.each(
          ["x", "y", "width", "height"],
          function(n) {
            var s = a.capitalize(n), l = "_" + n;
            this["get" + s] = function() {
              return this[l];
            }, this["set" + s] = function(h) {
              this[l] = h, this._dontNotify || this._owner[this._setter](this);
            };
          },
          a.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(n) {
              var s = "set" + n;
              this[s] = function() {
                this._dontNotify = !0, i[s].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(n) {
                var s = this._owner;
                s._changeSelection && s._changeSelection(2, n);
              }
            }
          )
        );
      }()
    ), J = a.extend({
      _class: "Matrix",
      initialize: function i(n, s) {
        var l = arguments, h = l.length, d = !0;
        if (h >= 6 ? this._set.apply(this, l) : h === 1 || h === 2 ? n instanceof i ? this._set(
          n._a,
          n._b,
          n._c,
          n._d,
          n._tx,
          n._ty,
          s
        ) : Array.isArray(n) ? this._set.apply(
          this,
          s ? n.concat([s]) : n
        ) : d = !1 : h ? d = !1 : this.reset(), !d)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, n, s, l, h, d, m) {
        return this._a = i, this._b = n, this._c = s, this._d = l, this._tx = h, this._ty = d, m || this._changed(), this;
      },
      _serialize: function(i, n) {
        return a.serialize(this.getValues(), i, !0, n);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new J(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = I.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, n) {
        var s = this._owner;
        return s ? (s.transform(null, a.pick(i, !0), n), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = M.read(arguments), n = i.x, s = i.y;
        return this._tx += n * this._a + s * this._c, this._ty += n * this._b + s * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, n = M.read(i), s = M.read(i, 0, { readNull: !0 });
        return s && this.translate(s), this._a *= n.x, this._b *= n.x, this._c *= n.y, this._d *= n.y, s && this.translate(s.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var n = M.read(arguments, 1), s = n.x, l = n.y, h = Math.cos(i), d = Math.sin(i), m = s - s * h + l * d, _ = l - s * d - l * h, b = this._a, x = this._b, T = this._c, E = this._d;
        return this._a = h * b + d * T, this._b = h * x + d * E, this._c = -d * b + h * T, this._d = -d * x + h * E, this._tx += m * b + _ * T, this._ty += m * x + _ * E, this._changed(), this;
      },
      shear: function() {
        var i = arguments, n = M.read(i), s = M.read(i, 0, { readNull: !0 });
        s && this.translate(s);
        var l = this._a, h = this._b;
        return this._a += n.y * this._c, this._b += n.y * this._d, this._c += n.x * l, this._d += n.x * h, s && this.translate(s.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, n = M.read(i), s = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, h = new M(
          Math.tan(n.x * l),
          Math.tan(n.y * l)
        );
        return this.shear(h, s);
      },
      append: function(i, n) {
        if (i) {
          var s = this._a, l = this._b, h = this._c, d = this._d, m = i._a, _ = i._c, b = i._b, x = i._d, T = i._tx, E = i._ty;
          this._a = m * s + b * h, this._c = _ * s + x * h, this._b = m * l + b * d, this._d = _ * l + x * d, this._tx += T * s + E * h, this._ty += T * l + E * d, n || this._changed();
        }
        return this;
      },
      prepend: function(i, n) {
        if (i) {
          var s = this._a, l = this._b, h = this._c, d = this._d, m = this._tx, _ = this._ty, b = i._a, x = i._c, T = i._b, E = i._d, L = i._tx, A = i._ty;
          this._a = b * s + x * l, this._c = b * h + x * d, this._b = T * s + E * l, this._d = T * h + E * d, this._tx = b * m + x * _ + L, this._ty = T * m + E * _ + A, n || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, n = this._b, s = this._c, l = this._d, h = this._tx, d = this._ty, m = i * l - n * s, _ = null;
        return m && !isNaN(m) && isFinite(h) && isFinite(d) && (this._a = l / m, this._b = -n / m, this._c = -s / m, this._d = i / m, this._tx = (s * d - l * h) / m, this._ty = (n * h - i * d) / m, _ = this), _;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new J(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, n, s) {
        return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, n, s);
      },
      _transformPoint: function(i, n, s) {
        var l = i.x, h = i.y;
        return n || (n = new M()), n._set(
          l * this._a + h * this._c + this._tx,
          l * this._b + h * this._d + this._ty,
          s
        );
      },
      _transformCoordinates: function(i, n, s) {
        for (var l = 0, h = 2 * s; l < h; l += 2) {
          var d = i[l], m = i[l + 1];
          n[l] = d * this._a + m * this._c + this._tx, n[l + 1] = d * this._b + m * this._d + this._ty;
        }
        return n;
      },
      _transformCorners: function(i) {
        var n = i.x, s = i.y, l = n + i.width, h = s + i.height, d = [n, s, l, s, l, h, n, h];
        return this._transformCoordinates(d, d, 4);
      },
      _transformBounds: function(i, n, s) {
        for (var l = this._transformCorners(i), h = l.slice(0, 2), d = h.slice(), m = 2; m < 8; m++) {
          var _ = l[m], b = m & 1;
          _ < h[b] ? h[b] = _ : _ > d[b] && (d[b] = _);
        }
        return n || (n = new G()), n._set(
          h[0],
          h[1],
          d[0] - h[0],
          d[1] - h[1],
          s
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(M.read(arguments));
      },
      _inverseTransform: function(i, n, s) {
        var l = this._a, h = this._b, d = this._c, m = this._d, _ = this._tx, b = this._ty, x = l * m - h * d, T = null;
        if (x && !isNaN(x) && isFinite(_) && isFinite(b)) {
          var E = i.x - this._tx, L = i.y - this._ty;
          n || (n = new M()), T = n._set(
            (E * m - L * d) / x,
            (L * l - E * h) / x,
            s
          );
        }
        return T;
      },
      decompose: function() {
        var i = this._a, n = this._b, s = this._c, l = this._d, h = i * l - n * s, d = Math.sqrt, m = Math.atan2, _ = 180 / Math.PI, b, x, T;
        if (i !== 0 || n !== 0) {
          var E = d(i * i + n * n);
          b = Math.acos(i / E) * (n > 0 ? 1 : -1), x = [E, h / E], T = [m(i * s + n * l, E * E), 0];
        } else if (s !== 0 || l !== 0) {
          var L = d(s * s + l * l);
          b = Math.asin(s / L) * (l > 0 ? 1 : -1), x = [h / L, L], T = [0, m(i * s + n * l, L * L)];
        } else
          b = 0, T = x = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: b * _,
          scaling: new M(x),
          skewing: new M(T[0] * _, T[1] * _)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new M(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, a.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var n = a.capitalize(i), s = "_" + i;
      this["get" + n] = function() {
        return this[s];
      }, this["set" + n] = function(l) {
        this[s] = l, this._changed();
      };
    }, {})), he = a.extend({
      _class: "Line",
      initialize: function(i, n, s, l, h) {
        var d = !1;
        arguments.length >= 4 ? (this._px = i, this._py = n, this._vx = s, this._vy = l, d = h) : (this._px = i.x, this._py = i.y, this._vx = n.x, this._vy = n.y, d = s), d || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new M(this._px, this._py);
      },
      getVector: function() {
        return new M(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, n) {
        return he.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          n
        );
      },
      getSide: function(i, n) {
        return he.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          n
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return he.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, n, s, l, h, d, m, _, b, x) {
          b || (s -= i, l -= n, m -= h, _ -= d);
          var T = s * _ - l * m;
          if (!D.isMachineZero(T)) {
            var E = i - h, L = n - d, A = (m * L - _ * E) / T, U = (s * L - l * E) / T, k = 1e-12, F = -k, B = 1 + k;
            if (x || F < A && A < B && F < U && U < B)
              return x || (A = A <= 0 ? 0 : A >= 1 ? 1 : A), new M(
                i + A * s,
                n + A * l
              );
          }
        },
        getSide: function(i, n, s, l, h, d, m, _) {
          m || (s -= i, l -= n);
          var b = h - i, x = d - n, T = b * l - x * s;
          return !_ && D.isMachineZero(T) && (T = (b * s + b * s) / (s * s + l * l), T >= 0 && T <= 1 && (T = 0)), T < 0 ? -1 : T > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, n, s, l, h, d, m) {
          return m || (s -= i, l -= n), s === 0 ? l > 0 ? h - i : i - h : l === 0 ? s < 0 ? d - n : n - d : ((h - i) * l - (d - n) * s) / (l > s ? l * Math.sqrt(1 + s * s / (l * l)) : s * Math.sqrt(1 + l * l / (s * s)));
        },
        getDistance: function(i, n, s, l, h, d, m) {
          return Math.abs(
            he.getSignedDistance(i, n, s, l, h, d, m)
          );
        }
      }
    }), ve = v.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(i) {
        v.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new ui(null, null, this), this._view = ei.create(
          this,
          i || dt.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, n) {
        return a.serialize(this._children, i, !0, n);
      },
      _changed: function(i, n) {
        if (i & 1) {
          var s = this._view;
          s && (s._needsUpdate = !0, !s._requested && s._autoUpdate && s.requestUpdate());
        }
        var l = this._changes;
        if (l && n) {
          var h = this._changesById, d = n._id, m = h[d];
          m ? m.flags |= i : l.push(h[d] = { item: n, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, n = i.length - 1; n >= 0; n--)
          i[n].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new We({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], n = {};
        return this.getItems({
          class: Lt,
          match: function(s) {
            var l = s._definition, h = l._id;
            return n[h] || (n[h] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, n = [];
        for (var s in i) {
          var l = i[s], h = l._selection;
          h & 1 && l.isInserted() ? n.push(l) : h || this._updateSelection(l);
        }
        return n;
      },
      _updateSelection: function(i) {
        var n = i._id, s = this._selectionItems;
        i._selection ? s[n] !== i && (this._selectionCount++, s[n] = i) : s[n] === i && (this._selectionCount--, delete s[n]);
      },
      selectAll: function() {
        for (var i = this._children, n = 0, s = i.length; n < s; n++)
          i[n].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var n in i)
          i[n].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, n) {
        if (n instanceof We) {
          n._remove(!1, !0), a.splice(this._children, [n], i, 0), n._setProject(this, !0);
          var s = n._name;
          s && n.setName(s), this._changes && n._changed(5), this._activeLayer || (this._activeLayer = n);
        } else
          n = null;
        return n;
      },
      _insertItem: function(i, n, s) {
        return n = this.insertLayer(i, n) || (this._activeLayer || this._insertItem(
          t,
          new We(K.NO_INSERT),
          !0
        )).insertChild(i, n), s && n.activate && n.activate(), n;
      },
      getItems: function(i) {
        return K._getItems(this, i);
      },
      getItem: function(i) {
        return K._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var n = this._activeLayer;
        return a.importJSON(i, n && n.isEmpty() && n);
      },
      removeOn: function(i) {
        var n = this._removeSets;
        if (n) {
          i === "mouseup" && (n.mousedrag = null);
          var s = n[i];
          if (s) {
            for (var l in s) {
              var h = s[l];
              for (var d in n) {
                var m = n[d];
                m && m != s && delete m[h._id];
              }
              h.remove();
            }
            n[i] = null;
          }
        }
      },
      draw: function(i, n, s) {
        this._updateVersion++, i.save(), n.applyToContext(i);
        for (var l = this._children, h = new a({
          offset: new M(0, 0),
          pixelRatio: s,
          viewMatrix: n.isIdentity() ? null : n,
          matrices: [new J()],
          updateMatrix: !0
        }), d = 0, m = l.length; d < m; d++)
          l[d].draw(i, h);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var _ = this._selectionItems, b = this._scope.settings.handleSize, x = this._updateVersion;
          for (var T in _)
            _[T]._drawSelection(i, n, b, _, x);
          i.restore();
        }
      }
    }), K = a.extend(
      u,
      {
        statics: {
          extend: function i(n) {
            return n._serializeFields && (n._serializeFields = a.set(
              {},
              this.prototype._serializeFields,
              n._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new J(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return a.each(
          i,
          function(n) {
            this._events[n] = {
              install: function(s) {
                this.getView()._countItemEvent(s, 1);
              },
              uninstall: function(s) {
                this.getView()._countItemEvent(s, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, n) {
          var s = i && a.isPlainObject(i), l = s && i.internal === !0, h = this._matrix = new J(), d = s && i.project || He.project, m = He.settings;
          return this._id = l ? null : Z.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && m.applyMatrix, n && h.translate(n), h._owner = this, this._style = new ui(d._currentStyle, this, d), l || s && i.insert == !1 || !m.insertItems && !(s && i.insert == !0) ? this._setProject(d) : (s && i.parent || d)._insertItem(t, this, !0), s && i !== K.NO_INSERT && i !== K.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), s;
        },
        _serialize: function(i, n) {
          var s = {}, l = this;
          function h(d) {
            for (var m in d) {
              var _ = l[m];
              a.equals(_, m === "leading" ? d.fontSize * 1.2 : d[m]) || (s[m] = a.serialize(
                _,
                i,
                m !== "data",
                n
              ));
            }
          }
          return h(this._serializeFields), this instanceof j || h(this._style._defaults), [this._class, s];
        },
        _changed: function(i) {
          var n = this._symbol, s = this._parent || n, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), s && i & 72 && K._clearBoundsCache(s), i & 2 && K._clearBoundsCache(this), l && l._changed(i, this), n && n._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var n = this._getOwner();
          if (i && n) {
            var s = n._children, l = n._namedChildren;
            (l[i] = l[i] || []).push(this), i in s || (s[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      a.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var n = a.capitalize(i), s = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + n] = function() {
            return this[s];
          }, this["set" + n] = function(h) {
            h != this[s] && (this[s] = h, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var n = this._project;
            n && (n._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, n) {
          var s = this._selection;
          this.setSelection(n ? s | i : s & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, n = 0, s = i.length; n < s; n++)
              if (i[n].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var n = this._children, s = 0, l = n.length; s < l; s++)
              n[s].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, n = !!(this._selection & 1);
          if (i && n) {
            for (var s = 0, l = i.length; s < l; s++)
              if (!i[s].isFullySelected())
                return !1;
            return !0;
          }
          return n;
        },
        setFullySelected: function(i) {
          var n = this._children;
          if (n)
            for (var s = 0, l = n.length; s < l; s++)
              n[s].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var n = i ? M : X, s = this._position || (this._position = this._getPositionFromBounds());
          return new n(s.x, s.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(M.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new X(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      a.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, n) {
          this[n] = function(s) {
            return this.getBounds(s, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, n) {
            var s = n || i instanceof J, l = a.set(
              {},
              s ? n : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var h = this._getCachedBounds(s && i, l).rect;
            return arguments.length ? h : new te(
              h.x,
              h.y,
              h.width,
              h.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = G.read(arguments), n = this.getBounds(), s = this._matrix, l = new J(), h = i.getCenter();
            l.translate(h), (i.width != n.width || i.height != n.height) && (s.isInvertible() || (s.set(s._backup || new J().translate(s.getTranslation())), n = this.getBounds()), l.scale(
              n.width !== 0 ? i.width / n.width : 0,
              n.height !== 0 ? i.height / n.height : 0
            )), h = n.getCenter(), l.translate(-h.x, -h.y), this.transform(l);
          },
          _getBounds: function(i, n) {
            var s = this._children;
            return !s || !s.length ? new G() : (K._updateBoundsCache(this, n.cacheItem), K._getBounds(s, i, n));
          },
          _getBoundsCacheKey: function(i, n) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              n ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, n, s) {
            i = i && i._orNullIfIdentity();
            var l = n.internal && !s, h = n.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), m = h && (!i || i.equals(d)) && this._getBoundsCacheKey(n, l), _ = this._bounds;
            if (K._updateBoundsCache(this._parent || this._symbol, h), m && _ && m in _) {
              var b = _[m];
              return {
                rect: b.rect.clone(),
                nonscaling: b.nonscaling
              };
            }
            var x = this._getBounds(i || d, n), T = x.rect || x, E = this._style, L = x.nonscaling || E.hasStroke() && !E.getStrokeScaling();
            if (m) {
              _ || (this._bounds = _ = {});
              var b = _[m] = {
                rect: T.clone(),
                nonscaling: L,
                internal: l
              };
            }
            return {
              rect: T,
              nonscaling: L
            };
          },
          _getStrokeMatrix: function(i, n) {
            var s = this.getStrokeScaling() ? null : n && n.internal ? this : this._parent || this._symbol && this._symbol._item, l = s ? s.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, n) {
              if (i && n) {
                var s = n._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[s] || (l.list.push(n), l.ids[s] = n);
              }
            },
            _clearBoundsCache: function(i) {
              var n = i._boundsCache;
              if (n) {
                i._bounds = i._position = i._boundsCache = t;
                for (var s = 0, l = n.list, h = l.length; s < h; s++) {
                  var d = l[s];
                  d !== i && (d._bounds = d._position = t, d._boundsCache && K._clearBoundsCache(d));
                }
              }
            },
            _getBounds: function(i, n, s) {
              var l = 1 / 0, h = -l, d = l, m = h, _ = !1;
              s = s || {};
              for (var b = 0, x = i.length; b < x; b++) {
                var T = i[b];
                if (T._visible && !T.isEmpty(!0)) {
                  var E = T._getCachedBounds(
                    n && n.appended(T._matrix),
                    s,
                    !0
                  ), L = E.rect;
                  l = Math.min(L.x, l), d = Math.min(L.y, d), h = Math.max(L.x + L.width, h), m = Math.max(L.y + L.height, m), E.nonscaling && (_ = !0);
                }
              }
              return {
                rect: isFinite(l) ? new G(l, d, h - l, m - d) : new G(),
                nonscaling: _
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          if (n != null && i != null) {
            var s = this._decomposed;
            this.rotate(i - n), s && (s.rotation = i, this._decomposed = s);
          }
        },
        getScaling: function() {
          var i = this._decompose(), n = i && i.scaling;
          return new X(n ? n.x : 1, n ? n.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = M.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && n && !i.equals(n)) {
            var s = this.getRotation(), l = this._decomposed, h = new J(), d = D.isZero;
            if (d(i.x) || d(i.y))
              h.translate(l.translation), s && h.rotate(s), h.scale(n.x, n.y), this._matrix.set(h);
            else {
              var m = this.getPosition(!0);
              h.translate(m), s && h.rotate(s), h.scale(n.x / i.x, n.y / i.y), s && h.rotate(-s), h.translate(m.negate()), this.transform(h);
            }
            l && (l.scaling = n, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var n = this._globalMatrix;
          if (n)
            for (var s = this._parent, l = []; s; ) {
              if (!s._globalMatrix) {
                n = null;
                for (var h = 0, d = l.length; h < d; h++)
                  l[h]._globalMatrix = null;
                break;
              }
              l.push(s), s = s._parent;
            }
          if (!n) {
            n = this._globalMatrix = this._matrix.clone();
            var s = this._parent;
            s && n.prepend(s.getGlobalMatrix(!0));
          }
          return i ? n : n.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, n) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var s = this._children, l = 0, h = s && s.length; l < h; l++)
              s[l]._setProject(i);
            n = !0;
          }
          n && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(n) {
          i.base.call(this, n);
          for (var s = this._children, l = 0, h = s && s.length; l < h; l++)
            s[l]._installEvents(n);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof We)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return a.equals(this._children, i._children);
        },
        clone: function(i) {
          var n = new this.constructor(K.NO_INSERT), s = this._children, l = a.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), h = a.pick(i ? i.deep : t, !0);
          s && n.copyAttributes(this), (!s || h) && n.copyContent(this), s || n.copyAttributes(this), l && n.insertAbove(this);
          var d = this._name, m = this._parent;
          if (d && m) {
            for (var s = m._children, _ = d, b = 1; s[d]; )
              d = _ + " " + b++;
            d !== _ && n.setName(d);
          }
          return n;
        },
        copyContent: function(i) {
          for (var n = i._children, s = 0, l = n && n.length; s < l; s++)
            this.addChild(n[s].clone(!1), !0);
        },
        copyAttributes: function(i, n) {
          this.setStyle(i._style);
          for (var s = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, h = s.length; l < h; l++) {
            var d = s[l];
            i.hasOwnProperty(d) && (this[d] = i[d]);
          }
          n || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var m = i._data, _ = i._name;
          this._data = m ? a.clone(m) : null, _ && this.setName(_);
        },
        rasterize: function(i, n) {
          var s, l, h;
          a.isPlainObject(i) ? (s = i.resolution, l = i.insert, h = i.raster) : (s = i, l = n), h || (h = new $e(K.NO_INSERT));
          var d = this.getStrokeBounds(), m = (s || this.getView().getResolution()) / 72, _ = d.getTopLeft().floor(), b = d.getBottomRight().ceil(), x = new Y(b.subtract(_)), T = x.multiply(m);
          if (h.setSize(T, !0), !T.isZero()) {
            var E = h.getContext(!0), L = new J().scale(m).translate(_.negate());
            E.save(), L.applyToContext(E), this.draw(E, new a({ matrices: [L] })), E.restore();
          }
          return h._matrix.set(
            new J().translate(_.add(x.divide(2))).scale(1 / m)
          ), (l === t || l) && h.insertAbove(this), h;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
        },
        _contains: function(i) {
          var n = this._children;
          if (n) {
            for (var s = n.length - 1; s >= 0; s--)
              if (n[s].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return G.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new it.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, n) {
          return i instanceof K ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            n,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            M.read(l),
            Xe.getOptions(l)
          );
        }
        function n() {
          var l = arguments, h = M.read(l), d = Xe.getOptions(l), m = [];
          return this._hitTest(h, new a({ all: m }, d)), m;
        }
        function s(l, h, d, m) {
          var _ = this._children;
          if (_)
            for (var b = _.length - 1; b >= 0; b--) {
              var x = _[b], T = x !== m && x._hitTest(
                l,
                h,
                d
              );
              if (T && !h.all)
                return T;
            }
          return null;
        }
        return ve.inject({
          hitTest: i,
          hitTestAll: n,
          _hitTest: s
        }), {
          hitTest: i,
          hitTestAll: n,
          _hitTestChildren: s
        };
      }(),
      {
        _hitTest: function(i, n, s) {
          if (this._locked || !this._visible || this._guide && !n.guides || this.isEmpty())
            return null;
          var l = this._matrix, h = s ? s.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(n.tolerance, 1e-12), m = n._tolerancePadding = new Y(
            it._getStrokePadding(
              d,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(m.multiply(2))._containsPoint(i))
            return null;
          var _ = !(n.guides && !this._guide || n.selected && !this.isSelected() || n.type && n.type !== a.hyphenate(this._class) || n.class && !(this instanceof n.class)), b = n.match, x = this, T, E;
          function L(C) {
            return C && b && !b(C) && (C = null), C && n.all && n.all.push(C), C;
          }
          function A(C, P) {
            var H = P ? T["get" + P]() : x.getPosition();
            if (i.subtract(H).divide(m).length <= 1)
              return new Xe(C, x, {
                name: P ? a.hyphenate(P) : C,
                point: H
              });
          }
          var U = n.position, k = n.center, F = n.bounds;
          if (_ && this._parent && (U || k || F)) {
            if ((k || F) && (T = this.getInternalBounds()), E = U && A("position") || k && A("center", "Center"), !E && F)
              for (var B = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], R = 0; R < 8 && !E; R++)
                E = A("bounds", B[R]);
            E = L(E);
          }
          return E || (E = this._hitTestChildren(i, n, h) || _ && L(this._hitTestSelf(
            i,
            n,
            h,
            this.getStrokeScaling() ? null : h._shiftless().invert()
          )) || null), E && E.point && (E.point = l.transform(E.point)), E;
        },
        _hitTestSelf: function(i, n) {
          if (n.fill && this.hasFill() && this._contains(i))
            return new Xe("fill", this);
        },
        matches: function(i, n) {
          function s(m, _) {
            for (var b in m)
              if (m.hasOwnProperty(b)) {
                var x = m[b], T = _[b];
                if (a.isPlainObject(x) && a.isPlainObject(T)) {
                  if (!s(x, T))
                    return !1;
                } else if (!a.equals(x, T))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var h in i)
              if (i.hasOwnProperty(h) && !this.matches(h, i[h]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return n(this);
            var d = /^(empty|editable)$/.test(i) ? this["is" + a.capitalize(i)]() : i === "type" ? a.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof n == "function")
                return this instanceof n;
              d = this._class;
            }
            if (typeof n == "function")
              return !!n(d);
            if (n) {
              if (n.test)
                return n.test(d);
              if (a.isPlainObject(n))
                return s(n, d);
            }
            return a.equals(d, n);
          }
        },
        getItems: function(i) {
          return K._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return K._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(n, s, l, h, d) {
            if (!h) {
              var m = typeof s == "object" && s, _ = m && m.overlapping, b = m && m.inside, x = _ || b, L = x && G.read([x]);
              h = {
                items: [],
                recursive: m && m.recursive !== !1,
                inside: !!b,
                overlapping: !!_,
                rect: L,
                path: _ && new it.Rectangle({
                  rectangle: L,
                  insert: !1
                })
              }, m && (s = a.filter({}, s, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var T = n._children, E = h.items, L = h.rect;
            l = L && (l || new J());
            for (var A = 0, U = T && T.length; A < U; A++) {
              var k = T[A], F = l && l.appended(k._matrix), B = !0;
              if (L) {
                var x = k.getBounds(F);
                if (!L.intersects(x))
                  continue;
                L.contains(x) || h.overlapping && (x.contains(L) || h.path.intersects(k, F)) || (B = !1);
              }
              if (B && k.matches(s) && (E.push(k), d) || (h.recursive !== !1 && i(k, s, F, h, d), d && E.length > 0))
                break;
            }
            return E;
          }
        }
      },
      {
        importJSON: function(i) {
          var n = a.importJSON(i, this);
          return n !== this ? this.addChild(n) : n;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, n) {
          var s = n ? this.insertChildren(i, [n]) : null;
          return s && s[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, n) {
          var s = this._children;
          if (s && n && n.length > 0) {
            n = a.slice(n);
            for (var l = {}, h = n.length - 1; h >= 0; h--) {
              var d = n[h], m = d && d._id;
              !d || l[m] ? n.splice(h, 1) : (d._remove(!1, !0), l[m] = !0);
            }
            a.splice(s, n, i, 0);
            for (var _ = this._project, b = _._changes, h = 0, x = n.length; h < x; h++) {
              var d = n[h], T = d._name;
              d._parent = this, d._setProject(_, !0), T && d.setName(T), b && d._changed(5);
            }
            this._changed(11);
          } else
            n = null;
          return n;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, n) {
          var s = i && i._getOwner(), l = i !== this && s ? this : null;
          return l && (l._remove(!1, !0), s._insertItem(i._index + n, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var n = this._children;
          if (n && n.length === 1) {
            var s = n[0].reduce(i);
            return this._parent ? (s.insertAbove(this), this.remove()) : s.remove(), s;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var n = i._children, s = i._namedChildren, l = this._name, h = s[l], d = h ? h.indexOf(this) : -1;
            d !== -1 && (n[l] == this && delete n[l], h.splice(d, 1), h.length ? n[l] = h[0] : delete s[l]);
          }
        },
        _remove: function(i, n) {
          var s = this._getOwner(), l = this._project, h = this._index;
          return this._style && this._style._dispose(), s ? (this._name && this._removeNamed(), h != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), a.splice(s._children, null, h, 1)), this._installEvents(!1), i && l._changes && this._changed(5), n && s._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var n = i && i.insertBelow(this);
          return n && this.remove(), n;
        },
        removeChildren: function(i, n) {
          if (!this._children)
            return null;
          i = i || 0, n = a.pick(n, this._children.length);
          for (var s = a.splice(this._children, null, i, n - i), l = s.length - 1; l >= 0; l--)
            s[l]._remove(!0, !1);
          return s.length > 0 && this._changed(11), s;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, n = this._children.length; i < n; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var n = this._children, s = n ? n.length : 0;
          if (i) {
            for (var l = 0; l < s; l++)
              if (!n[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !s;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function n(m) {
            var _ = [];
            do
              _.unshift(m);
            while (m = m._parent);
            return _;
          }
          for (var s = n(this), l = n(i), h = 0, d = Math.min(s.length, l.length); h < d; h++)
            if (s[h] != l[h])
              return s[h]._index < l[h]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var n = this; n = n._parent; )
            if (n === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var n = this._parent; n; ) {
            if (n._parent && /^(Group|Layer|CompoundPath)$/.test(n._class) && i.isDescendant(n))
              return !0;
            n = n._parent;
          }
          return !1;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (n ? a : M).read(s), h = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            h || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, n, s) {
          var l = this._matrix, h = i && !i.isIdentity(), d = s && this._canApplyMatrix || this._applyMatrix && (h || !l.isIdentity() || n && this._children);
          if (!h && !d)
            return this;
          if (h) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var m = this._style, _ = m.getFillColor(!0), b = m.getStrokeColor(!0);
            _ && _.transform(i), b && b.transform(i);
          }
          if (d && (d = this._transformContent(
            l,
            n,
            s
          ))) {
            var x = this._pivot;
            x && l._transformPoint(x, x, !0), l.reset(!0), s && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var T = this._bounds, E = this._position;
          (h || d) && this._changed(25);
          var L = h && T && i.decompose();
          if (L && L.skewing.isZero() && L.rotation % 90 === 0) {
            for (var A in T) {
              var U = T[A];
              if (U.nonscaling)
                delete T[A];
              else if (d || !U.internal) {
                var k = U.rect;
                i._transformBounds(k, k);
              }
            }
            this._bounds = T;
            var F = T[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            F && (this._position = this._getPositionFromBounds(F.rect));
          } else
            h && E && this._pivot && (this._position = i._transformPoint(E, E));
          return this;
        },
        _transformContent: function(i, n, s) {
          var l = this._children;
          if (l) {
            for (var h = 0, d = l.length; h < d; h++)
              l[h].transform(i, n, s);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            M.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            M.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        fitBounds: function(i, n) {
          i = G.read(arguments);
          var s = this.getBounds(), l = s.height / s.width, h = i.height / i.width, d = (n ? l > h : l < h) ? i.width / s.width : i.height / s.height, m = new G(
            new M(),
            new Y(s.width * d, s.height * d)
          );
          m.setCenter(i.getCenter()), this.setBounds(m);
        }
      }),
      {
        _setStyles: function(i, n, s) {
          var l = this._style, h = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, h)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, h), i.lineWidth = l.getStrokeWidth();
            var d = l.getStrokeJoin(), m = l.getStrokeCap(), _ = l.getMiterLimit();
            if (d && (i.lineJoin = d), m && (i.lineCap = m), _ && (i.miterLimit = _), He.support.nativeDash) {
              var b = l.getDashArray(), x = l.getDashOffset();
              b && b.length && ("setLineDash" in i ? (i.setLineDash(b), i.lineDashOffset = x) : (i.mozDash = b, i.mozDashOffset = x));
            }
          }
          if (l.hasShadow()) {
            var T = n.pixelRatio || 1, E = s._shiftless().prepend(
              new J().scale(T, T)
            ), L = E.transform(new M(l.getShadowBlur(), 0)), A = E.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = L.getLength(), i.shadowOffsetX = A.x, i.shadowOffsetY = A.y;
          }
        },
        draw: function(i, n, s) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = n.matrices, h = n.viewMatrix, d = this._matrix, m = l[l.length - 1].appended(d);
            if (m.isInvertible()) {
              h = h ? h.appended(m) : m, l.push(m), n.updateMatrix && (this._globalMatrix = m);
              var _ = this._blendMode, b = D.clamp(this._opacity, 0, 1), x = _ === "normal", T = et.nativeModes[_], E = x && b === 1 || n.dontStart || n.clip || (T || x && b < 1) && this._canComposite(), L = n.pixelRatio || 1, A, U, k;
              if (!E) {
                var F = this.getStrokeBounds(h);
                if (!F.width || !F.height) {
                  l.pop();
                  return;
                }
                k = n.offset, U = n.offset = F.getTopLeft().floor(), A = i, i = dt.getContext(F.getSize().ceil().add(1).multiply(L)), L !== 1 && i.scale(L, L);
              }
              i.save();
              var B = s ? s.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && h, R = !E && n.clipItem, C = !B || R;
              if (E ? (i.globalAlpha = b, T && (i.globalCompositeOperation = _)) : C && i.translate(-U.x, -U.y), C && (E ? d : h).applyToContext(i), R && n.clipItem.draw(i, n.extend({ clip: !0 })), B) {
                i.setTransform(L, 0, 0, L, 0, 0);
                var P = n.offset;
                P && i.translate(-P.x, -P.y);
              }
              this._draw(i, n, h, B), i.restore(), l.pop(), n.clip && !n.dontFinish && i.clip(this.getFillRule()), E || (et.process(
                _,
                i,
                A,
                b,
                U.subtract(k).multiply(L)
              ), dt.release(i), n.offset = k);
            }
          }
        },
        _isUpdated: function(i) {
          var n = this._parent;
          if (n instanceof Zt)
            return n._isUpdated(i);
          var s = this._updateVersion === i;
          return !s && n && n._visible && n._isUpdated(i) && (this._updateVersion = i, s = !0), s;
        },
        _drawSelection: function(i, n, s, l, h) {
          var d = this._selection, m = d & 1, _ = d & 2 || m && this._selectBounds, b = d & 4;
          if (this._drawSelected || (m = !1), (m || _ || b) && this._isUpdated(h)) {
            var x, T = this.getSelectedColor(!0) || (x = this.getLayer()) && x.getSelectedColor(!0), E = n.appended(this.getGlobalMatrix(!0)), L = s / 2;
            if (i.strokeStyle = i.fillStyle = T ? T.toCanvasStyle(i) : "#009dec", m && this._drawSelected(i, E, l), b) {
              var A = this.getPosition(!0), U = this._parent, k = U ? U.localToGlobal(A) : A, F = k.x, B = k.y;
              i.beginPath(), i.arc(F, B, L, 0, Math.PI * 2, !0), i.stroke();
              for (var R = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = L, P = s + 1, H = 0; H < 4; H++) {
                var W = R[H], V = W[0], Q = W[1];
                i.moveTo(F + V * C, B + Q * C), i.lineTo(F + V * P, B + Q * P), i.stroke();
              }
            }
            if (_) {
              var ae = E._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var H = 0; H < 8; H++)
                i[H ? "lineTo" : "moveTo"](ae[H], ae[++H]);
              i.closePath(), i.stroke();
              for (var H = 0; H < 8; H++)
                i.fillRect(
                  ae[H] - L,
                  ae[++H] - L,
                  s,
                  s
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      a.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + a.capitalize(i)] = function() {
          var n = {};
          return n[i] = !0, this.removeOn(n);
        };
      }, {
        removeOn: function(i) {
          for (var n in i)
            if (i[n]) {
              var s = "mouse" + n, l = this._project, h = l._removeSets = l._removeSets || {};
              h[s] = h[s] || {}, h[s][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, n, s) {
          s || (s = n, n = i, i = null, s || (s = n, n = null));
          var l = s && s.easing, h = s && s.start, d = s != null && (typeof s == "number" ? s : s.duration), m = new Qe(this, i, n, d, l, h);
          function _(b) {
            m._handleFrame(b.time * 1e3), m.running || this.off("frame", _);
          }
          return d && this.on("frame", _), m;
        },
        tweenTo: function(i, n) {
          return this.tween(null, i, n);
        },
        tweenFrom: function(i, n) {
          return this.tween(i, null, n);
        }
      }
    ), j = K.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(i) {
        this._children = [], this._namedChildren = {}, this._initialize(i) || this.addChildren(Array.isArray(i) ? i : arguments);
      },
      _changed: function i(n) {
        i.base.call(this, n), n & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var n = this._children, s = 0, l = n.length; s < l; s++)
            if (n[s]._clipMask) {
              i = n[s];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var n = this.getFirstChild();
        n && n.setClipMask(i);
      },
      _getBounds: function i(n, s) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(n),
          a.set({}, s, { stroke: !1 })
        ) : i.base.call(this, n, s);
      },
      _hitTestChildren: function i(n, s, l) {
        var h = this._getClipItem();
        return (!h || h.contains(n)) && i.base.call(
          this,
          n,
          s,
          l,
          h
        );
      },
      _draw: function(i, n) {
        var s = n.clip, l = !s && this._getClipItem();
        n = n.extend({ clipItem: l, clip: !1 }), s ? (i.beginPath(), n.dontStart = n.dontFinish = !0) : l && l.draw(i, n.extend({ clip: !0 }));
        for (var h = this._children, d = 0, m = h.length; d < m; d++) {
          var _ = h[d];
          _ !== l && _.draw(i, n);
        }
      }
    }), We = j.extend({
      _class: "Layer",
      initialize: function() {
        j.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), ke = K.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(i, n) {
          this._initialize(i, n);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && a.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new ie(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = Y.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var n = this._type, s = i.width, l = i.height;
            n === "rectangle" ? this._radius.set(Y.min(this._radius, i.divide(2).abs())) : n === "circle" ? (s = l = (s + l) / 2, this._radius = s / 2) : n === "ellipse" && this._radius._set(s / 2, l / 2), this._size._set(s, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new ie(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var n = this._type;
          if (n === "circle") {
            if (i === this._radius)
              return;
            var s = i * 2;
            this._radius = i, this._size._set(s, s);
          } else if (i = Y.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), n === "rectangle") {
              var s = Y.max(this._size, i.multiply(2));
              this._size.set(s);
            } else
              n === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var n = new it[a.capitalize(this._type)]({
            center: new M(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return n.copyAttributes(this), He.settings.applyMatrix && n.setApplyMatrix(!0), (i === t || i) && n.insertAbove(this), n;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, n, s, l) {
          var h = this._style, d = h.hasFill(), m = h.hasStroke(), _ = n.dontFinish || n.clip, b = !l;
          if (d || m || _) {
            var x = this._type, T = this._radius, E = x === "circle";
            if (n.dontStart || i.beginPath(), b && E)
              i.arc(0, 0, T, 0, Math.PI * 2, !0);
            else {
              var L = E ? T : T.width, A = E ? T : T.height, U = this._size, k = U.width, F = U.height;
              if (b && x === "rectangle" && L === 0 && A === 0)
                i.rect(-k / 2, -F / 2, k, F);
              else {
                var B = k / 2, R = F / 2, C = 1 - 0.5522847498307936, P = L * C, H = A * C, W = [
                  -B,
                  -R + A,
                  -B,
                  -R + H,
                  -B + P,
                  -R,
                  -B + L,
                  -R,
                  B - L,
                  -R,
                  B - P,
                  -R,
                  B,
                  -R + H,
                  B,
                  -R + A,
                  B,
                  R - A,
                  B,
                  R - H,
                  B - P,
                  R,
                  B - L,
                  R,
                  -B + L,
                  R,
                  -B + P,
                  R,
                  -B,
                  R - H,
                  -B,
                  R - A
                ];
                l && l.transform(W, W, 32), i.moveTo(W[0], W[1]), i.bezierCurveTo(W[2], W[3], W[4], W[5], W[6], W[7]), B !== L && i.lineTo(W[8], W[9]), i.bezierCurveTo(W[10], W[11], W[12], W[13], W[14], W[15]), R !== A && i.lineTo(W[16], W[17]), i.bezierCurveTo(W[18], W[19], W[20], W[21], W[22], W[23]), B !== L && i.lineTo(W[24], W[25]), i.bezierCurveTo(W[26], W[27], W[28], W[29], W[30], W[31]);
              }
            }
            i.closePath();
          }
          !_ && (d || m) && (this._setStyles(i, n, s), d && (i.fill(h.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), m && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, n) {
          var s = new G(this._size).setCenter(0, 0), l = this._style, h = n.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (s = i._transformBounds(s)), h ? s.expand(it._getStrokePadding(
            h,
            this._getStrokeMatrix(i, n)
          )) : s;
        }
      },
      new function() {
        function i(s, l, h) {
          var d = s._radius;
          if (!d.isZero())
            for (var m = s._size.divide(2), _ = 1; _ <= 4; _++) {
              var b = new M(_ > 1 && _ < 4 ? -1 : 1, _ > 2 ? -1 : 1), x = b.multiply(m), T = x.subtract(b.multiply(d)), E = new G(
                h ? x.add(b.multiply(h)) : x,
                T
              );
              if (E.contains(l))
                return { point: T, quadrant: _ };
            }
        }
        function n(s, l, h, d) {
          var m = s.divide(l);
          return (!d || m.isInQuadrant(d)) && m.subtract(m.normalize()).multiply(l).divide(h).length <= 1;
        }
        return {
          _contains: function s(l) {
            if (this._type === "rectangle") {
              var h = i(this, l);
              return h ? l.subtract(h.point).divide(this._radius).getLength() <= 1 : s.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function s(l, h, d, m) {
            var _ = !1, b = this._style, x = h.stroke && b.hasStroke(), T = h.fill && b.hasFill();
            if (x || T) {
              var E = this._type, L = this._radius, A = x ? b.getStrokeWidth() / 2 : 0, U = h._tolerancePadding.add(
                it._getStrokePadding(
                  A,
                  !b.getStrokeScaling() && m
                )
              );
              if (E === "rectangle") {
                var k = U.multiply(2), F = i(this, l, k);
                if (F)
                  _ = n(
                    l.subtract(F.point),
                    L,
                    U,
                    F.quadrant
                  );
                else {
                  var B = new G(this._size).setCenter(0, 0), R = B.expand(k), C = B.expand(k.negate());
                  _ = R._containsPoint(l) && !C._containsPoint(l);
                }
              } else
                _ = n(l, L, U);
            }
            return _ ? new Xe(x ? "stroke" : "fill", this) : s.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(n, s, l, h, d) {
            var m = a.create(ke.prototype);
            return m._type = n, m._size = l, m._radius = h, m._initialize(a.getNamed(d), s), m;
          }
          return {
            Circle: function() {
              var n = arguments, s = M.readNamed(n, "center"), l = a.readNamed(n, "radius");
              return i(
                "circle",
                s,
                new Y(l * 2),
                l,
                n
              );
            },
            Rectangle: function() {
              var n = arguments, s = G.readNamed(n, "rectangle"), l = Y.min(
                Y.readNamed(n, "radius"),
                s.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                s.getCenter(!0),
                s.getSize(!0),
                l,
                n
              );
            },
            Ellipse: function() {
              var n = arguments, s = ke._readEllipse(n), l = s.radius;
              return i(
                "ellipse",
                s.center,
                l.multiply(2),
                l,
                n
              );
            },
            _readEllipse: function(n) {
              var s, l;
              if (a.hasNamed(n, "radius"))
                s = M.readNamed(n, "center"), l = Y.readNamed(n, "radius");
              else {
                var h = G.readNamed(n, "rectangle");
                s = h.getCenter(!0), l = h.getSize(!0).divide(2);
              }
              return { center: s, radius: l };
            }
          };
        }()
      }
    ), $e = K.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(i, n) {
        if (!this._initialize(
          i,
          n !== t && M.read(arguments)
        )) {
          var s, l = typeof i, h = l === "string" ? o.getElementById(i) : l === "object" ? i : null;
          if (h && h !== K.NO_INSERT) {
            if (h.getContext || h.naturalHeight != null)
              s = h;
            else if (h) {
              var d = Y.read(arguments);
              d.isZero() || (s = dt.getCanvas(d));
            }
          }
          s ? this.setImage(s) : this.setSource(i);
        }
        this._size || (this._size = new Y(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var n = i._image, s = i._canvas;
        if (n)
          this._setImage(n);
        else if (s) {
          var l = dt.getCanvas(i._size);
          l.getContext("2d").drawImage(s, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new ie(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, n) {
        var s = Y.read(arguments);
        if (s.equals(this._size))
          n && this.clear();
        else if (s.width > 0 && s.height > 0) {
          var l = !n && this.getElement();
          this._setImage(dt.getCanvas(s)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            s.width,
            s.height
          );
        } else
          this._canvas && dt.release(this._canvas), this._size = s.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, n = new M(0, 0).transform(i), s = new M(1, 0).transform(i).subtract(n), l = new M(0, 1).transform(i).subtract(n);
        return new Y(
          72 / s.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var n = this;
        function s(l) {
          var h = n.getView(), d = l && l.type || "load";
          h && n.responds(d) && (He = h._scope, n.emit(d, new tn(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(s, 0) : i && Qt.add(i, {
          load: function(l) {
            n._setImage(i), s(l);
          },
          error: s
        });
      },
      _setImage: function(i) {
        this._canvas && dt.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new Y(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = dt.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            dt.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var n = new e.Image(), s = this._crossOrigin;
        s && (n.crossOrigin = s), i && (n.src = i), this.setImage(n);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var n = this._image;
        n && (n.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = G.read(arguments), n = dt.getContext(i.getSize());
        return n.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), n.canvas;
      },
      getSubRaster: function() {
        var i = G.read(arguments), n = new $e(K.NO_INSERT);
        return n._setImage(this.getSubCanvas(i)), n.translate(i.getCenter().subtract(this.getSize().divide(2))), n._matrix.prepend(this._matrix), n.insertAbove(this), n;
      },
      toDataURL: function() {
        var i = this._image, n = i && i.src;
        if (/^data:/.test(n))
          return n;
        var s = this.getCanvas();
        return s ? s.toDataURL.apply(s, arguments) : null;
      },
      drawImage: function(i) {
        var n = M.read(arguments, 1);
        this.getContext(!0).drawImage(i, n.x, n.y);
      },
      getAverageColor: function(i) {
        var n, s;
        if (i ? i instanceof Gt ? (s = i, n = i.getBounds()) : typeof i == "object" && ("width" in i ? n = new G(i) : "x" in i && (n = new G(i.x - 0.5, i.y - 0.5, 1, 1))) : n = this.getBounds(), !n)
          return null;
        var l = 32, h = Math.min(n.width, l), d = Math.min(n.height, l), m = $e._sampleContext;
        m ? m.clearRect(0, 0, l + 1, l + 1) : m = $e._sampleContext = dt.getContext(
          new Y(l)
        ), m.save();
        var _ = new J().scale(h / n.width, d / n.height).translate(-n.x, -n.y);
        _.applyToContext(m), s && s.draw(m, new a({ clip: !0, matrices: [_] })), this._matrix.applyToContext(m);
        var b = this.getElement(), x = this._size;
        b && m.drawImage(b, -x.width / 2, -x.height / 2), m.restore();
        for (var T = m.getImageData(
          0.5,
          0.5,
          Math.ceil(h),
          Math.ceil(d)
        ).data, E = [0, 0, 0], L = 0, A = 0, U = T.length; A < U; A += 4) {
          var k = T[A + 3];
          L += k, k /= 255, E[0] += T[A] * k, E[1] += T[A + 1] * k, E[2] += T[A + 2] * k;
        }
        for (var A = 0; A < 3; A++)
          E[A] /= L;
        return L ? At.read(E) : null;
      },
      getPixel: function() {
        var i = M.read(arguments), n = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new At(
          "rgb",
          [n[0] / 255, n[1] / 255, n[2] / 255],
          n[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, n = M.read(i), s = At.read(i), l = s._convert("rgb"), h = s._alpha, d = this.getContext(!0), m = d.createImageData(1, 1), _ = m.data;
        _[0] = l[0] * 255, _[1] = l[1] * 255, _[2] = l[2] * 255, _[3] = h != null ? h * 255 : 255, d.putImageData(m, n.x, n.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = Y.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = G.read(arguments);
        return i.isEmpty() && (i = new G(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var n = M.read(arguments, 1);
        this.getContext(!0).putImageData(i, n.x, n.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, n) {
        var s = new G(this._size).setCenter(0, 0);
        return i ? i._transformBounds(s) : s;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var n = this;
          return new Xe("pixel", n, {
            offset: i.add(n._size.divide(2)).round(),
            color: {
              get: function() {
                return n.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, n, s) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = D.clamp(this._opacity, 0, 1), this._setStyles(i, n, s);
          var h = this._smoothing, d = h === "off";
          Wt.setPrefixed(
            i,
            d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            d ? !1 : h
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), Lt = K.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(i, n) {
        this._initialize(
          i,
          n !== t && M.read(arguments, 1)
        ) || this.setDefinition(i instanceof Be ? i : new Be(i));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, n) {
        var s = this._definition._item;
        return s._getCachedBounds(s._matrix.prepended(i), n);
      },
      _hitTestSelf: function(i, n, s) {
        var l = n.extend({ all: !1 }), h = this._definition._item._hitTest(i, l, s);
        return h && (h.item = this), h;
      },
      _draw: function(i, n) {
        this._definition._item.draw(i, n);
      }
    }), Be = a.extend({
      _class: "SymbolDefinition",
      initialize: function(i, n) {
        this._id = Z.get(), this.project = He.project, i && this.setItem(i, n);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._class, this._item],
            i,
            !1,
            n
          );
        });
      },
      _changed: function(i) {
        i & 8 && K._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, n) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), n || i.setPosition(new M()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new Lt(this, i);
      },
      clone: function() {
        return new Be(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), Xe = a.extend({
      _class: "HitResult",
      initialize: function(i, n, s) {
        this.type = i, this.item = n, s && this.inject(s);
      },
      statics: {
        getOptions: function(i) {
          var n = i && a.read(i);
          return new a({
            type: null,
            tolerance: He.settings.hitTolerance,
            fill: !n,
            stroke: !n,
            segments: !n,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, n);
        }
      }
    }), ue = a.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(i, n, s, l, h, d) {
        var m = arguments.length, _, b, x, T;
        m > 0 && (i == null || typeof i == "object" ? m === 1 && i && "point" in i ? (_ = i.point, b = i.handleIn, x = i.handleOut, T = i.selection) : (_ = i, b = n, x = s, T = l) : (_ = [i, n], b = s !== t ? [s, l] : null, x = h !== t ? [h, d] : null)), new yt(_, this, "_point"), new yt(b, this, "_handleIn"), new yt(x, this, "_handleOut"), T && this.setSelection(T);
      },
      _serialize: function(i, n) {
        var s = this._point, l = this._selection, h = l || this.hasHandles() ? [s, this._handleIn, this._handleOut] : s;
        return l && h.push(l), a.serialize(h, i, !0, n);
      },
      _changed: function(i) {
        var n = this._path;
        if (n) {
          var s = n._curves, l = this._index, h;
          s && ((!i || i === this._point || i === this._handleIn) && (h = l > 0 ? s[l - 1] : n._closed ? s[s.length - 1] : null) && h._changed(), (!i || i === this._point || i === this._handleOut) && (h = s[l]) && h._changed()), n._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(M.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(M.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(M.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, n = this._handleOut;
        return !i.isZero() && !n.isZero() && i.isCollinear(n);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var n = this._selection, s = this._path;
        this._selection = i = i || 0, s && i !== n && (s._updateSelection(this, n, i), s._changed(257));
      },
      _changeSelection: function(i, n) {
        var s = this._selection;
        this.setSelection(n ? s | i : s & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, n = this._index;
        return i ? (n > 0 && !i._closed && n === i._segments.length - 1 && n--, i.getCurves()[n] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new ot(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, n, s) {
        var l = i || {}, h = l.type, d = l.factor, m = this.getPrevious(), _ = this.getNext(), b = (m || this)._point, x = this._point, T = (_ || this)._point, E = b.getDistance(x), L = x.getDistance(T);
        if (!h || h === "catmull-rom") {
          var A = d === t ? 0.5 : d, U = Math.pow(E, A), k = U * U, F = Math.pow(L, A), B = F * F;
          if (!n && m) {
            var R = 2 * B + 3 * F * U + k, C = 3 * F * (F + U);
            this.setHandleIn(C !== 0 ? new M(
              (B * b._x + R * x._x - k * T._x) / C - x._x,
              (B * b._y + R * x._y - k * T._y) / C - x._y
            ) : new M());
          }
          if (!s && _) {
            var R = 2 * k + 3 * U * F + B, C = 3 * U * (U + F);
            this.setHandleOut(C !== 0 ? new M(
              (k * T._x + R * x._x - B * b._x) / C - x._x,
              (k * T._y + R * x._y - B * b._y) / C - x._y
            ) : new M());
          }
        } else if (h === "geometric") {
          if (m && _) {
            var P = b.subtract(T), H = d === t ? 0.4 : d, W = H * E / (E + L);
            n || this.setHandleIn(P.multiply(W)), s || this.setHandleOut(P.multiply(W - H));
          }
        } else
          throw new Error("Smoothing method '" + h + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, n = this._handleOut, s = i.clone();
        i.set(n), n.set(s);
      },
      reversed: function() {
        return new ue(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new ue(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, n, s) {
        var l = 1 - s, h = s, d = i._point, m = n._point, _ = i._handleIn, b = n._handleIn, x = n._handleOut, T = i._handleOut;
        this._point._set(
          l * d._x + h * m._x,
          l * d._y + h * m._y,
          !0
        ), this._handleIn._set(
          l * _._x + h * b._x,
          l * _._y + h * b._y,
          !0
        ), this._handleOut._set(
          l * T._x + h * x._x,
          l * T._y + h * x._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, n, s) {
        var l = this._point, h = !s || !this._handleIn.isZero() ? this._handleIn : null, d = !s || !this._handleOut.isZero() ? this._handleOut : null, m = l._x, _ = l._y, b = 2;
        return n[0] = m, n[1] = _, h && (n[b++] = h._x + m, n[b++] = h._y + _), d && (n[b++] = d._x + m, n[b++] = d._y + _), i && (i._transformCoordinates(n, n, b / 2), m = n[0], _ = n[1], s ? (l._x = m, l._y = _, b = 2, h && (h._x = n[b++] - m, h._y = n[b++] - _), d && (d._x = n[b++] - m, d._y = n[b++] - _)) : (h || (n[b++] = m, n[b++] = _), d || (n[b++] = m, n[b++] = _))), n;
      }
    }), yt = M.extend({
      initialize: function(i, n, s) {
        var l, h, d;
        if (!i)
          l = h = 0;
        else if ((l = i[0]) !== t)
          h = i[1];
        else {
          var m = i;
          (l = m.x) === t && (m = M.read(arguments), l = m.x), h = m.y, d = m.selected;
        }
        this._x = l, this._y = h, this._owner = n, n[s] = this, d && this.setSelected(!0);
      },
      _set: function(i, n) {
        return this._x = i, this._y = n, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = D.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), Ue = a.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(i, n, s, l, h, d, m, _) {
          var b = arguments.length, x, T, E, L, A, U;
          b === 3 ? (this._path = i, x = n, T = s) : b ? b === 1 ? "segment1" in i ? (x = new ue(i.segment1), T = new ue(i.segment2)) : "point1" in i ? (E = i.point1, A = i.handle1, U = i.handle2, L = i.point2) : Array.isArray(i) && (E = [i[0], i[1]], L = [i[6], i[7]], A = [i[2] - i[0], i[3] - i[1]], U = [i[4] - i[6], i[5] - i[7]]) : b === 2 ? (x = new ue(i), T = new ue(n)) : b === 4 ? (E = i, A = n, U = s, L = l) : b === 8 && (E = [i, n], L = [m, _], A = [s - i, l - n], U = [h - m, d - _]) : (x = new ue(), T = new ue()), this._segment1 = x || new ue(E, null, A), this._segment2 = T || new ue(L, U, null);
        },
        _serialize: function(i, n) {
          return a.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            n
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new Ue(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return Ue.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var n = this._segment2, s = n._handleOut;
            i = n.remove(), i && this._segment1._handleOut.set(s);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(M.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(M.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(M.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(M.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return Ue.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), n = [], s = 0; s < 8; s += 2)
            n.push(new M(i[s], i[s + 1]));
          return n;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = Ue.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return Ue.getArea(this.getValues());
        },
        getLine: function() {
          return new he(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, n) {
          return new Ue(Ue.getPart(this.getValues(), i, n));
        },
        getPartLength: function(i, n) {
          return Ue.getLength(this.getValues(), i, n);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, n) {
          var s = 1e-8, l = 1 - s, h = null;
          if (i >= s && i <= l) {
            var d = Ue.subdivide(this.getValues(), i), m = d[0], _ = d[1], b = n || this.hasHandles(), x = this._segment1, T = this._segment2, E = this._path;
            b && (x._handleOut._set(m[2] - m[0], m[3] - m[1]), T._handleIn._set(_[4] - _[6], _[5] - _[7]));
            var L = m[6], A = m[7], U = new ue(
              new M(L, A),
              b && new M(m[4] - L, m[5] - A),
              b && new M(_[2] - L, _[3] - A)
            );
            E ? (E.insert(x._index + 1, U), h = this.getNext()) : (this._segment2 = U, this._changed(), h = new Ue(U, T));
          }
          return h;
        },
        splitAt: function(i) {
          var n = this._path;
          return n ? n.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, n) {
          return this.divideAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        split: function(i, n) {
          return this.splitAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new Ue(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, n, s, l) {
            var h = i._point, d = i._handleOut, m = n._handleIn, _ = n._point, b = h.x, x = h.y, T = _.x, E = _.y, L = l ? [b, x, b, x, T, E, T, E] : [
              b,
              x,
              b + d._x,
              x + d._y,
              T + m._x,
              E + m._y,
              T,
              E
            ];
            return s && s._transformCoordinates(L, L, 4), L;
          },
          subdivide: function(i, n) {
            var s = i[0], l = i[1], h = i[2], d = i[3], m = i[4], _ = i[5], b = i[6], x = i[7];
            n === t && (n = 0.5);
            var T = 1 - n, E = T * s + n * h, L = T * l + n * d, A = T * h + n * m, U = T * d + n * _, k = T * m + n * b, F = T * _ + n * x, B = T * E + n * A, R = T * L + n * U, C = T * A + n * k, P = T * U + n * F, H = T * B + n * C, W = T * R + n * P;
            return [
              [s, l, E, L, B, R, H, W],
              [H, W, C, P, k, F, b, x]
            ];
          },
          getMonoCurves: function(i, n) {
            var s = [], l = n ? 0 : 1, h = i[l + 0], d = i[l + 2], m = i[l + 4], _ = i[l + 6];
            if (h >= d == d >= m && d >= m == m >= _ || Ue.isStraight(i))
              s.push(i);
            else {
              var b = 3 * (d - m) - h + _, x = 2 * (h + m) - 4 * d, T = d - h, E = 1e-8, L = 1 - E, A = [], U = D.solveQuadratic(b, x, T, A, E, L);
              if (!U)
                s.push(i);
              else {
                A.sort();
                var k = A[0], F = Ue.subdivide(i, k);
                s.push(F[0]), U > 1 && (k = (A[1] - k) / (1 - k), F = Ue.subdivide(F[1], k), s.push(F[0])), s.push(F[1]);
              }
            }
            return s;
          },
          solveCubic: function(i, n, s, l, h, d) {
            var m = i[n], _ = i[n + 2], b = i[n + 4], x = i[n + 6], T = 0;
            if (!(m < s && x < s && _ < s && b < s || m > s && x > s && _ > s && b > s)) {
              var E = 3 * (_ - m), L = 3 * (b - _) - E, A = x - m - E - L;
              T = D.solveCubic(A, L, E, m - s, l, h, d);
            }
            return T;
          },
          getTimeOf: function(i, n) {
            var s = new M(i[0], i[1]), l = new M(i[6], i[7]), h = 1e-12, d = 1e-7, m = n.isClose(s, h) ? 0 : n.isClose(l, h) ? 1 : null;
            if (m === null)
              for (var _ = [n.x, n.y], b = [], x = 0; x < 2; x++)
                for (var T = Ue.solveCubic(i, x, _[x], b, 0, 1), E = 0; E < T; E++) {
                  var L = b[E];
                  if (n.isClose(Ue.getPoint(i, L), d))
                    return L;
                }
            return n.isClose(s, d) ? 0 : n.isClose(l, d) ? 1 : null;
          },
          getNearestTime: function(i, n) {
            if (Ue.isStraight(i)) {
              var s = i[0], l = i[1], h = i[6], d = i[7], m = h - s, _ = d - l, b = m * m + _ * _;
              if (b === 0)
                return 0;
              var x = ((n.x - s) * m + (n.y - l) * _) / b;
              return x < 1e-12 ? 0 : x > 0.999999999999 ? 1 : Ue.getTimeOf(
                i,
                new M(s + x * m, l + x * _)
              );
            }
            var T = 100, E = 1 / 0, L = 0;
            function A(F) {
              if (F >= 0 && F <= 1) {
                var B = n.getDistance(Ue.getPoint(i, F), !0);
                if (B < E)
                  return E = B, L = F, !0;
              }
            }
            for (var U = 0; U <= T; U++)
              A(U / T);
            for (var k = 1 / (T * 2); k > 1e-8; )
              !A(L - k) && !A(L + k) && (k /= 2);
            return L;
          },
          getPart: function(i, n, s) {
            var l = n > s;
            if (l) {
              var h = n;
              n = s, s = h;
            }
            return n > 0 && (i = Ue.subdivide(i, n)[1]), s < 1 && (i = Ue.subdivide(i, (s - n) / (1 - n))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, n) {
            var s = i[0], l = i[1], h = i[2], d = i[3], m = i[4], _ = i[5], b = i[6], x = i[7], T = 3 * h - 2 * s - b, E = 3 * d - 2 * l - x, L = 3 * m - 2 * b - s, A = 3 * _ - 2 * x - l;
            return Math.max(T * T, L * L) + Math.max(E * E, A * A) <= 16 * n * n;
          },
          getArea: function(i) {
            var n = i[0], s = i[1], l = i[2], h = i[3], d = i[4], m = i[5], _ = i[6], b = i[7];
            return 3 * ((b - s) * (l + d) - (_ - n) * (h + m) + h * (n - d) - l * (s - m) + b * (d + n / 3) - _ * (m + s / 3)) / 20;
          },
          getBounds: function(i) {
            for (var n = i.slice(0, 2), s = n.slice(), l = [0, 0], h = 0; h < 2; h++)
              Ue._addBounds(
                i[h],
                i[h + 2],
                i[h + 4],
                i[h + 6],
                h,
                0,
                n,
                s,
                l
              );
            return new G(n[0], n[1], s[0] - n[0], s[1] - n[1]);
          },
          _addBounds: function(i, n, s, l, h, d, m, _, b) {
            function x(H, W) {
              var V = H - W, Q = H + W;
              V < m[h] && (m[h] = V), Q > _[h] && (_[h] = Q);
            }
            d /= 2;
            var T = m[h] + d, E = _[h] - d;
            if (i < T || n < T || s < T || l < T || i > E || n > E || s > E || l > E)
              if (n < i != n < l && s < i != s < l)
                x(i, 0), x(l, 0);
              else {
                var L = 3 * (n - s) - i + l, A = 2 * (i + s) - 4 * n, U = n - i, k = D.solveQuadratic(L, A, U, b), F = 1e-8, B = 1 - F;
                x(l, 0);
                for (var R = 0; R < k; R++) {
                  var C = b[R], P = 1 - C;
                  F <= C && C <= B && x(
                    P * P * P * i + 3 * P * P * C * n + 3 * P * C * C * s + C * C * C * l,
                    d
                  );
                }
              }
          }
        }
      },
      a.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var n = this._bounds[i];
            return n || (n = this._bounds[i] = it[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), n.clone();
          };
        },
        {}
      ),
      a.each({
        isStraight: function(i, n, s, l) {
          if (n.isZero() && s.isZero())
            return !0;
          var h = l.subtract(i);
          if (h.isZero())
            return !1;
          if (h.isCollinear(n) && h.isCollinear(s)) {
            var d = new he(i, l), m = 1e-7;
            if (d.getDistance(i.add(n)) < m && d.getDistance(l.add(s)) < m) {
              var _ = h.dot(h), b = h.dot(n) / _, x = h.dot(s) / _;
              return b >= 0 && b <= 1 && x <= 0 && x >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, n, s, l) {
          var h = l.subtract(i).divide(3);
          return n.equals(h) && s.negate().equals(h);
        }
      }, function(i, n) {
        this[n] = function(s) {
          var l = this._segment1, h = this._segment2;
          return i(
            l._point,
            l._handleOut,
            h._handleIn,
            h._point,
            s
          );
        }, this.statics[n] = function(s, l) {
          var h = s[0], d = s[1], m = s[6], _ = s[7];
          return i(
            new M(h, d),
            new M(s[2] - h, s[3] - d),
            new M(s[4] - m, s[5] - _),
            new M(m, _),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, n) {
          return this.getLocationAtTime(
            n ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new ot(this, i) : null;
        },
        getTimeAt: function(i, n) {
          return Ue.getTimeAt(this.getValues(), i, n);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = M.read(arguments);
          return i.isZero() ? [] : Ue.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return Ue.getTimeOf(this.getValues(), M.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = M.read(arguments), n = this.getValues(), s = Ue.getNearestTime(n, i), l = Ue.getPoint(n, s);
          return new ot(this, s, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return a.each(
          i,
          function(n) {
            this[n + "At"] = function(s, l) {
              var h = this.getValues();
              return Ue[n](h, l ? s : Ue.getTimeAt(h, s));
            }, this[n + "AtTime"] = function(s) {
              return Ue[n](this.getValues(), s);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var h = l[0], d = l[1], m = l[2], _ = l[3], b = l[4], x = l[5], T = l[6], E = l[7], L = 9 * (m - b) + 3 * (T - h), A = 6 * (h + b) - 12 * m, U = 3 * (m - h), k = 9 * (_ - x) + 3 * (E - d), F = 6 * (d + x) - 12 * _, B = 3 * (_ - d);
          return function(R) {
            var C = (L * R + A) * R + U, P = (k * R + F) * R + B;
            return Math.sqrt(C * C + P * P);
          };
        }
        function n(l, h) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(h - l) * 32)));
        }
        function s(l, h, d, m) {
          if (h == null || h < 0 || h > 1)
            return null;
          var _ = l[0], b = l[1], x = l[2], T = l[3], E = l[4], L = l[5], A = l[6], U = l[7], k = D.isZero;
          k(x - _) && k(T - b) && (x = _, T = b), k(E - A) && k(L - U) && (E = A, L = U);
          var F = 3 * (x - _), B = 3 * (E - x) - F, R = A - _ - F - B, C = 3 * (T - b), P = 3 * (L - T) - C, H = U - b - C - P, W, V;
          if (d === 0)
            W = h === 0 ? _ : h === 1 ? A : ((R * h + B) * h + F) * h + _, V = h === 0 ? b : h === 1 ? U : ((H * h + P) * h + C) * h + b;
          else {
            var Q = 1e-8, ae = 1 - Q;
            if (h < Q ? (W = F, V = C) : h > ae ? (W = 3 * (A - E), V = 3 * (U - L)) : (W = (3 * R * h + 2 * B) * h + F, V = (3 * H * h + 2 * P) * h + C), m) {
              W === 0 && V === 0 && (h < Q || h > ae) && (W = E - x, V = L - T);
              var le = Math.sqrt(W * W + V * V);
              le && (W /= le, V /= le);
            }
            if (d === 3) {
              var E = 6 * R * h + 2 * B, L = 6 * H * h + 2 * P, fe = Math.pow(W * W + V * V, 3 / 2);
              W = fe !== 0 ? (W * L - V * E) / fe : 0, V = 0;
            }
          }
          return d === 2 ? new M(V, -W) : new M(W, V);
        }
        return { statics: {
          classify: function(l) {
            var h = l[0], d = l[1], m = l[2], _ = l[3], b = l[4], x = l[5], T = l[6], E = l[7], L = h * (E - x) + d * (b - T) + T * x - E * b, A = m * (d - E) + _ * (T - h) + h * E - d * T, U = b * (_ - d) + x * (h - m) + m * d - _ * h, k = 3 * U, F = k - A, B = F - A + L, R = Math.sqrt(B * B + F * F + k * k), C = R !== 0 ? 1 / R : 0, P = D.isZero, H = "serpentine";
            B *= C, F *= C, k *= C;
            function W(le, fe, se) {
              var ge = fe !== t, me = ge && fe > 0 && fe < 1, we = ge && se > 0 && se < 1;
              return ge && (!(me || we) || le === "loop" && !(me && we)) && (le = "arch", me = we = !1), {
                type: le,
                roots: me || we ? me && we ? fe < se ? [fe, se] : [se, fe] : [me ? fe : se] : null
              };
            }
            if (P(B))
              return P(F) ? W(P(k) ? "line" : "quadratic") : W(H, k / (3 * F));
            var V = 3 * F * F - 4 * B * k;
            if (P(V))
              return W("cusp", F / (2 * B));
            var Q = V > 0 ? Math.sqrt(V / 3) : Math.sqrt(-V), ae = 2 * B;
            return W(
              V > 0 ? H : "loop",
              (F + Q) / ae,
              (F - Q) / ae
            );
          },
          getLength: function(l, h, d, m) {
            if (h === t && (h = 0), d === t && (d = 1), Ue.isStraight(l)) {
              var _ = l;
              d < 1 && (_ = Ue.subdivide(_, d)[0], h /= d), h > 0 && (_ = Ue.subdivide(_, h)[1]);
              var b = _[6] - _[0], x = _[7] - _[1];
              return Math.sqrt(b * b + x * x);
            }
            return D.integrate(
              m || i(l),
              h,
              d,
              n(h, d)
            );
          },
          getTimeAt: function(l, h, d) {
            if (d === t && (d = h < 0 ? 1 : 0), h === 0)
              return d;
            var m = Math.abs, _ = 1e-12, b = h > 0, x = b ? d : 0, T = b ? 1 : d, E = i(l), L = Ue.getLength(l, x, T, E), A = m(h) - L;
            if (m(A) < _)
              return b ? T : x;
            if (A > _)
              return null;
            var U = h / L, k = 0;
            function F(B) {
              return k += D.integrate(
                E,
                d,
                B,
                n(d, B)
              ), d = B, k - h;
            }
            return D.findRoot(
              F,
              E,
              d + U,
              x,
              T,
              32,
              1e-12
            );
          },
          getPoint: function(l, h) {
            return s(l, h, 0, !1);
          },
          getTangent: function(l, h) {
            return s(l, h, 1, !0);
          },
          getWeightedTangent: function(l, h) {
            return s(l, h, 1, !1);
          },
          getNormal: function(l, h) {
            return s(l, h, 2, !0);
          },
          getWeightedNormal: function(l, h) {
            return s(l, h, 2, !1);
          },
          getCurvature: function(l, h) {
            return s(l, h, 3, !1).x;
          },
          getPeaks: function(l) {
            var h = l[0], d = l[1], m = l[2], _ = l[3], b = l[4], x = l[5], T = l[6], E = l[7], L = -h + 3 * m - 3 * b + T, A = 3 * h - 6 * m + 3 * b, U = -3 * h + 3 * m, k = -d + 3 * _ - 3 * x + E, F = 3 * d - 6 * _ + 3 * x, B = -3 * d + 3 * _, R = 1e-8, C = 1 - R, P = [];
            return D.solveCubic(
              9 * (L * L + k * k),
              9 * (L * A + F * k),
              2 * (A * A + F * F) + 3 * (U * L + B * k),
              U * A + F * B,
              P,
              R,
              C
            ), P.sort();
          }
        } };
      }(),
      new function() {
        function i(A, U, k, F, B, R, C) {
          var P = !C && k.getPrevious() === B, H = !C && k !== B && k.getNext() === B, W = 1e-8, V = 1 - W;
          if (F !== null && F >= (P ? W : 0) && F <= (H ? V : 1) && R !== null && R >= (H ? W : 0) && R <= (P ? V : 1)) {
            var Q = new ot(k, F, null, C), ae = new ot(B, R, null, C);
            Q._intersection = ae, ae._intersection = Q, (!U || U(Q)) && ot.insert(A, Q, !0);
          }
        }
        function n(A, U, k, F, B, R, C, P, H, W, V, Q, ae) {
          if (++H >= 4096 || ++P >= 40)
            return H;
          var le = 1e-9, fe = U[0], se = U[1], ge = U[6], me = U[7], we = he.getSignedDistance, Se = we(fe, se, ge, me, U[2], U[3]), Ae = we(fe, se, ge, me, U[4], U[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, Je = Ge * Math.min(0, Se, Ae), tt = Ge * Math.max(0, Se, Ae), ft = we(fe, se, ge, me, A[0], A[1]), Ne = we(fe, se, ge, me, A[2], A[3]), ze = we(fe, se, ge, me, A[4], A[5]), nt = we(fe, se, ge, me, A[6], A[7]), _t = s(ft, Ne, ze, nt), mt = _t[0], Pt = _t[1], Et, zt;
          if (Se === 0 && Ae === 0 && ft === 0 && Ne === 0 && ze === 0 && nt === 0 || (Et = l(mt, Pt, Je, tt)) == null || (zt = l(
            mt.reverse(),
            Pt.reverse(),
            Je,
            tt
          )) == null)
            return H;
          var jt = W + (V - W) * Et, Ft = W + (V - W) * zt;
          if (Math.max(ae - Q, Ft - jt) < le) {
            var Mi = (jt + Ft) / 2, Rt = (Q + ae) / 2;
            i(
              B,
              R,
              C ? F : k,
              C ? Rt : Mi,
              C ? k : F,
              C ? Mi : Rt
            );
          } else {
            A = Ue.getPart(A, Et, zt);
            var hi = ae - Q;
            if (zt - Et > 0.8)
              if (Ft - jt > hi) {
                var ci = Ue.subdivide(A, 0.5), Mi = (jt + Ft) / 2;
                H = n(
                  U,
                  ci[0],
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Q,
                  ae,
                  jt,
                  Mi
                ), H = n(
                  U,
                  ci[1],
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Q,
                  ae,
                  Mi,
                  Ft
                );
              } else {
                var ci = Ue.subdivide(U, 0.5), Rt = (Q + ae) / 2;
                H = n(
                  ci[0],
                  A,
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Q,
                  Rt,
                  jt,
                  Ft
                ), H = n(
                  ci[1],
                  A,
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Rt,
                  ae,
                  jt,
                  Ft
                );
              }
            else
              hi === 0 || hi >= le ? H = n(
                U,
                A,
                F,
                k,
                B,
                R,
                !C,
                P,
                H,
                Q,
                ae,
                jt,
                Ft
              ) : H = n(
                A,
                U,
                k,
                F,
                B,
                R,
                C,
                P,
                H,
                jt,
                Ft,
                Q,
                ae
              );
          }
          return H;
        }
        function s(A, U, k, F) {
          var B = [0, A], R = [1 / 3, U], C = [2 / 3, k], P = [1, F], H = U - (2 * A + F) / 3, W = k - (A + 2 * F) / 3, V;
          if (H * W < 0)
            V = [[B, R, P], [B, C, P]];
          else {
            var Q = H / W;
            V = [
              Q >= 2 ? [B, R, P] : Q <= 0.5 ? [B, C, P] : [B, R, C, P],
              [B, P]
            ];
          }
          return (H || W) < 0 ? V.reverse() : V;
        }
        function l(A, U, k, F) {
          return A[0][1] < k ? h(A, !0, k) : U[0][1] > F ? h(U, !1, F) : A[0][0];
        }
        function h(A, U, k) {
          for (var F = A[0][0], B = A[0][1], R = 1, C = A.length; R < C; R++) {
            var P = A[R][0], H = A[R][1];
            if (U ? H >= k : H <= k)
              return H === k ? P : F + (k - B) * (P - F) / (H - B);
            F = P, B = H;
          }
          return null;
        }
        function d(A, U, k, F, B) {
          var R = D.isZero;
          if (R(F) && R(B)) {
            var C = Ue.getTimeOf(A, new M(U, k));
            return C === null ? [] : [C];
          }
          for (var P = Math.atan2(-B, F), H = Math.sin(P), W = Math.cos(P), V = [], Q = [], ae = 0; ae < 8; ae += 2) {
            var le = A[ae] - U, fe = A[ae + 1] - k;
            V.push(
              le * W - fe * H,
              le * H + fe * W
            );
          }
          return Ue.solveCubic(V, 1, 0, Q, 0, 1), Q;
        }
        function m(A, U, k, F, B, R, C) {
          for (var P = U[0], H = U[1], W = U[6], V = U[7], Q = d(A, P, H, W - P, V - H), ae = 0, le = Q.length; ae < le; ae++) {
            var fe = Q[ae], se = Ue.getPoint(A, fe), ge = Ue.getTimeOf(U, se);
            ge !== null && i(
              B,
              R,
              C ? F : k,
              C ? ge : fe,
              C ? k : F,
              C ? fe : ge
            );
          }
        }
        function _(A, U, k, F, B, R) {
          var C = he.intersect(
            A[0],
            A[1],
            A[6],
            A[7],
            U[0],
            U[1],
            U[6],
            U[7]
          );
          C && i(
            B,
            R,
            k,
            Ue.getTimeOf(A, C),
            F,
            Ue.getTimeOf(U, C)
          );
        }
        function b(A, U, k, F, B, R) {
          var C = 1e-12, P = Math.min, H = Math.max;
          if (H(A[0], A[2], A[4], A[6]) + C > P(U[0], U[2], U[4], U[6]) && P(A[0], A[2], A[4], A[6]) - C < H(U[0], U[2], U[4], U[6]) && H(A[1], A[3], A[5], A[7]) + C > P(U[1], U[3], U[5], U[7]) && P(A[1], A[3], A[5], A[7]) - C < H(U[1], U[3], U[5], U[7])) {
            var W = E(A, U);
            if (W)
              for (var V = 0; V < 2; V++) {
                var Q = W[V];
                i(
                  B,
                  R,
                  k,
                  Q[0],
                  F,
                  Q[1],
                  !0
                );
              }
            else {
              var ae = Ue.isStraight(A), le = Ue.isStraight(U), fe = ae && le, se = ae && !le, ge = B.length;
              if ((fe ? _ : ae || le ? m : n)(
                se ? U : A,
                se ? A : U,
                se ? F : k,
                se ? k : F,
                B,
                R,
                se,
                0,
                0,
                0,
                1,
                0,
                1
              ), !fe || B.length === ge)
                for (var V = 0; V < 4; V++) {
                  var me = V >> 1, we = V & 1, Se = me * 6, Ae = we * 6, Ge = new M(A[Se], A[Se + 1]), Je = new M(U[Ae], U[Ae + 1]);
                  Ge.isClose(Je, C) && i(
                    B,
                    R,
                    k,
                    me,
                    F,
                    we
                  );
                }
            }
          }
          return B;
        }
        function x(A, U, k, F) {
          var B = Ue.classify(A);
          if (B.type === "loop") {
            var R = B.roots;
            i(
              k,
              F,
              U,
              R[0],
              U,
              R[1]
            );
          }
          return k;
        }
        function T(A, U, k, F, B, R) {
          var C = 1e-7, P = !U;
          P && (U = A);
          for (var H = A.length, W = U.length, V = new Array(H), Q = P ? V : new Array(W), ae = [], le = 0; le < H; le++)
            V[le] = A[le].getValues(F);
          if (!P)
            for (var le = 0; le < W; le++)
              Q[le] = U[le].getValues(B);
          for (var fe = S.findCurveBoundsCollisions(
            V,
            Q,
            C
          ), se = 0; se < H; se++) {
            var ge = A[se], me = V[se];
            P && x(me, ge, ae, k);
            var we = fe[se];
            if (we)
              for (var Se = 0; Se < we.length; Se++) {
                if (R && ae.length)
                  return ae;
                var Ae = we[Se];
                if (!P || Ae > se) {
                  var Ge = U[Ae], Je = Q[Ae];
                  b(
                    me,
                    Je,
                    ge,
                    Ge,
                    ae,
                    k
                  );
                }
              }
          }
          return ae;
        }
        function E(A, U) {
          function k(nt) {
            var _t = nt[6] - nt[0], mt = nt[7] - nt[1];
            return _t * _t + mt * mt;
          }
          var F = Math.abs, B = he.getDistance, R = 1e-8, C = 1e-7, P = Ue.isStraight(A), H = Ue.isStraight(U), W = P && H, V = k(A) < k(U), Q = V ? U : A, ae = V ? A : U, le = Q[0], fe = Q[1], se = Q[6] - le, ge = Q[7] - fe;
          if (B(le, fe, se, ge, ae[0], ae[1], !0) < C && B(le, fe, se, ge, ae[6], ae[7], !0) < C)
            !W && B(le, fe, se, ge, Q[2], Q[3], !0) < C && B(le, fe, se, ge, Q[4], Q[5], !0) < C && B(le, fe, se, ge, ae[2], ae[3], !0) < C && B(le, fe, se, ge, ae[4], ae[5], !0) < C && (P = H = W = !0);
          else if (W)
            return null;
          if (P ^ H)
            return null;
          for (var me = [A, U], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
            var Ae = Se & 1, Ge = Ae ^ 1, Je = Se >> 1, tt = Ue.getTimeOf(me[Ae], new M(
              me[Ge][Je ? 6 : 0],
              me[Ge][Je ? 7 : 1]
            ));
            if (tt != null) {
              var ft = Ae ? [Je, tt] : [tt, Je];
              (!we.length || F(ft[0] - we[0][0]) > R && F(ft[1] - we[0][1]) > R) && we.push(ft);
            }
            if (Se > 2 && !we.length)
              break;
          }
          if (we.length !== 2)
            we = null;
          else if (!W) {
            var Ne = Ue.getPart(A, we[0][0], we[1][0]), ze = Ue.getPart(U, we[0][1], we[1][1]);
            (F(ze[2] - Ne[2]) > C || F(ze[3] - Ne[3]) > C || F(ze[4] - Ne[4]) > C || F(ze[5] - Ne[5]) > C) && (we = null);
          }
          return we;
        }
        function L(A, U) {
          var k = A[0], F = A[1], B = A[2], R = A[3], C = A[4], P = A[5], H = A[6], W = A[7], V = U.normalize(), Q = V.x, ae = V.y, le = 3 * H - 9 * C + 9 * B - 3 * k, fe = 3 * W - 9 * P + 9 * R - 3 * F, se = 6 * C - 12 * B + 6 * k, ge = 6 * P - 12 * R + 6 * F, me = 3 * B - 3 * k, we = 3 * R - 3 * F, Se = 2 * le * ae - 2 * fe * Q, Ae = [];
          if (Math.abs(Se) < D.CURVETIME_EPSILON) {
            var Ge = le * we - fe * me, Se = le * ge - fe * se;
            if (Se != 0) {
              var Je = -Ge / Se;
              Je >= 0 && Je <= 1 && Ae.push(Je);
            }
          } else {
            var tt = (se * se - 4 * le * me) * ae * ae + (-2 * se * ge + 4 * fe * me + 4 * le * we) * Q * ae + (ge * ge - 4 * fe * we) * Q * Q, ft = se * ae - ge * Q;
            if (tt >= 0 && Se != 0) {
              var Ne = Math.sqrt(tt), ze = -(ft + Ne) / Se, nt = (-ft + Ne) / Se;
              ze >= 0 && ze <= 1 && Ae.push(ze), nt >= 0 && nt <= 1 && Ae.push(nt);
            }
          }
          return Ae;
        }
        return {
          getIntersections: function(A) {
            var U = this.getValues(), k = A && A !== this && A.getValues();
            return k ? b(U, k, this, A, []) : x(U, this, []);
          },
          statics: {
            getOverlaps: E,
            getIntersections: T,
            getCurveLineIntersections: d,
            getTimesWithTangent: L
          }
        };
      }()
    ), ot = a.extend(
      {
        _class: "CurveLocation",
        initialize: function(i, n, s, l, h) {
          if (n >= 0.99999999) {
            var d = i.getNext();
            d && (n = 0, i = d);
          }
          this._setCurve(i), this._time = n, this._point = s || i.getPointAtTime(n), this._overlap = l, this._distance = h, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var n = i.getCurve();
          n ? this._setCurve(n) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var n = this.getCurve(), s = this.getTime();
            s === 0 ? i = n._segment1 : s === 1 ? i = n._segment2 : s != null && (i = n.getPartLength(0, s) < n.getPartLength(s, 1) ? n._segment1 : n._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, n = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function s(l) {
            var h = l && l.getCurve();
            if (h && (n._time = h.getTimeOf(n._point)) != null)
              return n._setCurve(h), h;
          }
          return this._curve || s(this._segment) || s(this._segment1) || s(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), n = this._time;
          return i && n == null ? this._time = i.getTimeOf(this._point) : n;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var n = this.getPath(), s = this.getIndex();
            if (n && s != null)
              for (var l = n.getCurves(), h = 0; h < s; h++)
                i += l[h].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var n = this.getCurve(), s = this.getTime();
            this._curveOffset = i = s != null && n && n.getPartLength(0, s);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), n = i && i.divideAtTime(this.getTime());
          return n && this._setSegment(n._segment1), n;
        },
        split: function() {
          var i = this.getCurve(), n = i._path, s = i && i.splitAtTime(this.getTime());
          return s && this._setSegment(n.getLastSegment()), s;
        },
        equals: function(i, n) {
          var s = this === i;
          if (!s && i instanceof ot) {
            var l = this.getCurve(), h = i.getCurve(), d = l._path, m = h._path;
            if (d === m) {
              var _ = Math.abs, b = 1e-7, x = _(this.getOffset() - i.getOffset()), T = !n && this._intersection, E = !n && i._intersection;
              s = (x < b || d && _(d.getLength() - x) < b) && (!T && !E || T && E && T.equals(E, !0));
            }
          }
          return s;
        },
        toString: function() {
          var i = [], n = this.getPoint(), s = I.instance;
          n && i.push("point: " + n);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var h = this.getTime();
          return h != null && i.push("time: " + s.number(h)), this._distance != null && i.push("distance: " + s.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var n = this.getCurve(), s = i.getCurve();
            return !(n.isStraight() && s.isStraight() && n.getLine().intersect(s.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var n = this.getTime(), s = i.getTime(), l = 1e-8, h = 1 - l, d = n >= l && n <= h, m = s >= l && s <= h;
          if (d && m)
            return !this.isTouching();
          var _ = this.getCurve(), b = _ && n < l ? _.getPrevious() : _, x = i.getCurve(), T = x && s < l ? x.getPrevious() : x;
          if (n > h && (_ = _.getNext()), s > h && (x = x.getNext()), !b || !_ || !T || !x)
            return !1;
          var E = [];
          function L(Q, ae) {
            var le = Q.getValues(), fe = Ue.classify(le).roots || Ue.getPeaks(le), se = fe.length, ge = Ue.getLength(
              le,
              ae && se ? fe[se - 1] : 0,
              !ae && se ? fe[0] : 1
            );
            E.push(se ? ge : ge / 32);
          }
          function A(Q, ae, le) {
            return ae < le ? Q > ae && Q < le : Q > ae || Q < le;
          }
          d || (L(b, !0), L(_, !1)), m || (L(T, !0), L(x, !1));
          var U = this.getPoint(), k = Math.min.apply(Math, E), F = d ? _.getTangentAtTime(n) : _.getPointAt(k).subtract(U), B = d ? F.negate() : b.getPointAt(-k).subtract(U), R = m ? x.getTangentAtTime(s) : x.getPointAt(k).subtract(U), C = m ? R.negate() : T.getPointAt(-k).subtract(U), P = B.getAngle(), H = F.getAngle(), W = C.getAngle(), V = R.getAngle();
          return !!(d ? A(P, W, V) ^ A(H, W, V) && A(P, V, W) ^ A(H, V, W) : A(W, P, H) ^ A(V, P, H) && A(W, H, P) ^ A(V, H, P));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      a.each(Ue._evaluateMethods, function(i) {
        var n = i + "At";
        this[i] = function() {
          var s = this.getCurve(), l = this.getTime();
          return l != null && s && s[n](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(n, s, l) {
          var h = n.length, d = 0, m = h - 1;
          function _(U, k) {
            for (var F = U + k; F >= -1 && F <= h; F += k) {
              var B = n[(F % h + h) % h];
              if (!s.getPoint().isClose(
                B.getPoint(),
                1e-7
              ))
                break;
              if (s.equals(B))
                return B;
            }
            return null;
          }
          for (; d <= m; ) {
            var b = d + m >>> 1, x = n[b], T;
            if (l && (T = s.equals(x) ? x : _(b, -1) || _(b, 1)))
              return s._overlap && (T._overlap = T._intersection._overlap = !0), T;
            var E = s.getPath(), L = x.getPath(), A = E !== L ? E._id - L._id : s.getIndex() + s.getTime() - (x.getIndex() + x.getTime());
            A < 0 ? m = b - 1 : d = b + 1;
          }
          return n.splice(d, 0, s), s;
        }
        return { statics: {
          insert: i,
          expand: function(n) {
            for (var s = n.slice(), l = n.length - 1; l >= 0; l--)
              i(s, n[l]._intersection, !1);
            return s;
          }
        } };
      }()
    ), Gt = K.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var n, s, l;
          if (a.isPlainObject(i) ? (s = i.segments, n = i.pathData) : Array.isArray(i) ? s = i : typeof i == "string" && (n = i), s) {
            var h = s[0];
            l = h && Array.isArray(h[0]);
          } else
            n && (l = (n.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(n));
          var d = l ? Zt : it;
          return new d(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var n = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), s, l = !1, h, d, m = new M(), _ = new M();
        function b(C, P) {
          var H = +s[C];
          return l && (H += m[P]), H;
        }
        function x(C) {
          return new M(
            b(C, "x"),
            b(C + 1, "y")
          );
        }
        this.clear();
        for (var T = 0, E = n && n.length; T < E; T++) {
          var L = n[T], A = L[0], U = A.toLowerCase();
          s = L.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var k = s && s.length;
          switch (l = A === U, h === "z" && !/[mz]/.test(U) && this.moveTo(m), U) {
            case "m":
            case "l":
              for (var F = U === "m", B = 0; B < k; B += 2)
                this[F ? "moveTo" : "lineTo"](m = x(B)), F && (_ = m, F = !1);
              d = m;
              break;
            case "h":
            case "v":
              var R = U === "h" ? "x" : "y";
              m = m.clone();
              for (var B = 0; B < k; B++)
                m[R] = b(B, R), this.lineTo(m);
              d = m;
              break;
            case "c":
              for (var B = 0; B < k; B += 6)
                this.cubicCurveTo(
                  x(B),
                  d = x(B + 2),
                  m = x(B + 4)
                );
              break;
            case "s":
              for (var B = 0; B < k; B += 4)
                this.cubicCurveTo(
                  /[cs]/.test(h) ? m.multiply(2).subtract(d) : m,
                  d = x(B),
                  m = x(B + 2)
                ), h = U;
              break;
            case "q":
              for (var B = 0; B < k; B += 4)
                this.quadraticCurveTo(
                  d = x(B),
                  m = x(B + 2)
                );
              break;
            case "t":
              for (var B = 0; B < k; B += 2)
                this.quadraticCurveTo(
                  d = /[qt]/.test(h) ? m.multiply(2).subtract(d) : m,
                  m = x(B)
                ), h = U;
              break;
            case "a":
              for (var B = 0; B < k; B += 7)
                this.arcTo(
                  m = x(B + 5),
                  new Y(+s[B], +s[B + 1]),
                  +s[B + 2],
                  +s[B + 4],
                  +s[B + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), m = _;
              break;
          }
          h = U;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var n = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return n.onPath || !!(this.getFillRule() === "evenodd" ? n.windingL & 1 || n.windingR & 1 : n.winding);
      },
      getIntersections: function(i, n, s, l) {
        var h = this === i || !i, d = this._matrix._orNullIfIdentity(), m = h ? d : (s || i._matrix)._orNullIfIdentity();
        return h || this.getBounds(d).intersects(
          i.getBounds(m),
          1e-12
        ) ? Ue.getIntersections(
          this.getCurves(),
          !h && i.getCurves(),
          n,
          d,
          m,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(n) {
          return n.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = M.read(arguments), n = this.getCurves(), s = 1 / 0, l = null, h = 0, d = n.length; h < d; h++) {
          var m = n[h].getNearestLocation(i);
          m._distance < s && (s = m._distance, l = m);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, n, s) {
        var l = !this._children, h = l ? "_segments" : "_children", d = i[h], m = n[h], _ = this[h];
        if (!d || !m || d.length !== m.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + n);
        var b = _.length, x = m.length;
        if (b < x)
          for (var T = l ? ue : it, E = b; E < x; E++)
            this.add(new T());
        else
          b > x && this[l ? "removeSegments" : "removeChildren"](x, b);
        for (var E = 0; E < x; E++)
          _[E].interpolate(d[E], m[E], s);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var n = !1;
        if (i) {
          var s = this._children || [this], l = i._children ? i._children.slice() : [i], h = s.length, d = l.length, m = [], _ = 0;
          n = !0;
          for (var b = S.findItemBoundsCollisions(s, l, D.GEOMETRIC_EPSILON), x = h - 1; x >= 0 && n; x--) {
            var T = s[x];
            n = !1;
            var E = b[x];
            if (E)
              for (var L = E.length - 1; L >= 0 && !n; L--)
                T.compare(l[E[L]]) && (m[E[L]] || (m[E[L]] = !0, _++), n = !0);
          }
          n = n && _ === d;
        }
        return n;
      }
    }), it = Gt.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(i) {
          this._closed = !1, this._segments = [], this._version = 0;
          var n = arguments, s = Array.isArray(i) ? typeof i[0] == "object" ? i : n : i && i.size === t && (i.x !== t || i.point !== t) ? n : null;
          s && s.length > 0 ? this.setSegments(s) : (this._curves = t, this._segmentSelection = 0, !s && typeof i == "string" && (this.setPathData(i), i = null)), this._initialize(!s && i);
        },
        _equals: function(i) {
          return this._closed === i._closed && a.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(n) {
          if (i.base.call(this, n), n & 8) {
            if (this._length = this._area = t, n & 32)
              this._version++;
            else if (this._curves)
              for (var s = 0, l = this._curves.length; s < l; s++)
                this._curves[s]._changed();
          } else
            n & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof Zt ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var n = this.isFullySelected(), s = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, s) {
            var l = i[s - 1];
            typeof l == "boolean" && (this.setClosed(l), s--), this._add(ue.readList(i, 0, {}, s));
          }
          n && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, n = this._segments;
          if (!i) {
            var s = this._countCurves();
            i = this._curves = new Array(s);
            for (var l = 0; l < s; l++)
              i[l] = new Ue(
                this,
                n[l],
                n[l + 1] || n[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var n = this._curves.length = this._countCurves();
              i && (this._curves[n - 1] = new Ue(
                this,
                this._segments[n - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, n) {
          var s = this._segments, l = s.length, h = new I(n), d = new Array(6), m = !0, _, b, x, T, E, L, A, U, k = [];
          function F(R, C) {
            if (R._transformCoordinates(i, d), _ = d[0], b = d[1], m)
              k.push("M" + h.pair(_, b)), m = !1;
            else if (E = d[2], L = d[3], E === _ && L === b && A === x && U === T) {
              if (!C) {
                var P = _ - x, H = b - T;
                k.push(
                  P === 0 ? "v" + h.number(H) : H === 0 ? "h" + h.number(P) : "l" + h.pair(P, H)
                );
              }
            } else
              k.push("c" + h.pair(A - x, U - T) + " " + h.pair(E - x, L - T) + " " + h.pair(_ - x, b - T));
            x = _, T = b, A = d[4], U = d[5];
          }
          if (!l)
            return "";
          for (var B = 0; B < l; B++)
            F(s[B]);
          return this._closed && l > 0 && (F(s[0], !0), k.push("z")), k.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var n = this._segments, s = new Array(6), l = 0, h = n.length; l < h; l++)
            n[l]._transformCoordinates(i, s, !0);
          return !0;
        },
        _add: function(i, n) {
          for (var s = this._segments, l = this._curves, h = i.length, d = n == null, n = d ? s.length : n, m = 0; m < h; m++) {
            var _ = i[m];
            _._path && (_ = i[m] = _.clone()), _._path = this, _._index = n + m, _._selection && this._updateSelection(_, 0, _._selection);
          }
          if (d)
            a.push(s, i);
          else {
            s.splice.apply(s, [n, 0].concat(i));
            for (var m = n + h, b = s.length; m < b; m++)
              s[m]._index = m;
          }
          if (l) {
            var x = this._countCurves(), T = n > 0 && n + h - 1 === x ? n - 1 : n, E = T, L = Math.min(T + h, x);
            i._curves && (l.splice.apply(l, [T, 0].concat(i._curves)), E += i._curves.length);
            for (var m = E; m < L; m++)
              l.splice(m, 0, new Ue(this, null, null));
            this._adjustCurves(T, L);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, n) {
          for (var s = this._segments, l = this._curves, h, d = i; d < n; d++)
            h = l[d], h._path = this, h._segment1 = s[d], h._segment2 = s[d + 1] || s[0], h._changed();
          (h = l[this._closed && !i ? s.length - 1 : i - 1]) && (h._segment2 = s[i] || s[0], h._changed()), (h = l[n]) && (h._segment1 = s[n], h._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var n = arguments;
          return n.length > 1 && typeof i != "number" ? this._add(ue.readList(n)) : this._add([ue.read(n)])[0];
        },
        insert: function(i, n) {
          var s = arguments;
          return s.length > 2 && typeof n != "number" ? this._add(ue.readList(s, 1), i) : this._add([ue.read(s, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([ue.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([ue.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(ue.readList(i));
        },
        insertSegments: function(i, n) {
          return this._add(ue.readList(n), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, n, s) {
          i = i || 0, n = a.pick(n, this._segments.length);
          var l = this._segments, h = this._curves, d = l.length, m = l.splice(i, n - i), _ = m.length;
          if (!_)
            return m;
          for (var b = 0; b < _; b++) {
            var x = m[b];
            x._selection && this._updateSelection(x, x._selection, 0), x._index = x._path = null;
          }
          for (var b = i, T = l.length; b < T; b++)
            l[b]._index = b;
          if (h) {
            for (var E = i > 0 && n === d + (this._closed ? 1 : 0) ? i - 1 : i, h = h.splice(E, _), b = h.length - 1; b >= 0; b--)
              h[b]._path = null;
            s && (m._curves = h.slice(1)), this._adjustCurves(E, E);
          }
          return this._changed(41), m;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, n = 0, s = i.length; n < s; n++)
            if (i[n].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, n = 0, s = i.length; n < s; n++)
            i[n].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), n = 0, s = 0, l = i.length; s < l; s++)
              n += i[s].getLength();
            this._length = n;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var n = this._segments, s = this._closed;
            i = 0;
            for (var l = 0, h = n.length; l < h; l++) {
              var d = l + 1 === h;
              i += Ue.getArea(Ue.getValues(
                n[l],
                n[d ? 0 : l + 1],
                null,
                d && !s
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(n) {
          n & 1 || this._selectSegments(!1), i.base.call(this, n);
        },
        _selectSegments: function(i) {
          var n = this._segments, s = n.length, l = i ? 7 : 0;
          this._segmentSelection = l * s;
          for (var h = 0; h < s; h++)
            n[h]._selection = l;
        },
        _updateSelection: function(i, n, s) {
          i._selection = s;
          var l = this._segmentSelection += s - n;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var n = this.getLocationAt(i), s;
          return n && (s = n.getCurve().divideAt(n.getCurveOffset())) ? s._segment1 : null;
        },
        splitAt: function(i) {
          var n = this.getLocationAt(i), s = n && n.index, l = n && n.time, h = 1e-8, d = 1 - h;
          l > d && (s++, l = 0);
          var m = this.getCurves();
          if (s >= 0 && s < m.length) {
            l >= h && m[s++].divideAtTime(l);
            var _ = this.removeSegments(s, this._segments.length, !0), b;
            return this._closed ? (this.setClosed(!1), b = this) : (b = new it(K.NO_INSERT), b.insertAbove(this), b.copyAttributes(this)), b._add(_, 0), this.addSegment(_[0]), b;
          }
          return null;
        },
        split: function(i, n) {
          var s, l = n === t ? i : (s = this.getCurves()[i]) && s.getLocationAtTime(n);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, n) {
          var s = n || 0;
          if (i && i !== this) {
            var l = i._segments, h = this.getLastSegment(), d = i.getLastSegment();
            if (!d)
              return this;
            h && h._point.isClose(d._point, s) && i.reverse();
            var m = i.getFirstSegment();
            if (h && h._point.isClose(m._point, s))
              h.setHandleOut(m._handleOut), this._add(l.slice(1));
            else {
              var _ = this.getFirstSegment();
              _ && _._point.isClose(m._point, s) && i.reverse(), d = i.getLastSegment(), _ && _._point.isClose(d._point, s) ? (_.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var b = this.getFirstSegment(), x = this.getLastSegment();
          return b !== x && b._point.isClose(x._point, s) && (b.setHandleIn(x._handleIn), x.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var n = this.getCurves(), s = i && i.simplify, l = s ? 1e-7 : 0, h = n.length - 1; h >= 0; h--) {
            var d = n[h];
            !d.hasHandles() && (!d.hasLength(l) || s && d.isCollinear(d.getNext())) && d.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, n = this._segments.length; i < n; i++) {
            var s = this._segments[i], l = s._handleIn;
            s._handleIn = s._handleOut, s._handleOut = l, s._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var n = new ct(this, i || 0.25, 256, !0), s = n.parts, l = s.length, h = [], d = 0; d < l; d++)
            h.push(new ue(s[d].curve.slice(0, 2)));
          !this._closed && l > 0 && h.push(new ue(s[l - 1].curve.slice(6))), this.setSegments(h);
        },
        simplify: function(i) {
          var n = new lt(this).fit(i || 2.5);
          return n && this.setSegments(n), !!n;
        },
        smooth: function(i) {
          var n = this, s = i || {}, l = s.type || "asymmetric", h = this._segments, d = h.length, m = this._closed;
          function _(mt, Pt) {
            var Et = mt && mt.index;
            if (Et != null) {
              var zt = mt.path;
              if (zt && zt !== n)
                throw new Error(mt._class + " " + Et + " of " + zt + " is not part of " + n);
              Pt && mt instanceof Ue && Et++;
            } else
              Et = typeof mt == "number" ? mt : Pt;
            return Math.min(Et < 0 && m ? Et % d : Et < 0 ? Et + d : Et, d - 1);
          }
          var b = m && s.from === t && s.to === t, x = _(s.from, 0), T = _(s.to, d - 1);
          if (x > T)
            if (m)
              x -= d;
            else {
              var E = x;
              x = T, T = E;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var L = l === "asymmetric", A = Math.min, U = T - x + 1, k = U - 1, F = b ? A(U, 4) : 1, B = F, R = F, C = [];
            if (m || (B = A(1, x), R = A(1, d - T - 1)), k += B + R, k <= 1)
              return;
            for (var P = 0, H = x - B; P <= k; P++, H++)
              C[P] = h[(H < 0 ? H + d : H) % d]._point;
            for (var W = C[0]._x + 2 * C[1]._x, V = C[0]._y + 2 * C[1]._y, Q = 2, ae = k - 1, le = [W], fe = [V], se = [Q], ge = [], me = [], P = 1; P < k; P++) {
              var we = P < ae, Se = we || L ? 1 : 2, Ae = we ? 4 : L ? 2 : 7, Ge = we ? 4 : L ? 3 : 8, Je = we ? 2 : L ? 0 : 1, tt = Se / Q;
              Q = se[P] = Ae - tt, W = le[P] = Ge * C[P]._x + Je * C[P + 1]._x - tt * W, V = fe[P] = Ge * C[P]._y + Je * C[P + 1]._y - tt * V;
            }
            ge[ae] = le[ae] / se[ae], me[ae] = fe[ae] / se[ae];
            for (var P = k - 2; P >= 0; P--)
              ge[P] = (le[P] - ge[P + 1]) / se[P], me[P] = (fe[P] - me[P + 1]) / se[P];
            ge[k] = (3 * C[k]._x - ge[ae]) / 2, me[k] = (3 * C[k]._y - me[ae]) / 2;
            for (var P = B, ft = k - R, H = x; P <= ft; P++, H++) {
              var Ne = h[H < 0 ? H + d : H], ze = Ne._point, nt = ge[P] - ze._x, _t = me[P] - ze._y;
              (b || P < ft) && Ne.setHandleOut(nt, _t), (b || P > B) && Ne.setHandleIn(-nt, -_t);
            }
          } else
            for (var P = x; P <= T; P++)
              h[P < 0 ? P + d : P].smooth(
                s,
                !b && P === x,
                !b && P === T
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var n = this._segments, s, l, h, d;
          function m(L, A) {
            var U = n[L], k = U.getNext(), F = n[A], B = F.getNext();
            return U._handleOut.isZero() && k._handleIn.isZero() && F._handleOut.isZero() && B._handleIn.isZero() && k._point.subtract(U._point).isCollinear(
              B._point.subtract(F._point)
            );
          }
          function _(L) {
            var A = n[L], U = A.getPrevious(), k = A.getNext();
            return U._handleOut.isZero() && A._handleIn.isZero() && A._handleOut.isZero() && k._handleIn.isZero() && A._point.subtract(U._point).isOrthogonal(
              k._point.subtract(A._point)
            );
          }
          function b(L) {
            var A = n[L], U = A.getNext(), k = A._handleOut, F = U._handleIn, B = 0.5522847498307936;
            if (k.isOrthogonal(F)) {
              var R = A._point, C = U._point, P = new he(R, k, !0).intersect(
                new he(C, F, !0),
                !0
              );
              return P && D.isZero(k.getLength() / P.subtract(R).getLength() - B) && D.isZero(F.getLength() / P.subtract(C).getLength() - B);
            }
            return !1;
          }
          function x(L, A) {
            return n[L]._point.getDistance(n[A]._point);
          }
          if (!this.hasHandles() && n.length === 4 && m(0, 2) && m(1, 3) && _(1) ? (s = ke.Rectangle, l = new Y(x(0, 3), x(0, 1)), d = n[1]._point.add(n[2]._point).divide(2)) : n.length === 8 && b(0) && b(2) && b(4) && b(6) && m(1, 5) && m(3, 7) ? (s = ke.Rectangle, l = new Y(x(1, 6), x(0, 3)), h = l.subtract(new Y(
            x(0, 7),
            x(1, 2)
          )).divide(2), d = n[3]._point.add(n[4]._point).divide(2)) : n.length === 4 && b(0) && b(1) && b(2) && b(3) && (D.isZero(x(0, 2) - x(1, 3)) ? (s = ke.Circle, h = x(0, 2) / 2) : (s = ke.Ellipse, h = new Y(x(2, 0) / 2, x(3, 1) / 2)), d = n[1]._point), s) {
            var T = this.getPosition(!0), E = new s({
              center: T,
              size: l,
              radius: h,
              insert: !1
            });
            return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(T).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(n) {
          if (!n || n instanceof Zt)
            return i.base.call(this, n);
          var s = this.getCurves(), l = n.getCurves(), h = s.length, d = l.length;
          if (!h || !d)
            return h == d;
          for (var m = s[0].getValues(), _ = [], b = 0, x, T = 0, E, L = 0; L < d; L++) {
            var A = l[L].getValues();
            _.push(A);
            var U = Ue.getOverlaps(m, A);
            if (U) {
              x = !L && U[0][0] > 0 ? d - 1 : L, E = U[0][1];
              break;
            }
          }
          for (var k = Math.abs, F = 1e-8, A = _[x], B; m && A; ) {
            var U = Ue.getOverlaps(m, A);
            if (U) {
              var R = U[0][0];
              if (k(R - T) < F) {
                T = U[1][0], T === 1 && (m = ++b < h ? s[b].getValues() : null, T = 0);
                var C = U[0][1];
                if (k(C - E) < F) {
                  if (B || (B = [x, C]), E = U[1][1], E === 1 && (++x >= d && (x = 0), A = _[x] || l[x].getValues(), E = 0), !m)
                    return B[0] === x && B[1] === E;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, n, s, l) {
          var h = this, d = this.getStyle(), m = this._segments, _ = m.length, b = this._closed, x = n._tolerancePadding, T = x, E, L, A, U, k, F, B = n.stroke && d.hasStroke(), R = n.fill && d.hasFill(), C = n.curves, P = B ? d.getStrokeWidth() / 2 : R && n.tolerance > 0 || C ? 0 : null;
          P !== null && (P > 0 ? (E = d.getStrokeJoin(), L = d.getStrokeCap(), A = d.getMiterLimit(), T = T.add(
            it._getStrokePadding(P, l)
          )) : E = L = "round");
          function H(ge, me) {
            return i.subtract(ge).divide(me).length <= 1;
          }
          function W(ge, me, we) {
            if (!n.selected || me.isSelected()) {
              var Se = ge._point;
              if (me !== Se && (me = me.add(Se)), H(me, T))
                return new Xe(we, h, {
                  segment: ge,
                  point: me
                });
            }
          }
          function V(ge, me) {
            return (me || n.segments) && W(ge, ge._point, "segment") || !me && n.handles && (W(ge, ge._handleIn, "handle-in") || W(ge, ge._handleOut, "handle-out"));
          }
          function Q(ge) {
            U.add(ge);
          }
          function ae(ge) {
            var me = b || ge._index > 0 && ge._index < _ - 1;
            if ((me ? E : L) === "round")
              return H(ge._point, T);
            if (U = new it({ internal: !0, closed: !0 }), me ? ge.isSmooth() || it._addBevelJoin(
              ge,
              E,
              P,
              A,
              null,
              l,
              Q,
              !0
            ) : L === "square" && it._addSquareCap(
              ge,
              L,
              P,
              null,
              l,
              Q,
              !0
            ), !U.isEmpty()) {
              var we;
              return U.contains(i) || (we = U.getNearestLocation(i)) && H(we.getPoint(), x);
            }
          }
          if (n.ends && !n.segments && !b) {
            if (F = V(m[0], !0) || V(m[_ - 1], !0))
              return F;
          } else if (n.segments || n.handles) {
            for (var le = 0; le < _; le++)
              if (F = V(m[le]))
                return F;
          }
          if (P !== null) {
            if (k = this.getNearestLocation(i), k) {
              var fe = k.getTime();
              fe === 0 || fe === 1 && _ > 1 ? ae(k.getSegment()) || (k = null) : H(k.getPoint(), T) || (k = null);
            }
            if (!k && E === "miter" && _ > 1)
              for (var le = 0; le < _; le++) {
                var se = m[le];
                if (i.getDistance(se._point) <= A * P && ae(se)) {
                  k = se.getLocation();
                  break;
                }
              }
          }
          return !k && R && this._contains(i) || k && !B && !C ? new Xe("fill", this) : k ? new Xe(B ? "stroke" : "curve", this, {
            location: k,
            point: k.getPoint()
          }) : null;
        }
      },
      a.each(
        Ue._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var s = this.getLocationAt(n);
            return s && s[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = M.read(arguments), n = this.getCurves(), s = 0, l = n.length; s < l; s++) {
              var h = n[s].getLocationOf(i);
              if (h)
                return h;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var n = this.getCurves(), s = 0, l = 0, h = n.length; l < h; l++) {
                var d = s, m = n[l];
                if (s += m.getLength(), s > i)
                  return m.getLocationAt(i - d);
              }
              if (n.length > 0 && i <= this.getLength())
                return new ot(n[n.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = M.read(arguments);
            if (i.isZero())
              return [];
            for (var n = [], s = 0, l = this.getCurves(), h = 0, d = l.length; h < d; h++) {
              for (var m = l[h], _ = m.getTimesWithTangent(i), b = 0, x = _.length; b < x; b++) {
                var T = s + m.getOffsetAtTime(_[b]);
                n.indexOf(T) < 0 && n.push(T);
              }
              s += m.length;
            }
            return n;
          }
        }
      ),
      new function() {
        function i(s, l, h, d) {
          if (d <= 0)
            return;
          var m = d / 2, _ = d - 2, b = m - 1, x = new Array(6), T, E;
          function L(R) {
            var C = x[R], P = x[R + 1];
            (T != C || E != P) && (s.beginPath(), s.moveTo(T, E), s.lineTo(C, P), s.stroke(), s.beginPath(), s.arc(C, P, m, 0, Math.PI * 2, !0), s.fill());
          }
          for (var A = 0, U = l.length; A < U; A++) {
            var k = l[A], F = k._selection;
            if (k._transformCoordinates(h, x), T = x[0], E = x[1], F & 2 && L(2), F & 4 && L(4), s.fillRect(T - m, E - m, d, d), _ > 0 && !(F & 1)) {
              var B = s.fillStyle;
              s.fillStyle = "#ffffff", s.fillRect(T - b, E - b, _, _), s.fillStyle = B;
            }
          }
        }
        function n(s, l, h) {
          var d = l._segments, m = d.length, _ = new Array(6), b = !0, x, T, E, L, A, U, k, F;
          function B(C) {
            if (h)
              C._transformCoordinates(h, _), x = _[0], T = _[1];
            else {
              var P = C._point;
              x = P._x, T = P._y;
            }
            if (b)
              s.moveTo(x, T), b = !1;
            else {
              if (h)
                A = _[2], U = _[3];
              else {
                var H = C._handleIn;
                A = x + H._x, U = T + H._y;
              }
              A === x && U === T && k === E && F === L ? s.lineTo(x, T) : s.bezierCurveTo(k, F, A, U, x, T);
            }
            if (E = x, L = T, h)
              k = _[4], F = _[5];
            else {
              var H = C._handleOut;
              k = E + H._x, F = L + H._y;
            }
          }
          for (var R = 0; R < m; R++)
            B(d[R]);
          l._closed && m > 0 && B(d[0]);
        }
        return {
          _draw: function(s, l, h, d) {
            var m = l.dontStart, _ = l.dontFinish || l.clip, b = this.getStyle(), x = b.hasFill(), T = b.hasStroke(), E = b.getDashArray(), L = !He.support.nativeDash && T && E && E.length;
            m || s.beginPath(), (x || T && !L || _) && (n(s, this, d), this._closed && s.closePath());
            function A(C) {
              return E[(C % L + L) % L];
            }
            if (!_ && (x || T) && (this._setStyles(s, l, h), x && (s.fill(b.getFillRule()), s.shadowColor = "rgba(0,0,0,0)"), T)) {
              if (L) {
                m || s.beginPath();
                for (var U = new ct(
                  this,
                  0.25,
                  32,
                  !1,
                  d
                ), k = U.length, F = -b.getDashOffset(), B, R = 0; F > 0; )
                  F -= A(R--) + A(R--);
                for (; F < k; )
                  B = F + A(R++), (F > 0 || B > 0) && U.drawPart(
                    s,
                    Math.max(F, 0),
                    Math.max(B, 0)
                  ), F = B + A(R++);
              }
              s.stroke();
            }
          },
          _drawSelected: function(s, l) {
            s.beginPath(), n(s, this, l), s.stroke(), i(s, this._segments, l, He.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(n) {
          var s = n._segments;
          if (!s.length)
            throw new Error("Use a moveTo() command first");
          return s[s.length - 1];
        }
        return {
          moveTo: function() {
            var n = this._segments;
            n.length === 1 && this.removeSegment(0), n.length || this._add([new ue(M.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new ue(M.read(arguments))]);
          },
          cubicCurveTo: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = M.read(n), d = i(this);
            d.setHandleOut(s.subtract(d._point)), this._add([new ue(h, l.subtract(h))]);
          },
          quadraticCurveTo: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = i(this)._point;
            this.cubicCurveTo(
              s.add(h.subtract(s).multiply(1 / 3)),
              s.add(l.subtract(s).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = a.pick(a.read(n), 0.5), d = 1 - h, m = i(this)._point, _ = s.subtract(m.multiply(d * d)).subtract(l.multiply(h * h)).divide(2 * h * d);
            if (_.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + h
              );
            this.quadraticCurveTo(_, l);
          },
          arcTo: function() {
            var n = arguments, s = Math.abs, l = Math.sqrt, h = i(this), d = h._point, m = M.read(n), U, _ = a.peek(n), b = a.pick(_, !0), x, T, E, L;
            if (typeof b == "boolean")
              var A = d.add(m).divide(2), U = A.add(A.subtract(d).rotate(
                b ? -90 : 90
              ));
            else if (a.remain(n) <= 2)
              U = m, m = M.read(n);
            else if (!d.equals(m)) {
              var k = Y.read(n), F = D.isZero;
              if (F(k.width) || F(k.height))
                return this.lineTo(m);
              var B = a.read(n), b = !!a.read(n), R = !!a.read(n), A = d.add(m).divide(2), C = d.subtract(A).rotate(-B), P = C.x, H = C.y, W = s(k.width), V = s(k.height), Q = W * W, ae = V * V, le = P * P, fe = H * H, se = l(le / Q + fe / ae);
              if (se > 1 && (W *= se, V *= se, Q = W * W, ae = V * V), se = (Q * ae - Q * fe - ae * le) / (Q * fe + ae * le), s(se) < 1e-12 && (se = 0), se < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              x = new M(W * H / V, -V * P / W).multiply((R === b ? -1 : 1) * l(se)).rotate(B).add(A), L = new J().translate(x).rotate(B).scale(W, V), E = L._inverseTransform(d), T = E.getDirectedAngle(L._inverseTransform(m)), !b && T > 0 ? T -= 360 : b && T < 0 && (T += 360);
            }
            if (U) {
              var ge = new he(
                d.add(U).divide(2),
                U.subtract(d).rotate(90),
                !0
              ), me = new he(
                U.add(m).divide(2),
                m.subtract(U).rotate(90),
                !0
              ), we = new he(d, m), Se = we.getSide(U);
              if (x = ge.intersect(me, !0), !x) {
                if (!Se)
                  return this.lineTo(m);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              E = d.subtract(x), T = E.getDirectedAngle(m.subtract(x));
              var Ae = we.getSide(x, !0);
              Ae === 0 ? T = Se * s(T) : Se === Ae && (T += T < 0 ? 360 : -360);
            }
            if (T) {
              for (var Ge = 1e-5, Je = s(T), tt = Je >= 360 ? 4 : Math.ceil((Je - Ge) / 90), ft = T / tt, Ne = ft * Math.PI / 360, ze = 4 / 3 * Math.sin(Ne) / (1 + Math.cos(Ne)), nt = [], _t = 0; _t <= tt; _t++) {
                var C = m, mt = null;
                if (_t < tt && (mt = E.rotate(90).multiply(ze), L ? (C = L._transformPoint(E), mt = L._transformPoint(E.add(mt)).subtract(C)) : C = x.add(E)), !_t)
                  h.setHandleOut(mt);
                else {
                  var Pt = E.rotate(-90).multiply(ze);
                  L && (Pt = L._transformPoint(E.add(Pt)).subtract(C)), nt.push(new ue(C, Pt, mt));
                }
                E = E.rotate(ft);
              }
              this._add(nt);
            }
          },
          lineBy: function() {
            var n = M.read(arguments), s = i(this)._point;
            this.lineTo(s.add(n));
          },
          curveBy: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = a.read(n), d = i(this)._point;
            this.curveTo(d.add(s), d.add(l), h);
          },
          cubicCurveBy: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = M.read(n), d = i(this)._point;
            this.cubicCurveTo(
              d.add(s),
              d.add(l),
              d.add(h)
            );
          },
          quadraticCurveBy: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = i(this)._point;
            this.quadraticCurveTo(h.add(s), h.add(l));
          },
          arcBy: function() {
            var n = arguments, s = i(this)._point, l = s.add(M.read(n)), h = a.pick(a.peek(n), !0);
            typeof h == "boolean" ? this.arcTo(l, h) : this.arcTo(l, s.add(M.read(n)));
          },
          closePath: function(n) {
            this.setClosed(!0), this.join(this, n);
          }
        };
      }(),
      {
        _getBounds: function(i, n) {
          var s = n.handle ? "getHandleBounds" : n.stroke ? "getStrokeBounds" : "getBounds";
          return it[s](this._segments, this._closed, this, i, n);
        },
        statics: {
          getBounds: function(i, n, s, l, h, d) {
            var m = i[0];
            if (!m)
              return new G();
            var _ = new Array(6), b = m._transformCoordinates(l, new Array(6)), x = b.slice(0, 2), T = x.slice(), E = new Array(2);
            function L(k) {
              k._transformCoordinates(l, _);
              for (var F = 0; F < 2; F++)
                Ue._addBounds(
                  b[F],
                  b[F + 4],
                  _[F + 2],
                  _[F],
                  F,
                  d ? d[F] : 0,
                  x,
                  T,
                  E
                );
              var B = b;
              b = _, _ = B;
            }
            for (var A = 1, U = i.length; A < U; A++)
              L(i[A]);
            return n && L(m), new G(x[0], x[1], T[0] - x[0], T[1] - x[1]);
          },
          getStrokeBounds: function(i, n, s, l, h) {
            var d = s.getStyle(), m = d.hasStroke(), _ = d.getStrokeWidth(), b = m && s._getStrokeMatrix(l, h), x = m && it._getStrokePadding(
              _,
              b
            ), T = it.getBounds(
              i,
              n,
              s,
              l,
              h,
              x
            );
            if (!m)
              return T;
            var E = _ / 2, L = d.getStrokeJoin(), A = d.getStrokeCap(), U = d.getMiterLimit(), k = new G(new Y(x));
            function F(W) {
              T = T.include(W);
            }
            function B(W) {
              T = T.unite(
                k.setCenter(W._point.transform(l))
              );
            }
            function R(W, V) {
              V === "round" || W.isSmooth() ? B(W) : it._addBevelJoin(
                W,
                V,
                E,
                U,
                l,
                b,
                F
              );
            }
            function C(W, V) {
              V === "round" ? B(W) : it._addSquareCap(
                W,
                V,
                E,
                l,
                b,
                F
              );
            }
            var P = i.length - (n ? 0 : 1);
            if (P > 0) {
              for (var H = 1; H < P; H++)
                R(i[H], L);
              n ? R(i[0], L) : (C(i[0], A), C(i[i.length - 1], A));
            }
            return T;
          },
          _getStrokePadding: function(i, n) {
            if (!n)
              return [i, i];
            var s = new M(i, 0).transform(n), l = new M(0, i).transform(n), h = s.getAngleInRadians(), d = s.getLength(), m = l.getLength(), _ = Math.sin(h), b = Math.cos(h), x = Math.tan(h), T = Math.atan2(m * x, d), E = Math.atan2(m, x * d);
            return [
              Math.abs(d * Math.cos(T) * b + m * Math.sin(T) * _),
              Math.abs(m * Math.sin(E) * b + d * Math.cos(E) * _)
            ];
          },
          _addBevelJoin: function(i, n, s, l, h, d, m, _) {
            var b = i.getCurve(), x = b.getPrevious(), T = b.getPoint1().transform(h), E = x.getNormalAtTime(1).multiply(s).transform(d), L = b.getNormalAtTime(0).multiply(s).transform(d), A = E.getDirectedAngle(L);
            if ((A < 0 || A >= 180) && (E = E.negate(), L = L.negate()), _ && m(T), m(T.add(E)), n === "miter") {
              var U = new he(
                T.add(E),
                new M(-E.y, E.x),
                !0
              ).intersect(new he(
                T.add(L),
                new M(-L.y, L.x),
                !0
              ), !0);
              U && T.getDistance(U) <= l * s && m(U);
            }
            m(T.add(L));
          },
          _addSquareCap: function(i, n, s, l, h, d, m) {
            var _ = i._point.transform(l), b = i.getLocation(), x = b.getNormal().multiply(b.getTime() === 0 ? s : -s).transform(h);
            n === "square" && (m && (d(_.subtract(x)), d(_.add(x))), _ = _.add(x.rotate(-90))), d(_.add(x)), d(_.subtract(x));
          },
          getHandleBounds: function(i, n, s, l, h) {
            var d = s.getStyle(), m = h.stroke && d.hasStroke(), _, b;
            if (m) {
              var x = s._getStrokeMatrix(l, h), T = d.getStrokeWidth() / 2, E = T;
              d.getStrokeJoin() === "miter" && (E = T * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, T * Math.SQRT2)), _ = it._getStrokePadding(T, x), b = it._getStrokePadding(E, x);
            }
            for (var L = new Array(6), A = 1 / 0, U = -A, k = A, F = U, B = 0, R = i.length; B < R; B++) {
              var C = i[B];
              C._transformCoordinates(l, L);
              for (var P = 0; P < 6; P += 2) {
                var H = P ? _ : b, W = H ? H[0] : 0, V = H ? H[1] : 0, Q = L[P], ae = L[P + 1], le = Q - W, fe = Q + W, se = ae - V, ge = ae + V;
                le < A && (A = le), fe > U && (U = fe), se < k && (k = se), ge > F && (F = ge);
              }
            }
            return new G(A, k, U - A, F - k);
          }
        }
      }
    );
    it.inject({ statics: new function() {
      var i = 0.5522847498307936, n = [
        new ue([-1, 0], [0, i], [0, -i]),
        new ue([0, -1], [-i, 0], [i, 0]),
        new ue([1, 0], [0, -i], [0, i]),
        new ue([0, 1], [i, 0], [-i, 0])
      ];
      function s(h, d, m) {
        var _ = a.getNamed(m), b = new it(_ && (_.insert == !0 ? K.INSERT : _.insert == !1 ? K.NO_INSERT : null));
        return b._add(h), b._closed = d, b.set(_, K.INSERT);
      }
      function l(h, d, m) {
        for (var _ = new Array(4), b = 0; b < 4; b++) {
          var x = n[b];
          _[b] = new ue(
            x._point.multiply(d).add(h),
            x._handleIn.multiply(d),
            x._handleOut.multiply(d)
          );
        }
        return s(_, !0, m);
      }
      return {
        Line: function() {
          var h = arguments;
          return s([
            new ue(M.readNamed(h, "from")),
            new ue(M.readNamed(h, "to"))
          ], !1, h);
        },
        Circle: function() {
          var h = arguments, d = M.readNamed(h, "center"), m = a.readNamed(h, "radius");
          return l(d, new Y(m), h);
        },
        Rectangle: function() {
          var h = arguments, d = G.readNamed(h, "rectangle"), m = Y.readNamed(
            h,
            "radius",
            0,
            { readNull: !0 }
          ), _ = d.getBottomLeft(!0), b = d.getTopLeft(!0), x = d.getTopRight(!0), T = d.getBottomRight(!0), E;
          if (!m || m.isZero())
            E = [
              new ue(_),
              new ue(b),
              new ue(x),
              new ue(T)
            ];
          else {
            m = Y.min(m, d.getSize(!0).divide(2));
            var L = m.width, A = m.height, U = L * i, k = A * i;
            E = [
              new ue(_.add(L, 0), null, [-U, 0]),
              new ue(_.subtract(0, A), [0, k]),
              new ue(b.add(0, A), null, [0, -k]),
              new ue(b.add(L, 0), [-U, 0], null),
              new ue(x.subtract(L, 0), null, [U, 0]),
              new ue(x.add(0, A), [0, -k], null),
              new ue(T.subtract(0, A), null, [0, k]),
              new ue(T.subtract(L, 0), [U, 0])
            ];
          }
          return s(E, !0, h);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var h = arguments, d = ke._readEllipse(h);
          return l(d.center, d.radius, h);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var h = arguments, d = M.readNamed(h, "from"), m = M.readNamed(h, "through"), _ = M.readNamed(h, "to"), b = a.getNamed(h), x = new it(b && b.insert == !1 && K.NO_INSERT);
          return x.moveTo(d), x.arcTo(m, _), x.set(b);
        },
        RegularPolygon: function() {
          for (var h = arguments, d = M.readNamed(h, "center"), m = a.readNamed(h, "sides"), _ = a.readNamed(h, "radius"), b = 360 / m, x = m % 3 === 0, T = new M(0, x ? -_ : _), E = x ? -1 : 0.5, L = new Array(m), A = 0; A < m; A++)
            L[A] = new ue(d.add(
              T.rotate((A + E) * b)
            ));
          return s(L, !0, h);
        },
        Star: function() {
          for (var h = arguments, d = M.readNamed(h, "center"), m = a.readNamed(h, "points") * 2, _ = a.readNamed(h, "radius1"), b = a.readNamed(h, "radius2"), x = 360 / m, T = new M(0, -1), E = new Array(m), L = 0; L < m; L++)
            E[L] = new ue(d.add(T.rotate(x * L).multiply(L % 2 ? b : _)));
          return s(E, !0, h);
        }
      };
    }() });
    var Zt = Gt.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(i) {
          this._children = [], this._namedChildren = {}, this._initialize(i) || (typeof i == "string" ? this.setPathData(i) : this.addChildren(Array.isArray(i) ? i : arguments));
        },
        insertChildren: function i(n, s) {
          var l = s, h = l[0];
          h && typeof h[0] == "number" && (l = [l]);
          for (var d = s.length - 1; d >= 0; d--) {
            var m = l[d];
            l === s && !(m instanceof it) && (l = a.slice(l)), Array.isArray(m) ? l[d] = new it({ segments: m, insert: !1 }) : m instanceof Zt && (l.splice.apply(l, [d, 1].concat(m.removeChildren())), m.remove());
          }
          return i.base.call(this, n, l);
        },
        reduce: function i(n) {
          for (var s = this._children, l = s.length - 1; l >= 0; l--) {
            var h = s[l].reduce(n);
            h.isEmpty() && h.remove();
          }
          if (!s.length) {
            var h = new it(K.NO_INSERT);
            return h.copyAttributes(this), h.insertAbove(this), this.remove(), h;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, n = 0, s = i.length; n < s; n++)
            if (!i[n]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var n = this._children, s = 0, l = n.length; s < l; s++)
            n[s].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, n = [], s = 0, l = i.length; s < l; s++)
            a.push(n, i[s].getCurves());
          return n;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, n = 0, s = 0, l = i.length; s < l; s++)
            n += i[s].getArea();
          return n;
        },
        getLength: function() {
          for (var i = this._children, n = 0, s = 0, l = i.length; s < l; s++)
            n += i[s].getLength();
          return n;
        },
        getPathData: function(i, n) {
          for (var s = this._children, l = [], h = 0, d = s.length; h < d; h++) {
            var m = s[h], _ = m._matrix;
            l.push(m.getPathData(i && !_.isIdentity() ? i.appended(_) : i, n));
          }
          return l.join("");
        },
        _hitTestChildren: function i(n, s, l) {
          return i.base.call(
            this,
            n,
            s.class === it || s.type === "path" ? s : a.set({}, s, { fill: !1 }),
            l
          );
        },
        _draw: function(i, n, s, l) {
          var h = this._children;
          if (h.length) {
            n = n.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var d = 0, m = h.length; d < m; d++)
              h[d].draw(i, n, l);
            if (!n.clip) {
              this._setStyles(i, n, s);
              var _ = this._style;
              _.hasFill() && (i.fill(_.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), _.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, n, s) {
          for (var l = this._children, h = 0, d = l.length; h < d; h++) {
            var m = l[h], _ = m._matrix;
            s[m._id] || m._drawSelected(i, _.isIdentity() ? n : n.appended(_));
          }
        }
      },
      new function() {
        function i(n, s) {
          var l = n._children;
          if (s && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return a.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(n) {
            this[n] = function() {
              var s = i(this, !0);
              s[n].apply(s, arguments);
            };
          },
          {
            moveTo: function() {
              var n = i(this), s = n && n.isEmpty() ? n : new it(K.NO_INSERT);
              s !== n && this.addChild(s), s.moveTo.apply(s, arguments);
            },
            moveBy: function() {
              var n = i(this, !0), s = n && n.getLastSegment(), l = M.read(arguments);
              this.moveTo(s ? l.add(s._point) : l);
            },
            closePath: function(n) {
              i(this, !0).closePath(n);
            }
          }
        );
      }(),
      a.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(n) {
          for (var s = this._children, l, h = 0, d = s.length; h < d; h++)
            l = s[h][i](n) || l;
          return l;
        };
      }, {})
    );
    Gt.inject(new function() {
      var i = Math.min, n = Math.max, s = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function h(B) {
        return B._children || [B];
      }
      function d(B, R) {
        var C = B.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (R) {
          for (var P = h(C), H = 0, W = P.length; H < W; H++) {
            var B = P[H];
            !B._closed && !B.isEmpty() && (B.closePath(1e-12), B.getFirstSegment().setHandleIn(0, 0), B.getLastSegment().setHandleOut(0, 0));
          }
          C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
        }
        return C;
      }
      function m(B, R, C, P, H) {
        var W = new Zt(K.NO_INSERT);
        return W.addChildren(B, !0), W = W.reduce({ simplify: R }), H && H.insert == !1 || W.insertAbove(P && C.isSibling(P) && C.getIndex() < P.getIndex() ? P : C), W.copyAttributes(C, !0), W;
      }
      function _(B) {
        return B.hasOverlap() || B.isCrossing();
      }
      function b(B, R, C, P) {
        if (P && (P.trace == !1 || P.stroke) && /^(subtract|intersect)$/.test(C))
          return x(B, R, C);
        var H = d(B, !0), W = R && B !== R && d(R, !0), V = l[C];
        V[C] = !0, W && (V.subtract || V.exclude) ^ (W.isClockwise() ^ H.isClockwise()) && W.reverse();
        var Q = A(ot.expand(
          H.getIntersections(W, _)
        )), ae = h(H), le = W && h(W), fe = [], se = [], ge;
        function me(mt) {
          for (var Pt = 0, Et = mt.length; Pt < Et; Pt++) {
            var zt = mt[Pt];
            a.push(fe, zt._segments), a.push(se, zt.getCurves()), zt._overlapsOnly = !0;
          }
        }
        function we(mt) {
          for (var Pt = [], Et = 0, zt = mt && mt.length; Et < zt; Et++)
            Pt.push(se[mt[Et]]);
          return Pt;
        }
        if (Q.length) {
          me(ae), le && me(le);
          for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
            Se[Ae] = se[Ae].getValues();
          for (var Je = S.findCurveBoundsCollisions(
            Se,
            Se,
            0,
            !0
          ), tt = {}, Ae = 0; Ae < se.length; Ae++) {
            var ft = se[Ae], Ne = ft._path._id, ze = tt[Ne] = tt[Ne] || {};
            ze[ft.getIndex()] = {
              hor: we(Je[Ae].hor),
              ver: we(Je[Ae].ver)
            };
          }
          for (var Ae = 0, Ge = Q.length; Ae < Ge; Ae++)
            k(
              Q[Ae]._segment,
              H,
              W,
              tt,
              V
            );
          for (var Ae = 0, Ge = fe.length; Ae < Ge; Ae++) {
            var nt = fe[Ae], _t = nt._intersection;
            nt._winding || k(
              nt,
              H,
              W,
              tt,
              V
            ), _t && _t._overlap || (nt._path._overlapsOnly = !1);
          }
          ge = F(fe, V);
        } else
          ge = L(
            le ? ae.concat(le) : ae.slice(),
            function(mt) {
              return !!V[mt];
            }
          );
        return m(ge, !0, B, R, P);
      }
      function x(B, R, C) {
        var P = d(B), H = d(R), W = P.getIntersections(H, _), V = C === "subtract", Q = C === "divide", ae = {}, le = [];
        function fe(me) {
          if (!ae[me._id] && (Q || H.contains(me.getPointAt(me.getLength() / 2)) ^ V))
            return le.unshift(me), ae[me._id] = !0;
        }
        for (var se = W.length - 1; se >= 0; se--) {
          var ge = W[se].split();
          ge && (fe(ge) && ge.getFirstSegment().setHandleIn(0, 0), P.getLastSegment().setHandleOut(0, 0));
        }
        return fe(P), m(le, !1, B, R);
      }
      function T(B, R) {
        for (var C = B; C; ) {
          if (C === R)
            return;
          C = C._previous;
        }
        for (; B._next && B._next !== R; )
          B = B._next;
        if (!B._next) {
          for (; R._previous; )
            R = R._previous;
          B._next = R, R._previous = B;
        }
      }
      function E(B) {
        for (var R = B.length - 1; R >= 0; R--)
          B[R].clearHandles();
      }
      function L(B, R, C) {
        var P = B && B.length;
        if (P) {
          var H = a.each(B, function(Je, tt) {
            this[Je._id] = {
              container: null,
              winding: Je.isClockwise() ? 1 : -1,
              index: tt
            };
          }, {}), W = B.slice().sort(function(Je, tt) {
            return s(tt.getArea()) - s(Je.getArea());
          }), V = W[0], Q = S.findItemBoundsCollisions(
            W,
            null,
            D.GEOMETRIC_EPSILON
          );
          C == null && (C = V.isClockwise());
          for (var ae = 0; ae < P; ae++) {
            var le = W[ae], fe = H[le._id], se = 0, ge = Q[ae];
            if (ge) {
              for (var me = null, we = ge.length - 1; we >= 0; we--)
                if (ge[we] < ae) {
                  me = me || le.getInteriorPoint();
                  var Se = W[ge[we]];
                  if (Se.contains(me)) {
                    var Ae = H[Se._id];
                    se = Ae.winding, fe.winding += se, fe.container = Ae.exclude ? Ae.container : Se;
                    break;
                  }
                }
            }
            if (R(fe.winding) === R(se))
              fe.exclude = !0, B[fe.index] = null;
            else {
              var Ge = fe.container;
              le.setClockwise(
                Ge ? !Ge.isClockwise() : C
              );
            }
          }
        }
        return B;
      }
      function A(B, R, C) {
        var P = R && [], H = 1e-8, W = 1 - H, V = !1, Q = C || [], ae = C && {}, le, fe, se;
        function ge(Pt) {
          return Pt._path._id + "." + Pt._segment1._index;
        }
        for (var me = (C && C.length) - 1; me >= 0; me--) {
          var we = C[me];
          we._path && (ae[ge(we)] = !0);
        }
        for (var me = B.length - 1; me >= 0; me--) {
          var Se = B[me], Ae = Se._time, Ge = Ae, Je = R && !R(Se), we = Se._curve, tt;
          if (we && (we !== fe ? (V = !we.hasHandles() || ae && ae[ge(we)], le = [], se = null, fe = we) : se >= H && (Ae /= se)), Je) {
            le && le.push(Se);
            continue;
          } else
            R && P.unshift(Se);
          if (se = Ge, Ae < H)
            tt = we._segment1;
          else if (Ae > W)
            tt = we._segment2;
          else {
            var ft = we.divideAtTime(Ae, !0);
            V && Q.push(we, ft), tt = ft._segment1;
            for (var Ne = le.length - 1; Ne >= 0; Ne--) {
              var ze = le[Ne];
              ze._time = (ze._time - Ae) / (1 - Ae);
            }
          }
          Se._setSegment(tt);
          var nt = tt._intersection, _t = Se._intersection;
          if (nt) {
            T(nt, _t);
            for (var mt = nt; mt; )
              T(mt._intersection, nt), mt = mt._next;
          } else
            tt._intersection = _t;
        }
        return C || E(Q), P || B;
      }
      function U(B, R, C, P, H) {
        var W = Array.isArray(R) ? R : R[C ? "hor" : "ver"], V = C ? 1 : 0, Q = V ^ 1, ae = [B.x, B.y], le = ae[V], fe = ae[Q], se = 1e-9, ge = 1e-6, me = le - se, we = le + se, Se = 0, Ae = 0, Ge = 0, Je = 0, tt = !1, ft = !1, Ne = 1, ze = [], nt, _t;
        function mt(ni) {
          var di = ni[Q + 0], Hi = ni[Q + 6];
          if (!(fe < i(di, Hi) || fe > n(di, Hi))) {
            var xi = ni[V + 0], qi = ni[V + 2], Ti = ni[V + 4], Ci = ni[V + 6];
            if (di === Hi) {
              (xi < we && Ci > me || Ci < we && xi > me) && (tt = !0);
              return;
            }
            var Xi = fe === di ? 0 : fe === Hi || me > n(xi, qi, Ti, Ci) || we < i(xi, qi, Ti, Ci) ? 1 : Ue.solveCubic(ni, Q, fe, ze, 0, 1) > 0 ? ze[0] : 1, Gi = Xi === 0 ? xi : Xi === 1 ? Ci : Ue.getPoint(ni, Xi)[C ? "y" : "x"], Ki = di > Hi ? 1 : -1, un = nt[Q] > nt[Q + 6] ? 1 : -1, nn = nt[V + 6];
            return fe !== di ? (Gi < me ? Ge += Ki : Gi > we ? Je += Ki : tt = !0, Gi > le - ge && Gi < le + ge && (Ne /= 2)) : (Ki !== un ? xi < me ? Ge += Ki : xi > we && (Je += Ki) : xi != nn && (nn < we && Gi > we ? (Je += Ki, tt = !0) : nn > me && Gi < me && (Ge += Ki, tt = !0)), Ne /= 4), nt = ni, !H && Gi > me && Gi < we && Ue.getTangent(ni, Xi)[C ? "x" : "y"] === 0 && U(B, R, !C, P, !0);
          }
        }
        function Pt(ni) {
          var di = ni[Q + 0], Hi = ni[Q + 2], xi = ni[Q + 4], qi = ni[Q + 6];
          if (fe <= n(di, Hi, xi, qi) && fe >= i(di, Hi, xi, qi)) {
            for (var Ti = ni[V + 0], Ci = ni[V + 2], Xi = ni[V + 4], Gi = ni[V + 6], Ki = me > n(Ti, Ci, Xi, Gi) || we < i(Ti, Ci, Xi, Gi) ? [ni] : Ue.getMonoCurves(ni, C), un, nn = 0, Wn = Ki.length; nn < Wn; nn++)
              if (un = mt(Ki[nn]))
                return un;
          }
        }
        for (var Et = 0, zt = W.length; Et < zt; Et++) {
          var jt = W[Et], Ft = jt._path, Mi = jt.getValues(), Rt;
          if ((!Et || W[Et - 1]._path !== Ft) && (nt = null, Ft._closed || (_t = Ue.getValues(
            Ft.getLastCurve().getSegment2(),
            jt.getSegment1(),
            null,
            !P
          ), _t[Q] !== _t[Q + 6] && (nt = _t)), !nt)) {
            nt = Mi;
            for (var hi = Ft.getLastCurve(); hi && hi !== jt; ) {
              var ci = hi.getValues();
              if (ci[Q] !== ci[Q + 6]) {
                nt = ci;
                break;
              }
              hi = hi.getPrevious();
            }
          }
          if (Rt = Pt(Mi))
            return Rt;
          if (Et + 1 === zt || W[Et + 1]._path !== Ft) {
            if (_t && (Rt = Pt(_t)))
              return Rt;
            tt && !Ge && !Je && (Ge = Je = Ft.isClockwise(P) ^ C ? 1 : -1), Se += Ge, Ae += Je, Ge = Je = 0, tt && (ft = !0, tt = !1), _t = null;
          }
        }
        return Se = s(Se), Ae = s(Ae), {
          winding: n(Se, Ae),
          windingL: Se,
          windingR: Ae,
          quality: Ne,
          onPath: ft
        };
      }
      function k(B, R, C, P, H) {
        var W = [], V = B, Q = 0, ae;
        do {
          var le = B.getCurve();
          if (le) {
            var fe = le.getLength();
            W.push({ segment: B, curve: le, length: fe }), Q += fe;
          }
          B = B.getNext();
        } while (B && !B._intersection && B !== V);
        for (var se = [0.5, 0.25, 0.75], ae = { winding: 0, quality: -1 }, ge = 1e-3, me = 1 - ge, we = 0; we < se.length && ae.quality < 0.5; we++)
          for (var fe = Q * se[we], Se = 0, Ae = W.length; Se < Ae; Se++) {
            var Ge = W[Se], Je = Ge.length;
            if (fe <= Je) {
              var le = Ge.curve, tt = le._path, ft = tt._parent, Ne = ft instanceof Zt ? ft : tt, ze = D.clamp(le.getTimeAt(fe), ge, me), nt = le.getPointAtTime(ze), _t = s(le.getTangentAtTime(ze).y) < Math.SQRT1_2, mt = null;
              if (H.subtract && C) {
                var Pt = Ne === R ? C : R, Et = Pt._getWinding(nt, _t, !0);
                if (Ne === R && Et.winding || Ne === C && !Et.winding) {
                  if (Et.quality < 1)
                    continue;
                  mt = { winding: 0, quality: 1 };
                }
              }
              mt = mt || U(
                nt,
                P[tt._id][le.getIndex()],
                _t,
                !0
              ), mt.quality > ae.quality && (ae = mt);
              break;
            }
            fe -= Je;
          }
        for (var Se = W.length - 1; Se >= 0; Se--)
          W[Se].segment._winding = ae;
      }
      function F(B, R) {
        var C = [], P;
        function H(zt) {
          var jt;
          return !!(zt && !zt._visited && (!R || R[(jt = zt._winding || {}).winding] && !(R.unite && jt.winding === 2 && jt.windingL && jt.windingR)));
        }
        function W(zt) {
          if (zt) {
            for (var jt = 0, Ft = P.length; jt < Ft; jt++)
              if (zt === P[jt])
                return !0;
          }
          return !1;
        }
        function V(zt) {
          for (var jt = zt._segments, Ft = 0, Mi = jt.length; Ft < Mi; Ft++)
            jt[Ft]._visited = !0;
        }
        function Q(zt, jt) {
          var Ft = zt._intersection, Mi = Ft, Rt = [];
          jt && (P = [zt]);
          function hi(ci, ni) {
            for (; ci && ci !== ni; ) {
              var di = ci._segment, Hi = di && di._path;
              if (Hi) {
                var xi = di.getNext() || Hi.getFirstSegment(), qi = xi._intersection;
                di !== zt && (W(di) || W(xi) || xi && H(di) && (H(xi) || qi && H(qi._segment))) && Rt.push(di), jt && P.push(di);
              }
              ci = ci._next;
            }
          }
          if (Ft) {
            for (hi(Ft); Ft && Ft._previous; )
              Ft = Ft._previous;
            hi(Ft, Mi);
          }
          return Rt;
        }
        B.sort(function(zt, jt) {
          var Ft = zt._intersection, Mi = jt._intersection, Rt = !!(Ft && Ft._overlap), hi = !!(Mi && Mi._overlap), ci = zt._path, ni = jt._path;
          return Rt ^ hi ? Rt ? 1 : -1 : !Ft ^ !Mi ? Ft ? 1 : -1 : ci !== ni ? ci._id - ni._id : zt._index - jt._index;
        });
        for (var ae = 0, le = B.length; ae < le; ae++) {
          var fe = B[ae], se = H(fe), ge = null, me = !1, we = !0, Se = [], Ae, Ge, Je;
          if (se && fe._path._overlapsOnly) {
            var tt = fe._path, ft = fe._intersection._segment._path;
            tt.compare(ft) && (tt.getArea() && C.push(tt.clone(!1)), V(tt), V(ft), se = !1);
          }
          for (; se; ) {
            var Ne = !ge, ze = Q(fe, Ne), nt = ze.shift(), me = !Ne && (W(fe) || W(nt)), _t = !me && nt;
            if (Ne && (ge = new it(K.NO_INSERT), Ae = null), me) {
              (fe.isFirst() || fe.isLast()) && (we = fe._path._closed), fe._visited = !0;
              break;
            }
            if (_t && Ae && (Se.push(Ae), Ae = null), Ae || (_t && ze.push(fe), Ae = {
              start: ge._segments.length,
              crossings: ze,
              visited: Ge = [],
              handleIn: Je
            }), _t && (fe = nt), !H(fe)) {
              ge.removeSegments(Ae.start);
              for (var mt = 0, Pt = Ge.length; mt < Pt; mt++)
                Ge[mt]._visited = !1;
              Ge.length = 0;
              do
                fe = Ae && Ae.crossings.shift(), (!fe || !fe._path) && (fe = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, Je = Ae.handleIn));
              while (Ae && !H(fe));
              if (!fe)
                break;
            }
            var Et = fe.getNext();
            ge.add(new ue(
              fe._point,
              Je,
              Et && fe._handleOut
            )), fe._visited = !0, Ge.push(fe), fe = Et || fe._path.getFirstSegment(), Je = Et && Et._handleIn;
          }
          me && (we && (ge.getFirstSegment().setHandleIn(Je), ge.setClosed(we)), ge.getArea() !== 0 && C.push(ge));
        }
        return C;
      }
      return {
        _getWinding: function(B, R, C) {
          return U(B, this.getCurves(), R, C);
        },
        unite: function(B, R) {
          return b(this, B, "unite", R);
        },
        intersect: function(B, R) {
          return b(this, B, "intersect", R);
        },
        subtract: function(B, R) {
          return b(this, B, "subtract", R);
        },
        exclude: function(B, R) {
          return b(this, B, "exclude", R);
        },
        divide: function(B, R) {
          return R && (R.trace == !1 || R.stroke) ? x(this, B, "divide") : m([
            this.subtract(B, R),
            this.intersect(B, R)
          ], !0, this, B, R);
        },
        resolveCrossings: function() {
          var B = this._children, R = B || [this];
          function C(Ae, Ge) {
            var Je = Ae && Ae._intersection;
            return Je && Je._overlap && Je._path === Ge;
          }
          var P = !1, H = !1, W = this.getIntersections(null, function(Ae) {
            return Ae.hasOverlap() && (P = !0) || Ae.isCrossing() && (H = !0);
          }), V = P && H && [];
          if (W = ot.expand(W), P)
            for (var Q = A(W, function(Ae) {
              return Ae.hasOverlap();
            }, V), ae = Q.length - 1; ae >= 0; ae--) {
              var le = Q[ae], fe = le._path, se = le._segment, ge = se.getPrevious(), me = se.getNext();
              C(ge, fe) && C(me, fe) && (se.remove(), ge._handleOut._set(0, 0), me._handleIn._set(0, 0), ge !== se && !ge.getCurve().hasLength() && (me._handleIn.set(ge._handleIn), ge.remove()));
            }
          H && (A(W, P && function(Ae) {
            var Ge = Ae.getCurve(), Je = Ae.getSegment(), tt = Ae._intersection, ft = tt._curve, Ne = tt._segment;
            if (Ge && ft && Ge._path && ft._path)
              return !0;
            Je && (Je._intersection = null), Ne && (Ne._intersection = null);
          }, V), V && E(V), R = F(a.each(R, function(Ae) {
            a.push(this, Ae._segments);
          }, [])));
          var we = R.length, Se;
          return we > 1 && B ? (R !== B && this.setChildren(R), Se = this) : we === 1 && !B && (R[0] !== this && this.setSegments(R[0].removeSegments()), Se = this), Se || (Se = new Zt(K.NO_INSERT), Se.addChildren(R), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
        },
        reorient: function(B, R) {
          var C = this._children;
          return C && C.length ? this.setChildren(L(
            this.removeChildren(),
            function(P) {
              return !!(B ? P : P & 1);
            },
            R
          )) : R !== t && this.setClockwise(R), this;
        },
        getInteriorPoint: function() {
          var B = this.getBounds(), R = B.getCenter(!0);
          if (!this.contains(R)) {
            for (var C = this.getCurves(), P = R.y, H = [], W = [], V = 0, Q = C.length; V < Q; V++) {
              var ae = C[V].getValues(), le = ae[1], fe = ae[3], se = ae[5], ge = ae[7];
              if (P >= i(le, fe, se, ge) && P <= n(le, fe, se, ge))
                for (var me = Ue.getMonoCurves(ae), we = 0, Se = me.length; we < Se; we++) {
                  var Ae = me[we], Ge = Ae[1], Je = Ae[7];
                  if (Ge !== Je && (P >= Ge && P <= Je || P >= Je && P <= Ge)) {
                    var tt = P === Ge ? Ae[0] : P === Je ? Ae[6] : Ue.solveCubic(Ae, 1, P, W, 0, 1) === 1 ? Ue.getPoint(Ae, W[0]).x : (Ae[0] + Ae[6]) / 2;
                    H.push(tt);
                  }
                }
            }
            H.length > 1 && (H.sort(function(ft, Ne) {
              return ft - Ne;
            }), R.x = (H[0] + H[1]) / 2);
          }
          return R;
        }
      };
    }());
    var ct = a.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, n, s, l, h) {
          var d = [], m = [], _ = 0, b = 1 / (s || 32), x = i._segments, T = x[0], E;
          function L(F, B) {
            var R = Ue.getValues(F, B, h);
            d.push(R), A(R, F._index, 0, 1);
          }
          function A(F, B, R, C) {
            if (C - R > b && !(l && Ue.isStraight(F)) && !Ue.isFlatEnough(F, n || 0.25)) {
              var P = Ue.subdivide(F, 0.5), H = (R + C) / 2;
              A(P[0], B, R, H), A(P[1], B, H, C);
            } else {
              var W = F[6] - F[0], V = F[7] - F[1], Q = Math.sqrt(W * W + V * V);
              Q > 0 && (_ += Q, m.push({
                offset: _,
                curve: F,
                index: B,
                time: C
              }));
            }
          }
          for (var U = 1, k = x.length; U < k; U++)
            E = x[U], L(T, E), T = E;
          i._closed && L(E || T, x[0]), this.curves = d, this.parts = m, this.length = _, this.index = 0;
        },
        _get: function(i) {
          for (var n = this.parts, s = n.length, l, h = this.index; l = h, !(!h || n[--h].offset < i); )
            ;
          for (; l < s; l++) {
            var d = n[l];
            if (d.offset >= i) {
              this.index = l;
              var m = n[l - 1], _ = m && m.index === d.index ? m.time : 0, b = m ? m.offset : 0;
              return {
                index: d.index,
                time: _ + (d.time - _) * (i - b) / (d.offset - b)
              };
            }
          }
          return {
            index: n[s - 1].index,
            time: 1
          };
        },
        drawPart: function(i, n, s) {
          for (var l = this._get(n), h = this._get(s), d = l.index, m = h.index; d <= m; d++) {
            var _ = Ue.getPart(
              this.curves[d],
              d === l.index ? l.time : 0,
              d === h.index ? h.time : 1
            );
            d === l.index && i.moveTo(_[0], _[1]), i.bezierCurveTo.apply(i, _.slice(2));
          }
        }
      },
      a.each(
        Ue._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var s = this._get(n);
            return Ue[i](this.curves[s.index], s.time);
          };
        },
        {}
      )
    ), lt = a.extend({
      initialize: function(i) {
        for (var n = this.points = [], s = i._segments, l = i._closed, h = 0, d, m = s.length; h < m; h++) {
          var _ = s[h].point;
          (!d || !d.equals(_)) && n.push(d = _.clone());
        }
        l && (n.unshift(n[n.length - 1]), n.push(n[1])), this.closed = l;
      },
      fit: function(i) {
        var n = this.points, s = n.length, l = null;
        return s > 0 && (l = [new ue(n[0])], s > 1 && (this.fitCubic(
          l,
          i,
          0,
          s - 1,
          n[1].subtract(n[0]),
          n[s - 2].subtract(n[s - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, n, s, l, h, d) {
        var m = this.points;
        if (l - s === 1) {
          var _ = m[s], b = m[l], x = _.getDistance(b) / 3;
          this.addCurve(i, [
            _,
            _.add(h.normalize(x)),
            b.add(d.normalize(x)),
            b
          ]);
          return;
        }
        for (var T = this.chordLengthParameterize(s, l), E = Math.max(n, n * n), L, A = !0, U = 0; U <= 4; U++) {
          var k = this.generateBezier(s, l, T, h, d), F = this.findMaxError(s, l, k, T);
          if (F.error < n && A) {
            this.addCurve(i, k);
            return;
          }
          if (L = F.index, F.error >= E)
            break;
          A = this.reparameterize(s, l, T, k), E = F.error;
        }
        var B = m[L - 1].subtract(m[L + 1]);
        this.fitCubic(i, n, s, L, h, B), this.fitCubic(i, n, L, l, B.negate(), d);
      },
      addCurve: function(i, n) {
        var s = i[i.length - 1];
        s.setHandleOut(n[1].subtract(n[0])), i.push(new ue(n[3], n[2].subtract(n[3])));
      },
      generateBezier: function(i, n, s, l, h) {
        for (var d = 1e-12, m = Math.abs, _ = this.points, b = _[i], x = _[n], T = [[0, 0], [0, 0]], E = [0, 0], L = 0, A = n - i + 1; L < A; L++) {
          var U = s[L], k = 1 - U, F = 3 * U * k, B = k * k * k, R = F * k, C = F * U, P = U * U * U, H = l.normalize(R), W = h.normalize(C), V = _[i + L].subtract(b.multiply(B + R)).subtract(x.multiply(C + P));
          T[0][0] += H.dot(H), T[0][1] += H.dot(W), T[1][0] = T[0][1], T[1][1] += W.dot(W), E[0] += H.dot(V), E[1] += W.dot(V);
        }
        var Q = T[0][0] * T[1][1] - T[1][0] * T[0][1], ae, le;
        if (m(Q) > d) {
          var fe = T[0][0] * E[1] - T[1][0] * E[0], se = E[0] * T[1][1] - E[1] * T[0][1];
          ae = se / Q, le = fe / Q;
        } else {
          var ge = T[0][0] + T[0][1], me = T[1][0] + T[1][1];
          ae = le = m(ge) > d ? E[0] / ge : m(me) > d ? E[1] / me : 0;
        }
        var we = x.getDistance(b), Se = d * we, Ae, Ge;
        if (ae < Se || le < Se)
          ae = le = we / 3;
        else {
          var Je = x.subtract(b);
          Ae = l.normalize(ae), Ge = h.normalize(le), Ae.dot(Je) - Ge.dot(Je) > we * we && (ae = le = we / 3, Ae = Ge = null);
        }
        return [
          b,
          b.add(Ae || l.normalize(ae)),
          x.add(Ge || h.normalize(le)),
          x
        ];
      },
      reparameterize: function(i, n, s, l) {
        for (var h = i; h <= n; h++)
          s[h - i] = this.findRoot(l, this.points[h], s[h - i]);
        for (var h = 1, d = s.length; h < d; h++)
          if (s[h] <= s[h - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, n, s) {
        for (var l = [], h = [], d = 0; d <= 2; d++)
          l[d] = i[d + 1].subtract(i[d]).multiply(3);
        for (var d = 0; d <= 1; d++)
          h[d] = l[d + 1].subtract(l[d]).multiply(2);
        var m = this.evaluate(3, i, s), _ = this.evaluate(2, l, s), b = this.evaluate(1, h, s), x = m.subtract(n), T = _.dot(_) + x.dot(b);
        return D.isMachineZero(T) ? s : s - x.dot(_) / T;
      },
      evaluate: function(i, n, s) {
        for (var l = n.slice(), h = 1; h <= i; h++)
          for (var d = 0; d <= i - h; d++)
            l[d] = l[d].multiply(1 - s).add(l[d + 1].multiply(s));
        return l[0];
      },
      chordLengthParameterize: function(i, n) {
        for (var s = [0], l = i + 1; l <= n; l++)
          s[l - i] = s[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, h = n - i; l <= h; l++)
          s[l] /= s[h];
        return s;
      },
      findMaxError: function(i, n, s, l) {
        for (var h = Math.floor((n - i + 1) / 2), d = 0, m = i + 1; m < n; m++) {
          var _ = this.evaluate(3, s, l[m - i]), b = _.subtract(this.points[m]), x = b.x * b.x + b.y * b.y;
          x >= d && (d = x, h = m);
        }
        return {
          error: d,
          index: h
        };
      }
    }), $t = K.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(i) {
        this._content = "", this._lines = [];
        var n = i && a.isPlainObject(i) && i.x === t && i.y === t;
        this._initialize(n && i, !n && M.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), Kt = $t.extend({
      _class: "PointText",
      initialize: function() {
        $t.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new X(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, n, s) {
        if (this._content) {
          this._setStyles(i, n, s);
          var l = this._lines, h = this._style, d = h.hasFill(), m = h.hasStroke(), _ = h.getLeading(), b = i.shadowColor;
          i.font = h.getFontStyle(), i.textAlign = h.getJustification();
          for (var x = 0, T = l.length; x < T; x++) {
            i.shadowColor = b;
            var E = l[x];
            d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), m && i.strokeText(E, 0, 0), i.translate(0, _);
          }
        }
      },
      _getBounds: function(i, n) {
        var s = this._style, l = this._lines, h = l.length, d = s.getJustification(), m = s.getLeading(), _ = this.getView().getTextWidth(s.getFontStyle(), l), b = 0;
        d !== "left" && (b -= _ / (d === "center" ? 2 : 1));
        var x = new G(
          b,
          h ? -0.75 * m : 0,
          _,
          h * m
        );
        return i ? i._transformBounds(x, x) : x;
      }
    }), At = a.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, n = {}, s = {
          transparent: [0, 0, 0, 0]
        }, l;
        function h(_) {
          var b = _.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || _.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), x = "rgb", T;
          if (b) {
            var E = b[4] ? 4 : 3;
            T = new Array(E);
            for (var L = 0; L < E; L++) {
              var A = b[L + 1];
              T[L] = parseInt(A.length == 1 ? A + A : A, 16) / 255;
            }
          } else if (b = _.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            x = b[1], T = b[2].trim().split(/[,\s]+/g);
            for (var U = x === "hsl", L = 0, k = Math.min(T.length, 4); L < k; L++) {
              var F = T[L], A = parseFloat(F);
              if (U)
                if (L === 0) {
                  var B = F.match(/([a-z]*)$/)[1];
                  A *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[B] || 1;
                } else
                  L < 3 && (A /= 100);
              else
                L < 3 && (A /= /%$/.test(F) ? 100 : 255);
              T[L] = A;
            }
          } else {
            var R = s[_];
            if (!R)
              if (r) {
                l || (l = dt.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = _, l.fillRect(0, 0, 1, 1);
                var C = l.getImageData(0, 0, 1, 1).data;
                R = s[_] = [
                  C[0] / 255,
                  C[1] / 255,
                  C[2] / 255
                ];
              } else
                R = [0, 0, 0];
            T = R.slice();
          }
          return [x, T];
        }
        var d = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], m = {
          "rgb-hsb": function(_, b, x) {
            var T = Math.max(_, b, x), E = Math.min(_, b, x), L = T - E, A = L === 0 ? 0 : (T == _ ? (b - x) / L + (b < x ? 6 : 0) : T == b ? (x - _) / L + 2 : (_ - b) / L + 4) * 60;
            return [A, T === 0 ? 0 : L / T, T];
          },
          "hsb-rgb": function(_, b, x) {
            _ = (_ / 60 % 6 + 6) % 6;
            var E = Math.floor(_), T = _ - E, E = d[E], L = [
              x,
              x * (1 - b),
              x * (1 - b * T),
              x * (1 - b * (1 - T))
            ];
            return [L[E[0]], L[E[1]], L[E[2]]];
          },
          "rgb-hsl": function(_, b, x) {
            var T = Math.max(_, b, x), E = Math.min(_, b, x), L = T - E, A = L === 0, U = A ? 0 : (T == _ ? (b - x) / L + (b < x ? 6 : 0) : T == b ? (x - _) / L + 2 : (_ - b) / L + 4) * 60, k = (T + E) / 2, F = A ? 0 : k < 0.5 ? L / (T + E) : L / (2 - T - E);
            return [U, F, k];
          },
          "hsl-rgb": function(_, b, x) {
            if (_ = (_ / 360 % 1 + 1) % 1, b === 0)
              return [x, x, x];
            for (var T = [_ + 1 / 3, _, _ - 1 / 3], E = x < 0.5 ? x * (1 + b) : x + b - x * b, L = 2 * x - E, A = [], U = 0; U < 3; U++) {
              var k = T[U];
              k < 0 && (k += 1), k > 1 && (k -= 1), A[U] = 6 * k < 1 ? L + (E - L) * 6 * k : 2 * k < 1 ? E : 3 * k < 2 ? L + (E - L) * (2 / 3 - k) * 6 : L;
            }
            return A;
          },
          "rgb-gray": function(_, b, x) {
            return [_ * 0.2989 + b * 0.587 + x * 0.114];
          },
          "gray-rgb": function(_) {
            return [_, _, _];
          },
          "gray-hsb": function(_) {
            return [0, 0, _];
          },
          "gray-hsl": function(_) {
            return [0, 0, _];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return a.each(i, function(_, b) {
          n[b] = [], a.each(_, function(x, T) {
            var E = a.capitalize(x), L = /^(hue|saturation)$/.test(x), A = n[b][T] = b === "gradient" ? x === "gradient" ? function(U) {
              var k = this._components[0];
              return U = Ni.read(
                Array.isArray(U) ? U : arguments,
                0,
                { readNull: !0 }
              ), k !== U && (k && k._removeOwner(this), U && U._addOwner(this)), U;
            } : function() {
              return M.read(arguments, 0, {
                readNull: x === "highlight",
                clone: !0
              });
            } : function(U) {
              return U == null || isNaN(U) ? 0 : +U;
            };
            this["get" + E] = function() {
              return this._type === b || L && /^hs[bl]$/.test(this._type) ? this._components[T] : this._convert(b)[T];
            }, this["set" + E] = function(U) {
              this._type !== b && !(L && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(b), this._properties = i[b], this._type = b), this._components[T] = A.call(this, U), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function _(b) {
            var x = arguments, T = this.__read, E = 0, L, A, U, k;
            Array.isArray(b) && (x = b, b = x[0]);
            var F = b != null && typeof b;
            if (F === "string" && b in i && (L = b, b = x[1], Array.isArray(b) ? (A = b, U = x[2]) : (T && (E = 1), x = a.slice(x, 1), F = typeof b)), !A) {
              if (k = F === "number" ? x : F === "object" && b.length != null ? b : null, k) {
                L || (L = k.length >= 3 ? "rgb" : "gray");
                var B = i[L].length;
                U = k[B], T && (E += k === arguments ? B + (U != null ? 1 : 0) : 1), k.length > B && (k = a.slice(k, 0, B));
              } else if (F === "string") {
                var R = h(b);
                L = R[0], A = R[1], A.length === 4 && (U = A[3], A.length--);
              } else if (F === "object")
                if (b.constructor === _) {
                  if (L = b._type, A = b._components.slice(), U = b._alpha, L === "gradient")
                    for (var C = 1, P = A.length; C < P; C++) {
                      var H = A[C];
                      H && (A[C] = H.clone());
                    }
                } else if (b.constructor === Ni)
                  L = "gradient", k = x;
                else {
                  L = "hue" in b ? "lightness" in b ? "hsl" : "hsb" : "gradient" in b || "stops" in b || "radial" in b ? "gradient" : "gray" in b ? "gray" : "rgb";
                  var W = i[L], V = n[L];
                  this._components = A = [];
                  for (var C = 0, P = W.length; C < P; C++) {
                    var Q = b[W[C]];
                    Q == null && !C && L === "gradient" && "stops" in b && (Q = {
                      stops: b.stops,
                      radial: b.radial
                    }), Q = V[C].call(this, Q), Q != null && (A[C] = Q);
                  }
                  U = b.alpha;
                }
              T && L && (E = 1);
            }
            if (this._type = L || "rgb", !A) {
              this._components = A = [];
              for (var V = n[this._type], C = 0, P = V.length; C < P; C++) {
                var Q = V[C].call(this, k && k[C]);
                Q != null && (A[C] = Q);
              }
            }
            return this._components = A, this._properties = i[this._type], this._alpha = U, T && (this.__read = E), this;
          },
          set: "#initialize",
          _serialize: function(_, b) {
            var x = this.getComponents();
            return a.serialize(
              /^(gray|rgb)$/.test(this._type) ? x : [this._type].concat(x),
              _,
              !0,
              b
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(_) {
            var b;
            return this._type === _ ? this._components.slice() : (b = m[this._type + "-" + _]) ? b.apply(this, this._components) : m["rgb-" + _].apply(
              this,
              m[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(_) {
            return new At(_, this._convert(_), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(_) {
            this._components = this._convert(_), this._properties = i[_], this._type = _;
          },
          getComponents: function() {
            var _ = this._components.slice();
            return this._alpha != null && _.push(this._alpha), _;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(_) {
            this._alpha = _ == null ? null : Math.min(Math.max(_, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(_) {
            var b = a.isPlainValue(_, !0) ? At.read(arguments) : _;
            return b === this || b && this._class === b._class && this._type === b._type && this.getAlpha() === b.getAlpha() && a.equals(this._components, b._components) || !1;
          },
          toString: function() {
            for (var _ = this._properties, b = [], x = this._type === "gradient", T = I.instance, E = 0, L = _.length; E < L; E++) {
              var A = this._components[E];
              A != null && b.push(_[E] + ": " + (x ? A : T.number(A)));
            }
            return this._alpha != null && b.push("alpha: " + T.number(this._alpha)), "{ " + b.join(", ") + " }";
          },
          toCSS: function(_) {
            var b = this._convert("rgb"), x = _ || this._alpha == null ? 1 : this._alpha;
            function T(E) {
              return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
            }
            return b = [
              T(b[0]),
              T(b[1]),
              T(b[2])
            ], x < 1 && b.push(x < 0 ? 0 : x), _ ? "#" + ((1 << 24) + (b[0] << 16) + (b[1] << 8) + b[2]).toString(16).slice(1) : (b.length == 4 ? "rgba(" : "rgb(") + b.join(",") + ")";
          },
          toCanvasStyle: function(_, b) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var x = this._components, T = x[0], E = T._stops, L = x[1], A = x[2], U = x[3], k = b && b.inverted(), F;
            if (k && (L = k._transformPoint(L), A = k._transformPoint(A), U && (U = k._transformPoint(U))), T._radial) {
              var B = A.getDistance(L);
              if (U) {
                var R = U.subtract(L);
                R.getLength() > B && (U = L.add(R.normalize(B - 0.1)));
              }
              var C = U || L;
              F = _.createRadialGradient(
                C.x,
                C.y,
                0,
                L.x,
                L.y,
                B
              );
            } else
              F = _.createLinearGradient(
                L.x,
                L.y,
                A.x,
                A.y
              );
            for (var P = 0, H = E.length; P < H; P++) {
              var W = E[P], V = W._offset;
              F.addColorStop(
                V ?? P / (H - 1),
                W._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = F;
          },
          transform: function(_) {
            if (this._type === "gradient") {
              for (var b = this._components, x = 1, T = b.length; x < T; x++) {
                var E = b[x];
                _._transformPoint(E, E, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var _ = Math.random;
              return new At(_(), _(), _());
            },
            _setOwner: function(_, b, x) {
              return _ && (_._owner && b && _._owner !== b && (_ = _.clone()), !_._owner ^ !b && (_._owner = b || null, _._setter = x || null)), _;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(n, s) {
            return n + s;
          },
          subtract: function(n, s) {
            return n - s;
          },
          multiply: function(n, s) {
            return n * s;
          },
          divide: function(n, s) {
            return n / s;
          }
        };
        return a.each(i, function(n, s) {
          this[s] = function(l) {
            l = At.read(arguments);
            for (var h = this._type, d = this._components, m = l._convert(h), _ = 0, b = d.length; _ < b; _++)
              m[_] = n(d[_], m[_]);
            return new At(
              h,
              m,
              this._alpha != null ? n(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), Ni = a.extend({
      _class: "Gradient",
      initialize: function(i, n) {
        this._id = Z.get(), i && a.isPlainObject(i) && (this.set(i), i = n = null), this._stops == null && this.setStops(i || ["white", "black"]), this._radial == null && this.setRadial(typeof n == "string" && n === "radial" || n || !1);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._stops, this._radial],
            i,
            !0,
            n
          );
        });
      },
      _changed: function() {
        for (var i = 0, n = this._owners && this._owners.length; i < n; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var n = this._owners ? this._owners.indexOf(i) : -1;
        n != -1 && (this._owners.splice(n, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], n = 0, s = this._stops.length; n < s; n++)
          i[n] = this._stops[n].clone();
        return new Ni(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var n = this._stops;
        if (n)
          for (var s = 0, l = n.length; s < l; s++)
            n[s]._owner = t;
        n = this._stops = rn.readList(i, 0, { clone: !0 });
        for (var s = 0, l = n.length; s < l; s++)
          n[s]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var n = this._stops, s = i._stops, l = n.length;
          if (l === s.length) {
            for (var h = 0; h < l; h++)
              if (!n[h].equals(s[h]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), rn = a.extend({
      _class: "GradientStop",
      initialize: function(i, n) {
        var s = i, l = n;
        typeof i == "object" && n === t && (Array.isArray(i) && typeof i[0] != "number" ? (s = i[0], l = i[1]) : ("color" in i || "offset" in i || "rampPoint" in i) && (s = i.color, l = i.offset || i.rampPoint || 0)), this.setColor(s), this.setOffset(l);
      },
      clone: function() {
        return new rn(this._color.clone(), this._offset);
      },
      _serialize: function(i, n) {
        var s = this._color, l = this._offset;
        return a.serialize(
          l == null ? [s] : [s, l],
          i,
          !0,
          n
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        At._setOwner(this._color, null), this._color = At._setOwner(
          At.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), ui = a.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new M(),
        selectedColor: null
      }, n = a.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), s = a.set({}, n, {
        fillColor: new At()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, h = {
        beans: !0
      }, d = {
        _class: "Style",
        beans: !0,
        initialize: function(m, _, b) {
          this._values = {}, this._owner = _, this._project = _ && _._project || b || He.project, this._defaults = !_ || _ instanceof j ? n : _ instanceof $t ? s : i, m && this.set(m);
        }
      };
      return a.each(n, function(m, _) {
        var b = /Color$/.test(_), x = _ === "shadowOffset", T = a.capitalize(_), E = l[_], L = "set" + T, A = "get" + T;
        d[L] = function(U) {
          var k = this._owner, F = k && k._children, B = F && F.length > 0 && !(k instanceof Zt);
          if (B)
            for (var R = 0, C = F.length; R < C; R++)
              F[R]._style[L](U);
          if ((_ === "selectedColor" || !B) && _ in this._defaults) {
            var P = this._values[_];
            P !== U && (b && (P && (At._setOwner(P, null), P._canvasStyle = null), U && U.constructor === At && (U = At._setOwner(
              U,
              k,
              B && L
            ))), this._values[_] = U, k && k._changed(E || 129));
          }
        }, d[A] = function(U) {
          var k = this._owner, F = k && k._children, B = F && F.length > 0 && !(k instanceof Zt), R;
          if (B && !U)
            for (var C = 0, P = F.length; C < P; C++) {
              var H = F[C]._style[A]();
              if (!C)
                R = H;
              else if (!a.equals(R, H))
                return t;
            }
          else if (_ in this._defaults) {
            var R = this._values[_];
            if (R === t)
              R = this._defaults[_], R && R.clone && (R = R.clone());
            else {
              var W = b ? At : x ? M : null;
              W && !(R && R.constructor === W) && (this._values[_] = R = W.read(
                [R],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return R && b && (R = At._setOwner(R, k, B && L)), R;
        }, h[A] = function(U) {
          return this._style[A](U);
        }, h[L] = function(U) {
          this._style[L](U);
        };
      }), a.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(m, _) {
        var b = "get" + _, x = "set" + _;
        d[b] = h[b] = "#get" + m, d[x] = h[x] = "#set" + m;
      }), K.inject(h), d;
    }(), {
      set: function(i) {
        var n = i instanceof ui, s = n ? i._values : i;
        if (s) {
          for (var l in s)
            if (l in this._defaults) {
              var h = s[l];
              this[l] = h && n && h.clone ? h.clone() : h;
            }
        }
      },
      equals: function(i) {
        function n(s, l, h) {
          var d = s._values, m = l._values, _ = l._defaults;
          for (var b in d) {
            var x = d[b], T = m[b];
            if (!(h && b in m) && !a.equals(
              x,
              T === t ? _[b] : T
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && n(this, i) && n(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var n = i.base.call(this), s = this.getFontSize();
        return /pt|em|%|px/.test(s) && (s = this.getView().getPixelSize(s)), n ?? s * 1.2;
      }
    }), Wt = new function() {
      function i(n, s, l, h) {
        for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], m = s[0].toUpperCase() + s.substring(1), _ = 0; _ < 6; _++) {
          var b = d[_], x = b ? b + m : s;
          if (x in n) {
            if (l)
              n[x] = h;
            else
              return n[x];
            break;
          }
        }
      }
      return {
        getStyles: function(n) {
          var s = n && n.nodeType !== 9 ? n.ownerDocument : n, l = s && s.defaultView;
          return l && l.getComputedStyle(n, "");
        },
        getBounds: function(n, s) {
          var l = n.ownerDocument, h = l.body, d = l.documentElement, m;
          try {
            m = n.getBoundingClientRect();
          } catch {
            m = { left: 0, top: 0, width: 0, height: 0 };
          }
          var _ = m.left - (d.clientLeft || h.clientLeft || 0), b = m.top - (d.clientTop || h.clientTop || 0);
          if (!s) {
            var x = l.defaultView;
            _ += x.pageXOffset || d.scrollLeft || h.scrollLeft, b += x.pageYOffset || d.scrollTop || h.scrollTop;
          }
          return new G(_, b, m.width, m.height);
        },
        getViewportBounds: function(n) {
          var s = n.ownerDocument, l = s.defaultView, h = s.documentElement;
          return new G(
            0,
            0,
            l.innerWidth || h.clientWidth,
            l.innerHeight || h.clientHeight
          );
        },
        getOffset: function(n, s) {
          return Wt.getBounds(n, s).getPoint();
        },
        getSize: function(n) {
          return Wt.getBounds(n, !0).getSize();
        },
        isInvisible: function(n) {
          return Wt.getSize(n).equals(new Y(0, 0));
        },
        isInView: function(n) {
          return !Wt.isInvisible(n) && Wt.getViewportBounds(n).intersects(
            Wt.getBounds(n, !0)
          );
        },
        isInserted: function(n) {
          return o.body.contains(n);
        },
        getPrefixed: function(n, s) {
          return n && i(n, s);
        },
        setPrefixed: function(n, s, l) {
          if (typeof s == "object")
            for (var h in s)
              i(n, h, !0, s[h]);
          else
            i(n, s, !0, l);
        }
      };
    }(), Qt = {
      add: function(i, n) {
        if (i)
          for (var s in n)
            for (var l = n[s], h = s.split(/[\s,]+/g), d = 0, m = h.length; d < m; d++) {
              var _ = h[d], b = i === o && (_ === "touchstart" || _ === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(_, l, b);
            }
      },
      remove: function(i, n) {
        if (i)
          for (var s in n)
            for (var l = n[s], h = s.split(/[\s,]+/g), d = 0, m = h.length; d < m; d++)
              i.removeEventListener(h[d], l, !1);
      },
      getPoint: function(i) {
        var n = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new M(
          n.pageX || n.clientX + o.documentElement.scrollLeft,
          n.pageY || n.clientY + o.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, n) {
        return Qt.getPoint(i).subtract(Wt.getOffset(
          n || Qt.getTarget(i)
        ));
      }
    };
    Qt.requestAnimationFrame = new function() {
      var i = Wt.getPrefixed(r, "requestAnimationFrame"), n = !1, s = [], l;
      function h() {
        var d = s;
        s = [];
        for (var m = 0, _ = d.length; m < _; m++)
          d[m]();
        n = i && s.length, n && i(h);
      }
      return function(d) {
        s.push(d), i ? n || (i(h), n = !0) : l || (l = setInterval(h, 1e3 / 60));
      };
    }();
    var ei = a.extend(
      u,
      {
        _class: "View",
        initialize: function i(n, s) {
          function l(E) {
            return s[E] || parseInt(s.getAttribute(E), 10);
          }
          function h() {
            var E = Wt.getSize(s);
            return E.isNaN() || E.isZero() ? new Y(l("width"), l("height")) : E;
          }
          var d;
          if (r && s) {
            this._id = s.getAttribute("id"), this._id == null && s.setAttribute("id", this._id = "paper-view-" + i._id++), Qt.add(s, this._viewEvents);
            var m = "none";
            if (Wt.setPrefixed(s.style, {
              userDrag: m,
              userSelect: m,
              touchCallout: m,
              contentZooming: m,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), f.hasAttribute(s, "resize")) {
              var _ = this;
              Qt.add(r, this._windowEvents = {
                resize: function() {
                  _.setViewSize(h());
                }
              });
            }
            if (d = h(), f.hasAttribute(s, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var b = this._stats.domElement, x = b.style, T = Wt.getOffset(s);
              x.position = "absolute", x.left = T.x + "px", x.top = T.y + "px", o.body.appendChild(b);
            }
          } else
            d = new Y(s), s = null;
          this._project = n, this._scope = n._scope, this._element = s, this._pixelRatio || (this._pixelRatio = r && r.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new J())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !He.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          ei._focused === this && (ei._focused = null), ei._views.splice(ei._views.indexOf(this), 1), delete ei._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Qt.remove(this._element, this._viewEvents), Qt.remove(r, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: a.each(
          K._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Qt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var n = i._element;
                (!Wt.getPrefixed(o, "hidden") || f.getAttribute(n, "keepalive") === "true") && Wt.isInView(n) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          He = this._scope;
          var i = Date.now() / 1e3, n = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new a({
            delta: n,
            time: this._time += n,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, n) {
          var s = this._frameItems;
          n ? (s[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete s[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var n in this._frameItems) {
            var s = this._frameItems[n];
            s.item.emit("frame", new a(i, {
              time: s.time += i.delta,
              count: s.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new ie(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = Y.read(arguments), n = i.subtract(this._viewSize);
          n.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: n }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, n) {
          var s = this._element;
          s && (s.width !== i && (s.width = i), s.height !== n && (s.height = n));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new G(new M(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return Wt.isInView(this._element);
        },
        isInserted: function() {
          return Wt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var n = this._element, s;
          if (n) {
            var l = n.parentNode, h = o.createElement("div");
            h.style.fontSize = i, l.appendChild(h), s = parseFloat(Wt.getStyles(h).fontSize), l.removeChild(h);
          } else
            s = parseFloat(s);
          return s;
        },
        getTextWidth: function(i, n) {
          return 0;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (n ? a : M).read(s), h = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            h || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = M.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new J().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          n != null && i != null && this.rotate(i - n);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new X(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = M.read(arguments, 0, { clone: !0, readNull: !0 });
          i && n && this.scale(n.x / i.x, n.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(M.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Qt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, n) {
            o && typeof n == "string" && (n = o.getElementById(n));
            var s = r ? on : ei;
            return new s(i, n);
          }
        }
      },
      new function() {
        if (!r)
          return;
        var i, n, s = !1, l = !1;
        function h(se) {
          var ge = Qt.getTarget(se);
          return ge.getAttribute && ei._viewsById[ge.getAttribute("id")];
        }
        function d() {
          var se = ei._focused;
          if (!se || !se.isVisible()) {
            for (var ge = 0, me = ei._views.length; ge < me; ge++)
              if ((se = ei._views[ge]).isVisible()) {
                ei._focused = n = se;
                break;
              }
          }
        }
        function m(se, ge, me) {
          se._handleMouseEvent("mousemove", ge, me);
        }
        var _ = r.navigator, b, x, T;
        _.pointerEnabled || _.msPointerEnabled ? (b = "pointerdown MSPointerDown", x = "pointermove MSPointerMove", T = "pointerup pointercancel MSPointerUp MSPointerCancel") : (b = "touchstart", x = "touchmove", T = "touchend touchcancel", "ontouchstart" in r && _.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (b += " mousedown", x += " mousemove", T += " mouseup"));
        var E = {}, L = {
          mouseout: function(se) {
            var ge = ei._focused, me = Qt.getRelatedTarget(se);
            if (ge && (!me || me.nodeName === "HTML")) {
              var we = Qt.getOffset(se, ge._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), Je = 1 << 25, tt = Ge - Je;
              we.x = Ae(tt) < Ge ? tt * (Se < 0 ? -1 : 1) : Se, m(ge, se, ge.viewToProject(we));
            }
          },
          scroll: d
        };
        E[b] = function(se) {
          var ge = ei._focused = h(se);
          s || (s = !0, ge._handleMouseEvent("mousedown", se));
        }, L[x] = function(se) {
          var ge = ei._focused;
          if (!l) {
            var me = h(se);
            me ? ge !== me && (ge && m(ge, se), i || (i = ge), ge = ei._focused = n = me) : n && n === ge && (i && !i.isInserted() && (i = null), ge = ei._focused = i, i = null, d());
          }
          ge && m(ge, se);
        }, L[b] = function() {
          l = !0;
        }, L[T] = function(se) {
          var ge = ei._focused;
          ge && s && ge._handleMouseEvent("mouseup", se), l = s = !1;
        }, Qt.add(o, L), Qt.add(r, {
          load: d
        });
        var A = !1, U = !1, k = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, F = !1, B, R, C, P, H, W, V, Q;
        function ae(se, ge, me, we, Se, Ae, Ge) {
          var Je = !1, tt;
          function ft(Ne, ze) {
            if (Ne.responds(ze)) {
              if (tt || (tt = new xt(
                ze,
                we,
                Se,
                ge || Ne,
                Ae ? Se.subtract(Ae) : null
              )), Ne.emit(ze, tt) && (A = !0, tt.prevented && (U = !0), tt.stopped))
                return Je = !0;
            } else {
              var nt = k[ze];
              if (nt)
                return ft(Ne, nt);
            }
          }
          for (; se && se !== Ge && !ft(se, me); )
            se = se._parent;
          return Je;
        }
        function le(se, ge, me, we, Se, Ae) {
          return se._project.removeOn(me), U = A = !1, H && ae(
            H,
            null,
            me,
            we,
            Se,
            Ae
          ) || ge && ge !== H && !ge.isDescendant(H) && ae(ge, null, me === "mousedrag" ? "mousemove" : me, we, Se, Ae, H) || ae(
            se,
            H || ge || se,
            me,
            we,
            Se,
            Ae
          );
        }
        var fe = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: E,
          _handleMouseEvent: function(se, ge, me) {
            var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, Je = this;
            function tt(Pt) {
              return we.virtual[Pt] || Je.responds(Pt) || Ge && Ge.responds(Pt);
            }
            Ae && s && tt("mousedrag") && (se = "mousedrag"), me || (me = this.getEventPoint(ge));
            var ft = this.getBounds().contains(me), Ne = Se && ft && Je._project.hitTest(me, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), ze = Ne && Ne.item || null, nt = !1, _t = {};
            if (_t[se.substr(5)] = !0, Se && ze !== P && (P && ae(P, null, "mouseleave", ge, me), ze && ae(ze, null, "mouseenter", ge, me), P = ze), F ^ ft && (ae(
              this,
              null,
              ft ? "mouseenter" : "mouseleave",
              ge,
              me
            ), nt = !0), (ft || _t.drag) && !me.equals(R) && (le(
              this,
              ze,
              Ae ? se : "mousemove",
              ge,
              me,
              R
            ), nt = !0), F = ft, _t.down && ft || _t.up && B) {
              if (le(this, ze, se, ge, me, B), _t.down) {
                if (Q = ze === W && Date.now() - V < 300, C = W = ze, !U && ze) {
                  for (var mt = ze; mt && !mt.responds("mousedrag"); )
                    mt = mt._parent;
                  mt && (H = ze);
                }
                B = me;
              } else
                _t.up && (!U && ze === C && (V = Date.now(), le(this, ze, Q ? "doubleclick" : "click", ge, me, B), Q = !1), C = H = null);
              F = !1, nt = !0;
            }
            R = me, nt && Ge && (A = Ge._handleMouseEvent(se, ge, me, _t) || A), ge.cancelable !== !1 && (A && !_t.move || _t.down && tt("mouseup")) && ge.preventDefault();
          },
          _handleKeyEvent: function(se, ge, me, we) {
            var Se = this._scope, Ae = Se.tool, Ge;
            function Je(tt) {
              tt.responds(se) && (He = Se, tt.emit(se, Ge = Ge || new pe(se, ge, me, we)));
            }
            this.isVisible() && (Je(this), Ae && Ae.responds(se) && Je(Ae));
          },
          _countItemEvent: function(se, ge) {
            var me = this._itemEvents, we = me.native, Se = me.virtual;
            for (var Ae in fe)
              we[Ae] = (we[Ae] || 0) + (fe[Ae][se] || 0) * ge;
            Se[se] = (Se[se] || 0) + ge;
          },
          statics: {
            updateFocus: d,
            _resetState: function() {
              s = l = A = F = !1, i = n = B = R = C = P = H = W = V = Q = null;
            }
          }
        };
      }()
    ), on = ei.extend({
      _class: "CanvasView",
      initialize: function(i, n) {
        if (!(n instanceof r.HTMLCanvasElement)) {
          var s = Y.read(arguments, 1);
          if (s.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + a.slice(arguments, 1)
            );
          n = dt.getCanvas(s);
        }
        var l = this._context = n.getContext("2d");
        if (l.save(), this._pixelRatio = 1, !/^off|false$/.test(f.getAttribute(n, "hidpi"))) {
          var h = r.devicePixelRatio || 1, d = Wt.getPrefixed(
            l,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = h / d;
        }
        ei.call(this, i, n), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(n, s) {
        var l = this._pixelRatio;
        if (i.base.call(this, n * l, s * l), l !== 1) {
          var h = this._element, d = this._context;
          if (!f.hasAttribute(h, "resize")) {
            var m = h.style;
            m.width = n + "px", m.height = s + "px";
          }
          d.restore(), d.save(), d.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(n) {
        var s = He.agent, l;
        if (s && s.firefox)
          l = i.base.call(this, n);
        else {
          var h = this._context, d = h.font;
          h.font = n + " serif", l = parseFloat(h.font), h.font = d;
        }
        return l;
      },
      getTextWidth: function(i, n) {
        var s = this._context, l = s.font, h = 0;
        s.font = i;
        for (var d = 0, m = n.length; d < m; d++)
          h = Math.max(h, s.measureText(n[d]).width);
        return s.font = l, h;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, n = this._context, s = this._viewSize;
        return n.clearRect(0, 0, s.width + 1, s.height + 1), i && i.draw(n, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), tn = a.extend({
      _class: "Event",
      initialize: function(i) {
        this.event = i, this.type = i && i.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return Tt.modifiers;
      }
    }), pe = tn.extend({
      _class: "KeyEvent",
      initialize: function(i, n, s, l) {
        this.type = i, this.event = n, this.key = s, this.character = l;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), Tt = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, n = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, s = {}, l = {}, h, d, m = new a({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var x = He && He.agent;
            return x && x.mac ? this.meta : this.control;
          }
        }
      });
      function _(x) {
        var T = x.key || x.keyIdentifier;
        return T = /^U\+/.test(T) ? String.fromCharCode(parseInt(T.substr(2), 16)) : /^Arrow[A-Z]/.test(T) ? T.substr(5) : T === "Unidentified" || T === t ? String.fromCharCode(x.keyCode) : T, i[T] || (T.length > 1 ? a.hyphenate(T) : T.toLowerCase());
      }
      function b(x, T, E, L) {
        var A = ei._focused, U;
        if (s[T] = x, x ? l[T] = E : delete l[T], T.length > 1 && (U = a.camelize(T)) in m) {
          m[U] = x;
          var k = He && He.agent;
          if (U === "meta" && k && k.mac)
            if (x)
              h = {};
            else {
              for (var F in h)
                F in l && b(!1, F, h[F], L);
              h = null;
            }
        } else
          x && h && (h[T] = E);
        A && A._handleKeyEvent(
          x ? "keydown" : "keyup",
          L,
          T,
          E
        );
      }
      return Qt.add(o, {
        keydown: function(x) {
          var T = _(x), E = He && He.agent;
          T.length > 1 || E && E.chrome && (x.altKey || E.mac && x.metaKey || !E.mac && x.ctrlKey) ? b(
            !0,
            T,
            n[T] || (T.length > 1 ? "" : T),
            x
          ) : d = T;
        },
        keypress: function(x) {
          if (d) {
            var T = _(x), E = x.charCode, L = E >= 32 ? String.fromCharCode(E) : T.length > 1 ? "" : T;
            T !== d && (T = L.toLowerCase()), b(!0, T, L, x), d = null;
          }
        },
        keyup: function(x) {
          var T = _(x);
          T in l && b(!1, T, l[T], x);
        }
      }), Qt.add(r, {
        blur: function(x) {
          for (var T in l)
            b(!1, T, l[T], x);
        }
      }), {
        modifiers: m,
        isDown: function(x) {
          return !!s[x];
        }
      };
    }(), xt = tn.extend({
      _class: "MouseEvent",
      initialize: function(i, n, s, l, h) {
        this.type = i, this.event = n, this.point = s, this.target = l, this.delta = h;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Re = tn.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(i, n, s) {
        this.tool = i, this.type = n, this.event = s;
      },
      _choosePoint: function(i, n) {
        return i || (n ? n.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var n = i.item, s = n._parent; /^(Group|CompoundPath)$/.test(s._class); )
              n = s, s = s._parent;
            this._item = n;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ie = v.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(i) {
        v.call(this), this._moveCount = -1, this._downCount = -1, this.set(i);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, n, s, l) {
        He = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var h = l.move || l.drag, d = this.responds(i), m = this.minDistance, _ = this.maxDistance, b = !1, x = this;
        function T(L, A) {
          var U = s, k = h ? x._point : x._downPoint || U;
          if (h) {
            if (x._moveCount >= 0 && U.equals(k))
              return !1;
            if (k && (L != null || A != null)) {
              var F = U.subtract(k), B = F.getLength();
              if (B < (L || 0))
                return !1;
              A && (U = k.add(F.normalize(
                Math.min(B, A)
              )));
            }
            x._moveCount++;
          }
          return x._point = U, x._lastPoint = k || U, l.down && (x._moveCount = -1, x._downPoint = U, x._downCount++), !0;
        }
        function E() {
          d && (b = x.emit(i, new Re(x, i, n)) || b);
        }
        if (l.down)
          T(), E();
        else if (l.up)
          T(null, _), E();
        else if (d)
          for (; T(m, _); )
            E();
        return b;
      }
    }), Qe = a.extend(u, {
      _class: "Tween",
      statics: {
        easings: new a({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(n, s, l, h, d, m) {
        this.object = n;
        var _ = typeof d, b = _ === "function";
        this.type = b ? _ : _ === "string" ? d : "linear", this.easing = b ? d : i.easings[this.type], this.duration = h, this.running = !1, this._then = null, this._startTime = null;
        var x = s || l;
        this._keys = x ? Object.keys(x) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = x && this._getState(s), this._to = x && this._getState(l), m !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var n = this.easing(i), s = this._keys, l = function(T) {
            return typeof T == "function" ? T(n, i) : T;
          }, h = 0, d = s && s.length; h < d; h++) {
            var m = s[h], _ = l(this._from[m]), b = l(this._to[m]), x = _ && b && _.__add && b.__add ? b.__subtract(_).__multiply(n).__add(_) : (b - _) * n + _;
            this._setProperty(this._parsedKeys[m], x);
          }
          this.responds("update") && this.emit("update", new a({
            progress: i,
            factor: n
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var n = this._startTime, s = n ? (i - n) / this.duration : 0;
        n || (this._startTime = i), this.update(s);
      },
      _getState: function(i) {
        for (var n = this._keys, s = {}, l = 0, h = n.length; l < h; l++) {
          var d = n[l], m = this._parsedKeys[d], _ = this._getProperty(m), b;
          if (i) {
            var x = this._resolveValue(_, i[d]);
            this._setProperty(m, x), b = this._getProperty(m), b = b && b.clone ? b.clone() : b, this._setProperty(m, _);
          } else
            b = _ && _.clone ? _.clone() : _;
          s[d] = b;
        }
        return s;
      },
      _resolveValue: function(i, n) {
        if (n) {
          if (Array.isArray(n) && n.length === 2) {
            var s = n[0];
            return s && s.match && s.match(/^[+\-\*\/]=/) ? this._calculate(i, s[0], n[1]) : n;
          } else if (typeof n == "string") {
            var l = n.match(/^[+\-*/]=(.*)/);
            if (l) {
              var h = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, n[0], h);
            }
          }
        }
        return n;
      },
      _calculate: function(i, n, s) {
        return He.PaperScript.calculateBinary(i, n, s);
      },
      _parseKeys: function(i) {
        for (var n = {}, s = 0, l = i.length; s < l; s++) {
          var h = i[s], d = h.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          n[h] = d.split("/");
        }
        return n;
      },
      _getProperty: function(i, n) {
        for (var s = this.object, l = 0, h = i.length - (n || 0); l < h && s; l++)
          s = s[i[l]];
        return s;
      },
      _setProperty: function(i, n) {
        var s = this._getProperty(i, 1);
        s && (s[i[i.length - 1]] = n);
      }
    }), Bt = {
      request: function(i) {
        var n = new e.XMLHttpRequest();
        return n.open(
          (i.method || "get").toUpperCase(),
          i.url,
          a.pick(i.async, !0)
        ), i.mimeType && n.overrideMimeType(i.mimeType), n.onload = function() {
          var s = n.status;
          s === 0 || s === 200 ? i.onLoad && i.onLoad.call(n, n.responseText) : n.onerror();
        }, n.onerror = function() {
          var s = n.status, l = 'Could not load "' + i.url + '" (Status: ' + s + ")";
          if (i.onError)
            i.onError(l, s);
          else
            throw new Error(l);
        }, n.send(null);
      }
    }, dt = a.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, n, s) {
        if (!r)
          return null;
        var l, h = !0;
        typeof i == "object" && (n = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = o.createElement("canvas"), h = !1);
        var d = l.getContext("2d", s || {});
        if (!d)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === n ? h && d.clearRect(0, 0, i + 1, n + 1) : (l.width = i, l.height = n), d.save(), l;
      },
      getContext: function(i, n, s) {
        var l = this.getCanvas(i, n, s);
        return l ? l.getContext("2d", s || {}) : null;
      },
      release: function(i) {
        var n = i && i.canvas ? i.canvas : i;
        n && n.getContext && (n.getContext("2d").restore(), this.canvases.push(n));
      }
    }, et = new function() {
      var i = Math.min, n = Math.max, s = Math.abs, l, h, d, m, _, b, x, T, E, L, A;
      function U(H, W, V) {
        return 0.2989 * H + 0.587 * W + 0.114 * V;
      }
      function k(H, W, V, le) {
        var ae = le - U(H, W, V);
        E = H + ae, L = W + ae, A = V + ae;
        var le = U(E, L, A), fe = i(E, L, A), se = n(E, L, A);
        if (fe < 0) {
          var ge = le - fe;
          E = le + (E - le) * le / ge, L = le + (L - le) * le / ge, A = le + (A - le) * le / ge;
        }
        if (se > 255) {
          var me = 255 - le, we = se - le;
          E = le + (E - le) * me / we, L = le + (L - le) * me / we, A = le + (A - le) * me / we;
        }
      }
      function F(H, W, V) {
        return n(H, W, V) - i(H, W, V);
      }
      function B(H, W, V, Q) {
        var ae = [H, W, V], le = n(H, W, V), fe = i(H, W, V), se;
        fe = fe === H ? 0 : fe === W ? 1 : 2, le = le === H ? 0 : le === W ? 1 : 2, se = i(fe, le) === 0 ? n(fe, le) === 1 ? 2 : 1 : 0, ae[le] > ae[fe] ? (ae[se] = (ae[se] - ae[fe]) * Q / (ae[le] - ae[fe]), ae[le] = Q) : ae[se] = ae[le] = 0, ae[fe] = 0, E = ae[0], L = ae[1], A = ae[2];
      }
      var R = {
        multiply: function() {
          E = _ * l / 255, L = b * h / 255, A = x * d / 255;
        },
        screen: function() {
          E = _ + l - _ * l / 255, L = b + h - b * h / 255, A = x + d - x * d / 255;
        },
        overlay: function() {
          E = _ < 128 ? 2 * _ * l / 255 : 255 - 2 * (255 - _) * (255 - l) / 255, L = b < 128 ? 2 * b * h / 255 : 255 - 2 * (255 - b) * (255 - h) / 255, A = x < 128 ? 2 * x * d / 255 : 255 - 2 * (255 - x) * (255 - d) / 255;
        },
        "soft-light": function() {
          var H = l * _ / 255;
          E = H + _ * (255 - (255 - _) * (255 - l) / 255 - H) / 255, H = h * b / 255, L = H + b * (255 - (255 - b) * (255 - h) / 255 - H) / 255, H = d * x / 255, A = H + x * (255 - (255 - x) * (255 - d) / 255 - H) / 255;
        },
        "hard-light": function() {
          E = l < 128 ? 2 * l * _ / 255 : 255 - 2 * (255 - l) * (255 - _) / 255, L = h < 128 ? 2 * h * b / 255 : 255 - 2 * (255 - h) * (255 - b) / 255, A = d < 128 ? 2 * d * x / 255 : 255 - 2 * (255 - d) * (255 - x) / 255;
        },
        "color-dodge": function() {
          E = _ === 0 ? 0 : l === 255 ? 255 : i(255, 255 * _ / (255 - l)), L = b === 0 ? 0 : h === 255 ? 255 : i(255, 255 * b / (255 - h)), A = x === 0 ? 0 : d === 255 ? 255 : i(255, 255 * x / (255 - d));
        },
        "color-burn": function() {
          E = _ === 255 ? 255 : l === 0 ? 0 : n(0, 255 - (255 - _) * 255 / l), L = b === 255 ? 255 : h === 0 ? 0 : n(0, 255 - (255 - b) * 255 / h), A = x === 255 ? 255 : d === 0 ? 0 : n(0, 255 - (255 - x) * 255 / d);
        },
        darken: function() {
          E = _ < l ? _ : l, L = b < h ? b : h, A = x < d ? x : d;
        },
        lighten: function() {
          E = _ > l ? _ : l, L = b > h ? b : h, A = x > d ? x : d;
        },
        difference: function() {
          E = _ - l, E < 0 && (E = -E), L = b - h, L < 0 && (L = -L), A = x - d, A < 0 && (A = -A);
        },
        exclusion: function() {
          E = _ + l * (255 - _ - _) / 255, L = b + h * (255 - b - b) / 255, A = x + d * (255 - x - x) / 255;
        },
        hue: function() {
          B(l, h, d, F(_, b, x)), k(E, L, A, U(_, b, x));
        },
        saturation: function() {
          B(_, b, x, F(l, h, d)), k(E, L, A, U(_, b, x));
        },
        luminosity: function() {
          k(_, b, x, U(l, h, d));
        },
        color: function() {
          k(l, h, d, U(_, b, x));
        },
        add: function() {
          E = i(_ + l, 255), L = i(b + h, 255), A = i(x + d, 255);
        },
        subtract: function() {
          E = n(_ - l, 0), L = n(b - h, 0), A = n(x - d, 0);
        },
        average: function() {
          E = (_ + l) / 2, L = (b + h) / 2, A = (x + d) / 2;
        },
        negation: function() {
          E = 255 - s(255 - l - _), L = 255 - s(255 - h - b), A = 255 - s(255 - d - x);
        }
      }, C = this.nativeModes = a.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(H) {
        this[H] = !0;
      }, {}), P = dt.getContext(1, 1, { willReadFrequently: !0 });
      P && (a.each(R, function(H, W) {
        var V = W === "darken", Q = !1;
        P.save();
        try {
          P.fillStyle = V ? "#300" : "#a00", P.fillRect(0, 0, 1, 1), P.globalCompositeOperation = W, P.globalCompositeOperation === W && (P.fillStyle = V ? "#a00" : "#300", P.fillRect(0, 0, 1, 1), Q = P.getImageData(0, 0, 1, 1).data[0] !== V ? 170 : 51);
        } catch {
        }
        P.restore(), C[W] = Q;
      }), dt.release(P)), this.process = function(H, W, V, Q, ae) {
        var le = W.canvas, fe = H === "normal";
        if (fe || C[H])
          V.save(), V.setTransform(1, 0, 0, 1, 0, 0), V.globalAlpha = Q, fe || (V.globalCompositeOperation = H), V.drawImage(le, ae.x, ae.y), V.restore();
        else {
          var se = R[H];
          if (!se)
            return;
          for (var ge = V.getImageData(
            ae.x,
            ae.y,
            le.width,
            le.height
          ), me = ge.data, we = W.getImageData(
            0,
            0,
            le.width,
            le.height
          ).data, Se = 0, Ae = me.length; Se < Ae; Se += 4) {
            l = we[Se], _ = me[Se], h = we[Se + 1], b = me[Se + 1], d = we[Se + 2], x = me[Se + 2], m = we[Se + 3], T = me[Se + 3], se();
            var Ge = m * Q / 255, Je = 1 - Ge;
            me[Se] = Ge * E + Je * _, me[Se + 1] = Ge * L + Je * b, me[Se + 2] = Ge * A + Je * x, me[Se + 3] = m * Q + Je * T;
          }
          V.putImageData(ge, ae.x, ae.y);
        }
      };
    }(), wt = new function() {
      var i = "http://www.w3.org/2000/svg", n = "http://www.w3.org/2000/xmlns", s = "http://www.w3.org/1999/xlink", l = {
        href: s,
        xlink: n,
        xmlns: n + "/",
        "xmlns:xlink": n + "/"
      };
      function h(_, b, x) {
        return m(o.createElementNS(i, _), b, x);
      }
      function d(_, b) {
        var x = l[b], T = x ? _.getAttributeNS(x, b) : _.getAttribute(b);
        return T === "null" ? null : T;
      }
      function m(_, b, x) {
        for (var T in b) {
          var E = b[T], L = l[T];
          typeof E == "number" && x && (E = x.number(E)), L ? _.setAttributeNS(L, T, E) : _.setAttribute(T, E);
        }
        return _;
      }
      return {
        svg: i,
        xmlns: n,
        xlink: s,
        create: h,
        get: d,
        set: m
      };
    }(), Xt = a.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, n) {
        return !n && (i instanceof Gt || i instanceof ke || i instanceof $t);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, n) {
      var s = a.capitalize(n), l = i[2];
      this[n] = {
        type: i[1],
        property: n,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && a.each(l, function(h, d) {
          this[h] = d;
        }, {}),
        exportFilter: i[3],
        get: "get" + s,
        set: "set" + s
      };
    }, {});
    new function() {
      var i;
      function n(R, C, P) {
        var H = new a(), W = R.getTranslation();
        if (C) {
          var V;
          R.isInvertible() ? (R = R._shiftless(), V = R._inverseTransform(W), W = null) : V = new M(), H[P ? "cx" : "x"] = V.x, H[P ? "cy" : "y"] = V.y;
        }
        if (!R.isIdentity()) {
          var Q = R.decompose();
          if (Q) {
            var ae = [], le = Q.rotation, fe = Q.scaling, se = Q.skewing;
            W && !W.isZero() && ae.push("translate(" + i.point(W) + ")"), le && ae.push("rotate(" + i.number(le) + ")"), (!D.isZero(fe.x - 1) || !D.isZero(fe.y - 1)) && ae.push("scale(" + i.point(fe) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), H.transform = ae.join(" ");
          } else
            H.transform = "matrix(" + R.getValues().join(",") + ")";
        }
        return H;
      }
      function s(R, C) {
        for (var P = n(R._matrix), H = R._children, W = wt.create("g", P, i), V = 0, Q = H.length; V < Q; V++) {
          var ae = H[V], le = F(ae, C);
          if (le)
            if (ae.isClipMask()) {
              var fe = wt.create("clipPath");
              fe.appendChild(le), U(ae, fe, "clip"), wt.set(W, {
                "clip-path": "url(#" + fe.id + ")"
              });
            } else
              W.appendChild(le);
        }
        return W;
      }
      function l(R, C) {
        var P = n(R._matrix, !0), H = R.getSize(), W = R.getImage();
        return P.x -= H.width / 2, P.y -= H.height / 2, P.width = H.width, P.height = H.height, P.href = C.embedImages == !1 && W && W.src || R.toDataURL(), wt.create("image", P, i);
      }
      function h(R, C) {
        var P = C.matchShapes;
        if (P) {
          var H = R.toShape(!1);
          if (H)
            return d(H);
        }
        var W = R._segments, V = W.length, Q, ae = n(R._matrix);
        if (P && V >= 2 && !R.hasHandles())
          if (V > 2) {
            Q = R._closed ? "polygon" : "polyline";
            for (var le = [], fe = 0; fe < V; fe++)
              le.push(i.point(W[fe]._point));
            ae.points = le.join(" ");
          } else {
            Q = "line";
            var se = W[0]._point, ge = W[1]._point;
            ae.set({
              x1: se.x,
              y1: se.y,
              x2: ge.x,
              y2: ge.y
            });
          }
        else
          Q = "path", ae.d = R.getPathData(null, C.precision);
        return wt.create(Q, ae, i);
      }
      function d(R) {
        var C = R._type, P = R._radius, H = n(R._matrix, !0, C !== "rectangle");
        if (C === "rectangle") {
          C = "rect";
          var W = R._size, V = W.width, Q = W.height;
          H.x -= V / 2, H.y -= Q / 2, H.width = V, H.height = Q, P.isZero() && (P = null);
        }
        return P && (C === "circle" ? H.r = P : (H.rx = P.width, H.ry = P.height)), wt.create(C, H, i);
      }
      function m(R, C) {
        var P = n(R._matrix), H = R.getPathData(null, C.precision);
        return H && (P.d = H), wt.create("path", P, i);
      }
      function _(R, C) {
        var P = n(R._matrix, !0), H = R._definition, W = A(H, "symbol"), V = H._item, Q = V.getStrokeBounds();
        return W || (W = wt.create("symbol", {
          viewBox: i.rectangle(Q)
        }), W.appendChild(F(V, C)), U(H, W, "symbol")), P.href = "#" + W.id, P.x += Q.x, P.y += Q.y, P.width = Q.width, P.height = Q.height, P.overflow = "visible", wt.create("use", P, i);
      }
      function b(R) {
        var C = A(R, "color");
        if (!C) {
          var P = R.getGradient(), H = P._radial, W = R.getOrigin(), V = R.getDestination(), Q;
          if (H) {
            Q = {
              cx: W.x,
              cy: W.y,
              r: W.getDistance(V)
            };
            var ae = R.getHighlight();
            ae && (Q.fx = ae.x, Q.fy = ae.y);
          } else
            Q = {
              x1: W.x,
              y1: W.y,
              x2: V.x,
              y2: V.y
            };
          Q.gradientUnits = "userSpaceOnUse", C = wt.create((H ? "radial" : "linear") + "Gradient", Q, i);
          for (var le = P._stops, fe = 0, se = le.length; fe < se; fe++) {
            var ge = le[fe], me = ge._color, we = me.getAlpha(), Se = ge._offset;
            Q = {
              offset: Se ?? fe / (se - 1)
            }, me && (Q["stop-color"] = me.toCSS(!0)), we < 1 && (Q["stop-opacity"] = we), C.appendChild(
              wt.create("stop", Q, i)
            );
          }
          U(R, C, "color");
        }
        return "url(#" + C.id + ")";
      }
      function x(R) {
        var C = wt.create(
          "text",
          n(R._matrix, !0),
          i
        );
        return C.textContent = R._content, C;
      }
      var T = {
        Group: s,
        Layer: s,
        Raster: l,
        Path: h,
        Shape: d,
        CompoundPath: m,
        SymbolItem: _,
        PointText: x
      };
      function E(R, C, P) {
        var H = {}, W = !P && R.getParent(), V = [];
        return R._name != null && (H.id = R._name), a.each(Xt, function(Q) {
          var ae = Q.get, le = Q.type, fe = R[ae]();
          if (Q.exportFilter ? Q.exportFilter(R, fe) : !W || !a.equals(W[ae](), fe)) {
            if (le === "color" && fe != null) {
              var se = fe.getAlpha();
              se < 1 && (H[Q.attribute + "-opacity"] = se);
            }
            le === "style" ? V.push(Q.attribute + ": " + fe) : H[Q.attribute] = fe == null ? "none" : le === "color" ? fe.gradient ? b(fe) : fe.toCSS(!0) : le === "array" ? fe.join(",") : le === "lookup" ? Q.toSVG[fe] : fe;
          }
        }), V.length && (H.style = V.join(";")), H.opacity === 1 && delete H.opacity, R._visible || (H.visibility = "hidden"), wt.set(C, H, i);
      }
      var L;
      function A(R, C) {
        return L || (L = { ids: {}, svgs: {} }), R && L.svgs[C + "-" + (R._id || R.__id || (R.__id = Z.get("svg")))];
      }
      function U(R, C, P) {
        L || A();
        var H = L.ids[P] = (L.ids[P] || 0) + 1;
        C.id = P + "-" + H, L.svgs[P + "-" + (R._id || R.__id)] = C;
      }
      function k(R, C) {
        var P = R, H = null;
        if (L) {
          P = R.nodeName.toLowerCase() === "svg" && R;
          for (var W in L.svgs)
            H || (P || (P = wt.create("svg"), P.appendChild(R)), H = P.insertBefore(
              wt.create("defs"),
              P.firstChild
            )), H.appendChild(L.svgs[W]);
          L = null;
        }
        return C.asString ? new e.XMLSerializer().serializeToString(P) : P;
      }
      function F(R, C, P) {
        var H = T[R._class], W = H && H(R, C);
        if (W) {
          var V = C.onExport;
          V && (W = V(R, W, C) || W);
          var Q = JSON.stringify(R._data);
          Q && Q !== "{}" && Q !== "null" && W.setAttribute("data-paper-data", Q);
        }
        return W && E(R, W, P);
      }
      function B(R) {
        return R || (R = {}), i = new I(R.precision), R;
      }
      K.inject({
        exportSVG: function(R) {
          return R = B(R), k(F(this, R, !0), R);
        }
      }), ve.inject({
        exportSVG: function(R) {
          R = B(R);
          var C = this._children, P = this.getView(), H = a.pick(R.bounds, "view"), W = R.matrix || H === "view" && P._matrix, V = W && J.read([W]), Q = H === "view" ? new G([0, 0], P.getViewSize()) : H === "content" ? K._getBounds(C, V, { stroke: !0 }).rect : G.read([H], 0, { readNull: !0 }), ae = {
            version: "1.1",
            xmlns: wt.svg,
            "xmlns:xlink": wt.xlink
          };
          Q && (ae.width = Q.width, ae.height = Q.height, (Q.x || Q.x === 0 || Q.y || Q.y === 0) && (ae.viewBox = i.rectangle(Q)));
          var le = wt.create("svg", ae, i), fe = le;
          V && !V.isIdentity() && (fe = le.appendChild(wt.create(
            "g",
            n(V),
            i
          )));
          for (var se = 0, ge = C.length; se < ge; se++)
            fe.appendChild(F(C[se], R, !0));
          return k(le, R);
        }
      });
    }(), new function() {
      var i = {}, n;
      function s(C, P, H, W, V, Q) {
        var ae = wt.get(C, P) || Q, le = ae == null ? W ? null : H ? "" : 0 : H ? ae : parseFloat(ae);
        return /%\s*$/.test(ae) ? le / 100 * (V ? 1 : n[/x|^width/.test(P) ? "width" : "height"]) : le;
      }
      function l(C, P, H, W, V, Q, ae) {
        return P = s(C, P || "x", !1, W, V, Q), H = s(C, H || "y", !1, W, V, ae), W && (P == null || H == null) ? null : new M(P, H);
      }
      function h(C, P, H, W, V) {
        return P = s(C, P || "width", !1, W, V), H = s(C, H || "height", !1, W, V), W && (P == null || H == null) ? null : new Y(P, H);
      }
      function d(C, P, H) {
        return C === "none" ? null : P === "number" ? parseFloat(C) : P === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : P === "color" ? F(C) || C : P === "lookup" ? H[C] : C;
      }
      function m(C, P, H, W) {
        var V = C.childNodes, Q = P === "clippath", ae = P === "defs", le = new j(), fe = le._project, se = fe._currentStyle, ge = [];
        if (!Q && !ae && (le = k(le, C, W), fe._currentStyle = le._style.clone()), W)
          for (var me = C.querySelectorAll("defs"), we = 0, Se = me.length; we < Se; we++)
            B(me[we], H, !1);
        for (var we = 0, Se = V.length; we < Se; we++) {
          var Ae = V[we], Ge;
          Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = B(Ae, H, !1)) && !(Ge instanceof Be) && ge.push(Ge);
        }
        return le.addChildren(ge), Q && (le = k(le.reduce(), C, W)), fe._currentStyle = se, (Q || ae) && (le.remove(), le = null), le;
      }
      function _(C, P) {
        for (var H = C.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), W = [], V = 0, Q = H.length; V < Q; V += 2)
          W.push(new M(
            parseFloat(H[V]),
            parseFloat(H[V + 1])
          ));
        var ae = new it(W);
        return P === "polygon" && ae.closePath(), ae;
      }
      function b(C) {
        return Gt.create(C.getAttribute("d"));
      }
      function x(C, P) {
        var H = (s(C, "href", !0) || "").substring(1), W = P === "radialgradient", V;
        if (H)
          V = i[H].getGradient(), V._radial ^ W && (V = V.clone(), V._radial = W);
        else {
          for (var Q = C.childNodes, ae = [], le = 0, fe = Q.length; le < fe; le++) {
            var se = Q[le];
            se.nodeType === 1 && ae.push(k(new rn(), se));
          }
          V = new Ni(ae, W);
        }
        var ge, me, we, Se = s(C, "gradientUnits", !0) !== "userSpaceOnUse";
        W ? (ge = l(
          C,
          "cx",
          "cy",
          !1,
          Se,
          "50%",
          "50%"
        ), me = ge.add(
          s(C, "r", !1, !1, Se, "50%"),
          0
        ), we = l(C, "fx", "fy", !0, Se)) : (ge = l(
          C,
          "x1",
          "y1",
          !1,
          Se,
          "0%",
          "0%"
        ), me = l(
          C,
          "x2",
          "y2",
          !1,
          Se,
          "100%",
          "0%"
        ));
        var Ae = k(
          new At(V, ge, me, we),
          C
        );
        return Ae._scaleToBounds = Se, null;
      }
      var T = {
        "#document": function(C, P, H, W) {
          for (var V = C.childNodes, Q = 0, ae = V.length; Q < ae; Q++) {
            var le = V[Q];
            if (le.nodeType === 1)
              return B(le, H, W);
          }
        },
        g: m,
        svg: m,
        clippath: m,
        polygon: _,
        polyline: _,
        path: b,
        lineargradient: x,
        radialgradient: x,
        image: function(C) {
          var P = new $e(s(C, "href", !0));
          return P.on("load", function() {
            var H = h(C);
            this.setSize(H);
            var W = l(C).add(H.divide(2));
            this._matrix.append(new J().translate(W));
          }), P;
        },
        symbol: function(C, P, H, W) {
          return new Be(
            m(C, P, H, W),
            !0
          );
        },
        defs: m,
        use: function(C) {
          var P = (s(C, "href", !0) || "").substring(1), H = i[P], W = l(C);
          return H ? H instanceof Be ? H.place(W) : H.clone().translate(W) : null;
        },
        circle: function(C) {
          return new ke.Circle(
            l(C, "cx", "cy"),
            s(C, "r")
          );
        },
        ellipse: function(C) {
          return new ke.Ellipse({
            center: l(C, "cx", "cy"),
            radius: h(C, "rx", "ry")
          });
        },
        rect: function(C) {
          return new ke.Rectangle(new G(
            l(C),
            h(C)
          ), h(C, "rx", "ry"));
        },
        line: function(C) {
          return new it.Line(
            l(C, "x1", "y1"),
            l(C, "x2", "y2")
          );
        },
        text: function(C) {
          var P = new Kt(l(C).add(
            l(C, "dx", "dy")
          ));
          return P.setContent(C.textContent.trim() || ""), P;
        },
        switch: m
      };
      function E(C, P, H, W) {
        if (C.transform) {
          for (var V = (W.getAttribute(H) || "").split(/\)\s*/g), Q = new J(), ae = 0, le = V.length; ae < le; ae++) {
            var fe = V[ae];
            if (!fe)
              break;
            for (var se = fe.split(/\(\s*/), ge = se[0], me = se[1].split(/[\s,]+/g), we = 0, Se = me.length; we < Se; we++)
              me[we] = parseFloat(me[we]);
            switch (ge) {
              case "matrix":
                Q.append(
                  new J(me[0], me[1], me[2], me[3], me[4], me[5])
                );
                break;
              case "rotate":
                Q.rotate(me[0], me[1] || 0, me[2] || 0);
                break;
              case "translate":
                Q.translate(me[0], me[1] || 0);
                break;
              case "scale":
                Q.scale(me);
                break;
              case "skewX":
                Q.skew(me[0], 0);
                break;
              case "skewY":
                Q.skew(0, me[0]);
                break;
            }
          }
          C.transform(Q);
        }
      }
      function L(C, P, H) {
        var W = H === "fill-opacity" ? "getFillColor" : "getStrokeColor", V = C[W] && C[W]();
        V && V.setAlpha(parseFloat(P));
      }
      var A = a.set(a.each(Xt, function(C) {
        this[C.attribute] = function(P, H) {
          if (P[C.set] && (P[C.set](d(H, C.type, C.fromSVG)), C.type === "color")) {
            var W = P[C.get]();
            if (W && W._scaleToBounds) {
              var V = P.getBounds();
              W.transform(new J().translate(V.getPoint()).scale(V.getSize()));
            }
          }
        };
      }, {}), {
        id: function(C, P) {
          i[P] = C, C.setName && C.setName(P);
        },
        "clip-path": function(C, P) {
          var H = F(P);
          if (H)
            if (H = H.clone(), H.setClipMask(!0), C instanceof j)
              C.insertChild(0, H);
            else
              return new j(H, C);
        },
        gradientTransform: E,
        transform: E,
        "fill-opacity": L,
        "stroke-opacity": L,
        visibility: function(C, P) {
          C.setVisible && C.setVisible(P === "visible");
        },
        display: function(C, P) {
          C.setVisible && C.setVisible(P !== null);
        },
        "stop-color": function(C, P) {
          C.setColor && C.setColor(P);
        },
        "stop-opacity": function(C, P) {
          C._color && C._color.setAlpha(parseFloat(P));
        },
        offset: function(C, P) {
          if (C.setOffset) {
            var H = P.match(/(.*)%$/);
            C.setOffset(H ? H[1] / 100 : parseFloat(P));
          }
        },
        viewBox: function(C, P, H, W, V) {
          var Q = new G(d(P, "array")), ae = h(W, null, null, !0), le, fe;
          if (C instanceof j) {
            var se = ae ? ae.divide(Q.getSize()) : 1, fe = new J().scale(se).translate(Q.getPoint().negate());
            le = C;
          } else
            C instanceof Be && (ae && Q.setSize(ae), le = C._item);
          if (le) {
            if (U(W, "overflow", V) !== "visible") {
              var ge = new ke.Rectangle(Q);
              ge.setClipMask(!0), le.addChild(ge);
            }
            fe && le.transform(fe);
          }
        }
      });
      function U(C, P, H) {
        var W = C.attributes[P], V = W && W.value;
        if (!V && C.style) {
          var Q = a.camelize(P);
          V = C.style[Q], !V && H.node[Q] !== H.parent[Q] && (V = H.node[Q]);
        }
        return V ? V === "none" ? null : V : t;
      }
      function k(C, P, H) {
        var W = P.parentNode, V = {
          node: Wt.getStyles(P) || {},
          parent: !H && !/^defs$/i.test(W.tagName) && Wt.getStyles(W) || {}
        };
        return a.each(A, function(Q, ae) {
          var le = U(P, ae, V);
          C = le !== t && Q(C, le, ae, P, V) || C;
        }), C;
      }
      function F(C) {
        var P = C && C.match(/\((?:["'#]*)([^"')]+)/), H = P && P[1], W = H && i[r ? H.replace(r.location.href.split("#")[0] + "#", "") : H];
        return W && W._scaleToBounds && (W = W.clone(), W._scaleToBounds = !0), W;
      }
      function B(C, P, H) {
        var W = C.nodeName.toLowerCase(), V = W !== "#document", Q = o.body, ae, le, fe;
        H && V && (n = He.getView().getSize(), n = h(C, null, null, !0) || n, ae = wt.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), le = C.parentNode, fe = C.nextSibling, ae.appendChild(C), Q.appendChild(ae));
        var se = He.settings, ge = se.applyMatrix, me = se.insertItems;
        se.applyMatrix = !1, se.insertItems = !1;
        var we = T[W], Se = we && we(C, W, P, H) || null;
        if (se.insertItems = me, se.applyMatrix = ge, Se) {
          V && !(Se instanceof j) && (Se = k(Se, C, H));
          var Ae = P.onImport, Ge = V && C.getAttribute("data-paper-data");
          Ae && (Se = Ae(C, Se, P) || Se), P.expandShapes && Se instanceof ke && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
        }
        return ae && (Q.removeChild(ae), le && (fe ? le.insertBefore(C, fe) : le.appendChild(C))), H && (i = {}, Se && a.pick(P.applyMatrix, ge) && Se.matrix.apply(!0, !0)), Se;
      }
      function R(C, P, H) {
        if (!C)
          return null;
        P = typeof P == "function" ? { onLoad: P } : P || {};
        var W = He, V = null;
        function Q(se) {
          try {
            var ge = typeof se == "object" ? se : new e.DOMParser().parseFromString(
              se.trim(),
              "image/svg+xml"
            );
            if (!ge.nodeName)
              throw ge = null, new Error("Unsupported SVG source: " + C);
            He = W, V = B(ge, P, !0), (!P || P.insert !== !1) && H._insertItem(t, V);
            var me = P.onLoad;
            me && me(V, se);
          } catch (we) {
            ae(we);
          }
        }
        function ae(se, ge) {
          var me = P.onError;
          if (me)
            me(se, ge);
          else
            throw new Error(se);
        }
        if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
          var le = o.getElementById(C);
          le ? Q(le) : Bt.request({
            url: C,
            async: !0,
            onLoad: Q,
            onError: ae
          });
        } else if (typeof File < "u" && C instanceof File) {
          var fe = new FileReader();
          return fe.onload = function() {
            Q(fe.result);
          }, fe.onerror = function() {
            ae(fe.error);
          }, fe.readAsText(C);
        } else
          Q(C);
        return V;
      }
      K.inject({
        importSVG: function(C, P) {
          return R(C, P, this);
        }
      }), ve.inject({
        importSVG: function(C, P) {
          return this.activate(), R(C, P, this);
        }
      });
    }(), a.exports.PaperScript = (function() {
      var i = this, n = i.acorn;
      if (!n && typeof Py < "u")
        try {
          n = require("acorn");
        } catch {
        }
      if (!n) {
        var s, l;
        n = s = l = {}, function(k, F) {
          if (typeof s == "object" && typeof l == "object")
            return F(s);
          if (typeof t == "function" && t.amd)
            return t(["exports"], F);
          F(k.acorn || (k.acorn = {}));
        }(this, function(k) {
          k.version = "0.5.0";
          var F, B, R, C;
          k.parse = function(ee, oe) {
            return B = String(ee), R = B.length, H(oe), _e(), Js(F.program);
          };
          var P = k.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function H(ee) {
            F = ee || {};
            for (var oe in P)
              Object.prototype.hasOwnProperty.call(F, oe) || (F[oe] = P[oe]);
            C = F.sourceFile || null;
          }
          var W = k.getLineInfo = function(ee, oe) {
            for (var Me = 1, Ee = 0; ; ) {
              O.lastIndex = Ee;
              var at = O.exec(ee);
              if (at && at.index < oe)
                ++Me, Ee = at.index + at[0].length;
              else
                break;
            }
            return { line: Me, column: oe - Ee };
          };
          k.tokenize = function(ee, oe) {
            B = String(ee), R = B.length, H(oe), _e();
            var Me = {};
            function Ee(at) {
              return Ge = ae, fn(at), Me.start = Q, Me.end = ae, Me.startLoc = le, Me.endLoc = fe, Me.type = se, Me.value = ge, Me;
            }
            return Ee.jumpTo = function(at, Mt) {
              if (V = at, F.locations) {
                we = 1, Se = O.lastIndex = 0;
                for (var vt; (vt = O.exec(B)) && vt.index < at; )
                  ++we, Se = vt.index + vt[0].length;
              }
              me = Mt, Ke();
            }, Ee;
          };
          var V, Q, ae, le, fe, se, ge, me, we, Se, Ae, Ge, Je, tt, ft, Ne;
          function ze(ee, oe) {
            var Me = W(B, ee);
            oe += " (" + Me.line + ":" + Me.column + ")";
            var Ee = new SyntaxError(oe);
            throw Ee.pos = ee, Ee.loc = Me, Ee.raisedAt = V, Ee;
          }
          var nt = [], _t = { type: "num" }, mt = { type: "regexp" }, Pt = { type: "string" }, Et = { type: "name" }, zt = { type: "eof" }, jt = { keyword: "break" }, Ft = { keyword: "case", beforeExpr: !0 }, Mi = { keyword: "catch" }, Rt = { keyword: "continue" }, hi = { keyword: "debugger" }, ci = { keyword: "default" }, ni = { keyword: "do", isLoop: !0 }, di = { keyword: "else", beforeExpr: !0 }, Hi = { keyword: "finally" }, xi = { keyword: "for", isLoop: !0 }, qi = { keyword: "function" }, Ti = { keyword: "if" }, Ci = { keyword: "return", beforeExpr: !0 }, Xi = { keyword: "switch" }, Gi = { keyword: "throw", beforeExpr: !0 }, Ki = { keyword: "try" }, un = { keyword: "var" }, nn = { keyword: "while", isLoop: !0 }, Wn = { keyword: "with" }, ir = { keyword: "new", beforeExpr: !0 }, Tr = { keyword: "this" }, yr = { keyword: "null", atomValue: null }, In = { keyword: "true", atomValue: !0 }, nr = { keyword: "false", atomValue: !1 }, si = { keyword: "in", binop: 7, beforeExpr: !0 }, ur = {
            break: jt,
            case: Ft,
            catch: Mi,
            continue: Rt,
            debugger: hi,
            default: ci,
            do: ni,
            else: di,
            finally: Hi,
            for: xi,
            function: qi,
            if: Ti,
            return: Ci,
            switch: Xi,
            throw: Gi,
            try: Ki,
            var: un,
            while: nn,
            with: Wn,
            null: yr,
            true: In,
            false: nr,
            new: ir,
            in: si,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Tr,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Dn = { type: "[", beforeExpr: !0 }, Mn = { type: "]" }, gn = { type: "{", beforeExpr: !0 }, Cn = { type: "}" }, cn = { type: "(", beforeExpr: !0 }, Ji = { type: ")" }, g = { type: ",", beforeExpr: !0 }, z = { type: ";", beforeExpr: !0 }, ce = { type: ":", beforeExpr: !0 }, xe = { type: "." }, Pe = { type: "?", beforeExpr: !0 }, rt = { binop: 10, beforeExpr: !0 }, pt = { isAssign: !0, beforeExpr: !0 }, Dt = { isAssign: !0, beforeExpr: !0 }, qt = { postfix: !0, prefix: !0, isUpdate: !0 }, gi = { prefix: !0, beforeExpr: !0 }, vi = { binop: 1, beforeExpr: !0 }, ln = { binop: 2, beforeExpr: !0 }, cr = { binop: 3, beforeExpr: !0 }, Lr = { binop: 4, beforeExpr: !0 }, br = { binop: 5, beforeExpr: !0 }, Fr = { binop: 6, beforeExpr: !0 }, Fi = { binop: 7, beforeExpr: !0 }, Ri = { binop: 8, beforeExpr: !0 }, Ps = { binop: 9, prefix: !0, beforeExpr: !0 }, bs = { binop: 10, beforeExpr: !0 };
          k.tokTypes = {
            bracketL: Dn,
            bracketR: Mn,
            braceL: gn,
            braceR: Cn,
            parenL: cn,
            parenR: Ji,
            comma: g,
            semi: z,
            colon: ce,
            dot: xe,
            question: Pe,
            slash: rt,
            eq: pt,
            name: Et,
            eof: zt,
            num: _t,
            regexp: mt,
            string: Pt
          };
          for (var ls in ur)
            k.tokTypes["_" + ls] = ur[ls];
          function rr(ee) {
            ee = ee.split(" ");
            var oe = "", Me = [];
            e:
              for (var Ee = 0; Ee < ee.length; ++Ee) {
                for (var at = 0; at < Me.length; ++at)
                  if (Me[at][0].length == ee[Ee].length) {
                    Me[at].push(ee[Ee]);
                    continue e;
                  }
                Me.push([ee[Ee]]);
              }
            function Mt(Vt) {
              if (Vt.length == 1)
                return oe += "return str === " + JSON.stringify(Vt[0]) + ";";
              oe += "switch(str){";
              for (var Ei = 0; Ei < Vt.length; ++Ei)
                oe += "case " + JSON.stringify(Vt[Ei]) + ":";
              oe += "return true}return false;";
            }
            if (Me.length > 3) {
              Me.sort(function(Vt, Ei) {
                return Ei.length - Vt.length;
              }), oe += "switch(str.length){";
              for (var Ee = 0; Ee < Me.length; ++Ee) {
                var vt = Me[Ee];
                oe += "case " + vt[0].length + ":", Mt(vt);
              }
              oe += "}";
            } else
              Mt(ee);
            return new Function("str", oe);
          }
          var xs = rr("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Ks = rr("class enum extends super const export import"), hs = rr("implements interface let package private protected public static yield"), Br = rr("eval arguments"), pn = rr("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), us = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Qn = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ns = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", Qr = new RegExp("[" + Qn + "]"), Zn = new RegExp("[" + Qn + Ns + "]"), w = /[\n\r\u2028\u2029]/, O = /\r\n|[\n\r\u2028\u2029]/g, q = k.isIdentifierStart = function(ee) {
            return ee < 65 ? ee === 36 : ee < 91 ? !0 : ee < 97 ? ee === 95 : ee < 123 ? !0 : ee >= 170 && Qr.test(String.fromCharCode(ee));
          }, ne = k.isIdentifierChar = function(ee) {
            return ee < 48 ? ee === 36 : ee < 58 ? !0 : ee < 65 ? !1 : ee < 91 ? !0 : ee < 97 ? ee === 95 : ee < 123 ? !0 : ee >= 170 && Zn.test(String.fromCharCode(ee));
          };
          function de() {
            this.line = we, this.column = V - Se;
          }
          function _e() {
            we = 1, V = Se = 0, me = !0, Ke();
          }
          function ye(ee, oe) {
            ae = V, F.locations && (fe = new de()), se = ee, Ke(), ge = oe, me = ee.beforeExpr;
          }
          function Ve() {
            var ee = F.onComment && F.locations && new de(), oe = V, Me = B.indexOf("*/", V += 2);
            if (Me === -1 && ze(V - 2, "Unterminated comment"), V = Me + 2, F.locations) {
              O.lastIndex = oe;
              for (var Ee; (Ee = O.exec(B)) && Ee.index < V; )
                ++we, Se = Ee.index + Ee[0].length;
            }
            F.onComment && F.onComment(
              !0,
              B.slice(oe + 2, Me),
              oe,
              V,
              ee,
              F.locations && new de()
            );
          }
          function De() {
            for (var ee = V, oe = F.onComment && F.locations && new de(), Me = B.charCodeAt(V += 2); V < R && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
              ++V, Me = B.charCodeAt(V);
            F.onComment && F.onComment(
              !1,
              B.slice(ee + 2, V),
              ee,
              V,
              oe,
              F.locations && new de()
            );
          }
          function Ke() {
            for (; V < R; ) {
              var ee = B.charCodeAt(V);
              if (ee === 32)
                ++V;
              else if (ee === 13) {
                ++V;
                var oe = B.charCodeAt(V);
                oe === 10 && ++V, F.locations && (++we, Se = V);
              } else if (ee === 10 || ee === 8232 || ee === 8233)
                ++V, F.locations && (++we, Se = V);
              else if (ee > 8 && ee < 14)
                ++V;
              else if (ee === 47) {
                var oe = B.charCodeAt(V + 1);
                if (oe === 42)
                  Ve();
                else if (oe === 47)
                  De();
                else
                  break;
              } else if (ee === 160)
                ++V;
              else if (ee >= 5760 && us.test(String.fromCharCode(ee)))
                ++V;
              else
                break;
            }
          }
          function St() {
            var ee = B.charCodeAt(V + 1);
            return ee >= 48 && ee <= 57 ? Wi(!0) : (++V, ye(xe));
          }
          function Ct() {
            var ee = B.charCodeAt(V + 1);
            return me ? (++V, Bi()) : ee === 61 ? pi(Dt, 2) : pi(rt, 1);
          }
          function ut() {
            var ee = B.charCodeAt(V + 1);
            return ee === 61 ? pi(Dt, 2) : pi(bs, 1);
          }
          function Ut(ee) {
            var oe = B.charCodeAt(V + 1);
            return oe === ee ? pi(ee === 124 ? vi : ln, 2) : oe === 61 ? pi(Dt, 2) : pi(ee === 124 ? cr : br, 1);
          }
          function ti() {
            var ee = B.charCodeAt(V + 1);
            return ee === 61 ? pi(Dt, 2) : pi(Lr, 1);
          }
          function wi(ee) {
            var oe = B.charCodeAt(V + 1);
            return oe === ee ? oe == 45 && B.charCodeAt(V + 2) == 62 && w.test(B.slice(Ge, V)) ? (V += 3, De(), Ke(), fn()) : pi(qt, 2) : oe === 61 ? pi(Dt, 2) : pi(Ps, 1);
          }
          function bi(ee) {
            var oe = B.charCodeAt(V + 1), Me = 1;
            return oe === ee ? (Me = ee === 62 && B.charCodeAt(V + 2) === 62 ? 3 : 2, B.charCodeAt(V + Me) === 61 ? pi(Dt, Me + 1) : pi(Ri, Me)) : oe == 33 && ee == 60 && B.charCodeAt(V + 2) == 45 && B.charCodeAt(V + 3) == 45 ? (V += 4, De(), Ke(), fn()) : (oe === 61 && (Me = B.charCodeAt(V + 2) === 61 ? 3 : 2), pi(Fi, Me));
          }
          function An(ee) {
            var oe = B.charCodeAt(V + 1);
            return oe === 61 ? pi(Fr, B.charCodeAt(V + 2) === 61 ? 3 : 2) : pi(ee === 61 ? pt : gi, 1);
          }
          function _n(ee) {
            switch (ee) {
              case 46:
                return St();
              case 40:
                return ++V, ye(cn);
              case 41:
                return ++V, ye(Ji);
              case 59:
                return ++V, ye(z);
              case 44:
                return ++V, ye(g);
              case 91:
                return ++V, ye(Dn);
              case 93:
                return ++V, ye(Mn);
              case 123:
                return ++V, ye(gn);
              case 125:
                return ++V, ye(Cn);
              case 58:
                return ++V, ye(ce);
              case 63:
                return ++V, ye(Pe);
              case 48:
                var oe = B.charCodeAt(V + 1);
                if (oe === 120 || oe === 88)
                  return Oi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return Wi(!1);
              case 34:
              case 39:
                return es(ee);
              case 47:
                return Ct();
              case 37:
              case 42:
                return ut();
              case 124:
              case 38:
                return Ut(ee);
              case 94:
                return ti();
              case 43:
              case 45:
                return wi(ee);
              case 60:
              case 62:
                return bi(ee);
              case 61:
              case 33:
                return An(ee);
              case 126:
                return pi(gi, 1);
            }
            return !1;
          }
          function fn(ee) {
            if (ee ? V = Q + 1 : Q = V, F.locations && (le = new de()), ee)
              return Bi();
            if (V >= R)
              return ye(zt);
            var oe = B.charCodeAt(V);
            if (q(oe) || oe === 92)
              return Un();
            var Me = _n(oe);
            if (Me === !1) {
              var Ee = String.fromCharCode(oe);
              if (Ee === "\\" || Qr.test(Ee))
                return Un();
              ze(V, "Unexpected character '" + Ee + "'");
            }
            return Me;
          }
          function pi(ee, oe) {
            var Me = B.slice(V, V + oe);
            V += oe, ye(ee, Me);
          }
          function Bi() {
            for (var at = "", ee, oe, Me = V; ; ) {
              V >= R && ze(Me, "Unterminated regular expression");
              var Ee = B.charAt(V);
              if (w.test(Ee) && ze(Me, "Unterminated regular expression"), ee)
                ee = !1;
              else {
                if (Ee === "[")
                  oe = !0;
                else if (Ee === "]" && oe)
                  oe = !1;
                else if (Ee === "/" && !oe)
                  break;
                ee = Ee === "\\";
              }
              ++V;
            }
            var at = B.slice(Me, V);
            ++V;
            var Mt = fr();
            Mt && !/^[gmsiy]*$/.test(Mt) && ze(Me, "Invalid regexp flag");
            try {
              var vt = new RegExp(at, Mt);
            } catch (Vt) {
              Vt instanceof SyntaxError && ze(Me, Vt.message), ze(Vt);
            }
            return ye(mt, vt);
          }
          function On(ee, oe) {
            for (var Me = V, Ee = 0, at = 0, Mt = oe ?? 1 / 0; at < Mt; ++at) {
              var vt = B.charCodeAt(V), Vt;
              if (vt >= 97 ? Vt = vt - 97 + 10 : vt >= 65 ? Vt = vt - 65 + 10 : vt >= 48 && vt <= 57 ? Vt = vt - 48 : Vt = 1 / 0, Vt >= ee)
                break;
              ++V, Ee = Ee * ee + Vt;
            }
            return V === Me || oe != null && V - Me !== oe ? null : Ee;
          }
          function Oi() {
            V += 2;
            var ee = On(16);
            return ee == null && ze(Q + 2, "Expected hexadecimal number"), q(B.charCodeAt(V)) && ze(V, "Identifier directly after number"), ye(_t, ee);
          }
          function Wi(ee) {
            var oe = V, Me = !1, Ee = B.charCodeAt(V) === 48;
            !ee && On(10) === null && ze(oe, "Invalid number"), B.charCodeAt(V) === 46 && (++V, On(10), Me = !0);
            var at = B.charCodeAt(V);
            (at === 69 || at === 101) && (at = B.charCodeAt(++V), (at === 43 || at === 45) && ++V, On(10) === null && ze(oe, "Invalid number"), Me = !0), q(B.charCodeAt(V)) && ze(V, "Identifier directly after number");
            var Mt = B.slice(oe, V), vt;
            return Me ? vt = parseFloat(Mt) : !Ee || Mt.length === 1 ? vt = parseInt(Mt, 10) : /[89]/.test(Mt) || Ne ? ze(oe, "Invalid number") : vt = parseInt(Mt, 8), ye(_t, vt);
          }
          function es(ee) {
            V++;
            for (var oe = ""; ; ) {
              V >= R && ze(Q, "Unterminated string constant");
              var Me = B.charCodeAt(V);
              if (Me === ee)
                return ++V, ye(Pt, oe);
              if (Me === 92) {
                Me = B.charCodeAt(++V);
                var Ee = /^[0-7]+/.exec(B.slice(V, V + 3));
                for (Ee && (Ee = Ee[0]); Ee && parseInt(Ee, 8) > 255; )
                  Ee = Ee.slice(0, -1);
                if (Ee === "0" && (Ee = null), ++V, Ee)
                  Ne && ze(V - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(Ee, 8)), V += Ee.length - 1;
                else
                  switch (Me) {
                    case 110:
                      oe += `
`;
                      break;
                    case 114:
                      oe += "\r";
                      break;
                    case 120:
                      oe += String.fromCharCode(sr(2));
                      break;
                    case 117:
                      oe += String.fromCharCode(sr(4));
                      break;
                    case 85:
                      oe += String.fromCharCode(sr(8));
                      break;
                    case 116:
                      oe += "	";
                      break;
                    case 98:
                      oe += "\b";
                      break;
                    case 118:
                      oe += "\v";
                      break;
                    case 102:
                      oe += "\f";
                      break;
                    case 48:
                      oe += "\0";
                      break;
                    case 13:
                      B.charCodeAt(V) === 10 && ++V;
                    case 10:
                      F.locations && (Se = V, ++we);
                      break;
                    default:
                      oe += String.fromCharCode(Me);
                      break;
                  }
              } else
                (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && ze(Q, "Unterminated string constant"), oe += String.fromCharCode(Me), ++V;
            }
          }
          function sr(ee) {
            var oe = On(16, ee);
            return oe === null && ze(Q, "Bad character escape sequence"), oe;
          }
          var mn;
          function fr() {
            mn = !1;
            for (var ee, oe = !0, Me = V; ; ) {
              var Ee = B.charCodeAt(V);
              if (ne(Ee))
                mn && (ee += B.charAt(V)), ++V;
              else if (Ee === 92) {
                mn || (ee = B.slice(Me, V)), mn = !0, B.charCodeAt(++V) != 117 && ze(V, "Expecting Unicode escape sequence \\uXXXX"), ++V;
                var at = sr(4), Mt = String.fromCharCode(at);
                Mt || ze(V - 1, "Invalid Unicode escape"), (oe ? q(at) : ne(at)) || ze(V - 4, "Invalid Unicode escape"), ee += Mt;
              } else
                break;
              oe = !1;
            }
            return mn ? ee : B.slice(Me, V);
          }
          function Un() {
            var ee = fr(), oe = Et;
            return !mn && pn(ee) && (oe = ur[ee]), ye(oe, ee);
          }
          function Jt() {
            Ae = Q, Ge = ae, Je = fe, fn();
          }
          function qn(ee) {
            if (Ne = ee, V = Q, F.locations)
              for (; V < Se; )
                Se = B.lastIndexOf(`
`, Se - 2) + 1, --we;
            Ke(), fn();
          }
          function Pn() {
            this.type = null, this.start = Q, this.end = null;
          }
          function Er() {
            this.start = le, this.end = null, C !== null && (this.source = C);
          }
          function Si() {
            var ee = new Pn();
            return F.locations && (ee.loc = new Er()), F.directSourceFile && (ee.sourceFile = F.directSourceFile), F.ranges && (ee.range = [Q, 0]), ee;
          }
          function sn(ee) {
            var oe = new Pn();
            return oe.start = ee.start, F.locations && (oe.loc = new Er(), oe.loc.start = ee.loc.start), F.ranges && (oe.range = [ee.range[0], 0]), oe;
          }
          function Yt(ee, oe) {
            return ee.type = oe, ee.end = Ge, F.locations && (ee.loc.end = Je), F.ranges && (ee.range[1] = Ge), ee;
          }
          function kr(ee) {
            return F.ecmaVersion >= 5 && ee.type === "ExpressionStatement" && ee.expression.type === "Literal" && ee.expression.value === "use strict";
          }
          function ai(ee) {
            if (se === ee)
              return Jt(), !0;
          }
          function Pi() {
            return !F.strictSemicolons && (se === zt || se === Cn || w.test(B.slice(Ge, Q)));
          }
          function Tn() {
            !ai(z) && !Pi() && dn();
          }
          function oi(ee) {
            se === ee ? Jt() : dn();
          }
          function dn() {
            ze(Q, "Unexpected token");
          }
          function Ir(ee) {
            ee.type !== "Identifier" && ee.type !== "MemberExpression" && ze(ee.start, "Assigning to rvalue"), Ne && ee.type === "Identifier" && Br(ee.name) && ze(ee.start, "Assigning to " + ee.name + " in strict mode");
          }
          function Js(ee) {
            Ae = Ge = V, F.locations && (Je = new de()), tt = Ne = null, ft = [], fn();
            var oe = ee || Si(), Me = !0;
            for (ee || (oe.body = []); se !== zt; ) {
              var Ee = hn();
              oe.body.push(Ee), Me && kr(Ee) && qn(!0), Me = !1;
            }
            return Yt(oe, "Program");
          }
          var Ur = { kind: "loop" }, Xn = { kind: "switch" };
          function hn() {
            (se === rt || se === Dt && ge == "/=") && fn(!0);
            var ee = se, oe = Si();
            switch (ee) {
              case jt:
              case Rt:
                Jt();
                var Me = ee === jt;
                ai(z) || Pi() ? oe.label = null : se !== Et ? dn() : (oe.label = Ye(), Tn());
                for (var Ee = 0; Ee < ft.length; ++Ee) {
                  var at = ft[Ee];
                  if ((oe.label == null || at.name === oe.label.name) && (at.kind != null && (Me || at.kind === "loop") || oe.label && Me))
                    break;
                }
                return Ee === ft.length && ze(oe.start, "Unsyntactic " + ee.keyword), Yt(oe, Me ? "BreakStatement" : "ContinueStatement");
              case hi:
                return Jt(), Tn(), Yt(oe, "DebuggerStatement");
              case ni:
                return Jt(), ft.push(Ur), oe.body = hn(), ft.pop(), oi(nn), oe.test = Nn(), Tn(), Yt(oe, "DoWhileStatement");
              case xi:
                if (Jt(), ft.push(Ur), oi(cn), se === z)
                  return ar(oe, null);
                if (se === un) {
                  var Mt = Si();
                  return Jt(), dr(Mt, !0), Yt(Mt, "VariableDeclaration"), Mt.declarations.length === 1 && ai(si) ? Yn(oe, Mt) : ar(oe, Mt);
                }
                var Mt = Ui(!1, !0);
                return ai(si) ? (Ir(Mt), Yn(oe, Mt)) : ar(oe, Mt);
              case qi:
                return Jt(), Le(oe, !0);
              case Ti:
                return Jt(), oe.test = Nn(), oe.consequent = hn(), oe.alternate = ai(di) ? hn() : null, Yt(oe, "IfStatement");
              case Ci:
                return !tt && !F.allowReturnOutsideFunction && ze(Q, "'return' outside of function"), Jt(), ai(z) || Pi() ? oe.argument = null : (oe.argument = Ui(), Tn()), Yt(oe, "ReturnStatement");
              case Xi:
                Jt(), oe.discriminant = Nn(), oe.cases = [], oi(gn), ft.push(Xn);
                for (var vt, Vt; se != Cn; )
                  if (se === Ft || se === ci) {
                    var Ei = se === Ft;
                    vt && Yt(vt, "SwitchCase"), oe.cases.push(vt = Si()), vt.consequent = [], Jt(), Ei ? vt.test = Ui() : (Vt && ze(Ae, "Multiple default clauses"), Vt = !0, vt.test = null), oi(ce);
                  } else
                    vt || dn(), vt.consequent.push(hn());
                return vt && Yt(vt, "SwitchCase"), Jt(), ft.pop(), Yt(oe, "SwitchStatement");
              case Gi:
                return Jt(), w.test(B.slice(Ge, Q)) && ze(Ge, "Illegal newline after throw"), oe.argument = Ui(), Tn(), Yt(oe, "ThrowStatement");
              case Ki:
                if (Jt(), oe.block = Kn(), oe.handler = null, se === Mi) {
                  var $i = Si();
                  Jt(), oi(cn), $i.param = Ye(), Ne && Br($i.param.name) && ze($i.param.start, "Binding " + $i.param.name + " in strict mode"), oi(Ji), $i.guard = null, $i.body = Kn(), oe.handler = Yt($i, "CatchClause");
                }
                return oe.guardedHandlers = nt, oe.finalizer = ai(Hi) ? Kn() : null, !oe.handler && !oe.finalizer && ze(oe.start, "Missing catch or finally clause"), Yt(oe, "TryStatement");
              case un:
                return Jt(), dr(oe), Tn(), Yt(oe, "VariableDeclaration");
              case nn:
                return Jt(), oe.test = Nn(), ft.push(Ur), oe.body = hn(), ft.pop(), Yt(oe, "WhileStatement");
              case Wn:
                return Ne && ze(Q, "'with' in strict mode"), Jt(), oe.object = Nn(), oe.body = hn(), Yt(oe, "WithStatement");
              case gn:
                return Kn();
              case z:
                return Jt(), Yt(oe, "EmptyStatement");
              default:
                var vn = ge, wn = Ui();
                if (ee === Et && wn.type === "Identifier" && ai(ce)) {
                  for (var Ee = 0; Ee < ft.length; ++Ee)
                    ft[Ee].name === vn && ze(wn.start, "Label '" + vn + "' is already declared");
                  var gr = se.isLoop ? "loop" : se === Xi ? "switch" : null;
                  return ft.push({ name: vn, kind: gr }), oe.body = hn(), ft.pop(), oe.label = wn, Yt(oe, "LabeledStatement");
                } else
                  return oe.expression = wn, Tn(), Yt(oe, "ExpressionStatement");
            }
          }
          function Nn() {
            oi(cn);
            var ee = Ui();
            return oi(Ji), ee;
          }
          function Kn(ee) {
            var oe = Si(), Me = !0, Ee = !1, at;
            for (oe.body = [], oi(gn); !ai(Cn); ) {
              var Mt = hn();
              oe.body.push(Mt), Me && ee && kr(Mt) && (at = Ee, qn(Ee = !0)), Me = !1;
            }
            return Ee && !at && qn(!1), Yt(oe, "BlockStatement");
          }
          function ar(ee, oe) {
            return ee.init = oe, oi(z), ee.test = se === z ? null : Ui(), oi(z), ee.update = se === Ji ? null : Ui(), oi(Ji), ee.body = hn(), ft.pop(), Yt(ee, "ForStatement");
          }
          function Yn(ee, oe) {
            return ee.left = oe, ee.right = Ui(), oi(Ji), ee.body = hn(), ft.pop(), Yt(ee, "ForInStatement");
          }
          function dr(ee, oe) {
            for (ee.declarations = [], ee.kind = "var"; ; ) {
              var Me = Si();
              if (Me.id = Ye(), Ne && Br(Me.id.name) && ze(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = ai(pt) ? Ui(!0, oe) : null, ee.declarations.push(Yt(Me, "VariableDeclarator")), !ai(g))
                break;
            }
            return ee;
          }
          function Ui(ee, oe) {
            var Me = ts(oe);
            if (!ee && se === g) {
              var Ee = sn(Me);
              for (Ee.expressions = [Me]; ai(g); )
                Ee.expressions.push(ts(oe));
              return Yt(Ee, "SequenceExpression");
            }
            return Me;
          }
          function ts(ee) {
            var oe = cs(ee);
            if (se.isAssign) {
              var Me = sn(oe);
              return Me.operator = ge, Me.left = oe, Jt(), Me.right = ts(ee), Ir(oe), Yt(Me, "AssignmentExpression");
            }
            return oe;
          }
          function cs(ee) {
            var oe = xr(ee);
            if (ai(Pe)) {
              var Me = sn(oe);
              return Me.test = oe, Me.consequent = Ui(!0), oi(ce), Me.alternate = Ui(!0, ee), Yt(Me, "ConditionalExpression");
            }
            return oe;
          }
          function xr(ee) {
            return Ln(Vr(), -1, ee);
          }
          function Ln(ee, oe, Me) {
            var Ee = se.binop;
            if (Ee != null && (!Me || se !== si) && Ee > oe) {
              var at = sn(ee);
              at.left = ee, at.operator = ge;
              var Mt = se;
              Jt(), at.right = Ln(Vr(), Ee, Me);
              var vt = Yt(at, Mt === vi || Mt === ln ? "LogicalExpression" : "BinaryExpression");
              return Ln(vt, oe, Me);
            }
            return ee;
          }
          function Vr() {
            if (se.prefix) {
              var ee = Si(), oe = se.isUpdate;
              return ee.operator = ge, ee.prefix = !0, me = !0, Jt(), ee.argument = Vr(), oe ? Ir(ee.argument) : Ne && ee.operator === "delete" && ee.argument.type === "Identifier" && ze(ee.start, "Deleting local variable in strict mode"), Yt(ee, oe ? "UpdateExpression" : "UnaryExpression");
            }
            for (var Me = ws(); se.postfix && !Pi(); ) {
              var ee = sn(Me);
              ee.operator = ge, ee.prefix = !1, ee.argument = Me, Ir(Me), Jt(), Me = Yt(ee, "UpdateExpression");
            }
            return Me;
          }
          function ws() {
            return or(Oe());
          }
          function or(ee, oe) {
            if (ai(xe)) {
              var Me = sn(ee);
              return Me.object = ee, Me.property = Ye(!0), Me.computed = !1, or(Yt(Me, "MemberExpression"), oe);
            } else if (ai(Dn)) {
              var Me = sn(ee);
              return Me.object = ee, Me.property = Ui(), Me.computed = !0, oi(Mn), or(Yt(Me, "MemberExpression"), oe);
            } else if (!oe && ai(cn)) {
              var Me = sn(ee);
              return Me.callee = ee, Me.arguments = je(Ji, !1), or(Yt(Me, "CallExpression"), oe);
            } else
              return ee;
          }
          function Oe() {
            switch (se) {
              case Tr:
                var Ee = Si();
                return Jt(), Yt(Ee, "ThisExpression");
              case Et:
                return Ye();
              case _t:
              case Pt:
              case mt:
                var Ee = Si();
                return Ee.value = ge, Ee.raw = B.slice(Q, ae), Jt(), Yt(Ee, "Literal");
              case yr:
              case In:
              case nr:
                var Ee = Si();
                return Ee.value = se.atomValue, Ee.raw = se.keyword, Jt(), Yt(Ee, "Literal");
              case cn:
                var ee = le, oe = Q;
                Jt();
                var Me = Ui();
                return Me.start = oe, Me.end = ae, F.locations && (Me.loc.start = ee, Me.loc.end = fe), F.ranges && (Me.range = [oe, ae]), oi(Ji), Me;
              case Dn:
                var Ee = Si();
                return Jt(), Ee.elements = je(Mn, !0, !0), Yt(Ee, "ArrayExpression");
              case gn:
                return ht();
              case qi:
                var Ee = Si();
                return Jt(), Le(Ee, !1);
              case ir:
                return qe();
              default:
                dn();
            }
          }
          function qe() {
            var ee = Si();
            return Jt(), ee.callee = or(Oe(), !0), ai(cn) ? ee.arguments = je(Ji, !1) : ee.arguments = nt, Yt(ee, "NewExpression");
          }
          function ht() {
            var ee = Si(), oe = !0, Me = !1;
            for (ee.properties = [], Jt(); !ai(Cn); ) {
              if (oe)
                oe = !1;
              else if (oi(g), F.allowTrailingCommas && ai(Cn))
                break;
              var Ee = { key: gt() }, at = !1, Mt;
              if (ai(ce) ? (Ee.value = Ui(!0), Mt = Ee.kind = "init") : F.ecmaVersion >= 5 && Ee.key.type === "Identifier" && (Ee.key.name === "get" || Ee.key.name === "set") ? (at = Me = !0, Mt = Ee.kind = Ee.key.name, Ee.key = gt(), se !== cn && dn(), Ee.value = Le(Si(), !1)) : dn(), Ee.key.type === "Identifier" && (Ne || Me))
                for (var vt = 0; vt < ee.properties.length; ++vt) {
                  var Vt = ee.properties[vt];
                  if (Vt.key.name === Ee.key.name) {
                    var Ei = Mt == Vt.kind || at && Vt.kind === "init" || Mt === "init" && (Vt.kind === "get" || Vt.kind === "set");
                    Ei && !Ne && Mt === "init" && Vt.kind === "init" && (Ei = !1), Ei && ze(Ee.key.start, "Redefinition of property");
                  }
                }
              ee.properties.push(Ee);
            }
            return Yt(ee, "ObjectExpression");
          }
          function gt() {
            return se === _t || se === Pt ? Oe() : Ye(!0);
          }
          function Le(ee, oe) {
            se === Et ? ee.id = Ye() : oe ? dn() : ee.id = null, ee.params = [];
            var Me = !0;
            for (oi(cn); !ai(Ji); )
              Me ? Me = !1 : oi(g), ee.params.push(Ye());
            var Ee = tt, at = ft;
            if (tt = !0, ft = [], ee.body = Kn(!0), tt = Ee, ft = at, Ne || ee.body.body.length && kr(ee.body.body[0]))
              for (var Mt = ee.id ? -1 : 0; Mt < ee.params.length; ++Mt) {
                var vt = Mt < 0 ? ee.id : ee.params[Mt];
                if ((hs(vt.name) || Br(vt.name)) && ze(vt.start, "Defining '" + vt.name + "' in strict mode"), Mt >= 0)
                  for (var Vt = 0; Vt < Mt; ++Vt)
                    vt.name === ee.params[Vt].name && ze(vt.start, "Argument name clash in strict mode");
              }
            return Yt(ee, oe ? "FunctionDeclaration" : "FunctionExpression");
          }
          function je(ee, oe, Me) {
            for (var Ee = [], at = !0; !ai(ee); ) {
              if (at)
                at = !1;
              else if (oi(g), oe && F.allowTrailingCommas && ai(ee))
                break;
              Me && se === g ? Ee.push(null) : Ee.push(Ui(!0));
            }
            return Ee;
          }
          function Ye(ee) {
            var oe = Si();
            return ee && F.forbidReserved == "everywhere" && (ee = !1), se === Et ? (!ee && (F.forbidReserved && (F.ecmaVersion === 3 ? xs : Ks)(ge) || Ne && hs(ge)) && B.slice(Q, ae).indexOf("\\") == -1 && ze(Q, "The keyword '" + ge + "' is reserved"), oe.name = ge) : ee && se.keyword ? oe.name = se.keyword : dn(), me = !1, Jt(), Yt(oe, "Identifier");
          }
        }), n.version || (n = null);
      }
      function h(k, F) {
        return (i.acorn || n).parse(k, F);
      }
      var d = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, m = {
        "-": "__negate",
        "+": "__self"
      }, _ = a.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(k) {
          this["__" + k] = "#" + k;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      M.inject(_), Y.inject(_), At.inject(_);
      function b(k, F, B) {
        var R = d[F];
        if (k && k[R]) {
          var C = k[R](B);
          return F === "!=" ? !C : C;
        }
        switch (F) {
          case "+":
            return k + B;
          case "-":
            return k - B;
          case "*":
            return k * B;
          case "/":
            return k / B;
          case "%":
            return k % B;
          case "==":
            return k == B;
          case "!=":
            return k != B;
        }
      }
      function x(k, F) {
        var B = m[k];
        if (F && F[B])
          return F[B]();
        switch (k) {
          case "+":
            return +F;
          case "-":
            return -F;
        }
      }
      function T(k, F) {
        if (!k)
          return "";
        F = F || {};
        var B = [];
        function R(Ne) {
          for (var ze = 0, nt = B.length; ze < nt; ze++) {
            var _t = B[ze];
            if (_t[0] >= Ne)
              break;
            Ne += _t[1];
          }
          return Ne;
        }
        function C(Ne) {
          return k.substring(
            R(Ne.range[0]),
            R(Ne.range[1])
          );
        }
        function P(Ne, ze) {
          return k.substring(
            R(Ne.range[1]),
            R(ze.range[0])
          );
        }
        function H(Ne, ze) {
          for (var nt = R(Ne.range[0]), _t = R(Ne.range[1]), mt = 0, Pt = B.length - 1; Pt >= 0; Pt--)
            if (nt > B[Pt][0]) {
              mt = Pt + 1;
              break;
            }
          B.splice(mt, 0, [nt, ze.length - _t + nt]), k = k.substring(0, nt) + ze + k.substring(_t);
        }
        function W(Ne, ze) {
          switch (Ne.type) {
            case "UnaryExpression":
              if (Ne.operator in m && Ne.argument.type !== "Literal") {
                var nt = C(Ne.argument);
                H(Ne, '$__("' + Ne.operator + '", ' + nt + ")");
              }
              break;
            case "BinaryExpression":
              if (Ne.operator in d && Ne.left.type !== "Literal") {
                var _t = C(Ne.left), mt = C(Ne.right), Pt = P(Ne.left, Ne.right), Et = Ne.operator;
                H(Ne, "__$__(" + _t + "," + Pt.replace(
                  new RegExp("\\" + Et),
                  '"' + Et + '"'
                ) + ", " + mt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var zt = ze && ze.type;
              if (!(zt === "ForStatement" || zt === "BinaryExpression" && /^[=!<>]/.test(ze.operator) || zt === "MemberExpression" && ze.computed)) {
                if (Ne.type === "UpdateExpression") {
                  var nt = C(Ne.argument), jt = "__$__(" + nt + ', "' + Ne.operator[0] + '", 1)', Ft = nt + " = " + jt;
                  Ne.prefix ? Ft = "(" + Ft + ")" : (zt === "AssignmentExpression" || zt === "VariableDeclarator" || zt === "BinaryExpression") && (C(ze.left || ze.id) === nt && (Ft = jt), Ft = nt + "; " + Ft), H(Ne, Ft);
                } else if (/^.=$/.test(Ne.operator) && Ne.left.type !== "Literal") {
                  var _t = C(Ne.left), mt = C(Ne.right), jt = _t + " = __$__(" + _t + ', "' + Ne.operator[0] + '", ' + mt + ")";
                  H(Ne, /^\(.*\)$/.test(C(Ne)) ? "(" + jt + ")" : jt);
                }
              }
              break;
          }
        }
        function V(Ne) {
          switch (Ne.type) {
            case "ExportDefaultDeclaration":
              H({
                range: [Ne.start, Ne.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var ze = Ne.declaration, nt = Ne.specifiers;
              if (ze) {
                var _t = ze.declarations;
                _t && (_t.forEach(function(Pt) {
                  H(Pt, "module.exports." + C(Pt));
                }), H({
                  range: [
                    Ne.start,
                    ze.start + ze.kind.length
                  ]
                }, ""));
              } else if (nt) {
                var mt = nt.map(function(Pt) {
                  var Et = C(Pt);
                  return "module.exports." + Et + " = " + Et + "; ";
                }).join("");
                mt && H(Ne, mt);
              }
              break;
          }
        }
        function Q(Ne, ze, nt) {
          if (Ne) {
            for (var _t in Ne)
              if (_t !== "range" && _t !== "loc") {
                var mt = Ne[_t];
                if (Array.isArray(mt))
                  for (var Pt = 0, Et = mt.length; Pt < Et; Pt++)
                    Q(mt[Pt], Ne, nt);
                else
                  mt && typeof mt == "object" && Q(mt, Ne, nt);
              }
            nt.operatorOverloading !== !1 && W(Ne, ze), nt.moduleExports !== !1 && V(Ne);
          }
        }
        function ae(Ne) {
          var ze = "", nt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Ne = (Math.abs(Ne) << 1) + (Ne < 0 ? 1 : 0); Ne || !ze; ) {
            var _t = Ne & 31;
            Ne >>= 5, Ne && (_t |= 32), ze += nt[_t];
          }
          return ze;
        }
        var le = F.url || "", fe = F.sourceMaps, se = F.paperFeatures || {}, ge = F.source || k, me = F.offset || 0, we = He.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, Je;
        if (fe && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
          if (we.node)
            me -= 2;
          else if (r && le && !r.location.href.indexOf(le)) {
            var tt = o.getElementsByTagName("html")[0].innerHTML;
            me = tt.substr(0, tt.indexOf(k) + 1).match(
              Ge
            ).length + 1;
          }
          Ae = me > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
          var ft = ["AA" + ae(Ae ? 0 : me) + "A"];
          ft.length = (k.match(Ge) || []).length + 1 + (Ae ? me : 0), Je = {
            version: 3,
            file: le,
            names: [],
            mappings: ft.join(";AACA"),
            sourceRoot: "",
            sources: [le],
            sourcesContent: [ge]
          };
        }
        return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && Q(h(k, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, se), Je && (Ae && (k = new Array(me + 1).join(`
`) + k), /^(inline|both)$/.test(fe) && (k += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(Je)
        )))), k += `
//# sourceURL=` + (le || "paperscript")), {
          url: le,
          source: ge,
          code: k,
          map: Je
        };
      }
      function E(k, F, B) {
        He = F;
        var R = F.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(k) && !/\bnew\s+Tool\b/.test(k) ? new Ie() : null, P = C ? C._events : [], H = ["onFrame", "onResize"].concat(P), W = [], V = [], Q, ae = typeof k == "object" ? k : T(k, B);
        k = ae.code;
        function le(Se, Ae) {
          for (var Ge in Se)
            (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(k) && (W.push(Ge), V.push(Se[Ge]));
        }
        le(
          { __$__: b, $__: x, paper: F, tool: C },
          !0
        ), le(F), k = "var module = { exports: {} }; " + k;
        var me = a.each(H, function(Se) {
          new RegExp("\\s+" + Se + "\\b").test(k) && (W.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
        }, []).join(`
`);
        me && (k += `
` + me), k += `
return module.exports;`;
        var fe = He.agent;
        if (o && (fe.chrome || fe.firefox && fe.versionNumber < 40)) {
          var se = o.createElement("script"), ge = o.head || o.getElementsByTagName("head")[0];
          fe.firefox && (k = `
` + k), se.appendChild(o.createTextNode(
            "document.__paperscript__ = function(" + W + ") {" + k + `
}`
          )), ge.appendChild(se), Q = o.__paperscript__, delete o.__paperscript__, ge.removeChild(se);
        } else
          Q = Function(W, k);
        var me = Q && Q.apply(F, V), we = me || {};
        return a.each(P, function(Se) {
          var Ae = we[Se];
          Ae && (C[Se] = Ae);
        }), R && (we.onResize && R.setOnResize(we.onResize), R.emit("resize", {
          size: R.size,
          delta: new M()
        }), we.onFrame && R.setOnFrame(we.onFrame), R.requestUpdate()), me;
      }
      function L(k) {
        if (/^text\/(?:x-|)paperscript$/.test(k.type) && f.getAttribute(k, "ignore") !== "true") {
          var F = f.getAttribute(k, "canvas"), B = o.getElementById(F), R = k.src || k.getAttribute("data-src"), C = f.hasAttribute(k, "async"), P = "data-paper-scope";
          if (!B)
            throw new Error('Unable to find canvas with id "' + F + '"');
          var H = f.get(B.getAttribute(P)) || new f().setup(B);
          return B.setAttribute(P, H._id), R ? Bt.request({
            url: R,
            async: C,
            mimeType: "text/plain",
            onLoad: function(W) {
              E(W, H, R);
            }
          }) : E(k.innerHTML, H, k.baseURI), k.setAttribute("data-paper-ignore", "true"), H;
        }
      }
      function A() {
        a.each(
          o && o.getElementsByTagName("script"),
          L
        );
      }
      function U(k) {
        return k ? L(k) : A();
      }
      return r && (o.readyState === "complete" ? setTimeout(A) : Qt.add(r, { load: A })), {
        compile: T,
        execute: E,
        load: U,
        parse: h,
        calculateBinary: b,
        calculateUnary: x
      };
    }).call(this);
    var He = new (f.inject(a.exports, {
      Base: a,
      Numerical: D,
      Key: Tt,
      DomEvent: Qt,
      DomElement: Wt,
      document: o,
      window: r,
      Symbol: Be,
      PlacedSymbol: Lt
    }))();
    return He.agent.node && pf(He), typeof t == "function" && t.amd ? t("paper", He) : y && (y.exports = He), He;
  }).call(ky, typeof self == "object" ? self : null);
})(Qf);
var Dy = Qf.exports;
const _f = /* @__PURE__ */ Iy(Dy);
class zy {
  constructor() {
    wh(this, "_paperScope", new _f.PaperScope()), wh(this, "_baseMaterial", null), wh(this, "_borderMaterial", null);
    const e = document.createElement("canvas");
    e.width = 1, e.height = 1, this._paperScope.setup(new _f.Size(1, 1));
  }
  generatePreview3D(e, t) {
    if (!e.columns || isNaN(e.columns) || e.columns < 1 || e.rows < 1 || !e.rows || isNaN(e.rows))
      throw new Error("Invalid columns or rows value. Columns and rows must be greater than 0 and must be a number.");
    console.log("Generating 3D preview for resizable canvas...", e), this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("baseMaterial", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("borderMaterial", t)), this._baseMaterial.albedoColor = new BABYLON.Color3(1, 1, 1), this._baseMaterial.metallic = 0, this._baseMaterial.roughness = 0.5, this._borderMaterial.albedoColor = BABYLON.Color3.FromHexString(e.borderColor), this._borderMaterial.metallic = 0, this._borderMaterial.roughness = 0.5, e.useCheckerTexture && (this._baseMaterial.albedoTexture = new BABYLON.Texture("https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", t), this._baseMaterial.albedoTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, this._baseMaterial.albedoTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE, this._borderMaterial.albedoTexture = new BABYLON.Texture("https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", t), this._borderMaterial.albedoTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, this._borderMaterial.albedoTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
    const r = new BABYLON.Mesh("groupMesh", t), o = [], a = [], u = [];
    for (let D = 0; D < e.columns; D++)
      for (let Z = 0; Z < e.rows; Z++) {
        const [M, X, Y] = this.generateCanvasMesh(e, t, D, Z);
        o.push(M), a.push(X), u.push(Y);
      }
    const f = BABYLON.Mesh.MergeMeshes(o, !0, !0, void 0, !1, !1), v = BABYLON.Mesh.MergeMeshes(a, !0, !0, void 0, !1, !1), S = BABYLON.Mesh.MergeMeshes(u, !0, !0, void 0, !1, !1);
    if (!f || !v || !S)
      return null;
    f.material = this._borderMaterial, v.material = this._baseMaterial, S.material = this._baseMaterial, f.parent = r, v.parent = r, S.parent = r, f.name = "borders", v.name = "back", S.name = "front";
    const I = BABYLON.SceneSerializer.SerializeMesh(r, !1, !0);
    return r == null || r.dispose(), I;
  }
  generateCanvasMesh(e, t, r, o) {
    const a = e.width / e.columns, u = e.height / e.rows, f = a * 0.1, v = BABYLON.MeshBuilder.CreateBox(
      "borders",
      {
        width: a,
        height: u,
        depth: e.depth
      },
      t
    ), S = BABYLON.MeshBuilder.CreatePlane(
      "front",
      {
        width: a,
        height: u
      },
      t
    ), I = BABYLON.MeshBuilder.CreatePlane(
      "back",
      {
        width: a,
        height: u
      },
      t
    );
    v.position = new BABYLON.Vector3(a / 2 + r * (a + f), u / 2 + o * (u + f)), S.position = new BABYLON.Vector3(a / 2 + r * (a + f), u / 2 + o * (u + f), -e.depth / 2), I.position = new BABYLON.Vector3(a / 2 + r * (a + f), u / 2 + o * (u + f), e.depth / 2), I.rotate(BABYLON.Axis.X, Math.PI, BABYLON.Space.WORLD), I.rotate(BABYLON.Axis.Z, Math.PI, BABYLON.Space.WORLD), v.material = this._borderMaterial, I.material = this._borderMaterial, S.material = this._baseMaterial;
    const D = v.getVerticesData(BABYLON.VertexBuffer.NormalKind), Z = v.getVerticesData(BABYLON.VertexBuffer.UVKind), M = S.getVerticesData(BABYLON.VertexBuffer.UVKind), X = I.getVerticesData(BABYLON.VertexBuffer.UVKind);
    if (e.borderRadius > 0 && console.warn("Mirror canvas effect will not work for border radius > 0"), e.borderRadius === 0) {
      const K = e.depth / e.width, j = e.depth / e.height, We = Math.min(K, j), ke = a / e.width, $e = u / e.height;
      for (var Y = 0; Y < Z.length; Y += 2) {
        const Lt = Math.round(D[Y / 2 * 3]), Be = Math.round(D[Y / 2 * 3 + 1]), Xe = Math.round(D[Y / 2 * 3 + 2]), ue = Lt == -1 && Be == 0 && Xe == 0, yt = Lt == 1 && Be == 0 && Xe == 0, Ue = Lt == 0 && Be == 1 && Xe == 0, ot = Lt == 0 && Be == -1 && Xe == 0;
        if (ue) {
          var ie = Z[Y], G = Z[Y + 1];
          Z[Y] = G * We + ke * r, Z[Y + 1] = ie * $e + $e * o;
        }
        if (yt) {
          var ie = Z[Y], G = Z[Y + 1];
          Z[Y] = G * We + (1 - We) - ke * (e.columns - 1 - r), Z[Y + 1] = ie * $e + $e * o;
        }
        if (ot) {
          var ie = Z[Y], G = Z[Y + 1];
          Z[Y] = G * ke + ke * r, Z[Y + 1] = ie * We + $e * o;
        }
        if (Ue) {
          var ie = Z[Y], G = Z[Y + 1];
          Z[Y] = (-G + 1) * ke + ke * r, Z[Y + 1] = (-ie + 1) * We + (1 - We);
        }
      }
      v.setVerticesData(BABYLON.VertexBuffer.UVKind, Z);
      for (var Y = 0; Y < M.length; Y += 2) {
        var ie = M[Y], G = M[Y + 1];
        M[Y] = ie * ke + ke * r, M[Y + 1] = G * $e + $e * o;
      }
      S.setVerticesData(BABYLON.VertexBuffer.UVKind, M);
      for (var Y = 0; Y < X.length; Y += 2) {
        var ie = X[Y], G = X[Y + 1];
        X[Y] = ie * ke + ke * (e.columns - 1 - r), X[Y + 1] = G * $e + $e * o;
      }
      I.setVerticesData(BABYLON.VertexBuffer.UVKind, X);
    }
    S.isVisible = !1, I.isVisible = !1;
    const te = v.getVerticesData(BABYLON.VertexBuffer.PositionKind) ?? [], J = v.getVerticesData(BABYLON.VertexBuffer.NormalKind) ?? [], he = v.getVerticesData(BABYLON.VertexBuffer.UVKind) ?? [], ve = v.getIndices() ?? [];
    return te.splice(0, 8 * 3), J.splice(0, 8 * 3), he.splice(0, 8 * 2), ve.splice(ve.length - 4 * 3, 4 * 3), v.updateVerticesData(BABYLON.VertexBuffer.PositionKind, te), v.updateVerticesData(BABYLON.VertexBuffer.NormalKind, J), v.updateVerticesData(BABYLON.VertexBuffer.UVKind, he), v.updateIndices(ve), [v, I, S];
  }
  /*public generatePreview3D(options: ResizableCanvas3DOptions) {
  
          // Use paper to generate the path
          const rectangle = new this._paperScope.Path.Rectangle({
              point: [0, 0],
              size: [options.width, options.height],
              radius: options.borderRadius,
          });
  
          rectangle.flatten(options.radiusResolution);
          rectangle.remove();
  
          //Shape profile in XY plane
          const shape = [
              ...rectangle.segments.map(segment => new BABYLON.Vector3(segment.point.x, 0, segment.point.y)),
          ];
  
          var faceUV = new Array(3);
  
          // We know that the texture created from the customer is squared and the 
          // printing area is "fitted" inside the UV quadrant, at the center.
          // So, based on the width and height ratio, we know what portion of the UV map quadrant
          // we have to show, we just need to normalized the width and height in the quadrant
  
          //const ratio = options.width / options.height;
          //let width = 1;
          //let height = 1 / ratio;
  
          //if (ratio < 1) {
            //  width = 1 * ratio;
           //   height = 1;
          //}
  
          //const uvU = 0.5 - width / 2;
          //const uvV = 0.5 - height / 2;
  
          //faceUV[0] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
          //faceUV[1] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
          //faceUV[2] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
  
          faceUV[0] = new BABYLON.Vector4(0, 0, 1, 1);
          faceUV[1] = new BABYLON.Vector4(0, 0, 1, 1);
          faceUV[2] = new BABYLON.Vector4(0, 0, 1, -1);
  
  
          let mesh = BABYLON.MeshBuilder.ExtrudePolygon("canvas", {
              shape: shape,
              depth: options.depth,
              faceUV,
          }, null, earcut);
  
          // Get vertexes
          let positions = mesh!.getVerticesData(BABYLON.VertexBuffer.PositionKind) as number[];
          let indices = mesh!.getIndices() as number[];
          let normals = mesh!.getVerticesData(BABYLON.VertexBuffer.NormalKind) as number[];
          let uvs = mesh!.getVerticesData(BABYLON.VertexBuffer.UVKind) as number[];
  
          if (options.borderRadius > 0)
              console.warn("Mirror canvas effect will not work for border radius > 0")
  
          if (options.borderRadius === 0) {
              // Make the mirror UV map, normally is 0,0 1,1 but we need to use the correct portion too
              const sidePortionX = options.depth / options.width;
              const sidePortionY = options.depth / options.height;
  
              // Use the same portion for both directions
              const sidePortion = Math.min(sidePortionX, sidePortionY);
  
              for (var i = 0; i < uvs.length; i += 2) {
                  // Get the vertex normal
                  const normalX = Math.round(normals[i / 2 * 3]);
                  const normalY = Math.round(normals[i / 2 * 3 + 1]);
                  const normalZ = Math.round(normals[i / 2 * 3 + 2]);
  
  
                  // Left
                  if (normalX == -1 && normalY == 0 && normalZ == 0) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = -y * sidePortion + sidePortion;// uv is inverted??? 
                      uvs[i + 1] = -x + 1;
                  }
  
                  // Right
                  if (normalX == 1 && normalY == 0 && normalZ == 0) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = y * sidePortion - sidePortion + 1;// uv is inverted??? 
                      uvs[i + 1] = x;
  
  
                      console.log(i, uvs[i], uvs[i + 1])
                  }
  
                  // Bottom
                  if (normalX == 0 && normalY == 0 && normalZ == -1) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = x;
                      uvs[i + 1] = -y * sidePortion + sidePortion;// uv is inverted??? 
                  }
  
                  // Top
                  if (normalX == 0 && normalY == 0 && normalZ == 1) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = -x + 1;
                      uvs[i + 1] = y * sidePortion - sidePortion + 1; // uv is inverted??? 
                  }
              }
  
              mesh.setVerticesData(BABYLON.VertexBuffer.UVKind, uvs);
          }
  
          mesh?.dispose();
  
          return { positions, indices, normals, uvs };
      }*/
}
function ed(y, e) {
  return function() {
    return y.apply(e, arguments);
  };
}
const { toString: Fy } = Object.prototype, { getPrototypeOf: Kh } = Object, xl = ((y) => (e) => {
  const t = Fy.call(e);
  return y[t] || (y[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ys = (y) => (y = y.toLowerCase(), (e) => xl(e) === y), wl = (y) => (e) => typeof e === y, { isArray: La } = Array, ro = wl("undefined");
function Uy(y) {
  return y !== null && !ro(y) && y.constructor !== null && !ro(y.constructor) && $r(y.constructor.isBuffer) && y.constructor.isBuffer(y);
}
const td = ys("ArrayBuffer");
function Vy(y) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(y) : e = y && y.buffer && td(y.buffer), e;
}
const Hy = wl("string"), $r = wl("function"), id = wl("number"), Sl = (y) => y !== null && typeof y == "object", Yy = (y) => y === !0 || y === !1, nl = (y) => {
  if (xl(y) !== "object")
    return !1;
  const e = Kh(y);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in y) && !(Symbol.iterator in y);
}, Gy = ys("Date"), jy = ys("File"), Wy = ys("Blob"), Zy = ys("FileList"), qy = (y) => Sl(y) && $r(y.pipe), Xy = (y) => {
  let e;
  return y && (typeof FormData == "function" && y instanceof FormData || $r(y.append) && ((e = xl(y)) === "formdata" || // detect form-data instance
  e === "object" && $r(y.toString) && y.toString() === "[object FormData]"));
}, Ky = ys("URLSearchParams"), Jy = (y) => y.trim ? y.trim() : y.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function co(y, e, { allOwnKeys: t = !1 } = {}) {
  if (y === null || typeof y > "u")
    return;
  let r, o;
  if (typeof y != "object" && (y = [y]), La(y))
    for (r = 0, o = y.length; r < o; r++)
      e.call(null, y[r], r, y);
  else {
    const a = t ? Object.getOwnPropertyNames(y) : Object.keys(y), u = a.length;
    let f;
    for (r = 0; r < u; r++)
      f = a[r], e.call(null, y[f], f, y);
  }
}
function nd(y, e) {
  e = e.toLowerCase();
  const t = Object.keys(y);
  let r = t.length, o;
  for (; r-- > 0; )
    if (o = t[r], e === o.toLowerCase())
      return o;
  return null;
}
const rd = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), sd = (y) => !ro(y) && y !== rd;
function Ph() {
  const { caseless: y } = sd(this) && this || {}, e = {}, t = (r, o) => {
    const a = y && nd(e, o) || o;
    nl(e[a]) && nl(r) ? e[a] = Ph(e[a], r) : nl(r) ? e[a] = Ph({}, r) : La(r) ? e[a] = r.slice() : e[a] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && co(arguments[r], t);
  return e;
}
const $y = (y, e, t, { allOwnKeys: r } = {}) => (co(e, (o, a) => {
  t && $r(o) ? y[a] = ed(o, t) : y[a] = o;
}, { allOwnKeys: r }), y), Qy = (y) => (y.charCodeAt(0) === 65279 && (y = y.slice(1)), y), eb = (y, e, t, r) => {
  y.prototype = Object.create(e.prototype, r), y.prototype.constructor = y, Object.defineProperty(y, "super", {
    value: e.prototype
  }), t && Object.assign(y.prototype, t);
}, tb = (y, e, t, r) => {
  let o, a, u;
  const f = {};
  if (e = e || {}, y == null)
    return e;
  do {
    for (o = Object.getOwnPropertyNames(y), a = o.length; a-- > 0; )
      u = o[a], (!r || r(u, y, e)) && !f[u] && (e[u] = y[u], f[u] = !0);
    y = t !== !1 && Kh(y);
  } while (y && (!t || t(y, e)) && y !== Object.prototype);
  return e;
}, ib = (y, e, t) => {
  y = String(y), (t === void 0 || t > y.length) && (t = y.length), t -= e.length;
  const r = y.indexOf(e, t);
  return r !== -1 && r === t;
}, nb = (y) => {
  if (!y)
    return null;
  if (La(y))
    return y;
  let e = y.length;
  if (!id(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = y[e];
  return t;
}, rb = ((y) => (e) => y && e instanceof y)(typeof Uint8Array < "u" && Kh(Uint8Array)), sb = (y, e) => {
  const r = (y && y[Symbol.iterator]).call(y);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const a = o.value;
    e.call(y, a[0], a[1]);
  }
}, ab = (y, e) => {
  let t;
  const r = [];
  for (; (t = y.exec(e)) !== null; )
    r.push(t);
  return r;
}, ob = ys("HTMLFormElement"), lb = (y) => y.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, o) {
    return r.toUpperCase() + o;
  }
), mf = (({ hasOwnProperty: y }) => (e, t) => y.call(e, t))(Object.prototype), hb = ys("RegExp"), ad = (y, e) => {
  const t = Object.getOwnPropertyDescriptors(y), r = {};
  co(t, (o, a) => {
    let u;
    (u = e(o, a, y)) !== !1 && (r[a] = u || o);
  }), Object.defineProperties(y, r);
}, ub = (y) => {
  ad(y, (e, t) => {
    if ($r(y) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const r = y[t];
    if ($r(r)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, cb = (y, e) => {
  const t = {}, r = (o) => {
    o.forEach((a) => {
      t[a] = !0;
    });
  };
  return La(y) ? r(y) : r(String(y).split(e)), t;
}, fb = () => {
}, db = (y, e) => (y = +y, Number.isFinite(y) ? y : e), Sh = "abcdefghijklmnopqrstuvwxyz", vf = "0123456789", od = {
  DIGIT: vf,
  ALPHA: Sh,
  ALPHA_DIGIT: Sh + Sh.toUpperCase() + vf
}, gb = (y = 16, e = od.ALPHA_DIGIT) => {
  let t = "";
  const { length: r } = e;
  for (; y--; )
    t += e[Math.random() * r | 0];
  return t;
};
function pb(y) {
  return !!(y && $r(y.append) && y[Symbol.toStringTag] === "FormData" && y[Symbol.iterator]);
}
const _b = (y) => {
  const e = new Array(10), t = (r, o) => {
    if (Sl(r)) {
      if (e.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        e[o] = r;
        const a = La(r) ? [] : {};
        return co(r, (u, f) => {
          const v = t(u, o + 1);
          !ro(v) && (a[f] = v);
        }), e[o] = void 0, a;
      }
    }
    return r;
  };
  return t(y, 0);
}, mb = ys("AsyncFunction"), vb = (y) => y && (Sl(y) || $r(y)) && $r(y.then) && $r(y.catch), Ot = {
  isArray: La,
  isArrayBuffer: td,
  isBuffer: Uy,
  isFormData: Xy,
  isArrayBufferView: Vy,
  isString: Hy,
  isNumber: id,
  isBoolean: Yy,
  isObject: Sl,
  isPlainObject: nl,
  isUndefined: ro,
  isDate: Gy,
  isFile: jy,
  isBlob: Wy,
  isRegExp: hb,
  isFunction: $r,
  isStream: qy,
  isURLSearchParams: Ky,
  isTypedArray: rb,
  isFileList: Zy,
  forEach: co,
  merge: Ph,
  extend: $y,
  trim: Jy,
  stripBOM: Qy,
  inherits: eb,
  toFlatObject: tb,
  kindOf: xl,
  kindOfTest: ys,
  endsWith: ib,
  toArray: nb,
  forEachEntry: sb,
  matchAll: ab,
  isHTMLForm: ob,
  hasOwnProperty: mf,
  hasOwnProp: mf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ad,
  freezeMethods: ub,
  toObjectSet: cb,
  toCamelCase: lb,
  noop: fb,
  toFiniteNumber: db,
  findKey: nd,
  global: rd,
  isContextDefined: sd,
  ALPHABET: od,
  generateString: gb,
  isSpecCompliantForm: pb,
  toJSONObject: _b,
  isAsyncFn: mb,
  isThenable: vb
};
function Qi(y, e, t, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = y, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), r && (this.request = r), o && (this.response = o);
}
Ot.inherits(Qi, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Ot.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const ld = Qi.prototype, hd = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((y) => {
  hd[y] = { value: y };
});
Object.defineProperties(Qi, hd);
Object.defineProperty(ld, "isAxiosError", { value: !0 });
Qi.from = (y, e, t, r, o, a) => {
  const u = Object.create(ld);
  return Ot.toFlatObject(y, u, function(v) {
    return v !== Error.prototype;
  }, (f) => f !== "isAxiosError"), Qi.call(u, y.message, e, t, r, o), u.cause = y, u.name = y.name, a && Object.assign(u, a), u;
};
const yb = null;
function Nh(y) {
  return Ot.isPlainObject(y) || Ot.isArray(y);
}
function ud(y) {
  return Ot.endsWith(y, "[]") ? y.slice(0, -2) : y;
}
function yf(y, e, t) {
  return y ? y.concat(e).map(function(o, a) {
    return o = ud(o), !t && a ? "[" + o + "]" : o;
  }).join(t ? "." : "") : e;
}
function bb(y) {
  return Ot.isArray(y) && !y.some(Nh);
}
const xb = Ot.toFlatObject(Ot, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Ml(y, e, t) {
  if (!Ot.isObject(y))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = Ot.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(Y, ie) {
    return !Ot.isUndefined(ie[Y]);
  });
  const r = t.metaTokens, o = t.visitor || I, a = t.dots, u = t.indexes, v = (t.Blob || typeof Blob < "u" && Blob) && Ot.isSpecCompliantForm(e);
  if (!Ot.isFunction(o))
    throw new TypeError("visitor must be a function");
  function S(X) {
    if (X === null)
      return "";
    if (Ot.isDate(X))
      return X.toISOString();
    if (!v && Ot.isBlob(X))
      throw new Qi("Blob is not supported. Use a Buffer instead.");
    return Ot.isArrayBuffer(X) || Ot.isTypedArray(X) ? v && typeof Blob == "function" ? new Blob([X]) : Buffer.from(X) : X;
  }
  function I(X, Y, ie) {
    let G = X;
    if (X && !ie && typeof X == "object") {
      if (Ot.endsWith(Y, "{}"))
        Y = r ? Y : Y.slice(0, -2), X = JSON.stringify(X);
      else if (Ot.isArray(X) && bb(X) || (Ot.isFileList(X) || Ot.endsWith(Y, "[]")) && (G = Ot.toArray(X)))
        return Y = ud(Y), G.forEach(function(J, he) {
          !(Ot.isUndefined(J) || J === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            u === !0 ? yf([Y], he, a) : u === null ? Y : Y + "[]",
            S(J)
          );
        }), !1;
    }
    return Nh(X) ? !0 : (e.append(yf(ie, Y, a), S(X)), !1);
  }
  const D = [], Z = Object.assign(xb, {
    defaultVisitor: I,
    convertValue: S,
    isVisitable: Nh
  });
  function M(X, Y) {
    if (!Ot.isUndefined(X)) {
      if (D.indexOf(X) !== -1)
        throw Error("Circular reference detected in " + Y.join("."));
      D.push(X), Ot.forEach(X, function(G, te) {
        (!(Ot.isUndefined(G) || G === null) && o.call(
          e,
          G,
          Ot.isString(te) ? te.trim() : te,
          Y,
          Z
        )) === !0 && M(G, Y ? Y.concat(te) : [te]);
      }), D.pop();
    }
  }
  if (!Ot.isObject(y))
    throw new TypeError("data must be an object");
  return M(y), e;
}
function bf(y) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(y).replace(/[!'()~]|%20|%00/g, function(r) {
    return e[r];
  });
}
function Jh(y, e) {
  this._pairs = [], y && Ml(y, this, e);
}
const cd = Jh.prototype;
cd.append = function(e, t) {
  this._pairs.push([e, t]);
};
cd.toString = function(e) {
  const t = e ? function(r) {
    return e.call(this, r, bf);
  } : bf;
  return this._pairs.map(function(o) {
    return t(o[0]) + "=" + t(o[1]);
  }, "").join("&");
};
function wb(y) {
  return encodeURIComponent(y).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function fd(y, e, t) {
  if (!e)
    return y;
  const r = t && t.encode || wb, o = t && t.serialize;
  let a;
  if (o ? a = o(e, t) : a = Ot.isURLSearchParams(e) ? e.toString() : new Jh(e, t).toString(r), a) {
    const u = y.indexOf("#");
    u !== -1 && (y = y.slice(0, u)), y += (y.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return y;
}
class Sb {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, r) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    Ot.forEach(this.handlers, function(r) {
      r !== null && e(r);
    });
  }
}
const xf = Sb, dd = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Mb = typeof URLSearchParams < "u" ? URLSearchParams : Jh, Cb = typeof FormData < "u" ? FormData : null, Ab = typeof Blob < "u" ? Blob : null, Tb = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Mb,
    FormData: Cb,
    Blob: Ab
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, gd = typeof window < "u" && typeof document < "u", Lb = ((y) => gd && ["ReactNative", "NativeScript", "NS"].indexOf(y) < 0)(typeof navigator < "u" && navigator.product), Bb = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Eb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: gd,
  hasStandardBrowserEnv: Lb,
  hasStandardBrowserWebWorkerEnv: Bb
}, Symbol.toStringTag, { value: "Module" })), vs = {
  ...Eb,
  ...Tb
};
function kb(y, e) {
  return Ml(y, new vs.classes.URLSearchParams(), Object.assign({
    visitor: function(t, r, o, a) {
      return vs.isNode && Ot.isBuffer(t) ? (this.append(r, t.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Ib(y) {
  return Ot.matchAll(/\w+|\[(\w*)]/g, y).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Ob(y) {
  const e = {}, t = Object.keys(y);
  let r;
  const o = t.length;
  let a;
  for (r = 0; r < o; r++)
    a = t[r], e[a] = y[a];
  return e;
}
function pd(y) {
  function e(t, r, o, a) {
    let u = t[a++];
    if (u === "__proto__")
      return !0;
    const f = Number.isFinite(+u), v = a >= t.length;
    return u = !u && Ot.isArray(o) ? o.length : u, v ? (Ot.hasOwnProp(o, u) ? o[u] = [o[u], r] : o[u] = r, !f) : ((!o[u] || !Ot.isObject(o[u])) && (o[u] = []), e(t, r, o[u], a) && Ot.isArray(o[u]) && (o[u] = Ob(o[u])), !f);
  }
  if (Ot.isFormData(y) && Ot.isFunction(y.entries)) {
    const t = {};
    return Ot.forEachEntry(y, (r, o) => {
      e(Ib(r), o, t, 0);
    }), t;
  }
  return null;
}
function Pb(y, e, t) {
  if (Ot.isString(y))
    try {
      return (e || JSON.parse)(y), Ot.trim(y);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (t || JSON.stringify)(y);
}
const $h = {
  transitional: dd,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, t) {
    const r = t.getContentType() || "", o = r.indexOf("application/json") > -1, a = Ot.isObject(e);
    if (a && Ot.isHTMLForm(e) && (e = new FormData(e)), Ot.isFormData(e))
      return o ? JSON.stringify(pd(e)) : e;
    if (Ot.isArrayBuffer(e) || Ot.isBuffer(e) || Ot.isStream(e) || Ot.isFile(e) || Ot.isBlob(e))
      return e;
    if (Ot.isArrayBufferView(e))
      return e.buffer;
    if (Ot.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let f;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return kb(e, this.formSerializer).toString();
      if ((f = Ot.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
        const v = this.env && this.env.FormData;
        return Ml(
          f ? { "files[]": e } : e,
          v && new v(),
          this.formSerializer
        );
      }
    }
    return a || o ? (t.setContentType("application/json", !1), Pb(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || $h.transitional, r = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (e && Ot.isString(e) && (r && !this.responseType || o)) {
      const u = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e);
      } catch (f) {
        if (u)
          throw f.name === "SyntaxError" ? Qi.from(f, Qi.ERR_BAD_RESPONSE, this, null, this.response) : f;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: vs.classes.FormData,
    Blob: vs.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Ot.forEach(["delete", "get", "head", "post", "put", "patch"], (y) => {
  $h.headers[y] = {};
});
const Qh = $h, Nb = Ot.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Rb = (y) => {
  const e = {};
  let t, r, o;
  return y && y.split(`
`).forEach(function(u) {
    o = u.indexOf(":"), t = u.substring(0, o).trim().toLowerCase(), r = u.substring(o + 1).trim(), !(!t || e[t] && Nb[t]) && (t === "set-cookie" ? e[t] ? e[t].push(r) : e[t] = [r] : e[t] = e[t] ? e[t] + ", " + r : r);
  }), e;
}, wf = Symbol("internals");
function Ya(y) {
  return y && String(y).trim().toLowerCase();
}
function rl(y) {
  return y === !1 || y == null ? y : Ot.isArray(y) ? y.map(rl) : String(y);
}
function Db(y) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = t.exec(y); )
    e[r[1]] = r[2];
  return e;
}
const zb = (y) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(y.trim());
function Mh(y, e, t, r, o) {
  if (Ot.isFunction(r))
    return r.call(this, e, t);
  if (o && (e = t), !!Ot.isString(e)) {
    if (Ot.isString(r))
      return e.indexOf(r) !== -1;
    if (Ot.isRegExp(r))
      return r.test(e);
  }
}
function Fb(y) {
  return y.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, r) => t.toUpperCase() + r);
}
function Ub(y, e) {
  const t = Ot.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(y, r + t, {
      value: function(o, a, u) {
        return this[r].call(this, e, o, a, u);
      },
      configurable: !0
    });
  });
}
class Cl {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    const o = this;
    function a(f, v, S) {
      const I = Ya(v);
      if (!I)
        throw new Error("header name must be a non-empty string");
      const D = Ot.findKey(o, I);
      (!D || o[D] === void 0 || S === !0 || S === void 0 && o[D] !== !1) && (o[D || v] = rl(f));
    }
    const u = (f, v) => Ot.forEach(f, (S, I) => a(S, I, v));
    return Ot.isPlainObject(e) || e instanceof this.constructor ? u(e, t) : Ot.isString(e) && (e = e.trim()) && !zb(e) ? u(Rb(e), t) : e != null && a(t, e, r), this;
  }
  get(e, t) {
    if (e = Ya(e), e) {
      const r = Ot.findKey(this, e);
      if (r) {
        const o = this[r];
        if (!t)
          return o;
        if (t === !0)
          return Db(o);
        if (Ot.isFunction(t))
          return t.call(this, o, r);
        if (Ot.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Ya(e), e) {
      const r = Ot.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || Mh(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    const r = this;
    let o = !1;
    function a(u) {
      if (u = Ya(u), u) {
        const f = Ot.findKey(r, u);
        f && (!t || Mh(r, r[f], f, t)) && (delete r[f], o = !0);
      }
    }
    return Ot.isArray(e) ? e.forEach(a) : a(e), o;
  }
  clear(e) {
    const t = Object.keys(this);
    let r = t.length, o = !1;
    for (; r--; ) {
      const a = t[r];
      (!e || Mh(this, this[a], a, e, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(e) {
    const t = this, r = {};
    return Ot.forEach(this, (o, a) => {
      const u = Ot.findKey(r, a);
      if (u) {
        t[u] = rl(o), delete t[a];
        return;
      }
      const f = e ? Fb(a) : String(a).trim();
      f !== a && delete t[a], t[f] = rl(o), r[f] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return Ot.forEach(this, (r, o) => {
      r != null && r !== !1 && (t[o] = e && Ot.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const r = new this(e);
    return t.forEach((o) => r.set(o)), r;
  }
  static accessor(e) {
    const r = (this[wf] = this[wf] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(u) {
      const f = Ya(u);
      r[f] || (Ub(o, u), r[f] = !0);
    }
    return Ot.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
Cl.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Ot.reduceDescriptors(Cl.prototype, ({ value: y }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => y,
    set(r) {
      this[t] = r;
    }
  };
});
Ot.freezeMethods(Cl);
const Os = Cl;
function Ch(y, e) {
  const t = this || Qh, r = e || t, o = Os.from(r.headers);
  let a = r.data;
  return Ot.forEach(y, function(f) {
    a = f.call(t, a, o.normalize(), e ? e.status : void 0);
  }), o.normalize(), a;
}
function _d(y) {
  return !!(y && y.__CANCEL__);
}
function fo(y, e, t) {
  Qi.call(this, y ?? "canceled", Qi.ERR_CANCELED, e, t), this.name = "CanceledError";
}
Ot.inherits(fo, Qi, {
  __CANCEL__: !0
});
function Vb(y, e, t) {
  const r = t.config.validateStatus;
  !t.status || !r || r(t.status) ? y(t) : e(new Qi(
    "Request failed with status code " + t.status,
    [Qi.ERR_BAD_REQUEST, Qi.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
const Hb = vs.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(y, e, t, r, o, a) {
      const u = [y + "=" + encodeURIComponent(e)];
      Ot.isNumber(t) && u.push("expires=" + new Date(t).toGMTString()), Ot.isString(r) && u.push("path=" + r), Ot.isString(o) && u.push("domain=" + o), a === !0 && u.push("secure"), document.cookie = u.join("; ");
    },
    read(y) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + y + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(y) {
      this.write(y, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Yb(y) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(y);
}
function Gb(y, e) {
  return e ? y.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : y;
}
function md(y, e) {
  return y && !Yb(e) ? Gb(y, e) : e;
}
const jb = vs.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let r;
    function o(a) {
      let u = a;
      return e && (t.setAttribute("href", u), u = t.href), t.setAttribute("href", u), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return r = o(window.location.href), function(u) {
      const f = Ot.isString(u) ? o(u) : u;
      return f.protocol === r.protocol && f.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Wb(y) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(y);
  return e && e[1] || "";
}
function Zb(y, e) {
  y = y || 10;
  const t = new Array(y), r = new Array(y);
  let o = 0, a = 0, u;
  return e = e !== void 0 ? e : 1e3, function(v) {
    const S = Date.now(), I = r[a];
    u || (u = S), t[o] = v, r[o] = S;
    let D = a, Z = 0;
    for (; D !== o; )
      Z += t[D++], D = D % y;
    if (o = (o + 1) % y, o === a && (a = (a + 1) % y), S - u < e)
      return;
    const M = I && S - I;
    return M ? Math.round(Z * 1e3 / M) : void 0;
  };
}
function Sf(y, e) {
  let t = 0;
  const r = Zb(50, 250);
  return (o) => {
    const a = o.loaded, u = o.lengthComputable ? o.total : void 0, f = a - t, v = r(f), S = a <= u;
    t = a;
    const I = {
      loaded: a,
      total: u,
      progress: u ? a / u : void 0,
      bytes: f,
      rate: v || void 0,
      estimated: v && u && S ? (u - a) / v : void 0,
      event: o
    };
    I[e ? "download" : "upload"] = !0, y(I);
  };
}
const qb = typeof XMLHttpRequest < "u", Xb = qb && function(y) {
  return new Promise(function(t, r) {
    let o = y.data;
    const a = Os.from(y.headers).normalize();
    let { responseType: u, withXSRFToken: f } = y, v;
    function S() {
      y.cancelToken && y.cancelToken.unsubscribe(v), y.signal && y.signal.removeEventListener("abort", v);
    }
    let I;
    if (Ot.isFormData(o)) {
      if (vs.hasStandardBrowserEnv || vs.hasStandardBrowserWebWorkerEnv)
        a.setContentType(!1);
      else if ((I = a.getContentType()) !== !1) {
        const [Y, ...ie] = I ? I.split(";").map((G) => G.trim()).filter(Boolean) : [];
        a.setContentType([Y || "multipart/form-data", ...ie].join("; "));
      }
    }
    let D = new XMLHttpRequest();
    if (y.auth) {
      const Y = y.auth.username || "", ie = y.auth.password ? unescape(encodeURIComponent(y.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(Y + ":" + ie));
    }
    const Z = md(y.baseURL, y.url);
    D.open(y.method.toUpperCase(), fd(Z, y.params, y.paramsSerializer), !0), D.timeout = y.timeout;
    function M() {
      if (!D)
        return;
      const Y = Os.from(
        "getAllResponseHeaders" in D && D.getAllResponseHeaders()
      ), G = {
        data: !u || u === "text" || u === "json" ? D.responseText : D.response,
        status: D.status,
        statusText: D.statusText,
        headers: Y,
        config: y,
        request: D
      };
      Vb(function(J) {
        t(J), S();
      }, function(J) {
        r(J), S();
      }, G), D = null;
    }
    if ("onloadend" in D ? D.onloadend = M : D.onreadystatechange = function() {
      !D || D.readyState !== 4 || D.status === 0 && !(D.responseURL && D.responseURL.indexOf("file:") === 0) || setTimeout(M);
    }, D.onabort = function() {
      D && (r(new Qi("Request aborted", Qi.ECONNABORTED, y, D)), D = null);
    }, D.onerror = function() {
      r(new Qi("Network Error", Qi.ERR_NETWORK, y, D)), D = null;
    }, D.ontimeout = function() {
      let ie = y.timeout ? "timeout of " + y.timeout + "ms exceeded" : "timeout exceeded";
      const G = y.transitional || dd;
      y.timeoutErrorMessage && (ie = y.timeoutErrorMessage), r(new Qi(
        ie,
        G.clarifyTimeoutError ? Qi.ETIMEDOUT : Qi.ECONNABORTED,
        y,
        D
      )), D = null;
    }, vs.hasStandardBrowserEnv && (f && Ot.isFunction(f) && (f = f(y)), f || f !== !1 && jb(Z))) {
      const Y = y.xsrfHeaderName && y.xsrfCookieName && Hb.read(y.xsrfCookieName);
      Y && a.set(y.xsrfHeaderName, Y);
    }
    o === void 0 && a.setContentType(null), "setRequestHeader" in D && Ot.forEach(a.toJSON(), function(ie, G) {
      D.setRequestHeader(G, ie);
    }), Ot.isUndefined(y.withCredentials) || (D.withCredentials = !!y.withCredentials), u && u !== "json" && (D.responseType = y.responseType), typeof y.onDownloadProgress == "function" && D.addEventListener("progress", Sf(y.onDownloadProgress, !0)), typeof y.onUploadProgress == "function" && D.upload && D.upload.addEventListener("progress", Sf(y.onUploadProgress)), (y.cancelToken || y.signal) && (v = (Y) => {
      D && (r(!Y || Y.type ? new fo(null, y, D) : Y), D.abort(), D = null);
    }, y.cancelToken && y.cancelToken.subscribe(v), y.signal && (y.signal.aborted ? v() : y.signal.addEventListener("abort", v)));
    const X = Wb(Z);
    if (X && vs.protocols.indexOf(X) === -1) {
      r(new Qi("Unsupported protocol " + X + ":", Qi.ERR_BAD_REQUEST, y));
      return;
    }
    D.send(o || null);
  });
}, Rh = {
  http: yb,
  xhr: Xb
};
Ot.forEach(Rh, (y, e) => {
  if (y) {
    try {
      Object.defineProperty(y, "name", { value: e });
    } catch {
    }
    Object.defineProperty(y, "adapterName", { value: e });
  }
});
const Mf = (y) => `- ${y}`, Kb = (y) => Ot.isFunction(y) || y === null || y === !1, vd = {
  getAdapter: (y) => {
    y = Ot.isArray(y) ? y : [y];
    const { length: e } = y;
    let t, r;
    const o = {};
    for (let a = 0; a < e; a++) {
      t = y[a];
      let u;
      if (r = t, !Kb(t) && (r = Rh[(u = String(t)).toLowerCase()], r === void 0))
        throw new Qi(`Unknown adapter '${u}'`);
      if (r)
        break;
      o[u || "#" + a] = r;
    }
    if (!r) {
      const a = Object.entries(o).map(
        ([f, v]) => `adapter ${f} ` + (v === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let u = e ? a.length > 1 ? `since :
` + a.map(Mf).join(`
`) : " " + Mf(a[0]) : "as no adapter specified";
      throw new Qi(
        "There is no suitable adapter to dispatch the request " + u,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Rh
};
function Ah(y) {
  if (y.cancelToken && y.cancelToken.throwIfRequested(), y.signal && y.signal.aborted)
    throw new fo(null, y);
}
function Cf(y) {
  return Ah(y), y.headers = Os.from(y.headers), y.data = Ch.call(
    y,
    y.transformRequest
  ), ["post", "put", "patch"].indexOf(y.method) !== -1 && y.headers.setContentType("application/x-www-form-urlencoded", !1), vd.getAdapter(y.adapter || Qh.adapter)(y).then(function(r) {
    return Ah(y), r.data = Ch.call(
      y,
      y.transformResponse,
      r
    ), r.headers = Os.from(r.headers), r;
  }, function(r) {
    return _d(r) || (Ah(y), r && r.response && (r.response.data = Ch.call(
      y,
      y.transformResponse,
      r.response
    ), r.response.headers = Os.from(r.response.headers))), Promise.reject(r);
  });
}
const Af = (y) => y instanceof Os ? { ...y } : y;
function Aa(y, e) {
  e = e || {};
  const t = {};
  function r(S, I, D) {
    return Ot.isPlainObject(S) && Ot.isPlainObject(I) ? Ot.merge.call({ caseless: D }, S, I) : Ot.isPlainObject(I) ? Ot.merge({}, I) : Ot.isArray(I) ? I.slice() : I;
  }
  function o(S, I, D) {
    if (Ot.isUndefined(I)) {
      if (!Ot.isUndefined(S))
        return r(void 0, S, D);
    } else
      return r(S, I, D);
  }
  function a(S, I) {
    if (!Ot.isUndefined(I))
      return r(void 0, I);
  }
  function u(S, I) {
    if (Ot.isUndefined(I)) {
      if (!Ot.isUndefined(S))
        return r(void 0, S);
    } else
      return r(void 0, I);
  }
  function f(S, I, D) {
    if (D in e)
      return r(S, I);
    if (D in y)
      return r(void 0, S);
  }
  const v = {
    url: a,
    method: a,
    data: a,
    baseURL: u,
    transformRequest: u,
    transformResponse: u,
    paramsSerializer: u,
    timeout: u,
    timeoutMessage: u,
    withCredentials: u,
    withXSRFToken: u,
    adapter: u,
    responseType: u,
    xsrfCookieName: u,
    xsrfHeaderName: u,
    onUploadProgress: u,
    onDownloadProgress: u,
    decompress: u,
    maxContentLength: u,
    maxBodyLength: u,
    beforeRedirect: u,
    transport: u,
    httpAgent: u,
    httpsAgent: u,
    cancelToken: u,
    socketPath: u,
    responseEncoding: u,
    validateStatus: f,
    headers: (S, I) => o(Af(S), Af(I), !0)
  };
  return Ot.forEach(Object.keys(Object.assign({}, y, e)), function(I) {
    const D = v[I] || o, Z = D(y[I], e[I], I);
    Ot.isUndefined(Z) && D !== f || (t[I] = Z);
  }), t;
}
const yd = "1.6.8", eu = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((y, e) => {
  eu[y] = function(r) {
    return typeof r === y || "a" + (e < 1 ? "n " : " ") + y;
  };
});
const Tf = {};
eu.transitional = function(e, t, r) {
  function o(a, u) {
    return "[Axios v" + yd + "] Transitional option '" + a + "'" + u + (r ? ". " + r : "");
  }
  return (a, u, f) => {
    if (e === !1)
      throw new Qi(
        o(u, " has been removed" + (t ? " in " + t : "")),
        Qi.ERR_DEPRECATED
      );
    return t && !Tf[u] && (Tf[u] = !0, console.warn(
      o(
        u,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, u, f) : !0;
  };
};
function Jb(y, e, t) {
  if (typeof y != "object")
    throw new Qi("options must be an object", Qi.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(y);
  let o = r.length;
  for (; o-- > 0; ) {
    const a = r[o], u = e[a];
    if (u) {
      const f = y[a], v = f === void 0 || u(f, a, y);
      if (v !== !0)
        throw new Qi("option " + a + " must be " + v, Qi.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Qi("Unknown option " + a, Qi.ERR_BAD_OPTION);
  }
}
const Dh = {
  assertOptions: Jb,
  validators: eu
}, Hs = Dh.validators;
class dl {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new xf(),
      response: new xf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        r.stack ? a && !String(r.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + a) : r.stack = a;
      }
      throw r;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Aa(this.defaults, t);
    const { transitional: r, paramsSerializer: o, headers: a } = t;
    r !== void 0 && Dh.assertOptions(r, {
      silentJSONParsing: Hs.transitional(Hs.boolean),
      forcedJSONParsing: Hs.transitional(Hs.boolean),
      clarifyTimeoutError: Hs.transitional(Hs.boolean)
    }, !1), o != null && (Ot.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : Dh.assertOptions(o, {
      encode: Hs.function,
      serialize: Hs.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let u = a && Ot.merge(
      a.common,
      a[t.method]
    );
    a && Ot.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (X) => {
        delete a[X];
      }
    ), t.headers = Os.concat(u, a);
    const f = [];
    let v = !0;
    this.interceptors.request.forEach(function(Y) {
      typeof Y.runWhen == "function" && Y.runWhen(t) === !1 || (v = v && Y.synchronous, f.unshift(Y.fulfilled, Y.rejected));
    });
    const S = [];
    this.interceptors.response.forEach(function(Y) {
      S.push(Y.fulfilled, Y.rejected);
    });
    let I, D = 0, Z;
    if (!v) {
      const X = [Cf.bind(this), void 0];
      for (X.unshift.apply(X, f), X.push.apply(X, S), Z = X.length, I = Promise.resolve(t); D < Z; )
        I = I.then(X[D++], X[D++]);
      return I;
    }
    Z = f.length;
    let M = t;
    for (D = 0; D < Z; ) {
      const X = f[D++], Y = f[D++];
      try {
        M = X(M);
      } catch (ie) {
        Y.call(this, ie);
        break;
      }
    }
    try {
      I = Cf.call(this, M);
    } catch (X) {
      return Promise.reject(X);
    }
    for (D = 0, Z = S.length; D < Z; )
      I = I.then(S[D++], S[D++]);
    return I;
  }
  getUri(e) {
    e = Aa(this.defaults, e);
    const t = md(e.baseURL, e.url);
    return fd(t, e.params, e.paramsSerializer);
  }
}
Ot.forEach(["delete", "get", "head", "options"], function(e) {
  dl.prototype[e] = function(t, r) {
    return this.request(Aa(r || {}, {
      method: e,
      url: t,
      data: (r || {}).data
    }));
  };
});
Ot.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(a, u, f) {
      return this.request(Aa(f || {}, {
        method: e,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: u
      }));
    };
  }
  dl.prototype[e] = t(), dl.prototype[e + "Form"] = t(!0);
});
const sl = dl;
class tu {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(a) {
      t = a;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners)
        return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const u = new Promise((f) => {
        r.subscribe(f), a = f;
      }).then(o);
      return u.cancel = function() {
        r.unsubscribe(a);
      }, u;
    }, e(function(a, u, f) {
      r.reason || (r.reason = new fo(a, u, f), t(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new tu(function(o) {
        e = o;
      }),
      cancel: e
    };
  }
}
const $b = tu;
function Qb(y) {
  return function(t) {
    return y.apply(null, t);
  };
}
function ex(y) {
  return Ot.isObject(y) && y.isAxiosError === !0;
}
const zh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(zh).forEach(([y, e]) => {
  zh[e] = y;
});
const tx = zh;
function bd(y) {
  const e = new sl(y), t = ed(sl.prototype.request, e);
  return Ot.extend(t, sl.prototype, e, { allOwnKeys: !0 }), Ot.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(o) {
    return bd(Aa(y, o));
  }, t;
}
const Hn = bd(Qh);
Hn.Axios = sl;
Hn.CanceledError = fo;
Hn.CancelToken = $b;
Hn.isCancel = _d;
Hn.VERSION = yd;
Hn.toFormData = Ml;
Hn.AxiosError = Qi;
Hn.Cancel = Hn.CanceledError;
Hn.all = function(e) {
  return Promise.all(e);
};
Hn.spread = Qb;
Hn.isAxiosError = ex;
Hn.mergeConfig = Aa;
Hn.AxiosHeaders = Os;
Hn.formToJSON = (y) => pd(Ot.isHTMLForm(y) ? new FormData(y) : y);
Hn.getAdapter = vd.getAdapter;
Hn.HttpStatusCode = tx;
Hn.default = Hn;
const Lf = Hn;
var Ga = globalThis && globalThis.__awaiter || function(y, e, t, r) {
  function o(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function f(I) {
      try {
        S(r.next(I));
      } catch (D) {
        u(D);
      }
    }
    function v(I) {
      try {
        S(r.throw(I));
      } catch (D) {
        u(D);
      }
    }
    function S(I) {
      I.done ? a(I.value) : o(I.value).then(f, v);
    }
    S((r = r.apply(y, e || [])).next());
  });
}, ja = globalThis && globalThis.__generator || function(y, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, o, a, u;
  return u = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function f(S) {
    return function(I) {
      return v([S, I]);
    };
  }
  function v(S) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (r = 1, o && (a = S[0] & 2 ? o.return : S[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, S[1])).done)
          return a;
        switch (o = 0, a && (S = [S[0] & 2, a.value]), S[0]) {
          case 0:
          case 1:
            a = S;
            break;
          case 4:
            return t.label++, { value: S[1], done: !1 };
          case 5:
            t.label++, o = S[1], S = [0];
            continue;
          case 7:
            S = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (S[0] === 6 || S[0] === 2)) {
              t = 0;
              continue;
            }
            if (S[0] === 3 && (!a || S[1] > a[0] && S[1] < a[3])) {
              t.label = S[1];
              break;
            }
            if (S[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = S;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(S);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        S = e.call(y, t);
      } catch (I) {
        S = [6, I], o = 0;
      } finally {
        r = a = 0;
      }
    if (S[0] & 5)
      throw S[1];
    return { value: S[0] ? S[1] : void 0, done: !0 };
  }
}, Bf = (
  /** @class */
  function() {
    function y(e, t, r) {
      var o = this;
      r === void 0 && (r = !0), this.tasksUrl = e, this.token = t, this.upload = function(a, u) {
        return Ga(o, void 0, void 0, function() {
          return ja(this, function(f) {
            switch (f.label) {
              case 0:
                return [4, this.uploadFileChunked(a, a.type, Zakeke.generateUUID(), u)];
              case 1:
                return [2, f.sent()];
            }
          });
        });
      }, this.uploadFileChunked = function(a, u, f, v, S) {
        return Ga(o, void 0, void 0, function() {
          var I, D, Z;
          return ja(this, function(M) {
            switch (M.label) {
              case 0:
                return [4, this.resumableUpload(a, u, f, S)];
              case 1:
                return I = M.sent(), I !== "OK" ? [3, 5] : [4, this.createTask(f, v)];
              case 2:
                return D = M.sent(), D === -1 ? [3, 4] : [4, this.getResultFromTask(D)];
              case 3:
                return Z = M.sent(), Z ? [2, Z.files] : [3, 5];
              case 4:
                throw "Upload failed";
              case 5:
                return [2, null];
            }
          });
        });
      }, this.resumableUpload = function(a, u, f, v) {
        return Ga(o, void 0, void 0, function() {
          var S = this;
          return ja(this, function(I) {
            return [2, new Promise(function(D, Z) {
              var M = new Resumable({
                target: Zakeke.config.baseApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function() {
                  return f;
                },
                maxFiles: 1,
                testChunks: !1,
                headers: S.headers,
                query: { resumableType: u },
                simultaneousUploads: 3
              });
              M.addFile(a), M.on("fileError", function(X, Y) {
                D("KO"), console.error("fileError", X, Y);
              }), M.on("error", function(X, Y) {
                D("KO"), console.error("error", X, Y);
              }), M.on("progress", function() {
                var X = M.progress() * 100;
                v && v(X);
              }), M.on("fileAdded", function(X, Y) {
                M.upload();
              }), M.on("complete", function() {
                D("OK");
              });
            })];
          });
        });
      }, this.createTask = function(a, u) {
        return Ga(o, void 0, void 0, function() {
          var f, v;
          return ja(this, function(S) {
            switch (S.label) {
              case 0:
                return f = { fileID: a, options: u }, [4, Lf.post(Zakeke.config.baseApiUrl + this.tasksUrl, f, { headers: this.headers })];
              case 1:
                return v = S.sent(), [2, v ? v.data.taskID : -1];
            }
          });
        });
      }, this.getResultFromTask = function(a) {
        return Ga(o, void 0, void 0, function() {
          var u, f;
          return ja(this, function(v) {
            switch (v.label) {
              case 0:
                u = 0, v.label = 1;
              case 1:
                return v.trys.push([1, 3, , 4]), [4, Lf.get(Zakeke.config.baseApiUrl + this.tasksUrl + "/results/" + a, { headers: this.headers })];
              case 2:
                return f = v.sent(), f && f.data.state === 2 ? [2, f.data] : f && f.data.state === 3 ? [2, null] : [3, 4];
              case 3:
                return v.sent(), [2, null];
              case 4:
                return u++, u > 100 ? [2, null] : [4, new Promise(function(S) {
                  return setTimeout(S, 1e3);
                })];
              case 5:
                v.sent(), v.label = 6;
              case 6:
                return [3, 1];
              case 7:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, r ? this.headers = {
        Authorization: "Bearer " + this.token,
        "Accept-Language": "en-US"
      } : this.headers = {
        "X-Auth-Token": this.token,
        "Accept-Language": "en-US"
      };
    }
    return y;
  }()
);
class li {
}
li.Environment = {
  //EnvironmentTextureName: "environmentSpecular.dds",
  EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
  GroundTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundGround9.png",
  SkyboxTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundSkybox.dds",
  //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
  //EnvironmentTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/environmentSpecular.dds"
  EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env"
};
li.TryonReferences = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/tryon/references/",
  ReferenceGlassesFrameName: "Reference Glasses Frame",
  ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json",
  EyewearName: "glasses_VTO_Reference",
  EyewearURL: "Eyewear_VTO_Reference.babylon",
  EyewearDownloadableURL: "Eyewear_VTO_Reference.glb",
  ScarvesName: "scarves_VTO_Reference",
  ScarvesURL: "Scarves_VTO_Reference.babylon",
  ScarvesDownloadableURL: "Scarves_VTO_Reference.glb",
  EarringsName: "earrings_VTO_Reference",
  EarringsURL: "Earrings_VTO_Reference.babylon",
  EarringsDownloadableURL: "Earrings_VTO_Reference.glb",
  HeadwearName: "headwear_VTO_Reference",
  HeadwearURL: "Headwear_VTO_Reference.babylon",
  HeadwearDownloadableURL: "Headwear_VTO_Reference.glb",
  NecklaceName: "necklace_VTO_Reference",
  NecklaceURL: "Necklace_VTO_Reference.babylon",
  NecklaceDownloadableURL: "Necklace_VTO_Reference.glb",
  ShoeName: "foot_VTO_Reference",
  ShoeURL: "Foot_VTO_Reference.babylon",
  ShoeDownloadableURL: "Foot_VTO_Reference.glb"
};
li.Shapes = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/shapes/",
  RoundedCubeName: "Rounded Cube",
  RoundedCubeFileName: "rounded_cube.babylon",
  RoundedCylinderName: "Rounded Cylinder",
  RoundedCylinderFileName: "rounded_cylinder.babylon",
  MatBallName: "Mat Ball",
  MatBallFileName: "mat_ball.babylon",
  MaleHeadName: "Group48944",
  MaleHeadFileName: "DemoHead.babylon",
  FemaleHeadName: "Group12208",
  FemaleHeadFileName: "FemaleHead.babylon",
  PokemonBallName: "PokemonBall",
  PokemonBallFileName: "PokemonBall.babylon",
  ShaderBallName: "Elements",
  ShaderBallFileName: "ShaderBall.babylon",
  BootsFolder: "boots/",
  BootsName: "shoe",
  BootsFileName: "boots.incremental.babylon",
  SuzanneName: "Suzanne",
  SuzanneFileName: "suzanne.babylon",
  StepPyramidName: "Pyramid",
  StepPyramidFileName: "step-pyramid.babylon",
  TeapotName: "Teapot",
  TeapotFileName: "teapot.babylon",
  AlloyWheelName: "Wheel",
  AlloyWheelFolder: "alloy_wheel/",
  AlloyWheelFileName: "alloy_wheel.incremental.babylon"
};
class ps {
  /**
   * Checks for a matching suffix at the end of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static EndsWith(e, t) {
    return e.indexOf(t, e.length - t.length) !== -1;
  }
  /**
   * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static StartsWith(e, t) {
    return e.indexOf(t) === 0;
  }
  /**
   * Decodes a buffer into a string
   * @param buffer The buffer to decode
   * @returns The decoded string
   */
  static Decode(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let t = "";
    for (let r = 0; r < e.byteLength; r++)
      t += String.fromCharCode(e[r]);
    return t;
  }
  /**
   * Encode a buffer to a base64 string
   * @param buffer defines the buffer to encode
   * @returns the encoded string
   */
  static EncodeArrayBufferToBase64(e) {
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r = "", o, a, u, f, v, S, I, D = 0, Z = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e); D < Z.length; )
      o = Z[D++], a = D < Z.length ? Z[D++] : Number.NaN, u = D < Z.length ? Z[D++] : Number.NaN, f = o >> 2, v = (o & 3) << 4 | a >> 4, S = (a & 15) << 2 | u >> 6, I = u & 63, isNaN(a) ? S = I = 64 : isNaN(u) && (I = 64), r += t.charAt(f) + t.charAt(v) + t.charAt(S) + t.charAt(I);
    return r;
  }
}
class ix {
  constructor() {
    this._mesh = null, this._scene = null, this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  dispose() {
  }
  resetDataModel() {
    this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  prepareDataModel() {
    if (this.resetDataModel(), this._mesh && this._scene && (this._facesOfVertices = [], this._sharedFacesOfVertices = {}, this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind), this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), this._meshIndices = this._mesh.getIndices(), this._meshPositions = [], this._meshFacesNormals = [], this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices)) {
      for (let e = 0; e < this._meshVerticesPositions.length; e += 3)
        this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[e], this._meshVerticesPositions[e + 1], this._meshVerticesPositions[e + 2]));
      for (let e = 0; e < this._mesh.getTotalIndices() / 3; e++)
        this._computeFaceNormal(e);
      this._getFacesOfVertices();
    }
  }
  _getFaceVerticesIndex(e) {
    return this._meshIndices ? {
      v1: this._meshIndices[e * 3],
      v2: this._meshIndices[e * 3 + 1],
      v3: this._meshIndices[e * 3 + 2]
    } : null;
  }
  // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
  // tra i vettori che connettono gli spigoli
  _computeFaceNormal(e) {
    if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
      const t = this._getFaceVerticesIndex(e);
      if (t) {
        const r = this._meshPositions[t.v1].subtract(this._meshPositions[t.v2]), o = this._meshPositions[t.v3].subtract(this._meshPositions[t.v2]);
        this._meshFacesNormals[e] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(r, o));
      }
    }
  }
  _getPositionKey(e) {
    return `${e.x}_${e.y}_${e.z}`;
  }
  // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
  // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
  // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
  // un vertice come spigolo.
  _getFacesOfVertices() {
    if (this._mesh && this._meshPositions && this._meshIndices) {
      this._sharedFacesOfVertices = {}, this._facesOfVertices = [];
      for (let e = 0; e < this._meshPositions.length; e++) {
        this._facesOfVertices[e] = [];
        const t = this._meshPositions[e], r = this._getPositionKey(t);
        this._sharedFacesOfVertices.hasOwnProperty(r) || (this._sharedFacesOfVertices[r] = /* @__PURE__ */ new Set());
      }
      for (let e = 0; e < this._meshIndices.length; e++) {
        const t = this._meshIndices[e], r = e / 3 | 0;
        this._facesOfVertices[t].push(r);
        const o = this._meshPositions[t], a = this._getPositionKey(o);
        this._sharedFacesOfVertices.hasOwnProperty(a) && this._sharedFacesOfVertices[a].add(r);
      }
    }
  }
  expandMesh(e, t = 0.01) {
    if (e instanceof BABYLON.Mesh && (this._mesh = e, this._scene = e.getScene(), this.prepareDataModel(), this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals)) {
      for (let r = 0; r < this._meshPositions.length; r++) {
        const o = this._meshPositions[r], a = this._getVertexComputedNormal(r);
        if (a) {
          const u = a.scale(t);
          o.addInPlace(u), this._meshVerticesPositions[r * 3] = o.x, this._meshVerticesPositions[r * 3 + 1] = o.y, this._meshVerticesPositions[r * 3 + 2] = o.z;
        }
      }
      this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, !0), this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions), this._mesh.computeWorldMatrix(!0);
    }
  }
  _reComputeNormals() {
    const e = [];
    if (this._meshPositions && this._facesOfVertices) {
      for (let r = 0; r < this._meshPositions.length; r++) {
        const o = this._facesOfVertices[r];
        for (let a = 0; a < o.length; a++)
          e[o[a]] = !0;
      }
      let t;
      for (t in e)
        this._computeFaceNormal(t);
      for (t in e) {
        const r = this._getFaceVerticesIndex(t);
        r && (this._computeNormal(r.v1), this._computeNormal(r.v2), this._computeNormal(r.v3));
      }
    }
  }
  _getVertexComputedNormal(e) {
    let t = null;
    if (this._meshPositions && this._meshFacesNormals) {
      const r = this._meshPositions, o = this._meshFacesNormals, a = r[e], u = this._getPositionKey(a);
      if (this._sharedFacesOfVertices.hasOwnProperty(u)) {
        const f = this._sharedFacesOfVertices[u];
        t = BABYLON.Vector3.Zero(), f.forEach((v) => {
          const S = o[v];
          t && S && (t = t.add(S));
        }), t = BABYLON.Vector3.Normalize(t.scale(1 / f.size));
      }
    }
    return t;
  }
  _computeNormal(e) {
    const t = this._getVertexComputedNormal(e);
    t && this._meshVerticesNormals && (this._meshVerticesNormals[e * 3] = t.x, this._meshVerticesNormals[e * 3 + 1] = t.y, this._meshVerticesNormals[e * 3 + 2] = t.z);
  }
}
class nx {
  static async convertGlbToUsdz(e) {
    return new Promise((t, r) => {
      let o = null;
      new THREE.GLTFLoader().load(e, async function(u) {
        u.scene.updateWorldMatrix(!0, !0);
        const v = await new THREE.USDZExporter().parse(u.scene);
        o = new Blob([v], { type: "model/vnd.usdz+zip" }), t(o);
      });
    });
  }
}
var Kr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iu(y) {
  return y && y.__esModule && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y;
}
function rx(y) {
  if (y.__esModule)
    return y;
  var e = y.default;
  if (typeof e == "function") {
    var t = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(y).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(y, r);
    Object.defineProperty(t, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return y[r];
      }
    });
  }), t;
}
function Xa(y) {
  throw new Error('Could not dynamically require "' + y + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var xd = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(y, e) {
  (function(t) {
    y.exports = t();
  })(function() {
    return function t(r, o, a) {
      function u(S, I) {
        if (!o[S]) {
          if (!r[S]) {
            var D = typeof Xa == "function" && Xa;
            if (!I && D)
              return D(S, !0);
            if (f)
              return f(S, !0);
            var Z = new Error("Cannot find module '" + S + "'");
            throw Z.code = "MODULE_NOT_FOUND", Z;
          }
          var M = o[S] = { exports: {} };
          r[S][0].call(M.exports, function(X) {
            var Y = r[S][1][X];
            return u(Y || X);
          }, M, M.exports, t, r, o, a);
        }
        return o[S].exports;
      }
      for (var f = typeof Xa == "function" && Xa, v = 0; v < a.length; v++)
        u(a[v]);
      return u;
    }({ 1: [function(t, r, o) {
      var a = t("./utils"), u = t("./support"), f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      o.encode = function(v) {
        for (var S, I, D, Z, M, X, Y, ie = [], G = 0, te = v.length, J = te, he = a.getTypeOf(v) !== "string"; G < v.length; )
          J = te - G, D = he ? (S = v[G++], I = G < te ? v[G++] : 0, G < te ? v[G++] : 0) : (S = v.charCodeAt(G++), I = G < te ? v.charCodeAt(G++) : 0, G < te ? v.charCodeAt(G++) : 0), Z = S >> 2, M = (3 & S) << 4 | I >> 4, X = 1 < J ? (15 & I) << 2 | D >> 6 : 64, Y = 2 < J ? 63 & D : 64, ie.push(f.charAt(Z) + f.charAt(M) + f.charAt(X) + f.charAt(Y));
        return ie.join("");
      }, o.decode = function(v) {
        var S, I, D, Z, M, X, Y = 0, ie = 0, G = "data:";
        if (v.substr(0, G.length) === G)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var te, J = 3 * (v = v.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (v.charAt(v.length - 1) === f.charAt(64) && J--, v.charAt(v.length - 2) === f.charAt(64) && J--, J % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (te = u.uint8array ? new Uint8Array(0 | J) : new Array(0 | J); Y < v.length; )
          S = f.indexOf(v.charAt(Y++)) << 2 | (Z = f.indexOf(v.charAt(Y++))) >> 4, I = (15 & Z) << 4 | (M = f.indexOf(v.charAt(Y++))) >> 2, D = (3 & M) << 6 | (X = f.indexOf(v.charAt(Y++))), te[ie++] = S, M !== 64 && (te[ie++] = I), X !== 64 && (te[ie++] = D);
        return te;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(t, r, o) {
      var a = t("./external"), u = t("./stream/DataWorker"), f = t("./stream/Crc32Probe"), v = t("./stream/DataLengthProbe");
      function S(I, D, Z, M, X) {
        this.compressedSize = I, this.uncompressedSize = D, this.crc32 = Z, this.compression = M, this.compressedContent = X;
      }
      S.prototype = { getContentWorker: function() {
        var I = new u(a.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new v("data_length")), D = this;
        return I.on("end", function() {
          if (this.streamInfo.data_length !== D.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), I;
      }, getCompressedWorker: function() {
        return new u(a.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, S.createWorkerFrom = function(I, D, Z) {
        return I.pipe(new f()).pipe(new v("uncompressedSize")).pipe(D.compressWorker(Z)).pipe(new v("compressedSize")).withStreamInfo("compression", D);
      }, r.exports = S;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(t, r, o) {
      var a = t("./stream/GenericWorker");
      o.STORE = { magic: "\0\0", compressWorker: function() {
        return new a("STORE compression");
      }, uncompressWorker: function() {
        return new a("STORE decompression");
      } }, o.DEFLATE = t("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(t, r, o) {
      var a = t("./utils"), u = function() {
        for (var f, v = [], S = 0; S < 256; S++) {
          f = S;
          for (var I = 0; I < 8; I++)
            f = 1 & f ? 3988292384 ^ f >>> 1 : f >>> 1;
          v[S] = f;
        }
        return v;
      }();
      r.exports = function(f, v) {
        return f !== void 0 && f.length ? a.getTypeOf(f) !== "string" ? function(S, I, D, Z) {
          var M = u, X = Z + D;
          S ^= -1;
          for (var Y = Z; Y < X; Y++)
            S = S >>> 8 ^ M[255 & (S ^ I[Y])];
          return -1 ^ S;
        }(0 | v, f, f.length, 0) : function(S, I, D, Z) {
          var M = u, X = Z + D;
          S ^= -1;
          for (var Y = Z; Y < X; Y++)
            S = S >>> 8 ^ M[255 & (S ^ I.charCodeAt(Y))];
          return -1 ^ S;
        }(0 | v, f, f.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(t, r, o) {
      o.base64 = !1, o.binary = !1, o.dir = !1, o.createFolders = !0, o.date = null, o.compression = null, o.compressionOptions = null, o.comment = null, o.unixPermissions = null, o.dosPermissions = null;
    }, {}], 6: [function(t, r, o) {
      var a = null;
      a = typeof Promise < "u" ? Promise : t("lie"), r.exports = { Promise: a };
    }, { lie: 37 }], 7: [function(t, r, o) {
      var a = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", u = t("pako"), f = t("./utils"), v = t("./stream/GenericWorker"), S = a ? "uint8array" : "array";
      function I(D, Z) {
        v.call(this, "FlateWorker/" + D), this._pako = null, this._pakoAction = D, this._pakoOptions = Z, this.meta = {};
      }
      o.magic = "\b\0", f.inherits(I, v), I.prototype.processChunk = function(D) {
        this.meta = D.meta, this._pako === null && this._createPako(), this._pako.push(f.transformTo(S, D.data), !1);
      }, I.prototype.flush = function() {
        v.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, I.prototype.cleanUp = function() {
        v.prototype.cleanUp.call(this), this._pako = null;
      }, I.prototype._createPako = function() {
        this._pako = new u[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var D = this;
        this._pako.onData = function(Z) {
          D.push({ data: Z, meta: D.meta });
        };
      }, o.compressWorker = function(D) {
        return new I("Deflate", D);
      }, o.uncompressWorker = function() {
        return new I("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(t, r, o) {
      function a(M, X) {
        var Y, ie = "";
        for (Y = 0; Y < X; Y++)
          ie += String.fromCharCode(255 & M), M >>>= 8;
        return ie;
      }
      function u(M, X, Y, ie, G, te) {
        var J, he, ve = M.file, K = M.compression, j = te !== S.utf8encode, We = f.transformTo("string", te(ve.name)), ke = f.transformTo("string", S.utf8encode(ve.name)), $e = ve.comment, Lt = f.transformTo("string", te($e)), Be = f.transformTo("string", S.utf8encode($e)), Xe = ke.length !== ve.name.length, ue = Be.length !== $e.length, yt = "", Ue = "", ot = "", Gt = ve.dir, it = ve.date, Zt = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        X && !Y || (Zt.crc32 = M.crc32, Zt.compressedSize = M.compressedSize, Zt.uncompressedSize = M.uncompressedSize);
        var ct = 0;
        X && (ct |= 8), j || !Xe && !ue || (ct |= 2048);
        var lt = 0, $t = 0;
        Gt && (lt |= 16), G === "UNIX" ? ($t = 798, lt |= function(At, Ni) {
          var rn = At;
          return At || (rn = Ni ? 16893 : 33204), (65535 & rn) << 16;
        }(ve.unixPermissions, Gt)) : ($t = 20, lt |= function(At) {
          return 63 & (At || 0);
        }(ve.dosPermissions)), J = it.getUTCHours(), J <<= 6, J |= it.getUTCMinutes(), J <<= 5, J |= it.getUTCSeconds() / 2, he = it.getUTCFullYear() - 1980, he <<= 4, he |= it.getUTCMonth() + 1, he <<= 5, he |= it.getUTCDate(), Xe && (Ue = a(1, 1) + a(I(We), 4) + ke, yt += "up" + a(Ue.length, 2) + Ue), ue && (ot = a(1, 1) + a(I(Lt), 4) + Be, yt += "uc" + a(ot.length, 2) + ot);
        var Kt = "";
        return Kt += `
\0`, Kt += a(ct, 2), Kt += K.magic, Kt += a(J, 2), Kt += a(he, 2), Kt += a(Zt.crc32, 4), Kt += a(Zt.compressedSize, 4), Kt += a(Zt.uncompressedSize, 4), Kt += a(We.length, 2), Kt += a(yt.length, 2), { fileRecord: D.LOCAL_FILE_HEADER + Kt + We + yt, dirRecord: D.CENTRAL_FILE_HEADER + a($t, 2) + Kt + a(Lt.length, 2) + "\0\0\0\0" + a(lt, 4) + a(ie, 4) + We + yt + Lt };
      }
      var f = t("../utils"), v = t("../stream/GenericWorker"), S = t("../utf8"), I = t("../crc32"), D = t("../signature");
      function Z(M, X, Y, ie) {
        v.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = X, this.zipPlatform = Y, this.encodeFileName = ie, this.streamFiles = M, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      f.inherits(Z, v), Z.prototype.push = function(M) {
        var X = M.meta.percent || 0, Y = this.entriesCount, ie = this._sources.length;
        this.accumulate ? this.contentBuffer.push(M) : (this.bytesWritten += M.data.length, v.prototype.push.call(this, { data: M.data, meta: { currentFile: this.currentFile, percent: Y ? (X + 100 * (Y - ie - 1)) / Y : 100 } }));
      }, Z.prototype.openedSource = function(M) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = M.file.name;
        var X = this.streamFiles && !M.file.dir;
        if (X) {
          var Y = u(M, X, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: Y.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, Z.prototype.closedSource = function(M) {
        this.accumulate = !1;
        var X = this.streamFiles && !M.file.dir, Y = u(M, X, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(Y.dirRecord), X)
          this.push({ data: function(ie) {
            return D.DATA_DESCRIPTOR + a(ie.crc32, 4) + a(ie.compressedSize, 4) + a(ie.uncompressedSize, 4);
          }(M), meta: { percent: 100 } });
        else
          for (this.push({ data: Y.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, Z.prototype.flush = function() {
        for (var M = this.bytesWritten, X = 0; X < this.dirRecords.length; X++)
          this.push({ data: this.dirRecords[X], meta: { percent: 100 } });
        var Y = this.bytesWritten - M, ie = function(G, te, J, he, ve) {
          var K = f.transformTo("string", ve(he));
          return D.CENTRAL_DIRECTORY_END + "\0\0\0\0" + a(G, 2) + a(G, 2) + a(te, 4) + a(J, 4) + a(K.length, 2) + K;
        }(this.dirRecords.length, Y, M, this.zipComment, this.encodeFileName);
        this.push({ data: ie, meta: { percent: 100 } });
      }, Z.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, Z.prototype.registerPrevious = function(M) {
        this._sources.push(M);
        var X = this;
        return M.on("data", function(Y) {
          X.processChunk(Y);
        }), M.on("end", function() {
          X.closedSource(X.previous.streamInfo), X._sources.length ? X.prepareNextSource() : X.end();
        }), M.on("error", function(Y) {
          X.error(Y);
        }), this;
      }, Z.prototype.resume = function() {
        return !!v.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, Z.prototype.error = function(M) {
        var X = this._sources;
        if (!v.prototype.error.call(this, M))
          return !1;
        for (var Y = 0; Y < X.length; Y++)
          try {
            X[Y].error(M);
          } catch {
          }
        return !0;
      }, Z.prototype.lock = function() {
        v.prototype.lock.call(this);
        for (var M = this._sources, X = 0; X < M.length; X++)
          M[X].lock();
      }, r.exports = Z;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(t, r, o) {
      var a = t("../compressions"), u = t("./ZipFileWorker");
      o.generateWorker = function(f, v, S) {
        var I = new u(v.streamFiles, S, v.platform, v.encodeFileName), D = 0;
        try {
          f.forEach(function(Z, M) {
            D++;
            var X = function(te, J) {
              var he = te || J, ve = a[he];
              if (!ve)
                throw new Error(he + " is not a valid compression method !");
              return ve;
            }(M.options.compression, v.compression), Y = M.options.compressionOptions || v.compressionOptions || {}, ie = M.dir, G = M.date;
            M._compressWorker(X, Y).withStreamInfo("file", { name: Z, dir: ie, date: G, comment: M.comment || "", unixPermissions: M.unixPermissions, dosPermissions: M.dosPermissions }).pipe(I);
          }), I.entriesCount = D;
        } catch (Z) {
          I.error(Z);
        }
        return I;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(t, r, o) {
      function a() {
        if (!(this instanceof a))
          return new a();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var u = new a();
          for (var f in this)
            typeof this[f] != "function" && (u[f] = this[f]);
          return u;
        };
      }
      (a.prototype = t("./object")).loadAsync = t("./load"), a.support = t("./support"), a.defaults = t("./defaults"), a.version = "3.10.1", a.loadAsync = function(u, f) {
        return new a().loadAsync(u, f);
      }, a.external = t("./external"), r.exports = a;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(t, r, o) {
      var a = t("./utils"), u = t("./external"), f = t("./utf8"), v = t("./zipEntries"), S = t("./stream/Crc32Probe"), I = t("./nodejsUtils");
      function D(Z) {
        return new u.Promise(function(M, X) {
          var Y = Z.decompressed.getContentWorker().pipe(new S());
          Y.on("error", function(ie) {
            X(ie);
          }).on("end", function() {
            Y.streamInfo.crc32 !== Z.decompressed.crc32 ? X(new Error("Corrupted zip : CRC32 mismatch")) : M();
          }).resume();
        });
      }
      r.exports = function(Z, M) {
        var X = this;
        return M = a.extend(M || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: f.utf8decode }), I.isNode && I.isStream(Z) ? u.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : a.prepareContent("the loaded zip file", Z, !0, M.optimizedBinaryString, M.base64).then(function(Y) {
          var ie = new v(M);
          return ie.load(Y), ie;
        }).then(function(Y) {
          var ie = [u.Promise.resolve(Y)], G = Y.files;
          if (M.checkCRC32)
            for (var te = 0; te < G.length; te++)
              ie.push(D(G[te]));
          return u.Promise.all(ie);
        }).then(function(Y) {
          for (var ie = Y.shift(), G = ie.files, te = 0; te < G.length; te++) {
            var J = G[te], he = J.fileNameStr, ve = a.resolve(J.fileNameStr);
            X.file(ve, J.decompressed, { binary: !0, optimizedBinaryString: !0, date: J.date, dir: J.dir, comment: J.fileCommentStr.length ? J.fileCommentStr : null, unixPermissions: J.unixPermissions, dosPermissions: J.dosPermissions, createFolders: M.createFolders }), J.dir || (X.file(ve).unsafeOriginalName = he);
          }
          return ie.zipComment.length && (X.comment = ie.zipComment), X;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(t, r, o) {
      var a = t("../utils"), u = t("../stream/GenericWorker");
      function f(v, S) {
        u.call(this, "Nodejs stream input adapter for " + v), this._upstreamEnded = !1, this._bindStream(S);
      }
      a.inherits(f, u), f.prototype._bindStream = function(v) {
        var S = this;
        (this._stream = v).pause(), v.on("data", function(I) {
          S.push({ data: I, meta: { percent: 0 } });
        }).on("error", function(I) {
          S.isPaused ? this.generatedError = I : S.error(I);
        }).on("end", function() {
          S.isPaused ? S._upstreamEnded = !0 : S.end();
        });
      }, f.prototype.pause = function() {
        return !!u.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, f.prototype.resume = function() {
        return !!u.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, r.exports = f;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(t, r, o) {
      var a = t("readable-stream").Readable;
      function u(f, v, S) {
        a.call(this, v), this._helper = f;
        var I = this;
        f.on("data", function(D, Z) {
          I.push(D) || I._helper.pause(), S && S(Z);
        }).on("error", function(D) {
          I.emit("error", D);
        }).on("end", function() {
          I.push(null);
        });
      }
      t("../utils").inherits(u, a), u.prototype._read = function() {
        this._helper.resume();
      }, r.exports = u;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(t, r, o) {
      r.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(a, u) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(a, u);
        if (typeof a == "number")
          throw new Error('The "data" argument must not be a number');
        return new Buffer(a, u);
      }, allocBuffer: function(a) {
        if (Buffer.alloc)
          return Buffer.alloc(a);
        var u = new Buffer(a);
        return u.fill(0), u;
      }, isBuffer: function(a) {
        return Buffer.isBuffer(a);
      }, isStream: function(a) {
        return a && typeof a.on == "function" && typeof a.pause == "function" && typeof a.resume == "function";
      } };
    }, {}], 15: [function(t, r, o) {
      function a(ve, K, j) {
        var We, ke = f.getTypeOf(K), $e = f.extend(j || {}, I);
        $e.date = $e.date || /* @__PURE__ */ new Date(), $e.compression !== null && ($e.compression = $e.compression.toUpperCase()), typeof $e.unixPermissions == "string" && ($e.unixPermissions = parseInt($e.unixPermissions, 8)), $e.unixPermissions && 16384 & $e.unixPermissions && ($e.dir = !0), $e.dosPermissions && 16 & $e.dosPermissions && ($e.dir = !0), $e.dir && (ve = G(ve)), $e.createFolders && (We = ie(ve)) && te.call(this, We, !0);
        var Lt = ke === "string" && $e.binary === !1 && $e.base64 === !1;
        j && j.binary !== void 0 || ($e.binary = !Lt), (K instanceof D && K.uncompressedSize === 0 || $e.dir || !K || K.length === 0) && ($e.base64 = !1, $e.binary = !0, K = "", $e.compression = "STORE", ke = "string");
        var Be = null;
        Be = K instanceof D || K instanceof v ? K : X.isNode && X.isStream(K) ? new Y(ve, K) : f.prepareContent(ve, K, $e.binary, $e.optimizedBinaryString, $e.base64);
        var Xe = new Z(ve, Be, $e);
        this.files[ve] = Xe;
      }
      var u = t("./utf8"), f = t("./utils"), v = t("./stream/GenericWorker"), S = t("./stream/StreamHelper"), I = t("./defaults"), D = t("./compressedObject"), Z = t("./zipObject"), M = t("./generate"), X = t("./nodejsUtils"), Y = t("./nodejs/NodejsStreamInputAdapter"), ie = function(ve) {
        ve.slice(-1) === "/" && (ve = ve.substring(0, ve.length - 1));
        var K = ve.lastIndexOf("/");
        return 0 < K ? ve.substring(0, K) : "";
      }, G = function(ve) {
        return ve.slice(-1) !== "/" && (ve += "/"), ve;
      }, te = function(ve, K) {
        return K = K !== void 0 ? K : I.createFolders, ve = G(ve), this.files[ve] || a.call(this, ve, null, { dir: !0, createFolders: K }), this.files[ve];
      };
      function J(ve) {
        return Object.prototype.toString.call(ve) === "[object RegExp]";
      }
      var he = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(ve) {
        var K, j, We;
        for (K in this.files)
          We = this.files[K], (j = K.slice(this.root.length, K.length)) && K.slice(0, this.root.length) === this.root && ve(j, We);
      }, filter: function(ve) {
        var K = [];
        return this.forEach(function(j, We) {
          ve(j, We) && K.push(We);
        }), K;
      }, file: function(ve, K, j) {
        if (arguments.length !== 1)
          return ve = this.root + ve, a.call(this, ve, K, j), this;
        if (J(ve)) {
          var We = ve;
          return this.filter(function($e, Lt) {
            return !Lt.dir && We.test($e);
          });
        }
        var ke = this.files[this.root + ve];
        return ke && !ke.dir ? ke : null;
      }, folder: function(ve) {
        if (!ve)
          return this;
        if (J(ve))
          return this.filter(function(ke, $e) {
            return $e.dir && ve.test(ke);
          });
        var K = this.root + ve, j = te.call(this, K), We = this.clone();
        return We.root = j.name, We;
      }, remove: function(ve) {
        ve = this.root + ve;
        var K = this.files[ve];
        if (K || (ve.slice(-1) !== "/" && (ve += "/"), K = this.files[ve]), K && !K.dir)
          delete this.files[ve];
        else
          for (var j = this.filter(function(ke, $e) {
            return $e.name.slice(0, ve.length) === ve;
          }), We = 0; We < j.length; We++)
            delete this.files[j[We].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(ve) {
        var K, j = {};
        try {
          if ((j = f.extend(ve || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: u.utf8encode })).type = j.type.toLowerCase(), j.compression = j.compression.toUpperCase(), j.type === "binarystring" && (j.type = "string"), !j.type)
            throw new Error("No output type specified.");
          f.checkSupport(j.type), j.platform !== "darwin" && j.platform !== "freebsd" && j.platform !== "linux" && j.platform !== "sunos" || (j.platform = "UNIX"), j.platform === "win32" && (j.platform = "DOS");
          var We = j.comment || this.comment || "";
          K = M.generateWorker(this, j, We);
        } catch (ke) {
          (K = new v("error")).error(ke);
        }
        return new S(K, j.type || "string", j.mimeType);
      }, generateAsync: function(ve, K) {
        return this.generateInternalStream(ve).accumulate(K);
      }, generateNodeStream: function(ve, K) {
        return (ve = ve || {}).type || (ve.type = "nodebuffer"), this.generateInternalStream(ve).toNodejsStream(K);
      } };
      r.exports = he;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(t, r, o) {
      r.exports = t("stream");
    }, { stream: void 0 }], 17: [function(t, r, o) {
      var a = t("./DataReader");
      function u(f) {
        a.call(this, f);
        for (var v = 0; v < this.data.length; v++)
          f[v] = 255 & f[v];
      }
      t("../utils").inherits(u, a), u.prototype.byteAt = function(f) {
        return this.data[this.zero + f];
      }, u.prototype.lastIndexOfSignature = function(f) {
        for (var v = f.charCodeAt(0), S = f.charCodeAt(1), I = f.charCodeAt(2), D = f.charCodeAt(3), Z = this.length - 4; 0 <= Z; --Z)
          if (this.data[Z] === v && this.data[Z + 1] === S && this.data[Z + 2] === I && this.data[Z + 3] === D)
            return Z - this.zero;
        return -1;
      }, u.prototype.readAndCheckSignature = function(f) {
        var v = f.charCodeAt(0), S = f.charCodeAt(1), I = f.charCodeAt(2), D = f.charCodeAt(3), Z = this.readData(4);
        return v === Z[0] && S === Z[1] && I === Z[2] && D === Z[3];
      }, u.prototype.readData = function(f) {
        if (this.checkOffset(f), f === 0)
          return [];
        var v = this.data.slice(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, r.exports = u;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(t, r, o) {
      var a = t("../utils");
      function u(f) {
        this.data = f, this.length = f.length, this.index = 0, this.zero = 0;
      }
      u.prototype = { checkOffset: function(f) {
        this.checkIndex(this.index + f);
      }, checkIndex: function(f) {
        if (this.length < this.zero + f || f < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + f + "). Corrupted zip ?");
      }, setIndex: function(f) {
        this.checkIndex(f), this.index = f;
      }, skip: function(f) {
        this.setIndex(this.index + f);
      }, byteAt: function() {
      }, readInt: function(f) {
        var v, S = 0;
        for (this.checkOffset(f), v = this.index + f - 1; v >= this.index; v--)
          S = (S << 8) + this.byteAt(v);
        return this.index += f, S;
      }, readString: function(f) {
        return a.transformTo("string", this.readData(f));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var f = this.readInt(4);
        return new Date(Date.UTC(1980 + (f >> 25 & 127), (f >> 21 & 15) - 1, f >> 16 & 31, f >> 11 & 31, f >> 5 & 63, (31 & f) << 1));
      } }, r.exports = u;
    }, { "../utils": 32 }], 19: [function(t, r, o) {
      var a = t("./Uint8ArrayReader");
      function u(f) {
        a.call(this, f);
      }
      t("../utils").inherits(u, a), u.prototype.readData = function(f) {
        this.checkOffset(f);
        var v = this.data.slice(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, r.exports = u;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(t, r, o) {
      var a = t("./DataReader");
      function u(f) {
        a.call(this, f);
      }
      t("../utils").inherits(u, a), u.prototype.byteAt = function(f) {
        return this.data.charCodeAt(this.zero + f);
      }, u.prototype.lastIndexOfSignature = function(f) {
        return this.data.lastIndexOf(f) - this.zero;
      }, u.prototype.readAndCheckSignature = function(f) {
        return f === this.readData(4);
      }, u.prototype.readData = function(f) {
        this.checkOffset(f);
        var v = this.data.slice(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, r.exports = u;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(t, r, o) {
      var a = t("./ArrayReader");
      function u(f) {
        a.call(this, f);
      }
      t("../utils").inherits(u, a), u.prototype.readData = function(f) {
        if (this.checkOffset(f), f === 0)
          return new Uint8Array(0);
        var v = this.data.subarray(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, r.exports = u;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(t, r, o) {
      var a = t("../utils"), u = t("../support"), f = t("./ArrayReader"), v = t("./StringReader"), S = t("./NodeBufferReader"), I = t("./Uint8ArrayReader");
      r.exports = function(D) {
        var Z = a.getTypeOf(D);
        return a.checkSupport(Z), Z !== "string" || u.uint8array ? Z === "nodebuffer" ? new S(D) : u.uint8array ? new I(a.transformTo("uint8array", D)) : new f(a.transformTo("array", D)) : new v(D);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(t, r, o) {
      o.LOCAL_FILE_HEADER = "PK", o.CENTRAL_FILE_HEADER = "PK", o.CENTRAL_DIRECTORY_END = "PK", o.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", o.ZIP64_CENTRAL_DIRECTORY_END = "PK", o.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(t, r, o) {
      var a = t("./GenericWorker"), u = t("../utils");
      function f(v) {
        a.call(this, "ConvertWorker to " + v), this.destType = v;
      }
      u.inherits(f, a), f.prototype.processChunk = function(v) {
        this.push({ data: u.transformTo(this.destType, v.data), meta: v.meta });
      }, r.exports = f;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(t, r, o) {
      var a = t("./GenericWorker"), u = t("../crc32");
      function f() {
        a.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      t("../utils").inherits(f, a), f.prototype.processChunk = function(v) {
        this.streamInfo.crc32 = u(v.data, this.streamInfo.crc32 || 0), this.push(v);
      }, r.exports = f;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(t, r, o) {
      var a = t("../utils"), u = t("./GenericWorker");
      function f(v) {
        u.call(this, "DataLengthProbe for " + v), this.propName = v, this.withStreamInfo(v, 0);
      }
      a.inherits(f, u), f.prototype.processChunk = function(v) {
        if (v) {
          var S = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = S + v.data.length;
        }
        u.prototype.processChunk.call(this, v);
      }, r.exports = f;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(t, r, o) {
      var a = t("../utils"), u = t("./GenericWorker");
      function f(v) {
        u.call(this, "DataWorker");
        var S = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, v.then(function(I) {
          S.dataIsReady = !0, S.data = I, S.max = I && I.length || 0, S.type = a.getTypeOf(I), S.isPaused || S._tickAndRepeat();
        }, function(I) {
          S.error(I);
        });
      }
      a.inherits(f, u), f.prototype.cleanUp = function() {
        u.prototype.cleanUp.call(this), this.data = null;
      }, f.prototype.resume = function() {
        return !!u.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, a.delay(this._tickAndRepeat, [], this)), !0);
      }, f.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (a.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, f.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var v = null, S = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            v = this.data.substring(this.index, S);
            break;
          case "uint8array":
            v = this.data.subarray(this.index, S);
            break;
          case "array":
          case "nodebuffer":
            v = this.data.slice(this.index, S);
        }
        return this.index = S, this.push({ data: v, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, r.exports = f;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(t, r, o) {
      function a(u) {
        this.name = u || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      a.prototype = { push: function(u) {
        this.emit("data", u);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (u) {
          this.emit("error", u);
        }
        return !0;
      }, error: function(u) {
        return !this.isFinished && (this.isPaused ? this.generatedError = u : (this.isFinished = !0, this.emit("error", u), this.previous && this.previous.error(u), this.cleanUp()), !0);
      }, on: function(u, f) {
        return this._listeners[u].push(f), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(u, f) {
        if (this._listeners[u])
          for (var v = 0; v < this._listeners[u].length; v++)
            this._listeners[u][v].call(this, f);
      }, pipe: function(u) {
        return u.registerPrevious(this);
      }, registerPrevious: function(u) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = u.streamInfo, this.mergeStreamInfo(), this.previous = u;
        var f = this;
        return u.on("data", function(v) {
          f.processChunk(v);
        }), u.on("end", function() {
          f.end();
        }), u.on("error", function(v) {
          f.error(v);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var u = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), u = !0), this.previous && this.previous.resume(), !u;
      }, flush: function() {
      }, processChunk: function(u) {
        this.push(u);
      }, withStreamInfo: function(u, f) {
        return this.extraStreamInfo[u] = f, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var u in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, u) && (this.streamInfo[u] = this.extraStreamInfo[u]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var u = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + u : u;
      } }, r.exports = a;
    }, {}], 29: [function(t, r, o) {
      var a = t("../utils"), u = t("./ConvertWorker"), f = t("./GenericWorker"), v = t("../base64"), S = t("../support"), I = t("../external"), D = null;
      if (S.nodestream)
        try {
          D = t("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function Z(X, Y) {
        return new I.Promise(function(ie, G) {
          var te = [], J = X._internalType, he = X._outputType, ve = X._mimeType;
          X.on("data", function(K, j) {
            te.push(K), Y && Y(j);
          }).on("error", function(K) {
            te = [], G(K);
          }).on("end", function() {
            try {
              var K = function(j, We, ke) {
                switch (j) {
                  case "blob":
                    return a.newBlob(a.transformTo("arraybuffer", We), ke);
                  case "base64":
                    return v.encode(We);
                  default:
                    return a.transformTo(j, We);
                }
              }(he, function(j, We) {
                var ke, $e = 0, Lt = null, Be = 0;
                for (ke = 0; ke < We.length; ke++)
                  Be += We[ke].length;
                switch (j) {
                  case "string":
                    return We.join("");
                  case "array":
                    return Array.prototype.concat.apply([], We);
                  case "uint8array":
                    for (Lt = new Uint8Array(Be), ke = 0; ke < We.length; ke++)
                      Lt.set(We[ke], $e), $e += We[ke].length;
                    return Lt;
                  case "nodebuffer":
                    return Buffer.concat(We);
                  default:
                    throw new Error("concat : unsupported type '" + j + "'");
                }
              }(J, te), ve);
              ie(K);
            } catch (j) {
              G(j);
            }
            te = [];
          }).resume();
        });
      }
      function M(X, Y, ie) {
        var G = Y;
        switch (Y) {
          case "blob":
          case "arraybuffer":
            G = "uint8array";
            break;
          case "base64":
            G = "string";
        }
        try {
          this._internalType = G, this._outputType = Y, this._mimeType = ie, a.checkSupport(G), this._worker = X.pipe(new u(G)), X.lock();
        } catch (te) {
          this._worker = new f("error"), this._worker.error(te);
        }
      }
      M.prototype = { accumulate: function(X) {
        return Z(this, X);
      }, on: function(X, Y) {
        var ie = this;
        return X === "data" ? this._worker.on(X, function(G) {
          Y.call(ie, G.data, G.meta);
        }) : this._worker.on(X, function() {
          a.delay(Y, arguments, ie);
        }), this;
      }, resume: function() {
        return a.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(X) {
        if (a.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new D(this, { objectMode: this._outputType !== "nodebuffer" }, X);
      } }, r.exports = M;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(t, r, o) {
      if (o.base64 = !0, o.array = !0, o.string = !0, o.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", o.nodebuffer = typeof Buffer < "u", o.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        o.blob = !1;
      else {
        var a = new ArrayBuffer(0);
        try {
          o.blob = new Blob([a], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var u = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            u.append(a), o.blob = u.getBlob("application/zip").size === 0;
          } catch {
            o.blob = !1;
          }
        }
      }
      try {
        o.nodestream = !!t("readable-stream").Readable;
      } catch {
        o.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(t, r, o) {
      for (var a = t("./utils"), u = t("./support"), f = t("./nodejsUtils"), v = t("./stream/GenericWorker"), S = new Array(256), I = 0; I < 256; I++)
        S[I] = 252 <= I ? 6 : 248 <= I ? 5 : 240 <= I ? 4 : 224 <= I ? 3 : 192 <= I ? 2 : 1;
      S[254] = S[254] = 1;
      function D() {
        v.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function Z() {
        v.call(this, "utf-8 encode");
      }
      o.utf8encode = function(M) {
        return u.nodebuffer ? f.newBufferFrom(M, "utf-8") : function(X) {
          var Y, ie, G, te, J, he = X.length, ve = 0;
          for (te = 0; te < he; te++)
            (64512 & (ie = X.charCodeAt(te))) == 55296 && te + 1 < he && (64512 & (G = X.charCodeAt(te + 1))) == 56320 && (ie = 65536 + (ie - 55296 << 10) + (G - 56320), te++), ve += ie < 128 ? 1 : ie < 2048 ? 2 : ie < 65536 ? 3 : 4;
          for (Y = u.uint8array ? new Uint8Array(ve) : new Array(ve), te = J = 0; J < ve; te++)
            (64512 & (ie = X.charCodeAt(te))) == 55296 && te + 1 < he && (64512 & (G = X.charCodeAt(te + 1))) == 56320 && (ie = 65536 + (ie - 55296 << 10) + (G - 56320), te++), ie < 128 ? Y[J++] = ie : (ie < 2048 ? Y[J++] = 192 | ie >>> 6 : (ie < 65536 ? Y[J++] = 224 | ie >>> 12 : (Y[J++] = 240 | ie >>> 18, Y[J++] = 128 | ie >>> 12 & 63), Y[J++] = 128 | ie >>> 6 & 63), Y[J++] = 128 | 63 & ie);
          return Y;
        }(M);
      }, o.utf8decode = function(M) {
        return u.nodebuffer ? a.transformTo("nodebuffer", M).toString("utf-8") : function(X) {
          var Y, ie, G, te, J = X.length, he = new Array(2 * J);
          for (Y = ie = 0; Y < J; )
            if ((G = X[Y++]) < 128)
              he[ie++] = G;
            else if (4 < (te = S[G]))
              he[ie++] = 65533, Y += te - 1;
            else {
              for (G &= te === 2 ? 31 : te === 3 ? 15 : 7; 1 < te && Y < J; )
                G = G << 6 | 63 & X[Y++], te--;
              1 < te ? he[ie++] = 65533 : G < 65536 ? he[ie++] = G : (G -= 65536, he[ie++] = 55296 | G >> 10 & 1023, he[ie++] = 56320 | 1023 & G);
            }
          return he.length !== ie && (he.subarray ? he = he.subarray(0, ie) : he.length = ie), a.applyFromCharCode(he);
        }(M = a.transformTo(u.uint8array ? "uint8array" : "array", M));
      }, a.inherits(D, v), D.prototype.processChunk = function(M) {
        var X = a.transformTo(u.uint8array ? "uint8array" : "array", M.data);
        if (this.leftOver && this.leftOver.length) {
          if (u.uint8array) {
            var Y = X;
            (X = new Uint8Array(Y.length + this.leftOver.length)).set(this.leftOver, 0), X.set(Y, this.leftOver.length);
          } else
            X = this.leftOver.concat(X);
          this.leftOver = null;
        }
        var ie = function(te, J) {
          var he;
          for ((J = J || te.length) > te.length && (J = te.length), he = J - 1; 0 <= he && (192 & te[he]) == 128; )
            he--;
          return he < 0 || he === 0 ? J : he + S[te[he]] > J ? he : J;
        }(X), G = X;
        ie !== X.length && (u.uint8array ? (G = X.subarray(0, ie), this.leftOver = X.subarray(ie, X.length)) : (G = X.slice(0, ie), this.leftOver = X.slice(ie, X.length))), this.push({ data: o.utf8decode(G), meta: M.meta });
      }, D.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: o.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, o.Utf8DecodeWorker = D, a.inherits(Z, v), Z.prototype.processChunk = function(M) {
        this.push({ data: o.utf8encode(M.data), meta: M.meta });
      }, o.Utf8EncodeWorker = Z;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(t, r, o) {
      var a = t("./support"), u = t("./base64"), f = t("./nodejsUtils"), v = t("./external");
      function S(Y) {
        return Y;
      }
      function I(Y, ie) {
        for (var G = 0; G < Y.length; ++G)
          ie[G] = 255 & Y.charCodeAt(G);
        return ie;
      }
      t("setimmediate"), o.newBlob = function(Y, ie) {
        o.checkSupport("blob");
        try {
          return new Blob([Y], { type: ie });
        } catch {
          try {
            var G = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return G.append(Y), G.getBlob(ie);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var D = { stringifyByChunk: function(Y, ie, G) {
        var te = [], J = 0, he = Y.length;
        if (he <= G)
          return String.fromCharCode.apply(null, Y);
        for (; J < he; )
          ie === "array" || ie === "nodebuffer" ? te.push(String.fromCharCode.apply(null, Y.slice(J, Math.min(J + G, he)))) : te.push(String.fromCharCode.apply(null, Y.subarray(J, Math.min(J + G, he)))), J += G;
        return te.join("");
      }, stringifyByChar: function(Y) {
        for (var ie = "", G = 0; G < Y.length; G++)
          ie += String.fromCharCode(Y[G]);
        return ie;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return a.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return a.nodebuffer && String.fromCharCode.apply(null, f.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function Z(Y) {
        var ie = 65536, G = o.getTypeOf(Y), te = !0;
        if (G === "uint8array" ? te = D.applyCanBeUsed.uint8array : G === "nodebuffer" && (te = D.applyCanBeUsed.nodebuffer), te)
          for (; 1 < ie; )
            try {
              return D.stringifyByChunk(Y, G, ie);
            } catch {
              ie = Math.floor(ie / 2);
            }
        return D.stringifyByChar(Y);
      }
      function M(Y, ie) {
        for (var G = 0; G < Y.length; G++)
          ie[G] = Y[G];
        return ie;
      }
      o.applyFromCharCode = Z;
      var X = {};
      X.string = { string: S, array: function(Y) {
        return I(Y, new Array(Y.length));
      }, arraybuffer: function(Y) {
        return X.string.uint8array(Y).buffer;
      }, uint8array: function(Y) {
        return I(Y, new Uint8Array(Y.length));
      }, nodebuffer: function(Y) {
        return I(Y, f.allocBuffer(Y.length));
      } }, X.array = { string: Z, array: S, arraybuffer: function(Y) {
        return new Uint8Array(Y).buffer;
      }, uint8array: function(Y) {
        return new Uint8Array(Y);
      }, nodebuffer: function(Y) {
        return f.newBufferFrom(Y);
      } }, X.arraybuffer = { string: function(Y) {
        return Z(new Uint8Array(Y));
      }, array: function(Y) {
        return M(new Uint8Array(Y), new Array(Y.byteLength));
      }, arraybuffer: S, uint8array: function(Y) {
        return new Uint8Array(Y);
      }, nodebuffer: function(Y) {
        return f.newBufferFrom(new Uint8Array(Y));
      } }, X.uint8array = { string: Z, array: function(Y) {
        return M(Y, new Array(Y.length));
      }, arraybuffer: function(Y) {
        return Y.buffer;
      }, uint8array: S, nodebuffer: function(Y) {
        return f.newBufferFrom(Y);
      } }, X.nodebuffer = { string: Z, array: function(Y) {
        return M(Y, new Array(Y.length));
      }, arraybuffer: function(Y) {
        return X.nodebuffer.uint8array(Y).buffer;
      }, uint8array: function(Y) {
        return M(Y, new Uint8Array(Y.length));
      }, nodebuffer: S }, o.transformTo = function(Y, ie) {
        if (ie = ie || "", !Y)
          return ie;
        o.checkSupport(Y);
        var G = o.getTypeOf(ie);
        return X[G][Y](ie);
      }, o.resolve = function(Y) {
        for (var ie = Y.split("/"), G = [], te = 0; te < ie.length; te++) {
          var J = ie[te];
          J === "." || J === "" && te !== 0 && te !== ie.length - 1 || (J === ".." ? G.pop() : G.push(J));
        }
        return G.join("/");
      }, o.getTypeOf = function(Y) {
        return typeof Y == "string" ? "string" : Object.prototype.toString.call(Y) === "[object Array]" ? "array" : a.nodebuffer && f.isBuffer(Y) ? "nodebuffer" : a.uint8array && Y instanceof Uint8Array ? "uint8array" : a.arraybuffer && Y instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, o.checkSupport = function(Y) {
        if (!a[Y.toLowerCase()])
          throw new Error(Y + " is not supported by this platform");
      }, o.MAX_VALUE_16BITS = 65535, o.MAX_VALUE_32BITS = -1, o.pretty = function(Y) {
        var ie, G, te = "";
        for (G = 0; G < (Y || "").length; G++)
          te += "\\x" + ((ie = Y.charCodeAt(G)) < 16 ? "0" : "") + ie.toString(16).toUpperCase();
        return te;
      }, o.delay = function(Y, ie, G) {
        setImmediate(function() {
          Y.apply(G || null, ie || []);
        });
      }, o.inherits = function(Y, ie) {
        function G() {
        }
        G.prototype = ie.prototype, Y.prototype = new G();
      }, o.extend = function() {
        var Y, ie, G = {};
        for (Y = 0; Y < arguments.length; Y++)
          for (ie in arguments[Y])
            Object.prototype.hasOwnProperty.call(arguments[Y], ie) && G[ie] === void 0 && (G[ie] = arguments[Y][ie]);
        return G;
      }, o.prepareContent = function(Y, ie, G, te, J) {
        return v.Promise.resolve(ie).then(function(he) {
          return a.blob && (he instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(he)) !== -1) && typeof FileReader < "u" ? new v.Promise(function(ve, K) {
            var j = new FileReader();
            j.onload = function(We) {
              ve(We.target.result);
            }, j.onerror = function(We) {
              K(We.target.error);
            }, j.readAsArrayBuffer(he);
          }) : he;
        }).then(function(he) {
          var ve = o.getTypeOf(he);
          return ve ? (ve === "arraybuffer" ? he = o.transformTo("uint8array", he) : ve === "string" && (J ? he = u.decode(he) : G && te !== !0 && (he = function(K) {
            return I(K, a.uint8array ? new Uint8Array(K.length) : new Array(K.length));
          }(he))), he) : v.Promise.reject(new Error("Can't read the data of '" + Y + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(t, r, o) {
      var a = t("./reader/readerFor"), u = t("./utils"), f = t("./signature"), v = t("./zipEntry"), S = t("./support");
      function I(D) {
        this.files = [], this.loadOptions = D;
      }
      I.prototype = { checkSignature: function(D) {
        if (!this.reader.readAndCheckSignature(D)) {
          this.reader.index -= 4;
          var Z = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + u.pretty(Z) + ", expected " + u.pretty(D) + ")");
        }
      }, isSignature: function(D, Z) {
        var M = this.reader.index;
        this.reader.setIndex(D);
        var X = this.reader.readString(4) === Z;
        return this.reader.setIndex(M), X;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var D = this.reader.readData(this.zipCommentLength), Z = S.uint8array ? "uint8array" : "array", M = u.transformTo(Z, D);
        this.zipComment = this.loadOptions.decodeFileName(M);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var D, Z, M, X = this.zip64EndOfCentralSize - 44; 0 < X; )
          D = this.reader.readInt(2), Z = this.reader.readInt(4), M = this.reader.readData(Z), this.zip64ExtensibleData[D] = { id: D, length: Z, value: M };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var D, Z;
        for (D = 0; D < this.files.length; D++)
          Z = this.files[D], this.reader.setIndex(Z.localHeaderOffset), this.checkSignature(f.LOCAL_FILE_HEADER), Z.readLocalPart(this.reader), Z.handleUTF8(), Z.processAttributes();
      }, readCentralDir: function() {
        var D;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(f.CENTRAL_FILE_HEADER); )
          (D = new v({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(D);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var D = this.reader.lastIndexOfSignature(f.CENTRAL_DIRECTORY_END);
        if (D < 0)
          throw this.isSignature(0, f.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(D);
        var Z = D;
        if (this.checkSignature(f.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === u.MAX_VALUE_16BITS || this.diskWithCentralDirStart === u.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === u.MAX_VALUE_16BITS || this.centralDirRecords === u.MAX_VALUE_16BITS || this.centralDirSize === u.MAX_VALUE_32BITS || this.centralDirOffset === u.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (D = this.reader.lastIndexOfSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(D), this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, f.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(f.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var M = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (M += 20, M += 12 + this.zip64EndOfCentralSize);
        var X = Z - M;
        if (0 < X)
          this.isSignature(Z, f.CENTRAL_FILE_HEADER) || (this.reader.zero = X);
        else if (X < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(X) + " bytes.");
      }, prepareReader: function(D) {
        this.reader = a(D);
      }, load: function(D) {
        this.prepareReader(D), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, r.exports = I;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(t, r, o) {
      var a = t("./reader/readerFor"), u = t("./utils"), f = t("./compressedObject"), v = t("./crc32"), S = t("./utf8"), I = t("./compressions"), D = t("./support");
      function Z(M, X) {
        this.options = M, this.loadOptions = X;
      }
      Z.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(M) {
        var X, Y;
        if (M.skip(22), this.fileNameLength = M.readInt(2), Y = M.readInt(2), this.fileName = M.readData(this.fileNameLength), M.skip(Y), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((X = function(ie) {
          for (var G in I)
            if (Object.prototype.hasOwnProperty.call(I, G) && I[G].magic === ie)
              return I[G];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + u.pretty(this.compressionMethod) + " unknown (inner file : " + u.transformTo("string", this.fileName) + ")");
        this.decompressed = new f(this.compressedSize, this.uncompressedSize, this.crc32, X, M.readData(this.compressedSize));
      }, readCentralPart: function(M) {
        this.versionMadeBy = M.readInt(2), M.skip(2), this.bitFlag = M.readInt(2), this.compressionMethod = M.readString(2), this.date = M.readDate(), this.crc32 = M.readInt(4), this.compressedSize = M.readInt(4), this.uncompressedSize = M.readInt(4);
        var X = M.readInt(2);
        if (this.extraFieldsLength = M.readInt(2), this.fileCommentLength = M.readInt(2), this.diskNumberStart = M.readInt(2), this.internalFileAttributes = M.readInt(2), this.externalFileAttributes = M.readInt(4), this.localHeaderOffset = M.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        M.skip(X), this.readExtraFields(M), this.parseZIP64ExtraField(M), this.fileComment = M.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var M = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), M == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), M == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var M = a(this.extraFields[1].value);
          this.uncompressedSize === u.MAX_VALUE_32BITS && (this.uncompressedSize = M.readInt(8)), this.compressedSize === u.MAX_VALUE_32BITS && (this.compressedSize = M.readInt(8)), this.localHeaderOffset === u.MAX_VALUE_32BITS && (this.localHeaderOffset = M.readInt(8)), this.diskNumberStart === u.MAX_VALUE_32BITS && (this.diskNumberStart = M.readInt(4));
        }
      }, readExtraFields: function(M) {
        var X, Y, ie, G = M.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); M.index + 4 < G; )
          X = M.readInt(2), Y = M.readInt(2), ie = M.readData(Y), this.extraFields[X] = { id: X, length: Y, value: ie };
        M.setIndex(G);
      }, handleUTF8: function() {
        var M = D.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = S.utf8decode(this.fileName), this.fileCommentStr = S.utf8decode(this.fileComment);
        else {
          var X = this.findExtraFieldUnicodePath();
          if (X !== null)
            this.fileNameStr = X;
          else {
            var Y = u.transformTo(M, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(Y);
          }
          var ie = this.findExtraFieldUnicodeComment();
          if (ie !== null)
            this.fileCommentStr = ie;
          else {
            var G = u.transformTo(M, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(G);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var M = this.extraFields[28789];
        if (M) {
          var X = a(M.value);
          return X.readInt(1) !== 1 || v(this.fileName) !== X.readInt(4) ? null : S.utf8decode(X.readData(M.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var M = this.extraFields[25461];
        if (M) {
          var X = a(M.value);
          return X.readInt(1) !== 1 || v(this.fileComment) !== X.readInt(4) ? null : S.utf8decode(X.readData(M.length - 5));
        }
        return null;
      } }, r.exports = Z;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(t, r, o) {
      function a(X, Y, ie) {
        this.name = X, this.dir = ie.dir, this.date = ie.date, this.comment = ie.comment, this.unixPermissions = ie.unixPermissions, this.dosPermissions = ie.dosPermissions, this._data = Y, this._dataBinary = ie.binary, this.options = { compression: ie.compression, compressionOptions: ie.compressionOptions };
      }
      var u = t("./stream/StreamHelper"), f = t("./stream/DataWorker"), v = t("./utf8"), S = t("./compressedObject"), I = t("./stream/GenericWorker");
      a.prototype = { internalStream: function(X) {
        var Y = null, ie = "string";
        try {
          if (!X)
            throw new Error("No output type specified.");
          var G = (ie = X.toLowerCase()) === "string" || ie === "text";
          ie !== "binarystring" && ie !== "text" || (ie = "string"), Y = this._decompressWorker();
          var te = !this._dataBinary;
          te && !G && (Y = Y.pipe(new v.Utf8EncodeWorker())), !te && G && (Y = Y.pipe(new v.Utf8DecodeWorker()));
        } catch (J) {
          (Y = new I("error")).error(J);
        }
        return new u(Y, ie, "");
      }, async: function(X, Y) {
        return this.internalStream(X).accumulate(Y);
      }, nodeStream: function(X, Y) {
        return this.internalStream(X || "nodebuffer").toNodejsStream(Y);
      }, _compressWorker: function(X, Y) {
        if (this._data instanceof S && this._data.compression.magic === X.magic)
          return this._data.getCompressedWorker();
        var ie = this._decompressWorker();
        return this._dataBinary || (ie = ie.pipe(new v.Utf8EncodeWorker())), S.createWorkerFrom(ie, X, Y);
      }, _decompressWorker: function() {
        return this._data instanceof S ? this._data.getContentWorker() : this._data instanceof I ? this._data : new f(this._data);
      } };
      for (var D = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], Z = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, M = 0; M < D.length; M++)
        a.prototype[D[M]] = Z;
      r.exports = a;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(t, r, o) {
      (function(a) {
        var u, f, v = a.MutationObserver || a.WebKitMutationObserver;
        if (v) {
          var S = 0, I = new v(X), D = a.document.createTextNode("");
          I.observe(D, { characterData: !0 }), u = function() {
            D.data = S = ++S % 2;
          };
        } else if (a.setImmediate || a.MessageChannel === void 0)
          u = "document" in a && "onreadystatechange" in a.document.createElement("script") ? function() {
            var Y = a.document.createElement("script");
            Y.onreadystatechange = function() {
              X(), Y.onreadystatechange = null, Y.parentNode.removeChild(Y), Y = null;
            }, a.document.documentElement.appendChild(Y);
          } : function() {
            setTimeout(X, 0);
          };
        else {
          var Z = new a.MessageChannel();
          Z.port1.onmessage = X, u = function() {
            Z.port2.postMessage(0);
          };
        }
        var M = [];
        function X() {
          var Y, ie;
          f = !0;
          for (var G = M.length; G; ) {
            for (ie = M, M = [], Y = -1; ++Y < G; )
              ie[Y]();
            G = M.length;
          }
          f = !1;
        }
        r.exports = function(Y) {
          M.push(Y) !== 1 || f || u();
        };
      }).call(this, typeof Kr < "u" ? Kr : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(t, r, o) {
      var a = t("immediate");
      function u() {
      }
      var f = {}, v = ["REJECTED"], S = ["FULFILLED"], I = ["PENDING"];
      function D(G) {
        if (typeof G != "function")
          throw new TypeError("resolver must be a function");
        this.state = I, this.queue = [], this.outcome = void 0, G !== u && Y(this, G);
      }
      function Z(G, te, J) {
        this.promise = G, typeof te == "function" && (this.onFulfilled = te, this.callFulfilled = this.otherCallFulfilled), typeof J == "function" && (this.onRejected = J, this.callRejected = this.otherCallRejected);
      }
      function M(G, te, J) {
        a(function() {
          var he;
          try {
            he = te(J);
          } catch (ve) {
            return f.reject(G, ve);
          }
          he === G ? f.reject(G, new TypeError("Cannot resolve promise with itself")) : f.resolve(G, he);
        });
      }
      function X(G) {
        var te = G && G.then;
        if (G && (typeof G == "object" || typeof G == "function") && typeof te == "function")
          return function() {
            te.apply(G, arguments);
          };
      }
      function Y(G, te) {
        var J = !1;
        function he(j) {
          J || (J = !0, f.reject(G, j));
        }
        function ve(j) {
          J || (J = !0, f.resolve(G, j));
        }
        var K = ie(function() {
          te(ve, he);
        });
        K.status === "error" && he(K.value);
      }
      function ie(G, te) {
        var J = {};
        try {
          J.value = G(te), J.status = "success";
        } catch (he) {
          J.status = "error", J.value = he;
        }
        return J;
      }
      (r.exports = D).prototype.finally = function(G) {
        if (typeof G != "function")
          return this;
        var te = this.constructor;
        return this.then(function(J) {
          return te.resolve(G()).then(function() {
            return J;
          });
        }, function(J) {
          return te.resolve(G()).then(function() {
            throw J;
          });
        });
      }, D.prototype.catch = function(G) {
        return this.then(null, G);
      }, D.prototype.then = function(G, te) {
        if (typeof G != "function" && this.state === S || typeof te != "function" && this.state === v)
          return this;
        var J = new this.constructor(u);
        return this.state !== I ? M(J, this.state === S ? G : te, this.outcome) : this.queue.push(new Z(J, G, te)), J;
      }, Z.prototype.callFulfilled = function(G) {
        f.resolve(this.promise, G);
      }, Z.prototype.otherCallFulfilled = function(G) {
        M(this.promise, this.onFulfilled, G);
      }, Z.prototype.callRejected = function(G) {
        f.reject(this.promise, G);
      }, Z.prototype.otherCallRejected = function(G) {
        M(this.promise, this.onRejected, G);
      }, f.resolve = function(G, te) {
        var J = ie(X, te);
        if (J.status === "error")
          return f.reject(G, J.value);
        var he = J.value;
        if (he)
          Y(G, he);
        else {
          G.state = S, G.outcome = te;
          for (var ve = -1, K = G.queue.length; ++ve < K; )
            G.queue[ve].callFulfilled(te);
        }
        return G;
      }, f.reject = function(G, te) {
        G.state = v, G.outcome = te;
        for (var J = -1, he = G.queue.length; ++J < he; )
          G.queue[J].callRejected(te);
        return G;
      }, D.resolve = function(G) {
        return G instanceof this ? G : f.resolve(new this(u), G);
      }, D.reject = function(G) {
        var te = new this(u);
        return f.reject(te, G);
      }, D.all = function(G) {
        var te = this;
        if (Object.prototype.toString.call(G) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var J = G.length, he = !1;
        if (!J)
          return this.resolve([]);
        for (var ve = new Array(J), K = 0, j = -1, We = new this(u); ++j < J; )
          ke(G[j], j);
        return We;
        function ke($e, Lt) {
          te.resolve($e).then(function(Be) {
            ve[Lt] = Be, ++K !== J || he || (he = !0, f.resolve(We, ve));
          }, function(Be) {
            he || (he = !0, f.reject(We, Be));
          });
        }
      }, D.race = function(G) {
        var te = this;
        if (Object.prototype.toString.call(G) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var J = G.length, he = !1;
        if (!J)
          return this.resolve([]);
        for (var ve = -1, K = new this(u); ++ve < J; )
          j = G[ve], te.resolve(j).then(function(We) {
            he || (he = !0, f.resolve(K, We));
          }, function(We) {
            he || (he = !0, f.reject(K, We));
          });
        var j;
        return K;
      };
    }, { immediate: 36 }], 38: [function(t, r, o) {
      var a = {};
      (0, t("./lib/utils/common").assign)(a, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), r.exports = a;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(t, r, o) {
      var a = t("./zlib/deflate"), u = t("./utils/common"), f = t("./utils/strings"), v = t("./zlib/messages"), S = t("./zlib/zstream"), I = Object.prototype.toString, D = 0, Z = -1, M = 0, X = 8;
      function Y(G) {
        if (!(this instanceof Y))
          return new Y(G);
        this.options = u.assign({ level: Z, method: X, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: M, to: "" }, G || {});
        var te = this.options;
        te.raw && 0 < te.windowBits ? te.windowBits = -te.windowBits : te.gzip && 0 < te.windowBits && te.windowBits < 16 && (te.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new S(), this.strm.avail_out = 0;
        var J = a.deflateInit2(this.strm, te.level, te.method, te.windowBits, te.memLevel, te.strategy);
        if (J !== D)
          throw new Error(v[J]);
        if (te.header && a.deflateSetHeader(this.strm, te.header), te.dictionary) {
          var he;
          if (he = typeof te.dictionary == "string" ? f.string2buf(te.dictionary) : I.call(te.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(te.dictionary) : te.dictionary, (J = a.deflateSetDictionary(this.strm, he)) !== D)
            throw new Error(v[J]);
          this._dict_set = !0;
        }
      }
      function ie(G, te) {
        var J = new Y(te);
        if (J.push(G, !0), J.err)
          throw J.msg || v[J.err];
        return J.result;
      }
      Y.prototype.push = function(G, te) {
        var J, he, ve = this.strm, K = this.options.chunkSize;
        if (this.ended)
          return !1;
        he = te === ~~te ? te : te === !0 ? 4 : 0, typeof G == "string" ? ve.input = f.string2buf(G) : I.call(G) === "[object ArrayBuffer]" ? ve.input = new Uint8Array(G) : ve.input = G, ve.next_in = 0, ve.avail_in = ve.input.length;
        do {
          if (ve.avail_out === 0 && (ve.output = new u.Buf8(K), ve.next_out = 0, ve.avail_out = K), (J = a.deflate(ve, he)) !== 1 && J !== D)
            return this.onEnd(J), !(this.ended = !0);
          ve.avail_out !== 0 && (ve.avail_in !== 0 || he !== 4 && he !== 2) || (this.options.to === "string" ? this.onData(f.buf2binstring(u.shrinkBuf(ve.output, ve.next_out))) : this.onData(u.shrinkBuf(ve.output, ve.next_out)));
        } while ((0 < ve.avail_in || ve.avail_out === 0) && J !== 1);
        return he === 4 ? (J = a.deflateEnd(this.strm), this.onEnd(J), this.ended = !0, J === D) : he !== 2 || (this.onEnd(D), !(ve.avail_out = 0));
      }, Y.prototype.onData = function(G) {
        this.chunks.push(G);
      }, Y.prototype.onEnd = function(G) {
        G === D && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = u.flattenChunks(this.chunks)), this.chunks = [], this.err = G, this.msg = this.strm.msg;
      }, o.Deflate = Y, o.deflate = ie, o.deflateRaw = function(G, te) {
        return (te = te || {}).raw = !0, ie(G, te);
      }, o.gzip = function(G, te) {
        return (te = te || {}).gzip = !0, ie(G, te);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(t, r, o) {
      var a = t("./zlib/inflate"), u = t("./utils/common"), f = t("./utils/strings"), v = t("./zlib/constants"), S = t("./zlib/messages"), I = t("./zlib/zstream"), D = t("./zlib/gzheader"), Z = Object.prototype.toString;
      function M(Y) {
        if (!(this instanceof M))
          return new M(Y);
        this.options = u.assign({ chunkSize: 16384, windowBits: 0, to: "" }, Y || {});
        var ie = this.options;
        ie.raw && 0 <= ie.windowBits && ie.windowBits < 16 && (ie.windowBits = -ie.windowBits, ie.windowBits === 0 && (ie.windowBits = -15)), !(0 <= ie.windowBits && ie.windowBits < 16) || Y && Y.windowBits || (ie.windowBits += 32), 15 < ie.windowBits && ie.windowBits < 48 && !(15 & ie.windowBits) && (ie.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new I(), this.strm.avail_out = 0;
        var G = a.inflateInit2(this.strm, ie.windowBits);
        if (G !== v.Z_OK)
          throw new Error(S[G]);
        this.header = new D(), a.inflateGetHeader(this.strm, this.header);
      }
      function X(Y, ie) {
        var G = new M(ie);
        if (G.push(Y, !0), G.err)
          throw G.msg || S[G.err];
        return G.result;
      }
      M.prototype.push = function(Y, ie) {
        var G, te, J, he, ve, K, j = this.strm, We = this.options.chunkSize, ke = this.options.dictionary, $e = !1;
        if (this.ended)
          return !1;
        te = ie === ~~ie ? ie : ie === !0 ? v.Z_FINISH : v.Z_NO_FLUSH, typeof Y == "string" ? j.input = f.binstring2buf(Y) : Z.call(Y) === "[object ArrayBuffer]" ? j.input = new Uint8Array(Y) : j.input = Y, j.next_in = 0, j.avail_in = j.input.length;
        do {
          if (j.avail_out === 0 && (j.output = new u.Buf8(We), j.next_out = 0, j.avail_out = We), (G = a.inflate(j, v.Z_NO_FLUSH)) === v.Z_NEED_DICT && ke && (K = typeof ke == "string" ? f.string2buf(ke) : Z.call(ke) === "[object ArrayBuffer]" ? new Uint8Array(ke) : ke, G = a.inflateSetDictionary(this.strm, K)), G === v.Z_BUF_ERROR && $e === !0 && (G = v.Z_OK, $e = !1), G !== v.Z_STREAM_END && G !== v.Z_OK)
            return this.onEnd(G), !(this.ended = !0);
          j.next_out && (j.avail_out !== 0 && G !== v.Z_STREAM_END && (j.avail_in !== 0 || te !== v.Z_FINISH && te !== v.Z_SYNC_FLUSH) || (this.options.to === "string" ? (J = f.utf8border(j.output, j.next_out), he = j.next_out - J, ve = f.buf2string(j.output, J), j.next_out = he, j.avail_out = We - he, he && u.arraySet(j.output, j.output, J, he, 0), this.onData(ve)) : this.onData(u.shrinkBuf(j.output, j.next_out)))), j.avail_in === 0 && j.avail_out === 0 && ($e = !0);
        } while ((0 < j.avail_in || j.avail_out === 0) && G !== v.Z_STREAM_END);
        return G === v.Z_STREAM_END && (te = v.Z_FINISH), te === v.Z_FINISH ? (G = a.inflateEnd(this.strm), this.onEnd(G), this.ended = !0, G === v.Z_OK) : te !== v.Z_SYNC_FLUSH || (this.onEnd(v.Z_OK), !(j.avail_out = 0));
      }, M.prototype.onData = function(Y) {
        this.chunks.push(Y);
      }, M.prototype.onEnd = function(Y) {
        Y === v.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = u.flattenChunks(this.chunks)), this.chunks = [], this.err = Y, this.msg = this.strm.msg;
      }, o.Inflate = M, o.inflate = X, o.inflateRaw = function(Y, ie) {
        return (ie = ie || {}).raw = !0, X(Y, ie);
      }, o.ungzip = X;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(t, r, o) {
      var a = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      o.assign = function(v) {
        for (var S = Array.prototype.slice.call(arguments, 1); S.length; ) {
          var I = S.shift();
          if (I) {
            if (typeof I != "object")
              throw new TypeError(I + "must be non-object");
            for (var D in I)
              I.hasOwnProperty(D) && (v[D] = I[D]);
          }
        }
        return v;
      }, o.shrinkBuf = function(v, S) {
        return v.length === S ? v : v.subarray ? v.subarray(0, S) : (v.length = S, v);
      };
      var u = { arraySet: function(v, S, I, D, Z) {
        if (S.subarray && v.subarray)
          v.set(S.subarray(I, I + D), Z);
        else
          for (var M = 0; M < D; M++)
            v[Z + M] = S[I + M];
      }, flattenChunks: function(v) {
        var S, I, D, Z, M, X;
        for (S = D = 0, I = v.length; S < I; S++)
          D += v[S].length;
        for (X = new Uint8Array(D), S = Z = 0, I = v.length; S < I; S++)
          M = v[S], X.set(M, Z), Z += M.length;
        return X;
      } }, f = { arraySet: function(v, S, I, D, Z) {
        for (var M = 0; M < D; M++)
          v[Z + M] = S[I + M];
      }, flattenChunks: function(v) {
        return [].concat.apply([], v);
      } };
      o.setTyped = function(v) {
        v ? (o.Buf8 = Uint8Array, o.Buf16 = Uint16Array, o.Buf32 = Int32Array, o.assign(o, u)) : (o.Buf8 = Array, o.Buf16 = Array, o.Buf32 = Array, o.assign(o, f));
      }, o.setTyped(a);
    }, {}], 42: [function(t, r, o) {
      var a = t("./common"), u = !0, f = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        u = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        f = !1;
      }
      for (var v = new a.Buf8(256), S = 0; S < 256; S++)
        v[S] = 252 <= S ? 6 : 248 <= S ? 5 : 240 <= S ? 4 : 224 <= S ? 3 : 192 <= S ? 2 : 1;
      function I(D, Z) {
        if (Z < 65537 && (D.subarray && f || !D.subarray && u))
          return String.fromCharCode.apply(null, a.shrinkBuf(D, Z));
        for (var M = "", X = 0; X < Z; X++)
          M += String.fromCharCode(D[X]);
        return M;
      }
      v[254] = v[254] = 1, o.string2buf = function(D) {
        var Z, M, X, Y, ie, G = D.length, te = 0;
        for (Y = 0; Y < G; Y++)
          (64512 & (M = D.charCodeAt(Y))) == 55296 && Y + 1 < G && (64512 & (X = D.charCodeAt(Y + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (X - 56320), Y++), te += M < 128 ? 1 : M < 2048 ? 2 : M < 65536 ? 3 : 4;
        for (Z = new a.Buf8(te), Y = ie = 0; ie < te; Y++)
          (64512 & (M = D.charCodeAt(Y))) == 55296 && Y + 1 < G && (64512 & (X = D.charCodeAt(Y + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (X - 56320), Y++), M < 128 ? Z[ie++] = M : (M < 2048 ? Z[ie++] = 192 | M >>> 6 : (M < 65536 ? Z[ie++] = 224 | M >>> 12 : (Z[ie++] = 240 | M >>> 18, Z[ie++] = 128 | M >>> 12 & 63), Z[ie++] = 128 | M >>> 6 & 63), Z[ie++] = 128 | 63 & M);
        return Z;
      }, o.buf2binstring = function(D) {
        return I(D, D.length);
      }, o.binstring2buf = function(D) {
        for (var Z = new a.Buf8(D.length), M = 0, X = Z.length; M < X; M++)
          Z[M] = D.charCodeAt(M);
        return Z;
      }, o.buf2string = function(D, Z) {
        var M, X, Y, ie, G = Z || D.length, te = new Array(2 * G);
        for (M = X = 0; M < G; )
          if ((Y = D[M++]) < 128)
            te[X++] = Y;
          else if (4 < (ie = v[Y]))
            te[X++] = 65533, M += ie - 1;
          else {
            for (Y &= ie === 2 ? 31 : ie === 3 ? 15 : 7; 1 < ie && M < G; )
              Y = Y << 6 | 63 & D[M++], ie--;
            1 < ie ? te[X++] = 65533 : Y < 65536 ? te[X++] = Y : (Y -= 65536, te[X++] = 55296 | Y >> 10 & 1023, te[X++] = 56320 | 1023 & Y);
          }
        return I(te, X);
      }, o.utf8border = function(D, Z) {
        var M;
        for ((Z = Z || D.length) > D.length && (Z = D.length), M = Z - 1; 0 <= M && (192 & D[M]) == 128; )
          M--;
        return M < 0 || M === 0 ? Z : M + v[D[M]] > Z ? M : Z;
      };
    }, { "./common": 41 }], 43: [function(t, r, o) {
      r.exports = function(a, u, f, v) {
        for (var S = 65535 & a | 0, I = a >>> 16 & 65535 | 0, D = 0; f !== 0; ) {
          for (f -= D = 2e3 < f ? 2e3 : f; I = I + (S = S + u[v++] | 0) | 0, --D; )
            ;
          S %= 65521, I %= 65521;
        }
        return S | I << 16 | 0;
      };
    }, {}], 44: [function(t, r, o) {
      r.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(t, r, o) {
      var a = function() {
        for (var u, f = [], v = 0; v < 256; v++) {
          u = v;
          for (var S = 0; S < 8; S++)
            u = 1 & u ? 3988292384 ^ u >>> 1 : u >>> 1;
          f[v] = u;
        }
        return f;
      }();
      r.exports = function(u, f, v, S) {
        var I = a, D = S + v;
        u ^= -1;
        for (var Z = S; Z < D; Z++)
          u = u >>> 8 ^ I[255 & (u ^ f[Z])];
        return -1 ^ u;
      };
    }, {}], 46: [function(t, r, o) {
      var a, u = t("../utils/common"), f = t("./trees"), v = t("./adler32"), S = t("./crc32"), I = t("./messages"), D = 0, Z = 4, M = 0, X = -2, Y = -1, ie = 4, G = 2, te = 8, J = 9, he = 286, ve = 30, K = 19, j = 2 * he + 1, We = 15, ke = 3, $e = 258, Lt = $e + ke + 1, Be = 42, Xe = 113, ue = 1, yt = 2, Ue = 3, ot = 4;
      function Gt(pe, Tt) {
        return pe.msg = I[Tt], Tt;
      }
      function it(pe) {
        return (pe << 1) - (4 < pe ? 9 : 0);
      }
      function Zt(pe) {
        for (var Tt = pe.length; 0 <= --Tt; )
          pe[Tt] = 0;
      }
      function ct(pe) {
        var Tt = pe.state, xt = Tt.pending;
        xt > pe.avail_out && (xt = pe.avail_out), xt !== 0 && (u.arraySet(pe.output, Tt.pending_buf, Tt.pending_out, xt, pe.next_out), pe.next_out += xt, Tt.pending_out += xt, pe.total_out += xt, pe.avail_out -= xt, Tt.pending -= xt, Tt.pending === 0 && (Tt.pending_out = 0));
      }
      function lt(pe, Tt) {
        f._tr_flush_block(pe, 0 <= pe.block_start ? pe.block_start : -1, pe.strstart - pe.block_start, Tt), pe.block_start = pe.strstart, ct(pe.strm);
      }
      function $t(pe, Tt) {
        pe.pending_buf[pe.pending++] = Tt;
      }
      function Kt(pe, Tt) {
        pe.pending_buf[pe.pending++] = Tt >>> 8 & 255, pe.pending_buf[pe.pending++] = 255 & Tt;
      }
      function At(pe, Tt) {
        var xt, Re, Ie = pe.max_chain_length, Qe = pe.strstart, Bt = pe.prev_length, dt = pe.nice_match, et = pe.strstart > pe.w_size - Lt ? pe.strstart - (pe.w_size - Lt) : 0, wt = pe.window, Xt = pe.w_mask, He = pe.prev, i = pe.strstart + $e, n = wt[Qe + Bt - 1], s = wt[Qe + Bt];
        pe.prev_length >= pe.good_match && (Ie >>= 2), dt > pe.lookahead && (dt = pe.lookahead);
        do
          if (wt[(xt = Tt) + Bt] === s && wt[xt + Bt - 1] === n && wt[xt] === wt[Qe] && wt[++xt] === wt[Qe + 1]) {
            Qe += 2, xt++;
            do
              ;
            while (wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && wt[++Qe] === wt[++xt] && Qe < i);
            if (Re = $e - (i - Qe), Qe = i - $e, Bt < Re) {
              if (pe.match_start = Tt, dt <= (Bt = Re))
                break;
              n = wt[Qe + Bt - 1], s = wt[Qe + Bt];
            }
          }
        while ((Tt = He[Tt & Xt]) > et && --Ie != 0);
        return Bt <= pe.lookahead ? Bt : pe.lookahead;
      }
      function Ni(pe) {
        var Tt, xt, Re, Ie, Qe, Bt, dt, et, wt, Xt, He = pe.w_size;
        do {
          if (Ie = pe.window_size - pe.lookahead - pe.strstart, pe.strstart >= He + (He - Lt)) {
            for (u.arraySet(pe.window, pe.window, He, He, 0), pe.match_start -= He, pe.strstart -= He, pe.block_start -= He, Tt = xt = pe.hash_size; Re = pe.head[--Tt], pe.head[Tt] = He <= Re ? Re - He : 0, --xt; )
              ;
            for (Tt = xt = He; Re = pe.prev[--Tt], pe.prev[Tt] = He <= Re ? Re - He : 0, --xt; )
              ;
            Ie += He;
          }
          if (pe.strm.avail_in === 0)
            break;
          if (Bt = pe.strm, dt = pe.window, et = pe.strstart + pe.lookahead, wt = Ie, Xt = void 0, Xt = Bt.avail_in, wt < Xt && (Xt = wt), xt = Xt === 0 ? 0 : (Bt.avail_in -= Xt, u.arraySet(dt, Bt.input, Bt.next_in, Xt, et), Bt.state.wrap === 1 ? Bt.adler = v(Bt.adler, dt, Xt, et) : Bt.state.wrap === 2 && (Bt.adler = S(Bt.adler, dt, Xt, et)), Bt.next_in += Xt, Bt.total_in += Xt, Xt), pe.lookahead += xt, pe.lookahead + pe.insert >= ke)
            for (Qe = pe.strstart - pe.insert, pe.ins_h = pe.window[Qe], pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[Qe + 1]) & pe.hash_mask; pe.insert && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[Qe + ke - 1]) & pe.hash_mask, pe.prev[Qe & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = Qe, Qe++, pe.insert--, !(pe.lookahead + pe.insert < ke)); )
              ;
        } while (pe.lookahead < Lt && pe.strm.avail_in !== 0);
      }
      function rn(pe, Tt) {
        for (var xt, Re; ; ) {
          if (pe.lookahead < Lt) {
            if (Ni(pe), pe.lookahead < Lt && Tt === D)
              return ue;
            if (pe.lookahead === 0)
              break;
          }
          if (xt = 0, pe.lookahead >= ke && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + ke - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), xt !== 0 && pe.strstart - xt <= pe.w_size - Lt && (pe.match_length = At(pe, xt)), pe.match_length >= ke)
            if (Re = f._tr_tally(pe, pe.strstart - pe.match_start, pe.match_length - ke), pe.lookahead -= pe.match_length, pe.match_length <= pe.max_lazy_match && pe.lookahead >= ke) {
              for (pe.match_length--; pe.strstart++, pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + ke - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart, --pe.match_length != 0; )
                ;
              pe.strstart++;
            } else
              pe.strstart += pe.match_length, pe.match_length = 0, pe.ins_h = pe.window[pe.strstart], pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + 1]) & pe.hash_mask;
          else
            Re = f._tr_tally(pe, 0, pe.window[pe.strstart]), pe.lookahead--, pe.strstart++;
          if (Re && (lt(pe, !1), pe.strm.avail_out === 0))
            return ue;
        }
        return pe.insert = pe.strstart < ke - 1 ? pe.strstart : ke - 1, Tt === Z ? (lt(pe, !0), pe.strm.avail_out === 0 ? Ue : ot) : pe.last_lit && (lt(pe, !1), pe.strm.avail_out === 0) ? ue : yt;
      }
      function ui(pe, Tt) {
        for (var xt, Re, Ie; ; ) {
          if (pe.lookahead < Lt) {
            if (Ni(pe), pe.lookahead < Lt && Tt === D)
              return ue;
            if (pe.lookahead === 0)
              break;
          }
          if (xt = 0, pe.lookahead >= ke && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + ke - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), pe.prev_length = pe.match_length, pe.prev_match = pe.match_start, pe.match_length = ke - 1, xt !== 0 && pe.prev_length < pe.max_lazy_match && pe.strstart - xt <= pe.w_size - Lt && (pe.match_length = At(pe, xt), pe.match_length <= 5 && (pe.strategy === 1 || pe.match_length === ke && 4096 < pe.strstart - pe.match_start) && (pe.match_length = ke - 1)), pe.prev_length >= ke && pe.match_length <= pe.prev_length) {
            for (Ie = pe.strstart + pe.lookahead - ke, Re = f._tr_tally(pe, pe.strstart - 1 - pe.prev_match, pe.prev_length - ke), pe.lookahead -= pe.prev_length - 1, pe.prev_length -= 2; ++pe.strstart <= Ie && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + ke - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), --pe.prev_length != 0; )
              ;
            if (pe.match_available = 0, pe.match_length = ke - 1, pe.strstart++, Re && (lt(pe, !1), pe.strm.avail_out === 0))
              return ue;
          } else if (pe.match_available) {
            if ((Re = f._tr_tally(pe, 0, pe.window[pe.strstart - 1])) && lt(pe, !1), pe.strstart++, pe.lookahead--, pe.strm.avail_out === 0)
              return ue;
          } else
            pe.match_available = 1, pe.strstart++, pe.lookahead--;
        }
        return pe.match_available && (Re = f._tr_tally(pe, 0, pe.window[pe.strstart - 1]), pe.match_available = 0), pe.insert = pe.strstart < ke - 1 ? pe.strstart : ke - 1, Tt === Z ? (lt(pe, !0), pe.strm.avail_out === 0 ? Ue : ot) : pe.last_lit && (lt(pe, !1), pe.strm.avail_out === 0) ? ue : yt;
      }
      function Wt(pe, Tt, xt, Re, Ie) {
        this.good_length = pe, this.max_lazy = Tt, this.nice_length = xt, this.max_chain = Re, this.func = Ie;
      }
      function Qt() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = te, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new u.Buf16(2 * j), this.dyn_dtree = new u.Buf16(2 * (2 * ve + 1)), this.bl_tree = new u.Buf16(2 * (2 * K + 1)), Zt(this.dyn_ltree), Zt(this.dyn_dtree), Zt(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new u.Buf16(We + 1), this.heap = new u.Buf16(2 * he + 1), Zt(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new u.Buf16(2 * he + 1), Zt(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function ei(pe) {
        var Tt;
        return pe && pe.state ? (pe.total_in = pe.total_out = 0, pe.data_type = G, (Tt = pe.state).pending = 0, Tt.pending_out = 0, Tt.wrap < 0 && (Tt.wrap = -Tt.wrap), Tt.status = Tt.wrap ? Be : Xe, pe.adler = Tt.wrap === 2 ? 0 : 1, Tt.last_flush = D, f._tr_init(Tt), M) : Gt(pe, X);
      }
      function on(pe) {
        var Tt = ei(pe);
        return Tt === M && function(xt) {
          xt.window_size = 2 * xt.w_size, Zt(xt.head), xt.max_lazy_match = a[xt.level].max_lazy, xt.good_match = a[xt.level].good_length, xt.nice_match = a[xt.level].nice_length, xt.max_chain_length = a[xt.level].max_chain, xt.strstart = 0, xt.block_start = 0, xt.lookahead = 0, xt.insert = 0, xt.match_length = xt.prev_length = ke - 1, xt.match_available = 0, xt.ins_h = 0;
        }(pe.state), Tt;
      }
      function tn(pe, Tt, xt, Re, Ie, Qe) {
        if (!pe)
          return X;
        var Bt = 1;
        if (Tt === Y && (Tt = 6), Re < 0 ? (Bt = 0, Re = -Re) : 15 < Re && (Bt = 2, Re -= 16), Ie < 1 || J < Ie || xt !== te || Re < 8 || 15 < Re || Tt < 0 || 9 < Tt || Qe < 0 || ie < Qe)
          return Gt(pe, X);
        Re === 8 && (Re = 9);
        var dt = new Qt();
        return (pe.state = dt).strm = pe, dt.wrap = Bt, dt.gzhead = null, dt.w_bits = Re, dt.w_size = 1 << dt.w_bits, dt.w_mask = dt.w_size - 1, dt.hash_bits = Ie + 7, dt.hash_size = 1 << dt.hash_bits, dt.hash_mask = dt.hash_size - 1, dt.hash_shift = ~~((dt.hash_bits + ke - 1) / ke), dt.window = new u.Buf8(2 * dt.w_size), dt.head = new u.Buf16(dt.hash_size), dt.prev = new u.Buf16(dt.w_size), dt.lit_bufsize = 1 << Ie + 6, dt.pending_buf_size = 4 * dt.lit_bufsize, dt.pending_buf = new u.Buf8(dt.pending_buf_size), dt.d_buf = 1 * dt.lit_bufsize, dt.l_buf = 3 * dt.lit_bufsize, dt.level = Tt, dt.strategy = Qe, dt.method = xt, on(pe);
      }
      a = [new Wt(0, 0, 0, 0, function(pe, Tt) {
        var xt = 65535;
        for (xt > pe.pending_buf_size - 5 && (xt = pe.pending_buf_size - 5); ; ) {
          if (pe.lookahead <= 1) {
            if (Ni(pe), pe.lookahead === 0 && Tt === D)
              return ue;
            if (pe.lookahead === 0)
              break;
          }
          pe.strstart += pe.lookahead, pe.lookahead = 0;
          var Re = pe.block_start + xt;
          if ((pe.strstart === 0 || pe.strstart >= Re) && (pe.lookahead = pe.strstart - Re, pe.strstart = Re, lt(pe, !1), pe.strm.avail_out === 0) || pe.strstart - pe.block_start >= pe.w_size - Lt && (lt(pe, !1), pe.strm.avail_out === 0))
            return ue;
        }
        return pe.insert = 0, Tt === Z ? (lt(pe, !0), pe.strm.avail_out === 0 ? Ue : ot) : (pe.strstart > pe.block_start && (lt(pe, !1), pe.strm.avail_out), ue);
      }), new Wt(4, 4, 8, 4, rn), new Wt(4, 5, 16, 8, rn), new Wt(4, 6, 32, 32, rn), new Wt(4, 4, 16, 16, ui), new Wt(8, 16, 32, 32, ui), new Wt(8, 16, 128, 128, ui), new Wt(8, 32, 128, 256, ui), new Wt(32, 128, 258, 1024, ui), new Wt(32, 258, 258, 4096, ui)], o.deflateInit = function(pe, Tt) {
        return tn(pe, Tt, te, 15, 8, 0);
      }, o.deflateInit2 = tn, o.deflateReset = on, o.deflateResetKeep = ei, o.deflateSetHeader = function(pe, Tt) {
        return pe && pe.state ? pe.state.wrap !== 2 ? X : (pe.state.gzhead = Tt, M) : X;
      }, o.deflate = function(pe, Tt) {
        var xt, Re, Ie, Qe;
        if (!pe || !pe.state || 5 < Tt || Tt < 0)
          return pe ? Gt(pe, X) : X;
        if (Re = pe.state, !pe.output || !pe.input && pe.avail_in !== 0 || Re.status === 666 && Tt !== Z)
          return Gt(pe, pe.avail_out === 0 ? -5 : X);
        if (Re.strm = pe, xt = Re.last_flush, Re.last_flush = Tt, Re.status === Be)
          if (Re.wrap === 2)
            pe.adler = 0, $t(Re, 31), $t(Re, 139), $t(Re, 8), Re.gzhead ? ($t(Re, (Re.gzhead.text ? 1 : 0) + (Re.gzhead.hcrc ? 2 : 0) + (Re.gzhead.extra ? 4 : 0) + (Re.gzhead.name ? 8 : 0) + (Re.gzhead.comment ? 16 : 0)), $t(Re, 255 & Re.gzhead.time), $t(Re, Re.gzhead.time >> 8 & 255), $t(Re, Re.gzhead.time >> 16 & 255), $t(Re, Re.gzhead.time >> 24 & 255), $t(Re, Re.level === 9 ? 2 : 2 <= Re.strategy || Re.level < 2 ? 4 : 0), $t(Re, 255 & Re.gzhead.os), Re.gzhead.extra && Re.gzhead.extra.length && ($t(Re, 255 & Re.gzhead.extra.length), $t(Re, Re.gzhead.extra.length >> 8 & 255)), Re.gzhead.hcrc && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending, 0)), Re.gzindex = 0, Re.status = 69) : ($t(Re, 0), $t(Re, 0), $t(Re, 0), $t(Re, 0), $t(Re, 0), $t(Re, Re.level === 9 ? 2 : 2 <= Re.strategy || Re.level < 2 ? 4 : 0), $t(Re, 3), Re.status = Xe);
          else {
            var Bt = te + (Re.w_bits - 8 << 4) << 8;
            Bt |= (2 <= Re.strategy || Re.level < 2 ? 0 : Re.level < 6 ? 1 : Re.level === 6 ? 2 : 3) << 6, Re.strstart !== 0 && (Bt |= 32), Bt += 31 - Bt % 31, Re.status = Xe, Kt(Re, Bt), Re.strstart !== 0 && (Kt(Re, pe.adler >>> 16), Kt(Re, 65535 & pe.adler)), pe.adler = 1;
          }
        if (Re.status === 69)
          if (Re.gzhead.extra) {
            for (Ie = Re.pending; Re.gzindex < (65535 & Re.gzhead.extra.length) && (Re.pending !== Re.pending_buf_size || (Re.gzhead.hcrc && Re.pending > Ie && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending - Ie, Ie)), ct(pe), Ie = Re.pending, Re.pending !== Re.pending_buf_size)); )
              $t(Re, 255 & Re.gzhead.extra[Re.gzindex]), Re.gzindex++;
            Re.gzhead.hcrc && Re.pending > Ie && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending - Ie, Ie)), Re.gzindex === Re.gzhead.extra.length && (Re.gzindex = 0, Re.status = 73);
          } else
            Re.status = 73;
        if (Re.status === 73)
          if (Re.gzhead.name) {
            Ie = Re.pending;
            do {
              if (Re.pending === Re.pending_buf_size && (Re.gzhead.hcrc && Re.pending > Ie && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending - Ie, Ie)), ct(pe), Ie = Re.pending, Re.pending === Re.pending_buf_size)) {
                Qe = 1;
                break;
              }
              Qe = Re.gzindex < Re.gzhead.name.length ? 255 & Re.gzhead.name.charCodeAt(Re.gzindex++) : 0, $t(Re, Qe);
            } while (Qe !== 0);
            Re.gzhead.hcrc && Re.pending > Ie && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending - Ie, Ie)), Qe === 0 && (Re.gzindex = 0, Re.status = 91);
          } else
            Re.status = 91;
        if (Re.status === 91)
          if (Re.gzhead.comment) {
            Ie = Re.pending;
            do {
              if (Re.pending === Re.pending_buf_size && (Re.gzhead.hcrc && Re.pending > Ie && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending - Ie, Ie)), ct(pe), Ie = Re.pending, Re.pending === Re.pending_buf_size)) {
                Qe = 1;
                break;
              }
              Qe = Re.gzindex < Re.gzhead.comment.length ? 255 & Re.gzhead.comment.charCodeAt(Re.gzindex++) : 0, $t(Re, Qe);
            } while (Qe !== 0);
            Re.gzhead.hcrc && Re.pending > Ie && (pe.adler = S(pe.adler, Re.pending_buf, Re.pending - Ie, Ie)), Qe === 0 && (Re.status = 103);
          } else
            Re.status = 103;
        if (Re.status === 103 && (Re.gzhead.hcrc ? (Re.pending + 2 > Re.pending_buf_size && ct(pe), Re.pending + 2 <= Re.pending_buf_size && ($t(Re, 255 & pe.adler), $t(Re, pe.adler >> 8 & 255), pe.adler = 0, Re.status = Xe)) : Re.status = Xe), Re.pending !== 0) {
          if (ct(pe), pe.avail_out === 0)
            return Re.last_flush = -1, M;
        } else if (pe.avail_in === 0 && it(Tt) <= it(xt) && Tt !== Z)
          return Gt(pe, -5);
        if (Re.status === 666 && pe.avail_in !== 0)
          return Gt(pe, -5);
        if (pe.avail_in !== 0 || Re.lookahead !== 0 || Tt !== D && Re.status !== 666) {
          var dt = Re.strategy === 2 ? function(et, wt) {
            for (var Xt; ; ) {
              if (et.lookahead === 0 && (Ni(et), et.lookahead === 0)) {
                if (wt === D)
                  return ue;
                break;
              }
              if (et.match_length = 0, Xt = f._tr_tally(et, 0, et.window[et.strstart]), et.lookahead--, et.strstart++, Xt && (lt(et, !1), et.strm.avail_out === 0))
                return ue;
            }
            return et.insert = 0, wt === Z ? (lt(et, !0), et.strm.avail_out === 0 ? Ue : ot) : et.last_lit && (lt(et, !1), et.strm.avail_out === 0) ? ue : yt;
          }(Re, Tt) : Re.strategy === 3 ? function(et, wt) {
            for (var Xt, He, i, n, s = et.window; ; ) {
              if (et.lookahead <= $e) {
                if (Ni(et), et.lookahead <= $e && wt === D)
                  return ue;
                if (et.lookahead === 0)
                  break;
              }
              if (et.match_length = 0, et.lookahead >= ke && 0 < et.strstart && (He = s[i = et.strstart - 1]) === s[++i] && He === s[++i] && He === s[++i]) {
                n = et.strstart + $e;
                do
                  ;
                while (He === s[++i] && He === s[++i] && He === s[++i] && He === s[++i] && He === s[++i] && He === s[++i] && He === s[++i] && He === s[++i] && i < n);
                et.match_length = $e - (n - i), et.match_length > et.lookahead && (et.match_length = et.lookahead);
              }
              if (et.match_length >= ke ? (Xt = f._tr_tally(et, 1, et.match_length - ke), et.lookahead -= et.match_length, et.strstart += et.match_length, et.match_length = 0) : (Xt = f._tr_tally(et, 0, et.window[et.strstart]), et.lookahead--, et.strstart++), Xt && (lt(et, !1), et.strm.avail_out === 0))
                return ue;
            }
            return et.insert = 0, wt === Z ? (lt(et, !0), et.strm.avail_out === 0 ? Ue : ot) : et.last_lit && (lt(et, !1), et.strm.avail_out === 0) ? ue : yt;
          }(Re, Tt) : a[Re.level].func(Re, Tt);
          if (dt !== Ue && dt !== ot || (Re.status = 666), dt === ue || dt === Ue)
            return pe.avail_out === 0 && (Re.last_flush = -1), M;
          if (dt === yt && (Tt === 1 ? f._tr_align(Re) : Tt !== 5 && (f._tr_stored_block(Re, 0, 0, !1), Tt === 3 && (Zt(Re.head), Re.lookahead === 0 && (Re.strstart = 0, Re.block_start = 0, Re.insert = 0))), ct(pe), pe.avail_out === 0))
            return Re.last_flush = -1, M;
        }
        return Tt !== Z ? M : Re.wrap <= 0 ? 1 : (Re.wrap === 2 ? ($t(Re, 255 & pe.adler), $t(Re, pe.adler >> 8 & 255), $t(Re, pe.adler >> 16 & 255), $t(Re, pe.adler >> 24 & 255), $t(Re, 255 & pe.total_in), $t(Re, pe.total_in >> 8 & 255), $t(Re, pe.total_in >> 16 & 255), $t(Re, pe.total_in >> 24 & 255)) : (Kt(Re, pe.adler >>> 16), Kt(Re, 65535 & pe.adler)), ct(pe), 0 < Re.wrap && (Re.wrap = -Re.wrap), Re.pending !== 0 ? M : 1);
      }, o.deflateEnd = function(pe) {
        var Tt;
        return pe && pe.state ? (Tt = pe.state.status) !== Be && Tt !== 69 && Tt !== 73 && Tt !== 91 && Tt !== 103 && Tt !== Xe && Tt !== 666 ? Gt(pe, X) : (pe.state = null, Tt === Xe ? Gt(pe, -3) : M) : X;
      }, o.deflateSetDictionary = function(pe, Tt) {
        var xt, Re, Ie, Qe, Bt, dt, et, wt, Xt = Tt.length;
        if (!pe || !pe.state || (Qe = (xt = pe.state).wrap) === 2 || Qe === 1 && xt.status !== Be || xt.lookahead)
          return X;
        for (Qe === 1 && (pe.adler = v(pe.adler, Tt, Xt, 0)), xt.wrap = 0, Xt >= xt.w_size && (Qe === 0 && (Zt(xt.head), xt.strstart = 0, xt.block_start = 0, xt.insert = 0), wt = new u.Buf8(xt.w_size), u.arraySet(wt, Tt, Xt - xt.w_size, xt.w_size, 0), Tt = wt, Xt = xt.w_size), Bt = pe.avail_in, dt = pe.next_in, et = pe.input, pe.avail_in = Xt, pe.next_in = 0, pe.input = Tt, Ni(xt); xt.lookahead >= ke; ) {
          for (Re = xt.strstart, Ie = xt.lookahead - (ke - 1); xt.ins_h = (xt.ins_h << xt.hash_shift ^ xt.window[Re + ke - 1]) & xt.hash_mask, xt.prev[Re & xt.w_mask] = xt.head[xt.ins_h], xt.head[xt.ins_h] = Re, Re++, --Ie; )
            ;
          xt.strstart = Re, xt.lookahead = ke - 1, Ni(xt);
        }
        return xt.strstart += xt.lookahead, xt.block_start = xt.strstart, xt.insert = xt.lookahead, xt.lookahead = 0, xt.match_length = xt.prev_length = ke - 1, xt.match_available = 0, pe.next_in = dt, pe.input = et, pe.avail_in = Bt, xt.wrap = Qe, M;
      }, o.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(t, r, o) {
      r.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(t, r, o) {
      r.exports = function(a, u) {
        var f, v, S, I, D, Z, M, X, Y, ie, G, te, J, he, ve, K, j, We, ke, $e, Lt, Be, Xe, ue, yt;
        f = a.state, v = a.next_in, ue = a.input, S = v + (a.avail_in - 5), I = a.next_out, yt = a.output, D = I - (u - a.avail_out), Z = I + (a.avail_out - 257), M = f.dmax, X = f.wsize, Y = f.whave, ie = f.wnext, G = f.window, te = f.hold, J = f.bits, he = f.lencode, ve = f.distcode, K = (1 << f.lenbits) - 1, j = (1 << f.distbits) - 1;
        e:
          do {
            J < 15 && (te += ue[v++] << J, J += 8, te += ue[v++] << J, J += 8), We = he[te & K];
            t:
              for (; ; ) {
                if (te >>>= ke = We >>> 24, J -= ke, (ke = We >>> 16 & 255) === 0)
                  yt[I++] = 65535 & We;
                else {
                  if (!(16 & ke)) {
                    if (!(64 & ke)) {
                      We = he[(65535 & We) + (te & (1 << ke) - 1)];
                      continue t;
                    }
                    if (32 & ke) {
                      f.mode = 12;
                      break e;
                    }
                    a.msg = "invalid literal/length code", f.mode = 30;
                    break e;
                  }
                  $e = 65535 & We, (ke &= 15) && (J < ke && (te += ue[v++] << J, J += 8), $e += te & (1 << ke) - 1, te >>>= ke, J -= ke), J < 15 && (te += ue[v++] << J, J += 8, te += ue[v++] << J, J += 8), We = ve[te & j];
                  i:
                    for (; ; ) {
                      if (te >>>= ke = We >>> 24, J -= ke, !(16 & (ke = We >>> 16 & 255))) {
                        if (!(64 & ke)) {
                          We = ve[(65535 & We) + (te & (1 << ke) - 1)];
                          continue i;
                        }
                        a.msg = "invalid distance code", f.mode = 30;
                        break e;
                      }
                      if (Lt = 65535 & We, J < (ke &= 15) && (te += ue[v++] << J, (J += 8) < ke && (te += ue[v++] << J, J += 8)), M < (Lt += te & (1 << ke) - 1)) {
                        a.msg = "invalid distance too far back", f.mode = 30;
                        break e;
                      }
                      if (te >>>= ke, J -= ke, (ke = I - D) < Lt) {
                        if (Y < (ke = Lt - ke) && f.sane) {
                          a.msg = "invalid distance too far back", f.mode = 30;
                          break e;
                        }
                        if (Xe = G, (Be = 0) === ie) {
                          if (Be += X - ke, ke < $e) {
                            for ($e -= ke; yt[I++] = G[Be++], --ke; )
                              ;
                            Be = I - Lt, Xe = yt;
                          }
                        } else if (ie < ke) {
                          if (Be += X + ie - ke, (ke -= ie) < $e) {
                            for ($e -= ke; yt[I++] = G[Be++], --ke; )
                              ;
                            if (Be = 0, ie < $e) {
                              for ($e -= ke = ie; yt[I++] = G[Be++], --ke; )
                                ;
                              Be = I - Lt, Xe = yt;
                            }
                          }
                        } else if (Be += ie - ke, ke < $e) {
                          for ($e -= ke; yt[I++] = G[Be++], --ke; )
                            ;
                          Be = I - Lt, Xe = yt;
                        }
                        for (; 2 < $e; )
                          yt[I++] = Xe[Be++], yt[I++] = Xe[Be++], yt[I++] = Xe[Be++], $e -= 3;
                        $e && (yt[I++] = Xe[Be++], 1 < $e && (yt[I++] = Xe[Be++]));
                      } else {
                        for (Be = I - Lt; yt[I++] = yt[Be++], yt[I++] = yt[Be++], yt[I++] = yt[Be++], 2 < ($e -= 3); )
                          ;
                        $e && (yt[I++] = yt[Be++], 1 < $e && (yt[I++] = yt[Be++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (v < S && I < Z);
        v -= $e = J >> 3, te &= (1 << (J -= $e << 3)) - 1, a.next_in = v, a.next_out = I, a.avail_in = v < S ? S - v + 5 : 5 - (v - S), a.avail_out = I < Z ? Z - I + 257 : 257 - (I - Z), f.hold = te, f.bits = J;
      };
    }, {}], 49: [function(t, r, o) {
      var a = t("../utils/common"), u = t("./adler32"), f = t("./crc32"), v = t("./inffast"), S = t("./inftrees"), I = 1, D = 2, Z = 0, M = -2, X = 1, Y = 852, ie = 592;
      function G(Be) {
        return (Be >>> 24 & 255) + (Be >>> 8 & 65280) + ((65280 & Be) << 8) + ((255 & Be) << 24);
      }
      function te() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new a.Buf16(320), this.work = new a.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function J(Be) {
        var Xe;
        return Be && Be.state ? (Xe = Be.state, Be.total_in = Be.total_out = Xe.total = 0, Be.msg = "", Xe.wrap && (Be.adler = 1 & Xe.wrap), Xe.mode = X, Xe.last = 0, Xe.havedict = 0, Xe.dmax = 32768, Xe.head = null, Xe.hold = 0, Xe.bits = 0, Xe.lencode = Xe.lendyn = new a.Buf32(Y), Xe.distcode = Xe.distdyn = new a.Buf32(ie), Xe.sane = 1, Xe.back = -1, Z) : M;
      }
      function he(Be) {
        var Xe;
        return Be && Be.state ? ((Xe = Be.state).wsize = 0, Xe.whave = 0, Xe.wnext = 0, J(Be)) : M;
      }
      function ve(Be, Xe) {
        var ue, yt;
        return Be && Be.state ? (yt = Be.state, Xe < 0 ? (ue = 0, Xe = -Xe) : (ue = 1 + (Xe >> 4), Xe < 48 && (Xe &= 15)), Xe && (Xe < 8 || 15 < Xe) ? M : (yt.window !== null && yt.wbits !== Xe && (yt.window = null), yt.wrap = ue, yt.wbits = Xe, he(Be))) : M;
      }
      function K(Be, Xe) {
        var ue, yt;
        return Be ? (yt = new te(), (Be.state = yt).window = null, (ue = ve(Be, Xe)) !== Z && (Be.state = null), ue) : M;
      }
      var j, We, ke = !0;
      function $e(Be) {
        if (ke) {
          var Xe;
          for (j = new a.Buf32(512), We = new a.Buf32(32), Xe = 0; Xe < 144; )
            Be.lens[Xe++] = 8;
          for (; Xe < 256; )
            Be.lens[Xe++] = 9;
          for (; Xe < 280; )
            Be.lens[Xe++] = 7;
          for (; Xe < 288; )
            Be.lens[Xe++] = 8;
          for (S(I, Be.lens, 0, 288, j, 0, Be.work, { bits: 9 }), Xe = 0; Xe < 32; )
            Be.lens[Xe++] = 5;
          S(D, Be.lens, 0, 32, We, 0, Be.work, { bits: 5 }), ke = !1;
        }
        Be.lencode = j, Be.lenbits = 9, Be.distcode = We, Be.distbits = 5;
      }
      function Lt(Be, Xe, ue, yt) {
        var Ue, ot = Be.state;
        return ot.window === null && (ot.wsize = 1 << ot.wbits, ot.wnext = 0, ot.whave = 0, ot.window = new a.Buf8(ot.wsize)), yt >= ot.wsize ? (a.arraySet(ot.window, Xe, ue - ot.wsize, ot.wsize, 0), ot.wnext = 0, ot.whave = ot.wsize) : (yt < (Ue = ot.wsize - ot.wnext) && (Ue = yt), a.arraySet(ot.window, Xe, ue - yt, Ue, ot.wnext), (yt -= Ue) ? (a.arraySet(ot.window, Xe, ue - yt, yt, 0), ot.wnext = yt, ot.whave = ot.wsize) : (ot.wnext += Ue, ot.wnext === ot.wsize && (ot.wnext = 0), ot.whave < ot.wsize && (ot.whave += Ue))), 0;
      }
      o.inflateReset = he, o.inflateReset2 = ve, o.inflateResetKeep = J, o.inflateInit = function(Be) {
        return K(Be, 15);
      }, o.inflateInit2 = K, o.inflate = function(Be, Xe) {
        var ue, yt, Ue, ot, Gt, it, Zt, ct, lt, $t, Kt, At, Ni, rn, ui, Wt, Qt, ei, on, tn, pe, Tt, xt, Re, Ie = 0, Qe = new a.Buf8(4), Bt = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!Be || !Be.state || !Be.output || !Be.input && Be.avail_in !== 0)
          return M;
        (ue = Be.state).mode === 12 && (ue.mode = 13), Gt = Be.next_out, Ue = Be.output, Zt = Be.avail_out, ot = Be.next_in, yt = Be.input, it = Be.avail_in, ct = ue.hold, lt = ue.bits, $t = it, Kt = Zt, Tt = Z;
        e:
          for (; ; )
            switch (ue.mode) {
              case X:
                if (ue.wrap === 0) {
                  ue.mode = 13;
                  break;
                }
                for (; lt < 16; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                if (2 & ue.wrap && ct === 35615) {
                  Qe[ue.check = 0] = 255 & ct, Qe[1] = ct >>> 8 & 255, ue.check = f(ue.check, Qe, 2, 0), lt = ct = 0, ue.mode = 2;
                  break;
                }
                if (ue.flags = 0, ue.head && (ue.head.done = !1), !(1 & ue.wrap) || (((255 & ct) << 8) + (ct >> 8)) % 31) {
                  Be.msg = "incorrect header check", ue.mode = 30;
                  break;
                }
                if ((15 & ct) != 8) {
                  Be.msg = "unknown compression method", ue.mode = 30;
                  break;
                }
                if (lt -= 4, pe = 8 + (15 & (ct >>>= 4)), ue.wbits === 0)
                  ue.wbits = pe;
                else if (pe > ue.wbits) {
                  Be.msg = "invalid window size", ue.mode = 30;
                  break;
                }
                ue.dmax = 1 << pe, Be.adler = ue.check = 1, ue.mode = 512 & ct ? 10 : 12, lt = ct = 0;
                break;
              case 2:
                for (; lt < 16; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                if (ue.flags = ct, (255 & ue.flags) != 8) {
                  Be.msg = "unknown compression method", ue.mode = 30;
                  break;
                }
                if (57344 & ue.flags) {
                  Be.msg = "unknown header flags set", ue.mode = 30;
                  break;
                }
                ue.head && (ue.head.text = ct >> 8 & 1), 512 & ue.flags && (Qe[0] = 255 & ct, Qe[1] = ct >>> 8 & 255, ue.check = f(ue.check, Qe, 2, 0)), lt = ct = 0, ue.mode = 3;
              case 3:
                for (; lt < 32; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                ue.head && (ue.head.time = ct), 512 & ue.flags && (Qe[0] = 255 & ct, Qe[1] = ct >>> 8 & 255, Qe[2] = ct >>> 16 & 255, Qe[3] = ct >>> 24 & 255, ue.check = f(ue.check, Qe, 4, 0)), lt = ct = 0, ue.mode = 4;
              case 4:
                for (; lt < 16; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                ue.head && (ue.head.xflags = 255 & ct, ue.head.os = ct >> 8), 512 & ue.flags && (Qe[0] = 255 & ct, Qe[1] = ct >>> 8 & 255, ue.check = f(ue.check, Qe, 2, 0)), lt = ct = 0, ue.mode = 5;
              case 5:
                if (1024 & ue.flags) {
                  for (; lt < 16; ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  ue.length = ct, ue.head && (ue.head.extra_len = ct), 512 & ue.flags && (Qe[0] = 255 & ct, Qe[1] = ct >>> 8 & 255, ue.check = f(ue.check, Qe, 2, 0)), lt = ct = 0;
                } else
                  ue.head && (ue.head.extra = null);
                ue.mode = 6;
              case 6:
                if (1024 & ue.flags && (it < (At = ue.length) && (At = it), At && (ue.head && (pe = ue.head.extra_len - ue.length, ue.head.extra || (ue.head.extra = new Array(ue.head.extra_len)), a.arraySet(ue.head.extra, yt, ot, At, pe)), 512 & ue.flags && (ue.check = f(ue.check, yt, At, ot)), it -= At, ot += At, ue.length -= At), ue.length))
                  break e;
                ue.length = 0, ue.mode = 7;
              case 7:
                if (2048 & ue.flags) {
                  if (it === 0)
                    break e;
                  for (At = 0; pe = yt[ot + At++], ue.head && pe && ue.length < 65536 && (ue.head.name += String.fromCharCode(pe)), pe && At < it; )
                    ;
                  if (512 & ue.flags && (ue.check = f(ue.check, yt, At, ot)), it -= At, ot += At, pe)
                    break e;
                } else
                  ue.head && (ue.head.name = null);
                ue.length = 0, ue.mode = 8;
              case 8:
                if (4096 & ue.flags) {
                  if (it === 0)
                    break e;
                  for (At = 0; pe = yt[ot + At++], ue.head && pe && ue.length < 65536 && (ue.head.comment += String.fromCharCode(pe)), pe && At < it; )
                    ;
                  if (512 & ue.flags && (ue.check = f(ue.check, yt, At, ot)), it -= At, ot += At, pe)
                    break e;
                } else
                  ue.head && (ue.head.comment = null);
                ue.mode = 9;
              case 9:
                if (512 & ue.flags) {
                  for (; lt < 16; ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  if (ct !== (65535 & ue.check)) {
                    Be.msg = "header crc mismatch", ue.mode = 30;
                    break;
                  }
                  lt = ct = 0;
                }
                ue.head && (ue.head.hcrc = ue.flags >> 9 & 1, ue.head.done = !0), Be.adler = ue.check = 0, ue.mode = 12;
                break;
              case 10:
                for (; lt < 32; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                Be.adler = ue.check = G(ct), lt = ct = 0, ue.mode = 11;
              case 11:
                if (ue.havedict === 0)
                  return Be.next_out = Gt, Be.avail_out = Zt, Be.next_in = ot, Be.avail_in = it, ue.hold = ct, ue.bits = lt, 2;
                Be.adler = ue.check = 1, ue.mode = 12;
              case 12:
                if (Xe === 5 || Xe === 6)
                  break e;
              case 13:
                if (ue.last) {
                  ct >>>= 7 & lt, lt -= 7 & lt, ue.mode = 27;
                  break;
                }
                for (; lt < 3; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                switch (ue.last = 1 & ct, lt -= 1, 3 & (ct >>>= 1)) {
                  case 0:
                    ue.mode = 14;
                    break;
                  case 1:
                    if ($e(ue), ue.mode = 20, Xe !== 6)
                      break;
                    ct >>>= 2, lt -= 2;
                    break e;
                  case 2:
                    ue.mode = 17;
                    break;
                  case 3:
                    Be.msg = "invalid block type", ue.mode = 30;
                }
                ct >>>= 2, lt -= 2;
                break;
              case 14:
                for (ct >>>= 7 & lt, lt -= 7 & lt; lt < 32; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                if ((65535 & ct) != (ct >>> 16 ^ 65535)) {
                  Be.msg = "invalid stored block lengths", ue.mode = 30;
                  break;
                }
                if (ue.length = 65535 & ct, lt = ct = 0, ue.mode = 15, Xe === 6)
                  break e;
              case 15:
                ue.mode = 16;
              case 16:
                if (At = ue.length) {
                  if (it < At && (At = it), Zt < At && (At = Zt), At === 0)
                    break e;
                  a.arraySet(Ue, yt, ot, At, Gt), it -= At, ot += At, Zt -= At, Gt += At, ue.length -= At;
                  break;
                }
                ue.mode = 12;
                break;
              case 17:
                for (; lt < 14; ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                if (ue.nlen = 257 + (31 & ct), ct >>>= 5, lt -= 5, ue.ndist = 1 + (31 & ct), ct >>>= 5, lt -= 5, ue.ncode = 4 + (15 & ct), ct >>>= 4, lt -= 4, 286 < ue.nlen || 30 < ue.ndist) {
                  Be.msg = "too many length or distance symbols", ue.mode = 30;
                  break;
                }
                ue.have = 0, ue.mode = 18;
              case 18:
                for (; ue.have < ue.ncode; ) {
                  for (; lt < 3; ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  ue.lens[Bt[ue.have++]] = 7 & ct, ct >>>= 3, lt -= 3;
                }
                for (; ue.have < 19; )
                  ue.lens[Bt[ue.have++]] = 0;
                if (ue.lencode = ue.lendyn, ue.lenbits = 7, xt = { bits: ue.lenbits }, Tt = S(0, ue.lens, 0, 19, ue.lencode, 0, ue.work, xt), ue.lenbits = xt.bits, Tt) {
                  Be.msg = "invalid code lengths set", ue.mode = 30;
                  break;
                }
                ue.have = 0, ue.mode = 19;
              case 19:
                for (; ue.have < ue.nlen + ue.ndist; ) {
                  for (; Wt = (Ie = ue.lencode[ct & (1 << ue.lenbits) - 1]) >>> 16 & 255, Qt = 65535 & Ie, !((ui = Ie >>> 24) <= lt); ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  if (Qt < 16)
                    ct >>>= ui, lt -= ui, ue.lens[ue.have++] = Qt;
                  else {
                    if (Qt === 16) {
                      for (Re = ui + 2; lt < Re; ) {
                        if (it === 0)
                          break e;
                        it--, ct += yt[ot++] << lt, lt += 8;
                      }
                      if (ct >>>= ui, lt -= ui, ue.have === 0) {
                        Be.msg = "invalid bit length repeat", ue.mode = 30;
                        break;
                      }
                      pe = ue.lens[ue.have - 1], At = 3 + (3 & ct), ct >>>= 2, lt -= 2;
                    } else if (Qt === 17) {
                      for (Re = ui + 3; lt < Re; ) {
                        if (it === 0)
                          break e;
                        it--, ct += yt[ot++] << lt, lt += 8;
                      }
                      lt -= ui, pe = 0, At = 3 + (7 & (ct >>>= ui)), ct >>>= 3, lt -= 3;
                    } else {
                      for (Re = ui + 7; lt < Re; ) {
                        if (it === 0)
                          break e;
                        it--, ct += yt[ot++] << lt, lt += 8;
                      }
                      lt -= ui, pe = 0, At = 11 + (127 & (ct >>>= ui)), ct >>>= 7, lt -= 7;
                    }
                    if (ue.have + At > ue.nlen + ue.ndist) {
                      Be.msg = "invalid bit length repeat", ue.mode = 30;
                      break;
                    }
                    for (; At--; )
                      ue.lens[ue.have++] = pe;
                  }
                }
                if (ue.mode === 30)
                  break;
                if (ue.lens[256] === 0) {
                  Be.msg = "invalid code -- missing end-of-block", ue.mode = 30;
                  break;
                }
                if (ue.lenbits = 9, xt = { bits: ue.lenbits }, Tt = S(I, ue.lens, 0, ue.nlen, ue.lencode, 0, ue.work, xt), ue.lenbits = xt.bits, Tt) {
                  Be.msg = "invalid literal/lengths set", ue.mode = 30;
                  break;
                }
                if (ue.distbits = 6, ue.distcode = ue.distdyn, xt = { bits: ue.distbits }, Tt = S(D, ue.lens, ue.nlen, ue.ndist, ue.distcode, 0, ue.work, xt), ue.distbits = xt.bits, Tt) {
                  Be.msg = "invalid distances set", ue.mode = 30;
                  break;
                }
                if (ue.mode = 20, Xe === 6)
                  break e;
              case 20:
                ue.mode = 21;
              case 21:
                if (6 <= it && 258 <= Zt) {
                  Be.next_out = Gt, Be.avail_out = Zt, Be.next_in = ot, Be.avail_in = it, ue.hold = ct, ue.bits = lt, v(Be, Kt), Gt = Be.next_out, Ue = Be.output, Zt = Be.avail_out, ot = Be.next_in, yt = Be.input, it = Be.avail_in, ct = ue.hold, lt = ue.bits, ue.mode === 12 && (ue.back = -1);
                  break;
                }
                for (ue.back = 0; Wt = (Ie = ue.lencode[ct & (1 << ue.lenbits) - 1]) >>> 16 & 255, Qt = 65535 & Ie, !((ui = Ie >>> 24) <= lt); ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                if (Wt && !(240 & Wt)) {
                  for (ei = ui, on = Wt, tn = Qt; Wt = (Ie = ue.lencode[tn + ((ct & (1 << ei + on) - 1) >> ei)]) >>> 16 & 255, Qt = 65535 & Ie, !(ei + (ui = Ie >>> 24) <= lt); ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  ct >>>= ei, lt -= ei, ue.back += ei;
                }
                if (ct >>>= ui, lt -= ui, ue.back += ui, ue.length = Qt, Wt === 0) {
                  ue.mode = 26;
                  break;
                }
                if (32 & Wt) {
                  ue.back = -1, ue.mode = 12;
                  break;
                }
                if (64 & Wt) {
                  Be.msg = "invalid literal/length code", ue.mode = 30;
                  break;
                }
                ue.extra = 15 & Wt, ue.mode = 22;
              case 22:
                if (ue.extra) {
                  for (Re = ue.extra; lt < Re; ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  ue.length += ct & (1 << ue.extra) - 1, ct >>>= ue.extra, lt -= ue.extra, ue.back += ue.extra;
                }
                ue.was = ue.length, ue.mode = 23;
              case 23:
                for (; Wt = (Ie = ue.distcode[ct & (1 << ue.distbits) - 1]) >>> 16 & 255, Qt = 65535 & Ie, !((ui = Ie >>> 24) <= lt); ) {
                  if (it === 0)
                    break e;
                  it--, ct += yt[ot++] << lt, lt += 8;
                }
                if (!(240 & Wt)) {
                  for (ei = ui, on = Wt, tn = Qt; Wt = (Ie = ue.distcode[tn + ((ct & (1 << ei + on) - 1) >> ei)]) >>> 16 & 255, Qt = 65535 & Ie, !(ei + (ui = Ie >>> 24) <= lt); ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  ct >>>= ei, lt -= ei, ue.back += ei;
                }
                if (ct >>>= ui, lt -= ui, ue.back += ui, 64 & Wt) {
                  Be.msg = "invalid distance code", ue.mode = 30;
                  break;
                }
                ue.offset = Qt, ue.extra = 15 & Wt, ue.mode = 24;
              case 24:
                if (ue.extra) {
                  for (Re = ue.extra; lt < Re; ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  ue.offset += ct & (1 << ue.extra) - 1, ct >>>= ue.extra, lt -= ue.extra, ue.back += ue.extra;
                }
                if (ue.offset > ue.dmax) {
                  Be.msg = "invalid distance too far back", ue.mode = 30;
                  break;
                }
                ue.mode = 25;
              case 25:
                if (Zt === 0)
                  break e;
                if (At = Kt - Zt, ue.offset > At) {
                  if ((At = ue.offset - At) > ue.whave && ue.sane) {
                    Be.msg = "invalid distance too far back", ue.mode = 30;
                    break;
                  }
                  Ni = At > ue.wnext ? (At -= ue.wnext, ue.wsize - At) : ue.wnext - At, At > ue.length && (At = ue.length), rn = ue.window;
                } else
                  rn = Ue, Ni = Gt - ue.offset, At = ue.length;
                for (Zt < At && (At = Zt), Zt -= At, ue.length -= At; Ue[Gt++] = rn[Ni++], --At; )
                  ;
                ue.length === 0 && (ue.mode = 21);
                break;
              case 26:
                if (Zt === 0)
                  break e;
                Ue[Gt++] = ue.length, Zt--, ue.mode = 21;
                break;
              case 27:
                if (ue.wrap) {
                  for (; lt < 32; ) {
                    if (it === 0)
                      break e;
                    it--, ct |= yt[ot++] << lt, lt += 8;
                  }
                  if (Kt -= Zt, Be.total_out += Kt, ue.total += Kt, Kt && (Be.adler = ue.check = ue.flags ? f(ue.check, Ue, Kt, Gt - Kt) : u(ue.check, Ue, Kt, Gt - Kt)), Kt = Zt, (ue.flags ? ct : G(ct)) !== ue.check) {
                    Be.msg = "incorrect data check", ue.mode = 30;
                    break;
                  }
                  lt = ct = 0;
                }
                ue.mode = 28;
              case 28:
                if (ue.wrap && ue.flags) {
                  for (; lt < 32; ) {
                    if (it === 0)
                      break e;
                    it--, ct += yt[ot++] << lt, lt += 8;
                  }
                  if (ct !== (4294967295 & ue.total)) {
                    Be.msg = "incorrect length check", ue.mode = 30;
                    break;
                  }
                  lt = ct = 0;
                }
                ue.mode = 29;
              case 29:
                Tt = 1;
                break e;
              case 30:
                Tt = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return M;
            }
        return Be.next_out = Gt, Be.avail_out = Zt, Be.next_in = ot, Be.avail_in = it, ue.hold = ct, ue.bits = lt, (ue.wsize || Kt !== Be.avail_out && ue.mode < 30 && (ue.mode < 27 || Xe !== 4)) && Lt(Be, Be.output, Be.next_out, Kt - Be.avail_out) ? (ue.mode = 31, -4) : ($t -= Be.avail_in, Kt -= Be.avail_out, Be.total_in += $t, Be.total_out += Kt, ue.total += Kt, ue.wrap && Kt && (Be.adler = ue.check = ue.flags ? f(ue.check, Ue, Kt, Be.next_out - Kt) : u(ue.check, Ue, Kt, Be.next_out - Kt)), Be.data_type = ue.bits + (ue.last ? 64 : 0) + (ue.mode === 12 ? 128 : 0) + (ue.mode === 20 || ue.mode === 15 ? 256 : 0), ($t == 0 && Kt === 0 || Xe === 4) && Tt === Z && (Tt = -5), Tt);
      }, o.inflateEnd = function(Be) {
        if (!Be || !Be.state)
          return M;
        var Xe = Be.state;
        return Xe.window && (Xe.window = null), Be.state = null, Z;
      }, o.inflateGetHeader = function(Be, Xe) {
        var ue;
        return Be && Be.state && 2 & (ue = Be.state).wrap ? ((ue.head = Xe).done = !1, Z) : M;
      }, o.inflateSetDictionary = function(Be, Xe) {
        var ue, yt = Xe.length;
        return Be && Be.state ? (ue = Be.state).wrap !== 0 && ue.mode !== 11 ? M : ue.mode === 11 && u(1, Xe, yt, 0) !== ue.check ? -3 : Lt(Be, Xe, yt, yt) ? (ue.mode = 31, -4) : (ue.havedict = 1, Z) : M;
      }, o.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(t, r, o) {
      var a = t("../utils/common"), u = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], f = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], v = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], S = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      r.exports = function(I, D, Z, M, X, Y, ie, G) {
        var te, J, he, ve, K, j, We, ke, $e, Lt = G.bits, Be = 0, Xe = 0, ue = 0, yt = 0, Ue = 0, ot = 0, Gt = 0, it = 0, Zt = 0, ct = 0, lt = null, $t = 0, Kt = new a.Buf16(16), At = new a.Buf16(16), Ni = null, rn = 0;
        for (Be = 0; Be <= 15; Be++)
          Kt[Be] = 0;
        for (Xe = 0; Xe < M; Xe++)
          Kt[D[Z + Xe]]++;
        for (Ue = Lt, yt = 15; 1 <= yt && Kt[yt] === 0; yt--)
          ;
        if (yt < Ue && (Ue = yt), yt === 0)
          return X[Y++] = 20971520, X[Y++] = 20971520, G.bits = 1, 0;
        for (ue = 1; ue < yt && Kt[ue] === 0; ue++)
          ;
        for (Ue < ue && (Ue = ue), Be = it = 1; Be <= 15; Be++)
          if (it <<= 1, (it -= Kt[Be]) < 0)
            return -1;
        if (0 < it && (I === 0 || yt !== 1))
          return -1;
        for (At[1] = 0, Be = 1; Be < 15; Be++)
          At[Be + 1] = At[Be] + Kt[Be];
        for (Xe = 0; Xe < M; Xe++)
          D[Z + Xe] !== 0 && (ie[At[D[Z + Xe]]++] = Xe);
        if (j = I === 0 ? (lt = Ni = ie, 19) : I === 1 ? (lt = u, $t -= 257, Ni = f, rn -= 257, 256) : (lt = v, Ni = S, -1), Be = ue, K = Y, Gt = Xe = ct = 0, he = -1, ve = (Zt = 1 << (ot = Ue)) - 1, I === 1 && 852 < Zt || I === 2 && 592 < Zt)
          return 1;
        for (; ; ) {
          for (We = Be - Gt, $e = ie[Xe] < j ? (ke = 0, ie[Xe]) : ie[Xe] > j ? (ke = Ni[rn + ie[Xe]], lt[$t + ie[Xe]]) : (ke = 96, 0), te = 1 << Be - Gt, ue = J = 1 << ot; X[K + (ct >> Gt) + (J -= te)] = We << 24 | ke << 16 | $e | 0, J !== 0; )
            ;
          for (te = 1 << Be - 1; ct & te; )
            te >>= 1;
          if (te !== 0 ? (ct &= te - 1, ct += te) : ct = 0, Xe++, --Kt[Be] == 0) {
            if (Be === yt)
              break;
            Be = D[Z + ie[Xe]];
          }
          if (Ue < Be && (ct & ve) !== he) {
            for (Gt === 0 && (Gt = Ue), K += ue, it = 1 << (ot = Be - Gt); ot + Gt < yt && !((it -= Kt[ot + Gt]) <= 0); )
              ot++, it <<= 1;
            if (Zt += 1 << ot, I === 1 && 852 < Zt || I === 2 && 592 < Zt)
              return 1;
            X[he = ct & ve] = Ue << 24 | ot << 16 | K - Y | 0;
          }
        }
        return ct !== 0 && (X[K + ct] = Be - Gt << 24 | 64 << 16 | 0), G.bits = Ue, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(t, r, o) {
      r.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(t, r, o) {
      var a = t("../utils/common"), u = 0, f = 1;
      function v(Ie) {
        for (var Qe = Ie.length; 0 <= --Qe; )
          Ie[Qe] = 0;
      }
      var S = 0, I = 29, D = 256, Z = D + 1 + I, M = 30, X = 19, Y = 2 * Z + 1, ie = 15, G = 16, te = 7, J = 256, he = 16, ve = 17, K = 18, j = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], We = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], ke = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], $e = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], Lt = new Array(2 * (Z + 2));
      v(Lt);
      var Be = new Array(2 * M);
      v(Be);
      var Xe = new Array(512);
      v(Xe);
      var ue = new Array(256);
      v(ue);
      var yt = new Array(I);
      v(yt);
      var Ue, ot, Gt, it = new Array(M);
      function Zt(Ie, Qe, Bt, dt, et) {
        this.static_tree = Ie, this.extra_bits = Qe, this.extra_base = Bt, this.elems = dt, this.max_length = et, this.has_stree = Ie && Ie.length;
      }
      function ct(Ie, Qe) {
        this.dyn_tree = Ie, this.max_code = 0, this.stat_desc = Qe;
      }
      function lt(Ie) {
        return Ie < 256 ? Xe[Ie] : Xe[256 + (Ie >>> 7)];
      }
      function $t(Ie, Qe) {
        Ie.pending_buf[Ie.pending++] = 255 & Qe, Ie.pending_buf[Ie.pending++] = Qe >>> 8 & 255;
      }
      function Kt(Ie, Qe, Bt) {
        Ie.bi_valid > G - Bt ? (Ie.bi_buf |= Qe << Ie.bi_valid & 65535, $t(Ie, Ie.bi_buf), Ie.bi_buf = Qe >> G - Ie.bi_valid, Ie.bi_valid += Bt - G) : (Ie.bi_buf |= Qe << Ie.bi_valid & 65535, Ie.bi_valid += Bt);
      }
      function At(Ie, Qe, Bt) {
        Kt(Ie, Bt[2 * Qe], Bt[2 * Qe + 1]);
      }
      function Ni(Ie, Qe) {
        for (var Bt = 0; Bt |= 1 & Ie, Ie >>>= 1, Bt <<= 1, 0 < --Qe; )
          ;
        return Bt >>> 1;
      }
      function rn(Ie, Qe, Bt) {
        var dt, et, wt = new Array(ie + 1), Xt = 0;
        for (dt = 1; dt <= ie; dt++)
          wt[dt] = Xt = Xt + Bt[dt - 1] << 1;
        for (et = 0; et <= Qe; et++) {
          var He = Ie[2 * et + 1];
          He !== 0 && (Ie[2 * et] = Ni(wt[He]++, He));
        }
      }
      function ui(Ie) {
        var Qe;
        for (Qe = 0; Qe < Z; Qe++)
          Ie.dyn_ltree[2 * Qe] = 0;
        for (Qe = 0; Qe < M; Qe++)
          Ie.dyn_dtree[2 * Qe] = 0;
        for (Qe = 0; Qe < X; Qe++)
          Ie.bl_tree[2 * Qe] = 0;
        Ie.dyn_ltree[2 * J] = 1, Ie.opt_len = Ie.static_len = 0, Ie.last_lit = Ie.matches = 0;
      }
      function Wt(Ie) {
        8 < Ie.bi_valid ? $t(Ie, Ie.bi_buf) : 0 < Ie.bi_valid && (Ie.pending_buf[Ie.pending++] = Ie.bi_buf), Ie.bi_buf = 0, Ie.bi_valid = 0;
      }
      function Qt(Ie, Qe, Bt, dt) {
        var et = 2 * Qe, wt = 2 * Bt;
        return Ie[et] < Ie[wt] || Ie[et] === Ie[wt] && dt[Qe] <= dt[Bt];
      }
      function ei(Ie, Qe, Bt) {
        for (var dt = Ie.heap[Bt], et = Bt << 1; et <= Ie.heap_len && (et < Ie.heap_len && Qt(Qe, Ie.heap[et + 1], Ie.heap[et], Ie.depth) && et++, !Qt(Qe, dt, Ie.heap[et], Ie.depth)); )
          Ie.heap[Bt] = Ie.heap[et], Bt = et, et <<= 1;
        Ie.heap[Bt] = dt;
      }
      function on(Ie, Qe, Bt) {
        var dt, et, wt, Xt, He = 0;
        if (Ie.last_lit !== 0)
          for (; dt = Ie.pending_buf[Ie.d_buf + 2 * He] << 8 | Ie.pending_buf[Ie.d_buf + 2 * He + 1], et = Ie.pending_buf[Ie.l_buf + He], He++, dt === 0 ? At(Ie, et, Qe) : (At(Ie, (wt = ue[et]) + D + 1, Qe), (Xt = j[wt]) !== 0 && Kt(Ie, et -= yt[wt], Xt), At(Ie, wt = lt(--dt), Bt), (Xt = We[wt]) !== 0 && Kt(Ie, dt -= it[wt], Xt)), He < Ie.last_lit; )
            ;
        At(Ie, J, Qe);
      }
      function tn(Ie, Qe) {
        var Bt, dt, et, wt = Qe.dyn_tree, Xt = Qe.stat_desc.static_tree, He = Qe.stat_desc.has_stree, i = Qe.stat_desc.elems, n = -1;
        for (Ie.heap_len = 0, Ie.heap_max = Y, Bt = 0; Bt < i; Bt++)
          wt[2 * Bt] !== 0 ? (Ie.heap[++Ie.heap_len] = n = Bt, Ie.depth[Bt] = 0) : wt[2 * Bt + 1] = 0;
        for (; Ie.heap_len < 2; )
          wt[2 * (et = Ie.heap[++Ie.heap_len] = n < 2 ? ++n : 0)] = 1, Ie.depth[et] = 0, Ie.opt_len--, He && (Ie.static_len -= Xt[2 * et + 1]);
        for (Qe.max_code = n, Bt = Ie.heap_len >> 1; 1 <= Bt; Bt--)
          ei(Ie, wt, Bt);
        for (et = i; Bt = Ie.heap[1], Ie.heap[1] = Ie.heap[Ie.heap_len--], ei(Ie, wt, 1), dt = Ie.heap[1], Ie.heap[--Ie.heap_max] = Bt, Ie.heap[--Ie.heap_max] = dt, wt[2 * et] = wt[2 * Bt] + wt[2 * dt], Ie.depth[et] = (Ie.depth[Bt] >= Ie.depth[dt] ? Ie.depth[Bt] : Ie.depth[dt]) + 1, wt[2 * Bt + 1] = wt[2 * dt + 1] = et, Ie.heap[1] = et++, ei(Ie, wt, 1), 2 <= Ie.heap_len; )
          ;
        Ie.heap[--Ie.heap_max] = Ie.heap[1], function(s, l) {
          var h, d, m, _, b, x, T = l.dyn_tree, E = l.max_code, L = l.stat_desc.static_tree, A = l.stat_desc.has_stree, U = l.stat_desc.extra_bits, k = l.stat_desc.extra_base, F = l.stat_desc.max_length, B = 0;
          for (_ = 0; _ <= ie; _++)
            s.bl_count[_] = 0;
          for (T[2 * s.heap[s.heap_max] + 1] = 0, h = s.heap_max + 1; h < Y; h++)
            F < (_ = T[2 * T[2 * (d = s.heap[h]) + 1] + 1] + 1) && (_ = F, B++), T[2 * d + 1] = _, E < d || (s.bl_count[_]++, b = 0, k <= d && (b = U[d - k]), x = T[2 * d], s.opt_len += x * (_ + b), A && (s.static_len += x * (L[2 * d + 1] + b)));
          if (B !== 0) {
            do {
              for (_ = F - 1; s.bl_count[_] === 0; )
                _--;
              s.bl_count[_]--, s.bl_count[_ + 1] += 2, s.bl_count[F]--, B -= 2;
            } while (0 < B);
            for (_ = F; _ !== 0; _--)
              for (d = s.bl_count[_]; d !== 0; )
                E < (m = s.heap[--h]) || (T[2 * m + 1] !== _ && (s.opt_len += (_ - T[2 * m + 1]) * T[2 * m], T[2 * m + 1] = _), d--);
          }
        }(Ie, Qe), rn(wt, n, Ie.bl_count);
      }
      function pe(Ie, Qe, Bt) {
        var dt, et, wt = -1, Xt = Qe[1], He = 0, i = 7, n = 4;
        for (Xt === 0 && (i = 138, n = 3), Qe[2 * (Bt + 1) + 1] = 65535, dt = 0; dt <= Bt; dt++)
          et = Xt, Xt = Qe[2 * (dt + 1) + 1], ++He < i && et === Xt || (He < n ? Ie.bl_tree[2 * et] += He : et !== 0 ? (et !== wt && Ie.bl_tree[2 * et]++, Ie.bl_tree[2 * he]++) : He <= 10 ? Ie.bl_tree[2 * ve]++ : Ie.bl_tree[2 * K]++, wt = et, n = (He = 0) === Xt ? (i = 138, 3) : et === Xt ? (i = 6, 3) : (i = 7, 4));
      }
      function Tt(Ie, Qe, Bt) {
        var dt, et, wt = -1, Xt = Qe[1], He = 0, i = 7, n = 4;
        for (Xt === 0 && (i = 138, n = 3), dt = 0; dt <= Bt; dt++)
          if (et = Xt, Xt = Qe[2 * (dt + 1) + 1], !(++He < i && et === Xt)) {
            if (He < n)
              for (; At(Ie, et, Ie.bl_tree), --He != 0; )
                ;
            else
              et !== 0 ? (et !== wt && (At(Ie, et, Ie.bl_tree), He--), At(Ie, he, Ie.bl_tree), Kt(Ie, He - 3, 2)) : He <= 10 ? (At(Ie, ve, Ie.bl_tree), Kt(Ie, He - 3, 3)) : (At(Ie, K, Ie.bl_tree), Kt(Ie, He - 11, 7));
            wt = et, n = (He = 0) === Xt ? (i = 138, 3) : et === Xt ? (i = 6, 3) : (i = 7, 4);
          }
      }
      v(it);
      var xt = !1;
      function Re(Ie, Qe, Bt, dt) {
        Kt(Ie, (S << 1) + (dt ? 1 : 0), 3), function(et, wt, Xt, He) {
          Wt(et), He && ($t(et, Xt), $t(et, ~Xt)), a.arraySet(et.pending_buf, et.window, wt, Xt, et.pending), et.pending += Xt;
        }(Ie, Qe, Bt, !0);
      }
      o._tr_init = function(Ie) {
        xt || (function() {
          var Qe, Bt, dt, et, wt, Xt = new Array(ie + 1);
          for (et = dt = 0; et < I - 1; et++)
            for (yt[et] = dt, Qe = 0; Qe < 1 << j[et]; Qe++)
              ue[dt++] = et;
          for (ue[dt - 1] = et, et = wt = 0; et < 16; et++)
            for (it[et] = wt, Qe = 0; Qe < 1 << We[et]; Qe++)
              Xe[wt++] = et;
          for (wt >>= 7; et < M; et++)
            for (it[et] = wt << 7, Qe = 0; Qe < 1 << We[et] - 7; Qe++)
              Xe[256 + wt++] = et;
          for (Bt = 0; Bt <= ie; Bt++)
            Xt[Bt] = 0;
          for (Qe = 0; Qe <= 143; )
            Lt[2 * Qe + 1] = 8, Qe++, Xt[8]++;
          for (; Qe <= 255; )
            Lt[2 * Qe + 1] = 9, Qe++, Xt[9]++;
          for (; Qe <= 279; )
            Lt[2 * Qe + 1] = 7, Qe++, Xt[7]++;
          for (; Qe <= 287; )
            Lt[2 * Qe + 1] = 8, Qe++, Xt[8]++;
          for (rn(Lt, Z + 1, Xt), Qe = 0; Qe < M; Qe++)
            Be[2 * Qe + 1] = 5, Be[2 * Qe] = Ni(Qe, 5);
          Ue = new Zt(Lt, j, D + 1, Z, ie), ot = new Zt(Be, We, 0, M, ie), Gt = new Zt(new Array(0), ke, 0, X, te);
        }(), xt = !0), Ie.l_desc = new ct(Ie.dyn_ltree, Ue), Ie.d_desc = new ct(Ie.dyn_dtree, ot), Ie.bl_desc = new ct(Ie.bl_tree, Gt), Ie.bi_buf = 0, Ie.bi_valid = 0, ui(Ie);
      }, o._tr_stored_block = Re, o._tr_flush_block = function(Ie, Qe, Bt, dt) {
        var et, wt, Xt = 0;
        0 < Ie.level ? (Ie.strm.data_type === 2 && (Ie.strm.data_type = function(He) {
          var i, n = 4093624447;
          for (i = 0; i <= 31; i++, n >>>= 1)
            if (1 & n && He.dyn_ltree[2 * i] !== 0)
              return u;
          if (He.dyn_ltree[18] !== 0 || He.dyn_ltree[20] !== 0 || He.dyn_ltree[26] !== 0)
            return f;
          for (i = 32; i < D; i++)
            if (He.dyn_ltree[2 * i] !== 0)
              return f;
          return u;
        }(Ie)), tn(Ie, Ie.l_desc), tn(Ie, Ie.d_desc), Xt = function(He) {
          var i;
          for (pe(He, He.dyn_ltree, He.l_desc.max_code), pe(He, He.dyn_dtree, He.d_desc.max_code), tn(He, He.bl_desc), i = X - 1; 3 <= i && He.bl_tree[2 * $e[i] + 1] === 0; i--)
            ;
          return He.opt_len += 3 * (i + 1) + 5 + 5 + 4, i;
        }(Ie), et = Ie.opt_len + 3 + 7 >>> 3, (wt = Ie.static_len + 3 + 7 >>> 3) <= et && (et = wt)) : et = wt = Bt + 5, Bt + 4 <= et && Qe !== -1 ? Re(Ie, Qe, Bt, dt) : Ie.strategy === 4 || wt === et ? (Kt(Ie, 2 + (dt ? 1 : 0), 3), on(Ie, Lt, Be)) : (Kt(Ie, 4 + (dt ? 1 : 0), 3), function(He, i, n, s) {
          var l;
          for (Kt(He, i - 257, 5), Kt(He, n - 1, 5), Kt(He, s - 4, 4), l = 0; l < s; l++)
            Kt(He, He.bl_tree[2 * $e[l] + 1], 3);
          Tt(He, He.dyn_ltree, i - 1), Tt(He, He.dyn_dtree, n - 1);
        }(Ie, Ie.l_desc.max_code + 1, Ie.d_desc.max_code + 1, Xt + 1), on(Ie, Ie.dyn_ltree, Ie.dyn_dtree)), ui(Ie), dt && Wt(Ie);
      }, o._tr_tally = function(Ie, Qe, Bt) {
        return Ie.pending_buf[Ie.d_buf + 2 * Ie.last_lit] = Qe >>> 8 & 255, Ie.pending_buf[Ie.d_buf + 2 * Ie.last_lit + 1] = 255 & Qe, Ie.pending_buf[Ie.l_buf + Ie.last_lit] = 255 & Bt, Ie.last_lit++, Qe === 0 ? Ie.dyn_ltree[2 * Bt]++ : (Ie.matches++, Qe--, Ie.dyn_ltree[2 * (ue[Bt] + D + 1)]++, Ie.dyn_dtree[2 * lt(Qe)]++), Ie.last_lit === Ie.lit_bufsize - 1;
      }, o._tr_align = function(Ie) {
        Kt(Ie, 2, 3), At(Ie, J, Lt), function(Qe) {
          Qe.bi_valid === 16 ? ($t(Qe, Qe.bi_buf), Qe.bi_buf = 0, Qe.bi_valid = 0) : 8 <= Qe.bi_valid && (Qe.pending_buf[Qe.pending++] = 255 & Qe.bi_buf, Qe.bi_buf >>= 8, Qe.bi_valid -= 8);
        }(Ie);
      };
    }, { "../utils/common": 41 }], 53: [function(t, r, o) {
      r.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(t, r, o) {
      (function(a) {
        (function(u, f) {
          if (!u.setImmediate) {
            var v, S, I, D, Z = 1, M = {}, X = !1, Y = u.document, ie = Object.getPrototypeOf && Object.getPrototypeOf(u);
            ie = ie && ie.setTimeout ? ie : u, v = {}.toString.call(u.process) === "[object process]" ? function(he) {
              process.nextTick(function() {
                te(he);
              });
            } : function() {
              if (u.postMessage && !u.importScripts) {
                var he = !0, ve = u.onmessage;
                return u.onmessage = function() {
                  he = !1;
                }, u.postMessage("", "*"), u.onmessage = ve, he;
              }
            }() ? (D = "setImmediate$" + Math.random() + "$", u.addEventListener ? u.addEventListener("message", J, !1) : u.attachEvent("onmessage", J), function(he) {
              u.postMessage(D + he, "*");
            }) : u.MessageChannel ? ((I = new MessageChannel()).port1.onmessage = function(he) {
              te(he.data);
            }, function(he) {
              I.port2.postMessage(he);
            }) : Y && "onreadystatechange" in Y.createElement("script") ? (S = Y.documentElement, function(he) {
              var ve = Y.createElement("script");
              ve.onreadystatechange = function() {
                te(he), ve.onreadystatechange = null, S.removeChild(ve), ve = null;
              }, S.appendChild(ve);
            }) : function(he) {
              setTimeout(te, 0, he);
            }, ie.setImmediate = function(he) {
              typeof he != "function" && (he = new Function("" + he));
              for (var ve = new Array(arguments.length - 1), K = 0; K < ve.length; K++)
                ve[K] = arguments[K + 1];
              var j = { callback: he, args: ve };
              return M[Z] = j, v(Z), Z++;
            }, ie.clearImmediate = G;
          }
          function G(he) {
            delete M[he];
          }
          function te(he) {
            if (X)
              setTimeout(te, 0, he);
            else {
              var ve = M[he];
              if (ve) {
                X = !0;
                try {
                  (function(K) {
                    var j = K.callback, We = K.args;
                    switch (We.length) {
                      case 0:
                        j();
                        break;
                      case 1:
                        j(We[0]);
                        break;
                      case 2:
                        j(We[0], We[1]);
                        break;
                      case 3:
                        j(We[0], We[1], We[2]);
                        break;
                      default:
                        j.apply(f, We);
                    }
                  })(ve);
                } finally {
                  G(he), X = !1;
                }
              }
            }
          }
          function J(he) {
            he.source === u && typeof he.data == "string" && he.data.indexOf(D) === 0 && te(+he.data.slice(D.length));
          }
        })(typeof self > "u" ? a === void 0 ? this : a : self);
      }).call(this, typeof Kr < "u" ? Kr : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(xd);
var sx = xd.exports;
const Ef = /* @__PURE__ */ iu(sx), wd = class Sn {
  constructor(e) {
    this._hemiLight = null, this._pointLight = null, this._onPrePointerObservableObserver = null, this._isPointerDown = !1, this._radiusScale = 0.85, this._positionScale = 0.5, this._limitLowerRadius = !0, this._zoomEnabled = !0, this._minZoomPerc = null, this._maxZoomPerc = null, this._cameraZoom = null, this._cameraPivot = null, this._resizableCanvas3DGenerator = new zy(), this.parentNode = null, this.enableShadows = !1, this.areShadowVisible = !0, this.setInitialZoomToBoundingBox = !0, this.changeRotationDirection = !1, this.initialZoomToBBInertiaDamping = 0.68, this._initialZoomToBBModelSizeRadius = 0.7, this.initialZoomToBBScrollZoomEnabled = !0, this.initialZoomToBBScrollLowerLimit = 2, this.initialZoomToBBScrollUpperLimit = 2, this.animateIntro = !1, this._defHemiLightID = "f90aba65-3b60-44ac-87f4-1b6441aee44b", this._defPointLightID = "b6491635-c471-45a4-bbb8-3f08556e5b3c", this._targetAnimationID = "6225769c-0113-4236-ab17-c39d24013de4", this._radiusAnimationID = "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d", this._alphaAnimationID = "10713520-fe06-4cbf-bc6a-bab881d516e6", this._betaAnimationID = "6096ba34-852a-4423-bab3-dc97c1a9268f", this._dummyMaterialID = "081796b8-0908-44dc-a38a-d786b14cA6fc", this._loadingMaterials = {}, this.getVTOMeshes = () => {
      const t = [
        "vto_reference",
        "ground",
        "shadowGround",
        "shadow",
        "skybox",
        "environment",
        "axes",
        "grid",
        "boundingbox",
        "highlight",
        "EditControl",
        "guideCtl",
        "bxAxis",
        "byAxis",
        "bzAxis",
        "xAxis",
        "yAxis",
        "zAxis",
        "pALL",
        "pXZ",
        "pZY",
        "pYX",
        "pickPlanes",
        "tarnsCtl",
        "X",
        "Y",
        "Z",
        "XZ",
        "ZY",
        "YX",
        "ALL",
        "tEndX",
        "tEndY",
        "tEndZ",
        "XZ",
        "ZY",
        "YX",
        "tEndAll"
      ], r = (f) => t.filter((v) => f.toLowerCase() === v.toLowerCase()).length > 0, o = (f) => f.toLowerCase().includes("vto_reference"), a = this._scene.meshes.filter((f) => o(f.name)), u = this._scene.meshes.filter((f) => !r(f.name) && !o(f.name));
      return {
        tryonReferencesModels: a,
        userMeshes: u
      };
    }, this._loadedMeshes = [], this._isLoading = !1, this._lastVisibilityStates = /* @__PURE__ */ new Map(), this._scene = e, this._engine = e.getEngine(), this._camera = e.activeCamera, this._canvas = e.getEngine().getRenderingCanvas(), this.init();
  }
  get initialZoomToBBModelSizeRadius() {
    return console.log("Getting initialZoomToBBModelSizeRadius: ", this._initialZoomToBBModelSizeRadius), this._initialZoomToBBModelSizeRadius;
  }
  set initialZoomToBBModelSizeRadius(e) {
    console.log("Setting initialZoomToBBModelSizeRadius to: ", e), this._initialZoomToBBModelSizeRadius = e;
  }
  get camera() {
    return this._camera;
  }
  static checkAllMaterialTextureReady(e) {
    const t = e.getActiveTextures();
    for (let r = 0; r < t.length; r++) {
      const o = t[r];
      if (o.isReady())
        o instanceof BABYLON.ProceduralTexture && o.getEffect();
      else
        return !1;
    }
    return !0;
  }
  removeDefaultBackground(e) {
    e && (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0));
  }
  setUpSceneToneMapping(e) {
    var u, f, v, S;
    const t = (u = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : u.get("toneMappingEnabled");
    t != null && (this._scene.imageProcessingConfiguration.toneMappingEnabled = t);
    const r = (f = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : f.get("toneMappingType");
    r != null && (this._scene.imageProcessingConfiguration.toneMappingType = r);
    const o = (v = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : v.get("exposure"), a = (S = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : S.get("contrast");
    a && (this._scene.imageProcessingConfiguration.contrast = a), o && (this._scene.imageProcessingConfiguration.exposure = o);
  }
  static whenAllMaterialTexturesAreReady(e) {
    return new Promise((t, r) => {
      if (this.checkAllMaterialTextureReady(e))
        t();
      else {
        let o = setInterval(() => {
          this.checkAllMaterialTextureReady(e) && (clearInterval(o), t());
        }, 5);
      }
    });
  }
  static whenTextureIsReadyAsync(e) {
    return new Promise((t, r) => {
      if (e.isReady())
        t();
      else {
        let o = setInterval(() => {
          e.isReady() && (clearInterval(o), e instanceof BABYLON.ProceduralTexture && e.getEffect(), t());
        }, 5);
      }
    });
  }
  static whenMeshMaterialIsReady(e) {
    return new Promise((t, r) => {
      let o = setInterval(() => {
        (!e.material || e.material.isReady(e)) && (clearInterval(o), t());
      }, 5);
    });
  }
  static whenMaterialIsReadyForSubMeshAsync(e, t, r) {
    return new Promise((o, a) => {
      if (e.isReadyForSubMesh(t, r))
        Logger.info(`Material ${e.name} ready`), o();
      else {
        Logger.info(`Material ${e.name} NOT ready`);
        let u = setInterval(() => {
          e.isReadyForSubMesh(t, r) && (!t.material || t.material != e || t.material.isReady(t)) && (Logger.info(`Material ${e.name} ready`), clearInterval(u), o());
        }, 5);
      }
    });
  }
  static getMeshGeometry(e) {
    if (e.geometry)
      return e.geometry;
    const r = e.getScene().getGeometries();
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      if (a.meshes.find((u) => u === e))
        return a;
    }
    return null;
  }
  static checkMeshIsReady(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e._checkDelayState(), e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)
        return !1;
      if (!e.geometry) {
        const r = e.getScene().getGeometries();
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          if (a.meshes.find((u) => u === e) && !a.isReady())
            return !1;
        }
      }
      if (e.geometry && !e.geometry.isReady())
        return !1;
      for (let t = 0; t < e.getChildMeshes().length; t++) {
        const r = e.getChildMeshes()[t];
        if (!this.checkMeshIsReady(r))
          return !1;
      }
    }
    return e.isReady(!0);
  }
  static checkAllMeshesAreReady(e) {
    let t = !0;
    for (let r = 0; r < e.length; r++)
      this.checkMeshIsReady(e[r]) || (t = !1);
    return t;
  }
  static whenAllMeshesAreReadyAsync(e) {
    return new Promise((t, r) => {
      if (this.checkAllMeshesAreReady(e))
        t();
      else {
        let o = setInterval(() => {
          this.checkAllMeshesAreReady(e) && (clearInterval(o), t());
        }, 5);
      }
    });
  }
  static async whenAllVisibleMeshesAreReadyAsync(e) {
    await this.whenAllMeshesAreReadyAsync(e);
  }
  static whenMeshIsReadyAsync(e) {
    return new Promise((t, r) => {
      if (this.checkMeshIsReady(e))
        t();
      else {
        let o = setInterval(() => {
          this.checkMeshIsReady(e) && (clearInterval(o), t());
        }, 100);
      }
    });
  }
  static visibleMeshesRequireDelayedLoading(e) {
    const t = e.meshes.filter((r) => r.isVisible);
    for (let r = 0; r < t.length; r++)
      if (this.meshRequiresDelayedLoading(t[r]))
        return !0;
    return !1;
  }
  static meshRequiresDelayedLoading(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED || e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING)
        return !0;
      const t = Sn.getMeshGeometry(e);
      if (t && (t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING || t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED))
        return !0;
    }
    return !1;
  }
  materialRequiresDelayedLoading(e) {
    return this._scene.getMaterialByID(e) ? !1 : !!(this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) || this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e));
  }
  init() {
    this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add((e) => {
      if (e.type === BABYLON.PointerEventTypes.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      e.type === BABYLON.PointerEventTypes.POINTERUP && (this._isPointerDown = !1);
    });
  }
  dispose() {
    this._scene && this._onPrePointerObservableObserver && this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
  }
  switchFullScreen(e) {
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement ? this.quitFullscreen(e || this._canvas) : this.launchFullscreen(e || this._canvas), this._canvas && (this._canvas.width = document.body.clientWidth, this._canvas.height = document.body.clientHeight, this.adjustCamera(void 0, !0, !0, !1));
  }
  quitFullscreen(e) {
    let t = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
    t && t.call(document);
  }
  launchFullscreen(e) {
    let t = e.requestFullscreen || e.webkitRequestFullscreen || e.msRequestFullscreen || e.mozRequestFullScreen;
    t && t.call(e);
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    const t = e.getHierarchyBoundingVectors(!0), r = t.max.subtract(t.min);
    return t.min.add(r.scale(0.5));
  }
  getSceneBoundingInfo() {
    if (!this._scene)
      return null;
    const e = this.getWorldExtends();
    return e ? new BABYLON.BoundingInfo(e.min, e.max) : null;
  }
  setupShadows(e) {
    var ve, K, j, We, ke, $e, Lt, Be, Xe, ue, yt, Ue, ot, Gt, it, Zt, ct;
    if (!e)
      return;
    const t = (ve = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ve.get("enableShadows");
    t != null && (this.enableShadows = t), this.areShadowVisible || (this.enableShadows = !1);
    const r = (K = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : K.get("shadowMapSize"), o = (j = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : j.get("contactHardeningUVRatio"), a = (We = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : We.get("useContactHardeningShadow"), u = (ke = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ke.get("useBlurCloseExponentialShadowMap"), f = ($e = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : $e.get("usePercentageCloserFiltering"), v = (Lt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Lt.get("usePoissonSampling"), S = (Be = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Be.get("useKernelBlur"), I = (Xe = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Xe.get("blurBoxOffset"), D = (ue = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ue.get("blurScale"), Z = (yt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : yt.get("blurKernel"), M = (Ue = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ue.get("depthScale"), X = (ot = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ot.get("shadowDarkness"), Y = (Gt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Gt.get("shadowMinZ"), ie = (it = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : it.get("shadowMaxZ");
    if (!this.enableShadows) {
      const lt = (Zt = this._scene) == null ? void 0 : Zt.getMeshByName("shadowGround");
      lt && lt.dispose();
      const $t = (ct = this._scene) == null ? void 0 : ct.getMaterialByName("shadowMaterial");
      $t && $t.dispose();
      const Kt = this._scene.getLightByName("shadowDirectionalLight");
      Kt && Kt.dispose();
      return;
    }
    if (!this._scene)
      throw new Error("Scene is not defined");
    const G = this._scene.getLightByName("shadowDirectionalLight"), te = new BABYLON.Vector3(0, -2, 0), J = G ?? new BABYLON.DirectionalLight("shadowDirectionalLight", te, this._scene);
    J.intensity = 0, J.shadowMinZ = Y ?? void 0, J.shadowMaxZ = ie ?? void 0, Sn._shadowGenerator = new BABYLON.ShadowGenerator(Number(r), J), Sn._shadowGenerator.usePoissonSampling = !!v, Sn._shadowGenerator.usePercentageCloserFiltering = !!f, Sn._shadowGenerator.useBlurCloseExponentialShadowMap = !!u, Sn._shadowGenerator.useKernelBlur = !!S, Sn._shadowGenerator.blurBoxOffset = Number(I), Sn._shadowGenerator.blurScale = Number(D), Sn._shadowGenerator.blurKernel = Number(Z), Sn._shadowGenerator.depthScale = Number(M), Sn._shadowGenerator.setDarkness(Number(X)), Sn._shadowGenerator.useContactHardeningShadow = !!a, Sn._shadowGenerator.contactHardeningLightSizeUVRatio = Number(o), Sn._shadowGenerator.transparencyShadow = !0, Sn._shadowGenerator.enableSoftTransparentShadow = !0;
    const he = Sn._shadowGenerator.getShadowMap();
    this._scene.meshes.forEach((lt) => {
      var $t;
      ($t = he == null ? void 0 : he.renderList) == null || $t.push(lt);
    }), this.createGroundFromBoundingBox(e);
  }
  setShadowsVisibility(e) {
    Sn._shadowGenerator && (this.areShadowVisible = e);
  }
  stopAllAnimations() {
    this._scene && this._scene.stopAllAnimations();
  }
  hasAnimations() {
    return this._scene ? this._scene.animationGroups.length > 0 : !1;
  }
  playAnimations() {
    if (this._scene && this.hasAnimations()) {
      const e = this._scene.animationGroups[0];
      e.start(!0, 1, e.from, e.to, !1);
    }
  }
  setupAnimations(e) {
    var v;
    const t = e == null ? void 0 : e.getAnimationsConfig(), r = !!(t != null && t.get("runAtStart")), o = !!(t != null && t.get("loop")), a = (t == null ? void 0 : t.get("speed")) || 1, u = (v = this._scene) == null ? void 0 : v.animationGroups, f = u && this._scene.animationGroups.length > 0;
    if (u && u.forEach((S) => {
      S.stop(), S.reset();
    }), r && f) {
      const S = u[0];
      S.start(o, a, S.from, S.to, !1);
    }
  }
  createGroundFromBoundingBox(e) {
    var M, X, Y, ie, G, te, J, he, ve;
    if (!e)
      return;
    const t = (M = this._scene) == null ? void 0 : M.getMeshByName("shadowGround");
    t && t.dispose();
    const r = (X = this._scene) == null ? void 0 : X.getMaterialByName("shadowMaterial");
    r && r.dispose();
    const o = (Y = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Y.get("enableShadows");
    if (o != null && (this.enableShadows = o), !this.enableShadows) {
      console.log("Shadows are not enabled");
      return;
    }
    const a = this.getSceneBoundingInfo();
    if (!a || !a.boundingBox) {
      console.error("Cannot create ground: No bounding box information available.");
      return;
    }
    const u = (ie = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ie.get("shadowHexColor"), f = (G = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : G.get("groundSizeMultiplierWidth"), v = (te = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : te.get("groundSizeMultiplierLength"), S = a.boundingBox.minimumWorld, D = a.boundingBox.maximumWorld.subtract(S), Z = S.add(D.scale(0.5));
    if (this._scene !== null) {
      const K = BABYLON.MeshBuilder.CreateGround(
        "shadowGround",
        {
          width: D.x * Number(f),
          height: D.z * Number(v)
        },
        this._scene
      );
      K.position = new BABYLON.Vector3(Z.x, S.y, Z.z), K.rotation.y = Math.PI;
      const j = new BABYLON.ShadowOnlyMaterial("bbmat", this._scene);
      K.material = j, K.receiveShadows = !0, K.material.shadowColor = BABYLON.Color3.FromHexString(
        String(u)
      ), K.metadata = { AR: !1, isRealMesh: !1 };
      const We = (J = Sn._shadowGenerator) == null ? void 0 : J.getShadowMap();
      Sn._shadowGenerator && We ? ((he = We.renderList) == null || he.push(K), K.receiveShadows = !0) : console.error("Failed to add ground mesh to shadow map render list.");
    } else
      console.error("Cannot create ground: Scene is null.");
    console.log("Shadow ground created"), (ve = this._scene) == null || ve.render();
  }
  userIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0 || this._isPointerDown;
  }
  cameraIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0;
  }
  cameraLimitsReached() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.lowerRadiusLimit !== void 0 && this._camera.lowerRadiusLimit !== null && this._camera.radius === this._camera.lowerRadiusLimit || this._camera.upperRadiusLimit !== void 0 && this._camera.upperRadiusLimit !== null && this._camera.radius === this._camera.upperRadiusLimit;
  }
  restoreCameraState() {
    this._camera && this._camera.restoreState();
  }
  isTextureWithUrl(e) {
    return e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture);
  }
  getTextureUrl(e) {
    if (e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture)) {
      let t = e.url;
      if (e.getInternalTexture) {
        const r = e.getInternalTexture();
        r && r.url && (t = r.url);
      }
      return t;
    }
    return null;
  }
  isEditControl(e) {
    return e && (e.name == "EditoControl" || e.metadata && e.metadata.isEditControl);
  }
  isRealMesh(e) {
    return !(this.isEditControl(e) || e.metadata && (e.metadata.boundingBox || e.metadata.isAxis || e.metadata.isGround || e.metadata.isEnvironmentNode || e.metadata.hasOwnProperty("isRealMesh") && !e.metadata.isRealMesh));
  }
  meshFineTuningSettings(e) {
    return e.metadata && e.metadata.hasOwnProperty("tryOnFineTuningSettings") && e.metadata.tryOnFineTuningSettings ? e.metadata.tryOnFineTuningSettings : null;
  }
  meshHasParent(e, t) {
    if (this._scene) {
      let r = this._scene.getMeshById(e);
      if (r)
        for (; r.parent; ) {
          if (r.parent.id === t)
            return !0;
          r = r.parent;
        }
    }
    return !1;
  }
  countSceneMeshes() {
    let e = 0;
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e++;
    }), e;
  }
  sceneHasRealMeshes() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      if (this.isRealMesh(this._scene.meshes[e]))
        return !0;
    return !1;
  }
  getSceneMeshes() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e.push(t);
    }), e;
  }
  getSceneMeshesByName(e) {
    let t = [];
    if (this._scene) {
      const o = function(a) {
        return a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      };
      if (e) {
        var r = new RegExp(o(e).replace(/\\\*/g, ".*"), "i");
        for (let a = 0; a < this._scene.meshes.length; a++) {
          const u = this._scene.meshes[a];
          this.isRealMesh(u) && u.name && r.test(u.name) && t.push(u);
        }
      }
    }
    return t;
  }
  isVisibleMesh(e) {
    return this.isRealMesh(e) && e.isVisible;
  }
  getVisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isVisibleMesh(t) && e.push(t);
    }), e;
  }
  getInvisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && !t.isVisible && e.push(t);
    }), e;
  }
  getSubMesh(e, t) {
    return e.subMeshes && e.subMeshes.length > 0 && t >= 0 && t < e.subMeshes.length ? e.subMeshes[t] : null;
  }
  getMeshHierarchy(e) {
    const t = [];
    let r = this._scene.getMeshById(e);
    if (!r)
      return t;
    let o = (a) => {
      t.push(a);
      let u = a.getChildMeshes(!0);
      for (let f = 0; f < u.length; f++)
        o(u[f]);
    };
    return o(r), t;
  }
  getTryOnMeshHierarchy(e) {
    const t = [];
    let r = this._scene.getMeshById(e);
    if (!r)
      return t;
    let o = (a) => {
      t.push(a);
      let u = a.getChildMeshes(!0);
      for (const f of u)
        (this.isVisibleCanvasMesh(f) || this.isVisibleTryOnMesh(f)) && o(f);
    };
    return o(r), t;
  }
  isVisibleCanvasMesh(e) {
    return this.isCanvasMesh(e) && e.isVisible;
  }
  isCanvasMesh(e) {
    return !e || !e.metadata ? !1 : e.metadata.hasOwnProperty("iscanvasMesh") && typeof e.metadata.iscanvasMesh == "boolean" ? e.metadata.iscanvasMesh : !1;
  }
  isAREnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.AR === void 0 || e.metadata.AR === null || typeof e.metadata.AR != "boolean" ? !0 : e.metadata.AR : !1;
  }
  isTryOnEnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.TryOn === void 0 || e.metadata.TryOn === null || typeof e.metadata.TryOn != "boolean" ? !0 : e.metadata.TryOn : !1;
  }
  isVisibleTryOnMesh(e) {
    return this.isTryOnEnabledForMesh(e) && this.isVisibleMesh(e);
  }
  getMeshesForAR() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isAREnabledForMesh(t) && e.push(t);
    }), e;
  }
  checkMaterialsForAR() {
    const e = this.getMeshesMaterials(this.getMeshesForAR());
    for (let t = 0; t < e.length; t++) {
      const r = e[t];
      if (!(r instanceof BABYLON.PBRMaterial) && !(r instanceof BABYLON.PBRMetallicRoughnessMaterial) && !(r instanceof BABYLON.StandardMaterial))
        return !1;
    }
    return !0;
  }
  getMeshesMaterials(e) {
    const t = [], r = [];
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (a.material)
        if (a.material instanceof BABYLON.MultiMaterial)
          for (let u = 0; u < a.material.subMaterials.length; u++) {
            let f = a.material.subMaterials[u];
            f && t.indexOf(f.id) === -1 && (r.push(f), t.push(f.id));
          }
        else
          t.indexOf(a.material.id) === -1 && (r.push(a.material), t.push(a.material.id));
    }
    return r;
  }
  getMeshMaterials(e) {
    const t = [];
    if (e && e.material)
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let r = 0; r < e.material.subMaterials.length; r++) {
          let o = e.material.subMaterials[r];
          o && t.push(o);
        }
      else
        t.push(e.material);
    return t;
  }
  getHiddenMeshTotalVertices() {
    return this.getTotalVertices((e) => !e.isVisible);
  }
  getTotalVertices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((r) => {
      this.isRealMesh(r) && (e && !e(r) || (t += r.getTotalVertices()));
    }), t;
  }
  getHiddenMeshTotalIndices() {
    return this.getTotalIndices((e) => !e.isVisible);
  }
  getTotalIndices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((r) => {
      this.isRealMesh(r) && (e && !e(r) || (t += r.getTotalIndices()));
    }), t;
  }
  getAllMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t.metadata && (t.metadata.isRealMaterial !== void 0 && !t.metadata.isRealMaterial || t.metadata.isEnvironmentNode !== void 0 && t.metadata.isEnvironmentNode) || t.id !== "groundMaterial" && t.id !== "default material" && e.push(t);
    }), e;
  }
  getMeshesUsingMaterial(e) {
    const t = [], r = this.getSceneMeshes();
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      this.isMeshUsingMaterial(a, e) && t.push(a);
    }
    return t;
  }
  isMeshUsingMaterial(e, t) {
    if (e.material) {
      if (e.material.id === t)
        return !0;
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let r = 0; r < e.material.subMaterials.length; r++) {
          const o = e.material.subMaterials[r];
          if (o && o.id === t)
            return !0;
        }
    }
    return !1;
  }
  getAllUnusedMaterials() {
    const e = this.getAllMaterials(), t = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r];
      this.getMeshesUsingMaterial(o.id).length === 0 && t.push(o);
    }
    return t;
  }
  async getSceneScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    let r = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, r, "image/png");
  }
  containsPBRMaterials() {
    if (this._scene) {
      for (let e = 0; e < this._scene.materials.length; e++)
        if (this._scene.materials[e] instanceof BABYLON.PBRBaseMaterial)
          return !0;
    }
    return !1;
  }
  getMeshesForTryOn() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isTryOnEnabledForMesh(t) && e.push(t);
    }), e;
  }
  setupLights() {
    this._hemiLight = null, this._pointLight = null;
    let e = null, t = null;
    this._scene.lights.forEach((r) => {
      r instanceof BABYLON.HemisphericLight && (e === null && (e = r), r.id === this._defHemiLightID && (this._hemiLight = r)), r instanceof BABYLON.PointLight && (t === null && (t = r), r.id === this._defPointLightID && (this._pointLight = r));
    }), this._hemiLight === null && (e !== null ? this._hemiLight = e : (this._hemiLight = new BABYLON.HemisphericLight(
      "Default Hemispheric Light",
      BABYLON.Vector3.Up(),
      this._scene
    ), this._hemiLight.intensity = 0.5), this._hemiLight && (this._hemiLight.id = this._defHemiLightID)), this._pointLight === null && (t !== null ? this._pointLight = t : (this._pointLight = new BABYLON.PointLight(
      "Default Point Light",
      new BABYLON.Vector3(0, 5, 0),
      this._scene
    ), this._pointLight.intensity = 0.5), this._pointLight && (this._pointLight.id = this._defPointLightID));
  }
  setUpCustomLights(e) {
    Object.entries(e).forEach((t) => {
      const r = t[0], o = t[1].position, a = t[1].general.intensity, u = t[1].general.visible, f = {
        position: o,
        intensity: a,
        visible: u
      };
      this.createOrUpdateLight(r, f);
    });
  }
  createOrUpdateLight(e, t) {
    const r = this._scene.getLightByName(e);
    if (r && (this._scene.removeLight(r), r.dispose()), !t.visible)
      return;
    const o = new BABYLON.Vector3(t.position.x, t.position.y, t.position.z);
    let a;
    e.match(/directional/i) ? (a = new BABYLON.DirectionalLight(e, o, this._scene), a.intensity = t.intensity, a.id = Zakeke.generateUUID()) : e.match(/pointLight/i) ? (a = new BABYLON.PointLight(e, o, this._scene), a.intensity = t.intensity, a.id = Zakeke.generateUUID()) : e.match(/hemisphere/i) && (a = new BABYLON.HemisphericLight(e, o, this._scene), a.intensity = t.intensity, a.id = Zakeke.generateUUID());
  }
  getDefaultHemisphericLight() {
    return this._hemiLight;
  }
  getDefaultPointLight() {
    return this._pointLight;
  }
  isDefaultLight(e) {
    return e.id == this._defHemiLightID || e.id == this._defPointLightID;
  }
  setUpCameraByOptions(e) {
    if (e && this._scene) {
      let t = this._scene.cameras.find((r) => r instanceof BABYLON.ArcRotateCamera);
      e && t instanceof BABYLON.ArcRotateCamera && (t.beta = e.beta ?? t.beta, t.alpha = e.alpha ?? t.alpha, t.fov = e.fov ?? t.fov);
    }
  }
  setupCamera() {
    if (this._scene) {
      let e = this._scene.cameras.find((t) => t instanceof BABYLON.ArcRotateCamera);
      e ? this._camera = e : (this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene), this._camera.setPosition(new BABYLON.Vector3(0, 3, -8))), this.setupCameraLimits(), this._canvas && this._camera.attachControl(this._canvas, !1);
    }
  }
  setCameraRadiusParameters(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = e * (this._zoomEnabled ? 0.01 : 1), this._camera.upperRadiusLimit = e * (this._zoomEnabled ? 3 : 1), this._camera.wheelPrecision = 100 / e, this._camera.pinchPrecision = 100 / e, this._camera.minZ = e * 0.01, this._camera.maxZ = e * 1e3, this._camera.speed = e * 0.2, this._camera.wheelDeltaPercentage = 0.01, this._camera.pinchDeltaPercentage = 6e-4, this._camera.panningSensibility = 1e-6, this._camera.wheelPrecision = 100 / e, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0, this._camera.radius = e);
  }
  removeCameraLimits() {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = null, this._camera.upperRadiusLimit = null, this._camera.minZ = 1, this._camera.maxZ = 1e4);
  }
  getWorldExtends() {
    return this._scene ? this._scene.getWorldExtends((e) => this.isRealMesh(e) && e.isVisible) : null;
  }
  getCameraWorldExtends() {
    let e = null;
    if (this._scene) {
      let t = this._cameraPivot;
      if (!t)
        for (let r = 0; r < this._scene.meshes.length; r++) {
          const o = this._scene.meshes[r];
          if (o.metadata && o.metadata.isCameraPivot !== void 0 && o.metadata.isCameraPivot) {
            t = o;
            break;
          }
        }
      t && (e = this._scene.getWorldExtends((r) => r === t || this.meshHasParent(r.id, t.id)));
    }
    return e || (e = this.getWorldExtends()), e;
  }
  setupCameraLimits(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      if (e == null) {
        let r = this.getCameraWorldExtends();
        r && (e = r);
      }
      if (!e)
        return;
      const t = e.max.subtract(e.min);
      if (isFinite(t.length())) {
        this.removeCameraLimits();
        const r = this.calculateCameraRadius(e);
        if (this.setCameraRadiusParameters(r), this._limitLowerRadius) {
          if (this._scene.meshes.length && this._zoomEnabled) {
            this._camera.useFramingBehavior = !0;
            const o = this._camera.getBehaviorByName("Framing");
            o && o instanceof BABYLON.FramingBehavior && (o.elevationReturnTime = -1, this._camera.lowerRadiusLimit = null, this._minZoomPerc !== null && this._minZoomPerc !== void 0 && this._minZoomPerc > 0 && (this._camera.lowerRadiusLimit = r * this._minZoomPerc), this._maxZoomPerc !== null && this._maxZoomPerc !== void 0 && this._maxZoomPerc > 0 && (this._camera.upperRadiusLimit = r * this._maxZoomPerc));
          }
        } else
          this._camera.lowerRadiusLimit = null;
      }
    }
  }
  adjustCamera(e, t = !0, r = !0, o = !0, a = !1) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let u = this.getCameraWorldExtends();
    if (!u)
      return;
    const f = u.max.subtract(u.min);
    if (!isFinite(f.length()))
      return;
    const v = u.min.add(f.scale(0.5));
    this.removeCameraLimits();
    const S = this.calculateCameraRadius(u);
    let I = this._camera.alpha;
    t || (I = -(Math.PI / 2), e && e === "gltf" && (I += Math.PI));
    let D = this._camera.beta;
    r || (D = Math.PI / 2 - 0.3);
    let Z = v.clone(), M = u.min.y, X = u.max.y, Y = M + (X - M) * this._positionScale;
    if (Z.y = Y, !o)
      this._camera.alpha = I, this._camera.beta = D, this._camera.radius = S, this._camera.target = Z, this.setupCameraLimits(u);
    else {
      if (a) {
        const ie = this.calculateCameraRadius(u);
        this._camera.radius = ie;
      }
      this.animateCameraToFinalParamters(I, D, S, Z, 2, () => {
        this.setupCameraLimits(u);
      });
    }
  }
  normalizeAngleOfView(e, t) {
    const r = BABYLON.Vector3.Zero(), o = new BABYLON.ArcRotateCamera("ghostCamera", e, t, 1, r, this._scene), a = o.position;
    return o.dispose(), this.computeCameraAngleOfView(r, a);
  }
  computeCameraAngleOfView(e, t) {
    const r = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    r.setPosition(t);
    const o = r.alpha, a = r.beta;
    return r.dispose(), {
      alpha: o,
      beta: a
    };
  }
  moveCamera(e, t) {
    var r = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    r.setPosition(t);
    var o = r.alpha, a = r.beta, u = r.radius;
    r.dispose(), this.moveCameraToFinalParameters(o, a, u, e);
  }
  animateCamera(e, t, r, o) {
    var a = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    a.setPosition(t);
    var u = a.alpha, f = a.beta, v = a.radius;
    a.dispose(), this.animateCameraToFinalParamters(u, f, v, e, r, o);
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, r = Math.floor((e + Math.PI) * (1 / t));
      e -= r * t;
    }
    return e;
  }
  wrap2Pi(e) {
    let t = e % (Math.PI * 2);
    return t < 0 && (t += Math.PI * 2), t;
  }
  zoomIn() {
    this.zoom(0.85);
  }
  zoomOut() {
    this.zoom(1.15);
  }
  zoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let r = this._camera.radius, o = this._camera.lowerRadiusLimit !== null && this._camera.lowerRadiusLimit !== void 0 ? this._camera.lowerRadiusLimit : 0, a = Math.max(0, o), u = Number.MAX_VALUE;
      this._camera.upperRadiusLimit != null && (u = this._camera.upperRadiusLimit);
      var t = Math.max(a, Math.min(u, r * e));
      t !== r && this.animateCameraToFinalParamters(
        this._camera.alpha,
        this._camera.beta,
        t,
        this._camera.target,
        0.5
      );
    }
  }
  moveCameraToFinalParameters(e, t, r, o) {
    !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) || (this._camera.target = o, this._camera.alpha = e, this._camera.beta = t, this._camera.radius = r);
  }
  animateCameraToFinalParamters(e, t, r, o, a, u) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let f = this._camera.radius, v = () => {
      if (this._camera) {
        this._scene.stopAnimation(this._camera);
        for (let Be = 0; Be < this._camera.animations.length; Be++)
          this._camera.animations[Be], this._camera.animations.splice(Be--, 1);
      }
    };
    v();
    let S = this._camera.alpha;
    !this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit && (S = this.wrap2Pi(this._camera.alpha));
    let I = this._camera.beta;
    !this._camera.lowerBetaLimit && !this._camera.upperBetaLimit && (I = this.wrap2Pi(this._camera.beta));
    let D = isFinite(e) ? this.wrapPi(e) : S;
    Math.abs(S - D) > Math.PI && (D += Math.PI * 2);
    let Z = isFinite(t) ? this.wrapPi(t) : I;
    Math.abs(I - Z) > Math.PI && (Z += Math.PI * 2);
    let M = 2;
    a && typeof a == "number" && a > 0 && (M = a);
    let X = 60, Y = Math.floor(M * X), te = this._camera.target.subtract(o).length() / this._camera.radius, J = [], he = new BABYLON.CubicEase();
    he.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    let ve = null;
    this._camera.target !== o && (te >= 5e-3 ? (ve = new BABYLON.Animation(
      "camTargetAnimation",
      "target",
      X,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: this._camera.target
      },
      {
        frame: Y,
        value: o
      }
    ], ve.setKeys(J), ve.setEasingFunction(he)) : this._camera.target = o);
    let K = null;
    S !== D && (K = new BABYLON.Animation(
      "camAlphaAnimation",
      "alpha",
      X,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: S
      },
      {
        frame: Y,
        value: D
      }
    ], K.setKeys(J), K.setEasingFunction(he));
    let j = null;
    I !== Z && (j = new BABYLON.Animation(
      "camBetaAnimation",
      "beta",
      X,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: I
      },
      {
        frame: Y,
        value: Z
      }
    ], j.setKeys(J), j.setEasingFunction(he));
    let We = Math.abs(this._camera.radius - r) / this._camera.radius, ke = null;
    this._camera.radius !== r && (We >= 5e-3 ? (ke = new BABYLON.Animation(
      "camRadiusAnimation",
      "radius",
      X,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: f
      },
      {
        frame: Y,
        value: r
      }
    ], ke.setKeys(J), ke.setEasingFunction(he)) : this._camera.radius = r);
    let $e = this._camera.animations.length;
    if (ve && this._camera.animations.push(ve), K && this._camera.animations.push(K), j && this._camera.animations.push(j), ke && this._camera.animations.push(ke), this._camera.animations.length > $e) {
      var Lt = this._scene.beginAnimation(this._camera, 0, Y, !1, 1);
      Lt.onAnimationEnd = () => {
        v(), this.setupShaderMaterialsCameraPosition(), u && u();
      };
    } else
      u && u();
  }
  //Returns the frustum slope based on the canvas ratio and camera FOV
  //returns The frustum slope represented as a Vector2 with X and Y slopes
  getFrustumSlope() {
    let e = this._camera;
    if (!e)
      return BABYLON.Vector2.Zero();
    let r = this._engine.getAspectRatio(e), o = Math.tan(e.fov / 2), a = o * r;
    return new BABYLON.Vector2(a, o);
  }
  calculateCameraRadius(e) {
    if (e == null) {
      let r = this.getCameraWorldExtends();
      r && (e = r);
    }
    if (!e)
      return 1;
    var t = this.calculateLowerRadiusFromModelBoundingSphere(e.min, e.max);
    return isFinite(t) || (t = 1), t + (this._cameraZoom ?? 0);
  }
  // Calculates the lowest radius for the camera based on the bounding box of the mesh.
  calculateLowerRadiusFromModelBoundingSphere(e, t) {
    const o = t.subtract(e).length(), a = this.getFrustumSlope(), u = o * 0.5, f = this._radiusScale, v = u * f, S = v * Math.sqrt(1 + 1 / (a.x * a.x)), I = v * Math.sqrt(1 + 1 / (a.y * a.y));
    let D = Math.max(S, I);
    var Z = this._camera;
    return !Z || !(Z instanceof BABYLON.ArcRotateCamera) ? 0 : (Z.upperRadiusLimit && (D = D > Z.upperRadiusLimit ? Z.upperRadiusLimit : D), D);
  }
  getWorldCenter(e) {
    if (e == null) {
      let o = this.getCameraWorldExtends();
      o && (e = o);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraWorldCenter(e) {
    if (e == null) {
      let o = this.getCameraWorldExtends();
      o && (e = o);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraRadius(e) {
    if (e == null) {
      let o = this.getCameraWorldExtends();
      o && (e = o);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? this.calculateCameraRadius(e) : null;
  }
  setCameraLimitLowerRadius(e, t = !1) {
    if (this._limitLowerRadius = e, this.setupCameraLimits(), t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      let r = this._camera.target.clone(), o = this.getCameraWorldExtends();
      if (o) {
        let a = o.min.y, u = o.max.y, f = a + (u - a) * this._positionScale;
        r.y = f, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          r,
          0.5
        );
      }
    }
  }
  setCameraPositionScale(e, t = !1) {
    if (this._positionScale = e, t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      var r = this._camera.target.clone(), o = this.getCameraWorldExtends();
      if (o) {
        var a = o.min.y, u = o.max.y, f = a + (u - a) * this._positionScale;
        r.y = f, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          r,
          0.5
        );
      }
    }
  }
  getCameraPivot() {
    return this._cameraPivot;
  }
  setCameraPivot(e) {
    this._cameraPivot = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setZoomEnabled(e) {
    this._zoomEnabled = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setMinZoomPerc(e) {
    const t = e ?? null;
    t !== this._minZoomPerc && (this._minZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setMaxZoomPerc(e) {
    const t = e ?? null;
    t !== this._maxZoomPerc && (this._maxZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraZoom(e) {
    e != null && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._cameraZoom = -(e / 10), this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraAlphaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const r = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
      this.setCameraLowerAlphaLimit(e), this.setCameraUpperAlphaLimit(t), this._camera.alpha = r;
    }
  }
  setCameraLowerAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.upperAlphaLimit && t > this._camera.upperAlphaLimit && (this._camera.upperAlphaLimit += Math.PI * 2), this._camera.lowerAlphaLimit = t;
      }
  }
  setCameraUpperAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.lowerAlphaLimit && t < this._camera.lowerAlphaLimit && (t += Math.PI * 2), this._camera.upperAlphaLimit = t;
      }
  }
  setCameraLowerBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerBetaLimit = 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.upperBetaLimit && t > this._camera.upperBetaLimit && (this._camera.upperBetaLimit += Math.PI * 2), this._camera.lowerBetaLimit = t;
      }
  }
  setCameraUpperBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperBetaLimit = Math.PI - 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.lowerBetaLimit && t < this._camera.lowerBetaLimit && (this._camera.lowerBetaLimit -= Math.PI * 2), this._camera.upperBetaLimit = t;
      }
  }
  setCameraBetaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const r = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
      this.setCameraLowerBetaLimit(e), this.setCameraUpperBetaLimit(t), this._camera.beta = r;
    }
  }
  zoomOnMesh(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.useFramingBehavior = !0;
      const t = this._camera.getBehaviorByName("Framing");
      t && t instanceof BABYLON.FramingBehavior && (t.framingTime = 0, t.elevationReturnTime = -1, t.radiusScale = this._radiusScale, t.positionScale = this._positionScale, t.zoomOnMeshHierarchy(e));
    }
  }
  async takeScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    const r = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, r, "image/png");
  }
  async takeContentScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    var r = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._scene.render();
    let o = { width: e, height: t };
    const a = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, o, "image/png");
    this._scene.render(), this._scene.getEngine().endFrame();
    const u = await a;
    return this._scene.clearColor = r, u;
  }
  async takeMaterialScreenshotAsync(e, t, r) {
    let o = this._scene.getMaterialByID(e);
    if (!o)
      return "";
    let a = this.getVisibleMeshes();
    for (let Z = 0; Z < a.length; Z++) {
      var u = a[Z];
      u.isVisible = !1;
    }
    let f = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
    let v = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
    v.material = o;
    let S = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
    S.setPosition(new BABYLON.Vector3(0, 0, -4)), this._scene.activeCamera = S, this._scene.render();
    let I = { width: t, height: r }, D = await BABYLON.Tools.CreateScreenshotAsync(this._engine, S, I, "image/png");
    this._scene.clearColor = f, v.dispose();
    for (let Z = 0; Z < a.length; Z++) {
      var u = a[Z];
      u.isVisible = !0;
    }
    return this._scene.activeCamera = this._camera, S.dispose(), D;
  }
  getScenePBRMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t instanceof BABYLON.PBRBaseMaterial && e.push(t);
    }), e;
  }
  resetPBRMaterialsImageProcessingConfiguration() {
    var e = this.getScenePBRMaterials();
    e.forEach((t) => {
      this.adjustPBRMaterialImageProcessingConfiguration(t);
    });
  }
  adjustPBRMaterialImageProcessingConfiguration(e) {
    e instanceof BABYLON.PBRMaterial && e.imageProcessingConfiguration && (e.imageProcessingConfiguration.colorGradingWithGreenDepth = !1, e.imageProcessingConfiguration.colorGradingBGR = !1, e.imageProcessingConfiguration.exposure = 1, e.imageProcessingConfiguration.toneMappingEnabled = !1, e.imageProcessingConfiguration.contrast = 1);
  }
  animateMeshToFinalParameters(e, t, r, o, a, u = 2, f) {
    if (this._scene && e) {
      e.id;
      const I = () => {
        this._scene.stopAnimation(e);
        for (let he = 0; he < e.animations.length; he++)
          e.animations.splice(he--, 1);
      };
      I();
      const D = u, Z = 60, M = Math.floor(D * Z);
      let X, Y = null;
      e.position !== t && (Y = new BABYLON.Animation(
        "positionAnimation",
        "position",
        Z,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), X = [
        {
          frame: 0,
          value: e.position
        },
        {
          frame: M,
          value: t
        }
      ], Y.setKeys(X));
      let ie = null, G = null;
      if (e.rotationQuaternion == null) {
        var v;
        r != null ? v = r.clone() : v = o.toEulerAngles().clone(), e.rotation != v && (ie = new BABYLON.Animation(
          "eulerAnimation",
          "rotation",
          Z,
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), X = [
          {
            frame: 0,
            value: e.rotation
          },
          {
            frame: M,
            value: v
          }
        ], ie.setKeys(X));
      } else {
        let he;
        o != null ? he = o.clone() : (he = BABYLON.Quaternion.Identity(), he.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(r.y, r.x, r.z))), G = new BABYLON.Animation(
          "quaternionAnimation",
          "rotationQuaternion",
          Z,
          BABYLON.Animation.ANIMATIONTYPE_QUATERNION,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), X = [
          {
            frame: 0,
            value: e.rotationQuaternion
          },
          {
            frame: M,
            value: he
          }
        ], G.setKeys(X);
      }
      let te = null;
      e.scaling !== a && (te = new BABYLON.Animation(
        "scalingAnimation",
        "scaling",
        Z,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), X = [
        {
          frame: 0,
          value: e.scaling
        },
        {
          frame: M,
          value: a
        }
      ], te.setKeys(X));
      let J = e.animations.length;
      if (Y && e.animations.push(Y), ie && e.animations.push(ie), G && e.animations.push(G), te && e.animations.push(te), e.animations.length > J) {
        var S = this._scene.beginAnimation(e, 0, M, !1, 1);
        S.onAnimationEnd = () => {
          I(), f && f();
        };
      }
    }
  }
  getMaterialsUsingTexture(e) {
    var t = this.getTextureMaterialsMap();
    return this._scene.materials.forEach((r) => {
      var o = this.getTexturesForMaterial(r);
      o.forEach((a) => {
        t.hasOwnProperty(a.uid) || (t[a.uid] = []), t[a.uid].push(r);
      });
    }), t.hasOwnProperty(e.uid) ? t[e.uid] : [];
  }
  getTextureMaterialsMap() {
    let e = {};
    return this._scene && this._scene.materials.forEach((t) => {
      var r = this.getTexturesForMaterial(t);
      r.forEach((o) => {
        e.hasOwnProperty(o.uid) || (e[o.uid] = []), e[o.uid].push(t);
      });
    }), e;
  }
  // Recupera tutte le texture di un materiale
  getTexturesForMaterial(e) {
    return e.getActiveTextures();
  }
  getTexturesExclusivelyForMaterial(e) {
    let t = this.getTexturesForMaterial(e), r = this.getTextureMaterialsMap();
    for (var o = 0; o < t.length; o++) {
      let u = t[o];
      var a = r.hasOwnProperty(u.uid) ? r[u.uid] : [];
      a.length > 1 && t.splice(o--, 1);
    }
    return t;
  }
  getStandardMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getNewPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  createMeshesFromSubMeshes(e) {
    let t = e.getChildMeshes(!0);
    for (let a = 0; a < t.length; a++)
      this.createMeshesFromSubMeshes(t[a]);
    let r = [];
    if (e.subMeshes && e.subMeshes.length > 0)
      for (let a = 0; a < e.subMeshes.length; a++) {
        let u = this.createMeshFromSubMesh(e, a);
        u && r.push(u);
      }
    let o = new BABYLON.VertexData();
    o.positions = [], o.indices = [], o.normals = [], o.uvs = [], o.uvs2 = [], o.applyToMesh(e, !0), e.subMeshes = [], e.material = null, r.forEach((a) => {
      a.parent = e;
    });
  }
  createMeshFromSubMesh(e, t, r) {
    let o = null, a = e.subMeshes[t], u = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), f = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), v = e.getIndices();
    if (u && f && v) {
      let I = u.slice(
        3 * a.verticesStart,
        3 * (a.verticesStart + a.verticesCount)
      ), D = f.slice(
        3 * a.verticesStart,
        3 * (a.verticesStart + a.verticesCount)
      ), Z = v.slice(a.indexStart, a.indexStart + a.indexCount), M = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
        let ie = e.getVerticesData(BABYLON.VertexBuffer.UVKind);
        ie && (M = ie.slice(2 * a.verticesStart, 2 * (a.verticesStart + a.verticesCount)));
      }
      var S = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
        let ie = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
        ie && (S = ie.slice(
          2 * a.verticesStart,
          2 * (a.verticesStart + a.verticesCount)
        ));
      }
      for (let ie = 0; ie < Z.length; ie++)
        Z[ie] -= a.verticesStart;
      let X = new BABYLON.Mesh(r || e.name + "_part_" + a._id, this._scene), Y = new BABYLON.VertexData();
      Y.positions = I, Y.normals = D, Y.indices = Z, M && (Y.uvs = M), S && (Y.uvs2 = S), Y.applyToMesh(X), e.material && (X.material = e.material instanceof BABYLON.MultiMaterial ? e.material.subMaterials[a.materialIndex] : e.material);
    }
    return o;
  }
  getNextIncrementalName(e) {
    let t = e;
    if (e) {
      let f;
      for (var r = 0; this._scene.getMeshByName(t); ) {
        if (!f) {
          f = e;
          var o = e.lastIndexOf("_");
          if (o > 0) {
            var a = e.substring(o + 1), u = parseInt(a);
            u.toString() === a && (f = e.substring(0, o));
          }
        }
        r++, t = f + "_" + r;
      }
    }
    return t;
  }
  createBox(e, t) {
    let r = t || "Box";
    r = this.getNextIncrementalName(r);
    let o = BABYLON.Mesh.CreateBox(r, 5, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createBoundingBox(e, t) {
    let r = t || "BoundingBox";
    r = this.getNextIncrementalName(r);
    const o = e ? e.getHierarchyBoundingVectors() : this.getWorldExtends();
    if (!o)
      return this.createBox(e, t);
    const a = o.min, u = o.max, f = new BABYLON.BoundingInfo(a, u), v = u.subtract(a);
    if (!isFinite(v.length()))
      return this.createBox(e, t);
    const S = u.x - a.x, I = u.y - a.y, D = u.z - a.z, Z = BABYLON.VertexData.CreateBox({ width: S, height: I, depth: D }), M = new BABYLON.Mesh(r, this._scene);
    return Z.applyToMesh(M), M.position.copyFrom(f.boundingBox.centerWorld), M.refreshBoundingInfo(), e && e.parent && (M.parent = e.parent), M;
  }
  createSphere(e, t) {
    let r = t || "Sphere";
    r = this.getNextIncrementalName(r);
    const o = BABYLON.Mesh.CreateSphere(r, 30, 5, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createPlane(e, t) {
    let r = t || "Plane";
    r = this.getNextIncrementalName(r);
    const o = BABYLON.Mesh.CreatePlane(r, 10, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createDisc(e, t) {
    let r = t || "Disc";
    r = this.getNextIncrementalName(r);
    const o = BABYLON.MeshBuilder.CreateDisc(r, { tessellation: 70 }, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createCylinder(e, t) {
    let r = t || "Cylinder";
    r = this.getNextIncrementalName(r);
    const o = BABYLON.Mesh.CreateCylinder(r, 6, 6, 6, 30, 1, this._scene, !1);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createTorus(e, t) {
    let r = t || "Torus";
    r = this.getNextIncrementalName(r);
    const o = BABYLON.Mesh.CreateTorus(r, 8, 1, 50, this._scene, !1);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createKnot(e, t) {
    let r = t || "Knot";
    r = this.getNextIncrementalName(r);
    const o = BABYLON.Mesh.CreateTorusKnot(r, 2, 0.5, 128, 64, 2, 3, this._scene);
    return o.id = Zakeke.generateUUID(), e && (o.parent = e), o;
  }
  createRibbon(e, t) {
    let r = t || "Ribbon";
    r = this.getNextIncrementalName(r);
    const o = function(v) {
      for (var S = [], I = -10; I < 10; I++)
        S.push(new BABYLON.Vector3(v, I, Math.sin(v / 3) * 5 * Math.exp(-(I - v) * (I - v) / 60) + I / 3));
      return S;
    };
    for (var a = [], u = 0; u < 20; u++)
      a[u] = o(u);
    const f = BABYLON.Mesh.CreateRibbon("ribbon", a, !1, !1, 0, this._scene);
    return f.id = Zakeke.generateUUID(), e && (f.parent = e), f;
  }
  async createRoundedCubeAsync(e, t, r) {
    const o = li.Shapes.RoundedCubeName, a = li.Shapes.RootUrl, u = li.Shapes.RoundedCubeFileName;
    let f = t || "Rounded Cube";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createRoundedCylinderAsync(e, t, r) {
    const o = li.Shapes.RoundedCylinderName, a = li.Shapes.RootUrl, u = li.Shapes.RoundedCylinderFileName;
    let f = t || "Rounded Cylinder";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createMatBallAsync(e, t, r) {
    const o = li.Shapes.MatBallName, a = li.Shapes.RootUrl, u = li.Shapes.MatBallFileName;
    let f = t || "Mat Ball";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createMaleHeadAsync(e, t, r) {
    const o = li.Shapes.MaleHeadName, a = li.Shapes.RootUrl, u = li.Shapes.MaleHeadFileName;
    let f = t || "Male Head";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createFemaleHeadAsync(e, t, r) {
    const o = li.Shapes.FemaleHeadName, a = li.Shapes.RootUrl, u = li.Shapes.FemaleHeadFileName;
    let f = t || "Female Head";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createPokemonBallAsync(e, t, r) {
    const o = li.Shapes.PokemonBallName, a = li.Shapes.RootUrl, u = li.Shapes.PokemonBallFileName;
    let f = t || "Pokemon Ball";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createShaderBallAsync(e, t, r) {
    const o = li.Shapes.ShaderBallName, a = li.Shapes.RootUrl, u = li.Shapes.ShaderBallFileName;
    let f = t || "Shader Ball";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createBootsAsync(e, t, r) {
    const o = li.Shapes.BootsName, a = li.Shapes.RootUrl, u = li.Shapes.BootsFolder, f = li.Shapes.BootsFileName;
    let v = t || "Boots";
    return v = this.getNextIncrementalName(v), await this.importPrimitiveShapeAsync(o, a + u, f, e, v, r);
  }
  async createSuzanneAsync(e, t, r) {
    const o = li.Shapes.SuzanneName, a = li.Shapes.RootUrl, u = li.Shapes.SuzanneFileName;
    let f = t || "Suzanne";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createStepPyramidAsync(e, t, r) {
    const o = li.Shapes.StepPyramidName, a = li.Shapes.RootUrl, u = li.Shapes.StepPyramidFileName;
    let f = t || "Step Pyramid";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createTeapotAsync(e, t, r) {
    const o = li.Shapes.TeapotName, a = li.Shapes.RootUrl, u = li.Shapes.TeapotFileName;
    let f = t || "Teapot";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createAlloyWheelAsync(e, t, r) {
    const o = li.Shapes.AlloyWheelName, a = li.Shapes.RootUrl, u = li.Shapes.AlloyWheelFolder, f = li.Shapes.AlloyWheelFileName;
    let v = t || "Wheel";
    return v = this.getNextIncrementalName(v), await this.importPrimitiveShapeAsync(o, a + u, f, e, v, r);
  }
  async createTryonReferenceGlassesFrameAsync(e, t, r) {
    const o = li.TryonReferences.ReferenceGlassesFrameName, a = li.TryonReferences.RootUrl, u = li.TryonReferences.ReferenceGlassesFrameFileName;
    let f = t || "Reference Glasses Frame";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(o, a, u, e, f, r);
  }
  async createTryOnReferenceModelsAsync(e, t, r, o) {
    return await this.importPrimitiveShapeAsync(
      "",
      li.TryonReferences.RootUrl,
      r,
      e,
      t,
      o,
      !0
    );
  }
  async importPrimitiveShapeAsync(e, t, r, o, a, u, f = !1) {
    let v = [], S = await BABYLON.SceneLoader.ImportMeshAsync(e, t, r, this._scene, u);
    if (S && S.meshes) {
      v = S.meshes;
      for (let I = 0; I < v.length; I++) {
        let D = v[I];
        if (D.name === "__root__") {
          let Z = D.getChildMeshes();
          for (let M = 0; M < Z.length; M++) {
            let X = Z[M];
            X.parent = null;
          }
          D.dispose(), v.splice(I--, 1);
          continue;
        }
        D.id = Zakeke.generateUUID(), o && (D.parent = o);
      }
    }
    return v;
  }
  setTryOnReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((r) => {
      r.isVisible = e;
    });
  }
  setTryOnReferenceEnabled(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((r) => {
      r.setEnabled(e);
    });
  }
  isTryOnReferenceVisible() {
    const { tryonReferencesModels: e } = this.getVTOMeshes();
    return e.length > 0 && e[0].isVisible;
  }
  transformEntireScene(e, t, r, o) {
    var u;
    const a = (u = this._scene) == null ? void 0 : u.meshes;
    a == null || a.forEach((f) => {
      f.parent == null && f.setParent(o);
    }), e && (o.position = new BABYLON.Vector3(e.x, e.y, e.z)), t && (o.rotation = new BABYLON.Vector3(t.x, t.y, t.z)), r && (o.scaling = new BABYLON.Vector3(r.x, r.y, r.z)), a == null || a.forEach((f) => {
      f.parent == o && f.setParent(null);
    });
  }
  scaleSceneToTryonReferenceModels(e) {
    this.setSceneScalePercentageForVTO(100, e), this.setScenePositionPercentageForVTO(0, 0, 0, e);
  }
  getSceneScalingPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return 100;
    const r = this._scene.getWorldExtends((M) => t.includes(M)), o = this._scene.getWorldExtends((M) => e.includes(M)), a = r.max.x - r.min.x, u = r.max.y - r.min.y, f = r.max.z - r.min.z, v = o.max.x - o.min.x, S = o.max.y - o.min.y, I = o.max.z - o.min.z;
    return 1 / Math.min(
      a / v,
      u / S,
      f / I
    ) * 100;
  }
  setSceneScalePercentageForVTO(e, t) {
    const { userMeshes: r, tryonReferencesModels: o } = this.getVTOMeshes();
    if (o.length === 0 || r.length === 0)
      return;
    const a = this._scene.getWorldExtends((G) => o.includes(G)), u = this._scene.getWorldExtends((G) => r.includes(G)), f = a.max.x - a.min.x, v = a.max.y - a.min.y, S = a.max.z - a.min.z, I = u.max.x - u.min.x, D = u.max.y - u.min.y, Z = u.max.z - u.min.z, M = Math.min(
      f / I,
      v / D,
      S / Z
    ), { x: X, y: Y, z: ie } = this.getScenePositionPercentageForVTO();
    r.filter((G) => !G.parent).forEach((G) => {
      G.scaling.scaleInPlace(M), G.scaling.scaleInPlace(e / 100), t === "shoes" && G.scaling.scaleInPlace(1.3);
    }), this.setScenePositionPercentageForVTO(X, Y, ie);
  }
  getScenePositionPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const r = this._scene.getWorldExtends((v) => t.includes(v)), o = this._scene.getWorldExtends((v) => e.includes(v)), a = r.max.add(r.min).scale(0.5), f = o.max.add(o.min).scale(0.5).subtract(a);
    return {
      x: f.x / (r.max.x - r.min.x) * 100,
      y: f.y / (r.max.y - r.min.y) * 100,
      z: f.z / (r.max.z - r.min.z) * 100
    };
  }
  setScenePositionPercentageForVTO(e, t, r, o) {
    const { userMeshes: a, tryonReferencesModels: u } = this.getVTOMeshes();
    if (u.length === 0 || a.length === 0)
      return;
    const f = this._scene.getWorldExtends((M) => u.includes(M)), v = this._scene.getWorldExtends((M) => a.includes(M)), S = f.max.add(f.min).scale(0.5), I = v.max.add(v.min).scale(0.5), D = S.subtract(I), Z = new BABYLON.Vector3(
      e / 100 * (f.max.x - f.min.x),
      t / 100 * (f.max.y - f.min.y),
      r / 100 * (f.max.z - f.min.z)
    );
    a.filter((M) => !M.parent).forEach((M) => {
      M.position.addInPlace(D), M.position.addInPlace(Z), o === "shoes" && (console.log("shoes down and scale up to 0.3"), M.position.y = 0);
    });
  }
  getSceneRotationForVTO() {
    var u;
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const r = e.filter((f) => !f.parent)[0], o = ((u = r.rotationQuaternion) == null ? void 0 : u.toEulerAngles()) ?? r.rotation, a = {
      x: o.x / Math.PI * 180,
      y: o.y / Math.PI * 180,
      z: o.z / Math.PI * 180
    };
    return a.x = a.x < 0 ? 360 + a.x : a.x, a.y = a.y < 0 ? 360 + a.y : a.y, a.z = a.z < 0 ? 360 + a.z : a.z, a;
  }
  setSceneRotationForVTO(e, t, r) {
    const { userMeshes: o, tryonReferencesModels: a } = this.getVTOMeshes();
    if (a.length === 0 || o.length === 0)
      return;
    const u = new BABYLON.Vector3(e / 180 * Math.PI, t / 180 * Math.PI, r / 180 * Math.PI);
    o.filter((f) => !f.parent).forEach((f) => {
      f.rotation = u;
    });
  }
  setVTOReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((r) => {
      r.isVisible = e;
    });
  }
  replaceTransformNodeWithMesh(e) {
    let t = null;
    if (this._scene) {
      const r = e.parent, o = e.getChildren();
      t = new BABYLON.Mesh(e.name, this._scene, r), t.id = Zakeke.generateUUID(), t.scaling = e.scaling.clone(), t.position = e.position.clone(), t.rotation = e.rotation.clone(), e.rotationQuaternion && (t.rotationQuaternion = e.rotationQuaternion.clone()), o.forEach((a) => a.parent = t), e.dispose(), e.animations.forEach((a) => {
        t.animations.push(a.clone());
      }), this._scene.animationGroups.forEach((a) => {
        a.targetedAnimations.forEach((u) => {
          u.target === e && (u.target = t);
        });
      }), this._scene.skeletons.forEach((a) => {
        a.bones.forEach((u) => {
          u.getTransformNode() === e && u.linkTransformNode(t);
        });
      });
    }
    return t;
  }
  // import 3d model from a remote url
  async importMeshesFromUrlAsync(e, t, r, o, a, u) {
    let f;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((X) => {
      f = X.name;
    });
    let v = [];
    const S = await BABYLON.SceneLoader.ImportMeshAsync(
      "",
      e,
      void 0,
      this._scene,
      r,
      a
    );
    S && (S.meshes.forEach((X) => {
      X.id = Zakeke.generateUUID(), v.push(X), this.getMeshMaterials(X).forEach((ie) => ie.id = Zakeke.generateUUID());
    }), S.transformNodes.forEach((X) => {
      X.id = Zakeke.generateUUID();
      const Y = this.replaceTransformNodeWithMesh(X);
      Y && v.push(Y);
    }), S.geometries.forEach((X) => X.id = Zakeke.generateUUID()));
    let I = BABYLON.Tools.GetFilename(e), D = I, Z = I.lastIndexOf(".");
    Z !== -1 && (D = I.substr(0, Z));
    const M = v.filter((X) => !X.parent);
    if (M.length > 1 || M.length === 1 && M[0].name !== "__root__") {
      const X = new BABYLON.Mesh(D, this._scene);
      X.id = Zakeke.generateUUID(), X.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, v.push(X), M.forEach((Y) => {
        Y.setParent(X);
      }), f === "obj" && (X.scaling = new BABYLON.Vector3(-X.scaling.x, X.scaling.y, X.scaling.z), X.rotation = new BABYLON.Vector3(0, Math.PI, 0));
    } else if (M.length === 1) {
      const X = M[0];
      if (X.name === "__root__") {
        let ie = BABYLON.Tools.GetFilename(e), G = I.lastIndexOf(".");
        G !== -1 && (ie = I.substring(0, G)), X.name = ie, f === "obj" && (X.scaling = new BABYLON.Vector3(-X.scaling.x, X.scaling.y, -X.scaling.z), X.rotation = new BABYLON.Vector3(0, Math.PI, 0));
      }
      if (["gltf", "glb", "obj"].includes(f)) {
        X.name += "_transforms", X.metadata = {
          isGltfTransformNode: !0
        };
        const ie = new BABYLON.Mesh(D, this._scene);
        ie.id = Zakeke.generateUUID(), ie.metadata = {
          isRealMesh: !0,
          isGroup: !0
        }, v.push(ie), X.parent = ie;
      }
    }
    if (!u && f === "gltf" || f === "glb") {
      const X = [];
      v.forEach((Y) => {
        if (Y instanceof BABYLON.Mesh) {
          const G = BABYLON.VertexData.ExtractFromMesh(Y), te = ["uvs", "uvs2", "uvs3", "uvs4", "uvs5", "uvs6"];
          for (const J of te)
            if (G && G[J] && G[J].length > 0)
              for (let he = 0; he < G[J].length; he += 2)
                G[J][he + 1] = 1 - G[J][he + 1];
          G.applyToMesh(Y);
        }
        this.getMeshMaterials(Y).forEach((G) => {
          X.includes(G) || X.push(G);
        });
      }), X.forEach((Y) => {
        Y.getActiveTextures().forEach((ie) => {
          ie instanceof BABYLON.Texture && (ie.vScale *= -1);
        });
      });
    }
    return this.adjustCamera(f, !1, !1, o, !0), this.setupShaderMaterialsCameraPosition(), v;
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let t = 0; t < this._scene.materials.length; t++) {
        var e = this._scene.materials[t];
        this.setupShaderMaterialCameraPosition(e);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    if (this._scene && e && e instanceof BABYLON.ShaderMaterial) {
      const t = this._scene.activeCamera;
      t && e.setVector3("cameraPosition", t.position);
    }
  }
  getSceneCmScalingFactor(e = null, t = null) {
    let r = null;
    if (this._scene) {
      let a = null;
      for (let u = 0; u < this._scene.meshes.length; u++) {
        var o = this._scene.meshes[u];
        if (o.metadata && o.metadata.sizecm) {
          a = o;
          break;
        }
      }
      if (e && t && (a = t), a) {
        const u = a.getHierarchyBoundingVectors(), f = u.min, v = u.max, S = v.subtract(f);
        if (isFinite(S.length())) {
          const I = v.x - f.x, D = v.y - f.y, Z = v.z - f.z, M = e || a.metadata.sizecm;
          return M.width !== void 0 && typeof M.width == "number" && !isNaN(M.width) && I !== 0 ? r = M.width / I : M.height !== void 0 && typeof M.height == "number" && !isNaN(M.height) && D !== 0 ? r = M.height / D : M.depth !== void 0 && typeof M.depth == "number" && !isNaN(M.depth) && Z !== 0 && (r = M.depth / Z), r;
        }
      }
    }
    return r;
  }
  async exportSceneToUsdzAsync(e, t, r, o, a = null, u = null, f = !0) {
    const v = this.getMeshesForAR();
    let S = e || "scene";
    return S = S.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      S,
      t,
      v,
      r,
      o,
      "usdz",
      a,
      u,
      f
    );
  }
  async exportMeshToUsdzAsync(e, t, r = null, o = null, a = !0) {
    const u = this.getMeshHierarchy(t.id);
    let f = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      f,
      e,
      u,
      void 0,
      void 0,
      "usdz",
      r,
      o,
      a
    );
  }
  async exportSceneToRemoteGlTFAsync(e, t, r, o, a = null, u = null, f = !0) {
    const v = this.getMeshesForAR();
    let S = e || "scene";
    return S = S.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      S,
      t,
      v,
      r,
      o,
      "glTF",
      a,
      u,
      f
    );
  }
  async exportMeshToRemoteGlTFAsync(e, t, r = null, o = null, a = !0) {
    const u = this.getMeshHierarchy(t.id);
    let f = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      f,
      e,
      u,
      void 0,
      void 0,
      "glTF",
      r,
      o,
      a
    );
  }
  async exportSceneToRemoteGLBAsync(e, t, r, o, a = null, u = null, f = !0) {
    const v = this.getMeshesForAR();
    let S = e || "scene";
    return S = S.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      S,
      t,
      v,
      r,
      o,
      "glb",
      a,
      u,
      f
    );
  }
  async exportMeshToRemoteGLBAsync(e, t, r = null, o = null, a = !0) {
    const u = this.getMeshHierarchy(t.id);
    let f = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      f,
      e,
      u,
      void 0,
      void 0,
      "glb",
      r,
      o,
      a
    );
  }
  async exportSceneToARMultiformatAsync(e, t, r = ["usdz", "glb", "png"], o, a, u = null, f = null, v = !0) {
    const S = this.getMeshesForAR();
    let I = e || "scene";
    return I = I.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARMultiformatAsync(
      I,
      t,
      S,
      r,
      u,
      f,
      v,
      o,
      a
    );
  }
  async exportMeshToARMultiformatAsync(e, t, r = ["usdz", "glb", "png"], o = null, a = null, u = !0, f, v) {
    const S = this.getMeshHierarchy(t.id);
    let I = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARMultiformatAsync(
      I,
      e,
      S,
      r,
      o,
      a,
      u,
      f,
      v
    );
  }
  convertGltfTransformNodes(e) {
    const t = [];
    return e.filter((r) => r.metadata && r.metadata.isGltfTransformNode).forEach((r) => {
      const o = new BABYLON.TransformNode(r.name + "-transform-node", this._scene);
      o.scaling.z = -1;
      const a = new BABYLON.Quaternion();
      a.set(0, 1, 0, 0), o.rotationQuaternion = a, t.push([r, r.parent, o]), r.setParent(o);
    }), t;
  }
  restoreGltfTransformNodes(e) {
    e.forEach(([t, r, o]) => {
      t.setParent(r), o.dispose();
    });
  }
  async getGltfBlobForARExport(e, t, r) {
    var v;
    const o = this.convertGltfTransformNodes(r);
    (v = this._scene) == null || v.render();
    const a = {
      meshes: r,
      materials: this.getMeshesMaterials(r),
      transformNodes: this._scene.transformNodes,
      lights: void 0,
      exportTextureUrls: t != null,
      rootUrl: t,
      shouldExportNode: (S) => {
        for (let I = 0; I < r.length; I++)
          if (r[I] === S)
            return !0;
        return !1;
      }
    }, u = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, a);
    if (u) {
      const S = new Ef(), I = u.serverImages && u.glTFFiles.hasOwnProperty("TextureUrls.txt") ? u.serverImages : [];
      for (var f in u.glTFFiles)
        if (I.indexOf(f) === -1) {
          let Z = u.glTFFiles[f];
          ps.EndsWith(f, ".gltf") || ps.EndsWith(f, ".bin") ? S.file(f, Z, {
            compression: "DEFLATE",
            compressionOptions: {
              level: 9
              // force a compression and a compression level for this file
            }
          }) : S.file(f, Z, {
            compression: "STORE"
            // no compression
          });
        }
      this.restoreGltfTransformNodes(o), this._scene.render();
      let D = await S.generateAsync({ type: "blob" });
      if (D)
        return D = D, D.lastModifiedDate = /* @__PURE__ */ new Date(), D.name = "arobj.zip", D;
    }
    return null;
  }
  async exportMeshToGLBBlob(e, t) {
    const r = this.getTryOnMeshHierarchy(t), o = this.convertGltfTransformNodes(r), a = {
      meshes: r,
      materials: this.getMeshesMaterials(r),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: e != null,
      rootUrl: e,
      shouldExportNode: (v) => {
        for (let S = 0; S < r.length; S++)
          if (r[S] === v)
            return !0;
        return !1;
      }
    }, u = await BABYLON.GLTF2Export.GLBAsync(this._scene, "model", a).catch((v) => (console.error(v), null));
    let f = null;
    if (u && u.glTFFiles) {
      for (let v in u.glTFFiles)
        if (ps.EndsWith(v, ".glb")) {
          const S = new df(), I = await u.glTFFiles[v].arrayBuffer(), D = S.readBinary(I);
          D.getRoot().listNodes().filter((X) => X.getParent() === null || X.getParent() instanceof no).forEach((X) => {
          });
          const M = S.writeBinary(D);
          f = new Blob([M], { type: "model/gltf-binary" });
        }
    }
    return this.restoreGltfTransformNodes(o), f;
  }
  async exportMeshesToARAsync(e, t, r, o, a, u = "usdz", f = null, v = null, S = !0) {
    let I = "";
    if (o && a && Zakeke.config) {
      const D = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + o + "/" + a + "/" + u;
      try {
        I = await jQuery.ajax({
          url: D,
          cache: !1,
          contentType: !1,
          processData: !1,
          type: "GET"
        });
      } catch {
        I = "";
      }
    }
    if (!I) {
      let D = this.getSceneCmScalingFactor(f, v);
      const Z = await this.getGltfBlobForARExport(e, t, r);
      if (Z) {
        const M = {
          flipTextures: !0,
          formats: [u]
        };
        o && (M.sceneID = o), a && (M.sceneCode = a), D && (M.scale = D);
        let X = !0;
        window.isOwin != null && (X = window.isOwin);
        const ie = await new Bf("artasks", window.token, X).upload(Z, M);
        ie && ie.length > 0 && (I = ie[0].arFileUrl);
      }
    }
    return I;
  }
  async exportMeshesToARMultiformatAsync(e, t, r, o = ["usdz", "glb", "png"], a = null, u = null, f = !0, v, S) {
    let I = [], D = [];
    if (v && S && Zakeke.config)
      for (let Z = 0; Z < o.length; Z++) {
        const M = o[Z], X = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + v + "/" + S + "/" + M;
        try {
          const Y = await jQuery.ajax({
            url: X,
            cache: !1,
            contentType: !1,
            processData: !1,
            type: "GET"
          });
          Y && D.push({ format: M, arFileUrl: Y });
        } catch {
        }
        I = D;
      }
    if (D.length !== o.length) {
      const Z = this.getSceneCmScalingFactor(a, u), M = D.map((ie) => ie.format), X = o.filter((ie) => !M.includes(ie)), Y = await this.getGltfBlobForARExport(e, t, r);
      if (Y) {
        const ie = {
          flipTextures: !0,
          formats: X
          // Escludo i formati cachati
        };
        v && (ie.sceneID = v), S && (ie.sceneCode = S), Z && (ie.scale = Z);
        let G = !0;
        window.isOwin !== void 0 && (G = window.isOwin);
        const J = await new Bf("artasks", window.token, G).upload(Y, ie);
        if (J && J.length > 0)
          for (const he of J)
            he && he.arFileUrl && I.push({ format: he.format, arFileUrl: he.arFileUrl });
      }
    }
    return I;
  }
  // Metodi per esportazione on-the-fly client side
  async exportSceneToLocalGlTFBlobsAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), r = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    let o = [];
    for (let a in r.glTFFiles)
      o.push(r.glTFFiles[a]);
    return o;
  }
  async exportSceneToLocalGlTFUrlsAsync() {
    const e = [], t = Zakeke.generateUUID(), r = this.getSceneToGltfExportOptions(), o = await BABYLON.GLTF2Export.GLTFAsync(this._scene, t, r);
    if (o)
      for (let u in o.glTFFiles) {
        var a = o.glTFFiles[u];
        e.push(this.getGltfFileUrl(u, a));
      }
    return e;
  }
  async downloadSceneLocalGltfAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), r = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    r && r.downloadFiles();
  }
  async exportSceneToLocalGLBBlobAsync() {
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalGLBBase64Async() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let r = new FileReader();
      r.readAsDataURL(t.blob), r.onloadend = () => {
        let o = r.result;
        typeof o == "string" && (e = o);
      };
    }
    return e;
  }
  async exportSceneToLocalGLBUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getGltfFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalGLBAsync() {
    var r;
    (r = this._scene) == null || r.meshes.forEach((o) => {
      o.isVisible = !0;
    });
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let o = this.getGltfFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = o, t.click(), document.body.removeChild(t), URL.revokeObjectURL(o);
    }
  }
  async getSceneLocalGLBBlobInfoAsync(e = null, t = null) {
    let r = {
      name: null,
      blob: null
    };
    const o = Zakeke.generateUUID(), a = this.getSceneToGltfExportOptions();
    let u = await BABYLON.GLTF2Export.GLBAsync(this._scene, o, a).catch((f) => (console.error(f), null));
    if (u && u.glTFFiles) {
      for (let f in u.glTFFiles)
        if (ps.EndsWith(f, ".glb")) {
          let v = this.getSceneCmScalingFactor(), S = 1;
          v && (S = v / 100);
          const I = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI), D = new df(), Z = await u.glTFFiles[f].arrayBuffer(), M = D.readBinary(Z), X = M.getRoot().listNodes().filter((J) => J.getParent() === null || J.getParent() instanceof no), Y = [0, 1, 0, 0], ie = X.every((J) => {
            const he = J.getRotation();
            return Y.length === he.length && Y.every((ve, K) => ve === he[K]);
          });
          X.forEach((J) => {
            J.setScale([S, S, S]), ie && J.setRotation([I.x, I.y, I.z, I.w]);
          });
          const G = D.writeBinary(M), te = new Blob([G], { type: "model/gltf-binary" });
          r.name = f, r.blob = te;
          break;
        }
    }
    return r;
  }
  // -----------------------------------------------------------------------
  // Metodi per exportazione della scena in USDZ su client (on-the-fly)
  async exportSceneToLocalUSDZBlobAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalUSDZBase64Async() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let r = new FileReader();
      r.readAsDataURL(t.blob), r.onloadend = () => {
        let o = r.result;
        typeof o == "string" && (e = o);
      };
    }
    return e;
  }
  async exportSceneToLocalUSDZUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getUsdzFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalUSDZAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let r = this.getUsdzFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = r, t.click(), document.body.removeChild(t), URL.revokeObjectURL(r);
    }
  }
  async getSceneLocalUSDZBlobInfoAsync() {
    let e = {
      name: null,
      blob: null
    };
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.name && t.blob && t.blob instanceof Blob) {
      const r = this.getGltfFileUrl(t.name, t.blob), o = await nx.convertGlbToUsdz(r);
      e.name = t.name.replace(".glb", ".usdz"), e.blob = o;
    }
    return e;
  }
  // -----------------------------------------------------------------------
  getSceneToGltfExportOptions() {
    var e = this.getMeshesForAR(), t = {
      meshes: e,
      materials: this.getMeshesMaterials(e),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: !1,
      rootUrl: null,
      shouldExportNode: (r) => {
        for (var o = 0; o < e.length; o++)
          if (e[o] === r)
            return !0;
        return !1;
      }
    };
    return t;
  }
  getGltfFileUrl(e, t) {
    var r = void 0;
    return ps.EndsWith(e, ".glb") ? r = { type: "model/gltf-binary" } : ps.EndsWith(e, ".bin") ? r = { type: "application/octet-stream" } : ps.EndsWith(e, ".gltf") ? r = { type: "model/gltf+json" } : ps.EndsWith(e, ".jpeg") ? r = { type: "image/jpeg" } : ps.EndsWith(e, ".png") && (r = { type: "image/png" }), window.URL.createObjectURL(new Blob([t], r));
  }
  getUsdzFileUrl(e, t) {
    var r = { type: "model/vnd.usdz+zip" };
    return window.URL.createObjectURL(new Blob([t], r));
  }
  exportSceneToBabylon() {
    const e = BABYLON.SceneSerializer.Serialize(this._scene);
    return JSON.stringify(e);
  }
  exportVisibleMeshesToBabylon() {
    const e = this.getVisibleMeshes(), t = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
    return JSON.stringify(t);
  }
  downloadImageFromBase64(e, t, r) {
    var o = document.createElement("a");
    o.href = e, o.download = t, o.click(), o.remove();
  }
  getStandardMaterialTextureType(e, t) {
    return e.diffuseTexture === t ? "diffuse" : e.emissiveTexture === t ? "emissive" : e.ambientTexture === t ? "ambient" : e.lightmapTexture === t ? "lightmap" : e.opacityTexture === t ? "opacity" : e.specularTexture === t ? "specular" : e.reflectionTexture === t ? "reflection" : e.refractionTexture === t ? "refraction" : e.bumpTexture === t ? "bump" : null;
  }
  getPBRMetallicRoughnessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.baseTexture === t ? "base" : e.metallicRoughnessTexture === t ? "metallicRoughness" : null;
  }
  getPBRSpecularGlossinessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.diffuseTexture === t ? "diffuse" : e.specularGlossinessTexture === t ? "specularGlossiness" : null;
  }
  getPBRMaterialTextureType(e, t) {
    if (e.cameraColorGradingTexture === t)
      return "cameraColorGrading";
    if (e.albedoTexture === t)
      return "albedo";
    if (e.ambientTexture === t)
      return "ambient";
    if (e.opacityTexture === t)
      return "opacity";
    if (e.reflectionTexture === t)
      return "reflection";
    if (e.emissiveTexture === t)
      return "emissive";
    if (e.reflectivityTexture === t)
      return "reflectivity";
    if (e.metallicTexture === t)
      return "metallic";
    if (e.microSurfaceTexture === t)
      return "microSurface";
    if (e.bumpTexture === t)
      return "bump";
    if (e.lightmapTexture === t)
      return "lightmap";
    if (e.refractionTexture === t)
      return "refraction";
    if (e.clearCoat) {
      if (e.clearCoat.texture === t)
        return "clearCoat";
      if (e.clearCoat.bumpTexture === t)
        return "clearCoat_bump";
      if (e.clearCoat.tintTexture === t)
        return "clearCoat_tint";
      if (e.clearCoat.textureRoughness === t)
        return "clearCoat_textureRoughness";
      if (e.clearCoat.texture === t)
        return "clearCoat_texture";
    }
    if (e.anisotropy && e.anisotropy.texture === t)
      return "anisotropy_texture";
    if (e.sheen) {
      if (e.sheen.texture === t)
        return "sheen_texture";
      if (e.sheen.textureRoughness === t)
        return "sheen_textureRoughness";
    }
    if (e.subSurface) {
      if (e.subSurface.thicknessTexture === t)
        return "subSurface_thickness";
      if (e.subSurface.refractionIntensityTexture === t)
        return "subSurface_refractionIntensity";
      if (e.subSurface.translucencyIntensityTexture === t)
        return "subSurface_translucencyIntensity";
    }
    return null;
  }
  getZakekePBRMaterialTextureType(e, t) {
    return e.albedoTexture === t ? "albedo" : e.bumpTexture === t ? "bump" : e.reflectionTexture === t ? "reflection" : e.matCapReflectionTexture === t ? "matCapReflection" : e.reflectivityTexture === t ? "reflectivity" : e.microsurfaceTexture === t ? "microsurface" : e.ambientTexture === t ? "ambient" : e.aoTexture === t ? "ao" : e.opacityTexture === t ? "opacity" : null;
  }
  getMaterialTextureType(e, t) {
    return e instanceof BABYLON.StandardMaterial ? this.getStandardMaterialTextureType(e, t) : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? this.getPBRMetallicRoughnessMaterialTextureType(e, t) : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? this.getPBRSpecularGlossinessMaterialTextureType(e, t) : e instanceof BABYLON.PBRMaterial ? this.getPBRMaterialTextureType(e, t) : e instanceof Zakeke.PBRMaterial ? this.getZakekePBRMaterialTextureType(e, t) : null;
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          return e[`${t}Texture`];
        case "refraction":
          return e.refractionTexture;
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  applyTexture(e, t, r) {
    if (e && r == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (r) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (r) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${r}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (r) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${r}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (r) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${r}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(r, e) : t.removeTexture(r);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (r) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
  }
  applyTextureOnSerializedMaterial(e, t, r, o) {
    if (e && r == "lightmap" && (e.coordinatesIndex = 1, (o === "BABYLON.StandardMaterial" || o === "BABYLON.PBRMaterial" || o === "BABYLON.PBRBaseSimpleMaterial") && (t.useLightmapAsShadowmap = !0)), o === "BABYLON.StandardMaterial")
      t[`${r}Texture`] = e;
    else if (o === "BABYLON.PBRMetallicRoughnessMaterial")
      t[`${r}Texture`] = e;
    else if (o === "BABYLON.PBRSpecularGlossinessMaterial")
      t[`${r}Texture`] = e;
    else if (o === "BABYLON.PBRMaterial")
      switch (r) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          t[`${r}Texture`] = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else
      o === "Zakeke.PBRMaterial" && (t[`${r}Texture`] = e);
  }
  getSerializedMaterialTexture(e, t, r) {
    if (r === "BABYLON.StandardMaterial")
      return e[`${t}Texture`];
    if (r === "BABYLON.PBRMetallicRoughnessMaterial")
      return e[`${t}Texture`];
    if (r === "BABYLON.PBRSpecularGlossinessMaterial")
      return e[`${t}Texture`];
    if (r === "BABYLON.PBRMaterial")
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          return e[`${t}Texture`];
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (r === "Zakeke.PBRMaterial")
      return e[`${t}Texture`];
    return null;
  }
  getMaterialTypeName(e) {
    return e instanceof BABYLON.StandardMaterial ? "BABYLON.StandardMaterial" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "BABYLON.PBRMetallicRoughnessMaterial" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "BABYLON.PBRSpecularGlossinessMaterial" : e instanceof BABYLON.PBRMaterial ? "BABYLON.PBRMaterial" : e instanceof BABYLON.ShaderMaterial ? "BABYLON.ShaderMaterial" : e instanceof Zakeke.PBRMaterial ? "Zakeke.PBRMaterial" : "BABYLON.StandardMaterial";
  }
  async exportMeshToBabylon(e) {
    const t = this.getMeshHierarchy(e.id);
    return await this.exportMeshesToBabylon(t);
  }
  async exportMeshesToBabylon(e) {
    const t = this.getMeshesMaterials(e), r = e.map((a) => ({ id: a.id, doNotSerialize: a.doNotSerialize })), o = t.map((a) => ({ id: a.id, doNotSerialize: a.doNotSerialize }));
    e.forEach((a) => a.doNotSerialize = !1), t.forEach((a) => a.doNotSerialize = !1);
    try {
      const a = {};
      for (let v = 0; v < t.length; v++) {
        const S = t[v], I = S.id, D = this.getMaterialDynamicTextures(S);
        if (D.length > 0) {
          a[I] = {
            materialType: this.getMaterialTypeName(S),
            textures: []
          };
          for (let Z = 0; Z < D.length; Z++) {
            const M = D[Z], X = Zakeke.generateUUID(), Y = this.getMaterialTextureType(S, M), ie = await this.exportTextureToBase64Async(M, "image/png");
            if (Y && ie) {
              const G = {
                id: X,
                type: Y,
                base64String: ie,
                isProcedural: M instanceof BABYLON.ProceduralTexture
              };
              a[I].textures.push(G);
            }
          }
        }
      }
      const u = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
      for (const v of u.materials) {
        const S = Object.getOwnPropertyNames(v).filter(
          (D) => D.slice(-7) === "Texture" && typeof v[D] == "object"
        ), I = v.id;
        if (a.hasOwnProperty(I)) {
          const D = a[I], Z = D.materialType, M = D.textures;
          for (const X of M) {
            const Y = this.getSerializedMaterialTexture(
              v,
              X.type,
              D.materialType
            );
            if (Y) {
              if (X.isProcedural) {
                const ie = new BABYLON.Texture(
                  X.base64String,
                  this._scene,
                  void 0,
                  void 0,
                  void 0,
                  void 0
                );
                await Sn.whenTextureIsReadyAsync(ie), ie.uScale = Y.uScale, ie.vScale = Y.vScale, ie.uOffset = Y.uOffset, ie.vOffset = Y.vOffset, ie.uAng = Y.uAng, ie.vAng = Y.vAng, ie.level = Y.level, ie.coordinatesIndex = Y.coordinatesIndex, ie.coordinatesMode = Y.coordinatesMode, ie.wrapU = Y.wrapU, ie.wrapV = Y.wrapV;
                const G = ie.serialize();
                G.url = X.base64String, G.name = "prcedural texture", this.applyTextureOnSerializedMaterial(
                  G,
                  v,
                  X.type,
                  Z
                ), ie.dispose();
              }
            } else
              Y.url = X.base64String, Y.name = "dynamic texture";
          }
        }
      }
      let f = JSON.stringify(u);
      return e.forEach((v) => {
        var S;
        return v.doNotSerialize = (S = r.find((I) => I.id === v.id)) == null ? void 0 : S.doNotSerialize;
      }), t.forEach(
        (v) => v.doNotSerialize = o.find((S) => S.id === v.id).doNotSerialize
      ), f;
    } finally {
      e.forEach((a) => {
        var u;
        return a.doNotSerialize = (u = r.find((f) => f.id === a.id)) == null ? void 0 : u.doNotSerialize;
      }), t.forEach(
        (a) => a.doNotSerialize = o.find((u) => u.id === a.id).doNotSerialize
      );
    }
  }
  async exportMeshesForTyOnToBabylon() {
    const e = this.getMeshesForTryOn();
    return await this.exportMeshesToBabylon(e);
  }
  downloadBlob(e) {
    const t = URL.createObjectURL(e), r = document.createElement("a");
    r.download = "mesh.json", r.href = t, r.click(), URL.revokeObjectURL(t);
  }
  async downloadMeshBabylonAsync(e) {
    const t = await this.exportMeshToBabylon(e);
    if (t) {
      const r = new Blob([t], { type: "application/json" });
      this.downloadBlob(r);
    }
  }
  async downloadMeshesBabylonAsync(e) {
    const t = await this.exportMeshesToBabylon(e);
    if (t) {
      const r = new Blob([t], { type: "application/json" });
      this.downloadBlob(r);
    }
  }
  async loadAllDelayedMaterialFromZip(e, t, r) {
    console.log("Loading delayed materials from zip");
    const o = e + `materials_${t}.zip`, u = await (await fetch(o)).blob(), f = new File([u], "materials.zip", { type: "application/zip" }), v = new Ef();
    await v.loadAsync(f);
    const S = v.file(/\.json$/) || [], I = [], D = [];
    if (S.length === 0)
      throw console.warn("No material files found in the zip archive."), new Error("No material files found in the zip archive.");
    for (const [Z, M] of S.entries()) {
      const X = M.name.match(/material_\d+_(.*)\.json/);
      if (!X)
        continue;
      const Y = X[1].replace(/_/g, "-");
      D.push(
        new Promise(async (ie, G) => {
          console.log("Loading material: " + Y);
          try {
            const te = await M.async("string"), J = JSON.parse(te), he = BABYLON.Material.Parse(J, this._scene, e);
            he ? (he.metadata = he.metadata || {}, he.metadata.fromZip = !0, I.push(he), await (r == null ? void 0 : r(Z + 1, S.length)), ie(he)) : G(new Error("Failed to parse material " + Y));
          } catch (te) {
            G(te);
          }
        })
      );
    }
    return await Promise.all(D), I;
  }
  // In case loadAllDelayedMaterialAsync failed, we can cleanup all temporary materials.
  // They're recognized by the metadata property `fromZip` set to true.
  async cleanupAllTemporaryMaterialsAsync() {
    try {
      const e = this._scene.materials.filter((t) => {
        var r;
        return (r = t.metadata) == null ? void 0 : r.fromZip;
      });
      console.log("Cleaning up temporary materials loaded from zip, found:", e.length), e.forEach((t) => {
        t.dispose(!1, !0);
      });
    } catch (e) {
      console.warn("Error during cleanup of temporary materials:", e);
    }
  }
  async loadAllDelayedMaterialsAsync(e, t) {
    let r = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var o = {};
      for (var a in this._scene.metadata.delayedMaterials)
        o[a] = {
          name: this._scene.metadata.delayedMaterials[a].name,
          file: this._scene.metadata.delayedMaterials[a].file
        };
      r = await this.loadMaterialsAsync(e, o, t);
    }
    return r;
  }
  async loadDelayedMaterialsAsync(e, t) {
    let r = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      for (var o = {}, a = 0; a < t.length; a++)
        this._scene.metadata.delayedMaterials.hasOwnProperty(t[a]) && (o[t[a]] = {
          name: this._scene.metadata.delayedMaterials[t[a]].name,
          file: this._scene.metadata.delayedMaterials[t[a]].file
        });
      r = await this.loadMaterialsAsync(e, o);
    }
    return r;
  }
  async loadDelayedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var r = {};
      if (this._scene.metadata.delayedMaterials.hasOwnProperty(t)) {
        r[t] = {
          name: this._scene.metadata.delayedMaterials[t].name,
          file: this._scene.metadata.delayedMaterials[t].file
        };
        let o = await this.loadMaterialsAsync(e, r);
        if (o.length > 0)
          return o[0];
      }
    }
    return null;
  }
  async loadMaterialsAsync(e, t, r) {
    const o = [];
    let a = [];
    for (let f in t) {
      const v = this._scene.getMaterialByID(f);
      if (v)
        o.push(v);
      else {
        const S = t[f];
        a.push(this.loadMaterialInternalAsync(f, e, S.file));
      }
    }
    const u = await Promise.all(a);
    for (let f = 0; f < u.length; f++) {
      const v = u[f], S = JSON.parse(v), I = BABYLON.Material.Parse(S, this._scene, e);
      I && (console.debug("Waiting for material ready: " + I.id + " - " + I.name), this._scene.useDelayedTextureLoading || await Sn.whenAllMaterialTexturesAreReady(I), Logger.info("Material ready: " + I.id + " - " + I.name), o.push(I), await (r == null ? void 0 : r(f + 1, u.length)));
    }
    return this.setupShaderMaterialsCameraPosition(), o;
  }
  loadMaterialInternalAsync(e, t, r) {
    if (Logger.info("Loading delayed material: " + e), this._loadingMaterials.hasOwnProperty(e))
      return this._loadingMaterials[e];
    let o = ps.EndsWith(t, "/") ? "" : "/";
    var a = t + o + r;
    let u = new Promise((f, v) => {
      BABYLON.Tools.LoadFile(
        a,
        (S) => {
          Logger.info("Loaded delayed material: " + e), f(S), delete this._loadingMaterials[e];
        },
        void 0,
        void 0,
        !1,
        (S, I) => {
          v(I), delete this._loadingMaterials[e];
        }
      );
    });
    return this._loadingMaterials[e] = u, u;
  }
  showMesh(e) {
    this.showHideMesh(e, !0);
  }
  hideMesh(e) {
    this.showHideMesh(e, !1);
  }
  showHideMesh(e, t) {
    var r = (a, u) => {
      a.isVisible = u;
      var f = a.getChildMeshes(!0);
      f && f.forEach((v) => {
        r(v, u);
      });
    }, o = this._scene.getMeshById(e);
    o && r(o, t);
  }
  changeMaterialColor(e, t, r) {
    for (let o = 0; o < this._scene.meshes.length && this._scene.meshes[o].material !== e; o++)
      ;
    t && e[t] !== void 0 && (e[t] = r);
  }
  applyMaterialByName(e, t) {
    if (this._scene) {
      let r = this._scene.getMaterialByName(e);
      r && this.applyMaterial(r, t);
    }
  }
  applyMaterial(e, t) {
    var r = (o) => {
      if (o.subMeshes && o.subMeshes.length > 0 && o.material && o.material instanceof BABYLON.MultiMaterial)
        for (let u = 0; u < o.subMeshes.length; u++) {
          let f = o.subMeshes[u];
          this.applyMaterialToSubMesh(e, o, f);
        }
      else
        o.material = e;
      var a = o.getChildMeshes(!0);
      a && a.forEach((u) => {
        r(u);
      });
    };
    t && r(t);
  }
  applyMaterialToSubMeshByName(e, t, r) {
    var o = this._scene.getMaterialByName(e);
    o && this.applyMaterialToSubMesh(o, t, r);
  }
  applyMaterialToSubMesh(e, t, r) {
    const o = r.materialIndex, a = t || r.getMesh();
    a.material instanceof BABYLON.MultiMaterial && o >= 0 && o < a.material.subMaterials.length && (a.material.subMaterials[o] = e);
  }
  getSubMeshMaterial(e, t) {
    const r = t.materialIndex, o = e || t.getMesh();
    return o.material instanceof BABYLON.MultiMaterial && r >= 0 && r < o.material.subMaterials.length ? o.material.subMaterials[r] : null;
  }
  async prefetchTexturesFormMeshAsync(e) {
    e.material && await this.prefetchTexturesForMaterialAsync(e.material);
    var t = e.getChildMeshes(!0);
    for (let r = 0; r < t.length; r++) {
      let o = t[r];
      o.material && await this.prefetchTexturesForMaterialAsync(o.material);
    }
  }
  async prefetchTexturesForMaterialAsync(e) {
    if (e) {
      var t = this.getTexturesForMaterial(e);
      for (let r = 0; r < t.length; r++)
        await Sn.whenTextureIsReadyAsync(t[r]);
    }
  }
  checkDelayState(e) {
    e instanceof BABYLON.Mesh && e._checkDelayState();
    var t = e.getChildMeshes(!0);
    t.forEach((r) => this.checkDelayState(r));
  }
  // Crea una nuova mesh data da una minima espansione di quella passata in input
  // in modo che ne costituisca un rivestimento
  createEnvelopeMesh(e) {
    let t = 0.01;
    const r = e.getHierarchyBoundingVectors();
    if (r) {
      const a = r.min, u = r.max;
      t = new BABYLON.BoundingInfo(a, u).boundingSphere.radius * 5e-3;
    }
    const o = this.cloneMesh(e.id, !0, !0);
    return o && o instanceof BABYLON.Mesh && this.expandMesh(o, t), o;
  }
  expandMesh(e, t) {
    const r = new ix();
    if (e && e instanceof BABYLON.Mesh) {
      r.expandMesh(e, t);
      const o = e.getChildMeshes();
      for (const a of o)
        a instanceof BABYLON.Mesh && r.expandMesh(a, t);
    }
  }
  cloneMesh(e, t = !1, r = !1) {
    let o = null;
    if (this._scene) {
      const a = this._scene.getMeshById(e);
      if (a) {
        const u = this.getNextIncrementalName(a.name);
        if (o = a.clone(u, a.parent), o) {
          o.id = Zakeke.generateUUID(), t && this.duplicateGeometry(a, o, r);
          const f = o.getChildMeshes();
          for (const v of f) {
            const S = this._scene.getMeshById(v.id);
            v.id = Zakeke.generateUUID();
            const I = v.parent ? v.parent.name : null;
            if (I) {
              const D = v.name.indexOf(I + ".") + I.length + 1;
              v.name = v.name.substr(D);
            }
            S && t && this.duplicateGeometry(S, v, r);
          }
        }
      }
    }
    return o;
  }
  duplicateGeometry(e, t, r = !1) {
    if (e instanceof BABYLON.Mesh && t instanceof BABYLON.Mesh) {
      const o = BABYLON.VertexData.ExtractFromMesh(e, !0, !0);
      return new BABYLON.Geometry(
        Zakeke.generateUUID(),
        t.getScene(),
        o,
        r,
        t
      );
    }
    return null;
  }
  // Material metadata
  getSceneMaterialMetadata(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) ? this._scene.metadata.materialsMetadata[e] : null;
  }
  getOrCreateSceneMaterialMetadata(e) {
    let t = this.getSceneMaterialMetadata(e);
    return t || (t = {}, this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.materialsMetadata || (this._scene.metadata.materialsMetadata = {}), this._scene.metadata.materialsMetadata[e] = t), t;
  }
  removeSceneMaterialMetadata(e) {
    this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) && delete this._scene.metadata.materialsMetadata[e];
  }
  offloadAllUnusedMaterials() {
    this.getAllUnusedMaterials().forEach((t) => this.offloadMaterial(t.id));
  }
  // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
  // Lo scopo è quello di liberare la memoria occupata dalle texture
  offloadMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    t && t.id !== "default material" && this.getMeshesUsingMaterial(e).length === 0 && (Logger.info("Offloading material: " + t.id + " - " + t.name), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials || (this._scene.metadata.offloadedMaterials = {}), this._scene.metadata.offloadedMaterials[e] = this.getOffloadedMaterialInfo(t), Logger.info("Disposing material: " + e), t.dispose(!1, !0));
  }
  getOffloadedMaterialInfo(e) {
    return { name: e.name, data: e.serialize() };
  }
  // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
  loadAllOffloadedMaterials(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = this.loadOffloadedMaterials(e, this._scene.metadata.offloadedMaterials)), t;
  }
  loadOffloadedMaterialsByIDs(e, t) {
    let r = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const o = {};
      for (let a = 0; a < t.length; a++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[a]) && (o[t[a]] = {
          name: this._scene.metadata.offloadedMaterials[t[a]].name,
          data: this._scene.metadata.offloadedMaterials[t[a]].data
        });
      r = this.loadOffloadedMaterials(e, o);
    }
    return r;
  }
  loadOffloadedMaterial(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const r = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        r[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const o = this.loadOffloadedMaterials(e, r);
        if (o.length > 0)
          return o[0];
      }
    }
    return null;
  }
  loadOffloadedMaterials(e, t) {
    const r = [];
    for (const o in t) {
      const a = t[o], u = this.loadOffloadedMaterialInternal(o, a.name, e, a.data);
      u && r.push(u);
    }
    return r;
  }
  // Il nome viene passato solo ai fini del log
  loadOffloadedMaterialInternal(e, t, r, o) {
    const a = this._scene.getMaterialByID(e);
    if (a)
      return a;
    const u = t ? ` - ${t}` : "";
    return Logger.info("Loading offloaded material: " + e + u), BABYLON.Material.Parse(o, this._scene, r);
  }
  // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
  async loadAllOffloadedMaterialsAsync(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = await this.loadOffloadedMaterialsAsync(e, this._scene.metadata.offloadedMaterials)), t;
  }
  async loadOffloadedMaterialsByIDsAsync(e, t) {
    let r = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const o = {};
      for (let a = 0; a < t.length; a++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[a]) && (o[t[a]] = {
          name: this._scene.metadata.offloadedMaterials[t[a]].name,
          data: this._scene.metadata.offloadedMaterials[t[a]].data
        });
      r = await this.loadOffloadedMaterialsAsync(e, o);
    }
    return r;
  }
  async loadOffloadedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const r = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        r[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const o = await this.loadOffloadedMaterialsAsync(e, r);
        if (o.length > 0)
          return o[0];
      }
    }
    return null;
  }
  async loadOffloadedMaterialsAsync(e, t) {
    const r = [], o = [];
    for (const u in t) {
      const f = t[u];
      o.push(this.loadOffloadedMaterialInternalAsync(u, f.name, e, f.data));
    }
    return (await Promise.all(o)).forEach((u) => {
      u && r.push(u);
    }), r;
  }
  // Il nome viene passato solo ai fini del log
  async loadOffloadedMaterialInternalAsync(e, t, r, o) {
    const a = this._scene.getMaterialByID(e);
    if (a)
      return a;
    const u = t ? ` - ${t}` : "";
    Logger.info("Loading offloaded material: " + e + u);
    const f = BABYLON.Material.Parse(o, this._scene, r);
    return f ? (Logger.info("Waiting for material ready: " + e + u), await Sn.whenAllMaterialTexturesAreReady(f), Logger.info("Material ready: " + e + u)) : Logger.info("No material was created from offloaded material: " + e + u), f;
  }
  loadTextureFiles(e, t) {
    if (e)
      for (let r = 0; r < t.length; r++) {
        const o = t[r], a = /^(?:\/|[a-z]+:\/\/)/.test(o);
        let u = o;
        a || (u = e + o);
        const f = u.lastIndexOf("."), v = f > -1 ? u.substring(f).toLowerCase() : "";
        v === ".dds" || v === ".env" || v === ".hdr" ? BABYLON.Tools.LoadFile(u, () => {
        }) : (v === ".png" || v === ".jpg") && BABYLON.Tools.LoadImage(
          u,
          (X) => {
          },
          function() {
          },
          null
        );
      }
  }
  // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getOrLoadMaterialAsync(e, t) {
    let r = this._scene.getMaterialByID(e);
    return !r && this._scene.metadata && (this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e) ? r = await this.loadOffloadedMaterialAsync(t, e) : this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) && (r = await this.loadDelayedMaterialAsync(t, e))), r;
  }
  getOrCreateDummyMaterial() {
    let e = this._scene.getMaterialByID(this._dummyMaterialID);
    return e || (e = new BABYLON.StandardMaterial("Dummy Material", this._scene), e.id = this._dummyMaterialID, e.metadata = { isRealMaterial: !1 }), e;
  }
  isDummyMaterial(e) {
    return e.id === this._dummyMaterialID;
  }
  meshHasDummyMaterial(e, t) {
    var r;
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let o = 0; o < e.subMeshes.length; o++) {
        const u = e.subMeshes[o].materialIndex;
        if (e.material.subMaterials[u] && ((r = e.material.subMaterials[u]) == null ? void 0 : r.id) === this._dummyMaterialID)
          return !0;
      }
    else if (e.material && e.material.id === this._dummyMaterialID)
      return !0;
    if (t) {
      const o = e.getChildMeshes(!0);
      for (const a of o)
        if (this.meshHasDummyMaterial(a, !0))
          return !0;
    }
    return !1;
  }
  getMeshDelayedMaterialIDs(e) {
    var r;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let o = 0; o < e.subMeshes.length; o++) {
        const u = e.subMeshes[o].materialIndex;
        if (e.material.subMaterials[u] && ((r = e.material.subMaterials[u]) == null ? void 0 : r.id) === this._dummyMaterialID) {
          const f = `${e.id}_${u}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(f)) {
            const v = this._scene.metadata.originalMeshMaterials[f];
            this._scene.metadata.delayedMaterials.hasOwnProperty(v) && t.indexOf(v) === -1 && t.push(v);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const o = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.delayedMaterials.hasOwnProperty(o) && t.indexOf(o) === -1 && t.push(o);
    }
    return e.getChildMeshes().forEach(
      (o) => Array.prototype.push.apply(t, this.getMeshDelayedMaterialIDs(o))
    ), t;
  }
  getMeshOffloadedMaterialIDs(e) {
    var r;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let o = 0; o < e.subMeshes.length; o++) {
        const u = e.subMeshes[o].materialIndex;
        if (e.material.subMaterials[u] && ((r = e.material.subMaterials[u]) == null ? void 0 : r.id) === this._dummyMaterialID) {
          const f = `${e.id}_${u}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(f)) {
            const v = this._scene.metadata.originalMeshMaterials[f];
            this._scene.metadata.offloadedMaterials.hasOwnProperty(v) && t.indexOf(v) === -1 && t.push(v);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const o = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.offloadedMaterials.hasOwnProperty(o) && t.indexOf(o) === -1 && t.push(o);
    }
    return e.getChildMeshes().forEach(
      (o) => Array.prototype.push.apply(t, this.getMeshOffloadedMaterialIDs(o))
    ), t;
  }
  setDummyMaterialToInvisibleMeshes() {
    this.getInvisibleMeshes().forEach((t) => {
      this.setMeshDummyMaterial(t, !1);
    });
  }
  setMeshDummyMaterial(e, t) {
    this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.originalMeshMaterials || (this._scene.metadata.originalMeshMaterials = {});
    const r = this.getOrCreateDummyMaterial();
    if (e.material)
      if (e.subMeshes && e.subMeshes.length > 0 && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const u = e.subMeshes[o].materialIndex, f = e.material.subMaterials[u];
          if (f && !this.isDummyMaterial(f)) {
            const v = `${e.id}_${u}`;
            this._scene.metadata.originalMeshMaterials[v] = f.id, e.material.subMaterials[u] = r;
          }
        }
      else
        e.material && !this.isDummyMaterial(e.material) && (this._scene.metadata.originalMeshMaterials[e.id] = e.material.id, e.material = r);
    t && e.getChildMeshes().forEach((o) => this.setMeshDummyMaterial(o, !0));
  }
  // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
  unsetAllDummyMaterials() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      this.unsetMeshDummyMaterial(this._scene.meshes[e], !1);
  }
  // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
  async unsetAllDummyMaterialsAsync(e) {
    for (let t = 0; t < this._scene.meshes.length; t++)
      await this.unsetMeshDummyMaterialAsync(this._scene.meshes[t], e, !1);
  }
  // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
  unsetMeshDummyMaterial(e, t) {
    var r;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const u = e.subMeshes[o].materialIndex;
          if (e.material.subMaterials[u] && ((r = e.material.subMaterials[u]) == null ? void 0 : r.id) === this._dummyMaterialID) {
            const f = `${e.id}_${u}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(f)) {
              const v = this._scene.metadata.originalMeshMaterials[f], S = this._scene.getMaterialByID(v);
              S && (e.material.subMaterials[u] = S, delete this._scene.metadata.originalMeshMaterials[f]);
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const o = this._scene.metadata.originalMeshMaterials[e.id], a = this._scene.getMaterialByID(o);
        a && (e.material = a, delete this._scene.metadata.originalMeshMaterials[e.id]);
      }
      t && e.getChildMeshes().forEach((o) => this.unsetMeshDummyMaterial(o, !0));
    }
  }
  // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
  async unsetMeshDummyMaterialAsync(e, t, r) {
    var o;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let a = 0; a < e.subMeshes.length; a++) {
          const f = e.subMeshes[a].materialIndex;
          if (e.material.subMaterials[f] && ((o = e.material.subMaterials[f]) == null ? void 0 : o.id) === this._dummyMaterialID) {
            const v = `${e.id}_${f}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(v)) {
              const S = this._scene.metadata.originalMeshMaterials[v], I = await this.getOrLoadMaterialAsync(S, t);
              e.material.subMaterials[f] = I, delete this._scene.metadata.originalMeshMaterials[v];
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const a = this._scene.metadata.originalMeshMaterials[e.id], u = await this.getOrLoadMaterialAsync(a, t);
        e.material = u, delete this._scene.metadata.originalMeshMaterials[e.id];
      }
      if (r) {
        const a = e.getChildMeshes();
        for (const u of a)
          await this.unsetMeshDummyMaterialAsync(u, t, !0);
      }
    }
  }
  async reloadAllLoadingErrorTexturesAsync(e) {
    for (const t of this._scene.textures)
      await this.reloadLoadingErrorTextureAsync(e, t);
  }
  async reloadMaterialLoadingErrorTexturesAsync(e, t) {
    for (const r of t.getActiveTextures())
      await this.reloadLoadingErrorTextureAsync(e, r);
  }
  reloadLoadingErrorTextureAsync(e, t) {
    if (t instanceof BABYLON.Texture && t.url) {
      const o = t.getInternalTexture();
      if (t.loadingError || o && o.loadingError) {
        const a = t.url, u = /^(?:\/|[a-z]+:\/\/)/.test(t.url);
        var r = t.url;
        return u || (r = e + t.url), new Promise((f, v) => {
          t.updateURL(
            r,
            null,
            () => {
              t.url = a, f();
            },
            void 0,
            () => {
              t.url = a, v();
            }
          );
        });
      }
    }
    return Promise.resolve();
  }
  isTextureLoadingError(e) {
    if (e.loadingError)
      return !0;
    const t = e.getInternalTexture();
    return t !== null && t.loadingError;
  }
  materialHasLoadingErrorTextues(e) {
    return e.getActiveTextures().some((t) => this.isTextureLoadingError(t));
  }
  // A dynamic texture is a procedural texture or a texture created from a Blob
  getMaterialDynamicTextures(e) {
    return e.getActiveTextures().filter(
      (r) => r instanceof BABYLON.ProceduralTexture || r instanceof BABYLON.Texture && r.url && r.url.indexOf("blob:") !== -1
    );
  }
  exportTextureToBase64Async(e, t = "image/png", r = !1) {
    return Promise.resolve().then(async () => {
      const o = await this.getPixelsFromTexture(e);
      if (!o)
        return null;
      const a = e.getSize();
      if (e.mimeType)
        switch (e.mimeType) {
          case "image/jpeg":
            t = "image/jpeg";
            break;
          case "image/png":
            t = "image/png";
            break;
        }
      return this.createBase64FromCanvasAsync(o, a.width, a.height, t, r);
    });
  }
  createBase64FromCanvasAsync(e, t, r, o, a = !1) {
    return new Promise(async (u, f) => {
      const v = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, S = this._scene, I = S.getEngine(), D = I.createRawTexture(
        e,
        t,
        r,
        BABYLON.Constants.TEXTUREFORMAT_RGBA,
        !1,
        a,
        BABYLON.Texture.NEAREST_SAMPLINGMODE,
        null,
        v
      );
      await BABYLON.TextureTools.ApplyPostProcess(
        "pass",
        D,
        S,
        v,
        BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE,
        BABYLON.Constants.TEXTUREFORMAT_RGBA
      );
      const Z = await I._readTexturePixels(D, t, r), M = await BABYLON.Tools.DumpDataAsync(
        t,
        r,
        Z,
        o,
        void 0,
        !0,
        !1
      );
      u(M);
    });
  }
  getPixelsFromTexture(e) {
    return e.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, e.readPixels();
  }
  comparePBRMaterials(e, t) {
    (e.albedoColor && !t.albedoColor || !e.albedoColor && t.albedoColor || e.albedoColor && t.albedoColor && !e.albedoColor.equals(t.albedoColor)) && console.log("albedoColor"), e.allowShaderHotSwapping !== t.allowShaderHotSwapping && console.log("allowShaderHotSwapping"), e.alphaCutOff !== t.alphaCutOff && console.log("alphaCutOff"), (e.ambientColor && !t.ambientColor || !e.ambientColor && t.ambientColor || e.ambientColor && t.ambientColor && !e.ambientColor.equals(t.ambientColor)) && console.log("ambientColor"), e.ambientTextureStrength !== t.ambientTextureStrength && console.log("ambientTextureStrength"), this.compareAnisotropy(e.anisotropy, t.anisotropy), this.compareBRDF(e.brdf, t.brdf), this.compareClearCoat(e.clearCoat, t.clearCoat), e.depthFunction !== t.depthFunction && console.log("depthFunction"), this.compareDetailMap(e.detailMap, t.detailMap), e.directIntensity !== t.directIntensity && console.log("directIntensity"), e.disableBumpMap !== t.disableBumpMap && console.log("disableBumpMap"), e.disableColorWrite !== t.disableColorWrite && console.log("disableColorWrite"), e.disableDepthWrite !== t.disableDepthWrite && console.log("disableDepthWrite"), e.disableLighting !== t.disableLighting && console.log("disableLighting"), (e.emissiveColor && !t.emissiveColor || !e.emissiveColor && t.emissiveColor || e.emissiveColor && t.emissiveColor && !e.emissiveColor.equals(t.emissiveColor)) && console.log("emissiveColor"), e.emissiveIntensity !== t.emissiveIntensity && console.log("emissiveIntensity"), e.enableSpecularAntiAliasing !== t.enableSpecularAntiAliasing && console.log("enableSpecularAntiAliasing"), e.environmentIntensity !== t.environmentIntensity && console.log("environmentIntensity"), e.forceAlphaTest !== t.forceAlphaTest && console.log("forceAlphaTest"), e.forceDepthWrite !== t.forceDepthWrite && console.log("forceDepthWrite"), e.forceIrradianceInFragment !== t.forceIrradianceInFragment && console.log("forceIrradianceInFragment"), e.forceNormalForward !== t.forceNormalForward && console.log("forceNormalForward"), e.invertNormalMapX !== t.invertNormalMapX && console.log("invertNormalMapX"), e.invertNormalMapY !== t.invertNormalMapY && console.log("invertNormalMapY"), e.maxSimultaneousLights !== t.maxSimultaneousLights && console.log("maxSimultaneousLights"), e.metallic !== t.metallic && console.log("metallic"), e.metallicF0Factor !== t.metallicF0Factor && console.log("metallicF0Factor"), (e.metallicReflectanceColor && !t.metallicReflectanceColor || !e.metallicReflectanceColor && t.metallicReflectanceColor || e.metallicReflectanceColor && t.metallicReflectanceColor && !e.metallicReflectanceColor.equals(t.metallicReflectanceColor)) && console.log("metallicReflectanceColor"), e.microSurface !== t.microSurface && console.log("microSurface"), e.parallaxScaleBias !== t.parallaxScaleBias && console.log("parallaxScaleBias"), e.pointSize !== t.pointSize && console.log("pointSize"), this.comparePrePassConfiguration(e.prePassConfiguration, t.prePassConfiguration), (e.reflectionColor && !t.reflectionColor || !e.reflectionColor && t.reflectionColor || e.reflectionColor && t.reflectionColor && !e.reflectionColor.equals(t.reflectionColor)) && console.log("reflectionColor"), (e.reflectivityColor && !t.reflectivityColor || !e.reflectivityColor && t.reflectivityColor || e.reflectivityColor && t.reflectivityColor && !e.reflectivityColor.equals(t.reflectivityColor)) && console.log("reflectivityColor"), e.roughness !== t.roughness && console.log("roughness"), e.separateCullingPass !== t.separateCullingPass && console.log("separateCullingPass"), this.compareSheen(e.sheen, t.sheen), e.sideOrientation !== t.sideOrientation && console.log("sideOrientation"), e.specularIntensity !== t.specularIntensity && console.log("specularIntensity"), this.compareSubSurface(e.subSurface, t.subSurface), e.twoSidedLighting !== t.twoSidedLighting && console.log("twoSidedLighting"), e.unlit !== t.unlit && console.log("unlit"), e.useAlphaFresnel !== t.useAlphaFresnel && console.log("useAlphaFresnel"), e.useAlphaFromAlbedoTexture !== t.useAlphaFromAlbedoTexture && console.log("useAlphaFromAlbedoTexture"), e.useAmbientInGrayScale !== t.useAmbientInGrayScale && console.log("useAmbientInGrayScale"), e.useAmbientOcclusionFromMetallicTextureRed !== t.useAmbientOcclusionFromMetallicTextureRed && console.log("useAmbientOcclusionFromMetallicTextureRed"), e.useAutoMicroSurfaceFromReflectivityMap !== t.useAutoMicroSurfaceFromReflectivityMap && console.log("useAutoMicroSurfaceFromReflectivityMap"), e.useHorizonOcclusion !== t.useHorizonOcclusion && console.log("useHorizonOcclusion"), e.useLightmapAsShadowmap !== t.useLightmapAsShadowmap && console.log("useLightmapAsShadowmap"), e.useLinearAlphaFresnel !== t.useLinearAlphaFresnel && console.log("useLinearAlphaFresnel"), e.useMetallnessFromMetallicTextureBlue !== t.useMetallnessFromMetallicTextureBlue && console.log("useMetallnessFromMetallicTextureBlue"), e.useMicroSurfaceFromReflectivityMapAlpha !== t.useMicroSurfaceFromReflectivityMapAlpha && console.log("useMicroSurfaceFromReflectivityMapAlpha"), e.useObjectSpaceNormalMap !== t.useObjectSpaceNormalMap && console.log("useObjectSpaceNormalMap"), e.useOnlyMetallicFromMetallicReflectanceTexture !== t.useOnlyMetallicFromMetallicReflectanceTexture && console.log("useOnlyMetallicFromMetallicReflectanceTexture"), e.useParallax !== t.useParallax && console.log("useParallax"), e.useParallaxOcclusion !== t.useParallaxOcclusion && console.log("useParallaxOcclusion"), e.useRadianceOcclusion !== t.useRadianceOcclusion && console.log("useRadianceOcclusion"), e.useRadianceOverAlpha !== t.useRadianceOverAlpha && console.log("useRadianceOverAlpha"), e.useRoughnessFromMetallicTextureAlpha !== t.useRoughnessFromMetallicTextureAlpha && console.log("useRoughnessFromMetallicTextureAlpha"), e.useRoughnessFromMetallicTextureGreen !== t.useRoughnessFromMetallicTextureGreen && console.log("useRoughnessFromMetallicTextureGreen"), e.useSpecularOverAlpha !== t.useSpecularOverAlpha && console.log("useSpecularOverAlpha"), e.zOffset !== t.zOffset && console.log("zOffset"), e.zOffsetUnits !== t.zOffsetUnits && console.log("zOffsetUnits"), e.alpha !== t.alpha && console.log("alpha"), e.alphaMode !== t.alphaMode && console.log("alphaMode"), e.backFaceCulling !== t.backFaceCulling && console.log("backFaceCulling"), this.compareCameraCurve("", e.cameraColorCurves, t.cameraColorCurves), e.cameraColorCurvesEnabled !== t.cameraColorCurvesEnabled && console.log("cameraColorCurvesEnabled"), e.cameraColorGradingEnabled !== t.cameraColorGradingEnabled && console.log("cameraColorGradingEnabled"), e.cameraContrast !== t.cameraContrast && console.log("cameraContrast"), e.cameraExposure !== t.cameraExposure && console.log("cameraExposure"), e.cameraToneMappingEnabled !== t.cameraToneMappingEnabled && console.log("cameraToneMappingEnabled"), e.canRenderToMRT !== t.canRenderToMRT && console.log("canRenderToMRT"), e.cullBackFaces !== t.cullBackFaces && console.log("cullBackFaces"), e.fillMode !== t.fillMode && console.log("fillMode"), e.fogEnabled !== t.fogEnabled && console.log("fogEnabled"), e.hasRenderTargetTextures !== t.hasRenderTargetTextures && console.log("hasRenderTargetTextures"), this.compareImageProcessingConfiguration(e.imageProcessingConfiguration, t.imageProcessingConfiguration), e.indexOfRefraction !== t.indexOfRefraction && console.log("indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log("invertRefractionY"), e.isFrozen !== t.isFrozen && console.log("isFrozen"), e.isPrePassCapable !== t.isPrePassCapable && console.log("isPrePassCapable"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log("linkRefractionWithTransparency"), e.needDepthPrePass !== t.needDepthPrePass && console.log("needDepthPrePass"), e.realTimeFiltering !== t.realTimeFiltering && console.log("realTimeFiltering"), e.realTimeFilteringQuality !== t.realTimeFilteringQuality && console.log("realTimeFilteringQuality"), e.transparencyMode !== t.transparencyMode && console.log("transparencyMode"), e.useGLTFLightFalloff !== t.useGLTFLightFalloff && console.log("useGLTFLightFalloff"), e.useLogarithmicDepth !== t.useLogarithmicDepth && console.log("useLogarithmicDepth"), e.usePhysicalLightFalloff !== t.usePhysicalLightFalloff && console.log("usePhysicalLightFalloff"), this.compareTexture("albedo", e.albedoTexture, t.albedoTexture), this.compareTexture("emissive", e.emissiveTexture, t.emissiveTexture);
  }
  compareAnisotropy(e, t) {
    const r = "anisotropy";
    (e.direction && !t.direction || !e.direction && t.direction || e.direction && t.direction && !e.direction.equals(t.direction)) && console.log(r + " - direction"), e.intensity !== t.intensity && console.log(r + " - intensity"), e.isEnabled !== t.isEnabled && console.log(r + " - isEnabled");
  }
  compareBRDF(e, t) {
    const r = "brdf";
    e.useEnergyConservation !== t.useEnergyConservation && console.log(r + " - useEnergyConservation"), e.useSmithVisibilityHeightCorrelated !== t.useSmithVisibilityHeightCorrelated && console.log(r + " - useSmithVisibilityHeightCorrelated"), e.useSpecularGlossinessInputEnergyConservation !== t.useSpecularGlossinessInputEnergyConservation && console.log(r + " - useSpecularGlossinessInputEnergyConservation"), e.useSphericalHarmonics !== t.useSphericalHarmonics && console.log(r + " - useSphericalHarmonics");
  }
  compareClearCoat(e, t) {
    const r = "clearCoat";
    e.indexOfRefraction !== t.indexOfRefraction && console.log(r + " - indexOfRefraction"), e.intensity !== t.intensity && console.log(r + " - intensity"), e.isEnabled !== t.isEnabled && console.log(r + " - isEnabled"), e.isTintEnabled !== t.isTintEnabled && console.log(r + " - isTintEnabled"), e.roughness !== t.roughness && console.log(r + " - roughness"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(r + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(r + " - tintColorAtDistance"), e.tintThickness !== t.tintThickness && console.log(r + " - tintThickness"), e.useRoughnessFromMainTexture != t.useRoughnessFromMainTexture && console.log(r + " - useRoughnessFromMainTexture");
  }
  compareDetailMap(e, t) {
    const r = "detailMap";
    e.bumpLevel !== t.bumpLevel && console.log(r + " - bumpLevel"), e.diffuseBlendLevel !== t.diffuseBlendLevel && console.log(r + " - diffuseBlendLevel"), e.isEnabled !== t.isEnabled && console.log(r + " - isEnabled"), e.normalBlendMethod !== t.normalBlendMethod && console.log(r + " - normalBlendMethod"), e.roughnessBlendLevel !== t.roughnessBlendLevel && console.log(r + " - roughnessBlendLevel");
  }
  comparePrePassConfiguration(e, t) {
    const r = "PrePassConfiguration";
    (e.currentViewProjection && !t.currentViewProjection || !e.currentViewProjection && t.currentViewProjection || e.currentViewProjection && t.currentViewProjection && !e.currentViewProjection.equals(t.currentViewProjection)) && console.log(r + " - currentViewProjection"), (e.previousViewProjection && !t.previousViewProjection || !e.previousViewProjection && t.previousViewProjection || e.previousViewProjection && t.previousViewProjection && !e.previousViewProjection.equals(t.previousViewProjection)) && console.log(r + " - previousViewProjection");
  }
  compareSheen(e, t) {
    const r = "Sheen";
    e.albedoScaling !== t.albedoScaling && console.log(r + " - albedoScaling"), (e.color && !t.color || !e.color && t.color || e.color && t.color && !e.color.equals(t.color)) && console.log(r + " - color"), e.intensity !== t.intensity && console.log(r + " - intensity"), e.isEnabled !== t.isEnabled && console.log(r + " - isEnabled"), e.linkSheenWithAlbedo !== t.linkSheenWithAlbedo && console.log(r + " - linkSheenWithAlbedo"), e.roughness !== t.roughness && console.log(r + " - roughness"), e.useRoughnessFromMainTexture !== t.useRoughnessFromMainTexture && console.log(r + " - useRoughnessFromMainTexture");
  }
  compareSubSurface(e, t) {
    const r = "SubSurface";
    (e.diffusionDistance && !t.diffusionDistance || !e.diffusionDistance && t.diffusionDistance || e.diffusionDistance && t.diffusionDistance && !e.diffusionDistance.equals(t.diffusionDistance)) && console.log(r + " - diffusionDistance"), e.indexOfRefraction !== t.indexOfRefraction && console.log(r + " - indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log(r + " - invertRefractionY"), e.isRefractionEnabled !== t.isRefractionEnabled && console.log(r + " - isRefractionEnabled"), e.isScatteringEnabled !== t.isScatteringEnabled && console.log(r + " - isScatteringEnabled"), e.isTranslucencyEnabled !== t.isTranslucencyEnabled && console.log(r + " - isTranslucencyEnabled"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log(r + " - linkRefractionWithTransparency"), e.maximumThickness !== t.maximumThickness && console.log(r + " - maximumThickness"), e.minimumThickness !== t.minimumThickness && console.log(r + " - minimumThickness"), e.refractionIntensity !== t.refractionIntensity && console.log(r + " - refractionIntensity"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(r + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(r + " - tintColorAtDistance"), e.translucencyIntensity !== t.translucencyIntensity && console.log(r + " - translucencyIntensity"), e.useAlbedoToTintRefraction !== t.useAlbedoToTintRefraction && console.log(r + " - useAlbedoToTintRefraction"), e.useAlbedoToTintTranslucency !== t.useAlbedoToTintTranslucency && console.log(r + " - useAlbedoToTintTranslucency"), e.useGltfStyleTextures !== t.useGltfStyleTextures && console.log(r + " - useGltfStyleTextures"), e.useMaskFromThicknessTexture !== t.useMaskFromThicknessTexture && console.log(r + " - useMaskFromThicknessTexture"), e.useThicknessAsDepth !== t.useThicknessAsDepth && console.log(r + " - useThicknessAsDepth");
  }
  compareCameraCurve(e, t, r) {
    if ((t === null && r !== null || t !== null && r === null) && console.log("cameraColorCurves"), t && r) {
      const o = e ? e + " - cameraColorCurves" : "cameraColorCurves";
      t.globalDensity !== r.globalDensity && console.log(o + " - globalDensity"), t.globalExposure !== r.globalExposure && console.log(o + "- globalExposure"), t.globalHue !== r.globalHue && console.log(o + " - globalHue"), t.globalSaturation !== r.globalSaturation && console.log(o + " - globalSaturation"), t.highlightsDensity !== r.highlightsDensity && console.log(o + " - highlightsDensity"), t.highlightsExposure !== r.highlightsExposure && console.log(o + " - highlightsExposure"), t.highlightsHue !== r.highlightsHue && console.log(o + " - highlightsHue"), t.highlightsSaturation !== r.highlightsSaturation && console.log(o + " - highlightsSaturation"), t.midtonesDensity !== r.midtonesDensity && console.log(o + " - midtonesDensity"), t.midtonesExposure !== r.midtonesExposure && console.log(o + " - midtonesExposure"), t.midtonesHue !== r.midtonesHue && console.log(o + " - midtonesHue"), t.midtonesSaturation !== r.midtonesSaturation && console.log(o + " - midtonesSaturation"), t.shadowsDensity !== r.shadowsDensity && console.log(o + " - shadowsDensity"), t.shadowsExposure !== r.shadowsExposure && console.log(o + " - shadowsExposure"), t.shadowsHue !== r.shadowsHue && console.log(o + " - shadowsHue"), t.shadowsSaturation !== r.shadowsSaturation && console.log(o + " - shadowsSaturation");
    }
  }
  compareImageProcessingConfiguration(e, t) {
    const r = "imageProcessingConfiguration";
    this.compareCameraCurve(r, e.colorCurves, t.colorCurves), e.vignetteCameraFov !== t.vignetteCameraFov && console.log(r + " - vignetteCameraFov"), e.vignetteCentreX !== t.vignetteCentreX && console.log(r + " - vignetteCentreX"), e.vignetteCentreY !== t.vignetteCentreY && console.log(r + " - vignetteCentreY"), (e.vignetteColor && !t.vignetteColor || !e.vignetteColor && t.vignetteColor || e.vignetteColor && t.vignetteColor && !e.vignetteColor.equals(t.vignetteColor)) && console.log(r + " - vignetteColor"), e.vignetteStretch !== t.vignetteStretch && console.log(r + " - vignetteStretch"), e.vignetteWeight !== t.vignetteWeight && console.log(r + " - vignetteWeight"), e.applyByPostProcess !== t.applyByPostProcess && console.log(r + " - applyByPostProcess"), e.colorCurvesEnabled !== t.colorCurvesEnabled && console.log(r + " - colorCurvesEnabled"), e.colorGradingBGR !== t.colorGradingBGR && console.log(r + " - colorGradingBGR"), e.colorGradingEnabled !== t.colorGradingEnabled && console.log(r + " - colorGradingEnabled"), e.colorGradingWithGreenDepth !== t.colorGradingWithGreenDepth && console.log(r + " - colorGradingWithGreenDepth"), e.contrast !== t.contrast && console.log(r + " - contrast"), e.exposure !== t.exposure && console.log(r + " - exposure"), e.isEnabled !== t.isEnabled && console.log(r + " - isEnabled"), e.toneMappingEnabled !== t.toneMappingEnabled && console.log(r + " - toneMappingEnabled"), e.toneMappingType !== t.toneMappingType && console.log(r + " - toneMappingType"), e.vignetteBlendMode !== t.vignetteBlendMode && console.log(r + " - vignetteBlendMode"), e.vignetteEnabled !== t.vignetteEnabled && console.log(r + " - vignetteEnabled");
  }
  compareTexture(e, t, r) {
    if (t && !r || !t && r) {
      console.log(e);
      return;
    }
    if (t instanceof BABYLON.Texture && !(r instanceof BABYLON.Texture) || r instanceof BABYLON.Texture && !(t instanceof BABYLON.Texture)) {
      console.log(e);
      return;
    }
    t && r && (t.anisotropicFilteringLevel !== r.anisotropicFilteringLevel && console.log(e + " - anisotropicFilteringLevel"), t instanceof BABYLON.Texture && r instanceof BABYLON.Texture && (t.homogeneousRotationInUVTransform !== r.homogeneousRotationInUVTransform && console.log(e + " - homogeneousRotationInUVTransform"), t.uAng !== r.uAng && console.log(e + " - uAng"), t.uOffset !== r.uOffset && console.log(e + " - uOffset"), t.uRotationCenter !== r.uRotationCenter && console.log(e + " - uRotationCenterSearch"), t.uScale !== r.uScale && console.log(e + " - uScale"), t.vAng !== r.vAng && console.log(e + " - vAng"), t.vOffset !== r.vOffset && console.log(e + " - vOffset"), t.vRotationCenter !== r.vRotationCenter && console.log(e + " - vRotationCenterSearch"), t.vScale !== r.vScale && console.log(e + " - vScale"), t.wAng !== r.wAng && console.log(e + " - wAng"), t.wRotationCenter !== r.wRotationCenter && console.log(e + " - wRotationCenterSearch"), t.invertY !== r.invertY && console.log(e + " - invertY"), t.mimeType !== r.mimeType && console.log(e + " - mimeType")), t.invertZ !== r.invertZ && console.log(e + " - invertZ"), t.isRenderTarget !== r.isRenderTarget && console.log(e + " - isRenderTarget"), t.level !== r.level && console.log(e + " - level"), t.wrapR !== r.wrapR && console.log(e + " - wrapR"), t.canRescale !== r.canRescale && console.log(e + " - canRescale"), t.coordinatesIndex !== r.coordinatesIndex && console.log(e + " - coordinatesIndex"), t.coordinatesMode !== r.coordinatesMode && console.log(e + " - coordinatesMode"), t.gammaSpace !== r.gammaSpace && console.log(e + " - gammaSpace"), t.getAlphaFromRGB !== r.getAlphaFromRGB && console.log(e + " - getAlphaFromRGB"), t.hasAlpha !== r.hasAlpha && console.log(e + "- hasAlpha"), t.is2DArray !== r.is2DArray && console.log(e + " - is2DArray"), t.is3D !== r.is3D && console.log(e + " - is3D"), t.isBlocking !== r.isBlocking && console.log(e + " - isBlocking"), t.isCube !== r.isCube && console.log(e + " - isCube"), t.isRGBD !== r.isRGBD && console.log(e + " - isRGBD"), t.linearSpecularLOD !== r.linearSpecularLOD && console.log(e + " - linearSpecularLOD"), t.lodGenerationOffset !== r.lodGenerationOffset && console.log(e + " - lodGenerationOffset"), t.lodGenerationScale !== r.lodGenerationScale && console.log(e + " - lodGenerationScale"), t.noMipmap !== r.noMipmap && console.log(e + " - noMipmap"), t.samplingMode !== r.samplingMode && console.log(e + " - samplingMode"), t.textureFormat !== r.textureFormat && console.log(e + " - textureFormat"), t.textureType !== r.textureType && console.log(e + " - textureType"), t.wrapU !== r.wrapU && console.log(e + " - wrapU"), t.wrapV !== r.wrapV && console.log(e + " - wrapV"));
  }
  async showResizableCanvas(e, t, r, o, a, u, f, v, S) {
    if (!this._isLoading) {
      if (this._isLoading = !0, this._scene) {
        this.clearResizableMeshes();
        const I = this._resizableCanvas3DGenerator.generatePreview3D(
          {
            width: e,
            height: t,
            depth: r,
            borderRadius: o,
            radiusResolution: 0.1,
            type: a,
            borderColor: u,
            columns: f,
            rows: v,
            useCheckerTexture: !1
          },
          this._scene
        ), D = await BABYLON.SceneLoader.ImportMeshAsync(
          "",
          "",
          "data:" + JSON.stringify(I)
        );
        this._loadedMeshes.push(...D.meshes);
        const Z = D.meshes[0], M = 2 / Math.max(e, t);
        if (Z.scaling.scaleInPlace(M), Z.position.z = 0, Z.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL), this.camera && this.camera instanceof BABYLON.ArcRotateCamera && this.camera.setPosition(new BABYLON.Vector3(0, 1, 4)), !this._scene.lights.find((ie) => ie.name === "resizableLight")) {
          console.log("Creating light...");
          const ie = new BABYLON.HemisphericLight(
            "resizableLight",
            new BABYLON.Vector3(0.1, 1, 0.1),
            this._scene
          );
          ie.groundColor = new BABYLON.Color3(0.6, 0.6, 0.6), ie.intensity = 1;
          const G = this.getDefaultHemisphericLight();
          G && this._scene.removeLight(G);
        }
        const Y = D.meshes.find((ie) => !ie.parent);
        return Y.metadata = {
          isResizable: !0,
          AR: !0,
          sizecm: {
            height: t / S
          }
        }, this._isLoading = !1, D.meshes;
      }
      return this._isLoading = !1, null;
    }
  }
  /**
   * Remove all meshes from the scene
   */
  clearResizableMeshes() {
    this._scene.meshes.filter((e) => {
      var t;
      return (t = e.metadata) == null ? void 0 : t.isResizable;
    }).forEach((e) => e.dispose());
  }
  switchMode(e) {
    var o;
    console.log("Switch 3D mode", e);
    const t = this._scene.lights.find((a) => a.name === "resizableLight"), r = this.getDefaultHemisphericLight();
    e === "resizable" ? this._lastVisibilityStates.size === 0 && ((o = this._scene) == null || o.meshes.forEach((a) => {
      (!a.metadata || !a.metadata.isResizable) && (this._lastVisibilityStates.set(a, a.isVisible), a.isVisible = !1);
    })) : (t && (t.dispose(), this._scene.removeLight(t)), r && this._scene.addLight(r), this._lastVisibilityStates.forEach((a, u) => u.isVisible = a), this._lastVisibilityStates.clear(), this.clearResizableMeshes());
  }
  async rotate(e, t, r) {
    return new Promise((o) => {
      if (this._scene) {
        console.log(`Rotating scene on axis ${t} by ${e} degrees`);
        const a = e * Math.PI / 180;
        this._scene.meshes.filter((u) => !u.parent).forEach((u) => {
          if (!r)
            u.rotate(t, a, BABYLON.Space.WORLD), o();
          else {
            const f = u.rotationQuaternion ?? u.rotation.toQuaternion(), v = BABYLON.Quaternion.RotationAxis(t, a).multiply(
              f
            ), S = BABYLON.Animation.CreateAndStartAnimation(
              u.id + "rotation",
              u,
              "rotationQuaternion",
              60,
              20,
              f,
              v,
              BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT,
              void 0,
              () => {
                S == null || S.stop(), o();
              }
            );
          }
        });
      }
    });
  }
};
wd._shadowGenerator = null;
let yi = wd;
class Zs extends BABYLON.ProceduralTexture {
  constructor(e, t, r, o, a, u, f) {
    super(e, t, r, o, u, f), this._initializing = !1, this._baseTexture = a, this.updateShaderUniforms();
  }
  get initializing() {
    return this._initializing;
  }
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  isReadyAsync() {
    return yi.whenTextureIsReadyAsync(this);
  }
  dispose() {
    super.dispose(), this._baseTexture && this._baseTexture.dispose();
  }
  beginInit() {
    this._initializing = !0;
  }
  endInit() {
    this._initializing = !1, this.updateShaderUniforms();
  }
  updateShaderUniforms() {
    this._initializing || this.setBaseTextureUniform();
  }
  setBaseTextureUniform() {
    this.setTexture("uSampler", this._baseTexture);
  }
}
const nu = class Sd extends Zs {
  constructor(e, t, r, o, a, u) {
    super(e, t, Sd.FRAGMENT_SHADER, r, o, a, u), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  //@BABYLON.serialize()
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurXProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurXProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurXProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
nu.FRAGMENT_SHADER = "zakeke_BlurXProceduralTexture";
nu.CUSTOM_TYPE = "Zakeke.BlurXProceduralTexture";
let so = nu;
const ax = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], ox = ax.join(`
`);
BABYLON.Effect.ShadersStore[`${so.FRAGMENT_SHADER}PixelShader`] = ox;
const ru = class Md extends Zs {
  constructor(e, t, r, o, a, u) {
    super(e, t, Md.FRAGMENT_SHADER, r, o, a, u), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurYProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurYProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurYProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
ru.FRAGMENT_SHADER = "zakeke_BlurYProceduralTexture";
ru.CUSTOM_TYPE = "Zakeke.BlurYProceduralTexture";
let ao = ru;
const lx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], hx = lx.join(`
`);
BABYLON.Effect.ShadersStore[`${ao.FRAGMENT_SHADER}PixelShader`] = hx;
const su = class Cd extends Zs {
  constructor(e, t, r, o, a, u) {
    super(e, t, Cd.FRAGMENT_SHADER, r, o, a, u), this._foreColor = new BABYLON.Vector3(1, 1, 1), this._backColor = new BABYLON.Vector3(0, 0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get foreColor() {
    return this._foreColor;
  }
  set foreColor(e) {
    this._foreColor = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get backColor() {
    return this._backColor;
  }
  set backColor(e) {
    this._backColor = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._foreColor || new BABYLON.Vector3(1, 1, 1), t = this._backColor || new BABYLON.Vector3(0, 0, 0);
    this.setVector3("foreColor", e), this.setVector3("backColor", t);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = ForegroundBackgroundProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): ForegroundBackgroundProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new ForegroundBackgroundProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
su.FRAGMENT_SHADER = "zakeke_ForegroundBackgroundProceduralTexture";
su.CUSTOM_TYPE = "Zakeke.ForegroundBackgroundProceduralTexture";
let oo = su;
const ux = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec3 foreColor;",
  "uniform vec3 backColor;",
  "void main(void) {",
  "   // background color",
  "   vec4 background = vec4(backColor.xyz, 1);",
  "   vec4 foreground = vec4(foreColor.xyz, 1);",
  "   // texel",
  "	vec4 t0 = texture2D(uSampler, vUV.xy);",
  "   // change in white",
  "   t0 = vec4(foreground.xyz, t0.a);",
  "   gl_FragColor = mix(background, t0, t0.a);",
  "}"
], cx = ux.join(`
`);
BABYLON.Effect.ShadersStore[`${oo.FRAGMENT_SHADER}PixelShader`] = cx;
const au = class Ad extends Zs {
  constructor(e, t, r, o, a, u) {
    super(e, t, Ad.FRAGMENT_SHADER, r, o, a, u), this._offset = new BABYLON.Vector2(0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector2()
  get offset() {
    return this._offset;
  }
  set offset(e) {
    this._offset = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this.getRenderSize(), t = this._offset || new BABYLON.Vector2();
    this.setVector2("offset", new BABYLON.Vector2(t.x / e, t.y / e));
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = MoveProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): MoveProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new MoveProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
au.FRAGMENT_SHADER = "zakeke_MoveProceduralTexture";
au.CUSTOM_TYPE = "Zakeke.MoveProceduralTexture";
let ou = au;
const fx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec2 offset;",
  "void main(void) {",
  "   // translated texel",
  "   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));",
  //'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
  "}"
], dx = fx.join(`
`);
BABYLON.Effect.ShadersStore[`${ou.FRAGMENT_SHADER}PixelShader`] = dx;
const lu = class Td extends Zs {
  constructor(e, t, r, o, a, u, f) {
    super(e, t, Td.FRAGMENT_SHADER, r, o, u, f), this._blendTexture = a, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
lu.FRAGMENT_SHADER = "zakeke_MultiplyProceduralTexture";
lu.CUSTOM_TYPE = "Zakeke.MultiplyProceduralTexture";
let eo = lu;
const gx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = base * blend;",
  "}"
], px = gx.join(`
`);
BABYLON.Effect.ShadersStore[`${eo.FRAGMENT_SHADER}PixelShader`] = px;
const hu = class Ld extends Zs {
  constructor(e, t, r, o, a, u) {
    super(e, t, Ld.FRAGMENT_SHADER, r, o, a, u), this._bias = 50, this._invertR = !1, this._invertG = !1, this._bevel = !1, this._intensity = 0.5, this.updateShaderUniforms();
  }
  get bias() {
    return this._bias == null ? 50 : this._bias;
  }
  set bias(e) {
    this._bias = e, this.updateShaderUniforms();
  }
  get invertR() {
    return this._invertR == null ? !1 : this._invertR;
  }
  set invertR(e) {
    this._invertR = e, this.updateShaderUniforms();
  }
  get invertG() {
    return this._invertG == null ? !1 : this._invertG;
  }
  set invertG(e) {
    this._invertG = e, this.updateShaderUniforms();
  }
  get bevel() {
    return this._bevel == null ? !1 : this._bevel;
  }
  set bevel(e) {
    this._bevel = e, this.updateShaderUniforms();
  }
  get intensity() {
    return this._intensity == null ? 0.5 : this._intensity;
  }
  set intensity(e) {
    this._intensity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = this.getRenderSize(), t = e < 1024 ? e * 2 : e;
      this.setFloat("size", e), this.setVector2("u_textureSize", new BABYLON.Vector2(e, e)), this.setVector3("dimensions", new BABYLON.Vector3(t, t, 0)), this.setFloat("bias", this.bias), this.setFloat("invertR", this.invertR ? -1 : 1), this.setFloat("invertG", this.invertG ? -1 : 1), this.setFloat("bevel", this.bevel ? 1 : 0), this.setFloat("intensity", this.intensity);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
hu.FRAGMENT_SHADER = "zakeke_normalMapProceduralTexture";
hu.CUSTOM_TYPE = "Zakeke.NormalMapProceduralTexture";
let Bd = hu;
const _x = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform vec3 dimensions;",
  "uniform sampler2D uSampler;",
  "uniform vec2 u_textureSize;",
  "uniform float bias;",
  "uniform float invertR;",
  "uniform float invertG;",
  "uniform float bevel;",
  "uniform float intensity;",
  "void main(void) {",
  "   vec2 step = vec2(1.0, 1.0) / dimensions.xy;",
  "   vec4 black = vec4(0, 0, 0, 1);",
  "	vec4 bk = vec4(1, 1, 1, 1);",
  "	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));",
  "	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));",
  "	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));",
  "	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));",
  "	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));",
  "   if (bevel != 0.0) ",
  "   {",
  "      t0 = vec4(0, 0, 0, t0.a);",
  "      t1 = vec4(0, 0, 0, t1.a);",
  "      t2 = vec4(0, 0, 0, t2.a);",
  "      t3 = vec4(0, 0, 0, t3.a);",
  "      t4 = vec4(0, 0, 0, t4.a);",
  "   }",
  "	t0 = mix(bk, t0, t0.a);",
  "	t1 = mix(bk, t1, t1.a);",
  "	t2 = mix(bk, t2, t2.a);",
  "	t3 = mix(bk, t3, t3.a);",
  "	t4 = mix(bk, t4, t4.a);",
  "	float d0 = abs(t0.r);",
  "	float d1 = abs(t1.r);",
  "	float d2 = abs(t2.r);",
  "	float d3 = abs(t3.r);",
  "	float d4 = abs(t4.r);",
  "	float dx = ((d2 - d0) + (d0 - d1)) * intensity;",
  "	float dy = ((d4 - d0) + (d0 - d3)) * intensity;",
  "	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);",
  "	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);",
  "}"
], mx = _x.join(`
`);
BABYLON.Effect.ShadersStore[`${Bd.FRAGMENT_SHADER}PixelShader`] = mx;
const uu = class Ed extends Zs {
  constructor(e, t, r, o, a, u, f) {
    super(e, t, Ed.FRAGMENT_SHADER, r, o, u, f), this._opacity = 1, this.updateShaderUniforms();
  }
  get opacity() {
    return this._opacity == null ? 1 : this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    super.updateShaderUniforms(), !this.initializing && this.setFloat("opacity", this.opacity);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
uu.FRAGMENT_SHADER = "zakeke_OpacityProceduralTexture";
uu.CUSTOM_TYPE = "Zakeke.OpacityProceduralTexture";
let vx = uu;
const yx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform float opacity;",
  "void main(void) {",
  "	vec4 color = texture2D(uSampler, vUV.xy);",
  "   color.a = opacity;",
  "   gl_FragColor = color;",
  "}"
], bx = yx.join(`
`);
BABYLON.Effect.ShadersStore[`${vx.FRAGMENT_SHADER}PixelShader`] = bx;
const cu = class kd extends Zs {
  constructor(e, t, r, o, a, u, f) {
    super(e, t, kd.FRAGMENT_SHADER, r, o, u, f), this._blendTexture = a, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
cu.FRAGMENT_SHADER = "zakeke_OverlayProceduralTexture";
cu.CUSTOM_TYPE = "Zakeke.OverlayProceduralTexture";
let al = cu;
var xx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], wx = xx.join(`
`);
BABYLON.Effect.ShadersStore[`${al.FRAGMENT_SHADER}PixelShader`] = wx;
const fu = class ol extends BABYLON.ProceduralTexture {
  constructor(e, t, r = null, o, a) {
    super(e, t, ol.FRAGMENT_SHADER, r, o, a), this._baseTexture = null, this._blendTexture = null, this.updateShaderUniforms();
  }
  dispose() {
    this._baseTexture && this._baseTexture.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    this._baseTexture ? (this.setTexture("uSampler", this._baseTexture), this.setInt("hasSampler", 1), this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale))) : (this.setInt("hasSampler", 0), this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1))), this._blendTexture ? (this.setTexture("uBlendSampler", this._blendTexture), this.setInt("hasBlend", 1), this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale))) : (this.setInt("hasBlend", 0), this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1))), this.setFloat("size", this.getRenderSize());
  }
  render(e) {
    super.render(e);
  }
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  isReady() {
    return this._baseTexture && !this._baseTexture.isReady() || this._blendTexture && !this._blendTexture.isReady() ? !1 : super.isReady();
  }
  //@BABYLON.serializeAsTexture()
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  /**
   * Serializes this normal map procedural texture
   * @returns a serialized normal map procedural texture object
   */
  serialize() {
    var e = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    return e.customType = ol.CUSTOM_TYPE, this.baseTexture ? e.baseTexture = this.baseTexture.serialize() : e.baseTexture = null, this.blendTexture ? e.blendTexture = this.blendTexture.serialize() : e.blendTexture = null, e;
  }
  /**
   * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
   * @param parsedTexture defines parsed texture data
   * @param scene defines the current scene
   * @param rootUrl defines the root URL containing normal map procedural texture information
   * @returns a parsed Normal Map Procedural Texture
   */
  static Parse(e, t, r) {
    var o = BABYLON.SerializationHelper.Parse(
      () => new ol(
        e.name,
        e._size,
        t,
        void 0,
        e._generateMipMaps
      ),
      e,
      t,
      r
    );
    return e.baseTexture && (o.baseTexture = BABYLON.Texture.Parse(e.baseTexture, t, r)), e.blendTexture && (o.blendTexture = BABYLON.Texture.Parse(e.blendTexture, t, r)), o;
  }
};
fu.FRAGMENT_SHADER = "zakeke_BlendProceduralTexture";
fu.CUSTOM_TYPE = "Zakeke.BlendProceduralTexture";
let Id = fu;
var Sx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "uniform bool hasSampler;",
  "uniform bool hasBlend;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "   if (!hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);",
  "       return;",
  "   }",
  "   if (hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "       return;",
  "   }",
  "   if (!hasSampler && hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "       return;",
  "   }",
  "   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], Mx = Sx.join(`
`);
BABYLON.Effect.ShadersStore[`${Id.FRAGMENT_SHADER}PixelShader`] = Mx;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", Id);
class Od {
  constructor() {
  }
  getSubmeshIdx(e) {
    let t = e.lastIndexOf("-");
    if (t != -1) {
      e = e.substring(0, t);
      let r = Number(e.substring(t + 1));
      if (r && !isNaN(r))
        return r;
    }
    return null;
  }
  getRegExp(e, t) {
    if ((t & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
      let r = e.lastIndexOf("-");
      r != -1 && (e = e.substring(0, r), Number(e.substring(r + 1)));
    }
    return new RegExp(this.escapeRegExp(e).replace(/\\\*/g, ".*"), "i");
  }
  getElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const Z = this.getMeshes(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let Z = this.getSubmeshIdx(I);
        if (Z) {
          const M = this.getSubMeshes(e, t, r, D, I, Z);
          Array.prototype.push.apply(u, M);
        }
      }
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const Z = this.getMaterials(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
      if ((a & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const Z = this.getLights(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
      if ((a & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const Z = this.getCameras(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
      if ((a & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const Z = this.getCameraLocations(e, t, r, D);
        Array.prototype.push.apply(u, Z);
      }
    }
    return u;
  }
  getMeshElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const Z = this.getMeshes(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
    }
    return u;
  }
  getSubMeshElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let Z = this.getSubmeshIdx(I);
        if (Z) {
          const M = this.getSubMeshes(e, t, r, D, I, Z);
          Array.prototype.push.apply(u, M);
        }
      }
    }
    return u;
  }
  getMaterialElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const Z = this.getMaterials(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
    }
    return u;
  }
  getLightElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const Z = this.getLights(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
    }
    return u;
  }
  getCameraElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const Z = this.getCameras(e, t, r, D, I);
        Array.prototype.push.apply(u, Z);
      }
    }
    return u;
  }
  getCameraLocationElements(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = this.getRegExp(S, a);
      if ((a & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const D = this.getCameraLocations(e, t, r, I);
        Array.prototype.push.apply(u, D);
      }
    }
    return u;
  }
  getOffloadedElementIDs(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let D = 0; D < f.length; D++) {
      const Z = f[D];
      let M = Z;
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var v = Z.lastIndexOf("-");
        v != -1 && (M = Z.substring(0, v), Number(Z.substring(v + 1)));
      }
      var S = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var I = this.getOffloadedMaterialIDs(e, t, r, S, M);
        Array.prototype.push.apply(u, I);
      }
    }
    return u;
  }
  getDelayedElementIDs(e, t, r, o, a) {
    const u = [], f = o.split(";");
    for (let D = 0; D < f.length; D++) {
      const Z = f[D];
      let M = Z;
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var v = Z.lastIndexOf("-");
        v != -1 && (M = Z.substring(0, v), Number(Z.substring(v + 1)));
      }
      var S = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var I = this.getDelayedMaterialIDs(e, t, r, S, M);
        Array.prototype.push.apply(u, I);
      }
    }
    return u;
  }
  getMeshes(e, t, r, o, a) {
    const u = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.meshes.length; f++) {
        const v = t.meshes[f];
        (v.name && o.test(v.name) || v.id && v.id == a) && this.verifyFilter(v.id, r) && u.push(v);
      }
    return u;
  }
  getSubMeshes(e, t, r, o, a, u) {
    const f = [];
    if (t && t instanceof BABYLON.Scene)
      for (let v = 0; v < t.meshes.length; v++) {
        const S = t.meshes[v];
        (S.name && o.test(S.name) || S.id && S.id == a) && this.verifyFilter(S.id, r) && u < S.subMeshes.length && u >= 0 && f.push(S.subMeshes[u]);
      }
    return f;
  }
  getMaterials(e, t, r, o, a) {
    const u = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.materials.length; f++) {
        const v = t.materials[f];
        (v.name && o.test(v.name) || v.id && v.id == a || v.metadata && !v.metadata.isRealMaterial && v.metadata.originalMaterialID == a) && this.verifyFilter(v.id, r) && u.push(v);
      }
    return u;
  }
  getOffloadedMaterialIDs(e, t, r, o, a) {
    const u = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.offloadedMaterials)
      for (let f in t.metadata.offloadedMaterials) {
        const v = t.metadata.offloadedMaterials[f];
        (v.name && o.test(v.name) || f && f == a) && this.verifyFilter(f, r) && u.push(f);
      }
    return u;
  }
  getDelayedMaterialIDs(e, t, r, o, a) {
    const u = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.delayedMaterials)
      for (let f in t.metadata.delayedMaterials) {
        const v = t.metadata.delayedMaterials[f];
        (v.name && o.test(v.name) || f && f == a) && this.verifyFilter(f, r) && u.push(f);
      }
    return u;
  }
  getLights(e, t, r, o, a) {
    const u = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.lights.length; f++) {
        const v = t.lights[f];
        (v.name && o.test(v.name) || v.id && v.id == a) && this.verifyFilter(v.id, r) && u.push(v);
      }
    return u;
  }
  getCameras(e, t, r, o, a) {
    const u = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.cameras.length; f++) {
        const v = t.cameras[f];
        (v.name && o.test(v.name) || v.id && v.id == a) && this.verifyFilter(v.id, r) && u.push(v);
      }
    return u;
  }
  getCameraLocations(e, t, r, o) {
    var a = [];
    if (e && e instanceof Zakeke.Scene)
      for (var u = 0; u < e.get("cameraLocations").length; u++) {
        var f = e.get("cameraLocations").at(u), v = f.getLocationID(), S = f.get("name");
        (S && o.test(S) || v && o.test(v)) && this.verifyFilter(v, r) && a.push(f);
      }
    return a;
  }
  getYesNoElements(e, t, r, o, a) {
    const u = { yes: [], no: [] }, f = o.split(";");
    for (let v = 0; v < f.length; v++) {
      const S = f[v];
      let I = S, D = 0;
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let M = S.lastIndexOf("-");
        if (M != -1) {
          I = S.substring(0, M);
          let X = Number(S.substring(M + 1));
          X && !isNaN(X) && (D = X);
        }
      }
      const Z = new RegExp(this.escapeRegExp(I).replace(/\\\*/g, ".*"), "i");
      if ((a & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const M = this.getYesNoMeshes(e, t, r, Z);
        Array.prototype.push.apply(u.yes, M.yes), Array.prototype.push.apply(u.no, M.no);
      }
      if ((a & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        const M = this.getYesNoSubMeshes(e, t, r, Z, D);
        Array.prototype.push.apply(u.yes, M.yes), Array.prototype.push.apply(u.no, M.no);
      }
      if ((a & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const M = this.getYesNoMaterials(e, t, r, Z);
        Array.prototype.push.apply(u.yes, M.yes), Array.prototype.push.apply(u.no, M.no);
      }
      if ((a & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const M = this.getYesNoLights(e, t, r, Z);
        Array.prototype.push.apply(u.yes, M.yes), Array.prototype.push.apply(u.no, M.no);
      }
      if ((a & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const M = this.getYesNoCameras(e, t, r, Z);
        Array.prototype.push.apply(u.yes, M.yes), Array.prototype.push.apply(u.no, M.no);
      }
      if ((a & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const M = this.getYesNoCameraLocations(e, t, r, Z);
        Array.prototype.push.apply(u.yes, M.yes), Array.prototype.push.apply(u.no, M.no);
      }
    }
    return u;
  }
  getYesNoMeshes(e, t, r, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let u = 0; u < t.meshes.length; u++) {
        let f = t.meshes[u], v = a.no;
        (f.name && o.test(f.name) || f.id && o.test(f.id)) && this.verifyFilter(f.id, r) && (v = a.yes), v.push(f);
      }
    return a;
  }
  getYesNoSubMeshes(e, t, r, o, a) {
    const u = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.meshes.length; f++) {
        let v = t.meshes[f];
        if ((v.name && o.test(v.name) || v.id && o.test(v.id)) && this.verifyFilter(v.id, r) && v.subMeshes)
          for (let S = 0; S < v.subMeshes.length; S++)
            S == a ? u.yes.push(v.subMeshes[S]) : u.no.push(v.subMeshes[S]);
      }
    return u;
  }
  getYesNoMaterials(e, t, r, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let u = 0; u < t.materials.length; u++) {
        let f = t.materials[u];
        (f.name && o.test(f.name) || f.id && o.test(f.id)) && this.verifyFilter(f.id, r) ? a.yes.push(f) : a.no.push(f);
      }
    return a;
  }
  getYesNoLights(e, t, r, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let u = 0; u < t.lights.length; u++) {
        let f = t.lights[u];
        (f.name && o.test(f.name) || f.id && o.test(f.id)) && this.verifyFilter(f.id, r) ? a.yes.push(f) : a.no.push(f);
      }
    return a;
  }
  getYesNoCameras(e, t, r, o) {
    const a = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let u = 0; u < t.cameras.length; u++) {
        let f = t.cameras[u];
        (f.name && o.test(f.name) || f.id && o.test(f.id)) && this.verifyFilter(f.id, r) ? a.yes.push(f) : a.no.push(f);
      }
    return a;
  }
  getYesNoCameraLocations(e, t, r, o) {
    const a = { yes: [], no: [] };
    if (e && e instanceof Zakeke.Scene)
      for (let u = 0; u < e.get("cameraLocations").length; u++) {
        let f = e.get("cameraLocations").at(u), v = f.getLocationID(), S = f.get("name");
        (S && o.test(S) || v && o.test(v)) && this.verifyFilter(v, r) ? a.yes.push(f) : a.no.push(f);
      }
    return a;
  }
  escapeRegExp(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  verifyFilter(e, t) {
    return !t || t.length == 0 ? !0 : t.indexOf(e) !== -1;
  }
}
var yn = globalThis && globalThis.__awaiter || function(y, e, t, r) {
  function o(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function f(I) {
      try {
        S(r.next(I));
      } catch (D) {
        u(D);
      }
    }
    function v(I) {
      try {
        S(r.throw(I));
      } catch (D) {
        u(D);
      }
    }
    function S(I) {
      I.done ? a(I.value) : o(I.value).then(f, v);
    }
    S((r = r.apply(y, e || [])).next());
  });
}, bn = globalThis && globalThis.__generator || function(y, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, o, a, u;
  return u = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function f(S) {
    return function(I) {
      return v([S, I]);
    };
  }
  function v(S) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (r = 1, o && (a = S[0] & 2 ? o.return : S[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, S[1])).done)
          return a;
        switch (o = 0, a && (S = [S[0] & 2, a.value]), S[0]) {
          case 0:
          case 1:
            a = S;
            break;
          case 4:
            return t.label++, { value: S[1], done: !1 };
          case 5:
            t.label++, o = S[1], S = [0];
            continue;
          case 7:
            S = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (S[0] === 6 || S[0] === 2)) {
              t = 0;
              continue;
            }
            if (S[0] === 3 && (!a || S[1] > a[0] && S[1] < a[3])) {
              t.label = S[1];
              break;
            }
            if (S[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = S;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(S);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        S = e.call(y, t);
      } catch (I) {
        S = [6, I], o = 0;
      } finally {
        r = a = 0;
      }
    if (S[0] & 5)
      throw S[1];
    return { value: S[0] ? S[1] : void 0, done: !0 };
  }
}, Cx = (
  /** @class */
  function() {
    function y(e, t, r) {
      this._zkModel = null, this._sceneHelper = null, this._deviceType = MPlaza.DeviceType.All, this._meshDesignRefreshRequiredListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._useMaterialOffloading = !1, this._prefetchMeshes = !0, this._prefetchMaterials = !0, this._zkScene = e, this._scene = t, this._sceneHelper = new yi(t), this._elementSelector = new Od(), r && (this._zkModel = r);
    }
    return Object.defineProperty(y.prototype, "deviceType", {
      get: function() {
        return this._deviceType;
      },
      set: function(e) {
        this._deviceType != e && (this._deviceType = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(y.prototype, "useMaterialOffloading", {
      get: function() {
        return this._useMaterialOffloading;
      },
      set: function(e) {
        this._useMaterialOffloading != e && (this._useMaterialOffloading = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(y.prototype, "prefetchMeshes", {
      get: function() {
        return this._prefetchMeshes;
      },
      set: function(e) {
        this._prefetchMeshes !== e && (this._prefetchMeshes = e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(y.prototype, "prefetchMaterials", {
      get: function() {
        return this._prefetchMaterials;
      },
      set: function(e) {
        this._prefetchMaterials !== e && (this._prefetchMaterials = e);
      },
      enumerable: !1,
      configurable: !0
    }), y.prototype.dispose = function() {
      this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
    }, y.prototype.addMeshDesignRefreshRequiredListeners = function(e) {
      this._meshDesignRefreshRequiredListeners.push(e);
    }, y.prototype.fireMeshDesignRefreshRequiredEvent = function(e, t) {
      for (var r = { meshes: e, effect: t }, o = 0; o < this._meshDesignRefreshRequiredListeners.length; ++o)
        this._meshDesignRefreshRequiredListeners[o](r);
    }, y.prototype.addBeginAssetsLoadingListener = function(e) {
      this._beginAssetsLoadingListeners.push(e);
    }, y.prototype.fireBeginAssetsLoadingEvent = function() {
      for (var e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
        this._beginAssetsLoadingListeners[e]();
    }, y.prototype.addEndAssetsLoadingListener = function(e) {
      this._endAssetsLoadingListeners.push(e);
    }, y.prototype.fireEndAssetsLoadingEvent = function() {
      for (var e = 0; e < this._endAssetsLoadingListeners.length; ++e)
        this._endAssetsLoadingListeners[e]();
    }, y.prototype.isActionForDevice = function(e) {
      var t = e.get("deviceTypes");
      return t === MPlaza.DeviceType.Any || t === MPlaza.DeviceType.All || (t & this._deviceType) === this._deviceType;
    }, y.prototype.setupMeshData = function(e) {
      e.data || (e.data = {
        filters: {},
        toShow: e.isVisible
      });
    }, y.prototype.setMeshFilterAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        return bn(this, function(o) {
          switch (o.label) {
            case 0:
              return this.setupMeshData(e), e.data.filters[t] = r, [4, this.chekMeshVisibilityAsync(e)];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.setMeshVisibilityAsync = function(e, t) {
      return yn(this, void 0, void 0, function() {
        return bn(this, function(r) {
          switch (r.label) {
            case 0:
              return this.setupMeshData(e), e.data.toShow = t, [4, this.chekMeshVisibilityAsync(e)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.chekMeshVisibilityAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r, o;
        return bn(this, function(a) {
          switch (a.label) {
            case 0:
              if (t = null, e && e.data && (t = e.data.toShow, t))
                for (r in e.data.filters)
                  t = t && e.data.filters[r];
              return t !== null && this._sceneHelper ? t ? (o = this._zkScene.get("rootUrl"), o ? [4, this._sceneHelper.unsetMeshDummyMaterialAsync(e, o, !0)] : [3, 2]) : [3, 4] : [3, 5];
            case 1:
              a.sent(), a.label = 2;
            case 2:
              return [4, yi.whenMeshIsReadyAsync(e)];
            case 3:
              a.sent(), a.label = 4;
            case 4:
              this._sceneHelper.showHideMesh(e.id, t), a.label = 5;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.getMeshByID = function(e) {
      return this._scene.getMeshByID(e);
    }, y.prototype.getMaterialByID = function(e) {
      return this._scene.getMaterialByID(e);
    }, y.prototype.setCameraLocation = function(e) {
      var t = this._zkScene.getCameraLocation(e);
      if (t) {
        var r = new BABYLON.Vector3(t.get("px"), t.get("py"), t.get("pz")), o = new BABYLON.Vector3(t.get("tx"), t.get("ty"), t.get("tz"));
        this._sceneHelper && this._sceneHelper.animateCamera(o, r, 0.5);
      }
    }, y.prototype.adjustCamera = function(e) {
      this._sceneHelper && (e !== void 0 && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera());
    }, y.prototype.zoomIn = function() {
      this._sceneHelper && this._sceneHelper.zoomIn();
    }, y.prototype.zoomOut = function() {
      this._sceneHelper && this._sceneHelper.zoomOut();
    }, y.prototype.zoom = function(e) {
      this._sceneHelper && this._sceneHelper.zoom(e);
    }, y.prototype.setCameraPivot = function(e) {
      if (this._sceneHelper) {
        var t = e ? this._scene.getMeshByID(e) : null;
        this._sceneHelper.setCameraPivot(t);
      }
    }, y.prototype.setCameraZoomEnabled = function(e) {
      this._sceneHelper && this._sceneHelper.setZoomEnabled(e);
    }, y.prototype.setMeshMaterial = function(e, t) {
      return yn(this, void 0, void 0, function() {
        var r;
        return bn(this, function(o) {
          switch (o.label) {
            case 0:
              return this._sceneHelper ? [4, yi.whenAllMaterialTexturesAreReady(e)] : [3, 2];
            case 1:
              o.sent(), r = t.material, Logger.info("Setting material to mesh | mesh: " + t.id + " - " + t.name + " | material: " + e.id + " - " + e.name), this._sceneHelper.applyMaterial(e, t), this._useMaterialOffloading && r && this._sceneHelper.offloadMaterial(r.id), o.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.setSubmeshMaterial = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o;
        return bn(this, function(a) {
          switch (a.label) {
            case 0:
              return this._sceneHelper ? [4, yi.whenAllMaterialTexturesAreReady(e)] : [3, 2];
            case 1:
              a.sent(), o = this._sceneHelper.getSubMeshMaterial(t, r), this._sceneHelper.applyMaterialToSubMesh(e, t, r), this._useMaterialOffloading && o && this._sceneHelper.offloadMaterial(o.id), a.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.getMaterialFromActionValue = function(e) {
      if (this._elementSelector) {
        var t = e.get("value");
        if (t != null && t != null) {
          var r = this._scene.getMaterialByID(t);
          return r || (r = this._scene.getMaterialByName(t)), r;
        }
      }
      return null;
    }, y.prototype.getDelayedMaterialIDFromAction = function(e) {
      if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.delayedMaterials) {
        var t = e.get("value");
        if (t != null && t != null) {
          if (this._scene.metadata.delayedMaterials.hasOwnProperty(t))
            return t;
          for (var r in this._scene.metadata.delayedMaterials)
            if (this._scene.metadata.delayedMaterials[r].name === t)
              return r;
        }
      }
      return null;
    }, y.prototype.checkDelayedMaterial = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r;
        return bn(this, function(o) {
          switch (o.label) {
            case 0:
              return t = this.getMaterialByID(e), !t && this._sceneHelper ? (r = this._zkScene.get("rootUrl"), r != null && r != null ? [4, this._sceneHelper.loadDelayedMaterialAsync(r, e)] : [3, 2]) : [3, 2];
            case 1:
              t = o.sent(), o.label = 2;
            case 2:
              return [2, t];
          }
        });
      });
    }, y.prototype.getOffloadedMaterialIDFromAction = function(e) {
      if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
        var t = e.get("value");
        if (t != null) {
          if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t))
            return t;
          for (var r in this._scene.metadata.offloadedMaterials)
            if (this._scene.metadata.offloadedMaterials[r].name === t)
              return r;
        }
      }
      return null;
    }, y.prototype.checkOffloadedMaterialAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r;
        return bn(this, function(o) {
          switch (o.label) {
            case 0:
              return t = this.getMaterialByID(e), !t && this._sceneHelper ? (r = this._zkScene.get("rootUrl"), r == null ? [3, 2] : [4, this._sceneHelper.loadOffloadedMaterialAsync(r, e)]) : [3, 2];
            case 1:
              t = o.sent(), o.label = 2;
            case 2:
              return [2, t];
          }
        });
      });
    }, y.prototype.getDeepMaterialFromActionValueAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r, o;
        return bn(this, function(a) {
          switch (a.label) {
            case 0:
              return t = this.getMaterialFromActionValue(e), !t && this._sceneHelper ? (r = this._zkScene.get("rootUrl"), r == null ? [3, 4] : (o = this.getOffloadedMaterialIDFromAction(e), o ? (Logger.info("Requesting offloaded material - id: ", o), [4, this._sceneHelper.loadOffloadedMaterialAsync(r, o)]) : [3, 2])) : [3, 4];
            case 1:
              return t = a.sent(), Logger.info("Obtained offloaded material - id: ", o), [3, 4];
            case 2:
              return o = this.getDelayedMaterialIDFromAction(e), o ? (Logger.info("Requesting delayed material - id: ", o), [4, this._sceneHelper.loadDelayedMaterialAsync(r, o)]) : [3, 4];
            case 3:
              t = a.sent(), Logger.info("Obtained delayed material - id: ", o), a.label = 4;
            case 4:
              return [2, t];
          }
        });
      });
    }, y.prototype.scriptRequiresDelayedLoading = function(e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        if (this.actionsRequireDelayedLoading(r.actions))
          return !0;
      }
      return !1;
    }, y.prototype.actionsRequireDelayedLoading = function(e) {
      for (var t = 0; t < e.length; t++)
        if (this.actionRequiresDelayedLoading(e[t]))
          return !0;
      return !1;
    }, y.prototype.actionRequiresDelayedLoading = function(e) {
      if (this._sceneHelper && e.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && e.get("value") === "show") {
        var t = e.get("selector");
        if (t != null)
          for (var r = this._elementSelector.getElements(this._zkScene, this._scene, null, t, MPlaza.SceneElementType.Mesh), o = 0; o < r.length; o++) {
            var a = r[o];
            if (a instanceof BABYLON.AbstractMesh && !a.isVisible) {
              var u = this._sceneHelper.getMeshDelayedMaterialIDs(a), f = this._sceneHelper.getMeshOffloadedMaterialIDs(a);
              if (u.length > 0 || f.length > 0 || yi.meshRequiresDelayedLoading(a))
                return !0;
            }
          }
      }
      if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor || e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) {
        var v = this.getMaterialFromActionValue(e);
        if (!v) {
          var S = this.getDelayedMaterialIDFromAction(e);
          if (S)
            return !0;
          var I = this.getOffloadedMaterialIDFromAction(e);
          if (I)
            return !0;
        }
      }
      if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
        var t = e.get("selector");
        if (t != null) {
          var D = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, t, MPlaza.SceneElementType.Material), Z = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, t, MPlaza.SceneElementType.Material);
          if (D.length > 0 || Z.length > 0)
            return !0;
        }
      }
      return !1;
    }, y.prototype.getAllMaterialElementsAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r, o, a, u, f, v, S, I, D;
        return bn(this, function(Z) {
          switch (Z.label) {
            case 0:
              return t = [], this._zkScene && this._scene && this._sceneHelper && this._elementSelector ? (r = this._elementSelector.getMaterialElements(this._zkScene, this._scene, null, e, MPlaza.SceneElementType.Material), Array.prototype.push.apply(t, r), o = r.map(function(M) {
                return M.id;
              }), a = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, e, MPlaza.SceneElementType.Material), u = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, e, MPlaza.SceneElementType.Material), f = this._zkScene.get("rootUrl"), f == null ? [3, 4] : (v = [], a.forEach(function(M) {
                o.indexOf(M) === -1 && v.push(M);
              }), v.length > 0 ? [4, this._sceneHelper.loadDelayedMaterialsAsync(f, v)] : [3, 2])) : [3, 4];
            case 1:
              S = Z.sent(), Array.prototype.push.apply(t, S), Z.label = 2;
            case 2:
              return I = [], u.forEach(function(M) {
                o.indexOf(M) === -1 && I.push(M);
              }), I.length > 0 ? [4, this._sceneHelper.loadOffloadedMaterialsByIDsAsync(f, I)] : [3, 4];
            case 3:
              D = Z.sent(), Array.prototype.push.apply(t, D), Z.label = 4;
            case 4:
              return [2, t];
          }
        });
      });
    }, y.prototype.executeScriptAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r, o;
        return bn(this, function(a) {
          switch (a.label) {
            case 0:
              t = this.scriptRequiresDelayedLoading(e), t && this.fireBeginAssetsLoadingEvent(), r = 0, a.label = 1;
            case 1:
              return r < e.length ? (o = e[r], [4, this.executeActionsAsync(o.attributeID, o.selectedValue, o.actions, !1)]) : [3, 4];
            case 2:
              a.sent(), a.label = 3;
            case 3:
              return r++, [3, 1];
            case 4:
              return t && this.fireEndAssetsLoadingEvent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeActionsAsync = function(e, t, r, o) {
      return o === void 0 && (o = !0), yn(this, void 0, void 0, function() {
        var a, u;
        return bn(this, function(f) {
          switch (f.label) {
            case 0:
              return r.length > 0 ? (a = this.actionsRequireDelayedLoading(r), o && a && this.fireBeginAssetsLoadingEvent(), [4, this.checkActionsAssetsAreReadyAsync(r)]) : [3, 6];
            case 1:
              f.sent(), u = 0, f.label = 2;
            case 2:
              return u < r.length ? [4, this.executeActionAsync(e, t, r[u])] : [3, 5];
            case 3:
              f.sent(), f.label = 4;
            case 4:
              return u++, [3, 2];
            case 5:
              o && a && this.fireEndAssetsLoadingEvent(), f.label = 6;
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o;
        return bn(this, function(a) {
          switch (a.label) {
            case 0:
              if (!this.isActionForDevice(r))
                return [
                  2
                  /*return*/
                ];
              if (!r)
                return [3, 25];
              switch (o = r.get("actionTypeID"), o) {
                case MPlaza.SceneActionType.Filter:
                  return [3, 1];
                case MPlaza.SceneActionType.ShowHideMesh:
                  return [3, 3];
                case MPlaza.SceneActionType.SetMeshMaterial:
                  return [3, 5];
                case MPlaza.SceneActionType.SetSubMeshMaterial:
                  return [3, 7];
                case MPlaza.SceneActionType.SetMaterialColor:
                  return [3, 9];
                case MPlaza.SceneActionType.SetCameraLocation:
                  return [3, 11];
                case MPlaza.SceneActionType.AdjustCamera:
                  return [3, 13];
                case MPlaza.SceneActionType.SetCameraPivot:
                  return [3, 15];
                case MPlaza.SceneActionType.ResetCameraPivot:
                  return [3, 17];
                case MPlaza.SceneActionType.EnableDiableZoom:
                  return [3, 19];
                case MPlaza.SceneActionType.SetMeshDesignMaterial:
                  return [3, 21];
                case MPlaza.SceneActionType.SetMeshDesignEffect:
                  return [3, 23];
              }
              return [3, 25];
            case 1:
              return [4, this.executeFilterActionAsync(e, t, r)];
            case 2:
              return a.sent(), [3, 25];
            case 3:
              return [4, this.executeShowHideActionAsync(e, t, r)];
            case 4:
              return a.sent(), [3, 25];
            case 5:
              return [4, this.executeSetMeshMaterialActionAsync(e, t, r)];
            case 6:
              return a.sent(), [3, 25];
            case 7:
              return [4, this.executeSetSubMeshMaterialActionAsync(e, t, r)];
            case 8:
              return a.sent(), [3, 25];
            case 9:
              return [4, this.executeSetMaterialColorActionAsync(e, t, r)];
            case 10:
              return a.sent(), [3, 25];
            case 11:
              return [4, this.executeSetCameraLocationActionAsync(e, t, r)];
            case 12:
              return a.sent(), [3, 25];
            case 13:
              return [4, this.executeAdjustCameraActionAsync(e, t, r)];
            case 14:
              return a.sent(), [3, 25];
            case 15:
              return [4, this.executeSetCameraPivotActionAsync(e, t, r)];
            case 16:
              return a.sent(), [3, 25];
            case 17:
              return [4, this.executeResetCameraPivotActionAsync(e, t, r)];
            case 18:
              return a.sent(), [3, 25];
            case 19:
              return [4, this.executeEnableDisableZoomActionAsync(e, t, r)];
            case 20:
              return a.sent(), [3, 25];
            case 21:
              return [4, this.executeSetMeshDesignMaterialActionAsync(e, t, r)];
            case 22:
              return a.sent(), [3, 25];
            case 23:
              return [4, this.executeSetMeshDesignEffectActionAsync(e, t, r)];
            case 24:
              return a.sent(), [3, 25];
            case 25:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeFilterActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f, f;
        return bn(this, function(v) {
          switch (v.label) {
            case 0:
              if (!this.isActionForDevice(r))
                return [
                  2
                  /*return*/
                ];
              if (!(e !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction))
                return [3, 8];
              if (o = r.get("selector"), o == null)
                return [3, 8];
              a = this._elementSelector.getYesNoElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), u = r.get("value") === "enable", f = 0, v.label = 1;
            case 1:
              return f < a.yes.length ? [4, this.setMeshFilterAsync(a.yes[f], e, u)] : [3, 4];
            case 2:
              v.sent(), v.label = 3;
            case 3:
              return f++, [3, 1];
            case 4:
              f = 0, v.label = 5;
            case 5:
              return f < a.no.length ? [4, this.setMeshFilterAsync(a.yes[f], e, !u)] : [3, 8];
            case 6:
              v.sent(), v.label = 7;
            case 7:
              return f++, [3, 5];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeShowHideActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f;
        return bn(this, function(v) {
          switch (v.label) {
            case 0:
              if (!this.isActionForDevice(r))
                return [
                  2
                  /*return*/
                ];
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction))
                return [3, 4];
              if (o = r.get("selector"), o == null)
                return [3, 4];
              a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), u = r.get("value") === "show", f = 0, v.label = 1;
            case 1:
              return f < a.length ? [4, this.setMeshVisibilityAsync(a[f], u)] : [3, 4];
            case 2:
              v.sent(), v.label = 3;
            case 3:
              return f++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeSetMeshMaterialActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f;
        return bn(this, function(v) {
          switch (v.label) {
            case 0:
              return this.isActionForDevice(r) ? this._zkScene && this._scene && this._sceneHelper && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction ? (o = r.get("selector"), o == null ? [3, 5] : (a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), [4, this.getDeepMaterialFromActionValueAsync(r)])) : [3, 5] : [
                2
                /*return*/
              ];
            case 1:
              if (u = v.sent(), !u)
                return [3, 5];
              f = 0, v.label = 2;
            case 2:
              return f < a.length ? [4, this.setMeshMaterial(u, a[f])] : [3, 5];
            case 3:
              v.sent(), v.label = 4;
            case 4:
              return f++, [3, 2];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeSetSubMeshMaterialActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f;
        return bn(this, function(v) {
          switch (v.label) {
            case 0:
              return this.isActionForDevice(r) ? this._zkScene && this._scene && this._sceneHelper && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction ? (o = r.get("selector"), o == null ? [3, 5] : (a = this._elementSelector.getSubMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.SubMesh), [4, this.getDeepMaterialFromActionValueAsync(r)])) : [3, 5] : [
                2
                /*return*/
              ];
            case 1:
              if (u = v.sent(), !u)
                return [3, 5];
              f = 0, v.label = 2;
            case 2:
              return f < a.length ? [4, this.setSubmeshMaterial(u, null, a[f])] : [3, 5];
            case 3:
              v.sent(), v.label = 4;
            case 4:
              return f++, [3, 2];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeSetMaterialColorActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f, v, S;
        return bn(this, function(I) {
          switch (I.label) {
            case 0:
              return this.isActionForDevice(r) ? this._zkScene && this._scene && this._sceneHelper && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction ? (o = r.get("selector"), o == null ? [3, 2] : [4, this.getAllMaterialElementsAsync(o)]) : [3, 2] : [
                2
                /*return*/
              ];
            case 1:
              if (a = I.sent(), u = r.get("propertyName"), f = r.get("value"), u && f)
                for (t && (f = f.replace(/%value%/g, t)), v = BABYLON.Color3.FromHexString(f), S = 0; S < a.length; S++)
                  this._sceneHelper.changeMaterialColor(a[S], u, v);
              I.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeSetCameraLocationActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f;
        return bn(this, function(v) {
          if (!this.isActionForDevice(r))
            return [
              2
              /*return*/
            ];
          if (this._zkScene && this._scene && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction) {
            if (o = r.get("value"), a = null, o) {
              for (u = 0; u < this._zkScene.get("cameraLocations").length; u++)
                if (f = this._zkScene.get("cameraLocations").at(u), f.get("locationID") === o || f.get("name") === o) {
                  a = f;
                  break;
                }
            }
            a !== null && this.setCameraLocation(a.get("locationID"));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, y.prototype.executeAdjustCameraActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        return bn(this, function(o) {
          return this.isActionForDevice(r) ? (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction && this._sceneHelper.adjustCamera(), [
            2
            /*return*/
          ]) : [
            2
            /*return*/
          ];
        });
      });
    }, y.prototype.executeSetCameraPivotActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f;
        return bn(this, function(v) {
          if (!this.isActionForDevice(r))
            return [
              2
              /*return*/
            ];
          if (this._zkScene && this._scene && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction) {
            if (o = r.get("value"), a = null, o) {
              for (u = 0; u < this._scene.meshes.length; u++)
                if (f = this._scene.meshes[u], f.id === o || f.name === o) {
                  a = f;
                  break;
                }
            }
            a && this.setCameraPivot(a.id);
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, y.prototype.executeResetCameraPivotActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        return bn(this, function(o) {
          return this.isActionForDevice(r) ? (this.setCameraPivot(null), [
            2
            /*return*/
          ]) : [
            2
            /*return*/
          ];
        });
      });
    }, y.prototype.executeEnableDisableZoomActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o;
        return bn(this, function(a) {
          return this.isActionForDevice(r) ? (this._zkScene && this._scene && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction && (o = r.get("value") === "enable", this.setCameraZoomEnabled(o)), [
            2
            /*return*/
          ]) : [
            2
            /*return*/
          ];
        });
      });
    }, y.prototype.executeSetMeshDesignMaterialActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f, v;
        return bn(this, function(S) {
          switch (S.label) {
            case 0:
              return this._zkScene && this._scene && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction ? (o = r.get("selector"), o != null && o != null ? (a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), [4, this.getDeepMaterialFromActionValueAsync(r)]) : [3, 2]) : [3, 2];
            case 1:
              if (u = S.sent(), u) {
                for (f = 0; f < a.length; f++)
                  v = a[f], v.metadata = v.metadata || {}, v.metadata.designMaterialID = u.id;
                this.fireMeshDesignRefreshRequiredEvent(a, null);
              }
              S.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.executeSetMeshDesignEffectActionAsync = function(e, t, r) {
      return yn(this, void 0, void 0, function() {
        var o, a, u, f, v, S, I, D, Z, M, X;
        return bn(this, function(Y) {
          switch (Y.label) {
            case 0:
              if (!this.isActionForDevice(r))
                return [
                  2
                  /*return*/
                ];
              if (!(this._zkScene && this._scene && this._elementSelector && r && r instanceof MPlaza.AttributeSceneAction))
                return [3, 4];
              if (o = r.get("selector"), !(o != null && o != null))
                return [3, 4];
              if (a = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), u = r.get("value"), f = null, u != null && u != null && this._zkModel)
                for (v = 0; v < this._zkModel.get("scenes").length; v++) {
                  if (S = this._zkModel.get("scenes").at(v), S.get("isDefault") && (I = S.get("meshDesignEffects"), I)) {
                    for (D = 0; D < I.length; D++)
                      if (Z = I.at(D), Z.get("effectID") === u || Z.get("name") === u) {
                        f = Z;
                        break;
                      }
                  }
                  if (f)
                    break;
                }
              return M = null, f ? (X = f.get("materialID"), X ? [4, this.checkOffloadedMaterialAsync(X)] : [3, 3]) : [3, 3];
            case 1:
              return M = Y.sent(), M ? [3, 3] : [4, this.checkDelayedMaterial(X)];
            case 2:
              M = Y.sent(), Y.label = 3;
            case 3:
              this.fireMeshDesignRefreshRequiredEvent(a, f), Y.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.prefetchMeshesForUnselectedOptionsAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var t, r, o, a, u, f, v;
        return bn(this, function(S) {
          switch (S.label) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes))
                return [3, 6];
              t = 0, S.label = 1;
            case 1:
              if (!(t < e.length))
                return [3, 6];
              if (r = e[t], !(r && r instanceof MPlaza.AttributeSceneAction))
                return [3, 5];
              if (!(r.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && r.get("value") == "show"))
                return [3, 5];
              if (o = r.get("selector"), !(o != null && o != null))
                return [3, 5];
              a = this._elementSelector.getElements(this._zkScene, this._scene, null, o, MPlaza.SceneElementType.Mesh), u = 0, S.label = 2;
            case 2:
              return u < a.length ? (f = a[u], f instanceof BABYLON.AbstractMesh && !f.isVisible ? (this._sceneHelper.checkDelayState(f), v = f.material, v ? [4, this._sceneHelper.prefetchTexturesForMaterialAsync(v)] : [3, 4]) : [3, 4]) : [3, 5];
            case 3:
              S.sent(), S.label = 4;
            case 4:
              return u++, [3, 2];
            case 5:
              return t++, [3, 1];
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.checkActionsAssetsAreReadyAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        var S, I, t, Z, r, o, a, u, f, v, S, I, D, Z;
        return bn(this, function(M) {
          switch (M.label) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && this._sceneHelper))
                return [3, 17];
              S = 0, M.label = 1;
            case 1:
              if (!(S < e.length))
                return [3, 11];
              if (I = e[S], t = [], !(I && I instanceof MPlaza.AttributeSceneAction))
                return [3, 8];
              if (!(I.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && I.get("value") === "show"))
                return [3, 8];
              if (Z = I.get("selector"), Z == null)
                return [3, 8];
              r = this._elementSelector.getElements(this._zkScene, this._scene, null, Z, MPlaza.SceneElementType.Mesh), o = 0, M.label = 2;
            case 2:
              return o < r.length ? (a = r[o], a instanceof BABYLON.AbstractMesh && !a.isVisible ? (u = this._zkScene.get("rootUrl"), u ? (f = this._sceneHelper.getMeshDelayedMaterialIDs(a), v = this._sceneHelper.getMeshOffloadedMaterialIDs(a), f.length > 0 ? [4, this._sceneHelper.loadDelayedMaterialsAsync(u, f)] : [3, 4]) : [3, 6]) : [3, 7]) : [3, 8];
            case 3:
              M.sent(), M.label = 4;
            case 4:
              return v.length > 0 ? [4, this._sceneHelper.loadOffloadedMaterialsByIDsAsync(u, v)] : [3, 6];
            case 5:
              M.sent(), M.label = 6;
            case 6:
              t.push(a), M.label = 7;
            case 7:
              return o++, [3, 2];
            case 8:
              return [4, yi.whenAllMeshesAreReadyAsync(t)];
            case 9:
              M.sent(), M.label = 10;
            case 10:
              return S++, [3, 1];
            case 11:
              S = 0, M.label = 12;
            case 12:
              return S < e.length ? (I = e[S], I && I instanceof MPlaza.AttributeSceneAction ? I.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || I.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial ? (D = this.getMaterialFromActionValue(I), D ? [3, 14] : [4, this.getDeepMaterialFromActionValueAsync(I)]) : [3, 14] : [3, 16]) : [3, 17];
            case 13:
              D = M.sent(), M.label = 14;
            case 14:
              return I.get("actionTypeID") !== MPlaza.SceneActionType.SetMaterialColor ? [3, 16] : (Z = I.get("selector"), Z == null ? [3, 16] : [4, this.getAllMaterialElementsAsync(Z)]);
            case 15:
              M.sent(), M.label = 16;
            case 16:
              return S++, [3, 12];
            case 17:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, y.prototype.prefetchDataForUnselectedOptionsAsync = function(e) {
      return yn(this, void 0, void 0, function() {
        return bn(this, function(t) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, y;
  }()
);
class Ax {
  constructor() {
    this._zkScene = null, this._scene = null, this._sceneHelper = null, this._meshLocationCache = {}, this._cameraAnimationCompletedListeners = [], this._meshAnimationCompletedListeners = [], this._beforeSaveMeshLocationListeners = [], this._afterSaveMeshLocationListeners = [];
  }
  dispose() {
    for (; this._cameraAnimationCompletedListeners.length > 0; )
      this._cameraAnimationCompletedListeners.pop();
    for (; this._meshAnimationCompletedListeners.length > 0; )
      this._meshAnimationCompletedListeners.pop();
    for (; this._beforeSaveMeshLocationListeners.length > 0; )
      this._beforeSaveMeshLocationListeners.pop();
    for (; this._afterSaveMeshLocationListeners.length > 0; )
      this._afterSaveMeshLocationListeners.pop();
    this.disposeSceneHelper();
  }
  setScene(e) {
    this._scene = e, this.resetSceneHelper(), this.resetCache();
  }
  setModel(e) {
    this._zkScene = e, this.resetCache();
  }
  setModelAndScene(e, t) {
    this._zkScene = e, this._scene = t, this.resetSceneHelper(), this.resetCache();
  }
  resetCache() {
    this._meshLocationCache = {};
  }
  invalidateCache(e) {
    this._meshLocationCache && delete this._meshLocationCache[e];
  }
  disposeSceneHelper() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  resetSceneHelper() {
    this.disposeSceneHelper(), this._scene && (this._sceneHelper = new yi(this._scene));
  }
  clearMeshLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("meshLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
    }
  }
  async setMeshLocationByID(e) {
    if (this._zkScene && this._scene) {
      const t = this._zkScene.getMeshLocation(e);
      t && await this.setMeshLocation(t);
    }
  }
  async setMeshLocation(e) {
    if (this._zkScene && this._scene && this._sceneHelper) {
      let S, I = !0;
      if (e) {
        let D = e.get("locationID");
        if (I = e.get("adjustCamera"), this._meshLocationCache.hasOwnProperty(D))
          S = this._meshLocationCache[D];
        else {
          let Z = e.get("data"), M = null;
          if (typeof Z == "string") {
            let X = window.atob(Z), Y = X.length, ie = new Uint8Array(Y);
            for (let te = 0; te < Y; te++)
              ie[te] = X.charCodeAt(te);
            let G = ie.buffer;
            M = new Uint8Array(G);
          } else
            Object.prototype.toString.call(Z) === "[object Array]" && (M = Uint8Array.from(Z));
          if (M != null) {
            let X = LZString.decompressFromUint8Array(M);
            if (S = JSON.parse(X), S) {
              for (var t in S) {
                var r = S[t];
                r.p && (r.p = new BABYLON.Vector3(r.p.x, r.p.y, r.p.z)), r.rE && (r.rE = new BABYLON.Vector3(r.rE.x, r.rE.y, r.rE.z)), r.rQ && (r.rQ = new BABYLON.Quaternion(r.rQ.x, r.rQ.y, r.rQ.z, r.rQ.w)), r.s && (r.s = new BABYLON.Vector3(r.s.x, r.s.y, r.s.z));
              }
              this._meshLocationCache[D] = S;
            }
          }
        }
      }
      if (S) {
        const D = [];
        if (I && S.hasOwnProperty("wemin") && S.hasOwnProperty("wemax")) {
          var o = {
            min: new BABYLON.Vector3(S.wemin.x, S.wemin.y, S.wemin.z),
            max: new BABYLON.Vector3(S.wemax.x, S.wemax.y, S.wemax.z)
          };
          let Z = this._sceneHelper.camera;
          if (Z && Z instanceof BABYLON.ArcRotateCamera) {
            Z.upperRadiusLimit = null;
            var a = this._sceneHelper.calculateCameraRadius(o), u = this._sceneHelper.getWorldCenter(o);
            u && (this._sceneHelper.setCameraRadiusParameters(a), D.push(new Promise((M) => {
              Z && Z instanceof BABYLON.ArcRotateCamera && this._sceneHelper.animateCameraToFinalParamters(Z.alpha, Z.beta, a, u, 1, () => {
                this._sceneHelper && (this._sceneHelper.setupCameraLimits(o), this.fireCameraAnimationCompletedEvent(), M());
              });
            })));
          }
        }
        for (var f = 0; f < this._scene.meshes.length; f++) {
          var v = this._scene.meshes[f], t = v.id;
          if (S.hasOwnProperty(t)) {
            var r = S[t];
            D.push(new Promise((X) => {
              this._sceneHelper.animateMeshToFinalParameters(v, r.p, r.rE, r.rQ, r.s, 1, () => {
                this.fireMeshAnimationCompletedEvent(), X();
              });
            }));
          }
        }
        await Promise.all(D);
      }
    }
  }
  saveMeshLocation(e) {
    if (this._zkScene && this._scene) {
      var t = new Zakeke.SceneMeshLocation();
      t.set("name", e), this.updateMeshLocation(t), this._zkScene.get("meshLocations").push(t);
    }
  }
  saveExplodedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateExplodedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  saveCollapsedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateCollapsedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  updateMeshLocation(e) {
    if (this.fireBeforeSaveMeshLocationEvent(), this._scene && this._sceneHelper) {
      var t = this.getMeshPRSs(), r = this._sceneHelper.getWorldExtends();
      if (r) {
        let f = {
          x: r.min.x,
          y: r.min.y,
          z: r.min.z
        }, v = {
          x: r.max.x,
          y: r.max.y,
          z: r.max.z
        };
        t.wemin = f, t.wemax = v;
      }
      var o = JSON.stringify(t);
      let a = LZString.compressToUint8Array(o), u = [].slice.call(a);
      e.set("data", u), this.invalidateCache(e.get("locationID"));
    }
    this.fireAfterSaveMeshLocationEvent();
  }
  getMeshPRSs() {
    let e = {
      wemin: void 0,
      wemax: void 0
    };
    if (this._scene && this._sceneHelper)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const r = this._scene.meshes[t];
        if (this._sceneHelper.isRealMesh(r)) {
          let o = r.id, a = {
            p: void 0,
            rQ: void 0,
            rE: void 0,
            s: void 0
          }, u = {
            x: r.position.x,
            y: r.position.y,
            z: r.position.z
          };
          if (a.p = u, r.rotationQuaternion == null) {
            a.rQ = null;
            let v = {
              x: r.rotation.x,
              y: r.rotation.y,
              z: r.rotation.z
            };
            a.rE = v;
          } else {
            let v = {
              w: r.rotationQuaternion.w,
              x: r.rotationQuaternion.x,
              y: r.rotationQuaternion.y,
              z: r.rotationQuaternion.z
            };
            a.rQ = v, a.rE = null;
          }
          let f = {
            x: r.scaling.x,
            y: r.scaling.y,
            z: r.scaling.z
          };
          a.s = f, e[o] = a;
        }
      }
    return e;
  }
  async explodeMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstExplodedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  async collapseMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstCollapsedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  // Events
  fireCameraAnimationCompletedEvent() {
    for (let e = 0; e < this._cameraAnimationCompletedListeners.length; ++e)
      this._cameraAnimationCompletedListeners[e]();
  }
  addCameraAnimationCompletedListener(e) {
    this._cameraAnimationCompletedListeners.push(e);
  }
  fireMeshAnimationCompletedEvent() {
    for (let e = 0; e < this._meshAnimationCompletedListeners.length; ++e)
      this._meshAnimationCompletedListeners[e]();
  }
  addMeshAnimationCompletedListener(e) {
    this._meshAnimationCompletedListeners.push(e);
  }
  fireBeforeSaveMeshLocationEvent() {
    for (let e = 0; e < this._beforeSaveMeshLocationListeners.length; ++e)
      this._beforeSaveMeshLocationListeners[e]();
  }
  addBeforeSaveMeshLocationListener(e) {
    this._beforeSaveMeshLocationListeners.push(e);
  }
  fireAfterSaveMeshLocationEvent() {
    for (let e = 0; e < this._afterSaveMeshLocationListeners.length; ++e)
      this._afterSaveMeshLocationListeners[e]();
  }
  addAfterSaveMeshLocationListener(e) {
    this._afterSaveMeshLocationListeners.push(e);
  }
}
class Tx {
  constructor(e, t) {
    this._glowLayer = null, this._zkScene = e, this._scene = t, this._sceneHelper = new yi(this._scene), this._glowLayer = this._scene.getGlowLayerByName("glow");
  }
  get enabled() {
    const e = this.getGlowConfig();
    return e && e.get("enabled") != null && typeof e.get("enabled") == "boolean" && e.get("enabled"), !1;
  }
  set enabled(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("enabled", e), this.update();
  }
  get intensity() {
    const e = this.getGlowConfig();
    return e && e.get("intensity") != null && typeof e.get("intensity") == "number" && e.get("intensity"), 1;
  }
  set intensity(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("intensity", e), this.update();
  }
  get blurSize() {
    const e = this.getGlowConfig();
    return e && e.get("blurSize") != null && typeof e.get("blurSize") == "number" && e.get("blurSize"), 1;
  }
  set blurSize(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("blurSize", e), this.update();
  }
  dispose() {
    this.destroyGlowLayer();
  }
  destroyGlowLayer() {
    this._glowLayer && (this._glowLayer.dispose(), this._glowLayer = null);
  }
  createOrUpdateGlowLayer(e, t) {
    this._glowLayer || (this._glowLayer = new BABYLON.GlowLayer("glow", this._scene)), this._glowLayer && (this._glowLayer.intensity = e, this._glowLayer.blurKernelSize = t);
  }
  update() {
    if (this._scene) {
      var e = this.getGlowConfig();
      if (e) {
        const t = this.enabled, r = this.intensity, o = this.blurSize;
        t ? this.createOrUpdateGlowLayer(r, o) : this.destroyGlowLayer();
      } else
        this.destroyGlowLayer();
    }
  }
  turnOffGlow() {
    this.destroyGlowLayer();
  }
  turnOnGlow() {
    this.update();
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  isGlowEnabledForMesh(e) {
    return e ? e.metadata && e.metadata.enableGlow : !1;
  }
  // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
  // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
  // per cui il glow è diabilitato
  enableGlowForMesh(e) {
  }
  disableGlowForMesh(e) {
  }
  getGlowConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGlowConfig();
      if (e)
        return e;
    }
    return null;
  }
  getOrCreateGlowConfig() {
    return this.sanityCheck() ? this._zkScene.getOrCreateGlowConfig() : null;
  }
}
class du {
  /**
   * Constructor
   * @param workers Array of workers to use for actions
   */
  constructor(e) {
    this._pendingActions = new Array(), this._workerInfos = e.map((t) => ({
      worker: t,
      active: !1
    }));
  }
  /**
   * Terminates all workers and clears any pending actions.
   */
  dispose() {
    for (const e of this._workerInfos)
      e.worker.terminate();
    delete this._workerInfos, delete this._pendingActions;
  }
  /**
   * Pushes an action to the worker pool. If all the workers are active, the action will be
   * pended until a worker has completed its action.
   * @param action The action to perform. Call onComplete when the action is complete.
   */
  push(e) {
    for (const t of this._workerInfos)
      if (!t.active) {
        this._execute(t, e);
        return;
      }
    this._pendingActions.push(e);
  }
  _execute(e, t) {
    e.active = !0, t(e.worker, () => {
      e.active = !1;
      const r = this._pendingActions.shift();
      r && this._execute(e, r);
    });
  }
}
function Pd(y) {
  return typeof importScripts == "function" ? (importScripts(y), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(y, () => {
      e();
    }, (r) => {
      t(new Error(r));
    });
  });
}
function Nd(y) {
  if (y.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < y.length; t++)
    e.push(Pd(y[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function Rd(y, e, t) {
  return new MakeIncremental().getSceneIncrementalFiles(y, e, t);
}
function Lx() {
  let y;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const r = t.urls;
        y = Nd(r), postMessage("done");
        break;
      }
      case "makeIncremental": {
        if (!y)
          throw new Error("Worker not initialized");
        y.then(() => {
          const r = t.sceneJson, o = t.version, a = t.options, u = Rd(r, o, a);
          postMessage({ id: "result", files: u }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Bx(y) {
  return typeof document != "object" || typeof y != "string" ? y : BABYLON.Tools.GetAbsoluteUrl(y);
}
const gl = class ba {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the incremental file maker
   */
  static get Default() {
    return ba._Default || (ba._Default = new ba([])), ba._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  constructor(e, t = ba.DefaultNumWorkers) {
    const r = e.map((o) => Bx(o));
    if (t && typeof Worker == "function") {
      const o = `${Pd}${Nd}${Rd}(${Lx})()`, a = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), u = new Array(t);
      for (let f = 0; f < u.length; f++)
        u[f] = new Promise((v, S) => {
          const I = new Worker(a), D = (M) => {
            I.removeEventListener("error", D), I.removeEventListener("message", Z), S(M);
          }, Z = (M) => {
            M.data === "done" && (I.removeEventListener("error", D), I.removeEventListener("message", Z), v(I));
          };
          I.addEventListener("error", D), I.addEventListener("message", Z), I.postMessage({
            id: "init",
            urls: r
          });
        });
      this._workerPoolPromise = Promise.all(u).then((f) => new du(f));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getIncrementalFilesAsync(e, t, r) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((o) => new Promise((a, u) => {
        o.push((f, v) => {
          let S = [];
          const I = (Z) => {
            f.removeEventListener("error", I), f.removeEventListener("message", D), u(Z), v();
          }, D = (Z) => {
            Z.data === "done" ? (f.removeEventListener("error", I), f.removeEventListener("message", D), a(S), v()) : Z.data.id === "result" && (S = Z.data.files);
          };
          f.addEventListener("error", I), f.addEventListener("message", D), f.postMessage({ id: "makeIncremental", sceneJson: e, version: t, options: r });
        });
      }));
    throw new Error("Incremental file worker is not available");
  }
};
gl.DefaultNumWorkers = gl.GetDefaultNumWorkers();
gl._Default = null;
let Ex = gl;
var Dd = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(y) {
  (function(e, t) {
    y.exports = e.document ? t(e, !0) : function(r) {
      if (!r.document)
        throw new Error("jQuery requires a window with a document");
      return t(r);
    };
  })(typeof window < "u" ? window : Kr, function(e, t) {
    var r = [], o = Object.getPrototypeOf, a = r.slice, u = r.flat ? function(w) {
      return r.flat.call(w);
    } : function(w) {
      return r.concat.apply([], w);
    }, f = r.push, v = r.indexOf, S = {}, I = S.toString, D = S.hasOwnProperty, Z = D.toString, M = Z.call(Object), X = {}, Y = function(O) {
      return typeof O == "function" && typeof O.nodeType != "number" && typeof O.item != "function";
    }, ie = function(O) {
      return O != null && O === O.window;
    }, G = e.document, te = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };
    function J(w, O, q) {
      q = q || G;
      var ne, de, _e = q.createElement("script");
      if (_e.text = w, O)
        for (ne in te)
          de = O[ne] || O.getAttribute && O.getAttribute(ne), de && _e.setAttribute(ne, de);
      q.head.appendChild(_e).parentNode.removeChild(_e);
    }
    function he(w) {
      return w == null ? w + "" : typeof w == "object" || typeof w == "function" ? S[I.call(w)] || "object" : typeof w;
    }
    var ve = "3.7.1", K = /HTML$/i, j = function(w, O) {
      return new j.fn.init(w, O);
    };
    j.fn = j.prototype = {
      // The current version of jQuery being used
      jquery: ve,
      constructor: j,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return a.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(w) {
        return w == null ? a.call(this) : w < 0 ? this[w + this.length] : this[w];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(w) {
        var O = j.merge(this.constructor(), w);
        return O.prevObject = this, O;
      },
      // Execute a callback for every element in the matched set.
      each: function(w) {
        return j.each(this, w);
      },
      map: function(w) {
        return this.pushStack(j.map(this, function(O, q) {
          return w.call(O, q, O);
        }));
      },
      slice: function() {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(j.grep(this, function(w, O) {
          return (O + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(j.grep(this, function(w, O) {
          return O % 2;
        }));
      },
      eq: function(w) {
        var O = this.length, q = +w + (w < 0 ? O : 0);
        return this.pushStack(q >= 0 && q < O ? [this[q]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push: f,
      sort: r.sort,
      splice: r.splice
    }, j.extend = j.fn.extend = function() {
      var w, O, q, ne, de, _e, ye = arguments[0] || {}, Ve = 1, De = arguments.length, Ke = !1;
      for (typeof ye == "boolean" && (Ke = ye, ye = arguments[Ve] || {}, Ve++), typeof ye != "object" && !Y(ye) && (ye = {}), Ve === De && (ye = this, Ve--); Ve < De; Ve++)
        if ((w = arguments[Ve]) != null)
          for (O in w)
            ne = w[O], !(O === "__proto__" || ye === ne) && (Ke && ne && (j.isPlainObject(ne) || (de = Array.isArray(ne))) ? (q = ye[O], de && !Array.isArray(q) ? _e = [] : !de && !j.isPlainObject(q) ? _e = {} : _e = q, de = !1, ye[O] = j.extend(Ke, _e, ne)) : ne !== void 0 && (ye[O] = ne));
      return ye;
    }, j.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (ve + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: !0,
      error: function(w) {
        throw new Error(w);
      },
      noop: function() {
      },
      isPlainObject: function(w) {
        var O, q;
        return !w || I.call(w) !== "[object Object]" ? !1 : (O = o(w), O ? (q = D.call(O, "constructor") && O.constructor, typeof q == "function" && Z.call(q) === M) : !0);
      },
      isEmptyObject: function(w) {
        var O;
        for (O in w)
          return !1;
        return !0;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(w, O, q) {
        J(w, { nonce: O && O.nonce }, q);
      },
      each: function(w, O) {
        var q, ne = 0;
        if (We(w))
          for (q = w.length; ne < q && O.call(w[ne], ne, w[ne]) !== !1; ne++)
            ;
        else
          for (ne in w)
            if (O.call(w[ne], ne, w[ne]) === !1)
              break;
        return w;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(w) {
        var O, q = "", ne = 0, de = w.nodeType;
        if (!de)
          for (; O = w[ne++]; )
            q += j.text(O);
        return de === 1 || de === 11 ? w.textContent : de === 9 ? w.documentElement.textContent : de === 3 || de === 4 ? w.nodeValue : q;
      },
      // results is for internal usage only
      makeArray: function(w, O) {
        var q = O || [];
        return w != null && (We(Object(w)) ? j.merge(
          q,
          typeof w == "string" ? [w] : w
        ) : f.call(q, w)), q;
      },
      inArray: function(w, O, q) {
        return O == null ? -1 : v.call(O, w, q);
      },
      isXMLDoc: function(w) {
        var O = w && w.namespaceURI, q = w && (w.ownerDocument || w).documentElement;
        return !K.test(O || q && q.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(w, O) {
        for (var q = +O.length, ne = 0, de = w.length; ne < q; ne++)
          w[de++] = O[ne];
        return w.length = de, w;
      },
      grep: function(w, O, q) {
        for (var ne, de = [], _e = 0, ye = w.length, Ve = !q; _e < ye; _e++)
          ne = !O(w[_e], _e), ne !== Ve && de.push(w[_e]);
        return de;
      },
      // arg is for internal usage only
      map: function(w, O, q) {
        var ne, de, _e = 0, ye = [];
        if (We(w))
          for (ne = w.length; _e < ne; _e++)
            de = O(w[_e], _e, q), de != null && ye.push(de);
        else
          for (_e in w)
            de = O(w[_e], _e, q), de != null && ye.push(de);
        return u(ye);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support: X
    }), typeof Symbol == "function" && (j.fn[Symbol.iterator] = r[Symbol.iterator]), j.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(w, O) {
        S["[object " + O + "]"] = O.toLowerCase();
      }
    );
    function We(w) {
      var O = !!w && "length" in w && w.length, q = he(w);
      return Y(w) || ie(w) ? !1 : q === "array" || O === 0 || typeof O == "number" && O > 0 && O - 1 in w;
    }
    function ke(w, O) {
      return w.nodeName && w.nodeName.toLowerCase() === O.toLowerCase();
    }
    var $e = r.pop, Lt = r.sort, Be = r.splice, Xe = "[\\x20\\t\\r\\n\\f]", ue = new RegExp(
      "^" + Xe + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Xe + "+$",
      "g"
    );
    j.contains = function(w, O) {
      var q = O && O.parentNode;
      return w === q || !!(q && q.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (w.contains ? w.contains(q) : w.compareDocumentPosition && w.compareDocumentPosition(q) & 16));
    };
    var yt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function Ue(w, O) {
      return O ? w === "\0" ? "�" : w.slice(0, -1) + "\\" + w.charCodeAt(w.length - 1).toString(16) + " " : "\\" + w;
    }
    j.escapeSelector = function(w) {
      return (w + "").replace(yt, Ue);
    };
    var ot = G, Gt = f;
    (function() {
      var w, O, q, ne, de, _e = Gt, ye, Ve, De, Ke, St, Ct = j.expando, ut = 0, Ut = 0, ti = Tn(), wi = Tn(), bi = Tn(), An = Tn(), _n = function(Oe, qe) {
        return Oe === qe && (de = !0), 0;
      }, fn = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", pi = "(?:\\\\[\\da-fA-F]{1,6}" + Xe + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", Bi = "\\[" + Xe + "*(" + pi + ")(?:" + Xe + // Operator (capture 2)
      "*([*^$|!~]?=)" + Xe + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + pi + "))|)" + Xe + "*\\]", On = ":(" + pi + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + Bi + ")*)|.*)\\)|)", Oi = new RegExp(Xe + "+", "g"), Wi = new RegExp("^" + Xe + "*," + Xe + "*"), es = new RegExp("^" + Xe + "*([>+~]|" + Xe + ")" + Xe + "*"), sr = new RegExp(Xe + "|>"), mn = new RegExp(On), fr = new RegExp("^" + pi + "$"), Un = {
        ID: new RegExp("^#(" + pi + ")"),
        CLASS: new RegExp("^\\.(" + pi + ")"),
        TAG: new RegExp("^(" + pi + "|[*])"),
        ATTR: new RegExp("^" + Bi),
        PSEUDO: new RegExp("^" + On),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Xe + "*(even|odd|(([+-]|)(\\d*)n|)" + Xe + "*(?:([+-]|)" + Xe + "*(\\d+)|))" + Xe + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + fn + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + Xe + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Xe + "*((?:-\\d)?\\d*)" + Xe + "*\\)|)(?=[^-]|$)", "i")
      }, Jt = /^(?:input|select|textarea|button)$/i, qn = /^h\d$/i, Pn = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Er = /[+~]/, Si = new RegExp("\\\\[\\da-fA-F]{1,6}" + Xe + "?|\\\\([^\\r\\n\\f])", "g"), sn = function(Oe, qe) {
        var ht = "0x" + Oe.slice(1) - 65536;
        return qe || (ht < 0 ? String.fromCharCode(ht + 65536) : String.fromCharCode(ht >> 10 | 55296, ht & 1023 | 56320));
      }, Yt = function() {
        Nn();
      }, kr = dr(
        function(Oe) {
          return Oe.disabled === !0 && ke(Oe, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function ai() {
        try {
          return ye.activeElement;
        } catch {
        }
      }
      try {
        _e.apply(
          r = a.call(ot.childNodes),
          ot.childNodes
        ), r[ot.childNodes.length].nodeType;
      } catch {
        _e = {
          apply: function(qe, ht) {
            Gt.apply(qe, a.call(ht));
          },
          call: function(qe) {
            Gt.apply(qe, a.call(arguments, 1));
          }
        };
      }
      function Pi(Oe, qe, ht, gt) {
        var Le, je, Ye, ee, oe, Me, Ee, at = qe && qe.ownerDocument, Mt = qe ? qe.nodeType : 9;
        if (ht = ht || [], typeof Oe != "string" || !Oe || Mt !== 1 && Mt !== 9 && Mt !== 11)
          return ht;
        if (!gt && (Nn(qe), qe = qe || ye, De)) {
          if (Mt !== 11 && (oe = Pn.exec(Oe)))
            if (Le = oe[1]) {
              if (Mt === 9)
                if (Ye = qe.getElementById(Le)) {
                  if (Ye.id === Le)
                    return _e.call(ht, Ye), ht;
                } else
                  return ht;
              else if (at && (Ye = at.getElementById(Le)) && Pi.contains(qe, Ye) && Ye.id === Le)
                return _e.call(ht, Ye), ht;
            } else {
              if (oe[2])
                return _e.apply(ht, qe.getElementsByTagName(Oe)), ht;
              if ((Le = oe[3]) && qe.getElementsByClassName)
                return _e.apply(ht, qe.getElementsByClassName(Le)), ht;
            }
          if (!An[Oe + " "] && (!Ke || !Ke.test(Oe))) {
            if (Ee = Oe, at = qe, Mt === 1 && (sr.test(Oe) || es.test(Oe))) {
              for (at = Er.test(Oe) && hn(qe.parentNode) || qe, (at != qe || !X.scope) && ((ee = qe.getAttribute("id")) ? ee = j.escapeSelector(ee) : qe.setAttribute("id", ee = Ct)), Me = ar(Oe), je = Me.length; je--; )
                Me[je] = (ee ? "#" + ee : ":scope") + " " + Yn(Me[je]);
              Ee = Me.join(",");
            }
            try {
              return _e.apply(
                ht,
                at.querySelectorAll(Ee)
              ), ht;
            } catch {
              An(Oe, !0);
            } finally {
              ee === Ct && qe.removeAttribute("id");
            }
          }
        }
        return or(Oe.replace(ue, "$1"), qe, ht, gt);
      }
      function Tn() {
        var Oe = [];
        function qe(ht, gt) {
          return Oe.push(ht + " ") > O.cacheLength && delete qe[Oe.shift()], qe[ht + " "] = gt;
        }
        return qe;
      }
      function oi(Oe) {
        return Oe[Ct] = !0, Oe;
      }
      function dn(Oe) {
        var qe = ye.createElement("fieldset");
        try {
          return !!Oe(qe);
        } catch {
          return !1;
        } finally {
          qe.parentNode && qe.parentNode.removeChild(qe), qe = null;
        }
      }
      function Ir(Oe) {
        return function(qe) {
          return ke(qe, "input") && qe.type === Oe;
        };
      }
      function Js(Oe) {
        return function(qe) {
          return (ke(qe, "input") || ke(qe, "button")) && qe.type === Oe;
        };
      }
      function Ur(Oe) {
        return function(qe) {
          return "form" in qe ? qe.parentNode && qe.disabled === !1 ? "label" in qe ? "label" in qe.parentNode ? qe.parentNode.disabled === Oe : qe.disabled === Oe : qe.isDisabled === Oe || // Where there is no isDisabled, check manually
          qe.isDisabled !== !Oe && kr(qe) === Oe : qe.disabled === Oe : "label" in qe ? qe.disabled === Oe : !1;
        };
      }
      function Xn(Oe) {
        return oi(function(qe) {
          return qe = +qe, oi(function(ht, gt) {
            for (var Le, je = Oe([], ht.length, qe), Ye = je.length; Ye--; )
              ht[Le = je[Ye]] && (ht[Le] = !(gt[Le] = ht[Le]));
          });
        });
      }
      function hn(Oe) {
        return Oe && typeof Oe.getElementsByTagName < "u" && Oe;
      }
      function Nn(Oe) {
        var qe, ht = Oe ? Oe.ownerDocument || Oe : ot;
        return ht == ye || ht.nodeType !== 9 || !ht.documentElement || (ye = ht, Ve = ye.documentElement, De = !j.isXMLDoc(ye), St = Ve.matches || Ve.webkitMatchesSelector || Ve.msMatchesSelector, Ve.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        ot != ye && (qe = ye.defaultView) && qe.top !== qe && qe.addEventListener("unload", Yt), X.getById = dn(function(gt) {
          return Ve.appendChild(gt).id = j.expando, !ye.getElementsByName || !ye.getElementsByName(j.expando).length;
        }), X.disconnectedMatch = dn(function(gt) {
          return St.call(gt, "*");
        }), X.scope = dn(function() {
          return ye.querySelectorAll(":scope");
        }), X.cssHas = dn(function() {
          try {
            return ye.querySelector(":has(*,:jqfake)"), !1;
          } catch {
            return !0;
          }
        }), X.getById ? (O.filter.ID = function(gt) {
          var Le = gt.replace(Si, sn);
          return function(je) {
            return je.getAttribute("id") === Le;
          };
        }, O.find.ID = function(gt, Le) {
          if (typeof Le.getElementById < "u" && De) {
            var je = Le.getElementById(gt);
            return je ? [je] : [];
          }
        }) : (O.filter.ID = function(gt) {
          var Le = gt.replace(Si, sn);
          return function(je) {
            var Ye = typeof je.getAttributeNode < "u" && je.getAttributeNode("id");
            return Ye && Ye.value === Le;
          };
        }, O.find.ID = function(gt, Le) {
          if (typeof Le.getElementById < "u" && De) {
            var je, Ye, ee, oe = Le.getElementById(gt);
            if (oe) {
              if (je = oe.getAttributeNode("id"), je && je.value === gt)
                return [oe];
              for (ee = Le.getElementsByName(gt), Ye = 0; oe = ee[Ye++]; )
                if (je = oe.getAttributeNode("id"), je && je.value === gt)
                  return [oe];
            }
            return [];
          }
        }), O.find.TAG = function(gt, Le) {
          return typeof Le.getElementsByTagName < "u" ? Le.getElementsByTagName(gt) : Le.querySelectorAll(gt);
        }, O.find.CLASS = function(gt, Le) {
          if (typeof Le.getElementsByClassName < "u" && De)
            return Le.getElementsByClassName(gt);
        }, Ke = [], dn(function(gt) {
          var Le;
          Ve.appendChild(gt).innerHTML = "<a id='" + Ct + "' href='' disabled='disabled'></a><select id='" + Ct + "-\r\\' disabled='disabled'><option selected=''></option></select>", gt.querySelectorAll("[selected]").length || Ke.push("\\[" + Xe + "*(?:value|" + fn + ")"), gt.querySelectorAll("[id~=" + Ct + "-]").length || Ke.push("~="), gt.querySelectorAll("a#" + Ct + "+*").length || Ke.push(".#.+[+~]"), gt.querySelectorAll(":checked").length || Ke.push(":checked"), Le = ye.createElement("input"), Le.setAttribute("type", "hidden"), gt.appendChild(Le).setAttribute("name", "D"), Ve.appendChild(gt).disabled = !0, gt.querySelectorAll(":disabled").length !== 2 && Ke.push(":enabled", ":disabled"), Le = ye.createElement("input"), Le.setAttribute("name", ""), gt.appendChild(Le), gt.querySelectorAll("[name='']").length || Ke.push("\\[" + Xe + "*name" + Xe + "*=" + Xe + `*(?:''|"")`);
        }), X.cssHas || Ke.push(":has"), Ke = Ke.length && new RegExp(Ke.join("|")), _n = function(gt, Le) {
          if (gt === Le)
            return de = !0, 0;
          var je = !gt.compareDocumentPosition - !Le.compareDocumentPosition;
          return je || (je = (gt.ownerDocument || gt) == (Le.ownerDocument || Le) ? gt.compareDocumentPosition(Le) : (
            // Otherwise we know they are disconnected
            1
          ), je & 1 || !X.sortDetached && Le.compareDocumentPosition(gt) === je ? gt === ye || gt.ownerDocument == ot && Pi.contains(ot, gt) ? -1 : Le === ye || Le.ownerDocument == ot && Pi.contains(ot, Le) ? 1 : ne ? v.call(ne, gt) - v.call(ne, Le) : 0 : je & 4 ? -1 : 1);
        }), ye;
      }
      Pi.matches = function(Oe, qe) {
        return Pi(Oe, null, null, qe);
      }, Pi.matchesSelector = function(Oe, qe) {
        if (Nn(Oe), De && !An[qe + " "] && (!Ke || !Ke.test(qe)))
          try {
            var ht = St.call(Oe, qe);
            if (ht || X.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            Oe.document && Oe.document.nodeType !== 11)
              return ht;
          } catch {
            An(qe, !0);
          }
        return Pi(qe, ye, null, [Oe]).length > 0;
      }, Pi.contains = function(Oe, qe) {
        return (Oe.ownerDocument || Oe) != ye && Nn(Oe), j.contains(Oe, qe);
      }, Pi.attr = function(Oe, qe) {
        (Oe.ownerDocument || Oe) != ye && Nn(Oe);
        var ht = O.attrHandle[qe.toLowerCase()], gt = ht && D.call(O.attrHandle, qe.toLowerCase()) ? ht(Oe, qe, !De) : void 0;
        return gt !== void 0 ? gt : Oe.getAttribute(qe);
      }, Pi.error = function(Oe) {
        throw new Error("Syntax error, unrecognized expression: " + Oe);
      }, j.uniqueSort = function(Oe) {
        var qe, ht = [], gt = 0, Le = 0;
        if (de = !X.sortStable, ne = !X.sortStable && a.call(Oe, 0), Lt.call(Oe, _n), de) {
          for (; qe = Oe[Le++]; )
            qe === Oe[Le] && (gt = ht.push(Le));
          for (; gt--; )
            Be.call(Oe, ht[gt], 1);
        }
        return ne = null, Oe;
      }, j.fn.uniqueSort = function() {
        return this.pushStack(j.uniqueSort(a.apply(this)));
      }, O = j.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: oi,
        match: Un,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(Oe) {
            return Oe[1] = Oe[1].replace(Si, sn), Oe[3] = (Oe[3] || Oe[4] || Oe[5] || "").replace(Si, sn), Oe[2] === "~=" && (Oe[3] = " " + Oe[3] + " "), Oe.slice(0, 4);
          },
          CHILD: function(Oe) {
            return Oe[1] = Oe[1].toLowerCase(), Oe[1].slice(0, 3) === "nth" ? (Oe[3] || Pi.error(Oe[0]), Oe[4] = +(Oe[4] ? Oe[5] + (Oe[6] || 1) : 2 * (Oe[3] === "even" || Oe[3] === "odd")), Oe[5] = +(Oe[7] + Oe[8] || Oe[3] === "odd")) : Oe[3] && Pi.error(Oe[0]), Oe;
          },
          PSEUDO: function(Oe) {
            var qe, ht = !Oe[6] && Oe[2];
            return Un.CHILD.test(Oe[0]) ? null : (Oe[3] ? Oe[2] = Oe[4] || Oe[5] || "" : ht && mn.test(ht) && // Get excess from tokenize (recursively)
            (qe = ar(ht, !0)) && // advance to the next closing parenthesis
            (qe = ht.indexOf(")", ht.length - qe) - ht.length) && (Oe[0] = Oe[0].slice(0, qe), Oe[2] = ht.slice(0, qe)), Oe.slice(0, 3));
          }
        },
        filter: {
          TAG: function(Oe) {
            var qe = Oe.replace(Si, sn).toLowerCase();
            return Oe === "*" ? function() {
              return !0;
            } : function(ht) {
              return ke(ht, qe);
            };
          },
          CLASS: function(Oe) {
            var qe = ti[Oe + " "];
            return qe || (qe = new RegExp("(^|" + Xe + ")" + Oe + "(" + Xe + "|$)")) && ti(Oe, function(ht) {
              return qe.test(
                typeof ht.className == "string" && ht.className || typeof ht.getAttribute < "u" && ht.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(Oe, qe, ht) {
            return function(gt) {
              var Le = Pi.attr(gt, Oe);
              return Le == null ? qe === "!=" : qe ? (Le += "", qe === "=" ? Le === ht : qe === "!=" ? Le !== ht : qe === "^=" ? ht && Le.indexOf(ht) === 0 : qe === "*=" ? ht && Le.indexOf(ht) > -1 : qe === "$=" ? ht && Le.slice(-ht.length) === ht : qe === "~=" ? (" " + Le.replace(Oi, " ") + " ").indexOf(ht) > -1 : qe === "|=" ? Le === ht || Le.slice(0, ht.length + 1) === ht + "-" : !1) : !0;
            };
          },
          CHILD: function(Oe, qe, ht, gt, Le) {
            var je = Oe.slice(0, 3) !== "nth", Ye = Oe.slice(-4) !== "last", ee = qe === "of-type";
            return gt === 1 && Le === 0 ? (
              // Shortcut for :nth-*(n)
              function(oe) {
                return !!oe.parentNode;
              }
            ) : function(oe, Me, Ee) {
              var at, Mt, vt, Vt, Ei, $i = je !== Ye ? "nextSibling" : "previousSibling", vn = oe.parentNode, wn = ee && oe.nodeName.toLowerCase(), gr = !Ee && !ee, Li = !1;
              if (vn) {
                if (je) {
                  for (; $i; ) {
                    for (vt = oe; vt = vt[$i]; )
                      if (ee ? ke(vt, wn) : vt.nodeType === 1)
                        return !1;
                    Ei = $i = Oe === "only" && !Ei && "nextSibling";
                  }
                  return !0;
                }
                if (Ei = [Ye ? vn.firstChild : vn.lastChild], Ye && gr) {
                  for (Mt = vn[Ct] || (vn[Ct] = {}), at = Mt[Oe] || [], Vt = at[0] === ut && at[1], Li = Vt && at[2], vt = Vt && vn.childNodes[Vt]; vt = ++Vt && vt && vt[$i] || // Fallback to seeking `elem` from the start
                  (Li = Vt = 0) || Ei.pop(); )
                    if (vt.nodeType === 1 && ++Li && vt === oe) {
                      Mt[Oe] = [ut, Vt, Li];
                      break;
                    }
                } else if (gr && (Mt = oe[Ct] || (oe[Ct] = {}), at = Mt[Oe] || [], Vt = at[0] === ut && at[1], Li = Vt), Li === !1)
                  for (; (vt = ++Vt && vt && vt[$i] || (Li = Vt = 0) || Ei.pop()) && !((ee ? ke(vt, wn) : vt.nodeType === 1) && ++Li && (gr && (Mt = vt[Ct] || (vt[Ct] = {}), Mt[Oe] = [ut, Li]), vt === oe)); )
                    ;
                return Li -= Le, Li === gt || Li % gt === 0 && Li / gt >= 0;
              }
            };
          },
          PSEUDO: function(Oe, qe) {
            var ht, gt = O.pseudos[Oe] || O.setFilters[Oe.toLowerCase()] || Pi.error("unsupported pseudo: " + Oe);
            return gt[Ct] ? gt(qe) : gt.length > 1 ? (ht = [Oe, Oe, "", qe], O.setFilters.hasOwnProperty(Oe.toLowerCase()) ? oi(function(Le, je) {
              for (var Ye, ee = gt(Le, qe), oe = ee.length; oe--; )
                Ye = v.call(Le, ee[oe]), Le[Ye] = !(je[Ye] = ee[oe]);
            }) : function(Le) {
              return gt(Le, 0, ht);
            }) : gt;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: oi(function(Oe) {
            var qe = [], ht = [], gt = ws(Oe.replace(ue, "$1"));
            return gt[Ct] ? oi(function(Le, je, Ye, ee) {
              for (var oe, Me = gt(Le, null, ee, []), Ee = Le.length; Ee--; )
                (oe = Me[Ee]) && (Le[Ee] = !(je[Ee] = oe));
            }) : function(Le, je, Ye) {
              return qe[0] = Le, gt(qe, null, Ye, ht), qe[0] = null, !ht.pop();
            };
          }),
          has: oi(function(Oe) {
            return function(qe) {
              return Pi(Oe, qe).length > 0;
            };
          }),
          contains: oi(function(Oe) {
            return Oe = Oe.replace(Si, sn), function(qe) {
              return (qe.textContent || j.text(qe)).indexOf(Oe) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: oi(function(Oe) {
            return fr.test(Oe || "") || Pi.error("unsupported lang: " + Oe), Oe = Oe.replace(Si, sn).toLowerCase(), function(qe) {
              var ht;
              do
                if (ht = De ? qe.lang : qe.getAttribute("xml:lang") || qe.getAttribute("lang"))
                  return ht = ht.toLowerCase(), ht === Oe || ht.indexOf(Oe + "-") === 0;
              while ((qe = qe.parentNode) && qe.nodeType === 1);
              return !1;
            };
          }),
          // Miscellaneous
          target: function(Oe) {
            var qe = e.location && e.location.hash;
            return qe && qe.slice(1) === Oe.id;
          },
          root: function(Oe) {
            return Oe === Ve;
          },
          focus: function(Oe) {
            return Oe === ai() && ye.hasFocus() && !!(Oe.type || Oe.href || ~Oe.tabIndex);
          },
          // Boolean properties
          enabled: Ur(!1),
          disabled: Ur(!0),
          checked: function(Oe) {
            return ke(Oe, "input") && !!Oe.checked || ke(Oe, "option") && !!Oe.selected;
          },
          selected: function(Oe) {
            return Oe.parentNode && Oe.parentNode.selectedIndex, Oe.selected === !0;
          },
          // Contents
          empty: function(Oe) {
            for (Oe = Oe.firstChild; Oe; Oe = Oe.nextSibling)
              if (Oe.nodeType < 6)
                return !1;
            return !0;
          },
          parent: function(Oe) {
            return !O.pseudos.empty(Oe);
          },
          // Element/input types
          header: function(Oe) {
            return qn.test(Oe.nodeName);
          },
          input: function(Oe) {
            return Jt.test(Oe.nodeName);
          },
          button: function(Oe) {
            return ke(Oe, "input") && Oe.type === "button" || ke(Oe, "button");
          },
          text: function(Oe) {
            var qe;
            return ke(Oe, "input") && Oe.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((qe = Oe.getAttribute("type")) == null || qe.toLowerCase() === "text");
          },
          // Position-in-collection
          first: Xn(function() {
            return [0];
          }),
          last: Xn(function(Oe, qe) {
            return [qe - 1];
          }),
          eq: Xn(function(Oe, qe, ht) {
            return [ht < 0 ? ht + qe : ht];
          }),
          even: Xn(function(Oe, qe) {
            for (var ht = 0; ht < qe; ht += 2)
              Oe.push(ht);
            return Oe;
          }),
          odd: Xn(function(Oe, qe) {
            for (var ht = 1; ht < qe; ht += 2)
              Oe.push(ht);
            return Oe;
          }),
          lt: Xn(function(Oe, qe, ht) {
            var gt;
            for (ht < 0 ? gt = ht + qe : ht > qe ? gt = qe : gt = ht; --gt >= 0; )
              Oe.push(gt);
            return Oe;
          }),
          gt: Xn(function(Oe, qe, ht) {
            for (var gt = ht < 0 ? ht + qe : ht; ++gt < qe; )
              Oe.push(gt);
            return Oe;
          })
        }
      }, O.pseudos.nth = O.pseudos.eq;
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        O.pseudos[w] = Ir(w);
      for (w in { submit: !0, reset: !0 })
        O.pseudos[w] = Js(w);
      function Kn() {
      }
      Kn.prototype = O.filters = O.pseudos, O.setFilters = new Kn();
      function ar(Oe, qe) {
        var ht, gt, Le, je, Ye, ee, oe, Me = wi[Oe + " "];
        if (Me)
          return qe ? 0 : Me.slice(0);
        for (Ye = Oe, ee = [], oe = O.preFilter; Ye; ) {
          (!ht || (gt = Wi.exec(Ye))) && (gt && (Ye = Ye.slice(gt[0].length) || Ye), ee.push(Le = [])), ht = !1, (gt = es.exec(Ye)) && (ht = gt.shift(), Le.push({
            value: ht,
            // Cast descendant combinators to space
            type: gt[0].replace(ue, " ")
          }), Ye = Ye.slice(ht.length));
          for (je in O.filter)
            (gt = Un[je].exec(Ye)) && (!oe[je] || (gt = oe[je](gt))) && (ht = gt.shift(), Le.push({
              value: ht,
              type: je,
              matches: gt
            }), Ye = Ye.slice(ht.length));
          if (!ht)
            break;
        }
        return qe ? Ye.length : Ye ? Pi.error(Oe) : (
          // Cache the tokens
          wi(Oe, ee).slice(0)
        );
      }
      function Yn(Oe) {
        for (var qe = 0, ht = Oe.length, gt = ""; qe < ht; qe++)
          gt += Oe[qe].value;
        return gt;
      }
      function dr(Oe, qe, ht) {
        var gt = qe.dir, Le = qe.next, je = Le || gt, Ye = ht && je === "parentNode", ee = Ut++;
        return qe.first ? (
          // Check against closest ancestor/preceding element
          function(oe, Me, Ee) {
            for (; oe = oe[gt]; )
              if (oe.nodeType === 1 || Ye)
                return Oe(oe, Me, Ee);
            return !1;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(oe, Me, Ee) {
            var at, Mt, vt = [ut, ee];
            if (Ee) {
              for (; oe = oe[gt]; )
                if ((oe.nodeType === 1 || Ye) && Oe(oe, Me, Ee))
                  return !0;
            } else
              for (; oe = oe[gt]; )
                if (oe.nodeType === 1 || Ye)
                  if (Mt = oe[Ct] || (oe[Ct] = {}), Le && ke(oe, Le))
                    oe = oe[gt] || oe;
                  else {
                    if ((at = Mt[je]) && at[0] === ut && at[1] === ee)
                      return vt[2] = at[2];
                    if (Mt[je] = vt, vt[2] = Oe(oe, Me, Ee))
                      return !0;
                  }
            return !1;
          }
        );
      }
      function Ui(Oe) {
        return Oe.length > 1 ? function(qe, ht, gt) {
          for (var Le = Oe.length; Le--; )
            if (!Oe[Le](qe, ht, gt))
              return !1;
          return !0;
        } : Oe[0];
      }
      function ts(Oe, qe, ht) {
        for (var gt = 0, Le = qe.length; gt < Le; gt++)
          Pi(Oe, qe[gt], ht);
        return ht;
      }
      function cs(Oe, qe, ht, gt, Le) {
        for (var je, Ye = [], ee = 0, oe = Oe.length, Me = qe != null; ee < oe; ee++)
          (je = Oe[ee]) && (!ht || ht(je, gt, Le)) && (Ye.push(je), Me && qe.push(ee));
        return Ye;
      }
      function xr(Oe, qe, ht, gt, Le, je) {
        return gt && !gt[Ct] && (gt = xr(gt)), Le && !Le[Ct] && (Le = xr(Le, je)), oi(function(Ye, ee, oe, Me) {
          var Ee, at, Mt, vt, Vt = [], Ei = [], $i = ee.length, vn = Ye || ts(
            qe || "*",
            oe.nodeType ? [oe] : oe,
            []
          ), wn = Oe && (Ye || !qe) ? cs(vn, Vt, Oe, oe, Me) : vn;
          if (ht ? (vt = Le || (Ye ? Oe : $i || gt) ? (
            // ...intermediate processing is necessary
            []
          ) : (
            // ...otherwise use results directly
            ee
          ), ht(wn, vt, oe, Me)) : vt = wn, gt)
            for (Ee = cs(vt, Ei), gt(Ee, [], oe, Me), at = Ee.length; at--; )
              (Mt = Ee[at]) && (vt[Ei[at]] = !(wn[Ei[at]] = Mt));
          if (Ye) {
            if (Le || Oe) {
              if (Le) {
                for (Ee = [], at = vt.length; at--; )
                  (Mt = vt[at]) && Ee.push(wn[at] = Mt);
                Le(null, vt = [], Ee, Me);
              }
              for (at = vt.length; at--; )
                (Mt = vt[at]) && (Ee = Le ? v.call(Ye, Mt) : Vt[at]) > -1 && (Ye[Ee] = !(ee[Ee] = Mt));
            }
          } else
            vt = cs(
              vt === ee ? vt.splice($i, vt.length) : vt
            ), Le ? Le(null, ee, vt, Me) : _e.apply(ee, vt);
        });
      }
      function Ln(Oe) {
        for (var qe, ht, gt, Le = Oe.length, je = O.relative[Oe[0].type], Ye = je || O.relative[" "], ee = je ? 1 : 0, oe = dr(function(at) {
          return at === qe;
        }, Ye, !0), Me = dr(function(at) {
          return v.call(qe, at) > -1;
        }, Ye, !0), Ee = [function(at, Mt, vt) {
          var Vt = !je && (vt || Mt != q) || ((qe = Mt).nodeType ? oe(at, Mt, vt) : Me(at, Mt, vt));
          return qe = null, Vt;
        }]; ee < Le; ee++)
          if (ht = O.relative[Oe[ee].type])
            Ee = [dr(Ui(Ee), ht)];
          else {
            if (ht = O.filter[Oe[ee].type].apply(null, Oe[ee].matches), ht[Ct]) {
              for (gt = ++ee; gt < Le && !O.relative[Oe[gt].type]; gt++)
                ;
              return xr(
                ee > 1 && Ui(Ee),
                ee > 1 && Yn(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  Oe.slice(0, ee - 1).concat({ value: Oe[ee - 2].type === " " ? "*" : "" })
                ).replace(ue, "$1"),
                ht,
                ee < gt && Ln(Oe.slice(ee, gt)),
                gt < Le && Ln(Oe = Oe.slice(gt)),
                gt < Le && Yn(Oe)
              );
            }
            Ee.push(ht);
          }
        return Ui(Ee);
      }
      function Vr(Oe, qe) {
        var ht = qe.length > 0, gt = Oe.length > 0, Le = function(je, Ye, ee, oe, Me) {
          var Ee, at, Mt, vt = 0, Vt = "0", Ei = je && [], $i = [], vn = q, wn = je || gt && O.find.TAG("*", Me), gr = ut += vn == null ? 1 : Math.random() || 0.1, Li = wn.length;
          for (Me && (q = Ye == ye || Ye || Me); Vt !== Li && (Ee = wn[Vt]) != null; Vt++) {
            if (gt && Ee) {
              for (at = 0, !Ye && Ee.ownerDocument != ye && (Nn(Ee), ee = !De); Mt = Oe[at++]; )
                if (Mt(Ee, Ye || ye, ee)) {
                  _e.call(oe, Ee);
                  break;
                }
              Me && (ut = gr);
            }
            ht && ((Ee = !Mt && Ee) && vt--, je && Ei.push(Ee));
          }
          if (vt += Vt, ht && Vt !== vt) {
            for (at = 0; Mt = qe[at++]; )
              Mt(Ei, $i, Ye, ee);
            if (je) {
              if (vt > 0)
                for (; Vt--; )
                  Ei[Vt] || $i[Vt] || ($i[Vt] = $e.call(oe));
              $i = cs($i);
            }
            _e.apply(oe, $i), Me && !je && $i.length > 0 && vt + qe.length > 1 && j.uniqueSort(oe);
          }
          return Me && (ut = gr, q = vn), Ei;
        };
        return ht ? oi(Le) : Le;
      }
      function ws(Oe, qe) {
        var ht, gt = [], Le = [], je = bi[Oe + " "];
        if (!je) {
          for (qe || (qe = ar(Oe)), ht = qe.length; ht--; )
            je = Ln(qe[ht]), je[Ct] ? gt.push(je) : Le.push(je);
          je = bi(
            Oe,
            Vr(Le, gt)
          ), je.selector = Oe;
        }
        return je;
      }
      function or(Oe, qe, ht, gt) {
        var Le, je, Ye, ee, oe, Me = typeof Oe == "function" && Oe, Ee = !gt && ar(Oe = Me.selector || Oe);
        if (ht = ht || [], Ee.length === 1) {
          if (je = Ee[0] = Ee[0].slice(0), je.length > 2 && (Ye = je[0]).type === "ID" && qe.nodeType === 9 && De && O.relative[je[1].type]) {
            if (qe = (O.find.ID(
              Ye.matches[0].replace(Si, sn),
              qe
            ) || [])[0], qe)
              Me && (qe = qe.parentNode);
            else
              return ht;
            Oe = Oe.slice(je.shift().value.length);
          }
          for (Le = Un.needsContext.test(Oe) ? 0 : je.length; Le-- && (Ye = je[Le], !O.relative[ee = Ye.type]); )
            if ((oe = O.find[ee]) && (gt = oe(
              Ye.matches[0].replace(Si, sn),
              Er.test(je[0].type) && hn(qe.parentNode) || qe
            ))) {
              if (je.splice(Le, 1), Oe = gt.length && Yn(je), !Oe)
                return _e.apply(ht, gt), ht;
              break;
            }
        }
        return (Me || ws(Oe, Ee))(
          gt,
          qe,
          !De,
          ht,
          !qe || Er.test(Oe) && hn(qe.parentNode) || qe
        ), ht;
      }
      X.sortStable = Ct.split("").sort(_n).join("") === Ct, Nn(), X.sortDetached = dn(function(Oe) {
        return Oe.compareDocumentPosition(ye.createElement("fieldset")) & 1;
      }), j.find = Pi, j.expr[":"] = j.expr.pseudos, j.unique = j.uniqueSort, Pi.compile = ws, Pi.select = or, Pi.setDocument = Nn, Pi.tokenize = ar, Pi.escape = j.escapeSelector, Pi.getText = j.text, Pi.isXML = j.isXMLDoc, Pi.selectors = j.expr, Pi.support = j.support, Pi.uniqueSort = j.uniqueSort;
    })();
    var it = function(w, O, q) {
      for (var ne = [], de = q !== void 0; (w = w[O]) && w.nodeType !== 9; )
        if (w.nodeType === 1) {
          if (de && j(w).is(q))
            break;
          ne.push(w);
        }
      return ne;
    }, Zt = function(w, O) {
      for (var q = []; w; w = w.nextSibling)
        w.nodeType === 1 && w !== O && q.push(w);
      return q;
    }, ct = j.expr.match.needsContext, lt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function $t(w, O, q) {
      return Y(O) ? j.grep(w, function(ne, de) {
        return !!O.call(ne, de, ne) !== q;
      }) : O.nodeType ? j.grep(w, function(ne) {
        return ne === O !== q;
      }) : typeof O != "string" ? j.grep(w, function(ne) {
        return v.call(O, ne) > -1 !== q;
      }) : j.filter(O, w, q);
    }
    j.filter = function(w, O, q) {
      var ne = O[0];
      return q && (w = ":not(" + w + ")"), O.length === 1 && ne.nodeType === 1 ? j.find.matchesSelector(ne, w) ? [ne] : [] : j.find.matches(w, j.grep(O, function(de) {
        return de.nodeType === 1;
      }));
    }, j.fn.extend({
      find: function(w) {
        var O, q, ne = this.length, de = this;
        if (typeof w != "string")
          return this.pushStack(j(w).filter(function() {
            for (O = 0; O < ne; O++)
              if (j.contains(de[O], this))
                return !0;
          }));
        for (q = this.pushStack([]), O = 0; O < ne; O++)
          j.find(w, de[O], q);
        return ne > 1 ? j.uniqueSort(q) : q;
      },
      filter: function(w) {
        return this.pushStack($t(this, w || [], !1));
      },
      not: function(w) {
        return this.pushStack($t(this, w || [], !0));
      },
      is: function(w) {
        return !!$t(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof w == "string" && ct.test(w) ? j(w) : w || [],
          !1
        ).length;
      }
    });
    var Kt, At = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, Ni = j.fn.init = function(w, O, q) {
      var ne, de;
      if (!w)
        return this;
      if (q = q || Kt, typeof w == "string")
        if (w[0] === "<" && w[w.length - 1] === ">" && w.length >= 3 ? ne = [null, w, null] : ne = At.exec(w), ne && (ne[1] || !O))
          if (ne[1]) {
            if (O = O instanceof j ? O[0] : O, j.merge(this, j.parseHTML(
              ne[1],
              O && O.nodeType ? O.ownerDocument || O : G,
              !0
            )), lt.test(ne[1]) && j.isPlainObject(O))
              for (ne in O)
                Y(this[ne]) ? this[ne](O[ne]) : this.attr(ne, O[ne]);
            return this;
          } else
            return de = G.getElementById(ne[2]), de && (this[0] = de, this.length = 1), this;
        else
          return !O || O.jquery ? (O || q).find(w) : this.constructor(O).find(w);
      else {
        if (w.nodeType)
          return this[0] = w, this.length = 1, this;
        if (Y(w))
          return q.ready !== void 0 ? q.ready(w) : (
            // Execute immediately if ready is not present
            w(j)
          );
      }
      return j.makeArray(w, this);
    };
    Ni.prototype = j.fn, Kt = j(G);
    var rn = /^(?:parents|prev(?:Until|All))/, ui = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };
    j.fn.extend({
      has: function(w) {
        var O = j(w, this), q = O.length;
        return this.filter(function() {
          for (var ne = 0; ne < q; ne++)
            if (j.contains(this, O[ne]))
              return !0;
        });
      },
      closest: function(w, O) {
        var q, ne = 0, de = this.length, _e = [], ye = typeof w != "string" && j(w);
        if (!ct.test(w)) {
          for (; ne < de; ne++)
            for (q = this[ne]; q && q !== O; q = q.parentNode)
              if (q.nodeType < 11 && (ye ? ye.index(q) > -1 : (
                // Don't pass non-elements to jQuery#find
                q.nodeType === 1 && j.find.matchesSelector(q, w)
              ))) {
                _e.push(q);
                break;
              }
        }
        return this.pushStack(_e.length > 1 ? j.uniqueSort(_e) : _e);
      },
      // Determine the position of an element within the set
      index: function(w) {
        return w ? typeof w == "string" ? v.call(j(w), this[0]) : v.call(
          this,
          // If it receives a jQuery object, the first element is used
          w.jquery ? w[0] : w
        ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function(w, O) {
        return this.pushStack(
          j.uniqueSort(
            j.merge(this.get(), j(w, O))
          )
        );
      },
      addBack: function(w) {
        return this.add(
          w == null ? this.prevObject : this.prevObject.filter(w)
        );
      }
    });
    function Wt(w, O) {
      for (; (w = w[O]) && w.nodeType !== 1; )
        ;
      return w;
    }
    j.each({
      parent: function(w) {
        var O = w.parentNode;
        return O && O.nodeType !== 11 ? O : null;
      },
      parents: function(w) {
        return it(w, "parentNode");
      },
      parentsUntil: function(w, O, q) {
        return it(w, "parentNode", q);
      },
      next: function(w) {
        return Wt(w, "nextSibling");
      },
      prev: function(w) {
        return Wt(w, "previousSibling");
      },
      nextAll: function(w) {
        return it(w, "nextSibling");
      },
      prevAll: function(w) {
        return it(w, "previousSibling");
      },
      nextUntil: function(w, O, q) {
        return it(w, "nextSibling", q);
      },
      prevUntil: function(w, O, q) {
        return it(w, "previousSibling", q);
      },
      siblings: function(w) {
        return Zt((w.parentNode || {}).firstChild, w);
      },
      children: function(w) {
        return Zt(w.firstChild);
      },
      contents: function(w) {
        return w.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        o(w.contentDocument) ? w.contentDocument : (ke(w, "template") && (w = w.content || w), j.merge([], w.childNodes));
      }
    }, function(w, O) {
      j.fn[w] = function(q, ne) {
        var de = j.map(this, O, q);
        return w.slice(-5) !== "Until" && (ne = q), ne && typeof ne == "string" && (de = j.filter(ne, de)), this.length > 1 && (ui[w] || j.uniqueSort(de), rn.test(w) && de.reverse()), this.pushStack(de);
      };
    });
    var Qt = /[^\x20\t\r\n\f]+/g;
    function ei(w) {
      var O = {};
      return j.each(w.match(Qt) || [], function(q, ne) {
        O[ne] = !0;
      }), O;
    }
    j.Callbacks = function(w) {
      w = typeof w == "string" ? ei(w) : j.extend({}, w);
      var O, q, ne, de, _e = [], ye = [], Ve = -1, De = function() {
        for (de = de || w.once, ne = O = !0; ye.length; Ve = -1)
          for (q = ye.shift(); ++Ve < _e.length; )
            _e[Ve].apply(q[0], q[1]) === !1 && w.stopOnFalse && (Ve = _e.length, q = !1);
        w.memory || (q = !1), O = !1, de && (q ? _e = [] : _e = "");
      }, Ke = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          return _e && (q && !O && (Ve = _e.length - 1, ye.push(q)), function St(Ct) {
            j.each(Ct, function(ut, Ut) {
              Y(Ut) ? (!w.unique || !Ke.has(Ut)) && _e.push(Ut) : Ut && Ut.length && he(Ut) !== "string" && St(Ut);
            });
          }(arguments), q && !O && De()), this;
        },
        // Remove a callback from the list
        remove: function() {
          return j.each(arguments, function(St, Ct) {
            for (var ut; (ut = j.inArray(Ct, _e, ut)) > -1; )
              _e.splice(ut, 1), ut <= Ve && Ve--;
          }), this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(St) {
          return St ? j.inArray(St, _e) > -1 : _e.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          return _e && (_e = []), this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          return de = ye = [], _e = q = "", this;
        },
        disabled: function() {
          return !_e;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          return de = ye = [], !q && !O && (_e = q = ""), this;
        },
        locked: function() {
          return !!de;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(St, Ct) {
          return de || (Ct = Ct || [], Ct = [St, Ct.slice ? Ct.slice() : Ct], ye.push(Ct), O || De()), this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          return Ke.fireWith(this, arguments), this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!ne;
        }
      };
      return Ke;
    };
    function on(w) {
      return w;
    }
    function tn(w) {
      throw w;
    }
    function pe(w, O, q, ne) {
      var de;
      try {
        w && Y(de = w.promise) ? de.call(w).done(O).fail(q) : w && Y(de = w.then) ? de.call(w, O, q) : O.apply(void 0, [w].slice(ne));
      } catch (_e) {
        q.apply(void 0, [_e]);
      }
    }
    j.extend({
      Deferred: function(w) {
        var O = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            j.Callbacks("memory"),
            j.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            j.Callbacks("once memory"),
            j.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            j.Callbacks("once memory"),
            j.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], q = "pending", ne = {
          state: function() {
            return q;
          },
          always: function() {
            return de.done(arguments).fail(arguments), this;
          },
          catch: function(_e) {
            return ne.then(null, _e);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var _e = arguments;
            return j.Deferred(function(ye) {
              j.each(O, function(Ve, De) {
                var Ke = Y(_e[De[4]]) && _e[De[4]];
                de[De[1]](function() {
                  var St = Ke && Ke.apply(this, arguments);
                  St && Y(St.promise) ? St.promise().progress(ye.notify).done(ye.resolve).fail(ye.reject) : ye[De[0] + "With"](
                    this,
                    Ke ? [St] : arguments
                  );
                });
              }), _e = null;
            }).promise();
          },
          then: function(_e, ye, Ve) {
            var De = 0;
            function Ke(St, Ct, ut, Ut) {
              return function() {
                var ti = this, wi = arguments, bi = function() {
                  var _n, fn;
                  if (!(St < De)) {
                    if (_n = ut.apply(ti, wi), _n === Ct.promise())
                      throw new TypeError("Thenable self-resolution");
                    fn = _n && // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (typeof _n == "object" || typeof _n == "function") && _n.then, Y(fn) ? Ut ? fn.call(
                      _n,
                      Ke(De, Ct, on, Ut),
                      Ke(De, Ct, tn, Ut)
                    ) : (De++, fn.call(
                      _n,
                      Ke(De, Ct, on, Ut),
                      Ke(De, Ct, tn, Ut),
                      Ke(
                        De,
                        Ct,
                        on,
                        Ct.notifyWith
                      )
                    )) : (ut !== on && (ti = void 0, wi = [_n]), (Ut || Ct.resolveWith)(ti, wi));
                  }
                }, An = Ut ? bi : function() {
                  try {
                    bi();
                  } catch (_n) {
                    j.Deferred.exceptionHook && j.Deferred.exceptionHook(
                      _n,
                      An.error
                    ), St + 1 >= De && (ut !== tn && (ti = void 0, wi = [_n]), Ct.rejectWith(ti, wi));
                  }
                };
                St ? An() : (j.Deferred.getErrorHook ? An.error = j.Deferred.getErrorHook() : j.Deferred.getStackHook && (An.error = j.Deferred.getStackHook()), e.setTimeout(An));
              };
            }
            return j.Deferred(function(St) {
              O[0][3].add(
                Ke(
                  0,
                  St,
                  Y(Ve) ? Ve : on,
                  St.notifyWith
                )
              ), O[1][3].add(
                Ke(
                  0,
                  St,
                  Y(_e) ? _e : on
                )
              ), O[2][3].add(
                Ke(
                  0,
                  St,
                  Y(ye) ? ye : tn
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(_e) {
            return _e != null ? j.extend(_e, ne) : ne;
          }
        }, de = {};
        return j.each(O, function(_e, ye) {
          var Ve = ye[2], De = ye[5];
          ne[ye[1]] = Ve.add, De && Ve.add(
            function() {
              q = De;
            },
            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            O[3 - _e][2].disable,
            // rejected_handlers.disable
            // fulfilled_handlers.disable
            O[3 - _e][3].disable,
            // progress_callbacks.lock
            O[0][2].lock,
            // progress_handlers.lock
            O[0][3].lock
          ), Ve.add(ye[3].fire), de[ye[0]] = function() {
            return de[ye[0] + "With"](this === de ? void 0 : this, arguments), this;
          }, de[ye[0] + "With"] = Ve.fireWith;
        }), ne.promise(de), w && w.call(de, de), de;
      },
      // Deferred helper
      when: function(w) {
        var O = arguments.length, q = O, ne = Array(q), de = a.call(arguments), _e = j.Deferred(), ye = function(Ve) {
          return function(De) {
            ne[Ve] = this, de[Ve] = arguments.length > 1 ? a.call(arguments) : De, --O || _e.resolveWith(ne, de);
          };
        };
        if (O <= 1 && (pe(
          w,
          _e.done(ye(q)).resolve,
          _e.reject,
          !O
        ), _e.state() === "pending" || Y(de[q] && de[q].then)))
          return _e.then();
        for (; q--; )
          pe(de[q], ye(q), _e.reject);
        return _e.promise();
      }
    });
    var Tt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    j.Deferred.exceptionHook = function(w, O) {
      e.console && e.console.warn && w && Tt.test(w.name) && e.console.warn(
        "jQuery.Deferred exception: " + w.message,
        w.stack,
        O
      );
    }, j.readyException = function(w) {
      e.setTimeout(function() {
        throw w;
      });
    };
    var xt = j.Deferred();
    j.fn.ready = function(w) {
      return xt.then(w).catch(function(O) {
        j.readyException(O);
      }), this;
    }, j.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: !1,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(w) {
        (w === !0 ? --j.readyWait : j.isReady) || (j.isReady = !0, !(w !== !0 && --j.readyWait > 0) && xt.resolveWith(G, [j]));
      }
    }), j.ready.then = xt.then;
    function Re() {
      G.removeEventListener("DOMContentLoaded", Re), e.removeEventListener("load", Re), j.ready();
    }
    G.readyState === "complete" || G.readyState !== "loading" && !G.documentElement.doScroll ? e.setTimeout(j.ready) : (G.addEventListener("DOMContentLoaded", Re), e.addEventListener("load", Re));
    var Ie = function(w, O, q, ne, de, _e, ye) {
      var Ve = 0, De = w.length, Ke = q == null;
      if (he(q) === "object") {
        de = !0;
        for (Ve in q)
          Ie(w, O, Ve, q[Ve], !0, _e, ye);
      } else if (ne !== void 0 && (de = !0, Y(ne) || (ye = !0), Ke && (ye ? (O.call(w, ne), O = null) : (Ke = O, O = function(St, Ct, ut) {
        return Ke.call(j(St), ut);
      })), O))
        for (; Ve < De; Ve++)
          O(
            w[Ve],
            q,
            ye ? ne : ne.call(w[Ve], Ve, O(w[Ve], q))
          );
      return de ? w : Ke ? O.call(w) : De ? O(w[0], q) : _e;
    }, Qe = /^-ms-/, Bt = /-([a-z])/g;
    function dt(w, O) {
      return O.toUpperCase();
    }
    function et(w) {
      return w.replace(Qe, "ms-").replace(Bt, dt);
    }
    var wt = function(w) {
      return w.nodeType === 1 || w.nodeType === 9 || !+w.nodeType;
    };
    function Xt() {
      this.expando = j.expando + Xt.uid++;
    }
    Xt.uid = 1, Xt.prototype = {
      cache: function(w) {
        var O = w[this.expando];
        return O || (O = {}, wt(w) && (w.nodeType ? w[this.expando] = O : Object.defineProperty(w, this.expando, {
          value: O,
          configurable: !0
        }))), O;
      },
      set: function(w, O, q) {
        var ne, de = this.cache(w);
        if (typeof O == "string")
          de[et(O)] = q;
        else
          for (ne in O)
            de[et(ne)] = O[ne];
        return de;
      },
      get: function(w, O) {
        return O === void 0 ? this.cache(w) : (
          // Always use camelCase key (gh-2257)
          w[this.expando] && w[this.expando][et(O)]
        );
      },
      access: function(w, O, q) {
        return O === void 0 || O && typeof O == "string" && q === void 0 ? this.get(w, O) : (this.set(w, O, q), q !== void 0 ? q : O);
      },
      remove: function(w, O) {
        var q, ne = w[this.expando];
        if (ne !== void 0) {
          if (O !== void 0)
            for (Array.isArray(O) ? O = O.map(et) : (O = et(O), O = O in ne ? [O] : O.match(Qt) || []), q = O.length; q--; )
              delete ne[O[q]];
          (O === void 0 || j.isEmptyObject(ne)) && (w.nodeType ? w[this.expando] = void 0 : delete w[this.expando]);
        }
      },
      hasData: function(w) {
        var O = w[this.expando];
        return O !== void 0 && !j.isEmptyObject(O);
      }
    };
    var He = new Xt(), i = new Xt(), n = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, s = /[A-Z]/g;
    function l(w) {
      return w === "true" ? !0 : w === "false" ? !1 : w === "null" ? null : w === +w + "" ? +w : n.test(w) ? JSON.parse(w) : w;
    }
    function h(w, O, q) {
      var ne;
      if (q === void 0 && w.nodeType === 1)
        if (ne = "data-" + O.replace(s, "-$&").toLowerCase(), q = w.getAttribute(ne), typeof q == "string") {
          try {
            q = l(q);
          } catch {
          }
          i.set(w, O, q);
        } else
          q = void 0;
      return q;
    }
    j.extend({
      hasData: function(w) {
        return i.hasData(w) || He.hasData(w);
      },
      data: function(w, O, q) {
        return i.access(w, O, q);
      },
      removeData: function(w, O) {
        i.remove(w, O);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(w, O, q) {
        return He.access(w, O, q);
      },
      _removeData: function(w, O) {
        He.remove(w, O);
      }
    }), j.fn.extend({
      data: function(w, O) {
        var q, ne, de, _e = this[0], ye = _e && _e.attributes;
        if (w === void 0) {
          if (this.length && (de = i.get(_e), _e.nodeType === 1 && !He.get(_e, "hasDataAttrs"))) {
            for (q = ye.length; q--; )
              ye[q] && (ne = ye[q].name, ne.indexOf("data-") === 0 && (ne = et(ne.slice(5)), h(_e, ne, de[ne])));
            He.set(_e, "hasDataAttrs", !0);
          }
          return de;
        }
        return typeof w == "object" ? this.each(function() {
          i.set(this, w);
        }) : Ie(this, function(Ve) {
          var De;
          if (_e && Ve === void 0)
            return De = i.get(_e, w), De !== void 0 || (De = h(_e, w), De !== void 0) ? De : void 0;
          this.each(function() {
            i.set(this, w, Ve);
          });
        }, null, O, arguments.length > 1, null, !0);
      },
      removeData: function(w) {
        return this.each(function() {
          i.remove(this, w);
        });
      }
    }), j.extend({
      queue: function(w, O, q) {
        var ne;
        if (w)
          return O = (O || "fx") + "queue", ne = He.get(w, O), q && (!ne || Array.isArray(q) ? ne = He.access(w, O, j.makeArray(q)) : ne.push(q)), ne || [];
      },
      dequeue: function(w, O) {
        O = O || "fx";
        var q = j.queue(w, O), ne = q.length, de = q.shift(), _e = j._queueHooks(w, O), ye = function() {
          j.dequeue(w, O);
        };
        de === "inprogress" && (de = q.shift(), ne--), de && (O === "fx" && q.unshift("inprogress"), delete _e.stop, de.call(w, ye, _e)), !ne && _e && _e.empty.fire();
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(w, O) {
        var q = O + "queueHooks";
        return He.get(w, q) || He.access(w, q, {
          empty: j.Callbacks("once memory").add(function() {
            He.remove(w, [O + "queue", q]);
          })
        });
      }
    }), j.fn.extend({
      queue: function(w, O) {
        var q = 2;
        return typeof w != "string" && (O = w, w = "fx", q--), arguments.length < q ? j.queue(this[0], w) : O === void 0 ? this : this.each(function() {
          var ne = j.queue(this, w, O);
          j._queueHooks(this, w), w === "fx" && ne[0] !== "inprogress" && j.dequeue(this, w);
        });
      },
      dequeue: function(w) {
        return this.each(function() {
          j.dequeue(this, w);
        });
      },
      clearQueue: function(w) {
        return this.queue(w || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(w, O) {
        var q, ne = 1, de = j.Deferred(), _e = this, ye = this.length, Ve = function() {
          --ne || de.resolveWith(_e, [_e]);
        };
        for (typeof w != "string" && (O = w, w = void 0), w = w || "fx"; ye--; )
          q = He.get(_e[ye], w + "queueHooks"), q && q.empty && (ne++, q.empty.add(Ve));
        return Ve(), de.promise(O);
      }
    });
    var d = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, m = new RegExp("^(?:([+-])=|)(" + d + ")([a-z%]*)$", "i"), _ = ["Top", "Right", "Bottom", "Left"], b = G.documentElement, x = function(w) {
      return j.contains(w.ownerDocument, w);
    }, T = { composed: !0 };
    b.getRootNode && (x = function(w) {
      return j.contains(w.ownerDocument, w) || w.getRootNode(T) === w.ownerDocument;
    });
    var E = function(w, O) {
      return w = O || w, w.style.display === "none" || w.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      x(w) && j.css(w, "display") === "none";
    };
    function L(w, O, q, ne) {
      var de, _e, ye = 20, Ve = ne ? function() {
        return ne.cur();
      } : function() {
        return j.css(w, O, "");
      }, De = Ve(), Ke = q && q[3] || (j.cssNumber[O] ? "" : "px"), St = w.nodeType && (j.cssNumber[O] || Ke !== "px" && +De) && m.exec(j.css(w, O));
      if (St && St[3] !== Ke) {
        for (De = De / 2, Ke = Ke || St[3], St = +De || 1; ye--; )
          j.style(w, O, St + Ke), (1 - _e) * (1 - (_e = Ve() / De || 0.5)) <= 0 && (ye = 0), St = St / _e;
        St = St * 2, j.style(w, O, St + Ke), q = q || [];
      }
      return q && (St = +St || +De || 0, de = q[1] ? St + (q[1] + 1) * q[2] : +q[2], ne && (ne.unit = Ke, ne.start = St, ne.end = de)), de;
    }
    var A = {};
    function U(w) {
      var O, q = w.ownerDocument, ne = w.nodeName, de = A[ne];
      return de || (O = q.body.appendChild(q.createElement(ne)), de = j.css(O, "display"), O.parentNode.removeChild(O), de === "none" && (de = "block"), A[ne] = de, de);
    }
    function k(w, O) {
      for (var q, ne, de = [], _e = 0, ye = w.length; _e < ye; _e++)
        ne = w[_e], ne.style && (q = ne.style.display, O ? (q === "none" && (de[_e] = He.get(ne, "display") || null, de[_e] || (ne.style.display = "")), ne.style.display === "" && E(ne) && (de[_e] = U(ne))) : q !== "none" && (de[_e] = "none", He.set(ne, "display", q)));
      for (_e = 0; _e < ye; _e++)
        de[_e] != null && (w[_e].style.display = de[_e]);
      return w;
    }
    j.fn.extend({
      show: function() {
        return k(this, !0);
      },
      hide: function() {
        return k(this);
      },
      toggle: function(w) {
        return typeof w == "boolean" ? w ? this.show() : this.hide() : this.each(function() {
          E(this) ? j(this).show() : j(this).hide();
        });
      }
    });
    var F = /^(?:checkbox|radio)$/i, B = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, R = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var w = G.createDocumentFragment(), O = w.appendChild(G.createElement("div")), q = G.createElement("input");
      q.setAttribute("type", "radio"), q.setAttribute("checked", "checked"), q.setAttribute("name", "t"), O.appendChild(q), X.checkClone = O.cloneNode(!0).cloneNode(!0).lastChild.checked, O.innerHTML = "<textarea>x</textarea>", X.noCloneChecked = !!O.cloneNode(!0).lastChild.defaultValue, O.innerHTML = "<option></option>", X.option = !!O.lastChild;
    })();
    var C = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    C.tbody = C.tfoot = C.colgroup = C.caption = C.thead, C.th = C.td, X.option || (C.optgroup = C.option = [1, "<select multiple='multiple'>", "</select>"]);
    function P(w, O) {
      var q;
      return typeof w.getElementsByTagName < "u" ? q = w.getElementsByTagName(O || "*") : typeof w.querySelectorAll < "u" ? q = w.querySelectorAll(O || "*") : q = [], O === void 0 || O && ke(w, O) ? j.merge([w], q) : q;
    }
    function H(w, O) {
      for (var q = 0, ne = w.length; q < ne; q++)
        He.set(
          w[q],
          "globalEval",
          !O || He.get(O[q], "globalEval")
        );
    }
    var W = /<|&#?\w+;/;
    function V(w, O, q, ne, de) {
      for (var _e, ye, Ve, De, Ke, St, Ct = O.createDocumentFragment(), ut = [], Ut = 0, ti = w.length; Ut < ti; Ut++)
        if (_e = w[Ut], _e || _e === 0)
          if (he(_e) === "object")
            j.merge(ut, _e.nodeType ? [_e] : _e);
          else if (!W.test(_e))
            ut.push(O.createTextNode(_e));
          else {
            for (ye = ye || Ct.appendChild(O.createElement("div")), Ve = (B.exec(_e) || ["", ""])[1].toLowerCase(), De = C[Ve] || C._default, ye.innerHTML = De[1] + j.htmlPrefilter(_e) + De[2], St = De[0]; St--; )
              ye = ye.lastChild;
            j.merge(ut, ye.childNodes), ye = Ct.firstChild, ye.textContent = "";
          }
      for (Ct.textContent = "", Ut = 0; _e = ut[Ut++]; ) {
        if (ne && j.inArray(_e, ne) > -1) {
          de && de.push(_e);
          continue;
        }
        if (Ke = x(_e), ye = P(Ct.appendChild(_e), "script"), Ke && H(ye), q)
          for (St = 0; _e = ye[St++]; )
            R.test(_e.type || "") && q.push(_e);
      }
      return Ct;
    }
    var Q = /^([^.]*)(?:\.(.+)|)/;
    function ae() {
      return !0;
    }
    function le() {
      return !1;
    }
    function fe(w, O, q, ne, de, _e) {
      var ye, Ve;
      if (typeof O == "object") {
        typeof q != "string" && (ne = ne || q, q = void 0);
        for (Ve in O)
          fe(w, Ve, q, ne, O[Ve], _e);
        return w;
      }
      if (ne == null && de == null ? (de = q, ne = q = void 0) : de == null && (typeof q == "string" ? (de = ne, ne = void 0) : (de = ne, ne = q, q = void 0)), de === !1)
        de = le;
      else if (!de)
        return w;
      return _e === 1 && (ye = de, de = function(De) {
        return j().off(De), ye.apply(this, arguments);
      }, de.guid = ye.guid || (ye.guid = j.guid++)), w.each(function() {
        j.event.add(this, O, de, ne, q);
      });
    }
    j.event = {
      global: {},
      add: function(w, O, q, ne, de) {
        var _e, ye, Ve, De, Ke, St, Ct, ut, Ut, ti, wi, bi = He.get(w);
        if (wt(w))
          for (q.handler && (_e = q, q = _e.handler, de = _e.selector), de && j.find.matchesSelector(b, de), q.guid || (q.guid = j.guid++), (De = bi.events) || (De = bi.events = /* @__PURE__ */ Object.create(null)), (ye = bi.handle) || (ye = bi.handle = function(An) {
            return typeof j < "u" && j.event.triggered !== An.type ? j.event.dispatch.apply(w, arguments) : void 0;
          }), O = (O || "").match(Qt) || [""], Ke = O.length; Ke--; )
            Ve = Q.exec(O[Ke]) || [], Ut = wi = Ve[1], ti = (Ve[2] || "").split(".").sort(), Ut && (Ct = j.event.special[Ut] || {}, Ut = (de ? Ct.delegateType : Ct.bindType) || Ut, Ct = j.event.special[Ut] || {}, St = j.extend({
              type: Ut,
              origType: wi,
              data: ne,
              handler: q,
              guid: q.guid,
              selector: de,
              needsContext: de && j.expr.match.needsContext.test(de),
              namespace: ti.join(".")
            }, _e), (ut = De[Ut]) || (ut = De[Ut] = [], ut.delegateCount = 0, (!Ct.setup || Ct.setup.call(w, ne, ti, ye) === !1) && w.addEventListener && w.addEventListener(Ut, ye)), Ct.add && (Ct.add.call(w, St), St.handler.guid || (St.handler.guid = q.guid)), de ? ut.splice(ut.delegateCount++, 0, St) : ut.push(St), j.event.global[Ut] = !0);
      },
      // Detach an event or set of events from an element
      remove: function(w, O, q, ne, de) {
        var _e, ye, Ve, De, Ke, St, Ct, ut, Ut, ti, wi, bi = He.hasData(w) && He.get(w);
        if (!(!bi || !(De = bi.events))) {
          for (O = (O || "").match(Qt) || [""], Ke = O.length; Ke--; ) {
            if (Ve = Q.exec(O[Ke]) || [], Ut = wi = Ve[1], ti = (Ve[2] || "").split(".").sort(), !Ut) {
              for (Ut in De)
                j.event.remove(w, Ut + O[Ke], q, ne, !0);
              continue;
            }
            for (Ct = j.event.special[Ut] || {}, Ut = (ne ? Ct.delegateType : Ct.bindType) || Ut, ut = De[Ut] || [], Ve = Ve[2] && new RegExp("(^|\\.)" + ti.join("\\.(?:.*\\.|)") + "(\\.|$)"), ye = _e = ut.length; _e--; )
              St = ut[_e], (de || wi === St.origType) && (!q || q.guid === St.guid) && (!Ve || Ve.test(St.namespace)) && (!ne || ne === St.selector || ne === "**" && St.selector) && (ut.splice(_e, 1), St.selector && ut.delegateCount--, Ct.remove && Ct.remove.call(w, St));
            ye && !ut.length && ((!Ct.teardown || Ct.teardown.call(w, ti, bi.handle) === !1) && j.removeEvent(w, Ut, bi.handle), delete De[Ut]);
          }
          j.isEmptyObject(De) && He.remove(w, "handle events");
        }
      },
      dispatch: function(w) {
        var O, q, ne, de, _e, ye, Ve = new Array(arguments.length), De = j.event.fix(w), Ke = (He.get(this, "events") || /* @__PURE__ */ Object.create(null))[De.type] || [], St = j.event.special[De.type] || {};
        for (Ve[0] = De, O = 1; O < arguments.length; O++)
          Ve[O] = arguments[O];
        if (De.delegateTarget = this, !(St.preDispatch && St.preDispatch.call(this, De) === !1)) {
          for (ye = j.event.handlers.call(this, De, Ke), O = 0; (de = ye[O++]) && !De.isPropagationStopped(); )
            for (De.currentTarget = de.elem, q = 0; (_e = de.handlers[q++]) && !De.isImmediatePropagationStopped(); )
              (!De.rnamespace || _e.namespace === !1 || De.rnamespace.test(_e.namespace)) && (De.handleObj = _e, De.data = _e.data, ne = ((j.event.special[_e.origType] || {}).handle || _e.handler).apply(de.elem, Ve), ne !== void 0 && (De.result = ne) === !1 && (De.preventDefault(), De.stopPropagation()));
          return St.postDispatch && St.postDispatch.call(this, De), De.result;
        }
      },
      handlers: function(w, O) {
        var q, ne, de, _e, ye, Ve = [], De = O.delegateCount, Ke = w.target;
        if (De && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        Ke.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(w.type === "click" && w.button >= 1)) {
          for (; Ke !== this; Ke = Ke.parentNode || this)
            if (Ke.nodeType === 1 && !(w.type === "click" && Ke.disabled === !0)) {
              for (_e = [], ye = {}, q = 0; q < De; q++)
                ne = O[q], de = ne.selector + " ", ye[de] === void 0 && (ye[de] = ne.needsContext ? j(de, this).index(Ke) > -1 : j.find(de, this, null, [Ke]).length), ye[de] && _e.push(ne);
              _e.length && Ve.push({ elem: Ke, handlers: _e });
            }
        }
        return Ke = this, De < O.length && Ve.push({ elem: Ke, handlers: O.slice(De) }), Ve;
      },
      addProp: function(w, O) {
        Object.defineProperty(j.Event.prototype, w, {
          enumerable: !0,
          configurable: !0,
          get: Y(O) ? function() {
            if (this.originalEvent)
              return O(this.originalEvent);
          } : function() {
            if (this.originalEvent)
              return this.originalEvent[w];
          },
          set: function(q) {
            Object.defineProperty(this, w, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: q
            });
          }
        });
      },
      fix: function(w) {
        return w[j.expando] ? w : new j.Event(w);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: !0
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(w) {
            var O = this || w;
            return F.test(O.type) && O.click && ke(O, "input") && se(O, "click", !0), !1;
          },
          trigger: function(w) {
            var O = this || w;
            return F.test(O.type) && O.click && ke(O, "input") && se(O, "click"), !0;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(w) {
            var O = w.target;
            return F.test(O.type) && O.click && ke(O, "input") && He.get(O, "click") || ke(O, "a");
          }
        },
        beforeunload: {
          postDispatch: function(w) {
            w.result !== void 0 && w.originalEvent && (w.originalEvent.returnValue = w.result);
          }
        }
      }
    };
    function se(w, O, q) {
      if (!q) {
        He.get(w, O) === void 0 && j.event.add(w, O, ae);
        return;
      }
      He.set(w, O, !1), j.event.add(w, O, {
        namespace: !1,
        handler: function(ne) {
          var de, _e = He.get(this, O);
          if (ne.isTrigger & 1 && this[O]) {
            if (_e)
              (j.event.special[O] || {}).delegateType && ne.stopPropagation();
            else if (_e = a.call(arguments), He.set(this, O, _e), this[O](), de = He.get(this, O), He.set(this, O, !1), _e !== de)
              return ne.stopImmediatePropagation(), ne.preventDefault(), de;
          } else
            _e && (He.set(this, O, j.event.trigger(
              _e[0],
              _e.slice(1),
              this
            )), ne.stopPropagation(), ne.isImmediatePropagationStopped = ae);
        }
      });
    }
    j.removeEvent = function(w, O, q) {
      w.removeEventListener && w.removeEventListener(O, q);
    }, j.Event = function(w, O) {
      if (!(this instanceof j.Event))
        return new j.Event(w, O);
      w && w.type ? (this.originalEvent = w, this.type = w.type, this.isDefaultPrevented = w.defaultPrevented || w.defaultPrevented === void 0 && // Support: Android <=2.3 only
      w.returnValue === !1 ? ae : le, this.target = w.target && w.target.nodeType === 3 ? w.target.parentNode : w.target, this.currentTarget = w.currentTarget, this.relatedTarget = w.relatedTarget) : this.type = w, O && j.extend(this, O), this.timeStamp = w && w.timeStamp || Date.now(), this[j.expando] = !0;
    }, j.Event.prototype = {
      constructor: j.Event,
      isDefaultPrevented: le,
      isPropagationStopped: le,
      isImmediatePropagationStopped: le,
      isSimulated: !1,
      preventDefault: function() {
        var w = this.originalEvent;
        this.isDefaultPrevented = ae, w && !this.isSimulated && w.preventDefault();
      },
      stopPropagation: function() {
        var w = this.originalEvent;
        this.isPropagationStopped = ae, w && !this.isSimulated && w.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var w = this.originalEvent;
        this.isImmediatePropagationStopped = ae, w && !this.isSimulated && w.stopImmediatePropagation(), this.stopPropagation();
      }
    }, j.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: !0
    }, j.event.addProp), j.each({ focus: "focusin", blur: "focusout" }, function(w, O) {
      function q(ne) {
        if (G.documentMode) {
          var de = He.get(this, "handle"), _e = j.event.fix(ne);
          _e.type = ne.type === "focusin" ? "focus" : "blur", _e.isSimulated = !0, de(ne), _e.target === _e.currentTarget && de(_e);
        } else
          j.event.simulate(
            O,
            ne.target,
            j.event.fix(ne)
          );
      }
      j.event.special[w] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var ne;
          if (se(this, w, !0), G.documentMode)
            ne = He.get(this, O), ne || this.addEventListener(O, q), He.set(this, O, (ne || 0) + 1);
          else
            return !1;
        },
        trigger: function() {
          return se(this, w), !0;
        },
        teardown: function() {
          var ne;
          if (G.documentMode)
            ne = He.get(this, O) - 1, ne ? He.set(this, O, ne) : (this.removeEventListener(O, q), He.remove(this, O));
          else
            return !1;
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(ne) {
          return He.get(ne.target, w);
        },
        delegateType: O
      }, j.event.special[O] = {
        setup: function() {
          var ne = this.ownerDocument || this.document || this, de = G.documentMode ? this : ne, _e = He.get(de, O);
          _e || (G.documentMode ? this.addEventListener(O, q) : ne.addEventListener(w, q, !0)), He.set(de, O, (_e || 0) + 1);
        },
        teardown: function() {
          var ne = this.ownerDocument || this.document || this, de = G.documentMode ? this : ne, _e = He.get(de, O) - 1;
          _e ? He.set(de, O, _e) : (G.documentMode ? this.removeEventListener(O, q) : ne.removeEventListener(w, q, !0), He.remove(de, O));
        }
      };
    }), j.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(w, O) {
      j.event.special[w] = {
        delegateType: O,
        bindType: O,
        handle: function(q) {
          var ne, de = this, _e = q.relatedTarget, ye = q.handleObj;
          return (!_e || _e !== de && !j.contains(de, _e)) && (q.type = ye.origType, ne = ye.handler.apply(this, arguments), q.type = O), ne;
        }
      };
    }), j.fn.extend({
      on: function(w, O, q, ne) {
        return fe(this, w, O, q, ne);
      },
      one: function(w, O, q, ne) {
        return fe(this, w, O, q, ne, 1);
      },
      off: function(w, O, q) {
        var ne, de;
        if (w && w.preventDefault && w.handleObj)
          return ne = w.handleObj, j(w.delegateTarget).off(
            ne.namespace ? ne.origType + "." + ne.namespace : ne.origType,
            ne.selector,
            ne.handler
          ), this;
        if (typeof w == "object") {
          for (de in w)
            this.off(de, O, w[de]);
          return this;
        }
        return (O === !1 || typeof O == "function") && (q = O, O = void 0), q === !1 && (q = le), this.each(function() {
          j.event.remove(this, w, q, O);
        });
      }
    });
    var ge = /<script|<style|<link/i, me = /checked\s*(?:[^=]|=\s*.checked.)/i, we = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function Se(w, O) {
      return ke(w, "table") && ke(O.nodeType !== 11 ? O : O.firstChild, "tr") && j(w).children("tbody")[0] || w;
    }
    function Ae(w) {
      return w.type = (w.getAttribute("type") !== null) + "/" + w.type, w;
    }
    function Ge(w) {
      return (w.type || "").slice(0, 5) === "true/" ? w.type = w.type.slice(5) : w.removeAttribute("type"), w;
    }
    function Je(w, O) {
      var q, ne, de, _e, ye, Ve, De;
      if (O.nodeType === 1) {
        if (He.hasData(w) && (_e = He.get(w), De = _e.events, De)) {
          He.remove(O, "handle events");
          for (de in De)
            for (q = 0, ne = De[de].length; q < ne; q++)
              j.event.add(O, de, De[de][q]);
        }
        i.hasData(w) && (ye = i.access(w), Ve = j.extend({}, ye), i.set(O, Ve));
      }
    }
    function tt(w, O) {
      var q = O.nodeName.toLowerCase();
      q === "input" && F.test(w.type) ? O.checked = w.checked : (q === "input" || q === "textarea") && (O.defaultValue = w.defaultValue);
    }
    function ft(w, O, q, ne) {
      O = u(O);
      var de, _e, ye, Ve, De, Ke, St = 0, Ct = w.length, ut = Ct - 1, Ut = O[0], ti = Y(Ut);
      if (ti || Ct > 1 && typeof Ut == "string" && !X.checkClone && me.test(Ut))
        return w.each(function(wi) {
          var bi = w.eq(wi);
          ti && (O[0] = Ut.call(this, wi, bi.html())), ft(bi, O, q, ne);
        });
      if (Ct && (de = V(O, w[0].ownerDocument, !1, w, ne), _e = de.firstChild, de.childNodes.length === 1 && (de = _e), _e || ne)) {
        for (ye = j.map(P(de, "script"), Ae), Ve = ye.length; St < Ct; St++)
          De = de, St !== ut && (De = j.clone(De, !0, !0), Ve && j.merge(ye, P(De, "script"))), q.call(w[St], De, St);
        if (Ve)
          for (Ke = ye[ye.length - 1].ownerDocument, j.map(ye, Ge), St = 0; St < Ve; St++)
            De = ye[St], R.test(De.type || "") && !He.access(De, "globalEval") && j.contains(Ke, De) && (De.src && (De.type || "").toLowerCase() !== "module" ? j._evalUrl && !De.noModule && j._evalUrl(De.src, {
              nonce: De.nonce || De.getAttribute("nonce")
            }, Ke) : J(De.textContent.replace(we, ""), De, Ke));
      }
      return w;
    }
    function Ne(w, O, q) {
      for (var ne, de = O ? j.filter(O, w) : w, _e = 0; (ne = de[_e]) != null; _e++)
        !q && ne.nodeType === 1 && j.cleanData(P(ne)), ne.parentNode && (q && x(ne) && H(P(ne, "script")), ne.parentNode.removeChild(ne));
      return w;
    }
    j.extend({
      htmlPrefilter: function(w) {
        return w;
      },
      clone: function(w, O, q) {
        var ne, de, _e, ye, Ve = w.cloneNode(!0), De = x(w);
        if (!X.noCloneChecked && (w.nodeType === 1 || w.nodeType === 11) && !j.isXMLDoc(w))
          for (ye = P(Ve), _e = P(w), ne = 0, de = _e.length; ne < de; ne++)
            tt(_e[ne], ye[ne]);
        if (O)
          if (q)
            for (_e = _e || P(w), ye = ye || P(Ve), ne = 0, de = _e.length; ne < de; ne++)
              Je(_e[ne], ye[ne]);
          else
            Je(w, Ve);
        return ye = P(Ve, "script"), ye.length > 0 && H(ye, !De && P(w, "script")), Ve;
      },
      cleanData: function(w) {
        for (var O, q, ne, de = j.event.special, _e = 0; (q = w[_e]) !== void 0; _e++)
          if (wt(q)) {
            if (O = q[He.expando]) {
              if (O.events)
                for (ne in O.events)
                  de[ne] ? j.event.remove(q, ne) : j.removeEvent(q, ne, O.handle);
              q[He.expando] = void 0;
            }
            q[i.expando] && (q[i.expando] = void 0);
          }
      }
    }), j.fn.extend({
      detach: function(w) {
        return Ne(this, w, !0);
      },
      remove: function(w) {
        return Ne(this, w);
      },
      text: function(w) {
        return Ie(this, function(O) {
          return O === void 0 ? j.text(this) : this.empty().each(function() {
            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = O);
          });
        }, null, w, arguments.length);
      },
      append: function() {
        return ft(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var O = Se(this, w);
            O.appendChild(w);
          }
        });
      },
      prepend: function() {
        return ft(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var O = Se(this, w);
            O.insertBefore(w, O.firstChild);
          }
        });
      },
      before: function() {
        return ft(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this);
        });
      },
      after: function() {
        return ft(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this.nextSibling);
        });
      },
      empty: function() {
        for (var w, O = 0; (w = this[O]) != null; O++)
          w.nodeType === 1 && (j.cleanData(P(w, !1)), w.textContent = "");
        return this;
      },
      clone: function(w, O) {
        return w = w ?? !1, O = O ?? w, this.map(function() {
          return j.clone(this, w, O);
        });
      },
      html: function(w) {
        return Ie(this, function(O) {
          var q = this[0] || {}, ne = 0, de = this.length;
          if (O === void 0 && q.nodeType === 1)
            return q.innerHTML;
          if (typeof O == "string" && !ge.test(O) && !C[(B.exec(O) || ["", ""])[1].toLowerCase()]) {
            O = j.htmlPrefilter(O);
            try {
              for (; ne < de; ne++)
                q = this[ne] || {}, q.nodeType === 1 && (j.cleanData(P(q, !1)), q.innerHTML = O);
              q = 0;
            } catch {
            }
          }
          q && this.empty().append(O);
        }, null, w, arguments.length);
      },
      replaceWith: function() {
        var w = [];
        return ft(this, arguments, function(O) {
          var q = this.parentNode;
          j.inArray(this, w) < 0 && (j.cleanData(P(this)), q && q.replaceChild(O, this));
        }, w);
      }
    }), j.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(w, O) {
      j.fn[w] = function(q) {
        for (var ne, de = [], _e = j(q), ye = _e.length - 1, Ve = 0; Ve <= ye; Ve++)
          ne = Ve === ye ? this : this.clone(!0), j(_e[Ve])[O](ne), f.apply(de, ne.get());
        return this.pushStack(de);
      };
    });
    var ze = new RegExp("^(" + d + ")(?!px)[a-z%]+$", "i"), nt = /^--/, _t = function(w) {
      var O = w.ownerDocument.defaultView;
      return (!O || !O.opener) && (O = e), O.getComputedStyle(w);
    }, mt = function(w, O, q) {
      var ne, de, _e = {};
      for (de in O)
        _e[de] = w.style[de], w.style[de] = O[de];
      ne = q.call(w);
      for (de in O)
        w.style[de] = _e[de];
      return ne;
    }, Pt = new RegExp(_.join("|"), "i");
    (function() {
      function w() {
        if (Ke) {
          De.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Ke.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", b.appendChild(De).appendChild(Ke);
          var St = e.getComputedStyle(Ke);
          q = St.top !== "1%", Ve = O(St.marginLeft) === 12, Ke.style.right = "60%", _e = O(St.right) === 36, ne = O(St.width) === 36, Ke.style.position = "absolute", de = O(Ke.offsetWidth / 3) === 12, b.removeChild(De), Ke = null;
        }
      }
      function O(St) {
        return Math.round(parseFloat(St));
      }
      var q, ne, de, _e, ye, Ve, De = G.createElement("div"), Ke = G.createElement("div");
      Ke.style && (Ke.style.backgroundClip = "content-box", Ke.cloneNode(!0).style.backgroundClip = "", X.clearCloneStyle = Ke.style.backgroundClip === "content-box", j.extend(X, {
        boxSizingReliable: function() {
          return w(), ne;
        },
        pixelBoxStyles: function() {
          return w(), _e;
        },
        pixelPosition: function() {
          return w(), q;
        },
        reliableMarginLeft: function() {
          return w(), Ve;
        },
        scrollboxSize: function() {
          return w(), de;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var St, Ct, ut, Ut;
          return ye == null && (St = G.createElement("table"), Ct = G.createElement("tr"), ut = G.createElement("div"), St.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", Ct.style.cssText = "box-sizing:content-box;border:1px solid", Ct.style.height = "1px", ut.style.height = "9px", ut.style.display = "block", b.appendChild(St).appendChild(Ct).appendChild(ut), Ut = e.getComputedStyle(Ct), ye = parseInt(Ut.height, 10) + parseInt(Ut.borderTopWidth, 10) + parseInt(Ut.borderBottomWidth, 10) === Ct.offsetHeight, b.removeChild(St)), ye;
        }
      }));
    })();
    function Et(w, O, q) {
      var ne, de, _e, ye, Ve = nt.test(O), De = w.style;
      return q = q || _t(w), q && (ye = q.getPropertyValue(O) || q[O], Ve && ye && (ye = ye.replace(ue, "$1") || void 0), ye === "" && !x(w) && (ye = j.style(w, O)), !X.pixelBoxStyles() && ze.test(ye) && Pt.test(O) && (ne = De.width, de = De.minWidth, _e = De.maxWidth, De.minWidth = De.maxWidth = De.width = ye, ye = q.width, De.width = ne, De.minWidth = de, De.maxWidth = _e)), ye !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ye + ""
      ) : ye;
    }
    function zt(w, O) {
      return {
        get: function() {
          if (w()) {
            delete this.get;
            return;
          }
          return (this.get = O).apply(this, arguments);
        }
      };
    }
    var jt = ["Webkit", "Moz", "ms"], Ft = G.createElement("div").style, Mi = {};
    function Rt(w) {
      for (var O = w[0].toUpperCase() + w.slice(1), q = jt.length; q--; )
        if (w = jt[q] + O, w in Ft)
          return w;
    }
    function hi(w) {
      var O = j.cssProps[w] || Mi[w];
      return O || (w in Ft ? w : Mi[w] = Rt(w) || w);
    }
    var ci = /^(none|table(?!-c[ea]).+)/, ni = { position: "absolute", visibility: "hidden", display: "block" }, di = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function Hi(w, O, q) {
      var ne = m.exec(O);
      return ne ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, ne[2] - (q || 0)) + (ne[3] || "px")
      ) : O;
    }
    function xi(w, O, q, ne, de, _e) {
      var ye = O === "width" ? 1 : 0, Ve = 0, De = 0, Ke = 0;
      if (q === (ne ? "border" : "content"))
        return 0;
      for (; ye < 4; ye += 2)
        q === "margin" && (Ke += j.css(w, q + _[ye], !0, de)), ne ? (q === "content" && (De -= j.css(w, "padding" + _[ye], !0, de)), q !== "margin" && (De -= j.css(w, "border" + _[ye] + "Width", !0, de))) : (De += j.css(w, "padding" + _[ye], !0, de), q !== "padding" ? De += j.css(w, "border" + _[ye] + "Width", !0, de) : Ve += j.css(w, "border" + _[ye] + "Width", !0, de));
      return !ne && _e >= 0 && (De += Math.max(0, Math.ceil(
        w["offset" + O[0].toUpperCase() + O.slice(1)] - _e - De - Ve - 0.5
        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0), De + Ke;
    }
    function qi(w, O, q) {
      var ne = _t(w), de = !X.boxSizingReliable() || q, _e = de && j.css(w, "boxSizing", !1, ne) === "border-box", ye = _e, Ve = Et(w, O, ne), De = "offset" + O[0].toUpperCase() + O.slice(1);
      if (ze.test(Ve)) {
        if (!q)
          return Ve;
        Ve = "auto";
      }
      return (!X.boxSizingReliable() && _e || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !X.reliableTrDimensions() && ke(w, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      Ve === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(Ve) && j.css(w, "display", !1, ne) === "inline") && // Make sure the element is visible & connected
      w.getClientRects().length && (_e = j.css(w, "boxSizing", !1, ne) === "border-box", ye = De in w, ye && (Ve = w[De])), Ve = parseFloat(Ve) || 0, Ve + xi(
        w,
        O,
        q || (_e ? "border" : "content"),
        ye,
        ne,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        Ve
      ) + "px";
    }
    j.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(w, O) {
            if (O) {
              var q = Et(w, "opacity");
              return q === "" ? "1" : q;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageSlice: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        scale: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(w, O, q, ne) {
        if (!(!w || w.nodeType === 3 || w.nodeType === 8 || !w.style)) {
          var de, _e, ye, Ve = et(O), De = nt.test(O), Ke = w.style;
          if (De || (O = hi(Ve)), ye = j.cssHooks[O] || j.cssHooks[Ve], q !== void 0) {
            if (_e = typeof q, _e === "string" && (de = m.exec(q)) && de[1] && (q = L(w, O, de), _e = "number"), q == null || q !== q)
              return;
            _e === "number" && !De && (q += de && de[3] || (j.cssNumber[Ve] ? "" : "px")), !X.clearCloneStyle && q === "" && O.indexOf("background") === 0 && (Ke[O] = "inherit"), (!ye || !("set" in ye) || (q = ye.set(w, q, ne)) !== void 0) && (De ? Ke.setProperty(O, q) : Ke[O] = q);
          } else
            return ye && "get" in ye && (de = ye.get(w, !1, ne)) !== void 0 ? de : Ke[O];
        }
      },
      css: function(w, O, q, ne) {
        var de, _e, ye, Ve = et(O), De = nt.test(O);
        return De || (O = hi(Ve)), ye = j.cssHooks[O] || j.cssHooks[Ve], ye && "get" in ye && (de = ye.get(w, !0, q)), de === void 0 && (de = Et(w, O, ne)), de === "normal" && O in di && (de = di[O]), q === "" || q ? (_e = parseFloat(de), q === !0 || isFinite(_e) ? _e || 0 : de) : de;
      }
    }), j.each(["height", "width"], function(w, O) {
      j.cssHooks[O] = {
        get: function(q, ne, de) {
          if (ne)
            return ci.test(j.css(q, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!q.getClientRects().length || !q.getBoundingClientRect().width) ? mt(q, ni, function() {
              return qi(q, O, de);
            }) : qi(q, O, de);
        },
        set: function(q, ne, de) {
          var _e, ye = _t(q), Ve = !X.scrollboxSize() && ye.position === "absolute", De = Ve || de, Ke = De && j.css(q, "boxSizing", !1, ye) === "border-box", St = de ? xi(
            q,
            O,
            de,
            Ke,
            ye
          ) : 0;
          return Ke && Ve && (St -= Math.ceil(
            q["offset" + O[0].toUpperCase() + O.slice(1)] - parseFloat(ye[O]) - xi(q, O, "border", !1, ye) - 0.5
          )), St && (_e = m.exec(ne)) && (_e[3] || "px") !== "px" && (q.style[O] = ne, ne = j.css(q, O)), Hi(q, ne, St);
        }
      };
    }), j.cssHooks.marginLeft = zt(
      X.reliableMarginLeft,
      function(w, O) {
        if (O)
          return (parseFloat(Et(w, "marginLeft")) || w.getBoundingClientRect().left - mt(w, { marginLeft: 0 }, function() {
            return w.getBoundingClientRect().left;
          })) + "px";
      }
    ), j.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(w, O) {
      j.cssHooks[w + O] = {
        expand: function(q) {
          for (var ne = 0, de = {}, _e = typeof q == "string" ? q.split(" ") : [q]; ne < 4; ne++)
            de[w + _[ne] + O] = _e[ne] || _e[ne - 2] || _e[0];
          return de;
        }
      }, w !== "margin" && (j.cssHooks[w + O].set = Hi);
    }), j.fn.extend({
      css: function(w, O) {
        return Ie(this, function(q, ne, de) {
          var _e, ye, Ve = {}, De = 0;
          if (Array.isArray(ne)) {
            for (_e = _t(q), ye = ne.length; De < ye; De++)
              Ve[ne[De]] = j.css(q, ne[De], !1, _e);
            return Ve;
          }
          return de !== void 0 ? j.style(q, ne, de) : j.css(q, ne);
        }, w, O, arguments.length > 1);
      }
    });
    function Ti(w, O, q, ne, de) {
      return new Ti.prototype.init(w, O, q, ne, de);
    }
    j.Tween = Ti, Ti.prototype = {
      constructor: Ti,
      init: function(w, O, q, ne, de, _e) {
        this.elem = w, this.prop = q, this.easing = de || j.easing._default, this.options = O, this.start = this.now = this.cur(), this.end = ne, this.unit = _e || (j.cssNumber[q] ? "" : "px");
      },
      cur: function() {
        var w = Ti.propHooks[this.prop];
        return w && w.get ? w.get(this) : Ti.propHooks._default.get(this);
      },
      run: function(w) {
        var O, q = Ti.propHooks[this.prop];
        return this.options.duration ? this.pos = O = j.easing[this.easing](
          w,
          this.options.duration * w,
          0,
          1,
          this.options.duration
        ) : this.pos = O = w, this.now = (this.end - this.start) * O + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), q && q.set ? q.set(this) : Ti.propHooks._default.set(this), this;
      }
    }, Ti.prototype.init.prototype = Ti.prototype, Ti.propHooks = {
      _default: {
        get: function(w) {
          var O;
          return w.elem.nodeType !== 1 || w.elem[w.prop] != null && w.elem.style[w.prop] == null ? w.elem[w.prop] : (O = j.css(w.elem, w.prop, ""), !O || O === "auto" ? 0 : O);
        },
        set: function(w) {
          j.fx.step[w.prop] ? j.fx.step[w.prop](w) : w.elem.nodeType === 1 && (j.cssHooks[w.prop] || w.elem.style[hi(w.prop)] != null) ? j.style(w.elem, w.prop, w.now + w.unit) : w.elem[w.prop] = w.now;
        }
      }
    }, Ti.propHooks.scrollTop = Ti.propHooks.scrollLeft = {
      set: function(w) {
        w.elem.nodeType && w.elem.parentNode && (w.elem[w.prop] = w.now);
      }
    }, j.easing = {
      linear: function(w) {
        return w;
      },
      swing: function(w) {
        return 0.5 - Math.cos(w * Math.PI) / 2;
      },
      _default: "swing"
    }, j.fx = Ti.prototype.init, j.fx.step = {};
    var Ci, Xi, Gi = /^(?:toggle|show|hide)$/, Ki = /queueHooks$/;
    function un() {
      Xi && (G.hidden === !1 && e.requestAnimationFrame ? e.requestAnimationFrame(un) : e.setTimeout(un, j.fx.interval), j.fx.tick());
    }
    function nn() {
      return e.setTimeout(function() {
        Ci = void 0;
      }), Ci = Date.now();
    }
    function Wn(w, O) {
      var q, ne = 0, de = { height: w };
      for (O = O ? 1 : 0; ne < 4; ne += 2 - O)
        q = _[ne], de["margin" + q] = de["padding" + q] = w;
      return O && (de.opacity = de.width = w), de;
    }
    function ir(w, O, q) {
      for (var ne, de = (In.tweeners[O] || []).concat(In.tweeners["*"]), _e = 0, ye = de.length; _e < ye; _e++)
        if (ne = de[_e].call(q, O, w))
          return ne;
    }
    function Tr(w, O, q) {
      var ne, de, _e, ye, Ve, De, Ke, St, Ct = "width" in O || "height" in O, ut = this, Ut = {}, ti = w.style, wi = w.nodeType && E(w), bi = He.get(w, "fxshow");
      q.queue || (ye = j._queueHooks(w, "fx"), ye.unqueued == null && (ye.unqueued = 0, Ve = ye.empty.fire, ye.empty.fire = function() {
        ye.unqueued || Ve();
      }), ye.unqueued++, ut.always(function() {
        ut.always(function() {
          ye.unqueued--, j.queue(w, "fx").length || ye.empty.fire();
        });
      }));
      for (ne in O)
        if (de = O[ne], Gi.test(de)) {
          if (delete O[ne], _e = _e || de === "toggle", de === (wi ? "hide" : "show"))
            if (de === "show" && bi && bi[ne] !== void 0)
              wi = !0;
            else
              continue;
          Ut[ne] = bi && bi[ne] || j.style(w, ne);
        }
      if (De = !j.isEmptyObject(O), !(!De && j.isEmptyObject(Ut))) {
        Ct && w.nodeType === 1 && (q.overflow = [ti.overflow, ti.overflowX, ti.overflowY], Ke = bi && bi.display, Ke == null && (Ke = He.get(w, "display")), St = j.css(w, "display"), St === "none" && (Ke ? St = Ke : (k([w], !0), Ke = w.style.display || Ke, St = j.css(w, "display"), k([w]))), (St === "inline" || St === "inline-block" && Ke != null) && j.css(w, "float") === "none" && (De || (ut.done(function() {
          ti.display = Ke;
        }), Ke == null && (St = ti.display, Ke = St === "none" ? "" : St)), ti.display = "inline-block")), q.overflow && (ti.overflow = "hidden", ut.always(function() {
          ti.overflow = q.overflow[0], ti.overflowX = q.overflow[1], ti.overflowY = q.overflow[2];
        })), De = !1;
        for (ne in Ut)
          De || (bi ? "hidden" in bi && (wi = bi.hidden) : bi = He.access(w, "fxshow", { display: Ke }), _e && (bi.hidden = !wi), wi && k([w], !0), ut.done(function() {
            wi || k([w]), He.remove(w, "fxshow");
            for (ne in Ut)
              j.style(w, ne, Ut[ne]);
          })), De = ir(wi ? bi[ne] : 0, ne, ut), ne in bi || (bi[ne] = De.start, wi && (De.end = De.start, De.start = 0));
      }
    }
    function yr(w, O) {
      var q, ne, de, _e, ye;
      for (q in w)
        if (ne = et(q), de = O[ne], _e = w[q], Array.isArray(_e) && (de = _e[1], _e = w[q] = _e[0]), q !== ne && (w[ne] = _e, delete w[q]), ye = j.cssHooks[ne], ye && "expand" in ye) {
          _e = ye.expand(_e), delete w[ne];
          for (q in _e)
            q in w || (w[q] = _e[q], O[q] = de);
        } else
          O[ne] = de;
    }
    function In(w, O, q) {
      var ne, de, _e = 0, ye = In.prefilters.length, Ve = j.Deferred().always(function() {
        delete De.elem;
      }), De = function() {
        if (de)
          return !1;
        for (var Ct = Ci || nn(), ut = Math.max(0, Ke.startTime + Ke.duration - Ct), Ut = ut / Ke.duration || 0, ti = 1 - Ut, wi = 0, bi = Ke.tweens.length; wi < bi; wi++)
          Ke.tweens[wi].run(ti);
        return Ve.notifyWith(w, [Ke, ti, ut]), ti < 1 && bi ? ut : (bi || Ve.notifyWith(w, [Ke, 1, 0]), Ve.resolveWith(w, [Ke]), !1);
      }, Ke = Ve.promise({
        elem: w,
        props: j.extend({}, O),
        opts: j.extend(!0, {
          specialEasing: {},
          easing: j.easing._default
        }, q),
        originalProperties: O,
        originalOptions: q,
        startTime: Ci || nn(),
        duration: q.duration,
        tweens: [],
        createTween: function(Ct, ut) {
          var Ut = j.Tween(
            w,
            Ke.opts,
            Ct,
            ut,
            Ke.opts.specialEasing[Ct] || Ke.opts.easing
          );
          return Ke.tweens.push(Ut), Ut;
        },
        stop: function(Ct) {
          var ut = 0, Ut = Ct ? Ke.tweens.length : 0;
          if (de)
            return this;
          for (de = !0; ut < Ut; ut++)
            Ke.tweens[ut].run(1);
          return Ct ? (Ve.notifyWith(w, [Ke, 1, 0]), Ve.resolveWith(w, [Ke, Ct])) : Ve.rejectWith(w, [Ke, Ct]), this;
        }
      }), St = Ke.props;
      for (yr(St, Ke.opts.specialEasing); _e < ye; _e++)
        if (ne = In.prefilters[_e].call(Ke, w, St, Ke.opts), ne)
          return Y(ne.stop) && (j._queueHooks(Ke.elem, Ke.opts.queue).stop = ne.stop.bind(ne)), ne;
      return j.map(St, ir, Ke), Y(Ke.opts.start) && Ke.opts.start.call(w, Ke), Ke.progress(Ke.opts.progress).done(Ke.opts.done, Ke.opts.complete).fail(Ke.opts.fail).always(Ke.opts.always), j.fx.timer(
        j.extend(De, {
          elem: w,
          anim: Ke,
          queue: Ke.opts.queue
        })
      ), Ke;
    }
    j.Animation = j.extend(In, {
      tweeners: {
        "*": [function(w, O) {
          var q = this.createTween(w, O);
          return L(q.elem, w, m.exec(O), q), q;
        }]
      },
      tweener: function(w, O) {
        Y(w) ? (O = w, w = ["*"]) : w = w.match(Qt);
        for (var q, ne = 0, de = w.length; ne < de; ne++)
          q = w[ne], In.tweeners[q] = In.tweeners[q] || [], In.tweeners[q].unshift(O);
      },
      prefilters: [Tr],
      prefilter: function(w, O) {
        O ? In.prefilters.unshift(w) : In.prefilters.push(w);
      }
    }), j.speed = function(w, O, q) {
      var ne = w && typeof w == "object" ? j.extend({}, w) : {
        complete: q || !q && O || Y(w) && w,
        duration: w,
        easing: q && O || O && !Y(O) && O
      };
      return j.fx.off ? ne.duration = 0 : typeof ne.duration != "number" && (ne.duration in j.fx.speeds ? ne.duration = j.fx.speeds[ne.duration] : ne.duration = j.fx.speeds._default), (ne.queue == null || ne.queue === !0) && (ne.queue = "fx"), ne.old = ne.complete, ne.complete = function() {
        Y(ne.old) && ne.old.call(this), ne.queue && j.dequeue(this, ne.queue);
      }, ne;
    }, j.fn.extend({
      fadeTo: function(w, O, q, ne) {
        return this.filter(E).css("opacity", 0).show().end().animate({ opacity: O }, w, q, ne);
      },
      animate: function(w, O, q, ne) {
        var de = j.isEmptyObject(w), _e = j.speed(O, q, ne), ye = function() {
          var Ve = In(this, j.extend({}, w), _e);
          (de || He.get(this, "finish")) && Ve.stop(!0);
        };
        return ye.finish = ye, de || _e.queue === !1 ? this.each(ye) : this.queue(_e.queue, ye);
      },
      stop: function(w, O, q) {
        var ne = function(de) {
          var _e = de.stop;
          delete de.stop, _e(q);
        };
        return typeof w != "string" && (q = O, O = w, w = void 0), O && this.queue(w || "fx", []), this.each(function() {
          var de = !0, _e = w != null && w + "queueHooks", ye = j.timers, Ve = He.get(this);
          if (_e)
            Ve[_e] && Ve[_e].stop && ne(Ve[_e]);
          else
            for (_e in Ve)
              Ve[_e] && Ve[_e].stop && Ki.test(_e) && ne(Ve[_e]);
          for (_e = ye.length; _e--; )
            ye[_e].elem === this && (w == null || ye[_e].queue === w) && (ye[_e].anim.stop(q), de = !1, ye.splice(_e, 1));
          (de || !q) && j.dequeue(this, w);
        });
      },
      finish: function(w) {
        return w !== !1 && (w = w || "fx"), this.each(function() {
          var O, q = He.get(this), ne = q[w + "queue"], de = q[w + "queueHooks"], _e = j.timers, ye = ne ? ne.length : 0;
          for (q.finish = !0, j.queue(this, w, []), de && de.stop && de.stop.call(this, !0), O = _e.length; O--; )
            _e[O].elem === this && _e[O].queue === w && (_e[O].anim.stop(!0), _e.splice(O, 1));
          for (O = 0; O < ye; O++)
            ne[O] && ne[O].finish && ne[O].finish.call(this);
          delete q.finish;
        });
      }
    }), j.each(["toggle", "show", "hide"], function(w, O) {
      var q = j.fn[O];
      j.fn[O] = function(ne, de, _e) {
        return ne == null || typeof ne == "boolean" ? q.apply(this, arguments) : this.animate(Wn(O, !0), ne, de, _e);
      };
    }), j.each({
      slideDown: Wn("show"),
      slideUp: Wn("hide"),
      slideToggle: Wn("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(w, O) {
      j.fn[w] = function(q, ne, de) {
        return this.animate(O, q, ne, de);
      };
    }), j.timers = [], j.fx.tick = function() {
      var w, O = 0, q = j.timers;
      for (Ci = Date.now(); O < q.length; O++)
        w = q[O], !w() && q[O] === w && q.splice(O--, 1);
      q.length || j.fx.stop(), Ci = void 0;
    }, j.fx.timer = function(w) {
      j.timers.push(w), j.fx.start();
    }, j.fx.interval = 13, j.fx.start = function() {
      Xi || (Xi = !0, un());
    }, j.fx.stop = function() {
      Xi = null;
    }, j.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    }, j.fn.delay = function(w, O) {
      return w = j.fx && j.fx.speeds[w] || w, O = O || "fx", this.queue(O, function(q, ne) {
        var de = e.setTimeout(q, w);
        ne.stop = function() {
          e.clearTimeout(de);
        };
      });
    }, function() {
      var w = G.createElement("input"), O = G.createElement("select"), q = O.appendChild(G.createElement("option"));
      w.type = "checkbox", X.checkOn = w.value !== "", X.optSelected = q.selected, w = G.createElement("input"), w.value = "t", w.type = "radio", X.radioValue = w.value === "t";
    }();
    var nr, si = j.expr.attrHandle;
    j.fn.extend({
      attr: function(w, O) {
        return Ie(this, j.attr, w, O, arguments.length > 1);
      },
      removeAttr: function(w) {
        return this.each(function() {
          j.removeAttr(this, w);
        });
      }
    }), j.extend({
      attr: function(w, O, q) {
        var ne, de, _e = w.nodeType;
        if (!(_e === 3 || _e === 8 || _e === 2)) {
          if (typeof w.getAttribute > "u")
            return j.prop(w, O, q);
          if ((_e !== 1 || !j.isXMLDoc(w)) && (de = j.attrHooks[O.toLowerCase()] || (j.expr.match.bool.test(O) ? nr : void 0)), q !== void 0) {
            if (q === null) {
              j.removeAttr(w, O);
              return;
            }
            return de && "set" in de && (ne = de.set(w, q, O)) !== void 0 ? ne : (w.setAttribute(O, q + ""), q);
          }
          return de && "get" in de && (ne = de.get(w, O)) !== null ? ne : (ne = j.find.attr(w, O), ne ?? void 0);
        }
      },
      attrHooks: {
        type: {
          set: function(w, O) {
            if (!X.radioValue && O === "radio" && ke(w, "input")) {
              var q = w.value;
              return w.setAttribute("type", O), q && (w.value = q), O;
            }
          }
        }
      },
      removeAttr: function(w, O) {
        var q, ne = 0, de = O && O.match(Qt);
        if (de && w.nodeType === 1)
          for (; q = de[ne++]; )
            w.removeAttribute(q);
      }
    }), nr = {
      set: function(w, O, q) {
        return O === !1 ? j.removeAttr(w, q) : w.setAttribute(q, q), q;
      }
    }, j.each(j.expr.match.bool.source.match(/\w+/g), function(w, O) {
      var q = si[O] || j.find.attr;
      si[O] = function(ne, de, _e) {
        var ye, Ve, De = de.toLowerCase();
        return _e || (Ve = si[De], si[De] = ye, ye = q(ne, de, _e) != null ? De : null, si[De] = Ve), ye;
      };
    });
    var ur = /^(?:input|select|textarea|button)$/i, Dn = /^(?:a|area)$/i;
    j.fn.extend({
      prop: function(w, O) {
        return Ie(this, j.prop, w, O, arguments.length > 1);
      },
      removeProp: function(w) {
        return this.each(function() {
          delete this[j.propFix[w] || w];
        });
      }
    }), j.extend({
      prop: function(w, O, q) {
        var ne, de, _e = w.nodeType;
        if (!(_e === 3 || _e === 8 || _e === 2))
          return (_e !== 1 || !j.isXMLDoc(w)) && (O = j.propFix[O] || O, de = j.propHooks[O]), q !== void 0 ? de && "set" in de && (ne = de.set(w, q, O)) !== void 0 ? ne : w[O] = q : de && "get" in de && (ne = de.get(w, O)) !== null ? ne : w[O];
      },
      propHooks: {
        tabIndex: {
          get: function(w) {
            var O = j.find.attr(w, "tabindex");
            return O ? parseInt(O, 10) : ur.test(w.nodeName) || Dn.test(w.nodeName) && w.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), X.optSelected || (j.propHooks.selected = {
      get: function(w) {
        var O = w.parentNode;
        return O && O.parentNode && O.parentNode.selectedIndex, null;
      },
      set: function(w) {
        var O = w.parentNode;
        O && (O.selectedIndex, O.parentNode && O.parentNode.selectedIndex);
      }
    }), j.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      j.propFix[this.toLowerCase()] = this;
    });
    function Mn(w) {
      var O = w.match(Qt) || [];
      return O.join(" ");
    }
    function gn(w) {
      return w.getAttribute && w.getAttribute("class") || "";
    }
    function Cn(w) {
      return Array.isArray(w) ? w : typeof w == "string" ? w.match(Qt) || [] : [];
    }
    j.fn.extend({
      addClass: function(w) {
        var O, q, ne, de, _e, ye;
        return Y(w) ? this.each(function(Ve) {
          j(this).addClass(w.call(this, Ve, gn(this)));
        }) : (O = Cn(w), O.length ? this.each(function() {
          if (ne = gn(this), q = this.nodeType === 1 && " " + Mn(ne) + " ", q) {
            for (_e = 0; _e < O.length; _e++)
              de = O[_e], q.indexOf(" " + de + " ") < 0 && (q += de + " ");
            ye = Mn(q), ne !== ye && this.setAttribute("class", ye);
          }
        }) : this);
      },
      removeClass: function(w) {
        var O, q, ne, de, _e, ye;
        return Y(w) ? this.each(function(Ve) {
          j(this).removeClass(w.call(this, Ve, gn(this)));
        }) : arguments.length ? (O = Cn(w), O.length ? this.each(function() {
          if (ne = gn(this), q = this.nodeType === 1 && " " + Mn(ne) + " ", q) {
            for (_e = 0; _e < O.length; _e++)
              for (de = O[_e]; q.indexOf(" " + de + " ") > -1; )
                q = q.replace(" " + de + " ", " ");
            ye = Mn(q), ne !== ye && this.setAttribute("class", ye);
          }
        }) : this) : this.attr("class", "");
      },
      toggleClass: function(w, O) {
        var q, ne, de, _e, ye = typeof w, Ve = ye === "string" || Array.isArray(w);
        return Y(w) ? this.each(function(De) {
          j(this).toggleClass(
            w.call(this, De, gn(this), O),
            O
          );
        }) : typeof O == "boolean" && Ve ? O ? this.addClass(w) : this.removeClass(w) : (q = Cn(w), this.each(function() {
          if (Ve)
            for (_e = j(this), de = 0; de < q.length; de++)
              ne = q[de], _e.hasClass(ne) ? _e.removeClass(ne) : _e.addClass(ne);
          else
            (w === void 0 || ye === "boolean") && (ne = gn(this), ne && He.set(this, "__className__", ne), this.setAttribute && this.setAttribute(
              "class",
              ne || w === !1 ? "" : He.get(this, "__className__") || ""
            ));
        }));
      },
      hasClass: function(w) {
        var O, q, ne = 0;
        for (O = " " + w + " "; q = this[ne++]; )
          if (q.nodeType === 1 && (" " + Mn(gn(q)) + " ").indexOf(O) > -1)
            return !0;
        return !1;
      }
    });
    var cn = /\r/g;
    j.fn.extend({
      val: function(w) {
        var O, q, ne, de = this[0];
        return arguments.length ? (ne = Y(w), this.each(function(_e) {
          var ye;
          this.nodeType === 1 && (ne ? ye = w.call(this, _e, j(this).val()) : ye = w, ye == null ? ye = "" : typeof ye == "number" ? ye += "" : Array.isArray(ye) && (ye = j.map(ye, function(Ve) {
            return Ve == null ? "" : Ve + "";
          })), O = j.valHooks[this.type] || j.valHooks[this.nodeName.toLowerCase()], (!O || !("set" in O) || O.set(this, ye, "value") === void 0) && (this.value = ye));
        })) : de ? (O = j.valHooks[de.type] || j.valHooks[de.nodeName.toLowerCase()], O && "get" in O && (q = O.get(de, "value")) !== void 0 ? q : (q = de.value, typeof q == "string" ? q.replace(cn, "") : q ?? "")) : void 0;
      }
    }), j.extend({
      valHooks: {
        option: {
          get: function(w) {
            var O = j.find.attr(w, "value");
            return O ?? // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            Mn(j.text(w));
          }
        },
        select: {
          get: function(w) {
            var O, q, ne, de = w.options, _e = w.selectedIndex, ye = w.type === "select-one", Ve = ye ? null : [], De = ye ? _e + 1 : de.length;
            for (_e < 0 ? ne = De : ne = ye ? _e : 0; ne < De; ne++)
              if (q = de[ne], (q.selected || ne === _e) && // Don't return options that are disabled or in a disabled optgroup
              !q.disabled && (!q.parentNode.disabled || !ke(q.parentNode, "optgroup"))) {
                if (O = j(q).val(), ye)
                  return O;
                Ve.push(O);
              }
            return Ve;
          },
          set: function(w, O) {
            for (var q, ne, de = w.options, _e = j.makeArray(O), ye = de.length; ye--; )
              ne = de[ye], (ne.selected = j.inArray(j.valHooks.option.get(ne), _e) > -1) && (q = !0);
            return q || (w.selectedIndex = -1), _e;
          }
        }
      }
    }), j.each(["radio", "checkbox"], function() {
      j.valHooks[this] = {
        set: function(w, O) {
          if (Array.isArray(O))
            return w.checked = j.inArray(j(w).val(), O) > -1;
        }
      }, X.checkOn || (j.valHooks[this].get = function(w) {
        return w.getAttribute("value") === null ? "on" : w.value;
      });
    });
    var Ji = e.location, g = { guid: Date.now() }, z = /\?/;
    j.parseXML = function(w) {
      var O, q;
      if (!w || typeof w != "string")
        return null;
      try {
        O = new e.DOMParser().parseFromString(w, "text/xml");
      } catch {
      }
      return q = O && O.getElementsByTagName("parsererror")[0], (!O || q) && j.error("Invalid XML: " + (q ? j.map(q.childNodes, function(ne) {
        return ne.textContent;
      }).join(`
`) : w)), O;
    };
    var ce = /^(?:focusinfocus|focusoutblur)$/, xe = function(w) {
      w.stopPropagation();
    };
    j.extend(j.event, {
      trigger: function(w, O, q, ne) {
        var de, _e, ye, Ve, De, Ke, St, Ct, ut = [q || G], Ut = D.call(w, "type") ? w.type : w, ti = D.call(w, "namespace") ? w.namespace.split(".") : [];
        if (_e = Ct = ye = q = q || G, !(q.nodeType === 3 || q.nodeType === 8) && !ce.test(Ut + j.event.triggered) && (Ut.indexOf(".") > -1 && (ti = Ut.split("."), Ut = ti.shift(), ti.sort()), De = Ut.indexOf(":") < 0 && "on" + Ut, w = w[j.expando] ? w : new j.Event(Ut, typeof w == "object" && w), w.isTrigger = ne ? 2 : 3, w.namespace = ti.join("."), w.rnamespace = w.namespace ? new RegExp("(^|\\.)" + ti.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, w.result = void 0, w.target || (w.target = q), O = O == null ? [w] : j.makeArray(O, [w]), St = j.event.special[Ut] || {}, !(!ne && St.trigger && St.trigger.apply(q, O) === !1))) {
          if (!ne && !St.noBubble && !ie(q)) {
            for (Ve = St.delegateType || Ut, ce.test(Ve + Ut) || (_e = _e.parentNode); _e; _e = _e.parentNode)
              ut.push(_e), ye = _e;
            ye === (q.ownerDocument || G) && ut.push(ye.defaultView || ye.parentWindow || e);
          }
          for (de = 0; (_e = ut[de++]) && !w.isPropagationStopped(); )
            Ct = _e, w.type = de > 1 ? Ve : St.bindType || Ut, Ke = (He.get(_e, "events") || /* @__PURE__ */ Object.create(null))[w.type] && He.get(_e, "handle"), Ke && Ke.apply(_e, O), Ke = De && _e[De], Ke && Ke.apply && wt(_e) && (w.result = Ke.apply(_e, O), w.result === !1 && w.preventDefault());
          return w.type = Ut, !ne && !w.isDefaultPrevented() && (!St._default || St._default.apply(ut.pop(), O) === !1) && wt(q) && De && Y(q[Ut]) && !ie(q) && (ye = q[De], ye && (q[De] = null), j.event.triggered = Ut, w.isPropagationStopped() && Ct.addEventListener(Ut, xe), q[Ut](), w.isPropagationStopped() && Ct.removeEventListener(Ut, xe), j.event.triggered = void 0, ye && (q[De] = ye)), w.result;
        }
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(w, O, q) {
        var ne = j.extend(
          new j.Event(),
          q,
          {
            type: w,
            isSimulated: !0
          }
        );
        j.event.trigger(ne, null, O);
      }
    }), j.fn.extend({
      trigger: function(w, O) {
        return this.each(function() {
          j.event.trigger(w, O, this);
        });
      },
      triggerHandler: function(w, O) {
        var q = this[0];
        if (q)
          return j.event.trigger(w, O, q, !0);
      }
    });
    var Pe = /\[\]$/, rt = /\r?\n/g, pt = /^(?:submit|button|image|reset|file)$/i, Dt = /^(?:input|select|textarea|keygen)/i;
    function qt(w, O, q, ne) {
      var de;
      if (Array.isArray(O))
        j.each(O, function(_e, ye) {
          q || Pe.test(w) ? ne(w, ye) : qt(
            w + "[" + (typeof ye == "object" && ye != null ? _e : "") + "]",
            ye,
            q,
            ne
          );
        });
      else if (!q && he(O) === "object")
        for (de in O)
          qt(w + "[" + de + "]", O[de], q, ne);
      else
        ne(w, O);
    }
    j.param = function(w, O) {
      var q, ne = [], de = function(_e, ye) {
        var Ve = Y(ye) ? ye() : ye;
        ne[ne.length] = encodeURIComponent(_e) + "=" + encodeURIComponent(Ve ?? "");
      };
      if (w == null)
        return "";
      if (Array.isArray(w) || w.jquery && !j.isPlainObject(w))
        j.each(w, function() {
          de(this.name, this.value);
        });
      else
        for (q in w)
          qt(q, w[q], O, de);
      return ne.join("&");
    }, j.fn.extend({
      serialize: function() {
        return j.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var w = j.prop(this, "elements");
          return w ? j.makeArray(w) : this;
        }).filter(function() {
          var w = this.type;
          return this.name && !j(this).is(":disabled") && Dt.test(this.nodeName) && !pt.test(w) && (this.checked || !F.test(w));
        }).map(function(w, O) {
          var q = j(this).val();
          return q == null ? null : Array.isArray(q) ? j.map(q, function(ne) {
            return { name: O.name, value: ne.replace(rt, `\r
`) };
          }) : { name: O.name, value: q.replace(rt, `\r
`) };
        }).get();
      }
    });
    var gi = /%20/g, vi = /#.*$/, ln = /([?&])_=[^&]*/, cr = /^(.*?):[ \t]*([^\r\n]*)$/mg, Lr = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, br = /^(?:GET|HEAD)$/, Fr = /^\/\//, Fi = {}, Ri = {}, Ps = "*/".concat("*"), bs = G.createElement("a");
    bs.href = Ji.href;
    function ls(w) {
      return function(O, q) {
        typeof O != "string" && (q = O, O = "*");
        var ne, de = 0, _e = O.toLowerCase().match(Qt) || [];
        if (Y(q))
          for (; ne = _e[de++]; )
            ne[0] === "+" ? (ne = ne.slice(1) || "*", (w[ne] = w[ne] || []).unshift(q)) : (w[ne] = w[ne] || []).push(q);
      };
    }
    function rr(w, O, q, ne) {
      var de = {}, _e = w === Ri;
      function ye(Ve) {
        var De;
        return de[Ve] = !0, j.each(w[Ve] || [], function(Ke, St) {
          var Ct = St(O, q, ne);
          if (typeof Ct == "string" && !_e && !de[Ct])
            return O.dataTypes.unshift(Ct), ye(Ct), !1;
          if (_e)
            return !(De = Ct);
        }), De;
      }
      return ye(O.dataTypes[0]) || !de["*"] && ye("*");
    }
    function xs(w, O) {
      var q, ne, de = j.ajaxSettings.flatOptions || {};
      for (q in O)
        O[q] !== void 0 && ((de[q] ? w : ne || (ne = {}))[q] = O[q]);
      return ne && j.extend(!0, w, ne), w;
    }
    function Ks(w, O, q) {
      for (var ne, de, _e, ye, Ve = w.contents, De = w.dataTypes; De[0] === "*"; )
        De.shift(), ne === void 0 && (ne = w.mimeType || O.getResponseHeader("Content-Type"));
      if (ne) {
        for (de in Ve)
          if (Ve[de] && Ve[de].test(ne)) {
            De.unshift(de);
            break;
          }
      }
      if (De[0] in q)
        _e = De[0];
      else {
        for (de in q) {
          if (!De[0] || w.converters[de + " " + De[0]]) {
            _e = de;
            break;
          }
          ye || (ye = de);
        }
        _e = _e || ye;
      }
      if (_e)
        return _e !== De[0] && De.unshift(_e), q[_e];
    }
    function hs(w, O, q, ne) {
      var de, _e, ye, Ve, De, Ke = {}, St = w.dataTypes.slice();
      if (St[1])
        for (ye in w.converters)
          Ke[ye.toLowerCase()] = w.converters[ye];
      for (_e = St.shift(); _e; )
        if (w.responseFields[_e] && (q[w.responseFields[_e]] = O), !De && ne && w.dataFilter && (O = w.dataFilter(O, w.dataType)), De = _e, _e = St.shift(), _e) {
          if (_e === "*")
            _e = De;
          else if (De !== "*" && De !== _e) {
            if (ye = Ke[De + " " + _e] || Ke["* " + _e], !ye) {
              for (de in Ke)
                if (Ve = de.split(" "), Ve[1] === _e && (ye = Ke[De + " " + Ve[0]] || Ke["* " + Ve[0]], ye)) {
                  ye === !0 ? ye = Ke[de] : Ke[de] !== !0 && (_e = Ve[0], St.unshift(Ve[1]));
                  break;
                }
            }
            if (ye !== !0)
              if (ye && w.throws)
                O = ye(O);
              else
                try {
                  O = ye(O);
                } catch (Ct) {
                  return {
                    state: "parsererror",
                    error: ye ? Ct : "No conversion from " + De + " to " + _e
                  };
                }
          }
        }
      return { state: "success", data: O };
    }
    j.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Ji.href,
        type: "GET",
        isLocal: Lr.test(Ji.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": Ps,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": !0,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": j.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(w, O) {
        return O ? (
          // Building a settings object
          xs(xs(w, j.ajaxSettings), O)
        ) : (
          // Extending ajaxSettings
          xs(j.ajaxSettings, w)
        );
      },
      ajaxPrefilter: ls(Fi),
      ajaxTransport: ls(Ri),
      // Main method
      ajax: function(w, O) {
        typeof w == "object" && (O = w, w = void 0), O = O || {};
        var q, ne, de, _e, ye, Ve, De, Ke, St, Ct, ut = j.ajaxSetup({}, O), Ut = ut.context || ut, ti = ut.context && (Ut.nodeType || Ut.jquery) ? j(Ut) : j.event, wi = j.Deferred(), bi = j.Callbacks("once memory"), An = ut.statusCode || {}, _n = {}, fn = {}, pi = "canceled", Bi = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(Oi) {
            var Wi;
            if (De) {
              if (!_e)
                for (_e = {}; Wi = cr.exec(de); )
                  _e[Wi[1].toLowerCase() + " "] = (_e[Wi[1].toLowerCase() + " "] || []).concat(Wi[2]);
              Wi = _e[Oi.toLowerCase() + " "];
            }
            return Wi == null ? null : Wi.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return De ? de : null;
          },
          // Caches the header
          setRequestHeader: function(Oi, Wi) {
            return De == null && (Oi = fn[Oi.toLowerCase()] = fn[Oi.toLowerCase()] || Oi, _n[Oi] = Wi), this;
          },
          // Overrides response content-type header
          overrideMimeType: function(Oi) {
            return De == null && (ut.mimeType = Oi), this;
          },
          // Status-dependent callbacks
          statusCode: function(Oi) {
            var Wi;
            if (Oi)
              if (De)
                Bi.always(Oi[Bi.status]);
              else
                for (Wi in Oi)
                  An[Wi] = [An[Wi], Oi[Wi]];
            return this;
          },
          // Cancel the request
          abort: function(Oi) {
            var Wi = Oi || pi;
            return q && q.abort(Wi), On(0, Wi), this;
          }
        };
        if (wi.promise(Bi), ut.url = ((w || ut.url || Ji.href) + "").replace(Fr, Ji.protocol + "//"), ut.type = O.method || O.type || ut.method || ut.type, ut.dataTypes = (ut.dataType || "*").toLowerCase().match(Qt) || [""], ut.crossDomain == null) {
          Ve = G.createElement("a");
          try {
            Ve.href = ut.url, Ve.href = Ve.href, ut.crossDomain = bs.protocol + "//" + bs.host != Ve.protocol + "//" + Ve.host;
          } catch {
            ut.crossDomain = !0;
          }
        }
        if (ut.data && ut.processData && typeof ut.data != "string" && (ut.data = j.param(ut.data, ut.traditional)), rr(Fi, ut, O, Bi), De)
          return Bi;
        Ke = j.event && ut.global, Ke && j.active++ === 0 && j.event.trigger("ajaxStart"), ut.type = ut.type.toUpperCase(), ut.hasContent = !br.test(ut.type), ne = ut.url.replace(vi, ""), ut.hasContent ? ut.data && ut.processData && (ut.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (ut.data = ut.data.replace(gi, "+")) : (Ct = ut.url.slice(ne.length), ut.data && (ut.processData || typeof ut.data == "string") && (ne += (z.test(ne) ? "&" : "?") + ut.data, delete ut.data), ut.cache === !1 && (ne = ne.replace(ln, "$1"), Ct = (z.test(ne) ? "&" : "?") + "_=" + g.guid++ + Ct), ut.url = ne + Ct), ut.ifModified && (j.lastModified[ne] && Bi.setRequestHeader("If-Modified-Since", j.lastModified[ne]), j.etag[ne] && Bi.setRequestHeader("If-None-Match", j.etag[ne])), (ut.data && ut.hasContent && ut.contentType !== !1 || O.contentType) && Bi.setRequestHeader("Content-Type", ut.contentType), Bi.setRequestHeader(
          "Accept",
          ut.dataTypes[0] && ut.accepts[ut.dataTypes[0]] ? ut.accepts[ut.dataTypes[0]] + (ut.dataTypes[0] !== "*" ? ", " + Ps + "; q=0.01" : "") : ut.accepts["*"]
        );
        for (St in ut.headers)
          Bi.setRequestHeader(St, ut.headers[St]);
        if (ut.beforeSend && (ut.beforeSend.call(Ut, Bi, ut) === !1 || De))
          return Bi.abort();
        if (pi = "abort", bi.add(ut.complete), Bi.done(ut.success), Bi.fail(ut.error), q = rr(Ri, ut, O, Bi), !q)
          On(-1, "No Transport");
        else {
          if (Bi.readyState = 1, Ke && ti.trigger("ajaxSend", [Bi, ut]), De)
            return Bi;
          ut.async && ut.timeout > 0 && (ye = e.setTimeout(function() {
            Bi.abort("timeout");
          }, ut.timeout));
          try {
            De = !1, q.send(_n, On);
          } catch (Oi) {
            if (De)
              throw Oi;
            On(-1, Oi);
          }
        }
        function On(Oi, Wi, es, sr) {
          var mn, fr, Un, Jt, qn, Pn = Wi;
          De || (De = !0, ye && e.clearTimeout(ye), q = void 0, de = sr || "", Bi.readyState = Oi > 0 ? 4 : 0, mn = Oi >= 200 && Oi < 300 || Oi === 304, es && (Jt = Ks(ut, Bi, es)), !mn && j.inArray("script", ut.dataTypes) > -1 && j.inArray("json", ut.dataTypes) < 0 && (ut.converters["text script"] = function() {
          }), Jt = hs(ut, Jt, Bi, mn), mn ? (ut.ifModified && (qn = Bi.getResponseHeader("Last-Modified"), qn && (j.lastModified[ne] = qn), qn = Bi.getResponseHeader("etag"), qn && (j.etag[ne] = qn)), Oi === 204 || ut.type === "HEAD" ? Pn = "nocontent" : Oi === 304 ? Pn = "notmodified" : (Pn = Jt.state, fr = Jt.data, Un = Jt.error, mn = !Un)) : (Un = Pn, (Oi || !Pn) && (Pn = "error", Oi < 0 && (Oi = 0))), Bi.status = Oi, Bi.statusText = (Wi || Pn) + "", mn ? wi.resolveWith(Ut, [fr, Pn, Bi]) : wi.rejectWith(Ut, [Bi, Pn, Un]), Bi.statusCode(An), An = void 0, Ke && ti.trigger(
            mn ? "ajaxSuccess" : "ajaxError",
            [Bi, ut, mn ? fr : Un]
          ), bi.fireWith(Ut, [Bi, Pn]), Ke && (ti.trigger("ajaxComplete", [Bi, ut]), --j.active || j.event.trigger("ajaxStop")));
        }
        return Bi;
      },
      getJSON: function(w, O, q) {
        return j.get(w, O, q, "json");
      },
      getScript: function(w, O) {
        return j.get(w, void 0, O, "script");
      }
    }), j.each(["get", "post"], function(w, O) {
      j[O] = function(q, ne, de, _e) {
        return Y(ne) && (_e = _e || de, de = ne, ne = void 0), j.ajax(j.extend({
          url: q,
          type: O,
          dataType: _e,
          data: ne,
          success: de
        }, j.isPlainObject(q) && q));
      };
    }), j.ajaxPrefilter(function(w) {
      var O;
      for (O in w.headers)
        O.toLowerCase() === "content-type" && (w.contentType = w.headers[O] || "");
    }), j._evalUrl = function(w, O, q) {
      return j.ajax({
        url: w,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(ne) {
          j.globalEval(ne, O, q);
        }
      });
    }, j.fn.extend({
      wrapAll: function(w) {
        var O;
        return this[0] && (Y(w) && (w = w.call(this[0])), O = j(w, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && O.insertBefore(this[0]), O.map(function() {
          for (var q = this; q.firstElementChild; )
            q = q.firstElementChild;
          return q;
        }).append(this)), this;
      },
      wrapInner: function(w) {
        return Y(w) ? this.each(function(O) {
          j(this).wrapInner(w.call(this, O));
        }) : this.each(function() {
          var O = j(this), q = O.contents();
          q.length ? q.wrapAll(w) : O.append(w);
        });
      },
      wrap: function(w) {
        var O = Y(w);
        return this.each(function(q) {
          j(this).wrapAll(O ? w.call(this, q) : w);
        });
      },
      unwrap: function(w) {
        return this.parent(w).not("body").each(function() {
          j(this).replaceWith(this.childNodes);
        }), this;
      }
    }), j.expr.pseudos.hidden = function(w) {
      return !j.expr.pseudos.visible(w);
    }, j.expr.pseudos.visible = function(w) {
      return !!(w.offsetWidth || w.offsetHeight || w.getClientRects().length);
    }, j.ajaxSettings.xhr = function() {
      try {
        return new e.XMLHttpRequest();
      } catch {
      }
    };
    var Br = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, pn = j.ajaxSettings.xhr();
    X.cors = !!pn && "withCredentials" in pn, X.ajax = pn = !!pn, j.ajaxTransport(function(w) {
      var O, q;
      if (X.cors || pn && !w.crossDomain)
        return {
          send: function(ne, de) {
            var _e, ye = w.xhr();
            if (ye.open(
              w.type,
              w.url,
              w.async,
              w.username,
              w.password
            ), w.xhrFields)
              for (_e in w.xhrFields)
                ye[_e] = w.xhrFields[_e];
            w.mimeType && ye.overrideMimeType && ye.overrideMimeType(w.mimeType), !w.crossDomain && !ne["X-Requested-With"] && (ne["X-Requested-With"] = "XMLHttpRequest");
            for (_e in ne)
              ye.setRequestHeader(_e, ne[_e]);
            O = function(Ve) {
              return function() {
                O && (O = q = ye.onload = ye.onerror = ye.onabort = ye.ontimeout = ye.onreadystatechange = null, Ve === "abort" ? ye.abort() : Ve === "error" ? typeof ye.status != "number" ? de(0, "error") : de(
                  // File: protocol always yields status 0; see trac-8605, trac-14207
                  ye.status,
                  ye.statusText
                ) : de(
                  Br[ye.status] || ye.status,
                  ye.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (ye.responseType || "text") !== "text" || typeof ye.responseText != "string" ? { binary: ye.response } : { text: ye.responseText },
                  ye.getAllResponseHeaders()
                ));
              };
            }, ye.onload = O(), q = ye.onerror = ye.ontimeout = O("error"), ye.onabort !== void 0 ? ye.onabort = q : ye.onreadystatechange = function() {
              ye.readyState === 4 && e.setTimeout(function() {
                O && q();
              });
            }, O = O("abort");
            try {
              ye.send(w.hasContent && w.data || null);
            } catch (Ve) {
              if (O)
                throw Ve;
            }
          },
          abort: function() {
            O && O();
          }
        };
    }), j.ajaxPrefilter(function(w) {
      w.crossDomain && (w.contents.script = !1);
    }), j.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(w) {
          return j.globalEval(w), w;
        }
      }
    }), j.ajaxPrefilter("script", function(w) {
      w.cache === void 0 && (w.cache = !1), w.crossDomain && (w.type = "GET");
    }), j.ajaxTransport("script", function(w) {
      if (w.crossDomain || w.scriptAttrs) {
        var O, q;
        return {
          send: function(ne, de) {
            O = j("<script>").attr(w.scriptAttrs || {}).prop({ charset: w.scriptCharset, src: w.url }).on("load error", q = function(_e) {
              O.remove(), q = null, _e && de(_e.type === "error" ? 404 : 200, _e.type);
            }), G.head.appendChild(O[0]);
          },
          abort: function() {
            q && q();
          }
        };
      }
    });
    var us = [], Qn = /(=)\?(?=&|$)|\?\?/;
    j.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var w = us.pop() || j.expando + "_" + g.guid++;
        return this[w] = !0, w;
      }
    }), j.ajaxPrefilter("json jsonp", function(w, O, q) {
      var ne, de, _e, ye = w.jsonp !== !1 && (Qn.test(w.url) ? "url" : typeof w.data == "string" && (w.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Qn.test(w.data) && "data");
      if (ye || w.dataTypes[0] === "jsonp")
        return ne = w.jsonpCallback = Y(w.jsonpCallback) ? w.jsonpCallback() : w.jsonpCallback, ye ? w[ye] = w[ye].replace(Qn, "$1" + ne) : w.jsonp !== !1 && (w.url += (z.test(w.url) ? "&" : "?") + w.jsonp + "=" + ne), w.converters["script json"] = function() {
          return _e || j.error(ne + " was not called"), _e[0];
        }, w.dataTypes[0] = "json", de = e[ne], e[ne] = function() {
          _e = arguments;
        }, q.always(function() {
          de === void 0 ? j(e).removeProp(ne) : e[ne] = de, w[ne] && (w.jsonpCallback = O.jsonpCallback, us.push(ne)), _e && Y(de) && de(_e[0]), _e = de = void 0;
        }), "script";
    }), X.createHTMLDocument = function() {
      var w = G.implementation.createHTMLDocument("").body;
      return w.innerHTML = "<form></form><form></form>", w.childNodes.length === 2;
    }(), j.parseHTML = function(w, O, q) {
      if (typeof w != "string")
        return [];
      typeof O == "boolean" && (q = O, O = !1);
      var ne, de, _e;
      return O || (X.createHTMLDocument ? (O = G.implementation.createHTMLDocument(""), ne = O.createElement("base"), ne.href = G.location.href, O.head.appendChild(ne)) : O = G), de = lt.exec(w), _e = !q && [], de ? [O.createElement(de[1])] : (de = V([w], O, _e), _e && _e.length && j(_e).remove(), j.merge([], de.childNodes));
    }, j.fn.load = function(w, O, q) {
      var ne, de, _e, ye = this, Ve = w.indexOf(" ");
      return Ve > -1 && (ne = Mn(w.slice(Ve)), w = w.slice(0, Ve)), Y(O) ? (q = O, O = void 0) : O && typeof O == "object" && (de = "POST"), ye.length > 0 && j.ajax({
        url: w,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: de || "GET",
        dataType: "html",
        data: O
      }).done(function(De) {
        _e = arguments, ye.html(ne ? (
          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          j("<div>").append(j.parseHTML(De)).find(ne)
        ) : (
          // Otherwise use the full result
          De
        ));
      }).always(q && function(De, Ke) {
        ye.each(function() {
          q.apply(this, _e || [De.responseText, Ke, De]);
        });
      }), this;
    }, j.expr.pseudos.animated = function(w) {
      return j.grep(j.timers, function(O) {
        return w === O.elem;
      }).length;
    }, j.offset = {
      setOffset: function(w, O, q) {
        var ne, de, _e, ye, Ve, De, Ke, St = j.css(w, "position"), Ct = j(w), ut = {};
        St === "static" && (w.style.position = "relative"), Ve = Ct.offset(), _e = j.css(w, "top"), De = j.css(w, "left"), Ke = (St === "absolute" || St === "fixed") && (_e + De).indexOf("auto") > -1, Ke ? (ne = Ct.position(), ye = ne.top, de = ne.left) : (ye = parseFloat(_e) || 0, de = parseFloat(De) || 0), Y(O) && (O = O.call(w, q, j.extend({}, Ve))), O.top != null && (ut.top = O.top - Ve.top + ye), O.left != null && (ut.left = O.left - Ve.left + de), "using" in O ? O.using.call(w, ut) : Ct.css(ut);
      }
    }, j.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(w) {
        if (arguments.length)
          return w === void 0 ? this : this.each(function(de) {
            j.offset.setOffset(this, w, de);
          });
        var O, q, ne = this[0];
        if (ne)
          return ne.getClientRects().length ? (O = ne.getBoundingClientRect(), q = ne.ownerDocument.defaultView, {
            top: O.top + q.pageYOffset,
            left: O.left + q.pageXOffset
          }) : { top: 0, left: 0 };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (this[0]) {
          var w, O, q, ne = this[0], de = { top: 0, left: 0 };
          if (j.css(ne, "position") === "fixed")
            O = ne.getBoundingClientRect();
          else {
            for (O = this.offset(), q = ne.ownerDocument, w = ne.offsetParent || q.documentElement; w && (w === q.body || w === q.documentElement) && j.css(w, "position") === "static"; )
              w = w.parentNode;
            w && w !== ne && w.nodeType === 1 && (de = j(w).offset(), de.top += j.css(w, "borderTopWidth", !0), de.left += j.css(w, "borderLeftWidth", !0));
          }
          return {
            top: O.top - de.top - j.css(ne, "marginTop", !0),
            left: O.left - de.left - j.css(ne, "marginLeft", !0)
          };
        }
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          for (var w = this.offsetParent; w && j.css(w, "position") === "static"; )
            w = w.offsetParent;
          return w || b;
        });
      }
    }), j.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(w, O) {
      var q = O === "pageYOffset";
      j.fn[w] = function(ne) {
        return Ie(this, function(de, _e, ye) {
          var Ve;
          if (ie(de) ? Ve = de : de.nodeType === 9 && (Ve = de.defaultView), ye === void 0)
            return Ve ? Ve[O] : de[_e];
          Ve ? Ve.scrollTo(
            q ? Ve.pageXOffset : ye,
            q ? ye : Ve.pageYOffset
          ) : de[_e] = ye;
        }, w, ne, arguments.length);
      };
    }), j.each(["top", "left"], function(w, O) {
      j.cssHooks[O] = zt(
        X.pixelPosition,
        function(q, ne) {
          if (ne)
            return ne = Et(q, O), ze.test(ne) ? j(q).position()[O] + "px" : ne;
        }
      );
    }), j.each({ Height: "height", Width: "width" }, function(w, O) {
      j.each({
        padding: "inner" + w,
        content: O,
        "": "outer" + w
      }, function(q, ne) {
        j.fn[ne] = function(de, _e) {
          var ye = arguments.length && (q || typeof de != "boolean"), Ve = q || (de === !0 || _e === !0 ? "margin" : "border");
          return Ie(this, function(De, Ke, St) {
            var Ct;
            return ie(De) ? ne.indexOf("outer") === 0 ? De["inner" + w] : De.document.documentElement["client" + w] : De.nodeType === 9 ? (Ct = De.documentElement, Math.max(
              De.body["scroll" + w],
              Ct["scroll" + w],
              De.body["offset" + w],
              Ct["offset" + w],
              Ct["client" + w]
            )) : St === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              j.css(De, Ke, Ve)
            ) : (
              // Set width or height on the element
              j.style(De, Ke, St, Ve)
            );
          }, O, ye ? de : void 0, ye);
        };
      });
    }), j.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(w, O) {
      j.fn[O] = function(q) {
        return this.on(O, q);
      };
    }), j.fn.extend({
      bind: function(w, O, q) {
        return this.on(w, null, O, q);
      },
      unbind: function(w, O) {
        return this.off(w, null, O);
      },
      delegate: function(w, O, q, ne) {
        return this.on(O, w, q, ne);
      },
      undelegate: function(w, O, q) {
        return arguments.length === 1 ? this.off(w, "**") : this.off(O, w || "**", q);
      },
      hover: function(w, O) {
        return this.on("mouseenter", w).on("mouseleave", O || w);
      }
    }), j.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(w, O) {
        j.fn[O] = function(q, ne) {
          return arguments.length > 0 ? this.on(O, null, q, ne) : this.trigger(O);
        };
      }
    );
    var Ns = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    j.proxy = function(w, O) {
      var q, ne, de;
      if (typeof O == "string" && (q = w[O], O = w, w = q), !!Y(w))
        return ne = a.call(arguments, 2), de = function() {
          return w.apply(O || this, ne.concat(a.call(arguments)));
        }, de.guid = w.guid = w.guid || j.guid++, de;
    }, j.holdReady = function(w) {
      w ? j.readyWait++ : j.ready(!0);
    }, j.isArray = Array.isArray, j.parseJSON = JSON.parse, j.nodeName = ke, j.isFunction = Y, j.isWindow = ie, j.camelCase = et, j.type = he, j.now = Date.now, j.isNumeric = function(w) {
      var O = j.type(w);
      return (O === "number" || O === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(w - parseFloat(w));
    }, j.trim = function(w) {
      return w == null ? "" : (w + "").replace(Ns, "$1");
    };
    var Qr = e.jQuery, Zn = e.$;
    return j.noConflict = function(w) {
      return e.$ === j && (e.$ = Zn), w && e.jQuery === j && (e.jQuery = Qr), j;
    }, typeof t > "u" && (e.jQuery = e.$ = j), j;
  });
})(Dd);
var kx = Dd.exports;
const ua = /* @__PURE__ */ iu(kx);
function Hw() {
  const y = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, e = window.devicePixelRatio || 1, t = {
    width: window.screen.width * e,
    height: window.screen.height * e
  };
  return !!(y && t.width === 1125 && t.height === 2436);
}
function Yw() {
  return /android/i.test(navigator.userAgent);
}
function Gw() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
function Ix() {
  const y = navigator.userAgent || navigator.vendor || self.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    y
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    y.substr(0, 4)
  );
}
function jw() {
  const y = document.compatMode === "CSS1Compat";
  return {
    l: window.pageXOffset || (y ? document.documentElement.scrollLeft : document.body.scrollLeft),
    t: window.pageYOffset || (y ? document.documentElement.scrollTop : document.body.scrollTop),
    w: window.innerWidth || (y ? document.documentElement.clientWidth : document.body.clientWidth),
    h: window.innerHeight || (y ? document.documentElement.clientHeight : document.body.clientHeight)
  };
}
function Ww(y, e, t) {
  var r = (y * 299 + e * 587 + t * 114) / 1e3;
  return r >= 128 ? "black" : "white";
}
function Zw(y) {
  var e = parseInt(y.substr(0, 2), 16), t = parseInt(y.substr(2, 2), 16), r = parseInt(y.substr(4, 2), 16), o = (e * 299 + t * 587 + r * 114) / 1e3;
  return o >= 128 ? "black" : "white";
}
function aa(y, e) {
  return typeof e > "u" || typeof e === null ? !1 : function(r, o) {
    let a = o !== o, u;
    return !a && typeof Array.prototype.indexOf == "function" ? (u = Array.prototype.indexOf, u.call(r, o) > -1) : (u = function(f, v) {
      var S = -1, I = -1;
      for (S = 0; S < f.length; S++) {
        var D = f[S];
        if (a && D !== D || D === v) {
          I = S;
          break;
        }
      }
      return I;
    }, u(r, o) > -1);
  }(y, e);
}
function Ox(y) {
  y = String(y).replace(/[^0-9a-f]/gi, ""), y.length < 6 && (y = y[0] + y[0] + y[1] + y[1] + y[2] + y[2]);
  var e = parseInt(y.substr(0 * 2, 2), 16), t = parseInt(y.substr(1 * 2, 2), 16), r = parseInt(y.substr(2 * 2, 2), 16), o = Math.sqrt(e * e * 0.241 + t * t * 0.691 + r * r * 0.068);
  return o;
}
function Px(y) {
  return Ox(y) < 130;
}
function Nx(y, e = 0) {
  y = String(y).replace(/[^0-9a-f]/gi, ""), y.length < 6 && (y = y[0] + y[0] + y[1] + y[1] + y[2] + y[2]), e = e || 0;
  var t = "#", r, o;
  for (o = 0; o < 3; o++)
    r = parseInt(y.substr(o * 2, 2), 16), r = Math.round(Math.min(Math.max(0, r + r * e), 255)).toString(16), t += ("00" + r).substr(r.length);
  return t;
}
function Rx(y, e, t, r) {
  var o = new Image(), a = ua("<canvas>"), u = a[0], f = u.getContext("2d");
  o.crossOrigin = "anonymous", o.onload = function() {
    if (a.attr({ width: o.width, height: o.height }), f = u.getContext("2d"), f) {
      f.drawImage(o, 0, 0);
      let v = zd(u, o.width, o.height, e, t);
      r && r(v);
    } else
      alert("Get a real browser!");
  }, o.src = y;
}
async function Fh(y) {
  return new Promise((e, t) => {
    const r = new Image(), o = ua("<canvas>");
    let a = o[0], u = a.getContext("2d");
    r.crossOrigin = "anonymous", r.onload = function() {
      if (o.attr({ width: r.width, height: r.height }), u = a.getContext("2d"), u) {
        u.drawImage(r, 0, 0);
        let f = Dx(a);
        e(f);
      } else
        t(new Error("HTML5 Canvas not supported"));
    }, r.src = y;
  });
}
function Dx(y) {
  const e = y.getContext("2d");
  if (!e)
    return null;
  const t = y.width, r = y.height, a = e.getImageData(0, 0, y.width, y.height).data, u = (ie, G) => a[(t * G + ie) * 4 + 3], f = (ie) => ie < 10, v = (ie) => {
    const G = ie ? 1 : -1;
    for (var te = ie ? 0 : r - 1; ie ? te < r : te > -1; te += G)
      for (var J = 0; J < t; J++)
        if (!f(u(J, te)))
          return te;
    return null;
  }, S = (ie) => {
    const G = ie ? 1 : -1;
    for (var te = ie ? 0 : t - 1; ie ? te < t : te > -1; te += G)
      for (var J = 0; J < r; J++)
        if (!f(u(te, J)))
          return te;
    return null;
  }, I = v(!0), D = v(!1), Z = S(!0), M = S(!1);
  if (I != null && D != null && Z != null && M != null) {
    const ie = M - Z + 1, G = D - I + 1, J = ua("<canvas>").attr({ width: ie, height: G })[0];
    var X = J.getContext("2d");
    if (!X)
      return null;
    X.drawImage(y, Z, I, ie, G, 0, 0, ie, G), X.getImageData(0, 0, J.width, J.height);
    var Y = J.toDataURL();
    return Y;
  } else
    return null;
}
async function qw(y, e, t) {
  return new Promise((r, o) => {
    const a = new Image(), u = ua("<canvas>");
    let f = u[0], v = f.getContext("2d");
    a.crossOrigin = "anonymous", a.onload = function() {
      if (u.attr({ width: a.width, height: a.height }), v = f.getContext("2d"), v) {
        v.drawImage(a, 0, 0);
        let S = zd(f, a.width, a.height, e, t);
        r(S);
      } else
        o(new Error("HTML5 Canvas not supported"));
    }, a.src = y;
  });
}
function zd(y, e, t, r, o) {
  const a = y.getContext("2d");
  if (!a)
    return null;
  const f = a.getImageData(0, 0, y.width, y.height).data, v = (te, J) => f[(e * J + te) * 4 + 3], S = (te) => te === 0, I = (te) => {
    const J = te ? 1 : -1;
    for (var he = te ? 0 : t - 1; te ? he < t : he > -1; he += J)
      for (var ve = 0; ve < e; ve++)
        if (!S(v(ve, he)))
          return he;
    return null;
  }, D = (te) => {
    const J = te ? 1 : -1;
    for (var he = te ? 0 : e - 1; te ? he < e : he > -1; he += J)
      for (var ve = 0; ve < t; ve++)
        if (!S(v(he, ve)))
          return he;
    return null;
  }, Z = I(!0), M = I(!1), X = D(!0), Y = D(!1);
  if (Z != null && M != null && X != null && Y != null) {
    const te = Y - X, J = M - Z, he = r, ve = o, K = he / te, j = ve / J;
    let We = te * K, ke = J * K;
    ke > ve && (We = te * j, ke = J * j);
    const Lt = ua("<canvas>").attr({ width: he, height: ve })[0];
    var ie = Lt.getContext("2d");
    if (!ie)
      return null;
    ie.drawImage(
      y,
      X,
      Z,
      te,
      J,
      (he - We) / 2,
      (ve - ke) / 2,
      We,
      ke
    ), ie.getImageData(0, 0, Lt.width, Lt.height);
    var G = Lt.toDataURL();
    return G;
  } else
    return null;
}
async function zx(y, e, t, r) {
  return new Promise((o) => {
    const a = new Image();
    a.crossOrigin = "anonymous", a.onload = function() {
      let f = ua("<canvas>")[0], v = f.getContext("2d");
      if (v) {
        f.width = e, f.height = t;
        const S = Math.min(e / a.width, t / a.height), I = a.width * S, D = a.height * S;
        v.drawImage(
          a,
          0,
          0,
          a.width,
          a.height,
          (e - I + r) / 2,
          (t - D + r) / 2,
          I - r,
          D - r
        );
        const Z = f.toDataURL();
        o(Z);
      }
    }, a.src = y;
  });
}
function Xw(y, e, t) {
  var r = ua("<canvas>");
  r.attr({ width: e, height: t });
  var o = r[0], a = o.getContext("2d");
  if (a) {
    a.fillStyle = y, a.fillRect(0, 0, e, t);
    var u = o.toDataURL();
    return u;
  } else
    return null;
}
function Kw(y, e) {
  return y ? y.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function Jw(y) {
  let e = 0, t, r;
  if (y.length === 0)
    return e;
  for (t = 0; t < y.length; t++)
    r = y.charCodeAt(t), e = (e << 5) - e + r, e |= 0;
  return e;
}
function $w(y) {
  var e = document.createElement("a");
  return e.href = y, e.href;
}
function Fd(y) {
  for (var e = atob(y.split(",")[1]), t = y.split(",")[0].split(":")[1].split(";")[0], r = new ArrayBuffer(e.length), o = new Uint8Array(r), a = 0; a < e.length; a++)
    o[a] = e.charCodeAt(a);
  var u = new Blob([r], { type: t });
  return u;
}
function Qw(y, e) {
  if (typeof y != "number" && y < 1)
    throw new RangeError("Length must be a positive integer!");
  e === void 0 && (e = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  let t = "";
  const r = e.length;
  for (var o = 0; o < y; o++)
    t += e.charAt(Math.floor(Math.random() * r));
  return t;
}
async function e1(y, e) {
  return new Promise((t) => {
    const r = new Uint8Array(y), o = new Blob([r], { type: e }), u = (window.URL || window.webkitURL).createObjectURL(o), f = new Image();
    f.src = u, f.onload = async () => {
      const v = document.createElement("canvas"), S = v.getContext("2d");
      v.width = f.width, v.height = f.height, S.translate(0, f.height), S.scale(1, -1), S.drawImage(f, 0, 0), v.toBlob((I) => {
        const D = new FileReader();
        D.addEventListener("loadend", () => {
          const Z = D.result;
          t(Z);
        }), D.readAsArrayBuffer(I);
      }, e);
    };
  });
}
function $o(y) {
  return y instanceof BABYLON.PBRMaterial;
}
function t1() {
  const y = new URL(window.location.href);
  return new URLSearchParams(y.search);
}
class Fx {
  constructor() {
    this.previewFiles = {};
  }
  downloadFiles() {
    function e(t, r) {
      return t.indexOf(r, t.length - r.length) !== -1;
    }
    for (let t in this.previewFiles) {
      let r = null;
      const o = this.previewFiles[t];
      if (typeof o == "string" ? r = Fd(o) : r = o, r) {
        let a = null;
        if (e(t, ".jpeg") ? a = { type: "image/jpeg" } : e(t, ".png") && (a = { type: "image/png" }), a) {
          let u = document.createElement("a");
          document.body.appendChild(u), u.setAttribute("type", "hidden"), u.download = t, u.href = window.URL.createObjectURL(new Blob([r], a)), u.click();
        }
      }
    }
  }
}
class lo {
  static async getPreviewsAsync(e, t, r, o, a = !0) {
    await e.whenReadyAsync();
    const u = new Ux(e, t, r, o), f = await u.getPreviewsAsync(a);
    return u.dispose(), f;
  }
  static async downloadPreviewsAsync(e, t, r, o) {
    (await lo.getPreviewsAsync(e, t, r, o)).downloadFiles();
  }
}
class Ux {
  constructor(e, t, r, o) {
    this._width = 256, this._height = 256, this._crop = !1, this._materials = [], this._localEngine = null, this._hostingScene = null, this._hostingSceneHelper = null, this._hostingMesh = null, this._scene = e, this._rootUrl = t, this._materialIDs = r, this._options = o || {}, this.setupPreviewSize(), this._options.crop != null && (this._crop = this._options.crop), this.readMaterials();
  }
  dispose() {
    this.disposeHostingScene(), this.disposeLocalEngine();
  }
  getLocalEngine() {
    if (!this._localEngine) {
      const e = document.createElement("canvas");
      e.id = "MaterialPreviewCanvas", e.width = 1024, e.height = 1024, this._localEngine = new BABYLON.Engine(e, !0, { premultipliedAlpha: !1, preserveDrawingBuffer: !0 }), this._localEngine.setSize(this._width, this._height);
    }
    return this._localEngine;
  }
  disposeLocalEngine() {
    this._localEngine && this._localEngine.dispose();
  }
  disposeHostingScene() {
    this._hostingSceneHelper && (this._hostingSceneHelper.dispose(), this._hostingSceneHelper = null), this._hostingScene && (this._hostingScene.dispose(), this._hostingScene = null);
  }
  setupPreviewSize() {
    let e = this._options;
    e.width != null && e.height == null ? (this._width = e.width, this._height = e.width) : e.width == null && e.height != null ? (this._width = e.height, this._height = e.height) : e.width != null && e.height != null && (this._width = e.width, this._height = e.height);
  }
  readMaterials() {
    this._materialIDs.forEach((e) => {
      const t = this._scene.getMaterialByID(e);
      t && this._materials.push(t);
    });
  }
  async downloadPreviewsAsync() {
    (await this.getPreviewsAsync()).downloadFiles();
  }
  async getPreviewsAsync(e = !0) {
    const t = this.getLocalEngine();
    this._hostingScene = new BABYLON.Scene(t), this._hostingSceneHelper = new yi(this._hostingScene), this._hostingSceneHelper.setupCamera();
    const r = this._hostingScene.activeCamera;
    return r && (/firefox/i.test(navigator.userAgent) || new BABYLON.PassPostProcess("scale_pass", 4, r, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 2, r, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 1, r, BABYLON.Texture.BILINEAR_SAMPLINGMODE)), new Promise((o) => {
      const a = new BABYLON.CubeTexture(li.Environment.EnvironmentTextureCDNUrl, this._hostingScene, null, !1, null, async () => {
        if (!this._hostingScene || !this._hostingSceneHelper)
          return;
        this._hostingScene.environmentTexture = a, this._hostingSceneHelper.setupLights(), this._hostingMesh = this._hostingSceneHelper.createSphere(null), this._hostingSceneHelper.adjustCamera(void 0, void 0, void 0, !1);
        const u = new Fx();
        for (let f = 0; f < this._materials.length; f++) {
          const v = this._materials[f];
          await this.createMaterialPreviewFileAsync(v, u, e);
        }
        this.disposeHostingScene(), this.disposeLocalEngine(), o(u);
      }, null, void 0, !0, void 0, !0);
    });
  }
  async createMaterialPreviewFileAsync(e, t, r = !0) {
    if (this._hostingScene && this._hostingSceneHelper && this._hostingMesh) {
      const o = e.serialize(), a = BABYLON.Material.Parse(o, this._hostingScene, this._rootUrl);
      if (a) {
        this._hostingMesh.material = a, await yi.whenMeshMaterialIsReady(this._hostingMesh), this._hostingScene.render();
        let u = await this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
        if (this._crop) {
          const S = await Fh(u);
          S && (u = S);
        }
        let f = a.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
        f = this.getNextIncrementalName(f, ".png", t) + ".png", Logger.info("preview: " + f);
        let v = u;
        r && (v = Fd(u)), t.previewFiles[f] = v;
      }
    }
  }
  getNextIncrementalName(e, t, r) {
    let o = e;
    if (e) {
      let v, S = 0;
      for (; r.previewFiles.hasOwnProperty(o + t); ) {
        if (!v) {
          v = e;
          var a = e.lastIndexOf("_");
          if (a > 0) {
            var u = e.substring(a + 1), f = parseInt(u);
            f.toString() === u && (v = e.substring(0, a));
          }
        }
        S++, o = v + "_" + S;
      }
    }
    return o;
  }
}
class Vx {
  constructor(e, t, r, o) {
    this._bias = 50, this._invertR = !1, this._invertG = !1, this._preBlurEnabled = !1, this._preBlur = 3, this._postBlurEnabled = !1, this._postBlur = 3, this._bevel = !0, this._intensity = 0.5, this._activeTextures = [], this._preBlurXTexture = null, this._preBlurYTexture = null, this._normalMapTexture = null, this._postBlurXTexture = null, this._postBlurYTexture = null, this._baseTexture = e, this._size = t, this._scene = o, this.init(r);
  }
  init(e) {
    for (this._bias = e.get("bias"), this._invertR = e.get("invertR"), this._invertG = e.get("invertG"), this._bevel = e.get("bevel"), this._intensity = e.get("intensity"), this._preBlurEnabled = e.get("preBlurEnabled"), this._preBlur = e.get("preBlur"), this._postBlurEnabled = e.get("postBlurEnabled"), this._postBlur = e.get("postBlur"); this._activeTextures.length > 0; )
      this._activeTextures.pop();
    this.updateTextures();
  }
  updateTextures() {
    let e = this.updatePreBlurTexture();
    e = this.updateNormalmapTexture(e), e = this.updatePostBlurTexture(e);
  }
  updatePreBlurTexture() {
    let e = this._baseTexture;
    return this._preBlurEnabled && (this._preBlurXTexture ? this._preBlurXTexture.baseTexture = this._baseTexture : this._preBlurXTexture = new so("preBlurX", this._size, this._scene, this._baseTexture, void 0, !1), this._preBlurXTexture.beginInit(), this._preBlurXTexture.blur = this._preBlur, this._preBlurXTexture.refreshRate = 0, this._preBlurXTexture.endInit(), this._activeTextures.push(this._preBlurXTexture), this._preBlurYTexture ? this._preBlurYTexture.baseTexture = this._preBlurXTexture : this._preBlurYTexture = new ao("preBlurY", this._size, this._scene, this._preBlurXTexture, void 0, !1), this._preBlurYTexture.beginInit(), this._preBlurYTexture.blur = this._preBlur, this._preBlurYTexture.refreshRate = 0, this._preBlurYTexture.endInit(), this._activeTextures.push(this._preBlurYTexture), e = this._preBlurYTexture), e;
  }
  updateNormalmapTexture(e) {
    return this._normalMapTexture ? this._normalMapTexture.baseTexture = e : this._normalMapTexture = new Bd("procNormal", this._size, this._scene, e, void 0, !1), this._normalMapTexture.beginInit(), this._normalMapTexture.bias = this._bias, this._normalMapTexture.invertR = this._invertR, this._normalMapTexture.invertG = this._invertG, this._normalMapTexture.bevel = this._bevel, this._normalMapTexture.intensity = this._intensity, this._normalMapTexture.refreshRate = 0, this._normalMapTexture.endInit(), this._activeTextures.push(this._normalMapTexture), this._normalMapTexture;
  }
  updatePostBlurTexture(e) {
    let t = e;
    return this._postBlurEnabled && (this._postBlurXTexture ? this._postBlurXTexture.baseTexture = e : this._postBlurXTexture = new so("postBlurX", this._size, this._scene, e, void 0, !1), this._postBlurXTexture && (this._postBlurXTexture.beginInit(), this._postBlurXTexture.blur = this._postBlur, this._postBlurXTexture.refreshRate = 0, this._postBlurXTexture.endInit(), this._activeTextures.push(this._postBlurXTexture), this._postBlurYTexture ? this._postBlurYTexture.baseTexture = this._postBlurXTexture : this._postBlurYTexture = new ao("postBlurY", this._size, this._scene, this._postBlurXTexture, void 0, !1), this._postBlurYTexture && (this._postBlurYTexture.beginInit(), this._postBlurYTexture.blur = this._postBlur, this._postBlurYTexture.refreshRate = 0, this._postBlurYTexture.endInit(), this._activeTextures.push(this._postBlurYTexture), t = this._postBlurYTexture))), t;
  }
  dispose() {
    this._preBlurXTexture && (this._preBlurXTexture.dispose(), this._preBlurXTexture = null), this._preBlurYTexture && (this._preBlurYTexture.dispose(), this._preBlurYTexture = null), this._normalMapTexture && (this._normalMapTexture.dispose(), this._normalMapTexture = null), this._postBlurXTexture && (this._postBlurXTexture.dispose(), this._postBlurXTexture = null), this._postBlurYTexture && (this._postBlurYTexture.dispose(), this._postBlurYTexture = null);
  }
  async getNormalMapTextureAsync(e, t) {
    return await this.updateAsync(e, t), this._activeTextures.length > 0 ? this._activeTextures[this._activeTextures.length - 1] : null;
  }
  async updateAsync(e, t) {
    if (this.init(t), this._activeTextures.length > 0) {
      this._activeTextures[0].baseTexture = e;
      for (var r = 0; r < this._activeTextures.length; r++)
        await this._activeTextures[r].isReadyAsync(), this._activeTextures[r].render();
    }
  }
}
class Hx {
  constructor(e, t, r, o) {
    this._baseTexture = e, this._size = t, this._scene = o, this._mask = new oo("mask", this._size, this._scene, this._baseTexture), this._mask.backColor = new BABYLON.Vector3(0, 0, 0), this._mask.foreColor = new BABYLON.Vector3(1, 1, 1), this._mask.refreshRate = 0, this._shadow = new oo("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1), this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1), this._shadow.refreshRate = 0, this._shadowBlurX = new so("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 5, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ao("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 5, this._shadowBlurY.refreshRate = 0, this._shadowMove = new ou("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this._lightmap = new eo("lightmap", this._size, this._scene, this._shadowMove, this._mask), this._lightmap.refreshRate = 0, this.updateParameters(r);
  }
  updateParameters(e) {
    if (e) {
      let t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        const S = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(S.r, S.g, S.b);
      }
      this._shadow.backColor = t;
      let r = 1, o = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (o = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (r = e.get("distance"));
      let a = o * Math.PI / 180;
      a = this.wrapPi(a);
      const u = Math.cos(a) * r, f = Math.sin(a) * r;
      this._shadowMove.offset = new BABYLON.Vector2(-u, f);
      let v = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (v = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = v, this._shadowBlurY.blur = v;
    }
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, r = Math.floor((e + Math.PI) * (1 / t));
      e -= r * t;
    }
    return e;
  }
  dispose() {
    this._mask.dispose(), this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose(), this._lightmap.dispose();
  }
  async getInnerShadowTextureAsync(e) {
    return await this.updateAsync(e), this._lightmap;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await yi.whenTextureIsReadyAsync(this._baseTexture), this._mask.baseTexture = this._baseTexture, await this._mask.isReadyAsync(), this._mask.render(), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render(), await this._lightmap.isReadyAsync(), this._lightmap.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
class Yx {
  constructor(e, t, r, o) {
    this._size = t, this._baseTexture = e, this._scene = o, this._shadow = new oo("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(1, 1, 1), this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2), this._shadow.refreshRate = 0, this._shadowBlurX = new so("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 15, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ao("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 15, this._shadowBlurY.refreshRate = 0, this._shadowMove = new ou("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this.updateParameters(r);
  }
  updateParameters(e) {
    if (e) {
      var t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        var r = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(r.r, r.g, r.b);
      }
      this._shadow.foreColor = t;
      let o = 1, a = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (a = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (o = e.get("distance"));
      let u = a * Math.PI / 180;
      u = this.wrapPi(u);
      const f = Math.cos(u) * o, v = Math.sin(u) * o;
      this._shadowMove.offset = new BABYLON.Vector2(-f, v);
      let S = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (S = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = S, this._shadowBlurY.blur = S;
    }
  }
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, r = Math.floor((e + Math.PI) * (1 / t));
      e -= r * t;
    }
    return e;
  }
  dispose() {
    this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose();
  }
  async getOuterShadowTextureAsync(e) {
    return await this.updateAsync(e), this._shadowMove;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await yi.whenTextureIsReadyAsync(this._baseTexture), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
globalThis && globalThis.__awaiter;
globalThis && globalThis.__generator;
function Th(y, e, t) {
  e === void 0 && (e = 50), t === void 0 && (t = {
    isImmediate: !1
  });
  var r;
  return function() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    var u = this, f = function() {
      r = void 0, t.isImmediate || y.apply(u, o);
    }, v = t.isImmediate && r === void 0;
    r !== void 0 && clearTimeout(r), r = setTimeout(f, e), v && y.apply(u, o);
  };
}
const kf = /android/i.test(navigator.userAgent), If = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, Ud = class ms {
  constructor(e, t, r, o, a, u, f, v = !0, S, I = 0) {
    this._subMesh = null, this._isRefreshing = !1, this._showDesign = !0, this._viewRotation = 0, this._designTextureResolution = 1024, this._effect = null, this._meshSide = null, this._side = null, this._isDisposed = !1, this._baseWidth = ms.DEFAULT_SIZE, this._baseHeight = ms.DEFAULT_SIZE, this._textureWidth = ms.DEFAULT_SIZE, this._textureHeight = ms.DEFAULT_SIZE, this._coordinatesIndex = 0, this._currentVisibliity = !0, this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null, this._normalmapMaterial = null, this._originalMaterial = null, this._blankDataUrl = null, this._innerCanvasMesh = null, this._outerCanvasMesh = null, this._ownDynamicMaterial = !1, this._dynamicMaterial = null, this._dynamicTexture = null, this._normalmapTexture = null, this._dynamicOpacityTexture = null, this._ownOldDynamicMaterial = !1, this._oldDynamicMaterial = null, this._originalDiffuseTexture = null, this._combinedDiffuseTexture = null, this._originalMeshNormalmapTexture = null, this._originalDesignNormalmapTexture = null, this._meshCombinedNormalmapTexture = null, this._designCombinedNormalmapTexture = null, this._originalMeshLightmapTexture = null, this._originalDesignLightmapTexture = null, this._meshCombinedLightmapTexture = null, this._designCombinedLightmapTexture = null, this._innerShadowTexture = null, this._outerShadowTexture = null, this._context = null, this._canvas = null, this._canvasID = Zakeke.generateUUID(), this._customizer = null, this._renderingNeededListeners = [], this._proceduralNormalMap = null, this._innerShadowGenerator = null, this._outerShadowGenerator = null, this._debouncedUpdateDynamicTexture = null, this._originalViewMatrixValues = null, this._grids = [], this._lastUpdateTextureWasDynamic = !0, this.isFirstRender = !0, this._scene = e, this._sceneHelper = new yi(e), this._zkScene = t, this._mesh = r, this._subMesh = o, this._zkModel = a, this._zkDesign = u, this._grids = f, this._showDesign = v, this._viewRotation = I, S && (this._effect = S);
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e);
  }
  get rotation() {
    return this._viewRotation;
  }
  set rotation(e) {
    this._viewRotation != e && (this._viewRotation = e);
  }
  get side() {
    return this._side;
  }
  // Temporary until we can access internal matrix (speak with Matteo)
  getInternalCustomizer() {
    return this._customizer;
  }
  // Factory method for async object creation and initialization
  static async createMeshDesignManagerAsync(e, t, r, o, a, u, f, v = !0, S, I = 0) {
    const D = new ms(
      e,
      t,
      r,
      o,
      a,
      u,
      f,
      v,
      S,
      I
    );
    return await D.initAsync(), D;
  }
  async initAsync() {
    const e = this._zkScene.get("rootUrl");
    e && await this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, e, !0), this.setupMeshSide(), this.setupTextureSize(), this.checkDefaultEffect(), this.refreshModelSide(), await this.setupClonedObjectsAsync(), await this.setupCanvasAsync(), await this.setupDynamicMaterialAsync(), await this.refreshAsync();
  }
  isForMesh(e, t) {
    return !e || !this._mesh || e.id !== this._mesh.id ? !1 : !this._subMesh && !t ? !0 : !this._subMesh || !t ? !1 : t.materialIndex === this._subMesh.materialIndex;
  }
  getMeshID() {
    return this._mesh ? this._mesh.id : null;
  }
  getSubMeshIdx() {
    return this._subMesh ? this._subMesh.materialIndex : 0;
  }
  getMaterialIDForDesign() {
    let e;
    return this._effect && this._effect.get("materialID") ? e = this._effect.get("materialID") : this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID ? e = this._mesh.metadata.designMaterialID : this._meshSide && this._meshSide.get("materialID") && (e = this._meshSide.get("materialID")), e;
  }
  getDesignConfig() {
    let e;
    return this._effect && this._effect.get("config") ? e = this._effect.get("config") : this._meshSide && this._meshSide.get("config") && (e = this._meshSide.get("config")), e || (e = new MPlaza.MeshDesignConfig()), e;
  }
  dispose() {
    this._isDisposed = !0, this._customizer && (this._customizer.clearMemoryForIOS(), this._customizer = null), this.disposeOuterInnerCanvasMeshes(), this._canvasMesh && (this._canvasMesh.dispose(), this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null), this.disposeDynamicMaterial(), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.dispose(), this._dynamicOpacityTexture = null), this._dynamicTexture && (this._dynamicTexture.dispose(), this._dynamicTexture = null), this._renderingNeededListeners = [], $("#" + this._canvasID).remove(), this.restoreOrignalMaterial(), this.disposeNormalmapMaterial(), this._proceduralNormalMap && (this._proceduralNormalMap.dispose(), this._proceduralNormalMap = null), this._innerShadowGenerator && (this._innerShadowGenerator.dispose(), this._innerShadowGenerator = null), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.dispose(), this._combinedDiffuseTexture = null), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.dispose(), this._meshCombinedNormalmapTexture = null), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.dispose(), this._designCombinedNormalmapTexture = null), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.dispose(), this._meshCombinedLightmapTexture = null), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.dispose(), this._designCombinedLightmapTexture = null);
  }
  disposeOuterInnerCanvasMeshes() {
    this._innerCanvasMesh && (this._innerCanvasMesh.dispose(), this._innerCanvasMesh = null), this._outerCanvasMesh && (this._outerCanvasMesh.dispose(), this._outerCanvasMesh = null);
  }
  disposeNormalmapMaterial() {
    this._normalmapMaterial && this._originalMaterial && this._normalmapMaterial.id !== this._originalMaterial.id && this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0 && (this._normalmapMaterial.dispose(), this._normalmapMaterial = null), this._originalMeshNormalmapTexture = null, this._originalMeshLightmapTexture = null;
  }
  disposeDynamicMaterial() {
    this._ownDynamicMaterial && this._dynamicMaterial && this._dynamicMaterial.dispose(), this._dynamicMaterial = null, this._originalDesignNormalmapTexture = null, this._originalDesignLightmapTexture = null;
  }
  disposeOldDynamicMaterial() {
    this._ownOldDynamicMaterial && this._oldDynamicMaterial && this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial && this._oldDynamicMaterial.dispose(), this._oldDynamicMaterial = null;
  }
  createCanvasMeshClone(e) {
    if (this._canvasMesh) {
      const t = this._canvasMesh.clone(e + " - clone outer", null);
      if (t)
        return t.id = Zakeke.generateUUID(), this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== void 0 && this._canvasMesh.metadata.AR !== null && (t.metadata || (t.metadata = {}), t.metadata.AR = this._canvasMesh.metadata.AR), t;
    }
    return null;
  }
  expandCanvasMesh(e) {
    if (!this._mesh || !this._canvasMesh)
      return;
    this.disposeOuterInnerCanvasMeshes();
    const t = this.getMeshHierarchySize(this._mesh), r = this.getMeshHierarchySize(this._canvasMesh);
    if (!t.equals(r))
      return;
    let o = 4e-3;
    e && (o += e);
    const a = 0.2;
    if (this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone"), this._canvasMesh.isVisible = !1, this._outerCanvasMesh)
      if (Math.abs(t.x) <= 0.01 || Math.abs(t.y) <= 0.01 || Math.abs(t.z) <= 0.01) {
        const S = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), I = BABYLON.Vector3.FromArray(
          S,
          0
        ).normalize();
        this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(I.scale(a));
      } else {
        const S = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind)], I = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind)];
        for (var u = 0; u < S.length; u += 3) {
          const M = new BABYLON.Vector3(I[u], I[u + 1], I[u + 2]), X = new BABYLON.Vector3(
            S[u] + M.x * o,
            S[u + 1] + M.y * o,
            S[u + 2] + M.z * o
          );
          S[u] = X.x, S[u + 1] = X.y, S[u + 2] = X.z;
        }
        const D = BABYLON.VertexData.ExtractFromMesh(this._canvasMesh, !0, !0);
        D.positions = S;
        const Z = new BABYLON.Geometry(this._canvasMesh.name + " outer geometry", this._scene);
        D.applyToGeometry(Z), Z.applyToMesh(this._outerCanvasMesh), this._scene.render();
      }
  }
  // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che
  // racchiuda quella originale e che eviti il problema z- fighting.
  // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
  // spostata leggermente nella direzione della normale al piano
  // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
  // proprietà simili al zOffset di Babylon JS
  expandCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh)
      return;
    const e = 0.01, t = 1 + e, r = this.getMeshHierarchySize(this._mesh), o = this.getMeshHierarchySize(this._canvasMesh);
    if (!r.equals(o))
      return;
    const a = 0.1;
    if (Math.abs(r.x) <= a || Math.abs(r.y) <= a || Math.abs(r.z) <= a) {
      let f = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), v = BABYLON.Vector3.FromArray(
        f,
        0
      ).normalize();
      this._canvasMesh.position = this._canvasMesh.position.add(v.scale(e));
    } else {
      let f = this._canvasMesh.scaling;
      f = f.multiplyByFloats(t, t, t), this._canvasMesh.scaling = f;
      let v = this.getMeshHierarchyCenter(this._mesh), S = this.getMeshHierarchyCenter(this._canvasMesh);
      const I = v.subtract(S);
      I.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(I);
    }
  }
  contractCanvasMesh() {
    this._canvasMesh && (this._canvasMesh.isVisible = !0), this.disposeOuterInnerCanvasMeshes();
  }
  // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
  // zOffset per superare il problema dello z-fighting
  contractCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition)
      return;
    this._canvasMesh.scaling = this._originalCanvasMeshScaling, this._canvasMesh.position = this._originalCanvasMeshPosition;
    const e = this.getMeshHierarchyCenter(this._mesh), t = this.getMeshHierarchyCenter(this._canvasMesh), r = e.subtract(t);
    r.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(r);
  }
  setupMeshSide() {
    if (this._meshSide = null, this._coordinatesIndex = 0, this._zkModel && this._mesh && this._mesh.id)
      for (let r = 0; r < this._zkModel.get("scenes").length; r++) {
        var e = this._zkModel.get("scenes").at(r);
        if (e.get("isDefault"))
          for (let o = 0; o < e.get("meshSides").length; o++) {
            var t = e.get("meshSides").at(o);
            if (t.get("meshID") == this._mesh.id) {
              this._meshSide = t, this._meshSide.get("uvChannel") >= 0 && (this._coordinatesIndex = this._meshSide.get("uvChannel"));
              return;
            }
          }
      }
  }
  setupTextureSize() {
    this._meshSide && (!kf && !If ? (this._baseWidth = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionWidth() ?? ms.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionHeight() ?? ms.DEFAULT_SIZE) : kf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getMobileTextureResolutionWidth() ?? ms.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getMobileTextureResolutionHeight() ?? ms.DEFAULT_SIZE) : If && (this._baseWidth = 512, this._baseHeight = 512)), console.log("Texture size: " + this._baseWidth + "x" + this._baseHeight);
  }
  checkDefaultEffect() {
    if (!this._effect && this._meshSide) {
      var e = this._meshSide.getParentModel();
      if (e && e instanceof MPlaza.ModelScene) {
        let t = this.getMeshID();
        if (t) {
          let r = e.getDefaultDesignEffect(t, this.getSubMeshIdx());
          r && (this._effect = r);
        }
      }
    }
  }
  getAllSides() {
    const e = [];
    return this._zkModel.get("colors").each((t) => {
      t.get("sides").each((r) => {
        e.find((o) => o.get("sideID") == r.get("sideID")) || e.push(r);
      });
    }), e;
  }
  // Recupera il lato del modello corrispondente alla mesh in input
  // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
  // in base agli elementi del design, considerando buono il primo colore con elementi grafici
  refreshModelSide() {
    if (this._side = null, this._meshSide && this._zkDesign) {
      const e = this._meshSide.get("sideID"), t = this._meshSide.tempID;
      let r = null;
      if (r = this.getAllSides().find(function(o) {
        return o.get("sideID") == e;
      }) || null, r) {
        let o = null;
        for (const a of this._zkDesign.get("designItems").models)
          if (o = a, o.isOnSide(r)) {
            const u = o && o.get("areas").length > 0 ? o.get("areas").at(0).get("colorID") : null;
            u && this._zkModel.get("colors").each(function(f) {
              f.get("colorID") == u && f.get("sides").each(function(v) {
                (v.tempID ? v.tempID == t : v.get("sideID") == e) && (r = v);
              });
            });
            break;
          }
        this._side = r;
      }
    }
  }
  async setupClonedObjectsAsync() {
    if (this._side) {
      for (var e = 0; e < this._scene.meshes.length; e++) {
        let t = this._scene.meshes[e];
        if (t && t.metadata && t.metadata.originalMeshID && t.metadata.originalMeshID == this._mesh.id) {
          this._canvasMesh = t, this._canvasMesh.isVisible = this._currentVisibliity, this._normalmapMaterial = this._mesh.material, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
          break;
        }
      }
      if (!this._canvasMesh) {
        let t = this._mesh.name + " - clone";
        this._canvasMesh = this._mesh.clone(t, null), this._canvasMesh && (this._canvasMesh.id = Zakeke.generateUUID(), this._canvasMesh.isVisible = this._currentVisibliity, this._canvasMesh.doNotSerialize = !0, this._canvasMesh.isPickable = !1, this._canvasMesh.metadata = {}, this._canvasMesh.metadata.originalMeshID = this._mesh.id, this._canvasMesh.metadata.isRealMesh = !1, this._canvasMesh.metadata.iscanvasMesh = !0, this._mesh.metadata && this._mesh.metadata.AR !== void 0 && this._mesh.metadata.AR !== null && (this._canvasMesh.metadata.AR = this._mesh.metadata.AR));
      }
      this._canvasMesh && (this._originalCanvasMeshPosition = this._canvasMesh.position, this._originalCanvasMeshScaling = this._canvasMesh.scaling), this._normalmapMaterial || await this.setupNormalmapMaterialAsync();
    }
  }
  // Prepara il materiale per la normalmap da applicare alla mesh originale
  // posizionata sotto quella su cui è apposto il design.
  // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
  // quindi il nome andrebbe cambiato
  async setupNormalmapMaterialAsync() {
    this.disposeNormalmapMaterial(), this._originalMaterial = this._mesh.material;
    let e = Zakeke.generateUUID(), t = "normalmapMaterial - " + e;
    this._originalMaterial ? (t = this._originalMaterial.name + " - normalmap", this._normalmapMaterial = await this.cloneMaterialAsync(this._originalMaterial, t)) : this._normalmapMaterial = new BABYLON.StandardMaterial(t, this._scene), this._normalmapMaterial && (this._normalmapMaterial.id = e, this._normalmapMaterial.doNotSerialize = !0, this._normalmapMaterial.metadata = {}, this._originalMaterial ? this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id : this._normalmapMaterial.metadata.originalMaterialID = null, this._normalmapMaterial.metadata.isRealMaterial = !1, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial));
  }
  // private getOriginalTexture(): BABYLON.Texture | null {
  //     if (this._originalMaterial) {
  //         var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
  //         if (!this._originalMaterial[propertyName])
  //             return null;
  //         return this._originalMaterial[propertyName];
  //     }
  //     return null;
  // }
  getMaterialDiffuseTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "baseTexture" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? "albedoTexture" : "diffuseTexture";
  }
  getMaterialOpacityTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "opacityTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? null : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "opacityTexture");
  }
  getMaterialNormalmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "bumpTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "normalTexture" : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "bumpTexture");
  }
  getMaterialLightmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "ambientTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "occlusionTexture" : e instanceof BABYLON.PBRMaterial ? "ambientTexture" : e instanceof Zakeke.PBRMaterial ? "aoTexture" : "lightmapTexture";
  }
  getMaterialDiffuse(e) {
    let t = this.getMaterialDiffuseTexturePropertyName(e);
    return e[t];
  }
  getMaterialNormalmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialNormalmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialLightmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialLightmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialOpacity(e) {
    if (!e)
      return null;
    let t = this.getMaterialOpacityTexturePropertyName(e);
    return t ? e[t] : null;
  }
  setMaterialLightmap(e, t) {
    if (e) {
      var r = this.getMaterialLightmapTexturePropertyName(e);
      r && (e[r] = t, e instanceof Zakeke.PBRMaterial && (e.useAOTextureAsLightmap = !0));
    }
  }
  setTextureWrapping(e) {
    e && (e.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, e.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
  }
  async setupCanvasAsync() {
    if (this._side && this._canvasMesh && this._meshSide && !this._isRefreshing) {
      this._isRefreshing = !0;
      var e = this._baseWidth;
      this._meshSide.get("percWidth") > 0 && (e *= this._meshSide.get("percWidth"));
      var t = this._baseHeight;
      this._meshSide.get("percHeight") > 0 && (t *= this._meshSide.get("percHeight")), this._textureWidth = e, this._textureHeight = t;
      var r = $("<canvas>", { id: this._canvasID }).attr({ width: e, height: t });
      this._canvas = r[0], this._context = this._canvas.getContext("2d"), this._context && (this._context.imageSmoothingQuality = "high", this._context.imageSmoothingEnabled = !0, this._customizer = new MPlaza.Customizer(!0, !1, this._canvas, !0), this._blankDataUrl = this._canvas.toDataURL(), this._customizer.showSideImage = !1, this._customizer.model = this._zkModel, this._customizer.fitToScreenMargin = this._zkScene.getFitToScreenMargin(), this._customizer.setGrids(this._grids), this._customizer.setDesign(this._zkDesign), await new Promise(async (o) => {
        var a, u;
        await ((a = this._customizer) == null ? void 0 : a.setSide(this._side)), (u = this._customizer) == null || u.refresh({ boundsToAreas: !0 }, async () => {
          if (this._customizer) {
            if (this._meshSide) {
              let f = this._meshSide.get("matrix");
              if (f) {
                const v = JSON.parse(f);
                let S = new this._customizer.paper.Matrix(v);
                this._customizer.paper.view.matrix = S, this._customizer.paper.view.update();
              }
            }
            await this.updateDynamicTextureAsync(), this._customizer.addItemCreatedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addItemChangedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addItemRemovedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addImageLoadedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            });
          }
          o();
        });
      }));
    }
    this._isRefreshing = !1;
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._customizer) == null || t.setGrids(e);
  }
  // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
  restoreOrignalMaterial() {
    this._mesh && this._originalMaterial && this._mesh.material && this._normalmapMaterial && this._mesh.material.id === this._normalmapMaterial.id && (this._mesh.material = this._originalMaterial);
  }
  getMeshesUsingMaterial(e) {
    for (var t = [], r = this._scene.meshes, o = 0; o < r.length; o++) {
      var a = r[o];
      if (a.material) {
        if (a.material.id == e)
          t.push(a);
        else if (a.material instanceof BABYLON.MultiMaterial)
          for (var u = 0; u < a.material.subMaterials.length; u++) {
            let f = a.material.subMaterials[u];
            if (f != null && f.id === e) {
              t.push(a);
              break;
            }
          }
      }
    }
    return t;
  }
  async checkNormalmapMaterialAsync() {
    this._mesh && this._normalmapMaterial && (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id) && await this.setupNormalmapMaterialAsync();
  }
  // Se il materiale associato alla mesh è cambiato lo ricrea
  async checkDynamicMaterialAsync() {
    let e = this.getMaterialIDForDesign();
    e && this._side && this._canvasMesh && this._meshSide && this._dynamicMaterial && this._dynamicMaterial.id != e && await this.setupDynamicMaterialAsync();
  }
  async setupDynamicMaterialAsync() {
    if (this._side && this._canvasMesh && this._meshSide) {
      this._ownOldDynamicMaterial = this._ownDynamicMaterial, this._oldDynamicMaterial = this._dynamicMaterial;
      var e = this.getMaterialIDForDesign();
      if (e) {
        this._zkScene.get("rootUrl") && await this._sceneHelper.loadDelayedMaterialAsync(this._zkScene.get("rootUrl"), e);
        let t = this._scene.getMaterialById(e);
        t && (this._dynamicMaterial = await this.cloneMaterialAsync(t, t.name + " - clone"), this._ownDynamicMaterial = !0);
      }
      if (!this._dynamicMaterial) {
        if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
          const t = new BABYLON.PBRMaterial(
            "dynamicMaterial",
            this._scene
          );
          t.enableSpecularAntiAliasing = !0, t.backFaceCulling = !1, t.albedoColor = BABYLON.Color3.White(), t.reflectivityColor = BABYLON.Color3.Black(), t.transparencyMode = this._zkScene.getDefaultDesignMaterialTransparencyMode(), t.useAlphaFromAlbedoTexture = !0, this._mesh.material.subSurface.indexOfRefraction != null && (t.subSurface.indexOfRefraction = this._mesh.material.subSurface.indexOfRefraction), $o(this._mesh.material) && this._mesh.material.roughness != null && (t.roughness = this._mesh.material.roughness), $o(this._mesh.material) && this._mesh.material.metallic != null && (t.metallic = this._mesh.material.metallic), $o(this._mesh.material) && this._mesh.material.reflectionTexture != null && (t.reflectionTexture = this._mesh.material.reflectionTexture), $o(this._mesh.material) && this._mesh.material.microSurface != null && (t.microSurface = this._mesh.material.microSurface), this._dynamicMaterial = t;
        } else
          this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene), this._dynamicMaterial.backFaceCulling = !1, this._dynamicMaterial.specularColor = BABYLON.Color3.Black(), this._dynamicMaterial.ambientColor = BABYLON.Color3.White(), this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
        this._dynamicMaterial.id = Zakeke.generateUUID(), this._ownDynamicMaterial = !0;
      }
      this._dynamicMaterial.zOffset = -1, this._dynamicMaterial.metadata = { isRealMaterial: !1 }, this._dynamicMaterial.doNotSerialize = this._ownDynamicMaterial, this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial), this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial), this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);
    }
  }
  /*
      private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
          return new Promise<void>((resolve, reject) => {
  
              let t = setInterval(() => {
                  if (texture.isReady()) {
                      clearInterval(t);
                      if (texture instanceof BABYLON.ProceduralTexture)
                          texture.getEffect();
                      resolve();
                  }
              }, 5);
  
          });
      }
      */
  async cloneMaterialAsync(e, t) {
    if (e) {
      var r = e.getActiveTextures();
      r.forEach(async (a) => {
        await yi.whenTextureIsReadyAsync(a);
      });
      var o = t || e.name + " - clone";
      if (e instanceof BABYLON.ShaderMaterial) {
        const a = this._zkScene.get("rootUrl");
        if (!a)
          return null;
        let u = e.serialize();
        return BABYLON.Material.Parse(u, this._scene, a);
      } else
        return e.clone(o);
    }
    return null;
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    let t = e.getHierarchyBoundingVectors(!0), r = t.max.subtract(t.min);
    return t.min.add(r.scale(0.5));
  }
  async refreshAsync(e) {
    this._isRefreshing || (this._isRefreshing = !0, typeof e < "u" && (this._effect = e), await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync(), this.refreshModelSide(), await new Promise(async (t) => {
      var r, o, a;
      if (this._meshSide && this.side && this._customizer) {
        if (await ((r = this._customizer) == null ? void 0 : r.setSide(this.side)), await ((o = this._customizer) == null ? void 0 : o.updateGrids()), (a = this._customizer) == null || a.adaptZoomToSideAreas(!1), this._meshSide && this._customizer) {
          let u = this._meshSide.get("matrix");
          if (u) {
            const f = JSON.parse(u);
            let v = new this._customizer.paper.Matrix(f);
            if (this._customizer.paper.view.matrix = v, this._customizer.paper.view.rotation += -this._viewRotation, this._textureWidth !== 1024) {
              const S = 1024 / this._textureWidth;
              let I = new paper.Matrix();
              I = I.scale(1 / S, 1 / S);
              const D = v.prepend(I);
              this._customizer.paper.view.matrix = D;
            }
          } else
            this._customizer.paper.view.rotation = -this._viewRotation;
          this._customizer.paper.view.update();
        }
        await this.updateDynamicTextureAsync(), t();
      } else
        t();
    }), this._isRefreshing = !1);
  }
  async updateDynamicTextureAsync() {
    if (this.isFirstRender) {
      console.log("First render..."), await this.updateDynamicTextureInternalAsync(), this.isFirstRender = !1;
      return;
    }
    this._debouncedUpdateDynamicTexture || (this._debouncedUpdateDynamicTexture = Th(this.updateDynamicTextureInternalAsync, 10)), this._debouncedUpdateDynamicTexture();
  }
  async updateDynamicTextureInternalAsync(e = !0) {
    if (Logger.info("updateDynamicTextureInternal"), !this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)
      return;
    const t = this.getDesignConfig(), r = this._lastUpdateTextureWasDynamic != e;
    this._lastUpdateTextureWasDynamic = e, await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync();
    let o = t.getDiffuseEnabled(), a = t.getDiffuseBlendMode(), u = t.getDiffuseLevel();
    a !== "normal" && a !== "multiply" && a !== "overlay" && (a = "normal");
    const f = t.getOpacityEnabled();
    t.getOrCreateOpacityConfig();
    const v = t.getNormalmapEnabled(), S = t.getOrCreateNormalmapConfig(), I = t.getInnerShadowEnabled(), D = t.getOrCreateInnerShadowConfig(), Z = t.getOuterShadowEnabled(), M = t.getOrCreateOuterShadowConfig();
    let X = "diffuseTexture";
    const Y = this._meshSide.get("materialTexture");
    Y ? X = Y : X = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
    let ie = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial), G = this._dynamicTexture;
    r && G && (G.dispose(), this._dynamicTexture = null);
    let te = this._canvas.toDataURL(), J = te == this._blankDataUrl, he = this.dataURItoBlob(te), K = (window.URL || window.webkitURL).createObjectURL(he);
    this._dynamicTexture || (e ? (this._dynamicTexture = new BABYLON.DynamicTexture("dynamicTexture", this._canvas, this._scene), this._dynamicTexture.hasAlpha = !0) : (this._dynamicTexture = new BABYLON.Texture(K, this._scene), this._dynamicTexture.hasAlpha = !0)), e ? this._dynamicTexture.update() : await yi.whenTextureIsReadyAsync(this._dynamicTexture), !J && this._dynamicTexture && (v && await this.updateNormalmapTextureAsync(S), I && await this.updateInnerShadowTextureAsync(D), Z && await this.updateOuterShadowTextureAsync(M), f && await this.updateOpacityTextureAsync(), this._originalDiffuseTexture && o && a !== "normal" && await this.combineDiffuseTexturesAsync(a, u), this._showDesign && (o && X && (a === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture ? (this._dynamicTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicTexture), this._dynamicMaterial[X] = this._dynamicTexture) : this._combinedDiffuseTexture && (this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._combinedDiffuseTexture), this._dynamicMaterial[X] = this._combinedDiffuseTexture), this._dynamicMaterial[X].hasAlpha = !1, this._dynamicMaterial[X].hasAlpha = !0), !o && X && !this.compareTextures(
      this._dynamicMaterial[X],
      this._originalDiffuseTexture
    ) && (this._dynamicMaterial[X] = this._originalDiffuseTexture), f && ie && this._dynamicOpacityTexture && (this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicOpacityTexture), this._dynamicMaterial instanceof BABYLON.ShaderMaterial ? this._dynamicMaterial.setTexture(
      ie,
      this._dynamicOpacityTexture
    ) : this._dynamicMaterial[ie] = this._dynamicOpacityTexture), !f && ie && (this._dynamicMaterial[ie] = null), this._canvasMesh.material !== this._dynamicMaterial && (this._canvasMesh.material = this._dynamicMaterial), v && this._normalmapTexture ? await this.setNormalmapTextureAsync(S) : (this.resetMeshNormalmapTexture(), this.resetDesignNormalmapTexture()), I && this._innerShadowTexture ? await this.setInnerShadowTextureAsync(D) : this.removeInnerShadowTexture(), Z && this._outerShadowTexture ? await this.setOuterShadowTextureAsync(M) : this.removeOuterShadowTexture(), this.disposeOldDynamicMaterial(), this._canvasMesh.isVisible = this._currentVisibliity && t.getShowDesign())), J && (this._canvasMesh.isVisible = !1), this.fireRenderingNeededEvent();
  }
  resetDynamicTextures() {
    if (this._dynamicMaterial) {
      let e = "diffuseTexture";
      const t = this._meshSide ? this._meshSide.get("materialTexture") : null;
      t ? e = t : e = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial), e && !this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDiffuseTexture
      ) && (this._dynamicMaterial[e] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene), this._dynamicMaterial[e].hasAlpha = !1, this._dynamicMaterial[e].hasAlpha = !0), this.resetDesignNormalmapTexture();
      let r = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
      r && (this._dynamicMaterial[r] = null), this.removeInnerShadowTexture();
    }
    this._normalmapMaterial && (this.resetMeshNormalmapTexture(), this.removeOuterShadowTexture());
  }
  async updateOpacityTextureAsync() {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._dynamicOpacityTexture || (this._dynamicOpacityTexture = new oo(
      "dynamicOpacity",
      this._textureWidth,
      this._scene,
      this._dynamicTexture
    ), this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0), this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1), this._dynamicOpacityTexture.refreshRate = 0, this._dynamicOpacityTexture.getAlphaFromRGB = !0), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.baseTexture = this._dynamicTexture, await yi.whenTextureIsReadyAsync(this._dynamicOpacityTexture), this._dynamicOpacityTexture.render()));
  }
  async combineDiffuseTexturesAsync(e, t) {
    if (!this._originalDiffuseTexture || !this._dynamicTexture)
      return;
    await yi.whenTextureIsReadyAsync(this._originalDiffuseTexture), await yi.whenTextureIsReadyAsync(this._dynamicTexture);
    const r = t === 0 ? this._dynamicTexture : this._originalDiffuseTexture, o = t === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
    this._combinedDiffuseTexture || (e == "multiply" ? this._combinedDiffuseTexture = new eo(
      "multiplyDiffuse",
      this._textureWidth,
      this._scene,
      r,
      o
    ) : this._combinedDiffuseTexture = new al(
      "overlayDiffuse",
      this._textureWidth,
      this._scene,
      r,
      o
    ), this._combinedDiffuseTexture.refreshRate = 0), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.baseTexture = r, this._combinedDiffuseTexture.blendTexture = o, await yi.whenTextureIsReadyAsync(this._combinedDiffuseTexture), this._combinedDiffuseTexture.render());
  }
  // NORMAL MAP
  async updateNormalmapTextureAsync(e) {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._proceduralNormalMap || (this._proceduralNormalMap = new Vx(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    )), this._normalmapTexture = await this._proceduralNormalMap.getNormalMapTextureAsync(
      this._dynamicTexture,
      e
    ), this._normalmapTexture && (this._normalmapTexture.coordinatesIndex = this._coordinatesIndex));
  }
  // Aggiorna i materiali con la normalmapTexture
  // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
  // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
  // che le texture siano pronte
  async setNormalmapTextureAsync(e) {
    var o;
    let t = this._normalmapTexture, r = this._normalmapTexture;
    if (e.get("showOnMesh") && this._originalMeshNormalmapTexture && this._normalmapTexture && (await this.combineMeshNormalmapTexturesAsync(), this._meshCombinedNormalmapTexture && (t = this._meshCombinedNormalmapTexture)), e.get("showOnDesign") && this._originalDesignNormalmapTexture && this._normalmapTexture && (await this.combineDesignNormalmapTexturesAsync(), this._designCombinedNormalmapTexture && (r = this._designCombinedNormalmapTexture)), this._normalmapMaterial && t) {
      t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t);
      const a = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      e.get("showOnMesh") ? this._normalmapMaterial[a] = t : this.resetMeshNormalmapTexture(), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial, this._mesh.metadata || (this._mesh.metadata = {}), this._mesh.metadata.originalNormalmapMaterialID = (o = this._originalMaterial) == null ? void 0 : o.id);
    }
    if (this._dynamicMaterial && r) {
      r.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(r);
      const a = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      e.get("showOnDesign") ? this._dynamicMaterial[a] = r : this.resetDesignNormalmapTexture();
    }
  }
  async combineMeshNormalmapTexturesAsync() {
    !this._originalMeshNormalmapTexture || !this._normalmapTexture || (await yi.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture), await yi.whenTextureIsReadyAsync(this._normalmapTexture), this._meshCombinedNormalmapTexture || (this._meshCombinedNormalmapTexture = new al(
      "overlayMeshNormal",
      this._textureWidth,
      this._scene,
      this._originalMeshNormalmapTexture,
      this._normalmapTexture
    ), this._meshCombinedNormalmapTexture.refreshRate = 0), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture, this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await yi.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture), this._meshCombinedNormalmapTexture.render()));
  }
  resetMeshNormalmapTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      this.compareTextures(
        this._normalmapMaterial[e],
        this._originalMeshNormalmapTexture
      ) || (this._originalMeshNormalmapTexture ? this._normalmapMaterial[e] = this._originalMeshNormalmapTexture : this._normalmapMaterial[e] = null);
    }
  }
  resetDesignNormalmapTexture() {
    if (this._dynamicMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDesignNormalmapTexture
      ) || (this._originalDesignNormalmapTexture ? this._dynamicMaterial[e] = this._originalDesignNormalmapTexture : this._dynamicMaterial[e] = null);
    }
  }
  async combineDesignNormalmapTexturesAsync() {
    !this._originalDesignNormalmapTexture || !this._normalmapTexture || (await yi.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture), await yi.whenTextureIsReadyAsync(this._normalmapTexture), this._designCombinedNormalmapTexture || (this._designCombinedNormalmapTexture = new al(
      "overlayDesignNormal",
      this._textureWidth,
      this._scene,
      this._originalDesignNormalmapTexture,
      this._normalmapTexture
    ), this._designCombinedNormalmapTexture.refreshRate = 0), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture, this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await yi.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture), this._designCombinedNormalmapTexture.render()));
  }
  // INNER SHADOW
  async updateInnerShadowTextureAsync(e) {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._innerShadowGenerator ? await this._innerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._innerShadowGenerator = new Hx(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._innerShadowTexture = await this._innerShadowGenerator.getInnerShadowTextureAsync(
      this._dynamicTexture
    ), this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setInnerShadowTextureAsync(e) {
    let t = this._innerShadowTexture;
    this._originalDesignLightmapTexture && this._innerShadowTexture && (await this.combineDesignLightmapTexturesAsync(), this._designCombinedLightmapTexture && (t = this._designCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._dynamicMaterial, t));
  }
  async combineDesignLightmapTexturesAsync() {
    !this._originalDesignLightmapTexture || !this._innerShadowTexture || (await yi.whenTextureIsReadyAsync(this._originalDesignLightmapTexture), await yi.whenTextureIsReadyAsync(this._innerShadowTexture), this._designCombinedLightmapTexture || (this._designCombinedLightmapTexture = new eo(
      "overlayDesignLightmaps",
      this._textureWidth,
      this._scene,
      this._originalDesignLightmapTexture,
      this._innerShadowTexture
    ), this._designCombinedLightmapTexture.refreshRate = 0), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture, this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture, await yi.whenTextureIsReadyAsync(this._designCombinedLightmapTexture), this._designCombinedLightmapTexture.render()));
  }
  removeInnerShadowTexture() {
    if (this._dynamicMaterial) {
      let e = this.getMaterialLightmap(this._dynamicMaterial), t = this._originalDesignLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._dynamicMaterial, t);
    }
  }
  // OUTER SHADOW
  async updateOuterShadowTextureAsync(e) {
    this._dynamicTexture && (await yi.whenTextureIsReadyAsync(this._dynamicTexture), this._outerShadowGenerator ? await this._outerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._outerShadowGenerator = new Yx(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._outerShadowTexture = await this._outerShadowGenerator.getOuterShadowTextureAsync(
      this._dynamicTexture
    ), this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setOuterShadowTextureAsync(e) {
    let t = this._outerShadowTexture;
    this._originalMeshLightmapTexture && this._outerShadowTexture && (await this.combineMeshLightmapTexturesAsync(), this._meshCombinedLightmapTexture && (t = this._meshCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._normalmapMaterial, t), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial));
  }
  async combineMeshLightmapTexturesAsync() {
    !this._originalMeshLightmapTexture || !this._outerShadowTexture || this._isDisposed || (await yi.whenTextureIsReadyAsync(this._originalMeshLightmapTexture), await yi.whenTextureIsReadyAsync(this._outerShadowTexture), this._meshCombinedLightmapTexture || (this._meshCombinedLightmapTexture = new eo(
      "overlayMeshLightmap",
      this._textureWidth,
      this._scene,
      this._originalMeshLightmapTexture,
      this._outerShadowTexture
    ), this._meshCombinedLightmapTexture.refreshRate = 0), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture, this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture, await yi.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture), this._meshCombinedLightmapTexture.render()));
  }
  removeOuterShadowTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialLightmap(this._normalmapMaterial), t = this._originalMeshLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._normalmapMaterial, t);
    }
  }
  compareTextures(e, t) {
    return typeof e > "u" && typeof t > "u" || e === null && t === null ? !0 : !e || !t ? !1 : e === t;
  }
  dataURItoBlob(e) {
    let t = atob(e.split(",")[1]), r = e.split(",")[0].split(":")[1].split(";")[0], o = new ArrayBuffer(t.length), a = new Uint8Array(o);
    for (let f = 0; f < t.length; f++)
      a[f] = t.charCodeAt(f);
    return new Blob([o], { type: r });
  }
  downloadImage(e, t) {
    let r = this.dataURItoBlob(e), o = window.URL.createObjectURL(r), a = t || "image.png", u = document.createElement("a");
    u.download = a, u.innerHTML = "Download File", u.href = o, u.onclick = (f) => {
      document.body.removeChild(u);
    }, u.style.display = "none", u.setAttribute("type", "hidden"), document.body.appendChild(u), u.click();
  }
  setDesignMeshVisibility(e) {
    this._currentVisibliity = e, this._canvasMesh && (this._canvasMesh.isVisible = e);
  }
  getItemsInfo() {
    return this._customizer ? this._customizer.getItemsInfo() : [];
  }
  removeItem(e) {
    this._customizer && this._customizer.removeItemByGuid(e);
  }
  addItemText(e) {
    this._customizer && this._customizer.addTextElement(null, e, !1);
  }
  setItemText(e, t) {
    this._customizer && this._customizer.modifyTextElementContentByGuid(e, t);
  }
  setItemBold(e, t) {
    if (this._customizer) {
      let r = this._customizer.findItemByGuid(e);
      if (r) {
        let a = this._customizer.getTextItemInfo(r).fontWeight.split(" "), u = [a.length > 1 ? a[0] : "normal"];
        u.push(t ? "bold" : "normal"), this._customizer.modifyTextElementFontWeight(r, u.join(" "));
      }
    }
  }
  setItemItalic(e, t) {
    if (this._customizer) {
      let r = this._customizer.findItemByGuid(e);
      if (r) {
        let a = this._customizer.getTextItemInfo(r).fontWeight.split(" "), u = [t ? "italic" : "normal"];
        u.push(a.length > 1 ? a[1] : a[0]), this._customizer.modifyTextElementFontWeight(r, u.join(" "));
      }
    }
  }
  setItemColor(e, t) {
    this._customizer && this._customizer.modifyTextElementFillColorByGuid(e, t);
  }
  setItemFontFamily(e, t) {
    this._customizer && this._customizer.modifyTextElementFontFamilyByGuid(e, t);
  }
  async addItemImage(e) {
    this._customizer && await this._customizer.insertImageById(e);
  }
  async setItemImage(e, t) {
    this._customizer && await this._customizer.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t) {
    if (this._customizer) {
      let r = this._customizer.findItemByGuid(e);
      t ? this._customizer.convertToTextOnPath(r) : this._customizer.convertToTextArea(r);
    }
  }
  removeItemImage(e) {
    this._customizer && this._customizer.removeImageByGuid(e);
  }
  containsItem(e) {
    if (this._customizer) {
      const t = this._customizer.findItemByGuid(e);
      return t != null && t != null;
    }
    return !1;
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  addNotifyMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let r = Th(
        (o, a, u, f, v, S, I, D, Z) => {
          e(
            t.side.getSideID(),
            o,
            a,
            u,
            f,
            v,
            D.requiredWidth,
            D.requiredHeight,
            Z
          );
        },
        50
      );
      t.addNotifyMessageListeners(r);
    }
  }
  addRemoveMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let r = Th((o) => {
        e(t.side.getSideID(), o);
      }, 50);
      t.addRemoveMessageListeners(r);
    }
  }
  setEventMessages(e) {
    this._customizer && this._customizer.setCustomizedMessages(e);
  }
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t) {
    if (this._meshSide && this._customizer) {
      let u = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
      var r = JSON.parse(u), o = this._customizer.getTranslatedMatrixValues(r, e, t), a = JSON.stringify(o);
      this._meshSide.set("matrix", a);
    }
  }
  rotateDesignView(e, t, r) {
    if (this._meshSide && this._customizer) {
      var o = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), a = JSON.parse(o), u = this._customizer.getRotatedMatrixValues(a, e, t, r), f = JSON.stringify(u);
      this._meshSide.set("matrix", f);
    }
  }
  scaleDesignView(e, t, r, o) {
    if (this._meshSide && this._customizer) {
      var a = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), u = JSON.parse(a), f = this._customizer.getScaledMatrixValues(u, e, t, r, o), v = JSON.stringify(f);
      this._meshSide.set("matrix", v);
    }
  }
  async setDesignViewTextureUVChannelAsync(e) {
    this._meshSide && (this._meshSide.set("uvChannel", e), await this.updateDynamicTextureAsync());
  }
  async setDesignViewFormFactorAsync(e, t) {
    this._meshSide && (this._meshSide.set("percWidth", e), this._meshSide.set("percHeight", t), await this.refreshAsync());
  }
  async changeToDynamicTexture() {
    await this.updateDynamicTextureInternalAsync(!0);
  }
  async changeToRasterizedTexture() {
    await this.updateDynamicTextureInternalAsync(!1);
  }
};
Ud.DEFAULT_SIZE = 1024;
let Vd = Ud;
class Gx {
  constructor(e, t, r, o, a = !0) {
    this._rotation = 0, this._grids = [], this._meshDesignManagers = [], this._renderingNeededListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._meshDesignManagersRefreshing = /* @__PURE__ */ new Set(), this._scene = e, this._zkScene = t, this._zkModel = r, this._zkDesign = o, this._showDesign = a, this.init();
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e, this._meshDesignManagers.forEach((t) => t.showDesign = e));
  }
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation != e && (this._rotation = e, this._meshDesignManagers.forEach((t) => t.rotation = e));
  }
  dispose() {
    this._meshDesignManagers.forEach((e) => e.dispose());
  }
  init() {
  }
  isForModels(e, t, r) {
    return this._scene == e && this._zkModel == t && this._zkDesign == r;
  }
  getDefaultModelScene() {
    if (this._zkModel) {
      let e = this._zkModel.get("scenes").findWhere({ isDefault: !0 });
      if (e)
        return e;
    }
    return null;
  }
  getModelSceneMeshSide(e, t = 0) {
    if (this._scene && this._zkModel) {
      const r = this.getDefaultModelScene();
      if (r)
        for (let o = 0; o < r.get("meshSides").length; o++) {
          let a = r.get("meshSides").at(o);
          if (a.get("meshID") == e && a.get("subMeshID") == t)
            return a;
        }
    }
    return null;
  }
  async refreshAsync() {
    if (this._scene && this._zkModel && this._zkDesign) {
      const e = this.getDefaultModelScene();
      if (e) {
        let t = null, r = null, o = null;
        for (let a = 0; a < this._meshDesignManagers.length; a++) {
          t = this._meshDesignManagers[a];
          let u = !1;
          for (let v = 0; v < e.get("meshSides").length; v++)
            if (o = e.get("meshSides").at(v), o.get("meshID") == t.getMeshID() && o.get("subMeshID") == t.getSubMeshIdx()) {
              u = !0;
              break;
            }
          let f = !0;
          if (u) {
            let v = t.getMeshID();
            v && (r = this._scene.getMeshByID(v), r && (f = r.isVisible));
          }
          (!u || !f) && (t.dispose(), this._meshDesignManagers.splice(a--, 1));
        }
        for (let a = 0; a < e.get("meshSides").length; a++) {
          o = e.get("meshSides").at(a);
          const u = o.get("meshID"), f = o.get("subMeshID");
          u && await this.refreshMeshDesignAsync(u, f);
        }
      }
    }
  }
  isValidEffectForMesh(e, t, r) {
    if (r && r instanceof MPlaza.ModelSceneMeshDesignEffect) {
      const o = r.getParentModel();
      if (o && o instanceof MPlaza.ModelScene)
        return o.isEffectForMesh(e, t, r.get("effectID"));
    }
    return !1;
  }
  async refreshMeshDesignAsync(e, t = 0, r) {
    const o = this._scene.getMeshByID(e);
    console.log("Refreshing design manager", this._rotation);
    let a = r;
    if (r && !this.isValidEffectForMesh(e, t, r) && (a = void 0), o && o.isVisible) {
      let u = null;
      o.subMeshes && o.subMeshes.length > 0 && t >= 0 && t < o.subMeshes.length && (u = o.subMeshes[t]);
      let f = this.getMeshDesignMananger(o, u);
      if (f)
        f.showDesign = this._showDesign, f.rotation = this._rotation, await f.refreshAsync(a);
      else {
        f = await Vd.createMeshDesignManagerAsync(
          this._scene,
          this._zkScene,
          o,
          u,
          this._zkModel,
          this._zkDesign,
          this._grids,
          this._showDesign,
          a,
          this.rotation
        ), f.addRenderingNeededListener(() => this.fireRenderingNeededEvent()), f.setEventMessages(this._designEventMessages);
        for (let v of this._designNotifyMessageListeners)
          f.addNotifyMessageListener(v);
        for (let v of this._designRemoveMessageListeners)
          f.addRemoveMessageListener(v);
        this._meshDesignManagers.push(f);
      }
    }
  }
  getMeshDesignMananger(e, t) {
    for (let r = 0; r < this._meshDesignManagers.length; r++) {
      const o = this._meshDesignManagers[r];
      if (o.isForMesh(e, t))
        return o;
    }
    return null;
  }
  clearMeshDesignManagers() {
    this._meshDesignManagers = [];
  }
  setCustomizerGrids(e) {
    this._grids = e, this._meshDesignManagers.forEach((t) => t.setCustomizerGrids(e));
  }
  getItemsInfo() {
    let e = [];
    for (let t = 0; t < this._meshDesignManagers.length; t++) {
      const o = this._meshDesignManagers[t].getItemsInfo();
      for (let a = 0; a < o.length; a++) {
        const u = o[a];
        let f = !1;
        for (let v = 0; v < e.length; v++)
          if (e[v].itemGuid == u.itemGuid) {
            f = !0;
            break;
          }
        f || e.push(u);
      }
    }
    return e;
  }
  async execOnMeshManagersContainingItem(e, t) {
    for (const r of this._meshDesignManagers)
      r.containsItem(e) && await t(r);
  }
  removeItem(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItem(e));
  }
  addItemText(e, t) {
    let r = this._meshDesignManagers.find((o) => o.side != null && o.side.get("sideID") === t);
    r && r.addItemText(e);
  }
  async addItemImage(e, t) {
    let r = this._meshDesignManagers.find((o) => o.side != null && o.side.get("sideID") === t);
    r && await r.addItemImage(e);
  }
  setItemText(e, t) {
    this.execOnMeshManagersContainingItem(e, async (r) => r.setItemText(e, t));
  }
  setItemItalic(e, t) {
    this.execOnMeshManagersContainingItem(e, async (r) => r.setItemItalic(e, t));
  }
  setItemBold(e, t) {
    this.execOnMeshManagersContainingItem(e, async (r) => r.setItemBold(e, t));
  }
  setItemColor(e, t) {
    this.execOnMeshManagersContainingItem(e, async (r) => r.setItemColor(e, t));
  }
  setItemFontFamily(e, t) {
    this.execOnMeshManagersContainingItem(e, async (r) => r.setItemFontFamily(e, t));
  }
  async setItemImage(e, t) {
    await this.execOnMeshManagersContainingItem(e, async (r) => r.setItemImage(e, t));
  }
  setItemTextOnPath(e, t, r) {
    const o = this._meshDesignManagers.find(
      (a) => a.side != null && a.side.get("sideID") === t
    );
    o && o.setItemTextOnPath(e, r);
  }
  removeItemImage(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItemImage(e));
  }
  setDesignVisibility(e, t) {
    const r = this._scene.getMeshByID(e);
    if (r) {
      const o = this.getMeshDesignMananger(r, r.subMeshes.length > 0 ? r.subMeshes[0] : null);
      o && o.setDesignMeshVisibility(t);
    }
  }
  getDesignItemsJson() {
    let e = "";
    for (let t = 0; t < this._zkDesign.get("designItems").length; t++)
      e && (e += `
`), e += this._zkDesign.get("designItems").at(t).get("json");
    return e;
  }
  getDesignID() {
    return this._zkDesign.getDesignID();
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e;
    for (let t of this._meshDesignManagers)
      t.setEventMessages(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, r, o) {
    const a = this.getMeshDesignMananger(e, t);
    a && a.translateDesignView(r, o);
  }
  rotateDesignView(e, t, r, o, a) {
    const u = this.getMeshDesignMananger(e, t);
    u && u.rotateDesignView(r, o, a);
  }
  scaleDesignView(e, t, r, o, a, u) {
    const f = this.getMeshDesignMananger(e, t);
    f && f.scaleDesignView(r, o, a, u);
  }
  async setDesignViewTextureUVChannelAsync(e, t, r) {
    const o = this.getMeshDesignMananger(e, t);
    o && await o.setDesignViewTextureUVChannelAsync(r);
  }
  async setDesignViewFormFactorAsync(e, t, r, o) {
    const a = this.getMeshDesignMananger(e, t);
    a && await a.setDesignViewFormFactorAsync(r, o);
  }
  // -------------------------------------------------------------
  // Mesh - Side connection
  // -------------------------------------------------------------
  async connectMeshToModelSideAsync(e, t, r) {
    let o = this.getModelSceneMeshSide(e, t);
    if (!o && this._scene && this._zkModel) {
      let a = this._scene.getMeshByID(e);
      if (a && a.subMeshes && a.subMeshes.length > 0 && t >= 0 && t < a.subMeshes.length) {
        a.subMeshes[t];
        let u = this.getDefaultModelScene();
        u && (o = new MPlaza.ModelSceneMeshSide(), o.set("meshID", e), o.set("subMeshID", t), o.set("sideID", r), u.get("meshSides").add(o), await this.refreshAsync());
      }
    }
  }
  expandCanvasMeshes(e) {
    console.log("expandRatio ", e), this._meshDesignManagers.forEach((t) => t.expandCanvasMesh(e));
  }
  contractCanvasMeshes() {
    this._meshDesignManagers.forEach((e) => e.contractCanvasMesh());
  }
  async changeToRasterizedTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToRasterizedTexture();
    console.log("All tasks for rasterized textures completed.");
  }
  async changeToDynamicTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToDynamicTexture();
    console.log("All dynamic textures changes completed.");
  }
}
const Zr = "base_model";
class i1 {
  constructor(e, t, r) {
    this._zkModel = e, this._zkScene = t, this._scene = r, this._sceneHelper = new yi(r);
  }
  /**
   * Replace the product model, used when discarding changes
   * @param newModel The new model to replace the current one
   */
  replaceModel(e) {
    this._zkModel = e;
  }
  getOrCreateMaterialsForVariant(e) {
    const t = this.getVariantMeshes(e), r = [];
    return t.forEach((o) => {
      const a = this._scene.getMeshById(o);
      a && a.getChildMeshes().forEach((u) => r.push(u));
    }), this.hasVariantCustomModel(e) ? this.getMaterialsForMeshes(r) : (this.getMaterialsForMeshes(r).forEach((a) => {
      this.isSceneMaterialForVariant(a) || this.setVariableMaterialID(a.id);
    }), this.getVariantMaterials(e));
  }
  // restituisce tutti materiali della scena per cui è possibile specificare se sono
  // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
  // tutti i materiali che sono stati già clonati per rappresentare la variazione.
  // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
  // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
  // e verranno esclusi tutti i materiali non assegnati a nessuna mesh.
  // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
  // o indirettamente)
  getPossibleVariableMaterials() {
    const e = this._sceneHelper.getAllMaterials(), t = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], a = this.getMeshesUsingMaterial(o.id), u = this.isSceneMaterialForVariant(o);
      a.length > 0 && !u && t.push(o);
    }
    return t;
  }
  // Restituisce l'elenco dei materiali della scena già selezionati come variabili
  getVariableMaterials() {
    const e = [], t = this._zkModel.getPreview3D();
    if (t) {
      const r = t.getVariantsAttributeOptions();
      if (r)
        for (let o = 0; o < r.get("variableMaterials").length; o++) {
          let a = r.get("variableMaterials").at(o).get("materialID"), u = this._scene.getMaterialById(a);
          u && e.push(u);
        }
    }
    return e;
  }
  getVariableMaterialsSelection() {
    const t = this.getVariableMaterials().map((a) => a.id);
    return this.getPossibleVariableMaterials().map((a) => ({
      id: a.id,
      name: a.name,
      selected: t.indexOf(a.id) != -1
    }));
  }
  getVariantMaterialsWithOriginal(e) {
    const t = [], r = this._zkModel.getPreview3D();
    if (r && e && e instanceof MPlaza.Color) {
      const o = this.getVariantID(e), a = r.getVariantsAttributeOptions();
      if (a) {
        const u = a.getVariantOption(o);
        if (u)
          for (let f = 0; f < u.get("materials").length; f++) {
            const v = u.get("materials").at(f), S = v.get("optionMaterialID"), I = this._scene.getMaterialById(S), D = v.get("variableMaterialID"), Z = this._scene.getMaterialById(D);
            I && Z && t.push({ material: I, variableMaterial: Z });
          }
      }
    }
    return t;
  }
  // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
  // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
  // Se un materiale non esiste, lo elimina tra i materiali variabili.
  updateVariableMaterials() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t) {
        const r = [], o = [];
        for (let a = 0; a < t.get("variableMaterials").length; a++) {
          const f = t.get("variableMaterials").at(a).get("materialID");
          this._scene.getMaterialById(f) ? r.push(f) : o.push(f);
        }
        r.forEach((a) => this.setVariableMaterialID(a)), o.forEach((a) => this.unsetVariableMaterialID(a));
      }
    }
  }
  // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
  // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
  unsetVariableMaterialID(e) {
    const t = this._zkModel.getPreview3D();
    if (t) {
      const r = t.getVariantsAttributeOptions();
      if (r) {
        const o = this._zkModel.getAttributeByGuid(r.get("attributeGuid")), a = r.get("variableMaterials").getVariableMaterial(e);
        if (a) {
          const f = this._scene.getMaterialById(e);
          if (f)
            for (let v = 0; v < a.get("meshes").length; v++) {
              const S = this._scene.getMeshById(a.get("meshes")[v]);
              S && this._sceneHelper.applyMaterial(f, S);
            }
        }
        r.removeVariableMaterial(e);
        const u = [];
        for (let f = 0; f < r.get("variantOptions").length; f++) {
          const v = r.get("variantOptions").at(f);
          let S = null;
          o && (S = o.getOptionByGuid(v.get("optionGuid")));
          const I = [];
          for (let D = 0; D < v.get("materials").length; D++) {
            const Z = v.get("materials").at(D);
            if (Z.get("variableMaterialID") === e) {
              for (let M = 0; M < Z.get("actions").length; M++) {
                const X = Z.get("actions").at(M);
                if (S) {
                  const Y = S.get("actions").getActionByGuid(X.get("actionGuid"));
                  Y && S.get("actions").remove(Y);
                }
              }
              this.deleteSceneMaterial(Z.get("optionMaterialID")), I.push(Z);
            }
          }
          v.get("materials").remove(I), v.get("materials").length === 0 && u.push(v);
        }
        for (let f = 0; f < u.length; f++)
          this.removeVariantOption(r, u[f]);
      }
    }
  }
  // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
  // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
  setVariableMaterialID(e) {
    const t = this._scene.getMaterialById(e);
    if (t) {
      const r = this.getMeshesUsingMaterial(t.id), o = r.map((v) => v.id), u = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions();
      u.setVariableMaterial(e, o);
      const f = [];
      for (let v = 0; v < this._zkModel.get("colors").length; v++) {
        const S = this._zkModel.get("colors").at(v), I = this.getVariantID(S);
        f.push(I), this.checkVariantOption(u, t, r, S);
      }
      for (let v = 0; v < u.get("variantOptions").length; v++) {
        const S = u.get("variantOptions").at(v);
        f.indexOf(S.get("variantID")) === -1 && this.removeVariantOption(u, S);
      }
    }
  }
  getVariantAttribute() {
    const e = this._zkModel.getPreview3D();
    if (!e)
      return null;
    const t = e.getVariantsAttributeOptions();
    if (!t)
      return null;
    let r = null;
    return t.get("attributeGuid") && (r = this._zkModel.getAttributeByGuid(t.get("attributeGuid"))), r || (r = this._zkModel.get("attributes").getAttributeByCode("variants_attribute")), r;
  }
  checkVariantOption(e, t, r, o) {
    const a = this.getVariantID(o);
    let u = e.get("variantOptions").getVariantOption(a);
    u || (u = this.createVariantOption(e, o)), this.checkVariantOptionMaterial(e, u, t, r, o);
  }
  createVariantOption(e, t) {
    const r = this.getVariantID(t), o = this.getOrCreateVariantAttribute(e), a = this.getOrCreateVariantAttributeOption(e, t, o), u = new MPlaza.VariantOption();
    return u.set("variantID", r), u.set("optionGuid", a.get("optionGuid")), e.get("variantOptions").push(u), u;
  }
  removeVariantOption(e, t) {
    const r = this._zkModel.getAttributeByGuid(e.get("attributeGuid"));
    if (r) {
      const o = r.getOptionByGuid(t.get("optionGuid"));
      o && r.get("options").remove(o);
    }
    for (let o = 0; o < t.get("materials").length; o++) {
      const u = t.get("materials").at(o).get("optionMaterialID");
      this.deleteSceneMaterial(u);
    }
    e.get("variantOptions").remove(t);
  }
  getOrCreateVariantAttribute(e) {
    let t = this.getVariantAttribute();
    if (!t) {
      for (let r = 0; r < e.get("variantOptions").length; r++)
        this.removeVariantOption(
          e,
          e.get("variantOptions").at(r)
        );
      t = new MPlaza.Attribute(), t.set("attributeGuid", MPlaza.generateUUID()), t.set("name", "Variants attribute"), t.set("attributeCode", "variants_attribute"), t.set("attributeTypeID", MPlaza.AttributeType.Options), this._zkModel.get("attributes").push(t);
    }
    return e.set("attributeGuid", t.get("attributeGuid")), t;
  }
  getOrCreateVariantAttributeOption(e, t, r) {
    const o = this.getVariantID(t);
    let a = r.getOptionByCode(o);
    return a || (a = new MPlaza.AttributeOption(), a.set("optionCode", o), a.set("name", t.get("name")), r.get("options").push(a)), a;
  }
  getVariantID(e) {
    return `${e.getModelID()}_${e.getColorID()}`;
  }
  checkVariantOptionMaterial(e, t, r, o, a) {
    const u = this.getVariantID(a);
    let f = null;
    for (let v = 0; v < t.get("materials").length; v++) {
      const S = t.get("materials").at(v);
      if (S.get("variableMaterialID") === r.id) {
        f = S;
        break;
      }
    }
    if (!f) {
      let v = this.getSceneMaterialForVariant(u, r.id);
      if (!v) {
        const S = `${r.name} - ${a.get("name")}`;
        v = this.cloneSceneMaterial(r.id, void 0, S), v && this.setupSceneMaterialForVariant(v, u, r.id);
      }
      v && (f = new MPlaza.VariantOptionMaterial(), f.set("optionMaterialID", v.id), f.set("variableMaterialID", r.id), t.get("materials").push(f));
    }
    f && this.checkVariantOptionActions(
      e,
      t,
      f,
      r,
      o,
      a
    );
  }
  // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
  // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
  setupSceneMaterialForVariant(e, t, r) {
    const o = this.getOrCreateSceneMaterialMetadata(e.id);
    o.isForPreview = !0, o.autoCreate = !0, o.variantID = t, o.variableMaterialID = r;
  }
  getSceneMaterialForVariant(e, t) {
    const r = this._sceneHelper.getAllMaterials();
    for (let o = 0; o < r.length; o++) {
      const a = r[o], u = this.getSceneMaterialMetadata(a.id);
      if (u && u.isForPreview && u.variantID === e && u.variableMaterialID === t)
        return r[o];
    }
    return null;
  }
  isSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return t && t.isForPreview;
  }
  canDeleteSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return !t || t.isForPreview === void 0 || t.isForPreview === null || t.autoCreate === void 0 || t.autoCreate === null ? !0 : t.isForPreview && t.autoCreate;
  }
  getSceneMaterialMetadata(e) {
    return this._sceneHelper.getSceneMaterialMetadata(e);
  }
  getOrCreateSceneMaterialMetadata(e) {
    return this._sceneHelper.getOrCreateSceneMaterialMetadata(e);
  }
  removeSceneMaterialMetadata(e) {
    this._sceneHelper.removeSceneMaterialMetadata(e);
  }
  // Clona un materiale
  cloneSceneMaterial(e, t, r) {
    let o = this._scene.getMaterialById(e), a = null;
    if (o) {
      const u = r || `${o.name} - clone`;
      if (a = o.clone(u), a) {
        const f = t || MPlaza.generateUUID();
        a.id = f;
        const v = this._zkScene.getMappingForSceneMaterial(o.id);
        if (v) {
          const S = v.get("libraryMaterialID");
          this._zkScene.mapLibraryMaterial(S, a.id);
          const I = this._sceneHelper.getTexturesForMaterial(a), D = this._sceneHelper.getTexturesForMaterial(a);
          for (let Z = 0; Z < D.length; Z++) {
            const M = D[Z], X = I[Z];
            M.materialMapping = X.materialMapping;
          }
        }
      }
    }
    return a;
  }
  deleteSceneMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    if (t && this.canDeleteSceneMaterialForVariant(t)) {
      this.removeSceneMaterialMetadata(e);
      const r = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e);
      r && this._zkScene.unregisterShaderMaterial(r), this._zkScene.removeMappingForSceneMaterial(t.id);
      const o = this._sceneHelper.getTexturesExclusivelyForMaterial(t);
      t.dispose();
      for (let a = 0; a < o.length; a++)
        o[a].dispose();
    }
  }
  checkVariantOptionActions(e, t, r, o, a, u) {
    let f = [];
    a.forEach((D) => f.push(D.id));
    let v = this.getOrCreateVariantAttribute(e), S = this.getOrCreateVariantAttributeOption(e, u, v);
    for (let D = 0; D < a.length; D++) {
      let Z = a[D], M = r.get("actions").getActionForMesh(Z.id);
      if (!M) {
        let X = new MPlaza.AttributeSceneAction();
        X.set("name", ""), X.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial), X.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), X.set("selector", Z.id), X.set("value", r.get("optionMaterialID")), S.get("actions").push(X), M = new MPlaza.VariantOptionMaterialAction(), M.set("actionGuid", X.get("actionGuid")), M.set("meshID", Z.id), r.get("actions").push(M);
      }
    }
    let I = [];
    for (let D = 0; D < r.get("actions").length; D++) {
      let Z = r.get("actions").at(D);
      if (f.indexOf(Z.get("meshID")) === -1) {
        let M = S.getActionByGuid(Z.get("actionGuid"));
        M && S.get("actions").remove(M), I.push(Z);
      }
    }
    r.get("actions").remove(I);
  }
  isMaterialReal(e) {
    var o, a;
    const t = ((o = e.metadata) == null ? void 0 : o.isRealMaterial) !== !1 && e.id !== "default material", r = ((a = e.metadata) == null ? void 0 : a.isDesignMaterial) === !0;
    return t && !r;
  }
  getVariantMaterials(e) {
    let t = [];
    const r = this._zkModel.getPreview3D();
    if (r && e && e instanceof MPlaza.Color) {
      const o = this.getVariantID(e), a = r.getVariantsAttributeOptions();
      if (a) {
        const u = a.getVariantOption(o);
        if (u)
          for (let f = 0; f < u.get("materials").length; f++) {
            const S = u.get("materials").at(f).get("optionMaterialID"), I = this._scene.getMaterialById(S);
            I && this.isMaterialReal(I) && t.push(I);
          }
      }
    }
    return t;
  }
  getSelectedAttributeOption(e) {
    let t = {
      attributeID: null,
      attributeGuid: null,
      optionID: null,
      optionGuid: null
    };
    const r = this._zkModel.getPreview3D();
    if (r && e && e instanceof MPlaza.Color) {
      const o = this.getVariantID(e), a = r.getVariantsAttributeOptions();
      if (a && a.get("attributeGuid")) {
        const u = this._zkModel.getAttributeByGuid(a.get("attributeGuid"));
        if (u) {
          const f = a.getVariantOption(o);
          if (f) {
            const v = u.getOptionByGuid(f.get("optionGuid"));
            v && (t.attributeID = u.get("attributeID"), t.attributeGuid = u.get("attributeGuid"), t.optionID = v.get("optionID"), t.optionGuid = v.get("optionGuid"));
          }
        }
      }
    }
    return t;
  }
  resetOriginaMaterialsOnMeshes() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t)
        for (let r = 0; r < t.get("variableMaterials").length; r++) {
          const o = t.get("variableMaterials").at(r), a = o.get("materialID"), u = o.get("meshes"), f = this._scene.getMaterialByID(a);
          if (f)
            for (let v = 0; v < u.length; v++) {
              const S = this._scene.getMeshById(o.get("meshes")[v]);
              S && this._sceneHelper.applyMaterial(f, S);
            }
        }
    }
  }
  // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
  // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
  getMeshesUsingMaterial(e) {
    const t = [], r = this._sceneHelper.getSceneMeshes();
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      if (this._sceneHelper.isMeshUsingMaterial(a, e))
        t.push(a);
      else {
        const u = this._sceneHelper.getMeshMaterials(a);
        for (let f = 0; f < u.length; f++) {
          const v = u[f], S = this.getSceneMaterialMetadata(v.id);
          if (S && S.isForPreview && S.variableMaterialID && S.variableMaterialID === e) {
            t.push(a);
            break;
          }
        }
      }
    }
    return t;
  }
  getMaterialsForMeshes(e) {
    const t = e.map((o) => typeof o == "string" ? this._scene.getMeshById(o) : o), r = [];
    for (let o = 0; o < t.length; o++) {
      const a = t[o];
      if (a) {
        const u = this._sceneHelper.getMeshMaterials(a);
        for (let f = 0; f < u.length; f++) {
          const v = u[f];
          r.indexOf(v) === -1 && this.isMaterialReal(v) && r.push(v);
        }
      }
    }
    return r;
  }
  // Restituisce l'elenco delle mesh associate ad una variante
  // Se la variante non ha mesh associate, restituisce le mesh base
  getVariantMeshes(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return [Zr];
    const r = t == null ? void 0 : t.getVariantsAttributeOptions();
    if (!r)
      return [Zr];
    const o = this.getVariantID(e), a = r.get("variantOptions").getVariantOption(o);
    if (!a)
      return [Zr];
    const u = a.get("meshes");
    return u.length > 0 ? u : [Zr];
  }
  /**
   * Given a mesh, returns the variant it is associated with.
   * If the mesh is not associated with any variant, it returns null, which would be the base mesh.
   * It is used for AR, to know which variant was used for the measurement.
   * @param meshID The ID of the mesh to get the variant for.
   * @returns The variant associated with the mesh, or null if the mesh is not associated with any variant.
   */
  getVariantByMeshID(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return null;
    const r = t.getVariantsAttributeOptions();
    if (!r)
      return null;
    for (let o = 0; o < this._zkModel.get("colors").length; o++) {
      const a = this._zkModel.get("colors").at(o), u = this.getVariantID(a), f = r.getVariantOption(u);
      if (f && f.get("meshes").indexOf(e) !== -1)
        return a;
    }
    return null;
  }
  /**
   * Check if a variant has custom meshes associated with it.
   * @param modelColor  The color of the variant to check.
   * @returns True if the variant has custom meshes, false otherwise.
   */
  hasVariantCustomModel(e) {
    const t = this.getVariantMeshes(e);
    return !(t.length === 1 && t[0] === Zr);
  }
  /**
   * Set the meshes associated with a variant.
   * @param modelColor The color of the variant to set meshes for.
   * @param meshIDs The list of mesh IDs to set as variant meshes.
   */
  setVariantMeshes(e, t) {
    const o = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), a = this.getVariantID(e);
    let u = o.get("variantOptions").getVariantOption(a);
    u || (u = this.createVariantOption(o, e)), u.set("meshes", t), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Remove all meshes associated with a variant.
   * @param modelColor The color of the variant to remove meshes from.
   */
  removeVariantMeshes(e) {
    const r = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), o = this.getVariantID(e);
    let a = r.get("variantOptions").getVariantOption(o);
    if (a) {
      const u = a.get("meshes");
      for (const f of u) {
        const v = this._scene.getMeshById(f);
        v == null || v.dispose(!1, !0);
      }
      a.set("meshes", []);
    }
    this.updateVariableMaterials(), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Set the current base meshes for the scene.
   * @param meshIDs The list of mesh IDs to set as base meshes.
   */
  setBaseMeshes(e) {
    let t = this._scene.getMeshById(Zr);
    t || (t = new BABYLON.Mesh(Zr, this._scene), t.id = Zr);
    for (const r of e) {
      const o = this._scene.getMeshById(r);
      o && o.setParent(t);
    }
  }
  /**
   * Remove current base meshes from the scene.
   */
  removeBaseMeshes() {
    const e = this._scene.getMeshById(Zr);
    if (e) {
      const t = e.getChildMeshes(!0);
      for (const r of t)
        r.setParent(null);
    }
  }
  /**
   * Upgrade an old preview 3D scene to the new base mesh system.
   */
  upgradeToBaseMeshes() {
    this._scene.getMeshById(Zr) !== null || this.setBaseMeshes(
      this._scene.meshes.filter((t) => !t.parent && t.id !== Zr).map((t) => t.id) ?? []
    );
  }
  /**
   * This method will create or update all options by setting the correct show/hide actions
   * to show the base model or the variant model.
   */
  refreshOptionsShowHideVariantModels() {
    const t = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), r = this.getOrCreateVariantAttribute(t);
    for (let o = 0; o < this._zkModel.get("colors").length; o++) {
      const a = this._zkModel.get("colors").at(o), u = this.getVariantID(a);
      let f = t.get("variantOptions").getVariantOption(u);
      f || (f = this.createVariantOption(t, a));
      const v = this.getOrCreateVariantAttributeOption(t, a, r);
      let S = v.get("actions").find(
        (I) => I.get("selector") === "*" && I.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh
      );
      S || (S = new MPlaza.AttributeSceneAction(), S.set("name", ""), S.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), S.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), S.set("selector", "*"), S.set("value", "hide"), v.get("actions").push(S));
      for (let I = 0; I < v.get("actions").length; I++) {
        const D = v.get("actions").at(I);
        D.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && D.get("selector") !== "*" && (v.get("actions").remove(D), I--);
      }
      if ((f == null ? void 0 : f.get("meshes").length) === 0) {
        const I = new MPlaza.AttributeSceneAction();
        I.set("name", ""), I.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), I.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), I.set("selector", Zr), I.set("value", "show"), v.get("actions").push(I);
      } else
        for (const I of f.get("meshes")) {
          const D = new MPlaza.AttributeSceneAction();
          D.set("name", ""), D.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), D.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), D.set("selector", I), D.set("value", "show"), v.get("actions").push(D);
        }
    }
  }
  // Design materials
  setDesignMaterialForVariantEnabled(e, t) {
    var f;
    const r = this.hasVariantCustomModel(e) ? e.get("colorID") : null, o = this._zkModel.get("scenes").at(0).get("meshSides").filter((v) => v.get("colorID") === r), a = (f = o.at(0)) == null ? void 0 : f.get("materialID");
    let u = a ? this._scene.getMaterialById(a) : null;
    t || (o.forEach((v) => {
      v.set("materialID", null);
    }), u && (o.some(
      (S) => S.get("materialID") === u.id
    ) || u.dispose())), t && !u && (u = new BABYLON.PBRMaterial("Design material", this._scene), u.id = Zakeke.generateUUID(), u.zOffset = -1, u.metallic = 0.5, u.roughness = 0.2, o.forEach((v) => {
      v.set("materialID", u.id);
    }));
  }
  getDesignMaterialForVariant(e) {
    const t = this.hasVariantCustomModel(e) ? e.get("colorID") : null, r = this._zkModel.get("scenes").at(0).get("meshSides").find((a) => a.get("colorID") === t), o = r ? r.get("materialID") : null;
    return o ? this._scene.getMaterialById(o) : null;
  }
}
function Hd(y) {
  return typeof importScripts == "function" ? (importScripts(y), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(y, () => {
      e();
    }, (r) => {
      t(new Error(r));
    });
  });
}
function jx(y) {
  return new Promise((e, t) => {
    BABYLON.Tools.LoadFile(y, (r) => {
      e(r);
    }, void 0, void 0, !0, (r, o) => {
      t(o);
    });
  });
}
function Uh(y, e, t) {
  const r = e && y || t;
  if (r)
    return Hd(r).then(() => new Promise((o) => {
      DracoDecoderModule({ wasmBinary: e }).then((a) => {
        o({ module: a });
      });
    }));
}
function Vh(y, e, t, r, o) {
  const a = new y.DecoderBuffer();
  a.Init(e, e.byteLength);
  const u = new y.Decoder();
  let f, v;
  try {
    const I = u.GetEncodedGeometryType(a);
    switch (I) {
      case y.TRIANGULAR_MESH:
        f = new y.Mesh(), v = u.DecodeBufferToMesh(a, f);
        break;
      case y.POINT_CLOUD:
        f = new y.PointCloud(), v = u.DecodeBufferToPointCloud(a, f);
        break;
      default:
        throw new Error(`Invalid geometry type ${I}`);
    }
    if (!v.ok() || !f.ptr)
      throw new Error(v.error_msg());
    const D = f.num_points();
    if (I === y.TRIANGULAR_MESH) {
      const M = f.num_faces(), X = new y.DracoInt32Array();
      try {
        const Y = new Uint32Array(M * 3);
        for (let ie = 0; ie < M; ie++) {
          u.GetFaceFromMesh(f, ie, X);
          const G = ie * 3;
          Y[G + 0] = X.GetValue(0), Y[G + 1] = X.GetValue(1), Y[G + 2] = X.GetValue(2);
        }
        r(Y);
      } finally {
        y.destroy(X);
      }
    }
    const Z = (M, X) => {
      const Y = new y.DracoFloat32Array();
      try {
        u.GetAttributeFloatForAllPoints(f, X, Y);
        const ie = new Float32Array(D * X.num_components());
        for (let G = 0; G < ie.length; G++)
          ie[G] = Y.GetValue(G);
        o(M, ie);
      } finally {
        y.destroy(Y);
      }
    };
    if (t)
      for (const M in t) {
        const X = t[M], Y = u.GetAttributeByUniqueId(f, X);
        Z(M, Y);
      }
    else {
      const M = {
        position: "POSITION",
        normal: "NORMAL",
        color: "COLOR",
        uv: "TEX_COORD",
        uv2: "TEX_COORD",
        uv3: "TEX_COORD",
        uv4: "TEX_COORD",
        uv5: "TEX_COORD",
        uv6: "TEX_COORD"
      }, X = /^uv(\d+)$/;
      for (const Y in M) {
        const ie = Y.match(X);
        let G = -1;
        if (ie && ie.length > 1) {
          var S = parseInt(ie[1], 10);
          const te = u.GetAttributeId(f, y.TEX_COORD);
          te !== -1 && (G = te + S - 1);
        } else
          G = u.GetAttributeId(f, y[M[Y]]);
        if (G !== -1) {
          const te = u.GetAttributeByUniqueId(f, G);
          te && te.size() > 0 && Z(Y, te);
        }
      }
    }
  } finally {
    f && y.destroy(f), y.destroy(u), y.destroy(a);
  }
}
function Wx() {
  let y;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const r = t.decoder;
        y = Uh(r.wasmUrl, r.wasmBinary, r.fallbackUrl), postMessage("done");
        break;
      }
      case "decodeMesh": {
        if (!y)
          throw new Error("Draco decoder module is not available");
        y.then((r) => {
          Vh(r.module, t.dataView, t.attributes, (o) => {
            postMessage({ id: "indices", value: o }, [o.buffer]);
          }, (o, a) => {
            postMessage({ id: o, value: a }, [a.buffer]);
          }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Lh(y) {
  return typeof document != "object" || typeof y != "string" ? y : BABYLON.Tools.GetAbsoluteUrl(y);
}
const ho = class Ys {
  /**
   * Returns true if the decoder configuration is available.
   */
  static get DecoderAvailable() {
    const e = Ys.Configuration.decoder;
    return !!(e.wasmUrl && e.wasmBinaryUrl && typeof WebAssembly == "object" || e.fallbackUrl);
  }
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return Ys._Default || (Ys._Default = new Ys()), Ys._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e = Ys.DefaultNumWorkers) {
    const t = Ys.Configuration.decoder, r = t.wasmUrl && t.wasmBinaryUrl && typeof WebAssembly == "object" ? jx(Lh(t.wasmBinaryUrl)) : Promise.resolve(void 0);
    e && typeof Worker == "function" ? this._workerPoolPromise = r.then((o) => {
      const a = `${Hd}${Uh}${Vh}(${Wx})()`, u = URL.createObjectURL(new Blob([a], { type: "application/javascript" })), f = new Array(e);
      for (let v = 0; v < f.length; v++)
        f[v] = new Promise((S, I) => {
          const D = new Worker(u), Z = (X) => {
            D.removeEventListener("error", Z), D.removeEventListener("message", M), I(X);
          }, M = (X) => {
            X.data === "done" && (D.removeEventListener("error", Z), D.removeEventListener("message", M), S(D));
          };
          D.addEventListener("error", Z), D.addEventListener("message", M), D.postMessage({
            id: "init",
            decoder: {
              wasmUrl: Lh(t.wasmUrl),
              wasmBinary: o,
              fallbackUrl: Lh(t.fallbackUrl)
            }
          });
        });
      return Promise.all(f).then((v) => new du(v));
    }) : this._decoderModulePromise = r.then((o) => Uh(t.wasmUrl, o, t.fallbackUrl));
  }
  /**
   * Stop all async operations and release resources.
   */
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : this._decoderModulePromise ? this._decoderModulePromise.then(() => {
    }) : Promise.resolve();
  }
  /**
    * Decode Draco compressed mesh data to vertex data.
    * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
    * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
    * @returns A promise that resolves with the decoded vertex data
    */
  decodeMeshAsync(e, t) {
    const r = e instanceof ArrayBuffer ? new Uint8Array(e) : e;
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((o) => new Promise((a, u) => {
        o.push((f, v) => {
          const S = new BABYLON.VertexData(), I = (M) => {
            f.removeEventListener("error", I), f.removeEventListener("message", D), u(M), v();
          }, D = (M) => {
            M.data === "done" ? (f.removeEventListener("error", I), f.removeEventListener("message", D), a(S), v()) : M.data.id === "indices" ? S.indices = M.data.value : S.set(M.data.value, M.data.id);
          };
          f.addEventListener("error", I), f.addEventListener("message", D);
          const Z = new Uint8Array(r.byteLength);
          Z.set(new Uint8Array(r.buffer, r.byteOffset, r.byteLength)), f.postMessage({ id: "decodeMesh", dataView: Z, attributes: t }, [Z.buffer]);
        });
      }));
    if (this._decoderModulePromise)
      return this._decoderModulePromise.then((o) => {
        const a = new BABYLON.VertexData();
        return Vh(o.module, r, t, (u) => {
          a.indices = u;
        }, (u, f) => {
          a.set(f, u);
        }), a;
      });
    throw new Error("Draco decoder module is not available");
  }
};
ho.Configuration = {
  decoder: {
    //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
    //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
    //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
    /*
    wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
    wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
    fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
    */
    wasmUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
    wasmBinaryUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
    fallbackUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
  }
};
ho.DefaultNumWorkers = ho.GetDefaultNumWorkers();
ho._Default = null;
let Zx = ho;
class Yd {
  constructor(e, t, r = !1) {
    this._originalSceneClearColor = null, this._originalCameraAutoRotate = null, this._environmentHelper = null, this._shadowLight = null, this._isHologram = !1, this._zkScene = e, this._scene = t, this._sceneHelper = new yi(this._scene), this._isHologram = r;
  }
  get scene() {
    return this._scene;
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, this.update();
  }
  dispose() {
    this._shadowLight && this._shadowLight.dispose(), this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this.removeOldSkybox();
  }
  update() {
    this.configureScene(), this.configureCamera(), this.configureSkybox();
  }
  configureSkybox() {
    this.removeOldSkybox(), this._isHologram || this.createSkybox();
  }
  removeOldSkybox() {
    const e = this.getSkyboxMesh(), t = this.getSkyboxMaterial();
    e && e.dispose(), t && t.dispose();
  }
  createSkybox() {
    var r, o;
    this.getGeneralConfig();
    const e = this.getEnvironmentConfig(), t = this.getSkyboxConfig();
    if (t && t.get("createSkybox") != null && t.get("createSkybox")) {
      e && e.get("sizeAuto") != null && e.get("sizeAuto") != null && typeof e.get("sizeAuto") == "boolean" && e.get("sizeAuto");
      let a = null;
      t.get("size") != null && typeof t.get("size") == "number" && (a = t.get("size"));
      let u = null;
      t.get("texture") != null && typeof t.get("texture") == "string" && (u = t.get("texture"));
      let f = 0;
      t.get("blur") > 0 && (f = t.get("blur"));
      let v = null;
      t.get("extensions") != null && t.get("extensions") != null && Object.prototype.toString.call(t.get("extensions")) === "[object Array]" && ((r = t.get("extensions")) == null ? void 0 : r.length) === 6 && (v = t.get("extensions"));
      let S = null;
      if (t.get("files") != null && t.get("files") != null && Object.prototype.toString.call(t.get("files")) === "[object Array]" && ((o = t.get("files")) == null ? void 0 : o.length) === 6 && (S = t.get("files")), u) {
        let I = null;
        if (u.endsWith(".dds") ? I = BABYLON.CubeTexture.CreateFromPrefilteredData(u, this._scene) : u.endsWith(".hdr") ? I = new BABYLON.HDRCubeTexture(u, this._scene, 256, !1, !0, !1, !0) : u.endsWith(".env") ? I = new BABYLON.CubeTexture(
          u,
          this._scene,
          null,
          !1,
          null,
          void 0,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : u.endsWith(".basis") ? I = BABYLON.CubeTexture.CreateFromPrefilteredData(u, this._scene) : v && S ? I = new BABYLON.CubeTexture(u, this._scene, v, !1, S, void 0) : I = BABYLON.CubeTexture.CreateFromPrefilteredData(u, this._scene), I) {
          let D = 1e3;
          a != null && a > 0 ? D = a : D = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
          const Z = this._scene.createDefaultSkybox(I, !0, D, f, !1);
          if (Z) {
            Z.metadata = { isSkyboxMesh: !0, isRealMesh: !1 }, Z.doNotSerialize = !0;
            const M = Z.material;
            M && (M.metadata = { isSkyboxMaterial: !0, isRealMaterial: !1 }, M.doNotSerialize = !0);
          }
        }
      }
    }
  }
  getSkyboxMesh() {
    return this._scene.meshes.find((t) => t.metadata && t.metadata.isSkyboxMesh) || null;
  }
  getSkyboxMaterial() {
    let e = this._scene.materials.find((t) => t.metadata && t.metadata.isSkyboxMaterial);
    return e || null;
  }
  getSkyboxTexture() {
    const e = this.getSkyboxMaterial();
    return e ? e.reflectionTexture : null;
  }
  update_OLD() {
    this.configureScene(), this.configureCamera(), this.configureEnvironment();
  }
  configureScene() {
    if (this._scene) {
      if (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._originalSceneClearColor = this._scene.clearColor.clone(), this._isHologram) {
        this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
        return;
      }
      var e = this.getGeneralConfig();
      if (e) {
        let t = null;
        e.get("backgroundAlpha") != null && e.get("backgroundAlpha") != null && typeof e.get("backgroundAlpha") == "number" && (t = e.get("backgroundAlpha"));
        let r = null;
        if (e.get("backgroundColor") != null && typeof e.get("backgroundColor") == "string" && this.isValidHexColor(e.get("backgroundColor")) && (r = e.get("backgroundColor")), t || r) {
          this._originalSceneClearColor = this._scene.clearColor;
          let o = this._scene.clearColor;
          if (r != null) {
            let a = BABYLON.Color3.FromHexString(r);
            o.r = a.r, o.g = a.g, o.b = a.b;
          }
          t != null && (o.a = t);
        }
      }
    }
  }
  configureEnvironment() {
    if (this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._sceneHelper.countSceneMeshes() != 0) {
      var e = this.buildEnvironmentHelperOptions();
      if (e) {
        this._environmentHelper = this._scene.createDefaultEnvironment(e);
        const t = this.getEnvironmentSceneNodes();
        for (let r = 0; r < t.length; r++) {
          const o = t[r];
          o && (this.setDoNotSerialize(o), o.metadata || (o.metadata = {}), o.metadata.isEnvironmentNode = !0, o instanceof BABYLON.AbstractMesh && (o.isPickable = !1, o.metadata.isRealMesh = !1), o instanceof BABYLON.Material && (o.metadata.isRealMaterial = !1));
        }
      }
    }
  }
  buildEnvironmentHelperOptions() {
    let e = null;
    const t = this.getGeneralConfig(), r = this.getEnvironmentConfig(), o = this.getSkyboxConfig(), a = this.getGroundConfig(), u = this.getCameraConfig();
    let f = null;
    t && t.get("environmentTexture") != null && t.get("environmentTexture") != null && (f = t.get("environmentTexture"));
    let v = null;
    u && u.get("contrast") != null && typeof u.get("contrast") == "number" && (v = u.get("contrast"));
    let S = null;
    u && u.get("exposure") != null && typeof u.get("exposure") == "number" && (S = u.get("exposure"));
    let I = null;
    u && u.get("toneMappingEnabled") != null && typeof u.get("toneMappingEnabled") == "boolean" && (I = u.get("toneMappingEnabled"));
    let D = null;
    r && r.get("sizeAuto") != null && r.get("sizeAuto") != null && typeof r.get("sizeAuto") == "boolean" && (D = r.get("sizeAuto"));
    let Z = null;
    r && r.get("mainColor") != null && typeof r.get("mainColor") == "string" && this.isValidHexColor(r.get("mainColor")) && (Z = r.get("mainColor"));
    let M = null;
    a && a.get("size") != null && typeof a.get("size") == "number" && (M = a.get("size"));
    let X = null;
    a && a.get("color") != null && typeof a.get("color") == "string" && this.isValidHexColor(a.get("color")) && (X = a.get("color"));
    let Y = null;
    a && a.get("enableShadow") != null && typeof a.get("enableShadow") == "boolean" && (Y = a.get("enableShadow"));
    let ie = null;
    a && a.get("shadowLevel") != null && typeof a.get("shadowLevel") == "number" && (ie = a.get("shadowLevel"));
    let G = null;
    a && a.get("enableMirror") != null && typeof a.get("enableMirror") == "boolean" && (G = a.get("enableMirror"));
    let te = null;
    a && a.get("texture") != null && typeof a.get("texture") == "string" && (te = a.get("texture"));
    let J = null;
    a && a.get("opacity") != null && typeof a.get("opacity") == "number" && (J = a.get("opacity"));
    let he = null;
    a && a.get("mirrorBlurKernel") != null && typeof a.get("mirrorBlurKernel") == "number" && (he = a.get("mirrorBlurKernel"));
    let ve = null;
    o && o.get("size") != null && typeof o.get("size") == "number" && (ve = o.get("size"));
    let K = null;
    o && o.get("color") != null && typeof o.get("color") == "string" && this.isValidHexColor(o.get("color")) && (K = o.get("color"));
    let j = null;
    o && o.get("texture") != null && typeof o.get("texture") == "string" && (j = o.get("texture"));
    let We = f != null || v != null || S != null || I;
    return (o || a || We) && (e = e || {
      createSkybox: o && o.get("createSkybox"),
      createGround: a && a.get("createGround")
    }, e.setupImageProcessing = !1, f != null && (e.environmentTexture = f), (e.createSkybox || e.createGround) && (D != null && (e.sizeAuto = D), Z != null && (e.mainColor = BABYLON.Color3.FromHexString(Z)), e.createGround && (!e.sizeAuto && M != null && (e.groundSize = M), !e.mainColor && X != null && (e.groundColor = BABYLON.Color3.FromHexString(X)), Y != null && (e.enableGroundShadow = Y), e.enableGroundShadow && this.createShadowLight(), ie != null && (e.groundShadowLevel = ie), G != null && (e.enableGroundMirror = G), te != null && (e.groundTexture = te), J != null && (e.groundOpacity = J), e.enableGroundMirror && he != null && (e.groundMirrorBlurKernel = he)), e.createSkybox && (!e.sizeAuto && ve != null && (e.skyboxSize = ve), !e.mainColor && K != null && (e.skyboxColor = BABYLON.Color3.FromHexString(K)), j != null && (e.skyboxTexture = j)), u && (v != null && (e.cameraContrast = v), S != null && (e.cameraExposure = S), I != null && (e.toneMappingEnabled = I)))), e && (!e.environmentTexture && !this._scene.environmentTexture && (e.environmentTexture = li.Environment.EnvironmentTextureCDNUrl), e.createGround != null && e.createGround && !e.groundTexture && (e.groundTexture = li.Environment.GroundTextureCDNUrl), e.createSkybox != null && e.createSkybox && !e.skyboxTexture && (e.skyboxTexture = li.Environment.SkyboxTextureCDNUrl)), e;
  }
  createShadowLight() {
    if (this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._scene && this._sceneHelper) {
      var e = this._sceneHelper.getSceneBoundingInfo();
      if (e && e.boundingBox) {
        const r = e.boundingBox.vectorsWorld, o = Number(r[1].x - r[0].x), a = Number(r[1].y - r[0].y), u = Number(r[1].z - r[0].z), f = e.boundingBox.centerWorld;
        e.boundingBox.maximumWorld;
        const v = f.x + o * 2.67, S = f.y + a * 4.5, I = f.z + u * 1, D = new BABYLON.Vector3(v, S, I);
        let M = f.subtract(D);
        M = BABYLON.Vector3.Normalize(M), M = new BABYLON.Vector3(-2, -3, 1), this._shadowLight = new BABYLON.DirectionalLight("shadowLight", M, this._scene), this._shadowLight.position = D, this._shadowLight.intensity = 0.1;
        var t = new BABYLON.ShadowGenerator(512, this._shadowLight);
        t.useBlurExponentialShadowMap = !0, t.useKernelBlur = !0, t.usePercentageCloserFiltering = !0, t.blurKernel = 32;
        for (let X = 0; X < this._scene.meshes.length; X++) {
          const Y = this._scene.meshes[X];
          !this.isEnvironmentNode(Y) && this._sceneHelper.isRealMesh(Y) && (Y.receiveShadows = !1, t.addShadowCaster(Y));
        }
      }
    }
  }
  configureCamera() {
    if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera))
      return;
    const e = this.getCameraConfig();
    if (e) {
      const t = this._scene.activeCamera;
      this._originalCameraAutoRotate = t.useAutoRotationBehavior;
      let r = e.get("autoRotate");
      t.useAutoRotationBehavior = r != null && r;
      let o = t.getBehaviorByName("AutoRotation"), a = Number(e.get("rotationSpeed")), u = e.get("changeRotationDirection");
      if (r && a) {
        let f = u ? -1 : 1;
        o.idleRotationSpeed = a * f;
      }
    }
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  getSceneConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSceneConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGeneralConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGeneralConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getEnvironmentConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getEnvironmentConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getSkyboxConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSkyboxConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGroundConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGroundConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getCameraConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getCameraConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  isValidHexColor(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  }
  getEnvironmentSceneNodes() {
    const e = [];
    return this._environmentHelper && (this._environmentHelper.rootMesh && e.push(this._environmentHelper.rootMesh), this._environmentHelper.skybox && e.push(this._environmentHelper.skybox), this._environmentHelper.skyboxMaterial && e.push(this._environmentHelper.skyboxMaterial), this._environmentHelper.skyboxTexture && e.push(this._environmentHelper.skyboxTexture), this._environmentHelper.ground && e.push(this._environmentHelper.ground), this._environmentHelper.groundMaterial && e.push(this._environmentHelper.groundMaterial), this._environmentHelper.groundTexture && e.push(this._environmentHelper.groundTexture), this._environmentHelper.groundMirror && e.push(this._environmentHelper.groundMirror), this._shadowLight && e.push(this._shadowLight)), e;
  }
  isEnvironmentNode(e) {
    const t = this.getEnvironmentSceneNodes();
    for (let r = 0; r < t.length; r++)
      if (e == t[r])
        return !0;
    return !1;
  }
  setDoNotSerialize(e) {
    (e instanceof BABYLON.AbstractMesh || e instanceof BABYLON.Material || e instanceof BABYLON.Light) && (e.doNotSerialize = !0);
  }
  reset() {
    this._scene && (this._originalSceneClearColor && (this._scene.clearColor = this._originalSceneClearColor), this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera && (this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate), this._environmentHelper && this._environmentHelper.updateOptions({}));
  }
}
function Gd(y) {
  return typeof importScripts == "function" ? (importScripts(y), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(
      y,
      () => {
        e();
      },
      (r) => {
        t(new Error(r));
      }
    );
  });
}
function jd(y) {
  if (y.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < y.length; t++)
    e.push(Gd(y[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function Wd(y, e) {
  return y ? y.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function Zd(y, e, t) {
  let r = "scene_" + e + ".babylon", o = y;
  const a = [];
  if (o.length <= 5e6) {
    let f = !1;
    o.length > 180 && o.length <= 1e6 && (o = LZString.compressToUint8Array(o), r = "compressed_" + r, f = !0);
    let v = null;
    if (!f)
      v = new Blob([o], { type: "text/plain" });
    else {
      let S = o.buffer;
      v = new Blob([S]);
    }
    v && a.push({
      name: r,
      blob: v
    });
  } else {
    let f = Wd(o, 8e5);
    if (f)
      for (let v = 0; v < f.length; v++) {
        let S = f[v], I = r + "_part_" + v, D = !1;
        S.length > 180 && (S = LZString.compressToUint8Array(S), I = "compressed_" + I, D = !0);
        let Z = null;
        if (!D)
          Z = new Blob([S], { type: "text/plain" });
        else {
          var u = S.buffer;
          Z = new Blob([u]);
        }
        Z && a.push({
          name: I,
          blob: Z
        }), t(v / f.length * 100);
      }
  }
  return a;
}
function qx(y) {
  return typeof document != "object" || typeof y != "string" ? y : BABYLON.Tools.GetAbsoluteUrl(y);
}
function Xx() {
  let y;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const r = t.urls;
        y = jd(r), postMessage("done");
        break;
      }
      case "makeBlobs": {
        if (!y)
          throw new Error("Worker not initialized");
        y.then(() => {
          const r = t.json, o = t.version, a = Zd(r, o, (u) => {
            postMessage({ id: "progress", perc: u });
          });
          postMessage({ id: "result", blobInfos: a }), postMessage("done");
        });
        break;
      }
    }
  };
}
const pl = class xa {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return xa._Default || (xa._Default = new xa([])), xa._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e, t = xa.DefaultNumWorkers) {
    const r = e.map((o) => qx(o));
    if (t && typeof Worker == "function") {
      const o = `${Gd}${jd}${Wd}${Zd}(${Xx})()`, a = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), u = new Array(t);
      for (let f = 0; f < u.length; f++)
        u[f] = new Promise((v, S) => {
          const I = new Worker(a), D = (M) => {
            I.removeEventListener("error", D), I.removeEventListener("message", Z), S(M);
          }, Z = (M) => {
            M.data === "done" && (I.removeEventListener("error", D), I.removeEventListener("message", Z), v(I));
          };
          I.addEventListener("error", D), I.addEventListener("message", Z), I.postMessage({
            id: "init",
            urls: r
          });
        });
      this._workerPoolPromise = Promise.all(u).then((f) => new du(f));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getSceneBlobsAsync(e, t, r) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((o) => new Promise((a, u) => {
        o.push((f, v) => {
          let S = [];
          const I = (Z) => {
            f.removeEventListener("error", I), f.removeEventListener("message", D), u(Z), v();
          }, D = (Z) => {
            Z.data === "done" ? (f.removeEventListener("error", I), f.removeEventListener("message", D), a(S), v()) : Z.data.id === "progress" ? r(Z.data.perc) : Z.data.id === "result" && (S = Z.data.blobInfos);
          };
          f.addEventListener("error", I), f.addEventListener("message", D), f.postMessage({ id: "makeBlobs", json: e, version: t });
        });
      }));
    throw new Error("SceneToBlob worker is not available");
  }
};
pl.DefaultNumWorkers = pl.GetDefaultNumWorkers();
pl._Default = null;
let Kx = pl;
class Al {
  static openSceneViewer(e, t, r = !0, o = null) {
    if (this._fallbackInvoked)
      return;
    const a = self.location.toString(), u = new URL(a), f = new URL(e), v = new URLSearchParams(f.search);
    if (u.hash = this._noArViewerSigil, v.set("mode", "ar_preferred"), v.has("disable_occlusion") || v.set("disable_occlusion", "true"), r || v.set("resizable", "false"), o && o.toLowerCase() === "wall" && v.set("enable_vertical_placement", "true"), v.has("sound")) {
      const D = new URL(v.get("sound"), a);
      v.set("sound", D.toString());
    }
    if (v.has("link")) {
      const D = new URL(v.get("link"), a);
      v.set("link", D.toString());
    }
    const S = `intent://arvr.google.com/scene-viewer/1.0?${v.toString() + "&file=" + encodeURIComponent(
      f.toString()
    )}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(u.toString())};end;`;
    console.log(S);
    const I = () => {
      self.location.hash === this._noArViewerSigil && !this._fallbackInvoked && (this._fallbackInvoked = !0, t && t(), self.history.back());
    };
    self.addEventListener("hashchange", I, { once: !0 }), this._anchor.setAttribute("href", S), this._anchor.setAttribute("target", "_blank"), document.body.appendChild(this._anchor), this._anchor.click();
  }
}
Al._anchor = document.createElement("a");
Al._linkOrTitle = /(link|title)(=|&)|(\?|&)(link|title)$/;
Al._noArViewerSigil = "#model-viewer-no-ar-fallback";
Al._fallbackInvoked = !1;
class Jx {
  constructor(e, t, r) {
    this._meshesInfoPoints = {}, this._infoPoints = [], this._imageUrls = [], this._currentIdx = 0, this._imagePanel = null, this._loadingText = null, this._image = null, this._closeImageButton = null, this._moveNextImageButton = null, this._movePrevImageButton = null, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this._lastCameraPosition = null, this.onBeforeShowImages = null, this.onAfterShowImages = null, this._infoPointsShown = !0, this._canShowInfoPointsContent = !0, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._renderingNeededListeners = [], this.CLOSE_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_LEFT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_RIGHT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this._zkScene = e, this._scene = t, this._sceneHelper = new yi(t), this._style = {}, this.setDefaultStyle(), r && this.setStyle(r), this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene);
  }
  get infoPointsShown() {
    return this._infoPointsShown;
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this.hideImages();
  }
  dispose() {
    this._renderingNeededListeners = [], this._rootContainer.dispose();
  }
  setDefaultStyle() {
    this._style.infoPointsStyle = {
      borderColor: "#ffffff",
      innerPointColor: "#ffffff",
      color: "#a01c20",
      highlightColor: "#bb2025"
    }, this._style.imagePanelStyle = {
      backgroundColor: this._scene.clearColor.toHexString(),
      loadingTextColor: "#ffffff",
      buttonsBorderColor: "#a01c20",
      buttonsColor: "#a01c20",
      buttonsBorderHighlightColor: "#bb2025",
      buttonsHighlightColor: "#bb2025",
      buttonsIconColor: "white"
    };
  }
  setStyle(e) {
    e ? (e.infoPointsStyle && (this._style.infoPointsStyle || (this._style.infoPointsStyle = {}), e.infoPointsStyle.borderColor && (this._style.infoPointsStyle.borderColor = e.infoPointsStyle.borderColor), e.infoPointsStyle.innerPointColor && (this._style.infoPointsStyle.innerPointColor = e.infoPointsStyle.innerPointColor), e.infoPointsStyle.color && (this._style.infoPointsStyle.color = e.infoPointsStyle.color), e.infoPointsStyle.highlightColor && (this._style.infoPointsStyle.highlightColor = e.infoPointsStyle.highlightColor)), e.imagePanelStyle && (this._style.imagePanelStyle || (this._style.imagePanelStyle = {}), e.imagePanelStyle.backgroundColor && (this._style.imagePanelStyle.backgroundColor = e.imagePanelStyle.backgroundColor), e.imagePanelStyle.loadingTextColor && (this._style.imagePanelStyle.loadingTextColor = e.imagePanelStyle.loadingTextColor), e.imagePanelStyle.buttonsBorderColor && (this._style.imagePanelStyle.buttonsBorderColor = e.imagePanelStyle.buttonsBorderColor), e.imagePanelStyle.buttonsColor && (this._style.imagePanelStyle.buttonsColor = e.imagePanelStyle.buttonsColor), e.imagePanelStyle.buttonsBorderHighlightColor && (this._style.imagePanelStyle.buttonsBorderHighlightColor = e.imagePanelStyle.buttonsBorderHighlightColor), e.imagePanelStyle.buttonsHighlightColor && (this._style.imagePanelStyle.buttonsHighlightColor = e.imagePanelStyle.buttonsHighlightColor), e.imagePanelStyle.buttonsIconColor && (this._style.imagePanelStyle.buttonsIconColor = e.imagePanelStyle.buttonsIconColor))) : this.setDefaultStyle();
  }
  applyStyle(e) {
    this.setStyle(e), this.refresh();
  }
  showInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !0), this._infoPointsShown = !0, this.fireRenderingNeededEvent();
  }
  hideInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !1), this._infoPointsShown = !1, this.fireRenderingNeededEvent();
  }
  refresh() {
    this.hideImages(), this.refreshInfoPoints(), this.updateGuiElementsStyle(), this.fireRenderingNeededEvent();
  }
  getAllInfoPoints() {
    const e = [];
    for (const t in this._meshesInfoPoints)
      e.push(this._meshesInfoPoints[t]);
    return e;
  }
  refreshInfoPoints() {
    for (let e = 0; e < this._scene.meshes.length; e++) {
      const t = this._scene.meshes[e], r = t.metadata && t.metadata.showInfoPoints && (t.isVisible || t.metadata.forceShowInfoPoints), o = t.material, a = o ? this.getMaterialPhotoUrls(o) : [];
      if (r && a.length > 0) {
        const u = this.getOrCreateMeshInfoPoint(t);
        this.updateInfoPointUrls(u, a);
      } else
        this.removeMeshInfoPoints(t);
    }
  }
  removeMeshInfoPoints(e) {
    this._meshesInfoPoints.hasOwnProperty(e.id) && (this._meshesInfoPoints[e.id].dispose(), delete this._meshesInfoPoints[e.id]);
  }
  getOrCreateMeshInfoPoint(e) {
    if (this._meshesInfoPoints.hasOwnProperty(e.id))
      return this._meshesInfoPoints[e.id];
    const t = this.createMeshInfoPoint(e);
    return this._meshesInfoPoints[e.id] = t, t;
  }
  updateInfoPointUrls(e, t) {
    e.metadata || (e.metadata = {}), e.metadata.urls = t;
  }
  createMeshInfoPoint(e) {
    var o, a, u, f;
    const t = new BABYLON.GUI.Ellipse("infoPoint");
    t.width = "29px", t.height = "29px", t.color = ((o = this._style.infoPointsStyle) == null ? void 0 : o.borderColor) || "#dddddd", t.thickness = 4, t.background = ((a = this._style.infoPointsStyle) == null ? void 0 : a.color) || "#a01c20", t.alpha = 1, t.onPointerEnterObservable.add((v) => {
      var S;
      t.background = ((S = this._style.infoPointsStyle) == null ? void 0 : S.highlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), t.onPointerOutObservable.add((v) => {
      var S;
      t.background = ((S = this._style.infoPointsStyle) == null ? void 0 : S.color) || "#a01c20", this.fireRenderingNeededEvent();
    }), this._rootContainer.addControl(t);
    const r = new BABYLON.GUI.Ellipse("innerPoint");
    return r.width = 0.29, r.height = 0.29, r.color = ((u = this._style.infoPointsStyle) == null ? void 0 : u.innerPointColor) || "White", r.thickness = 0, r.background = ((f = this._style.infoPointsStyle) == null ? void 0 : f.innerPointColor) || "White", t.addControl(r), t.linkWithMesh(e), t.linkOffsetY = 0, t.shadowBlur = 6, t.shadowOffsetX = 2, t.shadowOffsetY = 2, t.isPointerBlocker = !0, t.hoverCursor = "pointer", t.onPointerClickObservable.add((v) => {
      if (t.metadata && t.metadata.urls) {
        const S = {
          meshID: e.id,
          materialID: e.material ? e.material.id : null,
          materialPhotoUrl: t.metadata.urls
        };
        this.fireInfoPointPickedEvent(S), this.showImages(t.metadata.urls);
      }
      this.fireRenderingNeededEvent();
    }), t;
  }
  getMaterialInfoPoint(e) {
    for (let t = 0; t < this._infoPoints.length; t++) {
      const r = this._infoPoints[t];
      if (r.metadata && r.metadata.materialID && r.metadata.materialID === e)
        return r;
    }
    return null;
  }
  getMaterialPhotoUrls(e) {
    return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(e.id);
  }
  getOrCreateImagePanel() {
    return this._imagePanel || this.createImagePanel(), this._imagePanel;
  }
  createImagePanel() {
    var t;
    const e = new BABYLON.GUI.Rectangle("imagePanel");
    return e.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.backgroundColor) || this._scene.clearColor.toHexString(), e.width = 1, e.height = 1, e.zIndex = 1e4, e.isVisible = !1, this._imagePanel = e, this._rootContainer.addControl(e), this.addCloseButton(e), this.addMoveNextImageButton(e), this.addMovePrevImageButton(e), e;
  }
  addCloseButton(e) {
    var a, u, f;
    const t = new BABYLON.GUI.StackPanel("closePanel");
    t.height = "48px", t.width = "48px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, t.isVertical = !1, t.zIndex = 10003, e.addControl(t);
    const r = new BABYLON.GUI.Rectangle("closeRect");
    r.width = "24px", r.height = "24px", r.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, r.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, r.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", r.color = ((u = this._style.imagePanelStyle) == null ? void 0 : u.buttonsBorderColor) || "#a01c20", r.isPointerBlocker = !0, r.hoverCursor = "pointer", r.onPointerEnterObservable.add((v) => {
      var S, I;
      r.background = ((S = this._style.imagePanelStyle) == null ? void 0 : S.buttonsHighlightColor) || "#bb2025", r.color = ((I = this._style.imagePanelStyle) == null ? void 0 : I.buttonsBorderHighlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), r.onPointerOutObservable.add((v) => {
      var S, I;
      r.background = ((S = this._style.imagePanelStyle) == null ? void 0 : S.buttonsColor) || "#a01c20", r.color = ((I = this._style.imagePanelStyle) == null ? void 0 : I.buttonsBorderColor) || "#a01c20", this.fireRenderingNeededEvent();
    }), r.onPointerClickObservable.add((v) => {
      this.hideImages(), this.fireRenderingNeededEvent();
    }), t.addControl(r);
    const o = new BABYLON.GUI.Image("close", this.getCloseSvg(((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsIconColor) || "white"));
    o.width = 1, o.height = 1, o.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, r.addControl(o), this._closeImageButton = t;
  }
  addMoveNextImageButton(e) {
    var a, u, f;
    const t = new BABYLON.GUI.StackPanel("rightPanel");
    t.width = "48px", t.height = "48px", t.paddingRight = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.zIndex = 10003, t.alpha = 0.3, t.isVisible = !1, e.addControl(t);
    const r = new BABYLON.GUI.Rectangle("rightRect");
    r.width = "24px", r.height = "48px", r.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, r.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, r.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", r.color = ((u = this._style.imagePanelStyle) == null ? void 0 : u.buttonsBorderColor) || "#a01c20", r.isPointerBlocker = !0, r.hoverCursor = "pointer", r.onPointerEnterObservable.add((v) => {
      var S, I;
      this._isOnMoveNextButton = !0, r.background = ((S = this._style.imagePanelStyle) == null ? void 0 : S.buttonsHighlightColor) || "#bb2025", r.color = ((I = this._style.imagePanelStyle) == null ? void 0 : I.buttonsBorderHighlightColor) || "#bb2025", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), r.onPointerOutObservable.add((v) => {
      var S, I;
      this._isOnMoveNextButton = !1, r.background = ((S = this._style.imagePanelStyle) == null ? void 0 : S.buttonsColor) || "#a01c20", r.color = ((I = this._style.imagePanelStyle) == null ? void 0 : I.buttonsBorderColor) || "#a01c20", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), r.onPointerClickObservable.add((v) => {
      this.moveNextImage(), this.fireRenderingNeededEvent();
    }), t.addControl(r);
    const o = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsIconColor) || "white"));
    o.width = 1, o.height = 1, o.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, o.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, r.addControl(o), this._moveNextImageButton = t;
  }
  addMovePrevImageButton(e) {
    var a, u, f;
    const t = new BABYLON.GUI.StackPanel("leftPanel");
    t.width = "48px", t.height = "48px", t.paddingLeft = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.alpha = 0.3, t.zIndex = 10003, t.isVisible = !1, e.addControl(t);
    const r = new BABYLON.GUI.Rectangle("leftRect");
    r.width = "24px", r.height = "48px", r.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, r.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, r.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", r.color = ((u = this._style.imagePanelStyle) == null ? void 0 : u.buttonsBorderColor) || "#a01c20", r.isPointerBlocker = !0, r.hoverCursor = "pointer", r.onPointerEnterObservable.add((v) => {
      var S, I;
      this._isOnMovePrevButton = !0, r.background = ((S = this._style.imagePanelStyle) == null ? void 0 : S.buttonsHighlightColor) || "#bb2025", r.color = ((I = this._style.imagePanelStyle) == null ? void 0 : I.buttonsBorderHighlightColor) || "#bb2025", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), r.onPointerOutObservable.add((v) => {
      var S, I;
      this._isOnMovePrevButton = !1, r.background = ((S = this._style.imagePanelStyle) == null ? void 0 : S.buttonsColor) || "#a01c20", r.color = ((I = this._style.imagePanelStyle) == null ? void 0 : I.buttonsBorderColor) || "#a01c20", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), r.onPointerClickObservable.add((v) => {
      this.movePrevImage(), this.fireRenderingNeededEvent();
    }), t.addControl(r);
    const o = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsIconColor) || "white"));
    o.width = 1, o.height = 1, o.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, o.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, r.addControl(o), this._movePrevImageButton = t;
  }
  updateMoveNextImageButton() {
    this._moveNextImageButton && (this._imageUrls.length <= 1 ? this._moveNextImageButton.isVisible = !1 : (this._moveNextImageButton.isVisible = !0, this._moveNextImageButton.alpha = this.canMoveNextImage() ? this._isOnMoveNextButton ? 1 : 0.3 : 0.1));
  }
  updateMovePrevImageButton() {
    this._movePrevImageButton && (this._imageUrls.length <= 1 ? this._movePrevImageButton.isVisible = !1 : (this._movePrevImageButton.isVisible = !0, this._movePrevImageButton.alpha = this.canMovePrevImage() ? this._isOnMovePrevButton ? 1 : 0.3 : 0.1));
  }
  showImages(e) {
    this._canShowInfoPointsContent && (this._currentIdx = 0, this._imageUrls = e, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this.getOrCreateImagePanel(), this._imagePanel && (this.onBeforeShowImages && this.onBeforeShowImages(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this._imagePanel.isVisible = !0, this.showCurrentImage(), this.fireInfoPointContentShownEvent()), this.fireRenderingNeededEvent());
  }
  moveNextImage() {
    this.canMoveNextImage() && (this._currentIdx++, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  movePrevImage() {
    this.canMovePrevImage() && (this._currentIdx--, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  showCurrentImage() {
    this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length && this.showImage(this._imageUrls[this._currentIdx]);
  }
  canMoveNextImage() {
    return this._imageUrls.length > 0 && this._currentIdx < this._imageUrls.length - 1;
  }
  canMovePrevImage() {
    return this._imageUrls.length > 0 && this._currentIdx > 0;
  }
  hideImages() {
    this._imagePanel && (this._imagePanel.isVisible = !1, this.onAfterShowImages && this.onAfterShowImages(), this.fireInfoPointContentHiddenEvent(), this.fireRenderingNeededEvent());
  }
  showImage(e) {
    if (this._imagePanel) {
      this._image && (this._imagePanel.removeControl(this._image), this._image.isVisible = !1, this._image.dispose(), this._image = null), this.showLoadingText();
      const t = new BABYLON.GUI.Image("but", e);
      t.width = 1, t.height = 1, t.isVisible = !0, t.zIndex = 10002, t.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, t.onImageLoadedObservable.add((r) => {
        this.hideLoadingText();
      }), this._imagePanel.addControl(t), this._image = t, this.fireRenderingNeededEvent();
    }
  }
  /**
   * Update info points visibility and return true if at least one info point has been updated.
   * 
   * @return {boolean} Return true if any info point has been updated.
   */
  updateInfoPointsVisibility() {
    let e = !1;
    if (this._scene.activeCamera && (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position))) {
      this._lastCameraPosition = this._scene.activeCamera.position.clone();
      for (const t in this._meshesInfoPoints) {
        const r = this._scene.getMeshByID(t);
        r && (this.updateMeshInfoPointVisibility(r, this._meshesInfoPoints[t]), e = !0);
      }
    }
    return e;
  }
  drawRay(e, t) {
    let r = t.subtract(e);
    r = r.normalize();
    const o = t.subtract(e).length() * 2, a = new BABYLON.Ray(e, r, o);
    BABYLON.RayHelper.CreateAndShow(a, this._scene, new BABYLON.Color3(1, 1, 0.1));
  }
  updateMeshInfoPointVisibility(e, t) {
    if (this._scene.activeCamera) {
      const r = this._sceneHelper.getMeshHierarchyCenter(e), o = this._scene.activeCamera.position;
      let a = r.subtract(o);
      a = a.normalize();
      const u = r.subtract(o).length() * 2, f = new BABYLON.Ray(o, a, u), v = this._scene.pickWithRay(f);
      v && v.pickedMesh && (t.alpha = v.pickedMesh === e ? 1 : 0.2);
    }
  }
  getCloseSvg(e) {
    return this.getSvg(this.CLOSE_SVG, e);
  }
  getChevronLeftSvg(e) {
    return this.getSvg(this.CHEVRON_LEFT_SVG, e);
  }
  getChevronRightSvg(e) {
    return this.getSvg(this.CHEVRON_RIGHT_SVG, e);
  }
  getSvg(e, t) {
    return e.replace("§color§", encodeURIComponent(t));
  }
  // -------------------------------------------------------------
  // Events 
  // -------------------------------------------------------------
  // picked
  fireInfoPointPickedEvent(e) {
    for (let t = 0; t < this._infoPointPickedListeners.length; t++)
      this._infoPointPickedListeners[t](e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e);
  }
  addInfoPointPickedListenerRange(e) {
    this._infoPointPickedListeners.push(...e);
  }
  // Content shown
  fireInfoPointContentShownEvent() {
    for (let e = 0; e < this._infoPointContentShownListeners.length; e++)
      this._infoPointContentShownListeners[e]();
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e);
  }
  addInfoPointContentShownListenerRange(e) {
    this._infoPointContentShownListeners.push(...e);
  }
  // content hidden
  fireInfoPointContentHiddenEvent() {
    for (let e = 0; e < this._infoPointContentHiddenListeners.length; e++)
      this._infoPointContentHiddenListeners[e]();
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e);
  }
  addInfoPointContentHiddenListenerRange(e) {
    this._infoPointContentHiddenListeners.push(...e);
  }
  // Rendering Needed
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  showLoadingText() {
    var e;
    if (this._loadingText) {
      this._loadingText.isVisible = !0;
      return;
    }
    this._imagePanel && (this._loadingText = new BABYLON.GUI.TextBlock("loading"), this._loadingText.text = "Loading...", this._loadingText.left = 0.5, this._loadingText.top = 0.7, this._loadingText.zIndex = 10001, this._loadingText.color = ((e = this._style.imagePanelStyle) == null ? void 0 : e.loadingTextColor) || "white", this._imagePanel.addControl(this._loadingText), this.fireRenderingNeededEvent());
  }
  hideLoadingText() {
    this._loadingText && (this._loadingText.isVisible = !1), this.fireRenderingNeededEvent();
  }
  updateGuiElementsStyle() {
    this.updateMeshInfoPointsStyle(), this.updateImagePanelStyle(), this.fireRenderingNeededEvent();
  }
  updateMeshInfoPointsStyle() {
    this.getAllInfoPoints().forEach((e) => {
      var r, o, a;
      e.color = ((r = this._style.infoPointsStyle) == null ? void 0 : r.borderColor) || "#dddddd", e.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.color) || "#a01c20";
      const t = e.getChildByName("innerPoint");
      t && t instanceof BABYLON.GUI.Container && (t.background = ((a = this._style.infoPointsStyle) == null ? void 0 : a.innerPointColor) || "White");
    });
  }
  updateImagePanelStyle() {
    var e, t, r, o, a, u, f, v;
    if (this._imagePanel) {
      this._imagePanel.background = ((e = this._style.imagePanelStyle) == null ? void 0 : e.backgroundColor) || this._scene.clearColor.toHexString();
      const S = this._imagePanel.getChildByName("closePanel");
      if (S && S instanceof BABYLON.GUI.Container) {
        const Z = S.getChildByName("closeRect");
        Z && Z instanceof BABYLON.GUI.Container && (Z.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.buttonsColor) || "#a01c20", Z.color = ((r = this._style.imagePanelStyle) == null ? void 0 : r.buttonsBorderColor) || "#a01c20");
      }
      const I = this._imagePanel.getChildByName("rightPanel");
      if (I && I instanceof BABYLON.GUI.Container) {
        const Z = I.getChildByName("rightRect");
        Z && Z instanceof BABYLON.GUI.Container && (Z.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", Z.color = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsBorderColor) || "#a01c20");
      }
      const D = this._imagePanel.getChildByName("leftPanel");
      if (D && D instanceof BABYLON.GUI.Container) {
        const Z = D.getChildByName("leftRect");
        Z && Z instanceof BABYLON.GUI.Container && (Z.background = ((u = this._style.imagePanelStyle) == null ? void 0 : u.buttonsColor) || "#a01c20", Z.color = ((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsBorderColor) || "#a01c20");
      }
      this._loadingText && (this._loadingText.color = ((v = this._style.imagePanelStyle) == null ? void 0 : v.loadingTextColor) || "white");
    }
  }
}
var qd = /* @__PURE__ */ ((y) => (y[y.NotSelected = 0] = "NotSelected", y[y.Eyewear = 1] = "Eyewear", y[y.Scarves = 2] = "Scarves", y[y.Earrings = 3] = "Earrings", y[y.Headwear = 4] = "Headwear", y[y.Necklace = 5] = "Necklace", y[y.Shoes = 6] = "Shoes", y[y.Watches = 7] = "Watches", y[y.Bracelet = 8] = "Bracelet", y))(qd || {}), Xd = /* @__PURE__ */ ((y) => (y[y.NotSelected = 0] = "NotSelected", y[y.Mazing = 1] = "Mazing", y[y.Banuba = 2] = "Banuba", y[y.DeepAR = 3] = "DeepAR", y))(Xd || {}), Is = /* @__PURE__ */ ((y) => (y.VirtualTryOn = "try_on", y.GlassPupillaryDistanceTool = "pd", y.StyleButton = "styleButton", y.MandatoryPupillaryDistance = "mandatoryPD", y))(Is || {}), $x = /* @__PURE__ */ ((y) => (y.Neutral = "neutral.hdr", y.Light = "light.hdr", y.Bright = "bright.hdr", y.Studio = "studio.hdr", y.Court = "court.hdr", y))($x || {}), Qx = /* @__PURE__ */ ((y) => (y.ViewProduct = "VIEW_PRODUCT", y.ViewArProdutc = "VIEW_AR_PRODUCT", y))(Qx || {}), ew = (
  /** @class */
  function() {
    function y(e) {
      var t = this;
      if (this._axisRoot = null, this._axes = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var r = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(r), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._sceneEditor.addPreUpdateListener(function() {
        return t.onPreUpdate();
      }), this._sceneEditor.addPostUpdateListener(function() {
        return t.onPostUpdate();
      }), this.createAxes();
    }
    return y.prototype.dispose = function() {
      this._scene && (this._scene.dispose(), delete this._scene);
    }, y.prototype.onPreUpdate = function() {
      if (this._scene) {
        var e = this._editorScene.activeCamera;
        if (e && (this._scene.activeCamera = e, this._axisRoot)) {
          var t = BABYLON.Vector3.Distance(e.position, this._axisRoot.position) * 0.03;
          this._axisRoot.scaling = new BABYLON.Vector3(t, t, t), this._axisRoot.computeWorldMatrix(!0);
        }
      }
    }, y.prototype.onPostUpdate = function() {
    }, y.prototype.createAxes = function() {
      var e = this, t = 10, r = this._scene, o = new BABYLON.Mesh("axisRoot", r);
      o.isVisible = this._sceneEditor.canShowAxes();
      var a = function(Z, M, X) {
        var Y = new BABYLON.DynamicTexture("DynamicTexture", 50, r, !0);
        Y.hasAlpha = !0, Y.drawText(Z, 5, 40, "bold 36px Arial", M, "transparent", !0);
        var ie = BABYLON.MeshBuilder.CreatePlane("TextPlane", { size: X, updatable: !0 }, r), G = new BABYLON.StandardMaterial("TextPlaneMaterial", r);
        return G.metadata = { isRealMaterial: !1 }, G.backFaceCulling = !1, G.specularColor = new BABYLON.Color3(0, 0, 0), G.diffuseTexture = Y, ie.material = G, ie.metadata = { isRealMesh: !1, isAxis: !0 }, ie.parent = o, ie.isVisible = e._sceneEditor.canShowAxes(), ie;
      }, u = BABYLON.Mesh.CreateLines("axisX", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, 0.05 * t, 0),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, -0.05 * t, 0)
      ], r);
      u.metadata = { isRealMesh: !1, isAxis: !0 }, u.color = new BABYLON.Color3(1, 0, 0), u.parent = o, u.isVisible = this._sceneEditor.canShowAxes();
      var f = a("X", "red", t / 10);
      f.position = new BABYLON.Vector3(0.9 * t, -0.05 * t, 0);
      var v = BABYLON.Mesh.CreateLines("axisY", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(-0.05 * t, t * 0.95, 0),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(0.05 * t, t * 0.95, 0)
      ], r);
      v.metadata = { isRealMesh: !1, isAxis: !0 }, v.color = new BABYLON.Color3(0, 1, 0), v.parent = o, v.isVisible = this._sceneEditor.canShowAxes();
      var S = a("Y", "green", t / 10);
      S.position = new BABYLON.Vector3(0, 0.9 * t, -0.05 * t);
      var I = BABYLON.Mesh.CreateLines("axisZ", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, -0.05 * t, t * 0.95),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, 0.05 * t, t * 0.95)
      ], r);
      I.metadata = { isRealMesh: !1, isAxis: !0 }, I.color = new BABYLON.Color3(0, 0, 1), I.parent = o, I.isVisible = this._sceneEditor.canShowAxes();
      var D = a("Z", "blue", t / 10);
      D.position = new BABYLON.Vector3(0, 0.05 * t, 0.9 * t), this._axisRoot = o, this._axes.push(o, u, v, I, f, S, D);
    }, y.prototype.refresh = function() {
      for (var e = 0; e < this._axes.length; e++) {
        var t = this._axes[e];
        t.isVisible = this._sceneEditor.canShowAxes();
      }
    }, y.prototype.render = function() {
      this._scene && this._scene.activeCamera && this._scene.render();
    }, y.prototype.getScene = function() {
      return this._scene;
    }, y;
  }()
), tw = (
  /** @class */
  function() {
    function y(e) {
      var t = this;
      if (this._lightMeshes = [], this._lightSelectedListeners = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var r = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(r), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._scene.onPointerDown = this.onPointerDown, this._sceneEditorPreUpdate = function() {
        return t.onPreUpdate();
      }, this._sceneEditorPostUpdate = function() {
        return t.onPostUpdate();
      }, this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
    }
    return y.prototype.dispose = function() {
      this._sceneEditor && (this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate)), this._scene && (this._scene.dispose(), delete this._scene);
    }, y.prototype.onPreUpdate = function() {
      this._scene.activeCamera = this._editorScene.activeCamera;
    }, y.prototype.onPostUpdate = function() {
      this._scene.getEngine();
      for (var e = 0; e < this._lightMeshes.length; e++) {
        var t = this._lightMeshes[e], r = this._editorScene.getLightByID(t.id);
        r && this.configureLightMesh(t, r);
      }
    }, y.prototype.onPointerDown = function(e, t, r) {
      if (t.hit && t.pickedMesh) {
        var o = { name: t.pickedMesh.name, id: t.pickedMesh.id };
        this.fireLightSelectedEvent(o);
      }
    }, y.prototype.refresh = function() {
      this.updateLightMeshes();
    }, y.prototype.updateLightMeshes = function() {
      if (this._scene && this._sceneEditor) {
        for (var e = 0; e < this._editorScene.lights.length; e++) {
          var t = this._editorScene.lights[e], r = this._scene.getMeshByID(t.id);
          r ? this.configureLightMesh(r, t) : this._lightMeshes.push(this.createLightMesh(t));
        }
        for (var e = 0; e < this._lightMeshes.length; e++) {
          var r = this._lightMeshes[e], t = this._editorScene.getLightByID(r.id);
          t || (r.dispose(), this._lightMeshes.splice(e--, 1));
        }
      }
    }, y.prototype.createLightMesh = function(e) {
      var t = new BABYLON.Texture(y._lightTexture, this._scene);
      t.hasAlpha = !0;
      var r = new BABYLON.StandardMaterial("LightMeshMaterial_" + e.id, this._scene);
      r.emissiveColor = BABYLON.Color3.White(), r.useAlphaFromDiffuseTexture = !0, r.disableDepthWrite = !1, r.diffuseTexture = t;
      var o = BABYLON.Mesh.CreatePlane(e.name, 1, this._scene);
      return o.id = e.id, o.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL, o.material = r, this.configureLightMesh(o, e), o;
    }, y.prototype.clearLightMeshes = function() {
      if (this._scene)
        for (; this._lightMeshes.length > 0; ) {
          var e = this._lightMeshes.pop();
          e && e.dispose();
        }
    }, y.prototype.configureLightMesh = function(e, t) {
      var r = this._editorScene.activeCamera;
      if (r && e && t) {
        e.position = t.getAbsolutePosition();
        var o = BABYLON.Vector3.Distance(r.position, e.position) * 0.03;
        e.scaling = new BABYLON.Vector3(o, o, o), e.computeWorldMatrix(!0), e.isVisible = this._sceneEditor.canShowLights();
      }
    }, y.prototype.render = function() {
      this._scene && this._scene.render();
    }, y.prototype.getScene = function() {
      return this._scene;
    }, y.prototype.fireLightSelectedEvent = function(e) {
      for (var t = 0; t < this._lightSelectedListeners.length; ++t)
        this._lightSelectedListeners[t](e);
    }, y.prototype.addLightSelectedListener = function(e) {
      this._lightSelectedListeners.push(e);
    }, y._lightTexture = "data:image/png;base64,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", y;
  }()
);
class iw {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  constructor(e, t = !1, r, o) {
    this.skipNextObservers = !1, this.mask = 0, this.initalize(e, t, r, o);
  }
  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  initalize(e, t = !1, r, o) {
    return this.mask = e, this.skipNextObservers = t, this.target = r, this.currentTarget = o, this;
  }
}
class nw {
  /**
   * Creates a new observer
   * @param callback defines the callback to call when the observer is notified
   * @param mask defines the mask of the observer (used to filter notifications)
   * @param scope defines the current scope used to restore the JS context
   */
  constructor(e, t, r = null) {
    this.callback = e, this.mask = t, this.scope = r, this._willBeUnregistered = !1, this.unregisterOnNextCall = !1;
  }
}
class Kd {
  constructor() {
    this._observers = null, this._observables = null;
  }
  /**
   * Release associated resources
   */
  dispose() {
    if (this._observers && this._observables)
      for (var e = 0; e < this._observers.length; e++)
        this._observables[e].remove(this._observers[e]);
    this._observers = null, this._observables = null;
  }
  /**
   * Raise a callback when one of the observable will notify
   * @param observables defines a list of observables to watch
   * @param callback defines the callback to call on notification
   * @param mask defines the mask used to filter notifications
   * @param scope defines the current scope used to restore the JS context
   * @returns the new MultiObserver
   */
  static Watch(e, t, r = 0, o = null) {
    let a = new Kd();
    a._observers = new Array(), a._observables = e;
    for (var u of e) {
      let f = u.add(t, r, !1, o);
      f && a._observers.push(f);
    }
    return a;
  }
}
class Jd {
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   */
  constructor(e) {
    this._observers = new Array(), this._onObserverAdded = null, this._eventState = new iw(0), e && (this._onObserverAdded = e);
  }
  /**
   * Gets the list of observers
   */
  get observers() {
    return this._observers;
  }
  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  add(e, t = 0, r = !1, o = null, a = !1) {
    if (!e)
      return null;
    var u = new nw(e, t, o);
    return u.unregisterOnNextCall = a, r ? this._observers.unshift(u) : this._observers.push(u), this._onObserverAdded && this._onObserverAdded(u), u;
  }
  /**
   * Create a new Observer with the specified callback and unregisters after the next notification
   * @param callback the callback that will be executed for that Observer
   * @returns the new observer created for the callback
   */
  addOnce(e) {
    return this.add(e, void 0, void 0, void 0, !0);
  }
  /**
   * Remove an Observer from the Observable object
   * @param observer the instance of the Observer to remove
   * @returns false if it doesn't belong to this Observable
   */
  remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._deferUnregister(e), !0) : !1;
  }
  /**
   * Remove a callback from the Observable object
   * @param callback the callback to remove
   * @param scope optional scope. If used only the callbacks with this scope will be removed
   * @returns false if it doesn't belong to this Observable
  */
  removeCallback(e, t) {
    for (var r = 0; r < this._observers.length; r++) {
      const o = this._observers[r];
      if (!o._willBeUnregistered && o.callback === e && (!t || t === o.scope))
        return this._deferUnregister(o), !0;
    }
    return !1;
  }
  _deferUnregister(e) {
    e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, setTimeout(() => {
      this._remove(e);
    }, 0);
  }
  // This should only be called when not iterating over _observers to avoid callback skipping.
  // Removes an observer from the _observer Array.
  _remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._observers.splice(t, 1), !0) : !1;
  }
  /**
   * Moves the observable to the top of the observer list making it get called first when notified
   * @param observer the observer to move
   */
  makeObserverTopPriority(e) {
    this._remove(e), this._observers.unshift(e);
  }
  /**
   * Moves the observable to the bottom of the observer list making it get called last when notified
   * @param observer the observer to move
   */
  makeObserverBottomPriority(e) {
    this._remove(e), this._observers.push(e);
  }
  /**
   * Notify all Observers by calling their respective callback with the given data
   * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
   * @param eventData defines the data to send to all observers
   * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
   */
  notifyObservers(e, t = 0, r, o) {
    if (!this._observers.length)
      return !0;
    let a = this._eventState;
    a.mask = t, a.target = r, a.currentTarget = o, a.skipNextObservers = !1, a.lastReturnValue = e;
    for (var u of this._observers)
      if (!u._willBeUnregistered && (u.mask & t && (u.scope ? a.lastReturnValue = u.callback.apply(u.scope, [e, a]) : a.lastReturnValue = u.callback(e, a), u.unregisterOnNextCall && this._deferUnregister(u)), a.skipNextObservers))
        return !1;
    return !0;
  }
  /**
   * Calling this will execute each callback, expecting it to be a promise or return a value.
   * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
   * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
   * and it is crucial that all callbacks will be executed.
   * The order of the callbacks is kept, callbacks are not executed parallel.
   *
   * @param eventData The data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   * @param target defines the callback target (see EventState)
   * @param currentTarget defines he current object in the bubbling phase
   * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
   */
  notifyObserversWithPromise(e, t = 0, r, o) {
    let a = Promise.resolve(e);
    if (!this._observers.length)
      return a;
    let u = this._eventState;
    return u.mask = t, u.target = r, u.currentTarget = o, u.skipNextObservers = !1, this._observers.forEach((f) => {
      u.skipNextObservers || f._willBeUnregistered || f.mask & t && (f.scope ? a = a.then((v) => (u.lastReturnValue = v, f.callback.apply(f.scope, [e, u]))) : a = a.then((v) => (u.lastReturnValue = v, f.callback(e, u))), f.unregisterOnNextCall && this._deferUnregister(f));
    }), a.then(() => e);
  }
  /**
   * Notify a specific observer
   * @param observer defines the observer to notify
   * @param eventData defines the data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   */
  notifyObserver(e, t, r = 0) {
    let o = this._eventState;
    o.mask = r, o.skipNextObservers = !1, e.callback(t, o);
  }
  /**
   * Gets a boolean indicating if the observable has at least one observer
   * @returns true is the Observable has at least one Observer registered
   */
  hasObservers() {
    return this._observers.length > 0;
  }
  /**
  * Clear the list of observers
  */
  clear() {
    this._observers = new Array(), this._onObserverAdded = null;
  }
  /**
   * Clone the current observable
   * @returns a new observable
   */
  clone() {
    var e = new Jd();
    return e._observers = this._observers.slice(0), e;
  }
  /**
   * Does this observable handles observer registered with a given mask
   * @param mask defines the mask to be tested
   * @return whether or not one observer registered with the given mask is handeled
  **/
  hasSpecificMask(e = 0) {
    for (var t of this._observers)
      if (t.mask & e || t.mask === e)
        return !0;
    return !1;
  }
}
class Of {
  /**
   * Creates a new Database
  */
  constructor() {
    this._idbFactory = typeof window < "u" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB, this._db = null, this._hasReachedQuota = !1, this._isSupported = !0;
  }
  openAsync() {
    return new Promise((e, t) => this.open(e, t));
  }
  /**
   * Open the database and make it available
   * @param successCallback defines the callback to call on success
   * @param errorCallback defines the callback to call on error
   */
  open(e, t) {
    const r = () => {
      this._isSupported = !1, t && t();
    };
    if (!this._idbFactory)
      this._isSupported = !1, t && t();
    else if (this._db)
      e && e();
    else {
      this._hasReachedQuota = !1, this._isSupported = !0;
      const o = this._idbFactory.open("zakeke", 1);
      o.onerror = () => {
        r();
      }, o.onblocked = () => {
        Logger.info("IDB request blocked. Please reload the page."), r();
      }, o.onsuccess = () => {
        this._db = o.result, e();
      }, o.onupgradeneeded = (a) => {
        if (this._db = a.target.result, this._db)
          try {
            this._db.createObjectStore("files", { keyPath: "fileId" });
          } catch (u) {
            Logger.info("Error while creating object stores. Exception: " + u.message), r();
          }
      };
    }
  }
  loadFileAsync(e) {
    return new Promise((t, r) => {
      if (this._isSupported && this._db) {
        const o = "files";
        let a;
        const u = this._db.transaction([o]);
        u.oncomplete = () => {
          t(a ? a.data : null);
        }, u.onabort = () => {
          t(null);
        };
        const f = u.objectStore(o).get(e);
        f.onsuccess = (v) => {
          a = v.target.result;
        }, f.onerror = () => {
          Logger.info("Error loading file " + e + " from DB."), t(null);
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), r("IndexedDB not supported or Db is not open");
    });
  }
  saveFileAsync(e, t) {
    return new Promise((r, o) => {
      if (this._isSupported) {
        const a = "files";
        if (!this._hasReachedQuota && this._db) {
          const u = this._db.transaction([a], "readwrite");
          u.onabort = (S) => {
            const I = S.srcElement.error;
            I && I.name === "QuotaExceededError" && (this._hasReachedQuota = !0, o("Quota Exceeded"));
          }, u.oncomplete = () => {
            Logger.info("File saved successfully"), r();
          };
          const f = { fileId: e, data: t }, v = u.objectStore(a).put(f);
          v.onsuccess = () => {
          }, v.onerror = () => {
            Logger.info("Error in DB add file request in Zakeke3D.Database."), o("Error in DB add file request");
          };
        } else {
          const u = this._hasReachedQuota ? "Quota has been reached" : "Database closed";
          o(u);
        }
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), o("IndexedDB not supported or Db is not open");
    });
  }
  deleteFileAsync(e) {
    return new Promise((t, r) => {
      if (this._isSupported && this._db) {
        const o = "files", a = this._db.transaction([o]);
        a.oncomplete = () => {
          t();
        }, a.onabort = () => {
          r("aborted cancellation");
        };
        const u = a.objectStore(o).get(e);
        u.onerror = () => {
          Logger.info("Error deleting file " + e + " from DB."), r("Error deleting file from DB");
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), r("IndexedDB not supported or Db is not open");
    });
  }
}
var _l = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
_l.exports;
(function(y, e) {
  (function() {
    var t, r = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", f = "Invalid `variable` option passed into `_.template`", v = "__lodash_hash_undefined__", S = 500, I = "__lodash_placeholder__", D = 1, Z = 2, M = 4, X = 1, Y = 2, ie = 1, G = 2, te = 4, J = 8, he = 16, ve = 32, K = 64, j = 128, We = 256, ke = 512, $e = 30, Lt = "...", Be = 800, Xe = 16, ue = 1, yt = 2, Ue = 3, ot = 1 / 0, Gt = 9007199254740991, it = 17976931348623157e292, Zt = 0 / 0, ct = 4294967295, lt = ct - 1, $t = ct >>> 1, Kt = [
      ["ary", j],
      ["bind", ie],
      ["bindKey", G],
      ["curry", J],
      ["curryRight", he],
      ["flip", ke],
      ["partial", ve],
      ["partialRight", K],
      ["rearg", We]
    ], At = "[object Arguments]", Ni = "[object Array]", rn = "[object AsyncFunction]", ui = "[object Boolean]", Wt = "[object Date]", Qt = "[object DOMException]", ei = "[object Error]", on = "[object Function]", tn = "[object GeneratorFunction]", pe = "[object Map]", Tt = "[object Number]", xt = "[object Null]", Re = "[object Object]", Ie = "[object Promise]", Qe = "[object Proxy]", Bt = "[object RegExp]", dt = "[object Set]", et = "[object String]", wt = "[object Symbol]", Xt = "[object Undefined]", He = "[object WeakMap]", i = "[object WeakSet]", n = "[object ArrayBuffer]", s = "[object DataView]", l = "[object Float32Array]", h = "[object Float64Array]", d = "[object Int8Array]", m = "[object Int16Array]", _ = "[object Int32Array]", b = "[object Uint8Array]", x = "[object Uint8ClampedArray]", T = "[object Uint16Array]", E = "[object Uint32Array]", L = /\b__p \+= '';/g, A = /\b(__p \+=) '' \+/g, U = /(__e\(.*?\)|\b__t\)) \+\n'';/g, k = /&(?:amp|lt|gt|quot|#39);/g, F = /[&<>"']/g, B = RegExp(k.source), R = RegExp(F.source), C = /<%-([\s\S]+?)%>/g, P = /<%([\s\S]+?)%>/g, H = /<%=([\s\S]+?)%>/g, W = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, V = /^\w*$/, Q = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ae = /[\\^$.*+?()[\]{}|]/g, le = RegExp(ae.source), fe = /^\s+/, se = /\s/, ge = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, me = /\{\n\/\* \[wrapped with (.+)\] \*/, we = /,? & /, Se = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ae = /[()=,{}\[\]\/\s]/, Ge = /\\(\\)?/g, Je = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, tt = /\w*$/, ft = /^[-+]0x[0-9a-f]+$/i, Ne = /^0b[01]+$/i, ze = /^\[object .+?Constructor\]$/, nt = /^0o[0-7]+$/i, _t = /^(?:0|[1-9]\d*)$/, mt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Pt = /($^)/, Et = /['\n\r\u2028\u2029\\]/g, zt = "\\ud800-\\udfff", jt = "\\u0300-\\u036f", Ft = "\\ufe20-\\ufe2f", Mi = "\\u20d0-\\u20ff", Rt = jt + Ft + Mi, hi = "\\u2700-\\u27bf", ci = "a-z\\xdf-\\xf6\\xf8-\\xff", ni = "\\xac\\xb1\\xd7\\xf7", di = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Hi = "\\u2000-\\u206f", xi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", qi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ti = "\\ufe0e\\ufe0f", Ci = ni + di + Hi + xi, Xi = "['’]", Gi = "[" + zt + "]", Ki = "[" + Ci + "]", un = "[" + Rt + "]", nn = "\\d+", Wn = "[" + hi + "]", ir = "[" + ci + "]", Tr = "[^" + zt + Ci + nn + hi + ci + qi + "]", yr = "\\ud83c[\\udffb-\\udfff]", In = "(?:" + un + "|" + yr + ")", nr = "[^" + zt + "]", si = "(?:\\ud83c[\\udde6-\\uddff]){2}", ur = "[\\ud800-\\udbff][\\udc00-\\udfff]", Dn = "[" + qi + "]", Mn = "\\u200d", gn = "(?:" + ir + "|" + Tr + ")", Cn = "(?:" + Dn + "|" + Tr + ")", cn = "(?:" + Xi + "(?:d|ll|m|re|s|t|ve))?", Ji = "(?:" + Xi + "(?:D|LL|M|RE|S|T|VE))?", g = In + "?", z = "[" + Ti + "]?", ce = "(?:" + Mn + "(?:" + [nr, si, ur].join("|") + ")" + z + g + ")*", xe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Pe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rt = z + g + ce, pt = "(?:" + [Wn, si, ur].join("|") + ")" + rt, Dt = "(?:" + [nr + un + "?", un, si, ur, Gi].join("|") + ")", qt = RegExp(Xi, "g"), gi = RegExp(un, "g"), vi = RegExp(yr + "(?=" + yr + ")|" + Dt + rt, "g"), ln = RegExp([
      Dn + "?" + ir + "+" + cn + "(?=" + [Ki, Dn, "$"].join("|") + ")",
      Cn + "+" + Ji + "(?=" + [Ki, Dn + gn, "$"].join("|") + ")",
      Dn + "?" + gn + "+" + cn,
      Dn + "+" + Ji,
      Pe,
      xe,
      nn,
      pt
    ].join("|"), "g"), cr = RegExp("[" + Mn + zt + Rt + Ti + "]"), Lr = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, br = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Fr = -1, Fi = {};
    Fi[l] = Fi[h] = Fi[d] = Fi[m] = Fi[_] = Fi[b] = Fi[x] = Fi[T] = Fi[E] = !0, Fi[At] = Fi[Ni] = Fi[n] = Fi[ui] = Fi[s] = Fi[Wt] = Fi[ei] = Fi[on] = Fi[pe] = Fi[Tt] = Fi[Re] = Fi[Bt] = Fi[dt] = Fi[et] = Fi[He] = !1;
    var Ri = {};
    Ri[At] = Ri[Ni] = Ri[n] = Ri[s] = Ri[ui] = Ri[Wt] = Ri[l] = Ri[h] = Ri[d] = Ri[m] = Ri[_] = Ri[pe] = Ri[Tt] = Ri[Re] = Ri[Bt] = Ri[dt] = Ri[et] = Ri[wt] = Ri[b] = Ri[x] = Ri[T] = Ri[E] = !0, Ri[ei] = Ri[on] = Ri[He] = !1;
    var Ps = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, bs = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, ls = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, rr = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, xs = parseFloat, Ks = parseInt, hs = typeof Kr == "object" && Kr && Kr.Object === Object && Kr, Br = typeof self == "object" && self && self.Object === Object && self, pn = hs || Br || Function("return this")(), us = e && !e.nodeType && e, Qn = us && !0 && y && !y.nodeType && y, Ns = Qn && Qn.exports === us, Qr = Ns && hs.process, Zn = function() {
      try {
        var Le = Qn && Qn.require && Qn.require("util").types;
        return Le || Qr && Qr.binding && Qr.binding("util");
      } catch {
      }
    }(), w = Zn && Zn.isArrayBuffer, O = Zn && Zn.isDate, q = Zn && Zn.isMap, ne = Zn && Zn.isRegExp, de = Zn && Zn.isSet, _e = Zn && Zn.isTypedArray;
    function ye(Le, je, Ye) {
      switch (Ye.length) {
        case 0:
          return Le.call(je);
        case 1:
          return Le.call(je, Ye[0]);
        case 2:
          return Le.call(je, Ye[0], Ye[1]);
        case 3:
          return Le.call(je, Ye[0], Ye[1], Ye[2]);
      }
      return Le.apply(je, Ye);
    }
    function Ve(Le, je, Ye, ee) {
      for (var oe = -1, Me = Le == null ? 0 : Le.length; ++oe < Me; ) {
        var Ee = Le[oe];
        je(ee, Ee, Ye(Ee), Le);
      }
      return ee;
    }
    function De(Le, je) {
      for (var Ye = -1, ee = Le == null ? 0 : Le.length; ++Ye < ee && je(Le[Ye], Ye, Le) !== !1; )
        ;
      return Le;
    }
    function Ke(Le, je) {
      for (var Ye = Le == null ? 0 : Le.length; Ye-- && je(Le[Ye], Ye, Le) !== !1; )
        ;
      return Le;
    }
    function St(Le, je) {
      for (var Ye = -1, ee = Le == null ? 0 : Le.length; ++Ye < ee; )
        if (!je(Le[Ye], Ye, Le))
          return !1;
      return !0;
    }
    function Ct(Le, je) {
      for (var Ye = -1, ee = Le == null ? 0 : Le.length, oe = 0, Me = []; ++Ye < ee; ) {
        var Ee = Le[Ye];
        je(Ee, Ye, Le) && (Me[oe++] = Ee);
      }
      return Me;
    }
    function ut(Le, je) {
      var Ye = Le == null ? 0 : Le.length;
      return !!Ye && Wi(Le, je, 0) > -1;
    }
    function Ut(Le, je, Ye) {
      for (var ee = -1, oe = Le == null ? 0 : Le.length; ++ee < oe; )
        if (Ye(je, Le[ee]))
          return !0;
      return !1;
    }
    function ti(Le, je) {
      for (var Ye = -1, ee = Le == null ? 0 : Le.length, oe = Array(ee); ++Ye < ee; )
        oe[Ye] = je(Le[Ye], Ye, Le);
      return oe;
    }
    function wi(Le, je) {
      for (var Ye = -1, ee = je.length, oe = Le.length; ++Ye < ee; )
        Le[oe + Ye] = je[Ye];
      return Le;
    }
    function bi(Le, je, Ye, ee) {
      var oe = -1, Me = Le == null ? 0 : Le.length;
      for (ee && Me && (Ye = Le[++oe]); ++oe < Me; )
        Ye = je(Ye, Le[oe], oe, Le);
      return Ye;
    }
    function An(Le, je, Ye, ee) {
      var oe = Le == null ? 0 : Le.length;
      for (ee && oe && (Ye = Le[--oe]); oe--; )
        Ye = je(Ye, Le[oe], oe, Le);
      return Ye;
    }
    function _n(Le, je) {
      for (var Ye = -1, ee = Le == null ? 0 : Le.length; ++Ye < ee; )
        if (je(Le[Ye], Ye, Le))
          return !0;
      return !1;
    }
    var fn = fr("length");
    function pi(Le) {
      return Le.split("");
    }
    function Bi(Le) {
      return Le.match(Se) || [];
    }
    function On(Le, je, Ye) {
      var ee;
      return Ye(Le, function(oe, Me, Ee) {
        if (je(oe, Me, Ee))
          return ee = Me, !1;
      }), ee;
    }
    function Oi(Le, je, Ye, ee) {
      for (var oe = Le.length, Me = Ye + (ee ? 1 : -1); ee ? Me-- : ++Me < oe; )
        if (je(Le[Me], Me, Le))
          return Me;
      return -1;
    }
    function Wi(Le, je, Ye) {
      return je === je ? ts(Le, je, Ye) : Oi(Le, sr, Ye);
    }
    function es(Le, je, Ye, ee) {
      for (var oe = Ye - 1, Me = Le.length; ++oe < Me; )
        if (ee(Le[oe], je))
          return oe;
      return -1;
    }
    function sr(Le) {
      return Le !== Le;
    }
    function mn(Le, je) {
      var Ye = Le == null ? 0 : Le.length;
      return Ye ? Pn(Le, je) / Ye : Zt;
    }
    function fr(Le) {
      return function(je) {
        return je == null ? t : je[Le];
      };
    }
    function Un(Le) {
      return function(je) {
        return Le == null ? t : Le[je];
      };
    }
    function Jt(Le, je, Ye, ee, oe) {
      return oe(Le, function(Me, Ee, at) {
        Ye = ee ? (ee = !1, Me) : je(Ye, Me, Ee, at);
      }), Ye;
    }
    function qn(Le, je) {
      var Ye = Le.length;
      for (Le.sort(je); Ye--; )
        Le[Ye] = Le[Ye].value;
      return Le;
    }
    function Pn(Le, je) {
      for (var Ye, ee = -1, oe = Le.length; ++ee < oe; ) {
        var Me = je(Le[ee]);
        Me !== t && (Ye = Ye === t ? Me : Ye + Me);
      }
      return Ye;
    }
    function Er(Le, je) {
      for (var Ye = -1, ee = Array(Le); ++Ye < Le; )
        ee[Ye] = je(Ye);
      return ee;
    }
    function Si(Le, je) {
      return ti(je, function(Ye) {
        return [Ye, Le[Ye]];
      });
    }
    function sn(Le) {
      return Le && Le.slice(0, Vr(Le) + 1).replace(fe, "");
    }
    function Yt(Le) {
      return function(je) {
        return Le(je);
      };
    }
    function kr(Le, je) {
      return ti(je, function(Ye) {
        return Le[Ye];
      });
    }
    function ai(Le, je) {
      return Le.has(je);
    }
    function Pi(Le, je) {
      for (var Ye = -1, ee = Le.length; ++Ye < ee && Wi(je, Le[Ye], 0) > -1; )
        ;
      return Ye;
    }
    function Tn(Le, je) {
      for (var Ye = Le.length; Ye-- && Wi(je, Le[Ye], 0) > -1; )
        ;
      return Ye;
    }
    function oi(Le, je) {
      for (var Ye = Le.length, ee = 0; Ye--; )
        Le[Ye] === je && ++ee;
      return ee;
    }
    var dn = Un(Ps), Ir = Un(bs);
    function Js(Le) {
      return "\\" + rr[Le];
    }
    function Ur(Le, je) {
      return Le == null ? t : Le[je];
    }
    function Xn(Le) {
      return cr.test(Le);
    }
    function hn(Le) {
      return Lr.test(Le);
    }
    function Nn(Le) {
      for (var je, Ye = []; !(je = Le.next()).done; )
        Ye.push(je.value);
      return Ye;
    }
    function Kn(Le) {
      var je = -1, Ye = Array(Le.size);
      return Le.forEach(function(ee, oe) {
        Ye[++je] = [oe, ee];
      }), Ye;
    }
    function ar(Le, je) {
      return function(Ye) {
        return Le(je(Ye));
      };
    }
    function Yn(Le, je) {
      for (var Ye = -1, ee = Le.length, oe = 0, Me = []; ++Ye < ee; ) {
        var Ee = Le[Ye];
        (Ee === je || Ee === I) && (Le[Ye] = I, Me[oe++] = Ye);
      }
      return Me;
    }
    function dr(Le) {
      var je = -1, Ye = Array(Le.size);
      return Le.forEach(function(ee) {
        Ye[++je] = ee;
      }), Ye;
    }
    function Ui(Le) {
      var je = -1, Ye = Array(Le.size);
      return Le.forEach(function(ee) {
        Ye[++je] = [ee, ee];
      }), Ye;
    }
    function ts(Le, je, Ye) {
      for (var ee = Ye - 1, oe = Le.length; ++ee < oe; )
        if (Le[ee] === je)
          return ee;
      return -1;
    }
    function cs(Le, je, Ye) {
      for (var ee = Ye + 1; ee--; )
        if (Le[ee] === je)
          return ee;
      return ee;
    }
    function xr(Le) {
      return Xn(Le) ? or(Le) : fn(Le);
    }
    function Ln(Le) {
      return Xn(Le) ? Oe(Le) : pi(Le);
    }
    function Vr(Le) {
      for (var je = Le.length; je-- && se.test(Le.charAt(je)); )
        ;
      return je;
    }
    var ws = Un(ls);
    function or(Le) {
      for (var je = vi.lastIndex = 0; vi.test(Le); )
        ++je;
      return je;
    }
    function Oe(Le) {
      return Le.match(vi) || [];
    }
    function qe(Le) {
      return Le.match(ln) || [];
    }
    var ht = function Le(je) {
      je = je == null ? pn : gt.defaults(pn.Object(), je, gt.pick(pn, br));
      var Ye = je.Array, ee = je.Date, oe = je.Error, Me = je.Function, Ee = je.Math, at = je.Object, Mt = je.RegExp, vt = je.String, Vt = je.TypeError, Ei = Ye.prototype, $i = Me.prototype, vn = at.prototype, wn = je["__core-js_shared__"], gr = $i.toString, Li = vn.hasOwnProperty, lg = 0, vu = function() {
        var c = /[^.]+$/.exec(wn && wn.keys && wn.keys.IE_PROTO || "");
        return c ? "Symbol(src)_1." + c : "";
      }(), go = vn.toString, hg = gr.call(at), ug = pn._, cg = Mt(
        "^" + gr.call(Li).replace(ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), po = Ns ? je.Buffer : t, Rs = je.Symbol, _o = je.Uint8Array, yu = po ? po.allocUnsafe : t, mo = ar(at.getPrototypeOf, at), bu = at.create, xu = vn.propertyIsEnumerable, vo = Ei.splice, wu = Rs ? Rs.isConcatSpreadable : t, Ba = Rs ? Rs.iterator : t, $s = Rs ? Rs.toStringTag : t, yo = function() {
        try {
          var c = na(at, "defineProperty");
          return c({}, "", {}), c;
        } catch {
        }
      }(), fg = je.clearTimeout !== pn.clearTimeout && je.clearTimeout, dg = ee && ee.now !== pn.Date.now && ee.now, gg = je.setTimeout !== pn.setTimeout && je.setTimeout, bo = Ee.ceil, xo = Ee.floor, Tl = at.getOwnPropertySymbols, pg = po ? po.isBuffer : t, Su = je.isFinite, _g = Ei.join, mg = ar(at.keys, at), Gn = Ee.max, lr = Ee.min, vg = ee.now, yg = je.parseInt, Mu = Ee.random, bg = Ei.reverse, Ll = na(je, "DataView"), Ea = na(je, "Map"), Bl = na(je, "Promise"), fa = na(je, "Set"), ka = na(je, "WeakMap"), Ia = na(at, "create"), wo = ka && new ka(), da = {}, xg = ra(Ll), wg = ra(Ea), Sg = ra(Bl), Mg = ra(fa), Cg = ra(ka), So = Rs ? Rs.prototype : t, Oa = So ? So.valueOf : t, Cu = So ? So.toString : t;
      function Ce(c) {
        if (Rn(c) && !ki(c) && !(c instanceof ji)) {
          if (c instanceof Hr)
            return c;
          if (Li.call(c, "__wrapped__"))
            return Ac(c);
        }
        return new Hr(c);
      }
      var ga = function() {
        function c() {
        }
        return function(p) {
          if (!Bn(p))
            return {};
          if (bu)
            return bu(p);
          c.prototype = p;
          var N = new c();
          return c.prototype = t, N;
        };
      }();
      function Mo() {
      }
      function Hr(c, p) {
        this.__wrapped__ = c, this.__actions__ = [], this.__chain__ = !!p, this.__index__ = 0, this.__values__ = t;
      }
      Ce.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: C,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: P,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: H,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Ce
        }
      }, Ce.prototype = Mo.prototype, Ce.prototype.constructor = Ce, Hr.prototype = ga(Mo.prototype), Hr.prototype.constructor = Hr;
      function ji(c) {
        this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ct, this.__views__ = [];
      }
      function Ag() {
        var c = new ji(this.__wrapped__);
        return c.__actions__ = wr(this.__actions__), c.__dir__ = this.__dir__, c.__filtered__ = this.__filtered__, c.__iteratees__ = wr(this.__iteratees__), c.__takeCount__ = this.__takeCount__, c.__views__ = wr(this.__views__), c;
      }
      function Tg() {
        if (this.__filtered__) {
          var c = new ji(this);
          c.__dir__ = -1, c.__filtered__ = !0;
        } else
          c = this.clone(), c.__dir__ *= -1;
        return c;
      }
      function Lg() {
        var c = this.__wrapped__.value(), p = this.__dir__, N = ki(c), re = p < 0, be = N ? c.length : 0, Te = Up(0, be, this.__views__), Fe = Te.start, Ze = Te.end, st = Ze - Fe, kt = re ? Ze : Fe - 1, It = this.__iteratees__, Ht = It.length, ii = 0, ri = lr(st, this.__takeCount__);
        if (!N || !re && be == st && ri == st)
          return Xu(c, this.__actions__);
        var _i = [];
        e:
          for (; st-- && ii < ri; ) {
            kt += p;
            for (var zi = -1, mi = c[kt]; ++zi < Ht; ) {
              var Yi = It[zi], Zi = Yi.iteratee, Nr = Yi.type, mr = Zi(mi);
              if (Nr == yt)
                mi = mr;
              else if (!mr) {
                if (Nr == ue)
                  continue e;
                break e;
              }
            }
            _i[ii++] = mi;
          }
        return _i;
      }
      ji.prototype = ga(Mo.prototype), ji.prototype.constructor = ji;
      function Qs(c) {
        var p = -1, N = c == null ? 0 : c.length;
        for (this.clear(); ++p < N; ) {
          var re = c[p];
          this.set(re[0], re[1]);
        }
      }
      function Bg() {
        this.__data__ = Ia ? Ia(null) : {}, this.size = 0;
      }
      function Eg(c) {
        var p = this.has(c) && delete this.__data__[c];
        return this.size -= p ? 1 : 0, p;
      }
      function kg(c) {
        var p = this.__data__;
        if (Ia) {
          var N = p[c];
          return N === v ? t : N;
        }
        return Li.call(p, c) ? p[c] : t;
      }
      function Ig(c) {
        var p = this.__data__;
        return Ia ? p[c] !== t : Li.call(p, c);
      }
      function Og(c, p) {
        var N = this.__data__;
        return this.size += this.has(c) ? 0 : 1, N[c] = Ia && p === t ? v : p, this;
      }
      Qs.prototype.clear = Bg, Qs.prototype.delete = Eg, Qs.prototype.get = kg, Qs.prototype.has = Ig, Qs.prototype.set = Og;
      function Ss(c) {
        var p = -1, N = c == null ? 0 : c.length;
        for (this.clear(); ++p < N; ) {
          var re = c[p];
          this.set(re[0], re[1]);
        }
      }
      function Pg() {
        this.__data__ = [], this.size = 0;
      }
      function Ng(c) {
        var p = this.__data__, N = Co(p, c);
        if (N < 0)
          return !1;
        var re = p.length - 1;
        return N == re ? p.pop() : vo.call(p, N, 1), --this.size, !0;
      }
      function Rg(c) {
        var p = this.__data__, N = Co(p, c);
        return N < 0 ? t : p[N][1];
      }
      function Dg(c) {
        return Co(this.__data__, c) > -1;
      }
      function zg(c, p) {
        var N = this.__data__, re = Co(N, c);
        return re < 0 ? (++this.size, N.push([c, p])) : N[re][1] = p, this;
      }
      Ss.prototype.clear = Pg, Ss.prototype.delete = Ng, Ss.prototype.get = Rg, Ss.prototype.has = Dg, Ss.prototype.set = zg;
      function Ms(c) {
        var p = -1, N = c == null ? 0 : c.length;
        for (this.clear(); ++p < N; ) {
          var re = c[p];
          this.set(re[0], re[1]);
        }
      }
      function Fg() {
        this.size = 0, this.__data__ = {
          hash: new Qs(),
          map: new (Ea || Ss)(),
          string: new Qs()
        };
      }
      function Ug(c) {
        var p = Do(this, c).delete(c);
        return this.size -= p ? 1 : 0, p;
      }
      function Vg(c) {
        return Do(this, c).get(c);
      }
      function Hg(c) {
        return Do(this, c).has(c);
      }
      function Yg(c, p) {
        var N = Do(this, c), re = N.size;
        return N.set(c, p), this.size += N.size == re ? 0 : 1, this;
      }
      Ms.prototype.clear = Fg, Ms.prototype.delete = Ug, Ms.prototype.get = Vg, Ms.prototype.has = Hg, Ms.prototype.set = Yg;
      function ea(c) {
        var p = -1, N = c == null ? 0 : c.length;
        for (this.__data__ = new Ms(); ++p < N; )
          this.add(c[p]);
      }
      function Gg(c) {
        return this.__data__.set(c, v), this;
      }
      function jg(c) {
        return this.__data__.has(c);
      }
      ea.prototype.add = ea.prototype.push = Gg, ea.prototype.has = jg;
      function is(c) {
        var p = this.__data__ = new Ss(c);
        this.size = p.size;
      }
      function Wg() {
        this.__data__ = new Ss(), this.size = 0;
      }
      function Zg(c) {
        var p = this.__data__, N = p.delete(c);
        return this.size = p.size, N;
      }
      function qg(c) {
        return this.__data__.get(c);
      }
      function Xg(c) {
        return this.__data__.has(c);
      }
      function Kg(c, p) {
        var N = this.__data__;
        if (N instanceof Ss) {
          var re = N.__data__;
          if (!Ea || re.length < o - 1)
            return re.push([c, p]), this.size = ++N.size, this;
          N = this.__data__ = new Ms(re);
        }
        return N.set(c, p), this.size = N.size, this;
      }
      is.prototype.clear = Wg, is.prototype.delete = Zg, is.prototype.get = qg, is.prototype.has = Xg, is.prototype.set = Kg;
      function Au(c, p) {
        var N = ki(c), re = !N && sa(c), be = !N && !re && Vs(c), Te = !N && !re && !be && va(c), Fe = N || re || be || Te, Ze = Fe ? Er(c.length, vt) : [], st = Ze.length;
        for (var kt in c)
          (p || Li.call(c, kt)) && !(Fe && // Safari 9 has enumerable `arguments.length` in strict mode.
          (kt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          be && (kt == "offset" || kt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Te && (kt == "buffer" || kt == "byteLength" || kt == "byteOffset") || // Skip index properties.
          Ls(kt, st))) && Ze.push(kt);
        return Ze;
      }
      function Tu(c) {
        var p = c.length;
        return p ? c[Ul(0, p - 1)] : t;
      }
      function Jg(c, p) {
        return zo(wr(c), ta(p, 0, c.length));
      }
      function $g(c) {
        return zo(wr(c));
      }
      function El(c, p, N) {
        (N !== t && !ns(c[p], N) || N === t && !(p in c)) && Cs(c, p, N);
      }
      function Pa(c, p, N) {
        var re = c[p];
        (!(Li.call(c, p) && ns(re, N)) || N === t && !(p in c)) && Cs(c, p, N);
      }
      function Co(c, p) {
        for (var N = c.length; N--; )
          if (ns(c[N][0], p))
            return N;
        return -1;
      }
      function Qg(c, p, N, re) {
        return Ds(c, function(be, Te, Fe) {
          p(re, be, N(be), Fe);
        }), re;
      }
      function Lu(c, p) {
        return c && ds(p, Jn(p), c);
      }
      function ep(c, p) {
        return c && ds(p, Mr(p), c);
      }
      function Cs(c, p, N) {
        p == "__proto__" && yo ? yo(c, p, {
          configurable: !0,
          enumerable: !0,
          value: N,
          writable: !0
        }) : c[p] = N;
      }
      function kl(c, p) {
        for (var N = -1, re = p.length, be = Ye(re), Te = c == null; ++N < re; )
          be[N] = Te ? t : ch(c, p[N]);
        return be;
      }
      function ta(c, p, N) {
        return c === c && (N !== t && (c = c <= N ? c : N), p !== t && (c = c >= p ? c : p)), c;
      }
      function Yr(c, p, N, re, be, Te) {
        var Fe, Ze = p & D, st = p & Z, kt = p & M;
        if (N && (Fe = be ? N(c, re, be, Te) : N(c)), Fe !== t)
          return Fe;
        if (!Bn(c))
          return c;
        var It = ki(c);
        if (It) {
          if (Fe = Hp(c), !Ze)
            return wr(c, Fe);
        } else {
          var Ht = hr(c), ii = Ht == on || Ht == tn;
          if (Vs(c))
            return $u(c, Ze);
          if (Ht == Re || Ht == At || ii && !be) {
            if (Fe = st || ii ? {} : mc(c), !Ze)
              return st ? kp(c, ep(Fe, c)) : Ep(c, Lu(Fe, c));
          } else {
            if (!Ri[Ht])
              return be ? c : {};
            Fe = Yp(c, Ht, Ze);
          }
        }
        Te || (Te = new is());
        var ri = Te.get(c);
        if (ri)
          return ri;
        Te.set(c, Fe), Wc(c) ? c.forEach(function(mi) {
          Fe.add(Yr(mi, p, N, mi, c, Te));
        }) : Gc(c) && c.forEach(function(mi, Yi) {
          Fe.set(Yi, Yr(mi, p, N, Yi, c, Te));
        });
        var _i = kt ? st ? Jl : Kl : st ? Mr : Jn, zi = It ? t : _i(c);
        return De(zi || c, function(mi, Yi) {
          zi && (Yi = mi, mi = c[Yi]), Pa(Fe, Yi, Yr(mi, p, N, Yi, c, Te));
        }), Fe;
      }
      function tp(c) {
        var p = Jn(c);
        return function(N) {
          return Bu(N, c, p);
        };
      }
      function Bu(c, p, N) {
        var re = N.length;
        if (c == null)
          return !re;
        for (c = at(c); re--; ) {
          var be = N[re], Te = p[be], Fe = c[be];
          if (Fe === t && !(be in c) || !Te(Fe))
            return !1;
        }
        return !0;
      }
      function Eu(c, p, N) {
        if (typeof c != "function")
          throw new Vt(u);
        return Va(function() {
          c.apply(t, N);
        }, p);
      }
      function Na(c, p, N, re) {
        var be = -1, Te = ut, Fe = !0, Ze = c.length, st = [], kt = p.length;
        if (!Ze)
          return st;
        N && (p = ti(p, Yt(N))), re ? (Te = Ut, Fe = !1) : p.length >= o && (Te = ai, Fe = !1, p = new ea(p));
        e:
          for (; ++be < Ze; ) {
            var It = c[be], Ht = N == null ? It : N(It);
            if (It = re || It !== 0 ? It : 0, Fe && Ht === Ht) {
              for (var ii = kt; ii--; )
                if (p[ii] === Ht)
                  continue e;
              st.push(It);
            } else
              Te(p, Ht, re) || st.push(It);
          }
        return st;
      }
      var Ds = nc(fs), ku = nc(Ol, !0);
      function ip(c, p) {
        var N = !0;
        return Ds(c, function(re, be, Te) {
          return N = !!p(re, be, Te), N;
        }), N;
      }
      function Ao(c, p, N) {
        for (var re = -1, be = c.length; ++re < be; ) {
          var Te = c[re], Fe = p(Te);
          if (Fe != null && (Ze === t ? Fe === Fe && !Pr(Fe) : N(Fe, Ze)))
            var Ze = Fe, st = Te;
        }
        return st;
      }
      function np(c, p, N, re) {
        var be = c.length;
        for (N = Di(N), N < 0 && (N = -N > be ? 0 : be + N), re = re === t || re > be ? be : Di(re), re < 0 && (re += be), re = N > re ? 0 : qc(re); N < re; )
          c[N++] = p;
        return c;
      }
      function Iu(c, p) {
        var N = [];
        return Ds(c, function(re, be, Te) {
          p(re, be, Te) && N.push(re);
        }), N;
      }
      function er(c, p, N, re, be) {
        var Te = -1, Fe = c.length;
        for (N || (N = jp), be || (be = []); ++Te < Fe; ) {
          var Ze = c[Te];
          p > 0 && N(Ze) ? p > 1 ? er(Ze, p - 1, N, re, be) : wi(be, Ze) : re || (be[be.length] = Ze);
        }
        return be;
      }
      var Il = rc(), Ou = rc(!0);
      function fs(c, p) {
        return c && Il(c, p, Jn);
      }
      function Ol(c, p) {
        return c && Ou(c, p, Jn);
      }
      function To(c, p) {
        return Ct(p, function(N) {
          return Bs(c[N]);
        });
      }
      function ia(c, p) {
        p = Fs(p, c);
        for (var N = 0, re = p.length; c != null && N < re; )
          c = c[gs(p[N++])];
        return N && N == re ? c : t;
      }
      function Pu(c, p, N) {
        var re = p(c);
        return ki(c) ? re : wi(re, N(c));
      }
      function pr(c) {
        return c == null ? c === t ? Xt : xt : $s && $s in at(c) ? Fp(c) : $p(c);
      }
      function Pl(c, p) {
        return c > p;
      }
      function rp(c, p) {
        return c != null && Li.call(c, p);
      }
      function sp(c, p) {
        return c != null && p in at(c);
      }
      function ap(c, p, N) {
        return c >= lr(p, N) && c < Gn(p, N);
      }
      function Nl(c, p, N) {
        for (var re = N ? Ut : ut, be = c[0].length, Te = c.length, Fe = Te, Ze = Ye(Te), st = 1 / 0, kt = []; Fe--; ) {
          var It = c[Fe];
          Fe && p && (It = ti(It, Yt(p))), st = lr(It.length, st), Ze[Fe] = !N && (p || be >= 120 && It.length >= 120) ? new ea(Fe && It) : t;
        }
        It = c[0];
        var Ht = -1, ii = Ze[0];
        e:
          for (; ++Ht < be && kt.length < st; ) {
            var ri = It[Ht], _i = p ? p(ri) : ri;
            if (ri = N || ri !== 0 ? ri : 0, !(ii ? ai(ii, _i) : re(kt, _i, N))) {
              for (Fe = Te; --Fe; ) {
                var zi = Ze[Fe];
                if (!(zi ? ai(zi, _i) : re(c[Fe], _i, N)))
                  continue e;
              }
              ii && ii.push(_i), kt.push(ri);
            }
          }
        return kt;
      }
      function op(c, p, N, re) {
        return fs(c, function(be, Te, Fe) {
          p(re, N(be), Te, Fe);
        }), re;
      }
      function Ra(c, p, N) {
        p = Fs(p, c), c = xc(c, p);
        var re = c == null ? c : c[gs(jr(p))];
        return re == null ? t : ye(re, c, N);
      }
      function Nu(c) {
        return Rn(c) && pr(c) == At;
      }
      function lp(c) {
        return Rn(c) && pr(c) == n;
      }
      function hp(c) {
        return Rn(c) && pr(c) == Wt;
      }
      function Da(c, p, N, re, be) {
        return c === p ? !0 : c == null || p == null || !Rn(c) && !Rn(p) ? c !== c && p !== p : up(c, p, N, re, Da, be);
      }
      function up(c, p, N, re, be, Te) {
        var Fe = ki(c), Ze = ki(p), st = Fe ? Ni : hr(c), kt = Ze ? Ni : hr(p);
        st = st == At ? Re : st, kt = kt == At ? Re : kt;
        var It = st == Re, Ht = kt == Re, ii = st == kt;
        if (ii && Vs(c)) {
          if (!Vs(p))
            return !1;
          Fe = !0, It = !1;
        }
        if (ii && !It)
          return Te || (Te = new is()), Fe || va(c) ? gc(c, p, N, re, be, Te) : Dp(c, p, st, N, re, be, Te);
        if (!(N & X)) {
          var ri = It && Li.call(c, "__wrapped__"), _i = Ht && Li.call(p, "__wrapped__");
          if (ri || _i) {
            var zi = ri ? c.value() : c, mi = _i ? p.value() : p;
            return Te || (Te = new is()), be(zi, mi, N, re, Te);
          }
        }
        return ii ? (Te || (Te = new is()), zp(c, p, N, re, be, Te)) : !1;
      }
      function cp(c) {
        return Rn(c) && hr(c) == pe;
      }
      function Rl(c, p, N, re) {
        var be = N.length, Te = be, Fe = !re;
        if (c == null)
          return !Te;
        for (c = at(c); be--; ) {
          var Ze = N[be];
          if (Fe && Ze[2] ? Ze[1] !== c[Ze[0]] : !(Ze[0] in c))
            return !1;
        }
        for (; ++be < Te; ) {
          Ze = N[be];
          var st = Ze[0], kt = c[st], It = Ze[1];
          if (Fe && Ze[2]) {
            if (kt === t && !(st in c))
              return !1;
          } else {
            var Ht = new is();
            if (re)
              var ii = re(kt, It, st, c, p, Ht);
            if (!(ii === t ? Da(It, kt, X | Y, re, Ht) : ii))
              return !1;
          }
        }
        return !0;
      }
      function Ru(c) {
        if (!Bn(c) || Zp(c))
          return !1;
        var p = Bs(c) ? cg : ze;
        return p.test(ra(c));
      }
      function fp(c) {
        return Rn(c) && pr(c) == Bt;
      }
      function dp(c) {
        return Rn(c) && hr(c) == dt;
      }
      function gp(c) {
        return Rn(c) && Go(c.length) && !!Fi[pr(c)];
      }
      function Du(c) {
        return typeof c == "function" ? c : c == null ? Cr : typeof c == "object" ? ki(c) ? Uu(c[0], c[1]) : Fu(c) : af(c);
      }
      function Dl(c) {
        if (!Ua(c))
          return mg(c);
        var p = [];
        for (var N in at(c))
          Li.call(c, N) && N != "constructor" && p.push(N);
        return p;
      }
      function pp(c) {
        if (!Bn(c))
          return Jp(c);
        var p = Ua(c), N = [];
        for (var re in c)
          re == "constructor" && (p || !Li.call(c, re)) || N.push(re);
        return N;
      }
      function zl(c, p) {
        return c < p;
      }
      function zu(c, p) {
        var N = -1, re = Sr(c) ? Ye(c.length) : [];
        return Ds(c, function(be, Te, Fe) {
          re[++N] = p(be, Te, Fe);
        }), re;
      }
      function Fu(c) {
        var p = Ql(c);
        return p.length == 1 && p[0][2] ? yc(p[0][0], p[0][1]) : function(N) {
          return N === c || Rl(N, c, p);
        };
      }
      function Uu(c, p) {
        return th(c) && vc(p) ? yc(gs(c), p) : function(N) {
          var re = ch(N, c);
          return re === t && re === p ? fh(N, c) : Da(p, re, X | Y);
        };
      }
      function Lo(c, p, N, re, be) {
        c !== p && Il(p, function(Te, Fe) {
          if (be || (be = new is()), Bn(Te))
            _p(c, p, Fe, N, Lo, re, be);
          else {
            var Ze = re ? re(nh(c, Fe), Te, Fe + "", c, p, be) : t;
            Ze === t && (Ze = Te), El(c, Fe, Ze);
          }
        }, Mr);
      }
      function _p(c, p, N, re, be, Te, Fe) {
        var Ze = nh(c, N), st = nh(p, N), kt = Fe.get(st);
        if (kt) {
          El(c, N, kt);
          return;
        }
        var It = Te ? Te(Ze, st, N + "", c, p, Fe) : t, Ht = It === t;
        if (Ht) {
          var ii = ki(st), ri = !ii && Vs(st), _i = !ii && !ri && va(st);
          It = st, ii || ri || _i ? ki(Ze) ? It = Ze : zn(Ze) ? It = wr(Ze) : ri ? (Ht = !1, It = $u(st, !0)) : _i ? (Ht = !1, It = Qu(st, !0)) : It = [] : Ha(st) || sa(st) ? (It = Ze, sa(Ze) ? It = Xc(Ze) : (!Bn(Ze) || Bs(Ze)) && (It = mc(st))) : Ht = !1;
        }
        Ht && (Fe.set(st, It), be(It, st, re, Te, Fe), Fe.delete(st)), El(c, N, It);
      }
      function Vu(c, p) {
        var N = c.length;
        if (N)
          return p += p < 0 ? N : 0, Ls(p, N) ? c[p] : t;
      }
      function Hu(c, p, N) {
        p.length ? p = ti(p, function(Te) {
          return ki(Te) ? function(Fe) {
            return ia(Fe, Te.length === 1 ? Te[0] : Te);
          } : Te;
        }) : p = [Cr];
        var re = -1;
        p = ti(p, Yt(fi()));
        var be = zu(c, function(Te, Fe, Ze) {
          var st = ti(p, function(kt) {
            return kt(Te);
          });
          return { criteria: st, index: ++re, value: Te };
        });
        return qn(be, function(Te, Fe) {
          return Bp(Te, Fe, N);
        });
      }
      function mp(c, p) {
        return Yu(c, p, function(N, re) {
          return fh(c, re);
        });
      }
      function Yu(c, p, N) {
        for (var re = -1, be = p.length, Te = {}; ++re < be; ) {
          var Fe = p[re], Ze = ia(c, Fe);
          N(Ze, Fe) && za(Te, Fs(Fe, c), Ze);
        }
        return Te;
      }
      function vp(c) {
        return function(p) {
          return ia(p, c);
        };
      }
      function Fl(c, p, N, re) {
        var be = re ? es : Wi, Te = -1, Fe = p.length, Ze = c;
        for (c === p && (p = wr(p)), N && (Ze = ti(c, Yt(N))); ++Te < Fe; )
          for (var st = 0, kt = p[Te], It = N ? N(kt) : kt; (st = be(Ze, It, st, re)) > -1; )
            Ze !== c && vo.call(Ze, st, 1), vo.call(c, st, 1);
        return c;
      }
      function Gu(c, p) {
        for (var N = c ? p.length : 0, re = N - 1; N--; ) {
          var be = p[N];
          if (N == re || be !== Te) {
            var Te = be;
            Ls(be) ? vo.call(c, be, 1) : Yl(c, be);
          }
        }
        return c;
      }
      function Ul(c, p) {
        return c + xo(Mu() * (p - c + 1));
      }
      function yp(c, p, N, re) {
        for (var be = -1, Te = Gn(bo((p - c) / (N || 1)), 0), Fe = Ye(Te); Te--; )
          Fe[re ? Te : ++be] = c, c += N;
        return Fe;
      }
      function Vl(c, p) {
        var N = "";
        if (!c || p < 1 || p > Gt)
          return N;
        do
          p % 2 && (N += c), p = xo(p / 2), p && (c += c);
        while (p);
        return N;
      }
      function Vi(c, p) {
        return rh(bc(c, p, Cr), c + "");
      }
      function bp(c) {
        return Tu(ya(c));
      }
      function xp(c, p) {
        var N = ya(c);
        return zo(N, ta(p, 0, N.length));
      }
      function za(c, p, N, re) {
        if (!Bn(c))
          return c;
        p = Fs(p, c);
        for (var be = -1, Te = p.length, Fe = Te - 1, Ze = c; Ze != null && ++be < Te; ) {
          var st = gs(p[be]), kt = N;
          if (st === "__proto__" || st === "constructor" || st === "prototype")
            return c;
          if (be != Fe) {
            var It = Ze[st];
            kt = re ? re(It, st, Ze) : t, kt === t && (kt = Bn(It) ? It : Ls(p[be + 1]) ? [] : {});
          }
          Pa(Ze, st, kt), Ze = Ze[st];
        }
        return c;
      }
      var ju = wo ? function(c, p) {
        return wo.set(c, p), c;
      } : Cr, wp = yo ? function(c, p) {
        return yo(c, "toString", {
          configurable: !0,
          enumerable: !1,
          value: gh(p),
          writable: !0
        });
      } : Cr;
      function Sp(c) {
        return zo(ya(c));
      }
      function Gr(c, p, N) {
        var re = -1, be = c.length;
        p < 0 && (p = -p > be ? 0 : be + p), N = N > be ? be : N, N < 0 && (N += be), be = p > N ? 0 : N - p >>> 0, p >>>= 0;
        for (var Te = Ye(be); ++re < be; )
          Te[re] = c[re + p];
        return Te;
      }
      function Mp(c, p) {
        var N;
        return Ds(c, function(re, be, Te) {
          return N = p(re, be, Te), !N;
        }), !!N;
      }
      function Bo(c, p, N) {
        var re = 0, be = c == null ? re : c.length;
        if (typeof p == "number" && p === p && be <= $t) {
          for (; re < be; ) {
            var Te = re + be >>> 1, Fe = c[Te];
            Fe !== null && !Pr(Fe) && (N ? Fe <= p : Fe < p) ? re = Te + 1 : be = Te;
          }
          return be;
        }
        return Hl(c, p, Cr, N);
      }
      function Hl(c, p, N, re) {
        var be = 0, Te = c == null ? 0 : c.length;
        if (Te === 0)
          return 0;
        p = N(p);
        for (var Fe = p !== p, Ze = p === null, st = Pr(p), kt = p === t; be < Te; ) {
          var It = xo((be + Te) / 2), Ht = N(c[It]), ii = Ht !== t, ri = Ht === null, _i = Ht === Ht, zi = Pr(Ht);
          if (Fe)
            var mi = re || _i;
          else
            kt ? mi = _i && (re || ii) : Ze ? mi = _i && ii && (re || !ri) : st ? mi = _i && ii && !ri && (re || !zi) : ri || zi ? mi = !1 : mi = re ? Ht <= p : Ht < p;
          mi ? be = It + 1 : Te = It;
        }
        return lr(Te, lt);
      }
      function Wu(c, p) {
        for (var N = -1, re = c.length, be = 0, Te = []; ++N < re; ) {
          var Fe = c[N], Ze = p ? p(Fe) : Fe;
          if (!N || !ns(Ze, st)) {
            var st = Ze;
            Te[be++] = Fe === 0 ? 0 : Fe;
          }
        }
        return Te;
      }
      function Zu(c) {
        return typeof c == "number" ? c : Pr(c) ? Zt : +c;
      }
      function Or(c) {
        if (typeof c == "string")
          return c;
        if (ki(c))
          return ti(c, Or) + "";
        if (Pr(c))
          return Cu ? Cu.call(c) : "";
        var p = c + "";
        return p == "0" && 1 / c == -ot ? "-0" : p;
      }
      function zs(c, p, N) {
        var re = -1, be = ut, Te = c.length, Fe = !0, Ze = [], st = Ze;
        if (N)
          Fe = !1, be = Ut;
        else if (Te >= o) {
          var kt = p ? null : Np(c);
          if (kt)
            return dr(kt);
          Fe = !1, be = ai, st = new ea();
        } else
          st = p ? [] : Ze;
        e:
          for (; ++re < Te; ) {
            var It = c[re], Ht = p ? p(It) : It;
            if (It = N || It !== 0 ? It : 0, Fe && Ht === Ht) {
              for (var ii = st.length; ii--; )
                if (st[ii] === Ht)
                  continue e;
              p && st.push(Ht), Ze.push(It);
            } else
              be(st, Ht, N) || (st !== Ze && st.push(Ht), Ze.push(It));
          }
        return Ze;
      }
      function Yl(c, p) {
        return p = Fs(p, c), c = xc(c, p), c == null || delete c[gs(jr(p))];
      }
      function qu(c, p, N, re) {
        return za(c, p, N(ia(c, p)), re);
      }
      function Eo(c, p, N, re) {
        for (var be = c.length, Te = re ? be : -1; (re ? Te-- : ++Te < be) && p(c[Te], Te, c); )
          ;
        return N ? Gr(c, re ? 0 : Te, re ? Te + 1 : be) : Gr(c, re ? Te + 1 : 0, re ? be : Te);
      }
      function Xu(c, p) {
        var N = c;
        return N instanceof ji && (N = N.value()), bi(p, function(re, be) {
          return be.func.apply(be.thisArg, wi([re], be.args));
        }, N);
      }
      function Gl(c, p, N) {
        var re = c.length;
        if (re < 2)
          return re ? zs(c[0]) : [];
        for (var be = -1, Te = Ye(re); ++be < re; )
          for (var Fe = c[be], Ze = -1; ++Ze < re; )
            Ze != be && (Te[be] = Na(Te[be] || Fe, c[Ze], p, N));
        return zs(er(Te, 1), p, N);
      }
      function Ku(c, p, N) {
        for (var re = -1, be = c.length, Te = p.length, Fe = {}; ++re < be; ) {
          var Ze = re < Te ? p[re] : t;
          N(Fe, c[re], Ze);
        }
        return Fe;
      }
      function jl(c) {
        return zn(c) ? c : [];
      }
      function Wl(c) {
        return typeof c == "function" ? c : Cr;
      }
      function Fs(c, p) {
        return ki(c) ? c : th(c, p) ? [c] : Cc(an(c));
      }
      var Cp = Vi;
      function Us(c, p, N) {
        var re = c.length;
        return N = N === t ? re : N, !p && N >= re ? c : Gr(c, p, N);
      }
      var Ju = fg || function(c) {
        return pn.clearTimeout(c);
      };
      function $u(c, p) {
        if (p)
          return c.slice();
        var N = c.length, re = yu ? yu(N) : new c.constructor(N);
        return c.copy(re), re;
      }
      function Zl(c) {
        var p = new c.constructor(c.byteLength);
        return new _o(p).set(new _o(c)), p;
      }
      function Ap(c, p) {
        var N = p ? Zl(c.buffer) : c.buffer;
        return new c.constructor(N, c.byteOffset, c.byteLength);
      }
      function Tp(c) {
        var p = new c.constructor(c.source, tt.exec(c));
        return p.lastIndex = c.lastIndex, p;
      }
      function Lp(c) {
        return Oa ? at(Oa.call(c)) : {};
      }
      function Qu(c, p) {
        var N = p ? Zl(c.buffer) : c.buffer;
        return new c.constructor(N, c.byteOffset, c.length);
      }
      function ec(c, p) {
        if (c !== p) {
          var N = c !== t, re = c === null, be = c === c, Te = Pr(c), Fe = p !== t, Ze = p === null, st = p === p, kt = Pr(p);
          if (!Ze && !kt && !Te && c > p || Te && Fe && st && !Ze && !kt || re && Fe && st || !N && st || !be)
            return 1;
          if (!re && !Te && !kt && c < p || kt && N && be && !re && !Te || Ze && N && be || !Fe && be || !st)
            return -1;
        }
        return 0;
      }
      function Bp(c, p, N) {
        for (var re = -1, be = c.criteria, Te = p.criteria, Fe = be.length, Ze = N.length; ++re < Fe; ) {
          var st = ec(be[re], Te[re]);
          if (st) {
            if (re >= Ze)
              return st;
            var kt = N[re];
            return st * (kt == "desc" ? -1 : 1);
          }
        }
        return c.index - p.index;
      }
      function tc(c, p, N, re) {
        for (var be = -1, Te = c.length, Fe = N.length, Ze = -1, st = p.length, kt = Gn(Te - Fe, 0), It = Ye(st + kt), Ht = !re; ++Ze < st; )
          It[Ze] = p[Ze];
        for (; ++be < Fe; )
          (Ht || be < Te) && (It[N[be]] = c[be]);
        for (; kt--; )
          It[Ze++] = c[be++];
        return It;
      }
      function ic(c, p, N, re) {
        for (var be = -1, Te = c.length, Fe = -1, Ze = N.length, st = -1, kt = p.length, It = Gn(Te - Ze, 0), Ht = Ye(It + kt), ii = !re; ++be < It; )
          Ht[be] = c[be];
        for (var ri = be; ++st < kt; )
          Ht[ri + st] = p[st];
        for (; ++Fe < Ze; )
          (ii || be < Te) && (Ht[ri + N[Fe]] = c[be++]);
        return Ht;
      }
      function wr(c, p) {
        var N = -1, re = c.length;
        for (p || (p = Ye(re)); ++N < re; )
          p[N] = c[N];
        return p;
      }
      function ds(c, p, N, re) {
        var be = !N;
        N || (N = {});
        for (var Te = -1, Fe = p.length; ++Te < Fe; ) {
          var Ze = p[Te], st = re ? re(N[Ze], c[Ze], Ze, N, c) : t;
          st === t && (st = c[Ze]), be ? Cs(N, Ze, st) : Pa(N, Ze, st);
        }
        return N;
      }
      function Ep(c, p) {
        return ds(c, eh(c), p);
      }
      function kp(c, p) {
        return ds(c, pc(c), p);
      }
      function ko(c, p) {
        return function(N, re) {
          var be = ki(N) ? Ve : Qg, Te = p ? p() : {};
          return be(N, c, fi(re, 2), Te);
        };
      }
      function pa(c) {
        return Vi(function(p, N) {
          var re = -1, be = N.length, Te = be > 1 ? N[be - 1] : t, Fe = be > 2 ? N[2] : t;
          for (Te = c.length > 3 && typeof Te == "function" ? (be--, Te) : t, Fe && _r(N[0], N[1], Fe) && (Te = be < 3 ? t : Te, be = 1), p = at(p); ++re < be; ) {
            var Ze = N[re];
            Ze && c(p, Ze, re, Te);
          }
          return p;
        });
      }
      function nc(c, p) {
        return function(N, re) {
          if (N == null)
            return N;
          if (!Sr(N))
            return c(N, re);
          for (var be = N.length, Te = p ? be : -1, Fe = at(N); (p ? Te-- : ++Te < be) && re(Fe[Te], Te, Fe) !== !1; )
            ;
          return N;
        };
      }
      function rc(c) {
        return function(p, N, re) {
          for (var be = -1, Te = at(p), Fe = re(p), Ze = Fe.length; Ze--; ) {
            var st = Fe[c ? Ze : ++be];
            if (N(Te[st], st, Te) === !1)
              break;
          }
          return p;
        };
      }
      function Ip(c, p, N) {
        var re = p & ie, be = Fa(c);
        function Te() {
          var Fe = this && this !== pn && this instanceof Te ? be : c;
          return Fe.apply(re ? N : this, arguments);
        }
        return Te;
      }
      function sc(c) {
        return function(p) {
          p = an(p);
          var N = Xn(p) ? Ln(p) : t, re = N ? N[0] : p.charAt(0), be = N ? Us(N, 1).join("") : p.slice(1);
          return re[c]() + be;
        };
      }
      function _a(c) {
        return function(p) {
          return bi(rf(nf(p).replace(qt, "")), c, "");
        };
      }
      function Fa(c) {
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return new c();
            case 1:
              return new c(p[0]);
            case 2:
              return new c(p[0], p[1]);
            case 3:
              return new c(p[0], p[1], p[2]);
            case 4:
              return new c(p[0], p[1], p[2], p[3]);
            case 5:
              return new c(p[0], p[1], p[2], p[3], p[4]);
            case 6:
              return new c(p[0], p[1], p[2], p[3], p[4], p[5]);
            case 7:
              return new c(p[0], p[1], p[2], p[3], p[4], p[5], p[6]);
          }
          var N = ga(c.prototype), re = c.apply(N, p);
          return Bn(re) ? re : N;
        };
      }
      function Op(c, p, N) {
        var re = Fa(c);
        function be() {
          for (var Te = arguments.length, Fe = Ye(Te), Ze = Te, st = ma(be); Ze--; )
            Fe[Ze] = arguments[Ze];
          var kt = Te < 3 && Fe[0] !== st && Fe[Te - 1] !== st ? [] : Yn(Fe, st);
          if (Te -= kt.length, Te < N)
            return uc(
              c,
              p,
              Io,
              be.placeholder,
              t,
              Fe,
              kt,
              t,
              t,
              N - Te
            );
          var It = this && this !== pn && this instanceof be ? re : c;
          return ye(It, this, Fe);
        }
        return be;
      }
      function ac(c) {
        return function(p, N, re) {
          var be = at(p);
          if (!Sr(p)) {
            var Te = fi(N, 3);
            p = Jn(p), N = function(Ze) {
              return Te(be[Ze], Ze, be);
            };
          }
          var Fe = c(p, N, re);
          return Fe > -1 ? be[Te ? p[Fe] : Fe] : t;
        };
      }
      function oc(c) {
        return Ts(function(p) {
          var N = p.length, re = N, be = Hr.prototype.thru;
          for (c && p.reverse(); re--; ) {
            var Te = p[re];
            if (typeof Te != "function")
              throw new Vt(u);
            if (be && !Fe && Ro(Te) == "wrapper")
              var Fe = new Hr([], !0);
          }
          for (re = Fe ? re : N; ++re < N; ) {
            Te = p[re];
            var Ze = Ro(Te), st = Ze == "wrapper" ? $l(Te) : t;
            st && ih(st[0]) && st[1] == (j | J | ve | We) && !st[4].length && st[9] == 1 ? Fe = Fe[Ro(st[0])].apply(Fe, st[3]) : Fe = Te.length == 1 && ih(Te) ? Fe[Ze]() : Fe.thru(Te);
          }
          return function() {
            var kt = arguments, It = kt[0];
            if (Fe && kt.length == 1 && ki(It))
              return Fe.plant(It).value();
            for (var Ht = 0, ii = N ? p[Ht].apply(this, kt) : It; ++Ht < N; )
              ii = p[Ht].call(this, ii);
            return ii;
          };
        });
      }
      function Io(c, p, N, re, be, Te, Fe, Ze, st, kt) {
        var It = p & j, Ht = p & ie, ii = p & G, ri = p & (J | he), _i = p & ke, zi = ii ? t : Fa(c);
        function mi() {
          for (var Yi = arguments.length, Zi = Ye(Yi), Nr = Yi; Nr--; )
            Zi[Nr] = arguments[Nr];
          if (ri)
            var mr = ma(mi), Rr = oi(Zi, mr);
          if (re && (Zi = tc(Zi, re, be, ri)), Te && (Zi = ic(Zi, Te, Fe, ri)), Yi -= Rr, ri && Yi < kt) {
            var Fn = Yn(Zi, mr);
            return uc(
              c,
              p,
              Io,
              mi.placeholder,
              N,
              Zi,
              Fn,
              Ze,
              st,
              kt - Yi
            );
          }
          var rs = Ht ? N : this, ks = ii ? rs[c] : c;
          return Yi = Zi.length, Ze ? Zi = Qp(Zi, Ze) : _i && Yi > 1 && Zi.reverse(), It && st < Yi && (Zi.length = st), this && this !== pn && this instanceof mi && (ks = zi || Fa(ks)), ks.apply(rs, Zi);
        }
        return mi;
      }
      function lc(c, p) {
        return function(N, re) {
          return op(N, c, p(re), {});
        };
      }
      function Oo(c, p) {
        return function(N, re) {
          var be;
          if (N === t && re === t)
            return p;
          if (N !== t && (be = N), re !== t) {
            if (be === t)
              return re;
            typeof N == "string" || typeof re == "string" ? (N = Or(N), re = Or(re)) : (N = Zu(N), re = Zu(re)), be = c(N, re);
          }
          return be;
        };
      }
      function ql(c) {
        return Ts(function(p) {
          return p = ti(p, Yt(fi())), Vi(function(N) {
            var re = this;
            return c(p, function(be) {
              return ye(be, re, N);
            });
          });
        });
      }
      function Po(c, p) {
        p = p === t ? " " : Or(p);
        var N = p.length;
        if (N < 2)
          return N ? Vl(p, c) : p;
        var re = Vl(p, bo(c / xr(p)));
        return Xn(p) ? Us(Ln(re), 0, c).join("") : re.slice(0, c);
      }
      function Pp(c, p, N, re) {
        var be = p & ie, Te = Fa(c);
        function Fe() {
          for (var Ze = -1, st = arguments.length, kt = -1, It = re.length, Ht = Ye(It + st), ii = this && this !== pn && this instanceof Fe ? Te : c; ++kt < It; )
            Ht[kt] = re[kt];
          for (; st--; )
            Ht[kt++] = arguments[++Ze];
          return ye(ii, be ? N : this, Ht);
        }
        return Fe;
      }
      function hc(c) {
        return function(p, N, re) {
          return re && typeof re != "number" && _r(p, N, re) && (N = re = t), p = Es(p), N === t ? (N = p, p = 0) : N = Es(N), re = re === t ? p < N ? 1 : -1 : Es(re), yp(p, N, re, c);
        };
      }
      function No(c) {
        return function(p, N) {
          return typeof p == "string" && typeof N == "string" || (p = Wr(p), N = Wr(N)), c(p, N);
        };
      }
      function uc(c, p, N, re, be, Te, Fe, Ze, st, kt) {
        var It = p & J, Ht = It ? Fe : t, ii = It ? t : Fe, ri = It ? Te : t, _i = It ? t : Te;
        p |= It ? ve : K, p &= ~(It ? K : ve), p & te || (p &= ~(ie | G));
        var zi = [
          c,
          p,
          be,
          ri,
          Ht,
          _i,
          ii,
          Ze,
          st,
          kt
        ], mi = N.apply(t, zi);
        return ih(c) && wc(mi, zi), mi.placeholder = re, Sc(mi, c, p);
      }
      function Xl(c) {
        var p = Ee[c];
        return function(N, re) {
          if (N = Wr(N), re = re == null ? 0 : lr(Di(re), 292), re && Su(N)) {
            var be = (an(N) + "e").split("e"), Te = p(be[0] + "e" + (+be[1] + re));
            return be = (an(Te) + "e").split("e"), +(be[0] + "e" + (+be[1] - re));
          }
          return p(N);
        };
      }
      var Np = fa && 1 / dr(new fa([, -0]))[1] == ot ? function(c) {
        return new fa(c);
      } : mh;
      function cc(c) {
        return function(p) {
          var N = hr(p);
          return N == pe ? Kn(p) : N == dt ? Ui(p) : Si(p, c(p));
        };
      }
      function As(c, p, N, re, be, Te, Fe, Ze) {
        var st = p & G;
        if (!st && typeof c != "function")
          throw new Vt(u);
        var kt = re ? re.length : 0;
        if (kt || (p &= ~(ve | K), re = be = t), Fe = Fe === t ? Fe : Gn(Di(Fe), 0), Ze = Ze === t ? Ze : Di(Ze), kt -= be ? be.length : 0, p & K) {
          var It = re, Ht = be;
          re = be = t;
        }
        var ii = st ? t : $l(c), ri = [
          c,
          p,
          N,
          re,
          be,
          It,
          Ht,
          Te,
          Fe,
          Ze
        ];
        if (ii && Kp(ri, ii), c = ri[0], p = ri[1], N = ri[2], re = ri[3], be = ri[4], Ze = ri[9] = ri[9] === t ? st ? 0 : c.length : Gn(ri[9] - kt, 0), !Ze && p & (J | he) && (p &= ~(J | he)), !p || p == ie)
          var _i = Ip(c, p, N);
        else
          p == J || p == he ? _i = Op(c, p, Ze) : (p == ve || p == (ie | ve)) && !be.length ? _i = Pp(c, p, N, re) : _i = Io.apply(t, ri);
        var zi = ii ? ju : wc;
        return Sc(zi(_i, ri), c, p);
      }
      function fc(c, p, N, re) {
        return c === t || ns(c, vn[N]) && !Li.call(re, N) ? p : c;
      }
      function dc(c, p, N, re, be, Te) {
        return Bn(c) && Bn(p) && (Te.set(p, c), Lo(c, p, t, dc, Te), Te.delete(p)), c;
      }
      function Rp(c) {
        return Ha(c) ? t : c;
      }
      function gc(c, p, N, re, be, Te) {
        var Fe = N & X, Ze = c.length, st = p.length;
        if (Ze != st && !(Fe && st > Ze))
          return !1;
        var kt = Te.get(c), It = Te.get(p);
        if (kt && It)
          return kt == p && It == c;
        var Ht = -1, ii = !0, ri = N & Y ? new ea() : t;
        for (Te.set(c, p), Te.set(p, c); ++Ht < Ze; ) {
          var _i = c[Ht], zi = p[Ht];
          if (re)
            var mi = Fe ? re(zi, _i, Ht, p, c, Te) : re(_i, zi, Ht, c, p, Te);
          if (mi !== t) {
            if (mi)
              continue;
            ii = !1;
            break;
          }
          if (ri) {
            if (!_n(p, function(Yi, Zi) {
              if (!ai(ri, Zi) && (_i === Yi || be(_i, Yi, N, re, Te)))
                return ri.push(Zi);
            })) {
              ii = !1;
              break;
            }
          } else if (!(_i === zi || be(_i, zi, N, re, Te))) {
            ii = !1;
            break;
          }
        }
        return Te.delete(c), Te.delete(p), ii;
      }
      function Dp(c, p, N, re, be, Te, Fe) {
        switch (N) {
          case s:
            if (c.byteLength != p.byteLength || c.byteOffset != p.byteOffset)
              return !1;
            c = c.buffer, p = p.buffer;
          case n:
            return !(c.byteLength != p.byteLength || !Te(new _o(c), new _o(p)));
          case ui:
          case Wt:
          case Tt:
            return ns(+c, +p);
          case ei:
            return c.name == p.name && c.message == p.message;
          case Bt:
          case et:
            return c == p + "";
          case pe:
            var Ze = Kn;
          case dt:
            var st = re & X;
            if (Ze || (Ze = dr), c.size != p.size && !st)
              return !1;
            var kt = Fe.get(c);
            if (kt)
              return kt == p;
            re |= Y, Fe.set(c, p);
            var It = gc(Ze(c), Ze(p), re, be, Te, Fe);
            return Fe.delete(c), It;
          case wt:
            if (Oa)
              return Oa.call(c) == Oa.call(p);
        }
        return !1;
      }
      function zp(c, p, N, re, be, Te) {
        var Fe = N & X, Ze = Kl(c), st = Ze.length, kt = Kl(p), It = kt.length;
        if (st != It && !Fe)
          return !1;
        for (var Ht = st; Ht--; ) {
          var ii = Ze[Ht];
          if (!(Fe ? ii in p : Li.call(p, ii)))
            return !1;
        }
        var ri = Te.get(c), _i = Te.get(p);
        if (ri && _i)
          return ri == p && _i == c;
        var zi = !0;
        Te.set(c, p), Te.set(p, c);
        for (var mi = Fe; ++Ht < st; ) {
          ii = Ze[Ht];
          var Yi = c[ii], Zi = p[ii];
          if (re)
            var Nr = Fe ? re(Zi, Yi, ii, p, c, Te) : re(Yi, Zi, ii, c, p, Te);
          if (!(Nr === t ? Yi === Zi || be(Yi, Zi, N, re, Te) : Nr)) {
            zi = !1;
            break;
          }
          mi || (mi = ii == "constructor");
        }
        if (zi && !mi) {
          var mr = c.constructor, Rr = p.constructor;
          mr != Rr && "constructor" in c && "constructor" in p && !(typeof mr == "function" && mr instanceof mr && typeof Rr == "function" && Rr instanceof Rr) && (zi = !1);
        }
        return Te.delete(c), Te.delete(p), zi;
      }
      function Ts(c) {
        return rh(bc(c, t, Bc), c + "");
      }
      function Kl(c) {
        return Pu(c, Jn, eh);
      }
      function Jl(c) {
        return Pu(c, Mr, pc);
      }
      var $l = wo ? function(c) {
        return wo.get(c);
      } : mh;
      function Ro(c) {
        for (var p = c.name + "", N = da[p], re = Li.call(da, p) ? N.length : 0; re--; ) {
          var be = N[re], Te = be.func;
          if (Te == null || Te == c)
            return be.name;
        }
        return p;
      }
      function ma(c) {
        var p = Li.call(Ce, "placeholder") ? Ce : c;
        return p.placeholder;
      }
      function fi() {
        var c = Ce.iteratee || ph;
        return c = c === ph ? Du : c, arguments.length ? c(arguments[0], arguments[1]) : c;
      }
      function Do(c, p) {
        var N = c.__data__;
        return Wp(p) ? N[typeof p == "string" ? "string" : "hash"] : N.map;
      }
      function Ql(c) {
        for (var p = Jn(c), N = p.length; N--; ) {
          var re = p[N], be = c[re];
          p[N] = [re, be, vc(be)];
        }
        return p;
      }
      function na(c, p) {
        var N = Ur(c, p);
        return Ru(N) ? N : t;
      }
      function Fp(c) {
        var p = Li.call(c, $s), N = c[$s];
        try {
          c[$s] = t;
          var re = !0;
        } catch {
        }
        var be = go.call(c);
        return re && (p ? c[$s] = N : delete c[$s]), be;
      }
      var eh = Tl ? function(c) {
        return c == null ? [] : (c = at(c), Ct(Tl(c), function(p) {
          return xu.call(c, p);
        }));
      } : vh, pc = Tl ? function(c) {
        for (var p = []; c; )
          wi(p, eh(c)), c = mo(c);
        return p;
      } : vh, hr = pr;
      (Ll && hr(new Ll(new ArrayBuffer(1))) != s || Ea && hr(new Ea()) != pe || Bl && hr(Bl.resolve()) != Ie || fa && hr(new fa()) != dt || ka && hr(new ka()) != He) && (hr = function(c) {
        var p = pr(c), N = p == Re ? c.constructor : t, re = N ? ra(N) : "";
        if (re)
          switch (re) {
            case xg:
              return s;
            case wg:
              return pe;
            case Sg:
              return Ie;
            case Mg:
              return dt;
            case Cg:
              return He;
          }
        return p;
      });
      function Up(c, p, N) {
        for (var re = -1, be = N.length; ++re < be; ) {
          var Te = N[re], Fe = Te.size;
          switch (Te.type) {
            case "drop":
              c += Fe;
              break;
            case "dropRight":
              p -= Fe;
              break;
            case "take":
              p = lr(p, c + Fe);
              break;
            case "takeRight":
              c = Gn(c, p - Fe);
              break;
          }
        }
        return { start: c, end: p };
      }
      function Vp(c) {
        var p = c.match(me);
        return p ? p[1].split(we) : [];
      }
      function _c(c, p, N) {
        p = Fs(p, c);
        for (var re = -1, be = p.length, Te = !1; ++re < be; ) {
          var Fe = gs(p[re]);
          if (!(Te = c != null && N(c, Fe)))
            break;
          c = c[Fe];
        }
        return Te || ++re != be ? Te : (be = c == null ? 0 : c.length, !!be && Go(be) && Ls(Fe, be) && (ki(c) || sa(c)));
      }
      function Hp(c) {
        var p = c.length, N = new c.constructor(p);
        return p && typeof c[0] == "string" && Li.call(c, "index") && (N.index = c.index, N.input = c.input), N;
      }
      function mc(c) {
        return typeof c.constructor == "function" && !Ua(c) ? ga(mo(c)) : {};
      }
      function Yp(c, p, N) {
        var re = c.constructor;
        switch (p) {
          case n:
            return Zl(c);
          case ui:
          case Wt:
            return new re(+c);
          case s:
            return Ap(c, N);
          case l:
          case h:
          case d:
          case m:
          case _:
          case b:
          case x:
          case T:
          case E:
            return Qu(c, N);
          case pe:
            return new re();
          case Tt:
          case et:
            return new re(c);
          case Bt:
            return Tp(c);
          case dt:
            return new re();
          case wt:
            return Lp(c);
        }
      }
      function Gp(c, p) {
        var N = p.length;
        if (!N)
          return c;
        var re = N - 1;
        return p[re] = (N > 1 ? "& " : "") + p[re], p = p.join(N > 2 ? ", " : " "), c.replace(ge, `{
/* [wrapped with ` + p + `] */
`);
      }
      function jp(c) {
        return ki(c) || sa(c) || !!(wu && c && c[wu]);
      }
      function Ls(c, p) {
        var N = typeof c;
        return p = p ?? Gt, !!p && (N == "number" || N != "symbol" && _t.test(c)) && c > -1 && c % 1 == 0 && c < p;
      }
      function _r(c, p, N) {
        if (!Bn(N))
          return !1;
        var re = typeof p;
        return (re == "number" ? Sr(N) && Ls(p, N.length) : re == "string" && p in N) ? ns(N[p], c) : !1;
      }
      function th(c, p) {
        if (ki(c))
          return !1;
        var N = typeof c;
        return N == "number" || N == "symbol" || N == "boolean" || c == null || Pr(c) ? !0 : V.test(c) || !W.test(c) || p != null && c in at(p);
      }
      function Wp(c) {
        var p = typeof c;
        return p == "string" || p == "number" || p == "symbol" || p == "boolean" ? c !== "__proto__" : c === null;
      }
      function ih(c) {
        var p = Ro(c), N = Ce[p];
        if (typeof N != "function" || !(p in ji.prototype))
          return !1;
        if (c === N)
          return !0;
        var re = $l(N);
        return !!re && c === re[0];
      }
      function Zp(c) {
        return !!vu && vu in c;
      }
      var qp = wn ? Bs : yh;
      function Ua(c) {
        var p = c && c.constructor, N = typeof p == "function" && p.prototype || vn;
        return c === N;
      }
      function vc(c) {
        return c === c && !Bn(c);
      }
      function yc(c, p) {
        return function(N) {
          return N == null ? !1 : N[c] === p && (p !== t || c in at(N));
        };
      }
      function Xp(c) {
        var p = Ho(c, function(re) {
          return N.size === S && N.clear(), re;
        }), N = p.cache;
        return p;
      }
      function Kp(c, p) {
        var N = c[1], re = p[1], be = N | re, Te = be < (ie | G | j), Fe = re == j && N == J || re == j && N == We && c[7].length <= p[8] || re == (j | We) && p[7].length <= p[8] && N == J;
        if (!(Te || Fe))
          return c;
        re & ie && (c[2] = p[2], be |= N & ie ? 0 : te);
        var Ze = p[3];
        if (Ze) {
          var st = c[3];
          c[3] = st ? tc(st, Ze, p[4]) : Ze, c[4] = st ? Yn(c[3], I) : p[4];
        }
        return Ze = p[5], Ze && (st = c[5], c[5] = st ? ic(st, Ze, p[6]) : Ze, c[6] = st ? Yn(c[5], I) : p[6]), Ze = p[7], Ze && (c[7] = Ze), re & j && (c[8] = c[8] == null ? p[8] : lr(c[8], p[8])), c[9] == null && (c[9] = p[9]), c[0] = p[0], c[1] = be, c;
      }
      function Jp(c) {
        var p = [];
        if (c != null)
          for (var N in at(c))
            p.push(N);
        return p;
      }
      function $p(c) {
        return go.call(c);
      }
      function bc(c, p, N) {
        return p = Gn(p === t ? c.length - 1 : p, 0), function() {
          for (var re = arguments, be = -1, Te = Gn(re.length - p, 0), Fe = Ye(Te); ++be < Te; )
            Fe[be] = re[p + be];
          be = -1;
          for (var Ze = Ye(p + 1); ++be < p; )
            Ze[be] = re[be];
          return Ze[p] = N(Fe), ye(c, this, Ze);
        };
      }
      function xc(c, p) {
        return p.length < 2 ? c : ia(c, Gr(p, 0, -1));
      }
      function Qp(c, p) {
        for (var N = c.length, re = lr(p.length, N), be = wr(c); re--; ) {
          var Te = p[re];
          c[re] = Ls(Te, N) ? be[Te] : t;
        }
        return c;
      }
      function nh(c, p) {
        if (!(p === "constructor" && typeof c[p] == "function") && p != "__proto__")
          return c[p];
      }
      var wc = Mc(ju), Va = gg || function(c, p) {
        return pn.setTimeout(c, p);
      }, rh = Mc(wp);
      function Sc(c, p, N) {
        var re = p + "";
        return rh(c, Gp(re, e_(Vp(re), N)));
      }
      function Mc(c) {
        var p = 0, N = 0;
        return function() {
          var re = vg(), be = Xe - (re - N);
          if (N = re, be > 0) {
            if (++p >= Be)
              return arguments[0];
          } else
            p = 0;
          return c.apply(t, arguments);
        };
      }
      function zo(c, p) {
        var N = -1, re = c.length, be = re - 1;
        for (p = p === t ? re : p; ++N < p; ) {
          var Te = Ul(N, be), Fe = c[Te];
          c[Te] = c[N], c[N] = Fe;
        }
        return c.length = p, c;
      }
      var Cc = Xp(function(c) {
        var p = [];
        return c.charCodeAt(0) === 46 && p.push(""), c.replace(Q, function(N, re, be, Te) {
          p.push(be ? Te.replace(Ge, "$1") : re || N);
        }), p;
      });
      function gs(c) {
        if (typeof c == "string" || Pr(c))
          return c;
        var p = c + "";
        return p == "0" && 1 / c == -ot ? "-0" : p;
      }
      function ra(c) {
        if (c != null) {
          try {
            return gr.call(c);
          } catch {
          }
          try {
            return c + "";
          } catch {
          }
        }
        return "";
      }
      function e_(c, p) {
        return De(Kt, function(N) {
          var re = "_." + N[0];
          p & N[1] && !ut(c, re) && c.push(re);
        }), c.sort();
      }
      function Ac(c) {
        if (c instanceof ji)
          return c.clone();
        var p = new Hr(c.__wrapped__, c.__chain__);
        return p.__actions__ = wr(c.__actions__), p.__index__ = c.__index__, p.__values__ = c.__values__, p;
      }
      function t_(c, p, N) {
        (N ? _r(c, p, N) : p === t) ? p = 1 : p = Gn(Di(p), 0);
        var re = c == null ? 0 : c.length;
        if (!re || p < 1)
          return [];
        for (var be = 0, Te = 0, Fe = Ye(bo(re / p)); be < re; )
          Fe[Te++] = Gr(c, be, be += p);
        return Fe;
      }
      function i_(c) {
        for (var p = -1, N = c == null ? 0 : c.length, re = 0, be = []; ++p < N; ) {
          var Te = c[p];
          Te && (be[re++] = Te);
        }
        return be;
      }
      function n_() {
        var c = arguments.length;
        if (!c)
          return [];
        for (var p = Ye(c - 1), N = arguments[0], re = c; re--; )
          p[re - 1] = arguments[re];
        return wi(ki(N) ? wr(N) : [N], er(p, 1));
      }
      var r_ = Vi(function(c, p) {
        return zn(c) ? Na(c, er(p, 1, zn, !0)) : [];
      }), s_ = Vi(function(c, p) {
        var N = jr(p);
        return zn(N) && (N = t), zn(c) ? Na(c, er(p, 1, zn, !0), fi(N, 2)) : [];
      }), a_ = Vi(function(c, p) {
        var N = jr(p);
        return zn(N) && (N = t), zn(c) ? Na(c, er(p, 1, zn, !0), t, N) : [];
      });
      function o_(c, p, N) {
        var re = c == null ? 0 : c.length;
        return re ? (p = N || p === t ? 1 : Di(p), Gr(c, p < 0 ? 0 : p, re)) : [];
      }
      function l_(c, p, N) {
        var re = c == null ? 0 : c.length;
        return re ? (p = N || p === t ? 1 : Di(p), p = re - p, Gr(c, 0, p < 0 ? 0 : p)) : [];
      }
      function h_(c, p) {
        return c && c.length ? Eo(c, fi(p, 3), !0, !0) : [];
      }
      function u_(c, p) {
        return c && c.length ? Eo(c, fi(p, 3), !0) : [];
      }
      function c_(c, p, N, re) {
        var be = c == null ? 0 : c.length;
        return be ? (N && typeof N != "number" && _r(c, p, N) && (N = 0, re = be), np(c, p, N, re)) : [];
      }
      function Tc(c, p, N) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var be = N == null ? 0 : Di(N);
        return be < 0 && (be = Gn(re + be, 0)), Oi(c, fi(p, 3), be);
      }
      function Lc(c, p, N) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var be = re - 1;
        return N !== t && (be = Di(N), be = N < 0 ? Gn(re + be, 0) : lr(be, re - 1)), Oi(c, fi(p, 3), be, !0);
      }
      function Bc(c) {
        var p = c == null ? 0 : c.length;
        return p ? er(c, 1) : [];
      }
      function f_(c) {
        var p = c == null ? 0 : c.length;
        return p ? er(c, ot) : [];
      }
      function d_(c, p) {
        var N = c == null ? 0 : c.length;
        return N ? (p = p === t ? 1 : Di(p), er(c, p)) : [];
      }
      function g_(c) {
        for (var p = -1, N = c == null ? 0 : c.length, re = {}; ++p < N; ) {
          var be = c[p];
          re[be[0]] = be[1];
        }
        return re;
      }
      function Ec(c) {
        return c && c.length ? c[0] : t;
      }
      function p_(c, p, N) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var be = N == null ? 0 : Di(N);
        return be < 0 && (be = Gn(re + be, 0)), Wi(c, p, be);
      }
      function __(c) {
        var p = c == null ? 0 : c.length;
        return p ? Gr(c, 0, -1) : [];
      }
      var m_ = Vi(function(c) {
        var p = ti(c, jl);
        return p.length && p[0] === c[0] ? Nl(p) : [];
      }), v_ = Vi(function(c) {
        var p = jr(c), N = ti(c, jl);
        return p === jr(N) ? p = t : N.pop(), N.length && N[0] === c[0] ? Nl(N, fi(p, 2)) : [];
      }), y_ = Vi(function(c) {
        var p = jr(c), N = ti(c, jl);
        return p = typeof p == "function" ? p : t, p && N.pop(), N.length && N[0] === c[0] ? Nl(N, t, p) : [];
      });
      function b_(c, p) {
        return c == null ? "" : _g.call(c, p);
      }
      function jr(c) {
        var p = c == null ? 0 : c.length;
        return p ? c[p - 1] : t;
      }
      function x_(c, p, N) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var be = re;
        return N !== t && (be = Di(N), be = be < 0 ? Gn(re + be, 0) : lr(be, re - 1)), p === p ? cs(c, p, be) : Oi(c, sr, be, !0);
      }
      function w_(c, p) {
        return c && c.length ? Vu(c, Di(p)) : t;
      }
      var S_ = Vi(kc);
      function kc(c, p) {
        return c && c.length && p && p.length ? Fl(c, p) : c;
      }
      function M_(c, p, N) {
        return c && c.length && p && p.length ? Fl(c, p, fi(N, 2)) : c;
      }
      function C_(c, p, N) {
        return c && c.length && p && p.length ? Fl(c, p, t, N) : c;
      }
      var A_ = Ts(function(c, p) {
        var N = c == null ? 0 : c.length, re = kl(c, p);
        return Gu(c, ti(p, function(be) {
          return Ls(be, N) ? +be : be;
        }).sort(ec)), re;
      });
      function T_(c, p) {
        var N = [];
        if (!(c && c.length))
          return N;
        var re = -1, be = [], Te = c.length;
        for (p = fi(p, 3); ++re < Te; ) {
          var Fe = c[re];
          p(Fe, re, c) && (N.push(Fe), be.push(re));
        }
        return Gu(c, be), N;
      }
      function sh(c) {
        return c == null ? c : bg.call(c);
      }
      function L_(c, p, N) {
        var re = c == null ? 0 : c.length;
        return re ? (N && typeof N != "number" && _r(c, p, N) ? (p = 0, N = re) : (p = p == null ? 0 : Di(p), N = N === t ? re : Di(N)), Gr(c, p, N)) : [];
      }
      function B_(c, p) {
        return Bo(c, p);
      }
      function E_(c, p, N) {
        return Hl(c, p, fi(N, 2));
      }
      function k_(c, p) {
        var N = c == null ? 0 : c.length;
        if (N) {
          var re = Bo(c, p);
          if (re < N && ns(c[re], p))
            return re;
        }
        return -1;
      }
      function I_(c, p) {
        return Bo(c, p, !0);
      }
      function O_(c, p, N) {
        return Hl(c, p, fi(N, 2), !0);
      }
      function P_(c, p) {
        var N = c == null ? 0 : c.length;
        if (N) {
          var re = Bo(c, p, !0) - 1;
          if (ns(c[re], p))
            return re;
        }
        return -1;
      }
      function N_(c) {
        return c && c.length ? Wu(c) : [];
      }
      function R_(c, p) {
        return c && c.length ? Wu(c, fi(p, 2)) : [];
      }
      function D_(c) {
        var p = c == null ? 0 : c.length;
        return p ? Gr(c, 1, p) : [];
      }
      function z_(c, p, N) {
        return c && c.length ? (p = N || p === t ? 1 : Di(p), Gr(c, 0, p < 0 ? 0 : p)) : [];
      }
      function F_(c, p, N) {
        var re = c == null ? 0 : c.length;
        return re ? (p = N || p === t ? 1 : Di(p), p = re - p, Gr(c, p < 0 ? 0 : p, re)) : [];
      }
      function U_(c, p) {
        return c && c.length ? Eo(c, fi(p, 3), !1, !0) : [];
      }
      function V_(c, p) {
        return c && c.length ? Eo(c, fi(p, 3)) : [];
      }
      var H_ = Vi(function(c) {
        return zs(er(c, 1, zn, !0));
      }), Y_ = Vi(function(c) {
        var p = jr(c);
        return zn(p) && (p = t), zs(er(c, 1, zn, !0), fi(p, 2));
      }), G_ = Vi(function(c) {
        var p = jr(c);
        return p = typeof p == "function" ? p : t, zs(er(c, 1, zn, !0), t, p);
      });
      function j_(c) {
        return c && c.length ? zs(c) : [];
      }
      function W_(c, p) {
        return c && c.length ? zs(c, fi(p, 2)) : [];
      }
      function Z_(c, p) {
        return p = typeof p == "function" ? p : t, c && c.length ? zs(c, t, p) : [];
      }
      function ah(c) {
        if (!(c && c.length))
          return [];
        var p = 0;
        return c = Ct(c, function(N) {
          if (zn(N))
            return p = Gn(N.length, p), !0;
        }), Er(p, function(N) {
          return ti(c, fr(N));
        });
      }
      function Ic(c, p) {
        if (!(c && c.length))
          return [];
        var N = ah(c);
        return p == null ? N : ti(N, function(re) {
          return ye(p, t, re);
        });
      }
      var q_ = Vi(function(c, p) {
        return zn(c) ? Na(c, p) : [];
      }), X_ = Vi(function(c) {
        return Gl(Ct(c, zn));
      }), K_ = Vi(function(c) {
        var p = jr(c);
        return zn(p) && (p = t), Gl(Ct(c, zn), fi(p, 2));
      }), J_ = Vi(function(c) {
        var p = jr(c);
        return p = typeof p == "function" ? p : t, Gl(Ct(c, zn), t, p);
      }), $_ = Vi(ah);
      function Q_(c, p) {
        return Ku(c || [], p || [], Pa);
      }
      function em(c, p) {
        return Ku(c || [], p || [], za);
      }
      var tm = Vi(function(c) {
        var p = c.length, N = p > 1 ? c[p - 1] : t;
        return N = typeof N == "function" ? (c.pop(), N) : t, Ic(c, N);
      });
      function Oc(c) {
        var p = Ce(c);
        return p.__chain__ = !0, p;
      }
      function im(c, p) {
        return p(c), c;
      }
      function Fo(c, p) {
        return p(c);
      }
      var nm = Ts(function(c) {
        var p = c.length, N = p ? c[0] : 0, re = this.__wrapped__, be = function(Te) {
          return kl(Te, c);
        };
        return p > 1 || this.__actions__.length || !(re instanceof ji) || !Ls(N) ? this.thru(be) : (re = re.slice(N, +N + (p ? 1 : 0)), re.__actions__.push({
          func: Fo,
          args: [be],
          thisArg: t
        }), new Hr(re, this.__chain__).thru(function(Te) {
          return p && !Te.length && Te.push(t), Te;
        }));
      });
      function rm() {
        return Oc(this);
      }
      function sm() {
        return new Hr(this.value(), this.__chain__);
      }
      function am() {
        this.__values__ === t && (this.__values__ = Zc(this.value()));
        var c = this.__index__ >= this.__values__.length, p = c ? t : this.__values__[this.__index__++];
        return { done: c, value: p };
      }
      function om() {
        return this;
      }
      function lm(c) {
        for (var p, N = this; N instanceof Mo; ) {
          var re = Ac(N);
          re.__index__ = 0, re.__values__ = t, p ? be.__wrapped__ = re : p = re;
          var be = re;
          N = N.__wrapped__;
        }
        return be.__wrapped__ = c, p;
      }
      function hm() {
        var c = this.__wrapped__;
        if (c instanceof ji) {
          var p = c;
          return this.__actions__.length && (p = new ji(this)), p = p.reverse(), p.__actions__.push({
            func: Fo,
            args: [sh],
            thisArg: t
          }), new Hr(p, this.__chain__);
        }
        return this.thru(sh);
      }
      function um() {
        return Xu(this.__wrapped__, this.__actions__);
      }
      var cm = ko(function(c, p, N) {
        Li.call(c, N) ? ++c[N] : Cs(c, N, 1);
      });
      function fm(c, p, N) {
        var re = ki(c) ? St : ip;
        return N && _r(c, p, N) && (p = t), re(c, fi(p, 3));
      }
      function dm(c, p) {
        var N = ki(c) ? Ct : Iu;
        return N(c, fi(p, 3));
      }
      var gm = ac(Tc), pm = ac(Lc);
      function _m(c, p) {
        return er(Uo(c, p), 1);
      }
      function mm(c, p) {
        return er(Uo(c, p), ot);
      }
      function vm(c, p, N) {
        return N = N === t ? 1 : Di(N), er(Uo(c, p), N);
      }
      function Pc(c, p) {
        var N = ki(c) ? De : Ds;
        return N(c, fi(p, 3));
      }
      function Nc(c, p) {
        var N = ki(c) ? Ke : ku;
        return N(c, fi(p, 3));
      }
      var ym = ko(function(c, p, N) {
        Li.call(c, N) ? c[N].push(p) : Cs(c, N, [p]);
      });
      function bm(c, p, N, re) {
        c = Sr(c) ? c : ya(c), N = N && !re ? Di(N) : 0;
        var be = c.length;
        return N < 0 && (N = Gn(be + N, 0)), jo(c) ? N <= be && c.indexOf(p, N) > -1 : !!be && Wi(c, p, N) > -1;
      }
      var xm = Vi(function(c, p, N) {
        var re = -1, be = typeof p == "function", Te = Sr(c) ? Ye(c.length) : [];
        return Ds(c, function(Fe) {
          Te[++re] = be ? ye(p, Fe, N) : Ra(Fe, p, N);
        }), Te;
      }), wm = ko(function(c, p, N) {
        Cs(c, N, p);
      });
      function Uo(c, p) {
        var N = ki(c) ? ti : zu;
        return N(c, fi(p, 3));
      }
      function Sm(c, p, N, re) {
        return c == null ? [] : (ki(p) || (p = p == null ? [] : [p]), N = re ? t : N, ki(N) || (N = N == null ? [] : [N]), Hu(c, p, N));
      }
      var Mm = ko(function(c, p, N) {
        c[N ? 0 : 1].push(p);
      }, function() {
        return [[], []];
      });
      function Cm(c, p, N) {
        var re = ki(c) ? bi : Jt, be = arguments.length < 3;
        return re(c, fi(p, 4), N, be, Ds);
      }
      function Am(c, p, N) {
        var re = ki(c) ? An : Jt, be = arguments.length < 3;
        return re(c, fi(p, 4), N, be, ku);
      }
      function Tm(c, p) {
        var N = ki(c) ? Ct : Iu;
        return N(c, Yo(fi(p, 3)));
      }
      function Lm(c) {
        var p = ki(c) ? Tu : bp;
        return p(c);
      }
      function Bm(c, p, N) {
        (N ? _r(c, p, N) : p === t) ? p = 1 : p = Di(p);
        var re = ki(c) ? Jg : xp;
        return re(c, p);
      }
      function Em(c) {
        var p = ki(c) ? $g : Sp;
        return p(c);
      }
      function km(c) {
        if (c == null)
          return 0;
        if (Sr(c))
          return jo(c) ? xr(c) : c.length;
        var p = hr(c);
        return p == pe || p == dt ? c.size : Dl(c).length;
      }
      function Im(c, p, N) {
        var re = ki(c) ? _n : Mp;
        return N && _r(c, p, N) && (p = t), re(c, fi(p, 3));
      }
      var Om = Vi(function(c, p) {
        if (c == null)
          return [];
        var N = p.length;
        return N > 1 && _r(c, p[0], p[1]) ? p = [] : N > 2 && _r(p[0], p[1], p[2]) && (p = [p[0]]), Hu(c, er(p, 1), []);
      }), Vo = dg || function() {
        return pn.Date.now();
      };
      function Pm(c, p) {
        if (typeof p != "function")
          throw new Vt(u);
        return c = Di(c), function() {
          if (--c < 1)
            return p.apply(this, arguments);
        };
      }
      function Rc(c, p, N) {
        return p = N ? t : p, p = c && p == null ? c.length : p, As(c, j, t, t, t, t, p);
      }
      function Dc(c, p) {
        var N;
        if (typeof p != "function")
          throw new Vt(u);
        return c = Di(c), function() {
          return --c > 0 && (N = p.apply(this, arguments)), c <= 1 && (p = t), N;
        };
      }
      var oh = Vi(function(c, p, N) {
        var re = ie;
        if (N.length) {
          var be = Yn(N, ma(oh));
          re |= ve;
        }
        return As(c, re, p, N, be);
      }), zc = Vi(function(c, p, N) {
        var re = ie | G;
        if (N.length) {
          var be = Yn(N, ma(zc));
          re |= ve;
        }
        return As(p, re, c, N, be);
      });
      function Fc(c, p, N) {
        p = N ? t : p;
        var re = As(c, J, t, t, t, t, t, p);
        return re.placeholder = Fc.placeholder, re;
      }
      function Uc(c, p, N) {
        p = N ? t : p;
        var re = As(c, he, t, t, t, t, t, p);
        return re.placeholder = Uc.placeholder, re;
      }
      function Vc(c, p, N) {
        var re, be, Te, Fe, Ze, st, kt = 0, It = !1, Ht = !1, ii = !0;
        if (typeof c != "function")
          throw new Vt(u);
        p = Wr(p) || 0, Bn(N) && (It = !!N.leading, Ht = "maxWait" in N, Te = Ht ? Gn(Wr(N.maxWait) || 0, p) : Te, ii = "trailing" in N ? !!N.trailing : ii);
        function ri(Fn) {
          var rs = re, ks = be;
          return re = be = t, kt = Fn, Fe = c.apply(ks, rs), Fe;
        }
        function _i(Fn) {
          return kt = Fn, Ze = Va(Yi, p), It ? ri(Fn) : Fe;
        }
        function zi(Fn) {
          var rs = Fn - st, ks = Fn - kt, of = p - rs;
          return Ht ? lr(of, Te - ks) : of;
        }
        function mi(Fn) {
          var rs = Fn - st, ks = Fn - kt;
          return st === t || rs >= p || rs < 0 || Ht && ks >= Te;
        }
        function Yi() {
          var Fn = Vo();
          if (mi(Fn))
            return Zi(Fn);
          Ze = Va(Yi, zi(Fn));
        }
        function Zi(Fn) {
          return Ze = t, ii && re ? ri(Fn) : (re = be = t, Fe);
        }
        function Nr() {
          Ze !== t && Ju(Ze), kt = 0, re = st = be = Ze = t;
        }
        function mr() {
          return Ze === t ? Fe : Zi(Vo());
        }
        function Rr() {
          var Fn = Vo(), rs = mi(Fn);
          if (re = arguments, be = this, st = Fn, rs) {
            if (Ze === t)
              return _i(st);
            if (Ht)
              return Ju(Ze), Ze = Va(Yi, p), ri(st);
          }
          return Ze === t && (Ze = Va(Yi, p)), Fe;
        }
        return Rr.cancel = Nr, Rr.flush = mr, Rr;
      }
      var Nm = Vi(function(c, p) {
        return Eu(c, 1, p);
      }), Rm = Vi(function(c, p, N) {
        return Eu(c, Wr(p) || 0, N);
      });
      function Dm(c) {
        return As(c, ke);
      }
      function Ho(c, p) {
        if (typeof c != "function" || p != null && typeof p != "function")
          throw new Vt(u);
        var N = function() {
          var re = arguments, be = p ? p.apply(this, re) : re[0], Te = N.cache;
          if (Te.has(be))
            return Te.get(be);
          var Fe = c.apply(this, re);
          return N.cache = Te.set(be, Fe) || Te, Fe;
        };
        return N.cache = new (Ho.Cache || Ms)(), N;
      }
      Ho.Cache = Ms;
      function Yo(c) {
        if (typeof c != "function")
          throw new Vt(u);
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return !c.call(this);
            case 1:
              return !c.call(this, p[0]);
            case 2:
              return !c.call(this, p[0], p[1]);
            case 3:
              return !c.call(this, p[0], p[1], p[2]);
          }
          return !c.apply(this, p);
        };
      }
      function zm(c) {
        return Dc(2, c);
      }
      var Fm = Cp(function(c, p) {
        p = p.length == 1 && ki(p[0]) ? ti(p[0], Yt(fi())) : ti(er(p, 1), Yt(fi()));
        var N = p.length;
        return Vi(function(re) {
          for (var be = -1, Te = lr(re.length, N); ++be < Te; )
            re[be] = p[be].call(this, re[be]);
          return ye(c, this, re);
        });
      }), lh = Vi(function(c, p) {
        var N = Yn(p, ma(lh));
        return As(c, ve, t, p, N);
      }), Hc = Vi(function(c, p) {
        var N = Yn(p, ma(Hc));
        return As(c, K, t, p, N);
      }), Um = Ts(function(c, p) {
        return As(c, We, t, t, t, p);
      });
      function Vm(c, p) {
        if (typeof c != "function")
          throw new Vt(u);
        return p = p === t ? p : Di(p), Vi(c, p);
      }
      function Hm(c, p) {
        if (typeof c != "function")
          throw new Vt(u);
        return p = p == null ? 0 : Gn(Di(p), 0), Vi(function(N) {
          var re = N[p], be = Us(N, 0, p);
          return re && wi(be, re), ye(c, this, be);
        });
      }
      function Ym(c, p, N) {
        var re = !0, be = !0;
        if (typeof c != "function")
          throw new Vt(u);
        return Bn(N) && (re = "leading" in N ? !!N.leading : re, be = "trailing" in N ? !!N.trailing : be), Vc(c, p, {
          leading: re,
          maxWait: p,
          trailing: be
        });
      }
      function Gm(c) {
        return Rc(c, 1);
      }
      function jm(c, p) {
        return lh(Wl(p), c);
      }
      function Wm() {
        if (!arguments.length)
          return [];
        var c = arguments[0];
        return ki(c) ? c : [c];
      }
      function Zm(c) {
        return Yr(c, M);
      }
      function qm(c, p) {
        return p = typeof p == "function" ? p : t, Yr(c, M, p);
      }
      function Xm(c) {
        return Yr(c, D | M);
      }
      function Km(c, p) {
        return p = typeof p == "function" ? p : t, Yr(c, D | M, p);
      }
      function Jm(c, p) {
        return p == null || Bu(c, p, Jn(p));
      }
      function ns(c, p) {
        return c === p || c !== c && p !== p;
      }
      var $m = No(Pl), Qm = No(function(c, p) {
        return c >= p;
      }), sa = Nu(function() {
        return arguments;
      }()) ? Nu : function(c) {
        return Rn(c) && Li.call(c, "callee") && !xu.call(c, "callee");
      }, ki = Ye.isArray, e0 = w ? Yt(w) : lp;
      function Sr(c) {
        return c != null && Go(c.length) && !Bs(c);
      }
      function zn(c) {
        return Rn(c) && Sr(c);
      }
      function t0(c) {
        return c === !0 || c === !1 || Rn(c) && pr(c) == ui;
      }
      var Vs = pg || yh, i0 = O ? Yt(O) : hp;
      function n0(c) {
        return Rn(c) && c.nodeType === 1 && !Ha(c);
      }
      function r0(c) {
        if (c == null)
          return !0;
        if (Sr(c) && (ki(c) || typeof c == "string" || typeof c.splice == "function" || Vs(c) || va(c) || sa(c)))
          return !c.length;
        var p = hr(c);
        if (p == pe || p == dt)
          return !c.size;
        if (Ua(c))
          return !Dl(c).length;
        for (var N in c)
          if (Li.call(c, N))
            return !1;
        return !0;
      }
      function s0(c, p) {
        return Da(c, p);
      }
      function a0(c, p, N) {
        N = typeof N == "function" ? N : t;
        var re = N ? N(c, p) : t;
        return re === t ? Da(c, p, t, N) : !!re;
      }
      function hh(c) {
        if (!Rn(c))
          return !1;
        var p = pr(c);
        return p == ei || p == Qt || typeof c.message == "string" && typeof c.name == "string" && !Ha(c);
      }
      function o0(c) {
        return typeof c == "number" && Su(c);
      }
      function Bs(c) {
        if (!Bn(c))
          return !1;
        var p = pr(c);
        return p == on || p == tn || p == rn || p == Qe;
      }
      function Yc(c) {
        return typeof c == "number" && c == Di(c);
      }
      function Go(c) {
        return typeof c == "number" && c > -1 && c % 1 == 0 && c <= Gt;
      }
      function Bn(c) {
        var p = typeof c;
        return c != null && (p == "object" || p == "function");
      }
      function Rn(c) {
        return c != null && typeof c == "object";
      }
      var Gc = q ? Yt(q) : cp;
      function l0(c, p) {
        return c === p || Rl(c, p, Ql(p));
      }
      function h0(c, p, N) {
        return N = typeof N == "function" ? N : t, Rl(c, p, Ql(p), N);
      }
      function u0(c) {
        return jc(c) && c != +c;
      }
      function c0(c) {
        if (qp(c))
          throw new oe(a);
        return Ru(c);
      }
      function f0(c) {
        return c === null;
      }
      function d0(c) {
        return c == null;
      }
      function jc(c) {
        return typeof c == "number" || Rn(c) && pr(c) == Tt;
      }
      function Ha(c) {
        if (!Rn(c) || pr(c) != Re)
          return !1;
        var p = mo(c);
        if (p === null)
          return !0;
        var N = Li.call(p, "constructor") && p.constructor;
        return typeof N == "function" && N instanceof N && gr.call(N) == hg;
      }
      var uh = ne ? Yt(ne) : fp;
      function g0(c) {
        return Yc(c) && c >= -Gt && c <= Gt;
      }
      var Wc = de ? Yt(de) : dp;
      function jo(c) {
        return typeof c == "string" || !ki(c) && Rn(c) && pr(c) == et;
      }
      function Pr(c) {
        return typeof c == "symbol" || Rn(c) && pr(c) == wt;
      }
      var va = _e ? Yt(_e) : gp;
      function p0(c) {
        return c === t;
      }
      function _0(c) {
        return Rn(c) && hr(c) == He;
      }
      function m0(c) {
        return Rn(c) && pr(c) == i;
      }
      var v0 = No(zl), y0 = No(function(c, p) {
        return c <= p;
      });
      function Zc(c) {
        if (!c)
          return [];
        if (Sr(c))
          return jo(c) ? Ln(c) : wr(c);
        if (Ba && c[Ba])
          return Nn(c[Ba]());
        var p = hr(c), N = p == pe ? Kn : p == dt ? dr : ya;
        return N(c);
      }
      function Es(c) {
        if (!c)
          return c === 0 ? c : 0;
        if (c = Wr(c), c === ot || c === -ot) {
          var p = c < 0 ? -1 : 1;
          return p * it;
        }
        return c === c ? c : 0;
      }
      function Di(c) {
        var p = Es(c), N = p % 1;
        return p === p ? N ? p - N : p : 0;
      }
      function qc(c) {
        return c ? ta(Di(c), 0, ct) : 0;
      }
      function Wr(c) {
        if (typeof c == "number")
          return c;
        if (Pr(c))
          return Zt;
        if (Bn(c)) {
          var p = typeof c.valueOf == "function" ? c.valueOf() : c;
          c = Bn(p) ? p + "" : p;
        }
        if (typeof c != "string")
          return c === 0 ? c : +c;
        c = sn(c);
        var N = Ne.test(c);
        return N || nt.test(c) ? Ks(c.slice(2), N ? 2 : 8) : ft.test(c) ? Zt : +c;
      }
      function Xc(c) {
        return ds(c, Mr(c));
      }
      function b0(c) {
        return c ? ta(Di(c), -Gt, Gt) : c === 0 ? c : 0;
      }
      function an(c) {
        return c == null ? "" : Or(c);
      }
      var x0 = pa(function(c, p) {
        if (Ua(p) || Sr(p)) {
          ds(p, Jn(p), c);
          return;
        }
        for (var N in p)
          Li.call(p, N) && Pa(c, N, p[N]);
      }), Kc = pa(function(c, p) {
        ds(p, Mr(p), c);
      }), Wo = pa(function(c, p, N, re) {
        ds(p, Mr(p), c, re);
      }), w0 = pa(function(c, p, N, re) {
        ds(p, Jn(p), c, re);
      }), S0 = Ts(kl);
      function M0(c, p) {
        var N = ga(c);
        return p == null ? N : Lu(N, p);
      }
      var C0 = Vi(function(c, p) {
        c = at(c);
        var N = -1, re = p.length, be = re > 2 ? p[2] : t;
        for (be && _r(p[0], p[1], be) && (re = 1); ++N < re; )
          for (var Te = p[N], Fe = Mr(Te), Ze = -1, st = Fe.length; ++Ze < st; ) {
            var kt = Fe[Ze], It = c[kt];
            (It === t || ns(It, vn[kt]) && !Li.call(c, kt)) && (c[kt] = Te[kt]);
          }
        return c;
      }), A0 = Vi(function(c) {
        return c.push(t, dc), ye(Jc, t, c);
      });
      function T0(c, p) {
        return On(c, fi(p, 3), fs);
      }
      function L0(c, p) {
        return On(c, fi(p, 3), Ol);
      }
      function B0(c, p) {
        return c == null ? c : Il(c, fi(p, 3), Mr);
      }
      function E0(c, p) {
        return c == null ? c : Ou(c, fi(p, 3), Mr);
      }
      function k0(c, p) {
        return c && fs(c, fi(p, 3));
      }
      function I0(c, p) {
        return c && Ol(c, fi(p, 3));
      }
      function O0(c) {
        return c == null ? [] : To(c, Jn(c));
      }
      function P0(c) {
        return c == null ? [] : To(c, Mr(c));
      }
      function ch(c, p, N) {
        var re = c == null ? t : ia(c, p);
        return re === t ? N : re;
      }
      function N0(c, p) {
        return c != null && _c(c, p, rp);
      }
      function fh(c, p) {
        return c != null && _c(c, p, sp);
      }
      var R0 = lc(function(c, p, N) {
        p != null && typeof p.toString != "function" && (p = go.call(p)), c[p] = N;
      }, gh(Cr)), D0 = lc(function(c, p, N) {
        p != null && typeof p.toString != "function" && (p = go.call(p)), Li.call(c, p) ? c[p].push(N) : c[p] = [N];
      }, fi), z0 = Vi(Ra);
      function Jn(c) {
        return Sr(c) ? Au(c) : Dl(c);
      }
      function Mr(c) {
        return Sr(c) ? Au(c, !0) : pp(c);
      }
      function F0(c, p) {
        var N = {};
        return p = fi(p, 3), fs(c, function(re, be, Te) {
          Cs(N, p(re, be, Te), re);
        }), N;
      }
      function U0(c, p) {
        var N = {};
        return p = fi(p, 3), fs(c, function(re, be, Te) {
          Cs(N, be, p(re, be, Te));
        }), N;
      }
      var V0 = pa(function(c, p, N) {
        Lo(c, p, N);
      }), Jc = pa(function(c, p, N, re) {
        Lo(c, p, N, re);
      }), H0 = Ts(function(c, p) {
        var N = {};
        if (c == null)
          return N;
        var re = !1;
        p = ti(p, function(Te) {
          return Te = Fs(Te, c), re || (re = Te.length > 1), Te;
        }), ds(c, Jl(c), N), re && (N = Yr(N, D | Z | M, Rp));
        for (var be = p.length; be--; )
          Yl(N, p[be]);
        return N;
      });
      function Y0(c, p) {
        return $c(c, Yo(fi(p)));
      }
      var G0 = Ts(function(c, p) {
        return c == null ? {} : mp(c, p);
      });
      function $c(c, p) {
        if (c == null)
          return {};
        var N = ti(Jl(c), function(re) {
          return [re];
        });
        return p = fi(p), Yu(c, N, function(re, be) {
          return p(re, be[0]);
        });
      }
      function j0(c, p, N) {
        p = Fs(p, c);
        var re = -1, be = p.length;
        for (be || (be = 1, c = t); ++re < be; ) {
          var Te = c == null ? t : c[gs(p[re])];
          Te === t && (re = be, Te = N), c = Bs(Te) ? Te.call(c) : Te;
        }
        return c;
      }
      function W0(c, p, N) {
        return c == null ? c : za(c, p, N);
      }
      function Z0(c, p, N, re) {
        return re = typeof re == "function" ? re : t, c == null ? c : za(c, p, N, re);
      }
      var Qc = cc(Jn), ef = cc(Mr);
      function q0(c, p, N) {
        var re = ki(c), be = re || Vs(c) || va(c);
        if (p = fi(p, 4), N == null) {
          var Te = c && c.constructor;
          be ? N = re ? new Te() : [] : Bn(c) ? N = Bs(Te) ? ga(mo(c)) : {} : N = {};
        }
        return (be ? De : fs)(c, function(Fe, Ze, st) {
          return p(N, Fe, Ze, st);
        }), N;
      }
      function X0(c, p) {
        return c == null ? !0 : Yl(c, p);
      }
      function K0(c, p, N) {
        return c == null ? c : qu(c, p, Wl(N));
      }
      function J0(c, p, N, re) {
        return re = typeof re == "function" ? re : t, c == null ? c : qu(c, p, Wl(N), re);
      }
      function ya(c) {
        return c == null ? [] : kr(c, Jn(c));
      }
      function $0(c) {
        return c == null ? [] : kr(c, Mr(c));
      }
      function Q0(c, p, N) {
        return N === t && (N = p, p = t), N !== t && (N = Wr(N), N = N === N ? N : 0), p !== t && (p = Wr(p), p = p === p ? p : 0), ta(Wr(c), p, N);
      }
      function ev(c, p, N) {
        return p = Es(p), N === t ? (N = p, p = 0) : N = Es(N), c = Wr(c), ap(c, p, N);
      }
      function tv(c, p, N) {
        if (N && typeof N != "boolean" && _r(c, p, N) && (p = N = t), N === t && (typeof p == "boolean" ? (N = p, p = t) : typeof c == "boolean" && (N = c, c = t)), c === t && p === t ? (c = 0, p = 1) : (c = Es(c), p === t ? (p = c, c = 0) : p = Es(p)), c > p) {
          var re = c;
          c = p, p = re;
        }
        if (N || c % 1 || p % 1) {
          var be = Mu();
          return lr(c + be * (p - c + xs("1e-" + ((be + "").length - 1))), p);
        }
        return Ul(c, p);
      }
      var iv = _a(function(c, p, N) {
        return p = p.toLowerCase(), c + (N ? tf(p) : p);
      });
      function tf(c) {
        return dh(an(c).toLowerCase());
      }
      function nf(c) {
        return c = an(c), c && c.replace(mt, dn).replace(gi, "");
      }
      function nv(c, p, N) {
        c = an(c), p = Or(p);
        var re = c.length;
        N = N === t ? re : ta(Di(N), 0, re);
        var be = N;
        return N -= p.length, N >= 0 && c.slice(N, be) == p;
      }
      function rv(c) {
        return c = an(c), c && R.test(c) ? c.replace(F, Ir) : c;
      }
      function sv(c) {
        return c = an(c), c && le.test(c) ? c.replace(ae, "\\$&") : c;
      }
      var av = _a(function(c, p, N) {
        return c + (N ? "-" : "") + p.toLowerCase();
      }), ov = _a(function(c, p, N) {
        return c + (N ? " " : "") + p.toLowerCase();
      }), lv = sc("toLowerCase");
      function hv(c, p, N) {
        c = an(c), p = Di(p);
        var re = p ? xr(c) : 0;
        if (!p || re >= p)
          return c;
        var be = (p - re) / 2;
        return Po(xo(be), N) + c + Po(bo(be), N);
      }
      function uv(c, p, N) {
        c = an(c), p = Di(p);
        var re = p ? xr(c) : 0;
        return p && re < p ? c + Po(p - re, N) : c;
      }
      function cv(c, p, N) {
        c = an(c), p = Di(p);
        var re = p ? xr(c) : 0;
        return p && re < p ? Po(p - re, N) + c : c;
      }
      function fv(c, p, N) {
        return N || p == null ? p = 0 : p && (p = +p), yg(an(c).replace(fe, ""), p || 0);
      }
      function dv(c, p, N) {
        return (N ? _r(c, p, N) : p === t) ? p = 1 : p = Di(p), Vl(an(c), p);
      }
      function gv() {
        var c = arguments, p = an(c[0]);
        return c.length < 3 ? p : p.replace(c[1], c[2]);
      }
      var pv = _a(function(c, p, N) {
        return c + (N ? "_" : "") + p.toLowerCase();
      });
      function _v(c, p, N) {
        return N && typeof N != "number" && _r(c, p, N) && (p = N = t), N = N === t ? ct : N >>> 0, N ? (c = an(c), c && (typeof p == "string" || p != null && !uh(p)) && (p = Or(p), !p && Xn(c)) ? Us(Ln(c), 0, N) : c.split(p, N)) : [];
      }
      var mv = _a(function(c, p, N) {
        return c + (N ? " " : "") + dh(p);
      });
      function vv(c, p, N) {
        return c = an(c), N = N == null ? 0 : ta(Di(N), 0, c.length), p = Or(p), c.slice(N, N + p.length) == p;
      }
      function yv(c, p, N) {
        var re = Ce.templateSettings;
        N && _r(c, p, N) && (p = t), c = an(c), p = Wo({}, p, re, fc);
        var be = Wo({}, p.imports, re.imports, fc), Te = Jn(be), Fe = kr(be, Te), Ze, st, kt = 0, It = p.interpolate || Pt, Ht = "__p += '", ii = Mt(
          (p.escape || Pt).source + "|" + It.source + "|" + (It === H ? Je : Pt).source + "|" + (p.evaluate || Pt).source + "|$",
          "g"
        ), ri = "//# sourceURL=" + (Li.call(p, "sourceURL") ? (p.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Fr + "]") + `
`;
        c.replace(ii, function(mi, Yi, Zi, Nr, mr, Rr) {
          return Zi || (Zi = Nr), Ht += c.slice(kt, Rr).replace(Et, Js), Yi && (Ze = !0, Ht += `' +
__e(` + Yi + `) +
'`), mr && (st = !0, Ht += `';
` + mr + `;
__p += '`), Zi && (Ht += `' +
((__t = (` + Zi + `)) == null ? '' : __t) +
'`), kt = Rr + mi.length, mi;
        }), Ht += `';
`;
        var _i = Li.call(p, "variable") && p.variable;
        if (!_i)
          Ht = `with (obj) {
` + Ht + `
}
`;
        else if (Ae.test(_i))
          throw new oe(f);
        Ht = (st ? Ht.replace(L, "") : Ht).replace(A, "$1").replace(U, "$1;"), Ht = "function(" + (_i || "obj") + `) {
` + (_i ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Ze ? ", __e = _.escape" : "") + (st ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ht + `return __p
}`;
        var zi = sf(function() {
          return Me(Te, ri + "return " + Ht).apply(t, Fe);
        });
        if (zi.source = Ht, hh(zi))
          throw zi;
        return zi;
      }
      function bv(c) {
        return an(c).toLowerCase();
      }
      function xv(c) {
        return an(c).toUpperCase();
      }
      function wv(c, p, N) {
        if (c = an(c), c && (N || p === t))
          return sn(c);
        if (!c || !(p = Or(p)))
          return c;
        var re = Ln(c), be = Ln(p), Te = Pi(re, be), Fe = Tn(re, be) + 1;
        return Us(re, Te, Fe).join("");
      }
      function Sv(c, p, N) {
        if (c = an(c), c && (N || p === t))
          return c.slice(0, Vr(c) + 1);
        if (!c || !(p = Or(p)))
          return c;
        var re = Ln(c), be = Tn(re, Ln(p)) + 1;
        return Us(re, 0, be).join("");
      }
      function Mv(c, p, N) {
        if (c = an(c), c && (N || p === t))
          return c.replace(fe, "");
        if (!c || !(p = Or(p)))
          return c;
        var re = Ln(c), be = Pi(re, Ln(p));
        return Us(re, be).join("");
      }
      function Cv(c, p) {
        var N = $e, re = Lt;
        if (Bn(p)) {
          var be = "separator" in p ? p.separator : be;
          N = "length" in p ? Di(p.length) : N, re = "omission" in p ? Or(p.omission) : re;
        }
        c = an(c);
        var Te = c.length;
        if (Xn(c)) {
          var Fe = Ln(c);
          Te = Fe.length;
        }
        if (N >= Te)
          return c;
        var Ze = N - xr(re);
        if (Ze < 1)
          return re;
        var st = Fe ? Us(Fe, 0, Ze).join("") : c.slice(0, Ze);
        if (be === t)
          return st + re;
        if (Fe && (Ze += st.length - Ze), uh(be)) {
          if (c.slice(Ze).search(be)) {
            var kt, It = st;
            for (be.global || (be = Mt(be.source, an(tt.exec(be)) + "g")), be.lastIndex = 0; kt = be.exec(It); )
              var Ht = kt.index;
            st = st.slice(0, Ht === t ? Ze : Ht);
          }
        } else if (c.indexOf(Or(be), Ze) != Ze) {
          var ii = st.lastIndexOf(be);
          ii > -1 && (st = st.slice(0, ii));
        }
        return st + re;
      }
      function Av(c) {
        return c = an(c), c && B.test(c) ? c.replace(k, ws) : c;
      }
      var Tv = _a(function(c, p, N) {
        return c + (N ? " " : "") + p.toUpperCase();
      }), dh = sc("toUpperCase");
      function rf(c, p, N) {
        return c = an(c), p = N ? t : p, p === t ? hn(c) ? qe(c) : Bi(c) : c.match(p) || [];
      }
      var sf = Vi(function(c, p) {
        try {
          return ye(c, t, p);
        } catch (N) {
          return hh(N) ? N : new oe(N);
        }
      }), Lv = Ts(function(c, p) {
        return De(p, function(N) {
          N = gs(N), Cs(c, N, oh(c[N], c));
        }), c;
      });
      function Bv(c) {
        var p = c == null ? 0 : c.length, N = fi();
        return c = p ? ti(c, function(re) {
          if (typeof re[1] != "function")
            throw new Vt(u);
          return [N(re[0]), re[1]];
        }) : [], Vi(function(re) {
          for (var be = -1; ++be < p; ) {
            var Te = c[be];
            if (ye(Te[0], this, re))
              return ye(Te[1], this, re);
          }
        });
      }
      function Ev(c) {
        return tp(Yr(c, D));
      }
      function gh(c) {
        return function() {
          return c;
        };
      }
      function kv(c, p) {
        return c == null || c !== c ? p : c;
      }
      var Iv = oc(), Ov = oc(!0);
      function Cr(c) {
        return c;
      }
      function ph(c) {
        return Du(typeof c == "function" ? c : Yr(c, D));
      }
      function Pv(c) {
        return Fu(Yr(c, D));
      }
      function Nv(c, p) {
        return Uu(c, Yr(p, D));
      }
      var Rv = Vi(function(c, p) {
        return function(N) {
          return Ra(N, c, p);
        };
      }), Dv = Vi(function(c, p) {
        return function(N) {
          return Ra(c, N, p);
        };
      });
      function _h(c, p, N) {
        var re = Jn(p), be = To(p, re);
        N == null && !(Bn(p) && (be.length || !re.length)) && (N = p, p = c, c = this, be = To(p, Jn(p)));
        var Te = !(Bn(N) && "chain" in N) || !!N.chain, Fe = Bs(c);
        return De(be, function(Ze) {
          var st = p[Ze];
          c[Ze] = st, Fe && (c.prototype[Ze] = function() {
            var kt = this.__chain__;
            if (Te || kt) {
              var It = c(this.__wrapped__), Ht = It.__actions__ = wr(this.__actions__);
              return Ht.push({ func: st, args: arguments, thisArg: c }), It.__chain__ = kt, It;
            }
            return st.apply(c, wi([this.value()], arguments));
          });
        }), c;
      }
      function zv() {
        return pn._ === this && (pn._ = ug), this;
      }
      function mh() {
      }
      function Fv(c) {
        return c = Di(c), Vi(function(p) {
          return Vu(p, c);
        });
      }
      var Uv = ql(ti), Vv = ql(St), Hv = ql(_n);
      function af(c) {
        return th(c) ? fr(gs(c)) : vp(c);
      }
      function Yv(c) {
        return function(p) {
          return c == null ? t : ia(c, p);
        };
      }
      var Gv = hc(), jv = hc(!0);
      function vh() {
        return [];
      }
      function yh() {
        return !1;
      }
      function Wv() {
        return {};
      }
      function Zv() {
        return "";
      }
      function qv() {
        return !0;
      }
      function Xv(c, p) {
        if (c = Di(c), c < 1 || c > Gt)
          return [];
        var N = ct, re = lr(c, ct);
        p = fi(p), c -= ct;
        for (var be = Er(re, p); ++N < c; )
          p(N);
        return be;
      }
      function Kv(c) {
        return ki(c) ? ti(c, gs) : Pr(c) ? [c] : wr(Cc(an(c)));
      }
      function Jv(c) {
        var p = ++lg;
        return an(c) + p;
      }
      var $v = Oo(function(c, p) {
        return c + p;
      }, 0), Qv = Xl("ceil"), ey = Oo(function(c, p) {
        return c / p;
      }, 1), ty = Xl("floor");
      function iy(c) {
        return c && c.length ? Ao(c, Cr, Pl) : t;
      }
      function ny(c, p) {
        return c && c.length ? Ao(c, fi(p, 2), Pl) : t;
      }
      function ry(c) {
        return mn(c, Cr);
      }
      function sy(c, p) {
        return mn(c, fi(p, 2));
      }
      function ay(c) {
        return c && c.length ? Ao(c, Cr, zl) : t;
      }
      function oy(c, p) {
        return c && c.length ? Ao(c, fi(p, 2), zl) : t;
      }
      var ly = Oo(function(c, p) {
        return c * p;
      }, 1), hy = Xl("round"), uy = Oo(function(c, p) {
        return c - p;
      }, 0);
      function cy(c) {
        return c && c.length ? Pn(c, Cr) : 0;
      }
      function fy(c, p) {
        return c && c.length ? Pn(c, fi(p, 2)) : 0;
      }
      return Ce.after = Pm, Ce.ary = Rc, Ce.assign = x0, Ce.assignIn = Kc, Ce.assignInWith = Wo, Ce.assignWith = w0, Ce.at = S0, Ce.before = Dc, Ce.bind = oh, Ce.bindAll = Lv, Ce.bindKey = zc, Ce.castArray = Wm, Ce.chain = Oc, Ce.chunk = t_, Ce.compact = i_, Ce.concat = n_, Ce.cond = Bv, Ce.conforms = Ev, Ce.constant = gh, Ce.countBy = cm, Ce.create = M0, Ce.curry = Fc, Ce.curryRight = Uc, Ce.debounce = Vc, Ce.defaults = C0, Ce.defaultsDeep = A0, Ce.defer = Nm, Ce.delay = Rm, Ce.difference = r_, Ce.differenceBy = s_, Ce.differenceWith = a_, Ce.drop = o_, Ce.dropRight = l_, Ce.dropRightWhile = h_, Ce.dropWhile = u_, Ce.fill = c_, Ce.filter = dm, Ce.flatMap = _m, Ce.flatMapDeep = mm, Ce.flatMapDepth = vm, Ce.flatten = Bc, Ce.flattenDeep = f_, Ce.flattenDepth = d_, Ce.flip = Dm, Ce.flow = Iv, Ce.flowRight = Ov, Ce.fromPairs = g_, Ce.functions = O0, Ce.functionsIn = P0, Ce.groupBy = ym, Ce.initial = __, Ce.intersection = m_, Ce.intersectionBy = v_, Ce.intersectionWith = y_, Ce.invert = R0, Ce.invertBy = D0, Ce.invokeMap = xm, Ce.iteratee = ph, Ce.keyBy = wm, Ce.keys = Jn, Ce.keysIn = Mr, Ce.map = Uo, Ce.mapKeys = F0, Ce.mapValues = U0, Ce.matches = Pv, Ce.matchesProperty = Nv, Ce.memoize = Ho, Ce.merge = V0, Ce.mergeWith = Jc, Ce.method = Rv, Ce.methodOf = Dv, Ce.mixin = _h, Ce.negate = Yo, Ce.nthArg = Fv, Ce.omit = H0, Ce.omitBy = Y0, Ce.once = zm, Ce.orderBy = Sm, Ce.over = Uv, Ce.overArgs = Fm, Ce.overEvery = Vv, Ce.overSome = Hv, Ce.partial = lh, Ce.partialRight = Hc, Ce.partition = Mm, Ce.pick = G0, Ce.pickBy = $c, Ce.property = af, Ce.propertyOf = Yv, Ce.pull = S_, Ce.pullAll = kc, Ce.pullAllBy = M_, Ce.pullAllWith = C_, Ce.pullAt = A_, Ce.range = Gv, Ce.rangeRight = jv, Ce.rearg = Um, Ce.reject = Tm, Ce.remove = T_, Ce.rest = Vm, Ce.reverse = sh, Ce.sampleSize = Bm, Ce.set = W0, Ce.setWith = Z0, Ce.shuffle = Em, Ce.slice = L_, Ce.sortBy = Om, Ce.sortedUniq = N_, Ce.sortedUniqBy = R_, Ce.split = _v, Ce.spread = Hm, Ce.tail = D_, Ce.take = z_, Ce.takeRight = F_, Ce.takeRightWhile = U_, Ce.takeWhile = V_, Ce.tap = im, Ce.throttle = Ym, Ce.thru = Fo, Ce.toArray = Zc, Ce.toPairs = Qc, Ce.toPairsIn = ef, Ce.toPath = Kv, Ce.toPlainObject = Xc, Ce.transform = q0, Ce.unary = Gm, Ce.union = H_, Ce.unionBy = Y_, Ce.unionWith = G_, Ce.uniq = j_, Ce.uniqBy = W_, Ce.uniqWith = Z_, Ce.unset = X0, Ce.unzip = ah, Ce.unzipWith = Ic, Ce.update = K0, Ce.updateWith = J0, Ce.values = ya, Ce.valuesIn = $0, Ce.without = q_, Ce.words = rf, Ce.wrap = jm, Ce.xor = X_, Ce.xorBy = K_, Ce.xorWith = J_, Ce.zip = $_, Ce.zipObject = Q_, Ce.zipObjectDeep = em, Ce.zipWith = tm, Ce.entries = Qc, Ce.entriesIn = ef, Ce.extend = Kc, Ce.extendWith = Wo, _h(Ce, Ce), Ce.add = $v, Ce.attempt = sf, Ce.camelCase = iv, Ce.capitalize = tf, Ce.ceil = Qv, Ce.clamp = Q0, Ce.clone = Zm, Ce.cloneDeep = Xm, Ce.cloneDeepWith = Km, Ce.cloneWith = qm, Ce.conformsTo = Jm, Ce.deburr = nf, Ce.defaultTo = kv, Ce.divide = ey, Ce.endsWith = nv, Ce.eq = ns, Ce.escape = rv, Ce.escapeRegExp = sv, Ce.every = fm, Ce.find = gm, Ce.findIndex = Tc, Ce.findKey = T0, Ce.findLast = pm, Ce.findLastIndex = Lc, Ce.findLastKey = L0, Ce.floor = ty, Ce.forEach = Pc, Ce.forEachRight = Nc, Ce.forIn = B0, Ce.forInRight = E0, Ce.forOwn = k0, Ce.forOwnRight = I0, Ce.get = ch, Ce.gt = $m, Ce.gte = Qm, Ce.has = N0, Ce.hasIn = fh, Ce.head = Ec, Ce.identity = Cr, Ce.includes = bm, Ce.indexOf = p_, Ce.inRange = ev, Ce.invoke = z0, Ce.isArguments = sa, Ce.isArray = ki, Ce.isArrayBuffer = e0, Ce.isArrayLike = Sr, Ce.isArrayLikeObject = zn, Ce.isBoolean = t0, Ce.isBuffer = Vs, Ce.isDate = i0, Ce.isElement = n0, Ce.isEmpty = r0, Ce.isEqual = s0, Ce.isEqualWith = a0, Ce.isError = hh, Ce.isFinite = o0, Ce.isFunction = Bs, Ce.isInteger = Yc, Ce.isLength = Go, Ce.isMap = Gc, Ce.isMatch = l0, Ce.isMatchWith = h0, Ce.isNaN = u0, Ce.isNative = c0, Ce.isNil = d0, Ce.isNull = f0, Ce.isNumber = jc, Ce.isObject = Bn, Ce.isObjectLike = Rn, Ce.isPlainObject = Ha, Ce.isRegExp = uh, Ce.isSafeInteger = g0, Ce.isSet = Wc, Ce.isString = jo, Ce.isSymbol = Pr, Ce.isTypedArray = va, Ce.isUndefined = p0, Ce.isWeakMap = _0, Ce.isWeakSet = m0, Ce.join = b_, Ce.kebabCase = av, Ce.last = jr, Ce.lastIndexOf = x_, Ce.lowerCase = ov, Ce.lowerFirst = lv, Ce.lt = v0, Ce.lte = y0, Ce.max = iy, Ce.maxBy = ny, Ce.mean = ry, Ce.meanBy = sy, Ce.min = ay, Ce.minBy = oy, Ce.stubArray = vh, Ce.stubFalse = yh, Ce.stubObject = Wv, Ce.stubString = Zv, Ce.stubTrue = qv, Ce.multiply = ly, Ce.nth = w_, Ce.noConflict = zv, Ce.noop = mh, Ce.now = Vo, Ce.pad = hv, Ce.padEnd = uv, Ce.padStart = cv, Ce.parseInt = fv, Ce.random = tv, Ce.reduce = Cm, Ce.reduceRight = Am, Ce.repeat = dv, Ce.replace = gv, Ce.result = j0, Ce.round = hy, Ce.runInContext = Le, Ce.sample = Lm, Ce.size = km, Ce.snakeCase = pv, Ce.some = Im, Ce.sortedIndex = B_, Ce.sortedIndexBy = E_, Ce.sortedIndexOf = k_, Ce.sortedLastIndex = I_, Ce.sortedLastIndexBy = O_, Ce.sortedLastIndexOf = P_, Ce.startCase = mv, Ce.startsWith = vv, Ce.subtract = uy, Ce.sum = cy, Ce.sumBy = fy, Ce.template = yv, Ce.times = Xv, Ce.toFinite = Es, Ce.toInteger = Di, Ce.toLength = qc, Ce.toLower = bv, Ce.toNumber = Wr, Ce.toSafeInteger = b0, Ce.toString = an, Ce.toUpper = xv, Ce.trim = wv, Ce.trimEnd = Sv, Ce.trimStart = Mv, Ce.truncate = Cv, Ce.unescape = Av, Ce.uniqueId = Jv, Ce.upperCase = Tv, Ce.upperFirst = dh, Ce.each = Pc, Ce.eachRight = Nc, Ce.first = Ec, _h(Ce, function() {
        var c = {};
        return fs(Ce, function(p, N) {
          Li.call(Ce.prototype, N) || (c[N] = p);
        }), c;
      }(), { chain: !1 }), Ce.VERSION = r, De(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(c) {
        Ce[c].placeholder = Ce;
      }), De(["drop", "take"], function(c, p) {
        ji.prototype[c] = function(N) {
          N = N === t ? 1 : Gn(Di(N), 0);
          var re = this.__filtered__ && !p ? new ji(this) : this.clone();
          return re.__filtered__ ? re.__takeCount__ = lr(N, re.__takeCount__) : re.__views__.push({
            size: lr(N, ct),
            type: c + (re.__dir__ < 0 ? "Right" : "")
          }), re;
        }, ji.prototype[c + "Right"] = function(N) {
          return this.reverse()[c](N).reverse();
        };
      }), De(["filter", "map", "takeWhile"], function(c, p) {
        var N = p + 1, re = N == ue || N == Ue;
        ji.prototype[c] = function(be) {
          var Te = this.clone();
          return Te.__iteratees__.push({
            iteratee: fi(be, 3),
            type: N
          }), Te.__filtered__ = Te.__filtered__ || re, Te;
        };
      }), De(["head", "last"], function(c, p) {
        var N = "take" + (p ? "Right" : "");
        ji.prototype[c] = function() {
          return this[N](1).value()[0];
        };
      }), De(["initial", "tail"], function(c, p) {
        var N = "drop" + (p ? "" : "Right");
        ji.prototype[c] = function() {
          return this.__filtered__ ? new ji(this) : this[N](1);
        };
      }), ji.prototype.compact = function() {
        return this.filter(Cr);
      }, ji.prototype.find = function(c) {
        return this.filter(c).head();
      }, ji.prototype.findLast = function(c) {
        return this.reverse().find(c);
      }, ji.prototype.invokeMap = Vi(function(c, p) {
        return typeof c == "function" ? new ji(this) : this.map(function(N) {
          return Ra(N, c, p);
        });
      }), ji.prototype.reject = function(c) {
        return this.filter(Yo(fi(c)));
      }, ji.prototype.slice = function(c, p) {
        c = Di(c);
        var N = this;
        return N.__filtered__ && (c > 0 || p < 0) ? new ji(N) : (c < 0 ? N = N.takeRight(-c) : c && (N = N.drop(c)), p !== t && (p = Di(p), N = p < 0 ? N.dropRight(-p) : N.take(p - c)), N);
      }, ji.prototype.takeRightWhile = function(c) {
        return this.reverse().takeWhile(c).reverse();
      }, ji.prototype.toArray = function() {
        return this.take(ct);
      }, fs(ji.prototype, function(c, p) {
        var N = /^(?:filter|find|map|reject)|While$/.test(p), re = /^(?:head|last)$/.test(p), be = Ce[re ? "take" + (p == "last" ? "Right" : "") : p], Te = re || /^find/.test(p);
        be && (Ce.prototype[p] = function() {
          var Fe = this.__wrapped__, Ze = re ? [1] : arguments, st = Fe instanceof ji, kt = Ze[0], It = st || ki(Fe), Ht = function(Yi) {
            var Zi = be.apply(Ce, wi([Yi], Ze));
            return re && ii ? Zi[0] : Zi;
          };
          It && N && typeof kt == "function" && kt.length != 1 && (st = It = !1);
          var ii = this.__chain__, ri = !!this.__actions__.length, _i = Te && !ii, zi = st && !ri;
          if (!Te && It) {
            Fe = zi ? Fe : new ji(this);
            var mi = c.apply(Fe, Ze);
            return mi.__actions__.push({ func: Fo, args: [Ht], thisArg: t }), new Hr(mi, ii);
          }
          return _i && zi ? c.apply(this, Ze) : (mi = this.thru(Ht), _i ? re ? mi.value()[0] : mi.value() : mi);
        });
      }), De(["pop", "push", "shift", "sort", "splice", "unshift"], function(c) {
        var p = Ei[c], N = /^(?:push|sort|unshift)$/.test(c) ? "tap" : "thru", re = /^(?:pop|shift)$/.test(c);
        Ce.prototype[c] = function() {
          var be = arguments;
          if (re && !this.__chain__) {
            var Te = this.value();
            return p.apply(ki(Te) ? Te : [], be);
          }
          return this[N](function(Fe) {
            return p.apply(ki(Fe) ? Fe : [], be);
          });
        };
      }), fs(ji.prototype, function(c, p) {
        var N = Ce[p];
        if (N) {
          var re = N.name + "";
          Li.call(da, re) || (da[re] = []), da[re].push({ name: p, func: N });
        }
      }), da[Io(t, G).name] = [{
        name: "wrapper",
        func: t
      }], ji.prototype.clone = Ag, ji.prototype.reverse = Tg, ji.prototype.value = Lg, Ce.prototype.at = nm, Ce.prototype.chain = rm, Ce.prototype.commit = sm, Ce.prototype.next = am, Ce.prototype.plant = lm, Ce.prototype.reverse = hm, Ce.prototype.toJSON = Ce.prototype.valueOf = Ce.prototype.value = um, Ce.prototype.first = Ce.prototype.head, Ba && (Ce.prototype[Ba] = om), Ce;
    }, gt = ht();
    Qn ? ((Qn.exports = gt)._ = gt, us._ = gt) : pn._ = gt;
  }).call(Kr);
})(_l, _l.exports);
var rw = _l.exports, $d = { exports: {} };
const sw = {}, aw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sw
}, Symbol.toStringTag, { value: "Module" })), Pf = /* @__PURE__ */ rx(aw);
var Qo = { exports: {} }, Nf;
function ow() {
  return Nf || (Nf = 1, function(y, e) {
    (function(t, r) {
      r(e);
    })(Kr, function(t) {
      var r = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], o = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], a = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", u = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", f = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, v = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", S = {
        5: v,
        "5module": v + " export import",
        6: v + " const class extends export import super"
      }, I = /^in(stanceof)?$/, D = new RegExp("[" + u + "]"), Z = new RegExp("[" + u + a + "]");
      function M(g, z) {
        for (var ce = 65536, xe = 0; xe < z.length; xe += 2) {
          if (ce += z[xe], ce > g)
            return !1;
          if (ce += z[xe + 1], ce >= g)
            return !0;
        }
        return !1;
      }
      function X(g, z) {
        return g < 65 ? g === 36 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && D.test(String.fromCharCode(g)) : z === !1 ? !1 : M(g, o);
      }
      function Y(g, z) {
        return g < 48 ? g === 36 : g < 58 ? !0 : g < 65 ? !1 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && Z.test(String.fromCharCode(g)) : z === !1 ? !1 : M(g, o) || M(g, r);
      }
      var ie = function(z, ce) {
        ce === void 0 && (ce = {}), this.label = z, this.keyword = ce.keyword, this.beforeExpr = !!ce.beforeExpr, this.startsExpr = !!ce.startsExpr, this.isLoop = !!ce.isLoop, this.isAssign = !!ce.isAssign, this.prefix = !!ce.prefix, this.postfix = !!ce.postfix, this.binop = ce.binop || null, this.updateContext = null;
      };
      function G(g, z) {
        return new ie(g, { beforeExpr: !0, binop: z });
      }
      var te = { beforeExpr: !0 }, J = { startsExpr: !0 }, he = {};
      function ve(g, z) {
        return z === void 0 && (z = {}), z.keyword = g, he[g] = new ie(g, z);
      }
      var K = {
        num: new ie("num", J),
        regexp: new ie("regexp", J),
        string: new ie("string", J),
        name: new ie("name", J),
        privateId: new ie("privateId", J),
        eof: new ie("eof"),
        // Punctuation token types.
        bracketL: new ie("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new ie("]"),
        braceL: new ie("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new ie("}"),
        parenL: new ie("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new ie(")"),
        comma: new ie(",", te),
        semi: new ie(";", te),
        colon: new ie(":", te),
        dot: new ie("."),
        question: new ie("?", te),
        questionDot: new ie("?."),
        arrow: new ie("=>", te),
        template: new ie("template"),
        invalidTemplate: new ie("invalidTemplate"),
        ellipsis: new ie("...", te),
        backQuote: new ie("`", J),
        dollarBraceL: new ie("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new ie("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new ie("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new ie("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new ie("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: G("||", 1),
        logicalAND: G("&&", 2),
        bitwiseOR: G("|", 3),
        bitwiseXOR: G("^", 4),
        bitwiseAND: G("&", 5),
        equality: G("==/!=/===/!==", 6),
        relational: G("</>/<=/>=", 7),
        bitShift: G("<</>>/>>>", 8),
        plusMin: new ie("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: G("%", 10),
        star: G("*", 10),
        slash: G("/", 10),
        starstar: new ie("**", { beforeExpr: !0 }),
        coalesce: G("??", 1),
        // Keyword token types.
        _break: ve("break"),
        _case: ve("case", te),
        _catch: ve("catch"),
        _continue: ve("continue"),
        _debugger: ve("debugger"),
        _default: ve("default", te),
        _do: ve("do", { isLoop: !0, beforeExpr: !0 }),
        _else: ve("else", te),
        _finally: ve("finally"),
        _for: ve("for", { isLoop: !0 }),
        _function: ve("function", J),
        _if: ve("if"),
        _return: ve("return", te),
        _switch: ve("switch"),
        _throw: ve("throw", te),
        _try: ve("try"),
        _var: ve("var"),
        _const: ve("const"),
        _while: ve("while", { isLoop: !0 }),
        _with: ve("with"),
        _new: ve("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: ve("this", J),
        _super: ve("super", J),
        _class: ve("class", J),
        _extends: ve("extends", te),
        _export: ve("export"),
        _import: ve("import", J),
        _null: ve("null", J),
        _true: ve("true", J),
        _false: ve("false", J),
        _in: ve("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: ve("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: ve("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: ve("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: ve("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, j = /\r\n?|\n|\u2028|\u2029/, We = new RegExp(j.source, "g");
      function ke(g) {
        return g === 10 || g === 13 || g === 8232 || g === 8233;
      }
      function $e(g, z, ce) {
        ce === void 0 && (ce = g.length);
        for (var xe = z; xe < ce; xe++) {
          var Pe = g.charCodeAt(xe);
          if (ke(Pe))
            return xe < ce - 1 && Pe === 13 && g.charCodeAt(xe + 1) === 10 ? xe + 2 : xe + 1;
        }
        return -1;
      }
      var Lt = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Be = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, Xe = Object.prototype, ue = Xe.hasOwnProperty, yt = Xe.toString, Ue = Object.hasOwn || function(g, z) {
        return ue.call(g, z);
      }, ot = Array.isArray || function(g) {
        return yt.call(g) === "[object Array]";
      }, Gt = /* @__PURE__ */ Object.create(null);
      function it(g) {
        return Gt[g] || (Gt[g] = new RegExp("^(?:" + g.replace(/ /g, "|") + ")$"));
      }
      function Zt(g) {
        return g <= 65535 ? String.fromCharCode(g) : (g -= 65536, String.fromCharCode((g >> 10) + 55296, (g & 1023) + 56320));
      }
      var ct = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, lt = function(z, ce) {
        this.line = z, this.column = ce;
      };
      lt.prototype.offset = function(z) {
        return new lt(this.line, this.column + z);
      };
      var $t = function(z, ce, xe) {
        this.start = ce, this.end = xe, z.sourceFile !== null && (this.source = z.sourceFile);
      };
      function Kt(g, z) {
        for (var ce = 1, xe = 0; ; ) {
          var Pe = $e(g, xe, z);
          if (Pe < 0)
            return new lt(ce, z - xe);
          ++ce, xe = Pe;
        }
      }
      var At = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"` or `"module"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, Ni = !1;
      function rn(g) {
        var z = {};
        for (var ce in At)
          z[ce] = g && Ue(g, ce) ? g[ce] : At[ce];
        if (z.ecmaVersion === "latest" ? z.ecmaVersion = 1e8 : z.ecmaVersion == null ? (!Ni && typeof console == "object" && console.warn && (Ni = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), z.ecmaVersion = 11) : z.ecmaVersion >= 2015 && (z.ecmaVersion -= 2009), z.allowReserved == null && (z.allowReserved = z.ecmaVersion < 5), (!g || g.allowHashBang == null) && (z.allowHashBang = z.ecmaVersion >= 14), ot(z.onToken)) {
          var xe = z.onToken;
          z.onToken = function(Pe) {
            return xe.push(Pe);
          };
        }
        return ot(z.onComment) && (z.onComment = ui(z, z.onComment)), z;
      }
      function ui(g, z) {
        return function(ce, xe, Pe, rt, pt, Dt) {
          var qt = {
            type: ce ? "Block" : "Line",
            value: xe,
            start: Pe,
            end: rt
          };
          g.locations && (qt.loc = new $t(this, pt, Dt)), g.ranges && (qt.range = [Pe, rt]), z.push(qt);
        };
      }
      var Wt = 1, Qt = 2, ei = 4, on = 8, tn = 16, pe = 32, Tt = 64, xt = 128, Re = 256, Ie = Wt | Qt | Re;
      function Qe(g, z) {
        return Qt | (g ? ei : 0) | (z ? on : 0);
      }
      var Bt = 0, dt = 1, et = 2, wt = 3, Xt = 4, He = 5, i = function(z, ce, xe) {
        this.options = z = rn(z), this.sourceFile = z.sourceFile, this.keywords = it(S[z.ecmaVersion >= 6 ? 6 : z.sourceType === "module" ? "5module" : 5]);
        var Pe = "";
        z.allowReserved !== !0 && (Pe = f[z.ecmaVersion >= 6 ? 6 : z.ecmaVersion === 5 ? 5 : 3], z.sourceType === "module" && (Pe += " await")), this.reservedWords = it(Pe);
        var rt = (Pe ? Pe + " " : "") + f.strict;
        this.reservedWordsStrict = it(rt), this.reservedWordsStrictBind = it(rt + " " + f.strictBind), this.input = String(ce), this.containsEsc = !1, xe ? (this.pos = xe, this.lineStart = this.input.lastIndexOf(`
`, xe - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(j).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = K.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = z.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && z.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(Wt), this.regexpState = null, this.privateNameStack = [];
      }, n = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      i.prototype.parse = function() {
        var z = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(z);
      }, n.inFunction.get = function() {
        return (this.currentVarScope().flags & Qt) > 0;
      }, n.inGenerator.get = function() {
        return (this.currentVarScope().flags & on) > 0 && !this.currentVarScope().inClassFieldInit;
      }, n.inAsync.get = function() {
        return (this.currentVarScope().flags & ei) > 0 && !this.currentVarScope().inClassFieldInit;
      }, n.canAwait.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var z = this.scopeStack[g];
          if (z.inClassFieldInit || z.flags & Re)
            return !1;
          if (z.flags & Qt)
            return (z.flags & ei) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, n.allowSuper.get = function() {
        var g = this.currentThisScope(), z = g.flags, ce = g.inClassFieldInit;
        return (z & Tt) > 0 || ce || this.options.allowSuperOutsideMethod;
      }, n.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & xt) > 0;
      }, n.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, n.allowNewDotTarget.get = function() {
        var g = this.currentThisScope(), z = g.flags, ce = g.inClassFieldInit;
        return (z & (Qt | Re)) > 0 || ce;
      }, n.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & Re) > 0;
      }, i.extend = function() {
        for (var z = [], ce = arguments.length; ce--; )
          z[ce] = arguments[ce];
        for (var xe = this, Pe = 0; Pe < z.length; Pe++)
          xe = z[Pe](xe);
        return xe;
      }, i.parse = function(z, ce) {
        return new this(ce, z).parse();
      }, i.parseExpressionAt = function(z, ce, xe) {
        var Pe = new this(xe, z, ce);
        return Pe.nextToken(), Pe.parseExpression();
      }, i.tokenizer = function(z, ce) {
        return new this(ce, z);
      }, Object.defineProperties(i.prototype, n);
      var s = i.prototype, l = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
      s.strictDirective = function(g) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          Be.lastIndex = g, g += Be.exec(this.input)[0].length;
          var z = l.exec(this.input.slice(g));
          if (!z)
            return !1;
          if ((z[1] || z[2]) === "use strict") {
            Be.lastIndex = g + z[0].length;
            var ce = Be.exec(this.input), xe = ce.index + ce[0].length, Pe = this.input.charAt(xe);
            return Pe === ";" || Pe === "}" || j.test(ce[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(Pe) || Pe === "!" && this.input.charAt(xe + 1) === "=");
          }
          g += z[0].length, Be.lastIndex = g, g += Be.exec(this.input)[0].length, this.input[g] === ";" && g++;
        }
      }, s.eat = function(g) {
        return this.type === g ? (this.next(), !0) : !1;
      }, s.isContextual = function(g) {
        return this.type === K.name && this.value === g && !this.containsEsc;
      }, s.eatContextual = function(g) {
        return this.isContextual(g) ? (this.next(), !0) : !1;
      }, s.expectContextual = function(g) {
        this.eatContextual(g) || this.unexpected();
      }, s.canInsertSemicolon = function() {
        return this.type === K.eof || this.type === K.braceR || j.test(this.input.slice(this.lastTokEnd, this.start));
      }, s.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, s.semicolon = function() {
        !this.eat(K.semi) && !this.insertSemicolon() && this.unexpected();
      }, s.afterTrailingComma = function(g, z) {
        if (this.type === g)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), z || this.next(), !0;
      }, s.expect = function(g) {
        this.eat(g) || this.unexpected();
      }, s.unexpected = function(g) {
        this.raise(g ?? this.start, "Unexpected token");
      };
      var h = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      s.checkPatternErrors = function(g, z) {
        if (g) {
          g.trailingComma > -1 && this.raiseRecoverable(g.trailingComma, "Comma is not permitted after the rest element");
          var ce = z ? g.parenthesizedAssign : g.parenthesizedBind;
          ce > -1 && this.raiseRecoverable(ce, z ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, s.checkExpressionErrors = function(g, z) {
        if (!g)
          return !1;
        var ce = g.shorthandAssign, xe = g.doubleProto;
        if (!z)
          return ce >= 0 || xe >= 0;
        ce >= 0 && this.raise(ce, "Shorthand property assignments are valid only in destructuring patterns"), xe >= 0 && this.raiseRecoverable(xe, "Redefinition of __proto__ property");
      }, s.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, s.isSimpleAssignTarget = function(g) {
        return g.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(g.expression) : g.type === "Identifier" || g.type === "MemberExpression";
      };
      var d = i.prototype;
      d.parseTopLevel = function(g) {
        var z = /* @__PURE__ */ Object.create(null);
        for (g.body || (g.body = []); this.type !== K.eof; ) {
          var ce = this.parseStatement(null, !0, z);
          g.body.push(ce);
        }
        if (this.inModule)
          for (var xe = 0, Pe = Object.keys(this.undefinedExports); xe < Pe.length; xe += 1) {
            var rt = Pe[xe];
            this.raiseRecoverable(this.undefinedExports[rt].start, "Export '" + rt + "' is not defined");
          }
        return this.adaptDirectivePrologue(g.body), this.next(), g.sourceType = this.options.sourceType, this.finishNode(g, "Program");
      };
      var m = { kind: "loop" }, _ = { kind: "switch" };
      d.isLet = function(g) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        Be.lastIndex = this.pos;
        var z = Be.exec(this.input), ce = this.pos + z[0].length, xe = this.input.charCodeAt(ce);
        if (xe === 91 || xe === 92)
          return !0;
        if (g)
          return !1;
        if (xe === 123 || xe > 55295 && xe < 56320)
          return !0;
        if (X(xe, !0)) {
          for (var Pe = ce + 1; Y(xe = this.input.charCodeAt(Pe), !0); )
            ++Pe;
          if (xe === 92 || xe > 55295 && xe < 56320)
            return !0;
          var rt = this.input.slice(ce, Pe);
          if (!I.test(rt))
            return !0;
        }
        return !1;
      }, d.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        Be.lastIndex = this.pos;
        var g = Be.exec(this.input), z = this.pos + g[0].length, ce;
        return !j.test(this.input.slice(this.pos, z)) && this.input.slice(z, z + 8) === "function" && (z + 8 === this.input.length || !(Y(ce = this.input.charCodeAt(z + 8)) || ce > 55295 && ce < 56320));
      }, d.parseStatement = function(g, z, ce) {
        var xe = this.type, Pe = this.startNode(), rt;
        switch (this.isLet(g) && (xe = K._var, rt = "let"), xe) {
          case K._break:
          case K._continue:
            return this.parseBreakContinueStatement(Pe, xe.keyword);
          case K._debugger:
            return this.parseDebuggerStatement(Pe);
          case K._do:
            return this.parseDoStatement(Pe);
          case K._for:
            return this.parseForStatement(Pe);
          case K._function:
            return g && (this.strict || g !== "if" && g !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(Pe, !1, !g);
          case K._class:
            return g && this.unexpected(), this.parseClass(Pe, !0);
          case K._if:
            return this.parseIfStatement(Pe);
          case K._return:
            return this.parseReturnStatement(Pe);
          case K._switch:
            return this.parseSwitchStatement(Pe);
          case K._throw:
            return this.parseThrowStatement(Pe);
          case K._try:
            return this.parseTryStatement(Pe);
          case K._const:
          case K._var:
            return rt = rt || this.value, g && rt !== "var" && this.unexpected(), this.parseVarStatement(Pe, rt);
          case K._while:
            return this.parseWhileStatement(Pe);
          case K._with:
            return this.parseWithStatement(Pe);
          case K.braceL:
            return this.parseBlock(!0, Pe);
          case K.semi:
            return this.parseEmptyStatement(Pe);
          case K._export:
          case K._import:
            if (this.options.ecmaVersion > 10 && xe === K._import) {
              Be.lastIndex = this.pos;
              var pt = Be.exec(this.input), Dt = this.pos + pt[0].length, qt = this.input.charCodeAt(Dt);
              if (qt === 40 || qt === 46)
                return this.parseExpressionStatement(Pe, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (z || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), xe === K._import ? this.parseImport(Pe) : this.parseExport(Pe, ce);
          default:
            if (this.isAsyncFunction())
              return g && this.unexpected(), this.next(), this.parseFunctionStatement(Pe, !0, !g);
            var gi = this.value, vi = this.parseExpression();
            return xe === K.name && vi.type === "Identifier" && this.eat(K.colon) ? this.parseLabeledStatement(Pe, gi, vi, g) : this.parseExpressionStatement(Pe, vi);
        }
      }, d.parseBreakContinueStatement = function(g, z) {
        var ce = z === "break";
        this.next(), this.eat(K.semi) || this.insertSemicolon() ? g.label = null : this.type !== K.name ? this.unexpected() : (g.label = this.parseIdent(), this.semicolon());
        for (var xe = 0; xe < this.labels.length; ++xe) {
          var Pe = this.labels[xe];
          if ((g.label == null || Pe.name === g.label.name) && (Pe.kind != null && (ce || Pe.kind === "loop") || g.label && ce))
            break;
        }
        return xe === this.labels.length && this.raise(g.start, "Unsyntactic " + z), this.finishNode(g, ce ? "BreakStatement" : "ContinueStatement");
      }, d.parseDebuggerStatement = function(g) {
        return this.next(), this.semicolon(), this.finishNode(g, "DebuggerStatement");
      }, d.parseDoStatement = function(g) {
        return this.next(), this.labels.push(m), g.body = this.parseStatement("do"), this.labels.pop(), this.expect(K._while), g.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(K.semi) : this.semicolon(), this.finishNode(g, "DoWhileStatement");
      }, d.parseForStatement = function(g) {
        this.next();
        var z = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(m), this.enterScope(0), this.expect(K.parenL), this.type === K.semi)
          return z > -1 && this.unexpected(z), this.parseFor(g, null);
        var ce = this.isLet();
        if (this.type === K._var || this.type === K._const || ce) {
          var xe = this.startNode(), Pe = ce ? "let" : this.value;
          return this.next(), this.parseVar(xe, !0, Pe), this.finishNode(xe, "VariableDeclaration"), (this.type === K._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && xe.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === K._in ? z > -1 && this.unexpected(z) : g.await = z > -1), this.parseForIn(g, xe)) : (z > -1 && this.unexpected(z), this.parseFor(g, xe));
        }
        var rt = this.isContextual("let"), pt = !1, Dt = new h(), qt = this.parseExpression(z > -1 ? "await" : !0, Dt);
        return this.type === K._in || (pt = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (this.options.ecmaVersion >= 9 && (this.type === K._in ? z > -1 && this.unexpected(z) : g.await = z > -1), rt && pt && this.raise(qt.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(qt, !1, Dt), this.checkLValPattern(qt), this.parseForIn(g, qt)) : (this.checkExpressionErrors(Dt, !0), z > -1 && this.unexpected(z), this.parseFor(g, qt));
      }, d.parseFunctionStatement = function(g, z, ce) {
        return this.next(), this.parseFunction(g, x | (ce ? 0 : T), !1, z);
      }, d.parseIfStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), g.consequent = this.parseStatement("if"), g.alternate = this.eat(K._else) ? this.parseStatement("if") : null, this.finishNode(g, "IfStatement");
      }, d.parseReturnStatement = function(g) {
        return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(K.semi) || this.insertSemicolon() ? g.argument = null : (g.argument = this.parseExpression(), this.semicolon()), this.finishNode(g, "ReturnStatement");
      }, d.parseSwitchStatement = function(g) {
        this.next(), g.discriminant = this.parseParenExpression(), g.cases = [], this.expect(K.braceL), this.labels.push(_), this.enterScope(0);
        for (var z, ce = !1; this.type !== K.braceR; )
          if (this.type === K._case || this.type === K._default) {
            var xe = this.type === K._case;
            z && this.finishNode(z, "SwitchCase"), g.cases.push(z = this.startNode()), z.consequent = [], this.next(), xe ? z.test = this.parseExpression() : (ce && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), ce = !0, z.test = null), this.expect(K.colon);
          } else
            z || this.unexpected(), z.consequent.push(this.parseStatement(null));
        return this.exitScope(), z && this.finishNode(z, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(g, "SwitchStatement");
      }, d.parseThrowStatement = function(g) {
        return this.next(), j.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), g.argument = this.parseExpression(), this.semicolon(), this.finishNode(g, "ThrowStatement");
      };
      var b = [];
      d.parseCatchClauseParam = function() {
        var g = this.parseBindingAtom(), z = g.type === "Identifier";
        return this.enterScope(z ? pe : 0), this.checkLValPattern(g, z ? Xt : et), this.expect(K.parenR), g;
      }, d.parseTryStatement = function(g) {
        if (this.next(), g.block = this.parseBlock(), g.handler = null, this.type === K._catch) {
          var z = this.startNode();
          this.next(), this.eat(K.parenL) ? z.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), z.param = null, this.enterScope(0)), z.body = this.parseBlock(!1), this.exitScope(), g.handler = this.finishNode(z, "CatchClause");
        }
        return g.finalizer = this.eat(K._finally) ? this.parseBlock() : null, !g.handler && !g.finalizer && this.raise(g.start, "Missing catch or finally clause"), this.finishNode(g, "TryStatement");
      }, d.parseVarStatement = function(g, z, ce) {
        return this.next(), this.parseVar(g, !1, z, ce), this.semicolon(), this.finishNode(g, "VariableDeclaration");
      }, d.parseWhileStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), this.labels.push(m), g.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(g, "WhileStatement");
      }, d.parseWithStatement = function(g) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), g.object = this.parseParenExpression(), g.body = this.parseStatement("with"), this.finishNode(g, "WithStatement");
      }, d.parseEmptyStatement = function(g) {
        return this.next(), this.finishNode(g, "EmptyStatement");
      }, d.parseLabeledStatement = function(g, z, ce, xe) {
        for (var Pe = 0, rt = this.labels; Pe < rt.length; Pe += 1) {
          var pt = rt[Pe];
          pt.name === z && this.raise(ce.start, "Label '" + z + "' is already declared");
        }
        for (var Dt = this.type.isLoop ? "loop" : this.type === K._switch ? "switch" : null, qt = this.labels.length - 1; qt >= 0; qt--) {
          var gi = this.labels[qt];
          if (gi.statementStart === g.start)
            gi.statementStart = this.start, gi.kind = Dt;
          else
            break;
        }
        return this.labels.push({ name: z, kind: Dt, statementStart: this.start }), g.body = this.parseStatement(xe ? xe.indexOf("label") === -1 ? xe + "label" : xe : "label"), this.labels.pop(), g.label = ce, this.finishNode(g, "LabeledStatement");
      }, d.parseExpressionStatement = function(g, z) {
        return g.expression = z, this.semicolon(), this.finishNode(g, "ExpressionStatement");
      }, d.parseBlock = function(g, z, ce) {
        for (g === void 0 && (g = !0), z === void 0 && (z = this.startNode()), z.body = [], this.expect(K.braceL), g && this.enterScope(0); this.type !== K.braceR; ) {
          var xe = this.parseStatement(null);
          z.body.push(xe);
        }
        return ce && (this.strict = !1), this.next(), g && this.exitScope(), this.finishNode(z, "BlockStatement");
      }, d.parseFor = function(g, z) {
        return g.init = z, this.expect(K.semi), g.test = this.type === K.semi ? null : this.parseExpression(), this.expect(K.semi), g.update = this.type === K.parenR ? null : this.parseExpression(), this.expect(K.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, "ForStatement");
      }, d.parseForIn = function(g, z) {
        var ce = this.type === K._in;
        return this.next(), z.type === "VariableDeclaration" && z.declarations[0].init != null && (!ce || this.options.ecmaVersion < 8 || this.strict || z.kind !== "var" || z.declarations[0].id.type !== "Identifier") && this.raise(
          z.start,
          (ce ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), g.left = z, g.right = ce ? this.parseExpression() : this.parseMaybeAssign(), this.expect(K.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, ce ? "ForInStatement" : "ForOfStatement");
      }, d.parseVar = function(g, z, ce, xe) {
        for (g.declarations = [], g.kind = ce; ; ) {
          var Pe = this.startNode();
          if (this.parseVarId(Pe, ce), this.eat(K.eq) ? Pe.init = this.parseMaybeAssign(z) : !xe && ce === "const" && !(this.type === K._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !xe && Pe.id.type !== "Identifier" && !(z && (this.type === K._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : Pe.init = null, g.declarations.push(this.finishNode(Pe, "VariableDeclarator")), !this.eat(K.comma))
            break;
        }
        return g;
      }, d.parseVarId = function(g, z) {
        g.id = this.parseBindingAtom(), this.checkLValPattern(g.id, z === "var" ? dt : et, !1);
      };
      var x = 1, T = 2, E = 4;
      d.parseFunction = function(g, z, ce, xe, Pe) {
        this.initFunction(g), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !xe) && (this.type === K.star && z & T && this.unexpected(), g.generator = this.eat(K.star)), this.options.ecmaVersion >= 8 && (g.async = !!xe), z & x && (g.id = z & E && this.type !== K.name ? null : this.parseIdent(), g.id && !(z & T) && this.checkLValSimple(g.id, this.strict || g.generator || g.async ? this.treatFunctionsAsVar ? dt : et : wt));
        var rt = this.yieldPos, pt = this.awaitPos, Dt = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Qe(g.async, g.generator)), z & x || (g.id = this.type === K.name ? this.parseIdent() : null), this.parseFunctionParams(g), this.parseFunctionBody(g, ce, !1, Pe), this.yieldPos = rt, this.awaitPos = pt, this.awaitIdentPos = Dt, this.finishNode(g, z & x ? "FunctionDeclaration" : "FunctionExpression");
      }, d.parseFunctionParams = function(g) {
        this.expect(K.parenL), g.params = this.parseBindingList(K.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, d.parseClass = function(g, z) {
        this.next();
        var ce = this.strict;
        this.strict = !0, this.parseClassId(g, z), this.parseClassSuper(g);
        var xe = this.enterClassBody(), Pe = this.startNode(), rt = !1;
        for (Pe.body = [], this.expect(K.braceL); this.type !== K.braceR; ) {
          var pt = this.parseClassElement(g.superClass !== null);
          pt && (Pe.body.push(pt), pt.type === "MethodDefinition" && pt.kind === "constructor" ? (rt && this.raiseRecoverable(pt.start, "Duplicate constructor in the same class"), rt = !0) : pt.key && pt.key.type === "PrivateIdentifier" && L(xe, pt) && this.raiseRecoverable(pt.key.start, "Identifier '#" + pt.key.name + "' has already been declared"));
        }
        return this.strict = ce, this.next(), g.body = this.finishNode(Pe, "ClassBody"), this.exitClassBody(), this.finishNode(g, z ? "ClassDeclaration" : "ClassExpression");
      }, d.parseClassElement = function(g) {
        if (this.eat(K.semi))
          return null;
        var z = this.options.ecmaVersion, ce = this.startNode(), xe = "", Pe = !1, rt = !1, pt = "method", Dt = !1;
        if (this.eatContextual("static")) {
          if (z >= 13 && this.eat(K.braceL))
            return this.parseClassStaticBlock(ce), ce;
          this.isClassElementNameStart() || this.type === K.star ? Dt = !0 : xe = "static";
        }
        if (ce.static = Dt, !xe && z >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === K.star) && !this.canInsertSemicolon() ? rt = !0 : xe = "async"), !xe && (z >= 9 || !rt) && this.eat(K.star) && (Pe = !0), !xe && !rt && !Pe) {
          var qt = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? pt = qt : xe = qt);
        }
        if (xe ? (ce.computed = !1, ce.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), ce.key.name = xe, this.finishNode(ce.key, "Identifier")) : this.parseClassElementName(ce), z < 13 || this.type === K.parenL || pt !== "method" || Pe || rt) {
          var gi = !ce.static && A(ce, "constructor"), vi = gi && g;
          gi && pt !== "method" && this.raise(ce.key.start, "Constructor can't have get/set modifier"), ce.kind = gi ? "constructor" : pt, this.parseClassMethod(ce, Pe, rt, vi);
        } else
          this.parseClassField(ce);
        return ce;
      }, d.isClassElementNameStart = function() {
        return this.type === K.name || this.type === K.privateId || this.type === K.num || this.type === K.string || this.type === K.bracketL || this.type.keyword;
      }, d.parseClassElementName = function(g) {
        this.type === K.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), g.computed = !1, g.key = this.parsePrivateIdent()) : this.parsePropertyName(g);
      }, d.parseClassMethod = function(g, z, ce, xe) {
        var Pe = g.key;
        g.kind === "constructor" ? (z && this.raise(Pe.start, "Constructor can't be a generator"), ce && this.raise(Pe.start, "Constructor can't be an async method")) : g.static && A(g, "prototype") && this.raise(Pe.start, "Classes may not have a static property named prototype");
        var rt = g.value = this.parseMethod(z, ce, xe);
        return g.kind === "get" && rt.params.length !== 0 && this.raiseRecoverable(rt.start, "getter should have no params"), g.kind === "set" && rt.params.length !== 1 && this.raiseRecoverable(rt.start, "setter should have exactly one param"), g.kind === "set" && rt.params[0].type === "RestElement" && this.raiseRecoverable(rt.params[0].start, "Setter cannot use rest params"), this.finishNode(g, "MethodDefinition");
      }, d.parseClassField = function(g) {
        if (A(g, "constructor") ? this.raise(g.key.start, "Classes can't have a field named 'constructor'") : g.static && A(g, "prototype") && this.raise(g.key.start, "Classes can't have a static field named 'prototype'"), this.eat(K.eq)) {
          var z = this.currentThisScope(), ce = z.inClassFieldInit;
          z.inClassFieldInit = !0, g.value = this.parseMaybeAssign(), z.inClassFieldInit = ce;
        } else
          g.value = null;
        return this.semicolon(), this.finishNode(g, "PropertyDefinition");
      }, d.parseClassStaticBlock = function(g) {
        g.body = [];
        var z = this.labels;
        for (this.labels = [], this.enterScope(Re | Tt); this.type !== K.braceR; ) {
          var ce = this.parseStatement(null);
          g.body.push(ce);
        }
        return this.next(), this.exitScope(), this.labels = z, this.finishNode(g, "StaticBlock");
      }, d.parseClassId = function(g, z) {
        this.type === K.name ? (g.id = this.parseIdent(), z && this.checkLValSimple(g.id, et, !1)) : (z === !0 && this.unexpected(), g.id = null);
      }, d.parseClassSuper = function(g) {
        g.superClass = this.eat(K._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, d.enterClassBody = function() {
        var g = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(g), g.declared;
      }, d.exitClassBody = function() {
        var g = this.privateNameStack.pop(), z = g.declared, ce = g.used;
        if (this.options.checkPrivateFields)
          for (var xe = this.privateNameStack.length, Pe = xe === 0 ? null : this.privateNameStack[xe - 1], rt = 0; rt < ce.length; ++rt) {
            var pt = ce[rt];
            Ue(z, pt.name) || (Pe ? Pe.used.push(pt) : this.raiseRecoverable(pt.start, "Private field '#" + pt.name + "' must be declared in an enclosing class"));
          }
      };
      function L(g, z) {
        var ce = z.key.name, xe = g[ce], Pe = "true";
        return z.type === "MethodDefinition" && (z.kind === "get" || z.kind === "set") && (Pe = (z.static ? "s" : "i") + z.kind), xe === "iget" && Pe === "iset" || xe === "iset" && Pe === "iget" || xe === "sget" && Pe === "sset" || xe === "sset" && Pe === "sget" ? (g[ce] = "true", !1) : xe ? !0 : (g[ce] = Pe, !1);
      }
      function A(g, z) {
        var ce = g.computed, xe = g.key;
        return !ce && (xe.type === "Identifier" && xe.name === z || xe.type === "Literal" && xe.value === z);
      }
      d.parseExportAllDeclaration = function(g, z) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (g.exported = this.parseModuleExportName(), this.checkExport(z, g.exported, this.lastTokStart)) : g.exported = null), this.expectContextual("from"), this.type !== K.string && this.unexpected(), g.source = this.parseExprAtom(), this.semicolon(), this.finishNode(g, "ExportAllDeclaration");
      }, d.parseExport = function(g, z) {
        if (this.next(), this.eat(K.star))
          return this.parseExportAllDeclaration(g, z);
        if (this.eat(K._default))
          return this.checkExport(z, "default", this.lastTokStart), g.declaration = this.parseExportDefaultDeclaration(), this.finishNode(g, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          g.declaration = this.parseExportDeclaration(g), g.declaration.type === "VariableDeclaration" ? this.checkVariableExport(z, g.declaration.declarations) : this.checkExport(z, g.declaration.id, g.declaration.id.start), g.specifiers = [], g.source = null;
        else {
          if (g.declaration = null, g.specifiers = this.parseExportSpecifiers(z), this.eatContextual("from"))
            this.type !== K.string && this.unexpected(), g.source = this.parseExprAtom();
          else {
            for (var ce = 0, xe = g.specifiers; ce < xe.length; ce += 1) {
              var Pe = xe[ce];
              this.checkUnreserved(Pe.local), this.checkLocalExport(Pe.local), Pe.local.type === "Literal" && this.raise(Pe.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            g.source = null;
          }
          this.semicolon();
        }
        return this.finishNode(g, "ExportNamedDeclaration");
      }, d.parseExportDeclaration = function(g) {
        return this.parseStatement(null);
      }, d.parseExportDefaultDeclaration = function() {
        var g;
        if (this.type === K._function || (g = this.isAsyncFunction())) {
          var z = this.startNode();
          return this.next(), g && this.next(), this.parseFunction(z, x | E, !1, g);
        } else if (this.type === K._class) {
          var ce = this.startNode();
          return this.parseClass(ce, "nullableID");
        } else {
          var xe = this.parseMaybeAssign();
          return this.semicolon(), xe;
        }
      }, d.checkExport = function(g, z, ce) {
        g && (typeof z != "string" && (z = z.type === "Identifier" ? z.name : z.value), Ue(g, z) && this.raiseRecoverable(ce, "Duplicate export '" + z + "'"), g[z] = !0);
      }, d.checkPatternExport = function(g, z) {
        var ce = z.type;
        if (ce === "Identifier")
          this.checkExport(g, z, z.start);
        else if (ce === "ObjectPattern")
          for (var xe = 0, Pe = z.properties; xe < Pe.length; xe += 1) {
            var rt = Pe[xe];
            this.checkPatternExport(g, rt);
          }
        else if (ce === "ArrayPattern")
          for (var pt = 0, Dt = z.elements; pt < Dt.length; pt += 1) {
            var qt = Dt[pt];
            qt && this.checkPatternExport(g, qt);
          }
        else
          ce === "Property" ? this.checkPatternExport(g, z.value) : ce === "AssignmentPattern" ? this.checkPatternExport(g, z.left) : ce === "RestElement" && this.checkPatternExport(g, z.argument);
      }, d.checkVariableExport = function(g, z) {
        if (g)
          for (var ce = 0, xe = z; ce < xe.length; ce += 1) {
            var Pe = xe[ce];
            this.checkPatternExport(g, Pe.id);
          }
      }, d.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, d.parseExportSpecifier = function(g) {
        var z = this.startNode();
        return z.local = this.parseModuleExportName(), z.exported = this.eatContextual("as") ? this.parseModuleExportName() : z.local, this.checkExport(
          g,
          z.exported,
          z.exported.start
        ), this.finishNode(z, "ExportSpecifier");
      }, d.parseExportSpecifiers = function(g) {
        var z = [], ce = !0;
        for (this.expect(K.braceL); !this.eat(K.braceR); ) {
          if (ce)
            ce = !1;
          else if (this.expect(K.comma), this.afterTrailingComma(K.braceR))
            break;
          z.push(this.parseExportSpecifier(g));
        }
        return z;
      }, d.parseImport = function(g) {
        return this.next(), this.type === K.string ? (g.specifiers = b, g.source = this.parseExprAtom()) : (g.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), g.source = this.type === K.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(g, "ImportDeclaration");
      }, d.parseImportSpecifier = function() {
        var g = this.startNode();
        return g.imported = this.parseModuleExportName(), this.eatContextual("as") ? g.local = this.parseIdent() : (this.checkUnreserved(g.imported), g.local = g.imported), this.checkLValSimple(g.local, et), this.finishNode(g, "ImportSpecifier");
      }, d.parseImportDefaultSpecifier = function() {
        var g = this.startNode();
        return g.local = this.parseIdent(), this.checkLValSimple(g.local, et), this.finishNode(g, "ImportDefaultSpecifier");
      }, d.parseImportNamespaceSpecifier = function() {
        var g = this.startNode();
        return this.next(), this.expectContextual("as"), g.local = this.parseIdent(), this.checkLValSimple(g.local, et), this.finishNode(g, "ImportNamespaceSpecifier");
      }, d.parseImportSpecifiers = function() {
        var g = [], z = !0;
        if (this.type === K.name && (g.push(this.parseImportDefaultSpecifier()), !this.eat(K.comma)))
          return g;
        if (this.type === K.star)
          return g.push(this.parseImportNamespaceSpecifier()), g;
        for (this.expect(K.braceL); !this.eat(K.braceR); ) {
          if (z)
            z = !1;
          else if (this.expect(K.comma), this.afterTrailingComma(K.braceR))
            break;
          g.push(this.parseImportSpecifier());
        }
        return g;
      }, d.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === K.string) {
          var g = this.parseLiteral(this.value);
          return ct.test(g.value) && this.raise(g.start, "An export name cannot include a lone surrogate."), g;
        }
        return this.parseIdent(!0);
      }, d.adaptDirectivePrologue = function(g) {
        for (var z = 0; z < g.length && this.isDirectiveCandidate(g[z]); ++z)
          g[z].directive = g[z].expression.raw.slice(1, -1);
      }, d.isDirectiveCandidate = function(g) {
        return this.options.ecmaVersion >= 5 && g.type === "ExpressionStatement" && g.expression.type === "Literal" && typeof g.expression.value == "string" && // Reject parenthesized strings.
        (this.input[g.start] === '"' || this.input[g.start] === "'");
      };
      var U = i.prototype;
      U.toAssignable = function(g, z, ce) {
        if (this.options.ecmaVersion >= 6 && g)
          switch (g.type) {
            case "Identifier":
              this.inAsync && g.name === "await" && this.raise(g.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              g.type = "ObjectPattern", ce && this.checkPatternErrors(ce, !0);
              for (var xe = 0, Pe = g.properties; xe < Pe.length; xe += 1) {
                var rt = Pe[xe];
                this.toAssignable(rt, z), rt.type === "RestElement" && (rt.argument.type === "ArrayPattern" || rt.argument.type === "ObjectPattern") && this.raise(rt.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              g.kind !== "init" && this.raise(g.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(g.value, z);
              break;
            case "ArrayExpression":
              g.type = "ArrayPattern", ce && this.checkPatternErrors(ce, !0), this.toAssignableList(g.elements, z);
              break;
            case "SpreadElement":
              g.type = "RestElement", this.toAssignable(g.argument, z), g.argument.type === "AssignmentPattern" && this.raise(g.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              g.operator !== "=" && this.raise(g.left.end, "Only '=' operator can be used for specifying default value."), g.type = "AssignmentPattern", delete g.operator, this.toAssignable(g.left, z);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(g.expression, z, ce);
              break;
            case "ChainExpression":
              this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!z)
                break;
            default:
              this.raise(g.start, "Assigning to rvalue");
          }
        else
          ce && this.checkPatternErrors(ce, !0);
        return g;
      }, U.toAssignableList = function(g, z) {
        for (var ce = g.length, xe = 0; xe < ce; xe++) {
          var Pe = g[xe];
          Pe && this.toAssignable(Pe, z);
        }
        if (ce) {
          var rt = g[ce - 1];
          this.options.ecmaVersion === 6 && z && rt && rt.type === "RestElement" && rt.argument.type !== "Identifier" && this.unexpected(rt.argument.start);
        }
        return g;
      }, U.parseSpread = function(g) {
        var z = this.startNode();
        return this.next(), z.argument = this.parseMaybeAssign(!1, g), this.finishNode(z, "SpreadElement");
      }, U.parseRestBinding = function() {
        var g = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== K.name && this.unexpected(), g.argument = this.parseBindingAtom(), this.finishNode(g, "RestElement");
      }, U.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case K.bracketL:
              var g = this.startNode();
              return this.next(), g.elements = this.parseBindingList(K.bracketR, !0, !0), this.finishNode(g, "ArrayPattern");
            case K.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, U.parseBindingList = function(g, z, ce, xe) {
        for (var Pe = [], rt = !0; !this.eat(g); )
          if (rt ? rt = !1 : this.expect(K.comma), z && this.type === K.comma)
            Pe.push(null);
          else {
            if (ce && this.afterTrailingComma(g))
              break;
            if (this.type === K.ellipsis) {
              var pt = this.parseRestBinding();
              this.parseBindingListItem(pt), Pe.push(pt), this.type === K.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(g);
              break;
            } else
              Pe.push(this.parseAssignableListItem(xe));
          }
        return Pe;
      }, U.parseAssignableListItem = function(g) {
        var z = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(z), z;
      }, U.parseBindingListItem = function(g) {
        return g;
      }, U.parseMaybeDefault = function(g, z, ce) {
        if (ce = ce || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(K.eq))
          return ce;
        var xe = this.startNodeAt(g, z);
        return xe.left = ce, xe.right = this.parseMaybeAssign(), this.finishNode(xe, "AssignmentPattern");
      }, U.checkLValSimple = function(g, z, ce) {
        z === void 0 && (z = Bt);
        var xe = z !== Bt;
        switch (g.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(g.name) && this.raiseRecoverable(g.start, (xe ? "Binding " : "Assigning to ") + g.name + " in strict mode"), xe && (z === et && g.name === "let" && this.raiseRecoverable(g.start, "let is disallowed as a lexically bound name"), ce && (Ue(ce, g.name) && this.raiseRecoverable(g.start, "Argument name clash"), ce[g.name] = !0), z !== He && this.declareName(g.name, z, g.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            xe && this.raiseRecoverable(g.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return xe && this.raiseRecoverable(g.start, "Binding parenthesized expression"), this.checkLValSimple(g.expression, z, ce);
          default:
            this.raise(g.start, (xe ? "Binding" : "Assigning to") + " rvalue");
        }
      }, U.checkLValPattern = function(g, z, ce) {
        switch (z === void 0 && (z = Bt), g.type) {
          case "ObjectPattern":
            for (var xe = 0, Pe = g.properties; xe < Pe.length; xe += 1) {
              var rt = Pe[xe];
              this.checkLValInnerPattern(rt, z, ce);
            }
            break;
          case "ArrayPattern":
            for (var pt = 0, Dt = g.elements; pt < Dt.length; pt += 1) {
              var qt = Dt[pt];
              qt && this.checkLValInnerPattern(qt, z, ce);
            }
            break;
          default:
            this.checkLValSimple(g, z, ce);
        }
      }, U.checkLValInnerPattern = function(g, z, ce) {
        switch (z === void 0 && (z = Bt), g.type) {
          case "Property":
            this.checkLValInnerPattern(g.value, z, ce);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(g.left, z, ce);
            break;
          case "RestElement":
            this.checkLValPattern(g.argument, z, ce);
            break;
          default:
            this.checkLValPattern(g, z, ce);
        }
      };
      var k = function(z, ce, xe, Pe, rt) {
        this.token = z, this.isExpr = !!ce, this.preserveSpace = !!xe, this.override = Pe, this.generator = !!rt;
      }, F = {
        b_stat: new k("{", !1),
        b_expr: new k("{", !0),
        b_tmpl: new k("${", !1),
        p_stat: new k("(", !1),
        p_expr: new k("(", !0),
        q_tmpl: new k("`", !0, !0, function(g) {
          return g.tryReadTemplateToken();
        }),
        f_stat: new k("function", !1),
        f_expr: new k("function", !0),
        f_expr_gen: new k("function", !0, !1, null, !0),
        f_gen: new k("function", !1, !1, null, !0)
      }, B = i.prototype;
      B.initialContext = function() {
        return [F.b_stat];
      }, B.curContext = function() {
        return this.context[this.context.length - 1];
      }, B.braceIsBlock = function(g) {
        var z = this.curContext();
        return z === F.f_expr || z === F.f_stat ? !0 : g === K.colon && (z === F.b_stat || z === F.b_expr) ? !z.isExpr : g === K._return || g === K.name && this.exprAllowed ? j.test(this.input.slice(this.lastTokEnd, this.start)) : g === K._else || g === K.semi || g === K.eof || g === K.parenR || g === K.arrow ? !0 : g === K.braceL ? z === F.b_stat : g === K._var || g === K._const || g === K.name ? !1 : !this.exprAllowed;
      }, B.inGeneratorContext = function() {
        for (var g = this.context.length - 1; g >= 1; g--) {
          var z = this.context[g];
          if (z.token === "function")
            return z.generator;
        }
        return !1;
      }, B.updateContext = function(g) {
        var z, ce = this.type;
        ce.keyword && g === K.dot ? this.exprAllowed = !1 : (z = ce.updateContext) ? z.call(this, g) : this.exprAllowed = ce.beforeExpr;
      }, B.overrideContext = function(g) {
        this.curContext() !== g && (this.context[this.context.length - 1] = g);
      }, K.parenR.updateContext = K.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var g = this.context.pop();
        g === F.b_stat && this.curContext().token === "function" && (g = this.context.pop()), this.exprAllowed = !g.isExpr;
      }, K.braceL.updateContext = function(g) {
        this.context.push(this.braceIsBlock(g) ? F.b_stat : F.b_expr), this.exprAllowed = !0;
      }, K.dollarBraceL.updateContext = function() {
        this.context.push(F.b_tmpl), this.exprAllowed = !0;
      }, K.parenL.updateContext = function(g) {
        var z = g === K._if || g === K._for || g === K._with || g === K._while;
        this.context.push(z ? F.p_stat : F.p_expr), this.exprAllowed = !0;
      }, K.incDec.updateContext = function() {
      }, K._function.updateContext = K._class.updateContext = function(g) {
        g.beforeExpr && g !== K._else && !(g === K.semi && this.curContext() !== F.p_stat) && !(g === K._return && j.test(this.input.slice(this.lastTokEnd, this.start))) && !((g === K.colon || g === K.braceL) && this.curContext() === F.b_stat) ? this.context.push(F.f_expr) : this.context.push(F.f_stat), this.exprAllowed = !1;
      }, K.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, K.backQuote.updateContext = function() {
        this.curContext() === F.q_tmpl ? this.context.pop() : this.context.push(F.q_tmpl), this.exprAllowed = !1;
      }, K.star.updateContext = function(g) {
        if (g === K._function) {
          var z = this.context.length - 1;
          this.context[z] === F.f_expr ? this.context[z] = F.f_expr_gen : this.context[z] = F.f_gen;
        }
        this.exprAllowed = !0;
      }, K.name.updateContext = function(g) {
        var z = !1;
        this.options.ecmaVersion >= 6 && g !== K.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (z = !0), this.exprAllowed = z;
      };
      var R = i.prototype;
      R.checkPropClash = function(g, z, ce) {
        if (!(this.options.ecmaVersion >= 9 && g.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (g.computed || g.method || g.shorthand))) {
          var xe = g.key, Pe;
          switch (xe.type) {
            case "Identifier":
              Pe = xe.name;
              break;
            case "Literal":
              Pe = String(xe.value);
              break;
            default:
              return;
          }
          var rt = g.kind;
          if (this.options.ecmaVersion >= 6) {
            Pe === "__proto__" && rt === "init" && (z.proto && (ce ? ce.doubleProto < 0 && (ce.doubleProto = xe.start) : this.raiseRecoverable(xe.start, "Redefinition of __proto__ property")), z.proto = !0);
            return;
          }
          Pe = "$" + Pe;
          var pt = z[Pe];
          if (pt) {
            var Dt;
            rt === "init" ? Dt = this.strict && pt.init || pt.get || pt.set : Dt = pt.init || pt[rt], Dt && this.raiseRecoverable(xe.start, "Redefinition of property");
          } else
            pt = z[Pe] = {
              init: !1,
              get: !1,
              set: !1
            };
          pt[rt] = !0;
        }
      }, R.parseExpression = function(g, z) {
        var ce = this.start, xe = this.startLoc, Pe = this.parseMaybeAssign(g, z);
        if (this.type === K.comma) {
          var rt = this.startNodeAt(ce, xe);
          for (rt.expressions = [Pe]; this.eat(K.comma); )
            rt.expressions.push(this.parseMaybeAssign(g, z));
          return this.finishNode(rt, "SequenceExpression");
        }
        return Pe;
      }, R.parseMaybeAssign = function(g, z, ce) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(g);
          this.exprAllowed = !1;
        }
        var xe = !1, Pe = -1, rt = -1, pt = -1;
        z ? (Pe = z.parenthesizedAssign, rt = z.trailingComma, pt = z.doubleProto, z.parenthesizedAssign = z.trailingComma = -1) : (z = new h(), xe = !0);
        var Dt = this.start, qt = this.startLoc;
        (this.type === K.parenL || this.type === K.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = g === "await");
        var gi = this.parseMaybeConditional(g, z);
        if (ce && (gi = ce.call(this, gi, Dt, qt)), this.type.isAssign) {
          var vi = this.startNodeAt(Dt, qt);
          return vi.operator = this.value, this.type === K.eq && (gi = this.toAssignable(gi, !1, z)), xe || (z.parenthesizedAssign = z.trailingComma = z.doubleProto = -1), z.shorthandAssign >= gi.start && (z.shorthandAssign = -1), this.type === K.eq ? this.checkLValPattern(gi) : this.checkLValSimple(gi), vi.left = gi, this.next(), vi.right = this.parseMaybeAssign(g), pt > -1 && (z.doubleProto = pt), this.finishNode(vi, "AssignmentExpression");
        } else
          xe && this.checkExpressionErrors(z, !0);
        return Pe > -1 && (z.parenthesizedAssign = Pe), rt > -1 && (z.trailingComma = rt), gi;
      }, R.parseMaybeConditional = function(g, z) {
        var ce = this.start, xe = this.startLoc, Pe = this.parseExprOps(g, z);
        if (this.checkExpressionErrors(z))
          return Pe;
        if (this.eat(K.question)) {
          var rt = this.startNodeAt(ce, xe);
          return rt.test = Pe, rt.consequent = this.parseMaybeAssign(), this.expect(K.colon), rt.alternate = this.parseMaybeAssign(g), this.finishNode(rt, "ConditionalExpression");
        }
        return Pe;
      }, R.parseExprOps = function(g, z) {
        var ce = this.start, xe = this.startLoc, Pe = this.parseMaybeUnary(z, !1, !1, g);
        return this.checkExpressionErrors(z) || Pe.start === ce && Pe.type === "ArrowFunctionExpression" ? Pe : this.parseExprOp(Pe, ce, xe, -1, g);
      }, R.parseExprOp = function(g, z, ce, xe, Pe) {
        var rt = this.type.binop;
        if (rt != null && (!Pe || this.type !== K._in) && rt > xe) {
          var pt = this.type === K.logicalOR || this.type === K.logicalAND, Dt = this.type === K.coalesce;
          Dt && (rt = K.logicalAND.binop);
          var qt = this.value;
          this.next();
          var gi = this.start, vi = this.startLoc, ln = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, Pe), gi, vi, rt, Pe), cr = this.buildBinary(z, ce, g, ln, qt, pt || Dt);
          return (pt && this.type === K.coalesce || Dt && (this.type === K.logicalOR || this.type === K.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(cr, z, ce, xe, Pe);
        }
        return g;
      }, R.buildBinary = function(g, z, ce, xe, Pe, rt) {
        xe.type === "PrivateIdentifier" && this.raise(xe.start, "Private identifier can only be left side of binary expression");
        var pt = this.startNodeAt(g, z);
        return pt.left = ce, pt.operator = Pe, pt.right = xe, this.finishNode(pt, rt ? "LogicalExpression" : "BinaryExpression");
      }, R.parseMaybeUnary = function(g, z, ce, xe) {
        var Pe = this.start, rt = this.startLoc, pt;
        if (this.isContextual("await") && this.canAwait)
          pt = this.parseAwait(xe), z = !0;
        else if (this.type.prefix) {
          var Dt = this.startNode(), qt = this.type === K.incDec;
          Dt.operator = this.value, Dt.prefix = !0, this.next(), Dt.argument = this.parseMaybeUnary(null, !0, qt, xe), this.checkExpressionErrors(g, !0), qt ? this.checkLValSimple(Dt.argument) : this.strict && Dt.operator === "delete" && Dt.argument.type === "Identifier" ? this.raiseRecoverable(Dt.start, "Deleting local variable in strict mode") : Dt.operator === "delete" && C(Dt.argument) ? this.raiseRecoverable(Dt.start, "Private fields can not be deleted") : z = !0, pt = this.finishNode(Dt, qt ? "UpdateExpression" : "UnaryExpression");
        } else if (!z && this.type === K.privateId)
          (xe || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), pt = this.parsePrivateIdent(), this.type !== K._in && this.unexpected();
        else {
          if (pt = this.parseExprSubscripts(g, xe), this.checkExpressionErrors(g))
            return pt;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var gi = this.startNodeAt(Pe, rt);
            gi.operator = this.value, gi.prefix = !1, gi.argument = pt, this.checkLValSimple(pt), this.next(), pt = this.finishNode(gi, "UpdateExpression");
          }
        }
        if (!ce && this.eat(K.starstar))
          if (z)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(Pe, rt, pt, this.parseMaybeUnary(null, !1, !1, xe), "**", !1);
        else
          return pt;
      };
      function C(g) {
        return g.type === "MemberExpression" && g.property.type === "PrivateIdentifier" || g.type === "ChainExpression" && C(g.expression);
      }
      R.parseExprSubscripts = function(g, z) {
        var ce = this.start, xe = this.startLoc, Pe = this.parseExprAtom(g, z);
        if (Pe.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return Pe;
        var rt = this.parseSubscripts(Pe, ce, xe, !1, z);
        return g && rt.type === "MemberExpression" && (g.parenthesizedAssign >= rt.start && (g.parenthesizedAssign = -1), g.parenthesizedBind >= rt.start && (g.parenthesizedBind = -1), g.trailingComma >= rt.start && (g.trailingComma = -1)), rt;
      }, R.parseSubscripts = function(g, z, ce, xe, Pe) {
        for (var rt = this.options.ecmaVersion >= 8 && g.type === "Identifier" && g.name === "async" && this.lastTokEnd === g.end && !this.canInsertSemicolon() && g.end - g.start === 5 && this.potentialArrowAt === g.start, pt = !1; ; ) {
          var Dt = this.parseSubscript(g, z, ce, xe, rt, pt, Pe);
          if (Dt.optional && (pt = !0), Dt === g || Dt.type === "ArrowFunctionExpression") {
            if (pt) {
              var qt = this.startNodeAt(z, ce);
              qt.expression = Dt, Dt = this.finishNode(qt, "ChainExpression");
            }
            return Dt;
          }
          g = Dt;
        }
      }, R.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(K.arrow);
      }, R.parseSubscriptAsyncArrow = function(g, z, ce, xe) {
        return this.parseArrowExpression(this.startNodeAt(g, z), ce, !0, xe);
      }, R.parseSubscript = function(g, z, ce, xe, Pe, rt, pt) {
        var Dt = this.options.ecmaVersion >= 11, qt = Dt && this.eat(K.questionDot);
        xe && qt && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var gi = this.eat(K.bracketL);
        if (gi || qt && this.type !== K.parenL && this.type !== K.backQuote || this.eat(K.dot)) {
          var vi = this.startNodeAt(z, ce);
          vi.object = g, gi ? (vi.property = this.parseExpression(), this.expect(K.bracketR)) : this.type === K.privateId && g.type !== "Super" ? vi.property = this.parsePrivateIdent() : vi.property = this.parseIdent(this.options.allowReserved !== "never"), vi.computed = !!gi, Dt && (vi.optional = qt), g = this.finishNode(vi, "MemberExpression");
        } else if (!xe && this.eat(K.parenL)) {
          var ln = new h(), cr = this.yieldPos, Lr = this.awaitPos, br = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var Fr = this.parseExprList(K.parenR, this.options.ecmaVersion >= 8, !1, ln);
          if (Pe && !qt && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(ln, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = cr, this.awaitPos = Lr, this.awaitIdentPos = br, this.parseSubscriptAsyncArrow(z, ce, Fr, pt);
          this.checkExpressionErrors(ln, !0), this.yieldPos = cr || this.yieldPos, this.awaitPos = Lr || this.awaitPos, this.awaitIdentPos = br || this.awaitIdentPos;
          var Fi = this.startNodeAt(z, ce);
          Fi.callee = g, Fi.arguments = Fr, Dt && (Fi.optional = qt), g = this.finishNode(Fi, "CallExpression");
        } else if (this.type === K.backQuote) {
          (qt || rt) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var Ri = this.startNodeAt(z, ce);
          Ri.tag = g, Ri.quasi = this.parseTemplate({ isTagged: !0 }), g = this.finishNode(Ri, "TaggedTemplateExpression");
        }
        return g;
      }, R.parseExprAtom = function(g, z, ce) {
        this.type === K.slash && this.readRegexp();
        var xe, Pe = this.potentialArrowAt === this.start;
        switch (this.type) {
          case K._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), xe = this.startNode(), this.next(), this.type === K.parenL && !this.allowDirectSuper && this.raise(xe.start, "super() call outside constructor of a subclass"), this.type !== K.dot && this.type !== K.bracketL && this.type !== K.parenL && this.unexpected(), this.finishNode(xe, "Super");
          case K._this:
            return xe = this.startNode(), this.next(), this.finishNode(xe, "ThisExpression");
          case K.name:
            var rt = this.start, pt = this.startLoc, Dt = this.containsEsc, qt = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !Dt && qt.name === "async" && !this.canInsertSemicolon() && this.eat(K._function))
              return this.overrideContext(F.f_expr), this.parseFunction(this.startNodeAt(rt, pt), 0, !1, !0, z);
            if (Pe && !this.canInsertSemicolon()) {
              if (this.eat(K.arrow))
                return this.parseArrowExpression(this.startNodeAt(rt, pt), [qt], !1, z);
              if (this.options.ecmaVersion >= 8 && qt.name === "async" && this.type === K.name && !Dt && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return qt = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(K.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(rt, pt), [qt], !0, z);
            }
            return qt;
          case K.regexp:
            var gi = this.value;
            return xe = this.parseLiteral(gi.value), xe.regex = { pattern: gi.pattern, flags: gi.flags }, xe;
          case K.num:
          case K.string:
            return this.parseLiteral(this.value);
          case K._null:
          case K._true:
          case K._false:
            return xe = this.startNode(), xe.value = this.type === K._null ? null : this.type === K._true, xe.raw = this.type.keyword, this.next(), this.finishNode(xe, "Literal");
          case K.parenL:
            var vi = this.start, ln = this.parseParenAndDistinguishExpression(Pe, z);
            return g && (g.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(ln) && (g.parenthesizedAssign = vi), g.parenthesizedBind < 0 && (g.parenthesizedBind = vi)), ln;
          case K.bracketL:
            return xe = this.startNode(), this.next(), xe.elements = this.parseExprList(K.bracketR, !0, !0, g), this.finishNode(xe, "ArrayExpression");
          case K.braceL:
            return this.overrideContext(F.b_expr), this.parseObj(!1, g);
          case K._function:
            return xe = this.startNode(), this.next(), this.parseFunction(xe, 0);
          case K._class:
            return this.parseClass(this.startNode(), !1);
          case K._new:
            return this.parseNew();
          case K.backQuote:
            return this.parseTemplate();
          case K._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(ce) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, R.parseExprAtomDefault = function() {
        this.unexpected();
      }, R.parseExprImport = function(g) {
        var z = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === K.parenL && !g)
          return this.parseDynamicImport(z);
        if (this.type === K.dot) {
          var ce = this.startNodeAt(z.start, z.loc && z.loc.start);
          return ce.name = "import", z.meta = this.finishNode(ce, "Identifier"), this.parseImportMeta(z);
        } else
          this.unexpected();
      }, R.parseDynamicImport = function(g) {
        if (this.next(), g.source = this.parseMaybeAssign(), !this.eat(K.parenR)) {
          var z = this.start;
          this.eat(K.comma) && this.eat(K.parenR) ? this.raiseRecoverable(z, "Trailing comma is not allowed in import()") : this.unexpected(z);
        }
        return this.finishNode(g, "ImportExpression");
      }, R.parseImportMeta = function(g) {
        this.next();
        var z = this.containsEsc;
        return g.property = this.parseIdent(!0), g.property.name !== "meta" && this.raiseRecoverable(g.property.start, "The only valid meta property for import is 'import.meta'"), z && this.raiseRecoverable(g.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(g.start, "Cannot use 'import.meta' outside a module"), this.finishNode(g, "MetaProperty");
      }, R.parseLiteral = function(g) {
        var z = this.startNode();
        return z.value = g, z.raw = this.input.slice(this.start, this.end), z.raw.charCodeAt(z.raw.length - 1) === 110 && (z.bigint = z.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(z, "Literal");
      }, R.parseParenExpression = function() {
        this.expect(K.parenL);
        var g = this.parseExpression();
        return this.expect(K.parenR), g;
      }, R.shouldParseArrow = function(g) {
        return !this.canInsertSemicolon();
      }, R.parseParenAndDistinguishExpression = function(g, z) {
        var ce = this.start, xe = this.startLoc, Pe, rt = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var pt = this.start, Dt = this.startLoc, qt = [], gi = !0, vi = !1, ln = new h(), cr = this.yieldPos, Lr = this.awaitPos, br;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== K.parenR; )
            if (gi ? gi = !1 : this.expect(K.comma), rt && this.afterTrailingComma(K.parenR, !0)) {
              vi = !0;
              break;
            } else if (this.type === K.ellipsis) {
              br = this.start, qt.push(this.parseParenItem(this.parseRestBinding())), this.type === K.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              qt.push(this.parseMaybeAssign(!1, ln, this.parseParenItem));
          var Fr = this.lastTokEnd, Fi = this.lastTokEndLoc;
          if (this.expect(K.parenR), g && this.shouldParseArrow(qt) && this.eat(K.arrow))
            return this.checkPatternErrors(ln, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = cr, this.awaitPos = Lr, this.parseParenArrowList(ce, xe, qt, z);
          (!qt.length || vi) && this.unexpected(this.lastTokStart), br && this.unexpected(br), this.checkExpressionErrors(ln, !0), this.yieldPos = cr || this.yieldPos, this.awaitPos = Lr || this.awaitPos, qt.length > 1 ? (Pe = this.startNodeAt(pt, Dt), Pe.expressions = qt, this.finishNodeAt(Pe, "SequenceExpression", Fr, Fi)) : Pe = qt[0];
        } else
          Pe = this.parseParenExpression();
        if (this.options.preserveParens) {
          var Ri = this.startNodeAt(ce, xe);
          return Ri.expression = Pe, this.finishNode(Ri, "ParenthesizedExpression");
        } else
          return Pe;
      }, R.parseParenItem = function(g) {
        return g;
      }, R.parseParenArrowList = function(g, z, ce, xe) {
        return this.parseArrowExpression(this.startNodeAt(g, z), ce, !1, xe);
      };
      var P = [];
      R.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var g = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === K.dot) {
          var z = this.startNodeAt(g.start, g.loc && g.loc.start);
          z.name = "new", g.meta = this.finishNode(z, "Identifier"), this.next();
          var ce = this.containsEsc;
          return g.property = this.parseIdent(!0), g.property.name !== "target" && this.raiseRecoverable(g.property.start, "The only valid meta property for new is 'new.target'"), ce && this.raiseRecoverable(g.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(g.start, "'new.target' can only be used in functions and class static block"), this.finishNode(g, "MetaProperty");
        }
        var xe = this.start, Pe = this.startLoc;
        return g.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), xe, Pe, !0, !1), this.eat(K.parenL) ? g.arguments = this.parseExprList(K.parenR, this.options.ecmaVersion >= 8, !1) : g.arguments = P, this.finishNode(g, "NewExpression");
      }, R.parseTemplateElement = function(g) {
        var z = g.isTagged, ce = this.startNode();
        return this.type === K.invalidTemplate ? (z || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), ce.value = {
          raw: this.value,
          cooked: null
        }) : ce.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), ce.tail = this.type === K.backQuote, this.finishNode(ce, "TemplateElement");
      }, R.parseTemplate = function(g) {
        g === void 0 && (g = {});
        var z = g.isTagged;
        z === void 0 && (z = !1);
        var ce = this.startNode();
        this.next(), ce.expressions = [];
        var xe = this.parseTemplateElement({ isTagged: z });
        for (ce.quasis = [xe]; !xe.tail; )
          this.type === K.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(K.dollarBraceL), ce.expressions.push(this.parseExpression()), this.expect(K.braceR), ce.quasis.push(xe = this.parseTemplateElement({ isTagged: z }));
        return this.next(), this.finishNode(ce, "TemplateLiteral");
      }, R.isAsyncProp = function(g) {
        return !g.computed && g.key.type === "Identifier" && g.key.name === "async" && (this.type === K.name || this.type === K.num || this.type === K.string || this.type === K.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === K.star) && !j.test(this.input.slice(this.lastTokEnd, this.start));
      }, R.parseObj = function(g, z) {
        var ce = this.startNode(), xe = !0, Pe = {};
        for (ce.properties = [], this.next(); !this.eat(K.braceR); ) {
          if (xe)
            xe = !1;
          else if (this.expect(K.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(K.braceR))
            break;
          var rt = this.parseProperty(g, z);
          g || this.checkPropClash(rt, Pe, z), ce.properties.push(rt);
        }
        return this.finishNode(ce, g ? "ObjectPattern" : "ObjectExpression");
      }, R.parseProperty = function(g, z) {
        var ce = this.startNode(), xe, Pe, rt, pt;
        if (this.options.ecmaVersion >= 9 && this.eat(K.ellipsis))
          return g ? (ce.argument = this.parseIdent(!1), this.type === K.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(ce, "RestElement")) : (ce.argument = this.parseMaybeAssign(!1, z), this.type === K.comma && z && z.trailingComma < 0 && (z.trailingComma = this.start), this.finishNode(ce, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (ce.method = !1, ce.shorthand = !1, (g || z) && (rt = this.start, pt = this.startLoc), g || (xe = this.eat(K.star)));
        var Dt = this.containsEsc;
        return this.parsePropertyName(ce), !g && !Dt && this.options.ecmaVersion >= 8 && !xe && this.isAsyncProp(ce) ? (Pe = !0, xe = this.options.ecmaVersion >= 9 && this.eat(K.star), this.parsePropertyName(ce)) : Pe = !1, this.parsePropertyValue(ce, g, xe, Pe, rt, pt, z, Dt), this.finishNode(ce, "Property");
      }, R.parseGetterSetter = function(g) {
        g.kind = g.key.name, this.parsePropertyName(g), g.value = this.parseMethod(!1);
        var z = g.kind === "get" ? 0 : 1;
        if (g.value.params.length !== z) {
          var ce = g.value.start;
          g.kind === "get" ? this.raiseRecoverable(ce, "getter should have no params") : this.raiseRecoverable(ce, "setter should have exactly one param");
        } else
          g.kind === "set" && g.value.params[0].type === "RestElement" && this.raiseRecoverable(g.value.params[0].start, "Setter cannot use rest params");
      }, R.parsePropertyValue = function(g, z, ce, xe, Pe, rt, pt, Dt) {
        (ce || xe) && this.type === K.colon && this.unexpected(), this.eat(K.colon) ? (g.value = z ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, pt), g.kind = "init") : this.options.ecmaVersion >= 6 && this.type === K.parenL ? (z && this.unexpected(), g.kind = "init", g.method = !0, g.value = this.parseMethod(ce, xe)) : !z && !Dt && this.options.ecmaVersion >= 5 && !g.computed && g.key.type === "Identifier" && (g.key.name === "get" || g.key.name === "set") && this.type !== K.comma && this.type !== K.braceR && this.type !== K.eq ? ((ce || xe) && this.unexpected(), this.parseGetterSetter(g)) : this.options.ecmaVersion >= 6 && !g.computed && g.key.type === "Identifier" ? ((ce || xe) && this.unexpected(), this.checkUnreserved(g.key), g.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = Pe), g.kind = "init", z ? g.value = this.parseMaybeDefault(Pe, rt, this.copyNode(g.key)) : this.type === K.eq && pt ? (pt.shorthandAssign < 0 && (pt.shorthandAssign = this.start), g.value = this.parseMaybeDefault(Pe, rt, this.copyNode(g.key))) : g.value = this.copyNode(g.key), g.shorthand = !0) : this.unexpected();
      }, R.parsePropertyName = function(g) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(K.bracketL))
            return g.computed = !0, g.key = this.parseMaybeAssign(), this.expect(K.bracketR), g.key;
          g.computed = !1;
        }
        return g.key = this.type === K.num || this.type === K.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, R.initFunction = function(g) {
        g.id = null, this.options.ecmaVersion >= 6 && (g.generator = g.expression = !1), this.options.ecmaVersion >= 8 && (g.async = !1);
      }, R.parseMethod = function(g, z, ce) {
        var xe = this.startNode(), Pe = this.yieldPos, rt = this.awaitPos, pt = this.awaitIdentPos;
        return this.initFunction(xe), this.options.ecmaVersion >= 6 && (xe.generator = g), this.options.ecmaVersion >= 8 && (xe.async = !!z), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Qe(z, xe.generator) | Tt | (ce ? xt : 0)), this.expect(K.parenL), xe.params = this.parseBindingList(K.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(xe, !1, !0, !1), this.yieldPos = Pe, this.awaitPos = rt, this.awaitIdentPos = pt, this.finishNode(xe, "FunctionExpression");
      }, R.parseArrowExpression = function(g, z, ce, xe) {
        var Pe = this.yieldPos, rt = this.awaitPos, pt = this.awaitIdentPos;
        return this.enterScope(Qe(ce, !1) | tn), this.initFunction(g), this.options.ecmaVersion >= 8 && (g.async = !!ce), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, g.params = this.toAssignableList(z, !0), this.parseFunctionBody(g, !0, !1, xe), this.yieldPos = Pe, this.awaitPos = rt, this.awaitIdentPos = pt, this.finishNode(g, "ArrowFunctionExpression");
      }, R.parseFunctionBody = function(g, z, ce, xe) {
        var Pe = z && this.type !== K.braceL, rt = this.strict, pt = !1;
        if (Pe)
          g.body = this.parseMaybeAssign(xe), g.expression = !0, this.checkParams(g, !1);
        else {
          var Dt = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(g.params);
          (!rt || Dt) && (pt = this.strictDirective(this.end), pt && Dt && this.raiseRecoverable(g.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var qt = this.labels;
          this.labels = [], pt && (this.strict = !0), this.checkParams(g, !rt && !pt && !z && !ce && this.isSimpleParamList(g.params)), this.strict && g.id && this.checkLValSimple(g.id, He), g.body = this.parseBlock(!1, void 0, pt && !rt), g.expression = !1, this.adaptDirectivePrologue(g.body.body), this.labels = qt;
        }
        this.exitScope();
      }, R.isSimpleParamList = function(g) {
        for (var z = 0, ce = g; z < ce.length; z += 1) {
          var xe = ce[z];
          if (xe.type !== "Identifier")
            return !1;
        }
        return !0;
      }, R.checkParams = function(g, z) {
        for (var ce = /* @__PURE__ */ Object.create(null), xe = 0, Pe = g.params; xe < Pe.length; xe += 1) {
          var rt = Pe[xe];
          this.checkLValInnerPattern(rt, dt, z ? null : ce);
        }
      }, R.parseExprList = function(g, z, ce, xe) {
        for (var Pe = [], rt = !0; !this.eat(g); ) {
          if (rt)
            rt = !1;
          else if (this.expect(K.comma), z && this.afterTrailingComma(g))
            break;
          var pt = void 0;
          ce && this.type === K.comma ? pt = null : this.type === K.ellipsis ? (pt = this.parseSpread(xe), xe && this.type === K.comma && xe.trailingComma < 0 && (xe.trailingComma = this.start)) : pt = this.parseMaybeAssign(!1, xe), Pe.push(pt);
        }
        return Pe;
      }, R.checkUnreserved = function(g) {
        var z = g.start, ce = g.end, xe = g.name;
        if (this.inGenerator && xe === "yield" && this.raiseRecoverable(z, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && xe === "await" && this.raiseRecoverable(z, "Cannot use 'await' as identifier inside an async function"), this.currentThisScope().inClassFieldInit && xe === "arguments" && this.raiseRecoverable(z, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (xe === "arguments" || xe === "await") && this.raise(z, "Cannot use " + xe + " in class static initialization block"), this.keywords.test(xe) && this.raise(z, "Unexpected keyword '" + xe + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(z, ce).indexOf("\\") !== -1)) {
          var Pe = this.strict ? this.reservedWordsStrict : this.reservedWords;
          Pe.test(xe) && (!this.inAsync && xe === "await" && this.raiseRecoverable(z, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(z, "The keyword '" + xe + "' is reserved"));
        }
      }, R.parseIdent = function(g) {
        var z = this.parseIdentNode();
        return this.next(!!g), this.finishNode(z, "Identifier"), g || (this.checkUnreserved(z), z.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = z.start)), z;
      }, R.parseIdentNode = function() {
        var g = this.startNode();
        return this.type === K.name ? g.name = this.value : this.type.keyword ? (g.name = this.type.keyword, (g.name === "class" || g.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = K.name) : this.unexpected(), g;
      }, R.parsePrivateIdent = function() {
        var g = this.startNode();
        return this.type === K.privateId ? g.name = this.value : this.unexpected(), this.next(), this.finishNode(g, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(g.start, "Private field '#" + g.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(g)), g;
      }, R.parseYield = function(g) {
        this.yieldPos || (this.yieldPos = this.start);
        var z = this.startNode();
        return this.next(), this.type === K.semi || this.canInsertSemicolon() || this.type !== K.star && !this.type.startsExpr ? (z.delegate = !1, z.argument = null) : (z.delegate = this.eat(K.star), z.argument = this.parseMaybeAssign(g)), this.finishNode(z, "YieldExpression");
      }, R.parseAwait = function(g) {
        this.awaitPos || (this.awaitPos = this.start);
        var z = this.startNode();
        return this.next(), z.argument = this.parseMaybeUnary(null, !0, !1, g), this.finishNode(z, "AwaitExpression");
      };
      var H = i.prototype;
      H.raise = function(g, z) {
        var ce = Kt(this.input, g);
        z += " (" + ce.line + ":" + ce.column + ")";
        var xe = new SyntaxError(z);
        throw xe.pos = g, xe.loc = ce, xe.raisedAt = this.pos, xe;
      }, H.raiseRecoverable = H.raise, H.curPosition = function() {
        if (this.options.locations)
          return new lt(this.curLine, this.pos - this.lineStart);
      };
      var W = i.prototype, V = function(z) {
        this.flags = z, this.var = [], this.lexical = [], this.functions = [], this.inClassFieldInit = !1;
      };
      W.enterScope = function(g) {
        this.scopeStack.push(new V(g));
      }, W.exitScope = function() {
        this.scopeStack.pop();
      }, W.treatFunctionsAsVarInScope = function(g) {
        return g.flags & Qt || !this.inModule && g.flags & Wt;
      }, W.declareName = function(g, z, ce) {
        var xe = !1;
        if (z === et) {
          var Pe = this.currentScope();
          xe = Pe.lexical.indexOf(g) > -1 || Pe.functions.indexOf(g) > -1 || Pe.var.indexOf(g) > -1, Pe.lexical.push(g), this.inModule && Pe.flags & Wt && delete this.undefinedExports[g];
        } else if (z === Xt) {
          var rt = this.currentScope();
          rt.lexical.push(g);
        } else if (z === wt) {
          var pt = this.currentScope();
          this.treatFunctionsAsVar ? xe = pt.lexical.indexOf(g) > -1 : xe = pt.lexical.indexOf(g) > -1 || pt.var.indexOf(g) > -1, pt.functions.push(g);
        } else
          for (var Dt = this.scopeStack.length - 1; Dt >= 0; --Dt) {
            var qt = this.scopeStack[Dt];
            if (qt.lexical.indexOf(g) > -1 && !(qt.flags & pe && qt.lexical[0] === g) || !this.treatFunctionsAsVarInScope(qt) && qt.functions.indexOf(g) > -1) {
              xe = !0;
              break;
            }
            if (qt.var.push(g), this.inModule && qt.flags & Wt && delete this.undefinedExports[g], qt.flags & Ie)
              break;
          }
        xe && this.raiseRecoverable(ce, "Identifier '" + g + "' has already been declared");
      }, W.checkLocalExport = function(g) {
        this.scopeStack[0].lexical.indexOf(g.name) === -1 && this.scopeStack[0].var.indexOf(g.name) === -1 && (this.undefinedExports[g.name] = g);
      }, W.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, W.currentVarScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var z = this.scopeStack[g];
          if (z.flags & Ie)
            return z;
        }
      }, W.currentThisScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var z = this.scopeStack[g];
          if (z.flags & Ie && !(z.flags & tn))
            return z;
        }
      };
      var Q = function(z, ce, xe) {
        this.type = "", this.start = ce, this.end = 0, z.options.locations && (this.loc = new $t(z, xe)), z.options.directSourceFile && (this.sourceFile = z.options.directSourceFile), z.options.ranges && (this.range = [ce, 0]);
      }, ae = i.prototype;
      ae.startNode = function() {
        return new Q(this, this.start, this.startLoc);
      }, ae.startNodeAt = function(g, z) {
        return new Q(this, g, z);
      };
      function le(g, z, ce, xe) {
        return g.type = z, g.end = ce, this.options.locations && (g.loc.end = xe), this.options.ranges && (g.range[1] = ce), g;
      }
      ae.finishNode = function(g, z) {
        return le.call(this, g, z, this.lastTokEnd, this.lastTokEndLoc);
      }, ae.finishNodeAt = function(g, z, ce, xe) {
        return le.call(this, g, z, ce, xe);
      }, ae.copyNode = function(g) {
        var z = new Q(this, g.start, this.startLoc);
        for (var ce in g)
          z[ce] = g[ce];
        return z;
      };
      var fe = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", se = fe + " Extended_Pictographic", ge = se, me = ge + " EBase EComp EMod EPres ExtPict", we = me, Se = we, Ae = {
        9: fe,
        10: se,
        11: ge,
        12: me,
        13: we,
        14: Se
      }, Ge = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", Je = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: Ge
      }, tt = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", ft = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Ne = ft + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", ze = Ne + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", nt = ze + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", _t = nt + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", mt = _t + " Hrkt Katakana_Or_Hiragana Kawi Nag_Mundari Nagm Unknown Zzzz", Pt = {
        9: ft,
        10: Ne,
        11: ze,
        12: nt,
        13: _t,
        14: mt
      }, Et = {};
      function zt(g) {
        var z = Et[g] = {
          binary: it(Ae[g] + " " + tt),
          binaryOfStrings: it(Je[g]),
          nonBinary: {
            General_Category: it(tt),
            Script: it(Pt[g])
          }
        };
        z.nonBinary.Script_Extensions = z.nonBinary.Script, z.nonBinary.gc = z.nonBinary.General_Category, z.nonBinary.sc = z.nonBinary.Script, z.nonBinary.scx = z.nonBinary.Script_Extensions;
      }
      for (var jt = 0, Ft = [9, 10, 11, 12, 13, 14]; jt < Ft.length; jt += 1) {
        var Mi = Ft[jt];
        zt(Mi);
      }
      var Rt = i.prototype, hi = function(z) {
        this.parser = z, this.validFlags = "gim" + (z.options.ecmaVersion >= 6 ? "uy" : "") + (z.options.ecmaVersion >= 9 ? "s" : "") + (z.options.ecmaVersion >= 13 ? "d" : "") + (z.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Et[z.options.ecmaVersion >= 14 ? 14 : z.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
      };
      hi.prototype.reset = function(z, ce, xe) {
        var Pe = xe.indexOf("v") !== -1, rt = xe.indexOf("u") !== -1;
        this.start = z | 0, this.source = ce + "", this.flags = xe, Pe && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = rt && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = rt && this.parser.options.ecmaVersion >= 9);
      }, hi.prototype.raise = function(z) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + z);
      }, hi.prototype.at = function(z, ce) {
        ce === void 0 && (ce = !1);
        var xe = this.source, Pe = xe.length;
        if (z >= Pe)
          return -1;
        var rt = xe.charCodeAt(z);
        if (!(ce || this.switchU) || rt <= 55295 || rt >= 57344 || z + 1 >= Pe)
          return rt;
        var pt = xe.charCodeAt(z + 1);
        return pt >= 56320 && pt <= 57343 ? (rt << 10) + pt - 56613888 : rt;
      }, hi.prototype.nextIndex = function(z, ce) {
        ce === void 0 && (ce = !1);
        var xe = this.source, Pe = xe.length;
        if (z >= Pe)
          return Pe;
        var rt = xe.charCodeAt(z), pt;
        return !(ce || this.switchU) || rt <= 55295 || rt >= 57344 || z + 1 >= Pe || (pt = xe.charCodeAt(z + 1)) < 56320 || pt > 57343 ? z + 1 : z + 2;
      }, hi.prototype.current = function(z) {
        return z === void 0 && (z = !1), this.at(this.pos, z);
      }, hi.prototype.lookahead = function(z) {
        return z === void 0 && (z = !1), this.at(this.nextIndex(this.pos, z), z);
      }, hi.prototype.advance = function(z) {
        z === void 0 && (z = !1), this.pos = this.nextIndex(this.pos, z);
      }, hi.prototype.eat = function(z, ce) {
        return ce === void 0 && (ce = !1), this.current(ce) === z ? (this.advance(ce), !0) : !1;
      }, hi.prototype.eatChars = function(z, ce) {
        ce === void 0 && (ce = !1);
        for (var xe = this.pos, Pe = 0, rt = z; Pe < rt.length; Pe += 1) {
          var pt = rt[Pe], Dt = this.at(xe, ce);
          if (Dt === -1 || Dt !== pt)
            return !1;
          xe = this.nextIndex(xe, ce);
        }
        return this.pos = xe, !0;
      }, Rt.validateRegExpFlags = function(g) {
        for (var z = g.validFlags, ce = g.flags, xe = !1, Pe = !1, rt = 0; rt < ce.length; rt++) {
          var pt = ce.charAt(rt);
          z.indexOf(pt) === -1 && this.raise(g.start, "Invalid regular expression flag"), ce.indexOf(pt, rt + 1) > -1 && this.raise(g.start, "Duplicate regular expression flag"), pt === "u" && (xe = !0), pt === "v" && (Pe = !0);
        }
        this.options.ecmaVersion >= 15 && xe && Pe && this.raise(g.start, "Invalid regular expression flag");
      }, Rt.validateRegExpPattern = function(g) {
        this.regexp_pattern(g), !g.switchN && this.options.ecmaVersion >= 9 && g.groupNames.length > 0 && (g.switchN = !0, this.regexp_pattern(g));
      }, Rt.regexp_pattern = function(g) {
        g.pos = 0, g.lastIntValue = 0, g.lastStringValue = "", g.lastAssertionIsQuantifiable = !1, g.numCapturingParens = 0, g.maxBackReference = 0, g.groupNames.length = 0, g.backReferenceNames.length = 0, this.regexp_disjunction(g), g.pos !== g.source.length && (g.eat(
          41
          /* ) */
        ) && g.raise("Unmatched ')'"), (g.eat(
          93
          /* ] */
        ) || g.eat(
          125
          /* } */
        )) && g.raise("Lone quantifier brackets")), g.maxBackReference > g.numCapturingParens && g.raise("Invalid escape");
        for (var z = 0, ce = g.backReferenceNames; z < ce.length; z += 1) {
          var xe = ce[z];
          g.groupNames.indexOf(xe) === -1 && g.raise("Invalid named capture referenced");
        }
      }, Rt.regexp_disjunction = function(g) {
        for (this.regexp_alternative(g); g.eat(
          124
          /* | */
        ); )
          this.regexp_alternative(g);
        this.regexp_eatQuantifier(g, !0) && g.raise("Nothing to repeat"), g.eat(
          123
          /* { */
        ) && g.raise("Lone quantifier brackets");
      }, Rt.regexp_alternative = function(g) {
        for (; g.pos < g.source.length && this.regexp_eatTerm(g); )
          ;
      }, Rt.regexp_eatTerm = function(g) {
        return this.regexp_eatAssertion(g) ? (g.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(g) && g.switchU && g.raise("Invalid quantifier"), !0) : (g.switchU ? this.regexp_eatAtom(g) : this.regexp_eatExtendedAtom(g)) ? (this.regexp_eatQuantifier(g), !0) : !1;
      }, Rt.regexp_eatAssertion = function(g) {
        var z = g.pos;
        if (g.lastAssertionIsQuantifiable = !1, g.eat(
          94
          /* ^ */
        ) || g.eat(
          36
          /* $ */
        ))
          return !0;
        if (g.eat(
          92
          /* \ */
        )) {
          if (g.eat(
            66
            /* B */
          ) || g.eat(
            98
            /* b */
          ))
            return !0;
          g.pos = z;
        }
        if (g.eat(
          40
          /* ( */
        ) && g.eat(
          63
          /* ? */
        )) {
          var ce = !1;
          if (this.options.ecmaVersion >= 9 && (ce = g.eat(
            60
            /* < */
          )), g.eat(
            61
            /* = */
          ) || g.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(g), g.eat(
              41
              /* ) */
            ) || g.raise("Unterminated group"), g.lastAssertionIsQuantifiable = !ce, !0;
        }
        return g.pos = z, !1;
      }, Rt.regexp_eatQuantifier = function(g, z) {
        return z === void 0 && (z = !1), this.regexp_eatQuantifierPrefix(g, z) ? (g.eat(
          63
          /* ? */
        ), !0) : !1;
      }, Rt.regexp_eatQuantifierPrefix = function(g, z) {
        return g.eat(
          42
          /* * */
        ) || g.eat(
          43
          /* + */
        ) || g.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(g, z);
      }, Rt.regexp_eatBracedQuantifier = function(g, z) {
        var ce = g.pos;
        if (g.eat(
          123
          /* { */
        )) {
          var xe = 0, Pe = -1;
          if (this.regexp_eatDecimalDigits(g) && (xe = g.lastIntValue, g.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(g) && (Pe = g.lastIntValue), g.eat(
            125
            /* } */
          )))
            return Pe !== -1 && Pe < xe && !z && g.raise("numbers out of order in {} quantifier"), !0;
          g.switchU && !z && g.raise("Incomplete quantifier"), g.pos = ce;
        }
        return !1;
      }, Rt.regexp_eatAtom = function(g) {
        return this.regexp_eatPatternCharacters(g) || g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g);
      }, Rt.regexp_eatReverseSolidusAtomEscape = function(g) {
        var z = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(g))
            return !0;
          g.pos = z;
        }
        return !1;
      }, Rt.regexp_eatUncapturingGroup = function(g) {
        var z = g.pos;
        if (g.eat(
          40
          /* ( */
        )) {
          if (g.eat(
            63
            /* ? */
          ) && g.eat(
            58
            /* : */
          )) {
            if (this.regexp_disjunction(g), g.eat(
              41
              /* ) */
            ))
              return !0;
            g.raise("Unterminated group");
          }
          g.pos = z;
        }
        return !1;
      }, Rt.regexp_eatCapturingGroup = function(g) {
        if (g.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(g) : g.current() === 63 && g.raise("Invalid group"), this.regexp_disjunction(g), g.eat(
            41
            /* ) */
          ))
            return g.numCapturingParens += 1, !0;
          g.raise("Unterminated group");
        }
        return !1;
      }, Rt.regexp_eatExtendedAtom = function(g) {
        return g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g) || this.regexp_eatInvalidBracedQuantifier(g) || this.regexp_eatExtendedPatternCharacter(g);
      }, Rt.regexp_eatInvalidBracedQuantifier = function(g) {
        return this.regexp_eatBracedQuantifier(g, !0) && g.raise("Nothing to repeat"), !1;
      }, Rt.regexp_eatSyntaxCharacter = function(g) {
        var z = g.current();
        return ci(z) ? (g.lastIntValue = z, g.advance(), !0) : !1;
      };
      function ci(g) {
        return g === 36 || g >= 40 && g <= 43 || g === 46 || g === 63 || g >= 91 && g <= 94 || g >= 123 && g <= 125;
      }
      Rt.regexp_eatPatternCharacters = function(g) {
        for (var z = g.pos, ce = 0; (ce = g.current()) !== -1 && !ci(ce); )
          g.advance();
        return g.pos !== z;
      }, Rt.regexp_eatExtendedPatternCharacter = function(g) {
        var z = g.current();
        return z !== -1 && z !== 36 && !(z >= 40 && z <= 43) && z !== 46 && z !== 63 && z !== 91 && z !== 94 && z !== 124 ? (g.advance(), !0) : !1;
      }, Rt.regexp_groupSpecifier = function(g) {
        if (g.eat(
          63
          /* ? */
        )) {
          if (this.regexp_eatGroupName(g)) {
            g.groupNames.indexOf(g.lastStringValue) !== -1 && g.raise("Duplicate capture group name"), g.groupNames.push(g.lastStringValue);
            return;
          }
          g.raise("Invalid group");
        }
      }, Rt.regexp_eatGroupName = function(g) {
        if (g.lastStringValue = "", g.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(g) && g.eat(
            62
            /* > */
          ))
            return !0;
          g.raise("Invalid capture group name");
        }
        return !1;
      }, Rt.regexp_eatRegExpIdentifierName = function(g) {
        if (g.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(g)) {
          for (g.lastStringValue += Zt(g.lastIntValue); this.regexp_eatRegExpIdentifierPart(g); )
            g.lastStringValue += Zt(g.lastIntValue);
          return !0;
        }
        return !1;
      }, Rt.regexp_eatRegExpIdentifierStart = function(g) {
        var z = g.pos, ce = this.options.ecmaVersion >= 11, xe = g.current(ce);
        return g.advance(ce), xe === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, ce) && (xe = g.lastIntValue), ni(xe) ? (g.lastIntValue = xe, !0) : (g.pos = z, !1);
      };
      function ni(g) {
        return X(g, !0) || g === 36 || g === 95;
      }
      Rt.regexp_eatRegExpIdentifierPart = function(g) {
        var z = g.pos, ce = this.options.ecmaVersion >= 11, xe = g.current(ce);
        return g.advance(ce), xe === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, ce) && (xe = g.lastIntValue), di(xe) ? (g.lastIntValue = xe, !0) : (g.pos = z, !1);
      };
      function di(g) {
        return Y(g, !0) || g === 36 || g === 95 || g === 8204 || g === 8205;
      }
      Rt.regexp_eatAtomEscape = function(g) {
        return this.regexp_eatBackReference(g) || this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g) || g.switchN && this.regexp_eatKGroupName(g) ? !0 : (g.switchU && (g.current() === 99 && g.raise("Invalid unicode escape"), g.raise("Invalid escape")), !1);
      }, Rt.regexp_eatBackReference = function(g) {
        var z = g.pos;
        if (this.regexp_eatDecimalEscape(g)) {
          var ce = g.lastIntValue;
          if (g.switchU)
            return ce > g.maxBackReference && (g.maxBackReference = ce), !0;
          if (ce <= g.numCapturingParens)
            return !0;
          g.pos = z;
        }
        return !1;
      }, Rt.regexp_eatKGroupName = function(g) {
        if (g.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(g))
            return g.backReferenceNames.push(g.lastStringValue), !0;
          g.raise("Invalid named reference");
        }
        return !1;
      }, Rt.regexp_eatCharacterEscape = function(g) {
        return this.regexp_eatControlEscape(g) || this.regexp_eatCControlLetter(g) || this.regexp_eatZero(g) || this.regexp_eatHexEscapeSequence(g) || this.regexp_eatRegExpUnicodeEscapeSequence(g, !1) || !g.switchU && this.regexp_eatLegacyOctalEscapeSequence(g) || this.regexp_eatIdentityEscape(g);
      }, Rt.regexp_eatCControlLetter = function(g) {
        var z = g.pos;
        if (g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(g))
            return !0;
          g.pos = z;
        }
        return !1;
      }, Rt.regexp_eatZero = function(g) {
        return g.current() === 48 && !ir(g.lookahead()) ? (g.lastIntValue = 0, g.advance(), !0) : !1;
      }, Rt.regexp_eatControlEscape = function(g) {
        var z = g.current();
        return z === 116 ? (g.lastIntValue = 9, g.advance(), !0) : z === 110 ? (g.lastIntValue = 10, g.advance(), !0) : z === 118 ? (g.lastIntValue = 11, g.advance(), !0) : z === 102 ? (g.lastIntValue = 12, g.advance(), !0) : z === 114 ? (g.lastIntValue = 13, g.advance(), !0) : !1;
      }, Rt.regexp_eatControlLetter = function(g) {
        var z = g.current();
        return Hi(z) ? (g.lastIntValue = z % 32, g.advance(), !0) : !1;
      };
      function Hi(g) {
        return g >= 65 && g <= 90 || g >= 97 && g <= 122;
      }
      Rt.regexp_eatRegExpUnicodeEscapeSequence = function(g, z) {
        z === void 0 && (z = !1);
        var ce = g.pos, xe = z || g.switchU;
        if (g.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 4)) {
            var Pe = g.lastIntValue;
            if (xe && Pe >= 55296 && Pe <= 56319) {
              var rt = g.pos;
              if (g.eat(
                92
                /* \ */
              ) && g.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(g, 4)) {
                var pt = g.lastIntValue;
                if (pt >= 56320 && pt <= 57343)
                  return g.lastIntValue = (Pe - 55296) * 1024 + (pt - 56320) + 65536, !0;
              }
              g.pos = rt, g.lastIntValue = Pe;
            }
            return !0;
          }
          if (xe && g.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(g) && g.eat(
            125
            /* } */
          ) && xi(g.lastIntValue))
            return !0;
          xe && g.raise("Invalid unicode escape"), g.pos = ce;
        }
        return !1;
      };
      function xi(g) {
        return g >= 0 && g <= 1114111;
      }
      Rt.regexp_eatIdentityEscape = function(g) {
        if (g.switchU)
          return this.regexp_eatSyntaxCharacter(g) ? !0 : g.eat(
            47
            /* / */
          ) ? (g.lastIntValue = 47, !0) : !1;
        var z = g.current();
        return z !== 99 && (!g.switchN || z !== 107) ? (g.lastIntValue = z, g.advance(), !0) : !1;
      }, Rt.regexp_eatDecimalEscape = function(g) {
        g.lastIntValue = 0;
        var z = g.current();
        if (z >= 49 && z <= 57) {
          do
            g.lastIntValue = 10 * g.lastIntValue + (z - 48), g.advance();
          while ((z = g.current()) >= 48 && z <= 57);
          return !0;
        }
        return !1;
      };
      var qi = 0, Ti = 1, Ci = 2;
      Rt.regexp_eatCharacterClassEscape = function(g) {
        var z = g.current();
        if (Xi(z))
          return g.lastIntValue = -1, g.advance(), Ti;
        var ce = !1;
        if (g.switchU && this.options.ecmaVersion >= 9 && ((ce = z === 80) || z === 112)) {
          g.lastIntValue = -1, g.advance();
          var xe;
          if (g.eat(
            123
            /* { */
          ) && (xe = this.regexp_eatUnicodePropertyValueExpression(g)) && g.eat(
            125
            /* } */
          ))
            return ce && xe === Ci && g.raise("Invalid property name"), xe;
          g.raise("Invalid property name");
        }
        return qi;
      };
      function Xi(g) {
        return g === 100 || g === 68 || g === 115 || g === 83 || g === 119 || g === 87;
      }
      Rt.regexp_eatUnicodePropertyValueExpression = function(g) {
        var z = g.pos;
        if (this.regexp_eatUnicodePropertyName(g) && g.eat(
          61
          /* = */
        )) {
          var ce = g.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(g)) {
            var xe = g.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(g, ce, xe), Ti;
          }
        }
        if (g.pos = z, this.regexp_eatLoneUnicodePropertyNameOrValue(g)) {
          var Pe = g.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(g, Pe);
        }
        return qi;
      }, Rt.regexp_validateUnicodePropertyNameAndValue = function(g, z, ce) {
        Ue(g.unicodeProperties.nonBinary, z) || g.raise("Invalid property name"), g.unicodeProperties.nonBinary[z].test(ce) || g.raise("Invalid property value");
      }, Rt.regexp_validateUnicodePropertyNameOrValue = function(g, z) {
        if (g.unicodeProperties.binary.test(z))
          return Ti;
        if (g.switchV && g.unicodeProperties.binaryOfStrings.test(z))
          return Ci;
        g.raise("Invalid property name");
      }, Rt.regexp_eatUnicodePropertyName = function(g) {
        var z = 0;
        for (g.lastStringValue = ""; Gi(z = g.current()); )
          g.lastStringValue += Zt(z), g.advance();
        return g.lastStringValue !== "";
      };
      function Gi(g) {
        return Hi(g) || g === 95;
      }
      Rt.regexp_eatUnicodePropertyValue = function(g) {
        var z = 0;
        for (g.lastStringValue = ""; Ki(z = g.current()); )
          g.lastStringValue += Zt(z), g.advance();
        return g.lastStringValue !== "";
      };
      function Ki(g) {
        return Gi(g) || ir(g);
      }
      Rt.regexp_eatLoneUnicodePropertyNameOrValue = function(g) {
        return this.regexp_eatUnicodePropertyValue(g);
      }, Rt.regexp_eatCharacterClass = function(g) {
        if (g.eat(
          91
          /* [ */
        )) {
          var z = g.eat(
            94
            /* ^ */
          ), ce = this.regexp_classContents(g);
          return g.eat(
            93
            /* ] */
          ) || g.raise("Unterminated character class"), z && ce === Ci && g.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, Rt.regexp_classContents = function(g) {
        return g.current() === 93 ? Ti : g.switchV ? this.regexp_classSetExpression(g) : (this.regexp_nonEmptyClassRanges(g), Ti);
      }, Rt.regexp_nonEmptyClassRanges = function(g) {
        for (; this.regexp_eatClassAtom(g); ) {
          var z = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(g)) {
            var ce = g.lastIntValue;
            g.switchU && (z === -1 || ce === -1) && g.raise("Invalid character class"), z !== -1 && ce !== -1 && z > ce && g.raise("Range out of order in character class");
          }
        }
      }, Rt.regexp_eatClassAtom = function(g) {
        var z = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(g))
            return !0;
          if (g.switchU) {
            var ce = g.current();
            (ce === 99 || In(ce)) && g.raise("Invalid class escape"), g.raise("Invalid escape");
          }
          g.pos = z;
        }
        var xe = g.current();
        return xe !== 93 ? (g.lastIntValue = xe, g.advance(), !0) : !1;
      }, Rt.regexp_eatClassEscape = function(g) {
        var z = g.pos;
        if (g.eat(
          98
          /* b */
        ))
          return g.lastIntValue = 8, !0;
        if (g.switchU && g.eat(
          45
          /* - */
        ))
          return g.lastIntValue = 45, !0;
        if (!g.switchU && g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(g))
            return !0;
          g.pos = z;
        }
        return this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g);
      }, Rt.regexp_classSetExpression = function(g) {
        var z = Ti, ce;
        if (!this.regexp_eatClassSetRange(g))
          if (ce = this.regexp_eatClassSetOperand(g)) {
            ce === Ci && (z = Ci);
            for (var xe = g.pos; g.eatChars(
              [38, 38]
              /* && */
            ); ) {
              if (g.current() !== 38 && (ce = this.regexp_eatClassSetOperand(g))) {
                ce !== Ci && (z = Ti);
                continue;
              }
              g.raise("Invalid character in character class");
            }
            if (xe !== g.pos)
              return z;
            for (; g.eatChars(
              [45, 45]
              /* -- */
            ); )
              this.regexp_eatClassSetOperand(g) || g.raise("Invalid character in character class");
            if (xe !== g.pos)
              return z;
          } else
            g.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(g)) {
            if (ce = this.regexp_eatClassSetOperand(g), !ce)
              return z;
            ce === Ci && (z = Ci);
          }
      }, Rt.regexp_eatClassSetRange = function(g) {
        var z = g.pos;
        if (this.regexp_eatClassSetCharacter(g)) {
          var ce = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(g)) {
            var xe = g.lastIntValue;
            return ce !== -1 && xe !== -1 && ce > xe && g.raise("Range out of order in character class"), !0;
          }
          g.pos = z;
        }
        return !1;
      }, Rt.regexp_eatClassSetOperand = function(g) {
        return this.regexp_eatClassSetCharacter(g) ? Ti : this.regexp_eatClassStringDisjunction(g) || this.regexp_eatNestedClass(g);
      }, Rt.regexp_eatNestedClass = function(g) {
        var z = g.pos;
        if (g.eat(
          91
          /* [ */
        )) {
          var ce = g.eat(
            94
            /* ^ */
          ), xe = this.regexp_classContents(g);
          if (g.eat(
            93
            /* ] */
          ))
            return ce && xe === Ci && g.raise("Negated character class may contain strings"), xe;
          g.pos = z;
        }
        if (g.eat(
          92
          /* \ */
        )) {
          var Pe = this.regexp_eatCharacterClassEscape(g);
          if (Pe)
            return Pe;
          g.pos = z;
        }
        return null;
      }, Rt.regexp_eatClassStringDisjunction = function(g) {
        var z = g.pos;
        if (g.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (g.eat(
            123
            /* { */
          )) {
            var ce = this.regexp_classStringDisjunctionContents(g);
            if (g.eat(
              125
              /* } */
            ))
              return ce;
          } else
            g.raise("Invalid escape");
          g.pos = z;
        }
        return null;
      }, Rt.regexp_classStringDisjunctionContents = function(g) {
        for (var z = this.regexp_classString(g); g.eat(
          124
          /* | */
        ); )
          this.regexp_classString(g) === Ci && (z = Ci);
        return z;
      }, Rt.regexp_classString = function(g) {
        for (var z = 0; this.regexp_eatClassSetCharacter(g); )
          z++;
        return z === 1 ? Ti : Ci;
      }, Rt.regexp_eatClassSetCharacter = function(g) {
        var z = g.pos;
        if (g.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(g) || this.regexp_eatClassSetReservedPunctuator(g) ? !0 : g.eat(
            98
            /* b */
          ) ? (g.lastIntValue = 8, !0) : (g.pos = z, !1);
        var ce = g.current();
        return ce < 0 || ce === g.lookahead() && un(ce) || nn(ce) ? !1 : (g.advance(), g.lastIntValue = ce, !0);
      };
      function un(g) {
        return g === 33 || g >= 35 && g <= 38 || g >= 42 && g <= 44 || g === 46 || g >= 58 && g <= 64 || g === 94 || g === 96 || g === 126;
      }
      function nn(g) {
        return g === 40 || g === 41 || g === 45 || g === 47 || g >= 91 && g <= 93 || g >= 123 && g <= 125;
      }
      Rt.regexp_eatClassSetReservedPunctuator = function(g) {
        var z = g.current();
        return Wn(z) ? (g.lastIntValue = z, g.advance(), !0) : !1;
      };
      function Wn(g) {
        return g === 33 || g === 35 || g === 37 || g === 38 || g === 44 || g === 45 || g >= 58 && g <= 62 || g === 64 || g === 96 || g === 126;
      }
      Rt.regexp_eatClassControlLetter = function(g) {
        var z = g.current();
        return ir(z) || z === 95 ? (g.lastIntValue = z % 32, g.advance(), !0) : !1;
      }, Rt.regexp_eatHexEscapeSequence = function(g) {
        var z = g.pos;
        if (g.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 2))
            return !0;
          g.switchU && g.raise("Invalid escape"), g.pos = z;
        }
        return !1;
      }, Rt.regexp_eatDecimalDigits = function(g) {
        var z = g.pos, ce = 0;
        for (g.lastIntValue = 0; ir(ce = g.current()); )
          g.lastIntValue = 10 * g.lastIntValue + (ce - 48), g.advance();
        return g.pos !== z;
      };
      function ir(g) {
        return g >= 48 && g <= 57;
      }
      Rt.regexp_eatHexDigits = function(g) {
        var z = g.pos, ce = 0;
        for (g.lastIntValue = 0; Tr(ce = g.current()); )
          g.lastIntValue = 16 * g.lastIntValue + yr(ce), g.advance();
        return g.pos !== z;
      };
      function Tr(g) {
        return g >= 48 && g <= 57 || g >= 65 && g <= 70 || g >= 97 && g <= 102;
      }
      function yr(g) {
        return g >= 65 && g <= 70 ? 10 + (g - 65) : g >= 97 && g <= 102 ? 10 + (g - 97) : g - 48;
      }
      Rt.regexp_eatLegacyOctalEscapeSequence = function(g) {
        if (this.regexp_eatOctalDigit(g)) {
          var z = g.lastIntValue;
          if (this.regexp_eatOctalDigit(g)) {
            var ce = g.lastIntValue;
            z <= 3 && this.regexp_eatOctalDigit(g) ? g.lastIntValue = z * 64 + ce * 8 + g.lastIntValue : g.lastIntValue = z * 8 + ce;
          } else
            g.lastIntValue = z;
          return !0;
        }
        return !1;
      }, Rt.regexp_eatOctalDigit = function(g) {
        var z = g.current();
        return In(z) ? (g.lastIntValue = z - 48, g.advance(), !0) : (g.lastIntValue = 0, !1);
      };
      function In(g) {
        return g >= 48 && g <= 55;
      }
      Rt.regexp_eatFixedHexDigits = function(g, z) {
        var ce = g.pos;
        g.lastIntValue = 0;
        for (var xe = 0; xe < z; ++xe) {
          var Pe = g.current();
          if (!Tr(Pe))
            return g.pos = ce, !1;
          g.lastIntValue = 16 * g.lastIntValue + yr(Pe), g.advance();
        }
        return !0;
      };
      var nr = function(z) {
        this.type = z.type, this.value = z.value, this.start = z.start, this.end = z.end, z.options.locations && (this.loc = new $t(z, z.startLoc, z.endLoc)), z.options.ranges && (this.range = [z.start, z.end]);
      }, si = i.prototype;
      si.next = function(g) {
        !g && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new nr(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, si.getToken = function() {
        return this.next(), new nr(this);
      }, typeof Symbol < "u" && (si[Symbol.iterator] = function() {
        var g = this;
        return {
          next: function() {
            var z = g.getToken();
            return {
              done: z.type === K.eof,
              value: z
            };
          }
        };
      }), si.nextToken = function() {
        var g = this.curContext();
        if ((!g || !g.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(K.eof);
        if (g.override)
          return g.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, si.readToken = function(g) {
        return X(g, this.options.ecmaVersion >= 6) || g === 92 ? this.readWord() : this.getTokenFromCode(g);
      }, si.fullCharCodeAtPos = function() {
        var g = this.input.charCodeAt(this.pos);
        if (g <= 55295 || g >= 56320)
          return g;
        var z = this.input.charCodeAt(this.pos + 1);
        return z <= 56319 || z >= 57344 ? g : (g << 10) + z - 56613888;
      }, si.skipBlockComment = function() {
        var g = this.options.onComment && this.curPosition(), z = this.pos, ce = this.input.indexOf("*/", this.pos += 2);
        if (ce === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = ce + 2, this.options.locations)
          for (var xe = void 0, Pe = z; (xe = $e(this.input, Pe, this.pos)) > -1; )
            ++this.curLine, Pe = this.lineStart = xe;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(z + 2, ce),
          z,
          this.pos,
          g,
          this.curPosition()
        );
      }, si.skipLineComment = function(g) {
        for (var z = this.pos, ce = this.options.onComment && this.curPosition(), xe = this.input.charCodeAt(this.pos += g); this.pos < this.input.length && !ke(xe); )
          xe = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(z + g, this.pos),
          z,
          this.pos,
          ce,
          this.curPosition()
        );
      }, si.skipSpace = function() {
        e:
          for (; this.pos < this.input.length; ) {
            var g = this.input.charCodeAt(this.pos);
            switch (g) {
              case 32:
              case 160:
                ++this.pos;
                break;
              case 13:
                this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
              case 10:
              case 8232:
              case 8233:
                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                break;
              case 47:
                switch (this.input.charCodeAt(this.pos + 1)) {
                  case 42:
                    this.skipBlockComment();
                    break;
                  case 47:
                    this.skipLineComment(2);
                    break;
                  default:
                    break e;
                }
                break;
              default:
                if (g > 8 && g < 14 || g >= 5760 && Lt.test(String.fromCharCode(g)))
                  ++this.pos;
                else
                  break e;
            }
          }
      }, si.finishToken = function(g, z) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var ce = this.type;
        this.type = g, this.value = z, this.updateContext(ce);
      }, si.readToken_dot = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        if (g >= 48 && g <= 57)
          return this.readNumber(!0);
        var z = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && g === 46 && z === 46 ? (this.pos += 3, this.finishToken(K.ellipsis)) : (++this.pos, this.finishToken(K.dot));
      }, si.readToken_slash = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : g === 61 ? this.finishOp(K.assign, 2) : this.finishOp(K.slash, 1);
      }, si.readToken_mult_modulo_exp = function(g) {
        var z = this.input.charCodeAt(this.pos + 1), ce = 1, xe = g === 42 ? K.star : K.modulo;
        return this.options.ecmaVersion >= 7 && g === 42 && z === 42 && (++ce, xe = K.starstar, z = this.input.charCodeAt(this.pos + 2)), z === 61 ? this.finishOp(K.assign, ce + 1) : this.finishOp(xe, ce);
      }, si.readToken_pipe_amp = function(g) {
        var z = this.input.charCodeAt(this.pos + 1);
        if (z === g) {
          if (this.options.ecmaVersion >= 12) {
            var ce = this.input.charCodeAt(this.pos + 2);
            if (ce === 61)
              return this.finishOp(K.assign, 3);
          }
          return this.finishOp(g === 124 ? K.logicalOR : K.logicalAND, 2);
        }
        return z === 61 ? this.finishOp(K.assign, 2) : this.finishOp(g === 124 ? K.bitwiseOR : K.bitwiseAND, 1);
      }, si.readToken_caret = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return g === 61 ? this.finishOp(K.assign, 2) : this.finishOp(K.bitwiseXOR, 1);
      }, si.readToken_plus_min = function(g) {
        var z = this.input.charCodeAt(this.pos + 1);
        return z === g ? z === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || j.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(K.incDec, 2) : z === 61 ? this.finishOp(K.assign, 2) : this.finishOp(K.plusMin, 1);
      }, si.readToken_lt_gt = function(g) {
        var z = this.input.charCodeAt(this.pos + 1), ce = 1;
        return z === g ? (ce = g === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + ce) === 61 ? this.finishOp(K.assign, ce + 1) : this.finishOp(K.bitShift, ce)) : z === 33 && g === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (z === 61 && (ce = 2), this.finishOp(K.relational, ce));
      }, si.readToken_eq_excl = function(g) {
        var z = this.input.charCodeAt(this.pos + 1);
        return z === 61 ? this.finishOp(K.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : g === 61 && z === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(K.arrow)) : this.finishOp(g === 61 ? K.eq : K.prefix, 1);
      }, si.readToken_question = function() {
        var g = this.options.ecmaVersion;
        if (g >= 11) {
          var z = this.input.charCodeAt(this.pos + 1);
          if (z === 46) {
            var ce = this.input.charCodeAt(this.pos + 2);
            if (ce < 48 || ce > 57)
              return this.finishOp(K.questionDot, 2);
          }
          if (z === 63) {
            if (g >= 12) {
              var xe = this.input.charCodeAt(this.pos + 2);
              if (xe === 61)
                return this.finishOp(K.assign, 3);
            }
            return this.finishOp(K.coalesce, 2);
          }
        }
        return this.finishOp(K.question, 1);
      }, si.readToken_numberSign = function() {
        var g = this.options.ecmaVersion, z = 35;
        if (g >= 13 && (++this.pos, z = this.fullCharCodeAtPos(), X(z, !0) || z === 92))
          return this.finishToken(K.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + Zt(z) + "'");
      }, si.getTokenFromCode = function(g) {
        switch (g) {
          case 46:
            return this.readToken_dot();
          case 40:
            return ++this.pos, this.finishToken(K.parenL);
          case 41:
            return ++this.pos, this.finishToken(K.parenR);
          case 59:
            return ++this.pos, this.finishToken(K.semi);
          case 44:
            return ++this.pos, this.finishToken(K.comma);
          case 91:
            return ++this.pos, this.finishToken(K.bracketL);
          case 93:
            return ++this.pos, this.finishToken(K.bracketR);
          case 123:
            return ++this.pos, this.finishToken(K.braceL);
          case 125:
            return ++this.pos, this.finishToken(K.braceR);
          case 58:
            return ++this.pos, this.finishToken(K.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(K.backQuote);
          case 48:
            var z = this.input.charCodeAt(this.pos + 1);
            if (z === 120 || z === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (z === 111 || z === 79)
                return this.readRadixNumber(8);
              if (z === 98 || z === 66)
                return this.readRadixNumber(2);
            }
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          case 34:
          case 39:
            return this.readString(g);
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(g);
          case 124:
          case 38:
            return this.readToken_pipe_amp(g);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(g);
          case 60:
          case 62:
            return this.readToken_lt_gt(g);
          case 61:
          case 33:
            return this.readToken_eq_excl(g);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(K.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + Zt(g) + "'");
      }, si.finishOp = function(g, z) {
        var ce = this.input.slice(this.pos, this.pos + z);
        return this.pos += z, this.finishToken(g, ce);
      }, si.readRegexp = function() {
        for (var g, z, ce = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(ce, "Unterminated regular expression");
          var xe = this.input.charAt(this.pos);
          if (j.test(xe) && this.raise(ce, "Unterminated regular expression"), g)
            g = !1;
          else {
            if (xe === "[")
              z = !0;
            else if (xe === "]" && z)
              z = !1;
            else if (xe === "/" && !z)
              break;
            g = xe === "\\";
          }
          ++this.pos;
        }
        var Pe = this.input.slice(ce, this.pos);
        ++this.pos;
        var rt = this.pos, pt = this.readWord1();
        this.containsEsc && this.unexpected(rt);
        var Dt = this.regexpState || (this.regexpState = new hi(this));
        Dt.reset(ce, Pe, pt), this.validateRegExpFlags(Dt), this.validateRegExpPattern(Dt);
        var qt = null;
        try {
          qt = new RegExp(Pe, pt);
        } catch {
        }
        return this.finishToken(K.regexp, { pattern: Pe, flags: pt, value: qt });
      }, si.readInt = function(g, z, ce) {
        for (var xe = this.options.ecmaVersion >= 12 && z === void 0, Pe = ce && this.input.charCodeAt(this.pos) === 48, rt = this.pos, pt = 0, Dt = 0, qt = 0, gi = z ?? 1 / 0; qt < gi; ++qt, ++this.pos) {
          var vi = this.input.charCodeAt(this.pos), ln = void 0;
          if (xe && vi === 95) {
            Pe && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), Dt === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), qt === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), Dt = vi;
            continue;
          }
          if (vi >= 97 ? ln = vi - 97 + 10 : vi >= 65 ? ln = vi - 65 + 10 : vi >= 48 && vi <= 57 ? ln = vi - 48 : ln = 1 / 0, ln >= g)
            break;
          Dt = vi, pt = pt * g + ln;
        }
        return xe && Dt === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === rt || z != null && this.pos - rt !== z ? null : pt;
      };
      function ur(g, z) {
        return z ? parseInt(g, 8) : parseFloat(g.replace(/_/g, ""));
      }
      function Dn(g) {
        return typeof BigInt != "function" ? null : BigInt(g.replace(/_/g, ""));
      }
      si.readRadixNumber = function(g) {
        var z = this.pos;
        this.pos += 2;
        var ce = this.readInt(g);
        return ce == null && this.raise(this.start + 2, "Expected number in radix " + g), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (ce = Dn(this.input.slice(z, this.pos)), ++this.pos) : X(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(K.num, ce);
      }, si.readNumber = function(g) {
        var z = this.pos;
        !g && this.readInt(10, void 0, !0) === null && this.raise(z, "Invalid number");
        var ce = this.pos - z >= 2 && this.input.charCodeAt(z) === 48;
        ce && this.strict && this.raise(z, "Invalid number");
        var xe = this.input.charCodeAt(this.pos);
        if (!ce && !g && this.options.ecmaVersion >= 11 && xe === 110) {
          var Pe = Dn(this.input.slice(z, this.pos));
          return ++this.pos, X(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(K.num, Pe);
        }
        ce && /[89]/.test(this.input.slice(z, this.pos)) && (ce = !1), xe === 46 && !ce && (++this.pos, this.readInt(10), xe = this.input.charCodeAt(this.pos)), (xe === 69 || xe === 101) && !ce && (xe = this.input.charCodeAt(++this.pos), (xe === 43 || xe === 45) && ++this.pos, this.readInt(10) === null && this.raise(z, "Invalid number")), X(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var rt = ur(this.input.slice(z, this.pos), ce);
        return this.finishToken(K.num, rt);
      }, si.readCodePoint = function() {
        var g = this.input.charCodeAt(this.pos), z;
        if (g === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var ce = ++this.pos;
          z = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, z > 1114111 && this.invalidStringToken(ce, "Code point out of bounds");
        } else
          z = this.readHexChar(4);
        return z;
      }, si.readString = function(g) {
        for (var z = "", ce = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var xe = this.input.charCodeAt(this.pos);
          if (xe === g)
            break;
          xe === 92 ? (z += this.input.slice(ce, this.pos), z += this.readEscapedChar(!1), ce = this.pos) : xe === 8232 || xe === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (ke(xe) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return z += this.input.slice(ce, this.pos++), this.finishToken(K.string, z);
      };
      var Mn = {};
      si.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (g) {
          if (g === Mn)
            this.readInvalidTemplateToken();
          else
            throw g;
        }
        this.inTemplateElement = !1;
      }, si.invalidStringToken = function(g, z) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw Mn;
        this.raise(g, z);
      }, si.readTmplToken = function() {
        for (var g = "", z = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var ce = this.input.charCodeAt(this.pos);
          if (ce === 96 || ce === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === K.template || this.type === K.invalidTemplate) ? ce === 36 ? (this.pos += 2, this.finishToken(K.dollarBraceL)) : (++this.pos, this.finishToken(K.backQuote)) : (g += this.input.slice(z, this.pos), this.finishToken(K.template, g));
          if (ce === 92)
            g += this.input.slice(z, this.pos), g += this.readEscapedChar(!0), z = this.pos;
          else if (ke(ce)) {
            switch (g += this.input.slice(z, this.pos), ++this.pos, ce) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                g += `
`;
                break;
              default:
                g += String.fromCharCode(ce);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), z = this.pos;
          } else
            ++this.pos;
        }
      }, si.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            case "`":
              return this.finishToken(K.invalidTemplate, this.input.slice(this.start, this.pos));
          }
        this.raise(this.start, "Unterminated template");
      }, si.readEscapedChar = function(g) {
        var z = this.input.charCodeAt(++this.pos);
        switch (++this.pos, z) {
          case 110:
            return `
`;
          case 114:
            return "\r";
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          case 117:
            return Zt(this.readCodePoint());
          case 116:
            return "	";
          case 98:
            return "\b";
          case 118:
            return "\v";
          case 102:
            return "\f";
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), g) {
              var ce = this.pos - 1;
              this.invalidStringToken(
                ce,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (z >= 48 && z <= 55) {
              var xe = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], Pe = parseInt(xe, 8);
              return Pe > 255 && (xe = xe.slice(0, -1), Pe = parseInt(xe, 8)), this.pos += xe.length - 1, z = this.input.charCodeAt(this.pos), (xe !== "0" || z === 56 || z === 57) && (this.strict || g) && this.invalidStringToken(
                this.pos - 1 - xe.length,
                g ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(Pe);
            }
            return ke(z) ? "" : String.fromCharCode(z);
        }
      }, si.readHexChar = function(g) {
        var z = this.pos, ce = this.readInt(16, g);
        return ce === null && this.invalidStringToken(z, "Bad character escape sequence"), ce;
      }, si.readWord1 = function() {
        this.containsEsc = !1;
        for (var g = "", z = !0, ce = this.pos, xe = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var Pe = this.fullCharCodeAtPos();
          if (Y(Pe, xe))
            this.pos += Pe <= 65535 ? 1 : 2;
          else if (Pe === 92) {
            this.containsEsc = !0, g += this.input.slice(ce, this.pos);
            var rt = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var pt = this.readCodePoint();
            (z ? X : Y)(pt, xe) || this.invalidStringToken(rt, "Invalid Unicode escape"), g += Zt(pt), ce = this.pos;
          } else
            break;
          z = !1;
        }
        return g + this.input.slice(ce, this.pos);
      }, si.readWord = function() {
        var g = this.readWord1(), z = K.name;
        return this.keywords.test(g) && (z = he[g]), this.finishToken(z, g);
      };
      var gn = "8.11.3";
      i.acorn = {
        Parser: i,
        version: gn,
        defaultOptions: At,
        Position: lt,
        SourceLocation: $t,
        getLineInfo: Kt,
        Node: Q,
        TokenType: ie,
        tokTypes: K,
        keywordTypes: he,
        TokContext: k,
        tokContexts: F,
        isIdentifierChar: Y,
        isIdentifierStart: X,
        Token: nr,
        isNewLine: ke,
        lineBreak: j,
        lineBreakG: We,
        nonASCIIwhitespace: Lt
      };
      function Cn(g, z) {
        return i.parse(g, z);
      }
      function cn(g, z, ce) {
        return i.parseExpressionAt(g, z, ce);
      }
      function Ji(g, z) {
        return i.tokenizer(g, z);
      }
      t.Node = Q, t.Parser = i, t.Position = lt, t.SourceLocation = $t, t.TokContext = k, t.Token = nr, t.TokenType = ie, t.defaultOptions = At, t.getLineInfo = Kt, t.isIdentifierChar = Y, t.isIdentifierStart = X, t.isNewLine = ke, t.keywordTypes = he, t.lineBreak = j, t.lineBreakG = We, t.nonASCIIwhitespace = Lt, t.parse = Cn, t.parseExpressionAt = cn, t.tokContexts = F, t.tokTypes = K, t.tokenizer = Ji, t.version = gn;
    });
  }(Qo, Qo.exports)), Qo.exports;
}
/*!
 * Paper.js v0.12.17 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Thu Nov 3 21:15:36 2022 +0100
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(y) {
  (function(e, t) {
    e = e || Pf;
    var r = e.window, o = e.document, a = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, n = [], s = n.slice, l = Object.create, h = Object.getOwnPropertyDescriptor, d = Object.defineProperty, m = n.forEach || function(L, A) {
        for (var U = 0, k = this.length; U < k; U++)
          L.call(A, this[U], U, this);
      }, _ = function(L, A) {
        for (var U in this)
          this.hasOwnProperty(U) && L.call(A, this[U], U, this);
      }, b = Object.assign || function(L) {
        for (var A = 1, U = arguments.length; A < U; A++) {
          var k = arguments[A];
          for (var F in k)
            k.hasOwnProperty(F) && (L[F] = k[F]);
        }
        return L;
      }, x = function(L, A, U) {
        if (L) {
          var k = h(L, "length");
          (k && typeof k.value == "number" ? m : _).call(L, A, U = U || L);
        }
        return U;
      };
      function T(L, A, U, k, F) {
        var B = {};
        function R(V, Q) {
          Q = Q || (Q = h(A, V)) && (Q.get ? Q : Q.value), typeof Q == "string" && Q[0] === "#" && (Q = L[Q.substring(1)] || Q);
          var ae = typeof Q == "function", le = Q, fe = F || ae && !Q.base ? Q && Q.get ? V in L : L[V] : null, se;
          (!F || !fe) && (ae && fe && (Q.base = fe), ae && k !== !1 && (se = V.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (B[se[3].toLowerCase() + se[4]] = se[2]), (!le || ae || !le.get || typeof le.get != "function" || !E.isPlainObject(le)) && (le = { value: le, writable: !0 }), (h(L, V) || { configurable: !0 }).configurable && (le.configurable = !0, le.enumerable = U ?? !se), d(L, V, le));
        }
        if (A) {
          for (var C in A)
            A.hasOwnProperty(C) && !i.test(C) && R(C);
          for (var C in B) {
            var P = B[C], H = L["set" + P], W = L["get" + P] || H && L["is" + P];
            W && (k === !0 || W.length === 0) && R(C, { get: W, set: H });
          }
        }
        return L;
      }
      function E() {
        for (var L = 0, A = arguments.length; L < A; L++) {
          var U = arguments[L];
          U && b(this, U);
        }
        return this;
      }
      return T(E, {
        inject: function(L) {
          if (L) {
            var A = L.statics === !0 ? L : L.statics, U = L.beans, k = L.preserve;
            A !== L && T(this.prototype, L, L.enumerable, U, k), T(this, A, null, U, k);
          }
          for (var F = 1, B = arguments.length; F < B; F++)
            this.inject(arguments[F]);
          return this;
        },
        extend: function() {
          for (var L = this, A, U, k = 0, F, B = arguments.length; k < B && !(A && U); k++)
            F = arguments[k], A = A || F.initialize, U = U || F.prototype;
          return A = A || function() {
            L.apply(this, arguments);
          }, U = A.prototype = U || l(this.prototype), d(
            U,
            "constructor",
            { value: A, writable: !0, configurable: !0 }
          ), T(A, this), arguments.length && this.inject.apply(A, arguments), A.base = L, A;
        }
      }).inject({
        enumerable: !1,
        initialize: E,
        set: E,
        inject: function() {
          for (var L = 0, A = arguments.length; L < A; L++) {
            var U = arguments[L];
            U && T(this, U, U.enumerable, U.beans, U.preserve);
          }
          return this;
        },
        extend: function() {
          var L = l(this);
          return L.inject.apply(L, arguments);
        },
        each: function(L, A) {
          return x(this, L, A);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: b,
          each: x,
          create: l,
          define: d,
          describe: h,
          clone: function(L) {
            return b(new L.constructor(), L);
          },
          isPlainObject: function(L) {
            var A = L != null && L.constructor;
            return A && (A === Object || A === E || A.name === "Object");
          },
          pick: function(L, A) {
            return L !== t ? L : A;
          },
          slice: function(L, A, U) {
            return s.call(L, A, U);
          }
        }
      });
    }();
    y.exports = a, a.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + a.each(this, function(i, n) {
          if (!/^_/.test(n)) {
            var s = typeof i;
            this.push(n + ": " + (s === "number" ? I.instance.number(i) : s === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return a.importJSON(i, this);
      },
      exportJSON: function(i) {
        return a.exportJSON(this, i);
      },
      toJSON: function() {
        return a.serialize(this);
      },
      set: function(i, n) {
        return i && a.filter(this, i, n, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var n = i.base.apply(this, arguments), s = n.prototype._class;
          return s && !a.exports[s] && (a.exports[s] = n), n;
        },
        equals: function(i, n) {
          if (i === n)
            return !0;
          if (i && i.equals)
            return i.equals(n);
          if (n && n.equals)
            return n.equals(i);
          if (i && n && typeof i == "object" && typeof n == "object") {
            if (Array.isArray(i) && Array.isArray(n)) {
              var s = i.length;
              if (s !== n.length)
                return !1;
              for (; s--; )
                if (!a.equals(i[s], n[s]))
                  return !1;
            } else {
              var l = Object.keys(i), s = l.length;
              if (s !== Object.keys(n).length)
                return !1;
              for (; s--; ) {
                var h = l[s];
                if (!(n.hasOwnProperty(h) && a.equals(i[h], n[h])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, n, s, l) {
          if (this === a) {
            var h = this.peek(i, n);
            return i.__index++, h;
          }
          var d = this.prototype, m = d._readIndex, _ = n || m && i.__index || 0, b = i.length, x = i[_];
          if (l = l || b - _, x instanceof this || s && s.readNull && x == null && l <= 1)
            return m && (i.__index = _ + 1), x && s && s.clone ? x.clone() : x;
          if (x = a.create(d), m && (x.__read = !0), x = x.initialize.apply(x, _ > 0 || _ + l < b ? a.slice(i, _, _ + l) : i) || x, m) {
            i.__index = _ + x.__read;
            var T = x.__filtered;
            T && (i.__filtered = T, x.__filtered = t), x.__read = t;
          }
          return x;
        },
        peek: function(i, n) {
          return i[i.__index = n || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, n, s, l) {
          for (var h = [], d, m = n || 0, _ = l ? m + l : i.length, b = m; b < _; b++)
            h.push(Array.isArray(d = i[b]) ? this.read(d, 0, s) : this.read(i, b, s, 1));
          return h;
        },
        readNamed: function(i, n, s, l, h) {
          var d = this.getNamed(i, n), m = d !== t;
          if (m) {
            var _ = i.__filtered;
            if (!_) {
              var b = this.getSource(i);
              _ = i.__filtered = a.create(b), _.__unfiltered = b;
            }
            _[n] = t;
          }
          return this.read(m ? [d] : i, s, l, h);
        },
        readSupported: function(i, n) {
          var s = this.getSource(i), l = this, h = !1;
          return s && Object.keys(s).forEach(function(d) {
            if (d in n) {
              var m = l.readNamed(i, d);
              m !== t && (n[d] = m), h = !0;
            }
          }), h;
        },
        getSource: function(i) {
          var n = i.__source;
          if (n === t) {
            var s = i.length === 1 && i[0];
            n = i.__source = s && a.isPlainObject(s) ? s : null;
          }
          return n;
        },
        getNamed: function(i, n) {
          var s = this.getSource(i);
          if (s)
            return n ? s[n] : i.__filtered || s;
        },
        hasNamed: function(i, n) {
          return !!this.getNamed(i, n);
        },
        filter: function(i, n, s, l) {
          var h;
          function d(T) {
            if (!(s && T in s) && !(h && T in h)) {
              var E = n[T];
              E !== t && (i[T] = E);
            }
          }
          if (l) {
            for (var m = {}, _ = 0, b, x = l.length; _ < x; _++)
              (b = l[_]) in n && (d(b), m[b] = !0);
            h = m;
          }
          return Object.keys(n.__unfiltered || n).forEach(d), i;
        },
        isPlainValue: function(i, n) {
          return a.isPlainObject(i) || Array.isArray(i) || n && typeof i == "string";
        },
        serialize: function(i, n, s, l) {
          n = n || {};
          var h = !l, d;
          if (h && (n.formatter = new I(n.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(E, L) {
              var A = "#" + E._id, U = this.references[A];
              if (!U) {
                this.length++;
                var k = L.call(E), F = E._class;
                F && k[0] !== F && k.unshift(F), this.definitions[A] = k, U = this.references[A] = [A];
              }
              return U;
            }
          }), i && i._serialize) {
            d = i._serialize(n, l);
            var m = i._class;
            m && !i._compactSerialize && (h || !s) && d[0] !== m && d.unshift(m);
          } else if (Array.isArray(i)) {
            d = [];
            for (var _ = 0, b = i.length; _ < b; _++)
              d[_] = a.serialize(i[_], n, s, l);
          } else if (a.isPlainObject(i)) {
            d = {};
            for (var x = Object.keys(i), _ = 0, b = x.length; _ < b; _++) {
              var T = x[_];
              d[T] = a.serialize(
                i[T],
                n,
                s,
                l
              );
            }
          } else
            typeof i == "number" ? d = n.formatter.number(i, n.precision) : d = i;
          return h && l.length > 0 ? [["dictionary", l.definitions], d] : d;
        },
        deserialize: function(i, n, s, l, h) {
          var d = i, m = !s, _ = m && i && i.length && i[0][0] === "dictionary";
          if (s = s || {}, Array.isArray(i)) {
            var b = i[0], x = b === "dictionary";
            if (i.length == 1 && /^#/.test(b))
              return s.dictionary[b];
            b = a.exports[b], d = [];
            for (var T = b ? 1 : 0, E = i.length; T < E; T++)
              d.push(a.deserialize(
                i[T],
                n,
                s,
                x,
                _
              ));
            if (b) {
              var L = d;
              n ? d = n(b, L, m || h) : d = new b(L);
            }
          } else if (a.isPlainObject(i)) {
            d = {}, l && (s.dictionary = d);
            for (var A in i)
              d[A] = a.deserialize(i[A], n, s);
          }
          return _ ? d[1] : d;
        },
        exportJSON: function(i, n) {
          var s = a.serialize(i, n);
          return n && n.asString == !1 ? s : JSON.stringify(s);
        },
        importJSON: function(i, n) {
          return a.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(s, l, h) {
              var d = h && n && n.constructor === s, m = d ? n : a.create(s.prototype);
              if (l.length === 1 && m instanceof K && (d || !(m instanceof We))) {
                var _ = l[0];
                a.isPlainObject(_) && (_.insert = !1, d && (l = l.concat([K.INSERT])));
              }
              return (d ? m.set : s).apply(m, l), d && (n = null), m;
            }
          );
        },
        push: function(i, n) {
          var s = n.length;
          if (s < 4096)
            i.push.apply(i, n);
          else {
            var l = i.length;
            i.length += s;
            for (var h = 0; h < s; h++)
              i[l + h] = n[h];
          }
          return i;
        },
        splice: function(i, n, s, l) {
          var h = n && n.length, d = s === t;
          s = d ? i.length : s, s > i.length && (s = i.length);
          for (var m = 0; m < h; m++)
            n[m]._index = s + m;
          if (d)
            return a.push(i, n), [];
          var _ = [s, l];
          n && a.push(_, n);
          for (var b = i.splice.apply(i, _), m = 0, x = b.length; m < x; m++)
            b[m]._index = t;
          for (var m = s + h, x = i.length; m < x; m++)
            i[m]._index = m;
          return b;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(n) {
            return n.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(n, s) {
            return s.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var u = {
      on: function(i, n) {
        if (typeof i != "string")
          a.each(i, function(d, m) {
            this.on(m, d);
          }, this);
        else {
          var s = this._eventTypes, l = s && s[i], h = this._callbacks = this._callbacks || {};
          h = h[i] = h[i] || [], h.indexOf(n) === -1 && (h.push(n), l && l.install && h.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, n) {
        if (typeof i != "string") {
          a.each(i, function(m, _) {
            this.off(_, m);
          }, this);
          return;
        }
        var s = this._eventTypes, l = s && s[i], h = this._callbacks && this._callbacks[i], d;
        return h && (!n || (d = h.indexOf(n)) !== -1 && h.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && h.splice(d, 1)), this;
      },
      once: function(i, n) {
        return this.on(i, function s() {
          n.apply(this, arguments), this.off(i, s);
        });
      },
      emit: function(i, n) {
        var s = this._callbacks && this._callbacks[i];
        if (!s)
          return !1;
        var l = a.slice(arguments, 1), h = n && n.target && !n.currentTarget;
        s = s.slice(), h && (n.currentTarget = this);
        for (var d = 0, m = s.length; d < m; d++)
          if (s[d].apply(this, l) == !1) {
            n && n.stop && n.stop();
            break;
          }
        return h && delete n.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var n = this._eventTypes, s = this._callbacks, l = i ? "install" : "uninstall";
        if (n) {
          for (var h in s)
            if (s[h].length > 0) {
              var d = n[h], m = d && d[l];
              m && m.call(this, h);
            }
        }
      },
      statics: {
        inject: function i(n) {
          var s = n._events;
          if (s) {
            var l = {};
            a.each(s, function(h, d) {
              var m = typeof h == "string", _ = m ? h : d, b = a.capitalize(_), x = _.substring(2).toLowerCase();
              l[x] = m ? {} : h, _ = "_" + _, n["get" + b] = function() {
                return this[_];
              }, n["set" + b] = function(T) {
                var E = this[_];
                E && this.off(x, E), T && this.on(x, T), this[_] = T;
              };
            }), n._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, f = a.extend({
      _class: "PaperScope",
      initialize: function i() {
        He = this, this.settings = new a({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var n = i.prototype;
        if (!this.support) {
          var s = dt.getContext(1, 1) || {};
          n.support = {
            nativeDash: "setLineDash" in s || "mozDash" in s,
            nativeBlendModes: et.nativeModes
          }, dt.release(s);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), h = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = h === "darwin" ? "mac" : h, m = n.agent = n.browser = { platform: d };
          d && (m[d] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(_, b, x, T, E) {
              if (!m.chrome) {
                var L = b === "opera" ? T : /^(node|trident)$/.test(b) ? E : x;
                m.version = L, m.versionNumber = parseFloat(L), b = { trident: "msie", jsdom: "node" }[b] || b, m.name = b, m[b] = !0;
              }
            }
          ), m.chrome && delete m.webkit, m.atom && delete m.chrome;
        }
      },
      version: "0.12.17",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, n) {
        var s = He.PaperScript.execute(i, this, n);
        return ei.updateFocus(), s;
      },
      install: function(i) {
        var n = this;
        a.each(["project", "view", "tool"], function(l) {
          a.define(i, l, {
            configurable: !0,
            get: function() {
              return n[l];
            }
          });
        });
        for (var s in this)
          !/^_/.test(s) && this[s] && (i[s] = this[s]);
      },
      setup: function(i) {
        return He = this, this.project = new ve(i), this;
      },
      createCanvas: function(i, n) {
        return dt.getCanvas(i, n);
      },
      activate: function() {
        He = this;
      },
      clear: function() {
        for (var i = this.projects, n = this.tools, s = i.length - 1; s >= 0; s--)
          i[s].remove();
        for (var s = n.length - 1; s >= 0; s--)
          n[s].remove();
      },
      remove: function() {
        this.clear(), delete f._scopes[this._id];
      },
      statics: new function() {
        function i(n) {
          return n += "Attribute", function(s, l) {
            return s[n](l) || s[n]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(n) {
            return this._scopes[n] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), v = a.extend(u, {
      initialize: function(i) {
        this._scope = He, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (a.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), S = {
      findItemBoundsCollisions: function(i, n, s) {
        function l(m) {
          for (var _ = new Array(m.length), b = 0; b < m.length; b++) {
            var x = m[b].getBounds();
            _[b] = [x.left, x.top, x.right, x.bottom];
          }
          return _;
        }
        var h = l(i), d = !n || n === i ? h : l(n);
        return this.findBoundsCollisions(h, d, s || 0);
      },
      findCurveBoundsCollisions: function(i, n, s, l) {
        function h(L) {
          for (var A = Math.min, U = Math.max, k = new Array(L.length), F = 0; F < L.length; F++) {
            var B = L[F];
            k[F] = [
              A(B[0], B[2], B[4], B[6]),
              A(B[1], B[3], B[5], B[7]),
              U(B[0], B[2], B[4], B[6]),
              U(B[1], B[3], B[5], B[7])
            ];
          }
          return k;
        }
        var d = h(i), m = !n || n === i ? d : h(n);
        if (l) {
          for (var _ = this.findBoundsCollisions(
            d,
            m,
            s || 0,
            !1,
            !0
          ), b = this.findBoundsCollisions(
            d,
            m,
            s || 0,
            !0,
            !0
          ), x = [], T = 0, E = _.length; T < E; T++)
            x[T] = { hor: _[T], ver: b[T] };
          return x;
        }
        return this.findBoundsCollisions(d, m, s || 0);
      },
      findBoundsCollisions: function(i, n, s, l, h) {
        var d = !n || i === n, m = d ? i : i.concat(n), _ = i.length, b = m.length;
        function x(Je, tt, ft) {
          for (var Ne = 0, ze = Je.length; Ne < ze; ) {
            var nt = ze + Ne >>> 1;
            m[Je[nt]][tt] < ft ? Ne = nt + 1 : ze = nt;
          }
          return Ne - 1;
        }
        for (var T = l ? 1 : 0, E = T + 2, L = l ? 0 : 1, A = L + 2, U = new Array(b), k = 0; k < b; k++)
          U[k] = k;
        U.sort(function(Je, tt) {
          return m[Je][T] - m[tt][T];
        });
        for (var F = [], B = new Array(_), k = 0; k < b; k++) {
          var R = U[k], C = m[R], P = d ? R : R - _, H = R < _, W = d || !H, V = H ? [] : null;
          if (F.length) {
            var Q = x(
              F,
              E,
              C[T] - s
            ) + 1;
            if (F.splice(0, Q), d && h) {
              V = V.concat(F);
              for (var ae = 0; ae < F.length; ae++) {
                var le = F[ae];
                B[le].push(P);
              }
            } else
              for (var fe = C[A], se = C[L], ae = 0; ae < F.length; ae++) {
                var le = F[ae], ge = m[le], me = le < _, we = d || le >= _;
                (h || (H && we || W && me) && fe >= ge[L] - s && se <= ge[A] + s) && (H && we && V.push(
                  d ? le : le - _
                ), W && me && B[le].push(P));
              }
          }
          if (H && (i === n && V.push(R), B[R] = V), F.length) {
            var Se = C[E], Ae = x(F, E, Se);
            F.splice(Ae + 1, 0, R);
          } else
            F.push(R);
        }
        for (var k = 0; k < B.length; k++) {
          var Ge = B[k];
          Ge && Ge.sort(function(tt, ft) {
            return tt - ft;
          });
        }
        return B;
      }
    }, I = a.extend({
      initialize: function(i) {
        this.precision = a.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, n, s) {
        return this.number(i) + (s || ",") + this.number(n);
      },
      point: function(i, n) {
        return this.number(i.x) + (n || ",") + this.number(i.y);
      },
      size: function(i, n) {
        return this.number(i.width) + (n || ",") + this.number(i.height);
      },
      rectangle: function(i, n) {
        return this.point(i, n) + (n || ",") + this.size(i, n);
      }
    });
    I.instance = new I();
    var D = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], n = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], s = Math.abs, l = Math.sqrt, h = Math.pow, d = Math.log2 || function(E) {
        return Math.log(E) * Math.LOG2E;
      }, m = 1e-12, _ = 112e-18;
      function b(E, L, A) {
        return E < L ? L : E > A ? A : E;
      }
      function x(E, L, A) {
        function U(Q) {
          var ae = Q * 134217729, le = Q - ae, fe = le + ae, se = Q - fe;
          return [fe, se];
        }
        var k = L * L - E * A, F = L * L + E * A;
        if (s(k) * 3 < F) {
          var B = U(E), R = U(L), C = U(A), P = L * L, H = R[0] * R[0] - P + 2 * R[0] * R[1] + R[1] * R[1], W = E * A, V = B[0] * C[0] - W + B[0] * C[1] + B[1] * C[0] + B[1] * C[1];
          k = P - W + (H - V);
        }
        return k;
      }
      function T() {
        var E = Math.max.apply(Math, arguments);
        return E && (E < 1e-8 || E > 1e8) ? h(2, -Math.round(d(E))) : 0;
      }
      return {
        EPSILON: m,
        MACHINE_EPSILON: _,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(E) {
          return E >= -m && E <= m;
        },
        isMachineZero: function(E) {
          return E >= -_ && E <= _;
        },
        clamp: b,
        integrate: function(E, L, A, U) {
          for (var k = i[U - 2], F = n[U - 2], B = (A - L) * 0.5, R = B + L, C = 0, P = U + 1 >> 1, H = U & 1 ? F[C++] * E(R) : 0; C < P; ) {
            var W = B * k[C];
            H += F[C++] * (E(R + W) + E(R - W));
          }
          return B * H;
        },
        findRoot: function(E, L, A, U, k, F, B) {
          for (var R = 0; R < F; R++) {
            var C = E(A), P = C / L(A), H = A - P;
            if (s(P) < B) {
              A = H;
              break;
            }
            C > 0 ? (k = A, A = H <= U ? (U + k) * 0.5 : H) : (U = A, A = H >= k ? (U + k) * 0.5 : H);
          }
          return b(A, U, k);
        },
        solveQuadratic: function(E, L, A, U, k, F) {
          var B, R = 1 / 0;
          if (s(E) < m) {
            if (s(L) < m)
              return s(A) < m ? -1 : 0;
            B = -A / L;
          } else {
            L *= -0.5;
            var C = x(E, L, A);
            if (C && s(C) < _) {
              var P = T(s(E), s(L), s(A));
              P && (E *= P, L *= P, A *= P, C = x(E, L, A));
            }
            if (C >= -_) {
              var H = C < 0 ? 0 : l(C), W = L + (L < 0 ? -H : H);
              W === 0 ? (B = A / E, R = -B) : (B = W / E, R = A / W);
            }
          }
          var V = 0, Q = k == null, ae = k - m, le = F + m;
          return isFinite(B) && (Q || B > ae && B < le) && (U[V++] = Q ? B : b(B, k, F)), R !== B && isFinite(R) && (Q || R > ae && R < le) && (U[V++] = Q ? R : b(R, k, F)), V;
        },
        solveCubic: function(E, L, A, U, k, F, B) {
          var R = T(s(E), s(L), s(A), s(U)), C, P, H, W, V;
          R && (E *= R, L *= R, A *= R, U *= R);
          function Q(Ae) {
            C = Ae;
            var Ge = E * C;
            P = Ge + L, H = P * C + A, W = (Ge + P) * C + H, V = H * C + U;
          }
          if (s(E) < m)
            E = L, P = A, H = U, C = 1 / 0;
          else if (s(U) < m)
            P = L, H = A, C = 0;
          else {
            Q(-(L / E) / 3);
            var ae = V / E, le = h(s(ae), 1 / 3), fe = ae < 0 ? -1 : 1, se = -W / E, ge = se > 0 ? 1.324717957244746 * Math.max(le, l(se)) : le, me = C - fe * ge;
            if (me !== C) {
              do
                Q(me), me = W === 0 ? C : C - V / W / (1 + _);
              while (fe * me > fe * C);
              s(E) * C * C > s(U / C) && (H = -U / C, P = (H - A) / C);
            }
          }
          var we = D.solveQuadratic(E, P, H, k, F, B), Se = F == null;
          return isFinite(C) && (we === 0 || we > 0 && C !== k[0] && C !== k[1]) && (Se || C > F - m && C < B + m) && (k[we++] = Se ? C : b(C, F, B)), we;
        }
      };
    }(), Z = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var n = this._pools[i];
          return n || (n = this._pools[i] = { _id: 1 }), n._id++;
        } else
          return this._id++;
      }
    }, M = a.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(n, s) {
        var l = typeof n, h = this.__read, d = 0;
        if (l === "number") {
          var m = typeof s == "number";
          this._set(n, m ? s : n), h && (d = m ? 2 : 1);
        } else if (l === "undefined" || n === null)
          this._set(0, 0), h && (d = n === null ? 1 : 0);
        else {
          var _ = l === "string" ? n.split(/[\s,]+/) || [] : n;
          d = 1, Array.isArray(_) ? this._set(+_[0], +(_.length > 1 ? _[1] : _[0])) : "x" in _ ? this._set(_.x || 0, _.y || 0) : "width" in _ ? this._set(_.width || 0, _.height || 0) : "angle" in _ ? (this._set(_.length || 0, 0), this.setAngle(_.angle || 0)) : (this._set(0, 0), d = 0);
        }
        return h && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.x = i, this.y = n, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new M(this.x, this.y);
      },
      toString: function() {
        var i = I.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [n.number(this.x), n.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var n = this._angle || 0;
          this._set(
            Math.cos(n) * i,
            Math.sin(n) * i
          );
        } else {
          var s = i / this.getLength();
          D.isZero(s) && this.getAngle(), this._set(
            this.x * s,
            this.y * s
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = M.read(arguments), n = this.getLength() * i.getLength();
          if (D.isZero(n))
            return NaN;
          var s = this.dot(i) / n;
          return Math.acos(s < -1 ? -1 : s > 1 ? 1 : s);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var n = this.getLength();
          this._set(
            Math.cos(i) * n,
            Math.sin(i) * n
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = M.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, n = M.read(i), s = n.x - this.x, l = n.y - this.y, h = s * s + l * l, d = a.read(i);
        return d ? h : Math.sqrt(h);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var n = this.getLength(), s = n !== 0 ? i / n : 0, l = new M(this.x * s, this.y * s);
        return s >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, n) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var s = n ? this.subtract(n) : this, l = Math.sin(i), h = Math.cos(i);
        return s = new M(
          s.x * h - s.y * l,
          s.x * l + s.y * h
        ), n ? s.add(n) : s;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = M.read(arguments);
        return new M(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = M.read(arguments);
        return new M(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = M.read(arguments);
        return new M(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = M.read(arguments);
        return new M(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = M.read(arguments);
        return new M(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new M(-this.x, -this.y);
      },
      isInside: function() {
        return G.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, n = M.read(i), s = a.read(i);
        return this.getDistance(n) <= s;
      },
      isCollinear: function() {
        var i = M.read(arguments);
        return M.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = M.read(arguments);
        return M.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = D.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = M.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = M.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = M.read(arguments), n = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new M(
          i.x * n,
          i.y * n
        );
      },
      statics: {
        min: function() {
          var i = arguments, n = M.read(i), s = M.read(i);
          return new M(
            Math.min(n.x, s.x),
            Math.min(n.y, s.y)
          );
        },
        max: function() {
          var i = arguments, n = M.read(i), s = M.read(i);
          return new M(
            Math.max(n.x, s.x),
            Math.max(n.y, s.y)
          );
        },
        random: function() {
          return new M(Math.random(), Math.random());
        },
        isCollinear: function(i, n, s, l) {
          return Math.abs(i * l - n * s) <= Math.sqrt((i * i + n * n) * (s * s + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, n, s, l) {
          return Math.abs(i * s + n * l) <= Math.sqrt((i * i + n * n) * (s * s + l * l)) * 1e-8;
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new M(n(this.x), n(this.y));
      };
    }, {})), X = M.extend({
      initialize: function(n, s, l, h) {
        this._x = n, this._y = s, this._owner = l, this._setter = h;
      },
      _set: function(i, n, s) {
        return this._x = i, this._y = n, s || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), Y = a.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(n, s) {
        var l = typeof n, h = this.__read, d = 0;
        if (l === "number") {
          var m = typeof s == "number";
          this._set(n, m ? s : n), h && (d = m ? 2 : 1);
        } else if (l === "undefined" || n === null)
          this._set(0, 0), h && (d = n === null ? 1 : 0);
        else {
          var _ = l === "string" ? n.split(/[\s,]+/) || [] : n;
          d = 1, Array.isArray(_) ? this._set(+_[0], +(_.length > 1 ? _[1] : _[0])) : "width" in _ ? this._set(_.width || 0, _.height || 0) : "x" in _ ? this._set(_.x || 0, _.y || 0) : (this._set(0, 0), d = 0);
        }
        return h && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, n) {
        return this.width = i, this.height = n, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new Y(this.width, this.height);
      },
      toString: function() {
        var i = I.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.width),
          n.number(this.height)
        ];
      },
      add: function() {
        var i = Y.read(arguments);
        return new Y(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = Y.read(arguments);
        return new Y(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = Y.read(arguments);
        return new Y(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = Y.read(arguments);
        return new Y(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = Y.read(arguments);
        return new Y(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new Y(-this.width, -this.height);
      },
      isZero: function() {
        var i = D.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, n) {
          return new Y(
            Math.min(i.width, n.width),
            Math.min(i.height, n.height)
          );
        },
        max: function(i, n) {
          return new Y(
            Math.max(i.width, n.width),
            Math.max(i.height, n.height)
          );
        },
        random: function() {
          return new Y(Math.random(), Math.random());
        }
      }
    }, a.each(["round", "ceil", "floor", "abs"], function(i) {
      var n = Math[i];
      this[i] = function() {
        return new Y(n(this.width), n(this.height));
      };
    }, {})), ie = Y.extend({
      initialize: function(n, s, l, h) {
        this._width = n, this._height = s, this._owner = l, this._setter = h;
      },
      _set: function(i, n, s) {
        return this._width = i, this._height = n, s || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), G = a.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(n, s, l, h) {
        var d = arguments, m = typeof n, _;
        if (m === "number" ? (this._set(n, s, l, h), _ = 4) : m === "undefined" || n === null ? (this._set(0, 0, 0, 0), _ = n === null ? 1 : 0) : d.length === 1 && (Array.isArray(n) ? (this._set.apply(this, n), _ = 1) : n.x !== t || n.width !== t ? (this._set(
          n.x || 0,
          n.y || 0,
          n.width || 0,
          n.height || 0
        ), _ = 1) : n.from === t && n.to === t && (this._set(0, 0, 0, 0), a.readSupported(d, this) && (_ = 1))), _ === t) {
          var b = M.readNamed(d, "from"), x = a.peek(d), T = b.x, E = b.y, L, A;
          if (x && x.x !== t || a.hasNamed(d, "to")) {
            var U = M.readNamed(d, "to");
            L = U.x - T, A = U.y - E, L < 0 && (T = U.x, L = -L), A < 0 && (E = U.y, A = -A);
          } else {
            var k = Y.read(d);
            L = k.width, A = k.height;
          }
          this._set(T, E, L, A), _ = d.__index;
        }
        var F = d.__filtered;
        return F && (this.__filtered = F), this.__read && (this.__read = _), this;
      },
      set: "#initialize",
      _set: function(i, n, s, l) {
        return this.x = i, this.y = n, this.width = s, this.height = l, this;
      },
      clone: function() {
        return new G(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var n = a.isPlainValue(i) ? G.read(arguments) : i;
        return n === this || n && this.x === n.x && this.y === n.y && this.width === n.width && this.height === n.height || !1;
      },
      toString: function() {
        var i = I.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var n = i.formatter;
        return [
          n.number(this.x),
          n.number(this.y),
          n.number(this.width),
          n.number(this.height)
        ];
      },
      getPoint: function(i) {
        var n = i ? M : X;
        return new n(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var n = i ? Y : ie;
        return new n(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = Y.read(arguments), n = this._sx, s = this._sy, l = i.width, h = i.height;
        n && (this.x += (this.width - l) * n), s && (this.y += (this.height - h) * s), this.width = l, this.height = h, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width -= this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height -= this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var n = i - this.x;
          this.width = this._sx === 0.5 ? n * 2 : n;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var n = i - this.y;
          this.height = this._sy === 0.5 ? n * 2 : n;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var n = i ? M : X;
        return new n(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = M.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(G.read(arguments)) : this._containsPoint(M.read(arguments));
      },
      _containsPoint: function(i) {
        var n = i.x, s = i.y;
        return n >= this.x && s >= this.y && n <= this.x + this.width && s <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var n = i.x, s = i.y;
        return n >= this.x && s >= this.y && n + i.width <= this.x + this.width && s + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = G.read(arguments), n = a.read(arguments) || 0;
        return i.x + i.width > this.x - n && i.y + i.height > this.y - n && i.x < this.x + this.width + n && i.y < this.y + this.height + n;
      },
      intersect: function() {
        var i = G.read(arguments), n = Math.max(this.x, i.x), s = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), h = Math.min(this.y + this.height, i.y + i.height);
        return new G(n, s, l - n, h - s);
      },
      unite: function() {
        var i = G.read(arguments), n = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), h = Math.max(this.y + this.height, i.y + i.height);
        return new G(n, s, l - n, h - s);
      },
      include: function() {
        var i = M.read(arguments), n = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), h = Math.max(this.y + this.height, i.y);
        return new G(n, s, l - n, h - s);
      },
      expand: function() {
        var i = Y.read(arguments), n = i.width, s = i.height;
        return new G(
          this.x - n / 2,
          this.y - s / 2,
          this.width + n,
          this.height + s
        );
      },
      scale: function(i, n) {
        return this.expand(
          this.width * i - this.width,
          this.height * (n === t ? i : n) - this.height
        );
      }
    }, a.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, n) {
        var s = i.join(""), l = /^[RL]/.test(s);
        n >= 4 && (i[1] += l ? "Y" : "X");
        var h = i[l ? 0 : 1], d = i[l ? 1 : 0], m = "get" + h, _ = "get" + d, b = "set" + h, x = "set" + d, T = "get" + s, E = "set" + s;
        this[T] = function(L) {
          var A = L ? M : X;
          return new A(this[m](), this[_](), this, E);
        }, this[E] = function() {
          var L = M.read(arguments);
          this[b](L.x), this[x](L.y);
        };
      },
      {
        beans: !0
      }
    )), te = G.extend(
      {
        initialize: function(n, s, l, h, d, m) {
          this._set(n, s, l, h, !0), this._owner = d, this._setter = m;
        },
        _set: function(i, n, s, l, h) {
          return this._x = i, this._y = n, this._width = s, this._height = l, h || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = G.prototype;
        return a.each(
          ["x", "y", "width", "height"],
          function(n) {
            var s = a.capitalize(n), l = "_" + n;
            this["get" + s] = function() {
              return this[l];
            }, this["set" + s] = function(h) {
              this[l] = h, this._dontNotify || this._owner[this._setter](this);
            };
          },
          a.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(n) {
              var s = "set" + n;
              this[s] = function() {
                this._dontNotify = !0, i[s].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(n) {
                var s = this._owner;
                s._changeSelection && s._changeSelection(2, n);
              }
            }
          )
        );
      }()
    ), J = a.extend({
      _class: "Matrix",
      initialize: function i(n, s) {
        var l = arguments, h = l.length, d = !0;
        if (h >= 6 ? this._set.apply(this, l) : h === 1 || h === 2 ? n instanceof i ? this._set(
          n._a,
          n._b,
          n._c,
          n._d,
          n._tx,
          n._ty,
          s
        ) : Array.isArray(n) ? this._set.apply(
          this,
          s ? n.concat([s]) : n
        ) : d = !1 : h ? d = !1 : this.reset(), !d)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, n, s, l, h, d, m) {
        return this._a = i, this._b = n, this._c = s, this._d = l, this._tx = h, this._ty = d, m || this._changed(), this;
      },
      _serialize: function(i, n) {
        return a.serialize(this.getValues(), i, !0, n);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new J(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = I.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, n) {
        var s = this._owner;
        return s ? (s.transform(null, a.pick(i, !0), n), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = M.read(arguments), n = i.x, s = i.y;
        return this._tx += n * this._a + s * this._c, this._ty += n * this._b + s * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, n = M.read(i), s = M.read(i, 0, { readNull: !0 });
        return s && this.translate(s), this._a *= n.x, this._b *= n.x, this._c *= n.y, this._d *= n.y, s && this.translate(s.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var n = M.read(arguments, 1), s = n.x, l = n.y, h = Math.cos(i), d = Math.sin(i), m = s - s * h + l * d, _ = l - s * d - l * h, b = this._a, x = this._b, T = this._c, E = this._d;
        return this._a = h * b + d * T, this._b = h * x + d * E, this._c = -d * b + h * T, this._d = -d * x + h * E, this._tx += m * b + _ * T, this._ty += m * x + _ * E, this._changed(), this;
      },
      shear: function() {
        var i = arguments, n = M.read(i), s = M.read(i, 0, { readNull: !0 });
        s && this.translate(s);
        var l = this._a, h = this._b;
        return this._a += n.y * this._c, this._b += n.y * this._d, this._c += n.x * l, this._d += n.x * h, s && this.translate(s.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, n = M.read(i), s = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, h = new M(
          Math.tan(n.x * l),
          Math.tan(n.y * l)
        );
        return this.shear(h, s);
      },
      append: function(i, n) {
        if (i) {
          var s = this._a, l = this._b, h = this._c, d = this._d, m = i._a, _ = i._c, b = i._b, x = i._d, T = i._tx, E = i._ty;
          this._a = m * s + b * h, this._c = _ * s + x * h, this._b = m * l + b * d, this._d = _ * l + x * d, this._tx += T * s + E * h, this._ty += T * l + E * d, n || this._changed();
        }
        return this;
      },
      prepend: function(i, n) {
        if (i) {
          var s = this._a, l = this._b, h = this._c, d = this._d, m = this._tx, _ = this._ty, b = i._a, x = i._c, T = i._b, E = i._d, L = i._tx, A = i._ty;
          this._a = b * s + x * l, this._c = b * h + x * d, this._b = T * s + E * l, this._d = T * h + E * d, this._tx = b * m + x * _ + L, this._ty = T * m + E * _ + A, n || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, n = this._b, s = this._c, l = this._d, h = this._tx, d = this._ty, m = i * l - n * s, _ = null;
        return m && !isNaN(m) && isFinite(h) && isFinite(d) && (this._a = l / m, this._b = -n / m, this._c = -s / m, this._d = i / m, this._tx = (s * d - l * h) / m, this._ty = (n * h - i * d) / m, _ = this), _;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new J(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, n, s) {
        return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, n, s);
      },
      _transformPoint: function(i, n, s) {
        var l = i.x, h = i.y;
        return n || (n = new M()), n._set(
          l * this._a + h * this._c + this._tx,
          l * this._b + h * this._d + this._ty,
          s
        );
      },
      _transformCoordinates: function(i, n, s) {
        for (var l = 0, h = 2 * s; l < h; l += 2) {
          var d = i[l], m = i[l + 1];
          n[l] = d * this._a + m * this._c + this._tx, n[l + 1] = d * this._b + m * this._d + this._ty;
        }
        return n;
      },
      _transformCorners: function(i) {
        var n = i.x, s = i.y, l = n + i.width, h = s + i.height, d = [n, s, l, s, l, h, n, h];
        return this._transformCoordinates(d, d, 4);
      },
      _transformBounds: function(i, n, s) {
        for (var l = this._transformCorners(i), h = l.slice(0, 2), d = h.slice(), m = 2; m < 8; m++) {
          var _ = l[m], b = m & 1;
          _ < h[b] ? h[b] = _ : _ > d[b] && (d[b] = _);
        }
        return n || (n = new G()), n._set(
          h[0],
          h[1],
          d[0] - h[0],
          d[1] - h[1],
          s
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(M.read(arguments));
      },
      _inverseTransform: function(i, n, s) {
        var l = this._a, h = this._b, d = this._c, m = this._d, _ = this._tx, b = this._ty, x = l * m - h * d, T = null;
        if (x && !isNaN(x) && isFinite(_) && isFinite(b)) {
          var E = i.x - this._tx, L = i.y - this._ty;
          n || (n = new M()), T = n._set(
            (E * m - L * d) / x,
            (L * l - E * h) / x,
            s
          );
        }
        return T;
      },
      decompose: function() {
        var i = this._a, n = this._b, s = this._c, l = this._d, h = i * l - n * s, d = Math.sqrt, m = Math.atan2, _ = 180 / Math.PI, b, x, T;
        if (i !== 0 || n !== 0) {
          var E = d(i * i + n * n);
          b = Math.acos(i / E) * (n > 0 ? 1 : -1), x = [E, h / E], T = [m(i * s + n * l, E * E), 0];
        } else if (s !== 0 || l !== 0) {
          var L = d(s * s + l * l);
          b = Math.asin(s / L) * (l > 0 ? 1 : -1), x = [h / L, L], T = [0, m(i * s + n * l, L * L)];
        } else
          b = 0, T = x = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: b * _,
          scaling: new M(x),
          skewing: new M(T[0] * _, T[1] * _)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new M(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, a.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var n = a.capitalize(i), s = "_" + i;
      this["get" + n] = function() {
        return this[s];
      }, this["set" + n] = function(l) {
        this[s] = l, this._changed();
      };
    }, {})), he = a.extend({
      _class: "Line",
      initialize: function(n, s, l, h, d) {
        var m = !1;
        arguments.length >= 4 ? (this._px = n, this._py = s, this._vx = l, this._vy = h, m = d) : (this._px = n.x, this._py = n.y, this._vx = s.x, this._vy = s.y, m = l), m || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new M(this._px, this._py);
      },
      getVector: function() {
        return new M(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, n) {
        return he.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          n
        );
      },
      getSide: function(i, n) {
        return he.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          n
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return he.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, n, s, l, h, d, m, _, b, x) {
          b || (s -= i, l -= n, m -= h, _ -= d);
          var T = s * _ - l * m;
          if (!D.isMachineZero(T)) {
            var E = i - h, L = n - d, A = (m * L - _ * E) / T, U = (s * L - l * E) / T, k = 1e-12, F = -k, B = 1 + k;
            if (x || F < A && A < B && F < U && U < B)
              return x || (A = A <= 0 ? 0 : A >= 1 ? 1 : A), new M(
                i + A * s,
                n + A * l
              );
          }
        },
        getSide: function(i, n, s, l, h, d, m, _) {
          m || (s -= i, l -= n);
          var b = h - i, x = d - n, T = b * l - x * s;
          return !_ && D.isMachineZero(T) && (T = (b * s + b * s) / (s * s + l * l), T >= 0 && T <= 1 && (T = 0)), T < 0 ? -1 : T > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, n, s, l, h, d, m) {
          return m || (s -= i, l -= n), s === 0 ? l > 0 ? h - i : i - h : l === 0 ? s < 0 ? d - n : n - d : ((h - i) * l - (d - n) * s) / (l > s ? l * Math.sqrt(1 + s * s / (l * l)) : s * Math.sqrt(1 + l * l / (s * s)));
        },
        getDistance: function(i, n, s, l, h, d, m) {
          return Math.abs(
            he.getSignedDistance(i, n, s, l, h, d, m)
          );
        }
      }
    }), ve = v.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(n) {
        v.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new ui(null, null, this), this._view = ei.create(
          this,
          n || dt.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, n) {
        return a.serialize(this._children, i, !0, n);
      },
      _changed: function(i, n) {
        if (i & 1) {
          var s = this._view;
          s && (s._needsUpdate = !0, !s._requested && s._autoUpdate && s.requestUpdate());
        }
        var l = this._changes;
        if (l && n) {
          var h = this._changesById, d = n._id, m = h[d];
          m ? m.flags |= i : l.push(h[d] = { item: n, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, n = i.length - 1; n >= 0; n--)
          i[n].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new We({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], n = {};
        return this.getItems({
          class: Lt,
          match: function(s) {
            var l = s._definition, h = l._id;
            return n[h] || (n[h] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, n = [];
        for (var s in i) {
          var l = i[s], h = l._selection;
          h & 1 && l.isInserted() ? n.push(l) : h || this._updateSelection(l);
        }
        return n;
      },
      _updateSelection: function(i) {
        var n = i._id, s = this._selectionItems;
        i._selection ? s[n] !== i && (this._selectionCount++, s[n] = i) : s[n] === i && (this._selectionCount--, delete s[n]);
      },
      selectAll: function() {
        for (var i = this._children, n = 0, s = i.length; n < s; n++)
          i[n].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var n in i)
          i[n].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, n) {
        if (n instanceof We) {
          n._remove(!1, !0), a.splice(this._children, [n], i, 0), n._setProject(this, !0);
          var s = n._name;
          s && n.setName(s), this._changes && n._changed(5), this._activeLayer || (this._activeLayer = n);
        } else
          n = null;
        return n;
      },
      _insertItem: function(i, n, s) {
        return n = this.insertLayer(i, n) || (this._activeLayer || this._insertItem(
          t,
          new We(K.NO_INSERT),
          !0
        )).insertChild(i, n), s && n.activate && n.activate(), n;
      },
      getItems: function(i) {
        return K._getItems(this, i);
      },
      getItem: function(i) {
        return K._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var n = this._activeLayer;
        return a.importJSON(i, n && n.isEmpty() && n);
      },
      removeOn: function(i) {
        var n = this._removeSets;
        if (n) {
          i === "mouseup" && (n.mousedrag = null);
          var s = n[i];
          if (s) {
            for (var l in s) {
              var h = s[l];
              for (var d in n) {
                var m = n[d];
                m && m != s && delete m[h._id];
              }
              h.remove();
            }
            n[i] = null;
          }
        }
      },
      draw: function(i, n, s) {
        this._updateVersion++, i.save(), n.applyToContext(i);
        for (var l = this._children, h = new a({
          offset: new M(0, 0),
          pixelRatio: s,
          viewMatrix: n.isIdentity() ? null : n,
          matrices: [new J()],
          updateMatrix: !0
        }), d = 0, m = l.length; d < m; d++)
          l[d].draw(i, h);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var _ = this._selectionItems, b = this._scope.settings.handleSize, x = this._updateVersion;
          for (var T in _)
            _[T]._drawSelection(i, n, b, _, x);
          i.restore();
        }
      }
    }), K = a.extend(
      u,
      {
        statics: {
          extend: function i(n) {
            return n._serializeFields && (n._serializeFields = a.set(
              {},
              this.prototype._serializeFields,
              n._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new J(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return a.each(
          i,
          function(n) {
            this._events[n] = {
              install: function(s) {
                this.getView()._countItemEvent(s, 1);
              },
              uninstall: function(s) {
                this.getView()._countItemEvent(s, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, n) {
          var s = i && a.isPlainObject(i), l = s && i.internal === !0, h = this._matrix = new J(), d = s && i.project || He.project, m = He.settings;
          return this._id = l ? null : Z.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && m.applyMatrix, n && h.translate(n), h._owner = this, this._style = new ui(d._currentStyle, this, d), l || s && i.insert == !1 || !m.insertItems && !(s && i.insert == !0) ? this._setProject(d) : (s && i.parent || d)._insertItem(t, this, !0), s && i !== K.NO_INSERT && i !== K.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), s;
        },
        _serialize: function(i, n) {
          var s = {}, l = this;
          function h(d) {
            for (var m in d) {
              var _ = l[m];
              a.equals(_, m === "leading" ? d.fontSize * 1.2 : d[m]) || (s[m] = a.serialize(
                _,
                i,
                m !== "data",
                n
              ));
            }
          }
          return h(this._serializeFields), this instanceof j || h(this._style._defaults), [this._class, s];
        },
        _changed: function(i) {
          var n = this._symbol, s = this._parent || n, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), s && i & 72 && K._clearBoundsCache(s), i & 2 && K._clearBoundsCache(this), l && l._changed(i, this), n && n._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var n = this._getOwner();
          if (i && n) {
            var s = n._children, l = n._namedChildren;
            (l[i] = l[i] || []).push(this), i in s || (s[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      a.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var n = a.capitalize(i), s = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + n] = function() {
            return this[s];
          }, this["set" + n] = function(h) {
            h != this[s] && (this[s] = h, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var n = this._project;
            n && (n._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, n) {
          var s = this._selection;
          this.setSelection(n ? s | i : s & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, n = 0, s = i.length; n < s; n++)
              if (i[n].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var n = this._children, s = 0, l = n.length; s < l; s++)
              n[s].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, n = !!(this._selection & 1);
          if (i && n) {
            for (var s = 0, l = i.length; s < l; s++)
              if (!i[s].isFullySelected())
                return !1;
            return !0;
          }
          return n;
        },
        setFullySelected: function(i) {
          var n = this._children;
          if (n)
            for (var s = 0, l = n.length; s < l; s++)
              n[s].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var n = i ? M : X, s = this._position || (this._position = this._getPositionFromBounds());
          return new n(s.x, s.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(M.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new X(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      a.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, n) {
          this[n] = function(s) {
            return this.getBounds(s, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, n) {
            var s = n || i instanceof J, l = a.set(
              {},
              s ? n : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var h = this._getCachedBounds(s && i, l).rect;
            return arguments.length ? h : new te(
              h.x,
              h.y,
              h.width,
              h.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = G.read(arguments), n = this.getBounds(), s = this._matrix, l = new J(), h = i.getCenter();
            l.translate(h), (i.width != n.width || i.height != n.height) && (s.isInvertible() || (s.set(s._backup || new J().translate(s.getTranslation())), n = this.getBounds()), l.scale(
              n.width !== 0 ? i.width / n.width : 0,
              n.height !== 0 ? i.height / n.height : 0
            )), h = n.getCenter(), l.translate(-h.x, -h.y), this.transform(l);
          },
          _getBounds: function(i, n) {
            var s = this._children;
            return !s || !s.length ? new G() : (K._updateBoundsCache(this, n.cacheItem), K._getBounds(s, i, n));
          },
          _getBoundsCacheKey: function(i, n) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              n ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, n, s) {
            i = i && i._orNullIfIdentity();
            var l = n.internal && !s, h = n.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), m = h && (!i || i.equals(d)) && this._getBoundsCacheKey(n, l), _ = this._bounds;
            if (K._updateBoundsCache(this._parent || this._symbol, h), m && _ && m in _) {
              var b = _[m];
              return {
                rect: b.rect.clone(),
                nonscaling: b.nonscaling
              };
            }
            var x = this._getBounds(i || d, n), T = x.rect || x, E = this._style, L = x.nonscaling || E.hasStroke() && !E.getStrokeScaling();
            if (m) {
              _ || (this._bounds = _ = {});
              var b = _[m] = {
                rect: T.clone(),
                nonscaling: L,
                internal: l
              };
            }
            return {
              rect: T,
              nonscaling: L
            };
          },
          _getStrokeMatrix: function(i, n) {
            var s = this.getStrokeScaling() ? null : n && n.internal ? this : this._parent || this._symbol && this._symbol._item, l = s ? s.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, n) {
              if (i && n) {
                var s = n._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[s] || (l.list.push(n), l.ids[s] = n);
              }
            },
            _clearBoundsCache: function(i) {
              var n = i._boundsCache;
              if (n) {
                i._bounds = i._position = i._boundsCache = t;
                for (var s = 0, l = n.list, h = l.length; s < h; s++) {
                  var d = l[s];
                  d !== i && (d._bounds = d._position = t, d._boundsCache && K._clearBoundsCache(d));
                }
              }
            },
            _getBounds: function(i, n, s) {
              var l = 1 / 0, h = -l, d = l, m = h, _ = !1;
              s = s || {};
              for (var b = 0, x = i.length; b < x; b++) {
                var T = i[b];
                if (T._visible && !T.isEmpty(!0)) {
                  var E = T._getCachedBounds(
                    n && n.appended(T._matrix),
                    s,
                    !0
                  ), L = E.rect;
                  l = Math.min(L.x, l), d = Math.min(L.y, d), h = Math.max(L.x + L.width, h), m = Math.max(L.y + L.height, m), E.nonscaling && (_ = !0);
                }
              }
              return {
                rect: isFinite(l) ? new G(l, d, h - l, m - d) : new G(),
                nonscaling: _
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          if (n != null && i != null) {
            var s = this._decomposed;
            this.rotate(i - n), s && (s.rotation = i, this._decomposed = s);
          }
        },
        getScaling: function() {
          var i = this._decompose(), n = i && i.scaling;
          return new X(n ? n.x : 1, n ? n.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = M.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && n && !i.equals(n)) {
            var s = this.getRotation(), l = this._decomposed, h = new J(), d = D.isZero;
            if (d(i.x) || d(i.y))
              h.translate(l.translation), s && h.rotate(s), h.scale(n.x, n.y), this._matrix.set(h);
            else {
              var m = this.getPosition(!0);
              h.translate(m), s && h.rotate(s), h.scale(n.x / i.x, n.y / i.y), s && h.rotate(-s), h.translate(m.negate()), this.transform(h);
            }
            l && (l.scaling = n, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var n = this._globalMatrix;
          if (n)
            for (var s = this._parent, l = []; s; ) {
              if (!s._globalMatrix) {
                n = null;
                for (var h = 0, d = l.length; h < d; h++)
                  l[h]._globalMatrix = null;
                break;
              }
              l.push(s), s = s._parent;
            }
          if (!n) {
            n = this._globalMatrix = this._matrix.clone();
            var s = this._parent;
            s && n.prepend(s.getGlobalMatrix(!0));
          }
          return i ? n : n.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, n) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var s = this._children, l = 0, h = s && s.length; l < h; l++)
              s[l]._setProject(i);
            n = !0;
          }
          n && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(n) {
          i.base.call(this, n);
          for (var s = this._children, l = 0, h = s && s.length; l < h; l++)
            s[l]._installEvents(n);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof We)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return a.equals(this._children, i._children);
        },
        clone: function(i) {
          var n = new this.constructor(K.NO_INSERT), s = this._children, l = a.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), h = a.pick(i ? i.deep : t, !0);
          s && n.copyAttributes(this), (!s || h) && n.copyContent(this), s || n.copyAttributes(this), l && n.insertAbove(this);
          var d = this._name, m = this._parent;
          if (d && m) {
            for (var s = m._children, _ = d, b = 1; s[d]; )
              d = _ + " " + b++;
            d !== _ && n.setName(d);
          }
          return n;
        },
        copyContent: function(i) {
          for (var n = i._children, s = 0, l = n && n.length; s < l; s++)
            this.addChild(n[s].clone(!1), !0);
        },
        copyAttributes: function(i, n) {
          this.setStyle(i._style);
          for (var s = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, h = s.length; l < h; l++) {
            var d = s[l];
            i.hasOwnProperty(d) && (this[d] = i[d]);
          }
          n || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var m = i._data, _ = i._name;
          this._data = m ? a.clone(m) : null, _ && this.setName(_);
        },
        rasterize: function(i, n) {
          var s, l, h;
          a.isPlainObject(i) ? (s = i.resolution, l = i.insert, h = i.raster) : (s = i, l = n), h || (h = new $e(K.NO_INSERT));
          var d = this.getStrokeBounds(), m = (s || this.getView().getResolution()) / 72, _ = d.getTopLeft().floor(), b = d.getBottomRight().ceil(), x = new Y(b.subtract(_)), T = x.multiply(m);
          if (h.setSize(T, !0), !T.isZero()) {
            var E = h.getContext(!0), L = new J().scale(m).translate(_.negate());
            E.save(), L.applyToContext(E), this.draw(E, new a({ matrices: [L] })), E.restore();
          }
          return h._matrix.set(
            new J().translate(_.add(x.divide(2))).scale(1 / m)
          ), (l === t || l) && h.insertAbove(this), h;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
        },
        _contains: function(i) {
          var n = this._children;
          if (n) {
            for (var s = n.length - 1; s >= 0; s--)
              if (n[s].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return G.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new it.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, n) {
          return i instanceof K ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            n,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            M.read(l),
            Xe.getOptions(l)
          );
        }
        function n() {
          var l = arguments, h = M.read(l), d = Xe.getOptions(l), m = [];
          return this._hitTest(h, new a({ all: m }, d)), m;
        }
        function s(l, h, d, m) {
          var _ = this._children;
          if (_)
            for (var b = _.length - 1; b >= 0; b--) {
              var x = _[b], T = x !== m && x._hitTest(
                l,
                h,
                d
              );
              if (T && !h.all)
                return T;
            }
          return null;
        }
        return ve.inject({
          hitTest: i,
          hitTestAll: n,
          _hitTest: s
        }), {
          hitTest: i,
          hitTestAll: n,
          _hitTestChildren: s
        };
      }(),
      {
        _hitTest: function(i, n, s) {
          if (this._locked || !this._visible || this._guide && !n.guides || this.isEmpty())
            return null;
          var l = this._matrix, h = s ? s.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(n.tolerance, 1e-12), m = n._tolerancePadding = new Y(
            it._getStrokePadding(
              d,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(m.multiply(2))._containsPoint(i))
            return null;
          var _ = !(n.guides && !this._guide || n.selected && !this.isSelected() || n.type && n.type !== a.hyphenate(this._class) || n.class && !(this instanceof n.class)), b = n.match, x = this, T, E;
          function L(C) {
            return C && b && !b(C) && (C = null), C && n.all && n.all.push(C), C;
          }
          function A(C, P) {
            var H = P ? T["get" + P]() : x.getPosition();
            if (i.subtract(H).divide(m).length <= 1)
              return new Xe(C, x, {
                name: P ? a.hyphenate(P) : C,
                point: H
              });
          }
          var U = n.position, k = n.center, F = n.bounds;
          if (_ && this._parent && (U || k || F)) {
            if ((k || F) && (T = this.getInternalBounds()), E = U && A("position") || k && A("center", "Center"), !E && F)
              for (var B = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], R = 0; R < 8 && !E; R++)
                E = A("bounds", B[R]);
            E = L(E);
          }
          return E || (E = this._hitTestChildren(i, n, h) || _ && L(this._hitTestSelf(
            i,
            n,
            h,
            this.getStrokeScaling() ? null : h._shiftless().invert()
          )) || null), E && E.point && (E.point = l.transform(E.point)), E;
        },
        _hitTestSelf: function(i, n) {
          if (n.fill && this.hasFill() && this._contains(i))
            return new Xe("fill", this);
        },
        matches: function(i, n) {
          function s(m, _) {
            for (var b in m)
              if (m.hasOwnProperty(b)) {
                var x = m[b], T = _[b];
                if (a.isPlainObject(x) && a.isPlainObject(T)) {
                  if (!s(x, T))
                    return !1;
                } else if (!a.equals(x, T))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var h in i)
              if (i.hasOwnProperty(h) && !this.matches(h, i[h]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return n(this);
            var d = /^(empty|editable)$/.test(i) ? this["is" + a.capitalize(i)]() : i === "type" ? a.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof n == "function")
                return this instanceof n;
              d = this._class;
            }
            if (typeof n == "function")
              return !!n(d);
            if (n) {
              if (n.test)
                return n.test(d);
              if (a.isPlainObject(n))
                return s(n, d);
            }
            return a.equals(d, n);
          }
        },
        getItems: function(i) {
          return K._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return K._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(n, s, l, h, d) {
            if (!h) {
              var m = typeof s == "object" && s, _ = m && m.overlapping, b = m && m.inside, x = _ || b, L = x && G.read([x]);
              h = {
                items: [],
                recursive: m && m.recursive !== !1,
                inside: !!b,
                overlapping: !!_,
                rect: L,
                path: _ && new it.Rectangle({
                  rectangle: L,
                  insert: !1
                })
              }, m && (s = a.filter({}, s, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var T = n._children, E = h.items, L = h.rect;
            l = L && (l || new J());
            for (var A = 0, U = T && T.length; A < U; A++) {
              var k = T[A], F = l && l.appended(k._matrix), B = !0;
              if (L) {
                var x = k.getBounds(F);
                if (!L.intersects(x))
                  continue;
                L.contains(x) || h.overlapping && (x.contains(L) || h.path.intersects(k, F)) || (B = !1);
              }
              if (B && k.matches(s) && (E.push(k), d) || (h.recursive !== !1 && i(k, s, F, h, d), d && E.length > 0))
                break;
            }
            return E;
          }
        }
      },
      {
        importJSON: function(i) {
          var n = a.importJSON(i, this);
          return n !== this ? this.addChild(n) : n;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, n) {
          var s = n ? this.insertChildren(i, [n]) : null;
          return s && s[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, n) {
          var s = this._children;
          if (s && n && n.length > 0) {
            n = a.slice(n);
            for (var l = {}, h = n.length - 1; h >= 0; h--) {
              var d = n[h], m = d && d._id;
              !d || l[m] ? n.splice(h, 1) : (d._remove(!1, !0), l[m] = !0);
            }
            a.splice(s, n, i, 0);
            for (var _ = this._project, b = _._changes, h = 0, x = n.length; h < x; h++) {
              var d = n[h], T = d._name;
              d._parent = this, d._setProject(_, !0), T && d.setName(T), b && d._changed(5);
            }
            this._changed(11);
          } else
            n = null;
          return n;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, n) {
          var s = i && i._getOwner(), l = i !== this && s ? this : null;
          return l && (l._remove(!1, !0), s._insertItem(i._index + n, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var n = this._children;
          if (n && n.length === 1) {
            var s = n[0].reduce(i);
            return this._parent ? (s.insertAbove(this), this.remove()) : s.remove(), s;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var n = i._children, s = i._namedChildren, l = this._name, h = s[l], d = h ? h.indexOf(this) : -1;
            d !== -1 && (n[l] == this && delete n[l], h.splice(d, 1), h.length ? n[l] = h[0] : delete s[l]);
          }
        },
        _remove: function(i, n) {
          var s = this._getOwner(), l = this._project, h = this._index;
          return this._style && this._style._dispose(), s ? (this._name && this._removeNamed(), h != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), a.splice(s._children, null, h, 1)), this._installEvents(!1), i && l._changes && this._changed(5), n && s._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var n = i && i.insertBelow(this);
          return n && this.remove(), n;
        },
        removeChildren: function(i, n) {
          if (!this._children)
            return null;
          i = i || 0, n = a.pick(n, this._children.length);
          for (var s = a.splice(this._children, null, i, n - i), l = s.length - 1; l >= 0; l--)
            s[l]._remove(!0, !1);
          return s.length > 0 && this._changed(11), s;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, n = this._children.length; i < n; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var n = this._children, s = n ? n.length : 0;
          if (i) {
            for (var l = 0; l < s; l++)
              if (!n[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !s;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function n(m) {
            var _ = [];
            do
              _.unshift(m);
            while (m = m._parent);
            return _;
          }
          for (var s = n(this), l = n(i), h = 0, d = Math.min(s.length, l.length); h < d; h++)
            if (s[h] != l[h])
              return s[h]._index < l[h]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var n = this; n = n._parent; )
            if (n === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var n = this._parent; n; ) {
            if (n._parent && /^(Group|Layer|CompoundPath)$/.test(n._class) && i.isDescendant(n))
              return !0;
            n = n._parent;
          }
          return !1;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (n ? a : M).read(s), h = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            h || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, n, s) {
          var l = this._matrix, h = i && !i.isIdentity(), d = s && this._canApplyMatrix || this._applyMatrix && (h || !l.isIdentity() || n && this._children);
          if (!h && !d)
            return this;
          if (h) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var m = this._style, _ = m.getFillColor(!0), b = m.getStrokeColor(!0);
            _ && _.transform(i), b && b.transform(i);
          }
          if (d && (d = this._transformContent(
            l,
            n,
            s
          ))) {
            var x = this._pivot;
            x && l._transformPoint(x, x, !0), l.reset(!0), s && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var T = this._bounds, E = this._position;
          (h || d) && this._changed(25);
          var L = h && T && i.decompose();
          if (L && L.skewing.isZero() && L.rotation % 90 === 0) {
            for (var A in T) {
              var U = T[A];
              if (U.nonscaling)
                delete T[A];
              else if (d || !U.internal) {
                var k = U.rect;
                i._transformBounds(k, k);
              }
            }
            this._bounds = T;
            var F = T[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            F && (this._position = this._getPositionFromBounds(F.rect));
          } else
            h && E && this._pivot && (this._position = i._transformPoint(E, E));
          return this;
        },
        _transformContent: function(i, n, s) {
          var l = this._children;
          if (l) {
            for (var h = 0, d = l.length; h < d; h++)
              l[h].transform(i, n, s);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            M.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            M.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        fitBounds: function(i, n) {
          i = G.read(arguments);
          var s = this.getBounds(), l = s.height / s.width, h = i.height / i.width, d = (n ? l > h : l < h) ? i.width / s.width : i.height / s.height, m = new G(
            new M(),
            new Y(s.width * d, s.height * d)
          );
          m.setCenter(i.getCenter()), this.setBounds(m);
        }
      }),
      {
        _setStyles: function(i, n, s) {
          var l = this._style, h = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, h)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, h), i.lineWidth = l.getStrokeWidth();
            var d = l.getStrokeJoin(), m = l.getStrokeCap(), _ = l.getMiterLimit();
            if (d && (i.lineJoin = d), m && (i.lineCap = m), _ && (i.miterLimit = _), He.support.nativeDash) {
              var b = l.getDashArray(), x = l.getDashOffset();
              b && b.length && ("setLineDash" in i ? (i.setLineDash(b), i.lineDashOffset = x) : (i.mozDash = b, i.mozDashOffset = x));
            }
          }
          if (l.hasShadow()) {
            var T = n.pixelRatio || 1, E = s._shiftless().prepend(
              new J().scale(T, T)
            ), L = E.transform(new M(l.getShadowBlur(), 0)), A = E.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = L.getLength(), i.shadowOffsetX = A.x, i.shadowOffsetY = A.y;
          }
        },
        draw: function(i, n, s) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = n.matrices, h = n.viewMatrix, d = this._matrix, m = l[l.length - 1].appended(d);
            if (m.isInvertible()) {
              h = h ? h.appended(m) : m, l.push(m), n.updateMatrix && (this._globalMatrix = m);
              var _ = this._blendMode, b = D.clamp(this._opacity, 0, 1), x = _ === "normal", T = et.nativeModes[_], E = x && b === 1 || n.dontStart || n.clip || (T || x && b < 1) && this._canComposite(), L = n.pixelRatio || 1, A, U, k;
              if (!E) {
                var F = this.getStrokeBounds(h);
                if (!F.width || !F.height) {
                  l.pop();
                  return;
                }
                k = n.offset, U = n.offset = F.getTopLeft().floor(), A = i, i = dt.getContext(F.getSize().ceil().add(1).multiply(L)), L !== 1 && i.scale(L, L);
              }
              i.save();
              var B = s ? s.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && h, R = !E && n.clipItem, C = !B || R;
              if (E ? (i.globalAlpha = b, T && (i.globalCompositeOperation = _)) : C && i.translate(-U.x, -U.y), C && (E ? d : h).applyToContext(i), R && n.clipItem.draw(i, n.extend({ clip: !0 })), B) {
                i.setTransform(L, 0, 0, L, 0, 0);
                var P = n.offset;
                P && i.translate(-P.x, -P.y);
              }
              this._draw(i, n, h, B), i.restore(), l.pop(), n.clip && !n.dontFinish && i.clip(this.getFillRule()), E || (et.process(
                _,
                i,
                A,
                b,
                U.subtract(k).multiply(L)
              ), dt.release(i), n.offset = k);
            }
          }
        },
        _isUpdated: function(i) {
          var n = this._parent;
          if (n instanceof Zt)
            return n._isUpdated(i);
          var s = this._updateVersion === i;
          return !s && n && n._visible && n._isUpdated(i) && (this._updateVersion = i, s = !0), s;
        },
        _drawSelection: function(i, n, s, l, h) {
          var d = this._selection, m = d & 1, _ = d & 2 || m && this._selectBounds, b = d & 4;
          if (this._drawSelected || (m = !1), (m || _ || b) && this._isUpdated(h)) {
            var x, T = this.getSelectedColor(!0) || (x = this.getLayer()) && x.getSelectedColor(!0), E = n.appended(this.getGlobalMatrix(!0)), L = s / 2;
            if (i.strokeStyle = i.fillStyle = T ? T.toCanvasStyle(i) : "#009dec", m && this._drawSelected(i, E, l), b) {
              var A = this.getPosition(!0), U = this._parent, k = U ? U.localToGlobal(A) : A, F = k.x, B = k.y;
              i.beginPath(), i.arc(F, B, L, 0, Math.PI * 2, !0), i.stroke();
              for (var R = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = L, P = s + 1, H = 0; H < 4; H++) {
                var W = R[H], V = W[0], Q = W[1];
                i.moveTo(F + V * C, B + Q * C), i.lineTo(F + V * P, B + Q * P), i.stroke();
              }
            }
            if (_) {
              var ae = E._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var H = 0; H < 8; H++)
                i[H ? "lineTo" : "moveTo"](ae[H], ae[++H]);
              i.closePath(), i.stroke();
              for (var H = 0; H < 8; H++)
                i.fillRect(
                  ae[H] - L,
                  ae[++H] - L,
                  s,
                  s
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      a.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + a.capitalize(i)] = function() {
          var n = {};
          return n[i] = !0, this.removeOn(n);
        };
      }, {
        removeOn: function(i) {
          for (var n in i)
            if (i[n]) {
              var s = "mouse" + n, l = this._project, h = l._removeSets = l._removeSets || {};
              h[s] = h[s] || {}, h[s][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, n, s) {
          s || (s = n, n = i, i = null, s || (s = n, n = null));
          var l = s && s.easing, h = s && s.start, d = s != null && (typeof s == "number" ? s : s.duration), m = new Qe(this, i, n, d, l, h);
          function _(b) {
            m._handleFrame(b.time * 1e3), m.running || this.off("frame", _);
          }
          return d && this.on("frame", _), m;
        },
        tweenTo: function(i, n) {
          return this.tween(null, i, n);
        },
        tweenFrom: function(i, n) {
          return this.tween(i, null, n);
        }
      }
    ), j = K.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(n) {
        this._children = [], this._namedChildren = {}, this._initialize(n) || this.addChildren(Array.isArray(n) ? n : arguments);
      },
      _changed: function i(n) {
        i.base.call(this, n), n & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var n = this._children, s = 0, l = n.length; s < l; s++)
            if (n[s]._clipMask) {
              i = n[s];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var n = this.getFirstChild();
        n && n.setClipMask(i);
      },
      _getBounds: function i(n, s) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(n),
          a.set({}, s, { stroke: !1 })
        ) : i.base.call(this, n, s);
      },
      _hitTestChildren: function i(n, s, l) {
        var h = this._getClipItem();
        return (!h || h.contains(n)) && i.base.call(
          this,
          n,
          s,
          l,
          h
        );
      },
      _draw: function(i, n) {
        var s = n.clip, l = !s && this._getClipItem();
        n = n.extend({ clipItem: l, clip: !1 }), s ? (i.beginPath(), n.dontStart = n.dontFinish = !0) : l && l.draw(i, n.extend({ clip: !0 }));
        for (var h = this._children, d = 0, m = h.length; d < m; d++) {
          var _ = h[d];
          _ !== l && _.draw(i, n);
        }
      }
    }), We = j.extend({
      _class: "Layer",
      initialize: function() {
        j.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), ke = K.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(n, s) {
          this._initialize(n, s);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && a.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new ie(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = Y.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var n = this._type, s = i.width, l = i.height;
            n === "rectangle" ? this._radius.set(Y.min(this._radius, i.divide(2).abs())) : n === "circle" ? (s = l = (s + l) / 2, this._radius = s / 2) : n === "ellipse" && this._radius._set(s / 2, l / 2), this._size._set(s, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new ie(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var n = this._type;
          if (n === "circle") {
            if (i === this._radius)
              return;
            var s = i * 2;
            this._radius = i, this._size._set(s, s);
          } else if (i = Y.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), n === "rectangle") {
              var s = Y.max(this._size, i.multiply(2));
              this._size.set(s);
            } else
              n === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var n = new it[a.capitalize(this._type)]({
            center: new M(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return n.copyAttributes(this), He.settings.applyMatrix && n.setApplyMatrix(!0), (i === t || i) && n.insertAbove(this), n;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, n, s, l) {
          var h = this._style, d = h.hasFill(), m = h.hasStroke(), _ = n.dontFinish || n.clip, b = !l;
          if (d || m || _) {
            var x = this._type, T = this._radius, E = x === "circle";
            if (n.dontStart || i.beginPath(), b && E)
              i.arc(0, 0, T, 0, Math.PI * 2, !0);
            else {
              var L = E ? T : T.width, A = E ? T : T.height, U = this._size, k = U.width, F = U.height;
              if (b && x === "rectangle" && L === 0 && A === 0)
                i.rect(-k / 2, -F / 2, k, F);
              else {
                var B = k / 2, R = F / 2, C = 1 - 0.5522847498307936, P = L * C, H = A * C, W = [
                  -B,
                  -R + A,
                  -B,
                  -R + H,
                  -B + P,
                  -R,
                  -B + L,
                  -R,
                  B - L,
                  -R,
                  B - P,
                  -R,
                  B,
                  -R + H,
                  B,
                  -R + A,
                  B,
                  R - A,
                  B,
                  R - H,
                  B - P,
                  R,
                  B - L,
                  R,
                  -B + L,
                  R,
                  -B + P,
                  R,
                  -B,
                  R - H,
                  -B,
                  R - A
                ];
                l && l.transform(W, W, 32), i.moveTo(W[0], W[1]), i.bezierCurveTo(W[2], W[3], W[4], W[5], W[6], W[7]), B !== L && i.lineTo(W[8], W[9]), i.bezierCurveTo(W[10], W[11], W[12], W[13], W[14], W[15]), R !== A && i.lineTo(W[16], W[17]), i.bezierCurveTo(W[18], W[19], W[20], W[21], W[22], W[23]), B !== L && i.lineTo(W[24], W[25]), i.bezierCurveTo(W[26], W[27], W[28], W[29], W[30], W[31]);
              }
            }
            i.closePath();
          }
          !_ && (d || m) && (this._setStyles(i, n, s), d && (i.fill(h.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), m && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, n) {
          var s = new G(this._size).setCenter(0, 0), l = this._style, h = n.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (s = i._transformBounds(s)), h ? s.expand(it._getStrokePadding(
            h,
            this._getStrokeMatrix(i, n)
          )) : s;
        }
      },
      new function() {
        function i(s, l, h) {
          var d = s._radius;
          if (!d.isZero())
            for (var m = s._size.divide(2), _ = 1; _ <= 4; _++) {
              var b = new M(_ > 1 && _ < 4 ? -1 : 1, _ > 2 ? -1 : 1), x = b.multiply(m), T = x.subtract(b.multiply(d)), E = new G(
                h ? x.add(b.multiply(h)) : x,
                T
              );
              if (E.contains(l))
                return { point: T, quadrant: _ };
            }
        }
        function n(s, l, h, d) {
          var m = s.divide(l);
          return (!d || m.isInQuadrant(d)) && m.subtract(m.normalize()).multiply(l).divide(h).length <= 1;
        }
        return {
          _contains: function s(l) {
            if (this._type === "rectangle") {
              var h = i(this, l);
              return h ? l.subtract(h.point).divide(this._radius).getLength() <= 1 : s.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function s(l, h, d, m) {
            var _ = !1, b = this._style, x = h.stroke && b.hasStroke(), T = h.fill && b.hasFill();
            if (x || T) {
              var E = this._type, L = this._radius, A = x ? b.getStrokeWidth() / 2 : 0, U = h._tolerancePadding.add(
                it._getStrokePadding(
                  A,
                  !b.getStrokeScaling() && m
                )
              );
              if (E === "rectangle") {
                var k = U.multiply(2), F = i(this, l, k);
                if (F)
                  _ = n(
                    l.subtract(F.point),
                    L,
                    U,
                    F.quadrant
                  );
                else {
                  var B = new G(this._size).setCenter(0, 0), R = B.expand(k), C = B.expand(k.negate());
                  _ = R._containsPoint(l) && !C._containsPoint(l);
                }
              } else
                _ = n(l, L, U);
            }
            return _ ? new Xe(x ? "stroke" : "fill", this) : s.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(n, s, l, h, d) {
            var m = a.create(ke.prototype);
            return m._type = n, m._size = l, m._radius = h, m._initialize(a.getNamed(d), s), m;
          }
          return {
            Circle: function() {
              var n = arguments, s = M.readNamed(n, "center"), l = a.readNamed(n, "radius");
              return i(
                "circle",
                s,
                new Y(l * 2),
                l,
                n
              );
            },
            Rectangle: function() {
              var n = arguments, s = G.readNamed(n, "rectangle"), l = Y.min(
                Y.readNamed(n, "radius"),
                s.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                s.getCenter(!0),
                s.getSize(!0),
                l,
                n
              );
            },
            Ellipse: function() {
              var n = arguments, s = ke._readEllipse(n), l = s.radius;
              return i(
                "ellipse",
                s.center,
                l.multiply(2),
                l,
                n
              );
            },
            _readEllipse: function(n) {
              var s, l;
              if (a.hasNamed(n, "radius"))
                s = M.readNamed(n, "center"), l = Y.readNamed(n, "radius");
              else {
                var h = G.readNamed(n, "rectangle");
                s = h.getCenter(!0), l = h.getSize(!0).divide(2);
              }
              return { center: s, radius: l };
            }
          };
        }()
      }
    ), $e = K.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(n, s) {
        if (!this._initialize(
          n,
          s !== t && M.read(arguments)
        )) {
          var l, h = typeof n, d = h === "string" ? o.getElementById(n) : h === "object" ? n : null;
          if (d && d !== K.NO_INSERT) {
            if (d.getContext || d.naturalHeight != null)
              l = d;
            else if (d) {
              var m = Y.read(arguments);
              m.isZero() || (l = dt.getCanvas(m));
            }
          }
          l ? this.setImage(l) : this.setSource(n);
        }
        this._size || (this._size = new Y(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var n = i._image, s = i._canvas;
        if (n)
          this._setImage(n);
        else if (s) {
          var l = dt.getCanvas(i._size);
          l.getContext("2d").drawImage(s, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new ie(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, n) {
        var s = Y.read(arguments);
        if (s.equals(this._size))
          n && this.clear();
        else if (s.width > 0 && s.height > 0) {
          var l = !n && this.getElement();
          this._setImage(dt.getCanvas(s)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            s.width,
            s.height
          );
        } else
          this._canvas && dt.release(this._canvas), this._size = s.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, n = new M(0, 0).transform(i), s = new M(1, 0).transform(i).subtract(n), l = new M(0, 1).transform(i).subtract(n);
        return new Y(
          72 / s.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var n = this;
        function s(l) {
          var h = n.getView(), d = l && l.type || "load";
          h && n.responds(d) && (He = h._scope, n.emit(d, new tn(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(s, 0) : i && Qt.add(i, {
          load: function(l) {
            n._setImage(i), s(l);
          },
          error: s
        });
      },
      _setImage: function(i) {
        this._canvas && dt.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new Y(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = dt.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            dt.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var n = new e.Image(), s = this._crossOrigin;
        s && (n.crossOrigin = s), i && (n.src = i), this.setImage(n);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var n = this._image;
        n && (n.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = G.read(arguments), n = dt.getContext(i.getSize());
        return n.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), n.canvas;
      },
      getSubRaster: function() {
        var i = G.read(arguments), n = new $e(K.NO_INSERT);
        return n._setImage(this.getSubCanvas(i)), n.translate(i.getCenter().subtract(this.getSize().divide(2))), n._matrix.prepend(this._matrix), n.insertAbove(this), n;
      },
      toDataURL: function() {
        var i = this._image, n = i && i.src;
        if (/^data:/.test(n))
          return n;
        var s = this.getCanvas();
        return s ? s.toDataURL.apply(s, arguments) : null;
      },
      drawImage: function(i) {
        var n = M.read(arguments, 1);
        this.getContext(!0).drawImage(i, n.x, n.y);
      },
      getAverageColor: function(i) {
        var n, s;
        if (i ? i instanceof Gt ? (s = i, n = i.getBounds()) : typeof i == "object" && ("width" in i ? n = new G(i) : "x" in i && (n = new G(i.x - 0.5, i.y - 0.5, 1, 1))) : n = this.getBounds(), !n)
          return null;
        var l = 32, h = Math.min(n.width, l), d = Math.min(n.height, l), m = $e._sampleContext;
        m ? m.clearRect(0, 0, l + 1, l + 1) : m = $e._sampleContext = dt.getContext(
          new Y(l)
        ), m.save();
        var _ = new J().scale(h / n.width, d / n.height).translate(-n.x, -n.y);
        _.applyToContext(m), s && s.draw(m, new a({ clip: !0, matrices: [_] })), this._matrix.applyToContext(m);
        var b = this.getElement(), x = this._size;
        b && m.drawImage(b, -x.width / 2, -x.height / 2), m.restore();
        for (var T = m.getImageData(
          0.5,
          0.5,
          Math.ceil(h),
          Math.ceil(d)
        ).data, E = [0, 0, 0], L = 0, A = 0, U = T.length; A < U; A += 4) {
          var k = T[A + 3];
          L += k, k /= 255, E[0] += T[A] * k, E[1] += T[A + 1] * k, E[2] += T[A + 2] * k;
        }
        for (var A = 0; A < 3; A++)
          E[A] /= L;
        return L ? At.read(E) : null;
      },
      getPixel: function() {
        var i = M.read(arguments), n = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new At(
          "rgb",
          [n[0] / 255, n[1] / 255, n[2] / 255],
          n[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, n = M.read(i), s = At.read(i), l = s._convert("rgb"), h = s._alpha, d = this.getContext(!0), m = d.createImageData(1, 1), _ = m.data;
        _[0] = l[0] * 255, _[1] = l[1] * 255, _[2] = l[2] * 255, _[3] = h != null ? h * 255 : 255, d.putImageData(m, n.x, n.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = Y.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = G.read(arguments);
        return i.isEmpty() && (i = new G(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var n = M.read(arguments, 1);
        this.getContext(!0).putImageData(i, n.x, n.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, n) {
        var s = new G(this._size).setCenter(0, 0);
        return i ? i._transformBounds(s) : s;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var n = this;
          return new Xe("pixel", n, {
            offset: i.add(n._size.divide(2)).round(),
            color: {
              get: function() {
                return n.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, n, s) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = D.clamp(this._opacity, 0, 1), this._setStyles(i, n, s);
          var h = this._smoothing, d = h === "off";
          Wt.setPrefixed(
            i,
            d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            d ? !1 : h
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), Lt = K.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(n, s) {
        this._initialize(
          n,
          s !== t && M.read(arguments, 1)
        ) || this.setDefinition(n instanceof Be ? n : new Be(n));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, n) {
        var s = this._definition._item;
        return s._getCachedBounds(s._matrix.prepended(i), n);
      },
      _hitTestSelf: function(i, n, s) {
        var l = n.extend({ all: !1 }), h = this._definition._item._hitTest(i, l, s);
        return h && (h.item = this), h;
      },
      _draw: function(i, n) {
        this._definition._item.draw(i, n);
      }
    }), Be = a.extend({
      _class: "SymbolDefinition",
      initialize: function(n, s) {
        this._id = Z.get(), this.project = He.project, n && this.setItem(n, s);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._class, this._item],
            i,
            !1,
            n
          );
        });
      },
      _changed: function(i) {
        i & 8 && K._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, n) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), n || i.setPosition(new M()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new Lt(this, i);
      },
      clone: function() {
        return new Be(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), Xe = a.extend({
      _class: "HitResult",
      initialize: function(n, s, l) {
        this.type = n, this.item = s, l && this.inject(l);
      },
      statics: {
        getOptions: function(i) {
          var n = i && a.read(i);
          return new a({
            type: null,
            tolerance: He.settings.hitTolerance,
            fill: !n,
            stroke: !n,
            segments: !n,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, n);
        }
      }
    }), ue = a.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(n, s, l, h, d, m) {
        var _ = arguments.length, b, x, T, E;
        _ > 0 && (n == null || typeof n == "object" ? _ === 1 && n && "point" in n ? (b = n.point, x = n.handleIn, T = n.handleOut, E = n.selection) : (b = n, x = s, T = l, E = h) : (b = [n, s], x = l !== t ? [l, h] : null, T = d !== t ? [d, m] : null)), new yt(b, this, "_point"), new yt(x, this, "_handleIn"), new yt(T, this, "_handleOut"), E && this.setSelection(E);
      },
      _serialize: function(i, n) {
        var s = this._point, l = this._selection, h = l || this.hasHandles() ? [s, this._handleIn, this._handleOut] : s;
        return l && h.push(l), a.serialize(h, i, !0, n);
      },
      _changed: function(i) {
        var n = this._path;
        if (n) {
          var s = n._curves, l = this._index, h;
          s && ((!i || i === this._point || i === this._handleIn) && (h = l > 0 ? s[l - 1] : n._closed ? s[s.length - 1] : null) && h._changed(), (!i || i === this._point || i === this._handleOut) && (h = s[l]) && h._changed()), n._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(M.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(M.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(M.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, n = this._handleOut;
        return !i.isZero() && !n.isZero() && i.isCollinear(n);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var n = this._selection, s = this._path;
        this._selection = i = i || 0, s && i !== n && (s._updateSelection(this, n, i), s._changed(257));
      },
      _changeSelection: function(i, n) {
        var s = this._selection;
        this.setSelection(n ? s | i : s & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, n = this._index;
        return i ? (n > 0 && !i._closed && n === i._segments.length - 1 && n--, i.getCurves()[n] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new ot(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, n, s) {
        var l = i || {}, h = l.type, d = l.factor, m = this.getPrevious(), _ = this.getNext(), b = (m || this)._point, x = this._point, T = (_ || this)._point, E = b.getDistance(x), L = x.getDistance(T);
        if (!h || h === "catmull-rom") {
          var A = d === t ? 0.5 : d, U = Math.pow(E, A), k = U * U, F = Math.pow(L, A), B = F * F;
          if (!n && m) {
            var R = 2 * B + 3 * F * U + k, C = 3 * F * (F + U);
            this.setHandleIn(C !== 0 ? new M(
              (B * b._x + R * x._x - k * T._x) / C - x._x,
              (B * b._y + R * x._y - k * T._y) / C - x._y
            ) : new M());
          }
          if (!s && _) {
            var R = 2 * k + 3 * U * F + B, C = 3 * U * (U + F);
            this.setHandleOut(C !== 0 ? new M(
              (k * T._x + R * x._x - B * b._x) / C - x._x,
              (k * T._y + R * x._y - B * b._y) / C - x._y
            ) : new M());
          }
        } else if (h === "geometric") {
          if (m && _) {
            var P = b.subtract(T), H = d === t ? 0.4 : d, W = H * E / (E + L);
            n || this.setHandleIn(P.multiply(W)), s || this.setHandleOut(P.multiply(W - H));
          }
        } else
          throw new Error("Smoothing method '" + h + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, n = this._handleOut, s = i.clone();
        i.set(n), n.set(s);
      },
      reversed: function() {
        return new ue(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new ue(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, n, s) {
        var l = 1 - s, h = s, d = i._point, m = n._point, _ = i._handleIn, b = n._handleIn, x = n._handleOut, T = i._handleOut;
        this._point._set(
          l * d._x + h * m._x,
          l * d._y + h * m._y,
          !0
        ), this._handleIn._set(
          l * _._x + h * b._x,
          l * _._y + h * b._y,
          !0
        ), this._handleOut._set(
          l * T._x + h * x._x,
          l * T._y + h * x._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, n, s) {
        var l = this._point, h = !s || !this._handleIn.isZero() ? this._handleIn : null, d = !s || !this._handleOut.isZero() ? this._handleOut : null, m = l._x, _ = l._y, b = 2;
        return n[0] = m, n[1] = _, h && (n[b++] = h._x + m, n[b++] = h._y + _), d && (n[b++] = d._x + m, n[b++] = d._y + _), i && (i._transformCoordinates(n, n, b / 2), m = n[0], _ = n[1], s ? (l._x = m, l._y = _, b = 2, h && (h._x = n[b++] - m, h._y = n[b++] - _), d && (d._x = n[b++] - m, d._y = n[b++] - _)) : (h || (n[b++] = m, n[b++] = _), d || (n[b++] = m, n[b++] = _))), n;
      }
    }), yt = M.extend({
      initialize: function(n, s, l) {
        var h, d, m;
        if (!n)
          h = d = 0;
        else if ((h = n[0]) !== t)
          d = n[1];
        else {
          var _ = n;
          (h = _.x) === t && (_ = M.read(arguments), h = _.x), d = _.y, m = _.selected;
        }
        this._x = h, this._y = d, this._owner = s, s[l] = this, m && this.setSelected(!0);
      },
      _set: function(i, n) {
        return this._x = i, this._y = n, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = D.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), Ue = a.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(n, s, l, h, d, m, _, b) {
          var x = arguments.length, T, E, L, A, U, k;
          x === 3 ? (this._path = n, T = s, E = l) : x ? x === 1 ? "segment1" in n ? (T = new ue(n.segment1), E = new ue(n.segment2)) : "point1" in n ? (L = n.point1, U = n.handle1, k = n.handle2, A = n.point2) : Array.isArray(n) && (L = [n[0], n[1]], A = [n[6], n[7]], U = [n[2] - n[0], n[3] - n[1]], k = [n[4] - n[6], n[5] - n[7]]) : x === 2 ? (T = new ue(n), E = new ue(s)) : x === 4 ? (L = n, U = s, k = l, A = h) : x === 8 && (L = [n, s], A = [_, b], U = [l - n, h - s], k = [d - _, m - b]) : (T = new ue(), E = new ue()), this._segment1 = T || new ue(L, null, U), this._segment2 = E || new ue(A, k, null);
        },
        _serialize: function(i, n) {
          return a.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            n
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new Ue(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return Ue.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var n = this._segment2, s = n._handleOut;
            i = n.remove(), i && this._segment1._handleOut.set(s);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(M.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(M.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(M.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(M.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return Ue.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), n = [], s = 0; s < 8; s += 2)
            n.push(new M(i[s], i[s + 1]));
          return n;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = Ue.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return Ue.getArea(this.getValues());
        },
        getLine: function() {
          return new he(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, n) {
          return new Ue(Ue.getPart(this.getValues(), i, n));
        },
        getPartLength: function(i, n) {
          return Ue.getLength(this.getValues(), i, n);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, n) {
          var s = 1e-8, l = 1 - s, h = null;
          if (i >= s && i <= l) {
            var d = Ue.subdivide(this.getValues(), i), m = d[0], _ = d[1], b = n || this.hasHandles(), x = this._segment1, T = this._segment2, E = this._path;
            b && (x._handleOut._set(m[2] - m[0], m[3] - m[1]), T._handleIn._set(_[4] - _[6], _[5] - _[7]));
            var L = m[6], A = m[7], U = new ue(
              new M(L, A),
              b && new M(m[4] - L, m[5] - A),
              b && new M(_[2] - L, _[3] - A)
            );
            E ? (E.insert(x._index + 1, U), h = this.getNext()) : (this._segment2 = U, this._changed(), h = new Ue(U, T));
          }
          return h;
        },
        splitAt: function(i) {
          var n = this._path;
          return n ? n.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, n) {
          return this.divideAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        split: function(i, n) {
          return this.splitAtTime(i === t ? 0.5 : n ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new Ue(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, n, s, l) {
            var h = i._point, d = i._handleOut, m = n._handleIn, _ = n._point, b = h.x, x = h.y, T = _.x, E = _.y, L = l ? [b, x, b, x, T, E, T, E] : [
              b,
              x,
              b + d._x,
              x + d._y,
              T + m._x,
              E + m._y,
              T,
              E
            ];
            return s && s._transformCoordinates(L, L, 4), L;
          },
          subdivide: function(i, n) {
            var s = i[0], l = i[1], h = i[2], d = i[3], m = i[4], _ = i[5], b = i[6], x = i[7];
            n === t && (n = 0.5);
            var T = 1 - n, E = T * s + n * h, L = T * l + n * d, A = T * h + n * m, U = T * d + n * _, k = T * m + n * b, F = T * _ + n * x, B = T * E + n * A, R = T * L + n * U, C = T * A + n * k, P = T * U + n * F, H = T * B + n * C, W = T * R + n * P;
            return [
              [s, l, E, L, B, R, H, W],
              [H, W, C, P, k, F, b, x]
            ];
          },
          getMonoCurves: function(i, n) {
            var s = [], l = n ? 0 : 1, h = i[l + 0], d = i[l + 2], m = i[l + 4], _ = i[l + 6];
            if (h >= d == d >= m && d >= m == m >= _ || Ue.isStraight(i))
              s.push(i);
            else {
              var b = 3 * (d - m) - h + _, x = 2 * (h + m) - 4 * d, T = d - h, E = 1e-8, L = 1 - E, A = [], U = D.solveQuadratic(b, x, T, A, E, L);
              if (!U)
                s.push(i);
              else {
                A.sort();
                var k = A[0], F = Ue.subdivide(i, k);
                s.push(F[0]), U > 1 && (k = (A[1] - k) / (1 - k), F = Ue.subdivide(F[1], k), s.push(F[0])), s.push(F[1]);
              }
            }
            return s;
          },
          solveCubic: function(i, n, s, l, h, d) {
            var m = i[n], _ = i[n + 2], b = i[n + 4], x = i[n + 6], T = 0;
            if (!(m < s && x < s && _ < s && b < s || m > s && x > s && _ > s && b > s)) {
              var E = 3 * (_ - m), L = 3 * (b - _) - E, A = x - m - E - L;
              T = D.solveCubic(A, L, E, m - s, l, h, d);
            }
            return T;
          },
          getTimeOf: function(i, n) {
            var s = new M(i[0], i[1]), l = new M(i[6], i[7]), h = 1e-12, d = 1e-7, m = n.isClose(s, h) ? 0 : n.isClose(l, h) ? 1 : null;
            if (m === null)
              for (var _ = [n.x, n.y], b = [], x = 0; x < 2; x++)
                for (var T = Ue.solveCubic(i, x, _[x], b, 0, 1), E = 0; E < T; E++) {
                  var L = b[E];
                  if (n.isClose(Ue.getPoint(i, L), d))
                    return L;
                }
            return n.isClose(s, d) ? 0 : n.isClose(l, d) ? 1 : null;
          },
          getNearestTime: function(i, n) {
            if (Ue.isStraight(i)) {
              var s = i[0], l = i[1], h = i[6], d = i[7], m = h - s, _ = d - l, b = m * m + _ * _;
              if (b === 0)
                return 0;
              var x = ((n.x - s) * m + (n.y - l) * _) / b;
              return x < 1e-12 ? 0 : x > 0.999999999999 ? 1 : Ue.getTimeOf(
                i,
                new M(s + x * m, l + x * _)
              );
            }
            var T = 100, E = 1 / 0, L = 0;
            function A(F) {
              if (F >= 0 && F <= 1) {
                var B = n.getDistance(Ue.getPoint(i, F), !0);
                if (B < E)
                  return E = B, L = F, !0;
              }
            }
            for (var U = 0; U <= T; U++)
              A(U / T);
            for (var k = 1 / (T * 2); k > 1e-8; )
              !A(L - k) && !A(L + k) && (k /= 2);
            return L;
          },
          getPart: function(i, n, s) {
            var l = n > s;
            if (l) {
              var h = n;
              n = s, s = h;
            }
            return n > 0 && (i = Ue.subdivide(i, n)[1]), s < 1 && (i = Ue.subdivide(i, (s - n) / (1 - n))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, n) {
            var s = i[0], l = i[1], h = i[2], d = i[3], m = i[4], _ = i[5], b = i[6], x = i[7], T = 3 * h - 2 * s - b, E = 3 * d - 2 * l - x, L = 3 * m - 2 * b - s, A = 3 * _ - 2 * x - l;
            return Math.max(T * T, L * L) + Math.max(E * E, A * A) <= 16 * n * n;
          },
          getArea: function(i) {
            var n = i[0], s = i[1], l = i[2], h = i[3], d = i[4], m = i[5], _ = i[6], b = i[7];
            return 3 * ((b - s) * (l + d) - (_ - n) * (h + m) + h * (n - d) - l * (s - m) + b * (d + n / 3) - _ * (m + s / 3)) / 20;
          },
          getBounds: function(i) {
            for (var n = i.slice(0, 2), s = n.slice(), l = [0, 0], h = 0; h < 2; h++)
              Ue._addBounds(
                i[h],
                i[h + 2],
                i[h + 4],
                i[h + 6],
                h,
                0,
                n,
                s,
                l
              );
            return new G(n[0], n[1], s[0] - n[0], s[1] - n[1]);
          },
          _addBounds: function(i, n, s, l, h, d, m, _, b) {
            function x(H, W) {
              var V = H - W, Q = H + W;
              V < m[h] && (m[h] = V), Q > _[h] && (_[h] = Q);
            }
            d /= 2;
            var T = m[h] + d, E = _[h] - d;
            if (i < T || n < T || s < T || l < T || i > E || n > E || s > E || l > E)
              if (n < i != n < l && s < i != s < l)
                x(i, 0), x(l, 0);
              else {
                var L = 3 * (n - s) - i + l, A = 2 * (i + s) - 4 * n, U = n - i, k = D.solveQuadratic(L, A, U, b), F = 1e-8, B = 1 - F;
                x(l, 0);
                for (var R = 0; R < k; R++) {
                  var C = b[R], P = 1 - C;
                  F <= C && C <= B && x(
                    P * P * P * i + 3 * P * P * C * n + 3 * P * C * C * s + C * C * C * l,
                    d
                  );
                }
              }
          }
        }
      },
      a.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var n = this._bounds[i];
            return n || (n = this._bounds[i] = it[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), n.clone();
          };
        },
        {}
      ),
      a.each({
        isStraight: function(i, n, s, l) {
          if (n.isZero() && s.isZero())
            return !0;
          var h = l.subtract(i);
          if (h.isZero())
            return !1;
          if (h.isCollinear(n) && h.isCollinear(s)) {
            var d = new he(i, l), m = 1e-7;
            if (d.getDistance(i.add(n)) < m && d.getDistance(l.add(s)) < m) {
              var _ = h.dot(h), b = h.dot(n) / _, x = h.dot(s) / _;
              return b >= 0 && b <= 1 && x <= 0 && x >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, n, s, l) {
          var h = l.subtract(i).divide(3);
          return n.equals(h) && s.negate().equals(h);
        }
      }, function(i, n) {
        this[n] = function(s) {
          var l = this._segment1, h = this._segment2;
          return i(
            l._point,
            l._handleOut,
            h._handleIn,
            h._point,
            s
          );
        }, this.statics[n] = function(s, l) {
          var h = s[0], d = s[1], m = s[6], _ = s[7];
          return i(
            new M(h, d),
            new M(s[2] - h, s[3] - d),
            new M(s[4] - m, s[5] - _),
            new M(m, _),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, n) {
          return this.getLocationAtTime(
            n ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new ot(this, i) : null;
        },
        getTimeAt: function(i, n) {
          return Ue.getTimeAt(this.getValues(), i, n);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = M.read(arguments);
          return i.isZero() ? [] : Ue.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return Ue.getTimeOf(this.getValues(), M.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = M.read(arguments), n = this.getValues(), s = Ue.getNearestTime(n, i), l = Ue.getPoint(n, s);
          return new ot(this, s, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return a.each(
          i,
          function(n) {
            this[n + "At"] = function(s, l) {
              var h = this.getValues();
              return Ue[n](h, l ? s : Ue.getTimeAt(h, s));
            }, this[n + "AtTime"] = function(s) {
              return Ue[n](this.getValues(), s);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var h = l[0], d = l[1], m = l[2], _ = l[3], b = l[4], x = l[5], T = l[6], E = l[7], L = 9 * (m - b) + 3 * (T - h), A = 6 * (h + b) - 12 * m, U = 3 * (m - h), k = 9 * (_ - x) + 3 * (E - d), F = 6 * (d + x) - 12 * _, B = 3 * (_ - d);
          return function(R) {
            var C = (L * R + A) * R + U, P = (k * R + F) * R + B;
            return Math.sqrt(C * C + P * P);
          };
        }
        function n(l, h) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(h - l) * 32)));
        }
        function s(l, h, d, m) {
          if (h == null || h < 0 || h > 1)
            return null;
          var _ = l[0], b = l[1], x = l[2], T = l[3], E = l[4], L = l[5], A = l[6], U = l[7], k = D.isZero;
          k(x - _) && k(T - b) && (x = _, T = b), k(E - A) && k(L - U) && (E = A, L = U);
          var F = 3 * (x - _), B = 3 * (E - x) - F, R = A - _ - F - B, C = 3 * (T - b), P = 3 * (L - T) - C, H = U - b - C - P, W, V;
          if (d === 0)
            W = h === 0 ? _ : h === 1 ? A : ((R * h + B) * h + F) * h + _, V = h === 0 ? b : h === 1 ? U : ((H * h + P) * h + C) * h + b;
          else {
            var Q = 1e-8, ae = 1 - Q;
            if (h < Q ? (W = F, V = C) : h > ae ? (W = 3 * (A - E), V = 3 * (U - L)) : (W = (3 * R * h + 2 * B) * h + F, V = (3 * H * h + 2 * P) * h + C), m) {
              W === 0 && V === 0 && (h < Q || h > ae) && (W = E - x, V = L - T);
              var le = Math.sqrt(W * W + V * V);
              le && (W /= le, V /= le);
            }
            if (d === 3) {
              var E = 6 * R * h + 2 * B, L = 6 * H * h + 2 * P, fe = Math.pow(W * W + V * V, 3 / 2);
              W = fe !== 0 ? (W * L - V * E) / fe : 0, V = 0;
            }
          }
          return d === 2 ? new M(V, -W) : new M(W, V);
        }
        return { statics: {
          classify: function(l) {
            var h = l[0], d = l[1], m = l[2], _ = l[3], b = l[4], x = l[5], T = l[6], E = l[7], L = h * (E - x) + d * (b - T) + T * x - E * b, A = m * (d - E) + _ * (T - h) + h * E - d * T, U = b * (_ - d) + x * (h - m) + m * d - _ * h, k = 3 * U, F = k - A, B = F - A + L, R = Math.sqrt(B * B + F * F + k * k), C = R !== 0 ? 1 / R : 0, P = D.isZero, H = "serpentine";
            B *= C, F *= C, k *= C;
            function W(le, fe, se) {
              var ge = fe !== t, me = ge && fe > 0 && fe < 1, we = ge && se > 0 && se < 1;
              return ge && (!(me || we) || le === "loop" && !(me && we)) && (le = "arch", me = we = !1), {
                type: le,
                roots: me || we ? me && we ? fe < se ? [fe, se] : [se, fe] : [me ? fe : se] : null
              };
            }
            if (P(B))
              return P(F) ? W(P(k) ? "line" : "quadratic") : W(H, k / (3 * F));
            var V = 3 * F * F - 4 * B * k;
            if (P(V))
              return W("cusp", F / (2 * B));
            var Q = V > 0 ? Math.sqrt(V / 3) : Math.sqrt(-V), ae = 2 * B;
            return W(
              V > 0 ? H : "loop",
              (F + Q) / ae,
              (F - Q) / ae
            );
          },
          getLength: function(l, h, d, m) {
            if (h === t && (h = 0), d === t && (d = 1), Ue.isStraight(l)) {
              var _ = l;
              d < 1 && (_ = Ue.subdivide(_, d)[0], h /= d), h > 0 && (_ = Ue.subdivide(_, h)[1]);
              var b = _[6] - _[0], x = _[7] - _[1];
              return Math.sqrt(b * b + x * x);
            }
            return D.integrate(
              m || i(l),
              h,
              d,
              n(h, d)
            );
          },
          getTimeAt: function(l, h, d) {
            if (d === t && (d = h < 0 ? 1 : 0), h === 0)
              return d;
            var m = Math.abs, _ = 1e-12, b = h > 0, x = b ? d : 0, T = b ? 1 : d, E = i(l), L = Ue.getLength(l, x, T, E), A = m(h) - L;
            if (m(A) < _)
              return b ? T : x;
            if (A > _)
              return null;
            var U = h / L, k = 0;
            function F(B) {
              return k += D.integrate(
                E,
                d,
                B,
                n(d, B)
              ), d = B, k - h;
            }
            return D.findRoot(
              F,
              E,
              d + U,
              x,
              T,
              32,
              1e-12
            );
          },
          getPoint: function(l, h) {
            return s(l, h, 0, !1);
          },
          getTangent: function(l, h) {
            return s(l, h, 1, !0);
          },
          getWeightedTangent: function(l, h) {
            return s(l, h, 1, !1);
          },
          getNormal: function(l, h) {
            return s(l, h, 2, !0);
          },
          getWeightedNormal: function(l, h) {
            return s(l, h, 2, !1);
          },
          getCurvature: function(l, h) {
            return s(l, h, 3, !1).x;
          },
          getPeaks: function(l) {
            var h = l[0], d = l[1], m = l[2], _ = l[3], b = l[4], x = l[5], T = l[6], E = l[7], L = -h + 3 * m - 3 * b + T, A = 3 * h - 6 * m + 3 * b, U = -3 * h + 3 * m, k = -d + 3 * _ - 3 * x + E, F = 3 * d - 6 * _ + 3 * x, B = -3 * d + 3 * _, R = 1e-8, C = 1 - R, P = [];
            return D.solveCubic(
              9 * (L * L + k * k),
              9 * (L * A + F * k),
              2 * (A * A + F * F) + 3 * (U * L + B * k),
              U * A + F * B,
              P,
              R,
              C
            ), P.sort();
          }
        } };
      }(),
      new function() {
        function i(A, U, k, F, B, R, C) {
          var P = !C && k.getPrevious() === B, H = !C && k !== B && k.getNext() === B, W = 1e-8, V = 1 - W;
          if (F !== null && F >= (P ? W : 0) && F <= (H ? V : 1) && R !== null && R >= (H ? W : 0) && R <= (P ? V : 1)) {
            var Q = new ot(k, F, null, C), ae = new ot(B, R, null, C);
            Q._intersection = ae, ae._intersection = Q, (!U || U(Q)) && ot.insert(A, Q, !0);
          }
        }
        function n(A, U, k, F, B, R, C, P, H, W, V, Q, ae) {
          if (++H >= 4096 || ++P >= 40)
            return H;
          var le = 1e-9, fe = U[0], se = U[1], ge = U[6], me = U[7], we = he.getSignedDistance, Se = we(fe, se, ge, me, U[2], U[3]), Ae = we(fe, se, ge, me, U[4], U[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, Je = Ge * Math.min(0, Se, Ae), tt = Ge * Math.max(0, Se, Ae), ft = we(fe, se, ge, me, A[0], A[1]), Ne = we(fe, se, ge, me, A[2], A[3]), ze = we(fe, se, ge, me, A[4], A[5]), nt = we(fe, se, ge, me, A[6], A[7]), _t = s(ft, Ne, ze, nt), mt = _t[0], Pt = _t[1], Et, zt;
          if (Se === 0 && Ae === 0 && ft === 0 && Ne === 0 && ze === 0 && nt === 0 || (Et = l(mt, Pt, Je, tt)) == null || (zt = l(
            mt.reverse(),
            Pt.reverse(),
            Je,
            tt
          )) == null)
            return H;
          var jt = W + (V - W) * Et, Ft = W + (V - W) * zt;
          if (Math.max(ae - Q, Ft - jt) < le) {
            var Mi = (jt + Ft) / 2, Rt = (Q + ae) / 2;
            i(
              B,
              R,
              C ? F : k,
              C ? Rt : Mi,
              C ? k : F,
              C ? Mi : Rt
            );
          } else {
            A = Ue.getPart(A, Et, zt);
            var hi = ae - Q;
            if (zt - Et > 0.8)
              if (Ft - jt > hi) {
                var ci = Ue.subdivide(A, 0.5), Mi = (jt + Ft) / 2;
                H = n(
                  U,
                  ci[0],
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Q,
                  ae,
                  jt,
                  Mi
                ), H = n(
                  U,
                  ci[1],
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Q,
                  ae,
                  Mi,
                  Ft
                );
              } else {
                var ci = Ue.subdivide(U, 0.5), Rt = (Q + ae) / 2;
                H = n(
                  ci[0],
                  A,
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Q,
                  Rt,
                  jt,
                  Ft
                ), H = n(
                  ci[1],
                  A,
                  F,
                  k,
                  B,
                  R,
                  !C,
                  P,
                  H,
                  Rt,
                  ae,
                  jt,
                  Ft
                );
              }
            else
              hi === 0 || hi >= le ? H = n(
                U,
                A,
                F,
                k,
                B,
                R,
                !C,
                P,
                H,
                Q,
                ae,
                jt,
                Ft
              ) : H = n(
                A,
                U,
                k,
                F,
                B,
                R,
                C,
                P,
                H,
                jt,
                Ft,
                Q,
                ae
              );
          }
          return H;
        }
        function s(A, U, k, F) {
          var B = [0, A], R = [1 / 3, U], C = [2 / 3, k], P = [1, F], H = U - (2 * A + F) / 3, W = k - (A + 2 * F) / 3, V;
          if (H * W < 0)
            V = [[B, R, P], [B, C, P]];
          else {
            var Q = H / W;
            V = [
              Q >= 2 ? [B, R, P] : Q <= 0.5 ? [B, C, P] : [B, R, C, P],
              [B, P]
            ];
          }
          return (H || W) < 0 ? V.reverse() : V;
        }
        function l(A, U, k, F) {
          return A[0][1] < k ? h(A, !0, k) : U[0][1] > F ? h(U, !1, F) : A[0][0];
        }
        function h(A, U, k) {
          for (var F = A[0][0], B = A[0][1], R = 1, C = A.length; R < C; R++) {
            var P = A[R][0], H = A[R][1];
            if (U ? H >= k : H <= k)
              return H === k ? P : F + (k - B) * (P - F) / (H - B);
            F = P, B = H;
          }
          return null;
        }
        function d(A, U, k, F, B) {
          var R = D.isZero;
          if (R(F) && R(B)) {
            var C = Ue.getTimeOf(A, new M(U, k));
            return C === null ? [] : [C];
          }
          for (var P = Math.atan2(-B, F), H = Math.sin(P), W = Math.cos(P), V = [], Q = [], ae = 0; ae < 8; ae += 2) {
            var le = A[ae] - U, fe = A[ae + 1] - k;
            V.push(
              le * W - fe * H,
              le * H + fe * W
            );
          }
          return Ue.solveCubic(V, 1, 0, Q, 0, 1), Q;
        }
        function m(A, U, k, F, B, R, C) {
          for (var P = U[0], H = U[1], W = U[6], V = U[7], Q = d(A, P, H, W - P, V - H), ae = 0, le = Q.length; ae < le; ae++) {
            var fe = Q[ae], se = Ue.getPoint(A, fe), ge = Ue.getTimeOf(U, se);
            ge !== null && i(
              B,
              R,
              C ? F : k,
              C ? ge : fe,
              C ? k : F,
              C ? fe : ge
            );
          }
        }
        function _(A, U, k, F, B, R) {
          var C = he.intersect(
            A[0],
            A[1],
            A[6],
            A[7],
            U[0],
            U[1],
            U[6],
            U[7]
          );
          C && i(
            B,
            R,
            k,
            Ue.getTimeOf(A, C),
            F,
            Ue.getTimeOf(U, C)
          );
        }
        function b(A, U, k, F, B, R) {
          var C = 1e-12, P = Math.min, H = Math.max;
          if (H(A[0], A[2], A[4], A[6]) + C > P(U[0], U[2], U[4], U[6]) && P(A[0], A[2], A[4], A[6]) - C < H(U[0], U[2], U[4], U[6]) && H(A[1], A[3], A[5], A[7]) + C > P(U[1], U[3], U[5], U[7]) && P(A[1], A[3], A[5], A[7]) - C < H(U[1], U[3], U[5], U[7])) {
            var W = E(A, U);
            if (W)
              for (var V = 0; V < 2; V++) {
                var Q = W[V];
                i(
                  B,
                  R,
                  k,
                  Q[0],
                  F,
                  Q[1],
                  !0
                );
              }
            else {
              var ae = Ue.isStraight(A), le = Ue.isStraight(U), fe = ae && le, se = ae && !le, ge = B.length;
              if ((fe ? _ : ae || le ? m : n)(
                se ? U : A,
                se ? A : U,
                se ? F : k,
                se ? k : F,
                B,
                R,
                se,
                0,
                0,
                0,
                1,
                0,
                1
              ), !fe || B.length === ge)
                for (var V = 0; V < 4; V++) {
                  var me = V >> 1, we = V & 1, Se = me * 6, Ae = we * 6, Ge = new M(A[Se], A[Se + 1]), Je = new M(U[Ae], U[Ae + 1]);
                  Ge.isClose(Je, C) && i(
                    B,
                    R,
                    k,
                    me,
                    F,
                    we
                  );
                }
            }
          }
          return B;
        }
        function x(A, U, k, F) {
          var B = Ue.classify(A);
          if (B.type === "loop") {
            var R = B.roots;
            i(
              k,
              F,
              U,
              R[0],
              U,
              R[1]
            );
          }
          return k;
        }
        function T(A, U, k, F, B, R) {
          var C = 1e-7, P = !U;
          P && (U = A);
          for (var H = A.length, W = U.length, V = new Array(H), Q = P ? V : new Array(W), ae = [], le = 0; le < H; le++)
            V[le] = A[le].getValues(F);
          if (!P)
            for (var le = 0; le < W; le++)
              Q[le] = U[le].getValues(B);
          for (var fe = S.findCurveBoundsCollisions(
            V,
            Q,
            C
          ), se = 0; se < H; se++) {
            var ge = A[se], me = V[se];
            P && x(me, ge, ae, k);
            var we = fe[se];
            if (we)
              for (var Se = 0; Se < we.length; Se++) {
                if (R && ae.length)
                  return ae;
                var Ae = we[Se];
                if (!P || Ae > se) {
                  var Ge = U[Ae], Je = Q[Ae];
                  b(
                    me,
                    Je,
                    ge,
                    Ge,
                    ae,
                    k
                  );
                }
              }
          }
          return ae;
        }
        function E(A, U) {
          function k(nt) {
            var _t = nt[6] - nt[0], mt = nt[7] - nt[1];
            return _t * _t + mt * mt;
          }
          var F = Math.abs, B = he.getDistance, R = 1e-8, C = 1e-7, P = Ue.isStraight(A), H = Ue.isStraight(U), W = P && H, V = k(A) < k(U), Q = V ? U : A, ae = V ? A : U, le = Q[0], fe = Q[1], se = Q[6] - le, ge = Q[7] - fe;
          if (B(le, fe, se, ge, ae[0], ae[1], !0) < C && B(le, fe, se, ge, ae[6], ae[7], !0) < C)
            !W && B(le, fe, se, ge, Q[2], Q[3], !0) < C && B(le, fe, se, ge, Q[4], Q[5], !0) < C && B(le, fe, se, ge, ae[2], ae[3], !0) < C && B(le, fe, se, ge, ae[4], ae[5], !0) < C && (P = H = W = !0);
          else if (W)
            return null;
          if (P ^ H)
            return null;
          for (var me = [A, U], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
            var Ae = Se & 1, Ge = Ae ^ 1, Je = Se >> 1, tt = Ue.getTimeOf(me[Ae], new M(
              me[Ge][Je ? 6 : 0],
              me[Ge][Je ? 7 : 1]
            ));
            if (tt != null) {
              var ft = Ae ? [Je, tt] : [tt, Je];
              (!we.length || F(ft[0] - we[0][0]) > R && F(ft[1] - we[0][1]) > R) && we.push(ft);
            }
            if (Se > 2 && !we.length)
              break;
          }
          if (we.length !== 2)
            we = null;
          else if (!W) {
            var Ne = Ue.getPart(A, we[0][0], we[1][0]), ze = Ue.getPart(U, we[0][1], we[1][1]);
            (F(ze[2] - Ne[2]) > C || F(ze[3] - Ne[3]) > C || F(ze[4] - Ne[4]) > C || F(ze[5] - Ne[5]) > C) && (we = null);
          }
          return we;
        }
        function L(A, U) {
          var k = A[0], F = A[1], B = A[2], R = A[3], C = A[4], P = A[5], H = A[6], W = A[7], V = U.normalize(), Q = V.x, ae = V.y, le = 3 * H - 9 * C + 9 * B - 3 * k, fe = 3 * W - 9 * P + 9 * R - 3 * F, se = 6 * C - 12 * B + 6 * k, ge = 6 * P - 12 * R + 6 * F, me = 3 * B - 3 * k, we = 3 * R - 3 * F, Se = 2 * le * ae - 2 * fe * Q, Ae = [];
          if (Math.abs(Se) < D.CURVETIME_EPSILON) {
            var Ge = le * we - fe * me, Se = le * ge - fe * se;
            if (Se != 0) {
              var Je = -Ge / Se;
              Je >= 0 && Je <= 1 && Ae.push(Je);
            }
          } else {
            var tt = (se * se - 4 * le * me) * ae * ae + (-2 * se * ge + 4 * fe * me + 4 * le * we) * Q * ae + (ge * ge - 4 * fe * we) * Q * Q, ft = se * ae - ge * Q;
            if (tt >= 0 && Se != 0) {
              var Ne = Math.sqrt(tt), ze = -(ft + Ne) / Se, nt = (-ft + Ne) / Se;
              ze >= 0 && ze <= 1 && Ae.push(ze), nt >= 0 && nt <= 1 && Ae.push(nt);
            }
          }
          return Ae;
        }
        return {
          getIntersections: function(A) {
            var U = this.getValues(), k = A && A !== this && A.getValues();
            return k ? b(U, k, this, A, []) : x(U, this, []);
          },
          statics: {
            getOverlaps: E,
            getIntersections: T,
            getCurveLineIntersections: d,
            getTimesWithTangent: L
          }
        };
      }()
    ), ot = a.extend(
      {
        _class: "CurveLocation",
        initialize: function(n, s, l, h, d) {
          if (s >= 0.99999999) {
            var m = n.getNext();
            m && (s = 0, n = m);
          }
          this._setCurve(n), this._time = s, this._point = l || n.getPointAtTime(s), this._overlap = h, this._distance = d, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var n = i.getCurve();
          n ? this._setCurve(n) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var n = this.getCurve(), s = this.getTime();
            s === 0 ? i = n._segment1 : s === 1 ? i = n._segment2 : s != null && (i = n.getPartLength(0, s) < n.getPartLength(s, 1) ? n._segment1 : n._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, n = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function s(l) {
            var h = l && l.getCurve();
            if (h && (n._time = h.getTimeOf(n._point)) != null)
              return n._setCurve(h), h;
          }
          return this._curve || s(this._segment) || s(this._segment1) || s(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), n = this._time;
          return i && n == null ? this._time = i.getTimeOf(this._point) : n;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var n = this.getPath(), s = this.getIndex();
            if (n && s != null)
              for (var l = n.getCurves(), h = 0; h < s; h++)
                i += l[h].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var n = this.getCurve(), s = this.getTime();
            this._curveOffset = i = s != null && n && n.getPartLength(0, s);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), n = i && i.divideAtTime(this.getTime());
          return n && this._setSegment(n._segment1), n;
        },
        split: function() {
          var i = this.getCurve(), n = i._path, s = i && i.splitAtTime(this.getTime());
          return s && this._setSegment(n.getLastSegment()), s;
        },
        equals: function(i, n) {
          var s = this === i;
          if (!s && i instanceof ot) {
            var l = this.getCurve(), h = i.getCurve(), d = l._path, m = h._path;
            if (d === m) {
              var _ = Math.abs, b = 1e-7, x = _(this.getOffset() - i.getOffset()), T = !n && this._intersection, E = !n && i._intersection;
              s = (x < b || d && _(d.getLength() - x) < b) && (!T && !E || T && E && T.equals(E, !0));
            }
          }
          return s;
        },
        toString: function() {
          var i = [], n = this.getPoint(), s = I.instance;
          n && i.push("point: " + n);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var h = this.getTime();
          return h != null && i.push("time: " + s.number(h)), this._distance != null && i.push("distance: " + s.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var n = this.getCurve(), s = i.getCurve();
            return !(n.isStraight() && s.isStraight() && n.getLine().intersect(s.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var n = this.getTime(), s = i.getTime(), l = 1e-8, h = 1 - l, d = n >= l && n <= h, m = s >= l && s <= h;
          if (d && m)
            return !this.isTouching();
          var _ = this.getCurve(), b = _ && n < l ? _.getPrevious() : _, x = i.getCurve(), T = x && s < l ? x.getPrevious() : x;
          if (n > h && (_ = _.getNext()), s > h && (x = x.getNext()), !b || !_ || !T || !x)
            return !1;
          var E = [];
          function L(Q, ae) {
            var le = Q.getValues(), fe = Ue.classify(le).roots || Ue.getPeaks(le), se = fe.length, ge = Ue.getLength(
              le,
              ae && se ? fe[se - 1] : 0,
              !ae && se ? fe[0] : 1
            );
            E.push(se ? ge : ge / 32);
          }
          function A(Q, ae, le) {
            return ae < le ? Q > ae && Q < le : Q > ae || Q < le;
          }
          d || (L(b, !0), L(_, !1)), m || (L(T, !0), L(x, !1));
          var U = this.getPoint(), k = Math.min.apply(Math, E), F = d ? _.getTangentAtTime(n) : _.getPointAt(k).subtract(U), B = d ? F.negate() : b.getPointAt(-k).subtract(U), R = m ? x.getTangentAtTime(s) : x.getPointAt(k).subtract(U), C = m ? R.negate() : T.getPointAt(-k).subtract(U), P = B.getAngle(), H = F.getAngle(), W = C.getAngle(), V = R.getAngle();
          return !!(d ? A(P, W, V) ^ A(H, W, V) && A(P, V, W) ^ A(H, V, W) : A(W, P, H) ^ A(V, P, H) && A(W, H, P) ^ A(V, H, P));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      a.each(Ue._evaluateMethods, function(i) {
        var n = i + "At";
        this[i] = function() {
          var s = this.getCurve(), l = this.getTime();
          return l != null && s && s[n](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(n, s, l) {
          var h = n.length, d = 0, m = h - 1;
          function _(U, k) {
            for (var F = U + k; F >= -1 && F <= h; F += k) {
              var B = n[(F % h + h) % h];
              if (!s.getPoint().isClose(
                B.getPoint(),
                1e-7
              ))
                break;
              if (s.equals(B))
                return B;
            }
            return null;
          }
          for (; d <= m; ) {
            var b = d + m >>> 1, x = n[b], T;
            if (l && (T = s.equals(x) ? x : _(b, -1) || _(b, 1)))
              return s._overlap && (T._overlap = T._intersection._overlap = !0), T;
            var E = s.getPath(), L = x.getPath(), A = E !== L ? E._id - L._id : s.getIndex() + s.getTime() - (x.getIndex() + x.getTime());
            A < 0 ? m = b - 1 : d = b + 1;
          }
          return n.splice(d, 0, s), s;
        }
        return { statics: {
          insert: i,
          expand: function(n) {
            for (var s = n.slice(), l = n.length - 1; l >= 0; l--)
              i(s, n[l]._intersection, !1);
            return s;
          }
        } };
      }()
    ), Gt = K.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var n, s, l;
          if (a.isPlainObject(i) ? (s = i.segments, n = i.pathData) : Array.isArray(i) ? s = i : typeof i == "string" && (n = i), s) {
            var h = s[0];
            l = h && Array.isArray(h[0]);
          } else
            n && (l = (n.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(n));
          var d = l ? Zt : it;
          return new d(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var n = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), s, l = !1, h, d, m = new M(), _ = new M();
        function b(C, P) {
          var H = +s[C];
          return l && (H += m[P]), H;
        }
        function x(C) {
          return new M(
            b(C, "x"),
            b(C + 1, "y")
          );
        }
        this.clear();
        for (var T = 0, E = n && n.length; T < E; T++) {
          var L = n[T], A = L[0], U = A.toLowerCase();
          s = L.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var k = s && s.length;
          switch (l = A === U, h === "z" && !/[mz]/.test(U) && this.moveTo(m), U) {
            case "m":
            case "l":
              for (var F = U === "m", B = 0; B < k; B += 2)
                this[F ? "moveTo" : "lineTo"](m = x(B)), F && (_ = m, F = !1);
              d = m;
              break;
            case "h":
            case "v":
              var R = U === "h" ? "x" : "y";
              m = m.clone();
              for (var B = 0; B < k; B++)
                m[R] = b(B, R), this.lineTo(m);
              d = m;
              break;
            case "c":
              for (var B = 0; B < k; B += 6)
                this.cubicCurveTo(
                  x(B),
                  d = x(B + 2),
                  m = x(B + 4)
                );
              break;
            case "s":
              for (var B = 0; B < k; B += 4)
                this.cubicCurveTo(
                  /[cs]/.test(h) ? m.multiply(2).subtract(d) : m,
                  d = x(B),
                  m = x(B + 2)
                ), h = U;
              break;
            case "q":
              for (var B = 0; B < k; B += 4)
                this.quadraticCurveTo(
                  d = x(B),
                  m = x(B + 2)
                );
              break;
            case "t":
              for (var B = 0; B < k; B += 2)
                this.quadraticCurveTo(
                  d = /[qt]/.test(h) ? m.multiply(2).subtract(d) : m,
                  m = x(B)
                ), h = U;
              break;
            case "a":
              for (var B = 0; B < k; B += 7)
                this.arcTo(
                  m = x(B + 5),
                  new Y(+s[B], +s[B + 1]),
                  +s[B + 2],
                  +s[B + 4],
                  +s[B + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), m = _;
              break;
          }
          h = U;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var n = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return n.onPath || !!(this.getFillRule() === "evenodd" ? n.windingL & 1 || n.windingR & 1 : n.winding);
      },
      getIntersections: function(i, n, s, l) {
        var h = this === i || !i, d = this._matrix._orNullIfIdentity(), m = h ? d : (s || i._matrix)._orNullIfIdentity();
        return h || this.getBounds(d).intersects(
          i.getBounds(m),
          1e-12
        ) ? Ue.getIntersections(
          this.getCurves(),
          !h && i.getCurves(),
          n,
          d,
          m,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(n) {
          return n.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = M.read(arguments), n = this.getCurves(), s = 1 / 0, l = null, h = 0, d = n.length; h < d; h++) {
          var m = n[h].getNearestLocation(i);
          m._distance < s && (s = m._distance, l = m);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, n, s) {
        var l = !this._children, h = l ? "_segments" : "_children", d = i[h], m = n[h], _ = this[h];
        if (!d || !m || d.length !== m.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + n);
        var b = _.length, x = m.length;
        if (b < x)
          for (var T = l ? ue : it, E = b; E < x; E++)
            this.add(new T());
        else
          b > x && this[l ? "removeSegments" : "removeChildren"](x, b);
        for (var E = 0; E < x; E++)
          _[E].interpolate(d[E], m[E], s);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var n = !1;
        if (i) {
          var s = this._children || [this], l = i._children ? i._children.slice() : [i], h = s.length, d = l.length, m = [], _ = 0;
          n = !0;
          for (var b = S.findItemBoundsCollisions(s, l, D.GEOMETRIC_EPSILON), x = h - 1; x >= 0 && n; x--) {
            var T = s[x];
            n = !1;
            var E = b[x];
            if (E)
              for (var L = E.length - 1; L >= 0 && !n; L--)
                T.compare(l[E[L]]) && (m[E[L]] || (m[E[L]] = !0, _++), n = !0);
          }
          n = n && _ === d;
        }
        return n;
      }
    }), it = Gt.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(n) {
          this._closed = !1, this._segments = [], this._version = 0;
          var s = arguments, l = Array.isArray(n) ? typeof n[0] == "object" ? n : s : n && n.size === t && (n.x !== t || n.point !== t) ? s : null;
          l && l.length > 0 ? this.setSegments(l) : (this._curves = t, this._segmentSelection = 0, !l && typeof n == "string" && (this.setPathData(n), n = null)), this._initialize(!l && n);
        },
        _equals: function(i) {
          return this._closed === i._closed && a.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(n) {
          if (i.base.call(this, n), n & 8) {
            if (this._length = this._area = t, n & 32)
              this._version++;
            else if (this._curves)
              for (var s = 0, l = this._curves.length; s < l; s++)
                this._curves[s]._changed();
          } else
            n & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof Zt ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var n = this.isFullySelected(), s = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, s) {
            var l = i[s - 1];
            typeof l == "boolean" && (this.setClosed(l), s--), this._add(ue.readList(i, 0, {}, s));
          }
          n && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, n = this._segments;
          if (!i) {
            var s = this._countCurves();
            i = this._curves = new Array(s);
            for (var l = 0; l < s; l++)
              i[l] = new Ue(
                this,
                n[l],
                n[l + 1] || n[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var n = this._curves.length = this._countCurves();
              i && (this._curves[n - 1] = new Ue(
                this,
                this._segments[n - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, n) {
          var s = this._segments, l = s.length, h = new I(n), d = new Array(6), m = !0, _, b, x, T, E, L, A, U, k = [];
          function F(R, C) {
            if (R._transformCoordinates(i, d), _ = d[0], b = d[1], m)
              k.push("M" + h.pair(_, b)), m = !1;
            else if (E = d[2], L = d[3], E === _ && L === b && A === x && U === T) {
              if (!C) {
                var P = _ - x, H = b - T;
                k.push(
                  P === 0 ? "v" + h.number(H) : H === 0 ? "h" + h.number(P) : "l" + h.pair(P, H)
                );
              }
            } else
              k.push("c" + h.pair(A - x, U - T) + " " + h.pair(E - x, L - T) + " " + h.pair(_ - x, b - T));
            x = _, T = b, A = d[4], U = d[5];
          }
          if (!l)
            return "";
          for (var B = 0; B < l; B++)
            F(s[B]);
          return this._closed && l > 0 && (F(s[0], !0), k.push("z")), k.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var n = this._segments, s = new Array(6), l = 0, h = n.length; l < h; l++)
            n[l]._transformCoordinates(i, s, !0);
          return !0;
        },
        _add: function(i, m) {
          for (var s = this._segments, l = this._curves, h = i.length, d = m == null, m = d ? s.length : m, _ = 0; _ < h; _++) {
            var b = i[_];
            b._path && (b = i[_] = b.clone()), b._path = this, b._index = m + _, b._selection && this._updateSelection(b, 0, b._selection);
          }
          if (d)
            a.push(s, i);
          else {
            s.splice.apply(s, [m, 0].concat(i));
            for (var _ = m + h, x = s.length; _ < x; _++)
              s[_]._index = _;
          }
          if (l) {
            var T = this._countCurves(), E = m > 0 && m + h - 1 === T ? m - 1 : m, L = E, A = Math.min(E + h, T);
            i._curves && (l.splice.apply(l, [E, 0].concat(i._curves)), L += i._curves.length);
            for (var _ = L; _ < A; _++)
              l.splice(_, 0, new Ue(this, null, null));
            this._adjustCurves(E, A);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, n) {
          for (var s = this._segments, l = this._curves, h, d = i; d < n; d++)
            h = l[d], h._path = this, h._segment1 = s[d], h._segment2 = s[d + 1] || s[0], h._changed();
          (h = l[this._closed && !i ? s.length - 1 : i - 1]) && (h._segment2 = s[i] || s[0], h._changed()), (h = l[n]) && (h._segment1 = s[n], h._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var n = arguments;
          return n.length > 1 && typeof i != "number" ? this._add(ue.readList(n)) : this._add([ue.read(n)])[0];
        },
        insert: function(i, n) {
          var s = arguments;
          return s.length > 2 && typeof n != "number" ? this._add(ue.readList(s, 1), i) : this._add([ue.read(s, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([ue.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([ue.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(ue.readList(i));
        },
        insertSegments: function(i, n) {
          return this._add(ue.readList(n), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, n, s) {
          i = i || 0, n = a.pick(n, this._segments.length);
          var l = this._segments, h = this._curves, d = l.length, m = l.splice(i, n - i), _ = m.length;
          if (!_)
            return m;
          for (var b = 0; b < _; b++) {
            var x = m[b];
            x._selection && this._updateSelection(x, x._selection, 0), x._index = x._path = null;
          }
          for (var b = i, T = l.length; b < T; b++)
            l[b]._index = b;
          if (h) {
            for (var E = i > 0 && n === d + (this._closed ? 1 : 0) ? i - 1 : i, h = h.splice(E, _), b = h.length - 1; b >= 0; b--)
              h[b]._path = null;
            s && (m._curves = h.slice(1)), this._adjustCurves(E, E);
          }
          return this._changed(41), m;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, n = 0, s = i.length; n < s; n++)
            if (i[n].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, n = 0, s = i.length; n < s; n++)
            i[n].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), n = 0, s = 0, l = i.length; s < l; s++)
              n += i[s].getLength();
            this._length = n;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var n = this._segments, s = this._closed;
            i = 0;
            for (var l = 0, h = n.length; l < h; l++) {
              var d = l + 1 === h;
              i += Ue.getArea(Ue.getValues(
                n[l],
                n[d ? 0 : l + 1],
                null,
                d && !s
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(n) {
          n & 1 || this._selectSegments(!1), i.base.call(this, n);
        },
        _selectSegments: function(i) {
          var n = this._segments, s = n.length, l = i ? 7 : 0;
          this._segmentSelection = l * s;
          for (var h = 0; h < s; h++)
            n[h]._selection = l;
        },
        _updateSelection: function(i, n, s) {
          i._selection = s;
          var l = this._segmentSelection += s - n;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var n = this.getLocationAt(i), s;
          return n && (s = n.getCurve().divideAt(n.getCurveOffset())) ? s._segment1 : null;
        },
        splitAt: function(i) {
          var n = this.getLocationAt(i), s = n && n.index, l = n && n.time, h = 1e-8, d = 1 - h;
          l > d && (s++, l = 0);
          var m = this.getCurves();
          if (s >= 0 && s < m.length) {
            l >= h && m[s++].divideAtTime(l);
            var _ = this.removeSegments(s, this._segments.length, !0), b;
            return this._closed ? (this.setClosed(!1), b = this) : (b = new it(K.NO_INSERT), b.insertAbove(this), b.copyAttributes(this)), b._add(_, 0), this.addSegment(_[0]), b;
          }
          return null;
        },
        split: function(i, n) {
          var s, l = n === t ? i : (s = this.getCurves()[i]) && s.getLocationAtTime(n);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, n) {
          var s = n || 0;
          if (i && i !== this) {
            var l = i._segments, h = this.getLastSegment(), d = i.getLastSegment();
            if (!d)
              return this;
            h && h._point.isClose(d._point, s) && i.reverse();
            var m = i.getFirstSegment();
            if (h && h._point.isClose(m._point, s))
              h.setHandleOut(m._handleOut), this._add(l.slice(1));
            else {
              var _ = this.getFirstSegment();
              _ && _._point.isClose(m._point, s) && i.reverse(), d = i.getLastSegment(), _ && _._point.isClose(d._point, s) ? (_.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var b = this.getFirstSegment(), x = this.getLastSegment();
          return b !== x && b._point.isClose(x._point, s) && (b.setHandleIn(x._handleIn), x.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var n = this.getCurves(), s = i && i.simplify, l = s ? 1e-7 : 0, h = n.length - 1; h >= 0; h--) {
            var d = n[h];
            !d.hasHandles() && (!d.hasLength(l) || s && d.isCollinear(d.getNext())) && d.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, n = this._segments.length; i < n; i++) {
            var s = this._segments[i], l = s._handleIn;
            s._handleIn = s._handleOut, s._handleOut = l, s._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var n = new ct(this, i || 0.25, 256, !0), s = n.parts, l = s.length, h = [], d = 0; d < l; d++)
            h.push(new ue(s[d].curve.slice(0, 2)));
          !this._closed && l > 0 && h.push(new ue(s[l - 1].curve.slice(6))), this.setSegments(h);
        },
        simplify: function(i) {
          var n = new lt(this).fit(i || 2.5);
          return n && this.setSegments(n), !!n;
        },
        smooth: function(i) {
          var n = this, s = i || {}, l = s.type || "asymmetric", h = this._segments, d = h.length, m = this._closed;
          function _(mt, Pt) {
            var Et = mt && mt.index;
            if (Et != null) {
              var zt = mt.path;
              if (zt && zt !== n)
                throw new Error(mt._class + " " + Et + " of " + zt + " is not part of " + n);
              Pt && mt instanceof Ue && Et++;
            } else
              Et = typeof mt == "number" ? mt : Pt;
            return Math.min(Et < 0 && m ? Et % d : Et < 0 ? Et + d : Et, d - 1);
          }
          var b = m && s.from === t && s.to === t, x = _(s.from, 0), T = _(s.to, d - 1);
          if (x > T)
            if (m)
              x -= d;
            else {
              var E = x;
              x = T, T = E;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var L = l === "asymmetric", A = Math.min, U = T - x + 1, k = U - 1, F = b ? A(U, 4) : 1, B = F, R = F, C = [];
            if (m || (B = A(1, x), R = A(1, d - T - 1)), k += B + R, k <= 1)
              return;
            for (var P = 0, H = x - B; P <= k; P++, H++)
              C[P] = h[(H < 0 ? H + d : H) % d]._point;
            for (var W = C[0]._x + 2 * C[1]._x, V = C[0]._y + 2 * C[1]._y, Q = 2, ae = k - 1, le = [W], fe = [V], se = [Q], ge = [], me = [], P = 1; P < k; P++) {
              var we = P < ae, Se = we || L ? 1 : 2, Ae = we ? 4 : L ? 2 : 7, Ge = we ? 4 : L ? 3 : 8, Je = we ? 2 : L ? 0 : 1, tt = Se / Q;
              Q = se[P] = Ae - tt, W = le[P] = Ge * C[P]._x + Je * C[P + 1]._x - tt * W, V = fe[P] = Ge * C[P]._y + Je * C[P + 1]._y - tt * V;
            }
            ge[ae] = le[ae] / se[ae], me[ae] = fe[ae] / se[ae];
            for (var P = k - 2; P >= 0; P--)
              ge[P] = (le[P] - ge[P + 1]) / se[P], me[P] = (fe[P] - me[P + 1]) / se[P];
            ge[k] = (3 * C[k]._x - ge[ae]) / 2, me[k] = (3 * C[k]._y - me[ae]) / 2;
            for (var P = B, ft = k - R, H = x; P <= ft; P++, H++) {
              var Ne = h[H < 0 ? H + d : H], ze = Ne._point, nt = ge[P] - ze._x, _t = me[P] - ze._y;
              (b || P < ft) && Ne.setHandleOut(nt, _t), (b || P > B) && Ne.setHandleIn(-nt, -_t);
            }
          } else
            for (var P = x; P <= T; P++)
              h[P < 0 ? P + d : P].smooth(
                s,
                !b && P === x,
                !b && P === T
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var n = this._segments, s, l, h, d;
          function m(L, A) {
            var U = n[L], k = U.getNext(), F = n[A], B = F.getNext();
            return U._handleOut.isZero() && k._handleIn.isZero() && F._handleOut.isZero() && B._handleIn.isZero() && k._point.subtract(U._point).isCollinear(
              B._point.subtract(F._point)
            );
          }
          function _(L) {
            var A = n[L], U = A.getPrevious(), k = A.getNext();
            return U._handleOut.isZero() && A._handleIn.isZero() && A._handleOut.isZero() && k._handleIn.isZero() && A._point.subtract(U._point).isOrthogonal(
              k._point.subtract(A._point)
            );
          }
          function b(L) {
            var A = n[L], U = A.getNext(), k = A._handleOut, F = U._handleIn, B = 0.5522847498307936;
            if (k.isOrthogonal(F)) {
              var R = A._point, C = U._point, P = new he(R, k, !0).intersect(
                new he(C, F, !0),
                !0
              );
              return P && D.isZero(k.getLength() / P.subtract(R).getLength() - B) && D.isZero(F.getLength() / P.subtract(C).getLength() - B);
            }
            return !1;
          }
          function x(L, A) {
            return n[L]._point.getDistance(n[A]._point);
          }
          if (!this.hasHandles() && n.length === 4 && m(0, 2) && m(1, 3) && _(1) ? (s = ke.Rectangle, l = new Y(x(0, 3), x(0, 1)), d = n[1]._point.add(n[2]._point).divide(2)) : n.length === 8 && b(0) && b(2) && b(4) && b(6) && m(1, 5) && m(3, 7) ? (s = ke.Rectangle, l = new Y(x(1, 6), x(0, 3)), h = l.subtract(new Y(
            x(0, 7),
            x(1, 2)
          )).divide(2), d = n[3]._point.add(n[4]._point).divide(2)) : n.length === 4 && b(0) && b(1) && b(2) && b(3) && (D.isZero(x(0, 2) - x(1, 3)) ? (s = ke.Circle, h = x(0, 2) / 2) : (s = ke.Ellipse, h = new Y(x(2, 0) / 2, x(3, 1) / 2)), d = n[1]._point), s) {
            var T = this.getPosition(!0), E = new s({
              center: T,
              size: l,
              radius: h,
              insert: !1
            });
            return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(T).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(n) {
          if (!n || n instanceof Zt)
            return i.base.call(this, n);
          var s = this.getCurves(), l = n.getCurves(), h = s.length, d = l.length;
          if (!h || !d)
            return h == d;
          for (var m = s[0].getValues(), _ = [], b = 0, x, T = 0, E, L = 0; L < d; L++) {
            var F = l[L].getValues();
            _.push(F);
            var A = Ue.getOverlaps(m, F);
            if (A) {
              x = !L && A[0][0] > 0 ? d - 1 : L, E = A[0][1];
              break;
            }
          }
          for (var U = Math.abs, k = 1e-8, F = _[x], B; m && F; ) {
            var A = Ue.getOverlaps(m, F);
            if (A) {
              var R = A[0][0];
              if (U(R - T) < k) {
                T = A[1][0], T === 1 && (m = ++b < h ? s[b].getValues() : null, T = 0);
                var C = A[0][1];
                if (U(C - E) < k) {
                  if (B || (B = [x, C]), E = A[1][1], E === 1 && (++x >= d && (x = 0), F = _[x] || l[x].getValues(), E = 0), !m)
                    return B[0] === x && B[1] === E;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, n, s, l) {
          var h = this, d = this.getStyle(), m = this._segments, _ = m.length, b = this._closed, x = n._tolerancePadding, T = x, E, L, A, U, k, F, B = n.stroke && d.hasStroke(), R = n.fill && d.hasFill(), C = n.curves, P = B ? d.getStrokeWidth() / 2 : R && n.tolerance > 0 || C ? 0 : null;
          P !== null && (P > 0 ? (E = d.getStrokeJoin(), L = d.getStrokeCap(), A = d.getMiterLimit(), T = T.add(
            it._getStrokePadding(P, l)
          )) : E = L = "round");
          function H(ge, me) {
            return i.subtract(ge).divide(me).length <= 1;
          }
          function W(ge, me, we) {
            if (!n.selected || me.isSelected()) {
              var Se = ge._point;
              if (me !== Se && (me = me.add(Se)), H(me, T))
                return new Xe(we, h, {
                  segment: ge,
                  point: me
                });
            }
          }
          function V(ge, me) {
            return (me || n.segments) && W(ge, ge._point, "segment") || !me && n.handles && (W(ge, ge._handleIn, "handle-in") || W(ge, ge._handleOut, "handle-out"));
          }
          function Q(ge) {
            U.add(ge);
          }
          function ae(ge) {
            var me = b || ge._index > 0 && ge._index < _ - 1;
            if ((me ? E : L) === "round")
              return H(ge._point, T);
            if (U = new it({ internal: !0, closed: !0 }), me ? ge.isSmooth() || it._addBevelJoin(
              ge,
              E,
              P,
              A,
              null,
              l,
              Q,
              !0
            ) : L === "square" && it._addSquareCap(
              ge,
              L,
              P,
              null,
              l,
              Q,
              !0
            ), !U.isEmpty()) {
              var we;
              return U.contains(i) || (we = U.getNearestLocation(i)) && H(we.getPoint(), x);
            }
          }
          if (n.ends && !n.segments && !b) {
            if (F = V(m[0], !0) || V(m[_ - 1], !0))
              return F;
          } else if (n.segments || n.handles) {
            for (var le = 0; le < _; le++)
              if (F = V(m[le]))
                return F;
          }
          if (P !== null) {
            if (k = this.getNearestLocation(i), k) {
              var fe = k.getTime();
              fe === 0 || fe === 1 && _ > 1 ? ae(k.getSegment()) || (k = null) : H(k.getPoint(), T) || (k = null);
            }
            if (!k && E === "miter" && _ > 1)
              for (var le = 0; le < _; le++) {
                var se = m[le];
                if (i.getDistance(se._point) <= A * P && ae(se)) {
                  k = se.getLocation();
                  break;
                }
              }
          }
          return !k && R && this._contains(i) || k && !B && !C ? new Xe("fill", this) : k ? new Xe(B ? "stroke" : "curve", this, {
            location: k,
            point: k.getPoint()
          }) : null;
        }
      },
      a.each(
        Ue._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var s = this.getLocationAt(n);
            return s && s[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = M.read(arguments), n = this.getCurves(), s = 0, l = n.length; s < l; s++) {
              var h = n[s].getLocationOf(i);
              if (h)
                return h;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var n = this.getCurves(), s = 0, l = 0, h = n.length; l < h; l++) {
                var d = s, m = n[l];
                if (s += m.getLength(), s > i)
                  return m.getLocationAt(i - d);
              }
              if (n.length > 0 && i <= this.getLength())
                return new ot(n[n.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = M.read(arguments);
            if (i.isZero())
              return [];
            for (var n = [], s = 0, l = this.getCurves(), h = 0, d = l.length; h < d; h++) {
              for (var m = l[h], _ = m.getTimesWithTangent(i), b = 0, x = _.length; b < x; b++) {
                var T = s + m.getOffsetAtTime(_[b]);
                n.indexOf(T) < 0 && n.push(T);
              }
              s += m.length;
            }
            return n;
          }
        }
      ),
      new function() {
        function i(s, l, h, d) {
          if (d <= 0)
            return;
          var m = d / 2, _ = d - 2, b = m - 1, x = new Array(6), T, E;
          function L(R) {
            var C = x[R], P = x[R + 1];
            (T != C || E != P) && (s.beginPath(), s.moveTo(T, E), s.lineTo(C, P), s.stroke(), s.beginPath(), s.arc(C, P, m, 0, Math.PI * 2, !0), s.fill());
          }
          for (var A = 0, U = l.length; A < U; A++) {
            var k = l[A], F = k._selection;
            if (k._transformCoordinates(h, x), T = x[0], E = x[1], F & 2 && L(2), F & 4 && L(4), s.fillRect(T - m, E - m, d, d), _ > 0 && !(F & 1)) {
              var B = s.fillStyle;
              s.fillStyle = "#ffffff", s.fillRect(T - b, E - b, _, _), s.fillStyle = B;
            }
          }
        }
        function n(s, l, h) {
          var d = l._segments, m = d.length, _ = new Array(6), b = !0, x, T, E, L, A, U, k, F;
          function B(C) {
            if (h)
              C._transformCoordinates(h, _), x = _[0], T = _[1];
            else {
              var P = C._point;
              x = P._x, T = P._y;
            }
            if (b)
              s.moveTo(x, T), b = !1;
            else {
              if (h)
                A = _[2], U = _[3];
              else {
                var H = C._handleIn;
                A = x + H._x, U = T + H._y;
              }
              A === x && U === T && k === E && F === L ? s.lineTo(x, T) : s.bezierCurveTo(k, F, A, U, x, T);
            }
            if (E = x, L = T, h)
              k = _[4], F = _[5];
            else {
              var H = C._handleOut;
              k = E + H._x, F = L + H._y;
            }
          }
          for (var R = 0; R < m; R++)
            B(d[R]);
          l._closed && m > 0 && B(d[0]);
        }
        return {
          _draw: function(s, l, h, d) {
            var m = l.dontStart, _ = l.dontFinish || l.clip, b = this.getStyle(), x = b.hasFill(), T = b.hasStroke(), E = b.getDashArray(), L = !He.support.nativeDash && T && E && E.length;
            m || s.beginPath(), (x || T && !L || _) && (n(s, this, d), this._closed && s.closePath());
            function A(C) {
              return E[(C % L + L) % L];
            }
            if (!_ && (x || T) && (this._setStyles(s, l, h), x && (s.fill(b.getFillRule()), s.shadowColor = "rgba(0,0,0,0)"), T)) {
              if (L) {
                m || s.beginPath();
                for (var U = new ct(
                  this,
                  0.25,
                  32,
                  !1,
                  d
                ), k = U.length, F = -b.getDashOffset(), B, R = 0; F > 0; )
                  F -= A(R--) + A(R--);
                for (; F < k; )
                  B = F + A(R++), (F > 0 || B > 0) && U.drawPart(
                    s,
                    Math.max(F, 0),
                    Math.max(B, 0)
                  ), F = B + A(R++);
              }
              s.stroke();
            }
          },
          _drawSelected: function(s, l) {
            s.beginPath(), n(s, this, l), s.stroke(), i(s, this._segments, l, He.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(n) {
          var s = n._segments;
          if (!s.length)
            throw new Error("Use a moveTo() command first");
          return s[s.length - 1];
        }
        return {
          moveTo: function() {
            var n = this._segments;
            n.length === 1 && this.removeSegment(0), n.length || this._add([new ue(M.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new ue(M.read(arguments))]);
          },
          cubicCurveTo: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = M.read(n), d = i(this);
            d.setHandleOut(s.subtract(d._point)), this._add([new ue(h, l.subtract(h))]);
          },
          quadraticCurveTo: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = i(this)._point;
            this.cubicCurveTo(
              s.add(h.subtract(s).multiply(1 / 3)),
              s.add(l.subtract(s).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = a.pick(a.read(n), 0.5), d = 1 - h, m = i(this)._point, _ = s.subtract(m.multiply(d * d)).subtract(l.multiply(h * h)).divide(2 * h * d);
            if (_.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + h
              );
            this.quadraticCurveTo(_, l);
          },
          arcTo: function() {
            var n = arguments, s = Math.abs, l = Math.sqrt, h = i(this), d = h._point, m = M.read(n), _, b = a.peek(n), x = a.pick(b, !0), T, E, L, A;
            if (typeof x == "boolean")
              var U = d.add(m).divide(2), _ = U.add(U.subtract(d).rotate(
                x ? -90 : 90
              ));
            else if (a.remain(n) <= 2)
              _ = m, m = M.read(n);
            else if (!d.equals(m)) {
              var k = Y.read(n), F = D.isZero;
              if (F(k.width) || F(k.height))
                return this.lineTo(m);
              var B = a.read(n), x = !!a.read(n), R = !!a.read(n), U = d.add(m).divide(2), C = d.subtract(U).rotate(-B), P = C.x, H = C.y, W = s(k.width), V = s(k.height), Q = W * W, ae = V * V, le = P * P, fe = H * H, se = l(le / Q + fe / ae);
              if (se > 1 && (W *= se, V *= se, Q = W * W, ae = V * V), se = (Q * ae - Q * fe - ae * le) / (Q * fe + ae * le), s(se) < 1e-12 && (se = 0), se < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              T = new M(W * H / V, -V * P / W).multiply((R === x ? -1 : 1) * l(se)).rotate(B).add(U), A = new J().translate(T).rotate(B).scale(W, V), L = A._inverseTransform(d), E = L.getDirectedAngle(A._inverseTransform(m)), !x && E > 0 ? E -= 360 : x && E < 0 && (E += 360);
            }
            if (_) {
              var ge = new he(
                d.add(_).divide(2),
                _.subtract(d).rotate(90),
                !0
              ), me = new he(
                _.add(m).divide(2),
                m.subtract(_).rotate(90),
                !0
              ), we = new he(d, m), Se = we.getSide(_);
              if (T = ge.intersect(me, !0), !T) {
                if (!Se)
                  return this.lineTo(m);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              L = d.subtract(T), E = L.getDirectedAngle(m.subtract(T));
              var Ae = we.getSide(T, !0);
              Ae === 0 ? E = Se * s(E) : Se === Ae && (E += E < 0 ? 360 : -360);
            }
            if (E) {
              for (var Ge = 1e-5, Je = s(E), tt = Je >= 360 ? 4 : Math.ceil((Je - Ge) / 90), ft = E / tt, Ne = ft * Math.PI / 360, ze = 4 / 3 * Math.sin(Ne) / (1 + Math.cos(Ne)), nt = [], _t = 0; _t <= tt; _t++) {
                var C = m, mt = null;
                if (_t < tt && (mt = L.rotate(90).multiply(ze), A ? (C = A._transformPoint(L), mt = A._transformPoint(L.add(mt)).subtract(C)) : C = T.add(L)), !_t)
                  h.setHandleOut(mt);
                else {
                  var Pt = L.rotate(-90).multiply(ze);
                  A && (Pt = A._transformPoint(L.add(Pt)).subtract(C)), nt.push(new ue(C, Pt, mt));
                }
                L = L.rotate(ft);
              }
              this._add(nt);
            }
          },
          lineBy: function() {
            var n = M.read(arguments), s = i(this)._point;
            this.lineTo(s.add(n));
          },
          curveBy: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = a.read(n), d = i(this)._point;
            this.curveTo(d.add(s), d.add(l), h);
          },
          cubicCurveBy: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = M.read(n), d = i(this)._point;
            this.cubicCurveTo(
              d.add(s),
              d.add(l),
              d.add(h)
            );
          },
          quadraticCurveBy: function() {
            var n = arguments, s = M.read(n), l = M.read(n), h = i(this)._point;
            this.quadraticCurveTo(h.add(s), h.add(l));
          },
          arcBy: function() {
            var n = arguments, s = i(this)._point, l = s.add(M.read(n)), h = a.pick(a.peek(n), !0);
            typeof h == "boolean" ? this.arcTo(l, h) : this.arcTo(l, s.add(M.read(n)));
          },
          closePath: function(n) {
            this.setClosed(!0), this.join(this, n);
          }
        };
      }(),
      {
        _getBounds: function(i, n) {
          var s = n.handle ? "getHandleBounds" : n.stroke ? "getStrokeBounds" : "getBounds";
          return it[s](this._segments, this._closed, this, i, n);
        },
        statics: {
          getBounds: function(i, n, s, l, h, d) {
            var m = i[0];
            if (!m)
              return new G();
            var _ = new Array(6), b = m._transformCoordinates(l, new Array(6)), x = b.slice(0, 2), T = x.slice(), E = new Array(2);
            function L(k) {
              k._transformCoordinates(l, _);
              for (var F = 0; F < 2; F++)
                Ue._addBounds(
                  b[F],
                  b[F + 4],
                  _[F + 2],
                  _[F],
                  F,
                  d ? d[F] : 0,
                  x,
                  T,
                  E
                );
              var B = b;
              b = _, _ = B;
            }
            for (var A = 1, U = i.length; A < U; A++)
              L(i[A]);
            return n && L(m), new G(x[0], x[1], T[0] - x[0], T[1] - x[1]);
          },
          getStrokeBounds: function(i, n, s, l, h) {
            var d = s.getStyle(), m = d.hasStroke(), _ = d.getStrokeWidth(), b = m && s._getStrokeMatrix(l, h), x = m && it._getStrokePadding(
              _,
              b
            ), T = it.getBounds(
              i,
              n,
              s,
              l,
              h,
              x
            );
            if (!m)
              return T;
            var E = _ / 2, L = d.getStrokeJoin(), A = d.getStrokeCap(), U = d.getMiterLimit(), k = new G(new Y(x));
            function F(W) {
              T = T.include(W);
            }
            function B(W) {
              T = T.unite(
                k.setCenter(W._point.transform(l))
              );
            }
            function R(W, V) {
              V === "round" || W.isSmooth() ? B(W) : it._addBevelJoin(
                W,
                V,
                E,
                U,
                l,
                b,
                F
              );
            }
            function C(W, V) {
              V === "round" ? B(W) : it._addSquareCap(
                W,
                V,
                E,
                l,
                b,
                F
              );
            }
            var P = i.length - (n ? 0 : 1);
            if (P > 0) {
              for (var H = 1; H < P; H++)
                R(i[H], L);
              n ? R(i[0], L) : (C(i[0], A), C(i[i.length - 1], A));
            }
            return T;
          },
          _getStrokePadding: function(i, n) {
            if (!n)
              return [i, i];
            var s = new M(i, 0).transform(n), l = new M(0, i).transform(n), h = s.getAngleInRadians(), d = s.getLength(), m = l.getLength(), _ = Math.sin(h), b = Math.cos(h), x = Math.tan(h), T = Math.atan2(m * x, d), E = Math.atan2(m, x * d);
            return [
              Math.abs(d * Math.cos(T) * b + m * Math.sin(T) * _),
              Math.abs(m * Math.sin(E) * b + d * Math.cos(E) * _)
            ];
          },
          _addBevelJoin: function(i, n, s, l, h, d, m, _) {
            var b = i.getCurve(), x = b.getPrevious(), T = b.getPoint1().transform(h), E = x.getNormalAtTime(1).multiply(s).transform(d), L = b.getNormalAtTime(0).multiply(s).transform(d), A = E.getDirectedAngle(L);
            if ((A < 0 || A >= 180) && (E = E.negate(), L = L.negate()), _ && m(T), m(T.add(E)), n === "miter") {
              var U = new he(
                T.add(E),
                new M(-E.y, E.x),
                !0
              ).intersect(new he(
                T.add(L),
                new M(-L.y, L.x),
                !0
              ), !0);
              U && T.getDistance(U) <= l * s && m(U);
            }
            m(T.add(L));
          },
          _addSquareCap: function(i, n, s, l, h, d, m) {
            var _ = i._point.transform(l), b = i.getLocation(), x = b.getNormal().multiply(b.getTime() === 0 ? s : -s).transform(h);
            n === "square" && (m && (d(_.subtract(x)), d(_.add(x))), _ = _.add(x.rotate(-90))), d(_.add(x)), d(_.subtract(x));
          },
          getHandleBounds: function(i, n, s, l, h) {
            var d = s.getStyle(), m = h.stroke && d.hasStroke(), _, b;
            if (m) {
              var x = s._getStrokeMatrix(l, h), T = d.getStrokeWidth() / 2, E = T;
              d.getStrokeJoin() === "miter" && (E = T * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, T * Math.SQRT2)), _ = it._getStrokePadding(T, x), b = it._getStrokePadding(E, x);
            }
            for (var L = new Array(6), A = 1 / 0, U = -A, k = A, F = U, B = 0, R = i.length; B < R; B++) {
              var C = i[B];
              C._transformCoordinates(l, L);
              for (var P = 0; P < 6; P += 2) {
                var H = P ? _ : b, W = H ? H[0] : 0, V = H ? H[1] : 0, Q = L[P], ae = L[P + 1], le = Q - W, fe = Q + W, se = ae - V, ge = ae + V;
                le < A && (A = le), fe > U && (U = fe), se < k && (k = se), ge > F && (F = ge);
              }
            }
            return new G(A, k, U - A, F - k);
          }
        }
      }
    );
    it.inject({ statics: new function() {
      var i = 0.5522847498307936, n = [
        new ue([-1, 0], [0, i], [0, -i]),
        new ue([0, -1], [-i, 0], [i, 0]),
        new ue([1, 0], [0, -i], [0, i]),
        new ue([0, 1], [i, 0], [-i, 0])
      ];
      function s(h, d, m) {
        var _ = a.getNamed(m), b = new it(_ && (_.insert == !0 ? K.INSERT : _.insert == !1 ? K.NO_INSERT : null));
        return b._add(h), b._closed = d, b.set(_, K.INSERT);
      }
      function l(h, d, m) {
        for (var _ = new Array(4), b = 0; b < 4; b++) {
          var x = n[b];
          _[b] = new ue(
            x._point.multiply(d).add(h),
            x._handleIn.multiply(d),
            x._handleOut.multiply(d)
          );
        }
        return s(_, !0, m);
      }
      return {
        Line: function() {
          var h = arguments;
          return s([
            new ue(M.readNamed(h, "from")),
            new ue(M.readNamed(h, "to"))
          ], !1, h);
        },
        Circle: function() {
          var h = arguments, d = M.readNamed(h, "center"), m = a.readNamed(h, "radius");
          return l(d, new Y(m), h);
        },
        Rectangle: function() {
          var h = arguments, d = G.readNamed(h, "rectangle"), m = Y.readNamed(
            h,
            "radius",
            0,
            { readNull: !0 }
          ), _ = d.getBottomLeft(!0), b = d.getTopLeft(!0), x = d.getTopRight(!0), T = d.getBottomRight(!0), E;
          if (!m || m.isZero())
            E = [
              new ue(_),
              new ue(b),
              new ue(x),
              new ue(T)
            ];
          else {
            m = Y.min(m, d.getSize(!0).divide(2));
            var L = m.width, A = m.height, U = L * i, k = A * i;
            E = [
              new ue(_.add(L, 0), null, [-U, 0]),
              new ue(_.subtract(0, A), [0, k]),
              new ue(b.add(0, A), null, [0, -k]),
              new ue(b.add(L, 0), [-U, 0], null),
              new ue(x.subtract(L, 0), null, [U, 0]),
              new ue(x.add(0, A), [0, -k], null),
              new ue(T.subtract(0, A), null, [0, k]),
              new ue(T.subtract(L, 0), [U, 0])
            ];
          }
          return s(E, !0, h);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var h = arguments, d = ke._readEllipse(h);
          return l(d.center, d.radius, h);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var h = arguments, d = M.readNamed(h, "from"), m = M.readNamed(h, "through"), _ = M.readNamed(h, "to"), b = a.getNamed(h), x = new it(b && b.insert == !1 && K.NO_INSERT);
          return x.moveTo(d), x.arcTo(m, _), x.set(b);
        },
        RegularPolygon: function() {
          for (var h = arguments, d = M.readNamed(h, "center"), m = a.readNamed(h, "sides"), _ = a.readNamed(h, "radius"), b = 360 / m, x = m % 3 === 0, T = new M(0, x ? -_ : _), E = x ? -1 : 0.5, L = new Array(m), A = 0; A < m; A++)
            L[A] = new ue(d.add(
              T.rotate((A + E) * b)
            ));
          return s(L, !0, h);
        },
        Star: function() {
          for (var h = arguments, d = M.readNamed(h, "center"), m = a.readNamed(h, "points") * 2, _ = a.readNamed(h, "radius1"), b = a.readNamed(h, "radius2"), x = 360 / m, T = new M(0, -1), E = new Array(m), L = 0; L < m; L++)
            E[L] = new ue(d.add(T.rotate(x * L).multiply(L % 2 ? b : _)));
          return s(E, !0, h);
        }
      };
    }() });
    var Zt = Gt.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(n) {
          this._children = [], this._namedChildren = {}, this._initialize(n) || (typeof n == "string" ? this.setPathData(n) : this.addChildren(Array.isArray(n) ? n : arguments));
        },
        insertChildren: function i(n, s) {
          var l = s, h = l[0];
          h && typeof h[0] == "number" && (l = [l]);
          for (var d = s.length - 1; d >= 0; d--) {
            var m = l[d];
            l === s && !(m instanceof it) && (l = a.slice(l)), Array.isArray(m) ? l[d] = new it({ segments: m, insert: !1 }) : m instanceof Zt && (l.splice.apply(l, [d, 1].concat(m.removeChildren())), m.remove());
          }
          return i.base.call(this, n, l);
        },
        reduce: function i(n) {
          for (var s = this._children, l = s.length - 1; l >= 0; l--) {
            var h = s[l].reduce(n);
            h.isEmpty() && h.remove();
          }
          if (!s.length) {
            var h = new it(K.NO_INSERT);
            return h.copyAttributes(this), h.insertAbove(this), this.remove(), h;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, n = 0, s = i.length; n < s; n++)
            if (!i[n]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var n = this._children, s = 0, l = n.length; s < l; s++)
            n[s].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, n = [], s = 0, l = i.length; s < l; s++)
            a.push(n, i[s].getCurves());
          return n;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, n = 0, s = 0, l = i.length; s < l; s++)
            n += i[s].getArea();
          return n;
        },
        getLength: function() {
          for (var i = this._children, n = 0, s = 0, l = i.length; s < l; s++)
            n += i[s].getLength();
          return n;
        },
        getPathData: function(i, n) {
          for (var s = this._children, l = [], h = 0, d = s.length; h < d; h++) {
            var m = s[h], _ = m._matrix;
            l.push(m.getPathData(i && !_.isIdentity() ? i.appended(_) : i, n));
          }
          return l.join("");
        },
        _hitTestChildren: function i(n, s, l) {
          return i.base.call(
            this,
            n,
            s.class === it || s.type === "path" ? s : a.set({}, s, { fill: !1 }),
            l
          );
        },
        _draw: function(i, n, s, l) {
          var h = this._children;
          if (h.length) {
            n = n.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var d = 0, m = h.length; d < m; d++)
              h[d].draw(i, n, l);
            if (!n.clip) {
              this._setStyles(i, n, s);
              var _ = this._style;
              _.hasFill() && (i.fill(_.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), _.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, n, s) {
          for (var l = this._children, h = 0, d = l.length; h < d; h++) {
            var m = l[h], _ = m._matrix;
            s[m._id] || m._drawSelected(i, _.isIdentity() ? n : n.appended(_));
          }
        }
      },
      new function() {
        function i(n, s) {
          var l = n._children;
          if (s && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return a.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(n) {
            this[n] = function() {
              var s = i(this, !0);
              s[n].apply(s, arguments);
            };
          },
          {
            moveTo: function() {
              var n = i(this), s = n && n.isEmpty() ? n : new it(K.NO_INSERT);
              s !== n && this.addChild(s), s.moveTo.apply(s, arguments);
            },
            moveBy: function() {
              var n = i(this, !0), s = n && n.getLastSegment(), l = M.read(arguments);
              this.moveTo(s ? l.add(s._point) : l);
            },
            closePath: function(n) {
              i(this, !0).closePath(n);
            }
          }
        );
      }(),
      a.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(n) {
          for (var s = this._children, l, h = 0, d = s.length; h < d; h++)
            l = s[h][i](n) || l;
          return l;
        };
      }, {})
    );
    Gt.inject(new function() {
      var i = Math.min, n = Math.max, s = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function h(B) {
        return B._children || [B];
      }
      function d(B, R) {
        var C = B.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (R) {
          for (var P = h(C), H = 0, W = P.length; H < W; H++) {
            var B = P[H];
            !B._closed && !B.isEmpty() && (B.closePath(1e-12), B.getFirstSegment().setHandleIn(0, 0), B.getLastSegment().setHandleOut(0, 0));
          }
          C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
        }
        return C;
      }
      function m(B, R, C, P, H) {
        var W = new Zt(K.NO_INSERT);
        return W.addChildren(B, !0), W = W.reduce({ simplify: R }), H && H.insert == !1 || W.insertAbove(P && C.isSibling(P) && C.getIndex() < P.getIndex() ? P : C), W.copyAttributes(C, !0), W;
      }
      function _(B) {
        return B.hasOverlap() || B.isCrossing();
      }
      function b(B, R, C, P) {
        if (P && (P.trace == !1 || P.stroke) && /^(subtract|intersect)$/.test(C))
          return x(B, R, C);
        var H = d(B, !0), W = R && B !== R && d(R, !0), V = l[C];
        V[C] = !0, W && (V.subtract || V.exclude) ^ (W.isClockwise() ^ H.isClockwise()) && W.reverse();
        var Q = A(ot.expand(
          H.getIntersections(W, _)
        )), ae = h(H), le = W && h(W), fe = [], se = [], ge;
        function me(mt) {
          for (var Pt = 0, Et = mt.length; Pt < Et; Pt++) {
            var zt = mt[Pt];
            a.push(fe, zt._segments), a.push(se, zt.getCurves()), zt._overlapsOnly = !0;
          }
        }
        function we(mt) {
          for (var Pt = [], Et = 0, zt = mt && mt.length; Et < zt; Et++)
            Pt.push(se[mt[Et]]);
          return Pt;
        }
        if (Q.length) {
          me(ae), le && me(le);
          for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
            Se[Ae] = se[Ae].getValues();
          for (var Je = S.findCurveBoundsCollisions(
            Se,
            Se,
            0,
            !0
          ), tt = {}, Ae = 0; Ae < se.length; Ae++) {
            var ft = se[Ae], Ne = ft._path._id, ze = tt[Ne] = tt[Ne] || {};
            ze[ft.getIndex()] = {
              hor: we(Je[Ae].hor),
              ver: we(Je[Ae].ver)
            };
          }
          for (var Ae = 0, Ge = Q.length; Ae < Ge; Ae++)
            k(
              Q[Ae]._segment,
              H,
              W,
              tt,
              V
            );
          for (var Ae = 0, Ge = fe.length; Ae < Ge; Ae++) {
            var nt = fe[Ae], _t = nt._intersection;
            nt._winding || k(
              nt,
              H,
              W,
              tt,
              V
            ), _t && _t._overlap || (nt._path._overlapsOnly = !1);
          }
          ge = F(fe, V);
        } else
          ge = L(
            le ? ae.concat(le) : ae.slice(),
            function(mt) {
              return !!V[mt];
            }
          );
        return m(ge, !0, B, R, P);
      }
      function x(B, R, C) {
        var P = d(B), H = d(R), W = P.getIntersections(H, _), V = C === "subtract", Q = C === "divide", ae = {}, le = [];
        function fe(me) {
          if (!ae[me._id] && (Q || H.contains(me.getPointAt(me.getLength() / 2)) ^ V))
            return le.unshift(me), ae[me._id] = !0;
        }
        for (var se = W.length - 1; se >= 0; se--) {
          var ge = W[se].split();
          ge && (fe(ge) && ge.getFirstSegment().setHandleIn(0, 0), P.getLastSegment().setHandleOut(0, 0));
        }
        return fe(P), m(le, !1, B, R);
      }
      function T(B, R) {
        for (var C = B; C; ) {
          if (C === R)
            return;
          C = C._previous;
        }
        for (; B._next && B._next !== R; )
          B = B._next;
        if (!B._next) {
          for (; R._previous; )
            R = R._previous;
          B._next = R, R._previous = B;
        }
      }
      function E(B) {
        for (var R = B.length - 1; R >= 0; R--)
          B[R].clearHandles();
      }
      function L(B, R, C) {
        var P = B && B.length;
        if (P) {
          var H = a.each(B, function(Je, tt) {
            this[Je._id] = {
              container: null,
              winding: Je.isClockwise() ? 1 : -1,
              index: tt
            };
          }, {}), W = B.slice().sort(function(Je, tt) {
            return s(tt.getArea()) - s(Je.getArea());
          }), V = W[0], Q = S.findItemBoundsCollisions(
            W,
            null,
            D.GEOMETRIC_EPSILON
          );
          C == null && (C = V.isClockwise());
          for (var ae = 0; ae < P; ae++) {
            var le = W[ae], fe = H[le._id], se = 0, ge = Q[ae];
            if (ge) {
              for (var me = null, we = ge.length - 1; we >= 0; we--)
                if (ge[we] < ae) {
                  me = me || le.getInteriorPoint();
                  var Se = W[ge[we]];
                  if (Se.contains(me)) {
                    var Ae = H[Se._id];
                    se = Ae.winding, fe.winding += se, fe.container = Ae.exclude ? Ae.container : Se;
                    break;
                  }
                }
            }
            if (R(fe.winding) === R(se))
              fe.exclude = !0, B[fe.index] = null;
            else {
              var Ge = fe.container;
              le.setClockwise(
                Ge ? !Ge.isClockwise() : C
              );
            }
          }
        }
        return B;
      }
      function A(B, R, C) {
        var P = R && [], H = 1e-8, W = 1 - H, V = !1, Q = C || [], ae = C && {}, le, fe, se;
        function ge(Pt) {
          return Pt._path._id + "." + Pt._segment1._index;
        }
        for (var me = (C && C.length) - 1; me >= 0; me--) {
          var we = C[me];
          we._path && (ae[ge(we)] = !0);
        }
        for (var me = B.length - 1; me >= 0; me--) {
          var Se = B[me], Ae = Se._time, Ge = Ae, Je = R && !R(Se), we = Se._curve, tt;
          if (we && (we !== fe ? (V = !we.hasHandles() || ae && ae[ge(we)], le = [], se = null, fe = we) : se >= H && (Ae /= se)), Je) {
            le && le.push(Se);
            continue;
          } else
            R && P.unshift(Se);
          if (se = Ge, Ae < H)
            tt = we._segment1;
          else if (Ae > W)
            tt = we._segment2;
          else {
            var ft = we.divideAtTime(Ae, !0);
            V && Q.push(we, ft), tt = ft._segment1;
            for (var Ne = le.length - 1; Ne >= 0; Ne--) {
              var ze = le[Ne];
              ze._time = (ze._time - Ae) / (1 - Ae);
            }
          }
          Se._setSegment(tt);
          var nt = tt._intersection, _t = Se._intersection;
          if (nt) {
            T(nt, _t);
            for (var mt = nt; mt; )
              T(mt._intersection, nt), mt = mt._next;
          } else
            tt._intersection = _t;
        }
        return C || E(Q), P || B;
      }
      function U(B, R, C, P, H) {
        var W = Array.isArray(R) ? R : R[C ? "hor" : "ver"], V = C ? 1 : 0, Q = V ^ 1, ae = [B.x, B.y], le = ae[V], fe = ae[Q], se = 1e-9, ge = 1e-6, me = le - se, we = le + se, Se = 0, Ae = 0, Ge = 0, Je = 0, tt = !1, ft = !1, Ne = 1, ze = [], nt, _t;
        function mt(ni) {
          var di = ni[Q + 0], Hi = ni[Q + 6];
          if (!(fe < i(di, Hi) || fe > n(di, Hi))) {
            var xi = ni[V + 0], qi = ni[V + 2], Ti = ni[V + 4], Ci = ni[V + 6];
            if (di === Hi) {
              (xi < we && Ci > me || Ci < we && xi > me) && (tt = !0);
              return;
            }
            var Xi = fe === di ? 0 : fe === Hi || me > n(xi, qi, Ti, Ci) || we < i(xi, qi, Ti, Ci) ? 1 : Ue.solveCubic(ni, Q, fe, ze, 0, 1) > 0 ? ze[0] : 1, Gi = Xi === 0 ? xi : Xi === 1 ? Ci : Ue.getPoint(ni, Xi)[C ? "y" : "x"], Ki = di > Hi ? 1 : -1, un = nt[Q] > nt[Q + 6] ? 1 : -1, nn = nt[V + 6];
            return fe !== di ? (Gi < me ? Ge += Ki : Gi > we ? Je += Ki : tt = !0, Gi > le - ge && Gi < le + ge && (Ne /= 2)) : (Ki !== un ? xi < me ? Ge += Ki : xi > we && (Je += Ki) : xi != nn && (nn < we && Gi > we ? (Je += Ki, tt = !0) : nn > me && Gi < me && (Ge += Ki, tt = !0)), Ne /= 4), nt = ni, !H && Gi > me && Gi < we && Ue.getTangent(ni, Xi)[C ? "x" : "y"] === 0 && U(B, R, !C, P, !0);
          }
        }
        function Pt(ni) {
          var di = ni[Q + 0], Hi = ni[Q + 2], xi = ni[Q + 4], qi = ni[Q + 6];
          if (fe <= n(di, Hi, xi, qi) && fe >= i(di, Hi, xi, qi)) {
            for (var Ti = ni[V + 0], Ci = ni[V + 2], Xi = ni[V + 4], Gi = ni[V + 6], Ki = me > n(Ti, Ci, Xi, Gi) || we < i(Ti, Ci, Xi, Gi) ? [ni] : Ue.getMonoCurves(ni, C), un, nn = 0, Wn = Ki.length; nn < Wn; nn++)
              if (un = mt(Ki[nn]))
                return un;
          }
        }
        for (var Et = 0, zt = W.length; Et < zt; Et++) {
          var jt = W[Et], Ft = jt._path, Mi = jt.getValues(), Rt;
          if ((!Et || W[Et - 1]._path !== Ft) && (nt = null, Ft._closed || (_t = Ue.getValues(
            Ft.getLastCurve().getSegment2(),
            jt.getSegment1(),
            null,
            !P
          ), _t[Q] !== _t[Q + 6] && (nt = _t)), !nt)) {
            nt = Mi;
            for (var hi = Ft.getLastCurve(); hi && hi !== jt; ) {
              var ci = hi.getValues();
              if (ci[Q] !== ci[Q + 6]) {
                nt = ci;
                break;
              }
              hi = hi.getPrevious();
            }
          }
          if (Rt = Pt(Mi))
            return Rt;
          if (Et + 1 === zt || W[Et + 1]._path !== Ft) {
            if (_t && (Rt = Pt(_t)))
              return Rt;
            tt && !Ge && !Je && (Ge = Je = Ft.isClockwise(P) ^ C ? 1 : -1), Se += Ge, Ae += Je, Ge = Je = 0, tt && (ft = !0, tt = !1), _t = null;
          }
        }
        return Se = s(Se), Ae = s(Ae), {
          winding: n(Se, Ae),
          windingL: Se,
          windingR: Ae,
          quality: Ne,
          onPath: ft
        };
      }
      function k(B, R, C, P, H) {
        var W = [], V = B, Q = 0, se;
        do {
          var ae = B.getCurve();
          if (ae) {
            var le = ae.getLength();
            W.push({ segment: B, curve: ae, length: le }), Q += le;
          }
          B = B.getNext();
        } while (B && !B._intersection && B !== V);
        for (var fe = [0.5, 0.25, 0.75], se = { winding: 0, quality: -1 }, ge = 1e-3, me = 1 - ge, we = 0; we < fe.length && se.quality < 0.5; we++)
          for (var le = Q * fe[we], Se = 0, Ae = W.length; Se < Ae; Se++) {
            var Ge = W[Se], Je = Ge.length;
            if (le <= Je) {
              var ae = Ge.curve, tt = ae._path, ft = tt._parent, Ne = ft instanceof Zt ? ft : tt, ze = D.clamp(ae.getTimeAt(le), ge, me), nt = ae.getPointAtTime(ze), _t = s(ae.getTangentAtTime(ze).y) < Math.SQRT1_2, mt = null;
              if (H.subtract && C) {
                var Pt = Ne === R ? C : R, Et = Pt._getWinding(nt, _t, !0);
                if (Ne === R && Et.winding || Ne === C && !Et.winding) {
                  if (Et.quality < 1)
                    continue;
                  mt = { winding: 0, quality: 1 };
                }
              }
              mt = mt || U(
                nt,
                P[tt._id][ae.getIndex()],
                _t,
                !0
              ), mt.quality > se.quality && (se = mt);
              break;
            }
            le -= Je;
          }
        for (var Se = W.length - 1; Se >= 0; Se--)
          W[Se].segment._winding = se;
      }
      function F(B, R) {
        var C = [], P;
        function H(zt) {
          var jt;
          return !!(zt && !zt._visited && (!R || R[(jt = zt._winding || {}).winding] && !(R.unite && jt.winding === 2 && jt.windingL && jt.windingR)));
        }
        function W(zt) {
          if (zt) {
            for (var jt = 0, Ft = P.length; jt < Ft; jt++)
              if (zt === P[jt])
                return !0;
          }
          return !1;
        }
        function V(zt) {
          for (var jt = zt._segments, Ft = 0, Mi = jt.length; Ft < Mi; Ft++)
            jt[Ft]._visited = !0;
        }
        function Q(zt, jt) {
          var Ft = zt._intersection, Mi = Ft, Rt = [];
          jt && (P = [zt]);
          function hi(ci, ni) {
            for (; ci && ci !== ni; ) {
              var di = ci._segment, Hi = di && di._path;
              if (Hi) {
                var xi = di.getNext() || Hi.getFirstSegment(), qi = xi._intersection;
                di !== zt && (W(di) || W(xi) || xi && H(di) && (H(xi) || qi && H(qi._segment))) && Rt.push(di), jt && P.push(di);
              }
              ci = ci._next;
            }
          }
          if (Ft) {
            for (hi(Ft); Ft && Ft._previous; )
              Ft = Ft._previous;
            hi(Ft, Mi);
          }
          return Rt;
        }
        B.sort(function(zt, jt) {
          var Ft = zt._intersection, Mi = jt._intersection, Rt = !!(Ft && Ft._overlap), hi = !!(Mi && Mi._overlap), ci = zt._path, ni = jt._path;
          return Rt ^ hi ? Rt ? 1 : -1 : !Ft ^ !Mi ? Ft ? 1 : -1 : ci !== ni ? ci._id - ni._id : zt._index - jt._index;
        });
        for (var ae = 0, le = B.length; ae < le; ae++) {
          var fe = B[ae], se = H(fe), ge = null, me = !1, we = !0, Se = [], Ae, Ge, Je;
          if (se && fe._path._overlapsOnly) {
            var tt = fe._path, ft = fe._intersection._segment._path;
            tt.compare(ft) && (tt.getArea() && C.push(tt.clone(!1)), V(tt), V(ft), se = !1);
          }
          for (; se; ) {
            var Ne = !ge, ze = Q(fe, Ne), nt = ze.shift(), me = !Ne && (W(fe) || W(nt)), _t = !me && nt;
            if (Ne && (ge = new it(K.NO_INSERT), Ae = null), me) {
              (fe.isFirst() || fe.isLast()) && (we = fe._path._closed), fe._visited = !0;
              break;
            }
            if (_t && Ae && (Se.push(Ae), Ae = null), Ae || (_t && ze.push(fe), Ae = {
              start: ge._segments.length,
              crossings: ze,
              visited: Ge = [],
              handleIn: Je
            }), _t && (fe = nt), !H(fe)) {
              ge.removeSegments(Ae.start);
              for (var mt = 0, Pt = Ge.length; mt < Pt; mt++)
                Ge[mt]._visited = !1;
              Ge.length = 0;
              do
                fe = Ae && Ae.crossings.shift(), (!fe || !fe._path) && (fe = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, Je = Ae.handleIn));
              while (Ae && !H(fe));
              if (!fe)
                break;
            }
            var Et = fe.getNext();
            ge.add(new ue(
              fe._point,
              Je,
              Et && fe._handleOut
            )), fe._visited = !0, Ge.push(fe), fe = Et || fe._path.getFirstSegment(), Je = Et && Et._handleIn;
          }
          me && (we && (ge.getFirstSegment().setHandleIn(Je), ge.setClosed(we)), ge.getArea() !== 0 && C.push(ge));
        }
        return C;
      }
      return {
        _getWinding: function(B, R, C) {
          return U(B, this.getCurves(), R, C);
        },
        unite: function(B, R) {
          return b(this, B, "unite", R);
        },
        intersect: function(B, R) {
          return b(this, B, "intersect", R);
        },
        subtract: function(B, R) {
          return b(this, B, "subtract", R);
        },
        exclude: function(B, R) {
          return b(this, B, "exclude", R);
        },
        divide: function(B, R) {
          return R && (R.trace == !1 || R.stroke) ? x(this, B, "divide") : m([
            this.subtract(B, R),
            this.intersect(B, R)
          ], !0, this, B, R);
        },
        resolveCrossings: function() {
          var B = this._children, R = B || [this];
          function C(Ae, Ge) {
            var Je = Ae && Ae._intersection;
            return Je && Je._overlap && Je._path === Ge;
          }
          var P = !1, H = !1, W = this.getIntersections(null, function(Ae) {
            return Ae.hasOverlap() && (P = !0) || Ae.isCrossing() && (H = !0);
          }), V = P && H && [];
          if (W = ot.expand(W), P)
            for (var Q = A(W, function(Ae) {
              return Ae.hasOverlap();
            }, V), ae = Q.length - 1; ae >= 0; ae--) {
              var le = Q[ae], fe = le._path, se = le._segment, ge = se.getPrevious(), me = se.getNext();
              C(ge, fe) && C(me, fe) && (se.remove(), ge._handleOut._set(0, 0), me._handleIn._set(0, 0), ge !== se && !ge.getCurve().hasLength() && (me._handleIn.set(ge._handleIn), ge.remove()));
            }
          H && (A(W, P && function(Ae) {
            var Ge = Ae.getCurve(), Je = Ae.getSegment(), tt = Ae._intersection, ft = tt._curve, Ne = tt._segment;
            if (Ge && ft && Ge._path && ft._path)
              return !0;
            Je && (Je._intersection = null), Ne && (Ne._intersection = null);
          }, V), V && E(V), R = F(a.each(R, function(Ae) {
            a.push(this, Ae._segments);
          }, [])));
          var we = R.length, Se;
          return we > 1 && B ? (R !== B && this.setChildren(R), Se = this) : we === 1 && !B && (R[0] !== this && this.setSegments(R[0].removeSegments()), Se = this), Se || (Se = new Zt(K.NO_INSERT), Se.addChildren(R), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
        },
        reorient: function(B, R) {
          var C = this._children;
          return C && C.length ? this.setChildren(L(
            this.removeChildren(),
            function(P) {
              return !!(B ? P : P & 1);
            },
            R
          )) : R !== t && this.setClockwise(R), this;
        },
        getInteriorPoint: function() {
          var B = this.getBounds(), R = B.getCenter(!0);
          if (!this.contains(R)) {
            for (var C = this.getCurves(), P = R.y, H = [], W = [], V = 0, Q = C.length; V < Q; V++) {
              var ae = C[V].getValues(), le = ae[1], fe = ae[3], se = ae[5], ge = ae[7];
              if (P >= i(le, fe, se, ge) && P <= n(le, fe, se, ge))
                for (var me = Ue.getMonoCurves(ae), we = 0, Se = me.length; we < Se; we++) {
                  var Ae = me[we], Ge = Ae[1], Je = Ae[7];
                  if (Ge !== Je && (P >= Ge && P <= Je || P >= Je && P <= Ge)) {
                    var tt = P === Ge ? Ae[0] : P === Je ? Ae[6] : Ue.solveCubic(Ae, 1, P, W, 0, 1) === 1 ? Ue.getPoint(Ae, W[0]).x : (Ae[0] + Ae[6]) / 2;
                    H.push(tt);
                  }
                }
            }
            H.length > 1 && (H.sort(function(ft, Ne) {
              return ft - Ne;
            }), R.x = (H[0] + H[1]) / 2);
          }
          return R;
        }
      };
    }());
    var ct = a.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, n, s, l, h) {
          var d = [], m = [], _ = 0, b = 1 / (s || 32), x = i._segments, T = x[0], E;
          function L(F, B) {
            var R = Ue.getValues(F, B, h);
            d.push(R), A(R, F._index, 0, 1);
          }
          function A(F, B, R, C) {
            if (C - R > b && !(l && Ue.isStraight(F)) && !Ue.isFlatEnough(F, n || 0.25)) {
              var P = Ue.subdivide(F, 0.5), H = (R + C) / 2;
              A(P[0], B, R, H), A(P[1], B, H, C);
            } else {
              var W = F[6] - F[0], V = F[7] - F[1], Q = Math.sqrt(W * W + V * V);
              Q > 0 && (_ += Q, m.push({
                offset: _,
                curve: F,
                index: B,
                time: C
              }));
            }
          }
          for (var U = 1, k = x.length; U < k; U++)
            E = x[U], L(T, E), T = E;
          i._closed && L(E || T, x[0]), this.curves = d, this.parts = m, this.length = _, this.index = 0;
        },
        _get: function(i) {
          for (var n = this.parts, s = n.length, l, h = this.index; l = h, !(!h || n[--h].offset < i); )
            ;
          for (; l < s; l++) {
            var d = n[l];
            if (d.offset >= i) {
              this.index = l;
              var m = n[l - 1], _ = m && m.index === d.index ? m.time : 0, b = m ? m.offset : 0;
              return {
                index: d.index,
                time: _ + (d.time - _) * (i - b) / (d.offset - b)
              };
            }
          }
          return {
            index: n[s - 1].index,
            time: 1
          };
        },
        drawPart: function(i, n, s) {
          for (var l = this._get(n), h = this._get(s), d = l.index, m = h.index; d <= m; d++) {
            var _ = Ue.getPart(
              this.curves[d],
              d === l.index ? l.time : 0,
              d === h.index ? h.time : 1
            );
            d === l.index && i.moveTo(_[0], _[1]), i.bezierCurveTo.apply(i, _.slice(2));
          }
        }
      },
      a.each(
        Ue._evaluateMethods,
        function(i) {
          this[i + "At"] = function(n) {
            var s = this._get(n);
            return Ue[i](this.curves[s.index], s.time);
          };
        },
        {}
      )
    ), lt = a.extend({
      initialize: function(i) {
        for (var n = this.points = [], s = i._segments, l = i._closed, h = 0, d, m = s.length; h < m; h++) {
          var _ = s[h].point;
          (!d || !d.equals(_)) && n.push(d = _.clone());
        }
        l && (n.unshift(n[n.length - 1]), n.push(n[1])), this.closed = l;
      },
      fit: function(i) {
        var n = this.points, s = n.length, l = null;
        return s > 0 && (l = [new ue(n[0])], s > 1 && (this.fitCubic(
          l,
          i,
          0,
          s - 1,
          n[1].subtract(n[0]),
          n[s - 2].subtract(n[s - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, n, s, l, h, d) {
        var m = this.points;
        if (l - s === 1) {
          var _ = m[s], b = m[l], x = _.getDistance(b) / 3;
          this.addCurve(i, [
            _,
            _.add(h.normalize(x)),
            b.add(d.normalize(x)),
            b
          ]);
          return;
        }
        for (var T = this.chordLengthParameterize(s, l), E = Math.max(n, n * n), L, A = !0, U = 0; U <= 4; U++) {
          var k = this.generateBezier(s, l, T, h, d), F = this.findMaxError(s, l, k, T);
          if (F.error < n && A) {
            this.addCurve(i, k);
            return;
          }
          if (L = F.index, F.error >= E)
            break;
          A = this.reparameterize(s, l, T, k), E = F.error;
        }
        var B = m[L - 1].subtract(m[L + 1]);
        this.fitCubic(i, n, s, L, h, B), this.fitCubic(i, n, L, l, B.negate(), d);
      },
      addCurve: function(i, n) {
        var s = i[i.length - 1];
        s.setHandleOut(n[1].subtract(n[0])), i.push(new ue(n[3], n[2].subtract(n[3])));
      },
      generateBezier: function(i, n, s, l, h) {
        for (var d = 1e-12, m = Math.abs, _ = this.points, b = _[i], x = _[n], T = [[0, 0], [0, 0]], E = [0, 0], L = 0, A = n - i + 1; L < A; L++) {
          var U = s[L], k = 1 - U, F = 3 * U * k, B = k * k * k, R = F * k, C = F * U, P = U * U * U, H = l.normalize(R), W = h.normalize(C), V = _[i + L].subtract(b.multiply(B + R)).subtract(x.multiply(C + P));
          T[0][0] += H.dot(H), T[0][1] += H.dot(W), T[1][0] = T[0][1], T[1][1] += W.dot(W), E[0] += H.dot(V), E[1] += W.dot(V);
        }
        var Q = T[0][0] * T[1][1] - T[1][0] * T[0][1], ae, le;
        if (m(Q) > d) {
          var fe = T[0][0] * E[1] - T[1][0] * E[0], se = E[0] * T[1][1] - E[1] * T[0][1];
          ae = se / Q, le = fe / Q;
        } else {
          var ge = T[0][0] + T[0][1], me = T[1][0] + T[1][1];
          ae = le = m(ge) > d ? E[0] / ge : m(me) > d ? E[1] / me : 0;
        }
        var we = x.getDistance(b), Se = d * we, Ae, Ge;
        if (ae < Se || le < Se)
          ae = le = we / 3;
        else {
          var Je = x.subtract(b);
          Ae = l.normalize(ae), Ge = h.normalize(le), Ae.dot(Je) - Ge.dot(Je) > we * we && (ae = le = we / 3, Ae = Ge = null);
        }
        return [
          b,
          b.add(Ae || l.normalize(ae)),
          x.add(Ge || h.normalize(le)),
          x
        ];
      },
      reparameterize: function(i, n, s, l) {
        for (var h = i; h <= n; h++)
          s[h - i] = this.findRoot(l, this.points[h], s[h - i]);
        for (var h = 1, d = s.length; h < d; h++)
          if (s[h] <= s[h - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, n, s) {
        for (var l = [], h = [], d = 0; d <= 2; d++)
          l[d] = i[d + 1].subtract(i[d]).multiply(3);
        for (var d = 0; d <= 1; d++)
          h[d] = l[d + 1].subtract(l[d]).multiply(2);
        var m = this.evaluate(3, i, s), _ = this.evaluate(2, l, s), b = this.evaluate(1, h, s), x = m.subtract(n), T = _.dot(_) + x.dot(b);
        return D.isMachineZero(T) ? s : s - x.dot(_) / T;
      },
      evaluate: function(i, n, s) {
        for (var l = n.slice(), h = 1; h <= i; h++)
          for (var d = 0; d <= i - h; d++)
            l[d] = l[d].multiply(1 - s).add(l[d + 1].multiply(s));
        return l[0];
      },
      chordLengthParameterize: function(i, n) {
        for (var s = [0], l = i + 1; l <= n; l++)
          s[l - i] = s[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, h = n - i; l <= h; l++)
          s[l] /= s[h];
        return s;
      },
      findMaxError: function(i, n, s, l) {
        for (var h = Math.floor((n - i + 1) / 2), d = 0, m = i + 1; m < n; m++) {
          var _ = this.evaluate(3, s, l[m - i]), b = _.subtract(this.points[m]), x = b.x * b.x + b.y * b.y;
          x >= d && (d = x, h = m);
        }
        return {
          error: d,
          index: h
        };
      }
    }), $t = K.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(n) {
        this._content = "", this._lines = [];
        var s = n && a.isPlainObject(n) && n.x === t && n.y === t;
        this._initialize(s && n, !s && M.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), Kt = $t.extend({
      _class: "PointText",
      initialize: function() {
        $t.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new X(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, n, s) {
        if (this._content) {
          this._setStyles(i, n, s);
          var l = this._lines, h = this._style, d = h.hasFill(), m = h.hasStroke(), _ = h.getLeading(), b = i.shadowColor;
          i.font = h.getFontStyle(), i.textAlign = h.getJustification();
          for (var x = 0, T = l.length; x < T; x++) {
            i.shadowColor = b;
            var E = l[x];
            d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), m && i.strokeText(E, 0, 0), i.translate(0, _);
          }
        }
      },
      _getBounds: function(i, n) {
        var s = this._style, l = this._lines, h = l.length, d = s.getJustification(), m = s.getLeading(), _ = this.getView().getTextWidth(s.getFontStyle(), l), b = 0;
        d !== "left" && (b -= _ / (d === "center" ? 2 : 1));
        var x = new G(
          b,
          h ? -0.75 * m : 0,
          _,
          h * m
        );
        return i ? i._transformBounds(x, x) : x;
      }
    }), At = a.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, n = {}, s = {
          transparent: [0, 0, 0, 0]
        }, l;
        function h(_) {
          var b = _.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || _.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), x = "rgb", T;
          if (b) {
            var E = b[4] ? 4 : 3;
            T = new Array(E);
            for (var L = 0; L < E; L++) {
              var A = b[L + 1];
              T[L] = parseInt(A.length == 1 ? A + A : A, 16) / 255;
            }
          } else if (b = _.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            x = b[1], T = b[2].trim().split(/[,\s]+/g);
            for (var U = x === "hsl", L = 0, k = Math.min(T.length, 4); L < k; L++) {
              var F = T[L], A = parseFloat(F);
              if (U)
                if (L === 0) {
                  var B = F.match(/([a-z]*)$/)[1];
                  A *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[B] || 1;
                } else
                  L < 3 && (A /= 100);
              else
                L < 3 && (A /= /%$/.test(F) ? 100 : 255);
              T[L] = A;
            }
          } else {
            var R = s[_];
            if (!R)
              if (r) {
                l || (l = dt.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = _, l.fillRect(0, 0, 1, 1);
                var C = l.getImageData(0, 0, 1, 1).data;
                R = s[_] = [
                  C[0] / 255,
                  C[1] / 255,
                  C[2] / 255
                ];
              } else
                R = [0, 0, 0];
            T = R.slice();
          }
          return [x, T];
        }
        var d = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], m = {
          "rgb-hsb": function(_, b, x) {
            var T = Math.max(_, b, x), E = Math.min(_, b, x), L = T - E, A = L === 0 ? 0 : (T == _ ? (b - x) / L + (b < x ? 6 : 0) : T == b ? (x - _) / L + 2 : (_ - b) / L + 4) * 60;
            return [A, T === 0 ? 0 : L / T, T];
          },
          "hsb-rgb": function(_, b, x) {
            _ = (_ / 60 % 6 + 6) % 6;
            var E = Math.floor(_), T = _ - E, E = d[E], L = [
              x,
              x * (1 - b),
              x * (1 - b * T),
              x * (1 - b * (1 - T))
            ];
            return [L[E[0]], L[E[1]], L[E[2]]];
          },
          "rgb-hsl": function(_, b, x) {
            var T = Math.max(_, b, x), E = Math.min(_, b, x), L = T - E, A = L === 0, U = A ? 0 : (T == _ ? (b - x) / L + (b < x ? 6 : 0) : T == b ? (x - _) / L + 2 : (_ - b) / L + 4) * 60, k = (T + E) / 2, F = A ? 0 : k < 0.5 ? L / (T + E) : L / (2 - T - E);
            return [U, F, k];
          },
          "hsl-rgb": function(_, b, x) {
            if (_ = (_ / 360 % 1 + 1) % 1, b === 0)
              return [x, x, x];
            for (var T = [_ + 1 / 3, _, _ - 1 / 3], E = x < 0.5 ? x * (1 + b) : x + b - x * b, L = 2 * x - E, A = [], U = 0; U < 3; U++) {
              var k = T[U];
              k < 0 && (k += 1), k > 1 && (k -= 1), A[U] = 6 * k < 1 ? L + (E - L) * 6 * k : 2 * k < 1 ? E : 3 * k < 2 ? L + (E - L) * (2 / 3 - k) * 6 : L;
            }
            return A;
          },
          "rgb-gray": function(_, b, x) {
            return [_ * 0.2989 + b * 0.587 + x * 0.114];
          },
          "gray-rgb": function(_) {
            return [_, _, _];
          },
          "gray-hsb": function(_) {
            return [0, 0, _];
          },
          "gray-hsl": function(_) {
            return [0, 0, _];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return a.each(i, function(_, b) {
          n[b] = [], a.each(_, function(x, T) {
            var E = a.capitalize(x), L = /^(hue|saturation)$/.test(x), A = n[b][T] = b === "gradient" ? x === "gradient" ? function(U) {
              var k = this._components[0];
              return U = Ni.read(
                Array.isArray(U) ? U : arguments,
                0,
                { readNull: !0 }
              ), k !== U && (k && k._removeOwner(this), U && U._addOwner(this)), U;
            } : function() {
              return M.read(arguments, 0, {
                readNull: x === "highlight",
                clone: !0
              });
            } : function(U) {
              return U == null || isNaN(U) ? 0 : +U;
            };
            this["get" + E] = function() {
              return this._type === b || L && /^hs[bl]$/.test(this._type) ? this._components[T] : this._convert(b)[T];
            }, this["set" + E] = function(U) {
              this._type !== b && !(L && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(b), this._properties = i[b], this._type = b), this._components[T] = A.call(this, U), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function _(b) {
            var x = arguments, T = this.__read, E = 0, L, A, U, k;
            Array.isArray(b) && (x = b, b = x[0]);
            var F = b != null && typeof b;
            if (F === "string" && b in i && (L = b, b = x[1], Array.isArray(b) ? (A = b, U = x[2]) : (T && (E = 1), x = a.slice(x, 1), F = typeof b)), !A) {
              if (k = F === "number" ? x : F === "object" && b.length != null ? b : null, k) {
                L || (L = k.length >= 3 ? "rgb" : "gray");
                var B = i[L].length;
                U = k[B], T && (E += k === arguments ? B + (U != null ? 1 : 0) : 1), k.length > B && (k = a.slice(k, 0, B));
              } else if (F === "string") {
                var R = h(b);
                L = R[0], A = R[1], A.length === 4 && (U = A[3], A.length--);
              } else if (F === "object")
                if (b.constructor === _) {
                  if (L = b._type, A = b._components.slice(), U = b._alpha, L === "gradient")
                    for (var C = 1, P = A.length; C < P; C++) {
                      var H = A[C];
                      H && (A[C] = H.clone());
                    }
                } else if (b.constructor === Ni)
                  L = "gradient", k = x;
                else {
                  L = "hue" in b ? "lightness" in b ? "hsl" : "hsb" : "gradient" in b || "stops" in b || "radial" in b ? "gradient" : "gray" in b ? "gray" : "rgb";
                  var W = i[L], V = n[L];
                  this._components = A = [];
                  for (var C = 0, P = W.length; C < P; C++) {
                    var Q = b[W[C]];
                    Q == null && !C && L === "gradient" && "stops" in b && (Q = {
                      stops: b.stops,
                      radial: b.radial
                    }), Q = V[C].call(this, Q), Q != null && (A[C] = Q);
                  }
                  U = b.alpha;
                }
              T && L && (E = 1);
            }
            if (this._type = L || "rgb", !A) {
              this._components = A = [];
              for (var V = n[this._type], C = 0, P = V.length; C < P; C++) {
                var Q = V[C].call(this, k && k[C]);
                Q != null && (A[C] = Q);
              }
            }
            return this._components = A, this._properties = i[this._type], this._alpha = U, T && (this.__read = E), this;
          },
          set: "#initialize",
          _serialize: function(_, b) {
            var x = this.getComponents();
            return a.serialize(
              /^(gray|rgb)$/.test(this._type) ? x : [this._type].concat(x),
              _,
              !0,
              b
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(_) {
            var b;
            return this._type === _ ? this._components.slice() : (b = m[this._type + "-" + _]) ? b.apply(this, this._components) : m["rgb-" + _].apply(
              this,
              m[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(_) {
            return new At(_, this._convert(_), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(_) {
            this._components = this._convert(_), this._properties = i[_], this._type = _;
          },
          getComponents: function() {
            var _ = this._components.slice();
            return this._alpha != null && _.push(this._alpha), _;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(_) {
            this._alpha = _ == null ? null : Math.min(Math.max(_, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(_) {
            var b = a.isPlainValue(_, !0) ? At.read(arguments) : _;
            return b === this || b && this._class === b._class && this._type === b._type && this.getAlpha() === b.getAlpha() && a.equals(this._components, b._components) || !1;
          },
          toString: function() {
            for (var _ = this._properties, b = [], x = this._type === "gradient", T = I.instance, E = 0, L = _.length; E < L; E++) {
              var A = this._components[E];
              A != null && b.push(_[E] + ": " + (x ? A : T.number(A)));
            }
            return this._alpha != null && b.push("alpha: " + T.number(this._alpha)), "{ " + b.join(", ") + " }";
          },
          toCSS: function(_) {
            var b = this._convert("rgb"), x = _ || this._alpha == null ? 1 : this._alpha;
            function T(E) {
              return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
            }
            return b = [
              T(b[0]),
              T(b[1]),
              T(b[2])
            ], x < 1 && b.push(x < 0 ? 0 : x), _ ? "#" + ((1 << 24) + (b[0] << 16) + (b[1] << 8) + b[2]).toString(16).slice(1) : (b.length == 4 ? "rgba(" : "rgb(") + b.join(",") + ")";
          },
          toCanvasStyle: function(_, b) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var x = this._components, T = x[0], E = T._stops, L = x[1], A = x[2], U = x[3], k = b && b.inverted(), F;
            if (k && (L = k._transformPoint(L), A = k._transformPoint(A), U && (U = k._transformPoint(U))), T._radial) {
              var B = A.getDistance(L);
              if (U) {
                var R = U.subtract(L);
                R.getLength() > B && (U = L.add(R.normalize(B - 0.1)));
              }
              var C = U || L;
              F = _.createRadialGradient(
                C.x,
                C.y,
                0,
                L.x,
                L.y,
                B
              );
            } else
              F = _.createLinearGradient(
                L.x,
                L.y,
                A.x,
                A.y
              );
            for (var P = 0, H = E.length; P < H; P++) {
              var W = E[P], V = W._offset;
              F.addColorStop(
                V ?? P / (H - 1),
                W._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = F;
          },
          transform: function(_) {
            if (this._type === "gradient") {
              for (var b = this._components, x = 1, T = b.length; x < T; x++) {
                var E = b[x];
                _._transformPoint(E, E, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var _ = Math.random;
              return new At(_(), _(), _());
            },
            _setOwner: function(_, b, x) {
              return _ && (_._owner && b && _._owner !== b && (_ = _.clone()), !_._owner ^ !b && (_._owner = b || null, _._setter = x || null)), _;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(n, s) {
            return n + s;
          },
          subtract: function(n, s) {
            return n - s;
          },
          multiply: function(n, s) {
            return n * s;
          },
          divide: function(n, s) {
            return n / s;
          }
        };
        return a.each(i, function(n, s) {
          this[s] = function(l) {
            l = At.read(arguments);
            for (var h = this._type, d = this._components, m = l._convert(h), _ = 0, b = d.length; _ < b; _++)
              m[_] = n(d[_], m[_]);
            return new At(
              h,
              m,
              this._alpha != null ? n(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), Ni = a.extend({
      _class: "Gradient",
      initialize: function(n, s) {
        this._id = Z.get(), n && a.isPlainObject(n) && (this.set(n), n = s = null), this._stops == null && this.setStops(n || ["white", "black"]), this._radial == null && this.setRadial(typeof s == "string" && s === "radial" || s || !1);
      },
      _serialize: function(i, n) {
        return n.add(this, function() {
          return a.serialize(
            [this._stops, this._radial],
            i,
            !0,
            n
          );
        });
      },
      _changed: function() {
        for (var i = 0, n = this._owners && this._owners.length; i < n; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var n = this._owners ? this._owners.indexOf(i) : -1;
        n != -1 && (this._owners.splice(n, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], n = 0, s = this._stops.length; n < s; n++)
          i[n] = this._stops[n].clone();
        return new Ni(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var n = this._stops;
        if (n)
          for (var s = 0, l = n.length; s < l; s++)
            n[s]._owner = t;
        n = this._stops = rn.readList(i, 0, { clone: !0 });
        for (var s = 0, l = n.length; s < l; s++)
          n[s]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var n = this._stops, s = i._stops, l = n.length;
          if (l === s.length) {
            for (var h = 0; h < l; h++)
              if (!n[h].equals(s[h]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), rn = a.extend({
      _class: "GradientStop",
      initialize: function(n, s) {
        var l = n, h = s;
        typeof n == "object" && s === t && (Array.isArray(n) && typeof n[0] != "number" ? (l = n[0], h = n[1]) : ("color" in n || "offset" in n || "rampPoint" in n) && (l = n.color, h = n.offset || n.rampPoint || 0)), this.setColor(l), this.setOffset(h);
      },
      clone: function() {
        return new rn(this._color.clone(), this._offset);
      },
      _serialize: function(i, n) {
        var s = this._color, l = this._offset;
        return a.serialize(
          l == null ? [s] : [s, l],
          i,
          !0,
          n
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        At._setOwner(this._color, null), this._color = At._setOwner(
          At.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), ui = a.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new M(),
        selectedColor: null
      }, n = a.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), s = a.set({}, n, {
        fillColor: new At()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, h = {
        beans: !0
      }, d = {
        _class: "Style",
        beans: !0,
        initialize: function(_, b, x) {
          this._values = {}, this._owner = b, this._project = b && b._project || x || He.project, this._defaults = !b || b instanceof j ? n : b instanceof $t ? s : i, _ && this.set(_);
        }
      };
      return a.each(n, function(m, _) {
        var b = /Color$/.test(_), x = _ === "shadowOffset", T = a.capitalize(_), E = l[_], L = "set" + T, A = "get" + T;
        d[L] = function(U) {
          var k = this._owner, F = k && k._children, B = F && F.length > 0 && !(k instanceof Zt);
          if (B)
            for (var R = 0, C = F.length; R < C; R++)
              F[R]._style[L](U);
          if ((_ === "selectedColor" || !B) && _ in this._defaults) {
            var P = this._values[_];
            P !== U && (b && (P && (At._setOwner(P, null), P._canvasStyle = null), U && U.constructor === At && (U = At._setOwner(
              U,
              k,
              B && L
            ))), this._values[_] = U, k && k._changed(E || 129));
          }
        }, d[A] = function(U) {
          var k = this._owner, F = k && k._children, B = F && F.length > 0 && !(k instanceof Zt), R;
          if (B && !U)
            for (var C = 0, P = F.length; C < P; C++) {
              var H = F[C]._style[A]();
              if (!C)
                R = H;
              else if (!a.equals(R, H))
                return t;
            }
          else if (_ in this._defaults) {
            var R = this._values[_];
            if (R === t)
              R = this._defaults[_], R && R.clone && (R = R.clone());
            else {
              var W = b ? At : x ? M : null;
              W && !(R && R.constructor === W) && (this._values[_] = R = W.read(
                [R],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return R && b && (R = At._setOwner(R, k, B && L)), R;
        }, h[A] = function(U) {
          return this._style[A](U);
        }, h[L] = function(U) {
          this._style[L](U);
        };
      }), a.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(m, _) {
        var b = "get" + _, x = "set" + _;
        d[b] = h[b] = "#get" + m, d[x] = h[x] = "#set" + m;
      }), K.inject(h), d;
    }(), {
      set: function(i) {
        var n = i instanceof ui, s = n ? i._values : i;
        if (s) {
          for (var l in s)
            if (l in this._defaults) {
              var h = s[l];
              this[l] = h && n && h.clone ? h.clone() : h;
            }
        }
      },
      equals: function(i) {
        function n(s, l, h) {
          var d = s._values, m = l._values, _ = l._defaults;
          for (var b in d) {
            var x = d[b], T = m[b];
            if (!(h && b in m) && !a.equals(
              x,
              T === t ? _[b] : T
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && n(this, i) && n(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var n = i.base.call(this), s = this.getFontSize();
        return /pt|em|%|px/.test(s) && (s = this.getView().getPixelSize(s)), n ?? s * 1.2;
      }
    }), Wt = new function() {
      function i(n, s, l, h) {
        for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], m = s[0].toUpperCase() + s.substring(1), _ = 0; _ < 6; _++) {
          var b = d[_], x = b ? b + m : s;
          if (x in n) {
            if (l)
              n[x] = h;
            else
              return n[x];
            break;
          }
        }
      }
      return {
        getStyles: function(n) {
          var s = n && n.nodeType !== 9 ? n.ownerDocument : n, l = s && s.defaultView;
          return l && l.getComputedStyle(n, "");
        },
        getBounds: function(n, s) {
          var l = n.ownerDocument, h = l.body, d = l.documentElement, m;
          try {
            m = n.getBoundingClientRect();
          } catch {
            m = { left: 0, top: 0, width: 0, height: 0 };
          }
          var _ = m.left - (d.clientLeft || h.clientLeft || 0), b = m.top - (d.clientTop || h.clientTop || 0);
          if (!s) {
            var x = l.defaultView;
            _ += x.pageXOffset || d.scrollLeft || h.scrollLeft, b += x.pageYOffset || d.scrollTop || h.scrollTop;
          }
          return new G(_, b, m.width, m.height);
        },
        getViewportBounds: function(n) {
          var s = n.ownerDocument, l = s.defaultView, h = s.documentElement;
          return new G(
            0,
            0,
            l.innerWidth || h.clientWidth,
            l.innerHeight || h.clientHeight
          );
        },
        getOffset: function(n, s) {
          return Wt.getBounds(n, s).getPoint();
        },
        getSize: function(n) {
          return Wt.getBounds(n, !0).getSize();
        },
        isInvisible: function(n) {
          return Wt.getSize(n).equals(new Y(0, 0));
        },
        isInView: function(n) {
          return !Wt.isInvisible(n) && Wt.getViewportBounds(n).intersects(
            Wt.getBounds(n, !0)
          );
        },
        isInserted: function(n) {
          return o.body.contains(n);
        },
        getPrefixed: function(n, s) {
          return n && i(n, s);
        },
        setPrefixed: function(n, s, l) {
          if (typeof s == "object")
            for (var h in s)
              i(n, h, !0, s[h]);
          else
            i(n, s, !0, l);
        }
      };
    }(), Qt = {
      add: function(i, n) {
        if (i)
          for (var s in n)
            for (var l = n[s], h = s.split(/[\s,]+/g), d = 0, m = h.length; d < m; d++) {
              var _ = h[d], b = i === o && (_ === "touchstart" || _ === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(_, l, b);
            }
      },
      remove: function(i, n) {
        if (i)
          for (var s in n)
            for (var l = n[s], h = s.split(/[\s,]+/g), d = 0, m = h.length; d < m; d++)
              i.removeEventListener(h[d], l, !1);
      },
      getPoint: function(i) {
        var n = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new M(
          n.pageX || n.clientX + o.documentElement.scrollLeft,
          n.pageY || n.clientY + o.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, n) {
        return Qt.getPoint(i).subtract(Wt.getOffset(
          n || Qt.getTarget(i)
        ));
      }
    };
    Qt.requestAnimationFrame = new function() {
      var i = Wt.getPrefixed(r, "requestAnimationFrame"), n = !1, s = [], l;
      function h() {
        var d = s;
        s = [];
        for (var m = 0, _ = d.length; m < _; m++)
          d[m]();
        n = i && s.length, n && i(h);
      }
      return function(d) {
        s.push(d), i ? n || (i(h), n = !0) : l || (l = setInterval(h, 1e3 / 60));
      };
    }();
    var ei = a.extend(
      u,
      {
        _class: "View",
        initialize: function i(n, s) {
          function l(E) {
            return s[E] || parseInt(s.getAttribute(E), 10);
          }
          function h() {
            var E = Wt.getSize(s);
            return E.isNaN() || E.isZero() ? new Y(l("width"), l("height")) : E;
          }
          var d;
          if (r && s) {
            this._id = s.getAttribute("id"), this._id == null && s.setAttribute("id", this._id = "paper-view-" + i._id++), Qt.add(s, this._viewEvents);
            var m = "none";
            if (Wt.setPrefixed(s.style, {
              userDrag: m,
              userSelect: m,
              touchCallout: m,
              contentZooming: m,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), f.hasAttribute(s, "resize")) {
              var _ = this;
              Qt.add(r, this._windowEvents = {
                resize: function() {
                  _.setViewSize(h());
                }
              });
            }
            if (d = h(), f.hasAttribute(s, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var b = this._stats.domElement, x = b.style, T = Wt.getOffset(s);
              x.position = "absolute", x.left = T.x + "px", x.top = T.y + "px", o.body.appendChild(b);
            }
          } else
            d = new Y(s), s = null;
          this._project = n, this._scope = n._scope, this._element = s, this._pixelRatio || (this._pixelRatio = r && r.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new J())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !He.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          ei._focused === this && (ei._focused = null), ei._views.splice(ei._views.indexOf(this), 1), delete ei._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Qt.remove(this._element, this._viewEvents), Qt.remove(r, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: a.each(
          K._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Qt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var n = i._element;
                (!Wt.getPrefixed(o, "hidden") || f.getAttribute(n, "keepalive") === "true") && Wt.isInView(n) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          He = this._scope;
          var i = Date.now() / 1e3, n = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new a({
            delta: n,
            time: this._time += n,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, n) {
          var s = this._frameItems;
          n ? (s[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete s[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var n in this._frameItems) {
            var s = this._frameItems[n];
            s.item.emit("frame", new a(i, {
              time: s.time += i.delta,
              count: s.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new ie(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = Y.read(arguments), n = i.subtract(this._viewSize);
          n.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: n }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, n) {
          var s = this._element;
          s && (s.width !== i && (s.width = i), s.height !== n && (s.height = n));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new G(new M(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return Wt.isInView(this._element);
        },
        isInserted: function() {
          return Wt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var n = this._element, s;
          if (n) {
            var l = n.parentNode, h = o.createElement("div");
            h.style.fontSize = i, l.appendChild(h), s = parseFloat(Wt.getStyles(h).fontSize), l.removeChild(h);
          } else
            s = parseFloat(s);
          return s;
        },
        getTextWidth: function(i, n) {
          return 0;
        }
      },
      a.each(["rotate", "scale", "shear", "skew"], function(i) {
        var n = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (n ? a : M).read(s), h = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            h || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = M.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new J().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var n = this.getRotation();
          n != null && i != null && this.rotate(i - n);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new X(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), n = M.read(arguments, 0, { clone: !0, readNull: !0 });
          i && n && this.scale(n.x / i.x, n.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(M.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Qt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, n) {
            o && typeof n == "string" && (n = o.getElementById(n));
            var s = r ? on : ei;
            return new s(i, n);
          }
        }
      },
      new function() {
        if (!r)
          return;
        var i, n, s = !1, l = !1;
        function h(se) {
          var ge = Qt.getTarget(se);
          return ge.getAttribute && ei._viewsById[ge.getAttribute("id")];
        }
        function d() {
          var se = ei._focused;
          if (!se || !se.isVisible()) {
            for (var ge = 0, me = ei._views.length; ge < me; ge++)
              if ((se = ei._views[ge]).isVisible()) {
                ei._focused = n = se;
                break;
              }
          }
        }
        function m(se, ge, me) {
          se._handleMouseEvent("mousemove", ge, me);
        }
        var _ = r.navigator, b, x, T;
        _.pointerEnabled || _.msPointerEnabled ? (b = "pointerdown MSPointerDown", x = "pointermove MSPointerMove", T = "pointerup pointercancel MSPointerUp MSPointerCancel") : (b = "touchstart", x = "touchmove", T = "touchend touchcancel", "ontouchstart" in r && _.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (b += " mousedown", x += " mousemove", T += " mouseup"));
        var E = {}, L = {
          mouseout: function(se) {
            var ge = ei._focused, me = Qt.getRelatedTarget(se);
            if (ge && (!me || me.nodeName === "HTML")) {
              var we = Qt.getOffset(se, ge._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), Je = 1 << 25, tt = Ge - Je;
              we.x = Ae(tt) < Ge ? tt * (Se < 0 ? -1 : 1) : Se, m(ge, se, ge.viewToProject(we));
            }
          },
          scroll: d
        };
        E[b] = function(se) {
          var ge = ei._focused = h(se);
          s || (s = !0, ge._handleMouseEvent("mousedown", se));
        }, L[x] = function(se) {
          var ge = ei._focused;
          if (!l) {
            var me = h(se);
            me ? ge !== me && (ge && m(ge, se), i || (i = ge), ge = ei._focused = n = me) : n && n === ge && (i && !i.isInserted() && (i = null), ge = ei._focused = i, i = null, d());
          }
          ge && m(ge, se);
        }, L[b] = function() {
          l = !0;
        }, L[T] = function(se) {
          var ge = ei._focused;
          ge && s && ge._handleMouseEvent("mouseup", se), l = s = !1;
        }, Qt.add(o, L), Qt.add(r, {
          load: d
        });
        var A = !1, U = !1, k = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, F = !1, B, R, C, P, H, W, V, Q;
        function ae(se, ge, me, we, Se, Ae, Ge) {
          var Je = !1, tt;
          function ft(Ne, ze) {
            if (Ne.responds(ze)) {
              if (tt || (tt = new xt(
                ze,
                we,
                Se,
                ge || Ne,
                Ae ? Se.subtract(Ae) : null
              )), Ne.emit(ze, tt) && (A = !0, tt.prevented && (U = !0), tt.stopped))
                return Je = !0;
            } else {
              var nt = k[ze];
              if (nt)
                return ft(Ne, nt);
            }
          }
          for (; se && se !== Ge && !ft(se, me); )
            se = se._parent;
          return Je;
        }
        function le(se, ge, me, we, Se, Ae) {
          return se._project.removeOn(me), U = A = !1, H && ae(
            H,
            null,
            me,
            we,
            Se,
            Ae
          ) || ge && ge !== H && !ge.isDescendant(H) && ae(ge, null, me === "mousedrag" ? "mousemove" : me, we, Se, Ae, H) || ae(
            se,
            H || ge || se,
            me,
            we,
            Se,
            Ae
          );
        }
        var fe = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: E,
          _handleMouseEvent: function(se, ge, me) {
            var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, Je = this;
            function tt(Pt) {
              return we.virtual[Pt] || Je.responds(Pt) || Ge && Ge.responds(Pt);
            }
            Ae && s && tt("mousedrag") && (se = "mousedrag"), me || (me = this.getEventPoint(ge));
            var ft = this.getBounds().contains(me), Ne = Se && ft && Je._project.hitTest(me, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), ze = Ne && Ne.item || null, nt = !1, _t = {};
            if (_t[se.substr(5)] = !0, Se && ze !== P && (P && ae(P, null, "mouseleave", ge, me), ze && ae(ze, null, "mouseenter", ge, me), P = ze), F ^ ft && (ae(
              this,
              null,
              ft ? "mouseenter" : "mouseleave",
              ge,
              me
            ), nt = !0), (ft || _t.drag) && !me.equals(R) && (le(
              this,
              ze,
              Ae ? se : "mousemove",
              ge,
              me,
              R
            ), nt = !0), F = ft, _t.down && ft || _t.up && B) {
              if (le(this, ze, se, ge, me, B), _t.down) {
                if (Q = ze === W && Date.now() - V < 300, C = W = ze, !U && ze) {
                  for (var mt = ze; mt && !mt.responds("mousedrag"); )
                    mt = mt._parent;
                  mt && (H = ze);
                }
                B = me;
              } else
                _t.up && (!U && ze === C && (V = Date.now(), le(this, ze, Q ? "doubleclick" : "click", ge, me, B), Q = !1), C = H = null);
              F = !1, nt = !0;
            }
            R = me, nt && Ge && (A = Ge._handleMouseEvent(se, ge, me, _t) || A), ge.cancelable !== !1 && (A && !_t.move || _t.down && tt("mouseup")) && ge.preventDefault();
          },
          _handleKeyEvent: function(se, ge, me, we) {
            var Se = this._scope, Ae = Se.tool, Ge;
            function Je(tt) {
              tt.responds(se) && (He = Se, tt.emit(se, Ge = Ge || new pe(se, ge, me, we)));
            }
            this.isVisible() && (Je(this), Ae && Ae.responds(se) && Je(Ae));
          },
          _countItemEvent: function(se, ge) {
            var me = this._itemEvents, we = me.native, Se = me.virtual;
            for (var Ae in fe)
              we[Ae] = (we[Ae] || 0) + (fe[Ae][se] || 0) * ge;
            Se[se] = (Se[se] || 0) + ge;
          },
          statics: {
            updateFocus: d,
            _resetState: function() {
              s = l = A = F = !1, i = n = B = R = C = P = H = W = V = Q = null;
            }
          }
        };
      }()
    ), on = ei.extend({
      _class: "CanvasView",
      initialize: function(n, s) {
        if (!(s instanceof r.HTMLCanvasElement)) {
          var l = Y.read(arguments, 1);
          if (l.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + a.slice(arguments, 1)
            );
          s = dt.getCanvas(l);
        }
        var h = this._context = s.getContext("2d");
        if (h.save(), this._pixelRatio = 1, !/^off|false$/.test(f.getAttribute(s, "hidpi"))) {
          var d = r.devicePixelRatio || 1, m = Wt.getPrefixed(
            h,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = d / m;
        }
        ei.call(this, n, s), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(n, s) {
        var l = this._pixelRatio;
        if (i.base.call(this, n * l, s * l), l !== 1) {
          var h = this._element, d = this._context;
          if (!f.hasAttribute(h, "resize")) {
            var m = h.style;
            m.width = n + "px", m.height = s + "px";
          }
          d.restore(), d.save(), d.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(n) {
        var s = He.agent, l;
        if (s && s.firefox)
          l = i.base.call(this, n);
        else {
          var h = this._context, d = h.font;
          h.font = n + " serif", l = parseFloat(h.font), h.font = d;
        }
        return l;
      },
      getTextWidth: function(i, n) {
        var s = this._context, l = s.font, h = 0;
        s.font = i;
        for (var d = 0, m = n.length; d < m; d++)
          h = Math.max(h, s.measureText(n[d]).width);
        return s.font = l, h;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, n = this._context, s = this._viewSize;
        return n.clearRect(0, 0, s.width + 1, s.height + 1), i && i.draw(n, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), tn = a.extend({
      _class: "Event",
      initialize: function(n) {
        this.event = n, this.type = n && n.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return Tt.modifiers;
      }
    }), pe = tn.extend({
      _class: "KeyEvent",
      initialize: function(n, s, l, h) {
        this.type = n, this.event = s, this.key = l, this.character = h;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), Tt = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, n = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, s = {}, l = {}, h, d, m = new a({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var x = He && He.agent;
            return x && x.mac ? this.meta : this.control;
          }
        }
      });
      function _(x) {
        var T = x.key || x.keyIdentifier;
        return T = /^U\+/.test(T) ? String.fromCharCode(parseInt(T.substr(2), 16)) : /^Arrow[A-Z]/.test(T) ? T.substr(5) : T === "Unidentified" || T === t ? String.fromCharCode(x.keyCode) : T, i[T] || (T.length > 1 ? a.hyphenate(T) : T.toLowerCase());
      }
      function b(x, T, E, L) {
        var A = ei._focused, U;
        if (s[T] = x, x ? l[T] = E : delete l[T], T.length > 1 && (U = a.camelize(T)) in m) {
          m[U] = x;
          var k = He && He.agent;
          if (U === "meta" && k && k.mac)
            if (x)
              h = {};
            else {
              for (var F in h)
                F in l && b(!1, F, h[F], L);
              h = null;
            }
        } else
          x && h && (h[T] = E);
        A && A._handleKeyEvent(
          x ? "keydown" : "keyup",
          L,
          T,
          E
        );
      }
      return Qt.add(o, {
        keydown: function(x) {
          var T = _(x), E = He && He.agent;
          T.length > 1 || E && E.chrome && (x.altKey || E.mac && x.metaKey || !E.mac && x.ctrlKey) ? b(
            !0,
            T,
            n[T] || (T.length > 1 ? "" : T),
            x
          ) : d = T;
        },
        keypress: function(x) {
          if (d) {
            var T = _(x), E = x.charCode, L = E >= 32 ? String.fromCharCode(E) : T.length > 1 ? "" : T;
            T !== d && (T = L.toLowerCase()), b(!0, T, L, x), d = null;
          }
        },
        keyup: function(x) {
          var T = _(x);
          T in l && b(!1, T, l[T], x);
        }
      }), Qt.add(r, {
        blur: function(x) {
          for (var T in l)
            b(!1, T, l[T], x);
        }
      }), {
        modifiers: m,
        isDown: function(x) {
          return !!s[x];
        }
      };
    }(), xt = tn.extend({
      _class: "MouseEvent",
      initialize: function(n, s, l, h, d) {
        this.type = n, this.event = s, this.point = l, this.target = h, this.delta = d;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Re = tn.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(n, s, l) {
        this.tool = n, this.type = s, this.event = l;
      },
      _choosePoint: function(i, n) {
        return i || (n ? n.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var n = i.item, s = n._parent; /^(Group|CompoundPath)$/.test(s._class); )
              n = s, s = s._parent;
            this._item = n;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ie = v.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(n) {
        v.call(this), this._moveCount = -1, this._downCount = -1, this.set(n);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, n, s, l) {
        He = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var h = l.move || l.drag, d = this.responds(i), m = this.minDistance, _ = this.maxDistance, b = !1, x = this;
        function T(L, A) {
          var U = s, k = h ? x._point : x._downPoint || U;
          if (h) {
            if (x._moveCount >= 0 && U.equals(k))
              return !1;
            if (k && (L != null || A != null)) {
              var F = U.subtract(k), B = F.getLength();
              if (B < (L || 0))
                return !1;
              A && (U = k.add(F.normalize(
                Math.min(B, A)
              )));
            }
            x._moveCount++;
          }
          return x._point = U, x._lastPoint = k || U, l.down && (x._moveCount = -1, x._downPoint = U, x._downCount++), !0;
        }
        function E() {
          d && (b = x.emit(i, new Re(x, i, n)) || b);
        }
        if (l.down)
          T(), E();
        else if (l.up)
          T(null, _), E();
        else if (d)
          for (; T(m, _); )
            E();
        return b;
      }
    }), Qe = a.extend(u, {
      _class: "Tween",
      statics: {
        easings: new a({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(n, s, l, h, d, m) {
        this.object = n;
        var _ = typeof d, b = _ === "function";
        this.type = b ? _ : _ === "string" ? d : "linear", this.easing = b ? d : i.easings[this.type], this.duration = h, this.running = !1, this._then = null, this._startTime = null;
        var x = s || l;
        this._keys = x ? Object.keys(x) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = x && this._getState(s), this._to = x && this._getState(l), m !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var n = this.easing(i), s = this._keys, l = function(T) {
            return typeof T == "function" ? T(n, i) : T;
          }, h = 0, d = s && s.length; h < d; h++) {
            var m = s[h], _ = l(this._from[m]), b = l(this._to[m]), x = _ && b && _.__add && b.__add ? b.__subtract(_).__multiply(n).__add(_) : (b - _) * n + _;
            this._setProperty(this._parsedKeys[m], x);
          }
          this.responds("update") && this.emit("update", new a({
            progress: i,
            factor: n
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var n = this._startTime, s = n ? (i - n) / this.duration : 0;
        n || (this._startTime = i), this.update(s);
      },
      _getState: function(i) {
        for (var n = this._keys, s = {}, l = 0, h = n.length; l < h; l++) {
          var d = n[l], m = this._parsedKeys[d], _ = this._getProperty(m), b;
          if (i) {
            var x = this._resolveValue(_, i[d]);
            this._setProperty(m, x), b = this._getProperty(m), b = b && b.clone ? b.clone() : b, this._setProperty(m, _);
          } else
            b = _ && _.clone ? _.clone() : _;
          s[d] = b;
        }
        return s;
      },
      _resolveValue: function(i, n) {
        if (n) {
          if (Array.isArray(n) && n.length === 2) {
            var s = n[0];
            return s && s.match && s.match(/^[+\-\*\/]=/) ? this._calculate(i, s[0], n[1]) : n;
          } else if (typeof n == "string") {
            var l = n.match(/^[+\-*/]=(.*)/);
            if (l) {
              var h = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, n[0], h);
            }
          }
        }
        return n;
      },
      _calculate: function(i, n, s) {
        return He.PaperScript.calculateBinary(i, n, s);
      },
      _parseKeys: function(i) {
        for (var n = {}, s = 0, l = i.length; s < l; s++) {
          var h = i[s], d = h.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          n[h] = d.split("/");
        }
        return n;
      },
      _getProperty: function(i, n) {
        for (var s = this.object, l = 0, h = i.length - (n || 0); l < h && s; l++)
          s = s[i[l]];
        return s;
      },
      _setProperty: function(i, n) {
        var s = this._getProperty(i, 1);
        s && (s[i[i.length - 1]] = n);
      }
    }), Bt = {
      request: function(i) {
        var n = new e.XMLHttpRequest();
        return n.open(
          (i.method || "get").toUpperCase(),
          i.url,
          a.pick(i.async, !0)
        ), i.mimeType && n.overrideMimeType(i.mimeType), n.onload = function() {
          var s = n.status;
          s === 0 || s === 200 ? i.onLoad && i.onLoad.call(n, n.responseText) : n.onerror();
        }, n.onerror = function() {
          var s = n.status, l = 'Could not load "' + i.url + '" (Status: ' + s + ")";
          if (i.onError)
            i.onError(l, s);
          else
            throw new Error(l);
        }, n.send(null);
      }
    }, dt = a.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, n, s) {
        if (!r)
          return null;
        var l, h = !0;
        typeof i == "object" && (n = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = o.createElement("canvas"), h = !1);
        var d = l.getContext("2d", s || {});
        if (!d)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === n ? h && d.clearRect(0, 0, i + 1, n + 1) : (l.width = i, l.height = n), d.save(), l;
      },
      getContext: function(i, n, s) {
        var l = this.getCanvas(i, n, s);
        return l ? l.getContext("2d", s || {}) : null;
      },
      release: function(i) {
        var n = i && i.canvas ? i.canvas : i;
        n && n.getContext && (n.getContext("2d").restore(), this.canvases.push(n));
      }
    }, et = new function() {
      var i = Math.min, n = Math.max, s = Math.abs, l, h, d, m, _, b, x, T, E, L, A;
      function U(H, W, V) {
        return 0.2989 * H + 0.587 * W + 0.114 * V;
      }
      function k(H, W, V, le) {
        var ae = le - U(H, W, V);
        E = H + ae, L = W + ae, A = V + ae;
        var le = U(E, L, A), fe = i(E, L, A), se = n(E, L, A);
        if (fe < 0) {
          var ge = le - fe;
          E = le + (E - le) * le / ge, L = le + (L - le) * le / ge, A = le + (A - le) * le / ge;
        }
        if (se > 255) {
          var me = 255 - le, we = se - le;
          E = le + (E - le) * me / we, L = le + (L - le) * me / we, A = le + (A - le) * me / we;
        }
      }
      function F(H, W, V) {
        return n(H, W, V) - i(H, W, V);
      }
      function B(H, W, V, Q) {
        var ae = [H, W, V], le = n(H, W, V), fe = i(H, W, V), se;
        fe = fe === H ? 0 : fe === W ? 1 : 2, le = le === H ? 0 : le === W ? 1 : 2, se = i(fe, le) === 0 ? n(fe, le) === 1 ? 2 : 1 : 0, ae[le] > ae[fe] ? (ae[se] = (ae[se] - ae[fe]) * Q / (ae[le] - ae[fe]), ae[le] = Q) : ae[se] = ae[le] = 0, ae[fe] = 0, E = ae[0], L = ae[1], A = ae[2];
      }
      var R = {
        multiply: function() {
          E = _ * l / 255, L = b * h / 255, A = x * d / 255;
        },
        screen: function() {
          E = _ + l - _ * l / 255, L = b + h - b * h / 255, A = x + d - x * d / 255;
        },
        overlay: function() {
          E = _ < 128 ? 2 * _ * l / 255 : 255 - 2 * (255 - _) * (255 - l) / 255, L = b < 128 ? 2 * b * h / 255 : 255 - 2 * (255 - b) * (255 - h) / 255, A = x < 128 ? 2 * x * d / 255 : 255 - 2 * (255 - x) * (255 - d) / 255;
        },
        "soft-light": function() {
          var H = l * _ / 255;
          E = H + _ * (255 - (255 - _) * (255 - l) / 255 - H) / 255, H = h * b / 255, L = H + b * (255 - (255 - b) * (255 - h) / 255 - H) / 255, H = d * x / 255, A = H + x * (255 - (255 - x) * (255 - d) / 255 - H) / 255;
        },
        "hard-light": function() {
          E = l < 128 ? 2 * l * _ / 255 : 255 - 2 * (255 - l) * (255 - _) / 255, L = h < 128 ? 2 * h * b / 255 : 255 - 2 * (255 - h) * (255 - b) / 255, A = d < 128 ? 2 * d * x / 255 : 255 - 2 * (255 - d) * (255 - x) / 255;
        },
        "color-dodge": function() {
          E = _ === 0 ? 0 : l === 255 ? 255 : i(255, 255 * _ / (255 - l)), L = b === 0 ? 0 : h === 255 ? 255 : i(255, 255 * b / (255 - h)), A = x === 0 ? 0 : d === 255 ? 255 : i(255, 255 * x / (255 - d));
        },
        "color-burn": function() {
          E = _ === 255 ? 255 : l === 0 ? 0 : n(0, 255 - (255 - _) * 255 / l), L = b === 255 ? 255 : h === 0 ? 0 : n(0, 255 - (255 - b) * 255 / h), A = x === 255 ? 255 : d === 0 ? 0 : n(0, 255 - (255 - x) * 255 / d);
        },
        darken: function() {
          E = _ < l ? _ : l, L = b < h ? b : h, A = x < d ? x : d;
        },
        lighten: function() {
          E = _ > l ? _ : l, L = b > h ? b : h, A = x > d ? x : d;
        },
        difference: function() {
          E = _ - l, E < 0 && (E = -E), L = b - h, L < 0 && (L = -L), A = x - d, A < 0 && (A = -A);
        },
        exclusion: function() {
          E = _ + l * (255 - _ - _) / 255, L = b + h * (255 - b - b) / 255, A = x + d * (255 - x - x) / 255;
        },
        hue: function() {
          B(l, h, d, F(_, b, x)), k(E, L, A, U(_, b, x));
        },
        saturation: function() {
          B(_, b, x, F(l, h, d)), k(E, L, A, U(_, b, x));
        },
        luminosity: function() {
          k(_, b, x, U(l, h, d));
        },
        color: function() {
          k(l, h, d, U(_, b, x));
        },
        add: function() {
          E = i(_ + l, 255), L = i(b + h, 255), A = i(x + d, 255);
        },
        subtract: function() {
          E = n(_ - l, 0), L = n(b - h, 0), A = n(x - d, 0);
        },
        average: function() {
          E = (_ + l) / 2, L = (b + h) / 2, A = (x + d) / 2;
        },
        negation: function() {
          E = 255 - s(255 - l - _), L = 255 - s(255 - h - b), A = 255 - s(255 - d - x);
        }
      }, C = this.nativeModes = a.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(H) {
        this[H] = !0;
      }, {}), P = dt.getContext(1, 1, { willReadFrequently: !0 });
      P && (a.each(R, function(H, W) {
        var V = W === "darken", Q = !1;
        P.save();
        try {
          P.fillStyle = V ? "#300" : "#a00", P.fillRect(0, 0, 1, 1), P.globalCompositeOperation = W, P.globalCompositeOperation === W && (P.fillStyle = V ? "#a00" : "#300", P.fillRect(0, 0, 1, 1), Q = P.getImageData(0, 0, 1, 1).data[0] !== V ? 170 : 51);
        } catch {
        }
        P.restore(), C[W] = Q;
      }), dt.release(P)), this.process = function(H, W, V, Q, ae) {
        var le = W.canvas, fe = H === "normal";
        if (fe || C[H])
          V.save(), V.setTransform(1, 0, 0, 1, 0, 0), V.globalAlpha = Q, fe || (V.globalCompositeOperation = H), V.drawImage(le, ae.x, ae.y), V.restore();
        else {
          var se = R[H];
          if (!se)
            return;
          for (var ge = V.getImageData(
            ae.x,
            ae.y,
            le.width,
            le.height
          ), me = ge.data, we = W.getImageData(
            0,
            0,
            le.width,
            le.height
          ).data, Se = 0, Ae = me.length; Se < Ae; Se += 4) {
            l = we[Se], _ = me[Se], h = we[Se + 1], b = me[Se + 1], d = we[Se + 2], x = me[Se + 2], m = we[Se + 3], T = me[Se + 3], se();
            var Ge = m * Q / 255, Je = 1 - Ge;
            me[Se] = Ge * E + Je * _, me[Se + 1] = Ge * L + Je * b, me[Se + 2] = Ge * A + Je * x, me[Se + 3] = m * Q + Je * T;
          }
          V.putImageData(ge, ae.x, ae.y);
        }
      };
    }(), wt = new function() {
      var i = "http://www.w3.org/2000/svg", n = "http://www.w3.org/2000/xmlns", s = "http://www.w3.org/1999/xlink", l = {
        href: s,
        xlink: n,
        xmlns: n + "/",
        "xmlns:xlink": n + "/"
      };
      function h(_, b, x) {
        return m(o.createElementNS(i, _), b, x);
      }
      function d(_, b) {
        var x = l[b], T = x ? _.getAttributeNS(x, b) : _.getAttribute(b);
        return T === "null" ? null : T;
      }
      function m(_, b, x) {
        for (var T in b) {
          var E = b[T], L = l[T];
          typeof E == "number" && x && (E = x.number(E)), L ? _.setAttributeNS(L, T, E) : _.setAttribute(T, E);
        }
        return _;
      }
      return {
        svg: i,
        xmlns: n,
        xlink: s,
        create: h,
        get: d,
        set: m
      };
    }(), Xt = a.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, n) {
        return !n && (i instanceof Gt || i instanceof ke || i instanceof $t);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, n) {
      var s = a.capitalize(n), l = i[2];
      this[n] = {
        type: i[1],
        property: n,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && a.each(l, function(h, d) {
          this[h] = d;
        }, {}),
        exportFilter: i[3],
        get: "get" + s,
        set: "set" + s
      };
    }, {});
    new function() {
      var i;
      function n(R, C, P) {
        var H = new a(), W = R.getTranslation();
        if (C) {
          var V;
          R.isInvertible() ? (R = R._shiftless(), V = R._inverseTransform(W), W = null) : V = new M(), H[P ? "cx" : "x"] = V.x, H[P ? "cy" : "y"] = V.y;
        }
        if (!R.isIdentity()) {
          var Q = R.decompose();
          if (Q) {
            var ae = [], le = Q.rotation, fe = Q.scaling, se = Q.skewing;
            W && !W.isZero() && ae.push("translate(" + i.point(W) + ")"), le && ae.push("rotate(" + i.number(le) + ")"), (!D.isZero(fe.x - 1) || !D.isZero(fe.y - 1)) && ae.push("scale(" + i.point(fe) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), H.transform = ae.join(" ");
          } else
            H.transform = "matrix(" + R.getValues().join(",") + ")";
        }
        return H;
      }
      function s(R, C) {
        for (var P = n(R._matrix), H = R._children, W = wt.create("g", P, i), V = 0, Q = H.length; V < Q; V++) {
          var ae = H[V], le = F(ae, C);
          if (le)
            if (ae.isClipMask()) {
              var fe = wt.create("clipPath");
              fe.appendChild(le), U(ae, fe, "clip"), wt.set(W, {
                "clip-path": "url(#" + fe.id + ")"
              });
            } else
              W.appendChild(le);
        }
        return W;
      }
      function l(R, C) {
        var P = n(R._matrix, !0), H = R.getSize(), W = R.getImage();
        return P.x -= H.width / 2, P.y -= H.height / 2, P.width = H.width, P.height = H.height, P.href = C.embedImages == !1 && W && W.src || R.toDataURL(), wt.create("image", P, i);
      }
      function h(R, C) {
        var P = C.matchShapes;
        if (P) {
          var H = R.toShape(!1);
          if (H)
            return d(H);
        }
        var W = R._segments, V = W.length, Q, ae = n(R._matrix);
        if (P && V >= 2 && !R.hasHandles())
          if (V > 2) {
            Q = R._closed ? "polygon" : "polyline";
            for (var le = [], fe = 0; fe < V; fe++)
              le.push(i.point(W[fe]._point));
            ae.points = le.join(" ");
          } else {
            Q = "line";
            var se = W[0]._point, ge = W[1]._point;
            ae.set({
              x1: se.x,
              y1: se.y,
              x2: ge.x,
              y2: ge.y
            });
          }
        else
          Q = "path", ae.d = R.getPathData(null, C.precision);
        return wt.create(Q, ae, i);
      }
      function d(R) {
        var C = R._type, P = R._radius, H = n(R._matrix, !0, C !== "rectangle");
        if (C === "rectangle") {
          C = "rect";
          var W = R._size, V = W.width, Q = W.height;
          H.x -= V / 2, H.y -= Q / 2, H.width = V, H.height = Q, P.isZero() && (P = null);
        }
        return P && (C === "circle" ? H.r = P : (H.rx = P.width, H.ry = P.height)), wt.create(C, H, i);
      }
      function m(R, C) {
        var P = n(R._matrix), H = R.getPathData(null, C.precision);
        return H && (P.d = H), wt.create("path", P, i);
      }
      function _(R, C) {
        var P = n(R._matrix, !0), H = R._definition, W = A(H, "symbol"), V = H._item, Q = V.getStrokeBounds();
        return W || (W = wt.create("symbol", {
          viewBox: i.rectangle(Q)
        }), W.appendChild(F(V, C)), U(H, W, "symbol")), P.href = "#" + W.id, P.x += Q.x, P.y += Q.y, P.width = Q.width, P.height = Q.height, P.overflow = "visible", wt.create("use", P, i);
      }
      function b(R) {
        var C = A(R, "color");
        if (!C) {
          var P = R.getGradient(), H = P._radial, W = R.getOrigin(), V = R.getDestination(), Q;
          if (H) {
            Q = {
              cx: W.x,
              cy: W.y,
              r: W.getDistance(V)
            };
            var ae = R.getHighlight();
            ae && (Q.fx = ae.x, Q.fy = ae.y);
          } else
            Q = {
              x1: W.x,
              y1: W.y,
              x2: V.x,
              y2: V.y
            };
          Q.gradientUnits = "userSpaceOnUse", C = wt.create((H ? "radial" : "linear") + "Gradient", Q, i);
          for (var le = P._stops, fe = 0, se = le.length; fe < se; fe++) {
            var ge = le[fe], me = ge._color, we = me.getAlpha(), Se = ge._offset;
            Q = {
              offset: Se ?? fe / (se - 1)
            }, me && (Q["stop-color"] = me.toCSS(!0)), we < 1 && (Q["stop-opacity"] = we), C.appendChild(
              wt.create("stop", Q, i)
            );
          }
          U(R, C, "color");
        }
        return "url(#" + C.id + ")";
      }
      function x(R) {
        var C = wt.create(
          "text",
          n(R._matrix, !0),
          i
        );
        return C.textContent = R._content, C;
      }
      var T = {
        Group: s,
        Layer: s,
        Raster: l,
        Path: h,
        Shape: d,
        CompoundPath: m,
        SymbolItem: _,
        PointText: x
      };
      function E(R, C, P) {
        var H = {}, W = !P && R.getParent(), V = [];
        return R._name != null && (H.id = R._name), a.each(Xt, function(Q) {
          var ae = Q.get, le = Q.type, fe = R[ae]();
          if (Q.exportFilter ? Q.exportFilter(R, fe) : !W || !a.equals(W[ae](), fe)) {
            if (le === "color" && fe != null) {
              var se = fe.getAlpha();
              se < 1 && (H[Q.attribute + "-opacity"] = se);
            }
            le === "style" ? V.push(Q.attribute + ": " + fe) : H[Q.attribute] = fe == null ? "none" : le === "color" ? fe.gradient ? b(fe) : fe.toCSS(!0) : le === "array" ? fe.join(",") : le === "lookup" ? Q.toSVG[fe] : fe;
          }
        }), V.length && (H.style = V.join(";")), H.opacity === 1 && delete H.opacity, R._visible || (H.visibility = "hidden"), wt.set(C, H, i);
      }
      var L;
      function A(R, C) {
        return L || (L = { ids: {}, svgs: {} }), R && L.svgs[C + "-" + (R._id || R.__id || (R.__id = Z.get("svg")))];
      }
      function U(R, C, P) {
        L || A();
        var H = L.ids[P] = (L.ids[P] || 0) + 1;
        C.id = P + "-" + H, L.svgs[P + "-" + (R._id || R.__id)] = C;
      }
      function k(R, C) {
        var P = R, H = null;
        if (L) {
          P = R.nodeName.toLowerCase() === "svg" && R;
          for (var W in L.svgs)
            H || (P || (P = wt.create("svg"), P.appendChild(R)), H = P.insertBefore(
              wt.create("defs"),
              P.firstChild
            )), H.appendChild(L.svgs[W]);
          L = null;
        }
        return C.asString ? new e.XMLSerializer().serializeToString(P) : P;
      }
      function F(R, C, P) {
        var H = T[R._class], W = H && H(R, C);
        if (W) {
          var V = C.onExport;
          V && (W = V(R, W, C) || W);
          var Q = JSON.stringify(R._data);
          Q && Q !== "{}" && Q !== "null" && W.setAttribute("data-paper-data", Q);
        }
        return W && E(R, W, P);
      }
      function B(R) {
        return R || (R = {}), i = new I(R.precision), R;
      }
      K.inject({
        exportSVG: function(R) {
          return R = B(R), k(F(this, R, !0), R);
        }
      }), ve.inject({
        exportSVG: function(R) {
          R = B(R);
          var C = this._children, P = this.getView(), H = a.pick(R.bounds, "view"), W = R.matrix || H === "view" && P._matrix, V = W && J.read([W]), Q = H === "view" ? new G([0, 0], P.getViewSize()) : H === "content" ? K._getBounds(C, V, { stroke: !0 }).rect : G.read([H], 0, { readNull: !0 }), ae = {
            version: "1.1",
            xmlns: wt.svg,
            "xmlns:xlink": wt.xlink
          };
          Q && (ae.width = Q.width, ae.height = Q.height, (Q.x || Q.x === 0 || Q.y || Q.y === 0) && (ae.viewBox = i.rectangle(Q)));
          var le = wt.create("svg", ae, i), fe = le;
          V && !V.isIdentity() && (fe = le.appendChild(wt.create(
            "g",
            n(V),
            i
          )));
          for (var se = 0, ge = C.length; se < ge; se++)
            fe.appendChild(F(C[se], R, !0));
          return k(le, R);
        }
      });
    }(), new function() {
      var i = {}, n;
      function s(C, P, H, W, V, Q) {
        var ae = wt.get(C, P) || Q, le = ae == null ? W ? null : H ? "" : 0 : H ? ae : parseFloat(ae);
        return /%\s*$/.test(ae) ? le / 100 * (V ? 1 : n[/x|^width/.test(P) ? "width" : "height"]) : le;
      }
      function l(C, P, H, W, V, Q, ae) {
        return P = s(C, P || "x", !1, W, V, Q), H = s(C, H || "y", !1, W, V, ae), W && (P == null || H == null) ? null : new M(P, H);
      }
      function h(C, P, H, W, V) {
        return P = s(C, P || "width", !1, W, V), H = s(C, H || "height", !1, W, V), W && (P == null || H == null) ? null : new Y(P, H);
      }
      function d(C, P, H) {
        return C === "none" ? null : P === "number" ? parseFloat(C) : P === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : P === "color" ? F(C) || C : P === "lookup" ? H[C] : C;
      }
      function m(C, P, H, W) {
        var V = C.childNodes, Q = P === "clippath", ae = P === "defs", le = new j(), fe = le._project, se = fe._currentStyle, ge = [];
        if (!Q && !ae && (le = k(le, C, W), fe._currentStyle = le._style.clone()), W)
          for (var me = C.querySelectorAll("defs"), we = 0, Se = me.length; we < Se; we++)
            B(me[we], H, !1);
        for (var we = 0, Se = V.length; we < Se; we++) {
          var Ae = V[we], Ge;
          Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = B(Ae, H, !1)) && !(Ge instanceof Be) && ge.push(Ge);
        }
        return le.addChildren(ge), Q && (le = k(le.reduce(), C, W)), fe._currentStyle = se, (Q || ae) && (le.remove(), le = null), le;
      }
      function _(C, P) {
        for (var H = C.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), W = [], V = 0, Q = H.length; V < Q; V += 2)
          W.push(new M(
            parseFloat(H[V]),
            parseFloat(H[V + 1])
          ));
        var ae = new it(W);
        return P === "polygon" && ae.closePath(), ae;
      }
      function b(C) {
        return Gt.create(C.getAttribute("d"));
      }
      function x(C, P) {
        var H = (s(C, "href", !0) || "").substring(1), W = P === "radialgradient", V;
        if (H)
          V = i[H].getGradient(), V._radial ^ W && (V = V.clone(), V._radial = W);
        else {
          for (var Q = C.childNodes, ae = [], le = 0, fe = Q.length; le < fe; le++) {
            var se = Q[le];
            se.nodeType === 1 && ae.push(k(new rn(), se));
          }
          V = new Ni(ae, W);
        }
        var ge, me, we, Se = s(C, "gradientUnits", !0) !== "userSpaceOnUse";
        W ? (ge = l(
          C,
          "cx",
          "cy",
          !1,
          Se,
          "50%",
          "50%"
        ), me = ge.add(
          s(C, "r", !1, !1, Se, "50%"),
          0
        ), we = l(C, "fx", "fy", !0, Se)) : (ge = l(
          C,
          "x1",
          "y1",
          !1,
          Se,
          "0%",
          "0%"
        ), me = l(
          C,
          "x2",
          "y2",
          !1,
          Se,
          "100%",
          "0%"
        ));
        var Ae = k(
          new At(V, ge, me, we),
          C
        );
        return Ae._scaleToBounds = Se, null;
      }
      var T = {
        "#document": function(C, P, H, W) {
          for (var V = C.childNodes, Q = 0, ae = V.length; Q < ae; Q++) {
            var le = V[Q];
            if (le.nodeType === 1)
              return B(le, H, W);
          }
        },
        g: m,
        svg: m,
        clippath: m,
        polygon: _,
        polyline: _,
        path: b,
        lineargradient: x,
        radialgradient: x,
        image: function(C) {
          var P = new $e(s(C, "href", !0));
          return P.on("load", function() {
            var H = h(C);
            this.setSize(H);
            var W = l(C).add(H.divide(2));
            this._matrix.append(new J().translate(W));
          }), P;
        },
        symbol: function(C, P, H, W) {
          return new Be(
            m(C, P, H, W),
            !0
          );
        },
        defs: m,
        use: function(C) {
          var P = (s(C, "href", !0) || "").substring(1), H = i[P], W = l(C);
          return H ? H instanceof Be ? H.place(W) : H.clone().translate(W) : null;
        },
        circle: function(C) {
          return new ke.Circle(
            l(C, "cx", "cy"),
            s(C, "r")
          );
        },
        ellipse: function(C) {
          return new ke.Ellipse({
            center: l(C, "cx", "cy"),
            radius: h(C, "rx", "ry")
          });
        },
        rect: function(C) {
          return new ke.Rectangle(new G(
            l(C),
            h(C)
          ), h(C, "rx", "ry"));
        },
        line: function(C) {
          return new it.Line(
            l(C, "x1", "y1"),
            l(C, "x2", "y2")
          );
        },
        text: function(C) {
          var P = new Kt(l(C).add(
            l(C, "dx", "dy")
          ));
          return P.setContent(C.textContent.trim() || ""), P;
        },
        switch: m
      };
      function E(C, P, H, W) {
        if (C.transform) {
          for (var V = (W.getAttribute(H) || "").split(/\)\s*/g), Q = new J(), ae = 0, le = V.length; ae < le; ae++) {
            var fe = V[ae];
            if (!fe)
              break;
            for (var se = fe.split(/\(\s*/), ge = se[0], me = se[1].split(/[\s,]+/g), we = 0, Se = me.length; we < Se; we++)
              me[we] = parseFloat(me[we]);
            switch (ge) {
              case "matrix":
                Q.append(
                  new J(me[0], me[1], me[2], me[3], me[4], me[5])
                );
                break;
              case "rotate":
                Q.rotate(me[0], me[1] || 0, me[2] || 0);
                break;
              case "translate":
                Q.translate(me[0], me[1] || 0);
                break;
              case "scale":
                Q.scale(me);
                break;
              case "skewX":
                Q.skew(me[0], 0);
                break;
              case "skewY":
                Q.skew(0, me[0]);
                break;
            }
          }
          C.transform(Q);
        }
      }
      function L(C, P, H) {
        var W = H === "fill-opacity" ? "getFillColor" : "getStrokeColor", V = C[W] && C[W]();
        V && V.setAlpha(parseFloat(P));
      }
      var A = a.set(a.each(Xt, function(C) {
        this[C.attribute] = function(P, H) {
          if (P[C.set] && (P[C.set](d(H, C.type, C.fromSVG)), C.type === "color")) {
            var W = P[C.get]();
            if (W && W._scaleToBounds) {
              var V = P.getBounds();
              W.transform(new J().translate(V.getPoint()).scale(V.getSize()));
            }
          }
        };
      }, {}), {
        id: function(C, P) {
          i[P] = C, C.setName && C.setName(P);
        },
        "clip-path": function(C, P) {
          var H = F(P);
          if (H)
            if (H = H.clone(), H.setClipMask(!0), C instanceof j)
              C.insertChild(0, H);
            else
              return new j(H, C);
        },
        gradientTransform: E,
        transform: E,
        "fill-opacity": L,
        "stroke-opacity": L,
        visibility: function(C, P) {
          C.setVisible && C.setVisible(P === "visible");
        },
        display: function(C, P) {
          C.setVisible && C.setVisible(P !== null);
        },
        "stop-color": function(C, P) {
          C.setColor && C.setColor(P);
        },
        "stop-opacity": function(C, P) {
          C._color && C._color.setAlpha(parseFloat(P));
        },
        offset: function(C, P) {
          if (C.setOffset) {
            var H = P.match(/(.*)%$/);
            C.setOffset(H ? H[1] / 100 : parseFloat(P));
          }
        },
        viewBox: function(C, P, H, W, V) {
          var Q = new G(d(P, "array")), ae = h(W, null, null, !0), le, fe;
          if (C instanceof j) {
            var se = ae ? ae.divide(Q.getSize()) : 1, fe = new J().scale(se).translate(Q.getPoint().negate());
            le = C;
          } else
            C instanceof Be && (ae && Q.setSize(ae), le = C._item);
          if (le) {
            if (U(W, "overflow", V) !== "visible") {
              var ge = new ke.Rectangle(Q);
              ge.setClipMask(!0), le.addChild(ge);
            }
            fe && le.transform(fe);
          }
        }
      });
      function U(C, P, H) {
        var W = C.attributes[P], V = W && W.value;
        if (!V && C.style) {
          var Q = a.camelize(P);
          V = C.style[Q], !V && H.node[Q] !== H.parent[Q] && (V = H.node[Q]);
        }
        return V ? V === "none" ? null : V : t;
      }
      function k(C, P, H) {
        var W = P.parentNode, V = {
          node: Wt.getStyles(P) || {},
          parent: !H && !/^defs$/i.test(W.tagName) && Wt.getStyles(W) || {}
        };
        return a.each(A, function(Q, ae) {
          var le = U(P, ae, V);
          C = le !== t && Q(C, le, ae, P, V) || C;
        }), C;
      }
      function F(C) {
        var P = C && C.match(/\((?:["'#]*)([^"')]+)/), H = P && P[1], W = H && i[r ? H.replace(r.location.href.split("#")[0] + "#", "") : H];
        return W && W._scaleToBounds && (W = W.clone(), W._scaleToBounds = !0), W;
      }
      function B(C, P, H) {
        var W = C.nodeName.toLowerCase(), V = W !== "#document", Q = o.body, ae, le, fe;
        H && V && (n = He.getView().getSize(), n = h(C, null, null, !0) || n, ae = wt.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), le = C.parentNode, fe = C.nextSibling, ae.appendChild(C), Q.appendChild(ae));
        var se = He.settings, ge = se.applyMatrix, me = se.insertItems;
        se.applyMatrix = !1, se.insertItems = !1;
        var we = T[W], Se = we && we(C, W, P, H) || null;
        if (se.insertItems = me, se.applyMatrix = ge, Se) {
          V && !(Se instanceof j) && (Se = k(Se, C, H));
          var Ae = P.onImport, Ge = V && C.getAttribute("data-paper-data");
          Ae && (Se = Ae(C, Se, P) || Se), P.expandShapes && Se instanceof ke && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
        }
        return ae && (Q.removeChild(ae), le && (fe ? le.insertBefore(C, fe) : le.appendChild(C))), H && (i = {}, Se && a.pick(P.applyMatrix, ge) && Se.matrix.apply(!0, !0)), Se;
      }
      function R(C, P, H) {
        if (!C)
          return null;
        P = typeof P == "function" ? { onLoad: P } : P || {};
        var W = He, V = null;
        function Q(se) {
          try {
            var ge = typeof se == "object" ? se : new e.DOMParser().parseFromString(
              se.trim(),
              "image/svg+xml"
            );
            if (!ge.nodeName)
              throw ge = null, new Error("Unsupported SVG source: " + C);
            He = W, V = B(ge, P, !0), (!P || P.insert !== !1) && H._insertItem(t, V);
            var me = P.onLoad;
            me && me(V, se);
          } catch (we) {
            ae(we);
          }
        }
        function ae(se, ge) {
          var me = P.onError;
          if (me)
            me(se, ge);
          else
            throw new Error(se);
        }
        if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
          var le = o.getElementById(C);
          le ? Q(le) : Bt.request({
            url: C,
            async: !0,
            onLoad: Q,
            onError: ae
          });
        } else if (typeof File < "u" && C instanceof File) {
          var fe = new FileReader();
          return fe.onload = function() {
            Q(fe.result);
          }, fe.onerror = function() {
            ae(fe.error);
          }, fe.readAsText(C);
        } else
          Q(C);
        return V;
      }
      K.inject({
        importSVG: function(C, P) {
          return R(C, P, this);
        }
      }), ve.inject({
        importSVG: function(C, P) {
          return this.activate(), R(C, P, this);
        }
      });
    }(), a.exports.PaperScript = (function() {
      var i = this, n = i.acorn;
      if (!n && typeof Xa < "u")
        try {
          n = ow();
        } catch {
        }
      if (!n) {
        var s, l;
        n = s = l = {}, function(k, F) {
          if (typeof s == "object" && typeof l == "object")
            return F(s);
          if (typeof t == "function" && t.amd)
            return t(["exports"], F);
          F(k.acorn || (k.acorn = {}));
        }(this, function(k) {
          k.version = "0.5.0";
          var F, B, R, C;
          k.parse = function(ee, oe) {
            return B = String(ee), R = B.length, H(oe), _e(), Js(F.program);
          };
          var P = k.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function H(ee) {
            F = ee || {};
            for (var oe in P)
              Object.prototype.hasOwnProperty.call(F, oe) || (F[oe] = P[oe]);
            C = F.sourceFile || null;
          }
          var W = k.getLineInfo = function(ee, oe) {
            for (var Me = 1, Ee = 0; ; ) {
              O.lastIndex = Ee;
              var at = O.exec(ee);
              if (at && at.index < oe)
                ++Me, Ee = at.index + at[0].length;
              else
                break;
            }
            return { line: Me, column: oe - Ee };
          };
          k.tokenize = function(ee, oe) {
            B = String(ee), R = B.length, H(oe), _e();
            var Me = {};
            function Ee(at) {
              return Ge = ae, fn(at), Me.start = Q, Me.end = ae, Me.startLoc = le, Me.endLoc = fe, Me.type = se, Me.value = ge, Me;
            }
            return Ee.jumpTo = function(at, Mt) {
              if (V = at, F.locations) {
                we = 1, Se = O.lastIndex = 0;
                for (var vt; (vt = O.exec(B)) && vt.index < at; )
                  ++we, Se = vt.index + vt[0].length;
              }
              me = Mt, Ke();
            }, Ee;
          };
          var V, Q, ae, le, fe, se, ge, me, we, Se, Ae, Ge, Je, tt, ft, Ne;
          function ze(ee, oe) {
            var Me = W(B, ee);
            oe += " (" + Me.line + ":" + Me.column + ")";
            var Ee = new SyntaxError(oe);
            throw Ee.pos = ee, Ee.loc = Me, Ee.raisedAt = V, Ee;
          }
          var nt = [], _t = { type: "num" }, mt = { type: "regexp" }, Pt = { type: "string" }, Et = { type: "name" }, zt = { type: "eof" }, jt = { keyword: "break" }, Ft = { keyword: "case", beforeExpr: !0 }, Mi = { keyword: "catch" }, Rt = { keyword: "continue" }, hi = { keyword: "debugger" }, ci = { keyword: "default" }, ni = { keyword: "do", isLoop: !0 }, di = { keyword: "else", beforeExpr: !0 }, Hi = { keyword: "finally" }, xi = { keyword: "for", isLoop: !0 }, qi = { keyword: "function" }, Ti = { keyword: "if" }, Ci = { keyword: "return", beforeExpr: !0 }, Xi = { keyword: "switch" }, Gi = { keyword: "throw", beforeExpr: !0 }, Ki = { keyword: "try" }, un = { keyword: "var" }, nn = { keyword: "while", isLoop: !0 }, Wn = { keyword: "with" }, ir = { keyword: "new", beforeExpr: !0 }, Tr = { keyword: "this" }, yr = { keyword: "null", atomValue: null }, In = { keyword: "true", atomValue: !0 }, nr = { keyword: "false", atomValue: !1 }, si = { keyword: "in", binop: 7, beforeExpr: !0 }, ur = {
            break: jt,
            case: Ft,
            catch: Mi,
            continue: Rt,
            debugger: hi,
            default: ci,
            do: ni,
            else: di,
            finally: Hi,
            for: xi,
            function: qi,
            if: Ti,
            return: Ci,
            switch: Xi,
            throw: Gi,
            try: Ki,
            var: un,
            while: nn,
            with: Wn,
            null: yr,
            true: In,
            false: nr,
            new: ir,
            in: si,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Tr,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Dn = { type: "[", beforeExpr: !0 }, Mn = { type: "]" }, gn = { type: "{", beforeExpr: !0 }, Cn = { type: "}" }, cn = { type: "(", beforeExpr: !0 }, Ji = { type: ")" }, g = { type: ",", beforeExpr: !0 }, z = { type: ";", beforeExpr: !0 }, ce = { type: ":", beforeExpr: !0 }, xe = { type: "." }, Pe = { type: "?", beforeExpr: !0 }, rt = { binop: 10, beforeExpr: !0 }, pt = { isAssign: !0, beforeExpr: !0 }, Dt = { isAssign: !0, beforeExpr: !0 }, qt = { postfix: !0, prefix: !0, isUpdate: !0 }, gi = { prefix: !0, beforeExpr: !0 }, vi = { binop: 1, beforeExpr: !0 }, ln = { binop: 2, beforeExpr: !0 }, cr = { binop: 3, beforeExpr: !0 }, Lr = { binop: 4, beforeExpr: !0 }, br = { binop: 5, beforeExpr: !0 }, Fr = { binop: 6, beforeExpr: !0 }, Fi = { binop: 7, beforeExpr: !0 }, Ri = { binop: 8, beforeExpr: !0 }, Ps = { binop: 9, prefix: !0, beforeExpr: !0 }, bs = { binop: 10, beforeExpr: !0 };
          k.tokTypes = {
            bracketL: Dn,
            bracketR: Mn,
            braceL: gn,
            braceR: Cn,
            parenL: cn,
            parenR: Ji,
            comma: g,
            semi: z,
            colon: ce,
            dot: xe,
            question: Pe,
            slash: rt,
            eq: pt,
            name: Et,
            eof: zt,
            num: _t,
            regexp: mt,
            string: Pt
          };
          for (var ls in ur)
            k.tokTypes["_" + ls] = ur[ls];
          function rr(ee) {
            ee = ee.split(" ");
            var oe = "", Me = [];
            e:
              for (var Ee = 0; Ee < ee.length; ++Ee) {
                for (var at = 0; at < Me.length; ++at)
                  if (Me[at][0].length == ee[Ee].length) {
                    Me[at].push(ee[Ee]);
                    continue e;
                  }
                Me.push([ee[Ee]]);
              }
            function Mt(Vt) {
              if (Vt.length == 1)
                return oe += "return str === " + JSON.stringify(Vt[0]) + ";";
              oe += "switch(str){";
              for (var Ei = 0; Ei < Vt.length; ++Ei)
                oe += "case " + JSON.stringify(Vt[Ei]) + ":";
              oe += "return true}return false;";
            }
            if (Me.length > 3) {
              Me.sort(function(Vt, Ei) {
                return Ei.length - Vt.length;
              }), oe += "switch(str.length){";
              for (var Ee = 0; Ee < Me.length; ++Ee) {
                var vt = Me[Ee];
                oe += "case " + vt[0].length + ":", Mt(vt);
              }
              oe += "}";
            } else
              Mt(ee);
            return new Function("str", oe);
          }
          var xs = rr("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), Ks = rr("class enum extends super const export import"), hs = rr("implements interface let package private protected public static yield"), Br = rr("eval arguments"), pn = rr("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), us = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Qn = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ns = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", Qr = new RegExp("[" + Qn + "]"), Zn = new RegExp("[" + Qn + Ns + "]"), w = /[\n\r\u2028\u2029]/, O = /\r\n|[\n\r\u2028\u2029]/g, q = k.isIdentifierStart = function(ee) {
            return ee < 65 ? ee === 36 : ee < 91 ? !0 : ee < 97 ? ee === 95 : ee < 123 ? !0 : ee >= 170 && Qr.test(String.fromCharCode(ee));
          }, ne = k.isIdentifierChar = function(ee) {
            return ee < 48 ? ee === 36 : ee < 58 ? !0 : ee < 65 ? !1 : ee < 91 ? !0 : ee < 97 ? ee === 95 : ee < 123 ? !0 : ee >= 170 && Zn.test(String.fromCharCode(ee));
          };
          function de() {
            this.line = we, this.column = V - Se;
          }
          function _e() {
            we = 1, V = Se = 0, me = !0, Ke();
          }
          function ye(ee, oe) {
            ae = V, F.locations && (fe = new de()), se = ee, Ke(), ge = oe, me = ee.beforeExpr;
          }
          function Ve() {
            var ee = F.onComment && F.locations && new de(), oe = V, Me = B.indexOf("*/", V += 2);
            if (Me === -1 && ze(V - 2, "Unterminated comment"), V = Me + 2, F.locations) {
              O.lastIndex = oe;
              for (var Ee; (Ee = O.exec(B)) && Ee.index < V; )
                ++we, Se = Ee.index + Ee[0].length;
            }
            F.onComment && F.onComment(
              !0,
              B.slice(oe + 2, Me),
              oe,
              V,
              ee,
              F.locations && new de()
            );
          }
          function De() {
            for (var ee = V, oe = F.onComment && F.locations && new de(), Me = B.charCodeAt(V += 2); V < R && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
              ++V, Me = B.charCodeAt(V);
            F.onComment && F.onComment(
              !1,
              B.slice(ee + 2, V),
              ee,
              V,
              oe,
              F.locations && new de()
            );
          }
          function Ke() {
            for (; V < R; ) {
              var ee = B.charCodeAt(V);
              if (ee === 32)
                ++V;
              else if (ee === 13) {
                ++V;
                var oe = B.charCodeAt(V);
                oe === 10 && ++V, F.locations && (++we, Se = V);
              } else if (ee === 10 || ee === 8232 || ee === 8233)
                ++V, F.locations && (++we, Se = V);
              else if (ee > 8 && ee < 14)
                ++V;
              else if (ee === 47) {
                var oe = B.charCodeAt(V + 1);
                if (oe === 42)
                  Ve();
                else if (oe === 47)
                  De();
                else
                  break;
              } else if (ee === 160)
                ++V;
              else if (ee >= 5760 && us.test(String.fromCharCode(ee)))
                ++V;
              else
                break;
            }
          }
          function St() {
            var ee = B.charCodeAt(V + 1);
            return ee >= 48 && ee <= 57 ? Wi(!0) : (++V, ye(xe));
          }
          function Ct() {
            var ee = B.charCodeAt(V + 1);
            return me ? (++V, Bi()) : ee === 61 ? pi(Dt, 2) : pi(rt, 1);
          }
          function ut() {
            var ee = B.charCodeAt(V + 1);
            return ee === 61 ? pi(Dt, 2) : pi(bs, 1);
          }
          function Ut(ee) {
            var oe = B.charCodeAt(V + 1);
            return oe === ee ? pi(ee === 124 ? vi : ln, 2) : oe === 61 ? pi(Dt, 2) : pi(ee === 124 ? cr : br, 1);
          }
          function ti() {
            var ee = B.charCodeAt(V + 1);
            return ee === 61 ? pi(Dt, 2) : pi(Lr, 1);
          }
          function wi(ee) {
            var oe = B.charCodeAt(V + 1);
            return oe === ee ? oe == 45 && B.charCodeAt(V + 2) == 62 && w.test(B.slice(Ge, V)) ? (V += 3, De(), Ke(), fn()) : pi(qt, 2) : oe === 61 ? pi(Dt, 2) : pi(Ps, 1);
          }
          function bi(ee) {
            var oe = B.charCodeAt(V + 1), Me = 1;
            return oe === ee ? (Me = ee === 62 && B.charCodeAt(V + 2) === 62 ? 3 : 2, B.charCodeAt(V + Me) === 61 ? pi(Dt, Me + 1) : pi(Ri, Me)) : oe == 33 && ee == 60 && B.charCodeAt(V + 2) == 45 && B.charCodeAt(V + 3) == 45 ? (V += 4, De(), Ke(), fn()) : (oe === 61 && (Me = B.charCodeAt(V + 2) === 61 ? 3 : 2), pi(Fi, Me));
          }
          function An(ee) {
            var oe = B.charCodeAt(V + 1);
            return oe === 61 ? pi(Fr, B.charCodeAt(V + 2) === 61 ? 3 : 2) : pi(ee === 61 ? pt : gi, 1);
          }
          function _n(ee) {
            switch (ee) {
              case 46:
                return St();
              case 40:
                return ++V, ye(cn);
              case 41:
                return ++V, ye(Ji);
              case 59:
                return ++V, ye(z);
              case 44:
                return ++V, ye(g);
              case 91:
                return ++V, ye(Dn);
              case 93:
                return ++V, ye(Mn);
              case 123:
                return ++V, ye(gn);
              case 125:
                return ++V, ye(Cn);
              case 58:
                return ++V, ye(ce);
              case 63:
                return ++V, ye(Pe);
              case 48:
                var oe = B.charCodeAt(V + 1);
                if (oe === 120 || oe === 88)
                  return Oi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return Wi(!1);
              case 34:
              case 39:
                return es(ee);
              case 47:
                return Ct();
              case 37:
              case 42:
                return ut();
              case 124:
              case 38:
                return Ut(ee);
              case 94:
                return ti();
              case 43:
              case 45:
                return wi(ee);
              case 60:
              case 62:
                return bi(ee);
              case 61:
              case 33:
                return An(ee);
              case 126:
                return pi(gi, 1);
            }
            return !1;
          }
          function fn(ee) {
            if (ee ? V = Q + 1 : Q = V, F.locations && (le = new de()), ee)
              return Bi();
            if (V >= R)
              return ye(zt);
            var oe = B.charCodeAt(V);
            if (q(oe) || oe === 92)
              return Un();
            var Me = _n(oe);
            if (Me === !1) {
              var Ee = String.fromCharCode(oe);
              if (Ee === "\\" || Qr.test(Ee))
                return Un();
              ze(V, "Unexpected character '" + Ee + "'");
            }
            return Me;
          }
          function pi(ee, oe) {
            var Me = B.slice(V, V + oe);
            V += oe, ye(ee, Me);
          }
          function Bi() {
            for (var at = "", ee, oe, Me = V; ; ) {
              V >= R && ze(Me, "Unterminated regular expression");
              var Ee = B.charAt(V);
              if (w.test(Ee) && ze(Me, "Unterminated regular expression"), ee)
                ee = !1;
              else {
                if (Ee === "[")
                  oe = !0;
                else if (Ee === "]" && oe)
                  oe = !1;
                else if (Ee === "/" && !oe)
                  break;
                ee = Ee === "\\";
              }
              ++V;
            }
            var at = B.slice(Me, V);
            ++V;
            var Mt = fr();
            Mt && !/^[gmsiy]*$/.test(Mt) && ze(Me, "Invalid regexp flag");
            try {
              var vt = new RegExp(at, Mt);
            } catch (Vt) {
              Vt instanceof SyntaxError && ze(Me, Vt.message), ze(Vt);
            }
            return ye(mt, vt);
          }
          function On(ee, oe) {
            for (var Me = V, Ee = 0, at = 0, Mt = oe ?? 1 / 0; at < Mt; ++at) {
              var vt = B.charCodeAt(V), Vt;
              if (vt >= 97 ? Vt = vt - 97 + 10 : vt >= 65 ? Vt = vt - 65 + 10 : vt >= 48 && vt <= 57 ? Vt = vt - 48 : Vt = 1 / 0, Vt >= ee)
                break;
              ++V, Ee = Ee * ee + Vt;
            }
            return V === Me || oe != null && V - Me !== oe ? null : Ee;
          }
          function Oi() {
            V += 2;
            var ee = On(16);
            return ee == null && ze(Q + 2, "Expected hexadecimal number"), q(B.charCodeAt(V)) && ze(V, "Identifier directly after number"), ye(_t, ee);
          }
          function Wi(ee) {
            var oe = V, Me = !1, Ee = B.charCodeAt(V) === 48;
            !ee && On(10) === null && ze(oe, "Invalid number"), B.charCodeAt(V) === 46 && (++V, On(10), Me = !0);
            var at = B.charCodeAt(V);
            (at === 69 || at === 101) && (at = B.charCodeAt(++V), (at === 43 || at === 45) && ++V, On(10) === null && ze(oe, "Invalid number"), Me = !0), q(B.charCodeAt(V)) && ze(V, "Identifier directly after number");
            var Mt = B.slice(oe, V), vt;
            return Me ? vt = parseFloat(Mt) : !Ee || Mt.length === 1 ? vt = parseInt(Mt, 10) : /[89]/.test(Mt) || Ne ? ze(oe, "Invalid number") : vt = parseInt(Mt, 8), ye(_t, vt);
          }
          function es(ee) {
            V++;
            for (var oe = ""; ; ) {
              V >= R && ze(Q, "Unterminated string constant");
              var Me = B.charCodeAt(V);
              if (Me === ee)
                return ++V, ye(Pt, oe);
              if (Me === 92) {
                Me = B.charCodeAt(++V);
                var Ee = /^[0-7]+/.exec(B.slice(V, V + 3));
                for (Ee && (Ee = Ee[0]); Ee && parseInt(Ee, 8) > 255; )
                  Ee = Ee.slice(0, -1);
                if (Ee === "0" && (Ee = null), ++V, Ee)
                  Ne && ze(V - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(Ee, 8)), V += Ee.length - 1;
                else
                  switch (Me) {
                    case 110:
                      oe += `
`;
                      break;
                    case 114:
                      oe += "\r";
                      break;
                    case 120:
                      oe += String.fromCharCode(sr(2));
                      break;
                    case 117:
                      oe += String.fromCharCode(sr(4));
                      break;
                    case 85:
                      oe += String.fromCharCode(sr(8));
                      break;
                    case 116:
                      oe += "	";
                      break;
                    case 98:
                      oe += "\b";
                      break;
                    case 118:
                      oe += "\v";
                      break;
                    case 102:
                      oe += "\f";
                      break;
                    case 48:
                      oe += "\0";
                      break;
                    case 13:
                      B.charCodeAt(V) === 10 && ++V;
                    case 10:
                      F.locations && (Se = V, ++we);
                      break;
                    default:
                      oe += String.fromCharCode(Me);
                      break;
                  }
              } else
                (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && ze(Q, "Unterminated string constant"), oe += String.fromCharCode(Me), ++V;
            }
          }
          function sr(ee) {
            var oe = On(16, ee);
            return oe === null && ze(Q, "Bad character escape sequence"), oe;
          }
          var mn;
          function fr() {
            mn = !1;
            for (var ee, oe = !0, Me = V; ; ) {
              var Ee = B.charCodeAt(V);
              if (ne(Ee))
                mn && (ee += B.charAt(V)), ++V;
              else if (Ee === 92) {
                mn || (ee = B.slice(Me, V)), mn = !0, B.charCodeAt(++V) != 117 && ze(V, "Expecting Unicode escape sequence \\uXXXX"), ++V;
                var at = sr(4), Mt = String.fromCharCode(at);
                Mt || ze(V - 1, "Invalid Unicode escape"), (oe ? q(at) : ne(at)) || ze(V - 4, "Invalid Unicode escape"), ee += Mt;
              } else
                break;
              oe = !1;
            }
            return mn ? ee : B.slice(Me, V);
          }
          function Un() {
            var ee = fr(), oe = Et;
            return !mn && pn(ee) && (oe = ur[ee]), ye(oe, ee);
          }
          function Jt() {
            Ae = Q, Ge = ae, Je = fe, fn();
          }
          function qn(ee) {
            if (Ne = ee, V = Q, F.locations)
              for (; V < Se; )
                Se = B.lastIndexOf(`
`, Se - 2) + 1, --we;
            Ke(), fn();
          }
          function Pn() {
            this.type = null, this.start = Q, this.end = null;
          }
          function Er() {
            this.start = le, this.end = null, C !== null && (this.source = C);
          }
          function Si() {
            var ee = new Pn();
            return F.locations && (ee.loc = new Er()), F.directSourceFile && (ee.sourceFile = F.directSourceFile), F.ranges && (ee.range = [Q, 0]), ee;
          }
          function sn(ee) {
            var oe = new Pn();
            return oe.start = ee.start, F.locations && (oe.loc = new Er(), oe.loc.start = ee.loc.start), F.ranges && (oe.range = [ee.range[0], 0]), oe;
          }
          function Yt(ee, oe) {
            return ee.type = oe, ee.end = Ge, F.locations && (ee.loc.end = Je), F.ranges && (ee.range[1] = Ge), ee;
          }
          function kr(ee) {
            return F.ecmaVersion >= 5 && ee.type === "ExpressionStatement" && ee.expression.type === "Literal" && ee.expression.value === "use strict";
          }
          function ai(ee) {
            if (se === ee)
              return Jt(), !0;
          }
          function Pi() {
            return !F.strictSemicolons && (se === zt || se === Cn || w.test(B.slice(Ge, Q)));
          }
          function Tn() {
            !ai(z) && !Pi() && dn();
          }
          function oi(ee) {
            se === ee ? Jt() : dn();
          }
          function dn() {
            ze(Q, "Unexpected token");
          }
          function Ir(ee) {
            ee.type !== "Identifier" && ee.type !== "MemberExpression" && ze(ee.start, "Assigning to rvalue"), Ne && ee.type === "Identifier" && Br(ee.name) && ze(ee.start, "Assigning to " + ee.name + " in strict mode");
          }
          function Js(ee) {
            Ae = Ge = V, F.locations && (Je = new de()), tt = Ne = null, ft = [], fn();
            var oe = ee || Si(), Me = !0;
            for (ee || (oe.body = []); se !== zt; ) {
              var Ee = hn();
              oe.body.push(Ee), Me && kr(Ee) && qn(!0), Me = !1;
            }
            return Yt(oe, "Program");
          }
          var Ur = { kind: "loop" }, Xn = { kind: "switch" };
          function hn() {
            (se === rt || se === Dt && ge == "/=") && fn(!0);
            var ee = se, oe = Si();
            switch (ee) {
              case jt:
              case Rt:
                Jt();
                var Me = ee === jt;
                ai(z) || Pi() ? oe.label = null : se !== Et ? dn() : (oe.label = Ye(), Tn());
                for (var Ee = 0; Ee < ft.length; ++Ee) {
                  var at = ft[Ee];
                  if ((oe.label == null || at.name === oe.label.name) && (at.kind != null && (Me || at.kind === "loop") || oe.label && Me))
                    break;
                }
                return Ee === ft.length && ze(oe.start, "Unsyntactic " + ee.keyword), Yt(oe, Me ? "BreakStatement" : "ContinueStatement");
              case hi:
                return Jt(), Tn(), Yt(oe, "DebuggerStatement");
              case ni:
                return Jt(), ft.push(Ur), oe.body = hn(), ft.pop(), oi(nn), oe.test = Nn(), Tn(), Yt(oe, "DoWhileStatement");
              case xi:
                if (Jt(), ft.push(Ur), oi(cn), se === z)
                  return ar(oe, null);
                if (se === un) {
                  var Mt = Si();
                  return Jt(), dr(Mt, !0), Yt(Mt, "VariableDeclaration"), Mt.declarations.length === 1 && ai(si) ? Yn(oe, Mt) : ar(oe, Mt);
                }
                var Mt = Ui(!1, !0);
                return ai(si) ? (Ir(Mt), Yn(oe, Mt)) : ar(oe, Mt);
              case qi:
                return Jt(), Le(oe, !0);
              case Ti:
                return Jt(), oe.test = Nn(), oe.consequent = hn(), oe.alternate = ai(di) ? hn() : null, Yt(oe, "IfStatement");
              case Ci:
                return !tt && !F.allowReturnOutsideFunction && ze(Q, "'return' outside of function"), Jt(), ai(z) || Pi() ? oe.argument = null : (oe.argument = Ui(), Tn()), Yt(oe, "ReturnStatement");
              case Xi:
                Jt(), oe.discriminant = Nn(), oe.cases = [], oi(gn), ft.push(Xn);
                for (var vt, Vt; se != Cn; )
                  if (se === Ft || se === ci) {
                    var Ei = se === Ft;
                    vt && Yt(vt, "SwitchCase"), oe.cases.push(vt = Si()), vt.consequent = [], Jt(), Ei ? vt.test = Ui() : (Vt && ze(Ae, "Multiple default clauses"), Vt = !0, vt.test = null), oi(ce);
                  } else
                    vt || dn(), vt.consequent.push(hn());
                return vt && Yt(vt, "SwitchCase"), Jt(), ft.pop(), Yt(oe, "SwitchStatement");
              case Gi:
                return Jt(), w.test(B.slice(Ge, Q)) && ze(Ge, "Illegal newline after throw"), oe.argument = Ui(), Tn(), Yt(oe, "ThrowStatement");
              case Ki:
                if (Jt(), oe.block = Kn(), oe.handler = null, se === Mi) {
                  var $i = Si();
                  Jt(), oi(cn), $i.param = Ye(), Ne && Br($i.param.name) && ze($i.param.start, "Binding " + $i.param.name + " in strict mode"), oi(Ji), $i.guard = null, $i.body = Kn(), oe.handler = Yt($i, "CatchClause");
                }
                return oe.guardedHandlers = nt, oe.finalizer = ai(Hi) ? Kn() : null, !oe.handler && !oe.finalizer && ze(oe.start, "Missing catch or finally clause"), Yt(oe, "TryStatement");
              case un:
                return Jt(), dr(oe), Tn(), Yt(oe, "VariableDeclaration");
              case nn:
                return Jt(), oe.test = Nn(), ft.push(Ur), oe.body = hn(), ft.pop(), Yt(oe, "WhileStatement");
              case Wn:
                return Ne && ze(Q, "'with' in strict mode"), Jt(), oe.object = Nn(), oe.body = hn(), Yt(oe, "WithStatement");
              case gn:
                return Kn();
              case z:
                return Jt(), Yt(oe, "EmptyStatement");
              default:
                var vn = ge, wn = Ui();
                if (ee === Et && wn.type === "Identifier" && ai(ce)) {
                  for (var Ee = 0; Ee < ft.length; ++Ee)
                    ft[Ee].name === vn && ze(wn.start, "Label '" + vn + "' is already declared");
                  var gr = se.isLoop ? "loop" : se === Xi ? "switch" : null;
                  return ft.push({ name: vn, kind: gr }), oe.body = hn(), ft.pop(), oe.label = wn, Yt(oe, "LabeledStatement");
                } else
                  return oe.expression = wn, Tn(), Yt(oe, "ExpressionStatement");
            }
          }
          function Nn() {
            oi(cn);
            var ee = Ui();
            return oi(Ji), ee;
          }
          function Kn(ee) {
            var oe = Si(), Me = !0, Ee = !1, at;
            for (oe.body = [], oi(gn); !ai(Cn); ) {
              var Mt = hn();
              oe.body.push(Mt), Me && ee && kr(Mt) && (at = Ee, qn(Ee = !0)), Me = !1;
            }
            return Ee && !at && qn(!1), Yt(oe, "BlockStatement");
          }
          function ar(ee, oe) {
            return ee.init = oe, oi(z), ee.test = se === z ? null : Ui(), oi(z), ee.update = se === Ji ? null : Ui(), oi(Ji), ee.body = hn(), ft.pop(), Yt(ee, "ForStatement");
          }
          function Yn(ee, oe) {
            return ee.left = oe, ee.right = Ui(), oi(Ji), ee.body = hn(), ft.pop(), Yt(ee, "ForInStatement");
          }
          function dr(ee, oe) {
            for (ee.declarations = [], ee.kind = "var"; ; ) {
              var Me = Si();
              if (Me.id = Ye(), Ne && Br(Me.id.name) && ze(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = ai(pt) ? Ui(!0, oe) : null, ee.declarations.push(Yt(Me, "VariableDeclarator")), !ai(g))
                break;
            }
            return ee;
          }
          function Ui(ee, oe) {
            var Me = ts(oe);
            if (!ee && se === g) {
              var Ee = sn(Me);
              for (Ee.expressions = [Me]; ai(g); )
                Ee.expressions.push(ts(oe));
              return Yt(Ee, "SequenceExpression");
            }
            return Me;
          }
          function ts(ee) {
            var oe = cs(ee);
            if (se.isAssign) {
              var Me = sn(oe);
              return Me.operator = ge, Me.left = oe, Jt(), Me.right = ts(ee), Ir(oe), Yt(Me, "AssignmentExpression");
            }
            return oe;
          }
          function cs(ee) {
            var oe = xr(ee);
            if (ai(Pe)) {
              var Me = sn(oe);
              return Me.test = oe, Me.consequent = Ui(!0), oi(ce), Me.alternate = Ui(!0, ee), Yt(Me, "ConditionalExpression");
            }
            return oe;
          }
          function xr(ee) {
            return Ln(Vr(), -1, ee);
          }
          function Ln(ee, oe, Me) {
            var Ee = se.binop;
            if (Ee != null && (!Me || se !== si) && Ee > oe) {
              var at = sn(ee);
              at.left = ee, at.operator = ge;
              var Mt = se;
              Jt(), at.right = Ln(Vr(), Ee, Me);
              var vt = Yt(at, Mt === vi || Mt === ln ? "LogicalExpression" : "BinaryExpression");
              return Ln(vt, oe, Me);
            }
            return ee;
          }
          function Vr() {
            if (se.prefix) {
              var ee = Si(), oe = se.isUpdate;
              return ee.operator = ge, ee.prefix = !0, me = !0, Jt(), ee.argument = Vr(), oe ? Ir(ee.argument) : Ne && ee.operator === "delete" && ee.argument.type === "Identifier" && ze(ee.start, "Deleting local variable in strict mode"), Yt(ee, oe ? "UpdateExpression" : "UnaryExpression");
            }
            for (var Me = ws(); se.postfix && !Pi(); ) {
              var ee = sn(Me);
              ee.operator = ge, ee.prefix = !1, ee.argument = Me, Ir(Me), Jt(), Me = Yt(ee, "UpdateExpression");
            }
            return Me;
          }
          function ws() {
            return or(Oe());
          }
          function or(ee, oe) {
            if (ai(xe)) {
              var Me = sn(ee);
              return Me.object = ee, Me.property = Ye(!0), Me.computed = !1, or(Yt(Me, "MemberExpression"), oe);
            } else if (ai(Dn)) {
              var Me = sn(ee);
              return Me.object = ee, Me.property = Ui(), Me.computed = !0, oi(Mn), or(Yt(Me, "MemberExpression"), oe);
            } else if (!oe && ai(cn)) {
              var Me = sn(ee);
              return Me.callee = ee, Me.arguments = je(Ji, !1), or(Yt(Me, "CallExpression"), oe);
            } else
              return ee;
          }
          function Oe() {
            switch (se) {
              case Tr:
                var Ee = Si();
                return Jt(), Yt(Ee, "ThisExpression");
              case Et:
                return Ye();
              case _t:
              case Pt:
              case mt:
                var Ee = Si();
                return Ee.value = ge, Ee.raw = B.slice(Q, ae), Jt(), Yt(Ee, "Literal");
              case yr:
              case In:
              case nr:
                var Ee = Si();
                return Ee.value = se.atomValue, Ee.raw = se.keyword, Jt(), Yt(Ee, "Literal");
              case cn:
                var ee = le, oe = Q;
                Jt();
                var Me = Ui();
                return Me.start = oe, Me.end = ae, F.locations && (Me.loc.start = ee, Me.loc.end = fe), F.ranges && (Me.range = [oe, ae]), oi(Ji), Me;
              case Dn:
                var Ee = Si();
                return Jt(), Ee.elements = je(Mn, !0, !0), Yt(Ee, "ArrayExpression");
              case gn:
                return ht();
              case qi:
                var Ee = Si();
                return Jt(), Le(Ee, !1);
              case ir:
                return qe();
              default:
                dn();
            }
          }
          function qe() {
            var ee = Si();
            return Jt(), ee.callee = or(Oe(), !0), ai(cn) ? ee.arguments = je(Ji, !1) : ee.arguments = nt, Yt(ee, "NewExpression");
          }
          function ht() {
            var ee = Si(), oe = !0, Me = !1;
            for (ee.properties = [], Jt(); !ai(Cn); ) {
              if (oe)
                oe = !1;
              else if (oi(g), F.allowTrailingCommas && ai(Cn))
                break;
              var Ee = { key: gt() }, at = !1, Mt;
              if (ai(ce) ? (Ee.value = Ui(!0), Mt = Ee.kind = "init") : F.ecmaVersion >= 5 && Ee.key.type === "Identifier" && (Ee.key.name === "get" || Ee.key.name === "set") ? (at = Me = !0, Mt = Ee.kind = Ee.key.name, Ee.key = gt(), se !== cn && dn(), Ee.value = Le(Si(), !1)) : dn(), Ee.key.type === "Identifier" && (Ne || Me))
                for (var vt = 0; vt < ee.properties.length; ++vt) {
                  var Vt = ee.properties[vt];
                  if (Vt.key.name === Ee.key.name) {
                    var Ei = Mt == Vt.kind || at && Vt.kind === "init" || Mt === "init" && (Vt.kind === "get" || Vt.kind === "set");
                    Ei && !Ne && Mt === "init" && Vt.kind === "init" && (Ei = !1), Ei && ze(Ee.key.start, "Redefinition of property");
                  }
                }
              ee.properties.push(Ee);
            }
            return Yt(ee, "ObjectExpression");
          }
          function gt() {
            return se === _t || se === Pt ? Oe() : Ye(!0);
          }
          function Le(ee, oe) {
            se === Et ? ee.id = Ye() : oe ? dn() : ee.id = null, ee.params = [];
            var Me = !0;
            for (oi(cn); !ai(Ji); )
              Me ? Me = !1 : oi(g), ee.params.push(Ye());
            var Ee = tt, at = ft;
            if (tt = !0, ft = [], ee.body = Kn(!0), tt = Ee, ft = at, Ne || ee.body.body.length && kr(ee.body.body[0]))
              for (var Mt = ee.id ? -1 : 0; Mt < ee.params.length; ++Mt) {
                var vt = Mt < 0 ? ee.id : ee.params[Mt];
                if ((hs(vt.name) || Br(vt.name)) && ze(vt.start, "Defining '" + vt.name + "' in strict mode"), Mt >= 0)
                  for (var Vt = 0; Vt < Mt; ++Vt)
                    vt.name === ee.params[Vt].name && ze(vt.start, "Argument name clash in strict mode");
              }
            return Yt(ee, oe ? "FunctionDeclaration" : "FunctionExpression");
          }
          function je(ee, oe, Me) {
            for (var Ee = [], at = !0; !ai(ee); ) {
              if (at)
                at = !1;
              else if (oi(g), oe && F.allowTrailingCommas && ai(ee))
                break;
              Me && se === g ? Ee.push(null) : Ee.push(Ui(!0));
            }
            return Ee;
          }
          function Ye(ee) {
            var oe = Si();
            return ee && F.forbidReserved == "everywhere" && (ee = !1), se === Et ? (!ee && (F.forbidReserved && (F.ecmaVersion === 3 ? xs : Ks)(ge) || Ne && hs(ge)) && B.slice(Q, ae).indexOf("\\") == -1 && ze(Q, "The keyword '" + ge + "' is reserved"), oe.name = ge) : ee && se.keyword ? oe.name = se.keyword : dn(), me = !1, Jt(), Yt(oe, "Identifier");
          }
        }), n.version || (n = null);
      }
      function h(k, F) {
        return (i.acorn || n).parse(k, F);
      }
      var d = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, m = {
        "-": "__negate",
        "+": "__self"
      }, _ = a.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(k) {
          this["__" + k] = "#" + k;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      M.inject(_), Y.inject(_), At.inject(_);
      function b(k, F, B) {
        var R = d[F];
        if (k && k[R]) {
          var C = k[R](B);
          return F === "!=" ? !C : C;
        }
        switch (F) {
          case "+":
            return k + B;
          case "-":
            return k - B;
          case "*":
            return k * B;
          case "/":
            return k / B;
          case "%":
            return k % B;
          case "==":
            return k == B;
          case "!=":
            return k != B;
        }
      }
      function x(k, F) {
        var B = m[k];
        if (F && F[B])
          return F[B]();
        switch (k) {
          case "+":
            return +F;
          case "-":
            return -F;
        }
      }
      function T(k, F) {
        if (!k)
          return "";
        F = F || {};
        var B = [];
        function R(Ne) {
          for (var ze = 0, nt = B.length; ze < nt; ze++) {
            var _t = B[ze];
            if (_t[0] >= Ne)
              break;
            Ne += _t[1];
          }
          return Ne;
        }
        function C(Ne) {
          return k.substring(
            R(Ne.range[0]),
            R(Ne.range[1])
          );
        }
        function P(Ne, ze) {
          return k.substring(
            R(Ne.range[1]),
            R(ze.range[0])
          );
        }
        function H(Ne, ze) {
          for (var nt = R(Ne.range[0]), _t = R(Ne.range[1]), mt = 0, Pt = B.length - 1; Pt >= 0; Pt--)
            if (nt > B[Pt][0]) {
              mt = Pt + 1;
              break;
            }
          B.splice(mt, 0, [nt, ze.length - _t + nt]), k = k.substring(0, nt) + ze + k.substring(_t);
        }
        function W(Ne, ze) {
          switch (Ne.type) {
            case "UnaryExpression":
              if (Ne.operator in m && Ne.argument.type !== "Literal") {
                var nt = C(Ne.argument);
                H(Ne, '$__("' + Ne.operator + '", ' + nt + ")");
              }
              break;
            case "BinaryExpression":
              if (Ne.operator in d && Ne.left.type !== "Literal") {
                var _t = C(Ne.left), mt = C(Ne.right), Pt = P(Ne.left, Ne.right), Et = Ne.operator;
                H(Ne, "__$__(" + _t + "," + Pt.replace(
                  new RegExp("\\" + Et),
                  '"' + Et + '"'
                ) + ", " + mt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var zt = ze && ze.type;
              if (!(zt === "ForStatement" || zt === "BinaryExpression" && /^[=!<>]/.test(ze.operator) || zt === "MemberExpression" && ze.computed)) {
                if (Ne.type === "UpdateExpression") {
                  var nt = C(Ne.argument), jt = "__$__(" + nt + ', "' + Ne.operator[0] + '", 1)', Ft = nt + " = " + jt;
                  Ne.prefix ? Ft = "(" + Ft + ")" : (zt === "AssignmentExpression" || zt === "VariableDeclarator" || zt === "BinaryExpression") && (C(ze.left || ze.id) === nt && (Ft = jt), Ft = nt + "; " + Ft), H(Ne, Ft);
                } else if (/^.=$/.test(Ne.operator) && Ne.left.type !== "Literal") {
                  var _t = C(Ne.left), mt = C(Ne.right), jt = _t + " = __$__(" + _t + ', "' + Ne.operator[0] + '", ' + mt + ")";
                  H(Ne, /^\(.*\)$/.test(C(Ne)) ? "(" + jt + ")" : jt);
                }
              }
              break;
          }
        }
        function V(Ne) {
          switch (Ne.type) {
            case "ExportDefaultDeclaration":
              H({
                range: [Ne.start, Ne.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var ze = Ne.declaration, nt = Ne.specifiers;
              if (ze) {
                var _t = ze.declarations;
                _t && (_t.forEach(function(Pt) {
                  H(Pt, "module.exports." + C(Pt));
                }), H({
                  range: [
                    Ne.start,
                    ze.start + ze.kind.length
                  ]
                }, ""));
              } else if (nt) {
                var mt = nt.map(function(Pt) {
                  var Et = C(Pt);
                  return "module.exports." + Et + " = " + Et + "; ";
                }).join("");
                mt && H(Ne, mt);
              }
              break;
          }
        }
        function Q(Ne, ze, nt) {
          if (Ne) {
            for (var _t in Ne)
              if (_t !== "range" && _t !== "loc") {
                var mt = Ne[_t];
                if (Array.isArray(mt))
                  for (var Pt = 0, Et = mt.length; Pt < Et; Pt++)
                    Q(mt[Pt], Ne, nt);
                else
                  mt && typeof mt == "object" && Q(mt, Ne, nt);
              }
            nt.operatorOverloading !== !1 && W(Ne, ze), nt.moduleExports !== !1 && V(Ne);
          }
        }
        function ae(Ne) {
          var ze = "", nt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Ne = (Math.abs(Ne) << 1) + (Ne < 0 ? 1 : 0); Ne || !ze; ) {
            var _t = Ne & 31;
            Ne >>= 5, Ne && (_t |= 32), ze += nt[_t];
          }
          return ze;
        }
        var le = F.url || "", fe = F.sourceMaps, se = F.paperFeatures || {}, ge = F.source || k, me = F.offset || 0, we = He.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, Je;
        if (fe && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
          if (we.node)
            me -= 2;
          else if (r && le && !r.location.href.indexOf(le)) {
            var tt = o.getElementsByTagName("html")[0].innerHTML;
            me = tt.substr(0, tt.indexOf(k) + 1).match(
              Ge
            ).length + 1;
          }
          Ae = me > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
          var ft = ["AA" + ae(Ae ? 0 : me) + "A"];
          ft.length = (k.match(Ge) || []).length + 1 + (Ae ? me : 0), Je = {
            version: 3,
            file: le,
            names: [],
            mappings: ft.join(";AACA"),
            sourceRoot: "",
            sources: [le],
            sourcesContent: [ge]
          };
        }
        return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && Q(h(k, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, se), Je && (Ae && (k = new Array(me + 1).join(`
`) + k), /^(inline|both)$/.test(fe) && (k += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(Je)
        )))), k += `
//# sourceURL=` + (le || "paperscript")), {
          url: le,
          source: ge,
          code: k,
          map: Je
        };
      }
      function E(k, F, B) {
        He = F;
        var R = F.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(k) && !/\bnew\s+Tool\b/.test(k) ? new Ie() : null, P = C ? C._events : [], H = ["onFrame", "onResize"].concat(P), W = [], V = [], Q, ae = typeof k == "object" ? k : T(k, B);
        k = ae.code;
        function le(Se, Ae) {
          for (var Ge in Se)
            (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(k) && (W.push(Ge), V.push(Se[Ge]));
        }
        le(
          { __$__: b, $__: x, paper: F, tool: C },
          !0
        ), le(F), k = "var module = { exports: {} }; " + k;
        var me = a.each(H, function(Se) {
          new RegExp("\\s+" + Se + "\\b").test(k) && (W.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
        }, []).join(`
`);
        me && (k += `
` + me), k += `
return module.exports;`;
        var fe = He.agent;
        if (o && (fe.chrome || fe.firefox && fe.versionNumber < 40)) {
          var se = o.createElement("script"), ge = o.head || o.getElementsByTagName("head")[0];
          fe.firefox && (k = `
` + k), se.appendChild(o.createTextNode(
            "document.__paperscript__ = function(" + W + ") {" + k + `
}`
          )), ge.appendChild(se), Q = o.__paperscript__, delete o.__paperscript__, ge.removeChild(se);
        } else
          Q = Function(W, k);
        var me = Q && Q.apply(F, V), we = me || {};
        return a.each(P, function(Se) {
          var Ae = we[Se];
          Ae && (C[Se] = Ae);
        }), R && (we.onResize && R.setOnResize(we.onResize), R.emit("resize", {
          size: R.size,
          delta: new M()
        }), we.onFrame && R.setOnFrame(we.onFrame), R.requestUpdate()), me;
      }
      function L(k) {
        if (/^text\/(?:x-|)paperscript$/.test(k.type) && f.getAttribute(k, "ignore") !== "true") {
          var F = f.getAttribute(k, "canvas"), B = o.getElementById(F), R = k.src || k.getAttribute("data-src"), C = f.hasAttribute(k, "async"), P = "data-paper-scope";
          if (!B)
            throw new Error('Unable to find canvas with id "' + F + '"');
          var H = f.get(B.getAttribute(P)) || new f().setup(B);
          return B.setAttribute(P, H._id), R ? Bt.request({
            url: R,
            async: C,
            mimeType: "text/plain",
            onLoad: function(W) {
              E(W, H, R);
            }
          }) : E(k.innerHTML, H, k.baseURI), k.setAttribute("data-paper-ignore", "true"), H;
        }
      }
      function A() {
        a.each(
          o && o.getElementsByTagName("script"),
          L
        );
      }
      function U(k) {
        return k ? L(k) : A();
      }
      return r && (o.readyState === "complete" ? setTimeout(A) : Qt.add(r, { load: A })), {
        compile: T,
        execute: E,
        load: U,
        parse: h,
        calculateBinary: b,
        calculateUnary: x
      };
    }).call(this);
    var He = new (f.inject(a.exports, {
      Base: a,
      Numerical: D,
      Key: Tt,
      DomEvent: Qt,
      DomElement: Wt,
      document: o,
      window: r,
      Symbol: Be,
      PlacedSymbol: Lt
    }))();
    return He.agent.node && Pf(He), typeof t == "function" && t.amd ? t("paper", He) : y && (y.exports = He), He;
  }).call(Kr, typeof self == "object" ? self : null);
})($d);
var lw = $d.exports;
const hw = /* @__PURE__ */ iu(lw);
function uw(y) {
  if (y && !(typeof window > "u")) {
    var e = document.createElement("style");
    return e.setAttribute("type", "text/css"), e.innerHTML = y, document.head.appendChild(e), y;
  }
}
function Ma(y, e) {
  var t = y.__state.conversionName.toString(), r = Math.round(y.r), o = Math.round(y.g), a = Math.round(y.b), u = y.a, f = Math.round(y.h), v = y.s.toFixed(1), S = y.v.toFixed(1);
  if (e || t === "THREE_CHAR_HEX" || t === "SIX_CHAR_HEX") {
    for (var I = y.hex.toString(16); I.length < 6; )
      I = "0" + I;
    return "#" + I;
  } else {
    if (t === "CSS_RGB")
      return "rgb(" + r + "," + o + "," + a + ")";
    if (t === "CSS_RGBA")
      return "rgba(" + r + "," + o + "," + a + "," + u + ")";
    if (t === "HEX")
      return "0x" + y.hex.toString(16);
    if (t === "RGB_ARRAY")
      return "[" + r + "," + o + "," + a + "]";
    if (t === "RGBA_ARRAY")
      return "[" + r + "," + o + "," + a + "," + u + "]";
    if (t === "RGB_OBJ")
      return "{r:" + r + ",g:" + o + ",b:" + a + "}";
    if (t === "RGBA_OBJ")
      return "{r:" + r + ",g:" + o + ",b:" + a + ",a:" + u + "}";
    if (t === "HSV_OBJ")
      return "{h:" + f + ",s:" + v + ",v:" + S + "}";
    if (t === "HSVA_OBJ")
      return "{h:" + f + ",s:" + v + ",v:" + S + ",a:" + u + "}";
  }
  return "unknown format";
}
var Rf = Array.prototype.forEach, Wa = Array.prototype.slice, Nt = {
  BREAK: {},
  extend: function(e) {
    return this.each(Wa.call(arguments, 1), function(t) {
      var r = this.isObject(t) ? Object.keys(t) : [];
      r.forEach((function(o) {
        this.isUndefined(t[o]) || (e[o] = t[o]);
      }).bind(this));
    }, this), e;
  },
  defaults: function(e) {
    return this.each(Wa.call(arguments, 1), function(t) {
      var r = this.isObject(t) ? Object.keys(t) : [];
      r.forEach((function(o) {
        this.isUndefined(e[o]) && (e[o] = t[o]);
      }).bind(this));
    }, this), e;
  },
  compose: function() {
    var e = Wa.call(arguments);
    return function() {
      for (var t = Wa.call(arguments), r = e.length - 1; r >= 0; r--)
        t = [e[r].apply(this, t)];
      return t[0];
    };
  },
  each: function(e, t, r) {
    if (e) {
      if (Rf && e.forEach && e.forEach === Rf)
        e.forEach(t, r);
      else if (e.length === e.length + 0) {
        var o = void 0, a = void 0;
        for (o = 0, a = e.length; o < a; o++)
          if (o in e && t.call(r, e[o], o) === this.BREAK)
            return;
      } else
        for (var u in e)
          if (t.call(r, e[u], u) === this.BREAK)
            return;
    }
  },
  defer: function(e) {
    setTimeout(e, 0);
  },
  debounce: function(e, t, r) {
    var o = void 0;
    return function() {
      var a = this, u = arguments;
      function f() {
        o = null, r || e.apply(a, u);
      }
      var v = r || !o;
      clearTimeout(o), o = setTimeout(f, t), v && e.apply(a, u);
    };
  },
  toArray: function(e) {
    return e.toArray ? e.toArray() : Wa.call(e);
  },
  isUndefined: function(e) {
    return e === void 0;
  },
  isNull: function(e) {
    return e === null;
  },
  isNaN: function(y) {
    function e(t) {
      return y.apply(this, arguments);
    }
    return e.toString = function() {
      return y.toString();
    }, e;
  }(function(y) {
    return isNaN(y);
  }),
  isArray: Array.isArray || function(y) {
    return y.constructor === Array;
  },
  isObject: function(e) {
    return e === Object(e);
  },
  isNumber: function(e) {
    return e === e + 0;
  },
  isString: function(e) {
    return e === e + "";
  },
  isBoolean: function(e) {
    return e === !1 || e === !0;
  },
  isFunction: function(e) {
    return e instanceof Function;
  }
}, cw = [
  {
    litmus: Nt.isString,
    conversions: {
      THREE_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
          };
        },
        write: Ma
      },
      SIX_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9]{6})$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString(), 0)
          };
        },
        write: Ma
      },
      CSS_RGB: {
        read: function(e) {
          var t = e.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3])
          };
        },
        write: Ma
      },
      CSS_RGBA: {
        read: function(e) {
          var t = e.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3]),
            a: parseFloat(t[4])
          };
        },
        write: Ma
      }
    }
  },
  {
    litmus: Nt.isNumber,
    conversions: {
      HEX: {
        read: function(e) {
          return {
            space: "HEX",
            hex: e,
            conversionName: "HEX"
          };
        },
        write: function(e) {
          return e.hex;
        }
      }
    }
  },
  {
    litmus: Nt.isArray,
    conversions: {
      RGB_ARRAY: {
        read: function(e) {
          return e.length !== 3 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b];
        }
      },
      RGBA_ARRAY: {
        read: function(e) {
          return e.length !== 4 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2],
            a: e[3]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b, e.a];
        }
      }
    }
  },
  {
    litmus: Nt.isObject,
    conversions: {
      RGBA_OBJ: {
        read: function(e) {
          return Nt.isNumber(e.r) && Nt.isNumber(e.g) && Nt.isNumber(e.b) && Nt.isNumber(e.a) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          };
        }
      },
      RGB_OBJ: {
        read: function(e) {
          return Nt.isNumber(e.r) && Nt.isNumber(e.g) && Nt.isNumber(e.b) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b
          };
        }
      },
      HSVA_OBJ: {
        read: function(e) {
          return Nt.isNumber(e.h) && Nt.isNumber(e.s) && Nt.isNumber(e.v) && Nt.isNumber(e.a) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          };
        }
      },
      HSV_OBJ: {
        read: function(e) {
          return Nt.isNumber(e.h) && Nt.isNumber(e.s) && Nt.isNumber(e.v) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v
          };
        }
      }
    }
  }
], Za = void 0, el = void 0, Hh = function() {
  el = !1;
  var e = arguments.length > 1 ? Nt.toArray(arguments) : arguments[0];
  return Nt.each(cw, function(t) {
    if (t.litmus(e))
      return Nt.each(t.conversions, function(r, o) {
        if (Za = r.read(e), el === !1 && Za !== !1)
          return el = Za, Za.conversionName = o, Za.conversion = r, Nt.BREAK;
      }), Nt.BREAK;
  }), el;
}, Df = void 0, ml = {
  hsv_to_rgb: function(e, t, r) {
    var o = Math.floor(e / 60) % 6, a = e / 60 - Math.floor(e / 60), u = r * (1 - t), f = r * (1 - a * t), v = r * (1 - (1 - a) * t), S = [[r, v, u], [f, r, u], [u, r, v], [u, f, r], [v, u, r], [r, u, f]][o];
    return {
      r: S[0] * 255,
      g: S[1] * 255,
      b: S[2] * 255
    };
  },
  rgb_to_hsv: function(e, t, r) {
    var o = Math.min(e, t, r), a = Math.max(e, t, r), u = a - o, f = void 0, v = void 0;
    if (a !== 0)
      v = u / a;
    else
      return {
        h: NaN,
        s: 0,
        v: 0
      };
    return e === a ? f = (t - r) / u : t === a ? f = 2 + (r - e) / u : f = 4 + (e - t) / u, f /= 6, f < 0 && (f += 1), {
      h: f * 360,
      s: v,
      v: a / 255
    };
  },
  rgb_to_hex: function(e, t, r) {
    var o = this.hex_with_component(0, 2, e);
    return o = this.hex_with_component(o, 1, t), o = this.hex_with_component(o, 0, r), o;
  },
  component_from_hex: function(e, t) {
    return e >> t * 8 & 255;
  },
  hex_with_component: function(e, t, r) {
    return r << (Df = t * 8) | e & ~(255 << Df);
  }
}, fw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
  return typeof y;
} : function(y) {
  return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
}, as = function(y, e) {
  if (!(y instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, os = function() {
  function y(e, t) {
    for (var r = 0; r < t.length; r++) {
      var o = t[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, t, r) {
    return t && y(e.prototype, t), r && y(e, r), e;
  };
}(), Ws = function y(e, t, r) {
  e === null && (e = Function.prototype);
  var o = Object.getOwnPropertyDescriptor(e, t);
  if (o === void 0) {
    var a = Object.getPrototypeOf(e);
    return a === null ? void 0 : y(a, t, r);
  } else {
    if ("value" in o)
      return o.value;
    var u = o.get;
    return u === void 0 ? void 0 : u.call(r);
  }
}, qs = function(y, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  y.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: y,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(y, e) : y.__proto__ = e);
}, Xs = function(y, e) {
  if (!y)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : y;
}, $n = function() {
  function y() {
    if (as(this, y), this.__state = Hh.apply(this, arguments), this.__state === !1)
      throw new Error("Failed to interpret color arguments");
    this.__state.a = this.__state.a || 1;
  }
  return os(y, [{
    key: "toString",
    value: function() {
      return Ma(this);
    }
  }, {
    key: "toHexString",
    value: function() {
      return Ma(this, !0);
    }
  }, {
    key: "toOriginal",
    value: function() {
      return this.__state.conversion.write(this);
    }
  }]), y;
}();
function gu(y, e, t) {
  Object.defineProperty(y, e, {
    get: function() {
      return this.__state.space === "RGB" ? this.__state[e] : ($n.recalculateRGB(this, e, t), this.__state[e]);
    },
    set: function(o) {
      this.__state.space !== "RGB" && ($n.recalculateRGB(this, e, t), this.__state.space = "RGB"), this.__state[e] = o;
    }
  });
}
function pu(y, e) {
  Object.defineProperty(y, e, {
    get: function() {
      return this.__state.space === "HSV" ? this.__state[e] : ($n.recalculateHSV(this), this.__state[e]);
    },
    set: function(r) {
      this.__state.space !== "HSV" && ($n.recalculateHSV(this), this.__state.space = "HSV"), this.__state[e] = r;
    }
  });
}
$n.recalculateRGB = function(y, e, t) {
  if (y.__state.space === "HEX")
    y.__state[e] = ml.component_from_hex(y.__state.hex, t);
  else if (y.__state.space === "HSV")
    Nt.extend(y.__state, ml.hsv_to_rgb(y.__state.h, y.__state.s, y.__state.v));
  else
    throw new Error("Corrupted color state");
};
$n.recalculateHSV = function(y) {
  var e = ml.rgb_to_hsv(y.r, y.g, y.b);
  Nt.extend(y.__state, {
    s: e.s,
    v: e.v
  }), Nt.isNaN(e.h) ? Nt.isUndefined(y.__state.h) && (y.__state.h = 0) : y.__state.h = e.h;
};
$n.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"];
gu($n.prototype, "r", 2);
gu($n.prototype, "g", 1);
gu($n.prototype, "b", 0);
pu($n.prototype, "h");
pu($n.prototype, "s");
pu($n.prototype, "v");
Object.defineProperty($n.prototype, "a", {
  get: function() {
    return this.__state.a;
  },
  set: function(e) {
    this.__state.a = e;
  }
});
Object.defineProperty($n.prototype, "hex", {
  get: function() {
    return this.__state.space !== "HEX" && (this.__state.hex = ml.rgb_to_hex(this.r, this.g, this.b), this.__state.space = "HEX"), this.__state.hex;
  },
  set: function(e) {
    this.__state.space = "HEX", this.__state.hex = e;
  }
});
var ca = function() {
  function y(e, t) {
    as(this, y), this.initialValue = e[t], this.domElement = document.createElement("div"), this.object = e, this.property = t, this.__onChange = void 0, this.__onFinishChange = void 0;
  }
  return os(y, [{
    key: "onChange",
    value: function(t) {
      return this.__onChange = t, this;
    }
  }, {
    key: "onFinishChange",
    value: function(t) {
      return this.__onFinishChange = t, this;
    }
  }, {
    key: "setValue",
    value: function(t) {
      return this.object[this.property] = t, this.__onChange && this.__onChange.call(this, t), this.updateDisplay(), this;
    }
  }, {
    key: "getValue",
    value: function() {
      return this.object[this.property];
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this;
    }
  }, {
    key: "isModified",
    value: function() {
      return this.initialValue !== this.getValue();
    }
  }]), y;
}(), dw = {
  HTMLEvents: ["change"],
  MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
  KeyboardEvents: ["keydown"]
}, Qd = {};
Nt.each(dw, function(y, e) {
  Nt.each(y, function(t) {
    Qd[t] = e;
  });
});
var gw = /(\d+(\.\d+)?)px/;
function _s(y) {
  if (y === "0" || Nt.isUndefined(y))
    return 0;
  var e = y.match(gw);
  return Nt.isNull(e) ? 0 : parseFloat(e[1]);
}
var bt = {
  makeSelectable: function(e, t) {
    e === void 0 || e.style === void 0 || (e.onselectstart = t ? function() {
      return !1;
    } : function() {
    }, e.style.MozUserSelect = t ? "auto" : "none", e.style.KhtmlUserSelect = t ? "auto" : "none", e.unselectable = t ? "on" : "off");
  },
  makeFullscreen: function(e, t, r) {
    var o = r, a = t;
    Nt.isUndefined(a) && (a = !0), Nt.isUndefined(o) && (o = !0), e.style.position = "absolute", a && (e.style.left = 0, e.style.right = 0), o && (e.style.top = 0, e.style.bottom = 0);
  },
  fakeEvent: function(e, t, r, o) {
    var a = r || {}, u = Qd[t];
    if (!u)
      throw new Error("Event type " + t + " not supported.");
    var f = document.createEvent(u);
    switch (u) {
      case "MouseEvents": {
        var v = a.x || a.clientX || 0, S = a.y || a.clientY || 0;
        f.initMouseEvent(
          t,
          a.bubbles || !1,
          a.cancelable || !0,
          window,
          a.clickCount || 1,
          0,
          0,
          v,
          S,
          !1,
          !1,
          !1,
          !1,
          0,
          null
        );
        break;
      }
      case "KeyboardEvents": {
        var I = f.initKeyboardEvent || f.initKeyEvent;
        Nt.defaults(a, {
          cancelable: !0,
          ctrlKey: !1,
          altKey: !1,
          shiftKey: !1,
          metaKey: !1,
          keyCode: void 0,
          charCode: void 0
        }), I(t, a.bubbles || !1, a.cancelable, window, a.ctrlKey, a.altKey, a.shiftKey, a.metaKey, a.keyCode, a.charCode);
        break;
      }
      default: {
        f.initEvent(t, a.bubbles || !1, a.cancelable || !0);
        break;
      }
    }
    Nt.defaults(f, o), e.dispatchEvent(f);
  },
  bind: function(e, t, r, o) {
    var a = o || !1;
    return e.addEventListener ? e.addEventListener(t, r, a) : e.attachEvent && e.attachEvent("on" + t, r), bt;
  },
  unbind: function(e, t, r, o) {
    var a = o || !1;
    return e.removeEventListener ? e.removeEventListener(t, r, a) : e.detachEvent && e.detachEvent("on" + t, r), bt;
  },
  addClass: function(e, t) {
    if (e.className === void 0)
      e.className = t;
    else if (e.className !== t) {
      var r = e.className.split(/ +/);
      r.indexOf(t) === -1 && (r.push(t), e.className = r.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }
    return bt;
  },
  removeClass: function(e, t) {
    if (t)
      if (e.className === t)
        e.removeAttribute("class");
      else {
        var r = e.className.split(/ +/), o = r.indexOf(t);
        o !== -1 && (r.splice(o, 1), e.className = r.join(" "));
      }
    else
      e.className = void 0;
    return bt;
  },
  hasClass: function(e, t) {
    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1;
  },
  getWidth: function(e) {
    var t = getComputedStyle(e);
    return _s(t["border-left-width"]) + _s(t["border-right-width"]) + _s(t["padding-left"]) + _s(t["padding-right"]) + _s(t.width);
  },
  getHeight: function(e) {
    var t = getComputedStyle(e);
    return _s(t["border-top-width"]) + _s(t["border-bottom-width"]) + _s(t["padding-top"]) + _s(t["padding-bottom"]) + _s(t.height);
  },
  getOffset: function(e) {
    var t = e, r = { left: 0, top: 0 };
    if (t.offsetParent)
      do
        r.left += t.offsetLeft, r.top += t.offsetTop, t = t.offsetParent;
      while (t);
    return r;
  },
  isActive: function(e) {
    return e === document.activeElement && (e.type || e.href);
  }
}, eg = function(y) {
  qs(e, y);
  function e(t, r) {
    as(this, e);
    var o = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r)), a = o;
    o.__prev = o.getValue(), o.__checkbox = document.createElement("input"), o.__checkbox.setAttribute("type", "checkbox");
    function u() {
      a.setValue(!a.__prev);
    }
    return bt.bind(o.__checkbox, "change", u, !1), o.domElement.appendChild(o.__checkbox), o.updateDisplay(), o;
  }
  return os(e, [{
    key: "setValue",
    value: function(r) {
      var o = Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, r);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), this.__prev = this.getValue(), o;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"), this.__checkbox.checked = !0, this.__prev = !0) : (this.__checkbox.checked = !1, this.__prev = !1), Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ca), pw = function(y) {
  qs(e, y);
  function e(t, r, o) {
    as(this, e);
    var a = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r)), u = o, f = a;
    if (a.__select = document.createElement("select"), Nt.isArray(u)) {
      var v = {};
      Nt.each(u, function(S) {
        v[S] = S;
      }), u = v;
    }
    return Nt.each(u, function(S, I) {
      var D = document.createElement("option");
      D.innerHTML = I, D.setAttribute("value", S), f.__select.appendChild(D);
    }), a.updateDisplay(), bt.bind(a.__select, "change", function() {
      var S = this.options[this.selectedIndex].value;
      f.setValue(S);
    }), a.domElement.appendChild(a.__select), a;
  }
  return os(e, [{
    key: "setValue",
    value: function(r) {
      var o = Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, r);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), o;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return bt.isActive(this.__select) ? this : (this.__select.value = this.getValue(), Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this));
    }
  }]), e;
}(ca), _w = function(y) {
  qs(e, y);
  function e(t, r) {
    as(this, e);
    var o = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r)), a = o;
    function u() {
      a.setValue(a.__input.value);
    }
    function f() {
      a.__onFinishChange && a.__onFinishChange.call(a, a.getValue());
    }
    return o.__input = document.createElement("input"), o.__input.setAttribute("type", "text"), bt.bind(o.__input, "keyup", u), bt.bind(o.__input, "change", u), bt.bind(o.__input, "blur", f), bt.bind(o.__input, "keydown", function(v) {
      v.keyCode === 13 && this.blur();
    }), o.updateDisplay(), o.domElement.appendChild(o.__input), o;
  }
  return os(e, [{
    key: "updateDisplay",
    value: function() {
      return bt.isActive(this.__input) || (this.__input.value = this.getValue()), Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ca);
function zf(y) {
  var e = y.toString();
  return e.indexOf(".") > -1 ? e.length - e.indexOf(".") - 1 : 0;
}
var tg = function(y) {
  qs(e, y);
  function e(t, r, o) {
    as(this, e);
    var a = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r)), u = o || {};
    return a.__min = u.min, a.__max = u.max, a.__step = u.step, Nt.isUndefined(a.__step) ? a.initialValue === 0 ? a.__impliedStep = 1 : a.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(a.initialValue)) / Math.LN10)) / 10 : a.__impliedStep = a.__step, a.__precision = zf(a.__impliedStep), a;
  }
  return os(e, [{
    key: "setValue",
    value: function(r) {
      var o = r;
      return this.__min !== void 0 && o < this.__min ? o = this.__min : this.__max !== void 0 && o > this.__max && (o = this.__max), this.__step !== void 0 && o % this.__step !== 0 && (o = Math.round(o / this.__step) * this.__step), Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, o);
    }
  }, {
    key: "min",
    value: function(r) {
      return this.__min = r, this;
    }
  }, {
    key: "max",
    value: function(r) {
      return this.__max = r, this;
    }
  }, {
    key: "step",
    value: function(r) {
      return this.__step = r, this.__impliedStep = r, this.__precision = zf(r), this;
    }
  }]), e;
}(ca);
function mw(y, e) {
  var t = Math.pow(10, e);
  return Math.round(y * t) / t;
}
var vl = function(y) {
  qs(e, y);
  function e(t, r, o) {
    as(this, e);
    var a = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r, o));
    a.__truncationSuspended = !1;
    var u = a, f = void 0;
    function v() {
      var X = parseFloat(u.__input.value);
      Nt.isNaN(X) || u.setValue(X);
    }
    function S() {
      u.__onFinishChange && u.__onFinishChange.call(u, u.getValue());
    }
    function I() {
      S();
    }
    function D(X) {
      var Y = f - X.clientY;
      u.setValue(u.getValue() + Y * u.__impliedStep), f = X.clientY;
    }
    function Z() {
      bt.unbind(window, "mousemove", D), bt.unbind(window, "mouseup", Z), S();
    }
    function M(X) {
      bt.bind(window, "mousemove", D), bt.bind(window, "mouseup", Z), f = X.clientY;
    }
    return a.__input = document.createElement("input"), a.__input.setAttribute("type", "text"), bt.bind(a.__input, "change", v), bt.bind(a.__input, "blur", I), bt.bind(a.__input, "mousedown", M), bt.bind(a.__input, "keydown", function(X) {
      X.keyCode === 13 && (u.__truncationSuspended = !0, this.blur(), u.__truncationSuspended = !1, S());
    }), a.updateDisplay(), a.domElement.appendChild(a.__input), a;
  }
  return os(e, [{
    key: "updateDisplay",
    value: function() {
      return this.__input.value = this.__truncationSuspended ? this.getValue() : mw(this.getValue(), this.__precision), Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(tg);
function Ff(y, e, t, r, o) {
  return r + (o - r) * ((y - e) / (t - e));
}
var Yh = function(y) {
  qs(e, y);
  function e(t, r, o, a, u) {
    as(this, e);
    var f = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r, { min: o, max: a, step: u })), v = f;
    f.__background = document.createElement("div"), f.__foreground = document.createElement("div"), bt.bind(f.__background, "mousedown", S), bt.bind(f.__background, "touchstart", Z), bt.addClass(f.__background, "slider"), bt.addClass(f.__foreground, "slider-fg");
    function S(Y) {
      document.activeElement.blur(), bt.bind(window, "mousemove", I), bt.bind(window, "mouseup", D), I(Y);
    }
    function I(Y) {
      Y.preventDefault();
      var ie = v.__background.getBoundingClientRect();
      return v.setValue(Ff(Y.clientX, ie.left, ie.right, v.__min, v.__max)), !1;
    }
    function D() {
      bt.unbind(window, "mousemove", I), bt.unbind(window, "mouseup", D), v.__onFinishChange && v.__onFinishChange.call(v, v.getValue());
    }
    function Z(Y) {
      Y.touches.length === 1 && (bt.bind(window, "touchmove", M), bt.bind(window, "touchend", X), M(Y));
    }
    function M(Y) {
      var ie = Y.touches[0].clientX, G = v.__background.getBoundingClientRect();
      v.setValue(Ff(ie, G.left, G.right, v.__min, v.__max));
    }
    function X() {
      bt.unbind(window, "touchmove", M), bt.unbind(window, "touchend", X), v.__onFinishChange && v.__onFinishChange.call(v, v.getValue());
    }
    return f.updateDisplay(), f.__background.appendChild(f.__foreground), f.domElement.appendChild(f.__background), f;
  }
  return os(e, [{
    key: "updateDisplay",
    value: function() {
      var r = (this.getValue() - this.__min) / (this.__max - this.__min);
      return this.__foreground.style.width = r * 100 + "%", Ws(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(tg), ig = function(y) {
  qs(e, y);
  function e(t, r, o) {
    as(this, e);
    var a = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r)), u = a;
    return a.__button = document.createElement("div"), a.__button.innerHTML = o === void 0 ? "Fire" : o, bt.bind(a.__button, "click", function(f) {
      return f.preventDefault(), u.fire(), !1;
    }), bt.addClass(a.__button, "button"), a.domElement.appendChild(a.__button), a;
  }
  return os(e, [{
    key: "fire",
    value: function() {
      this.__onChange && this.__onChange.call(this), this.getValue().call(this.object), this.__onFinishChange && this.__onFinishChange.call(this, this.getValue());
    }
  }]), e;
}(ca), Gh = function(y) {
  qs(e, y);
  function e(t, r) {
    as(this, e);
    var o = Xs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, r));
    o.__color = new $n(o.getValue()), o.__temp = new $n(0);
    var a = o;
    o.domElement = document.createElement("div"), bt.makeSelectable(o.domElement, !1), o.__selector = document.createElement("div"), o.__selector.className = "selector", o.__saturation_field = document.createElement("div"), o.__saturation_field.className = "saturation-field", o.__field_knob = document.createElement("div"), o.__field_knob.className = "field-knob", o.__field_knob_border = "2px solid ", o.__hue_knob = document.createElement("div"), o.__hue_knob.className = "hue-knob", o.__hue_field = document.createElement("div"), o.__hue_field.className = "hue-field", o.__input = document.createElement("input"), o.__input.type = "text", o.__input_textShadow = "0 1px 1px ", bt.bind(o.__input, "keydown", function(Y) {
      Y.keyCode === 13 && D.call(this);
    }), bt.bind(o.__input, "blur", D), bt.bind(o.__selector, "mousedown", function() {
      bt.addClass(this, "drag").bind(window, "mouseup", function() {
        bt.removeClass(a.__selector, "drag");
      });
    }), bt.bind(o.__selector, "touchstart", function() {
      bt.addClass(this, "drag").bind(window, "touchend", function() {
        bt.removeClass(a.__selector, "drag");
      });
    });
    var u = document.createElement("div");
    Nt.extend(o.__selector.style, {
      width: "122px",
      height: "102px",
      padding: "3px",
      backgroundColor: "#222",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
    }), Nt.extend(o.__field_knob.style, {
      position: "absolute",
      width: "12px",
      height: "12px",
      border: o.__field_knob_border + (o.__color.v < 0.5 ? "#fff" : "#000"),
      boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
      borderRadius: "12px",
      zIndex: 1
    }), Nt.extend(o.__hue_knob.style, {
      position: "absolute",
      width: "15px",
      height: "2px",
      borderRight: "4px solid #fff",
      zIndex: 1
    }), Nt.extend(o.__saturation_field.style, {
      width: "100px",
      height: "100px",
      border: "1px solid #555",
      marginRight: "3px",
      display: "inline-block",
      cursor: "pointer"
    }), Nt.extend(u.style, {
      width: "100%",
      height: "100%",
      background: "none"
    }), Uf(u, "top", "rgba(0,0,0,0)", "#000"), Nt.extend(o.__hue_field.style, {
      width: "15px",
      height: "100px",
      border: "1px solid #555",
      cursor: "ns-resize",
      position: "absolute",
      top: "3px",
      right: "3px"
    }), yw(o.__hue_field), Nt.extend(o.__input.style, {
      outline: "none",
      textAlign: "center",
      color: "#fff",
      border: 0,
      fontWeight: "bold",
      textShadow: o.__input_textShadow + "rgba(0,0,0,0.7)"
    }), bt.bind(o.__saturation_field, "mousedown", f), bt.bind(o.__saturation_field, "touchstart", f), bt.bind(o.__field_knob, "mousedown", f), bt.bind(o.__field_knob, "touchstart", f), bt.bind(o.__hue_field, "mousedown", v), bt.bind(o.__hue_field, "touchstart", v);
    function f(Y) {
      M(Y), bt.bind(window, "mousemove", M), bt.bind(window, "touchmove", M), bt.bind(window, "mouseup", S), bt.bind(window, "touchend", S);
    }
    function v(Y) {
      X(Y), bt.bind(window, "mousemove", X), bt.bind(window, "touchmove", X), bt.bind(window, "mouseup", I), bt.bind(window, "touchend", I);
    }
    function S() {
      bt.unbind(window, "mousemove", M), bt.unbind(window, "touchmove", M), bt.unbind(window, "mouseup", S), bt.unbind(window, "touchend", S), Z();
    }
    function I() {
      bt.unbind(window, "mousemove", X), bt.unbind(window, "touchmove", X), bt.unbind(window, "mouseup", I), bt.unbind(window, "touchend", I), Z();
    }
    function D() {
      var Y = Hh(this.value);
      Y !== !1 ? (a.__color.__state = Y, a.setValue(a.__color.toOriginal())) : this.value = a.__color.toString();
    }
    function Z() {
      a.__onFinishChange && a.__onFinishChange.call(a, a.__color.toOriginal());
    }
    o.__saturation_field.appendChild(u), o.__selector.appendChild(o.__field_knob), o.__selector.appendChild(o.__saturation_field), o.__selector.appendChild(o.__hue_field), o.__hue_field.appendChild(o.__hue_knob), o.domElement.appendChild(o.__input), o.domElement.appendChild(o.__selector), o.updateDisplay();
    function M(Y) {
      Y.type.indexOf("touch") === -1 && Y.preventDefault();
      var ie = a.__saturation_field.getBoundingClientRect(), G = Y.touches && Y.touches[0] || Y, te = G.clientX, J = G.clientY, he = (te - ie.left) / (ie.right - ie.left), ve = 1 - (J - ie.top) / (ie.bottom - ie.top);
      return ve > 1 ? ve = 1 : ve < 0 && (ve = 0), he > 1 ? he = 1 : he < 0 && (he = 0), a.__color.v = ve, a.__color.s = he, a.setValue(a.__color.toOriginal()), !1;
    }
    function X(Y) {
      Y.type.indexOf("touch") === -1 && Y.preventDefault();
      var ie = a.__hue_field.getBoundingClientRect(), G = Y.touches && Y.touches[0] || Y, te = G.clientY, J = 1 - (te - ie.top) / (ie.bottom - ie.top);
      return J > 1 ? J = 1 : J < 0 && (J = 0), a.__color.h = J * 360, a.setValue(a.__color.toOriginal()), !1;
    }
    return o;
  }
  return os(e, [{
    key: "updateDisplay",
    value: function() {
      var r = Hh(this.getValue());
      if (r !== !1) {
        var o = !1;
        Nt.each($n.COMPONENTS, function(f) {
          if (!Nt.isUndefined(r[f]) && !Nt.isUndefined(this.__color.__state[f]) && r[f] !== this.__color.__state[f])
            return o = !0, {};
        }, this), o && Nt.extend(this.__color.__state, r);
      }
      Nt.extend(this.__temp.__state, this.__color.__state), this.__temp.a = 1;
      var a = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0, u = 255 - a;
      Nt.extend(this.__field_knob.style, {
        marginLeft: 100 * this.__color.s - 7 + "px",
        marginTop: 100 * (1 - this.__color.v) - 7 + "px",
        backgroundColor: this.__temp.toHexString(),
        border: this.__field_knob_border + "rgb(" + a + "," + a + "," + a + ")"
      }), this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + "px", this.__temp.s = 1, this.__temp.v = 1, Uf(this.__saturation_field, "left", "#fff", this.__temp.toHexString()), this.__input.value = this.__color.toString(), Nt.extend(this.__input.style, {
        backgroundColor: this.__color.toHexString(),
        color: "rgb(" + a + "," + a + "," + a + ")",
        textShadow: this.__input_textShadow + "rgba(" + u + "," + u + "," + u + ",.7)"
      });
    }
  }]), e;
}(ca), vw = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
function Uf(y, e, t, r) {
  y.style.background = "", Nt.each(vw, function(o) {
    y.style.cssText += "background: " + o + "linear-gradient(" + e + ", " + t + " 0%, " + r + " 100%); ";
  });
}
function yw(y) {
  y.style.background = "", y.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);", y.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", y.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", y.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", y.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
}
var bw = {
  load: function(e, t) {
    var r = t || document, o = r.createElement("link");
    o.type = "text/css", o.rel = "stylesheet", o.href = e, r.getElementsByTagName("head")[0].appendChild(o);
  },
  inject: function(e, t) {
    var r = t || document, o = document.createElement("style");
    o.type = "text/css", o.innerHTML = e;
    var a = r.getElementsByTagName("head")[0];
    try {
      a.appendChild(o);
    } catch {
    }
  }
}, xw = `<div id="dg-save" class="dg dialogue">

  Here's the new load parameter for your <code>GUI</code>'s constructor:

  <textarea id="dg-new-constructor"></textarea>

  <div id="dg-save-locally">

    <input id="dg-local-storage" type="checkbox"/> Automatically save
    values to <code>localStorage</code> on exit.

    <div id="dg-local-explain">The values saved to <code>localStorage</code> will
      override those passed to <code>dat.GUI</code>'s constructor. This makes it
      easier to work incrementally, but <code>localStorage</code> is fragile,
      and your friends may not see the same values you do.

    </div>

  </div>

</div>`, ww = function(e, t) {
  var r = e[t];
  return Nt.isArray(arguments[2]) || Nt.isObject(arguments[2]) ? new pw(e, t, arguments[2]) : Nt.isNumber(r) ? Nt.isNumber(arguments[2]) && Nt.isNumber(arguments[3]) ? Nt.isNumber(arguments[4]) ? new Yh(e, t, arguments[2], arguments[3], arguments[4]) : new Yh(e, t, arguments[2], arguments[3]) : Nt.isNumber(arguments[4]) ? new vl(e, t, { min: arguments[2], max: arguments[3], step: arguments[4] }) : new vl(e, t, { min: arguments[2], max: arguments[3] }) : Nt.isString(r) ? new _w(e, t) : Nt.isFunction(r) ? new ig(e, t, "") : Nt.isBoolean(r) ? new eg(e, t) : null;
};
function Sw(y) {
  setTimeout(y, 1e3 / 60);
}
var Mw = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || Sw, Cw = function() {
  function y() {
    as(this, y), this.backgroundElement = document.createElement("div"), Nt.extend(this.backgroundElement.style, {
      backgroundColor: "rgba(0,0,0,0.8)",
      top: 0,
      left: 0,
      display: "none",
      zIndex: "1000",
      opacity: 0,
      WebkitTransition: "opacity 0.2s linear",
      transition: "opacity 0.2s linear"
    }), bt.makeFullscreen(this.backgroundElement), this.backgroundElement.style.position = "fixed", this.domElement = document.createElement("div"), Nt.extend(this.domElement.style, {
      position: "fixed",
      display: "none",
      zIndex: "1001",
      opacity: 0,
      WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
      transition: "transform 0.2s ease-out, opacity 0.2s linear"
    }), document.body.appendChild(this.backgroundElement), document.body.appendChild(this.domElement);
    var e = this;
    bt.bind(this.backgroundElement, "click", function() {
      e.hide();
    });
  }
  return os(y, [{
    key: "show",
    value: function() {
      var t = this;
      this.backgroundElement.style.display = "block", this.domElement.style.display = "block", this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)", this.layout(), Nt.defer(function() {
        t.backgroundElement.style.opacity = 1, t.domElement.style.opacity = 1, t.domElement.style.webkitTransform = "scale(1)";
      });
    }
  }, {
    key: "hide",
    value: function() {
      var t = this, r = function o() {
        t.domElement.style.display = "none", t.backgroundElement.style.display = "none", bt.unbind(t.domElement, "webkitTransitionEnd", o), bt.unbind(t.domElement, "transitionend", o), bt.unbind(t.domElement, "oTransitionEnd", o);
      };
      bt.bind(this.domElement, "webkitTransitionEnd", r), bt.bind(this.domElement, "transitionend", r), bt.bind(this.domElement, "oTransitionEnd", r), this.backgroundElement.style.opacity = 0, this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)";
    }
  }, {
    key: "layout",
    value: function() {
      this.domElement.style.left = window.innerWidth / 2 - bt.getWidth(this.domElement) / 2 + "px", this.domElement.style.top = window.innerHeight / 2 - bt.getHeight(this.domElement) / 2 + "px";
    }
  }]), y;
}(), Aw = uw(`.dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}
`);
bw.inject(Aw);
var Vf = "dg", Hf = 72, Yf = 20, uo = "Default", Ka = function() {
  try {
    return !!window.localStorage;
  } catch {
    return !1;
  }
}(), to = void 0, Gf = !0, wa = void 0, Bh = !1, ng = [], xn = function y(e) {
  var t = this, r = e || {};
  this.domElement = document.createElement("div"), this.__ul = document.createElement("ul"), this.domElement.appendChild(this.__ul), bt.addClass(this.domElement, Vf), this.__folders = {}, this.__controllers = [], this.__rememberedObjects = [], this.__rememberedObjectIndecesToControllers = [], this.__listening = [], r = Nt.defaults(r, {
    closeOnTop: !1,
    autoPlace: !0,
    width: y.DEFAULT_WIDTH
  }), r = Nt.defaults(r, {
    resizable: r.autoPlace,
    hideable: r.autoPlace
  }), Nt.isUndefined(r.load) ? r.load = { preset: uo } : r.preset && (r.load.preset = r.preset), Nt.isUndefined(r.parent) && r.hideable && ng.push(this), r.resizable = Nt.isUndefined(r.parent) && r.resizable, r.autoPlace && Nt.isUndefined(r.scrollable) && (r.scrollable = !0);
  var o = Ka && localStorage.getItem(Sa(this, "isLocal")) === "true", a = void 0, u = void 0;
  if (Object.defineProperties(
    this,
    {
      parent: {
        get: function() {
          return r.parent;
        }
      },
      scrollable: {
        get: function() {
          return r.scrollable;
        }
      },
      autoPlace: {
        get: function() {
          return r.autoPlace;
        }
      },
      closeOnTop: {
        get: function() {
          return r.closeOnTop;
        }
      },
      preset: {
        get: function() {
          return t.parent ? t.getRoot().preset : r.load.preset;
        },
        set: function(Z) {
          t.parent ? t.getRoot().preset = Z : r.load.preset = Z, Ew(this), t.revert();
        }
      },
      width: {
        get: function() {
          return r.width;
        },
        set: function(Z) {
          r.width = Z, Zh(t, Z);
        }
      },
      name: {
        get: function() {
          return r.name;
        },
        set: function(Z) {
          r.name = Z, u && (u.innerHTML = r.name);
        }
      },
      closed: {
        get: function() {
          return r.closed;
        },
        set: function(Z) {
          r.closed = Z, r.closed ? bt.addClass(t.__ul, y.CLASS_CLOSED) : bt.removeClass(t.__ul, y.CLASS_CLOSED), this.onResize(), t.__closeButton && (t.__closeButton.innerHTML = Z ? y.TEXT_OPEN : y.TEXT_CLOSED);
        }
      },
      load: {
        get: function() {
          return r.load;
        }
      },
      useLocalStorage: {
        get: function() {
          return o;
        },
        set: function(Z) {
          Ka && (o = Z, Z ? bt.bind(window, "unload", a) : bt.unbind(window, "unload", a), localStorage.setItem(Sa(t, "isLocal"), Z));
        }
      }
    }
  ), Nt.isUndefined(r.parent)) {
    if (this.closed = r.closed || !1, bt.addClass(this.domElement, y.CLASS_MAIN), bt.makeSelectable(this.domElement, !1), Ka && o) {
      t.useLocalStorage = !0;
      var f = localStorage.getItem(Sa(this, "gui"));
      f && (r.load = JSON.parse(f));
    }
    this.__closeButton = document.createElement("div"), this.__closeButton.innerHTML = y.TEXT_CLOSED, bt.addClass(this.__closeButton, y.CLASS_CLOSE_BUTTON), r.closeOnTop ? (bt.addClass(this.__closeButton, y.CLASS_CLOSE_TOP), this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0])) : (bt.addClass(this.__closeButton, y.CLASS_CLOSE_BOTTOM), this.domElement.appendChild(this.__closeButton)), bt.bind(this.__closeButton, "click", function() {
      t.closed = !t.closed;
    });
  } else {
    r.closed === void 0 && (r.closed = !0);
    var v = document.createTextNode(r.name);
    bt.addClass(v, "controller-name"), u = _u(t, v);
    var S = function(Z) {
      return Z.preventDefault(), t.closed = !t.closed, !1;
    };
    bt.addClass(this.__ul, y.CLASS_CLOSED), bt.addClass(u, "title"), bt.bind(u, "click", S), r.closed || (this.closed = !1);
  }
  r.autoPlace && (Nt.isUndefined(r.parent) && (Gf && (wa = document.createElement("div"), bt.addClass(wa, Vf), bt.addClass(wa, y.CLASS_AUTO_PLACE_CONTAINER), document.body.appendChild(wa), Gf = !1), wa.appendChild(this.domElement), bt.addClass(this.domElement, y.CLASS_AUTO_PLACE)), this.parent || Zh(t, r.width)), this.__resizeHandler = function() {
    t.onResizeDebounced();
  }, bt.bind(window, "resize", this.__resizeHandler), bt.bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler), bt.bind(this.__ul, "transitionend", this.__resizeHandler), bt.bind(this.__ul, "oTransitionEnd", this.__resizeHandler), this.onResize(), r.resizable && Bw(this), a = function() {
    Ka && localStorage.getItem(Sa(t, "isLocal")) === "true" && localStorage.setItem(Sa(t, "gui"), JSON.stringify(t.getSaveObject()));
  }, this.saveToLocalStorageIfPossible = a;
  function I() {
    var D = t.getRoot();
    D.width += 1, Nt.defer(function() {
      D.width -= 1;
    });
  }
  r.parent || I();
};
xn.toggleHide = function() {
  Bh = !Bh, Nt.each(ng, function(y) {
    y.domElement.style.display = Bh ? "none" : "";
  });
};
xn.CLASS_AUTO_PLACE = "a";
xn.CLASS_AUTO_PLACE_CONTAINER = "ac";
xn.CLASS_MAIN = "main";
xn.CLASS_CONTROLLER_ROW = "cr";
xn.CLASS_TOO_TALL = "taller-than-window";
xn.CLASS_CLOSED = "closed";
xn.CLASS_CLOSE_BUTTON = "close-button";
xn.CLASS_CLOSE_TOP = "close-top";
xn.CLASS_CLOSE_BOTTOM = "close-bottom";
xn.CLASS_DRAG = "drag";
xn.DEFAULT_WIDTH = 245;
xn.TEXT_CLOSED = "Close Controls";
xn.TEXT_OPEN = "Open Controls";
xn._keydownHandler = function(y) {
  document.activeElement.type !== "text" && (y.which === Hf || y.keyCode === Hf) && xn.toggleHide();
};
bt.bind(window, "keydown", xn._keydownHandler, !1);
Nt.extend(
  xn.prototype,
  {
    add: function(e, t) {
      return io(this, e, t, {
        factoryArgs: Array.prototype.slice.call(arguments, 2)
      });
    },
    addColor: function(e, t) {
      return io(this, e, t, {
        color: !0
      });
    },
    remove: function(e) {
      this.__ul.removeChild(e.__li), this.__controllers.splice(this.__controllers.indexOf(e), 1);
      var t = this;
      Nt.defer(function() {
        t.onResize();
      });
    },
    destroy: function() {
      if (this.parent)
        throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
      this.autoPlace && wa.removeChild(this.domElement);
      var e = this;
      Nt.each(this.__folders, function(t) {
        e.removeFolder(t);
      }), bt.unbind(window, "keydown", xn._keydownHandler, !1), jf(this);
    },
    addFolder: function(e) {
      if (this.__folders[e] !== void 0)
        throw new Error('You already have a folder in this GUI by the name "' + e + '"');
      var t = { name: e, parent: this };
      t.autoPlace = this.autoPlace, this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed, t.load = this.load.folders[e]);
      var r = new xn(t);
      this.__folders[e] = r;
      var o = _u(this, r.domElement);
      return bt.addClass(o, "folder"), r;
    },
    removeFolder: function(e) {
      this.__ul.removeChild(e.domElement.parentElement), delete this.__folders[e.name], this.load && this.load.folders && this.load.folders[e.name] && delete this.load.folders[e.name], jf(e);
      var t = this;
      Nt.each(e.__folders, function(r) {
        e.removeFolder(r);
      }), Nt.defer(function() {
        t.onResize();
      });
    },
    open: function() {
      this.closed = !1;
    },
    close: function() {
      this.closed = !0;
    },
    hide: function() {
      this.domElement.style.display = "none";
    },
    show: function() {
      this.domElement.style.display = "";
    },
    onResize: function() {
      var e = this.getRoot();
      if (e.scrollable) {
        var t = bt.getOffset(e.__ul).top, r = 0;
        Nt.each(e.__ul.childNodes, function(o) {
          e.autoPlace && o === e.__save_row || (r += bt.getHeight(o));
        }), window.innerHeight - t - Yf < r ? (bt.addClass(e.domElement, xn.CLASS_TOO_TALL), e.__ul.style.height = window.innerHeight - t - Yf + "px") : (bt.removeClass(e.domElement, xn.CLASS_TOO_TALL), e.__ul.style.height = "auto");
      }
      e.__resize_handle && Nt.defer(function() {
        e.__resize_handle.style.height = e.__ul.offsetHeight + "px";
      }), e.__closeButton && (e.__closeButton.style.width = e.width + "px");
    },
    onResizeDebounced: Nt.debounce(function() {
      this.onResize();
    }, 50),
    remember: function() {
      if (Nt.isUndefined(to) && (to = new Cw(), to.domElement.innerHTML = xw), this.parent)
        throw new Error("You can only call remember on a top level GUI.");
      var e = this;
      Nt.each(Array.prototype.slice.call(arguments), function(t) {
        e.__rememberedObjects.length === 0 && Lw(e), e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t);
      }), this.autoPlace && Zh(this, this.width);
    },
    getRoot: function() {
      for (var e = this; e.parent; )
        e = e.parent;
      return e;
    },
    getSaveObject: function() {
      var e = this.load;
      return e.closed = this.closed, this.__rememberedObjects.length > 0 && (e.preset = this.preset, e.remembered || (e.remembered = {}), e.remembered[this.preset] = tl(this)), e.folders = {}, Nt.each(this.__folders, function(t, r) {
        e.folders[r] = t.getSaveObject();
      }), e;
    },
    save: function() {
      this.load.remembered || (this.load.remembered = {}), this.load.remembered[this.preset] = tl(this), jh(this, !1), this.saveToLocalStorageIfPossible();
    },
    saveAs: function(e) {
      this.load.remembered || (this.load.remembered = {}, this.load.remembered[uo] = tl(this, !0)), this.load.remembered[e] = tl(this), this.preset = e, Wh(this, e, !0), this.saveToLocalStorageIfPossible();
    },
    revert: function(e) {
      Nt.each(this.__controllers, function(t) {
        this.getRoot().load.remembered ? rg(e || this.getRoot(), t) : t.setValue(t.initialValue), t.__onFinishChange && t.__onFinishChange.call(t, t.getValue());
      }, this), Nt.each(this.__folders, function(t) {
        t.revert(t);
      }), e || jh(this.getRoot(), !1);
    },
    listen: function(e) {
      var t = this.__listening.length === 0;
      this.__listening.push(e), t && sg(this.__listening);
    },
    updateDisplay: function() {
      Nt.each(this.__controllers, function(e) {
        e.updateDisplay();
      }), Nt.each(this.__folders, function(e) {
        e.updateDisplay();
      });
    }
  }
);
function _u(y, e, t) {
  var r = document.createElement("li");
  return e && r.appendChild(e), t ? y.__ul.insertBefore(r, t) : y.__ul.appendChild(r), y.onResize(), r;
}
function jf(y) {
  bt.unbind(window, "resize", y.__resizeHandler), y.saveToLocalStorageIfPossible && bt.unbind(window, "unload", y.saveToLocalStorageIfPossible);
}
function jh(y, e) {
  var t = y.__preset_select[y.__preset_select.selectedIndex];
  e ? t.innerHTML = t.value + "*" : t.innerHTML = t.value;
}
function Tw(y, e, t) {
  if (t.__li = e, t.__gui = y, Nt.extend(t, {
    options: function(u) {
      if (arguments.length > 1) {
        var f = t.__li.nextElementSibling;
        return t.remove(), io(y, t.object, t.property, {
          before: f,
          factoryArgs: [Nt.toArray(arguments)]
        });
      }
      if (Nt.isArray(u) || Nt.isObject(u)) {
        var v = t.__li.nextElementSibling;
        return t.remove(), io(y, t.object, t.property, {
          before: v,
          factoryArgs: [u]
        });
      }
    },
    name: function(u) {
      return t.__li.firstElementChild.firstElementChild.innerHTML = u, t;
    },
    listen: function() {
      return t.__gui.listen(t), t;
    },
    remove: function() {
      return t.__gui.remove(t), t;
    }
  }), t instanceof Yh) {
    var r = new vl(t.object, t.property, { min: t.__min, max: t.__max, step: t.__step });
    Nt.each(["updateDisplay", "onChange", "onFinishChange", "step", "min", "max"], function(a) {
      var u = t[a], f = r[a];
      t[a] = r[a] = function() {
        var v = Array.prototype.slice.call(arguments);
        return f.apply(r, v), u.apply(t, v);
      };
    }), bt.addClass(e, "has-slider"), t.domElement.insertBefore(r.domElement, t.domElement.firstElementChild);
  } else if (t instanceof vl) {
    var o = function(u) {
      if (Nt.isNumber(t.__min) && Nt.isNumber(t.__max)) {
        var f = t.__li.firstElementChild.firstElementChild.innerHTML, v = t.__gui.__listening.indexOf(t) > -1;
        t.remove();
        var S = io(y, t.object, t.property, {
          before: t.__li.nextElementSibling,
          factoryArgs: [t.__min, t.__max, t.__step]
        });
        return S.name(f), v && S.listen(), S;
      }
      return u;
    };
    t.min = Nt.compose(o, t.min), t.max = Nt.compose(o, t.max);
  } else
    t instanceof eg ? (bt.bind(e, "click", function() {
      bt.fakeEvent(t.__checkbox, "click");
    }), bt.bind(t.__checkbox, "click", function(a) {
      a.stopPropagation();
    })) : t instanceof ig ? (bt.bind(e, "click", function() {
      bt.fakeEvent(t.__button, "click");
    }), bt.bind(e, "mouseover", function() {
      bt.addClass(t.__button, "hover");
    }), bt.bind(e, "mouseout", function() {
      bt.removeClass(t.__button, "hover");
    })) : t instanceof Gh && (bt.addClass(e, "color"), t.updateDisplay = Nt.compose(function(a) {
      return e.style.borderLeftColor = t.__color.toString(), a;
    }, t.updateDisplay), t.updateDisplay());
  t.setValue = Nt.compose(function(a) {
    return y.getRoot().__preset_select && t.isModified() && jh(y.getRoot(), !0), a;
  }, t.setValue);
}
function rg(y, e) {
  var t = y.getRoot(), r = t.__rememberedObjects.indexOf(e.object);
  if (r !== -1) {
    var o = t.__rememberedObjectIndecesToControllers[r];
    if (o === void 0 && (o = {}, t.__rememberedObjectIndecesToControllers[r] = o), o[e.property] = e, t.load && t.load.remembered) {
      var a = t.load.remembered, u = void 0;
      if (a[y.preset])
        u = a[y.preset];
      else if (a[uo])
        u = a[uo];
      else
        return;
      if (u[r] && u[r][e.property] !== void 0) {
        var f = u[r][e.property];
        e.initialValue = f, e.setValue(f);
      }
    }
  }
}
function io(y, e, t, r) {
  if (e[t] === void 0)
    throw new Error('Object "' + e + '" has no property "' + t + '"');
  var o = void 0;
  if (r.color)
    o = new Gh(e, t);
  else {
    var a = [e, t].concat(r.factoryArgs);
    o = ww.apply(y, a);
  }
  r.before instanceof ca && (r.before = r.before.__li), rg(y, o), bt.addClass(o.domElement, "c");
  var u = document.createElement("span");
  bt.addClass(u, "property-name"), u.innerHTML = o.property;
  var f = document.createElement("div");
  f.appendChild(u), f.appendChild(o.domElement);
  var v = _u(y, f, r.before);
  return bt.addClass(v, xn.CLASS_CONTROLLER_ROW), o instanceof Gh ? bt.addClass(v, "color") : bt.addClass(v, fw(o.getValue())), Tw(y, v, o), y.__controllers.push(o), o;
}
function Sa(y, e) {
  return document.location.href + "." + e;
}
function Wh(y, e, t) {
  var r = document.createElement("option");
  r.innerHTML = e, r.value = e, y.__preset_select.appendChild(r), t && (y.__preset_select.selectedIndex = y.__preset_select.length - 1);
}
function Wf(y, e) {
  e.style.display = y.useLocalStorage ? "block" : "none";
}
function Lw(y) {
  var e = y.__save_row = document.createElement("li");
  bt.addClass(y.domElement, "has-save"), y.__ul.insertBefore(e, y.__ul.firstChild), bt.addClass(e, "save-row");
  var t = document.createElement("span");
  t.innerHTML = "&nbsp;", bt.addClass(t, "button gears");
  var r = document.createElement("span");
  r.innerHTML = "Save", bt.addClass(r, "button"), bt.addClass(r, "save");
  var o = document.createElement("span");
  o.innerHTML = "New", bt.addClass(o, "button"), bt.addClass(o, "save-as");
  var a = document.createElement("span");
  a.innerHTML = "Revert", bt.addClass(a, "button"), bt.addClass(a, "revert");
  var u = y.__preset_select = document.createElement("select");
  if (y.load && y.load.remembered ? Nt.each(y.load.remembered, function(D, Z) {
    Wh(y, Z, Z === y.preset);
  }) : Wh(y, uo, !1), bt.bind(u, "change", function() {
    for (var D = 0; D < y.__preset_select.length; D++)
      y.__preset_select[D].innerHTML = y.__preset_select[D].value;
    y.preset = this.value;
  }), e.appendChild(u), e.appendChild(t), e.appendChild(r), e.appendChild(o), e.appendChild(a), Ka) {
    var f = document.getElementById("dg-local-explain"), v = document.getElementById("dg-local-storage"), S = document.getElementById("dg-save-locally");
    S.style.display = "block", localStorage.getItem(Sa(y, "isLocal")) === "true" && v.setAttribute("checked", "checked"), Wf(y, f), bt.bind(v, "change", function() {
      y.useLocalStorage = !y.useLocalStorage, Wf(y, f);
    });
  }
  var I = document.getElementById("dg-new-constructor");
  bt.bind(I, "keydown", function(D) {
    D.metaKey && (D.which === 67 || D.keyCode === 67) && to.hide();
  }), bt.bind(t, "click", function() {
    I.innerHTML = JSON.stringify(y.getSaveObject(), void 0, 2), to.show(), I.focus(), I.select();
  }), bt.bind(r, "click", function() {
    y.save();
  }), bt.bind(o, "click", function() {
    var D = prompt("Enter a new preset name.");
    D && y.saveAs(D);
  }), bt.bind(a, "click", function() {
    y.revert();
  });
}
function Bw(y) {
  var e = void 0;
  y.__resize_handle = document.createElement("div"), Nt.extend(y.__resize_handle.style, {
    width: "6px",
    marginLeft: "-3px",
    height: "200px",
    cursor: "ew-resize",
    position: "absolute"
  });
  function t(a) {
    return a.preventDefault(), y.width += e - a.clientX, y.onResize(), e = a.clientX, !1;
  }
  function r() {
    bt.removeClass(y.__closeButton, xn.CLASS_DRAG), bt.unbind(window, "mousemove", t), bt.unbind(window, "mouseup", r);
  }
  function o(a) {
    return a.preventDefault(), e = a.clientX, bt.addClass(y.__closeButton, xn.CLASS_DRAG), bt.bind(window, "mousemove", t), bt.bind(window, "mouseup", r), !1;
  }
  bt.bind(y.__resize_handle, "mousedown", o), bt.bind(y.__closeButton, "mousedown", o), y.domElement.insertBefore(y.__resize_handle, y.domElement.firstElementChild);
}
function Zh(y, e) {
  y.domElement.style.width = e + "px", y.__save_row && y.autoPlace && (y.__save_row.style.width = e + "px"), y.__closeButton && (y.__closeButton.style.width = e + "px");
}
function tl(y, e) {
  var t = {};
  return Nt.each(y.__rememberedObjects, function(r, o) {
    var a = {}, u = y.__rememberedObjectIndecesToControllers[o];
    Nt.each(u, function(f, v) {
      a[v] = e ? f.initialValue : f.getValue();
    }), t[o] = a;
  }), t;
}
function Ew(y) {
  for (var e = 0; e < y.__preset_select.length; e++)
    y.__preset_select[e].value === y.preset && (y.__preset_select.selectedIndex = e);
}
function sg(y) {
  y.length !== 0 && Mw.call(window, function() {
    sg(y);
  }), Nt.each(y, function(e) {
    e.updateDisplay();
  });
}
var kw = xn;
let Eh = null;
class Iw {
  constructor(e) {
    if (this.debug = null, this.config = null, this.updateConfig = (t) => {
      this.config = t;
    }, Eh)
      return Eh;
    Eh = this, this.config = e, this.init();
  }
  init() {
    if (this.debug)
      return;
    const e = new kw({ width: 300 });
    let t;
    window.parent !== window ? (t = this.getExportIntegration(), e.add(t, "export").name("Save")) : (t = this.getExportStandalone(), e.add(t, "export").name("Export")), this.debug = e, this.debug.domElement.style.display = "none", new URLSearchParams(window.location.search).get("config") === "true" && (this.debug.open(), this.debug.domElement.style.display = "block");
  }
  getExportIntegration() {
    return {
      export: () => {
        const t = "babylon-customization.json", r = this.exportConfigCustmizations(this.config);
        window.parent.postMessage(
          {
            type: "exportConfig",
            data: {
              filename: t,
              config: r
            }
          },
          "*"
        );
      }
    };
  }
  getExportStandalone() {
    return {
      export: () => {
        const t = "babylon-customization.json", r = JSON.stringify(this.exportConfigCustmizations(this.config));
        let o = document.createElement("a");
        o.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(r)), o.setAttribute("download", t), o.style.display = "none", document.body.appendChild(o), o.click(), document.body.removeChild(o);
      }
    };
  }
  updateDisplay(e) {
    if (e) {
      for (var t in e.__controllers)
        e.__controllers[t].updateDisplay();
      for (var r in e.__folders)
        this.updateDisplay(e.__folders[r]);
    }
  }
  exportConfigCustmizations(e) {
    if (!(!e || !this.debug))
      return e;
  }
  exportCustomProperties(e) {
    return Object.entries(e.__folders).map(([t, r]) => ({
      [t]: this.exportCustomPropertiesProps(r)
    })).reduce((t, r) => ({ ...r, ...t }), {});
  }
  exportCustomPropertiesProps(e) {
    const t = e.__controllers.reduce(
      (o, a) => ({
        ...o,
        [a.property]: a.getValue()
      }),
      {}
    ), r = Object.entries(e.__folders).map(([o, a]) => ({
      [o]: this.exportCustomPropertiesProps(a)
    })).reduce((o, a) => ({ ...a, ...o }), {});
    return {
      ...t,
      ...r
    };
  }
}
class Ow {
  constructor(e, t, r) {
    this.gui = null, this.config = null, this.sceneHelper = null, this.shadowMinZController = null, this.shadowMaxZController = null;
    const o = new Iw(e);
    o.init(), this.gui = o, this.onUpdate = t, this.config = e, this.sceneHelper = r;
  }
  /**
   * The function "setupGui" configures the general, environment, lights, and camera settings based on
   * the provided configuration object, and calls the onUpdate function with the updated configuration.
   * @param {SceneConfig} config - The `config` parameter is an object that contains the initial configuration
   * for the GUI. It may include properties such as general settings, environment settings, lights
   * settings, and camera settings.
   * @param onUpdate - The `onUpdate` parameter is a callback function that will be called whenever
   * there is an update to the configuration. It takes a new configuration object as a parameter
   * (`newConfig: SceneConfig`).
   */
  setupGui(e) {
    if (!this.config)
      return;
    const t = (r) => {
      var o;
      this.onUpdate(r), (o = this.gui) == null || o.updateConfig(r);
    };
    this.configureGeneral(this.config, t), this.configureEnvironment(this.config, t), this.configureLights(this.config, t), this.configureCamera(this.config, t, e), this.configureShadows(this.config, t), this.configureAr(this.config, t), this.configureModel(this.config, t), this.configureAnimations(this.config, t, e);
  }
  configureModel(e, t) {
    var o, a;
    if (!e.model)
      return;
    const r = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("Model");
    e.model.config || (e.model.config = { doubleSided: !0 }), r == null || r.add(e.model.config, "doubleSided").name("Double Sided").onFinishChange(() => {
      t(e);
    });
  }
  configureShadows(e, t) {
    var a, u, f, v, S, I;
    if (!e.environment || !e.environment.shadows)
      return;
    const r = (u = (a = this.gui) == null ? void 0 : a.debug) == null ? void 0 : u.addFolder("Shadows");
    r == null || r.add(e.environment.shadows, "enableShadows").name("Enable Shadows").onChange(() => {
      t(e);
    }), r == null || r.addColor(e.environment.shadows, "shadowHexColor").name("Hex Color").onChange(() => {
      t(e);
    }), r == null || r.add(e.environment.shadows, "shadowDarkness", 0, 1, 0.1).name("Transparency").onChange(() => {
      t(e);
    }), r == null || r.add(e.environment.shadows, "groundSizeMultiplierWidth", 0, 5, 0.1).name("Ground Width").onChange(() => {
      t(e);
    }), r == null || r.add(e.environment.shadows, "groundSizeMultiplierLength", 0, 5, 0.1).name("Ground Length").onChange(() => {
      t(e);
    }), r == null || r.add(e.environment.shadows, "shadowMapSize", 0, 128, 4).name("Map Size").onChange(() => {
      t(e);
    });
    const o = {
      enableShadowMinZ: !!((v = (f = e == null ? void 0 : e.environment) == null ? void 0 : f.shadows) != null && v.shadowMinZ),
      enableShadowMaxZ: !!((I = (S = e == null ? void 0 : e.environment) == null ? void 0 : S.shadows) != null && I.shadowMaxZ)
    };
    r == null || r.add(o, "enableShadowMinZ").name("Enable starting shadow clipping").onChange(() => {
      o.enableShadowMinZ ? e.environment.shadows.shadowMinZ = 0 : (e.environment.shadows.shadowMinZ = null, t(e)), this.buildShadowZConfig(e, r, t);
    }), r == null || r.add(o, "enableShadowMaxZ").name("Enable ending shadow clipping").onChange(() => {
      o.enableShadowMaxZ ? e.environment.shadows.shadowMaxZ = 0 : (e.environment.shadows.shadowMaxZ = null, t(e)), this.buildShadowZConfig(e, r, t);
    }), r && this.buildShadowZConfig(e, r, t);
  }
  buildShadowZConfig(e, t, r) {
    var o, a, u, f, v, S, I, D, Z, M;
    ((a = (o = e == null ? void 0 : e.environment) == null ? void 0 : o.shadows) == null ? void 0 : a.shadowMinZ) !== void 0 && ((f = (u = e == null ? void 0 : e.environment) == null ? void 0 : u.shadows) == null ? void 0 : f.shadowMinZ) !== null ? this.shadowMinZController || (this.shadowMinZController = t == null ? void 0 : t.add((v = e == null ? void 0 : e.environment) == null ? void 0 : v.shadows, "shadowMinZ", -50, 0, 1).name("Clipping Start").onChange(() => {
      r(e);
    })) : this.shadowMinZController && (t == null || t.remove(this.shadowMinZController), this.shadowMinZController = null), ((I = (S = e == null ? void 0 : e.environment) == null ? void 0 : S.shadows) == null ? void 0 : I.shadowMaxZ) !== void 0 && ((Z = (D = e == null ? void 0 : e.environment) == null ? void 0 : D.shadows) == null ? void 0 : Z.shadowMaxZ) !== null ? this.shadowMaxZController || (this.shadowMaxZController = t == null ? void 0 : t.add((M = e == null ? void 0 : e.environment) == null ? void 0 : M.shadows, "shadowMaxZ", 0, 50, 1).name("Clipping End").onChange(() => {
      r(e);
    })) : this.shadowMaxZController && (t == null || t.remove(this.shadowMaxZController), this.shadowMaxZController = null);
  }
  configureGeneral(e, t) {
    var o, a;
    if (!e.general)
      return;
    const r = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("General");
    r == null || r.addColor(e.general, "backgroundColor").name("Background Color").onChange(() => {
      t(e);
    }), r == null || r.add(e.general, "removeDefaultBackground").name("Remove Background").onChange(() => {
      t(e);
    }), e.camera && (r == null || r.add(e.camera, "toneMappingEnabled").name("Tone Mapping Enabled").onFinishChange(() => {
      t(e);
    }), r == null || r.add(e.camera, "toneMappingType", {
      Standard: 0,
      AcesToneMapping: 1
    }).name("Tone Mapping Type").onFinishChange(() => {
      var u;
      (u = e == null ? void 0 : e.camera) != null && u.toneMappingType && (e.camera.toneMappingType = Number(e.camera.toneMappingType)), t(e);
    }), this.configureAntialias(r, e, t));
  }
  configureAntialias(e, t, r) {
    if (!e || !t.general)
      return;
    const o = e == null ? void 0 : e.addFolder("Antialias"), a = o == null ? void 0 : o.addFolder("Desktop"), u = o == null ? void 0 : o.addFolder("Mobile"), f = {
      desktop: null,
      mobile: null
    };
    t.general.antialias ? t.general.antialias && t.general.antialias.desktop && !t.general.antialias.mobile && (t.general.antialias.mobile = {
      enabled: t.general.antialias.desktop.enabled,
      inRotationEnabled: t.general.antialias.desktop.inRotationEnabled
    }) : t.general.antialias = {
      desktop: {
        enabled: !0,
        inRotationEnabled: !1
      },
      mobile: {
        enabled: !0,
        inRotationEnabled: !1
      }
    };
    function v(Z, M, X = !0) {
      var te, J, he;
      const Y = (J = (te = t.general) == null ? void 0 : te.antialias) == null ? void 0 : J[Z];
      if (!Y)
        return;
      const { enabled: ie, inRotationEnabled: G } = Y;
      if (Y.inRotationEnabled = ie ? G : !1, M) {
        const ve = (he = M.domElement.parentElement) == null ? void 0 : he.parentElement;
        ve && (ve.style.display = ie ? "" : "none");
      }
      X && r(t);
    }
    function S(Z, M) {
      var ie, G;
      const X = (G = (ie = t.general) == null ? void 0 : ie.antialias) == null ? void 0 : G[M];
      if (!X)
        return null;
      Z == null || Z.add(X, "enabled").name("Enabled").onChange(() => {
        v(M, f[M] ?? void 0);
      });
      const Y = Z == null ? void 0 : Z.add(X, "inRotationEnabled").name("In Rotation Enabled").listen().onChange(() => r(t));
      return f[M] = Y, Y;
    }
    const I = S(a, "desktop"), D = S(u, "mobile");
    v("desktop", I ?? void 0, !1), v("mobile", D ?? void 0, !1);
  }
  configureAr(e, t) {
    var I, D, Z, M, X;
    if (!e.general || !e.general.meshSize)
      return;
    const r = (D = (I = this.gui) == null ? void 0 : I.debug) == null ? void 0 : D.addFolder("Augmented Reality");
    r == null || r.add(e.general, "arEnabled").name("Enabled").onChange(() => {
      t(e);
    }), r == null || r.add({ enabled: e.general.arAnchor === "wall" }, "enabled").name("Enable wall placement").onChange((Y) => {
      e.general && (e.general.arAnchor = Y ? "wall" : null), t(e);
    }), r == null || r.add({ enabled: e.general.arScale ?? !1 }, "enabled").name("Resizable in AR").onChange((Y) => {
      e.general && (e.general.arScale = Y), t(e);
    }), r == null || r.add({ enabled: e.general.arOnTheFly }, "enabled").name("Faster AR Conversion").onChange((Y) => {
      e.general && (e.general.arOnTheFly = Y), t(e);
    });
    const o = r == null ? void 0 : r.addFolder("Measure Scene Ar"), a = {
      options: {
        width: ((Z = e.general.meshSize) == null ? void 0 : Z.width) ?? !1,
        height: ((M = e.general.meshSize) == null ? void 0 : M.height) ?? !1,
        depth: ((X = e.general.meshSize) == null ? void 0 : X.depth) ?? !1
      }
    };
    let f = (() => {
      const { width: Y, height: ie, depth: G } = a.options;
      return Y ? "width" : ie ? "height" : G ? "depth" : null;
    })();
    const v = (Y) => {
      if (Y === "none" || !Y)
        return 0;
      if (e.general && e.general.meshSize)
        return e.general.meshSize[Y];
    };
    o == null || o.add(a, "options", {
      None: "none",
      Width: "width",
      Height: "height",
      Depth: "depth"
    }).name("Know Dimension").setValue(f).onFinishChange((Y) => {
      f = Y, Y === "none" && e.general && e.general.meshSize && (e.general.meshSize = {
        width: null,
        height: null,
        depth: null
      }, t(e)), S == null || S.setValue(v(f));
    });
    const S = o == null ? void 0 : o.add({ size: 0 }, "size", -500, 500, 1).name("Measure (cm)").setValue(v(f)).onFinishChange((Y) => {
      e.general && e.general.meshSize && (Object.keys(e.general.meshSize).forEach((ie) => {
        e.general && e.general.meshSize && (e.general.meshSize[ie] = ie !== f ? null : Y);
      }), t(e));
    });
  }
  configureEnvironment(e, t) {
    var o, a;
    if (!e.general || !e.general.environmentOptions)
      return;
    const r = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("Environment");
    r == null || r.add(e.general, "exposure", 0, 5, 0.1).name("Exposure").onChange(() => {
      t(e);
    }), r == null || r.add(e.general, "contrast", 0, 5, 0.1).name("Contrast").onChange(() => {
      t(e);
    }).isModified, r == null || r.add(e.general.environmentOptions, "rotationY", 0, 10, 1e-3).name("Rotation Y").onChange(() => {
      t(e);
    }), r == null || r.add(e.general.environmentOptions, "intensity", 0, 20, 0.1).name("Intensity").onChange(() => {
      t(e);
    }), r == null || r.add(e.general.environmentOptions, "pbrIntensity", 0, 20, 0.1).name("PBR Intensity").onChange(() => {
      t(e);
    });
  }
  configureCamera(e, t, r) {
    var I, D;
    const o = r == null ? void 0 : r.cameras.find((Z) => Z instanceof BABYLON.ArcRotateCamera);
    if (!e.camera || !e.camera.position || !o)
      return;
    const a = (D = (I = this.gui) == null ? void 0 : I.debug) == null ? void 0 : D.addFolder("Camera");
    a == null || a.add(e.camera, "autoRotate").name("Auto Rotate").onChange(() => {
      t(e);
    }), e.camera.zoom === void 0 && (e.camera.zoom = 0), a == null || a.add(e.camera, "zoom", -50, 10, 0.1).name("Initial Zoom").onChange(() => {
      t(e);
    }), a == null || a.add(e.camera.position, "fov", 0, 1.6, 1e-3).name("Fov").onChange((Z) => {
      o.fov = Z, r == null || r.render();
    });
    const u = a == null ? void 0 : a.addFolder("Rotation");
    u == null || u.add(e.camera.position, "alpha", -10, 10, 0.01).name("X").onChange((Z) => {
      o.alpha = Z, r == null || r.render();
    }), u == null || u.add(e.camera.position, "beta", -3, 3, 0.01).name("Y").onChange((Z) => {
      o.beta = Z, r == null || r.render();
    });
    const f = a == null ? void 0 : a.addFolder("Zoom Settings");
    e.camera.useMinZoomPerc = e.camera.useMinZoomPerc === null ? !1 : e.camera.useMinZoomPerc, e.camera.useMaxZoomPerc = e.camera.useMaxZoomPerc === null ? !1 : e.camera.useMaxZoomPerc, f == null || f.add(e.camera, "useMinZoomPerc", 0, 1, 0.01).name("Enable Max Zoom").onChange(() => {
      t(e);
    });
    const v = f == null ? void 0 : f.add(e.camera, "minZoomPerc", 0, 10, 0.01).name("Max Zoom");
    v == null || v.onChange((Z) => {
      var X;
      const M = (X = e.camera) == null ? void 0 : X.maxZoomPerc;
      M && Z > M && v.setValue(M), t(e);
    }), f == null || f.add(e.camera, "useMaxZoomPerc", 0, 1, 0.01).name("Enable Min Zoom").onChange(() => {
      t(e);
    });
    const S = f == null ? void 0 : f.add(e.camera, "maxZoomPerc", 0, 10, 0.01).name("Min Zoom");
    S == null || S.onChange((Z) => {
      var X;
      const M = (X = e.camera) == null ? void 0 : X.minZoomPerc;
      Z === 0 ? S.setValue(0.01) : M && Z < M && S.setValue(M), t(e);
    });
  }
  configureLights(e, t) {
    var o, a;
    if (!e.lights)
      return;
    const r = (a = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : a.addFolder("Lights");
    this.configureLight(
      r,
      "Directional Light Back",
      e.lights.directionalLightBack,
      e,
      t
    ), this.configureLight(
      r,
      "Directional Light Left",
      e.lights.directionalLightLeft,
      e,
      t
    ), this.configureLight(r, "Point Light Back", e.lights.pointLightBack, e, t), this.configureLight(r, "Point Light Front", e.lights.pointLightFront, e, t), this.configureLight(r, "Hemisphere Light", e.lights.hemisphereLight, e, t);
  }
  configureLight(e, t, r, o, a) {
    const u = e == null ? void 0 : e.addFolder(t), f = u == null ? void 0 : u.addFolder("position"), v = u == null ? void 0 : u.addFolder("general");
    f == null || f.add(r.position, "x", -100, 100, 0.1).name("Position X").onChange(() => {
      a(o);
    }), f == null || f.add(r.position, "y", -100, 100, 0.1).name("Position Y").onChange(() => {
      a(o);
    }), f == null || f.add(r.position, "z", -100, 100, 0.1).name("Position Z").onChange(() => {
      a(o);
    }), v == null || v.add(r.general, "intensity", 0, 50, 0.1).name("Intensity").onChange(() => {
      a(o);
    }), v == null || v.add(r.general, "visible").name("Visible").onChange(() => {
      a(o);
    });
  }
  configureAnimations(e, t, r) {
    var u, f;
    const o = (r == null ? void 0 : r.animationGroups) && r.animationGroups.length > 0;
    if (!e.animations || !o)
      return;
    const a = (f = (u = this.gui) == null ? void 0 : u.debug) == null ? void 0 : f.addFolder("animations");
    a == null || a.add(e.animations, "runAtStart").name("Run At Start").onChange(() => t(e)), a == null || a.add(e.animations, "loop").name("Loop").onChange(() => t(e)), a == null || a.add(e.animations, "speed", 0.1, 5, 0.1).name("Speed").onChange(() => t(e));
  }
}
var Pw = /* @__PURE__ */ ((y) => (y.CameraMovement = "camera-movement", y.ScriptExecution = "script-execution", y.DesignChanged = "design-changed", y))(Pw || {});
class mu {
  constructor(e) {
    this._zkScene = null, this._zkModel = null, this._canvasID = "zakeke-canvas-viewer3D-" + Zakeke.makeID(5), this._canvas = null, this._domElement = null, this._lastWidth = Number.MIN_VALUE, this._lastHeight = Number.MIN_VALUE, this._engine = null, this._scene = null, this._bindedResize = null, this._sceneHelper = null, this._environmentManager = null, this._glowManager = null, this._sceneActionsExecutor = null, this._renderingNeeded = !1, this._renderingPaused = !1, this._autoRender = !1, this._antiAliasConfig = {
      enabled: !0,
      inRotationEnabled: !1
    }, this._postProcesses = [], this._camera = null, this._hemiLight = null, this._pointLight = null, this._highlightColor = "#00ff00", this._highlightSize = 2, this._highlightLayer = null, this._highlightBlurHorizontalSize = 1, this._highlightBlurVerticalSize = 1, this._highlightAnimationID = null, this._highlightCurrentMeshes = [], this._highlightNextMeshes = [], this._deviceType = MPlaza.DeviceType.All, this._destroyed = !1, this._sceneDesignManager = null, this._meshLocationsManager = null, this._groupPickedListeners = [], this._focusAttributesListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._onDelayLoadingStart = null, this._onDelayLoadingProgress = null, this._onDelayLoadingSuccess = null, this._onDelayLoadingError = null, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._nextSceneMeshesLoadedListeners = [], this._nextSceneTexturesLoadedListeners = [], this._beginSceneLoadingListeners = [], this._endSceneLoadingListeners = [], this._arFileUrls = {}, this._designTextureResolution = 1024, this._configPreview = !1, this._defaultBackgroundColor = null, this._grids = [], this._dracoCompression = null, this._infoPointsManager = null, this._infoPointsManagerStyle = null, this._canShowInfoPoints = !0, this._canShowInfoPointsContent = !0, this._broadcastChannel = null, this._isHologramSource = !1, this._isHologram = !1, this._lastResizableMeshID = "", this._brandLogoButton = null, this._advancedTexture = null, this._createGui = null, this._performanceInfo = null, this._currentRotation = 0, this._isRotating = !1, this._isViewer = !1, this._isSelectionMode = !0, this._mouseWheelInput = null, this._modelParentNode = null, this.setCameraLocked = (t) => {
      this._zkScene && this._sceneHelper && this._scene && (this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._camera && (t ? (this._sceneHelper.setCameraLimitLowerRadius(!0), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1)) : (this._sceneHelper.setCameraLimitLowerRadius(!1), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1.5))));
    }, e != null && (typeof e == "boolean" ? this._configPreview = e : (this._configPreview = e.configPreview, e.defaultBackgroundColor && (this._defaultBackgroundColor = BABYLON.Color4.FromHexString(e.defaultBackgroundColor)), this._isViewer = (e == null ? void 0 : e.isViewer) ?? !1)), this._elementSelector = new Od();
  }
  get zkScene() {
    return this._zkScene;
  }
  get zkModel() {
    return this._zkModel;
  }
  get canvas() {
    return this._canvas;
  }
  get engine() {
    return this._engine;
  }
  get scene() {
    return this._scene;
  }
  get autoRender() {
    return this._autoRender;
  }
  set autoRender(e) {
    this._autoRender = e;
  }
  get antiAliasConfig() {
    return this._antiAliasConfig;
  }
  set antiAliasConfig(e) {
    this._antiAliasConfig = e;
  }
  get isLowEndDevice() {
    return this._performanceInfo && this._performanceInfo.isLowEndDevice;
  }
  get isHologramSource() {
    return this.isHologramSource;
  }
  get createGui() {
    return this._createGui;
  }
  set createGui(e) {
    this._createGui = e;
  }
  set isHologramSource(e) {
    this._isHologramSource = e, e && (this._isHologram = !1, this.detachBroadcastChannelEventHandlers());
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, e ? (this._isHologramSource = !1, this.attachBroadcastChannelEventHandlers()) : this.detachBroadcastChannelEventHandlers(), this.refreshEnvironment();
  }
  get isSelectionMode() {
    return this._isSelectionMode;
  }
  set isSelectionMode(e) {
    this._isSelectionMode = e;
  }
  setupAntiAliasing() {
    if (this._zkScene) {
      let e = this.getAntiAliasingConfig();
      this._antiAliasConfig = e, e.enabled === !0 ? this.enableAntialiasing() : e.enabled === !1 && this.disableAntialiasing();
    }
  }
  getAntiAliasingConfig() {
    var t, r, o, a, u;
    if (!this._zkScene)
      return this._antiAliasConfig;
    const e = (a = (o = (r = (t = this._zkScene).get) == null ? void 0 : r.call(t, "config")) == null ? void 0 : o.toJSON) == null ? void 0 : a.call(o);
    return (u = e == null ? void 0 : e.general) != null && u.antialias ? Ix() ? e.general.antialias.mobile ?? this._antiAliasConfig : e.general.antialias.desktop ?? this._antiAliasConfig : this._antiAliasConfig;
  }
  enableAntialiasing() {
    this._scene && this._antiAliasConfig.enabled && (this.createAntialiasPostProcesses(), this._scene.postProcessesEnabled = !0);
  }
  disableAntialiasing(e = !1) {
    this._scene && (this._scene.postProcessesEnabled = !1), e && this.disposePostProcesses();
  }
  // Per coerenza con tutto il resto inserisco questi metodi set & get,
  // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
  getARScale() {
    let e = !0;
    if (this._zkScene) {
      let t = this._zkScene.getARScale();
      return t ?? e;
    }
    return e;
  }
  setARScale(e) {
    this._zkScene && this._zkScene.setARScale(e);
  }
  getUseMaterialOffloading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseMaterialOffloading();
      return t ?? e;
    }
    return e;
  }
  setUseMaterialOffloading(e) {
    this._zkScene && this._zkScene.setUseMaterialOffloading(e);
  }
  getPrefetchMeshes() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMeshes();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMeshes(e) {
    this._zkScene && this._zkScene.setPrefetchMeshes(e);
  }
  getPrefetchMaterials() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMaterials();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMaterials(e) {
    this._zkScene && this._zkScene.setPrefetchMaterials(e);
  }
  getShowHideInfoPoints() {
    return this.canShowInfoPoints;
  }
  setShowHideInfoPoints(e) {
    this.canShowInfoPoints = e;
  }
  get camera() {
    return this._camera;
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType = e;
  }
  getDeviceType() {
    return this.deviceType;
  }
  get highlightColor() {
    return this._highlightColor;
  }
  set highlightColor(e) {
    this._highlightColor = e;
  }
  get highlightSize() {
    return this._highlightSize;
  }
  set highlightSize(e) {
    this._highlightSize = e;
  }
  get destroyed() {
    return this._destroyed;
  }
  get onDelayLoadingStart() {
    return this._onDelayLoadingStart;
  }
  set onDelayLoadingStart(e) {
    this._onDelayLoadingStart = e;
  }
  get onDelayLoadingProgress() {
    return this._onDelayLoadingProgress;
  }
  set onDelayLoadingProgress(e) {
    this._onDelayLoadingProgress = e;
  }
  get onDelayLoadingSuccess() {
    return this._onDelayLoadingSuccess;
  }
  set onDelayLoadingSuccess(e) {
    this._onDelayLoadingSuccess = e;
  }
  get onDelayLoadingError() {
    return this._onDelayLoadingError;
  }
  set onDelayLoadingError(e) {
    this._onDelayLoadingError = e;
  }
  get dracoCompression() {
    return this._dracoCompression || (this._dracoCompression = Zx.Default), this._dracoCompression;
  }
  get infoPointsShown() {
    return this._infoPointsManager ? this._infoPointsManager.infoPointsShown : !1;
  }
  get infoPointsManagerStyle() {
    return this._infoPointsManagerStyle;
  }
  set infoPointsManagerStyle(e) {
    this._infoPointsManagerStyle = e, this.updateInfoPointsManagerStyle();
  }
  get canShowInfoPoints() {
    return this._canShowInfoPoints;
  }
  set canShowInfoPoints(e) {
    this._canShowInfoPoints = e, this.refreshInfoPoints();
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this._infoPointsManager && (this._infoPointsManager.canShowInfoPointsContent = e);
  }
  static async createSceneViewerAsync(e) {
    const t = new mu(e);
    return await t.initAsync(), t;
  }
  dispose() {
    this.closeBroadcastChannel(), this.removeCanvas(), this.removeDomElement(), this.deleteScene(), this.deleteEngine();
  }
  async initAsync() {
    this._bindedResize = this.resize.bind(this), Zakeke.Tools.Init(), BABYLON.Geometry.onDelayLoadingStart = (e) => {
      this._onDelayLoadingStart && this._onDelayLoadingStart(e);
    }, BABYLON.Geometry.onDelayLoadingProgress = (e) => {
      this._onDelayLoadingProgress && this._onDelayLoadingProgress(e);
    }, BABYLON.Geometry.onDelayLoadingSuccess = (e) => {
      this._onDelayLoadingSuccess && this._onDelayLoadingSuccess(e);
    }, BABYLON.Geometry.onDelayLoadingError = (e) => {
      this._onDelayLoadingError && this._onDelayLoadingError(e);
    }, BABYLON.Geometry.dracoDecodingFunction = (e, t, r) => {
      this.dracoDecodingFunction(e, t, r);
    }, this.createCanvas(), this.createDOMElement(), await this.init3DEngineAsync();
  }
  async init3DEngineAsync() {
    this.createEngine(), await this.createEmptySceneAsync(), this._destroyed = !1;
  }
  createCanvas() {
    return this._canvas = document.createElement("canvas"), this._canvas.setAttribute("id", this._canvasID), this._canvas.setAttribute("touch-action", "none"), this._canvas.addEventListener("dblclick", (e) => this.setRenderingNeeded()), this._canvas;
  }
  removeCanvas() {
    this._canvas && (this._canvas.remove(), this._canvas = null);
  }
  deleteEngine() {
    this._engine && (this._engine.dispose(), this._engine = null), this._destroyed = !0, $(window).off("resize", this._bindedResize);
  }
  deleteScene() {
    this.deleteComponents(), this._scene && (this._scene.dispose(), this._scene = null);
  }
  deleteComponents() {
    this.resetPerformanceInfo(), this.emptyArFileCache(), this.disposeInfoPointsManager(), this._meshLocationsManager && (this._meshLocationsManager.dispose(), this._meshLocationsManager = null), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._sceneActionsExecutor && (this._sceneActionsExecutor.dispose(), this._sceneActionsExecutor = null), this.disposePostProcesses();
  }
  disposeInfoPointsManager() {
    this._infoPointsManager && (this._infoPointsManager.dispose(), this._infoPointsManager = null);
  }
  disposePostProcesses() {
    for (; this._postProcesses.length > 0; ) {
      var e = this._postProcesses.pop();
      e && e.dispose();
    }
  }
  emptyArFileCache() {
    this._arFileUrls = {};
  }
  async resetSceneAsync() {
    await this.init3DEngineAsync();
  }
  /**
   * In some case, we need to replace the model with a new one for example when reverting some changes in the preview 3D.
   * Backbone don't allow to replace all the model, so we need to replace the model with a old clone.
   * @param zkModel The new model to replace the old one.
   */
  replaceModel(e) {
    this._zkModel = e, this.render();
  }
  setZkScene(e) {
    this._zkScene = e;
  }
  closeBroadcastChannel() {
    this._broadcastChannel && (this._broadcastChannel.close(), this._broadcastChannel = null);
  }
  openBroadcastChannel() {
    if (!this._broadcastChannel && window.BroadcastChannel)
      try {
        this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
      } catch (e) {
        console.error("Failed opening broadcast channel"), console.error(e);
      }
  }
  getOrCreateBroadcastChannel() {
    return this.openBroadcastChannel(), this._broadcastChannel;
  }
  createEngine() {
    this.deleteScene(), this.deleteEngine(), this._engine = new BABYLON.Engine(this._canvas, !0, { stencil: !0, preserveDrawingBuffer: !0 }), this._engine.enableOfflineSupport = !1, this._engine.disableUniformBuffers = !0, Logger.info("WebGL version: " + this._engine.webGLVersion), $(window).resize(this._bindedResize), $(window).on("orientationchange", () => {
      setTimeout(() => this._bindedResize(), 100);
    });
  }
  createBrandLogoButton() {
    var e = BABYLON.GUI.Button.CreateImageOnlyButton(
      "zakeke-logo",
      "https://zakeke.blob.core.windows.net/files/images/logo_hq.png"
    );
    return e.image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, e.width = "120px", e.height = "70px", e.color = "transparent", e.hoverCursor = "pointer", e.onPointerClickObservable.add(function() {
      window.open("https://www.zakeke.com/");
    }), this._brandLogoButton = e, this._advancedTexture = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene), this._advancedTexture.updateSamplingMode(BABYLON.Texture.NEAREST_NEAREST), this._advancedTexture.renderScale = 2, this._advancedTexture.addControl(this._brandLogoButton), this._brandLogoButton;
  }
  async createEmptySceneAsync() {
    this.deleteScene(), this._engine && (this._scene = new BABYLON.Scene(this._engine), this._defaultBackgroundColor && this._scene.clearColor.copyFrom(this._defaultBackgroundColor), await this.setupSceneAsync());
  }
  refreshLights() {
    var r, o, a, u, f, v;
    if (!this._zkScene)
      return;
    ((o = (r = this._zkScene) == null ? void 0 : r.getGeneralConfig()) == null ? void 0 : o.get("preventDefaultLights")) !== !0 && ((a = this._sceneHelper) == null || a.setupLights());
    const t = (f = (u = this._zkScene) == null ? void 0 : u.getSceneConfig()) == null ? void 0 : f.get("lights");
    t != null && t.attributes && ((v = this._sceneHelper) == null || v.setUpCustomLights(t.attributes));
  }
  async setupSceneAsync(e = !0) {
    var t, r, o, a, u, f, v, S, I, D, Z;
    if (this._zkScene && this._zkScene.get("config") && ((r = (t = this._zkScene.get("config")) == null ? void 0 : t.get("general")) != null && r.get("meshSize"))) {
      const M = (a = (o = this._zkScene.get("config")) == null ? void 0 : o.get("general")) == null ? void 0 : a.get("meshSize"), X = (u = this._scene) == null ? void 0 : u.meshes.find((Y) => !Y.parent);
      X && M && (M.width || M.height || M.depth) && (X.metadata ? X.metadata.sizecm = M : X.metadata = { sizecm: M });
    }
    if (this.refreshModel(), this._engine && this._scene) {
      this._sceneHelper = new yi(this._scene);
      const M = this._zkScene ? this._zkScene.getCameraPositionScale() : void 0, X = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : void 0, Y = this._zkScene ? this._zkScene.getCameraZoomEnabled() : void 0, ie = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : !1, G = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1, te = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : !1, J = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5, he = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null, ve = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null, K = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null, j = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null, We = this._zkScene ? (f = this._zkScene.getCameraConfig()) == null ? void 0 : f.get("zoom") : null;
      if (M != null && M != null && this._sceneHelper.setCameraPositionScale(M, !1), X != null && X != null && this._sceneHelper.setCameraLimitLowerRadius(X, !1), Y != null && Y != null && this._sceneHelper.setZoomEnabled(Y), this._sceneHelper.setCameraZoom(We), this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._mouseWheelInput = ((v = this._camera) == null ? void 0 : v.inputs.attached.mousewheel) ?? null, this._camera && (ie ? this._sceneHelper.setMinZoomPerc(G) : this._sceneHelper.setMinZoomPerc(null), te ? this._sceneHelper.setMaxZoomPerc(J) : this._sceneHelper.setMaxZoomPerc(null), this._sceneHelper.setCameraAlphaLimits(he, ve), this._sceneHelper.setCameraBetaLimits(K, j)), this._camera && e && (this._camera.onViewMatrixChangedObservable.add(() => {
        this.notifyCameraMovement();
      }), this._camera.onRestoreStateObservable.add(() => {
        this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded();
      }), this.refreshCameraPosition()), (S = this._sceneHelper) == null || S.setupAnimations(this._zkScene), this._modelParentNode || (this._modelParentNode = new BABYLON.TransformNode("modelParent")), (I = this._sceneHelper) == null || I.setupShadows(this._zkScene), this.refreshLights(), this.createHighlightLayer(), await this.refreshEnvironment(), await this.fixEnvironmentTexture(), this.setupGlowManager(), this._zkScene && (this._meshLocationsManager = new Ax(), this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene), this._meshLocationsManager.addMeshAnimationCompletedListener(() => this.setRenderingNeeded())), await this.setupSceneActionsExecutorAsync(), this.setRenderingOnDelayLoaded(), this.setupAntiAliasing(), this._scene.onPointerDown = (ke, $e) => this.onPointerDown(ke, $e), this._scene.registerBeforeRender(() => {
        this.onBeforeRender();
      }), this.refreshInfoPoints(), this.refreshModel(), this.refreshPBRMaterials(), this._zkScene) {
        const ke = (Z = (D = this._zkScene) == null ? void 0 : D.getGeneralConfig()) == null ? void 0 : Z.get("removeDefaultBackground");
        this._sceneHelper.removeDefaultBackground(ke), this._sceneHelper.setUpSceneToneMapping(this._zkScene);
      }
      this._engine.stopRenderLoop(), this.render(), this._engine.runRenderLoop(() => {
        this.checkRendering();
      });
    }
  }
  onBeforeRender() {
    if (this._scene && this._sceneHelper) {
      if (this._camera) {
        const e = this._sceneHelper.getDefaultPointLight();
        e && (e.position = this._camera.position);
      }
      this._scene.meshes.forEach((e) => {
        e.mustDepthSortFacets && e.isFacetDataEnabled && e.updateFacetData();
      });
    }
  }
  render() {
    this._scene && !this._scene.isDisposed && !this._renderingPaused && this._scene.render();
  }
  // Disabilito il post-processing quando la camera è in movimento
  checkRendering() {
    this._scene && (this._autoRender || this._renderingNeeded || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving() ? (this.checkPerformance(), (this.isLowEndDevice || this._autoRender && !this._camera.autoRotationBehavior || // fix: in autorotate the antialiasing will be disabled without autoRotationBehavior check
    this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving()) && !this._antiAliasConfig.inRotationEnabled ? this.disableAntialiasing() : this.enableAntialiasing(), this.render(), this._renderingNeeded && (this._renderingNeeded = !1)) : !this._scene.postProcessesEnabled && !this._antiAliasConfig.inRotationEnabled && (this.enableAntialiasing(), this.render()), this._infoPointsManager && this._infoPointsManager.updateInfoPointsVisibility() && this.render());
  }
  resetPerformanceInfo() {
    this._performanceInfo = null;
  }
  checkPerformance() {
    if (this._performanceInfo || (this._performanceInfo = { totalFPS: 0, countFPS: 0, isLowEndDevice: !1, chekDone: !1 }), this._engine && !this._performanceInfo.chekDone) {
      this._performanceInfo.totalFPS += this._engine.getFps(), this._performanceInfo.countFPS++;
      const e = this._performanceInfo.totalFPS / this._performanceInfo.countFPS;
      this._performanceInfo.countFPS > 30 && (this._performanceInfo.isLowEndDevice = e <= 30, this._performanceInfo.chekDone = !0);
    }
  }
  createAntialiasPostProcesses() {
    if (this._camera && this._postProcesses.length === 0) {
      var e = /firefox/i.test(navigator.userAgent);
      e || this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 4, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 2, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 1, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      );
    }
  }
  getDAMMainMesh() {
    var e, t;
    return (t = (e = this._sceneHelper) == null ? void 0 : e.getVTOMeshes().userMeshes.filter((r) => !r.parent)) == null ? void 0 : t[0];
  }
  setRenderingNeeded() {
    this._renderingNeeded = !0;
  }
  setLongRenderingNeeded() {
    this.setRenderingNeeded();
    for (let e = 50; e <= 1e3; e += 200)
      setTimeout(() => this.setRenderingNeeded(), e);
  }
  refreshRendering() {
    this.setLongRenderingNeeded();
  }
  pauseRendering() {
    this._renderingPaused = !0;
  }
  resumeRendering() {
    this._renderingPaused = !1, this.setRenderingNeeded();
  }
  setLoadingScreen(e) {
    this._engine && (this._engine.loadingScreen = e);
  }
  setRenderingOnDelayLoaded() {
    if (this._scene) {
      var e = this;
      this._scene.getGeometries().forEach(function(t) {
        var r = t.onGeometryUpdated;
        t.onGeometryUpdated = function(o, a) {
          e.setLongRenderingNeeded(), r && r.apply(this, [o, a]);
        };
      });
    }
  }
  createHighlightLayer() {
    this._scene && (this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene), this.updateHighlightLayerExcludedDesignMeshes(), this.setupHighlightLayerIntensity());
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightSize, this._highlightLayer.blurVerticalSize = this._highlightSize, this._highlightBlurHorizontalSize = this._highlightSize, this._highlightBlurVerticalSize = this._highlightSize);
  }
  updateHighlightLayerExcludedDesignMeshes() {
    this.scene && this._sceneHelper && this._highlightLayer && (this._highlightLayer.removeAllMeshes(), this.scene.meshes.filter(this._sceneHelper.isCanvasMesh).forEach((e) => this._highlightLayer.addExcludedMesh(e)));
  }
  createDOMElement() {
    this._canvas && (this._domElement = document.createElement("div"), this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5)), this._domElement.appendChild(this._canvas), this._domElement.style.position = "absolute", this._domElement.style.width = "100%", this._domElement.style.height = "100%", this._domElement.style.left = "0", this._domElement.style.top = "0");
  }
  removeDomElement() {
    this._domElement && (this.detach(), this._domElement.remove(), this._domElement = null);
  }
  appendTo(e) {
    this._domElement && (e.firstChild ? e.insertBefore(this._domElement, e.firstChild) : e.appendChild(this._domElement), e.appendChild(this._domElement), this.resize(), this.resize());
  }
  detach() {
    this._domElement && this._domElement.parentNode && this._domElement.parentNode.removeChild(this._domElement);
  }
  updateView(e = !0, t = !1) {
    this.resize(t), e && this._scene && this.adjustCamera(!1);
  }
  resize(e = !1) {
    if (this._canvas) {
      this.disableAntialiasing(!0);
      var t = this._canvas.parentNode;
      if (!(!t || !(t instanceof HTMLElement))) {
        var r = t.offsetWidth, o = t.offsetHeight;
        (r != this._lastWidth || o != this._lastHeight || e) && (this._canvas.style.width = "100%", this._canvas.style.height = "100%", this._engine && (this._engine.resize(), this._brandLogoButton && (this._brandLogoButton.left = -this._canvas.width + 100 + "px", this._brandLogoButton.top = -this._canvas.height + 50 + "px", console.group(
          "BrandLogoButton",
          "left: " + this._brandLogoButton.left + " - top: " + this._brandLogoButton.top
        ), console.groupEnd()), this.setRenderingNeeded())), this._lastWidth = r, this._lastHeight = o, this.enableAntialiasing();
      }
    }
  }
  switchFullScreen(e) {
    this._sceneHelper && this._sceneHelper.switchFullScreen(e);
  }
  setupGlowManager() {
    this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._zkScene && this._scene && (this._glowManager = new Tx(this._zkScene, this._scene), this._glowManager.update(), this.setRenderingNeeded());
  }
  async setupSceneActionsExecutorAsync() {
    this._zkScene && this._scene && (this._sceneActionsExecutor = new Cx(this._zkScene, this._scene), this._sceneActionsExecutor.deviceType = this.deviceType, this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading(), this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes(), this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials(), this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners(async (e) => {
      await this.refreshMeshesDesignAsync(e.meshes, e.effect);
    }), this._sceneActionsExecutor.addBeginAssetsLoadingListener(() => this.fireBeginAssetsLoadingEvent()), this._sceneActionsExecutor.addEndAssetsLoadingListener(() => this.fireEndAssetsLoadingEvent()));
  }
  restoreCameraState() {
    this._sceneHelper && (this._sceneHelper.restoreCameraState(), this._sceneHelper.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  async fixEnvironmentTexture() {
    if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture.url && typeof this._scene.environmentTexture.url == "string") {
      const e = this._scene.environmentTexture.url, t = (e.match(/http/g) || []).length;
      let r = e;
      if (t > 1) {
        let f = e.lastIndexOf("http");
        f >= 0 && (r = e.substring(f));
      } else if (t == 0 && this._zkScene && this._zkScene.get("rootUrl")) {
        let f = this._zkScene.get("rootUrl");
        if (f) {
          const v = f.endsWith("/") ? "" : "/";
          r = f + v + e;
        }
      } else if (t === 0)
        return;
      let o, a, u;
      this._scene && this._scene.metadata && (this._scene.metadata.environmentTextureRotationY !== void 0 && typeof this._scene.metadata.environmentTextureRotationY == "number" && (o = this._scene.metadata.environmentTextureRotationY), this._scene.metadata.environmentTextureExtensions && (a = this._scene.metadata.environmentTextureExtensions), this._scene.metadata.environmentTextureFiles && (u = this._scene.metadata.environmentTextureFiles)), await this.setSceneEnvironmentTexture(r, o, a, u);
    } else
      await this.checkSceneEmptyEnvironmentTexture();
  }
  async checkSceneEmptyEnvironmentTexture() {
    this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture && await this.setDefaultSceneEnvironmentTexture();
  }
  async setDefaultSceneEnvironmentTexture() {
    const e = li.Environment.EnvironmentTextureCDNUrl;
    await this.setSceneEnvironmentTexture(e);
  }
  async setSceneEnvironmentTexture(e, t, r, o, a, u) {
    return new Promise((f) => {
      if (this._scene && this._sceneHelper)
        if (this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null), this._scene && this._sceneHelper) {
          this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null);
          const v = () => {
            a && a(), this.setLongRenderingNeeded();
          };
          this._scene.metadata || (this._scene.metadata = {}), delete this._scene.metadata.environmentTextureType, delete this._scene.metadata.environmentTextureSize, delete this._scene.metadata.environmentTextureExtensions, delete this._scene.metadata.environmentTextureFiles;
          let S = null;
          e.endsWith(".dds") ? S = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : e.endsWith(".hdr") ? (S = new BABYLON.HDRCubeTexture(
            e,
            this._scene,
            128,
            (u == null ? void 0 : u.get("mipMaps")) || void 0,
            (u == null ? void 0 : u.get("generateHarmonics")) || void 0,
            (u == null ? void 0 : u.get("gammaSpace")) || void 0,
            (u == null ? void 0 : u.get("prefilterOnLoad")) || void 0,
            v
          ), this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture", this._scene.metadata.environmentTextureSize = 128) : e.endsWith(".env") ? S = new BABYLON.CubeTexture(
            e,
            this._scene,
            null,
            !1,
            null,
            v,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : e.endsWith(".basis") ? S = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : r && r.length === 6 && o && o.length === 6 && (S = new BABYLON.CubeTexture(
            e,
            this._scene,
            r,
            !1,
            o,
            v
          ), this._scene.metadata.environmentTextureExtensions = r, this._scene.metadata.environmentTextureFiles = o), S && yi.whenTextureIsReadyAsync(S).then(() => {
            var I, D, Z, M, X, Y, ie, G;
            if (S && this._scene) {
              const te = (M = (Z = (D = (I = this._zkScene) == null ? void 0 : I.get("config")) == null ? void 0 : D.get("general")) == null ? void 0 : Z.get("environmentOptions")) == null ? void 0 : M.get("intensity"), J = (G = (ie = (Y = (X = this._zkScene) == null ? void 0 : X.get("config")) == null ? void 0 : Y.get("general")) == null ? void 0 : ie.get("environmentOptions")) == null ? void 0 : G.get("rotationY");
              te && (S.level = te), J ? S.rotationY = J : this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY, this._scene.environmentTexture = S, this.setRenderingNeeded(), f();
            }
          });
        } else
          f();
    });
  }
  async loadSceneFromModelAsync(e, t, r) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      const o = t.get("rootUrl"), a = t.get("sceneFileName");
      o && a && await this.loadSceneFromRemoteFilesAsync(o, a, r);
    }
  }
  async loadSceneFromModelDataAsync(e, t, r, o) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      var a = "data:" + r;
      const u = t.get("rootUrl");
      u && await this.loadSceneFromRemoteFilesAsync(u, a, o);
    }
  }
  preSceneFileLoading() {
  }
  postSceneFileLoading() {
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync(e, t, r) {
    if (!this._engine)
      throw new Error("Unable to load scene when the 3D engine is null");
    try {
      this.fireBeginSceneLoadingEvent(), this.preSceneFileLoading(), this.pauseRendering(), this._engine.sceneFileRootUrl = e;
      let o = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, r);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), o.dispose();
        return;
      }
      if (await new Promise((S) => o.executeWhenReady(() => S())), this._destroyed)
        throw Logger.info("Loading scene engine destroyed"), o.dispose(), new Error("Engine destroyed while loading scene");
      const a = yi.visibleMeshesRequireDelayedLoading(o);
      a && this.fireBeginAssetsLoadingEvent();
      let u = 0;
      const f = o.meshes.filter((S) => S.isVisible);
      for (let S = 0; S < f.length; S++)
        await this.fireNextSceneMeshesLoadedEvent(S + 1, f.length), await new Promise((I) => {
          setTimeout(() => {
            I();
          }, 10);
        });
      await yi.whenAllVisibleMeshesAreReadyAsync(f), a && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = o;
      let v = [];
      for (let S = 0; S < this._scene.textures.length; S++) {
        const I = this._scene.textures[S];
        v.push(I.name), I instanceof BABYLON.Texture && I.onLoadObservable && I.onLoadObservable.add((D) => {
          this.setLongRenderingNeeded();
        });
      }
      if (this._scene && this._scene.metadata && !this._scene.metadata.delayedMaterials)
        for (let S = 0; S < this._scene.textures.length; S++)
          await this.fireNextSceneTextureLoadedEvent(S + 1, this._scene.textures.length), await new Promise((I) => {
            setTimeout(() => {
              I();
            }, 10);
          });
      if (await this.setupSceneAsync(), this._sceneHelper) {
        if (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials) {
          this._scene.useDelayedTextureLoading = !0;
          try {
            console.log("Trying loading delayed materials using Zip file"), await this._sceneHelper.loadAllDelayedMaterialFromZip(
              e,
              this.zkScene.get("version"),
              this.fireNextSceneTextureLoadedEvent.bind(this)
            ), console.log("Delayed materials loaded using zip file");
          } catch (S) {
            console.warn(
              "Delayed materials not loaded using zip file error:",
              S,
              ", trying to load delayed materials the stanrdad way"
            ), await this._sceneHelper.cleanupAllTemporaryMaterialsAsync(), await this._sceneHelper.loadAllDelayedMaterialsAsync(
              e,
              this.fireNextSceneTextureLoadedEvent.bind(this)
            );
          }
        }
        this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition();
        try {
          await this.reloadAllLoadingErrorTexturesAsync();
        } catch (S) {
          console.error(S);
        }
      }
      if (this._environmentManager) {
        const S = this._environmentManager.getSkyboxTexture();
        S && await yi.whenTextureIsReadyAsync(S);
      }
    } finally {
      this.resumeRendering(), this.postSceneFileLoading(), this.fireEndSceneLoadingEvent();
    }
  }
  getSkyboxTexture() {
    var e;
    return (e = this._environmentManager) == null ? void 0 : e.getSkyboxTexture();
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync_OLD(e, t, r) {
    return new Promise(async (o, a) => {
      this._engine || a(), this.preSceneFileLoading(), this._engine.sceneFileRootUrl = e;
      let u = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, r);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), u.dispose();
        return;
      }
      u.executeWhenReady(async () => {
        this._destroyed && (Logger.info("Loading scene engine destroyed"), u.dispose(), a());
        const f = u.meshes.filter((S) => S.isVisible), v = yi.visibleMeshesRequireDelayedLoading(u);
        v && this.fireBeginAssetsLoadingEvent(), await yi.whenAllVisibleMeshesAreReadyAsync(f), v && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = u;
        for (let S = 0; S < this._scene.textures.length; S++) {
          const I = this._scene.textures[S];
          I instanceof BABYLON.Texture && I.onLoadObservable && I.onLoadObservable.add((D) => {
            this.setLongRenderingNeeded();
          });
        }
        await this.setupSceneAsync(), this._sceneHelper && (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials && await this._sceneHelper.loadAllDelayedMaterialsAsync(e), this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition()), this.postSceneFileLoading(), o();
      });
    });
  }
  checkSceneShaderMaterials(e) {
    if (e instanceof Zakeke.Scene && e.get("shaderMaterials"))
      for (let t = 0; t < e.get("shaderMaterials").length; t++) {
        const r = e.get("shaderMaterials").at(t), o = r.get("name"), a = r.get("vertex"), u = r.get("fragment");
        if (o && a && u) {
          const f = { name: o, vertex: a, fragment: u };
          this.setupShadersStore(f);
        }
      }
  }
  checkShaderMaterial(e) {
    if (e && e instanceof Zakeke.Material && e.get("shaders")) {
      const r = e.get("shaders").get("name"), o = e.get("shaders").get("vertex"), a = e.get("shaders").get("fragment");
      if (r && o && a) {
        const u = { name: r, vertex: o, fragment: a };
        this.setupShadersStore(u);
      }
    }
  }
  setupShadersStore(e) {
    if (e && e.hasOwnProperty("name") && e.hasOwnProperty("vertex") && e.hasOwnProperty("fragment")) {
      var t = e.name + "VertexShader", r = e.name + "FragmentShader";
      BABYLON.Effect.ShadersStore[t] = e.vertex, BABYLON.Effect.ShadersStore[r] = e.fragment;
    }
  }
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  countSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
  }
  getVisibleMeshes() {
    return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
  }
  getSceneBoundingInfo() {
    return this._sceneHelper ? this._sceneHelper.getSceneBoundingInfo() : null;
  }
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && (this._scene.meshes.forEach((e) => this.unselectSingleMesh(e)), this.fireFocusAttributesEvent({ groups: [] }));
  }
  selectUnselectMesh(e, t) {
    if (this._scene && (this._scene.meshes.forEach((o) => this.unselectSingleMesh(o)), t)) {
      let o = (u) => {
        this.selectSingleMesh(u);
        const f = u.getChildMeshes();
        f && f.forEach((v) => o(v));
      };
      const a = this._scene.getMeshByID(e);
      if (a) {
        o(a);
        const u = this.getGroupForMesh(a);
        u && (this.highlightGroupForMesh(a), this.fireGroupPickedEvent({ groupID: u.get("groupID") }));
        var r = this.getVisibleHiddenAttributesForMesh(a);
        this.fireFocusAttributesEvent({ groups: r }), r.length > 0 && this.highlightMeshes([a]);
      }
    }
  }
  selectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !0;
  }
  unselectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !1;
  }
  selectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !0);
  }
  unselectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !1);
  }
  selectUnselectMeshesWithMaterial(e, t) {
    if (this._scene && (this._scene.meshes.forEach((r) => this.unselectSingleMesh(r)), t)) {
      let r = (o) => {
        o.material && o.material.id === e && this.selectSingleMesh(o);
        const a = o.getChildMeshes();
        a && a.forEach((u) => {
          r(u);
        });
      };
      this._scene.meshes.forEach((o) => {
        r(o);
      });
    }
  }
  onPointerDown(e, t) {
    t.hit && t.pickedMesh ? this.selectMesh(t.pickedMesh.id) : this.unselectAllMeshes();
  }
  getSelectedRootMesh() {
    if (this._scene)
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        if (t.selected) {
          const r = t.parent;
          if (!r || !r.selected)
            return t;
        }
      }
    return null;
  }
  getMeshByID(e) {
    return this._scene ? this._scene.getMeshByID(e) : null;
  }
  getMeshByName(e) {
    return this._scene ? this._scene.getMeshByName(e) : null;
  }
  getMaterialByID(e) {
    return this._scene ? this._scene.getMaterialByID(e) : null;
  }
  setCameraLocation(e, t = !1, r = !0) {
    if (this._zkScene && this._sceneHelper) {
      const o = this._zkScene.getCameraLocation(e);
      if (o) {
        const a = new BABYLON.Vector3(
          o.get("px"),
          o.get("py"),
          o.get("pz")
        ), u = new BABYLON.Vector3(
          o.get("tx"),
          o.get("ty"),
          o.get("tz")
        );
        if (r) {
          if (!t)
            this._sceneHelper.animateCamera(u, a, 0.5);
          else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const f = this._sceneHelper.computeCameraAngleOfView(u, a);
            this._sceneHelper.animateCameraToFinalParamters(
              f.alpha,
              f.beta,
              this._camera.radius,
              this._camera.target,
              0.5
            );
          }
        } else if (!t)
          this._sceneHelper.moveCamera(u, a);
        else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
          const f = this._sceneHelper.computeCameraAngleOfView(u, a);
          this._sceneHelper.moveCameraToFinalParameters(
            f.alpha,
            f.beta,
            this._camera.radius,
            this._camera.target
          );
        }
      }
    }
    this.setRenderingNeeded();
  }
  adjustCamera(e) {
    this._sceneHelper && (e != null && e != null && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera(), this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._scene && this._sceneHelper && (this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  async executeScriptAsync(e) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeScriptAsync(e), this.notifyScriptExecution(e), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async executeActionsAsync(e, t, r) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeActionsAsync(e, t, r), this.notifyActionExecution(e, t, r), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(e);
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(e);
  }
  async refreshPBRMaterials() {
    var o, a, u, f, v;
    const e = (o = this._scene) == null ? void 0 : o.materials, t = (u = (a = this._zkScene) == null ? void 0 : a.get("config")) == null ? void 0 : u.toJSON();
    if (!t || !e)
      return;
    const r = (v = (f = t == null ? void 0 : t.general) == null ? void 0 : f.environmentOptions) == null ? void 0 : v.pbrIntensity;
    r && (e == null || e.forEach((S) => {
      S instanceof BABYLON.PBRMaterial && (S.environmentIntensity = r);
    }));
  }
  async refreshModel() {
    var r, o, a, u, f, v, S, I;
    const e = (r = this._scene) == null ? void 0 : r.meshes, t = (a = (o = this._zkScene) == null ? void 0 : o.get("config")) == null ? void 0 : a.toJSON();
    if (!(!t || !e) && ((S = this._sceneHelper) == null || S.transformEntireScene(
      (u = t.model) == null ? void 0 : u.position,
      (f = t.model) == null ? void 0 : f.rotation,
      (v = t.model) == null ? void 0 : v.scale,
      this._modelParentNode
    ), (I = t.model) != null && I.config)) {
      const D = t.model.config.doubleSided;
      D !== void 0 && (e == null || e.forEach((Z) => {
        Z.material instanceof BABYLON.PBRMaterial && Z.material && !(Z instanceof BABYLON.GroundMesh) && (Z.material.backFaceCulling = !D);
      }));
    }
  }
  async refreshEnvironment() {
    if (this._zkScene && this._scene) {
      const e = this._zkScene.getOrCreateGeneralConfig().get("environmentTexture"), t = this._zkScene.getOrCreateGeneralConfig().get("environmentOptions");
      e && t && !this._scene.textures.some((r) => r.url === e) && await this.setSceneEnvironmentTexture(e, void 0, void 0, void 0, void 0, t), (!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram) && (this._environmentManager = new Yd(this._zkScene, this._scene, this._isHologram)), this._environmentManager.update(), this.setLongRenderingNeeded(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded();
    }
  }
  highlightMeshes(e) {
    if (!e || Object.prototype.toString.call(e) !== "[object Array]" || this._highlightSize == 0)
      return;
    const t = this._highlightBlurHorizontalSize, r = this._highlightBlurVerticalSize, o = (f) => {
      f.isVisible && this._highlightLayer && this._highlightLayer.addMesh(f, BABYLON.Color3.FromHexString(this._highlightColor)), f.getChildMeshes().forEach((S) => {
        S instanceof BABYLON.Mesh && o(S);
      });
    }, a = (f) => {
      this._highlightLayer && this._highlightLayer.removeMesh(f), f.getChildMeshes().forEach((S) => {
        S instanceof BABYLON.Mesh && a(S);
      });
    }, u = () => {
      if (this._highlightAnimationID && (clearInterval(this._highlightAnimationID), this._highlightAnimationID = null), this._highlightCurrentMeshes && this._highlightCurrentMeshes.forEach((f) => {
        f instanceof BABYLON.Mesh && a(f);
      }), this._highlightLayer && (this._highlightLayer.blurHorizontalSize = t, this._highlightLayer.blurVerticalSize = r), this._highlightNextMeshes) {
        const f = this._highlightNextMeshes;
        this._highlightNextMeshes = [], this.highlightMeshes(f);
      }
    };
    if (this._highlightAnimationID) {
      this._highlightNextMeshes = e, u();
      return;
    }
    if (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer) {
      this._highlightCurrentMeshes = e, e.forEach((Z) => {
        Z instanceof BABYLON.Mesh && o(Z);
      });
      const f = 800, v = 20, S = v / f;
      let I = t, D = r;
      this._highlightAnimationID = window.setInterval(() => {
        this._highlightLayer && (I -= t * S, D -= r * S, I = Math.max(0, I), D = Math.max(0, D), I >= 0 && (this._highlightLayer.blurHorizontalSize = I), D >= 0 && (this._highlightLayer.blurVerticalSize = D), (I == 0 || D == 0) && u(), this.setRenderingNeeded());
      }, v), this.setRenderingNeeded();
    }
  }
  highlightGroupForMesh(e) {
    const t = this.getGroupForMesh(e);
    this.highlightGroup(t);
  }
  highlightGroupByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributeGroups").findWhere({ groupID: e });
      t ? this.highlightGroup(t) : this.highlightGroup(null);
    }
  }
  highlightGroup(e) {
    if (this._zkScene && this._scene && e) {
      const r = e.get("meshSelector");
      if (r) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          r,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getGroupForMesh(e) {
    if (this._zkModel && this._zkScene && this._scene && e && this._sceneHelper) {
      const t = this._zkModel.get("attributeGroups");
      for (let r = 0; r < t.length; r++) {
        const o = t.at(r), a = o.get("meshSelector");
        if (a) {
          const u = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            a,
            MPlaza.SceneElementType.Mesh
          );
          for (let f = 0; f < u.length; f++) {
            let v = u[f];
            if (e.id == v.id || this._sceneHelper.meshHasParent(e.id, v.id))
              return o;
          }
        }
      }
    }
    return null;
  }
  highlightAttributeByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributes").findWhere({ attributeID: e });
      t ? this.highlightAttribute(t) : this.highlightAttribute(null);
    }
  }
  highlightAttribute(e) {
    if (this._zkScene && this._scene && e) {
      const r = e.get("meshSelector");
      if (r) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          r,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getVisibleHiddenAttributesForMesh(e) {
    const t = [], r = (a) => {
      let u = t.find((f) => f.groupId == a);
      return u || (u = { groupId: a, visibleAttributes: [], hiddenAttributes: [] }, t.push(u)), u;
    };
    if (this._zkModel && this._zkScene && this._scene && e) {
      const a = this._zkModel.get("attributes");
      for (let u = 0; u < a.length; u++) {
        const f = a.at(u), v = f.get("attributeID"), S = f.get("meshSelector");
        if (S) {
          const I = r(f.get("groupID"));
          var o = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            S,
            MPlaza.SceneElementType.Mesh
          );
          o.find((Z) => this._sceneHelper ? e.id == Z.id || this._sceneHelper.meshHasParent(e.id, Z.id) : !1) ? I.visibleAttributes.push(v) : I.hiddenAttributes.push(v);
        }
      }
    }
    return t.filter((a) => a.visibleAttributes.length > 0);
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireGroupPickedEvent(e) {
    for (let t = 0; t < this._groupPickedListeners.length; t++)
      this._groupPickedListeners[t](e);
  }
  addGroupPickedListener(e) {
    this._groupPickedListeners.push(e);
  }
  fireFocusAttributesEvent(e) {
    for (let t = 0; t < this._focusAttributesListeners.length; t++)
      this._focusAttributesListeners[t](e);
  }
  addFocusAttributesListener(e) {
    this._focusAttributesListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e, this._sceneDesignManager && this._sceneDesignManager.setEventMessages(e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointPickedListener(e);
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentShownListener(e);
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentHiddenListener(e);
  }
  // begin assets loading
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    Logger.info("Begin Assets Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    Logger.info("End Assets Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  addNextSceneMeshesLoadedListeners(e) {
    this._nextSceneMeshesLoadedListeners.push(e);
  }
  async fireNextSceneMeshesLoadedEvent(e, t) {
    let r = [];
    for (let o = 0; o < this._nextSceneMeshesLoadedListeners.length; ++o)
      r.push(this._nextSceneMeshesLoadedListeners[o](e, t));
    await Promise.all(r);
  }
  addNextSceneTextureLoadedListeners(e) {
    this._nextSceneTexturesLoadedListeners.push(e);
  }
  async fireNextSceneTextureLoadedEvent(e, t) {
    let r = [];
    for (let o = 0; o < this._nextSceneTexturesLoadedListeners.length; ++o)
      r.push(this._nextSceneTexturesLoadedListeners[o](e, t));
    await Promise.all(r);
  }
  addBeginSceneLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginSceneLoadingEvent() {
    Logger.info("Begin Scene Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndSceneLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndSceneLoadingEvent() {
    Logger.info("End Scene Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // --------------------------------------------------------------
  async getSceneScreenshotAsync(e, t) {
    return this._sceneHelper ? (this.setRenderingNeeded(), await this._sceneHelper.takeScreenshotAsync(e, t)) : null;
  }
  async getSceneContentScreenshotAsync(e, t, r = 0, o, a, u) {
    if (!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)
      return null;
    this.preSceneContentScreenshot(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this.setRenderingNeeded();
    let f = "";
    if (a)
      f = await this._sceneHelper.takeContentScreenshotAsync(e, t);
    else {
      const S = this._canvas;
      if (S) {
        const I = S.width, D = S.height;
        S.width = e, S.height = t;
        const Z = this.scene.activeCamera.position.clone(), M = this.scene.activeCamera.target.clone(), X = u ? {
          position: new BABYLON.Vector3(u.get("px"), u.get("py"), u.get("pz")),
          target: new BABYLON.Vector3(u.get("tx"), u.get("ty"), u.get("tz"))
        } : {
          position: this._scene.activeCamera.position,
          target: this._scene.activeCamera.target
        };
        this._scene.activeCamera.position = X.position, this._scene.activeCamera.target = X.target, this._scene.render(), f = await this._sceneHelper.takeContentScreenshotAsync(e, t), this._scene.activeCamera.position = Z, this._scene.activeCamera.target = M, S.width = I, S.height = D;
      }
    }
    console.log("senza Utils");
    let v = await Fh(f);
    if (v || (console.error("Failed trimming image.", f), v = f), v = await zx(v, e, t, r), !v)
      throw new Error("Failed resizing image.");
    return this.refreshEnvironment(), this.postSceneContentScreenshot(), v;
  }
  preSceneContentScreenshot() {
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
  }
  postSceneMaterialScreenshot() {
    this.refreshEnvironment();
  }
  async getMaterialScreenshotAsync(e, t, r) {
    if (!this._scene || !this._sceneHelper)
      return null;
    this.preSceneMaterialScreenshot();
    let o = null;
    const a = await this.getSceneRootUrl();
    if (a) {
      const u = await lo.getPreviewsAsync(
        this._scene,
        a,
        [e],
        {
          width: t,
          height: r,
          crop: !0
        },
        !1
      ), f = Object.keys(u.previewFiles);
      f.length == 1 && (o = u.previewFiles[f[0]]);
    } else {
      const u = await this._sceneHelper.takeMaterialScreenshotAsync(e, t, r), f = await Fh(u);
      f && (o = f);
    }
    return this.postSceneMaterialScreenshot(), o;
  }
  // Used to avoid multiple listeners when using react redraw
  clearListeners() {
    this._groupPickedListeners = [], this._focusAttributesListeners = [];
  }
  // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
  // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
  // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
  // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
  async renderDesignAsync(e, t = !0) {
    if (this._scene && this._zkScene && this._zkModel && e) {
      if (this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, e))
        this._sceneDesignManager.showDesign = t, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync();
      else {
        this.emptyArFileCache(), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneDesignManager = new Gx(
          this._scene,
          this._zkScene,
          this._zkModel,
          e,
          t
        ), this._sceneDesignManager.addRenderingNeededListener(() => {
          this.setLongRenderingNeeded(), this.notifyDesignChanged(e);
        }), this._sceneDesignManager.setCustomizerGrids(this._grids), this._sceneDesignManager.setEventMessages(this._designEventMessages);
        for (const r of this._designNotifyMessageListeners)
          this._sceneDesignManager.addNotifyMessageListener(r);
        for (const r of this._designRemoveMessageListeners)
          this._sceneDesignManager.addRemoveMessageListener(r);
        await this._sceneDesignManager.refreshAsync();
      }
      this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded();
    }
  }
  resetDesign() {
    this._scene && this._zkScene && this._zkModel && (this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded());
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  async refreshMeshesDesignAsync(e, t) {
    e && Object.prototype.toString.call(e) === "[object Array]" && e.forEach(async (r) => await this.refreshMeshDesignAsync(r.id, void 0, t || void 0));
  }
  async refreshMeshDesignAsync(e, t = 0, r) {
    var o;
    (o = this._sceneDesignManager) == null || o.refreshMeshDesignAsync(e, t, r);
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._sceneDesignManager) == null || t.setCustomizerGrids(e);
  }
  removeDesignItem(e, t) {
    var r;
    t == null || t.deselectAll(), t == null || t.removeItemByGuid(e), t == null || t.updateSelectionState(), (r = this._sceneDesignManager) == null || r.removeItem(e);
  }
  addDesignItemText(e, t, r) {
    var o;
    return r ? r.addTextElement(null, e, !1) : (o = this._sceneDesignManager) == null ? void 0 : o.addItemText(e, t);
  }
  async addDesignItemImage(e, t, r) {
    var o;
    r ? await r.insertImageById(e) : await ((o = this._sceneDesignManager) == null ? void 0 : o.addItemImage(e, t));
  }
  getDesignItemsInfo() {
    var e;
    return ((e = this._sceneDesignManager) == null ? void 0 : e.getItemsInfo()) || [];
  }
  setDesignItemText(e, t, r) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemText(e, t), r == null || r.modifyTextElementContentByGuid(e, t);
  }
  setDesignItemBold(e, t, r) {
    var a;
    (a = this._sceneDesignManager) == null || a.setItemBold(e, t);
    let o = r == null ? void 0 : r.findItemByGuid(e);
    if (o && r) {
      let f = r.getTextItemInfo(o).fontWeight.split(" "), v = [f.length > 1 ? f[0] : "normal"];
      v.push(t ? "bold" : "normal"), r.modifyTextElementFontWeight(o, v.join(" "));
    }
  }
  setDesignItemItalic(e, t, r) {
    var a;
    (a = this._sceneDesignManager) == null || a.setItemItalic(e, t);
    let o = r == null ? void 0 : r.findItemByGuid(e);
    if (o && r) {
      let f = r.getTextItemInfo(o).fontWeight.split(" "), v = [t ? "italic" : "normal"];
      v.push(f.length > 1 ? f[1] : f[0]), r.modifyTextElementFontWeight(o, v.join(" "));
    }
  }
  setDesignItemColor(e, t, r) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemColor(e, t), r == null || r.modifyTextElementFillColorByGuid(e, t);
  }
  setDesignItemFontFamily(e, t, r) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemFontFamily(e, t), r == null || r.modifyTextElementFontFamilyByGuid(e, t);
  }
  async setDesignItemImage(e, t, r) {
    var o;
    await ((o = this._sceneDesignManager) == null ? void 0 : o.setItemImage(e, t)), r == null || r.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t, r, o) {
    var u;
    (u = this._sceneDesignManager) == null || u.setItemTextOnPath(e, t, r);
    let a = o == null ? void 0 : o.findItemByGuid(e);
    r ? o == null || o.convertToTextOnPath(a) : o == null || o.convertToTextArea(a);
  }
  removeDesignItemImage(e, t) {
    var r;
    t == null || t.deselectAll(), t == null || t.removeImageByGuid(e), t == null || t.updateSelectionState(), (r = this._sceneDesignManager) == null || r.removeItemImage(e);
  }
  setDesignVisibility(e, t) {
    var r;
    (r = this._sceneDesignManager) == null || r.setDesignVisibility(e, t);
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let e = 0; e < this._scene.materials.length; e++) {
        const t = this._scene.materials[e];
        this.setupShaderMaterialCameraPosition(t);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    this._scene && this._scene.activeCamera && e && e instanceof BABYLON.ShaderMaterial && e.setVector3("cameraPosition", this._scene.activeCamera.position);
  }
  setMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.setMeshLocationByID(e);
  }
  async explodeMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.explodeMeshes();
  }
  async collapseMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.collapseMeshes();
  }
  dracoDecodingFunction(e, t, r) {
    this.decodeDracoFile(e, t, r);
  }
  decodeDracoFile(e, t, r) {
    var o = (/* @__PURE__ */ new Date()).getTime(), a = new Uint8Array(t), u = msgpack.decode(a);
    this.dracoCompression.decodeMeshAsync(u.data, u.attributes).then(function(f) {
      let v = {};
      f && (f.indices && (v.indices = f.indices), f.positions && (v.positions = f.positions), f.normals && (v.normals = f.normals), f.tangents && (v.tangents = f.tangents), f.uvs && (v.uvs = f.uvs), f.uvs2 && (v.uv2s = f.uvs2), f.uvs3 && (v.uv3s = f.uvs3), f.uvs4 && (v.uv4s = f.uvs4), f.uvs5 && (v.uv5s = f.uvs5), f.uvs6 && (v.uv6s = f.uvs6));
      var S = /* @__PURE__ */ new Date(), I = S.getTime(), D = I - o, Z = S.getHours() + ":" + S.getMinutes() + ":" + S.getSeconds() + "." + S.getMilliseconds();
      console.log(
        "Draco Decoding [" + Z + "] - " + e + "	" + t.byteLength + "	" + D + " ms"
      ), r && r(v);
    });
  }
  exportSceneToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportSceneToBabylon();
  }
  exportVisibleMeshesToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportVisibleMeshesToBabylon();
  }
  async exportMeshesForTyOnToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : await this._sceneHelper.exportMeshesForTyOnToBabylon();
  }
  async exportMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    const t = this._scene.getMeshById(e);
    return t ? await this._sceneHelper.exportMeshToBabylon(t) : null;
  }
  async downloadMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return;
    const t = this._scene.getMeshById(e);
    t && await this._sceneHelper.downloadMeshBabylonAsync(t);
  }
  async saveSceneOnDatabaseAsync(e) {
    const t = this.exportSceneToBabylon();
    if (t) {
      const r = new Of();
      await r.openAsync(), await r.saveFileAsync(e, t);
    }
  }
  async saveVisibleMeshesOnDatabaseAsync(e) {
    const t = await this.exportMeshesForTyOnToBabylon();
    if (t) {
      const r = new Of();
      await r.openAsync(), await r.saveFileAsync(e, t);
    }
  }
  async saveGlbOnDatabaseAsync(e) {
    let t = null, r = "";
    if (t = await this.exportSceneToLocalGLBAsync(), t) {
      const o = await t.arrayBuffer(), a = Math.random().toString(36).substring(7), u = new FormData();
      u.append("blob", new Blob([o]), `model_${a}.glb`);
      try {
        const f = await fetch(Zakeke.config.baseApiUrl + "tryonassetupload/asset-upload", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.token
          },
          body: u
        });
        if (f.status === 200)
          return r = await f.text(), r = r.replace(/^"|"$/g, "").substring(r.indexOf("fileUrl=") + 8 - 1), console.log("solo parametro restituito da asset-upload", r), r;
        console.error("Error uploading model", f);
      } catch (f) {
        console.error("Error uploading model", f);
      }
    }
    return r;
  }
  getArFileUrlCacheKey(e, t, r = "usdz") {
    let o = "scene_" + e;
    if (t && (o += "_code_" + t), this._sceneDesignManager) {
      var a = this._sceneDesignManager.getDesignItemsJson();
      if (a) {
        var u = CryptoJS.SHA1(a).toString();
        o += "_design_" + this._sceneDesignManager.getDesignID() + "_" + u;
      }
    }
    return o += "_" + r, o;
  }
  getCachedArFileUrl(e, t, r = "usdz") {
    var o = this.getArFileUrlCacheKey(e, t, r);
    return this._arFileUrls.hasOwnProperty(o) ? this._arFileUrls[o] : null;
  }
  cacheArFileUrl(e, t, r, o) {
    if (o) {
      var a = this.getArFileUrlCacheKey(e, t || void 0, r);
      this._arFileUrls[a] = o;
    }
  }
  async exportMeshToGLBBlob(e) {
    var a, u, f, v;
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    let t = null;
    const r = this._zkScene.get("rootUrl");
    r && (t = r), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToRasterizedTextures()), (u = this._sceneDesignManager) == null || u.expandCanvasMeshes(0.05);
    let o = await this._sceneHelper.exportMeshToGLBBlob(t, e);
    return console.log("dopo l'export faccio rientrare l'expand", o), (f = this._sceneDesignManager) == null || f.expandCanvasMeshes(-0.05), await ((v = this._sceneDesignManager) == null ? void 0 : v.changeToDynamicTextures()), o;
  }
  async exportSceneToUsdzAsync(e, t, r) {
    var I, D, Z, M;
    if (!this._zkScene || !this._sceneHelper)
      return null;
    const o = "usdz";
    let a = null;
    if (e && (!this._sceneDesignManager || r) && (a = this.getCachedArFileUrl(e, t, o)), a)
      return a;
    let u = null, f = null;
    const v = this._zkScene.get("name");
    v && (u = v);
    const S = this._zkScene.get("rootUrl");
    return S && (f = S), await ((I = this._sceneDesignManager) == null ? void 0 : I.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), a = await this._sceneHelper.exportSceneToUsdzAsync(
      u,
      f,
      this._sceneDesignManager && !r ? void 0 : e,
      this._sceneDesignManager && !r ? void 0 : t,
      ((D = this.zkScene) == null ? void 0 : D.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (Z = this._zkScene) == null ? void 0 : Z.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((M = this._sceneDesignManager) == null ? void 0 : M.changeToDynamicTextures()), a && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, o, a), a;
  }
  async exportMeshToUsdzAsync(e) {
    var r, o, a;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let u = null;
      const f = this._zkScene.get("rootUrl");
      f && (u = f), await ((r = this._sceneDesignManager) == null ? void 0 : r.changeToRasterizedTextures());
      const v = await this._sceneHelper.exportMeshToUsdzAsync(
        u,
        t,
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToDynamicTextures()), Logger.info("USDZ: " + v), v;
    }
    return null;
  }
  async exportSceneToRemoteGlTFAsync(e, t, r) {
    var v, S, I, D;
    if (!this._sceneHelper)
      return null;
    const o = "glTF";
    let a = null;
    if (e && (!this._sceneDesignManager || r) && (a = this.getCachedArFileUrl(e, t, o)), a)
      return a;
    let u = null, f = null;
    if (this._zkScene) {
      const Z = this._zkScene.get("name");
      Z && (u = Z);
      const M = this._zkScene.get("rootUrl");
      M && (f = M);
    }
    return await ((v = this._sceneDesignManager) == null ? void 0 : v.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), a = await this._sceneHelper.exportSceneToRemoteGlTFAsync(
      u,
      f,
      this._sceneDesignManager && !r ? void 0 : e,
      this._sceneDesignManager && !r ? void 0 : t,
      ((S = this.zkScene) == null ? void 0 : S.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (I = this._zkScene) == null ? void 0 : I.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((D = this._sceneDesignManager) == null ? void 0 : D.changeToDynamicTextures()), a && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, o, a), Logger.info("GlTF: " + a), a;
  }
  async exportMeshToRemoteGlTFAsync(e) {
    var r, o, a;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let u = null;
      const f = this._zkScene.get("rootUrl");
      f && (u = f), await ((r = this._sceneDesignManager) == null ? void 0 : r.changeToRasterizedTextures());
      const v = await this._sceneHelper.exportMeshToRemoteGlTFAsync(
        u,
        t,
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + v), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToDynamicTextures()), v;
    }
    return null;
  }
  async exportSceneToRemoteGLBAsync(e, t, r) {
    var v, S, I, D;
    if (!this._sceneHelper)
      return null;
    const o = "glb";
    let a = null;
    if (e && (!this._sceneDesignManager || r) && (a = this.getCachedArFileUrl(e, t, o)), a)
      return a;
    let u = null, f = null;
    if (this._zkScene) {
      const Z = this._zkScene.get("name");
      Z && (u = Z);
      const M = this._zkScene.get("rootUrl");
      M && (f = M);
    }
    return await ((v = this._sceneDesignManager) == null ? void 0 : v.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), a = await this._sceneHelper.exportSceneToRemoteGLBAsync(
      u,
      f,
      this._sceneDesignManager && !r ? void 0 : e,
      this._sceneDesignManager && !r ? void 0 : t,
      ((S = this.zkScene) == null ? void 0 : S.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (I = this._zkScene) == null ? void 0 : I.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((D = this._sceneDesignManager) == null ? void 0 : D.changeToDynamicTextures()), a && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, o, a), Logger.info("GLB: " + a), a;
  }
  async exportMeshToRemoteGLBAsync(e) {
    var r, o, a;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let u = null;
      const f = this._zkScene.get("rootUrl");
      f && (u = f), await ((r = this._sceneDesignManager) == null ? void 0 : r.changeToRasterizedTextures());
      const v = await this._sceneHelper.exportMeshToRemoteGLBAsync(
        u,
        t,
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + v), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToDynamicTextures()), v;
    }
    return null;
  }
  // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportSceneToARAsync(e, t) {
    var u, f;
    let r = [];
    if (!this._sceneHelper)
      return r;
    let o = null, a = null;
    if (this._zkScene) {
      const v = this._zkScene.get("name");
      v && (o = v);
      const S = this._zkScene.get("rootUrl");
      S && (a = S);
    }
    return await ((u = this._sceneDesignManager) == null ? void 0 : u.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), r = await this._sceneHelper.exportSceneToARMultiformatAsync(
      o,
      a,
      ["usdz", "glb"],
      e,
      t
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((f = this._sceneDesignManager) == null ? void 0 : f.changeToDynamicTextures()), r;
  }
  // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportMeshToARAsync(e) {
    var o, a, u;
    let t = [];
    const r = this.getMeshByID(e);
    if (r && this._zkScene && this._sceneHelper) {
      let f = null;
      const v = this._zkScene.get("rootUrl");
      v && (f = v), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToRasterizedTextures()), t = await this._sceneHelper.exportMeshToARMultiformatAsync(
        f,
        r,
        ["usdz", "glb"],
        ((a = this.zkScene) == null ? void 0 : a.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      ), await ((u = this._sceneDesignManager) == null ? void 0 : u.changeToDynamicTextures());
    }
    return t;
  }
  isAREnabled() {
    if (!this._zkScene)
      return !1;
    let e = this._zkScene.getAREnabled();
    return e != null && e && this._sceneHelper != null && // this._sceneHelper.getMeshesForAR().length > 0 &&
    this._sceneHelper.checkMaterialsForAR();
  }
  async exportSceneToLocalGLBAsync() {
    var t, r;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalGLBBlobAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((r = this._sceneDesignManager) == null ? void 0 : r.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalGLBAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalGLBAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  async exportSceneToLocalUSDZAsync() {
    var t, r;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalUSDZUrlAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((r = this._sceneDesignManager) == null ? void 0 : r.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalUSDZAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalUSDZAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  getSceneRootUrl() {
    return new Promise((e, t) => {
      let r = null;
      this._zkScene ? (r = this._zkScene.get("rootUrl") || null, r ? e(r) : jQuery.ajax({
        url: this._zkScene.getSceneRootUrlApiUrl(),
        type: "GET",
        success: function(o) {
          r = o, e(r);
        },
        error: function(o, a, u) {
          t(u);
        }
      })) : e(r);
    });
  }
  isTryOnMeshVisibleEnabledToShow() {
    const e = this.getVisibleMeshes();
    for (const t of e) {
      const r = t.getChildren();
      if (r.length > 0 && r.find(
        (a) => this._sceneHelper.isTryOnEnabledForMesh(a)
      ) && this._sceneHelper.isTryOnEnabledForMesh(t))
        return !0;
    }
    return !1;
  }
  getTryOnMeshVisible() {
    const e = this.getVisibleMeshes();
    for (let t of e) {
      const r = t.getChildren();
      if (r.length > 0 && !t.parent && r.find(
        (a) => {
          var u;
          return (u = this._sceneHelper) == null ? void 0 : u.isTryOnEnabledForMesh(a);
        }
      ))
        return t;
    }
    return null;
  }
  getFrameDAMSettings() {
    if (this._zkScene) {
      const e = this._zkScene.getFrameDAMSettings() ?? null;
      if (e)
        return JSON.parse(e);
    }
    return null;
  }
  getMeshFineTuningData(e) {
    const t = typeof e == "string" ? this.getMeshByID(e) : e;
    return t && t.metadata && t.metadata.tryOnFineTuningSettings ? t.metadata.tryOnFineTuningSettings : null;
  }
  getDAMFineTuningData() {
    var e, t;
    return (e = this.zkScene) != null && e.getFrameDAMSettings() && ((t = this.getFrameDAMSettings()) == null ? void 0 : t.finetuning) || null;
  }
  getTryOnFineTuningMeshVisible() {
    var t;
    const e = this.getVisibleMeshes();
    for (const r of e) {
      const o = r.getChildren();
      if (o.length > 0 && o.find(
        (u) => {
          var f;
          return (f = this._sceneHelper) == null ? void 0 : f.isTryOnEnabledForMesh(u);
        }
      ) && (t = r == null ? void 0 : r.metadata) != null && t.tryOnFineTuningSettings)
        return r;
    }
    return null;
  }
  refreshInfoPoints() {
    if (!(this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints)) {
      this.disposeInfoPointsManager(), this.setLongRenderingNeeded();
      return;
    }
    const t = this.getInfoPointsManagerStyle();
    let r = null;
    this._infoPointsManager || this._scene && this._zkScene && (this._infoPointsManager = new Jx(this._zkScene, this._scene, t), this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0 && this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners), this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0 && this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners), this._infoPointContentHiddenListeners && this._infoPointContentHiddenListeners.length > 0 && this._infoPointsManager.addInfoPointContentHiddenListenerRange(
      this._infoPointContentHiddenListeners
    ), this._infoPointsManager.onBeforeShowImages = () => {
      r === null && (r = this.antiAliasConfig.enabled), this.antiAliasConfig.enabled = !1, this.disableAntialiasing();
    }, this._infoPointsManager.onAfterShowImages = () => {
      this.antiAliasConfig.enabled = r, r = null, this.enableAntialiasing(), this.setLongRenderingNeeded();
    }, this._infoPointsManager.addRenderingNeededListener(() => this.setRenderingNeeded())), this._infoPointsManager && (this.updateInfoPointsManagerStyle(), this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent, this._infoPointsManager.refresh()), this.setLongRenderingNeeded();
  }
  getInfoPointsManagerStyle() {
    const e = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsStyleConfig();
      t && (e.infoPointsStyle || (e.infoPointsStyle = {}), t.get("borderColor") && (e.infoPointsStyle.borderColor = t.get("borderColor")), t.get("innerPointColor") && (e.infoPointsStyle.innerPointColor = t.get("innerPointColor")), t.get("color") && (e.infoPointsStyle.color = t.get("color")), t.get("highlightColor") && (e.infoPointsStyle.highlightColor = t.get("highlightColor")));
    }
    return e;
  }
  updateInfoPointsManagerStyle() {
    if (this._infoPointsManager) {
      const e = this.getInfoPointsManagerStyle();
      this._infoPointsManager.applyStyle(e);
    }
  }
  showInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.showInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  hideInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.hideInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  // try to reload all textures with loading errors
  async reloadAllLoadingErrorTexturesAsync() {
    if (this._zkScene && this._sceneHelper) {
      const e = this._zkScene.get("rootUrl");
      e && await this._sceneHelper.reloadAllLoadingErrorTexturesAsync(e);
    }
  }
  // try to reload the material textures with loading errors
  async reloadMaterialLoadingErrorTexturesAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(t, e);
    }
  }
  // try to reload the texture having loading errors
  async reloadLoadingErrorTextureAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadLoadingErrorTextureAsync(t, e);
    }
  }
  // were there any loading errors for the texture?
  isTextureLoadingError(e) {
    return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(e) : !1;
  }
  // the material has some texture with loading errors
  materialHasLoadingErrorTextues(e) {
    return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(e) : !1;
  }
  notifyCameraMovement() {
    if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.postMessage({
        type: "camera-movement",
        target: { x: this._camera.target.x, y: this._camera.target.y, z: this._camera.target.z },
        alpha: this._camera.alpha,
        beta: this._camera.beta,
        radius: this._camera.radius
      });
    }
  }
  notifyScriptExecution(e) {
    if (this._isHologramSource) {
      const t = e.map((o) => ({
        attributeID: o.attributeID,
        selectedValue: o.selectedValue,
        actions: o.actions.map((a) => a.toJSON())
        /*
        actions: s.actions.map(a => ({
        	attributeGuid: a.get("actionGuid"),
        	name: a.get("name"),
        	actionTypeID: a.get("actionTypeID"),
        	sceneElementTypeID: a.get("sceneElementTypeID"),
        	selector: a.get("selector"),
        	propertyName: a.get("propertyName"),
        	value: a.get("value"),
        	execOrder: a.get("execOrder"),
        	deviceTypes: a.get("deviceTypes")
        }))
        */
      }));
      let r = this.getOrCreateBroadcastChannel();
      if (!r)
        return;
      r.postMessage({
        type: "script-execution",
        script: t
      });
    }
  }
  notifyDesignChanged(e) {
    if (this._isHologramSource) {
      let t = this.getOrCreateBroadcastChannel();
      if (!t)
        return;
      t.postMessage({
        type: "design-changed",
        design: e.toJSON()
      });
    }
  }
  notifyActionExecution(e, t, r) {
    this.notifyScriptExecution([
      {
        attributeID: e,
        selectedValue: t,
        actions: r
      }
    ]);
  }
  attachBroadcastChannelEventHandlers() {
    if (this._isHologram && !this._isHologramSource) {
      var e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.onmessage = (t) => this.onBroadcastMessageReceived(t);
    }
  }
  detachBroadcastChannelEventHandlers() {
    this._broadcastChannel && (this._broadcastChannel.onmessage = null);
  }
  onBroadcastMessageReceived(e) {
    this._isHologram && e && e.data && e.data.type && (e.data.type === "camera-movement" ? this.processCameraMovementEvent(e) : e.data.type === "script-execution" ? this.processScriptExecution(e) : e.data.type === "design-changed" && this.processDesignChanged(e));
  }
  processCameraMovementEvent(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && e && e.data && (this._camera.target = new BABYLON.Vector3(e.data.target.x, e.data.target.y, e.data.target.z), this._camera.alpha = e.data.alpha, this._camera.beta = e.data.beta, this._camera.radius = e.data.radius, this.setRenderingNeeded());
  }
  processScriptExecution(e) {
    if (e && e.data && e.data.script && Object.prototype.toString.call(e.data.script) === "[object Array]") {
      var t = e.data.script.map(
        (r) => ({
          attributeID: r.attributeID,
          selectedValue: r.selectedValue,
          actions: r.actions.map((o) => new MPlaza.AttributeSceneAction(o))
        })
      );
      this.executeScriptAsync(t);
    }
  }
  processDesignChanged(e) {
    if (e && e.data && e.data.design) {
      let t = new MPlaza.Design(e.data.design);
      this.renderDesignAsync(t);
    }
  }
  loadSceneConfig(e) {
    const t = new Zakeke.SceneConfig(e);
    if (this._zkScene && !this._zkScene.get("config"))
      this._zkScene.set("config", t);
    else {
      const r = new Zakeke.Scene();
      r.set("config", t), this._zkScene = r;
    }
    this.checkSceneShaderMaterials(this._zkScene);
  }
  updateFromConfig(e, t) {
    var r, o;
    if (this._zkScene) {
      let a = (o = (r = this._zkScene) == null ? void 0 : r.get("config")) == null ? void 0 : o.toJSON();
      const u = rw.merge(a, e), f = new Zakeke.SceneConfig(u);
      if (this._zkScene.set("config", f), (t == null ? void 0 : t.preventRefresh) === !0)
        return;
      this.setupSceneAsync((t == null ? void 0 : t.updateCamera) === !0);
    }
  }
  /**
   * Set up new camera position if parameter is present in config
   */
  refreshCameraPosition() {
    var r, o, a;
    const e = (o = (r = this._zkScene) == null ? void 0 : r.get("config")) == null ? void 0 : o.toJSON(), t = e == null ? void 0 : e.camera;
    t && (t != null && t.position) && ((a = this._sceneHelper) == null || a.setUpCameraByOptions(t.position));
  }
  setupDebugGUI() {
    var r;
    const e = (r = this._zkScene) == null ? void 0 : r.get("config"), t = (o) => {
      this.updateFromConfig(o, { updateCamera: !1 });
    };
    this._createGui = new Ow(
      e.toJSON(),
      (o) => t(o),
      this._sceneHelper
    ), this._createGui.setupGui(this._scene);
  }
  async setUpEmptyScene(e) {
    this._scene && (e && this.loadSceneConfig(e), await this.setupSceneAsync(), this.setRenderingNeeded());
  }
  /**
   * Loads a babylon scene from a remote URL.
   * @param rootUrl The root URL of the scene.
   * @param sceneFileName The name of the scene file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromSceneUrl(e, t, r) {
    await this.loadSceneFromRemoteFilesAsync(e, t), r && this.loadSceneConfig(r), await this.setupSceneAsync(), this.setRenderingNeeded();
  }
  stopAllAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.stopAllAnimations();
  }
  hasAnimations() {
    return this._scene && this._sceneHelper ? this._sceneHelper.hasAnimations() : !1;
  }
  playAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.playAnimations();
  }
  // al momento Marco FF ha detto che non serve esposto
  // public setupAnimations () {
  // 	if (this._scene && this._sceneHelper) {
  // 		this._sceneHelper.setupAnimations(this._zkScene);
  // 	}
  // }
  /**
   * Loads a scene from a GLB file URL.
   * @param url The URL of the GLB file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromGlbUrl(e, t) {
    var o, a, u;
    const r = ((o = t == null ? void 0 : t.camera) == null ? void 0 : o.animateIntro) !== void 0 ? (a = t == null ? void 0 : t.camera) == null ? void 0 : a.animateIntro : !0;
    await ((u = this._sceneHelper) == null ? void 0 : u.importMeshesFromUrlAsync(e, null, void 0, r, ".glb", this._isViewer)), t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!1, !0);
  }
  /**
   * Loads a scene from a file.
   * @param file The file to load the scene from.
   */
  async loadFromFile(e, t) {
    var r, o;
    ((r = t == null ? void 0 : t.camera) == null ? void 0 : r.animateIntro) !== void 0 && ((o = t == null ? void 0 : t.camera) == null || o.animateIntro);
    try {
      await BABYLON.SceneLoader.AppendAsync(e.name, e, this._scene);
    } catch (a) {
      console.log("dropObjectIntoScene: ", a);
    }
    t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!0, !0), this.setRenderingNeeded();
  }
  async showResizableCanvasModel(e) {
    if (this._scene && this._zkScene && this._zkModel && this._sceneHelper) {
      const t = await this._sceneHelper.showResizableCanvas(
        e.width,
        e.height,
        e.depth,
        e.borderRadius,
        e.type,
        e.borderColor,
        e.columns,
        e.rows,
        e.ppcm
      );
      if (!t)
        return { meshes: [], matrixJson: "" };
      const r = new hw.PaperScope();
      r.setup(new r.Size(1, 1));
      const o = new r.Matrix(), a = Vd.DEFAULT_SIZE;
      o.translate(a / 2, a / 2), o.scale(a / e.width, a / e.height);
      const u = JSON.stringify(o.values);
      return { meshes: t, matrixJson: u };
    }
    return { meshes: [], matrixJson: "" };
  }
  async showResizableCanvasPerCurrentSide(e) {
    console.log("showResizableCanvasPerCurrentSide", e);
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-${e.currentSideId}-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const r = await this.showResizableCanvasModel(e);
    if (r.meshes.length === 0)
      return;
    const o = this._zkModel.get("scenes").at(0).get("meshSides");
    o.filter((v) => v.get("isResizable")).forEach((v) => o.remove(v));
    const u = e.type === "mirrored" ? ["front", "borders"] : ["front"];
    let f = 0;
    for (const v of r.meshes)
      if (v && u.includes(v.name)) {
        v.id = t.replace("sideIdPlaceholder", e.currentSideId.toString()) + f++;
        const S = new MPlaza.ModelSceneMeshSide({
          sideID: e.currentSideId,
          meshID: v.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: r.matrixJson,
          isResizable: !0
        });
        o.push(S);
      }
    console.log({ meshSides: o }), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async showResizableCanvasPerVariant(e) {
    if (console.log("showResizableCanvasPerVariant", e), !this.zkModel)
      return;
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-sideIdPlaceholder-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const r = await this.showResizableCanvasModel(e);
    if (r.meshes.length === 0)
      return;
    let o = 0;
    const a = e.sidesIds.length > 1;
    let u = ["front", "back", "borders"];
    e.type === "colored" ? a ? u = ["front", "back"] : u = ["front"] : e.type === "mirrored" && (a ? u = ["front", "back", "borders"] : u = ["front", "borders"]);
    const f = this._zkModel.get("scenes").at(0).get("meshSides");
    f.filter((S) => S.get("isResizable")).forEach((S) => f.remove(S));
    for (const S of r.meshes)
      if (S && u.includes(S.name)) {
        const I = !a || S.name === "front" ? e.sidesIds[0] : e.sidesIds[1];
        S.id = t.replace("sideIdPlaceholder", I.toString()) + o++;
        const D = new MPlaza.ModelSceneMeshSide({
          sideID: I,
          meshID: S.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: r.matrixJson,
          isResizable: !0
        });
        f.push(D);
      }
    setTimeout(() => this.adjustCamera(!1), 100);
  }
  clearResizableProduct() {
    var e;
    (e = this._sceneHelper) == null || e.clearResizableMeshes();
  }
  setMouseWheelInputEnabled(e) {
    this._camera && this._mouseWheelInput && (e ? this._camera.inputs.add(this._mouseWheelInput) : this._camera.inputs.remove(this._mouseWheelInput));
  }
  setCameraPinchingZoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.inputs.attached.pointers;
      t.pinchZoom = e, t.multiTouchPanAndZoom = e;
    }
  }
  switchMode(e) {
    var t;
    e === "upload" && (this._lastResizableMeshID = ""), (t = this._sceneHelper) == null || t.switchMode(e), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async setCanvasRotation(e, t) {
    var v;
    if (e = e % 360, this._isRotating || !this._zkModel || !this._sceneHelper || !this._sceneDesignManager || this._currentRotation === e)
      return;
    const r = this._zkModel.get("scenes").at(0).get("meshSides");
    if (r.length === 0)
      return;
    const a = r.at(0).get("meshID"), u = this.getMeshByID(a);
    if (!u)
      return;
    const f = u.getFacetNormal(0);
    this._isRotating = !0, await ((v = this._sceneHelper) == null ? void 0 : v.rotate(this._currentRotation - e, f, t)), this._currentRotation = e, this._isRotating = !1, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync(), this.setRenderingNeeded();
  }
  getFitToScreenMargin() {
    return this._zkScene ? this._zkScene.getFitToScreenMargin() : 1;
  }
  setFitToScreenMargin(e) {
    this._zkScene && this._zkScene.setFitToScreenMargin(e);
  }
}
class Nw {
  constructor(e) {
    this.materials = [], this.guid = Zakeke.generateUUID(), this.groupName = e;
  }
}
var Rw = /* @__PURE__ */ ((y) => (y[y.uploading = 0] = "uploading", y[y.progress = 1] = "progress", y[y.checking = 2] = "checking", y[y.success = 3] = "success", y[y.completed_success = 4] = "completed_success", y[y.completed_error = 5] = "completed_error", y))(Rw || {});
const ag = class ll extends mu {
  constructor(e) {
    super({ configPreview: !0 }), this._dracoEnabled = !0, this._dracoEncodingSpeed = 5, this._dracoDecodingSpeed = 5, this._envMode = Ar.Editor, this._selectOnPick = !0, this._showBoundingBox = !1, this._editorBackgroundColor = "#444444", this._showGround = !0, this._ground = null, this._showLights = !1, this._lightsLayer = null, this._showAxes = !1, this._axesLayer = null, this._showFineTuning = !1, this._fineTuningModelLoaded = !1, this._showHighlight = !0, this._highlightOver = !0, this._highlightOverColor = "#0082ff", this._editingMode = qa.None, this._manipulatedNode = null, this._oldManipulatedNode = null, this._EditControl = org.ssatguru.babylonjs.component.EditControl, this._editControl = null, this._editControlVisible = !1, this._shiftPressed = !1, this._ctrlPressed = !1, this._realMeshVisibility = {}, this._sceneSourceTasks = [], this._isLoadingSourceFiles = !1, this._authorizationToken = "", this._incrementalWorkersScriptsUrls = [], this._preUpdateListeners = [], this._postUpdateListeners = [], this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [], this._pickedProvider = Xd.NotSelected, this._providerData = { mesh: new Blob() }, this._sessionTryOnEnabled = !1, this._tryOnInfoLoading = !0, this._initialMeshMaterials = {}, this._initialSubMeshMaterials = {}, this._lastMeshMaterials = {}, this._lastSubMeshMaterials = {}, this._meshOver = null, this._incrementalFilesMaker = null, this._sceneToBlobs = null, this._showMeasurements = !1, this._modelMeasurements = BABYLON.Vector3.Zero(), e && (this._incrementalWorkersScriptsUrls = e.incrementalWorkersScriptsUrls, this._authorizationToken = e.authorizationToken, e.showGround != null && e.showGround != null && (this._showGround = e.showGround), e.editorBackgroundColor !== void 0 && e.editorBackgroundColor !== null && (this._editorBackgroundColor = e.editorBackgroundColor), e.showHighlight !== void 0 && e.showHighlight !== null && (this._showHighlight = e.showHighlight), e.highlightColor !== void 0 && e.highlightColor !== null && (this._highlightColor = e.highlightColor), e.highlightOver !== void 0 && e.highlightOver != null && (this._highlightOver = e.highlightOver), e.highlightOverColor !== void 0 && e.highlightOverColor != null && (this._highlightOverColor = e.highlightOverColor));
  }
  // Real mesh visibility
  get realMeshVisibility() {
    return this._realMeshVisibility;
  }
  // Environemnt manager
  get environmentManager() {
    return this._environmentManager;
  }
  // EnvMode
  get envMode() {
    return this._envMode;
  }
  // Source tasks
  get sceneSourceTasks() {
    return this._sceneSourceTasks;
  }
  set envMode(e) {
    this._envMode != e && (this._envMode = e, this.refreshEnvironment());
  }
  // SelectOnPick
  get selectOnPick() {
    return this._selectOnPick;
  }
  set seletOnPick(e) {
    this._selectOnPick != e && (this._selectOnPick = e);
  }
  // ShowBoundingBox
  get showBoundingBox() {
    return this._showBoundingBox;
  }
  set showBoundingBox(e) {
    this._showBoundingBox != e && (this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded());
  }
  // EditorBackgroundColor
  get editorBackgroundColor() {
    return this._editorBackgroundColor;
  }
  set editorBackgroundColor(e) {
    this._editorBackgroundColor != e && this.setEditorBackgroundColor(e);
  }
  // ShowGround
  get showGround() {
    return this._showGround;
  }
  set showGround(e) {
    this._showGround != e && (this._showGround = e, this.refreshGround());
  }
  // ShowLights
  get showLights() {
    return this._showLights;
  }
  set showLights(e) {
    this._showLights != e && (this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded());
  }
  // ShowAxes
  get showAxes() {
    return this._showAxes;
  }
  set showAxes(e) {
    this._showAxes != e && (this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded());
  }
  get showFineTuning() {
    return this._showFineTuning;
  }
  set showFineTuning(e) {
    this._showFineTuning = e, this._fineTuningModelLoaded = !1;
  }
  set fineTuningModelLoaded(e) {
    this._fineTuningModelLoaded = e;
  }
  get fineTuningModelLoaded() {
    return this._fineTuningModelLoaded;
  }
  get sessionTryOnEnabled() {
    return this._sessionTryOnEnabled;
  }
  set sessionTryOnEnabled(e) {
    this._sessionTryOnEnabled = e;
  }
  get tryOnInfoLoading() {
    return this._tryOnInfoLoading;
  }
  set tryOnInfoLoading(e) {
    this._tryOnInfoLoading = e;
  }
  // ShowHighlight
  get showHighlight() {
    return this._showHighlight;
  }
  set showHighlight(e) {
    this._showHighlight != e && (this._showHighlight = e);
  }
  // HighlightOver
  get highlightOver() {
    return this._highlightOver;
  }
  set highlightOver(e) {
    this._highlightOver != e && (this._highlightOver = e);
  }
  // HighlightOverColor
  get highlightOverColor() {
    return this._highlightOverColor;
  }
  set highlightOverColor(e) {
    this._highlightOverColor != e && (this._highlightOverColor = e);
  }
  // EditingMode
  get editingMode() {
    return this._editingMode;
  }
  set editingMode(e) {
    this._editingMode != e && this.setEditingMode(e);
  }
  // EditingControlVisible
  get editControlVisible() {
    return this._editControlVisible;
  }
  set editControlVisible(e) {
    this._editControlVisible != e && this.showHideEditControl(e);
  }
  get selectedProvider() {
    return this._pickedProvider;
  }
  get selectedProviderFineTuningData() {
    return this._providerData;
  }
  get modelMeasurements() {
    return this._modelMeasurements;
  }
  set modelMeasurements(e) {
    this._modelMeasurements = e;
  }
  get showMeasurements() {
    return this._showMeasurements;
  }
  fireHideMeasurementsEvent() {
    this._showMeasurements = !1;
  }
  fireShowMeasurementsEvent() {
    this._showMeasurements = !0;
  }
  static async createSceneEditorAsync(e) {
    const t = new ll(e);
    return await t.initAsync(), t.checkSceneSourceTasks(), t;
  }
  createCanvas() {
    const e = super.createCanvas();
    return e.addEventListener(
      "keydown",
      (t) => {
        this._shiftPressed = t.key == "Shift", this._ctrlPressed = t.key == "Control";
      },
      !1
    ), e.addEventListener(
      "keyup",
      (t) => {
        this._shiftPressed = t.key != "Shift", this._ctrlPressed = t.key != "Control";
      },
      !1
    ), e.addEventListener("dblclick", (t) => {
      this.setRenderingNeeded();
    }), e;
  }
  deleteComponents() {
    super.deleteComponents(), this._editControl && (this._editControl.detach(), this._editControl = null), this._lightsLayer && (this._lightsLayer.dispose(), this._lightsLayer = null), this._axesLayer && (this._axesLayer.dispose(), this._axesLayer = null);
  }
  dispose() {
    super.dispose(), this._incrementalFilesMaker && (this._incrementalFilesMaker.dispose(), delete this._incrementalFilesMaker), this._sceneToBlobs && (this._sceneToBlobs.dispose(), delete this._sceneToBlobs);
  }
  createEngine() {
    super.createEngine(), BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = !0;
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this._engine && this.fireSceneCreatedEvent();
  }
  async setupSceneAsync() {
    await super.setupSceneAsync(), this._engine && this._scene && (this._scene.setRenderingAutoClearDepthStencil(1, !0, !0, !1), this._scene.setRenderingAutoClearDepthStencil(2, !0, !0, !1), this._lightsLayer = new tw(this), this._lightsLayer.addLightSelectedListener((e) => {
      this.lightsLayer_onLightSelected(e);
    }), this.setupAxes(), this._zkModel && this._meshLocationsManager && (this._meshLocationsManager.addBeforeSaveMeshLocationListener(() => this.onBeforeSaveMeshLocation()), this._meshLocationsManager.addAfterSaveMeshLocationListener(() => this.onAfterSaveMeshLocation())), this._scene.onPointerMove = (e, t) => this.onPointerMove(e, t));
  }
  render() {
    this.firePreUpdateEvent(), super.render(), this._lightsLayer && this._lightsLayer.render(), this._axesLayer && this._axesLayer.render(), this.firePostUpdateEvent();
  }
  deleteHighlightLayer() {
    this._highlightLayer && (this._highlightLayer.dispose(), this._highlightLayer = null), this.setRenderingNeeded();
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize, this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize);
  }
  setupAxes() {
    this._axesLayer = new ew(this);
  }
  getMatchSameNameTextures() {
    if (this._zkScene) {
      let e = this._zkScene.getMatchSameNameTextures();
      return e ?? !1;
    }
    return !1;
  }
  setMatchSameNameTextures(e) {
    this._zkScene && this._zkScene.setMatchSameNameTextures(e);
  }
  getAREnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAREnabled();
      return t ?? e;
    }
    return e;
  }
  setAREnabled(e) {
    this._zkScene && this._zkScene.setAREnabled(e);
  }
  getAROnTheFly() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAROnTheFly();
      return t ?? e;
    }
    return e;
  }
  setAROnTheFly(e) {
    this._zkScene && this._zkScene.setAROnTheFly(e);
  }
  setARAnchor(e) {
    this._zkScene && this._zkScene.setARAnchor(e);
  }
  getTryOnEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getTryOnEnabled();
      return t ?? e;
    }
    return e;
  }
  setTryOnEnabled(e) {
    this._zkScene && this._zkScene.setTryOnEnabled(e);
  }
  setTryOnSelectedType(e) {
    if (this._zkScene) {
      const t = this.getTryOnDefaultTypeSettings(), r = this._zkScene.getTryOnSettings() || t;
      r.type = e, this.setTryOnTypeSettings(r);
    }
  }
  setFrameDAMSettings(e) {
    this._zkScene && this._zkScene.setFrameDAMSettings(typeof e == "string" ? e : JSON.stringify(e));
  }
  getForceDracoCompression() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getForceDracoCompression();
      return t ?? e;
    }
    return e;
  }
  setForceDracoCompression(e) {
    this._zkScene && this._zkScene.setForceDracoCompression(e);
  }
  getWebPEnabled() {
    return this._zkScene ? this._zkScene.getWebPEnabled() : !1;
  }
  setWebPEnabled(e) {
    this._zkScene && this._zkScene.setWebPEnabled(e);
  }
  getWebPType() {
    return this._zkScene ? this._zkScene.getWebPType() : "Lossless";
  }
  setWebPType(e) {
    this._zkScene && this._zkScene.setWebPType(e);
  }
  getWebPQuality() {
    return this._zkScene ? this._zkScene.getWebPQuality() : 80;
  }
  setWebPQuality(e) {
    this._zkScene && this._zkScene.setWebPQuality(e);
  }
  setProvider(e) {
    this._pickedProvider = e;
  }
  setProviderFineTuningData(e) {
    this._providerData = {
      mesh: e.mesh ? e.mesh : this._providerData.mesh,
      settings: e.settings ? e.settings : this._providerData.settings
    };
  }
  resetProviderFineTuningData() {
    var e;
    (e = this._scene) == null || e.meshes.forEach((t) => {
      t.metadata && t.metadata.tryOnFineTuningSettings && (t.metadata.tryOnFineTuningSettings = null);
    }), this._providerData = {};
  }
  setMeshFineTuningData(e, t) {
    const r = typeof e == "string" ? this.getMeshByID(e) : e;
    r && (r.metadata || (r.metadata = {}), r.metadata.tryOnFineTuningSettings = t);
  }
  setDAMFineTuningData(e) {
    const t = {
      finetuning: e
    };
    this.setFrameDAMSettings(t);
  }
  getTryOnSelectedType() {
    if (this._zkScene) {
      let e = this._zkScene.getTryOnSettings();
      if (e && e.type)
        return e.type;
    }
    return null;
  }
  getTryOnSettings() {
    const e = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t)
        return t;
    }
    return e;
  }
  getTryOnSetting(e) {
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t && e in t.typeSettings && t.typeSettings[e] && typeof t.typeSettings[e] == "boolean")
        return t.typeSettings[e];
    }
    return !1;
  }
  setTryOnSetting(e, t) {
    let r = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let o = this._zkScene.getTryOnSettings();
      if (!o) {
        switch (e) {
          case Is.GlassPupillaryDistanceTool:
          case Is.VirtualTryOn:
          case Is.MandatoryPupillaryDistance:
            r.typeSettings[e] = t;
            break;
          case Is.StyleButton:
            r.styleButton = t;
        }
        this.setTryOnTypeSettings(r);
        return;
      }
      switch (e) {
        case Is.GlassPupillaryDistanceTool:
          o.typeSettings.pd = t;
          break;
        case Is.VirtualTryOn:
          o.typeSettings.try_on = t;
          break;
        case Is.MandatoryPupillaryDistance:
          o.typeSettings.mandatoryPD = t;
          break;
        case Is.StyleButton:
          o.styleButton = t;
          break;
      }
      o.typeSettings.pd && o.typeSettings.try_on || (o.styleButton = "single"), this._zkScene.setTryOnSettings(o);
    }
  }
  setTryOnTypeSettings(e) {
    this._zkScene && this._zkScene.setTryOnSettings(e);
  }
  getTryOnDefaultTypeSettings() {
    return {
      type: qd.NotSelected,
      styleButton: "single",
      buttonCustomizations: [
        {
          image: "base",
          textLabel: "Virtual Try-on",
          textColor: null,
          backgroundColor: null,
          borderColor: null,
          borderWidth: 0,
          borderRadius: 0
        }
      ],
      typeSettings: {
        try_on: !0,
        pd: !1,
        active: this.getTryOnEnabled() ?? !1
      }
    };
  }
  setTryOnDefaultTypeSettings() {
    let e = this.getTryOnDefaultTypeSettings();
    this.setTryOnTypeSettings(e);
  }
  getUseDelayedMaterialLoading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseDelayedMaterialLoading();
      return t ?? e;
    }
    return e;
  }
  setUseDelayedMaterialLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedMaterialLoading(e);
  }
  getUseDelayedTextureLoading() {
    if (this._zkScene) {
      let t = this._zkScene.getUseDelayedTextureLoading();
      return t ?? !1;
    }
    return !1;
  }
  setUseDelayedTextureLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedTextureLoading(e);
  }
  getGlowEnabled() {
    return this._glowManager ? this._glowManager.enabled : !1;
  }
  setGlowEnabled(e) {
    this._glowManager && (this._glowManager.enabled = e, this.setRenderingNeeded());
  }
  getGlowIntensity() {
    return this._glowManager ? this._glowManager.intensity : 1;
  }
  setGlowIntensity(e) {
    this._glowManager && (this._glowManager.intensity = e, this.setRenderingNeeded());
  }
  getGlowBlurSize() {
    return this._glowManager ? this._glowManager.blurSize : 16;
  }
  setGlowBlurSize(e) {
    this._glowManager && (this._glowManager.blurSize = e, this.setRenderingNeeded());
  }
  getInfoPointsEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getInfoPointsEnabled();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsEnabled(e) {
    this._zkScene && this._zkScene.setInfoPointsEnabled(e), this.refreshInfoPoints();
  }
  getInfoPointsBorderColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsBorderColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsBorderColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsBorderColor(e), this.refreshInfoPoints());
  }
  getInfoPointsInnerPointColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsInnerPointColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsInnerPointColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsInnerPointColor(e), this.refreshInfoPoints());
  }
  getInfoPointsColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsColor(e), this.refreshInfoPoints());
  }
  getInfoPointsHighlightColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsHighlightColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsHighlightColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsHighlightColor(e), this.refreshInfoPoints());
  }
  enableGlowForMesh(e) {
    this._glowManager && this._glowManager.enableGlowForMesh(e);
  }
  disableGlowForMesh(e) {
    this._glowManager && (this._glowManager.disableGlowForMesh(e), this.setRenderingNeeded());
  }
  enableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !0);
  }
  disableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !1);
  }
  disableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !1, e.getChildMeshes().forEach((t) => this.disableTryOnForMesh(t)));
  }
  enableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !0, e.getChildMeshes().forEach((t) => this.enableTryOnForMesh(t)));
  }
  enableInfoPointsForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.showInfoPoints = !0, this.refreshInfoPoints());
  }
  disableInfoPointsForMesh(e) {
    e && e.metadata && e.metadata.showInfoPoints !== void 0 && e.metadata.showInfoPoints !== null && (delete e.metadata.showInfoPoints, this.refreshInfoPoints());
  }
  enableForcedInfoPointsVisibilityOnMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.forceShowInfoPoints = !0, this.refreshInfoPoints());
  }
  disableForcedInfoPointsVisibilityOnMesh(e) {
    e && e.metadata && e.metadata.forceShowInfoPoints !== void 0 && e.metadata.forceShowInfoPoints !== null && (delete e.metadata.forceShowInfoPoints, this.refreshInfoPoints());
  }
  setEditorBackgroundColor(e) {
    this._editorBackgroundColor = e, this.refreshEnvironment();
  }
  setViewerBackgroundAlpha(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", e), this.refreshEnvironment());
  }
  setViewerBackgroundColor(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundColor", e), this.refreshEnvironment());
  }
  setViewerEnvironmentSizeAuto(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("sizeAuto", e), this.refreshEnvironment());
  }
  setViewerEnvironmentMainColor(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("mainColor", e), this.refreshEnvironment());
  }
  setViewerSkyboxCreateSkybox(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("createSkybox", e), this.refreshEnvironment());
  }
  setViewerSkyboxSize(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerSkyboxBlur(e) {
    if (this._zkScene) {
      let t = e >= 0 ? e : 0;
      this._zkScene.getOrCreateSkyboxConfig().set("blur", t), this.refreshEnvironment();
    }
  }
  setViewerSkyboxTexture(e, t, r) {
    if (this._zkScene && e != null && typeof e == "string") {
      const o = this._zkScene.getOrCreateSkyboxConfig();
      o.set("texture", e), o.set("extensions", t), o.set("files", r), this.refreshEnvironment();
    }
  }
  removeViewerSkyboxTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getSkyboxConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerSkyboxColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateSkyboxConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundCreateGround(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("createGround", e), this.refreshEnvironment());
  }
  setViewerGroundSize(e) {
    this._zkScene && (this._zkScene.getOrCreateGroundConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerGroundTexture(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("texture", e), this.refreshEnvironment());
  }
  removeViewerGroundTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getGroundConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerGroundColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundOpacity(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("opacity", e), this.refreshEnvironment());
  }
  setViewerGroundEnableShadow(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableShadow", e), this.refreshEnvironment());
  }
  setViewerGroundShadowLevel(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("shadowLevel", e), this.refreshEnvironment());
  }
  setViewerGroundEnableMirror(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableMirror", e), this.refreshEnvironment());
  }
  setViewerGroundMirrorBlur(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("mirrorBlurKernel", e), this.refreshEnvironment());
  }
  setViewerCameraAutoRotate(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("autoRotate", e), this.autoRender = e, this.refreshEnvironment());
  }
  setViewerCameraContrast(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("contrast", e), this.refreshEnvironment());
  }
  setViewerCameraExposure(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("exposure", e), this.refreshEnvironment());
  }
  setViewerCameraUpperAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("lowerAlphaLimit");
      this._zkScene.setCameraUpperAlphaLimit(Math.max(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperAlphaLimit(Math.max(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("upperAlphaLimit");
      this._zkScene.setCameraLowerAlphaLimit(Math.min(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerAlphaLimit(Math.min(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("upperBetaLimit");
      this._zkScene.setCameraLowerBetaLimit(Math.min(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerBetaLimit(Math.min(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraUpperBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const o = this._zkScene.getOrCreateCameraConfig().get("lowerBetaLimit");
      this._zkScene.setCameraUpperBetaLimit(Math.max(e, o ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperBetaLimit(Math.max(e, o ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraToneMappingEnabled(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("toneMappingEnabled", e), this.refreshEnvironment());
  }
  serializeFromVector(e) {
    return e ? { x: e.x, y: e.y, z: e.z } : null;
  }
  setModelTransformsFromDAMMesh() {
    var t;
    const e = this.getDAMMainMesh();
    if (e) {
      const r = e.position, o = e.rotation, a = e.scaling, u = (t = this._zkScene) == null ? void 0 : t.getOrCreateModelConfig();
      u.set("position", this.serializeFromVector(r)), u.set("rotation", this.serializeFromVector(o)), u.set("scale", this.serializeFromVector(a));
    }
  }
  resetEditorEnvironment() {
    this.resetEditorBackground(), this.resetEditorCamera(), this.setRenderingNeeded();
  }
  resetEditorBackground() {
    this._scene && (this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4(), this.refreshGround(), this.setRenderingNeeded());
  }
  resetEditorCamera() {
    if (this._scene) {
      const e = this._scene.activeCamera;
      e instanceof BABYLON.ArcRotateCamera && (e.useAutoRotationBehavior = !1), this._autoRender = !1, this.setRenderingNeeded();
    }
  }
  preSceneContentScreenshot() {
    this.resetEditorEnvironment(), this.removeGround();
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    super.preSceneMaterialScreenshot(), this.adjustSceneForSerialization();
  }
  postSceneMaterialScreenshot() {
    super.postSceneMaterialScreenshot();
  }
  sceneReadyForSave() {
    if (this._scene) {
      for (let e = 0; e < this._scene.meshes.length; e++)
        if (!this._scene.meshes[e].isReady())
          return !1;
    }
    return !0;
  }
  isCurrentCameraPivot(e) {
    if (this._sceneHelper) {
      const t = this._sceneHelper.getCameraPivot();
      return t && t.id === e;
    }
    return !1;
  }
  getCurrentCameraPivotID() {
    if (this._scene && this._sceneHelper) {
      const e = this._sceneHelper.getCameraPivot();
      if (e) {
        const t = this._scene.getMeshByID(e.id);
        if (t)
          return t.id;
      }
    }
    return null;
  }
  // Riscritta quella di SceneViewer perché viene salvata l'informazione
  // sul nuovo pivot, non solo modifcato il punto di vista
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      for (let r = 0; r < this._scene.meshes.length; r++) {
        var t = this._scene.meshes[r];
        t.metadata && t.metadata.isCameraPivot != null && delete t.metadata.isCameraPivot;
      }
      if (e) {
        const r = this._scene.getMeshByID(e);
        r && (r.metadata = r.metadata || {}, r.metadata.isCameraPivot = !0), this._sceneHelper.setCameraPivot(r || null);
      } else
        this._sceneHelper.setCameraPivot(null);
    }
  }
  // --------------------------------------------------------
  // Funzioni per il salvataggio della scena
  // --------------------------------------------------------
  async getBlobFromEmbeddedTextureAsync(e) {
    let t = null;
    if (e.url) {
      const u = e.url;
      var r = u.substring(0, 5) === "data:", o = u.substring(0, 5) === "blob:", a = r && u.indexOf(";base64,") !== -1;
      if (r && e._buffer && (e._buffer instanceof ArrayBuffer || e._buffer instanceof Uint8Array || e._buffer instanceof Blob))
        e._buffer instanceof Blob ? t = e._buffer : e._buffer instanceof Uint8Array ? t = new Blob([e._buffer], { type: e.mimeType }) : e._buffer instanceof ArrayBuffer && (t = new Blob([new Uint8Array(e._buffer)], { type: e.mimeType }));
      else if (o)
        await new Promise((f) => {
          var v = new XMLHttpRequest();
          v.open("GET", u, !0), v.responseType = "blob", v.onload = function(S) {
            this.status == 200 && f(this.response);
          }, v.send();
        });
      else if (a) {
        const f = new Uint8Array(BABYLON.Tools.DecodeBase64(u));
        t = new Blob([f], { type: e.mimeType });
      }
    }
    return t;
  }
  async uploadEmbeddedTexturesAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper) {
      this._scene, this._zkScene;
      const r = this._sceneHelper;
      this.getAllMaterials().forEach((a) => {
        a.getActiveTextures().filter((f) => f instanceof BABYLON.Texture).forEach((f) => {
          if (f.url) {
            var v = f.url.substring(0, 5) === "data:", S = f.url.substring(0, 5) === "blob:", I = v && f.url.indexOf(";base64,") !== -1;
            if (v || S || I) {
              const D = r.getMaterialTextureType(a, f);
              D && t.push({
                texture: f,
                material: a,
                type: D
              });
            }
          }
        });
      });
    }
    for (let r = 0; r < t.length; r++) {
      const o = t[r], a = o.texture, u = await this.getBlobFromEmbeddedTextureAsync(a);
      if (u) {
        let f = ".png";
        a.mimeType === "image/jpeg" && (f = ".jpg");
        const S = `${o.type.replace(" ", "_")}${f}`;
        let I = new File([u], S);
        const D = await this.uploadTextureFileAsync(I, o.material);
        if (D) {
          const Z = D.get("url");
          Z && await new Promise((M, X) => {
            a.updateURL(
              Z,
              void 0,
              () => M(),
              void 0,
              () => X()
            );
          });
        }
        e && e(r / t.length * 100, "textures");
      }
    }
  }
  useIncrementalLoading() {
    if (this._sceneHelper) {
      const e = this._sceneHelper.getTotalVertices(), t = this._sceneHelper.getTotalIndices();
      if (e + t >= 1e3)
        return !0;
    }
    return !1;
  }
  // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
  // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
  // 2. Recupera il JSON della scena da Babylon JS.
  // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
  // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
  updateSceneModel(e, t, r, o) {
    if (this._zkScene && this._scene) {
      this._scene;
      const a = this._zkScene;
      this.resetRealVisibility();
      const u = this.infoPointsShown;
      u && this.hideInfoPoints(), this.uploadEmbeddedTexturesAsync((f, v) => {
        r && r(f, v);
      }).then(() => {
        this.getSceneScreenshotAsync(500, 450).then((f) => {
          u && this.showInfoPoints(), a.set("imageData", f), a.set("version", a.get("version") + 1);
          var v = this.useIncrementalLoading();
          v ? this.uploadSceneIncrementalFiles(
            (S) => {
              this.onUploadScenFileSuccess(S), e && e();
            },
            (S) => {
              t && t(S);
            },
            (S) => {
              r && r(S);
            },
            o
          ) : this.uploadSceneFile(
            (S) => {
              this.onUploadScenFileSuccess(S), e && e();
            },
            (S) => {
              t && t(S);
            },
            (S, I) => {
              r && r(S, I);
            }
          );
        });
      }).catch((f) => {
        t && t(f);
      });
    }
  }
  // Aggiorna il modello con i dati sul file di scena salvato
  onUploadScenFileSuccess(e) {
    this._zkScene && e && (e.hasOwnProperty("fileObjectID") || e.hasOwnProperty("fileLength")) && e.hasOwnProperty("rootUrl") && e.hasOwnProperty("sceneFileName") && (e.hasOwnProperty("manifestFileObjectID") || e.hasOwnProperty("manifestFileLength")) && (e.hasOwnProperty("incrementalsFileObjectID") || e.hasOwnProperty("incrementalsFileLength")) ? (this._zkScene.set("fileObjectID", e.fileObjectID), this._zkScene.set("fileLength", e.fileLength), this._zkScene.set("url", e.url), this._zkScene.set("rootUrl", e.rootUrl), this._zkScene.set("sceneFileName", e.sceneFileName), this._zkScene.set("manifestFileObjectID", e.manifestFileObjectID), this._zkScene.set("manifestFileLength", e.manifestFileLength), this._zkScene.set("manifestFileUrl", e.manifestFileUrl), this._zkScene.set("incrementalsFileObjectID", e.incrementalsFileObjectID), this._zkScene.set("incrementalsFileLength", e.incrementalsFileLength), this._zkScene.set("incrementalsFileUrl", e.incrementalsFileUrl)) : Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
  }
  uploadSceneFile(e, t, r) {
    if (!this._scene || !this._zkScene) {
      t && t("No scene to upload");
      return;
    }
    this._scene;
    const o = this._zkScene, a = o.get("version"), u = this.getSceneJson();
    this.getSceneFileBlobsAsync(u, a, (f) => {
      r && r(f, "optimize");
    }).then((f) => {
      const v = new FormData();
      for (let S = 0; S < f.length; S++) {
        const I = f[S];
        v.append("file_" + S, I.blob, I.name);
      }
      fetch(o.getSceneIncrementalFileUploadUrl(), {
        method: "POST",
        body: v,
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        }
      }).then((S) => {
        if (!S.ok)
          throw new Error("HTTP error " + S.status);
        return S.json();
      }).then((S) => {
        e && e(S);
      }).catch((S) => {
        t && t(S.message);
      });
    });
  }
  async getSceneFileBlobsAsync(e, t, r) {
    let o = [];
    return this._sceneToBlobs || (this._sceneToBlobs = new Kx(this._incrementalWorkersScriptsUrls)), this._sceneToBlobs && (await this._sceneToBlobs.whenReadyAsync(), o = await this._sceneToBlobs.getSceneBlobsAsync(e, t, r)), o;
  }
  // Serializza in JSON la scena Babylon JS
  getSceneJson() {
    var t;
    let e = "";
    if (this._scene && this._sceneHelper) {
      const r = this._envMode;
      this.setEnvironmentMode(Ar.Editor), this.disableAntialiasing(!0);
      const o = this.resetCameraRotationLimits();
      this.deleteHighlightLayer();
      const a = this._manipulatedNode;
      this.setManipulatedNode(null), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading() && this._sceneHelper.offloadAllUnusedMaterials(), this._sceneHelper.setDummyMaterialToInvisibleMeshes(), this.adjustSceneForSerialization();
      const u = BABYLON.SceneSerializer.Serialize(this._scene);
      if (u.postProcesses = [], e = JSON.stringify(u), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
        const f = (t = this._zkScene) == null ? void 0 : t.get("rootUrl");
        f && this._sceneHelper.loadAllOffloadedMaterials(f);
      }
      this._sceneHelper.unsetAllDummyMaterials(), r != Ar.Editor && this.setEnvironmentMode(r), this.enableAntialiasing(), this.createHighlightLayer(), this.setManipulatedNode(a), this.setCameraRotationLimits(o);
    }
    return e;
  }
  resetCameraRotationLimits() {
    const e = {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: null,
      upperBetaLimit: null
    };
    return this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (e.lowerAlphaLimit = this._camera.lowerAlphaLimit, e.upperAlphaLimit = this._camera.upperAlphaLimit, e.lowerBetaLimit = this._camera.lowerBetaLimit, e.upperBetaLimit = this._camera.upperBetaLimit, this._camera.lowerAlphaLimit = null, this._camera.upperAlphaLimit = null, this._camera.lowerBetaLimit = 0.01, this._camera.upperBetaLimit = Math.PI - 0.01), e;
  }
  setCameraRotationLimits(e) {
    e = e || {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: 0.01,
      upperBetaLimit: Math.PI - 0.01
    }, this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerAlphaLimit = e.lowerAlphaLimit, this._camera.upperAlphaLimit = e.upperAlphaLimit, this._camera.lowerBetaLimit = e.lowerBetaLimit || 0.01, this._camera.upperBetaLimit = e.upperBetaLimit || Math.PI - 0.01);
  }
  // Metodo fondamentale per modificare gli url delle texture ed eliminare le
  // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
  // risolve il nome delle texture in base al path della scena. Quindi gli url delle
  // texture vanno, se necessario, trasformanti in path relativi.
  adjustSceneForSerialization() {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const e = this._sceneHelper;
      this.removeDisabledFresnelParameters();
      let t = !1;
      this._zkScene.getUseDelayedTextureLoading() != null && (t = this._zkScene.getUseDelayedTextureLoading()), this._scene.useDelayedTextureLoading = t;
      const r = this.getMatchSameNameTextures(), o = this._zkScene.getSourcesIDs();
      this._zkScene.getLibraryMaterialIDs();
      const a = {}, u = {}, f = [], v = [], S = [], I = e.getTextureUrl(this._scene.environmentTexture), D = I !== null && I.endsWith(li.Environment.EnvironmentTextureName);
      if (this._zkScene.set("useDefaultEnvironmentTexture", D), this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
        const te = this._scene.environmentTexture.rotationY;
        this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.environmentTextureRotationY = te;
      }
      this._scene.textures.forEach((te) => {
        if (!e.isTextureWithUrl(te))
          return;
        let J = te.url;
        if (te.getInternalTexture) {
          const he = te.getInternalTexture();
          he && he.url && (J = he.url);
        }
        if (J) {
          let he = J;
          if (he === li.Environment.EnvironmentTextureCDNUrl) {
            te.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + li.Environment.EnvironmentTextureName, te.name = te.url;
            return;
          }
          if (he == li.Environment.SkyboxTextureCDNUrl || he == li.Environment.GroundTextureCDNUrl)
            return;
          let ve = !1;
          he.startsWith("blob:") && te.metadata && te.metadata.fileUrl && (he = te.metadata.fileUrl);
          for (let j = 0; j < o.length; j++) {
            let We = o[j].replace(/-/g, ""), ke = he.indexOf(We);
            if (ke != -1) {
              ve = !0, te.name = he.substring(ke), te.url = te.name, Logger.info("texture url: " + te.url);
              break;
            }
          }
          let K = !1;
          if (te.materialMapping) {
            K = !0;
            let j = te.materialMapping.libraryMaterialID.replace(/-/g, ""), We = te.materialMapping.sceneMaterialID.replace(/-/g, ""), ke = he, $e = te.name, Lt = he.indexOf(j);
            if (Lt != -1) {
              let Be = he.replace(new RegExp(j, "g"), We);
              ke = Be, $e = Be;
              let Xe = {};
              if (a.hasOwnProperty(j) ? Xe = a[j] : a[j] = Xe, Lt = Be.lastIndexOf("/"), Lt !== -1) {
                let ue = Be.substring(Lt + 1);
                Xe.hasOwnProperty(ue) ? (ke = Xe[ue], $e = ke, aa(f, ke) || f.push(ke)) : (Lt = Be.lastIndexOf("/", Lt - 1), Lt !== -1 && (Lt = Be.lastIndexOf("/", Lt - 1), Lt != -1 && (ke = Be.substring(Lt + 1), $e = ke, aa(f, ke) || f.push(ke), r && (Xe[ue] = ke))));
              }
              te.name = $e, te.url = ke;
            }
          }
          if (!ve && !K) {
            const j = this.extractTextureNameAndUrl(he, r, u);
            if (j.url && j.name && (te.url = j.url, te.name = j.name, aa(f, te.url) || f.push(te.url)), te.metadata && te.metadata.mobileUrl) {
              const We = this.extractTextureNameAndUrl(
                te.metadata.mobileUrl,
                r,
                u
              );
              We.url && We.name && (te.metadata.mobileUrl = We.url, aa(f, te.metadata.mobileUrl) || f.push(te.metadata.mobileUrl), aa(S, te.metadata.mobileUrl) || S.push(te.metadata.mobileUrl), aa(v, te.url) || v.push(te.url));
            }
          }
        }
      });
      const Z = ["px", "py", "pz", "nx", "ny", "nz"], M = (te) => {
        let J = te.lastIndexOf("."), he = te;
        if (J !== -1) {
          let ve = te.substring(0, J);
          for (let K = 0; K < Z.length; K++) {
            const j = Z[K];
            if (J = ve.lastIndexOf("_" + j), J != -1) {
              he = ve.substring(0, J);
              break;
            }
          }
        }
        return he;
      }, X = (te) => {
        const J = M(te);
        for (let he = 0; he < f.length; he++) {
          const ve = f[he];
          if (J.endsWith(ve))
            return !0;
        }
        return !1;
      }, Y = (te) => {
        const J = M(te);
        for (let he = 0; he < v.length; he++) {
          const ve = v[he];
          if (J.endsWith(ve))
            return !0;
        }
        return !1;
      }, ie = (te) => {
        const J = M(te);
        for (let he = 0; he < S.length; he++) {
          const ve = S[he];
          if (J.endsWith(ve))
            return !0;
        }
        return !1;
      }, G = [];
      for (let te = 0; te < this._zkScene.get("textures").length; te++) {
        const J = this._zkScene.get("textures").at(te), he = J.get("url");
        he && X(he) ? Y(he) ? J.set("usage", Zakeke.TextureUsage.Desktop) : ie(he) ? J.set("usage", Zakeke.TextureUsage.Mobile) : J.set("usage", Zakeke.TextureUsage.Any) : G.push(J);
      }
      G.length > 0 && this._zkScene.get("textures").remove(G), this._zkScene.set("usedTextureUrls", f);
    }
  }
  // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
  // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
  // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
  extractTextureNameAndUrl(e, t, r) {
    const o = { name: "", url: "" };
    let a = e.lastIndexOf("/");
    if (a !== -1) {
      const u = e.substring(a + 1);
      if (r.hasOwnProperty(u))
        o.url = r[u], o.name = o.url;
      else if (a = e.lastIndexOf("/", a - 1), a !== -1 && (a = e.lastIndexOf("/", a - 1), a !== -1)) {
        const f = e.substring(a + 1);
        o.url = f, o.name = f, t && (r[u] = f);
      }
    }
    return o;
  }
  removeDisabledFresnelParameters() {
    const e = function(t) {
      return t && t.isEnabled != null && !t.isEnabled && t.leftColor != null && t.leftColor != null && t.leftColor instanceof BABYLON.Color3 && t.leftColor.equals(BABYLON.Color3.White()) && t.rightColor != null && t.rightColor != null && t.rightColor instanceof BABYLON.Color3 && t.rightColor.equals(BABYLON.Color3.Black()) && t.bias != null && t.bias == 0 && t.power != null && t.power == 1;
    };
    this._scene && this._scene.materials.forEach(function(t) {
      t instanceof BABYLON.StandardMaterial ? (t.diffuseFresnelParameters && e(t.diffuseFresnelParameters) && (t.diffuseFresnelParameters = new BABYLON.FresnelParameters(), t.diffuseFresnelParameters.isEnabled = !1), t.emissiveFresnelParameters && e(t.emissiveFresnelParameters) && (t.emissiveFresnelParameters = new BABYLON.FresnelParameters(), t.emissiveFresnelParameters.isEnabled = !1), t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = new BABYLON.FresnelParameters(), t.opacityFresnelParameters.isEnabled = !1), t.reflectionFresnelParameters && e(t.reflectionFresnelParameters) && (t.reflectionFresnelParameters = new BABYLON.FresnelParameters(), t.reflectionFresnelParameters.isEnabled = !1), t.refractionFresnelParameters && e(t.refractionFresnelParameters) && (t.refractionFresnelParameters = new BABYLON.FresnelParameters(), t.refractionFresnelParameters.isEnabled = !1)) : t instanceof BABYLON.PBRMaterial || t instanceof Zakeke.PBRMaterial && t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = void 0);
    });
  }
  // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente
  // codificarli con Draco). In futuro si potrebbe convertire in async.
  uploadSceneIncrementalFiles(e, t, r, o) {
    if (!this._scene || !this._zkScene || !this._sceneHelper) {
      t && t("No scene to upload");
      return;
    }
    const a = this._zkScene, u = this._sceneHelper;
    let f = a.get("version"), v = this.envMode;
    this.setEnvironmentMode(Ar.Editor), this.disableAntialiasing(!0);
    let S = this.resetCameraRotationLimits();
    this.deleteHighlightLayer(), this.adjustSceneForSerialization(), u.setDummyMaterialToInvisibleMeshes();
    let I = this.getUseDelayedMaterialLoading(), D = this.getUseMaterialOffloading(), Z = {}, M = {};
    I ? this.getAllMaterials().forEach((G) => {
      const te = this.getMeshesUsingMaterial(G.id);
      G.id !== "default material" && te.length === 0 && (Z[G.id] = {
        name: G.name,
        file: "material_" + f + "_" + G.id.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".json"
      });
    }) : D && this.getAllMaterials().forEach((G) => {
      const te = this.getMeshesUsingMaterial(G.id);
      G.id !== "default material" && te.length === 0 && (M[G.id] = u.getOffloadedMaterialInfo(G));
    }), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials = M, this._scene.metadata.delayedMaterials = Z;
    let X = BABYLON.SceneSerializer.Serialize(this._scene);
    if (X.postProcesses = [], X.metadata && X.metadata.originalMeshMaterials) {
      const ie = JSON.parse(JSON.stringify(X.metadata.originalMeshMaterials));
      u.unsetAllDummyMaterials(), X.metadata.originalMeshMaterials = ie;
    }
    const Y = {
      useDraco: this._dracoEnabled,
      forceDraco: a.getForceDracoCompression() ?? !1,
      dracoEncodingSpeed: this._dracoEncodingSpeed,
      dracoDecodingSpeed: this._dracoDecodingSpeed,
      excludedMeshes: [],
      delayMatarialLoading: Object.keys(Z),
      offloadedMaterialIDs: Object.keys(M)
    };
    console.log(Y), this.getSceneIncrementalFilesAsync(f, X, Y, r).then(
      (ie) => {
        let G = new FormData();
        for (let J = 0; J < ie.length; J++) {
          const he = ie[J];
          let ve = he.name, K = he.data, j = !1;
          !he.dracoEncoded && he.data.length > 180 && he.data.length < 45e4 && (Logger.info("Uncompressed file length: " + he.data.length), K = LZString.compressToUint8Array(he.data), Logger.info("Compressed file length: " + K.length), ve = "compressed_" + he.name, j = !0);
          let We;
          if (!he.dracoEncoded && !j)
            We = new Blob([K], { type: "text/plain" });
          else {
            var te = K.buffer;
            We = new Blob([te]);
          }
          G.append("file_" + J, We, ve);
        }
        fetch(a.getSceneIncrementalFileUploadUrl(), {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this._authorizationToken
          },
          body: G
        }).then((J) => {
          if (!J.ok)
            throw new Error("HTTP error " + J.status);
          return J.json();
        }).then((J) => {
          e && e(J);
        }).catch(function(J) {
          t && t(J.message);
        }), v != Ar.Editor && this.setEnvironmentMode(v), this.enableAntialiasing(), this.createHighlightLayer(), this.setCameraRotationLimits(S);
      }
    );
  }
  // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
  async getSceneIncrementalFilesAsync(e, t, r, o) {
    let a = [];
    return this._incrementalFilesMaker || (this._incrementalFilesMaker = new Ex(this._incrementalWorkersScriptsUrls)), this._incrementalFilesMaker && (await this._incrementalFilesMaker.whenReadyAsync(), a = await this._incrementalFilesMaker.getIncrementalFilesAsync(t, e, r)), a;
  }
  // Fine funzioni salvataggio scena
  // --------------------------------------------------------
  async setNewSceneModelAsync(e, t) {
    this._zkModel = e, this._zkScene = t, await this.init3DEngineAsync(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  getSceneConfig() {
    var e;
    return ((e = this._zkScene) == null ? void 0 : e.getSceneConfig()) ?? null;
  }
  preSceneFileLoading() {
    this.resetRealVisibility();
  }
  postSceneFileLoading() {
    this.fireSceneCreatedEvent(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  // ==============================================================================
  // Importazione Assets
  // ==============================================================================
  // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
  // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
  // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
  // per il recupero tramite polling delle informazioni.
  // I task lato client avranno uno degli stati:
  //   uploading         - Task avviato per l'uploading dei file
  //   progress          - Task in elaborazione
  //   checking          - Chimata Ajax di controllo stato in corso
  //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
  //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
  //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
  loadSceneSourceFiles(e, t, r, o) {
    if (this._zkScene) {
      const S = this._zkScene, I = new FormData();
      if (t)
        I.append("url", t);
      else if (e) {
        for (let G = 0; G < e.length; G++)
          I.append("file-" + G, e[G]);
        var a = this._zkScene.getTexturesConfig();
        if (a) {
          var u = new Zakeke.SceneSourceTaskOptions();
          u.set("textures", a);
          var f = JSON.stringify(u), v = new Blob([f], {
            type: "application/json"
          });
          I.append("task-options", v, "task-options.json");
        }
      }
      const D = {
        downloadProgress: 0,
        uploadProgress: 0,
        status: 0,
        message: "",
        sceneSourceInfo: {},
        taskID: void 0,
        sourceID: void 0,
        meshes: []
      };
      this._sceneSourceTasks.push(D);
      const Z = S.getSourceTasksUrl(), M = new Request(Z, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        },
        body: I
      }), X = (G) => {
        const te = G.loaded / G.total;
        D.uploadProgress = te * 100, this.fireSceneSourceTaskCheckEvent();
      }, Y = (G) => {
        const te = G.loaded / G.total;
        D.downloadProgress = te * 100, this.fireSceneSourceTaskCheckEvent();
      }, ie = new XMLHttpRequest();
      ie.upload.addEventListener("progress", X), ie.addEventListener("progress", Y), M.signal.addEventListener("fetch", () => ie.send()), fetch(M).then((G) => G.json()).then((G) => {
        G && G.hasOwnProperty("taskID") && G.hasOwnProperty("sourceID") ? (D.taskID = G.taskID, D.sourceID = G.sourceID, D.status = 1, this.fireSceneSourceTaskCheckEvent()) : Logger.info("task creation process did not go well"), r && r(D);
      }).catch((G) => {
        this._sceneSourceTasks = this._sceneSourceTasks.filter((te) => {
        }), this.fireSceneSourceTaskCheckEvent(), o && o(G);
      }), this.fireSceneSourceTaskCheckEvent();
    }
  }
  // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
  // eventualmente presenti in coda
  checkSceneSourceTasks() {
    if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
      const t = this._zkScene;
      for (let r = 0; r < this._sceneSourceTasks.length; r++) {
        let o = this._sceneSourceTasks[r];
        if (o.status == 5 || o.status == 4) {
          this._sceneSourceTasks.splice(r--, 1), this.fireSceneSourceTaskCheckEvent();
          continue;
        }
        if (!(o.status == 2 || o.status == 0)) {
          if (o.status == 1) {
            o.status = 2;
            const a = (u) => {
              u.status = 5, this.fireSceneSourceTaskErrorEvent(u.taskID), this.fireSceneSourceTaskCheckEvent();
            };
            var e = async (u) => {
              try {
                const f = await fetch(t.getSourceTaskResultUrl(u.taskID), {
                  method: "GET",
                  cache: "no-cache",
                  headers: {
                    Authorization: "Bearer " + this._authorizationToken
                  }
                });
                if (f.ok) {
                  const v = await f.json();
                  if (v && v.hasOwnProperty("taskID") && v.hasOwnProperty("state") && v.hasOwnProperty("message") && v.hasOwnProperty("sourceFile"))
                    if (v.state == 2) {
                      u.sceneSourceInfo = {
                        sourceID: v.sourceFile.sourceID,
                        fileObjectID: v.sourceFile.fileObjectID,
                        fileLength: v.sourceFile.fileLength,
                        url: v.sourceFile.url,
                        rootUrl: v.sourceFile.rootUrl,
                        sceneFileName: v.sourceFile.sceneFileName,
                        textureFiles: []
                      };
                      for (let S = 0; S < v.sourceFile.textureFiles.length; S++)
                        u.sceneSourceInfo.textureFiles.push({
                          textureID: v.sourceFile.textureFiles[S].textureID,
                          fileObjectID: v.sourceFile.textureFiles[S].fileObjectID,
                          fileLength: v.sourceFile.textureFiles[S].fileLength,
                          url: v.sourceFile.textureFiles[S].url
                        });
                      u.status = 3;
                    } else
                      v.state == 3 ? a(u) : u.status = 1;
                  else
                    a(u);
                } else
                  a(u);
              } catch {
                a(u);
              }
            };
            e(o);
          }
          o.status == 3 && (this._isLoadingSourceFiles || (this._isLoadingSourceFiles = !0, o.sceneSourceInfo.rootUrl && o.sceneSourceInfo.sceneFileName ? (this.updateSceneModelFromSourceTask(o), this.loadMeshesFromRemoteFiles(
            o.sceneSourceInfo.rootUrl,
            o.sceneSourceInfo.sceneFileName,
            (a) => {
              a && Object.prototype.toString.call(a) === "[object Array]" && a.forEach((u) => {
                u.isPickable = !0;
              }), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskSuccessEvent(a), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), o.meshes = a, o.status = 4;
            },
            (a) => {
              Logger.info("Errore nel caricamento delle mesh: " + a), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(o.taskID), o.status = 5;
            }
          )) : (Logger.info("Risultato del task di caricamento non valido"), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(o.taskID), o.status = 5), this.fireSceneSourceTaskCheckEvent()));
        }
      }
    }
    setTimeout(() => this.checkSceneSourceTasks(), 500);
  }
  updateSceneModelFromSourceTask(e) {
    if (this._zkScene) {
      const t = new Zakeke.SceneSource();
      t.set("sourceID", e.sceneSourceInfo.sourceID), t.set("fileObjectID", e.sceneSourceInfo.fileObjectID), t.set("fileLength", e.sceneSourceInfo.fileLength), t.set("url", e.sceneSourceInfo.url), t.set("rootUrl", e.sceneSourceInfo.rootUrl), t.set("sceneFileName", e.sceneSourceInfo.sceneFileName);
      for (let r = 0; r < e.sceneSourceInfo.textureFiles.length; r++) {
        const o = e.sceneSourceInfo.textureFiles[r];
        if (o.textureID && (o.fileObjectID || o.fileLength) && o.url) {
          const a = new Zakeke.SceneSourceTexture();
          a.set("textureID", o.textureID), a.set("fileObjectID", o.fileObjectID), a.set("fileLength", o.fileLength), a.set("url", o.url), t.get("textures").push(a);
        }
      }
      this._zkScene.get("sources").push(t);
    }
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles(e, t, r, o) {
    if (!this._scene || !this._sceneHelper) {
      o && o("No scene to fill with imported meshes");
      return;
    }
    this._scene;
    const a = this._sceneHelper;
    let u = e + t;
    a.importMeshesFromUrlAsync(u, null, void 0).then(async (f) => (Logger.info("Uploading embedded textures..."), await this.uploadEmbeddedTexturesAsync(), f)).then((f) => (Logger.info("File imported successfully."), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), f)).then((f) => {
      Logger.info("Operation completed successfully."), r == null || r(f);
    }).catch((f) => {
      Logger.info("Error loading file"), o && o(f);
    }), Logger.info("loading finished");
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles_OLD(e, t, r, o) {
    if (!this._scene || !this._sceneHelper) {
      o && o("No scene to fill with imported meshes");
      return;
    }
    const a = this._scene, u = this._sceneHelper;
    let f = t, v = t.lastIndexOf(".");
    v !== -1 && (f = t.substr(0, v));
    const S = this._scene.materials.map((M) => M.id);
    let I;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((M) => {
      I = M.name;
    });
    const D = new BABYLON.AssetsManager(this._scene), Z = D.addMeshTask("mesh-task", "", e, t);
    Z.onSuccess = (M) => {
      Logger.info("task completed successfully");
      const X = M.loadedMeshes, Y = new BABYLON.Mesh(f, a);
      Y.id = Zakeke.generateUUID(), Y.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, X.forEach((ie) => {
        ie.parent || (ie.parent = Y), ie.material || (ie.material = new BABYLON.StandardMaterial(ie.name + "Mat", a)), ie.id = Zakeke.generateUUID();
      }), a.materials.forEach((ie) => {
        aa(S, ie.id) || (ie.id = Zakeke.generateUUID());
      }), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), u.adjustCamera(I, !1, !1), u.setupShaderMaterialsCameraPosition(), r && r(X);
    }, Z.onError = (M, X, Y) => {
      Logger.info("task completed with errors"), o && o(X);
    }, D.onFinish = function() {
      Logger.info("loading finished");
    }, D.load();
  }
  // Fine importazione Assets
  // ==============================================================================
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  onMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onSubMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onMaterialChanged(e) {
    this.setRenderingNeeded();
  }
  onLightChanged(e) {
    this.setRenderingNeeded();
  }
  getSceneMeshesByName(e) {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(e) : [];
  }
  getSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
  }
  getMeshesUsingMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(e) : [];
  }
  getMeshesMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(e) : [];
  }
  getMeshMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshMaterials(e) : [];
  }
  getAllMaterials() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
  }
  // restituisce un array di gruppi di materiali
  // ogni gruppo è del tipo MaterialGroup, con proprietà
  // "group"(nome del gruppo)
  // "materials"(elenco materiali)
  getGroupedMaterials() {
    const e = [], t = {}, r = this.getAllMaterials();
    for (let o = 0; o < r.length; o++) {
      let a = r[o];
      if (a.id == "groundMaterial")
        continue;
      const u = this.getMaterialGroup(a.id);
      let f = null;
      t.hasOwnProperty(u) ? f = t[u] : (f = new Nw(u), e.push(f), t[u] = f), f && f.materials.push(a);
    }
    return e.sort(function(o, a) {
      var u = o.groupName.toLowerCase(), f = a.groupName.toLowerCase();
      return u < f ? -1 : u > f ? 1 : 0;
    });
  }
  // Assegna il gruppo ad un array di materiali
  setMaterialsGroup(e, t, r = !0) {
    for (let o = 0; o < e.length; o++) {
      const a = e[o];
      this.setMaterialGroup(a, t, r);
    }
  }
  // Assegna il gruppo ad un singolo materiale
  setMaterialGroup(e, t, r = !0) {
    !this._scene || !this._scene.getMaterialByID(e) || (this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.groups || (this._scene.metadata.groups = {}), this._scene.metadata.groups[e] = t, r && this.fireMaterialsUpdateEvent());
  }
  // Restituisce il gruppo di un materiale
  getMaterialGroup(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) ? this._scene.metadata.groups[e] : ll.EmptyGroupName;
  }
  // Elimina il gruppo di un materiale
  removeMaterialGroup(e) {
    this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) && (delete this._scene.metadata.groups[e], this.fireMaterialsUpdateEvent());
  }
  getMaterialsByGroup(e) {
    const t = [], r = e || ll.EmptyGroupName;
    return this._scene && this._sceneHelper && this._sceneHelper.getAllMaterials().forEach((o) => {
      this.getMaterialGroup(o.id) === r && t.push(o);
    }), t;
  }
  getGroupCenter(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(e) : null;
  }
  getGroupBoundingInfo(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return new BABYLON.BoundingInfo(t.min, t.max);
  }
  showHideBoundingBox(e) {
    this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded();
  }
  updateBoundingBox() {
    this.deleteBoundingBox(), this.showBoundingBox && this.createSceneBoundingBox(!0);
  }
  deleteBoundingBox() {
    let e = this.getSceneBoundingBox();
    e && e.dispose();
  }
  setCameraPositionScale(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionScale(e), this._sceneHelper.setCameraPositionScale(e, !0), this.setRenderingNeeded());
  }
  setCameraLimitLowerRadius(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLimitLowerRadius(e), this._sceneHelper.setCameraLimitLowerRadius(e, !0), this.setRenderingNeeded());
  }
  setCameraZoomEnabled(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraZoomEnabled(e), this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  setCameraUseMinZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMinZoomPerc(e), this._sceneHelper.setMinZoomPerc(e ? this._zkScene.getCameraMinZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMinZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMinZoomPerc(e);
      var t = this._zkScene.getCameraUseMinZoomPerc();
      this._sceneHelper.setMinZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  setCameraUseMaxZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMaxZoomPerc(e), this._sceneHelper.setMaxZoomPerc(e ? this._zkScene.getCameraMaxZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMaxZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMaxZoomPerc(e);
      const t = this._zkScene.getCameraUseMaxZoomPerc();
      this._sceneHelper.setMaxZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  lockCameraAlphaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha ?? 0;
      this._zkScene.setCameraLowerAlphaLimit(e), this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraAlphaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraAlphaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraAlphaLimits(null, null), this.setRenderingNeeded());
  }
  lockCameraBetaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.beta ?? -1.57;
      this._zkScene.setCameraLowerBetaLimit(e), this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraBetaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraBetaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraBetaLimits(null, null), this.setRenderingNeeded());
  }
  setCameraLowerAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha;
      this._zkScene.setCameraLowerAlphaLimit(e), this._sceneHelper.setCameraLowerAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._sceneHelper.setCameraLowerAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.alpha;
      this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraUpperAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraUpperAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraLowerBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraLowerBetaLimit(e), this._sceneHelper.setCameraLowerBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerBetaLimit() {
    this._zkScene && this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._sceneHelper.setCameraLowerBetaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraUpperBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperBetaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraUpperBetaLimit(null), this.setRenderingNeeded());
  }
  // Mesh selection overrides (the selection logic si a little bit different
  // respect the parent SceneViewer one)
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && this._scene.meshes.forEach((e) => this.unselectSingleMesh(e));
  }
  selectUnselectMesh(e, t) {
    if (this._scene) {
      if (this.deleteBoundingBox(), this.unselectAllMeshes(), t) {
        const r = (a) => {
          this.selectSingleMesh(a), a.getChildMeshes().forEach((u) => r(u));
        };
        let o = this._scene.getMeshByID(e);
        this._isSelectionMode || (o = this.getDAMMainMesh() ?? o), o && r(o), this.setManipulatedNode(o);
      } else
        this.setManipulatedNode(null);
      this.fireSelectionChangedEvent();
    }
  }
  selectSingleMesh(e) {
    e.selected = !0, this.highlightMesh(e, !0), this.setRenderingNeeded();
  }
  unselectSingleMesh(e) {
    e.selected = !1, this.highlightMesh(e, !1), this.setRenderingNeeded();
  }
  isMeshSelected(e) {
    return e && e.selected != null && e.selected;
  }
  // Show-hide mesh methods
  showMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !0, !0);
  }
  hideMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !1, !0);
  }
  showHideMesh(e, t, r = !0) {
    var o;
    if (this._scene && this._sceneHelper && this._camera) {
      this._scene;
      const a = this._sceneHelper, u = this._camera, f = (I, D) => {
        I.isVisible = D, Logger.info(I.name), I.getChildMeshes().forEach((Z) => f(Z, D));
      }, v = (I, D) => {
        f(I, D), !(a && u && I.metadata && I.metadata.isGroup && I.getChildMeshes().length === 0) && D && !u.isCompletelyInFrustum(I) && (a.adjustCamera(void 0, !1, !1), a.setupShaderMaterialsCameraPosition()), r && this.fireMeshesUpdateEvent(), this.setRenderingNeeded();
      }, S = this._scene.getMeshByID(e);
      if (S) {
        const I = (o = this._zkScene) == null ? void 0 : o.get("rootUrl");
        I ? a.unsetMeshDummyMaterialAsync(S, I, !0).then(() => v(S, t)) : v(S, t);
      }
      this.refreshInfoPoints();
    }
  }
  // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
  // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
  // ripristinato con la funzione resetRealVisibility
  setTemporaryExclusivelyVisible(e) {
    this._scene && (this.resetRealVisibility(), this._realMeshVisibility = {}, this._scene.meshes.forEach((t) => {
      this._realMeshVisibility[t.id] = t.isVisible, this.isRealMesh(t) && (t.isVisible = !1);
    }), this.showHideMesh(e, !0, !1));
  }
  // Reimposto lo stato di visibilità come era precedentemente alla chiamata
  // a setTempraryExclusiveVisible
  resetRealVisibility() {
    this._scene && this._sceneHelper && this._realMeshVisibility && (this._sceneHelper.getSceneMeshes().forEach((t) => {
      this._realMeshVisibility.hasOwnProperty(t.id) && (t.isVisible = this._realMeshVisibility[t.id]);
    }), this.setRenderingNeeded());
  }
  // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
  changeMaterialColor(e, t, r) {
    this._sceneHelper && this._sceneHelper.changeMaterialColor(e, t, r);
  }
  renameMesh(e, t) {
    if (this._scene) {
      const r = this._scene.getMeshByID(e);
      r && (r.name = t, this.fireMeshesUpdateEvent());
    }
  }
  //#region Events
  // PreUpdateEvent
  firePreUpdateEvent() {
    this._preUpdateListeners.forEach((e) => e());
  }
  addPreUpdateListener(e) {
    this._preUpdateListeners.push(e);
  }
  removePreUpdateListener(e) {
    for (let t = 0; t < this._preUpdateListeners.length; t++)
      if (this._preUpdateListeners[t] == e) {
        this._preUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // PostUpdateEvent
  firePostUpdateEvent() {
    this._postUpdateListeners.forEach((e) => e());
  }
  addPostUpdateListener(e) {
    this._postUpdateListeners.push(e);
  }
  removePostUpdateListener(e) {
    for (let t = 0; t < this._postUpdateListeners.length; t++)
      if (this._postUpdateListeners[t] == e) {
        this._postUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // MeshSelected
  fireMeshSelectedEvent(e) {
    this._meshSelectedListeners.forEach((t) => t(e));
  }
  addMeshSelectedListener(e) {
    this._meshSelectedListeners.push(e);
  }
  removeMeshSelectedListener(e) {
    const t = this._meshSelectedListeners.indexOf(e);
    t != -1 && this._meshSelectedListeners.splice(t, 1);
  }
  // SelectionChanged
  fireSelectionChangedEvent() {
    this._selectionChangedListeners.forEach((e) => e());
  }
  addSelectionChangedListener(e) {
    this._selectionChangedListeners.push(e);
  }
  removeSelectionChangedListener(e) {
    const t = this._selectionChangedListeners.indexOf(e);
    t != -1 && this._selectionChangedListeners.splice(t, 1);
  }
  // LightsSelected
  fireLightSelectedEvent(e) {
    this._lightSelectedListeners.forEach((t) => t(e));
  }
  addLightSelectedListener(e) {
    this._lightSelectedListeners.push(e);
  }
  // SceneCreated
  fireSceneCreatedEvent() {
    this._sceneCreatedListeners.forEach((e) => e());
  }
  addSceneCreatedListener(e) {
    this._sceneCreatedListeners.push(e);
  }
  // CameraLocationCreated
  fireCameraLocationCreatedEvent(e) {
    this._cameraLocationCreatedListeners.forEach((t) => t(e));
  }
  addCameraLocationCreatedListener(e) {
    this._cameraLocationCreatedListeners.push(e);
  }
  // CameraLocationsUpdate
  fireCameraLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllCameraLocations()), !e)
      throw "Failed firing positions update event: lights are null and no scene present";
    this._cameraLocationsUpdateListeners.forEach((t) => t(e));
  }
  addCameraLocationsUpdateListener(e) {
    this._cameraLocationsUpdateListeners.push(e);
  }
  // SceneSourceTaskSuccess
  fireSceneSourceTaskSuccessEvent(e) {
    this._sceneSourceTaskSuccessListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskSuccessListener(e) {
    this._sceneSourceTaskSuccessListeners.push(e);
  }
  // SceneSourceTaskError
  fireSceneSourceTaskErrorEvent(e) {
    this._sceneSourceTaskErrorListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskErrorListener(e) {
    this._sceneSourceTaskErrorListeners.push(e);
  }
  removeSceneSourceTaskErrorListener(e) {
    const t = this._sceneSourceTaskErrorListeners.indexOf(e);
    t != -1 && this._sceneSourceTaskErrorListeners.splice(t, 1);
  }
  // SceneSourceTaskCheck
  fireSceneSourceTaskCheckEvent() {
    this._sceneSourceTasksCheckListeners.forEach((e) => e());
  }
  addSceneSourceTaskCheckListener(e) {
    this._sceneSourceTasksCheckListeners.push(e);
  }
  removeSceneSourceTaskCheckListener(e) {
    const t = this._sceneSourceTasksCheckListeners.indexOf(e);
    t != -1 && this._sceneSourceTasksCheckListeners.splice(t, 1);
  }
  // MeshesUpdate
  fireMeshesUpdateEvent(e) {
    if (!e && this._scene && (e = this.getSceneMeshes()), !e)
      throw "Failed firing mesh update event: meshes are null and no scene present";
    this._meshesUpdateListeners.forEach((t) => t(e));
  }
  addMeshesUpdateListener(e) {
    this._meshesUpdateListeners.push(e);
  }
  removeMeshesUpdateListener(e) {
    const t = this._meshesUpdateListeners.indexOf(e);
    t != -1 && this._meshesUpdateListeners.splice(t, 1);
  }
  // MaterialsUpdate
  fireMaterialsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getGroupedMaterials()), !e)
      throw "Failed firing materials update event: materials are null and no scene present";
    this._materialsUpdateListeners.forEach((t) => t(e));
  }
  addMaterialsUpdateListener(e) {
    this._materialsUpdateListeners.push(e);
  }
  // LighsUpdate
  fireLightsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllLights()), !e)
      throw "Failed firing lights update event: lights are null and no scene present";
    this._lightsUpdateListeners.forEach((t) => t(e));
  }
  addLightsUpdateListener(e) {
    this._lightsUpdateListeners.push(e);
  }
  // MeshLocationCreated
  fireMeshLocationCreatedEvent(e) {
    this._meshLocationCreatedListeners.forEach((t) => t(e));
  }
  addMeshLocationCreatedListener(e) {
    this._meshLocationCreatedListeners.push(e);
  }
  // MeshLocationsUpdate
  fireMeshLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllMeshLocations()), e)
      this._meshLocationsUpdateListeners.forEach((t) => t(e));
    else
      throw "Failed firing mesh positions update event: positions are null and no scene present";
  }
  addMeshLocatonsUpdateListener(e) {
    this._meshLocationsUpdateListeners.push(e);
  }
  // ArTaskSuccess
  fireArTaskSuccessEvent() {
    this._arTaskSuccessListeners.forEach((e) => e());
  }
  addArTaskSuccessListener(e) {
    this._arTaskSuccessListeners.push(e);
  }
  // ArTaskError
  fireArTaskErrorEvent() {
    this._arTaskErrorListeners.forEach((e) => e());
  }
  addArTaskErrorListener(e) {
    this._arTaskErrorListeners.push(e);
  }
  // ArTaskCheck
  fireArTaskCheckEvent() {
    this._arTasksCheckListeners.forEach((e) => e());
  }
  addArTaskCheckListener(e) {
    this._arTasksCheckListeners.push(e);
  }
  fireFineTuningSettingEvent(e) {
    this._tryOnFineTuningSettingListeners.forEach((t) => t(e));
  }
  addFineTuningSettingListener(e) {
    return this._tryOnFineTuningSettingListeners.push(e), this._tryOnFineTuningSettingListeners.length - 1;
  }
  removeFineTuningSettingListener(e) {
    this._tryOnFineTuningSettingListeners.splice(e, 1);
  }
  removeAllFineTuningSettingListeners() {
    this._tryOnFineTuningSettingListeners = [];
  }
  fireFineTuningCloseEvent() {
    this._tryOnFineTuningCloseListeners.forEach((e) => e());
  }
  addFineTuningCloseListener(e) {
    this._tryOnFineTuningCloseListeners.push(e);
  }
  // Clear
  clearListeners() {
    this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [];
  }
  //#endregion
  //#region Interazione utente (Pointer Down/Move)
  onPointerDown(e, t) {
    if (!(!this._scene || !this._sceneHelper || this._envMode != Ar.Editor) && this._selectOnPick && t && t.hit && t.pickedMesh && t.pickedMesh !== this._ground) {
      this.selectMesh(t.pickedMesh.id);
      const r = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
      if (r) {
        const o = {
          name: t.pickedMesh.name,
          id: t.pickedMesh.id,
          scenePointerX: this._scene.pointerX,
          scenePointerY: this._scene.pointerY,
          screenPointerX: r.X,
          screenPointerY: r.Y
        };
        this.fireMeshSelectedEvent(o);
      }
    }
  }
  onPointerMove(e, t) {
    if (!this._scene || !this._sceneHelper || this._envMode != Ar.Editor)
      return;
    if (this.highlightMeshOver(!1), !this._highlightOver) {
      this._meshOver = null;
      return;
    }
    const r = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
    r && r.hit && r.pickedMesh && this._sceneHelper.isRealMesh(r.pickedMesh) && (this._meshOver = r.pickedMesh, this.highlightMeshOver(!0));
  }
  //#endregion
  //#region Element Selection
  getSubMesh(e, t) {
    return this._sceneHelper ? this._sceneHelper.getSubMesh(e, t) : null;
  }
  getLightByID(e) {
    return this._scene ? this._scene.getLightByID(e) : null;
  }
  //#endregion
  //#region Apply material
  applyMaterialByName(e, t) {
    this._sceneHelper && this._sceneHelper.applyMaterialByName(e, t);
  }
  applyMaterial(e, t) {
    this._sceneHelper && (this._sceneHelper.applyMaterial(e, t), this.setLongRenderingNeeded());
  }
  applyMaterialToSubMeshByName(e, t, r) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMeshByName(e, t, r);
  }
  applyMaterialToSubMesh(e, t, r) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMesh(e, t, r);
  }
  resetMeshMaterial(e, t) {
    t ? this._initialMeshMaterials : this._lastMeshMaterials;
  }
  resetSubMeshMaterial(e, t, r) {
    const o = r ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
    if (e && t && e.material instanceof BABYLON.MultiMaterial) {
      const a = t.materialIndex;
      if (a >= 0 && a < e.material.subMaterials.length) {
        const u = `${e.id}_${a}`;
        if (o.hasOwnProperty(u)) {
          const f = o[u], v = this.getMaterialByID(f);
          v && (e.material.subMaterials[a] = v);
        }
      }
    }
    this.setRenderingNeeded();
  }
  //#endregion
  getExtension(e) {
    var t = e.lastIndexOf(".");
    if (t !== -1) {
      var r = e.substring(t).toLowerCase();
      return r;
    }
  }
  //#region Caricamento texture da file esterni
  loadMobileTextureFilesAsync(e, t, r, o) {
    return new Promise((a, u) => {
      this.loadMobileTextureFiles(
        e,
        t,
        r,
        o,
        () => a(),
        (f) => u()
      );
    });
  }
  loadMobileTextureFiles(e, t, r, o, a, u) {
    const f = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      r,
      (v) => {
        v.length > 0 && (f ? this.setMobileCubeTextureImages(v, t, r) : this.setMobileTextureImage(v[0], t, r, o)), a && a();
      },
      u,
      !1
    );
  }
  loadTextureFilesAsync(e, t, r, o) {
    return new Promise((a, u) => {
      this.loadTextureFiles(
        e,
        t,
        r,
        o,
        () => a(),
        (f) => u(f)
      );
    });
  }
  // Per il caso di texture di ambiente si suppone che material sia null e che type sia
  // uno di "environment", "skybox", "ground"
  loadTextureFiles(e, t, r, o, a, u) {
    const f = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      r,
      async (v) => {
        v.length > 0 && (f ? await this.setCubeTextureImages(v, t, r) : (await this.setTextureImage(v[0], t, r, o), (!r.includes("sheen") && !r.includes("clearCoat") && !r.includes("subSurface") && !r.includes("anisotropy") && (!t[r + "Texture"].metadata || !t[r + "Texture"].metadata.mobileUrl) || !t[r.split("_")[0]][r.toLowerCase().includes("texture") ? "texture" : r.split("_")[1] + "Texture"].metadata || !t[r.split("_")[0]][r.toLowerCase().includes("texture") ? "texture" : r.split("_")[1] + "Texture"].metadata.mobileUrl) && await new Promise(async (S) => {
          this.uploadTextureFiles(
            e,
            t,
            r,
            async (I) => {
              this.setMobileTextureImage(I[0], t, r, o), S();
            },
            u,
            !0
          );
        })), a && a());
      },
      u,
      !1
    );
  }
  getRecursiveBoundingBox(e) {
    this.calculateRecursiveBoundingBox(e);
    const t = e.getBoundingInfo().boundingBox.scale(2);
    return e.setBoundingInfo(new BABYLON.BoundingInfo(BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero())), new BABYLON.BoundingBox(t.minimum, t.maximum);
  }
  calculateRecursiveBoundingBox(e) {
    const t = (o) => {
      o.refreshBoundingInfo();
      for (const a of o.getChildMeshes(!0))
        t(a);
    };
    t(e);
    const r = e.getHierarchyBoundingVectors(!0);
    e.setBoundingInfo(new BABYLON.BoundingInfo(r.min, r.max));
  }
  calculateBoundingBox(e) {
    let { min: t, max: r } = e[0].getHierarchyBoundingVectors(!1);
    for (let o = 1; o < e.length; o++) {
      const a = e[o].getHierarchyBoundingVectors(!1);
      t = BABYLON.Vector3.Minimize(t, a.min), r = BABYLON.Vector3.Maximize(r, a.max);
    }
    return new BABYLON.BoundingBox(t, r).extendSizeWorld.length();
  }
  // VERIFICA SE CI SONO MESH CHE SUPERANO I BOUNDS DELLE MESH DI RIFERIMENTO
  // Ritorna 1 se la mesh supera il volume di tutte le altre mesh
  // Ritorna -1 se la mesh è superata da almeno una delle altre mesh
  // Ritorna 0 se la mesh non supera il volume di nessuna delle altre mesh o se il volume è simile
  //maxThreshold percentuale di sensibilità del controllo
  //minThreshold aumentondolo aumenta la sensibilità del controllo
  checkMeshHiddenByMeshes(e, t, r, o) {
    const a = this.calculateBoundingBox(t), u = this.calculateBoundingBox(e);
    return u - u * r > a ? 1 : u + u * o < a ? -1 : 0;
  }
  uploadTextureFileAsync(e, t) {
    return new Promise((r, o) => {
      if (!this._scene || !this._zkScene || !e) {
        r(null);
        return;
      }
      const a = t ? t.id : Zakeke.getEmptyUUID(), u = (S) => {
        if (this._zkScene && S && S.textureID && S.materialID && (S.fileObjectID || S.fileLength) && S.url) {
          const I = new Zakeke.SceneTexture();
          return I.set("textureID", S.textureID), I.set("materialID", S.materialID), I.set("fileObjectID", S.fileObjectID), I.set("fileLength", S.fileLength), I.set("url", S.url), this._zkScene.get("textures").push(I), I;
        }
        return null;
      }, f = new FormData();
      f.append("file", e);
      const v = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this._authorizationToken}`
        },
        body: f
      };
      fetch(this.getTexturesUploadUrl(a), v).then((S) => {
        if (S.ok)
          return S.json();
        throw new Error("An error occurred");
      }).then((S) => {
        if (Array.isArray(S)) {
          const I = u(S[0]);
          I ? r(I) : o("Invalid image");
        } else
          o("Invalid image");
      }).catch((S) => {
        o("An error occurred: " + S.message);
      });
    });
  }
  async uploadTextureFiles(e, t, r, o, a, u) {
    if (!this._scene || !this._zkScene || !e || e.length == 0)
      return;
    const f = t ? t.id : Zakeke.getEmptyUUID(), v = (J) => {
      if (this._zkScene && J && J.textureID && J.materialID && (J.fileObjectID || J.fileLength) && J.url) {
        const he = new Zakeke.SceneTexture();
        return he.set("textureID", J.textureID), he.set("materialID", J.materialID), he.set("fileObjectID", J.fileObjectID), he.set("fileLength", J.fileLength), he.set("url", J.url), this._zkScene.get("textures").push(he), he;
      }
      return null;
    }, S = (J) => {
      const he = J.lastIndexOf(".");
      return he !== -1 ? J.substring(he) : null;
    }, I = (J, he) => {
      const ve = J.lastIndexOf(".");
      return ve !== -1 ? J.substring(0, ve).endsWith("_" + he) : !1;
    }, D = S(e[0].name), Z = this.canLoadCubemap(t, r) && (e.length == 6 || D === ".dds" || D === ".hdr" || D === ".env" || D === ".basis"), M = [];
    if (Z && e.length == 6) {
      const J = ["px", "py", "pz", "nx", "ny", "nz"];
      for (let he = 0; he < e.length; he++) {
        const ve = e[he];
        let K = -1;
        for (let j = 0; j < J.length; j++)
          if (I(ve.name, J[j])) {
            M.push(ve), K = j;
            break;
          }
        K !== -1 && J.splice(K, 1);
      }
      if (J.length != 0) {
        const he = "Immagini per la cube map non valide";
        a && a(he), Logger.info(he);
        return;
      }
    } else
      M.push(e[0]);
    const X = new FormData();
    for (let J = 0; J < M.length; J++)
      X.append("file-" + J, M[J]);
    var Y = this._zkScene.getTexturesConfig();
    if (Y) {
      var ie = JSON.stringify(Y), G = new Blob([ie], {
        type: "application/json"
      });
      X.append("options", G, "options.json");
    }
    X.forEach((J) => console.log("File: ", J));
    const te = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this._authorizationToken}`
        // 'Content-Type': 'multipart/form-data',
      },
      body: X
    };
    fetch(this.getTexturesUploadUrl(f) + "?resize=" + u, te).then((J) => {
      if (!J.ok)
        throw new Error("An error occurred: " + J.status);
      return J.json();
    }).then((J) => {
      const he = [];
      if (Object.prototype.toString.call(J) === "[object Array]")
        for (let ve = 0; ve < J.length; ve++) {
          const K = v(J[ve]);
          if (!K) {
            const j = "Immagini non valide";
            if (a) {
              a(j);
              return;
            }
          }
          K && he.push(K);
        }
      o && o(he);
    }).catch((J) => {
      const he = "An error occurred: " + J.message;
      a && a(he);
    });
  }
  getTexturesUploadUrl(e) {
    return this._zkScene ? this._zkScene.getTexturesUrl(e) : "";
  }
  removeAllMaterialPhotos(e) {
    if (this._zkScene) {
      const t = [];
      for (let r = 0; r < this._zkScene.get("materialPhotos").length; r++)
        this._zkScene.get("materialPhotos").at(r).get("materialID") === e.id && t.push(this._zkScene.get("materialPhotos").at(r));
      t.length > 0 && this._zkScene.get("materialPhotos").remove(t);
    }
  }
  removeMaterialPhotoAtIndex(e, t) {
    if (this._zkScene) {
      const r = [];
      for (let o = 0; o < this._zkScene.get("materialPhotos").length; o++)
        this._zkScene.get("materialPhotos").at(o).get("materialID") === e.id && r.push(this._zkScene.get("materialPhotos").at(o));
      if (r.length > 0) {
        const o = r[t];
        this._zkScene.get("materialPhotos").remove(o);
      }
    }
  }
  loadMaterialPhotoFiles(e, t, r, o) {
    this.uploadMaterialPhotoFiles(
      e,
      t,
      (a) => {
        this.refreshInfoPoints(), r && r();
      },
      o
    );
  }
  uploadMaterialPhotoFiles(e, t, r, o) {
    if (!this._scene || !this._zkScene || !e || e.length === 0)
      return;
    const a = t.id, u = (S) => {
      if (this._zkScene && S && S.photoID && S.materialID && (S.fileObjectID || S.fileLength) && S.url) {
        const I = new Zakeke.SceneMaterialPhoto();
        return I.set("photoID", S.photoID), I.set("materialID", S.materialID), I.set("fileObjectID", S.fileObjectID), I.set("fileLength", S.fileLength), I.set("url", S.url), this._zkScene.get("materialPhotos").push(I), I;
      }
      return null;
    }, f = (S) => {
      const I = S.lastIndexOf(".");
      return I !== -1 ? S.substring(I) : null;
    }, v = new FormData();
    for (let S = 0; S < e.length; S++) {
      const I = f(e[S].name);
      (I === ".png" || I === ".jpg") && v.append("file-" + S, e[S]);
    }
    jQuery.ajax({
      url: this.getMaterialPhotosUploadUrl(a),
      data: v,
      cache: !1,
      contentType: !1,
      processData: !1,
      type: "POST",
      success: (S) => {
        const I = [];
        if (Object.prototype.toString.call(S) === "[object Array]")
          for (let D = 0; D < S.length; D++) {
            const Z = u(S[D]);
            if (!Z) {
              const M = "Immagini non valide";
              if (o) {
                o(M);
                return;
              }
            }
            Z && I.push(Z);
          }
        r && r(I);
      },
      error: (S, I, D) => {
        const Z = "An error occurred: " + I + " Error: " + D;
        o && o(Z);
      }
    });
  }
  getMaterialPhotosUploadUrl(e) {
    return this._zkScene ? this._zkScene.getMaterialPhotosUrl(e) : "";
  }
  // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
  canLoadCubemap(e, t) {
    return e ? e instanceof BABYLON.StandardMaterial && (t == "reflection" || t == "refraction") ? !0 : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? t === "environment" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? t === "reflection" : e instanceof BABYLON.ShaderMaterial : t == "environment" || t == "skybox";
  }
  // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
  setEnvironmentTexture(e, t, r, o, a) {
    t === "environment" ? this.setSceneEnvironmentTexture(e, void 0, r, o, a) : t === "skybox" ? this.setViewerSkyboxTexture(e, r, o) : t === "ground" && this.setViewerGroundTexture(e);
  }
  removeSceneEnvironmentTexture() {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null, this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY), this.setRenderingNeeded();
  }
  setSceneEnvironmentTextureRotationY(e) {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture) && (this._scene.environmentTexture.rotationY = e * Math.PI / 180, this.setLongRenderingNeeded());
  }
  // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
  async setTextureImage(e, t, r, o) {
    return new Promise((a) => {
      if (this._scene && e && e instanceof Zakeke.SceneTexture) {
        const u = e.get("url");
        if (u)
          if (!t)
            this.setEnvironmentTexture(u, r);
          else {
            const f = this.getMaterialTexture(t, r);
            let v = !0;
            f && f instanceof BABYLON.Texture && (v = f.invertY);
            const S = new BABYLON.Texture(
              u,
              this._scene,
              o,
              v,
              void 0,
              () => this.setRenderingNeeded()
            );
            f && f instanceof BABYLON.Texture && (S.uScale = f.uScale, S.vScale = f.vScale, S.uOffset = f.uOffset, S.vOffset = f.vOffset, S.uAng = f.uAng, S.vAng = f.vAng, S.level = f.level, S.coordinatesIndex = f.coordinatesIndex, S.coordinatesMode = f.coordinatesMode, S.hasAlpha = f.hasAlpha, S.wrapU = f.wrapU, S.wrapV = f.wrapV, S.gammaSpace = f.gammaSpace), yi.whenTextureIsReadyAsync(S).then(() => {
              this.applyTexture(S, t, r), f && !this.isTextureUsed(f) && f.dispose(), this.setRenderingNeeded(), a();
            });
          }
      }
    });
  }
  // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
  async setCubeTextureImages(e, t, r) {
    return new Promise((o) => {
      (!this._scene || Object.prototype.toString.call(e) != "[object Array]") && o();
      for (let v = 0; v < e.length; v++) {
        const S = e[v];
        (!S || !(S instanceof Zakeke.SceneTexture)) && o();
      }
      const a = () => this.setLongRenderingNeeded();
      let u = null;
      const f = this.getCubeTextureInfo(e);
      if (f.url && this._scene)
        if (e.length === 1) {
          const v = f.url;
          v && (t ? v.endsWith(".dds") ? u = BABYLON.CubeTexture.CreateFromPrefilteredData(v, this._scene) : v.endsWith(".hdr") ? u = new BABYLON.HDRCubeTexture(
            v,
            this._scene,
            128,
            void 0,
            void 0,
            void 0,
            void 0,
            a
          ) : v.endsWith(".env") ? u = new BABYLON.CubeTexture(
            v,
            this._scene,
            null,
            !1,
            null,
            a,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : v.endsWith(".basis") && (u = BABYLON.CubeTexture.CreateFromPrefilteredData(v, this._scene)) : this.setEnvironmentTexture(v, r));
        } else
          e.length === 6 && f.files.length === 6 && f.extensions.length === 6 && (t ? u = new BABYLON.CubeTexture(
            f.url,
            this._scene,
            f.extensions,
            !1,
            f.files,
            a
          ) : this.setEnvironmentTexture(
            f.url,
            r,
            f.extensions,
            f.files,
            a
          ));
      u ? yi.whenTextureIsReadyAsync(u).then(() => {
        if (t) {
          const v = this.getMaterialTexture(t, r);
          this.applyTexture(u, t, r), v && !this.isTextureUsed(v) && v.dispose(), this.setRenderingNeeded(), o();
        }
      }) : o();
    });
  }
  setMobileTextureImage(e, t, r, o) {
    if (this._scene && this._sceneHelper) {
      const a = e.get("url");
      if (a) {
        let u = null;
        t ? u = this.getMaterialTexture(t, r) : u = this._scene.environmentTexture, u !== null && this._sceneHelper.isTextureWithUrl(u) && (u.metadata || (u.metadata = {}), u.metadata.mobileUrl = a);
      }
    }
  }
  setMobileCubeTextureImages(e, t, r) {
    if (!this._scene || Object.prototype.toString.call(e) != "[object Array]")
      return;
    for (let a = 0; a < e.length; a++) {
      const u = e[a];
      if (!u || !(u instanceof Zakeke.SceneTexture))
        return;
    }
    const o = this.getCubeTextureInfo(e);
    if (o.url) {
      let a = null;
      t ? a = this.getMaterialTexture(t, r) : a = this._scene.environmentTexture, a && a instanceof BABYLON.CubeTexture && (a.metadata || (a.metadata = {}), a.metadata.mobileUrl = o.url, o.files.length === 6 && (a.metadata.mobileFiles = o.files, a.metadata.mobileExtensions = o.extensions));
    }
  }
  // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
  // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
  getCubeTextureInfo(e) {
    const t = {
      url: null,
      files: [],
      extensions: []
    };
    if (e.length === 1)
      t.url = e[0].get("url") || null;
    else if (e.length === 6) {
      const r = ["px", "py", "pz", "nx", "ny", "nz"];
      let o = null;
      const a = [], u = [], f = (I, D) => {
        const Z = I.lastIndexOf(".");
        return Z !== -1 ? I.substring(0, Z).endsWith("_" + D) : !1;
      }, v = (I, D) => {
        const Z = I.lastIndexOf(".");
        if (Z !== -1) {
          const M = I.substring(0, Z);
          if (M.endsWith("_" + D))
            return M.substring(0, M.length - ("_" + D).length);
        }
        return null;
      }, S = (I, D) => {
        const Z = I.lastIndexOf("_" + D);
        return Z !== -1 ? I.substr(Z) : null;
      };
      for (let I = 0; I < r.length; I++) {
        const D = r[I];
        for (let Z = 0; Z < e.length; Z++) {
          const M = e[Z].get("url");
          if (M && f(M, D)) {
            a.push(M);
            const X = S(M, D);
            X && u.push(X), o || (o = v(M, D));
            break;
          }
        }
      }
      t.url = o, t.files = a, t.extensions = u;
    }
    return t;
  }
  isTextureUsed(e) {
    if (this._scene && e)
      for (let t = 0; t < this._scene.materials.length; t++) {
        const o = this._scene.materials[t].getActiveTextures();
        for (let a = 0; a < o.length; a++)
          if (o[a].uid === e.uid)
            return !0;
      }
    return !1;
  }
  async changeTextureInvertYAsync(e, t, r) {
    if (this._scene && this._sceneHelper) {
      var o = this._sceneHelper.getMaterialTexture(e, t);
      if (o && o instanceof BABYLON.Texture && o.invertY != r) {
        let u = o.url;
        if (u) {
          let f = u;
          if (!/^(?:\/|[a-z]+:\/\/)/.test(u)) {
            var a = await this.getSceneRootUrl();
            a && (f = a + u);
          }
          const S = new BABYLON.Texture(
            f,
            this._scene,
            void 0,
            r,
            void 0,
            () => this.setRenderingNeeded()
          );
          o && o instanceof BABYLON.Texture && (S.uScale = o.uScale, S.vScale = o.vScale, S.uOffset = o.uOffset, S.vOffset = o.vOffset, S.uAng = o.uAng, S.vAng = o.vAng, S.level = o.level, S.coordinatesIndex = o.coordinatesIndex, S.coordinatesMode = o.coordinatesMode, S.hasAlpha = o.hasAlpha, S.wrapU = o.wrapU, S.wrapV = o.wrapV, S.gammaSpace = o.gammaSpace), await yi.whenTextureIsReadyAsync(S), this.applyTexture(S, e, t), o && !this.isTextureUsed(o) && o.dispose(), this.setRenderingNeeded();
        }
      }
    }
  }
  applyTextureByName(e, t, r) {
    if (this._scene) {
      const o = this._scene.textures.find((a) => a.name === e);
      o && this.applyTexture(o, t, r);
    }
  }
  applyTexture(e, t, r) {
    if (e && r == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (r) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (r) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${r}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (r) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${r}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (r) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${r}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(r, e) : t.removeTexture(r);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (r) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
    this.setLongRenderingNeeded();
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "base":
          return e.baseTexture;
        case "metallicRoughness":
          return e.metallicRoughnessTexture;
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "diffuse":
          return e.diffuseTexture;
        case "specularGlossiness":
          return e.specularGlossinessTexture;
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
          return e.albedoTexture;
        case "ambient":
          return e.ambientTexture;
        case "opacity":
          return e.opacityTexture;
        case "reflection":
          return e.reflectionTexture;
        case "emissive":
          return e.emissiveTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "metallic":
          return e.metallicTexture;
        case "microSurface":
          return e.microSurfaceTexture;
        case "bump":
          return e.bumpTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "refraction":
          return e.refractionTexture;
        case "clearCoat":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  removeMaterialTexture(e, t) {
    this.applyTexture(null, e, t);
  }
  removeMaterialMobileTexture(e, t) {
    const r = this.getMaterialTexture(e, t);
    r && r.metadata && r.metadata.mobileUrl && (delete r.metadata.mobileUrl, r.metadata.hasOwnProperty("mobileFiles") && delete r.metadata.mobileFiles, r.metadata.hasOwnProperty("mobileExtensions") && delete r.metadata.mobileExtensions, Object.keys(r.metadata).length === 0 && r.metadata.constructor === Object && delete r.metadata);
  }
  //#endregion
  //#region Operazioni sugli elementi della scena
  /**
   * Create a group of meshes
   * @param parentId Id of the parent node of the group
   * @param name Name of the group
   * @param children Array of meshes to be included in the group
   */
  createGroup(e, t, r) {
    if (this._scene) {
      const o = new BABYLON.Mesh(t, this._scene);
      if (o.id = Zakeke.generateUUID(), o.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, e) {
        const a = this._scene.getMeshByID(e);
        a && (o.parent = a);
      }
      return r && r.forEach((a) => a.parent = o), this.fireMeshesUpdateEvent(), o;
    }
    return null;
  }
  deleteMesh(e, t) {
    const r = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._scene, a = this._sceneHelper, u = this._zkScene, f = o.getMeshByID(e);
      if (f) {
        const v = (I) => {
          const D = this.getMeshMaterials(I);
          for (let Z = 0; Z < D.length; Z++) {
            const M = D[Z];
            if (!M)
              continue;
            const X = this.getMeshesUsingMaterial(M.id);
            X.length === 1 && X.every((Y) => a.meshHasParent(Y.id, f.id)) && (r.materialIDs.push(D[Z].id), D[Z].dispose());
          }
          I.getChildMeshes().forEach((Z) => v(Z));
        };
        t && (v(f), this.fireMaterialsUpdateEvent());
        const S = a.getCameraPivot();
        S && S === f && this.setCameraPivot(null), this.isMeshSelected(f) && this.unselectMesh(f.id), f.dispose(), r.meshIDs.push(e);
      }
      this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), r.materialIDs.forEach((v) => {
        const S = u.getLibraryShaderMaterialIDForSceneMaterial(v);
        S && u.unregisterShaderMaterial(S);
      });
    }
    return r;
  }
  // Cancella tutte le mesh
  deleteAllMeshes() {
    if (this._scene && this._sceneHelper) {
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        this._sceneHelper.isRealMesh(t) && (this._scene.meshes.splice(e--, 1), t.dispose());
      }
      this.setCameraPivot(null), this.setRenderingNeeded();
    }
  }
  deleteDuplicatedMeshesWithDifferentParent(e, t) {
    const r = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._scene, a = this._sceneHelper, u = this._zkScene, f = (S) => {
        const I = this.getSceneMeshesByName(S.name);
        let D = !1;
        for (let M = 0; M < I.length; M++) {
          var Z = I[M];
          if (Z.id != S.id && !a.meshHasParent(Z.id, e)) {
            if (t) {
              const X = this.getMeshMaterials(Z);
              for (let Y = 0; Y < X.length; Y++)
                this.getMeshesUsingMaterial(X[Y].id).length == 1 && (r.materialIDs.push(X[Y].id), X[Y].dispose());
            }
            r.meshIDs.push(Z.id), Z.dispose(), I.splice(M--, 1), D = !0;
            break;
          }
        }
        D || S.getChildMeshes().forEach((M) => f(M));
      }, v = o.getMeshByID(e);
      v && v.getChildMeshes().forEach((S) => f(S)), this.setRenderingNeeded(), r.materialIDs.forEach((S) => {
        const I = u.getLibraryShaderMaterialIDForSceneMaterial(S);
        I && u.unregisterShaderMaterial(I);
      });
    }
    return r;
  }
  // Cancella tutte le mesh figlie di quella in input
  // che hanno lo stesso nome di altre mesh con id diverso
  // Questa funzione può essere utile per elminiare oggetti duplicati importati
  // con file diversi
  deleteDuplicatedChildMeshes(e, t) {
    const r = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._scene, a = this._sceneHelper, u = this._zkScene, f = (S) => {
        const I = this.getSceneMeshesByName(S.name);
        let D = !1;
        for (let Z = 0; Z < I.length; Z++) {
          const M = I[Z];
          if (M.id != S.id && !a.meshHasParent(M.id, e)) {
            if (t) {
              const X = this.getMeshMaterials(S);
              for (let Y = 0; Y < X.length; Y++)
                this.getMeshesUsingMaterial(X[Y].id).length == 1 && (r.materialIDs.push(X[Y].id), X[Y].dispose());
            }
            r.meshIDs.push(S.id), S.dispose(), D = !0;
            break;
          }
        }
        if (!D) {
          const Z = S.getChildMeshes();
          for (let M = 0; M < Z.length; M++)
            f(Z[M]);
        }
      }, v = o.getMeshByID(e);
      v && v.getChildMeshes().forEach((S) => f(S)), this.setRenderingNeeded(), r.materialIDs.forEach((S) => {
        const I = u.getLibraryShaderMaterialIDForSceneMaterial(S);
        I && u.unregisterShaderMaterial(I);
      });
    }
    return r;
  }
  deleteMaterial(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMaterialByID(e);
      t && (this.deleteMaterialInternal(t), this.fireMaterialsUpdateEvent(), this.setRenderingNeeded());
    }
  }
  deleteMaterialInternal(e) {
    if (this._scene && this._sceneHelper && e) {
      const t = e.id;
      if (this._zkScene) {
        const o = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e.id);
        o && this._zkScene.unregisterShaderMaterial(o);
      }
      const r = this._sceneHelper.getTexturesExclusivelyForMaterial(e);
      e.dispose();
      for (let o = 0; o < r.length; o++)
        r[o].dispose();
      this._sceneHelper.removeSceneMaterialMetadata(t);
    }
  }
  deleteAllMaterials() {
    if (this._scene) {
      for (; this._scene.materials.length > 0; ) {
        const e = this._scene.materials.pop();
        e && this.deleteMaterialInternal(e);
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
  }
  renameMaterial(e, t) {
    if (this._scene) {
      const r = this._scene.getMaterialByID(e);
      r && (r.name = t), this.fireMaterialsUpdateEvent();
    }
  }
  cloneMesh(e) {
    let t = null;
    return this._scene && this._sceneHelper && (t = this._sceneHelper.cloneMesh(e, !1, !1), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), t;
  }
  // Same as clone but with duplicated geometry data too
  duplicateMesh(e, t = !1) {
    let r = null;
    return this._scene && this._sceneHelper && (r = this._sceneHelper.cloneMesh(e, !0, t), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), r;
  }
  cloneMaterial(e, t, r) {
    let o = null;
    if (this._scene && this._sceneHelper) {
      const u = this._scene.getMaterialById(e);
      if (u) {
        const f = r || u.name + " - clone";
        if (o = u.clone(f), o) {
          const v = t || Zakeke.generateUUID();
          if (o.id = v, this._zkScene) {
            const S = this._zkScene.getMappingForSceneMaterial(u.id);
            if (S) {
              var a = S.get("libraryMaterialID");
              this._zkScene.mapLibraryMaterial(a, o.id);
              const I = this._sceneHelper.getTexturesForMaterial(o), D = this._sceneHelper.getTexturesForMaterial(o);
              for (let Z = 0; Z < D.length; Z++) {
                const M = D[Z], X = I[Z];
                M.materialMapping = X.materialMapping;
              }
            }
          }
        }
      }
      this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return o;
  }
  createMaterial(e, t, r) {
    let o = null;
    if (this._scene) {
      const a = e || "new material", u = t || "Standard";
      u === "Standard" ? o = new BABYLON.StandardMaterial(a, this._scene) : u === "PBRMetallicRoughness" ? (o = new BABYLON.PBRMetallicRoughnessMaterial(a, this._scene), o.subSurface.indexOfRefraction = 1, o._imageProcessingConfiguration.contrast = 1) : u === "PBRSpecularGlossiness" ? o = new BABYLON.PBRSpecularGlossinessMaterial(a, this._scene) : u === "PBR" ? (o = new BABYLON.PBRMaterial(a, this._scene), o.enableSpecularAntiAliasing = !0, o.metallic = 0.9, o.roughness = 0.3, o.indexOfRefraction = 1.5) : u === "NewPBR" && (o = new Zakeke.PBRMaterial(a, this._scene)), o && (o.id = Zakeke.generateUUID(), r && (o.metadata || (o.metadata = {}), o.metadata.group = r)), this.checkSceneEmptyEnvironmentTexture(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return o;
  }
  changeMeshParent(e, t) {
    if (this._scene) {
      const r = this._scene.getMeshById(e);
      if (r && (!r.parent || r.parent.id != t)) {
        const o = this._scene.getMeshById(t);
        r.setParent(o), this.setRenderingNeeded(), this.fireMeshesUpdateEvent();
      }
    }
  }
  removeMeshParent(e) {
    if (this._scene) {
      const t = this._scene.getMeshByID(e);
      t && (t.parent = null, this.fireMeshesUpdateEvent());
    }
  }
  setManipulatedNode(e) {
    e !== this._manipulatedNode && (this._manipulatedNode = e, this.showHideEditControl(this._editControlVisible), this.setRenderingNeeded());
  }
  importLibraryMaterial(e) {
    if (this._scene && this._sceneHelper && this._zkScene && e && e instanceof Zakeke.Material) {
      e.get("shaders") && this.checkShaderMaterial(e);
      const r = e.get("JSON") || e.get("json"), o = e.get("rootUrl");
      if (r && o) {
        const a = JSON.parse(r), u = BABYLON.Material.Parse(a, this._scene, o);
        if (u) {
          if (u.id = Zakeke.generateUUID(), this._zkScene.mapLibraryMaterial(e.getMaterialID(), u.id), e.get("shaders")) {
            const I = e.get("shaders"), D = I.get("name"), Z = I.get("vertex"), M = I.get("fragment");
            D && Z && M && this._zkScene.registerShaderMaterial(
              e.getMaterialID(),
              D,
              Z,
              M
            ), this.setupShaderMaterialCameraPosition(u);
          }
          e.get("sourceTextureImages").forEach((I) => {
            var Z, M;
            if ((Z = this._zkScene) != null && Z.get("textures").find((X) => X.get("url") === I.get("url")))
              return;
            let D = new Zakeke.SceneTexture();
            D.set("textureID", Zakeke.generateUUID()), D.set("materialID", u.id), D.set("fileObjectID", I.get("fileObjectID")), D.set("fileLength", I.get("fileLength")), D.set("url", I.get("url")), (M = this.zkScene) == null || M.get("textures").push(D);
          }), e.get("textureImages").forEach((I) => {
            var Z, M;
            if ((Z = this._zkScene) != null && Z.get("textures").find((X) => X.get("url") === I.get("imageUrl")))
              return;
            let D = new Zakeke.SceneTexture();
            D.set("textureID", Zakeke.generateUUID()), D.set("materialID", u.id), D.set("fileObjectID", I.get("fileObjectID")), D.set("fileLength", I.get("fileLength")), D.set("url", I.get("imageUrl")), (M = this.zkScene) == null || M.get("textures").push(D);
          });
          const S = this._sceneHelper.getTexturesForMaterial(u);
          for (let I = 0; I < S.length; I++) {
            var t = S[I];
            t.materialMapping = {
              libraryMaterialRootUrl: o,
              libraryMaterialID: e.getMaterialID(),
              sceneMaterialID: u.id
            };
          }
        }
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Recupero Texture
  // I metodi per il recupero delle texture sono stati spostati in SceneHelper
  // Li lascio qui solo momentaneamente
  getTexturesForMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(e) : [];
  }
  getStandardMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(e) : [];
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(e) : [];
  }
  getPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(e) : [];
  }
  getNewPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(e) : [];
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(e) : [];
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(e) : [];
  }
  //#endregion
  //#region Camera Location
  removeCameraLocation(e) {
    var t;
    (t = this._zkScene) == null || t.get("cameraLocations").remove(e), this.fireCameraLocationsUpdateEvent();
  }
  saveCameraLocation(e) {
    if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, r = this._camera.target, o = new Zakeke.SceneCameraLocation();
      o.set("name", e), o.set("px", t.x), o.set("py", t.y), o.set("pz", t.z), o.set("tx", r.x), o.set("ty", r.y), o.set("tz", r.z), this._zkScene.get("cameraLocations").push(o), this.fireCameraLocationCreatedEvent(o), this.fireCameraLocationsUpdateEvent();
    }
  }
  clearCameraLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("cameraLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
      this.fireCameraLocationsUpdateEvent();
    }
  }
  //public setCameraLocation(locationID: string) {
  //    if (this._sceneHelper && this._zkScene) {
  //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
  //        if (zkCameraLocation) {
  //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
  //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
  //            this._sceneHelper.animateCamera(target, position, 0.5);
  //        }
  //    }
  //    this.setRenderingNeeded();
  //}
  getAllCameraLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("cameraLocations").length; t++)
        e.push(this._zkScene.get("cameraLocations").at(t));
    return e;
  }
  //#endregion
  //#region Collapse / Explode (Mesh Locations)
  saveMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.saveMeshLocation(e);
  }
  saveExplodedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveExplodedMeshLocation();
  }
  saveCollapsedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveCollapsedMeshLocation();
  }
  onBeforeSaveMeshLocation() {
    this._oldManipulatedNode = this._manipulatedNode, this.setManipulatedNode(null);
  }
  onAfterSaveMeshLocation() {
    this.fireMeshLocationsUpdateEvent(), this.setManipulatedNode(this._oldManipulatedNode);
  }
  clearMeshLocations() {
    this._meshLocationsManager && this._meshLocationsManager.clearMeshLocations();
  }
  getAllMeshLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("meshLocations").length; t++)
        e.push(this._zkScene.get("meshLocations").at(t));
    return e;
  }
  //#endregion
  //#region Material Library
  // Nota Bene
  // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione.
  // Il problema principale è la gestione delle texture
  // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
  // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
  // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
  // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
  // Recupera le texture (babylon) associate al materiale di scena.
  // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture.
  // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
  // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
  // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
  // Alla fine elimina il nuovo materiale creato come clone.
  makeLibraryMaterial(e, t) {
    return new Promise((r, o) => {
      this.getMaterialScreenShotForLibrary(e, (a) => {
        a ? this.createLibraryMaterial(e, t, a, r) : o("No data generated for screenshot");
      });
    });
  }
  getMaterialScreenShotForLibrary(e, t) {
    if (this._scene && this._sceneHelper) {
      this.resetEditorEnvironment(), this.removeGround(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
      const r = 500, o = 500;
      this._sceneHelper.takeMaterialScreenshotAsync(e, r, o).then((a) => {
        Rx(a, r, o, (u) => {
          this.refreshEnvironment(), t && t(u);
        });
      });
    } else
      t && t(null);
  }
  createLibraryMaterial(e, t, r, o) {
    let a = null;
    const u = () => {
      a && this.deleteMaterial(a.id), o && o();
    };
    if (!this._scene || !this._sceneHelper || !this._zkScene) {
      u();
      return;
    }
    const f = this._scene, v = this._sceneHelper, S = this._zkScene;
    if (!f.getMaterialByID(e)) {
      u();
      return;
    }
    const D = new Zakeke.Material();
    D.set("name", t), D.set("imageData", r);
    let Z = e, M = Z.replace(/-/g, "");
    const X = D.getMaterialID(), Y = X.replace(/-/g, "");
    if (a = this.cloneMaterial(e, X, t), !a) {
      u();
      return;
    }
    const ie = S.getSourcesIDs();
    S.getLibraryMaterialIDs();
    const G = v.getTexturesForMaterial(a), te = [];
    for (let We = 0; We < G.length; We++) {
      const ke = G[We];
      if (ke.materialMapping) {
        const $e = ke.materialMapping.libraryMaterialID;
        $e && te.push($e);
      }
    }
    let J = new Zakeke.Materials();
    const he = ["px", "py", "pz", "nx", "ny", "nz"], ve = function(We) {
      const ke = We.lastIndexOf(".");
      if (ke !== -1) {
        const $e = We.substring(0, ke);
        if (he.some((Lt) => $e.endsWith("_" + Lt)))
          return $e.substring(0, $e.length - 3);
      }
      return We;
    }, K = (We, ke) => ve(We).endsWith(ke), j = () => {
      for (let ke = 0; ke < G.length; ke++) {
        const $e = G[ke];
        if ($e && v.isTextureWithUrl($e) && $e.url) {
          let Lt = null, Be = null;
          for (let ot = 0; ot < ie.length; ot++) {
            const Gt = ie[ot].replace(/-/g, "");
            if ($e.url.indexOf(Gt) != -1) {
              Lt = ie[ot], Be = Gt;
              break;
            }
          }
          const Xe = [];
          for (let ot = 0; ot < S.get("textures").length; ot++) {
            const Gt = S.get("textures").at(ot);
            Gt.get("url") && K(Gt.get("url"), $e.url) && Xe.push({
              fileObjectID: Gt.get("fileObjectID"),
              url: Gt.get("url"),
              fileLength: Gt.get("fileLength")
            });
          }
          for (let ot = 0; ot < Xe.length; ot++) {
            const Gt = new Zakeke.MaterialSourceTextureImage();
            Gt.set("fileObjectID", Xe[ot].fileObjectID), Gt.set("url", Xe[ot].url || ""), Gt.set("fileLength", Xe[ot].fileLength || -1), Lt ? (Gt.set("sceneID", S.getSceneID()), Gt.set("sourceID", Lt)) : (Gt.set("sceneID", S.getSceneID()), Gt.set("materialID", Z)), D.get("sourceTextureImages").push(Gt);
          }
          let ue = "", yt = "", Ue = $e.name;
          if (Lt && Be) {
            const ot = $e.url.indexOf(Be);
            ot != -1 && (Ue = $e.url.substring(ot)), ue = Be, yt = "textures/" + Y, $e.name = Ue.replace(new RegExp(ue, "g"), yt);
          } else {
            var We = $e.url.lastIndexOf("/");
            We !== -1 && (We = $e.url.lastIndexOf("/", We - 1), We !== -1 && (We = $e.url.lastIndexOf("/", We - 1), We != -1 && (Ue = $e.url.substring(We + 1)))), ue = M, yt = Y, $e.name = Ue.replace(
              new RegExp("textures/([A-Za-z0-9]*)/(.*)", "g"),
              "textures/" + yt + "/$2"
            );
          }
          $e.url = $e.name;
        }
      }
      if (a) {
        const ke = a.serialize(), $e = JSON.stringify(ke);
        D.set("JSON", $e), D.save(null, {
          success: function(Lt, Be, Xe) {
            u();
          },
          error: function(Lt, Be, Xe) {
            u();
          }
        });
      } else
        u();
    };
    if (te.length > 0) {
      const We = { ids: te.join(",") };
      try {
        J.fetch({
          success: (ke, $e, Lt) => {
            J = ke, j();
          },
          error: (ke, $e, Lt) => {
            Logger.info("Errore nel salvataggio del materiale di libreria"), u();
          },
          data: We
        });
      } catch {
      }
    } else
      j();
  }
  //#endregion
  //#region Lights
  lightsLayer_onLightSelected(e) {
    this.fireLightSelectedEvent(e);
  }
  isDefaultLight(e) {
    return this._sceneHelper ? this._sceneHelper.isDefaultLight(e) : !1;
  }
  createLight(e, t) {
    let r = null;
    if (this._scene) {
      const o = e || "new light", a = t || "Point", u = BABYLON.Vector3.Zero(), f = BABYLON.Vector3.Zero(), v = 25 * Math.PI / 180, S = 2;
      a == "Point" ? r = new BABYLON.PointLight(o, u, this._scene) : a == "Directional" ? r = new BABYLON.DirectionalLight(o, f, this._scene) : a == "Spot" ? r = new BABYLON.SpotLight(o, u, f, v, S, this._scene) : a == "Hemispheric" && (r = new BABYLON.HemisphericLight(o, f, this._scene)), r && (r.id = Zakeke.generateUUID()), this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return r;
  }
  cloneLight(e, t, r) {
    let o = null;
    if (this._scene) {
      const a = this._scene.getLightByID(e);
      if (a) {
        const u = r || a.name + " - clone";
        if (o = a.clone(u), o) {
          o.name = u;
          const f = t || Zakeke.generateUUID();
          o.id = f, this._lightsLayer && this._lightsLayer.refresh();
        }
      }
      this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return o;
  }
  renameLight(e, t) {
    if (this._scene) {
      const r = this._scene.getLightByID(e);
      r && (r.name = t, this._lightsLayer && this._lightsLayer.refresh()), this.fireLightsUpdateEvent();
    }
  }
  deleteLight(e) {
    if (this._scene) {
      const t = this._scene.getLightByID(e);
      t && (t.dispose(), this._scene.meshes.forEach((r) => r._markSubMeshesAsLightDirty()), this._lightsLayer && this._lightsLayer.refresh()), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
  }
  getAllLights() {
    return this._scene ? this._scene.lights : [];
  }
  canShowLights() {
    return this._showLights && this._envMode == Ar.Editor;
  }
  showHideLights(e) {
    this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Ground
  canShowGround() {
    return this._showGround && this._envMode == Ar.Editor;
  }
  removeGround() {
    this._ground && (this._ground.dispose(), this._ground = null), this.setRenderingNeeded();
  }
  refreshGround() {
    if (!this._scene)
      return;
    if (this.removeGround(), !this.canShowGround()) {
      this.setRenderingNeeded();
      return;
    }
    const e = this._scene.clearColor, t = e.toHexString(), r = Px(t) ? 0.8 : -0.5, o = BABYLON.Color3.FromHexString(Nx(t, r));
    let a = 1e3, u = 1;
    if (this.countSceneMeshes() > 0) {
      const v = this._scene.getWorldExtends((D) => this.isRealMesh(D)), I = v.max.subtract(v.min).length() * 1.5;
      isFinite(I) && (a = I * 20, u = a / 100);
    }
    this._ground = BABYLON.Mesh.CreateGround("ground", a, a, 10, this._scene), this._ground.doNotSerialize = !0, this._ground.isVisible = this.showGround, this._ground.isPickable = !1, this._ground.metadata = {
      isRealMesh: !1,
      isGround: !0
    };
    const f = new BABYLON.GridMaterial("groundMaterial", this._scene);
    f.doNotSerialize = !0, f.backFaceCulling = !1, f.mainColor = new BABYLON.Color3(e.r, e.g, e.b), f.opacity = 1, f.gridRatio = u, f.lineColor = o, f.metadata = { isRealMaterial: !1 }, this._ground.material = f, this.setRenderingNeeded();
  }
  showHideGround(e) {
    this.showGround = e, this.refreshGround();
  }
  //#endregion
  //#region Axes
  canShowAxes() {
    return this._showAxes && this._envMode == Ar.Editor;
  }
  showHideAxes(e) {
    this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Highlights
  showHideHighlight(e) {
    this._showHighlight = e;
    const t = this.getSelectedRootMesh();
    this.highlightMesh(t, e), this.setRenderingNeeded();
  }
  setHighlightOver(e) {
    this._highlightOver = e;
  }
  highlightMesh(e, t) {
    if (!this._showHighlight || this._envMode != Ar.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    e && e instanceof BABYLON.Mesh && (t ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && this._highlightLayer.addMesh(e, BABYLON.Color3.FromHexString(this._highlightColor))) : this._highlightLayer && this._highlightLayer.removeMesh(e)), this.setLongRenderingNeeded();
  }
  highlightMeshOver(e) {
    if (!this._showHighlight || this._envMode != Ar.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver) && (e && this._highlightOver ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver) && this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor))) : this._highlightLayer && this._highlightLayer.removeMesh(this._meshOver)), this.setLongRenderingNeeded();
  }
  //#endregion
  //#region Edit control (Gizmo)
  showHideEditControl(e) {
    this._scene && this._camera && this._canvas && (this._editControlVisible = e, this._editControl && (!e || this._manipulatedNode == null) && (this._editControl.detach(), this._editControl = null), e && this._manipulatedNode && (this._editControl ? this._editControl.switchTo(this._manipulatedNode) : (this._editControl = new this._EditControl(
      this._manipulatedNode,
      this._camera,
      this._canvas,
      0.75,
      !0
    ), this._editControl.setRotSnapValue(3.14 / 18), this._editControl.setTransSnapValue(0.5), this._editControl.setScaleSnapValue(0.25), this._editControl.addActionEndListener((t) => {
      this.fireMeshesUpdateEvent();
    })), this.setEditingMode(this._editingMode)), this.setRenderingNeeded());
  }
  setEditingMode(e) {
    this._editingMode = e, this._editControl && (e === qa.Translate ? this._editControl.enableTranslation() : e === qa.Rotate ? this._editControl.enableRotation() : e === qa.Scaling && this._editControl.enableScaling()), this.setRenderingNeeded();
  }
  undoEditing() {
    this._editControl && this._editControl.undo();
  }
  redoEditing() {
    this._editControl && this._editControl.redo();
  }
  //#endregion
  //#region Environment
  setEnvironmentMode(e) {
    e != this._envMode && (this._envMode = e, this.refreshEnvironment());
  }
  async refreshEnvironment() {
    this._scene && (this.setRenderingNeeded(), this._envMode == Ar.Editor ? (this.disableAntialiasing(), this.resetEditorEnvironment(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null)) : (this.deleteHighlightLayer(), this.refreshGround(), this._zkScene && ((!this._environmentManager || this._environmentManager.scene != this._scene) && (this._environmentManager = new Yd(this._zkScene, this._scene)), this._environmentManager.update(), this.setLongRenderingNeeded())), this.refreshGround(), this._lightsLayer && this._lightsLayer.refresh(), this._axesLayer && this._axesLayer.refresh(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this.autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded());
  }
  //#endregion
  //#region Zoom & Move camera
  zoomOnMesh(e) {
    this._sceneHelper && this._sceneHelper.zoomOnMesh(e);
  }
  // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
  moveCameraToMeshPosition(e) {
    if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const r = this._sceneHelper.getMeshHierarchyCenter(e), o = this._camera.target, a = this._camera.radius, u = r.subtract(o), f = u.length();
      if (isFinite(f)) {
        let v = u.normalize(), S = o.add(v.scale(a));
        const I = new BABYLON.Ray(S, v.scale(-1), a), D = this._scene.pickWithRay(I, (Z) => Z === e);
        if (D && D.hit) {
          const Z = new BABYLON.Vector3(), M = new BABYLON.Quaternion(), X = new BABYLON.Vector3();
          e.getWorldMatrix().decompose(Z, M, X), 0.1 / Z.length() * 100, D.pickedPoint;
          var t = D.getNormal();
          t && (v = t.normalize(), S = o.add(v.scale(a)));
        }
        this._sceneHelper.animateCamera(o, S, 1);
      }
      this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
  exportMeshToOBJ(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const r = BABYLON.OBJExport.OBJ([t]);
    this.saveTextAsFile(r, t.name + ".obj");
  }
  exportMeshGeometryToJson(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const r = {
      positions: t.getVerticesData(BABYLON.VertexBuffer.PositionKind),
      normals: t.getVerticesData(BABYLON.VertexBuffer.NormalKind),
      colors: t.getVerticesData(BABYLON.VertexBuffer.ColorKind),
      uvs: t.getVerticesData(BABYLON.VertexBuffer.UVKind),
      uvs2: t.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
      indices: t.getIndices()
    }, o = JSON.stringify(r, null, 0);
    this.saveTextAsFile(o, t.name + ".json");
  }
  enableDisableARForMesh(e, t) {
    const r = this.getMeshByID(e);
    r && (r.metadata || (r.metadata = {}), r.metadata.AR = t);
  }
  isAREnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.AR !== void 0 ? t.metadata.AR : !0 : !1;
  }
  enableDisableTryOnForMesh(e, t) {
    const r = this.getMeshByID(e);
    r && (r.metadata || (r.metadata = {}), r.metadata.AR = t);
  }
  isTryOnEnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.TryOn !== void 0 ? t.metadata.TryOn : !0 : !1;
  }
  //#endregion
  //#region Utilities
  splitSubMeshes(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      t && this._sceneHelper.createMeshesFromSubMeshes(t);
    }
  }
  flipMeshFaces(e) {
    const t = this.getMeshByID(e);
    if (!t)
      return;
    const r = (o) => {
      o instanceof BABYLON.Mesh && o.flipFaces(!0), o.getChildMeshes().forEach((a) => r(a));
    };
    r(t);
  }
  convertSceneToScreenPoint(e, t) {
    if (this._canvas) {
      let r = 0, o = 0, a = this._canvas;
      do
        r += a.offsetLeft, o += a.offsetTop, a = a.offsetParent;
      while (a);
      return { X: e + r, Y: t + o };
    }
    return null;
  }
  saveTextAsFile(e, t) {
    const r = e, o = new Blob([r], { type: "text/plain" }), a = window.URL.createObjectURL(o), u = t;
    this.downloadFile(u, a);
  }
  saveBytesAsFile(e, t) {
    const r = new Blob([e]), o = window.URL.createObjectURL(r);
    this.downloadFile(t, o);
  }
  saveBlobAsFile(e, t, r) {
    let o = null;
    r ? o = window.URL.createObjectURL(new Blob([e], { type: r })) : o = window.URL.createObjectURL(new Blob([e])), this.downloadFile(t, o);
  }
  downloadFile(e, t) {
    var r = document.createElement("a");
    r.download = e, r.innerHTML = "Download File", r.href = t, r.onclick = (o) => {
      document.body.removeChild(r);
    }, r.style.display = "none", document.body.appendChild(r), r.click();
  }
  //#endregion
  //#region Draco
  // Test Draco encoding
  exportDracoEncodedToFile(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t)
      return;
    const r = this.getDracoEncodedGeometry(t);
    r && this.saveBytesAsFile(r, t.name + "_draco.dat");
  }
  // Funzione utile per testare la codifica Draco delle geometrie
  // La codifica reale delle mesh avviene durante il salvataggio e se ne
  // occupa la classe MakeIncremental, utilizzata in un worker thread
  getDracoEncodedGeometry(e) {
    let t = null;
    if (this._scene && e && e instanceof BABYLON.Mesh) {
      const o = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), a = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), u = e.getVerticesData(BABYLON.VertexBuffer.ColorKind), f = e.getVerticesData(BABYLON.VertexBuffer.UVKind), v = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind), S = e.getIndices(), I = {};
      S && (I.indices = new Uint32Array(S)), o && (I.positions = new Float32Array(o)), a && (I.normals = new Float32Array(a)), f && (I.uvs = new Float32Array(f)), v && (I.uvs2 = new Float32Array(v)), u && (I.colors = new Uint32Array(u));
      const D = DracoEncoderModule(), Z = new D.Encoder(), M = new D.MeshBuilder(), X = new D.Mesh(), Y = I.indices.length / 3, ie = I.positions.length / 3;
      M.AddFacesToMesh(X, Y, I.indices), M.AddFloatAttributeToMesh(X, D.POSITION, ie, 3, I.positions), I.normals && M.AddFloatAttributeToMesh(X, D.NORMAL, ie, 3, I.normals), I.colors && M.AddFloatAttributeToMesh(X, D.COLOR, ie, 4, I.colors), I.uvs && M.AddFloatAttributeToMesh(X, D.TEX_COORD, ie, 2, I.uvs), I.uvs2 && M.AddFloatAttributeToMesh(X, D.TEX_COORD, ie, 2, I.uvs2), Z.SetSpeedOptions(5, 5), Z.SetAttributeQuantization(D.POSITION, 14), Z.SetAttributeQuantization(D.TEX_COORD, 12), Z.SetAttributeQuantization(D.NORMAL, 10), Z.SetAttributeQuantization(D.COLOR, 10), Z.SetAttributeQuantization(D.GENERIC, 8), Z.SetEncodingMethod(D.MESH_EDGEBREAKER_ENCODING);
      const G = new D.DracoInt8Array(), te = Z.EncodeMeshToDracoBuffer(X, G);
      t = new ArrayBuffer(te);
      var r = new Int8Array(t);
      for (let J = 0; J < te; ++J)
        r[J] = G.GetValue(J);
      D.destroy(X), D.destroy(G), D.destroy(Z), D.destroy(M);
    }
    return t;
  }
  // Decodifica dei dati Draco ereditata da SceneViewer
  //#endregion
  //#region Mesh Creation
  // Crea una mesh (cubo) custom specificandone la geometria
  // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
  createCustomMesh() {
    let e = null;
    if (this._scene) {
      e = new BABYLON.Mesh("custom", this._scene);
      var t = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3], r = [0, 1, 2, 3, 4, 5], o = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1], a = [0, 1, 0, 0, 1, 0], u = [];
      BABYLON.VertexData.ComputeNormals(t, r, u);
      const f = new BABYLON.VertexData();
      f.positions = t, f.indices = r, f.colors = o, f.normals = u, f.uvs = a, f.applyToMesh(e);
    }
    return e;
  }
  createBox(e, t) {
    let r = null, o = null;
    return this._scene && this._sceneHelper && (e && (o = this._scene.getMeshByID(e)), r = this._sceneHelper.createBox(o, t), this.setLongRenderingNeeded()), r;
  }
  getSceneBoundingBox() {
    let e = null;
    if (this._scene)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const r = this._scene.meshes[t];
        if (r && r.metadata && r.metadata.sceneBoundingBox) {
          e = r;
          break;
        }
      }
    return e;
  }
  getOrCreateSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t || (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t ? t.isVisible = e : (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createBoundingBox(e, t, r = !0) {
    let o = null;
    if (e && (o = this.getMeshByID(e)), this._sceneHelper) {
      var a = this._sceneHelper.createBoundingBox(o, t);
      return a && (a.isVisible = r), this.setLongRenderingNeeded(), a;
    }
    return null;
  }
  createSphere(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createSphere(o, t), this.setLongRenderingNeeded()), r;
  }
  createPlane(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createPlane(o, t), this.setLongRenderingNeeded()), r;
  }
  createDisc(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createDisc(o, t), this.setLongRenderingNeeded()), r;
  }
  createCylinder(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createCylinder(o, t), this.setLongRenderingNeeded()), r;
  }
  createTorus(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createTorus(o, t), this.setLongRenderingNeeded()), r;
  }
  createKnot(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createKnot(o, t), this.setLongRenderingNeeded()), r;
  }
  createRibbon(e, t) {
    let r = null, o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = this._sceneHelper.createRibbon(o, t), this.setLongRenderingNeeded()), r;
  }
  async createRoundedCubeAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createRoundedCubeAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createRoundedCylinderAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createRoundedCylinderAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createMatBallAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createMatBallAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createMaleHeadAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createMaleHeadAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createFemaleHeadAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createFemaleHeadAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createPokemonBallAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createPokemonBallAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createShaderBallAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createShaderBallAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createBootsAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createBootsAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createSuzanneAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createSuzanneAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createStepPyramidAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createStepPyramidAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createTeapotAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createTeapotAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createAlloyWheelAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createAlloyWheelAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  async createTryonReferenceGlassesFrameAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.createTryonReferenceGlassesFrameAsync(o, t), this.setLongRenderingNeeded()), r;
  }
  removeAllVTOReferenceMeshes() {
    if (!this.scene)
      return [];
    const e = [], t = [...this.scene.meshes];
    for (const r of t)
      r.name && r.name.toLowerCase().includes("vto_reference") ? r.dispose(!1, !0) : e.push(r);
    return e;
  }
  hideAllVTOFiles(e) {
    for (const t of e)
      t.name && t.name.toLowerCase().includes("vto_reference") && (t.metadata || (t.metadata = {}), t.metadata.TryOn = !1);
  }
  async createTryOnReferenceModelsAsync(e, t, r) {
    let o = null, a = [];
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (a = await this._sceneHelper.createTryOnReferenceModelsAsync(o, t, r), this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), this.hideAllVTOFiles(a)), a;
  }
  setTryOnReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setTryOnReferenceVisible(e), this.setRenderingNeeded());
  }
  isTryOnReferenceVisible() {
    return this._sceneHelper ? this._sceneHelper.isTryOnReferenceVisible() : !1;
  }
  scaleSceneToTryonReferenceModels(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.scaleSceneToTryonReferenceModels(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneScalingPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneScalingPercentageForVTO() : 100;
  }
  setSceneScalePercentageForVTO(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setSceneScalePercentageForVTO(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getScenePositionPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getScenePositionPercentageForVTO() : { x: 0, y: 0, z: 0 };
  }
  setScenePositionPercentageForVTO(e, t, r) {
    var o;
    this._sceneHelper && (this._sceneHelper.setScenePositionPercentageForVTO(e, t, r), (o = this._sceneHelper) == null || o.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneRotationForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneRotationForVTO() : { x: 0, y: 0, z: 0 };
  }
  setSceneRotationForVTO(e, t, r) {
    var o;
    this._sceneHelper && (this._sceneHelper.setSceneRotationForVTO(e, t, r), (o = this._sceneHelper) == null || o.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  setVTOReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setVTOReferenceVisible(e), this.setRenderingNeeded());
  }
  setShadowsVisibility(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setShadowsVisibility(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  async importMeshesFromUrlAsync(e, t) {
    let r = [], o = null;
    return this._scene && e && (o = this._scene.getMeshById(e)), this._sceneHelper && (r = await this._sceneHelper.importMeshesFromUrlAsync(t, o), this.checkSceneEmptyEnvironmentTexture(), this.setLongRenderingNeeded()), r;
  }
  //#endregion
  //#region 2D Design Rendering
  async connectMeshToModelSideAsync(e, t, r) {
    this._sceneDesignManager && this._sceneDesignManager.connectMeshToModelSideAsync(e, t, r);
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  getMeshDesignMananger(e, t) {
    var r;
    return this._sceneDesignManager && this.scene ? (r = this._sceneDesignManager) == null ? void 0 : r.getMeshDesignMananger(e, t) : null;
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, r, o) {
    this._sceneDesignManager && this._sceneDesignManager.translateDesignView(e, t, r, o);
  }
  rotateDesignView(e, t, r, o, a) {
    this._sceneDesignManager && this._sceneDesignManager.rotateDesignView(e, t, r, o, a);
  }
  scaleDesignView(e, t, r, o, a, u) {
    this._sceneDesignManager && this._sceneDesignManager.scaleDesignView(e, t, r, o, a, u);
  }
  async setDesignViewTextureUVChannelAsync(e, t, r) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewTextureUVChannelAsync(e, t, r);
  }
  async setDesignViewFormFactorAsync(e, t, r, o) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewFormFactorAsync(e, t, r, o);
  }
  //#endregion
  //#region Mesh measuring
  getCurrentARMeshUsedForMeasure() {
    var t;
    return (t = this.scene) == null ? void 0 : t.meshes.find((r) => r.metadata && r.metadata.sizecm);
  }
  getCurrentARSizeCm() {
    var t;
    const e = this.getCurrentARMeshUsedForMeasure();
    return (t = e == null ? void 0 : e.metadata) == null ? void 0 : t.sizecm;
  }
  setSceneSizeCm(e, t) {
    const r = this.getOrCreateSceneBoundingBox(!1);
    r && this.setMeshSizeCm(r.id, e, t);
  }
  getSceneWidthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.width ? e.metadata.sizecm.width : null;
  }
  getSceneHeightCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.height ? e.metadata.sizecm.height : null;
  }
  getSceneDepthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.depth ? e.metadata.sizecm.depth : null;
  }
  setMeshSizeCm(e, t, r) {
    const o = this.getMeshByID(e);
    if (o) {
      let a = null;
      t && typeof t == "number" && !isNaN(t) && (r === "width" ? a = { width: t } : r === "height" ? a = { height: t } : r === "depth" && (a = { depth: t })), o.metadata || (o.metadata = {}), o.metadata.sizecm = a;
    }
  }
  getMeshWidthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.width ? t.metadata.sizecm.width : null;
  }
  getMeshHeightCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.height ? t.metadata.sizecm.height : null;
  }
  getMeshDepthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.depth ? t.metadata.sizecm.depth : null;
  }
  //#endregion
  //#region Material Previews
  async getMaterialsPreviewsAsync(e, t, r, o, a = !0) {
    const u = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const v = await this.getSceneRootUrl();
      if (v) {
        const S = await lo.getPreviewsAsync(
          this._scene,
          v,
          e,
          { width: t, height: r },
          !0
        );
        for (var f in S.previewFiles)
          u.push(S.previewFiles[f]);
      }
    }
    return u;
  }
  async getAllMaterialsPreviewsAsync(e, t, r, o = !0) {
    const a = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const f = this._sceneHelper.getAllMaterials().map((v) => v.id);
      return this.getMaterialsPreviewsAsync(f, e, t, r, o);
    }
    return a;
  }
  async downloadMaterialsPreviewsAsync(e, t, r, o) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = await this.getSceneRootUrl();
      a && await lo.downloadPreviewsAsync(this._scene, a, e, {
        width: t,
        height: r,
        crop: o
      });
    }
  }
  async downloadAllMaterialsPreviewsAsync(e, t, r) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = this._sceneHelper.getAllMaterials().map((u) => u.id);
      await this.downloadMaterialsPreviewsAsync(a, e, t, r);
    }
  }
  //#endregion
  createEnvelopeMesh(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      if (t && t instanceof BABYLON.Mesh)
        return this._sceneHelper.createEnvelopeMesh(t);
    }
    return null;
  }
  expandMesh(e, t) {
    if (this._scene && this._sceneHelper) {
      const r = this._scene.getMeshByID(e);
      r && r instanceof BABYLON.Mesh && this._sceneHelper.expandMesh(r, t);
    }
  }
  enableDisableMeshFacetData(e, t) {
    if (this._scene && this._sceneHelper) {
      const r = this._scene.getMeshByID(e);
      r && (t ? r.updateFacetData() : r.disableFacetData());
    }
  }
  enableDisableDepthSortFacets(e, t) {
    if (this._scene && this._sceneHelper) {
      const r = this._scene.getMeshByID(e);
      r && (r.mustDepthSortFacets = t);
    }
  }
};
ag.EmptyGroupName = "_dummy_";
let Dw = ag;
var zw = /* @__PURE__ */ ((y) => (y[y.Box = 0] = "Box", y[y.RoundedBox = 1] = "RoundedBox", y[y.Sphere = 2] = "Sphere", y[y.Plane = 3] = "Plane", y[y.Cylinder = 4] = "Cylinder", y[y.RoundedCylinder = 5] = "RoundedCylinder", y[y.Torus = 6] = "Torus", y[y.Knot = 7] = "Knot", y[y.Ribbon = 8] = "Ribbon", y[y.Custom = 9] = "Custom", y))(zw || {});
class og extends Dw {
  constructor(e) {
    super(e), this._zkMaterial = null, this._material = null, this._meshType = 0, this._mesh = null, this._materialCreatedListeners = [], this._filesInput = null;
  }
  get zkMaterial() {
    return this._zkMaterial;
  }
  get material() {
    return this._material;
  }
  static async createMaterialEditorAsync(e) {
    e || (e = {
      authorizationToken: "",
      showGround: !1,
      editorBackgroundColor: "#33334c",
      showHighlight: !1,
      incrementalWorkersScriptsUrls: []
    });
    const t = new og(e);
    return await t.initAsync(), t;
  }
  deleteComponents() {
    super.deleteComponents(), this.deleteEditorMaterial(), this.deleteEditorMesh();
  }
  deleteEditorMaterial() {
    this._material && (this._material.dispose(), this._material = null, this.fireMaterialCreatedEvent());
  }
  deleteEditorMesh() {
    this._mesh && (this._mesh.dispose(), this._mesh = null), this._scene && this._sceneHelper && this._sceneHelper.getSceneMeshes().forEach((t) => t.dispose());
  }
  dispose() {
    super.dispose();
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this.createEditorMaterial(void 0, "Standard"), await this.createEditorMeshAsync();
  }
  createEditorMaterial(e, t, r) {
    let o = null;
    return t != "ShaderMaterial" ? o = super.createMaterial(e, t, r) : (o = this.createShaderMaterial(), o && (o.id = Zakeke.generateUUID(), this.checkSceneEmptyEnvironmentTexture())), this._material = o, this.setRenderingNeeded(), this.fireMaterialCreatedEvent(), o;
  }
  applyEditorMaterial() {
    this._material && this._mesh && this.applyMaterial(this._material, this._mesh);
  }
  async replaceSceneAsync(e) {
    var t = null, r = null;
    this._material && this._zkMaterial && (t = this._material.serialize(), r = this._zkMaterial.get("rootUrl")), this.deleteScene(), this._scene = e, await this.setupSceneAsync(), t && r ? (this._material = BABYLON.Material.Parse(t, this._scene, r), this.fireMaterialCreatedEvent()) : this.createEditorMaterial(void 0, "Standard"), this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  createShaderMaterial() {
    let e = null;
    if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
      const r = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
      var t = {
        vertex: this._zkMaterial.get("shaders").get("name"),
        fragment: this._zkMaterial.get("shaders").get("name")
      };
      const o = {
        attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
        uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
        samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
      };
      e = new BABYLON.ShaderMaterial(r, this._scene, t, o), this.setupShaderMaterialCameraPosition(e);
    }
    return e;
  }
  createEditorMaterialFromJson(e, t) {
    if (this._scene) {
      var r = JSON.parse(e);
      this._material = BABYLON.Material.Parse(r, this._scene, t), this._material && this.setupShaderMaterialCameraPosition(this._material), this.checkSceneEmptyEnvironmentTexture(), this.fireMaterialCreatedEvent();
    }
  }
  async createEditorMeshAsync() {
    switch (this.deleteEditorMesh(), this._meshType) {
      case 0:
        this._mesh = this.createBox(null, "box");
        break;
      case 1:
        {
          const e = await this.createRoundedCubeAsync(null, "rounded box");
          e.length == 1 ? this._mesh = e[0] : this._mesh = this.createGroup(null, "rounded box group", e);
        }
        break;
      case 2:
        this._mesh = this.createSphere(null, "sphere");
        break;
      case 3:
        this._mesh = this.createPlane(null, "plane");
        break;
      case 4:
        this._mesh = this.createCylinder(null, "cylinder");
        break;
      case 5:
        {
          const e = await this.createRoundedCylinderAsync(null, "rounded cylinder");
          e.length == 1 ? this._mesh = e[0] : (this._mesh = this.createGroup(null, "rounded cylinder group"), e.forEach((t) => t.parent = this._mesh));
        }
        break;
      case 6:
        this._mesh = this.createTorus(null, "torus");
        break;
      case 7:
        this._mesh = this.createKnot(null, "knot");
        break;
      case 8:
        this._mesh = this.createRibbon(null, "ribbon");
        break;
    }
    this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  async setEditorMeshType(e) {
    this._meshType = e, await this.createEditorMeshAsync();
  }
  async updateMaterialModelAsync() {
    if (this._zkMaterial && this._material && this._sceneHelper) {
      const t = await this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
      this._zkMaterial.set("imageData", t);
      const r = this._zkMaterial.get("name");
      r && r != this._material.name && (this._material.name = r);
      var e = this.getEditorMaterialJson();
      e && this._zkMaterial.set("JSON", e);
    }
  }
  getEditorMaterialJson() {
    if (this._scene && this._sceneHelper && this._material) {
      const r = this._sceneHelper;
      this._scene.textures.forEach((o) => {
        if (r.isTextureWithUrl(o) && o.url) {
          var a = o.url.lastIndexOf("/");
          if (a !== -1 && (a = o.url.lastIndexOf("/", a - 1), a !== -1 && (a = o.url.lastIndexOf("/", a - 1), a != -1))) {
            var u = o.url.substring(a + 1);
            o.name = u, o.url = o.name;
          }
        }
      });
      var e = this._material.serialize(), t = JSON.stringify(e);
      return t;
    }
    return null;
  }
  setMaterialModel(e, t) {
    if (this._zkMaterial = e, this.deleteEditorMaterial(), this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
      const a = this._zkMaterial.get("shaders");
      if (a) {
        const u = a.get("name"), f = a.get("vertex"), v = a.get("fragment");
        u && f && v && this.setupShadersStore({ name: u, vertex: f, fragment: v });
      }
      var r = this._zkMaterial.get("JSON"), o = this._zkMaterial.get("rootUrl");
      r && o ? this.createEditorMaterialFromJson(r, o) : this.createEditorMaterial(this._zkMaterial.get("name") || void 0, t), this._material && (this._material.id = this._zkMaterial.getMaterialID());
    } else
      this.createEditorMaterial(void 0, t);
    this.applyEditorMaterial(), this.adjustCamera(!1), this.setupShaderMaterialsCameraPosition();
  }
  getTexturesUploadUrl(e) {
    return this._zkMaterial ? this._zkMaterial.getTexturesUrl() : "";
  }
  loadEditorMaterialTextureFiles__(e, t, r, o) {
    this.loadTextureFiles(e, this._material, t, !1, r, o);
  }
  loadEditorMaterialTextureFiles(e, t, r, o) {
    if (!this._material)
      return;
    const a = (M) => {
      let X = M.lastIndexOf(".");
      if (X !== -1)
        return M.substring(X);
    }, u = (M, X) => {
      const Y = M.lastIndexOf(".");
      return Y !== -1 ? M.substring(0, Y).endsWith("_" + X) : !1;
    };
    if (!(!e || e.length == 0)) {
      var f = this.canLoadCubemap(this._material, t) && (e.length == 6 || a(e[0].name) == ".dds" || a(e[0].name) == ".hdr"), v = [];
      if (f && e.length == 6) {
        var S = ["px", "py", "pz", "nx", "ny", "nz"];
        for (let M = 0; M < e.length; M++) {
          const X = e[M];
          let Y = -1;
          for (var I = 0; I < S.length; I++)
            if (u(X.name, S[I])) {
              v.push(X), Y = I;
              break;
            }
          Y !== -1 && S.splice(Y, 1);
        }
        if (S.length != 0) {
          var D = "Immagini per la cube map non valide";
          o && o(D), Logger.info(D);
          return;
        }
      } else
        v.push(e[0]);
      var Z = new FormData();
      for (let M = 0; M < v.length; M++)
        Z.append("file-" + M, v[M]);
      jQuery.ajax({
        url: this.getTexturesUploadUrl(this._material.id),
        data: Z,
        cache: !1,
        contentType: !1,
        processData: !1,
        type: "POST",
        success: (M) => {
          Object.prototype.toString.call(M) === "[object Array]" && (f ? this.setEditorMaterialCubeTextureImages(M, t) : this.setEditorMaterialTextureImage(M[0], t)), r && r();
        },
        error: (M, X, Y) => {
          var ie = "An error occurred: " + X + "nError: " + Y;
          o && o(ie);
        }
      });
    }
  }
  setEditorMaterialTextureImage(e, t) {
    if (this._scene && this._zkMaterial && this._material && e && e.imageUrl && e.fileObjectID) {
      const r = new Zakeke.MaterialTextureImage();
      r.set("textureImageID", Zakeke.generateUUID()), r.set("fileObjectID", e.fileObjectID), r.set("imageUrl", e.imageUrl), this._zkMaterial.get("textureImages").push(r);
      const o = e.imageUrl, a = new BABYLON.Texture(o, this._scene), u = this.getMaterialTexture(this._material, t);
      u && u instanceof BABYLON.Texture && (a.uScale = u.uScale, a.vScale = u.vScale, a.uOffset = u.uOffset, a.vOffset = u.vOffset, a.uAng = u.uAng, a.vAng = u.vAng, a.level = u.level, a.coordinatesIndex = u.coordinatesIndex, a.coordinatesMode = u.coordinatesMode, a.hasAlpha = u.hasAlpha, a.wrapU = u.wrapU, a.wrapV = u.wrapV), this.applyTexture(a, this._material, t), u && !this.isTextureUsed(u) && u.dispose();
    }
  }
  setEditorMaterialCubeTextureImages(e, t) {
    if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(e) != "[object Array]")
      return;
    let r = null;
    const o = () => this.setRenderingNeeded();
    if (e.length == 1) {
      let v = e[0];
      if (v.imageUrl && v.fileObjectID) {
        v.imageUrl.endsWith(".dds") ? r = BABYLON.CubeTexture.CreateFromPrefilteredData(v.imageUrl, this._scene) : v.imageUrl.endsWith(".hdr") && (r = new BABYLON.HDRCubeTexture(
          v.imageUrl,
          this._scene,
          512,
          void 0,
          void 0,
          void 0,
          void 0,
          o
        ));
        var a = new Zakeke.MaterialTextureImage();
        a.set("textureImageID", Zakeke.generateUUID()), a.set("fileObjectID", v.fileObjectID), a.set("imageUrl", v.imageUrl), this._zkMaterial.get("textureImages").push(a);
      }
    } else if (e.length == 6) {
      const v = ["px", "py", "pz", "nx", "ny", "nz"];
      let S = "";
      const I = [], D = [], Z = (Y, ie) => {
        var G = Y.lastIndexOf(".");
        if (G !== -1) {
          var te = Y.substring(0, G);
          return te.endsWith("_" + ie);
        }
        return !1;
      }, M = (Y, ie) => {
        const G = Y.lastIndexOf(".");
        if (G !== -1) {
          var te = Y.substring(0, G);
          if (te.endsWith("_" + ie))
            return te.substring(0, te.length - ("_" + ie).length);
        }
        return null;
      }, X = (Y, ie) => {
        const G = Y.lastIndexOf("_" + ie);
        return G !== -1 ? Y.substr(G) : null;
      };
      for (let Y = 0; Y < v.length; Y++) {
        var u = v[Y];
        for (let ie = 0; ie < e.length; ie++) {
          const te = e[ie].imageUrl;
          if (te && Z(te, u)) {
            I.push(te), D.push(X(te, u) ?? ""), S || (S = M(te, u) ?? "");
            break;
          }
        }
      }
      for (let Y = 0; Y < e.length; Y++) {
        const ie = e[Y];
        if (ie.imageUrl && ie.fileObjectID != null) {
          const G = ie.imageUrl, te = ie.fileObjectID, J = new Zakeke.MaterialTextureImage();
          J.set("textureImageID", Zakeke.generateUUID()), J.set("fileObjectID", te), J.set("imageUrl", G), this._zkMaterial.get("textureImages").push(J);
        }
      }
      r = new BABYLON.CubeTexture(S, this._scene, D, !1, I);
    }
    if (r) {
      var f = this.getMaterialTexture(this._material, t);
      this.applyTexture(r, this._material, t), f && !this.isTextureUsed(f) && f.dispose();
    }
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireMaterialCreatedEvent() {
    for (let e = 0; e < this._materialCreatedListeners.length; ++e)
      this._materialCreatedListeners[e]();
  }
  addMaterialCreatedListener(e) {
    this._materialCreatedListeners.push(e);
  }
  //#region Load Custom Mesh
  loadFiles(e, t, r) {
    if (!this._engine || !this._scene || !this._sceneHelper)
      return;
    const o = this._engine, a = this._scene, u = this._sceneHelper;
    this._filesInput || (this._filesInput = new BABYLON.FilesInput(
      o,
      a,
      async (f, v) => {
        await this.replaceSceneAsync(v);
        const S = u.getSceneMeshes();
        this._meshType = 9, this._mesh = this.createGroup(null, "group", S), this.applyEditorMaterial(), t && t();
      },
      null,
      //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
      null,
      //() => { },  // additionalRenderLoopLogicCallback
      null,
      //(remaining: number) => { }, // textureLoadingCallback
      null,
      //(files?: File[]) => { },  // startingProcessingFilesCallback
      null,
      //(sceneFile: File) => { }, // onReloadCallback
      (f, v, S) => {
        r && r(S);
      }
    )), this._filesInput && this._filesInput.loadFiles(e);
  }
  //#endregion
}
const Fw = "https://3dviewer-img.futurefashionsolution.com/_common/envMap/default.env", n1 = {
  general: {
    backgroundAlpha: 1,
    backgroundColor: "#ffffff",
    removeDefaultBackground: !0,
    environmentTexture: Fw,
    matchSameNameTextures: null,
    antialiasEnabled: null,
    tryOnEnabled: null,
    tryOnSettings: null,
    arEnabled: !0,
    arOnTheFly: !1,
    arAnchor: null,
    arScale: null,
    meshSize: {
      height: null,
      width: null,
      depth: null
    },
    antialias: {
      desktop: {
        enabled: !0,
        inRotationEnabled: !0
      }
    },
    frameDAMSettings: null,
    useDelayedTextureLoading: null,
    useDelayedMaterialLoading: null,
    useMaterialOffloading: null,
    prefetchMeshes: null,
    prefetchMaterials: null,
    exposure: 1,
    contrast: 1,
    preventDefaultLights: !0,
    forceDracoCompression: null,
    fitToScreenMargin: 1,
    environmentOptions: {
      mipMaps: !1,
      generateHarmonics: !1,
      gammaSpace: !0,
      prefilterOnLoad: !0,
      rotationY: 1.57,
      intensity: 1,
      // environment intensity
      pbrIntensity: 1
      // pbr intensity
    }
  },
  environment: {
    sizeAuto: null,
    mainColor: "#CB0E00",
    backgroundColor: "#5CA0B5",
    skybox: {
      createSkybox: !1,
      size: null,
      texture: null,
      extensions: null,
      files: null,
      color: null,
      blur: 0
    },
    ground: {
      createGround: !1,
      size: null,
      texture: null,
      color: null,
      opacity: null,
      enableShadow: !1,
      shadowLevel: null,
      enableMirror: !0,
      mirrorBlurKernel: null
    },
    shadows: {
      enableShadows: !1,
      groundSizeMultiplierWidth: 1.2,
      groundSizeMultiplierLength: 1.5,
      shadowMapSize: 51,
      shadowHexColor: "#454545",
      contactHardeningUVRatio: 0.4,
      useContactHardeningShadow: !0,
      useBlurCloseExponentialShadowMap: !1,
      usePercentageCloserFiltering: !1,
      useKernelBlur: !0,
      usePoissonSampling: !1,
      blurBoxOffset: 10,
      blurScale: 4,
      blurKernel: 10,
      depthScale: 1,
      shadowDarkness: 0.3
    }
  },
  camera: {
    autoRotate: !1,
    rotationSpeed: 0.2,
    changeRotationDirection: !1,
    contrast: 1.6,
    exposure: 0.8,
    toneMappingEnabled: !1,
    toneMappingType: 0,
    setInitialZoomToBoundingBox: !0,
    initialZoomToBBInertiaDamping: 0.9,
    initialZoomToBBModelSizeRadius: 0.7,
    initialZoomToBBScrollZoomEnabled: !0,
    initialZoomToBBScrollLowerLimit: 2,
    initialZoomToBBScrollUpperLimit: 2,
    positionScale: null,
    limitLowerRadius: !0,
    zoomEnabled: null,
    useMinZoomPerc: !0,
    minZoomPerc: 0.5,
    useMaxZoomPerc: !0,
    maxZoomPerc: 1.5,
    lowerAlphaLimit: null,
    upperAlphaLimit: null,
    fixedAlphaAngle: null,
    fixedBetaAngle: null,
    useLowerAlphaLimit: null,
    lowerBetaLimit: 0,
    upperBetaLimit: 3,
    useLowerBetaLimit: null,
    useUpperAlphaLimit: null,
    useUpperBetaLimit: null,
    zoom: 0,
    position: {
      alpha: 1.57,
      beta: 1.55,
      fov: 0.4
    },
    animateIntro: !1
  },
  model: {
    rotation: {
      x: 0,
      y: 0,
      z: 0
    },
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    scale: {
      x: 1,
      y: 1,
      z: 1
    },
    config: {
      doubleSided: !1
    }
  },
  glow: null,
  infoPoints: null,
  uiConfig: {
    urlARIcon: "",
    urlLoader: ""
  },
  lights: {
    directionalLightBack: {
      position: {
        x: -1,
        y: 0,
        z: -1
      },
      general: {
        intensity: 3,
        visible: !0
      }
    },
    directionalLightLeft: {
      position: {
        x: 0,
        y: 0,
        z: 1
      },
      general: {
        intensity: 1.2,
        visible: !0
      }
    },
    pointLightBack: {
      position: {
        x: 1,
        y: 0.5,
        z: 0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    pointLightFront: {
      position: {
        x: -1,
        y: 0.5,
        z: -0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    hemisphereLight: {
      position: {
        x: 0,
        y: 30.76964,
        z: 0
      },
      general: {
        intensity: 0.5,
        visible: !1
      }
    }
  },
  textures: null,
  animations: {
    runAtStart: !0,
    loop: !0,
    speed: 1
  }
};



/***/ }),

/***/ "./node_modules/axios/lib/adapters/adapters.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/adapters/adapters.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _http_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./http.js */ "./node_modules/axios/lib/helpers/null.js");
/* harmony import */ var _xhr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./xhr.js */ "./node_modules/axios/lib/adapters/xhr.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");





const knownAdapters = {
  http: _http_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  xhr: _xhr_js__WEBPACK_IMPORTED_MODULE_1__["default"]
}

_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  getAdapter: (adapters) => {
    adapters = _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"](
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});


/***/ }),

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/adapters/xhr.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_settle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../core/settle.js */ "./node_modules/axios/lib/core/settle.js");
/* harmony import */ var _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./../helpers/cookies.js */ "./node_modules/axios/lib/helpers/cookies.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../helpers/isURLSameOrigin.js */ "./node_modules/axios/lib/helpers/isURLSameOrigin.js");
/* harmony import */ var _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../defaults/transitional.js */ "./node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helpers/parseProtocol.js */ "./node_modules/axios/lib/helpers/parseProtocol.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/speedometer.js */ "./node_modules/axios/lib/helpers/speedometer.js");
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = (0,_helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__["default"])(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFormData(requestData) && (_platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserEnv || _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserWebWorkerEnv)) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = (0,_core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__["default"])(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__["default"])(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      (0,_core_settle_js__WEBPACK_IMPORTED_MODULE_6__["default"])(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Request aborted', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Network Error', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__["default"];
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"](
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ETIMEDOUT : _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (_platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || (0,_helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(fullPath))
        && config.xsrfCookieName && _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__["default"].read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__["default"](null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = (0,_helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__["default"])(fullPath);

    if (protocol && _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].protocols.indexOf(protocol) === -1) {
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Unsupported protocol ' + protocol + ':', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});


/***/ }),

/***/ "./node_modules/axios/lib/axios.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/axios.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js");
/* harmony import */ var _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/Axios.js */ "./node_modules/axios/lib/core/Axios.js");
/* harmony import */ var _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cancel/CancelToken.js */ "./node_modules/axios/lib/cancel/CancelToken.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./env/data.js */ "./node_modules/axios/lib/env/data.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./helpers/spread.js */ "./node_modules/axios/lib/helpers/spread.js");
/* harmony import */ var _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./helpers/isAxiosError.js */ "./node_modules/axios/lib/helpers/isAxiosError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./helpers/HttpStatusCode.js */ "./node_modules/axios/lib/helpers/HttpStatusCode.js");



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"](defaultConfig);
  const instance = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.request, context);

  // Copy axios.prototype to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype, context, {allOwnKeys: true});

  // Copy context to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance((0,_core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"])(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(_defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"]);

// Expose Axios class to allow class inheritance
axios.Axios = _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"];

// Expose Cancel & CancelToken
axios.CanceledError = _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__["default"];
axios.CancelToken = _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__["default"];
axios.isCancel = _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__["default"];
axios.VERSION = _env_data_js__WEBPACK_IMPORTED_MODULE_8__.VERSION;
axios.toFormData = _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__["default"];

// Expose AxiosError class
axios.AxiosError = _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__["default"];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__["default"];

// Expose isAxiosError
axios.isAxiosError = _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__["default"];

// Expose mergeConfig
axios.mergeConfig = _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"];

axios.AxiosHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__["default"];

axios.formToJSON = thing => (0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__["default"])(_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_15__["default"];

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (axios);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CancelToken);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CanceledError.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CanceledError.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, message == null ? 'canceled' : message, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].inherits(CanceledError, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"], {
  __CANCEL__: true
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CanceledError);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isCancel)
/* harmony export */ });


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}


/***/ }),

/***/ "./node_modules/axios/lib/core/Axios.js":
/*!**********************************************!*\
  !*** ./node_modules/axios/lib/core/Axios.js ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InterceptorManager.js */ "./node_modules/axios/lib/core/InterceptorManager.js");
/* harmony import */ var _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dispatchRequest.js */ "./node_modules/axios/lib/core/dispatchRequest.js");
/* harmony import */ var _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/validator.js */ "./node_modules/axios/lib/helpers/validator.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");











const validators = _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
      response: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"]()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__["default"].concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [_dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);
    const fullPath = (0,_buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__["default"])(config.baseURL, config.url);
    return (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__["default"])(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Axios);


/***/ }),

/***/ "./node_modules/axios/lib/core/AxiosError.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosError.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);

  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosError);


/***/ }),

/***/ "./node_modules/axios/lib/core/AxiosHeaders.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosHeaders.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/parseHeaders.js */ "./node_modules/axios/lib/helpers/parseHeaders.js");





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(value)) return;

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders((0,_helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"])(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders.prototype);
_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosHeaders);


/***/ }),

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InterceptorManager);


/***/ }),

/***/ "./node_modules/axios/lib/core/buildFullPath.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/buildFullPath.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildFullPath)
/* harmony export */ });
/* harmony import */ var _helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/isAbsoluteURL.js */ "./node_modules/axios/lib/helpers/isAbsoluteURL.js");
/* harmony import */ var _helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/combineURLs.js */ "./node_modules/axios/lib/helpers/combineURLs.js");





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !(0,_helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__["default"])(requestedURL)) {
    return (0,_helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__["default"])(baseURL, requestedURL);
  }
  return requestedURL;
}


/***/ }),

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ dispatchRequest)
/* harmony export */ });
/* harmony import */ var _transformData_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transformData.js */ "./node_modules/axios/lib/core/transformData.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../adapters/adapters.js */ "./node_modules/axios/lib/adapters/adapters.js");









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers);

  // Transform request data
  config.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__["default"].getAdapter(config.adapter || _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"].adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
      config,
      config.transformResponse,
      response
    );

    response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!(0,_cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__["default"])(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}


/***/ }),

/***/ "./node_modules/axios/lib/core/mergeConfig.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/mergeConfig.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ mergeConfig)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");





const headersToObject = (thing) => thing instanceof _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(target) && _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge.call({caseless}, target, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({}, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}


/***/ }),

/***/ "./node_modules/axios/lib/core/settle.js":
/*!***********************************************!*\
  !*** ./node_modules/axios/lib/core/settle.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ settle)
/* harmony export */ });
/* harmony import */ var _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"](
      'Request failed with status code ' + response.status,
      [_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_REQUEST, _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}


/***/ }),

/***/ "./node_modules/axios/lib/core/transformData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/transformData.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ transformData)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__["default"];
  const context = response || config;
  const headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(context.headers);
  let data = context.data;

  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}


/***/ }),

/***/ "./node_modules/axios/lib/defaults/index.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/defaults/index.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _transitional_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transitional.js */ "./node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers/toURLEncodedForm.js */ "./node_modules/axios/lib/helpers/toURLEncodedForm.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js");










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: _transitional_js__WEBPACK_IMPORTED_MODULE_1__["default"],

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(data);

    if (isObjectPayload && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify((0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__["default"])(data)) : data;
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStream(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFile(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(data)
    ) {
      return data;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return (0,_helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__["default"])(data, this.formSerializer).toString();
      }

      if ((isFileList = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return (0,_helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(e, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.FormData,
    Blob: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (defaults);


/***/ }),

/***/ "./node_modules/axios/lib/defaults/transitional.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/defaults/transitional.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});


/***/ }),

/***/ "./node_modules/axios/lib/env/data.js":
/*!********************************************!*\
  !*** ./node_modules/axios/lib/env/data.js ***!
  \********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   VERSION: () => (/* binding */ VERSION)
/* harmony export */ });
const VERSION = "1.3.6";

/***/ }),

/***/ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js":
/*!****************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js ***!
  \****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosURLSearchParams);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/HttpStatusCode.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/HttpStatusCode.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HttpStatusCode);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/bind.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/bind.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ bind)
/* harmony export */ });


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildURL)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js");





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(params) ?
      params.toString() :
      new _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__["default"](params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ combineURLs)
/* harmony export */ });


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/helpers/cookies.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(path)) {
          cookie.push('path=' + path);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());


/***/ }),

/***/ "./node_modules/axios/lib/helpers/formDataToJSON.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/formDataToJSON.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target) ? target.length : name;

    if (isLast) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(formData) && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(formData.entries)) {
    const obj = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formDataToJSON);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAbsoluteURL)
/* harmony export */ });


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAxiosError.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAxiosError.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAxiosError)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(payload) && (payload.isAxiosError === true);
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());


/***/ }),

/***/ "./node_modules/axios/lib/helpers/null.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/null.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// eslint-disable-next-line strict
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (null);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseProtocol.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseProtocol.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ parseProtocol)
/* harmony export */ });


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/speedometer.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/speedometer.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (speedometer);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/spread.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/helpers/spread.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ spread)
/* harmony export */ });


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/toFormData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toFormData.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/node/classes/FormData.js */ "./node_modules/axios/lib/helpers/null.js");




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(thing) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(arr) && !arr.some(isVisitable);
}

const predicates = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"], {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (_platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isSpecCompliantForm(formData);

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(value)) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"]('Blob is not supported. Use a Buffer instead.');
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) && isFlatArray(value)) ||
        ((_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]')) && (arr = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(value, function each(el, key) {
      const result = !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && visitor.call(
        formData, el, _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (toFormData);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/toURLEncodedForm.js":
/*!************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toURLEncodedForm.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toURLEncodedForm)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");






function toURLEncodedForm(data, options) {
  return (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(data, new _platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (_platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNode && _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/validator.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/validator.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../env/data.js */ "./node_modules/axios/lib/env/data.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + _env_data_js__WEBPACK_IMPORTED_MODULE_0__.VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"](
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('options must be an object', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('option ' + opt + ' must be ' + result, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('Unknown option ' + opt, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  assertOptions,
  validators
});


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/Blob.js":
/*!*****************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/Blob.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof Blob !== 'undefined' ? Blob : null);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/FormData.js":
/*!*********************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/FormData.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof FormData !== 'undefined' ? FormData : null);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js":
/*!****************************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/index.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes/URLSearchParams.js */ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js");
/* harmony import */ var _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./classes/FormData.js */ "./node_modules/axios/lib/platform/browser/classes/FormData.js");
/* harmony import */ var _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./classes/Blob.js */ "./node_modules/axios/lib/platform/browser/classes/Blob.js");




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isBrowser: true,
  classes: {
    URLSearchParams: _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"],
    FormData: _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"],
    Blob: _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__["default"]
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});


/***/ }),

/***/ "./node_modules/axios/lib/utils.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/utils.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js");




// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__["default"])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject
});


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/actualApply.js":
/*!*************************************************************!*\
  !*** ./node_modules/call-bind-apply-helpers/actualApply.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");

var $apply = __webpack_require__(/*! ./functionApply */ "./node_modules/call-bind-apply-helpers/functionApply.js");
var $call = __webpack_require__(/*! ./functionCall */ "./node_modules/call-bind-apply-helpers/functionCall.js");
var $reflectApply = __webpack_require__(/*! ./reflectApply */ "./node_modules/call-bind-apply-helpers/reflectApply.js");

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/applyBind.js":
/*!***********************************************************!*\
  !*** ./node_modules/call-bind-apply-helpers/applyBind.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var $apply = __webpack_require__(/*! ./functionApply */ "./node_modules/call-bind-apply-helpers/functionApply.js");
var actualApply = __webpack_require__(/*! ./actualApply */ "./node_modules/call-bind-apply-helpers/actualApply.js");

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/functionApply.js":
/*!***************************************************************!*\
  !*** ./node_modules/call-bind-apply-helpers/functionApply.js ***!
  \***************************************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/functionCall.js":
/*!**************************************************************!*\
  !*** ./node_modules/call-bind-apply-helpers/functionCall.js ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/index.js":
/*!*******************************************************!*\
  !*** ./node_modules/call-bind-apply-helpers/index.js ***!
  \*******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var $TypeError = __webpack_require__(/*! es-errors/type */ "./node_modules/es-errors/type.js");

var $call = __webpack_require__(/*! ./functionCall */ "./node_modules/call-bind-apply-helpers/functionCall.js");
var $actualApply = __webpack_require__(/*! ./actualApply */ "./node_modules/call-bind-apply-helpers/actualApply.js");

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ "./node_modules/call-bind-apply-helpers/reflectApply.js":
/*!**************************************************************!*\
  !*** ./node_modules/call-bind-apply-helpers/reflectApply.js ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ "./node_modules/call-bind/callBound.js":
/*!*********************************************!*\
  !*** ./node_modules/call-bind/callBound.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");

var callBind = __webpack_require__(/*! ./ */ "./node_modules/call-bind/index.js");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ "./node_modules/call-bind/index.js":
/*!*****************************************!*\
  !*** ./node_modules/call-bind/index.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var setFunctionLength = __webpack_require__(/*! set-function-length */ "./node_modules/set-function-length/index.js");

var $defineProperty = __webpack_require__(/*! es-define-property */ "./node_modules/es-define-property/index.js");

var callBindBasic = __webpack_require__(/*! call-bind-apply-helpers */ "./node_modules/call-bind-apply-helpers/index.js");
var applyBind = __webpack_require__(/*! call-bind-apply-helpers/applyBind */ "./node_modules/call-bind-apply-helpers/applyBind.js");

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		1 + (adjustedLength > 0 ? adjustedLength : 0),
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ "./node_modules/define-data-property/index.js":
/*!****************************************************!*\
  !*** ./node_modules/define-data-property/index.js ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(/*! es-define-property */ "./node_modules/es-define-property/index.js");

var $SyntaxError = __webpack_require__(/*! es-errors/syntax */ "./node_modules/es-errors/syntax.js");
var $TypeError = __webpack_require__(/*! es-errors/type */ "./node_modules/es-errors/type.js");

var gopd = __webpack_require__(/*! gopd */ "./node_modules/gopd/index.js");

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ "./node_modules/dunder-proto/get.js":
/*!******************************************!*\
  !*** ./node_modules/dunder-proto/get.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var callBind = __webpack_require__(/*! call-bind-apply-helpers */ "./node_modules/call-bind-apply-helpers/index.js");
var gOPD = __webpack_require__(/*! gopd */ "./node_modules/gopd/index.js");

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ "./node_modules/es-define-property/index.js":
/*!**************************************************!*\
  !*** ./node_modules/es-define-property/index.js ***!
  \**************************************************/
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ "./node_modules/es-errors/eval.js":
/*!****************************************!*\
  !*** ./node_modules/es-errors/eval.js ***!
  \****************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ "./node_modules/es-errors/index.js":
/*!*****************************************!*\
  !*** ./node_modules/es-errors/index.js ***!
  \*****************************************/
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ "./node_modules/es-errors/range.js":
/*!*****************************************!*\
  !*** ./node_modules/es-errors/range.js ***!
  \*****************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ "./node_modules/es-errors/ref.js":
/*!***************************************!*\
  !*** ./node_modules/es-errors/ref.js ***!
  \***************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ "./node_modules/es-errors/syntax.js":
/*!******************************************!*\
  !*** ./node_modules/es-errors/syntax.js ***!
  \******************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ "./node_modules/es-errors/type.js":
/*!****************************************!*\
  !*** ./node_modules/es-errors/type.js ***!
  \****************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ "./node_modules/es-errors/uri.js":
/*!***************************************!*\
  !*** ./node_modules/es-errors/uri.js ***!
  \***************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ "./node_modules/es-object-atoms/index.js":
/*!***********************************************!*\
  !*** ./node_modules/es-object-atoms/index.js ***!
  \***********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ "./node_modules/function-bind/implementation.js":
/*!******************************************************!*\
  !*** ./node_modules/function-bind/implementation.js ***!
  \******************************************************/
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "./node_modules/function-bind/index.js":
/*!*********************************************!*\
  !*** ./node_modules/function-bind/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(/*! ./implementation */ "./node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "./node_modules/get-intrinsic/index.js":
/*!*********************************************!*\
  !*** ./node_modules/get-intrinsic/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $Object = __webpack_require__(/*! es-object-atoms */ "./node_modules/es-object-atoms/index.js");

var $Error = __webpack_require__(/*! es-errors */ "./node_modules/es-errors/index.js");
var $EvalError = __webpack_require__(/*! es-errors/eval */ "./node_modules/es-errors/eval.js");
var $RangeError = __webpack_require__(/*! es-errors/range */ "./node_modules/es-errors/range.js");
var $ReferenceError = __webpack_require__(/*! es-errors/ref */ "./node_modules/es-errors/ref.js");
var $SyntaxError = __webpack_require__(/*! es-errors/syntax */ "./node_modules/es-errors/syntax.js");
var $TypeError = __webpack_require__(/*! es-errors/type */ "./node_modules/es-errors/type.js");
var $URIError = __webpack_require__(/*! es-errors/uri */ "./node_modules/es-errors/uri.js");

var abs = __webpack_require__(/*! math-intrinsics/abs */ "./node_modules/math-intrinsics/abs.js");
var floor = __webpack_require__(/*! math-intrinsics/floor */ "./node_modules/math-intrinsics/floor.js");
var max = __webpack_require__(/*! math-intrinsics/max */ "./node_modules/math-intrinsics/max.js");
var min = __webpack_require__(/*! math-intrinsics/min */ "./node_modules/math-intrinsics/min.js");
var pow = __webpack_require__(/*! math-intrinsics/pow */ "./node_modules/math-intrinsics/pow.js");
var round = __webpack_require__(/*! math-intrinsics/round */ "./node_modules/math-intrinsics/round.js");
var sign = __webpack_require__(/*! math-intrinsics/sign */ "./node_modules/math-intrinsics/sign.js");

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(/*! gopd */ "./node_modules/gopd/index.js");
var $defineProperty = __webpack_require__(/*! es-define-property */ "./node_modules/es-define-property/index.js");

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(/*! has-symbols */ "./node_modules/has-symbols/index.js")();

var getProto = __webpack_require__(/*! get-proto */ "./node_modules/get-proto/index.js");
var $ObjectGPO = __webpack_require__(/*! get-proto/Object.getPrototypeOf */ "./node_modules/get-proto/Object.getPrototypeOf.js");
var $ReflectGPO = __webpack_require__(/*! get-proto/Reflect.getPrototypeOf */ "./node_modules/get-proto/Reflect.getPrototypeOf.js");

var $apply = __webpack_require__(/*! call-bind-apply-helpers/functionApply */ "./node_modules/call-bind-apply-helpers/functionApply.js");
var $call = __webpack_require__(/*! call-bind-apply-helpers/functionCall */ "./node_modules/call-bind-apply-helpers/functionCall.js");

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var hasOwn = __webpack_require__(/*! hasown */ "./node_modules/hasown/index.js");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "./node_modules/get-proto/Object.getPrototypeOf.js":
/*!*********************************************************!*\
  !*** ./node_modules/get-proto/Object.getPrototypeOf.js ***!
  \*********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $Object = __webpack_require__(/*! es-object-atoms */ "./node_modules/es-object-atoms/index.js");

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ "./node_modules/get-proto/Reflect.getPrototypeOf.js":
/*!**********************************************************!*\
  !*** ./node_modules/get-proto/Reflect.getPrototypeOf.js ***!
  \**********************************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ "./node_modules/get-proto/index.js":
/*!*****************************************!*\
  !*** ./node_modules/get-proto/index.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var reflectGetProto = __webpack_require__(/*! ./Reflect.getPrototypeOf */ "./node_modules/get-proto/Reflect.getPrototypeOf.js");
var originalGetProto = __webpack_require__(/*! ./Object.getPrototypeOf */ "./node_modules/get-proto/Object.getPrototypeOf.js");

var getDunderProto = __webpack_require__(/*! dunder-proto/get */ "./node_modules/dunder-proto/get.js");

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ "./node_modules/gopd/gOPD.js":
/*!***********************************!*\
  !*** ./node_modules/gopd/gOPD.js ***!
  \***********************************/
/***/ ((module) => {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ "./node_modules/gopd/index.js":
/*!************************************!*\
  !*** ./node_modules/gopd/index.js ***!
  \************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(/*! ./gOPD */ "./node_modules/gopd/gOPD.js");

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ "./node_modules/has-property-descriptors/index.js":
/*!********************************************************!*\
  !*** ./node_modules/has-property-descriptors/index.js ***!
  \********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $defineProperty = __webpack_require__(/*! es-define-property */ "./node_modules/es-define-property/index.js");

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ "./node_modules/has-symbols/index.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/index.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(/*! ./shams */ "./node_modules/has-symbols/shams.js");

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "./node_modules/has-symbols/shams.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/shams.js ***!
  \*******************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "./node_modules/hasown/index.js":
/*!**************************************!*\
  !*** ./node_modules/hasown/index.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ "./node_modules/lodash/lodash.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/lodash.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "./node_modules/math-intrinsics/abs.js":
/*!*********************************************!*\
  !*** ./node_modules/math-intrinsics/abs.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ "./node_modules/math-intrinsics/floor.js":
/*!***********************************************!*\
  !*** ./node_modules/math-intrinsics/floor.js ***!
  \***********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ "./node_modules/math-intrinsics/isNaN.js":
/*!***********************************************!*\
  !*** ./node_modules/math-intrinsics/isNaN.js ***!
  \***********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ "./node_modules/math-intrinsics/max.js":
/*!*********************************************!*\
  !*** ./node_modules/math-intrinsics/max.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ "./node_modules/math-intrinsics/min.js":
/*!*********************************************!*\
  !*** ./node_modules/math-intrinsics/min.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ "./node_modules/math-intrinsics/pow.js":
/*!*********************************************!*\
  !*** ./node_modules/math-intrinsics/pow.js ***!
  \*********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ "./node_modules/math-intrinsics/round.js":
/*!***********************************************!*\
  !*** ./node_modules/math-intrinsics/round.js ***!
  \***********************************************/
/***/ ((module) => {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ "./node_modules/math-intrinsics/sign.js":
/*!**********************************************!*\
  !*** ./node_modules/math-intrinsics/sign.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var $isNaN = __webpack_require__(/*! ./isNaN */ "./node_modules/math-intrinsics/isNaN.js");

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ "./node_modules/object-inspect/index.js":
/*!**********************************************!*\
  !*** ./node_modules/object-inspect/index.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(/*! ./util.inspect */ "?4f7e");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ "./node_modules/qs/lib/formats.js":
/*!****************************************!*\
  !*** ./node_modules/qs/lib/formats.js ***!
  \****************************************/
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ "./node_modules/qs/lib/index.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/index.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(/*! ./stringify */ "./node_modules/qs/lib/stringify.js");
var parse = __webpack_require__(/*! ./parse */ "./node_modules/qs/lib/parse.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "./node_modules/qs/lib/parse.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/parse.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "./node_modules/qs/lib/stringify.js":
/*!******************************************!*\
  !*** ./node_modules/qs/lib/stringify.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(/*! side-channel */ "./node_modules/side-channel/index.js");
var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "./node_modules/qs/lib/utils.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/utils.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ "./node_modules/set-function-length/index.js":
/*!***************************************************!*\
  !*** ./node_modules/set-function-length/index.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var define = __webpack_require__(/*! define-data-property */ "./node_modules/define-data-property/index.js");
var hasDescriptors = __webpack_require__(/*! has-property-descriptors */ "./node_modules/has-property-descriptors/index.js")();
var gOPD = __webpack_require__(/*! gopd */ "./node_modules/gopd/index.js");

var $TypeError = __webpack_require__(/*! es-errors/type */ "./node_modules/es-errors/type.js");
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ "./node_modules/side-channel/index.js":
/*!********************************************!*\
  !*** ./node_modules/side-channel/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__(/*! call-bind/callBound */ "./node_modules/call-bind/callBound.js");
var inspect = __webpack_require__(/*! object-inspect */ "./node_modules/object-inspect/index.js");

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ "./src/api.ts":
/*!********************!*\
  !*** ./src/api.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   axiosApi: () => (/* binding */ axiosApi),
/* harmony export */   setupApi: () => (/* binding */ setupApi)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");



var axiosApi;
function setupApi(culture, token) {
  console.log(Zakeke.config);
  axiosApi = axios__WEBPACK_IMPORTED_MODULE_2__["default"].create({
    baseURL: Zakeke.config.cloudFlareApiUrl || Zakeke.config.baseApiUrl,
    timeout: 120000,
    withCredentials: true,
    headers: {
      Authorization: 'Bearer ' + token,
      'Accept-Language': culture
    }
  });
  $.ajaxSetup({
    xhrFields: {
      withCredentials: true
    },
    headers: {
      Authorization: 'Bearer ' + token,
      'Accept-Language': culture
    }
  });
  axiosApi.interceptors.response.use(function (response) {
    // Convert all to camelCase
    if (response.data && (lodash__WEBPACK_IMPORTED_MODULE_0___default().isObject(response.data) || lodash__WEBPACK_IMPORTED_MODULE_0___default().isArray(response.data))) response.data = _helpers__WEBPACK_IMPORTED_MODULE_1__.StringHelper.pascalToCamel(response.data);
    return response;
  }, function (error) {
    // Convert all to camelCase
    if (error.response && error.response.data) {
      error.response.data = _helpers__WEBPACK_IMPORTED_MODULE_1__.StringHelper.pascalToCamel(error.response.data);
    }
    return Promise.reject(error);
  });
}

/***/ }),

/***/ "./src/components/customizer.tsx":
/*!***************************************!*\
  !*** ./src/components/customizer.tsx ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZakekeDesigner: () => (/* binding */ ZakekeDesigner)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }






var ZakekeDesignerContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toutline: none !important;\n\n\tcanvas {\n\t\toutline: none !important;\n\t}\n"])));
// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
var ZakekeDesigner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useZakeke = (0,_hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)(),
    designUpdate = _useZakeke.designUpdate;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    guid = _React$useState2[0];
  var customizer = stateRef.current.state.customizer;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var container = document.getElementById('zakeke-designer-container-' + guid);
    var newCustomizer = new MPlaza.Customizer(false, false, null, true);
    newCustomizer.showSideImage = false;
    newCustomizer.addItemChangedListener(handleItemChanged);
    newCustomizer.addItemRemovedListener(handleItemRemoved);

    // Hide DPI warnings
    newCustomizer.setCustomizedMessages([{
      Description: '',
      EventID: MPlaza.EventMessages.DPIWarning,
      Visible: false
    }]);
    newCustomizer.appendTo(container);
    internalState.dispatch({
      type: 'CUSTOMIZER',
      customizer: newCustomizer
    });
    return function () {
      internalState.dispatch({
        type: 'CUSTOMIZER',
        customizer: null
      });
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (store.internalProduct) {
      var side = store.internalProduct.get('colors').at(0).get('sides').find(function (x) {
        return x.get('sideID') == props.areaId;
      });
      if (side && customizer && store.internalCurrentTemplate) {
        customizer.model = store.internalProduct;
        customizer.setDesign(store.internalCurrentTemplate);
        customizer.setSide(side).then(function () {
          customizer.adaptZoomToSideAreas(false);
        });
      }
    }
  }, [props.areaId, store.currentTemplate, !!customizer]);
  var handleItemChanged = function handleItemChanged() {
    designUpdate();
  };
  var handleItemRemoved = function handleItemRemoved() {
    designUpdate();
  };
  var zoomIn = function zoomIn() {
    if (customizer) customizer.zoomIn();
  };
  var zoomOut = function zoomOut() {
    if (customizer) customizer.zoomOut();
  };

  // Expose the zoom methods to ref
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {
      zoomIn: zoomIn,
      zoomOut: zoomOut
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeDesignerContainer, {
    id: 'zakeke-designer-container-' + guid
  });
});

/***/ }),

/***/ "./src/components/debugs/debugPanel.tsx":
/*!**********************************************!*\
  !*** ./src/components/debugs/debugPanel.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DebugPanel: () => (/* binding */ DebugPanel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../state/provider */ "./src/state/provider.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var DebugPanelContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tmin-width: 120px;\n\tbottom: 0;\n\tright: 0;\n\tbackground: #fff;\n\tpadding: 10px 20px;\n\tborder: 1px solid #ccc;\n\tz-index: 10000;\n\tcursor: ", ";\n"])), function (props) {
  return props.$hideCursor ? 'auto' : 'pointer';
});
var DebugContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tpadding: 25px 10px 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n"])));
var DebugPanelTitle = styled_components__WEBPACK_IMPORTED_MODULE_1___default().h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 5px;\n\tleft: 10px;\n\tmargin: 0;\n"])));
var DebugPanelClose = styled_components__WEBPACK_IMPORTED_MODULE_1___default().button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 5px;\n\tright: 10px;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tz-index: 10002;\n"])));
var DebugMeshTitle = styled_components__WEBPACK_IMPORTED_MODULE_1___default().h4(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin: 0;\n"])));
var DebugMeshList = styled_components__WEBPACK_IMPORTED_MODULE_1___default().ul(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tlist-style: none;\n\tpadding: 0;\n\toverflow: auto;\n\tmax-height: 200px;\n"])));
var DebugTextArea = styled_components__WEBPACK_IMPORTED_MODULE_1___default().textarea(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tmin-width: 400px;\n\theight: 200px;\n"])));
var DebugPanel = function DebugPanel(_ref) {
  var _viewer$scene;
  _objectDestructuringEmpty(_ref);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_2__.useInternalState)();
  var stateRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(internalState);
  var env = stateRef.current.state.environment;
  var viewer = stateRef.current.state.sceneViewer;
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    sceneConfig = _React$useState4[0],
    setSceneConfig = _React$useState4[1];
  var handleShow = function handleShow() {
    setShow(!show);
  };
  var showIfHidden = function showIfHidden() {
    if (!show) {
      setShow(true);
    }
  };
  var downloadFile = function downloadFile(blob, filename) {
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
  };
  var downloadScene = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var blob;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('Download Scene');
            _context.next = 3;
            return env.exportSceneToGlb();
          case 3:
            blob = _context.sent;
            downloadFile(blob, 'scene.glb');
            console.log('Scene downloaded');
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function downloadScene() {
      return _ref2.apply(this, arguments);
    };
  }();
  var downloadTryOnGLB = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var blob;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log('Download TryOn GLB');
            _context2.next = 3;
            return env.exportTryOnMeshToGlb();
          case 3:
            blob = _context2.sent;
            downloadFile(blob, 'tryon.glb');
            console.log('TryOn GLB downloaded');
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function downloadTryOnGLB() {
      return _ref3.apply(this, arguments);
    };
  }();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var _viewer$zkScene, _viewer$zkScene$getSc;
    var sceneConfig = viewer === null || viewer === void 0 ? void 0 : (_viewer$zkScene = viewer.zkScene) === null || _viewer$zkScene === void 0 ? void 0 : (_viewer$zkScene$getSc = _viewer$zkScene.getSceneConfig()) === null || _viewer$zkScene$getSc === void 0 ? void 0 : _viewer$zkScene$getSc.toJSON();
    if (sceneConfig) {
      setSceneConfig(JSON.stringify(sceneConfig, null, 2));
    }
  }, [viewer]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugPanelContainer, {
    $hideCursor: show,
    onClick: showIfHidden
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugPanelTitle, null, "Debug Panel"), show && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugPanelClose, {
    onClick: handleShow
  }, "X"), show && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: downloadScene
  }, "Download Scene"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: downloadTryOnGLB
  }, "Download TryOn GLB"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugMeshTitle, null, "Mesh list"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugMeshList, null, viewer === null || viewer === void 0 ? void 0 : (_viewer$scene = viewer.scene) === null || _viewer$scene === void 0 ? void 0 : _viewer$scene.meshes.map(function (mesh) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: mesh.id
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
      onClick: function onClick() {
        mesh.visibility = 1;
      }
    }, "Show"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
      onClick: function onClick() {
        mesh.visibility = 0;
      }
    }, "Hide"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, mesh.name));
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$scene2;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$scene2 = viewer.scene) === null || _viewer$scene2 === void 0 ? void 0 : _viewer$scene2.meshes);
    }
  }, "Log Meshes"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$scene3;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$scene3 = viewer.scene) === null || _viewer$scene3 === void 0 ? void 0 : _viewer$scene3.materials);
    }
  }, "Log Materials"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$scene4;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$scene4 = viewer.scene) === null || _viewer$scene4 === void 0 ? void 0 : _viewer$scene4.textures);
    }
  }, "Log Textures")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugMeshTitle, null, "Scene config"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(DebugTextArea, {
    value: sceneConfig,
    onChange: function onChange(e) {
      return setSceneConfig(e.target.value);
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      var _viewer$zkScene2, _viewer$zkScene2$getS;
      console.log(viewer === null || viewer === void 0 ? void 0 : (_viewer$zkScene2 = viewer.zkScene) === null || _viewer$zkScene2 === void 0 ? void 0 : (_viewer$zkScene2$getS = _viewer$zkScene2.getSceneConfig()) === null || _viewer$zkScene2$getS === void 0 ? void 0 : _viewer$zkScene2$getS.toJSON());
    }
  }, "Log Scene Config"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", {
    onClick: function onClick() {
      viewer === null || viewer === void 0 ? void 0 : viewer.loadSceneConfig(JSON.parse(sceneConfig));
      viewer === null || viewer === void 0 ? void 0 : viewer.setRenderingNeeded();
      viewer === null || viewer === void 0 ? void 0 : viewer.refreshRendering();
    }
  }, "Apply Scene Config"))));
};

/***/ }),

/***/ "./src/components/sceneViewer.tsx":
/*!****************************************!*\
  !*** ./src/components/sceneViewer.tsx ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZakekeViewer: () => (/* binding */ ZakekeViewer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _debugs_debugPanel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./debugs/debugPanel */ "./src/components/debugs/debugPanel.tsx");
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }







var ZakekeViewerContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toutline: none !important;\n\n\tcanvas {\n\t\toutline: none !important;\n\t\tbackground-color: ", ";\n\t}\n"])), function (props) {
  return props.backgroundColor ? props.backgroundColor : 'transparent';
});

// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
var ZakekeViewer = function ZakekeViewer(_ref) {
  var className = _ref.className,
    bgColor = _ref.bgColor;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    guid = _React$useState2[0];
  var _useZakeke = (0,_hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)(),
    isViewerReady = _useZakeke.isViewerReady,
    internalAppendViewer = _useZakeke.internalAppendViewer,
    backgroundColor = _useZakeke.backgroundColor,
    removeBackground = _useZakeke.removeBackground;
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(internalState);
  var getBackgroundColor = function getBackgroundColor() {
    var isFullscreen = !!document.fullscreenElement;
    var removeBackground = stateRef.current.state.environment.removeBackground;
    var backgroundColor = stateRef.current.state.environment.backgroundColor;
    if (!isFullscreen && removeBackground) return null; //			1 non cè' il background
    if (!isFullscreen && backgroundColor) return backgroundColor; // 2 background lato config
    return bgColor !== null && bgColor !== void 0 ? bgColor : '#f2f2f2'; //					3 background lato tema o default
  };
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(getBackgroundColor()),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    stateBackgroundCol = _React$useState4[0],
    setStateBackgroundCol = _React$useState4[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isViewerReady) internalAppendViewer(document.getElementById('zakeke-viewer-container-' + guid));
  }, [isViewerReady]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setStateBackgroundCol(getBackgroundColor());
    var e = function e() {
      setStateBackgroundCol(getBackgroundColor());
    };
    document.addEventListener('fullscreenchange', e);
    return function () {
      document.removeEventListener('fullscreenchange', e);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeViewerContainer, {
    backgroundColor: stateBackgroundCol,
    id: 'zakeke-viewer-container-' + guid,
    className: "zakeke-viewer-container ".concat(className)
  }, (stateRef === null || stateRef === void 0 ? void 0 : stateRef.current.state.isDebug) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_debugs_debugPanel__WEBPACK_IMPORTED_MODULE_5__.DebugPanel, null));
};

/***/ }),

/***/ "./src/components/tryon/tryOnFrame.tsx":
/*!*********************************************!*\
  !*** ./src/components/tryon/tryOnFrame.tsx ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TryOnFrame: () => (/* binding */ TryOnFrame)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
var _templateObject;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var TryOnIFrame = styled_components__WEBPACK_IMPORTED_MODULE_1___default().iframe(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\toutline: none;\n"])));
// #region common frame
var TryOnFrame = function TryOnFrame(props) {
  var frame = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    eventAdded = _useState2[0],
    setEventAdded = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    timeOut = _useState4[0],
    setTimeOut = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    lockForTimeOut = _useState6[0],
    setLockForTimeOut = _useState6[1];
  var pdToolFrame = frame === null || frame === void 0 ? void 0 : frame.current;
  var windowFineTuning = pdToolFrame === null || pdToolFrame === void 0 ? void 0 : pdToolFrame.contentWindow;
  var startTimeOut = function startTimeOut() {
    if (timeOut) clearTimeout(timeOut);
    setLockForTimeOut(true);
    pdToolFrame === null || pdToolFrame === void 0 ? void 0 : pdToolFrame.setAttribute('src', 'about:blank');
    setTimeOut(setTimeout(function () {
      setLockForTimeOut(false);
      pdToolFrame === null || pdToolFrame === void 0 ? void 0 : pdToolFrame.setAttribute('src', props.providerUrl);
    }, 1500));
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (pdToolFrame && windowFineTuning) {
      props.onReady && props.onReady(windowFineTuning);
      startTimeOut();
    }
  }, [windowFineTuning]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!eventAdded) {
      setEventAdded(true);
      window.addEventListener('message', props.outMessageHandler);
    }
    return function () {
      if (eventAdded) {
        window.removeEventListener('message', props.outMessageHandler);
        setEventAdded(false);
      }
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnIFrame, {
    ref: frame,
    className: props.className ? props.className : '' + ' tryon-' + props.providerTitle + '-frame',
    src: "about:blank",
    scrolling: "no",
    allowFullScreen: true,
    allow: "accelerometer; magnetometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;"
  });
};

// #endregion

/***/ }),

/***/ "./src/components/tryon/tryOnModels.ts":
/*!*********************************************!*\
  !*** ./src/components/tryon/tryOnModels.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PupillaryDistanceBaseProviderReceivedMessage: () => (/* binding */ PupillaryDistanceBaseProviderReceivedMessage),
/* harmony export */   PupillaryDistanceBaseProviderResponseMessage: () => (/* binding */ PupillaryDistanceBaseProviderResponseMessage),
/* harmony export */   TryOnBaseProviderReceivedMessage: () => (/* binding */ TryOnBaseProviderReceivedMessage),
/* harmony export */   TryOnBaseProviderResponseMessage: () => (/* binding */ TryOnBaseProviderResponseMessage),
/* harmony export */   TryOnMode: () => (/* binding */ TryOnMode),
/* harmony export */   parseJSON: () => (/* binding */ parseJSON)
/* harmony export */ });
var TryOnMode = /*#__PURE__*/function (TryOnMode) {
  TryOnMode[TryOnMode["TryOn"] = 1] = "TryOn";
  TryOnMode[TryOnMode["PDTool"] = 2] = "PDTool";
  return TryOnMode;
}({});
var TryOnBaseProviderReceivedMessage = {
  Start: '',
  WaitingAuthentication: 'WAITING_AUTH',
  AuthSuccessful: 'AUTH_SUCCESS',
  AuthError: 'AUTH_ERROR',
  WebcamError: 'WEBCAM_ERROR'
};
var TryOnBaseProviderResponseMessage = {};
var PupillaryDistanceBaseProviderReceivedMessage = {
  Start: '',
  WaitingAuthentication: 'WAITING_AUTH',
  AuthSuccessful: 'AUTH_SUCCESS',
  AuthError: 'AUTH_ERROR'
};
var PupillaryDistanceBaseProviderResponseMessage = {};
function parseJSON(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

/***/ }),

/***/ "./src/components/tryon/tryOnProviders/tryOnBanuba.tsx":
/*!*************************************************************!*\
  !*** ./src/components/tryon/tryOnProviders/tryOnBanuba.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BanubaTryOn: () => (/* binding */ BanubaTryOn),
/* harmony export */   BanubaTryOnReceivedMessage: () => (/* binding */ BanubaTryOnReceivedMessage),
/* harmony export */   BanubaTryOnResponseMessage: () => (/* binding */ BanubaTryOnResponseMessage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _tryOnFrame__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../tryOnFrame */ "./src/components/tryon/tryOnFrame.tsx");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../state/provider */ "./src/state/provider.tsx");
var _templateObject,
  _this = undefined;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






// #region interfaces
var BanubaTryOnBaseReceivedMessage = {
  WaitingAuthentication: 'WAITING_AUTH',
  TryOnLoaded: 'MODEL_LOADED',
  ScreenShotTaken: 'SCREENSHOT_TAKEN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var BanubaTryOnReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderReceivedMessage), BanubaTryOnBaseReceivedMessage);
var BanubaTryOnBaseResponseMessage = {
  StartAuthenticationTryOn: 'AUTH',
  LoadTryOn: 'LOAD_MODEL',
  LoadHands: 'LOAD_HANDS',
  TakeScreenshot: 'TAKE_SCREENSHOT',
  StopWebcam: 'STOP_WEBCAM'
};
var BanubaHandTypes = [
  //QUI TIPI DI PRODOTTI CHE RICHIEDONO LE MANI
];
var BanubaTryOnResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderResponseMessage), BanubaTryOnBaseResponseMessage);
//#endregion

var BanubaTryOnComponentContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: white;\n\tdisplay: flex;\n\t& .tryon-banuba-frame {\n\t\twidth: 77%;\n\t\theight: 100%;\n\t\tborder: none;\n\t\toutline: none;\n\t\tmargin: auto;\n\t}\n"])));

// #region virtual try on

var BanubaTryOn = function BanubaTryOn(props) {
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryOnState = _useState2[0],
    setTryOnState = _useState2[1];
  var _useZakekeTryOn = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn.tryon,
    setTryon = _useZakekeTryOn.setTryon;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    frameWindow = _useState4[0],
    setFrameWindow = _useState4[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        var _tryon$setVisible;
        return tryon === null || tryon === void 0 ? void 0 : (_tryon$setVisible = tryon.setVisible) === null || _tryon$setVisible === void 0 ? void 0 : _tryon$setVisible.call(tryon, false);
      },
      takeScreenshot: function takeScreenshot() {
        return sendMessage(frameWindowRef.current, BanubaTryOnResponseMessage.TakeScreenshot, null);
      },
      switchToPDTool: function switchToPDTool() {
        console.log('switchToPDTool');
      },
      switchToTryOn: function switchToTryOn() {
        console.log('switchToTryOn');
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        console.log('startPupillaryDistance');
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded, _props$onClose;
    switch (tryOnState.type) {
      // TRYON MESSAGES
      case BanubaTryOnReceivedMessage.Start:
        break;
      case BanubaTryOnReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, BanubaTryOnResponseMessage.StartAuthenticationTryOn, {
          token: Zakeke.config.banubaSettings.token
        });
        break;
      case BanubaTryOnReceivedMessage.AuthSuccessful:
        if (BanubaHandTypes.includes(props.product.typeID)) {
          sendMessage(frameWindow, BanubaTryOnResponseMessage.LoadHands, null);
          setTimeout(function () {
            sendMessage(frameWindow, BanubaTryOnResponseMessage.LoadTryOn, {
              glb: props.obj,
              settings: props.fineTuningSettings
            });
          }, 1500);
          return;
        }
        sendMessage(frameWindow, BanubaTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        break;
      case BanubaTryOnReceivedMessage.TryOnLoaded:
        (_props$onLoaded = props.onLoaded) === null || _props$onLoaded === void 0 ? void 0 : _props$onLoaded.call(props);
        break;
      case BanubaTryOnReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case BanubaTryOnReceivedMessage.WebcamStopped:
        (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        break;
    }
  }, [tryOnState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage(_objectSpread({
      type: message
    }, value), '*');
  };
  var handleMessage = function handleMessage(e) {
    setTryOnState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(BanubaTryOnComponentContainer, {
    className: "Banuba-tryon ".concat(props.className ? props.className : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_4__.TryOnFrame, {
    providerTitle: "banuba",
    providerUrl: Zakeke.config.banubaSettings.url,
    onReady: function onReady(w) {
      var _props$onReady;
      setFrameWindow(w);
      (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};

// #endregion

/***/ }),

/***/ "./src/components/tryon/tryOnProviders/tryOnDeepAR.tsx":
/*!*************************************************************!*\
  !*** ./src/components/tryon/tryOnProviders/tryOnDeepAR.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DeepARTryOn: () => (/* binding */ DeepARTryOn),
/* harmony export */   DeepARTryOnReceivedMessage: () => (/* binding */ DeepARTryOnReceivedMessage),
/* harmony export */   DeepARTryOnResponseMessage: () => (/* binding */ DeepARTryOnResponseMessage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _tryOnFrame__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../tryOnFrame */ "./src/components/tryon/tryOnFrame.tsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../helpers */ "./src/helpers.tsx");
var _templateObject,
  _this = undefined;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







// #region interfaces
var DeepARTryOnBaseReceivedMessage = {
  WaitingAuthentication: 'WAITING_AUTH',
  TryOnLoaded: 'MODEL_LOADED',
  ScreenShotTaken: 'SCREENSHOT_TAKEN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var DeepARTryOnReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_3__.TryOnBaseProviderReceivedMessage), DeepARTryOnBaseReceivedMessage);
var DeepARTryOnBaseResponseMessage = {
  StartAuthenticationTryOn: 'AUTH',
  LoadTryOn: 'LOAD_MODEL',
  LoadHands: 'LOAD_HANDS',
  TakeScreenshot: 'TAKE_SCREENSHOT',
  StopWebcam: 'STOP_WEBCAM'
};
var DeepARTryOnResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_3__.TryOnBaseProviderResponseMessage), DeepARTryOnBaseResponseMessage);
//#endregion

// const DeepARTryOnComponentContainer = styled.div`
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// 	width: 100%;
// 	height: 100%;
// 	display: flex;
// 	& .tryon-deepAR-frame {
// 		width: 77%;
// 		height: 100%;
// 		border: none;
// 		outline: none;
// 		margin: auto;
// 	}

// `;

var DeepARMobileContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tbackground-color: rgba(0, 0, 0, 0.7);\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\toverflow: auto;\n\tz-index: 12;\n\tborder-radius: 10px;\n"])));
var DeepARTryOn = function DeepARTryOn(props) {
  console.log('DeepAR props.fineTuningSettings', props.fineTuningSettings);
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryOnState = _useState2[0],
    setTryOnState = _useState2[1];
  var _useZakekeTryOn = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn.tryon,
    setTryon = _useZakekeTryOn.setTryon;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    frameWindow = _useState4[0],
    setFrameWindow = _useState4[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0___default().useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    deepARIframeUrl = _React$useState2[0],
    setDeepARIframeUrl = _React$useState2[1];
  var isDesktop = !(_helpers__WEBPACK_IMPORTED_MODULE_6__.IS_ANDROID || _helpers__WEBPACK_IMPORTED_MODULE_6__.IS_IOS);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        var _tryon$setVisible;
        return tryon === null || tryon === void 0 ? void 0 : (_tryon$setVisible = tryon.setVisible) === null || _tryon$setVisible === void 0 ? void 0 : _tryon$setVisible.call(tryon, false);
      },
      takeScreenshot: function takeScreenshot() {
        return sendMessage(frameWindowRef.current, DeepARTryOnResponseMessage.TakeScreenshot, null);
      },
      switchToPDTool: function switchToPDTool() {
        console.log('switchToPDTool');
      },
      switchToTryOn: function switchToTryOn() {
        console.log('switchToTryOn');
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        console.log('startPupillaryDistance');
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded, _props$onClose;
    switch (tryOnState.type) {
      // TRYON MESSAGES
      case DeepARTryOnReceivedMessage.Start:
        break;
      case DeepARTryOnReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, DeepARTryOnResponseMessage.StartAuthenticationTryOn, {
          token: Zakeke.config.deepARSettings.token
        });
        break;
      case DeepARTryOnReceivedMessage.AuthSuccessful:
        sendMessage(frameWindow, DeepARTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        break;
      case DeepARTryOnReceivedMessage.TryOnLoaded:
        (_props$onLoaded = props.onLoaded) === null || _props$onLoaded === void 0 ? void 0 : _props$onLoaded.call(props);
        break;
      case DeepARTryOnReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case DeepARTryOnReceivedMessage.WebcamStopped:
        (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        break;
    }
  }, [tryOnState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage(_objectSpread({
      type: message
    }, value), '*');
  };
  var handleMessage = function handleMessage(e) {
    setTryOnState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(DeepARMobileContainer, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_5__.TryOnFrame, {
    providerTitle: "deepAR",
    providerUrl: Zakeke.config.deepARSettings.url,
    onReady: function onReady(w) {
      var _props$onReady;
      setFrameWindow(w);
      (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};

// #endregion

/***/ }),

/***/ "./src/components/tryon/tryOnProviders/tryOnMazing.tsx":
/*!*************************************************************!*\
  !*** ./src/components/tryon/tryOnProviders/tryOnMazing.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MazingPupillaryDistance: () => (/* binding */ MazingPupillaryDistance),
/* harmony export */   MazingPupillaryDistanceResponseMessage: () => (/* binding */ MazingPupillaryDistanceResponseMessage),
/* harmony export */   MazingPupillaryDistanceStateReceivedMessage: () => (/* binding */ MazingPupillaryDistanceStateReceivedMessage),
/* harmony export */   MazingTryOn: () => (/* binding */ MazingTryOn),
/* harmony export */   MazingTryOnReceivedMessage: () => (/* binding */ MazingTryOnReceivedMessage),
/* harmony export */   MazingTryOnResponseMessage: () => (/* binding */ MazingTryOnResponseMessage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _tryOnFrame__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../tryOnFrame */ "./src/components/tryon/tryOnFrame.tsx");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../state/provider */ "./src/state/provider.tsx");
var _templateObject,
  _this = undefined;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







// #region interfaces
var MazingTryOnBaseReceivedMessage = {
  WaitingAuthentication: 'WAITING_AUTH',
  TryOnLoaded: 'MODEL_LOADED',
  ScreenShotTaken: 'SCREENSHOT_TAKEN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var MazingTryOnReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderReceivedMessage), MazingTryOnBaseReceivedMessage);
var MazingTryOnBaseResponseMessage = {
  StartAuthenticationTryOn: 'AUTH_TRY_ON',
  LoadTryOn: 'LOAD_MODEL',
  TakeScreenshot: 'TAKE_SCREENSHOT',
  StopWebcam: 'STOP_WEBCAM'
};
var MazingTryOnResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderResponseMessage), MazingTryOnBaseResponseMessage);
var MazingPupillaryDistanceBaseStateReceivedMessage = {
  PDLoaded: 'PD_LOADED',
  PDUpdated: 'NEW_PD',
  PDDataNotFoundError: 'PD_ERROR',
  WebcamError: 'WEBCAM_ERROR',
  PDCountdown: 'PD_COUNTDOWN',
  WebcamStopped: 'WEBCAM_STOPPED'
};
var MazingPupillaryDistanceStateReceivedMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderReceivedMessage), MazingPupillaryDistanceBaseStateReceivedMessage);
var MazingPupillaryDistanceBaseResponseMessage = {
  StartAuthenticationPD: 'AUTH_TRY_ON',
  LoadPD: 'LOAD_PD',
  StartPD: 'START_PD',
  StopWebcam: 'STOP_WEBCAM'
};
var MazingPupillaryDistanceResponseMessage = _objectSpread(_objectSpread({}, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderResponseMessage), MazingPupillaryDistanceBaseResponseMessage);
//#endregion

var MazingTryOnComponentContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tbackground-color: white;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n"])));

// #region virtual try on

var MazingTryOn = function MazingTryOn(props) {
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryOnState = _useState2[0],
    setTryOnState = _useState2[1];
  var _useZakekeTryOn = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn.tryon,
    setTryon = _useZakekeTryOn.setTryon,
    tryOnPickedMode = _useZakekeTryOn.tryOnPickedMode,
    setTryOnPickedMode = _useZakekeTryOn.setTryOnPickedMode;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    frameWindow = _useState4[0],
    setFrameWindow = _useState4[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  var customerUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.customer.settings).uid;
  var productUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.product.settings).uid;
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    switchedToPDTool = _useState6[0],
    setSwitchedToPDTool = _useState6[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        return sendMessage(frameWindowRef.current, MazingTryOnResponseMessage.StopWebcam, null);
      },
      takeScreenshot: function takeScreenshot() {
        return sendMessage(frameWindowRef.current, MazingTryOnResponseMessage.TakeScreenshot, null);
      },
      switchToPDTool: function switchToPDTool() {
        var _tryon$changeMode;
        setSwitchedToPDTool(true);
        sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.LoadPD, null);
        (_tryon$changeMode = tryon.changeMode) === null || _tryon$changeMode === void 0 ? void 0 : _tryon$changeMode.call(tryon, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnMode.PDTool);
      },
      switchToTryOn: function switchToTryOn() {
        var _tryon$changeMode2;
        setSwitchedToPDTool(false);
        sendMessage(frameWindowRef.current, MazingTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        (_tryon$changeMode2 = tryon.changeMode) === null || _tryon$changeMode2 === void 0 ? void 0 : _tryon$changeMode2.call(tryon, _tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnMode.TryOn);
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.StartPD, {
          seconds: time
        });
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded, _props$onLoaded2, _tryOnState$value, _props$onPDUpdated, _tryOnState$value2, _props$onClose;
    switch (tryOnState.type) {
      // TRYON MESSAGES
      case MazingTryOnReceivedMessage.Start:
        break;
      case MazingTryOnReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, MazingTryOnResponseMessage.StartAuthenticationTryOn, {
          customer_uid: customerUid,
          product_uid: productUid
        });
        break;
      case MazingTryOnReceivedMessage.AuthSuccessful:
        sendMessage(frameWindow, MazingTryOnResponseMessage.LoadTryOn, {
          glb: props.obj,
          settings: props.fineTuningSettings
        });
        break;
      case MazingTryOnReceivedMessage.TryOnLoaded:
        (_props$onLoaded = props.onLoaded) === null || _props$onLoaded === void 0 ? void 0 : _props$onLoaded.call(props);
        break;

      // PD MESSAGES
      case MazingPupillaryDistanceStateReceivedMessage.PDLoaded:
        (_props$onLoaded2 = props.onLoaded) === null || _props$onLoaded2 === void 0 ? void 0 : _props$onLoaded2.call(props);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDUpdated:
        store.setPDDistance((_tryOnState$value = tryOnState.value) === null || _tryOnState$value === void 0 ? void 0 : _tryOnState$value.pd);
        (_props$onPDUpdated = props.onPDUpdated) === null || _props$onPDUpdated === void 0 ? void 0 : _props$onPDUpdated.call(props, (_tryOnState$value2 = tryOnState.value) === null || _tryOnState$value2 === void 0 ? void 0 : _tryOnState$value2.pd);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDDataNotFoundError:
        break;
      case MazingTryOnReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case MazingTryOnReceivedMessage.WebcamStopped:
        (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
        break;
    }
  }, [tryOnState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage({
      type: message,
      value: value
    }, '*');
  };
  var handleMessage = function handleMessage(e) {
    setTryOnState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(MazingTryOnComponentContainer, {
    className: "mazing-tryon ".concat(props.className ? props.className : "")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_4__.TryOnFrame, {
    providerTitle: "Mazing",
    providerUrl: Zakeke.config.mazingSettings.url,
    onReady: function onReady(w) {
      var _props$onReady;
      setFrameWindow(w);
      (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};

// #endregion

// #region pd tool
var MazingPupillaryDistance = function MazingPupillaryDistance(props) {
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    pdState = _useState8[0],
    setPDState = _useState8[1];
  var _useZakekeTryOn2 = (0,_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_3__.useZakekeTryOn)(),
    tryon = _useZakekeTryOn2.tryon,
    setTryon = _useZakekeTryOn2.setTryon;
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = stateRef.current.state.environment;
  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    frameWindow = _useState10[0],
    setFrameWindow = _useState10[1];
  var frameWindowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  frameWindowRef.current = frameWindow;
  var customerUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.customer.settings).uid;
  var productUid = (0,_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON)(props.product.settings).uid;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      closeFrame: function closeFrame() {
        return sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.StopWebcam, null);
      },
      switchToPDTool: function switchToPDTool() {
        console.log('switchToPDTool not active');
      },
      switchToTryOn: function switchToTryOn() {
        console.log('switchToTryOn not active');
      },
      takeScreenshot: function takeScreenshot() {
        return console.log('takeScreenshot not active');
      },
      startPupillaryDistance: function startPupillaryDistance(time) {
        return sendMessage(frameWindowRef.current, MazingPupillaryDistanceResponseMessage.StartPD, {
          seconds: time
        });
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _props$onLoaded3, _props$onPDUpdated2, _props$onClose2;
    switch (pdState.type) {
      case MazingPupillaryDistanceStateReceivedMessage.Start:
        break;
      case MazingPupillaryDistanceStateReceivedMessage.WaitingAuthentication:
        sendMessage(frameWindow, MazingPupillaryDistanceResponseMessage.StartAuthenticationPD, {
          customer_uid: customerUid,
          product_uid: productUid
        });
        break;
      case MazingPupillaryDistanceStateReceivedMessage.AuthSuccessful:
        sendMessage(frameWindow, MazingPupillaryDistanceResponseMessage.LoadPD, {});
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDLoaded:
        (_props$onLoaded3 = props.onLoaded) === null || _props$onLoaded3 === void 0 ? void 0 : _props$onLoaded3.call(props);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDUpdated:
        store.setPDDistance(pdState.value.pd);
        (_props$onPDUpdated2 = props.onPDUpdated) === null || _props$onPDUpdated2 === void 0 ? void 0 : _props$onPDUpdated2.call(props, pdState.value.pd);
        break;
      case MazingPupillaryDistanceStateReceivedMessage.PDDataNotFoundError:
        break;
      case MazingPupillaryDistanceStateReceivedMessage.WebcamError:
        props.onWebcamError();
        break;
      case MazingPupillaryDistanceStateReceivedMessage.WebcamStopped:
        (_props$onClose2 = props.onClose) === null || _props$onClose2 === void 0 ? void 0 : _props$onClose2.call(props);
        break;
    }
  }, [pdState]);
  var sendMessage = function sendMessage(window, message, value) {
    window.postMessage({
      type: message,
      value: value
    }, '*');
  };
  var handleMessage = function handleMessage(e) {
    var _e$data;
    if (!!((_e$data = e.data) !== null && _e$data !== void 0 && _e$data.type)) setPDState(e.data);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(MazingTryOnComponentContainer, {
    className: "mazing-pd ".concat(props.className ? props.className : "")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnFrame__WEBPACK_IMPORTED_MODULE_4__.TryOnFrame, {
    providerTitle: "mazing",
    providerUrl: Zakeke.config.mazingSettings.url,
    onReady: function onReady(w) {
      var _props$onReady2;
      setFrameWindow(w);
      (_props$onReady2 = props.onReady) === null || _props$onReady2 === void 0 ? void 0 : _props$onReady2.call(props);
    },
    outMessageHandler: handleMessage.bind(_this)
  }));
};
// #endregion

// MazingTryOnComponent.defaultProps = {
//   initialState: {
//     type: MazingTryOnState.Start,
//     value: null,
//   },
//   fineTuningSettings: {
//     position: {
//       x: 0,
//       y: 0,
//       z: 0,
//     },
//     scale: 0,
//     temple: true,
//     environment: TryOnFineTuningMazingEnvironment.Neutral,
//   },
// };

// MazingPDToolComponent.defaultProps = {
//   initialState: {
//     type: MazingTryOnState.Start,
//     value: null,
//   },
// };

/***/ }),

/***/ "./src/components/tryon/tryOnViewer.tsx":
/*!**********************************************!*\
  !*** ./src/components/tryon/tryOnViewer.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PupillaryDistanceView: () => (/* binding */ PupillaryDistanceView),
/* harmony export */   TryOnView: () => (/* binding */ TryOnView),
/* harmony export */   ZakekeTryOnViewer: () => (/* binding */ ZakekeTryOnViewer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../models */ "./src/models.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _tryOnModels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _tryOnProviders_tryOnBanuba__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./tryOnProviders/tryOnBanuba */ "./src/components/tryon/tryOnProviders/tryOnBanuba.tsx");
/* harmony import */ var _tryOnProviders_tryOnDeepAR__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./tryOnProviders/tryOnDeepAR */ "./src/components/tryon/tryOnProviders/tryOnDeepAR.tsx");
/* harmony import */ var _tryOnProviders_tryOnMazing__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./tryOnProviders/tryOnMazing */ "./src/components/tryon/tryOnProviders/tryOnMazing.tsx");
/* harmony import */ var _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @zakeke/zakeke-3d-core */ "./node_modules/@zakeke/zakeke-3d-core/dist/index.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }










var TryOnOverlay = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: black;\n\topacity: 0.5;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 3;\n"])));
var TryOnViewContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tz-index: 6;\n\tleft: 0%;\n\ttop: 0%;\n"])));
var PupillaryDistanceViewContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: fixed;\n\tbackground-color: white;\n\tz-index: 6;\n\tleft: 0%;\n\ttop: 0%;\n"])));
var ZakekeTryOnViewer = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
  var _stateRef$current;
  console.log('props ZakekeTryonviewer', props);
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = (_stateRef$current = stateRef.current) === null || _stateRef$current === void 0 ? void 0 : _stateRef$current.state.environment;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    tryon = _useState2[0],
    setTryon = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_tryOnModels__WEBPACK_IMPORTED_MODULE_5__.TryOnMode.TryOn),
    _useState4 = _slicedToArray(_useState3, 2),
    tryOnPickedMode = _useState4[0],
    setTryOnPickedMode = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    tryOnVisibility = _useState6[0],
    setTryOnVisibility = _useState6[1];
  var frameRef = {
    tryon: tryon,
    setTryon: setTryon,
    tryOnPickedMode: tryOnPickedMode,
    setTryOnPickedMode: setTryOnPickedMode,
    tryOnVisibility: tryOnVisibility,
    setTryOnVisibility: setTryOnVisibility
  };
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    dataFetched = _useState8[0],
    setDataFetched = _useState8[1];
  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    switchToPDTool = _useState10[0],
    setSwitchToPDTool = _useState10[1];
  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    hasDataBeenFetched = _useState12[0],
    setHasDataBeenFetched = _useState12[1];
  var handleFrameReady = function handleFrameReady(sellerID, provider) {
    var _props$onReady;
    // conteggio view per billing
    store.tryOnCountView(sellerID, provider, tryOnPickedMode);
    (_props$onReady = props.onReady) === null || _props$onReady === void 0 ? void 0 : _props$onReady.call(props);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      mode: tryOnPickedMode,
      changeMode: function changeMode(mode) {
        setTryOnPickedMode(mode);
      },
      visible: tryOnVisibility,
      setVisible: function setVisible(visible) {
        setTryOnVisibility(visible);
      }
    }));
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setSwitchToPDTool(!!props.switchable);
  }, [props.switchable]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    setTryon(_objectSpread(_objectSpread({}, tryon), {}, {
      mode: tryOnPickedMode
    }));
  }, [tryOnPickedMode]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (tryOnVisibility) {
      if (hasDataBeenFetched && !switchToPDTool) setHasDataBeenFetched(false);
      console.log('fetching data');
      store.exportTryOnMeshToGlb().then(function (blob) {
        if (store.tryOnSellerSettings) {
          var product = store.tryOnProductSettings;
          var customer = store.tryOnSellerSettings;
          setDataFetched({
            product: product,
            customer: customer,
            provider: product.providerID,
            // forzo al momento a 3
            // provider: 3,
            mode: tryOnPickedMode,
            obj: blob,
            settings: store.tryOnMeshVisibleSettings
          });
          setTimeout(function () {
            setHasDataBeenFetched(true);
          }, 500);
        }
      });
    }
  }, [tryOnPickedMode, tryOnVisibility]);
  // Espongo i metodi esterni come reference per controllare il tryon/pd tool
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {
      closeFrame: tryon.closeFrame,
      takeScreenshot: tryon.takeScreenshot,
      switchToPDTool: tryon.switchToPDTool,
      switchToTryOn: tryon.switchToTryOn,
      startPupillaryDistance: tryon.startPupillaryDistance,
      mode: tryon.mode,
      changeMode: tryon.changeMode,
      visible: tryon.visible,
      setVisible: tryon.setVisible
    };
  }, [tryon]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_hooks_tryonContext__WEBPACK_IMPORTED_MODULE_2__.TryOnContext.Provider, {
    value: frameRef
  }, tryOnVisibility && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, hasDataBeenFetched && tryOnPickedMode === _tryOnModels__WEBPACK_IMPORTED_MODULE_5__.TryOnMode.PDTool && !switchToPDTool && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PupillaryDistanceView, {
    className: 'tryon-pd-tool' + (props.className ? ' ' + props.className : ''),
    provider: dataFetched.provider,
    product: dataFetched.product,
    customer: dataFetched.customer,
    onReady: function onReady() {
      return handleFrameReady(dataFetched.customer.sellerID, dataFetched.product.providerID);
    },
    onLoaded: props.onLoaded,
    onPDUpdated: props.onPDUpdated,
    onClose: props.onClose,
    onWebcamError: props.onWebcamError
  }), hasDataBeenFetched && (tryOnPickedMode === _tryOnModels__WEBPACK_IMPORTED_MODULE_5__.TryOnMode.TryOn || switchToPDTool) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnView, {
    className: 'tryon-view-tool' + (props.className ? ' ' + props.className : ''),
    provider: dataFetched.product.providerID,
    type: dataFetched.product.typeID,
    obj: dataFetched.obj,
    settings: store.tryOnMeshVisibleSettings,
    product: dataFetched.product,
    customer: dataFetched.customer,
    onPDUpdated: props.onPDUpdated,
    onReady: function onReady() {
      return handleFrameReady(dataFetched.customer.sellerID, dataFetched.product.providerID);
    },
    onLoaded: props.onLoaded,
    onClose: props.onClose,
    onWebcamError: props.onWebcamError
  }), props.children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnOverlay, null)));
});
var TryOnView = function TryOnView(props) {
  var _stateRef$current2;
  console.log(JSON.stringify(props, null, 2) + ' tryonview');
  var internalState = (0,_state_provider__WEBPACK_IMPORTED_MODULE_4__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(internalState);
  stateRef.current = internalState;
  var store = (_stateRef$current2 = stateRef.current) === null || _stateRef$current2 === void 0 ? void 0 : _stateRef$current2.state.environment;
  var pickViewer = function pickViewer() {
    var _store$tryOnProviders;
    var mappings = (_store$tryOnProviders = store.tryOnProvidersSettings) !== null && _store$tryOnProviders !== void 0 ? _store$tryOnProviders : {
      list: {}
    };
    var currentProvider = _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.NotSelected;
    console.log('currentProvider', currentProvider);
    if (mappings && mappings.list) {
      if (props.type.toString() in mappings.list) {
        currentProvider = mappings.list[props.type.toString()];
      }
    }
    switch (currentProvider) {
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.Mazing:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnMazing__WEBPACK_IMPORTED_MODULE_8__.MazingTryOn, {
          obj: props.obj,
          className: props.className,
          product: props.product,
          customer: props.customer,
          fineTuningSettings: props.settings ? props.settings : _models__WEBPACK_IMPORTED_MODULE_3__.DefaultMazingFineTuningSettings,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          onClose: props.onClose,
          onPDUpdated: props.onPDUpdated,
          onWebcamError: props.onWebcamError
        });
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.Banuba:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnBanuba__WEBPACK_IMPORTED_MODULE_6__.BanubaTryOn, {
          obj: props.obj,
          className: props.className,
          product: props.product,
          customer: props.customer,
          fineTuningSettings: props.settings ? props.settings : _models__WEBPACK_IMPORTED_MODULE_3__.DefaultBanubaFineTuningSettings,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          onClose: props.onClose,
          onPDUpdated: props.onPDUpdated,
          onWebcamError: props.onWebcamError
        });
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.DeepAR:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnDeepAR__WEBPACK_IMPORTED_MODULE_7__.DeepARTryOn, {
          obj: props.obj,
          className: props.className,
          product: props.product,
          customer: props.customer,
          fineTuningSettings: props.settings ? props.settings : _models__WEBPACK_IMPORTED_MODULE_3__.DefaultDeepARFineTuningSettings,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          onClose: props.onClose,
          onPDUpdated: props.onPDUpdated,
          onWebcamError: props.onWebcamError
        });
      default:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, "Unsupported Type");
    }
  };
  return props && props.provider === _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.DeepAR && !(_zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_9__.IS_ANDROID || _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_9__.IS_IOS) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(TryOnViewContainer, {
    className: props.className ? props.className : '' + ' tryon-viewer'
  }, pickViewer());
};
var PupillaryDistanceView = function PupillaryDistanceView(props) {
  var pickViewer = function pickViewer() {
    switch (props.provider) {
      case _models__WEBPACK_IMPORTED_MODULE_3__.TryOnProvider.Mazing:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tryOnProviders_tryOnMazing__WEBPACK_IMPORTED_MODULE_8__.MazingPupillaryDistance, {
          product: props.product,
          customer: props.customer,
          onPDUpdated: props.onPDUpdated,
          onReady: props.onReady,
          onLoaded: props.onLoaded,
          className: props.className,
          onClose: props.onClose,
          onWebcamError: props.onWebcamError
        });
      default:
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, "Unsupported Provider");
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(PupillaryDistanceViewContainer, {
    className: props.className
  }, pickViewer());
};

/***/ }),

/***/ "./src/environment.tsx":
/*!*****************************!*\
  !*** ./src/environment.tsx ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZakekeEnvironment: () => (/* binding */ ZakekeEnvironment)
/* harmony export */ });
/* harmony import */ var _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @zakeke/zakeke-3d-core */ "./node_modules/@zakeke/zakeke-3d-core/dist/index.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! . */ "./src/index.tsx");
/* harmony import */ var _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased */ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
/* harmony import */ var _fontsManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./fontsManager */ "./src/fontsManager.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");
/* harmony import */ var _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./imageUploadTask */ "./src/imageUploadTask.ts");
/* harmony import */ var _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./integrations/Integration */ "./src/integrations/Integration.ts");
/* harmony import */ var _integrations_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./integrations/helpers */ "./src/integrations/helpers.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./models */ "./src/models.ts");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/// <reference path="../../../typescript_definitions/declarations/All.d.ts" />















var ZakekeEnvironment = /*#__PURE__*/function () {
  function ZakekeEnvironment() {
    var _this = this;
    _classCallCheck(this, ZakekeEnvironment);
    _defineProperty(this, "booted", false);
    _defineProperty(this, "platformAttributesSelection", []);
    _defineProperty(this, "previewWidth", 1024);
    _defineProperty(this, "previewHeight", 1024);
    _defineProperty(this, "clientPreviewWidth", 1024);
    _defineProperty(this, "clientPreviewHeight", 1024);
    _defineProperty(this, "shareUrlPrefix", null);
    _defineProperty(this, "events", []);
    _defineProperty(this, "zkProduct", null);
    _defineProperty(this, "zkScene", null);
    _defineProperty(this, "zkCurrentTemplate", null);
    _defineProperty(this, "zkTemplates", []);
    _defineProperty(this, "internalIsFullscreen", false);
    _defineProperty(this, "highlightSettings", null);
    _defineProperty(this, "previousMeshesVisibleStates", {});
    _defineProperty(this, "lastCameraLocation", null);
    _defineProperty(this, "enableShareCompositionUrl", false);
    _defineProperty(this, "sharedCompositionDocId", null);
    _defineProperty(this, "templateId", null);
    _defineProperty(this, "deepARsceneGLBUrl", '');
    _defineProperty(this, "loadedComposition", null);
    _defineProperty(this, "savedCompositions", null);
    _defineProperty(this, "isDraftEditor", false);
    _defineProperty(this, "isViewerMode", false);
    _defineProperty(this, "isDAMViewer", false);
    // if DAM viewer
    _defineProperty(this, "isTemplateEditor", false);
    _defineProperty(this, "debugMode", false);
    _defineProperty(this, "draftCompositionDocId", null);
    _defineProperty(this, "undoStack", []);
    _defineProperty(this, "redoStack", []);
    _defineProperty(this, "currentAttributesSelection", null);
    _defineProperty(this, "currentCompositionInfo", null);
    _defineProperty(this, "copyrightMessageLocalStorageKey", '');
    _defineProperty(this, "isPupillaryDistanceMandatory", false);
    _defineProperty(this, "isAIEnabled", false);
    _defineProperty(this, "sellerSettings", null);
    _defineProperty(this, "themeCompositions", null);
    _defineProperty(this, "currency", 'EUR');
    _defineProperty(this, "groups", []);
    _defineProperty(this, "fonts", []);
    _defineProperty(this, "disableTextColors", false);
    _defineProperty(this, "textColors", []);
    /**
     * Get the current text default color.
     */
    _defineProperty(this, "defaultColor", '');
    _defineProperty(this, "quantity", 1);
    _defineProperty(this, "quantityRule", null);
    _defineProperty(this, "culture", 'en-US');
    _defineProperty(this, "price", 0);
    _defineProperty(this, "isOutOfStock", false);
    _defineProperty(this, "compositionId", null);
    _defineProperty(this, "templates", []);
    _defineProperty(this, "currentTemplate", null);
    _defineProperty(this, "product", null);
    _defineProperty(this, "templateMacroCategories", null);
    _defineProperty(this, "selectedTemplateCategory", null);
    _defineProperty(this, "cameras", []);
    _defineProperty(this, "isExplodedMode", false);
    _defineProperty(this, "isAssetsLoading", false);
    _defineProperty(this, "additionalCustomProperties", []);
    _defineProperty(this, "nftSettings", null);
    _defineProperty(this, "eventMessages", null);
    _defineProperty(this, "personalizedMessages", null);
    _defineProperty(this, "visibleEventMessages", []);
    _defineProperty(this, "tryOnProvidersSettings", null);
    _defineProperty(this, "tryOnProductSettings", null);
    _defineProperty(this, "tryOnSellerSettings", null);
    _defineProperty(this, "pdSettings", -1);
    _defineProperty(this, "isInfoPointContentVisible", false);
    _defineProperty(this, "animationsConfig", null);
    _defineProperty(this, "internalTranslations", {
      statics: [],
      dynamics: []
    });
    _defineProperty(this, "integrationVersion", 1);
    _defineProperty(this, "translations", null);
    _defineProperty(this, "useLegacyScreenshot", false);
    _defineProperty(this, "visibleCustomizer", null);
    _defineProperty(this, "uiConfig", null);
    _defineProperty(this, "backgroundColor", null);
    _defineProperty(this, "removeBackground", false);
    _defineProperty(this, "parseParameters", function (parameters) {
      console.info('Parameters', parameters);
      var parseSecure = function parseSecure(value) {
        //return decodeURIComponent(fixedEncodeURIComponent(value.toString().replace(/\+/g, ' ')));
        return decodeURIComponent(value.toString().replaceAll('%', '').replace(/\+/g, '%20'));
      };
      var parseSingleParameter = function parseSingleParameter(key, value) {
        var _parseInt;
        if (!value) return;
        switch (key) {
          case 'name':
            _this.productName = parseSecure(value);
            break;
          case 'ecommerce':
            _this.platform = decodeURIComponent(value);
            break;
          case 'qty':
            _this.quantity = parseFloat(decodeURIComponent(value));
            break;
          case 'culture':
            _this.culture = decodeURIComponent(value);
            break;
          case 'currency':
            _this.currency = decodeURIComponent(value);
            break;
          case 'token':
            _this.token = decodeURIComponent(value);
            break;
          case 'compositionId':
            _this.compositionId = decodeURIComponent(value);
            break;
          case 'modelCode':
            _this.productCode = parseSecure(value);
            break;
          case 'previewWidth':
            _this.previewWidth = parseInt(parseSecure(value));
            break;
          case 'previewHeight':
            _this.previewHeight = parseInt(parseSecure(value));
            break;
          case 'shareUrlPrefix':
            _this.shareUrlPrefix = parseSecure(value);
            break;
          case 'sharedCompositionDocId':
            _this.sharedCompositionDocId = parseSecure(value);
            break;
          case 'templateId':
            _this.templateId = parseSecure(value);
            break;
          case 'isDraftEditor':
            _this.isDraftEditor = true;
            break;
          case 'enableShareCompositionUrl':
            _this.enableShareCompositionUrl = true;
            break;
          case 'draftCompositionDocId':
            _this.draftCompositionDocId = value;
            break;
          case 'viewerMode':
            _this.isViewerMode = true;
            break;
          case 'isTemplateEditor':
            _this.isTemplateEditor = true;
            break;
          case 'selectedTemplateCategory':
            _this.selectedTemplateCategory = parseSecure(value);
            break;
          case 'legacyScreenshot':
            _this.useLegacyScreenshot = value == '1';
            break;
          case 'integrationVersion':
            _this.integrationVersion = (_parseInt = parseInt(value)) !== null && _parseInt !== void 0 ? _parseInt : 1;
            break;
          case 'dam':
            _this.isDAMViewer = value == '1' || value == 'true';
            break;
          case 'debugMode':
            _this.debugMode = value == '1' || value == 'true';
            break;
        }
      };

      // From parameters or URL
      if (parameters) {
        for (var key in parameters) {
          var value = parameters[key];
          parseSingleParameter(key, value);

          // Attributes collection
          if (key.indexOf('attributes') == 0) {
            var _iterator = _createForOfIteratorHelper(value),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var attr = _step.value;
                // In some special cases, the plugin could pass empty options (e.g. seat and tools)
                // In this cases, ignore them and take the Zakeke one.
                if (attr[0].id === '' || attr[1].id === '') continue;

                // For each attribute/option
                _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(JSON.stringify(attr[0]), JSON.stringify(attr[1]), '', '', true, true));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
      } else {
        var queryString = window.location.href.substring(window.location.href.lastIndexOf('?') + 1);
        var pieces = queryString.split('&');
        for (var i = 0; i < pieces.length; i++) {
          var index = pieces[i].indexOf('=');
          if (index == -1) {
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.ParametersParseFailException(pieces[i]);
          }
          var _key = decodeURIComponent(pieces[i].substring(0, index));
          var _value = pieces[i].substring(index + 1);
          parseSingleParameter(_key, _value);

          // Attributes collection
          if (_key.indexOf('attributes') == 0) {
            var data = decodeURIComponent(_value.replace(/\+/g, '%20'));
            if (data && data != '') {
              var json = JSON.parse(data);
              var _iterator2 = _createForOfIteratorHelper(json),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _attr = _step2.value;
                  // In some special cases, the plugin could pass empty options (e.g. seat and tools)
                  // In this cases, ignore them and take the Zakeke one.
                  if (_attr[0].id === '' || _attr[1].id === '') continue;
                  _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(JSON.stringify(_attr[0]), JSON.stringify(_attr[1]), '', '', true, true));
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        }
      }

      // Parameter validation
      var requiredParams = {
        'culture (in xx_XX format)': _this.culture,
        currency: _this.currency,
        'name (product name)': _this.productName,
        ecommerce: _this.platform,
        'qty (product quantity)': _this.quantity,
        token: _this.token,
        modelCode: _this.productCode
      };
      for (var _key2 in requiredParams) {
        if (!requiredParams[_key2]) throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Missing parameter: ' + _key2);
      }
      window['token'] = _this.token;
      window['isOwin'] = true;
      return true;
    });
    // Get product
    _defineProperty(this, "getProduct", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!_this.productCode || _this.productCode == '')) {
              _context.next = 2;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading product but no SKU found');
          case 2:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var zkModel = new MPlaza.Model();
              zkModel.set('modelID', 1);
              zkModel.fetch({
                success: function success() {
                  resolve(zkModel);
                },
                error: function error() {
                  reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading product'));
                },
                data: {
                  c: _this.productCode
                }
              });
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    // Get scene
    _defineProperty(this, "getScene", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(product) {
        var zkScene;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (product) {
                _context2.next = 2;
                break;
              }
              throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading scene but no product found');
            case 2:
              if (!(product.get('scenes').length == 0)) {
                _context2.next = 4;
                break;
              }
              throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("The product don't have any scene configured");
            case 4:
              zkScene = new Zakeke.Scene();
              zkScene.set('sceneID', product.get('scenes').at(0).get('sceneID'));
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                zkScene.fetch({
                  success: function success(zkScene) {
                    resolve(zkScene);
                  },
                  error: function error() {
                    reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading scene'));
                  }
                });
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    // Get composer models
    _defineProperty(this, "getComposerModels", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!_this.productCode || _this.productCode == '')) {
              _context3.next = 2;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading product but no SKU found');
          case 2:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var models = new Zakeke.ComposerModels();
              models.set('modelID', 1);
              models.fetch({
                success: function success() {
                  resolve(models);
                },
                error: function error() {
                  reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading product'));
                },
                data: {
                  c: _this.productCode
                }
              });
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    // Get fonts
    _defineProperty(this, "getFonts", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _this$zkProduct$get$a, _this$zkProduct;
      var fonts, productFonts;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('fontfamilies/');
          case 2:
            fonts = _context4.sent.data;
            productFonts = (_this$zkProduct$get$a = (_this$zkProduct = _this.zkProduct) === null || _this$zkProduct === void 0 ? void 0 : _this$zkProduct.get('printTypes').at(0).get('fonts').map(function (x) {
              return x.get('fontFamilyID');
            })) !== null && _this$zkProduct$get$a !== void 0 ? _this$zkProduct$get$a : [];
            if (productFonts.length > 0) fonts = fonts.filter(function (font) {
              return productFonts.indexOf(font.fontFamilyID) != -1;
            });
            return _context4.abrupt("return", fonts);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    // Get settings
    _defineProperty(this, "getSettings", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var settings;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('customizerinfo/');
          case 2:
            settings = _context5.sent.data;
            return _context5.abrupt("return", settings);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    _defineProperty(this, "getSellerSetting", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", new Promise(/*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
                var sellerSetting;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('sellerSetting/');
                    case 2:
                      sellerSetting = _context6.sent.data;
                      resolve(sellerSetting);
                    case 4:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x2, _x3) {
                return _ref7.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    })));
    // Create quote for composition
    _defineProperty(this, "createQuote", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(formData) {
        var _name;
        var quote, quoteCreated;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              quote = new _models__WEBPACK_IMPORTED_MODULE_11__.Quote();
              quote.formData = JSON.stringify(formData);
              quote.quantity = _this.quantity;
              quote.compositionDocID = _this.composition.get('docID');
              _context8.next = 6;
              return _this.getPrice();
            case 6:
              quote.modelPrice = _context8.sent.price;
              quote.variantName = (_name = _this.product.name) !== null && _name !== void 0 ? _name : '';
              _context8.next = 10;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'quotes', quote);
            case 10:
              quoteCreated = _context8.sent.data;
              return _context8.abrupt("return", quoteCreated);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getPrice", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var price, isOutOfStock, result, objectResult;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            price = 0;
            isOutOfStock = false;
            console.log('Get price from store (integration version ' + _this.integrationVersion + ')...');
            _context9.next = 5;
            return _this.integration.getPrice(_this.composition, _this.zkCurrentTemplate, _this.zkProduct, _this.platformAttributesSelection, _this.composition.getPrice(_this.zkProduct, _this.quantity), _this.settings.additionalFeatures.prices3dConfigurator, _this.settings.isPricingAdvancedEnabled, _this.quantity, 0);
          case 5:
            result = _context9.sent;
            if (_this.integrationVersion === 1) {
              price = result;
            } else if (_this.integrationVersion === 2) {
              objectResult = result;
              price = objectResult.price;
              isOutOfStock = objectResult.isOutOfStock;
            }
            console.log('Price from store: ' + price);
            return _context9.abrupt("return", {
              price: price,
              isOutOfStock: isOutOfStock
            });
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    })));
    _defineProperty(this, "getTranslations", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var response;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('sellerLocalizations/customizer-localizations');
          case 3:
            response = _context10.sent;
            if (!response) {
              _context10.next = 8;
              break;
            }
            return _context10.abrupt("return", response.data);
          case 8:
            console.log('getTranslations response is empty');
          case 9:
            _context10.next = 14;
            break;
          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](0);
            console.error(_context10.t0);
          case 14:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[0, 11]]);
    })));
    _defineProperty(this, "loadLocalization", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var lang;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            lang = _this.culture; // Try zh-TW
            if (Zakeke.config.avaibleLanguages.indexOf(lang) == -1) lang = _this.culture.substring(0, 2);

            // Try zh
            if (Zakeke.config.avaibleLanguages.lastIndexOf(lang) == -1) lang = 'en';
            _context11.next = 6;
            return _this.loadScript(Zakeke.config.localizationsUrl + "".concat(lang.toLowerCase(), "/composer.js"));
          case 6:
            _context11.next = 11;
            break;
          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            console.error('Failed loading localization', _context11.t0);
          case 11:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[0, 8]]);
    })));
    _defineProperty(this, "getTemplateMacroCategories", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var response, categories;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('compositionmacrocategories');
          case 2:
            response = _context12.sent;
            categories = response.data.map(function (macroCategory) {
              var allCategories = macroCategory.category.map(function (category) {
                return {
                  categoryName: category.name,
                  categoryID: category.categoryID
                };
              });
              return {
                macroCategoryName: macroCategory.name,
                macroCategoryID: macroCategory.macroCategoryID,
                categories: allCategories
              };
            });
            return _context12.abrupt("return", categories);
          case 5:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    })));
    _defineProperty(this, "loadScript", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(src) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.onload = resolve;
                script.src = src;
                document.body.appendChild(script);
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x5) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(this, "validationNFTEmail", function (email) {
      var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return EMAIL_REGEX.test(email);
    });
    _defineProperty(this, "validationNFTWalletAddress", function (address) {
      var NFT_WALLET_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
      return NFT_WALLET_ADDRESS_REGEX.test(address);
    });
    _defineProperty(this, "saveCustomerWalletInfo", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(docID, email, walletAddress) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'customerwalletdocs', {
                email: email,
                walletAddress: walletAddress,
                zakekeEnvironment: 2,
                //configurator
                compositionDocID: docID
              });
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x6, _x7, _x8) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setCopyrightMessageAccepted", function (copyrightMandatoryCheckbox) {
      try {
        if (copyrightMandatoryCheckbox) window.localStorage.setItem(_this.copyrightMessageLocalStorageKey, copyrightMandatoryCheckbox.toString());else window.localStorage.removeItem(_this.copyrightMessageLocalStorageKey);
      } catch (e) {}
    });
    _defineProperty(this, "getCopyrightMessageAccepted", function () {
      var copyrightMessageAccepted = false;
      try {
        copyrightMessageAccepted = window.localStorage.getItem(_this.copyrightMessageLocalStorageKey) ? true : false;
      } catch (e) {}
      return copyrightMessageAccepted;
    });
    /**
     * @private
     */
    _defineProperty(this, "boot", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(parameters) {
        var _this$zkProduct2;
        var staticTranslations, dynamicTranslations, composerModels, statusID, event, _this$zkScene, _this$zkScene$get$get7, _this$zkScene4, _this$zkScene4$get, _this$zkScene4$get$ge, _this$zkScene$get$get8, _this$zkScene5, _this$zkScene5$get, _this$zkScene5$get$ge, _this$zkScene6, _this$zkScene8, _this$zkScene8$getTry, _tryOnSettings$typeSe, _this$zkScene2, _this$zkScene2$get, _this$zkScene$get$get, _this$zkScene$get, _this$zkScene$get$get2, _this$zkScene$get$get3, _this$zkScene$get2, _this$zkScene3, _this$zkScene3$get, _this$zkScene$get$get4, _this$zkScene$get3, _this$zkScene$get3$ge, _this$zkScene$get$get5, _this$zkScene$get4, _this$zkScene$get4$ge, _this$zkScene$get$get6, _this$zkScene$get5, _this$zkScene$get5$ge, promises, tryonPromises, tryOnSettings;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!_this.booted) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return");
            case 2:
              _this.booted = true;
              _this.parseParameters(parameters);
              (0,_api__WEBPACK_IMPORTED_MODULE_4__.setupApi)(_this.culture, _this.token);
              _context15.next = 7;
              return _this.loadLocalization();
            case 7:
              _context15.next = 9;
              return _this.getSettings();
            case 9:
              _this.settings = _context15.sent;
              _this.copyrightMessageLocalStorageKey = _this.settings.userID + '_copyright_accepted';
              _this.eventMessages = _this.settings.eventMessages.map(function (message) {
                return ___WEBPACK_IMPORTED_MODULE_2__.EventMessage.fromMessage(message);
              });
              console.log(_this.eventMessages, 'eventMessages');
              _this.nftSettings = _this.settings.nftSettings;
              _this.isAIEnabled = _this.settings.additionalFeatures.aiPoweredTools;
              _this.trigger('change');
              _context15.next = 18;
              return _this.getTranslations();
            case 18:
              _this.internalTranslations = _context15.sent;
              staticTranslations = new Map(_this.internalTranslations.statics.map(function (staticTranslation) {
                return [staticTranslation.original, staticTranslation.localization];
              }));
              dynamicTranslations = new Map(_this.internalTranslations.dynamics.map(function (staticTranslation) {
                return [staticTranslation.original, staticTranslation.localization];
              }));
              _this.translations = {
                statics: staticTranslations,
                dynamics: dynamicTranslations
              };
              _helpers__WEBPACK_IMPORTED_MODULE_7__.T.translations = _this.translations;
              _this.trigger('change');
              _context15.next = 26;
              return _this.getComposerModels();
            case 26:
              composerModels = _context15.sent;
              if (!composerModels.get('scene').get('config')) composerModels.set('config', composerModels.get('model').get('sceneConfig'));
              _this.zkScene = composerModels.get('scene');
              _this.zkProduct = composerModels.get('model');
              statusID = (_this$zkProduct2 = _this.zkProduct) === null || _this$zkProduct2 === void 0 ? void 0 : _this$zkProduct2.get('statusID');
              console.log('sono prima del customEvent', statusID);
              if (!(statusID === 2 && _this.zkScene && _this.zkScene.get('url') && _this.zkScene.get('url').endsWith('.glb') || statusID === 2 && !_this.isShoppingPreview)) {
                _context15.next = 38;
                break;
              }
              console.log('Product unpublished, triggering event');
              event = new CustomEvent('productUnpublished', {
                detail: {
                  statusID: statusID
                }
              });
              window.dispatchEvent(event);
              _context15.next = 80;
              break;
            case 38:
              // fill the uiconfig with zkscene config url loader and ar icon
              if ((_this$zkScene = _this.zkScene) !== null && _this$zkScene !== void 0 && _this$zkScene.get('config')) {
                console.log('fill UIconfig and animations');
                if ((_this$zkScene2 = _this.zkScene) !== null && _this$zkScene2 !== void 0 && (_this$zkScene2$get = _this$zkScene2.get('config')) !== null && _this$zkScene2$get !== void 0 && _this$zkScene2$get.get('uiConfig')) _this.uiConfig = {
                  urlLoader: (_this$zkScene$get$get = (_this$zkScene$get = _this.zkScene.get('config')) === null || _this$zkScene$get === void 0 ? void 0 : (_this$zkScene$get$get2 = _this$zkScene$get.get('uiConfig')) === null || _this$zkScene$get$get2 === void 0 ? void 0 : _this$zkScene$get$get2.get('urlLoader')) !== null && _this$zkScene$get$get !== void 0 ? _this$zkScene$get$get : '',
                  urlARIcon: (_this$zkScene$get$get3 = (_this$zkScene$get2 = _this.zkScene.get('config')) === null || _this$zkScene$get2 === void 0 ? void 0 : _this$zkScene$get2.get('uiConfig').get('urlARIcon')) !== null && _this$zkScene$get$get3 !== void 0 ? _this$zkScene$get$get3 : ''
                };
                if ((_this$zkScene3 = _this.zkScene) !== null && _this$zkScene3 !== void 0 && (_this$zkScene3$get = _this$zkScene3.get('config')) !== null && _this$zkScene3$get !== void 0 && _this$zkScene3$get.get('animations')) _this.animationsConfig = {
                  runAtStart: (_this$zkScene$get$get4 = (_this$zkScene$get3 = _this.zkScene.get('config')) === null || _this$zkScene$get3 === void 0 ? void 0 : (_this$zkScene$get3$ge = _this$zkScene$get3.get('animations')) === null || _this$zkScene$get3$ge === void 0 ? void 0 : _this$zkScene$get3$ge.get('runAtStart')) !== null && _this$zkScene$get$get4 !== void 0 ? _this$zkScene$get$get4 : false,
                  loop: (_this$zkScene$get$get5 = (_this$zkScene$get4 = _this.zkScene.get('config')) === null || _this$zkScene$get4 === void 0 ? void 0 : (_this$zkScene$get4$ge = _this$zkScene$get4.get('animations')) === null || _this$zkScene$get4$ge === void 0 ? void 0 : _this$zkScene$get4$ge.get('loop')) !== null && _this$zkScene$get$get5 !== void 0 ? _this$zkScene$get$get5 : false,
                  speed: (_this$zkScene$get$get6 = (_this$zkScene$get5 = _this.zkScene.get('config')) === null || _this$zkScene$get5 === void 0 ? void 0 : (_this$zkScene$get5$ge = _this$zkScene$get5.get('animations')) === null || _this$zkScene$get5$ge === void 0 ? void 0 : _this$zkScene$get5$ge.get('speed')) !== null && _this$zkScene$get$get6 !== void 0 ? _this$zkScene$get$get6 : 1
                };
              }
              _this.backgroundColor = (_this$zkScene$get$get7 = (_this$zkScene4 = _this.zkScene) === null || _this$zkScene4 === void 0 ? void 0 : (_this$zkScene4$get = _this$zkScene4.get('config')) === null || _this$zkScene4$get === void 0 ? void 0 : (_this$zkScene4$get$ge = _this$zkScene4$get.get('general')) === null || _this$zkScene4$get$ge === void 0 ? void 0 : _this$zkScene4$get$ge.get('backgroundColor')) !== null && _this$zkScene$get$get7 !== void 0 ? _this$zkScene$get$get7 : null;
              _this.removeBackground = (_this$zkScene$get$get8 = (_this$zkScene5 = _this.zkScene) === null || _this$zkScene5 === void 0 ? void 0 : (_this$zkScene5$get = _this$zkScene5.get('config')) === null || _this$zkScene5$get === void 0 ? void 0 : (_this$zkScene5$get$ge = _this$zkScene5$get.get('general')) === null || _this$zkScene5$get$ge === void 0 ? void 0 : _this$zkScene5$get$ge.get('removeDefaultBackground')) !== null && _this$zkScene$get$get8 !== void 0 ? _this$zkScene$get$get8 : false;
              if ((_this$zkScene6 = _this.zkScene) !== null && _this$zkScene6 !== void 0 && _this$zkScene6.get('config')) _this.product = _models__WEBPACK_IMPORTED_MODULE_11__.Product.fromProduct(_this.zkProduct);
              _this.quantityRule = _this.zkProduct.get('quantityRule') ? _models__WEBPACK_IMPORTED_MODULE_11__.ProductQuantityRule.fromQuantityRule(_this.zkProduct.get('quantityRule')) : null;
              promises = [_this.getSettings(), _this.getTranslations(), (0,_integrations_helpers__WEBPACK_IMPORTED_MODULE_10__.integrationFor)(_this.platform), _this.getSellerSetting(), _this.getTemplateMacroCategories(), _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(_this.zkProduct, Zakeke.config.baseApiUrl, _this.token, true, Zakeke.config.cloudFlareApiUrl), _this.getFonts(), _this.getTemplates(), _this.getMessagesByProductCode(_this.productCode)];
              if (_this.zkScene && _this.zkScene.get('config') && _this.zkScene.getTryOnEnabled()) {
                tryonPromises = [_this.getTryOnProvidersList(), _this.getTryOnProductInfo()];
                promises.push.apply(promises, tryonPromises);
              }
              _context15.next = 47;
              return Promise.all(promises).then(function (_ref16) {
                var _this$zkScene$get$map, _this$zkScene7;
                var _ref17 = _slicedToArray(_ref16, 9),
                  customizerInfo = _ref17[0],
                  translations = _ref17[1],
                  integration = _ref17[2],
                  sellerSettings = _ref17[3],
                  templateMacroCategories = _ref17[4],
                  pricingCalculator = _ref17[5],
                  fonts = _ref17[6],
                  zkTemplates = _ref17[7],
                  personalizedMessages = _ref17[8];
                _this.settings = customizerInfo;
                _this.copyrightMessageLocalStorageKey = _this.settings.userID + '_copyright_accepted';
                _this.eventMessages = _this.settings.eventMessages.map(function (message) {
                  return ___WEBPACK_IMPORTED_MODULE_2__.EventMessage.fromMessage(message);
                });
                _this.nftSettings = _this.settings.nftSettings;
                _this.internalTranslations = translations;
                console.log(personalizedMessages, 'personalizedMessages');
                _this.personalizedMessages = personalizedMessages;
                var staticTranslations = new Map(_this.internalTranslations.statics.map(function (staticTranslation) {
                  return [staticTranslation.original, staticTranslation.localization];
                }));
                var dynamicTranslations = new Map(_this.internalTranslations.dynamics.map(function (staticTranslation) {
                  return [staticTranslation.original, staticTranslation.localization];
                }));
                _this.translations = {
                  statics: staticTranslations,
                  dynamics: dynamicTranslations
                };
                _helpers__WEBPACK_IMPORTED_MODULE_7__.T.translations = _this.translations;
                _this.integration = integration;
                _this.sellerSettings = sellerSettings ? _models__WEBPACK_IMPORTED_MODULE_11__.SellerSettings.fromSellerSettings(sellerSettings) : null;
                _this.templateMacroCategories = templateMacroCategories;
                _this.pricingCalculator = pricingCalculator;
                if (_this.zkProduct.get('colors').length > 0) {
                  _this.pricingCalculator.colorID = _this.zkProduct.get('colors').at(0).get('colorID');
                }
                _this.integration.setPricingCalculator(_this.pricingCalculator);
                _this.fonts = fonts;
                var restriction = _this.getPrintingMethodsRestrictions();
                _this.defaultColor = restriction.defaultColor;
                _this.disableTextColors = restriction.disableTextColors;
                _this.textColors = restriction.textColors;
                _this.zkTemplates = zkTemplates;
                _this.templates = _this.zkTemplates.map(function (zkTemplate) {
                  return _models__WEBPACK_IMPORTED_MODULE_11__.Template.fromTemplate(zkTemplate);
                });
                _this.cameras = (_this$zkScene$get$map = (_this$zkScene7 = _this.zkScene) === null || _this$zkScene7 === void 0 ? void 0 : _this$zkScene7.get('cameraLocations').map(function (x) {
                  return _models__WEBPACK_IMPORTED_MODULE_11__.Camera.fromZkCamera(x);
                })) !== null && _this$zkScene$get$map !== void 0 ? _this$zkScene$get$map : [];
                if (_this.tryOnProductSettings) _this.getTryOnSellerInfo(_this.tryOnProductSettings.typeID, _this.tryOnProductSettings.providerID);
              });
            case 47:
              if (_this.zkScene) {
                _context15.next = 49;
                break;
              }
              throw new Error('Product has no 3D scene.');
            case 49:
              if (_this.debugMode) _this.trigger('debugMode');
              _this.trigger('change');
              _context15.next = 53;
              return _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_0__.SceneViewer.createSceneViewerAsync({
                isViewer: _this.isDAMViewer
              });
            case 53:
              _this.viewer = _context15.sent;
              _this.trigger('viewer', _this.viewer);
              _this.viewer.isHologramSource = true;
              _this.viewer.addInfoPointPickedListener(function () {
                _this.isInfoPointContentVisible = true;
                _this.trigger('change');
              });
              _this.viewer.addInfoPointContentHiddenListener(function () {
                _this.isInfoPointContentVisible = false;
                _this.trigger('change');
              });
              _this.viewer.addBeginAssetsLoadingListener(function () {
                _this.isAssetsLoading = true;
                _this.trigger('change');
              });
              _this.viewer.addEndAssetsLoadingListener(function () {
                _this.isAssetsLoading = false;
                _this.trigger('change');
              });
              if (_this.highlightSettings) {
                _this.viewer.highlightColor = _this.highlightSettings.color;
                _this.viewer.highlightSize = _this.highlightSettings.size;
              }
              _this.viewer.setLoadingScreen({
                displayLoadingUI: function displayLoadingUI() {
                  return null;
                },
                hideLoadingUI: function hideLoadingUI() {
                  return null;
                },
                loadingUIBackgroundColor: 'black',
                loadingUIText: 'black'
              });
              _this.viewer.infoPointsManagerStyle = {
                imagePanelStyle: {
                  backgroundColor: 'white',
                  loadingTextColor: '#cccccc',
                  buttonsBorderColor: '#dddddd',
                  buttonsBorderHighlightColor: '#eeeeee',
                  buttonsColor: '#888888',
                  buttonsHighlightColor: '#555555',
                  buttonsIconColor: 'white'
                }
              };

              // Set transparent background
              // this.zkScene.getOrCreateEnvironmentConfig().set('mainColor', '#000000');
              // this.zkScene.getOrCreateGeneralConfig().set('backgroundColor', '#000000');
              // this.zkScene.getOrCreateGeneralConfig().set('backgroundAlpha', 0);

              // Pricing calculator
              _context15.next = 65;
              return _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(_this.zkProduct, Zakeke.config.baseApiUrl, _this.token, true, Zakeke.config.cloudFlareApiUrl);
            case 65:
              _this.pricingCalculator = _context15.sent;
              if (_this.zkProduct.get('colors').length > 0) {
                _this.pricingCalculator.colorID = _this.zkProduct.get('colors').at(0).get('colorID');
                _this.integration.setPricingCalculator(_this.pricingCalculator);
              }
              if (!(_this.zkScene && _this.zkScene.get('url') && _this.zkScene.get('url').endsWith('.glb'))) {
                _context15.next = 72;
                break;
              }
              _context15.next = 70;
              return _this.loadSceneFromGlbUrl(_this.zkScene.get('url'), _this.zkScene.get('config'));
            case 70:
              _context15.next = 74;
              break;
            case 72:
              _context15.next = 74;
              return _this.viewer.loadSceneFromModelAsync(_this.zkProduct, _this.zkScene);
            case 74:
              if (_this.settings.brand) _this.viewer.createBrandLogoButton();
              tryOnSettings = (_this$zkScene8 = _this.zkScene) === null || _this$zkScene8 === void 0 ? void 0 : (_this$zkScene8$getTry = _this$zkScene8.getTryOnSettings) === null || _this$zkScene8$getTry === void 0 ? void 0 : _this$zkScene8$getTry.call(_this$zkScene8);
              if (tryOnSettings !== null && tryOnSettings !== void 0 && (_tryOnSettings$typeSe = tryOnSettings.typeSettings) !== null && _tryOnSettings$typeSe !== void 0 && _tryOnSettings$typeSe.mandatoryPD) _this.isPupillaryDistanceMandatory = true;
              _this.trigger('change');
              _context15.next = 80;
              return _this.handleSceneLoaded();
            case 80:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(this, "buildDeepARSceneGLBUrl", function (config) {
      var finalUrl = Zakeke.config.deepARSettings.url + '?fileUrl=' + encodeURIComponent(_this.zkScene.get('url'));
      var settings = _this.tryOnMeshVisibleSettings || ___WEBPACK_IMPORTED_MODULE_2__.DefaultDeepARFineTuningSettings;
      var model = config.model;
      var queryParams = new URLSearchParams({
        positionX: settings.position.x.toString(),
        positionY: settings.position.y.toString(),
        positionZ: settings.position.z.toString(),
        rotationX: config.model.rotation.x.toString(),
        rotationY: config.model.rotation.y.toString(),
        rotationZ: config.model.rotation.z.toString(),
        scale: settings.scale.toString(),
        environment: settings.environment.toString(),
        modelPositionX: model.position.x.toString(),
        modelPositionY: model.position.y.toString(),
        modelPositionZ: model.position.z.toString(),
        modelScale: model.scale.x.toString()
      });
      console.log('buildDeepARSceneGLBUrl con nuovi param model ', model.position.x, model.position.y, model.position.z, model.scale.x);
      finalUrl = "".concat(finalUrl, "&").concat(queryParams.toString(), "&isDesktopDeepARUrl=true");
      console.log('sono finalUrl', finalUrl);
      return finalUrl;
    });
    _defineProperty(this, "loadSceneFromGlbUrl", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(glbUrl, sceneConfig) {
        var config;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              config = sceneConfig.toJSON();
              console.log(config, 'config scena');
              _this.deepARsceneGLBUrl = _this.buildDeepARSceneGLBUrl(config);
              _context16.next = 5;
              return _this.viewer.loadFromGlbUrl(glbUrl, config);
            case 5:
              if (_this.isDAMViewer) {
                _this.makeDAMAnalyticsView(_models__WEBPACK_IMPORTED_MODULE_11__.DAMViewerAnalyticsEventType.ViewProduct);
              }
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      return function (_x10, _x11) {
        return _ref18.apply(this, arguments);
      };
    }());
    _defineProperty(this, "appendViewer", function (container) {
      if (_this.viewer) _this.viewer.appendTo(container);
      _this.viewer.updateView(true, true);
    });
    _defineProperty(this, "setHighlightSettings", function (settings) {
      _this.highlightSettings = settings;
      if (_this.viewer) {
        _this.viewer.highlightColor = settings.color;
        _this.viewer.highlightSize = settings.size;
      }
    });
    /*public renderDesign = _.throttle(async () => {
    	if (this.viewer && this.zkCurrentTemplate) {
    		await this.viewer.renderDesignAsync(this.zkCurrentTemplate);
    		this.fireItemsChange();
    	}
    }, 300);*/
    _defineProperty(this, "renderDesign", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (!(_this.viewer && _this.zkCurrentTemplate)) {
              _context17.next = 4;
              break;
            }
            _context17.next = 3;
            return _this.viewer.renderDesignAsync(_this.zkCurrentTemplate);
          case 3:
            _this.debouncedChange();
          case 4:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    })));
    _defineProperty(this, "debouncedChange", (0,lodash__WEBPACK_IMPORTED_MODULE_1__.debounce)(function () {
      return _this.trigger('change');
    }, 300));
    _defineProperty(this, "restoreLastCameraLocation", function () {
      if (!_this.viewer) return;

      //this.viewer.updateView(false);

      // Restore last camera location
      if (_this.lastCameraLocation && _this.lastCameraLocation !== Zakeke.getEmptyUUID()) {
        console.log('Restoring last camera location ' + _this.lastCameraLocation + ' ...');
        _this.setCamera(_this.lastCameraLocation, false, false);
      } else {
        _this.viewer.adjustCamera(false);
      }
    });
    _defineProperty(this, "buildRecapProps", lodash__WEBPACK_IMPORTED_MODULE_1___default().debounce(function (selectedOptions) {
      if (!_this.sellerSettings || !_this.sellerSettings.isCompositionRecapEnabled) return;
      var storeAttr = _this.zkProduct.get('attributes');
      var storeGroups = _this.zkProduct.get('attributeGroups');
      var storeSteps = _this.zkProduct.get('attributeSteps');
      var recapProps = {};
      selectedOptions.forEach(function (item) {
        var _this$selection;
        var currentAttr = storeAttr.find(function (attr) {
          return attr.get('attributeID') == item.attributeID;
        });
        var currentOption = currentAttr.get('options').find(function (opt) {
          return opt.get('optionID') == item.optionID;
        });
        var currentGroup = storeGroups.find(function (group) {
          return group.get('groupID') == currentAttr.get('groupID');
        });
        var currentStep = storeSteps.find(function (step) {
          return step.get('stepID') == currentAttr.get('stepID');
        });
        var label = '';
        var isOptionEnabled = false;
        (_this$selection = _this.selection) === null || _this$selection === void 0 ? void 0 : _this$selection.get('groups').each(function (group) {
          group.get('attributes').each(function (attr) {
            var option = attr.get('options').find(function (x) {
              return x.get('optionID') == currentOption.get('optionID');
            });
            if (option && attr.get('enabled')) {
              var _currentGroup$get, _currentStep$get, _currentAttr$get, _currentOption$get;
              isOptionEnabled = _this.isOptionEnabled(currentOption.get('optionID'));
              label = group.get('groupID') !== -1 ? _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(group.get('name')) + ' ' + _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get('name')) : _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get('name'));
              recapProps["".concat(label)] = {
                groupDisplayOrder: (_currentGroup$get = currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.get('displayOrder')) !== null && _currentGroup$get !== void 0 ? _currentGroup$get : 0,
                stepDisplayOrder: (_currentStep$get = currentStep === null || currentStep === void 0 ? void 0 : currentStep.get('displayOrder')) !== null && _currentStep$get !== void 0 ? _currentStep$get : 0,
                attributeDisplayOrder: (_currentAttr$get = currentAttr === null || currentAttr === void 0 ? void 0 : currentAttr.get('displayOrder')) !== null && _currentAttr$get !== void 0 ? _currentAttr$get : 0,
                optionDisplayOrder: (_currentOption$get = currentOption === null || currentOption === void 0 ? void 0 : currentOption.get('displayOrder')) !== null && _currentOption$get !== void 0 ? _currentOption$get : 0,
                value: _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentOption.get('name'))
              };
            }
          });
        });
      });
      _this.currentAttributesSelection = recapProps;
    }, 200));
    _defineProperty(this, "updateRecapAndExtensionField", function () {
      var _this$selection2;
      var selectedOptions = [];
      (_this$selection2 = _this.selection) === null || _this$selection2 === void 0 ? void 0 : _this$selection2.getAllAttributeSelections().forEach(function (attribute) {
        attribute.get('options').forEach(function (option) {
          if (option.get('selected')) {
            selectedOptions.push({
              attributeID: option.get('attributeID'),
              optionID: option.get('optionID')
            });
          }
        });
      });
      _this.getCurrentExtensionFields(selectedOptions);
      _this.buildRecapProps(selectedOptions);
      _this.trigger('change');
    });
    _defineProperty(this, "getCurrentExtensionFields", function (options) {
      var propsValues = [];
      var propsMap = {};
      var storeAttr = _this.zkProduct.get('attributes');
      options.forEach(function (item) {
        var currentAttr = storeAttr.find(function (attr) {
          return attr.get('attributeID') == item.attributeID;
        });
        var currentOption = currentAttr.get('options').find(function (opt) {
          return opt.get('optionID') == item.optionID;
        });
        if (currentOption.get('extensionFields').length) {
          currentOption.get('extensionFields').forEach(function (item) {
            if (propsValues.length === 0 || propsValues.indexOf(item.name) == -1) {
              propsValues.push(item.name);
              propsMap[item.name] = {
                value: 0,
                label: item.label,
                formatString: item.formatString
              };
            }
            var val;
            if (item.dataTypeID === _models__WEBPACK_IMPORTED_MODULE_11__.ExtensionFieldDataType.Integer) {
              val = parseInt(item.value);
            } else {
              val = parseFloat(item.value);
            }
            propsMap[item.name].value += val;
          });
        }
      });
      var itemsArray = Object.keys(propsMap).map(function (key) {
        return propsMap[key];
      });
      _this.additionalCustomProperties = itemsArray;
    });
    _defineProperty(this, "handleSceneLoaded", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      var currentCompositionId, _this$sellerSettings, _this$sellerSettings2;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            // window.addEventListener('resize', this.resize);

            console.log('Scene loaded');
            _this.selection = Zakeke.ComposerSelection.CreateComposerSelection(_this.zkProduct);
            currentCompositionId = _this.templateId || _this.draftCompositionDocId || _this.sharedCompositionDocId || _this.compositionId;
            if (_this.initialSelection == undefined) {
              _this.initialSelection = _this.cloneSelection(_this.selection);
            }
            _context18.next = 6;
            return _this.internalLoadComposition(currentCompositionId);
          case 6:
            _this.trigger('change');
            _this.buildStructure();

            // Trigger quantity update
            _this.setQuantity(_this.quantity);
            _this.renderDesign();
            _this.viewer.addNotifyMessageListener(function (areaID, itemGuid, type, title, message, closabled, requiredWidth, requiredHeight, addToCartDisabledIfVisible) {
              _this.visibleEventMessages.push({
                areaID: areaID,
                itemGuid: itemGuid,
                type: type,
                title: title,
                message: message,
                closabled: closabled,
                requiredWidth: requiredWidth,
                requiredHeight: requiredHeight,
                addToCartDisabledIfVisible: addToCartDisabledIfVisible
              });
              _this.trigger('change');
            });
            _this.viewer.addRemoveMessageListener(function (areaID, itemGuid) {
              _this.visibleEventMessages = _this.visibleEventMessages.filter(function (x) {
                return x.areaID !== areaID && x.itemGuid !== itemGuid;
              });
              _this.trigger('change');
            });
            _this.viewer.setEventMessages(_this.settings.eventMessages.map(function (x) {
              return {
                AddToCartDisabledIfVisible: x.addToCartDisabledIfVisible,
                AdditionalData: x.additionalData,
                Closeable: x.closeable,
                Description: x.description,
                EnableCheckForSellerImages: x.enableCheckForSellerImages,
                EventID: x.eventID,
                Visible: x.visible
              };
            }));
            if (_this.sellerSettings) {
              _this.addHotjarScript((_this$sellerSettings = _this.sellerSettings) === null || _this$sellerSettings === void 0 ? void 0 : _this$sellerSettings.hotjarSiteID);
              _this.addGoogleTagManagerID((_this$sellerSettings2 = _this.sellerSettings) === null || _this$sellerSettings2 === void 0 ? void 0 : _this$sellerSettings2.googleTagManagerID);
            }
            if (_this.sharedCompositionDocId) {
              _this.composition.set('docID', null);
              _this.composition.set('designDocID', null);
            }
            _this.registerView();
            if (_this.isTemplateEditor) {
              _context18.next = 19;
              break;
            }
            _context18.next = 19;
            return _this.updateSavedCompositions();
          case 19:
            setTimeout(function () {
              return _this.updateRecapAndExtensionField();
            }, 1000);
          case 20:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    })));
    _defineProperty(this, "getComposition", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(id) {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", new Promise(function (resolve, reject) {
                var composition = new MPlaza.Composition();
                composition.set('docID', id);
                composition.fetch({
                  success: function success(model) {
                    resolve(model);
                  },
                  error: function error() {
                    reject();
                  },
                  data: {
                    frombackoffice: _this.isDraftEditor ? true : false
                  }
                });
              }));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x12) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getDesign", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(id) {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", new Promise(function (resolve, reject) {
                var design = new MPlaza.Design();
                design.set('docID', id);
                design.fetch({
                  success: function success(model) {
                    resolve(model);
                  },
                  error: function error() {
                    reject();
                  },
                  data: {
                    frombackoffice: _this.isDraftEditor ? true : false
                  }
                });
                design.addEventListener('change', _this.updatePrice);
              }));
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x13) {
        return _ref22.apply(this, arguments);
      };
    }());
    _defineProperty(this, "internalLoadDesign", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21(id) {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return _this.getDesign(_this.composition.get('designDocID'));
            case 2:
              _this.zkCurrentTemplate = _context21.sent;
              _context21.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(_this.zkCurrentTemplate, _this.fonts);
            case 5:
              _this.renderDesign();
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return function (_x14) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(this, "loadComposition", /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(id) {
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return _this.internalLoadComposition(id);
            case 2:
              _this.buildStructure();
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }));
      return function (_x15) {
        return _ref24.apply(this, arguments);
      };
    }());
    _defineProperty(this, "internalLoadComposition", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24(id) {
        var _iterator3, _step3, _loop;
        return _regeneratorRuntime().wrap(function _callee24$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              console.log('Loading composition ' + id + '...');
              // Get or create a new composition
              if (!id) {
                _context25.next = 14;
                break;
              }
              _context25.next = 4;
              return _this.getComposition(id);
            case 4:
              _this.composition = _context25.sent;
              if (_this.templateId) {
                _this.loadedComposition = {
                  templateName: _this.composition.get('name'),
                  attributesOptions: _this.composition.get('compositionItems').map(function (compositionItem) {
                    return {
                      attributeID: compositionItem.get('attributeID'),
                      optionID: compositionItem.get('selectedOptionID')
                    };
                  }),
                  selectedCategoryID: _this.composition.get('categories').length > 0 ? _this.composition.get('categories').at(0).get('categoryID') : null
                };
              }
              _this.selection.setupOnComposition(_this.composition);
              _context25.next = 9;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 9:
              _this.updateRecapAndExtensionField();
              _this.updateComposition();
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
                return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      if (!_this.composition.get('designDocID')) {
                        _context23.next = 5;
                        break;
                      }
                      _context23.next = 3;
                      return _this.internalLoadDesign(_this.composition.get('designDocID'));
                    case 3:
                      _context23.next = 8;
                      break;
                    case 5:
                      if (!(_this.templates.length > 0)) {
                        _context23.next = 8;
                        break;
                      }
                      _context23.next = 8;
                      return _this.setTemplate(_this.templates[0].id);
                    case 8:
                    case "end":
                      return _context23.stop();
                  }
                }, _callee23);
              })), 1000);
              _context25.next = 38;
              break;
            case 14:
              _this.composition = _this.selection.buildComposition();
              // Select initial values from platform
              _iterator3 = _createForOfIteratorHelper(_this.platformAttributesSelection);
              _context25.prev = 16;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var platformSelection;
                return _regeneratorRuntime().wrap(function _loop$(_context24) {
                  while (1) switch (_context24.prev = _context24.next) {
                    case 0:
                      platformSelection = _step3.value;
                      // Search the attribute
                      _this.zkProduct.get('attributes').each(function (attribute) {
                        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attribute.get('attributeCode'))) {
                          try {
                            if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(attribute.get('attributeCode')), JSON.parse(platformSelection.attributeCode))) {
                              var option = attribute.get('options').find(function (option) {
                                return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(option.get('optionCode')), JSON.parse(platformSelection.optionCode));
                              });
                              if (option) {
                                _this.selection.selectAttributeValue(attribute.get('attributeID'), option.get('optionID').toString());

                                // Update here the labels because events are not attached yet (attached below)
                                platformSelection.attributeLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(attribute.get('name'));
                                platformSelection.optionLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(option.get('name'));
                              }
                            }
                          } catch (ex) {
                            console.error('Failed parsing attribute from data:', platformSelection);
                            console.error(ex);
                          }
                        }
                      });
                    case 2:
                    case "end":
                      return _context24.stop();
                  }
                }, _loop);
              });
              _iterator3.s();
            case 19:
              if ((_step3 = _iterator3.n()).done) {
                _context25.next = 23;
                break;
              }
              return _context25.delegateYield(_loop(), "t0", 21);
            case 21:
              _context25.next = 19;
              break;
            case 23:
              _context25.next = 28;
              break;
            case 25:
              _context25.prev = 25;
              _context25.t1 = _context25["catch"](16);
              _iterator3.e(_context25.t1);
            case 28:
              _context25.prev = 28;
              _iterator3.f();
              return _context25.finish(28);
            case 31:
              if (!(_this.templates.length > 0)) {
                _context25.next = 34;
                break;
              }
              _context25.next = 34;
              return _this.setTemplate(_this.templates[0].id);
            case 34:
              _context25.next = 36;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 36:
              _this.updateComposition();
              _this.updateRecapAndExtensionField();
            case 38:
            case "end":
              return _context25.stop();
          }
        }, _callee24, null, [[16, 25, 28, 31]]);
      }));
      return function (_x16) {
        return _ref25.apply(this, arguments);
      };
    }());
    _defineProperty(this, "sync3DAndPlatformSelectionWithCurrentSelection", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      var script;
      return _regeneratorRuntime().wrap(function _callee25$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            // Add all composition attributes to the platformAttributes that we will send to the plugin
            _this.selection.get('groups').each(function (group) {
              group.get('attributes').each(function (attribute) {
                // Here we check if this attributes was already passed from the parameters.
                // If yes, we ignore it because the correct value was already selected in the previous rows.
                // else we add it to the list of attributes selections

                var oldAttribute = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
                });
                if (!oldAttribute) {
                  var selectedOption = attribute.get('options').findWhere({
                    selected: true
                  });
                  if (selectedOption) _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(attribute.get('attributeCode'), selectedOption.get('optionCode'), _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(attribute.get('name')), _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(selectedOption.get('name')), attribute.get('enabled'), selectedOption.get('enabled')));
                }
              });
            });
            script = _this.selection.getAllAttributeTransformationScript();
            _this.viewer.adjustCamera(false);
            _context26.next = 5;
            return _this.viewer.executeScriptAsync(script);
          case 5:
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
          case 10:
          case "end":
            return _context26.stop();
        }
      }, _callee25);
    })));
    _defineProperty(this, "cloneSelection", function (selection) {
      var clone = new Zakeke.ComposerSelection();
      clone.set('zkModel', _this.zkProduct);
      clone.set('attributeDependencies', selection.get('attributeDependencies'));
      clone.set('optionDependencies', selection.get('optionDependencies'));
      clone.get('groups').reset();
      selection.get('groups').each(function (group) {
        var cloneGroup = new Zakeke.AttributeGroupSelection();
        for (var key in group.attributes) {
          cloneGroup.set(key, group.attributes[key]);
        }
        clone.get('groups').add(cloneGroup);
      });
      var idx = 0;
      clone.get('groups').each(function (group) {
        group.set('attributes', selection.get('groups').at(idx).get('attributes').clone());
        group.get('attributes').reset();
        selection.get('groups').at(idx).get('attributes').each(function (attribute) {
          var cloneAttribute = new Zakeke.AttributeSelection();
          for (var key in attribute.attributes) {
            cloneAttribute.set(key, attribute.attributes[key]);
          }
          group.get('attributes').add(cloneAttribute);
        });
        var idx2 = 0;
        group.get('attributes').each(function (attribute) {
          attribute.set('options', selection.get('groups').at(idx).get('attributes').at(idx2).get('options').clone());
          attribute.get('options').reset();
          selection.get('groups').at(idx).get('attributes').at(idx2).get('options').each(function (option) {
            var cloneOption = new Zakeke.OptionSelection();
            for (var key in option.attributes) {
              cloneOption.set(key, option.attributes[key]);
            }
            attribute.get('options').add(cloneOption);
          });
          idx2++;
        });
        idx++;
      });
      return clone;
    });
    _defineProperty(this, "undo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      var selection, script;
      return _regeneratorRuntime().wrap(function _callee26$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            selection = _this.undoStack && _this.undoStack.length > 0 ? _this.undoStack.pop() : null;
            if (selection) {
              _context27.next = 3;
              break;
            }
            return _context27.abrupt("return");
          case 3:
            _this.redoStack.push(_this.selection);
            _this.selection = selection;
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            _this.selection.attachEvents();
            script = _this.selection.getAllAttributeTransformationScript();
            _context27.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.resetPlatformAttributesSelection();
            _this.updateComposition();
            _this.updateRecapAndExtensionField();
          case 18:
          case "end":
            return _context27.stop();
        }
      }, _callee26);
    })));
    _defineProperty(this, "redo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
      var selection, script;
      return _regeneratorRuntime().wrap(function _callee27$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            selection = _this.redoStack && _this.redoStack.length > 0 ? _this.redoStack.pop() : null;
            if (selection) {
              _context28.next = 3;
              break;
            }
            return _context28.abrupt("return");
          case 3:
            _this.undoStack.push(_this.selection);
            _this.selection = selection;
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            _this.selection.attachEvents();
            script = _this.selection.getAllAttributeTransformationScript();
            _context28.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.resetPlatformAttributesSelection();
            _this.updateComposition();
            _this.updateRecapAndExtensionField();
          case 18:
          case "end":
            return _context28.stop();
        }
      }, _callee27);
    })));
    /**
     * Reset the platform attributes selection to the current selection
     */
    _defineProperty(this, "resetPlatformAttributesSelection", function () {
      _this.selection.get('groups').each(function (group) {
        group.get('attributes').each(function (attribute) {
          var resetAttribute = _this.platformAttributesSelection.find(function (x) {
            return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
          });
          if (resetAttribute) {
            var selectedOption = attribute.get('options').findWhere({
              selected: true
            });
            resetAttribute.attributeCode = attribute.get('attributeCode');
            resetAttribute.attributeIsEnabled = attribute.get('enabled');
            resetAttribute.attributeLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(attribute.get('name'));
            resetAttribute.optionCode = selectedOption.get('optionCode');
            resetAttribute.optionLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(selectedOption.get('name'));
            resetAttribute.optionIsEnabled = selectedOption.get('enabled');
          }
        });
      });
    });
    _defineProperty(this, "reset", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
      var script;
      return _regeneratorRuntime().wrap(function _callee28$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            if (_this.initialSelection) {
              _context29.next = 2;
              break;
            }
            return _context29.abrupt("return");
          case 2:
            _this.undoStack = [];
            _this.redoStack = [];
            _this.selection = _this.cloneSelection(_this.initialSelection);
            _this.selection.attachEvents();
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            script = _this.selection.getAllAttributeTransformationScript();
            _context29.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.resetPlatformAttributesSelection();
            _this.updateComposition();
            _this.updateRecapAndExtensionField();
          case 18:
          case "end":
            return _context29.stop();
        }
      }, _callee28);
    })));
    _defineProperty(this, "handleAttributeSelectionChanged", /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee29(e) {
        var attribute, option, platformSelection;
        return _regeneratorRuntime().wrap(function _callee29$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return _this.viewer.executeActionsAsync(e.attributeID, e.selectedValue, e.actions);
            case 2:
              _this.updateComposition();
              attribute = _this.zkProduct.get('attributes').find(function (attribute) {
                return attribute.get('attributeID') == e.attributeID;
              });
              if (attribute) {
                option = attribute.get('options').find(function (option) {
                  return option.get('optionID') == e.selectedValue;
                });
                if (option) {
                  // Change platform selection
                  platformSelection = _this.platformAttributesSelection.find(function (x) {
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
                  });
                  if (platformSelection) {
                    platformSelection.optionCode = option.get('optionCode');
                    platformSelection.optionLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(option.get('name'));
                  }
                  _this.setOptionSelectionEnabled(attribute.get('attributeID'), option.get('optionID'), _this.isOptionEnabled(option.get('optionID')));
                }
              }
              _this.buildStructure();
              _this.renderDesign();
            case 7:
            case "end":
              return _context30.stop();
          }
        }, _callee29);
      }));
      return function (_x17) {
        return _ref31.apply(this, arguments);
      };
    }());
    _defineProperty(this, "handleAttributeEnabled", function (attributeId) {
      _this.updateComposition();
      _this.setAttributeSelectionEnabled(attributeId, true);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeDisabled", function (attributeId) {
      _this.updateComposition();
      _this.setAttributeSelectionEnabled(attributeId, false);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeOptionEnabled", function (attributeId, optionId) {
      _this.updateComposition();
      _this.setOptionSelectionEnabled(attributeId, optionId, true);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeOptionDisabled", function (attributeId, optionId) {
      _this.updateComposition();
      _this.setOptionSelectionEnabled(attributeId, optionId, false);
      _this.buildStructure();
      _this.renderDesign();
    });
    // Set the current attribute platform selection as enabled or not
    _defineProperty(this, "setAttributeSelectionEnabled", function (attributeId, isEnabled) {
      var attribute = _this.zkProduct.get('attributes').find(function (attribute) {
        return attribute.get('attributeID') == attributeId;
      });
      if (attribute) {
        var attributePlatformSelection = _this.platformAttributesSelection.find(function (selection) {
          return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get('attributeCode'));
        });
        if (attributePlatformSelection) {
          attributePlatformSelection.attributeIsEnabled = isEnabled;
        }

        // Set all options as disabled too in platfrom attributes
        attribute.get('options').each(function (option) {
          _this.setOptionSelectionEnabled(attributeId, option.get('optionID'), isEnabled);
        });
      }
    });
    // Set the current option platform selection as enabled or not but only if it's the selected option
    _defineProperty(this, "setOptionSelectionEnabled", function (attributeId, optionId, isEnabled) {
      var attribute = _this.zkProduct.get('attributes').find(function (attribute) {
        return attribute.get('attributeID') == attributeId;
      });
      if (attribute) {
        var option = attribute.get('options').find(function (option) {
          return option.get('optionID') == optionId;
        });
        if (option) {
          var attributePlatformSelection = _this.platformAttributesSelection.find(function (selection) {
            return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get('attributeCode'));
          });
          if (attributePlatformSelection && (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(attributePlatformSelection.optionCode, option.get('optionCode'))) {
            attributePlatformSelection.optionIsEnabled = isEnabled;
          }
        }
      }
      _this.updateRecapAndExtensionField();
    });
    _defineProperty(this, "isOptionEnabled", function (optionId) {
      var enabled = false;
      _this.selection.get('groups').each(function (group) {
        group.get('attributes').each(function (attr) {
          var option = attr.get('options').find(function (x) {
            return x.get('optionID') == optionId;
          });
          if (option) enabled = option.get('enabled');
        });
      });
      return enabled;
    });
    _defineProperty(this, "updateComposition", function () {
      _this.selection.updateComposition(_this.composition);
      _this.updatePrice();
    });
    _defineProperty(this, "_updatePrice", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
      var price, isOutOfStock, result;
      return _regeneratorRuntime().wrap(function _callee30$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            price = 0;
            isOutOfStock = false;
            if (!(_this.composition && _this.zkProduct)) {
              _context31.next = 8;
              break;
            }
            _context31.next = 5;
            return _this.getPrice();
          case 5:
            result = _context31.sent;
            price = result.price;
            isOutOfStock = result.isOutOfStock;
          case 8:
            _this.price = price;
            _this.isOutOfStock = isOutOfStock;
            _this.trigger('change');
          case 11:
          case "end":
            return _context31.stop();
        }
      }, _callee30);
    })));
    _defineProperty(this, "updatePrice", lodash__WEBPACK_IMPORTED_MODULE_1___default().debounce(this._updatePrice, 300));
    _defineProperty(this, "buildStructure", function () {
      var data = [];
      if (_this.selection) {
        for (var i = 0; i < _this.selection.get('groups').length; i++) {
          var group = _this.selection.get('groups').at(i);
          var groupData = _this.createGroupFromSelection(group);
          data.push(groupData);
        }
        data.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
      }
      _this.groups = data;
      _this.trigger('change');
    });
    _defineProperty(this, "createGroupFromSelection", function (groupSelection) {
      var zakekeGroup = _this.zkProduct.get('attributeGroups').get(groupSelection.get('groupID'));
      var imageUrl = zakekeGroup ? zakekeGroup.get('imageUrl') : null;
      var group = new _models__WEBPACK_IMPORTED_MODULE_11__.Group();
      group.id = zakekeGroup ? zakekeGroup.get('groupID') : -1;
      group.guid = zakekeGroup ? zakekeGroup.get('groupGuid') : '-1';
      group.name = zakekeGroup ? zakekeGroup.get('name') : 'Other';
      group.imageUrl = imageUrl;
      group.enabled = true;
      group.cameraLocationId = zakekeGroup ? zakekeGroup.get('sceneCameraLocationID') : null;
      group.steps = _this.zkProduct.get('attributeSteps').filter(function (step) {
        return step.get('groupID') == group.id;
      }).map(function (step) {
        return _this.createStep(step, groupSelection);
      });
      if (zakekeGroup) {
        group.displayOrder = zakekeGroup.get('displayOrder');
        group.direction = zakekeGroup.get('direction');
        group.attributesAlwaysOpened = zakekeGroup.get('attributesAlwaysOpened');
      }
      var _loop2 = function _loop2() {
        var attributeSelection = groupSelection.get('attributes').at(i);
        var zakekeAttribute = _this.zkProduct.get('attributes').find(function (attribute) {
          return attribute.get('attributeID') == attributeSelection.get('attributeID');
        });
        if (zakekeAttribute.get('stepID') == -1) {
          var attribute = _this.createAttributeFromSelection(attributeSelection);
          group.attributes.push(attribute);
        }
      };
      for (var i = 0; i < groupSelection.get('attributes').length; i++) {
        _loop2();
      }
      group.attributes.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });

      // template groups

      var templateGroups = groupSelection === null || groupSelection === void 0 ? void 0 : groupSelection.get('templateGroups');
      if (templateGroups) {
        var _loop3 = function _loop3() {
          var zakekeTemplateGroup = _this.zkProduct.get('templateGroups').at(k);
          var templateGroupSelection = templateGroups.find(function (templGr) {
            return templGr.get('templateGroupID') == zakekeTemplateGroup.get('templateGroupID');
          });
          if (templateGroupSelection && zakekeTemplateGroup.get('stepID') == null) {
            var templateGroup = _this.createTemplateGroupFromSelection(templateGroupSelection);
            group.templateGroups.push(templateGroup);
          }
        };
        for (var k = 0; k < _this.zkProduct.get('templateGroups').length; k++) {
          _loop3();
        }
      }
      group.templateGroups.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return group;
    });
    _defineProperty(this, "createAttributeFromSelection", function (attributeSelection) {
      var zakekeAttribute = _this.zkProduct.get('attributes').get(attributeSelection.get('attributeID'));
      var attribute = new _models__WEBPACK_IMPORTED_MODULE_11__.Attribute();
      attribute.id = zakekeAttribute.get('attributeID');
      attribute.guid = zakekeAttribute.get('attributeGuid');
      attribute.code = zakekeAttribute.get('attributeCode');
      attribute.name = zakekeAttribute.get('name') || '';
      attribute.description = zakekeAttribute.get('description') || '';
      attribute.optionShapeType = zakekeAttribute.get('optionPreviewShapeID') == 1 ? _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Round : _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Square;
      attribute.displayOrder = zakekeAttribute.get('displayOrder');
      attribute.enabled = attributeSelection.get('enabled');
      attribute.groupId = zakekeAttribute.get('groupID');
      attribute.stepId = zakekeAttribute.get('stepID');
      attribute.hideOptionsLabel = zakekeAttribute.get('hideOptionsLabel');
      attribute.cameraLocationId = zakekeAttribute ? zakekeAttribute.get('sceneCameraLocationID') : null;

      // Options
      for (var i = 0; i < attributeSelection.get('options').length; i++) {
        var optionSelection = attributeSelection.get('options').at(i);
        var option = _this.createOptionFromSelection(optionSelection);
        option.attribute = attribute;
        attribute.options.push(option);
      }
      if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Options) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Select;
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Color) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Number) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
        attribute.numberFormat = '';
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.String) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
        attribute.numberFormat = '';
      }
      attribute.options.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return attribute;
    });
    _defineProperty(this, "createOptionFromSelection", function (optionSelection) {
      var zakekeOption = _this.zkProduct.get('attributes').get(optionSelection.get('attributeID')).get('options').get(optionSelection.get('optionID'));
      var option = new _models__WEBPACK_IMPORTED_MODULE_11__.Option();
      var pricings = _this.zkProduct.get('attributes').get(optionSelection.get('attributeID')).get('pricings');
      if (pricings.length > 0) {
        var _pricings$find;
        var optionPrice = (_pricings$find = pricings.find(function (price) {
          return price.get('selectedOptionID') === optionSelection.get('optionID');
        })) === null || _pricings$find === void 0 ? void 0 : _pricings$find.get('price');
        if (optionPrice) option.pricings = [{
          fromQuantity: 0,
          price: optionPrice
        }];
      }
      option.id = zakekeOption.get('optionID');
      option.guid = zakekeOption.get('optionGuid');
      option.code = zakekeOption.get('optionCode');
      option.name = zakekeOption.get('name') || '';
      option.description = zakekeOption.get('description') || '';
      option.imageUrl = zakekeOption.get('imageUrl');
      option.displayOrder = zakekeOption.get('displayOrder');
      option.selected = optionSelection.get('selected');
      option.enabled = optionSelection.get('enabled');
      return option;
    });
    _defineProperty(this, "createTemplateGroupFromSelection", function (templateGroupSelection) {
      var _zakekeTemplateGroup$;
      var zakekeTemplateGroup = _this.zkProduct.get('templateGroups').find(function (templateGroup) {
        return templateGroup.get('templateGroupID') === templateGroupSelection.get('templateGroupID');
      });
      if (!zakekeTemplateGroup) return new ___WEBPACK_IMPORTED_MODULE_2__.ThemeTemplateGroup();
      var templateGroup = new ___WEBPACK_IMPORTED_MODULE_2__.ThemeTemplateGroup();
      templateGroup.templateGroupID = zakekeTemplateGroup.get('templateGroupID');
      templateGroup.name = (_zakekeTemplateGroup$ = zakekeTemplateGroup.get('name')) !== null && _zakekeTemplateGroup$ !== void 0 ? _zakekeTemplateGroup$ : '';
      templateGroup.groupID = zakekeTemplateGroup.get('groupID');
      templateGroup.stepID = zakekeTemplateGroup.get('stepID');
      templateGroup.displayOrder = zakekeTemplateGroup.get('displayOrder');
      var _loop4 = function _loop4() {
        var macroCategorySelection = templateGroupSelection.get('macrocategory').at(i);
        var zakekeMacroCategory = zakekeTemplateGroup.get('macrocategory').find(function (macroCategory) {
          return macroCategory.get('macroCategoryID') === macroCategorySelection.get('macroCategoryID');
        });
        if (!zakekeMacroCategory) return {
          v: templateGroup
        };
        var macroCategory = new ___WEBPACK_IMPORTED_MODULE_2__.ThemeMacroCategory();
        macroCategory.id = zakekeMacroCategory.get('macroCategoryID');
        macroCategory.name = zakekeMacroCategory.get('name');
        var _loop5 = function _loop5() {
          var categorySelection = macroCategorySelection.get('category').at(j);
          var zakekeCategory = zakekeMacroCategory.get('category').find(function (category) {
            return category.get('categoryID') === categorySelection.get('categoryID');
          });
          if (!zakekeCategory) return {
            v: {
              v: templateGroup
            }
          };
          var category = new ___WEBPACK_IMPORTED_MODULE_2__.ThemeCategory();
          category.id = zakekeCategory.get('categoryID');
          category.name = zakekeCategory.get('name');
          var _loop6 = function _loop6() {
            var compositionSelection = categorySelection.get('composition').at(k);
            var zakekeComposition = zakekeCategory.get('composition').find(function (composition) {
              return composition.get('compositionID') === compositionSelection.get('compositionID');
            });
            if (!zakekeComposition) return {
              v: {
                v: {
                  v: templateGroup
                }
              }
            };
            var composition = new ___WEBPACK_IMPORTED_MODULE_2__.TemplateComposition();
            composition.name = zakekeComposition.get('name');
            composition.previewImageUrl = zakekeComposition.get('previewImageUrl');
            composition.compositionID = zakekeComposition.get('compositionID');
            category.composition.push(composition);
          };
          for (k = 0; k < categorySelection.get('composition').length; k++) {
            var _ret3 = _loop6();
            if (_typeof(_ret3) === "object") return _ret3.v;
          }
          macroCategory.category.push(category);
        };
        for (j = 0; j < macroCategorySelection.get('category').length; j++) {
          var _ret2 = _loop5();
          if (_typeof(_ret2) === "object") return _ret2.v;
        }
        templateGroup.macroCategory.push(macroCategory);
      };
      for (var i = 0; i < templateGroupSelection.get('macrocategory').length; i++) {
        var j, k;
        var _ret = _loop4();
        if (_typeof(_ret) === "object") return _ret.v;
      }
      return templateGroup;
    });
    _defineProperty(this, "saveDesignBackbone", /*#__PURE__*/function () {
      var _ref33 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee31(isSharing) {
        return _regeneratorRuntime().wrap(function _callee31$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              return _context32.abrupt("return", new Promise(function (resolve, reject) {
                var design = _this.zkCurrentTemplate;
                if (!design) {
                  resolve();
                  return;
                }
                design.save(null, {
                  success: function success(model) {
                    _this.composition.set('designDocID', model.get('docID'));
                    resolve();
                  },
                  error: function error() {
                    reject();
                  },
                  headers: {
                    fromBackOffice: _this.isDraftEditor ? true : false,
                    isSharing: isSharing ? true : false
                  }
                });
              }));
            case 1:
            case "end":
              return _context32.stop();
          }
        }, _callee31);
      }));
      return function (_x18) {
        return _ref33.apply(this, arguments);
      };
    }());
    _defineProperty(this, "saveCompositionBackbone", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
      return _regeneratorRuntime().wrap(function _callee32$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            return _context33.abrupt("return", new Promise(function (resolve, reject) {
              _this.composition.save(null, {
                success: function success() {
                  resolve();
                },
                error: function error() {
                  reject();
                },
                headers: {
                  fromBackOffice: _this.isDraftEditor ? true : false
                }
              });
            }));
          case 1:
          case "end":
            return _context33.stop();
        }
      }, _callee32);
    })));
    // Events
    _defineProperty(this, "trigger", function (event) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
        params[_key3 - 1] = arguments[_key3];
      }
      var _iterator4 = _createForOfIteratorHelper(_this.events.filter(function (x) {
          return x.event == event;
        })),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var handler = _step4.value;
          if (handler.callback) handler.callback.apply(_this, params);else console.error("Event handler can't be null or undefined");
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
    _defineProperty(this, "on", function (event, callback) {
      _this.events.push(new _models__WEBPACK_IMPORTED_MODULE_11__.ZakekeEvent(event, callback));
    });
    _defineProperty(this, "off", function (event, callback) {
      _this.events = _this.events.filter(function (x) {
        return x.event == event && x.callback == callback;
      });
    });
    _defineProperty(this, "setTemplate", /*#__PURE__*/function () {
      var _ref35 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee33(templateId) {
        return _regeneratorRuntime().wrap(function _callee33$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _this.zkCurrentTemplate = _this.zkTemplates.find(function (x) {
                return x.get('templateDesignID') == templateId;
              });
              _this.currentTemplate = _this.templates.find(function (x) {
                return x.id == templateId;
              }) || null;
              _context34.next = 4;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(_this.zkCurrentTemplate, _this.fonts);
            case 4:
              _this.renderDesign();
            case 5:
            case "end":
              return _context34.stop();
          }
        }, _callee33);
      }));
      return function (_x19) {
        return _ref35.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getTemplateUploadRestrictictions", function (templateId, areaId) {
      var _ref36, _ref37, _getUploadRestriction, _getUploadRestriction2, _getUploadRestriction3, _getUploadRestriction4, _getUploadRestriction5, _getUploadRestriction6, _getUploadRestriction7;
      var design = _this.zkTemplates.find(function (x) {
        return x.get('templateDesignID') == templateId;
      });
      if (!design) throw 'Template does not exists with id ' + templateId;
      var designSide = design.getDesignSide(_this.zkProduct.get('colors').at(0).get('sides').get(areaId));
      var getUploadRestriction = function getUploadRestriction(restriction) {
        var _designSide$get, _design$get;
        if (designSide && designSide.get('uploadRestrictions')) return (_designSide$get = designSide.get('uploadRestrictions')) === null || _designSide$get === void 0 ? void 0 : _designSide$get[restriction];else if (design.get('uploadRestrictions')) (_design$get = design.get('uploadRestrictions')) === null || _design$get === void 0 ? void 0 : _design$get[restriction];else return null;
      };
      var pdfAddonEnabled = (_ref36 = _this.settings.addons.find(function (x) {
        return x.addonName === 'PDF' || x.addonName === 'PDF_EPS';
      }) || _this.settings.isPdfEpsEnabled) !== null && _ref36 !== void 0 ? _ref36 : false;
      var epsAddonEnabled = (_ref37 = _this.settings.addons.find(function (x) {
        return x.addonName === 'EPS' || x.addonName === 'PDF_EPS';
      }) || _this.settings.isPdfEpsEnabled) !== null && _ref37 !== void 0 ? _ref37 : false;
      return {
        isUserImageAllowed: (_getUploadRestriction = getUploadRestriction('isUserImageAllowed')) !== null && _getUploadRestriction !== void 0 ? _getUploadRestriction : true,
        isJpgAllowed: (_getUploadRestriction2 = getUploadRestriction('isJpgAllowed')) !== null && _getUploadRestriction2 !== void 0 ? _getUploadRestriction2 : true,
        isPngAllowed: (_getUploadRestriction3 = getUploadRestriction('isPngAllowed')) !== null && _getUploadRestriction3 !== void 0 ? _getUploadRestriction3 : true,
        isSvgAllowed: (_getUploadRestriction4 = getUploadRestriction('isSvgAllowed')) !== null && _getUploadRestriction4 !== void 0 ? _getUploadRestriction4 : true,
        isPdfAllowed: ((_getUploadRestriction5 = getUploadRestriction('isPdfAllowed')) !== null && _getUploadRestriction5 !== void 0 ? _getUploadRestriction5 : true) && !!pdfAddonEnabled,
        isEpsAllowed: ((_getUploadRestriction6 = getUploadRestriction('isEpsAllowed')) !== null && _getUploadRestriction6 !== void 0 ? _getUploadRestriction6 : true) && !!epsAddonEnabled,
        isPdfWithRasterAllowed: ((_getUploadRestriction7 = getUploadRestriction('isPdfWithRasterAllowed')) !== null && _getUploadRestriction7 !== void 0 ? _getUploadRestriction7 : true) && !!pdfAddonEnabled
      };
    });
    // Get template
    _defineProperty(this, "getTemplates", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
      return _regeneratorRuntime().wrap(function _callee35$(_context36) {
        while (1) switch (_context36.prev = _context36.next) {
          case 0:
            return _context36.abrupt("return", new Promise(/*#__PURE__*/function () {
              var _ref39 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee34(resolve, reject) {
                var templatesList, templates, _iterator5, _step5, _template, template;
                return _regeneratorRuntime().wrap(function _callee34$(_context35) {
                  while (1) switch (_context35.prev = _context35.next) {
                    case 0:
                      _context35.next = 2;
                      return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('designs/templates/' + _this.zkProduct.get('modelID'));
                    case 2:
                      templatesList = _context35.sent.data;
                      templates = []; // Build a new design
                      if (!(templatesList.length > 0)) {
                        _context35.next = 24;
                        break;
                      }
                      _iterator5 = _createForOfIteratorHelper(templatesList[0].categories[0].templates);
                      _context35.prev = 6;
                      _iterator5.s();
                    case 8:
                      if ((_step5 = _iterator5.n()).done) {
                        _context35.next = 16;
                        break;
                      }
                      _template = _step5.value;
                      _context35.next = 12;
                      return _this.getTemplate(_template.designID);
                    case 12:
                      template = _context35.sent;
                      //await downloadFontsOfDesign(template, this.fonts);
                      templates.push(template);
                    case 14:
                      _context35.next = 8;
                      break;
                    case 16:
                      _context35.next = 21;
                      break;
                    case 18:
                      _context35.prev = 18;
                      _context35.t0 = _context35["catch"](6);
                      _iterator5.e(_context35.t0);
                    case 21:
                      _context35.prev = 21;
                      _iterator5.f();
                      return _context35.finish(21);
                    case 24:
                      resolve(templates);
                    case 25:
                    case "end":
                      return _context35.stop();
                  }
                }, _callee34, null, [[6, 18, 21, 24]]);
              }));
              return function (_x20, _x21) {
                return _ref39.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context36.stop();
        }
      }, _callee35);
    })));
    _defineProperty(this, "saveProduct", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
      return _regeneratorRuntime().wrap(function _callee36$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            return _context37.abrupt("return", new Promise(function (resolve, reject) {
              _this.zkProduct && _this.zkProduct.save(null, {
                success: function success(model, response, options) {
                  resolve();
                },
                error: function error(model, response, options) {
                  reject(response);
                }
              });
            }));
          case 1:
          case "end":
            return _context37.stop();
        }
      }, _callee36);
    })));
    // Get single template
    _defineProperty(this, "getTemplate", /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee38(templateId) {
        return _regeneratorRuntime().wrap(function _callee38$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              return _context39.abrupt("return", new Promise(function (resolve, reject) {
                var design = new MPlaza.Design();
                design.set('docID', templateId);
                design.fetch({
                  success: function () {
                    var _success = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
                      return _regeneratorRuntime().wrap(function _callee37$(_context38) {
                        while (1) switch (_context38.prev = _context38.next) {
                          case 0:
                            resolve(design);
                          case 1:
                          case "end":
                            return _context38.stop();
                        }
                      }, _callee37);
                    }));
                    function success() {
                      return _success.apply(this, arguments);
                    }
                    return success;
                  }(),
                  error: function error() {
                    return null;
                  },
                  data: {
                    template: true
                  }
                });
                design.addEventListener('change', _this.updatePrice);
              }));
            case 1:
            case "end":
              return _context39.stop();
          }
        }, _callee38);
      }));
      return function (_x22) {
        return _ref41.apply(this, arguments);
      };
    }());
    // Public methods
    _defineProperty(this, "updateView", function () {
      _this.viewer.updateView();
    });
    _defineProperty(this, "selectOption", function (optionId) {
      var clone = _this.cloneSelection(_this.selection);
      _this.undoStack.push(clone);
      var option;
      var attribute;
      _this.zkProduct.get('attributes').each(function (attr) {
        var _option = attr.get('options').find(function (option) {
          return option.get('optionID') == optionId;
        });
        if (_option) {
          option = _option;
          attribute = attr;
        }
      });
      if (option) {
        // Don' t reselect it.
        if (option.selected) return;
        _this.selection.selectAttributeValue(attribute.get('attributeID'), optionId.toString());
      } else {
        throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Invalid option with id ' + optionId);
      }
    });
    // Focus a group executing some camera movements
    _defineProperty(this, "focusGroup", function (groupId) {
      var sceneGroup = _this.groups.find(function (x) {
        return x.id == groupId;
      });
      if (sceneGroup && sceneGroup.cameraLocationId) {
        _this.viewer.setCameraLocation(sceneGroup.cameraLocationId);
        _this.lastCameraLocation = sceneGroup.cameraLocationId;
      }
    });
    _defineProperty(this, "focusAttribute", /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee39(attributeId) {
        var unselectedOptionsActions, attribute;
        return _regeneratorRuntime().wrap(function _callee39$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              unselectedOptionsActions = _this.selection.getAttributeUnselectedOptionsSceneActions(attributeId);
              _context40.next = 3;
              return _this.viewer.prefetchDataForUnselectedOptionsAsync(unselectedOptionsActions);
            case 3:
              attribute = _this.zkProduct.get('attributes').find(function (attribute) {
                return attribute.get('attributeID') == attributeId;
              });
              if (attribute && attribute.get('sceneCameraLocationID') && attribute.get('sceneCameraLocationID') != Zakeke.getEmptyUUID()) {
                _this.viewer.setCameraLocation(attribute.get('sceneCameraLocationID'));
                _this.lastCameraLocation = attribute.get('sceneCameraLocationID');
              }
            case 5:
            case "end":
              return _context40.stop();
          }
        }, _callee39);
      }));
      return function (_x23) {
        return _ref42.apply(this, arguments);
      };
    }());
    _defineProperty(this, "base64StringToFile", function (base64String, filename) {
      var _arr$0$match$, _arr$, _arr$$match;
      var arr = base64String.split(','),
        mime = (_arr$0$match$ = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : (_arr$$match = _arr$.match(/:(.*?);/)) === null || _arr$$match === void 0 ? void 0 : _arr$$match[1]) !== null && _arr$0$match$ !== void 0 ? _arr$0$match$ : '',
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    });
    _defineProperty(this, "saveTemplate", /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee40(templateName, selectedCategoryID, attributeOptions) {
        var attributes, compositionItems, categories, mapping, _mapping, parsedCategory, templateGroup, group, step, attributesWithoutGroup;
        return _regeneratorRuntime().wrap(function _callee40$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              attributes = Array.from(attributeOptions.keys());
              compositionItems = _this.composition.get('compositionItems');
              compositionItems.toArray().forEach(function (compositionItem) {
                if (!attributes.includes(compositionItem.get('attributeID'))) compositionItems.remove(compositionItem);
              });
              _this.composition.set('name', templateName);
              _this.composition.set('compositionItems', compositionItems);
              _this.composition.set('isTemplate', true);
              categories = new MPlaza.CompositionCategoriesMapping();
              if (selectedCategoryID) {
                mapping = new MPlaza.CompositionCategoryMapping();
                mapping.set('categoryID', selectedCategoryID);
                mapping.set('name', ' ');
                categories.add(mapping);
              } else if (_this.selectedTemplateCategory) {
                try {
                  _mapping = new MPlaza.CompositionCategoryMapping();
                  parsedCategory = _this.selectedTemplateCategory.split(';');
                  _mapping.set('categoryID', Number.parseInt(parsedCategory[0]));
                  _mapping.set('name', parsedCategory[1]);
                  categories.add(_mapping);
                } catch (ex) {
                  console.error('Error while parsing associated category for template', ex, _this.selectedTemplateCategory);
                }
              }
              _this.composition.set('categories', categories);
              if (!(_this.zkProduct.get('templateGroups').length === 0)) {
                _context41.next = 16;
                break;
              }
              templateGroup = new MPlaza.TemplateGroup();
              templateGroup.set('name', 'Pre-set configurations');
              if (_this.zkProduct.get('attributeGroups').length > 0) {
                group = new MPlaza.AttributeGroup();
                group.set('name', 'Pre-set configurations');
                group.set('displayOrder', _this.zkProduct.get('attributeGroups').at(0).get('displayOrder') - 1);
                _this.zkProduct.get('attributeGroups').unshift(group);
                templateGroup.set('groupGuid', group.get('groupGuid'));
              } else {
                if (_this.zkProduct.get('attributeSteps') && _this.zkProduct.get('attributeSteps').length > 0) {
                  step = new MPlaza.AttributeStep();
                  step.set('name', 'Pre-set configurations');
                  step.set('groupGuid', Zakeke.generateUUID());
                  step.set('displayOrder', _this.zkProduct.get('attributeSteps').at(0).get('displayOrder') - 1);
                  _this.zkProduct.get('attributeSteps').unshift(step);
                  templateGroup.set('stepGuid', step.get('stepGuid'));
                } else {
                  attributesWithoutGroup = _this.zkProduct.get('attributes').filter(function (attr) {
                    return attr.get('groupID') === -1;
                  }).sort((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.ascComparator)(function (x) {
                    return x.get('displayOrder');
                  }));
                  if (attributesWithoutGroup.length > 0) templateGroup.set('displayOrder', attributesWithoutGroup[0].get('displayOrder') - 1);
                }
              }
              _this.zkProduct.get('templateGroups').add(templateGroup);
              _context41.next = 16;
              return _this.saveProduct();
            case 16:
              _context41.next = 18;
              return _this.addToCart([], undefined, undefined, undefined);
            case 18:
              _context41.next = 20;
              return _this.reset();
            case 20:
            case "end":
              return _context41.stop();
          }
        }, _callee40);
      }));
      return function (_x24, _x25, _x26) {
        return _ref43.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addToCart", /*#__PURE__*/function () {
      var _ref44 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee41(additionalProperties, onBeforeSendDataToParent, legacyScreenshot, nftForm) {
        var _this$zkScene9;
        var compositionClientPreviews, sortedBuyScreenshotCameras, previewFiles, buyScreenshotCameras, _iterator6, _step6, camera, preview, formData, file, previewCameraFile, previewFile;
        return _regeneratorRuntime().wrap(function _callee41$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return _this.setExplodedMode(false);
            case 2:
              if (_this.pdSettings) _this.composition.set('pdSettings', _this.pdSettings);
              _this.composition.set('compositionClientPreviews', []);
              compositionClientPreviews = [];
              sortedBuyScreenshotCameras = [];
              previewFiles = [];
              buyScreenshotCameras = (_this$zkScene9 = _this.zkScene) === null || _this$zkScene9 === void 0 ? void 0 : _this$zkScene9.get('cameraLocations').filter(function (x) {
                var _x$get;
                return ((_x$get = x.get('name')) === null || _x$get === void 0 ? void 0 : _x$get.toLowerCase().indexOf('buy_screenshot_camera_')) !== -1;
              });
              if (buyScreenshotCameras) sortedBuyScreenshotCameras = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.sortBy)(buyScreenshotCameras, function (a) {
                return a.get('name');
              });
              if (!(sortedBuyScreenshotCameras && sortedBuyScreenshotCameras.length > 0)) {
                _context42.next = 42;
                break;
              }
              _iterator6 = _createForOfIteratorHelper(sortedBuyScreenshotCameras);
              _context42.prev = 11;
              _iterator6.s();
            case 13:
              if ((_step6 = _iterator6.n()).done) {
                _context42.next = 33;
                break;
              }
              camera = _step6.value;
              _context42.next = 17;
              return _this.viewer.getSceneContentScreenshotAsync(_this.clientPreviewWidth, _this.clientPreviewHeight, 0, _this.zkCurrentTemplate, legacyScreenshot, camera);
            case 17:
              preview = _context42.sent;
              formData = new FormData();
              if (preview) {
                _context42.next = 21;
                break;
              }
              return _context42.abrupt("return");
            case 21:
              file = _this.base64StringToFile(preview, camera + '.png');
              formData.set('file', file);
              _context42.next = 25;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'compositions/upload-client-preview', formData);
            case 25:
              previewCameraFile = _context42.sent.data;
              compositionClientPreviews.push({
                fileObjectID: previewCameraFile.id,
                cameraName: camera.get('name'),
                url: previewCameraFile.url
              });
              previewFile = {
                url: previewCameraFile.url,
                cameraName: camera.get('name')
              };
              previewFiles.push(previewFile);
              _context42.next = 31;
              return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            case 31:
              _context42.next = 13;
              break;
            case 33:
              _context42.next = 38;
              break;
            case 35:
              _context42.prev = 35;
              _context42.t0 = _context42["catch"](11);
              _iterator6.e(_context42.t0);
            case 38:
              _context42.prev = 38;
              _iterator6.f();
              return _context42.finish(38);
            case 41:
              _this.composition.set('compositionClientPreviews', compositionClientPreviews);
            case 42:
              if (_this.composition.get('isDraft') && !_this.isDraftEditor) {
                _this.composition.set('docID', null);
                _this.composition.set('designDocID', null);
                _this.composition.set('isDraft', false);
                if (_this.zkCurrentTemplate) _this.zkCurrentTemplate.set('docID', null);
              }
              console.log('previewFiles', previewFiles);
              // Save composition
              _context42.next = 46;
              return _this.saveComposition(undefined, legacyScreenshot);
            case 46:
              if (!nftForm) {
                _context42.next = 49;
                break;
              }
              _context42.next = 49;
              return _this.saveCustomerWalletInfo(_this.composition.get('docID'), nftForm.email, nftForm.walletAddress);
            case 49:
              if (!onBeforeSendDataToParent) {
                _context42.next = 53;
                break;
              }
              _context42.next = 52;
              return onBeforeSendDataToParent({
                composition: _this.composition.id,
                preview: _this.composition.get('previewImageUrl'),
                attributes: _this.platformAttributesSelection,
                designItems: _this.getDesignItemsInfo(),
                quantity: _this.quantity,
                previewFiles: previewFiles,
                additionalProperties: additionalProperties
              });
            case 52:
              additionalProperties = _context42.sent;
            case 53:
              // Add to cart
              _this.integration.addToCart(_this.composition, _this.zkCurrentTemplate, _this.zkProduct, _this.platformAttributesSelection, _this.getDesignItemsInfo(), _this.quantity, additionalProperties, nftForm && _this.settings.ecommerceID === 3 ? _this.nftSettings ? _this.nftSettings.priceToAdd : 0 : 0);
            case 54:
            case "end":
              return _context42.stop();
          }
        }, _callee41, null, [[11, 35, 38, 41]]);
      }));
      return function (_x27, _x28, _x29, _x30) {
        return _ref44.apply(this, arguments);
      };
    }());
    _defineProperty(this, "zoomIn", function () {
      if (_this.viewer) _this.viewer.zoomIn();
    });
    _defineProperty(this, "zoomOut", function () {
      if (_this.viewer) _this.viewer.zoomOut();
    });
    _defineProperty(this, "isFullscreenEnabled", function () {
      return !_helpers__WEBPACK_IMPORTED_MODULE_7__.iOS;
    });
    _defineProperty(this, "switchFullscreen", function () {
      var interval = null;
      _this.viewer.switchFullScreen(document.querySelector('.zakeke-viewer-container'));
      if (!interval) {
        //eslint-disable-next-line
        interval = setInterval(function () {
          if (_this.isFullscreenMode && _this.internalIsFullscreen == false) {
            setTimeout(function () {
              _this.viewer.updateView();
              // doppio resize per mobile
              _this.viewer.updateView();
              _this.internalIsFullscreen = true;
              console.info('Fullscreen enabled');
            }, 10);
          }
          if (!_this.isFullscreenMode && _this.internalIsFullscreen == true) {
            clearInterval(interval);
            interval = null;
            setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
              return _regeneratorRuntime().wrap(function _callee42$(_context43) {
                while (1) switch (_context43.prev = _context43.next) {
                  case 0:
                    _this.internalIsFullscreen = false;

                    // Update layout for two seconds
                    _context43.next = 3;
                    return _this.extendedUpdate();
                  case 3:
                    _this.viewer.updateView();
                    // doppio resize per mobile
                    _this.viewer.updateView();
                    console.info('Fullscreen disabled');
                  case 6:
                  case "end":
                    return _context43.stop();
                }
              }, _callee42);
            })), 10);
          }
        }, 100);
      }
    });
    _defineProperty(this, "openSecondScreen", function () {
      var url = Zakeke.config.baseUrl + 'en/SecondScreen?token=' + _this.token + '&modelID=' + _this.zkProduct.get('modelID');
      window.open(url);
    });
    _defineProperty(this, "extendedUpdate", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
      return _regeneratorRuntime().wrap(function _callee43$(_context44) {
        while (1) switch (_context44.prev = _context44.next) {
          case 0:
            return _context44.abrupt("return", new Promise(function (resolve, reject) {
              var count = 0;
              var interval = setInterval(function () {
                _this.viewer.updateView();
                if (++count > 20) {
                  // After two seconds
                  clearInterval(interval);
                  resolve();
                }
              }, 100);
            }));
          case 1:
          case "end":
            return _context44.stop();
        }
      }, _callee43);
    })));
    _defineProperty(this, "exportSceneToUsdz", /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee44(hash) {
        return _regeneratorRuntime().wrap(function _callee44$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              if (!(_this.viewer && _this.viewer.zkScene)) {
                _context45.next = 2;
                break;
              }
              return _context45.abrupt("return", _this.viewer.exportSceneToUsdzAsync(_this.viewer.zkScene.get('sceneID'), hash));
            case 2:
            case "end":
              return _context45.stop();
          }
        }, _callee44);
      }));
      return function (_x31) {
        return _ref47.apply(this, arguments);
      };
    }());
    _defineProperty(this, "exportSceneToGlb", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
      return _regeneratorRuntime().wrap(function _callee45$(_context46) {
        while (1) switch (_context46.prev = _context46.next) {
          case 0:
            return _context46.abrupt("return", _this.viewer.exportSceneToLocalGLBAsync());
          case 1:
          case "end":
            return _context46.stop();
        }
      }, _callee45);
    })));
    _defineProperty(this, "setExplodedMode", /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee46(explodedMode) {
        return _regeneratorRuntime().wrap(function _callee46$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (!_this.viewer) {
                _context47.next = 8;
                break;
              }
              if (!explodedMode) {
                _context47.next = 6;
                break;
              }
              _context47.next = 4;
              return _this.viewer.explodeMeshes();
            case 4:
              _context47.next = 8;
              break;
            case 6:
              _context47.next = 8;
              return _this.viewer.collapseMeshes();
            case 8:
              _this.isExplodedMode = explodedMode;
            case 9:
            case "end":
              return _context47.stop();
          }
        }, _callee46);
      }));
      return function (_x32) {
        return _ref49.apply(this, arguments);
      };
    }());
    _defineProperty(this, "hasExplodedMode", function () {
      var zkScene = _this.zkScene;
      if (zkScene) return !!zkScene.getFirstExplodedMeshLocation();else return false;
    });
    _defineProperty(this, "setBackgroundColor", function (color, alpha) {
      var zkScene = _this.zkScene;
      if (color.indexOf('rgb') == 0) {
        var values = color.replace('rgb(', '').replace(')', '').split(',');
        color = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.rgb2hex)(values[0], values[1], values[2]);
      }
      if (_this.viewer && zkScene) {
        zkScene.getOrCreateEnvironmentConfig().set('mainColor', color);
        zkScene.getOrCreateGeneralConfig().set('backgroundColor', color);
        zkScene.getOrCreateGeneralConfig().set('backgroundAlpha', alpha);
        _this.viewer.refreshEnvironment();
      }
    });
    _defineProperty(this, "getCurrentSelection", function () {
      return lodash__WEBPACK_IMPORTED_MODULE_1___default().cloneDeep(_this.platformAttributesSelection);
    });
    _defineProperty(this, "getScreenshot", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
      var width,
        height,
        legacyScreenshot,
        backgroundColor,
        padding,
        camera,
        url,
        _args48 = arguments;
      return _regeneratorRuntime().wrap(function _callee47$(_context48) {
        while (1) switch (_context48.prev = _context48.next) {
          case 0:
            width = _args48.length > 0 && _args48[0] !== undefined ? _args48[0] : 1024;
            height = _args48.length > 1 && _args48[1] !== undefined ? _args48[1] : 1024;
            legacyScreenshot = _args48.length > 2 ? _args48[2] : undefined;
            backgroundColor = _args48.length > 3 && _args48[3] !== undefined ? _args48[3] : null;
            padding = _args48.length > 4 && _args48[4] !== undefined ? _args48[4] : 0;
            camera = _args48.length > 5 && _args48[5] !== undefined ? _args48[5] : null;
            _context48.next = 8;
            return _this.viewer.getSceneContentScreenshotAsync(width, height, padding, _this.zkCurrentTemplate, legacyScreenshot, camera);
          case 8:
            url = _context48.sent;
            if (url) {
              _context48.next = 11;
              break;
            }
            throw new Error('Failed generating screenshot');
          case 11:
            if (!backgroundColor) {
              _context48.next = 14;
              break;
            }
            _context48.next = 14;
            return new Promise(function (resolve) {
              var img = new Image();
              img.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext('2d');
                if (ctx) {
                  ctx.fillStyle = backgroundColor;
                  ctx.fillRect(0, 0, img.width, img.height);
                  ctx.drawImage(img, 0, 0);
                  url = canvas.toDataURL();
                  resolve();
                }
              };
              img.src = url;
            });
          case 14:
            return _context48.abrupt("return", url);
          case 15:
          case "end":
            return _context48.stop();
        }
      }, _callee47);
    })));
    _defineProperty(this, "fireItemsChange", function () {
      _this.trigger('change');
    });
    _defineProperty(this, "removeItem", /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee48(guid) {
        return _regeneratorRuntime().wrap(function _callee48$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              return _context49.abrupt("return", new Promise(function (resolve, reject) {
                if (_this.viewer) {
                  _this.viewer.removeDesignItem(guid, _this.visibleCustomizer);
                  _this.fireItemsChange();
                  resolve();
                } else {
                  reject('Called remove item but no viewer or viewer not ready');
                }
              }));
            case 1:
            case "end":
              return _context49.stop();
          }
        }, _callee48);
      }));
      return function (_x33) {
        return _ref51.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemText", function (guid, text) {
      var item = _this.getDesignItemsInfo().filter(function (x) {
        return x.guid === guid;
      })[0];
      var sanitizedText = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sanitizeTextFromUnsupportedAndEmojiCharacters)(item, text, _this.fonts);
      if (_this.viewer) {
        _this.viewer.setDesignItemText(guid, sanitizedText, _this.visibleCustomizer);
      } else throw 'Called set item text but no viewer or viewer not ready';
      return sanitizedText;
    });
    _defineProperty(this, "setItemItalic", function (guid, italic) {
      if (_this.viewer) {
        _this.viewer.setDesignItemItalic(guid, italic, _this.visibleCustomizer);
      } else throw 'Called set item italic but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemBold", function (guid, bold) {
      if (_this.viewer) {
        _this.viewer.setDesignItemBold(guid, bold, _this.visibleCustomizer);
      } else throw 'Called set item bold but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemColor", function (guid, color) {
      if (_this.viewer) {
        _this.viewer.setDesignItemColor(guid, color, _this.visibleCustomizer);
      } else throw 'Called set item color but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemFontFamily", /*#__PURE__*/function () {
      var _ref52 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee49(guid, fontFamily) {
        var font;
        return _regeneratorRuntime().wrap(function _callee49$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!_this.viewer) {
                _context50.next = 12;
                break;
              }
              font = _this.fonts.find(function (x) {
                return x.name === fontFamily;
              });
              if (!font) {
                _context50.next = 9;
                break;
              }
              _context50.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font])["catch"](function (e) {
                console.error('Error loading font', e, font);
              });
            case 5:
              _this.viewer.setDesignItemFontFamily(guid, fontFamily, _this.visibleCustomizer);
              _this.fireItemsChange();
              _context50.next = 10;
              break;
            case 9:
              console.warn("No font found for ".concat(fontFamily));
            case 10:
              _context50.next = 13;
              break;
            case 12:
              throw 'Called set item font family but no viewer or viewer not ready';
            case 13:
            case "end":
              return _context50.stop();
          }
        }, _callee49);
      }));
      return function (_x34, _x35) {
        return _ref52.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemTextOnPath", function (guid, areaId, value) {
      if (_this.viewer) {
        _this.viewer.setItemTextOnPath(guid, areaId, value, _this.visibleCustomizer);
        _this.fireItemsChange();
      } else throw 'Called toggleItemTextOnPath but no viewer or viewer not ready';
    });
    _defineProperty(this, "sanitizeString", function (family, text) {
      var _family$faces$;
      var face = (_family$faces$ = family.faces[0]) !== null && _family$faces$ !== void 0 ? _family$faces$ : null;
      if (!face) return text;
      return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.sanitizeString)(face, text);
    });
    _defineProperty(this, "getSanitationText", function (family, text) {
      var _family$faces$2;
      var face = (_family$faces$2 = family.faces[0]) !== null && _family$faces$2 !== void 0 ? _family$faces$2 : null;
      if (!face) return {
        dirtyChars: [],
        sanitizedText: text
      };
      return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.sanitizeText)(face, text);
    });
    _defineProperty(this, "createImage", /*#__PURE__*/function () {
      var _ref53 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee50(file, progress) {
        var _this$zkProduct3, imageTask, printingMethods, result, image;
        return _regeneratorRuntime().wrap(function _callee50$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              if (!_this.viewer) {
                _context51.next = 11;
                break;
              }
              imageTask = new _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__["default"](_this.culture, _this.token);
              printingMethods = (_this$zkProduct3 = _this.zkProduct) === null || _this$zkProduct3 === void 0 ? void 0 : _this$zkProduct3.get('printTypes');
              imageTask.addPrintingOptions(printingMethods);
              _context51.next = 6;
              return imageTask.upload(file, progress);
            case 6:
              result = _context51.sent;
              image = result ? result[0] : null;
              return _context51.abrupt("return", image);
            case 11:
              throw 'Called create image but no viewer or viewer not ready';
            case 12:
            case "end":
              return _context51.stop();
          }
        }, _callee50);
      }));
      return function (_x36, _x37) {
        return _ref53.apply(this, arguments);
      };
    }());
    _defineProperty(this, "createImageFromUrl", /*#__PURE__*/function () {
      var _ref54 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee51(url) {
        var result;
        return _regeneratorRuntime().wrap(function _callee51$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (!_this.viewer) {
                _context52.next = 7;
                break;
              }
              _context52.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'images/import/url', {
                url: url
              });
            case 3:
              result = _context52.sent.data;
              return _context52.abrupt("return", result);
            case 7:
              throw 'Called create image from url but no viewer or viewer not ready';
            case 8:
            case "end":
              return _context52.stop();
          }
        }, _callee51);
      }));
      return function (_x38) {
        return _ref54.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addItemImage", /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee52(id, areaId) {
        return _regeneratorRuntime().wrap(function _callee52$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              if (!_this.viewer) {
                _context53.next = 8;
                break;
              }
              _context53.next = 3;
              return _this.viewer.addDesignItemImage(id, areaId, _this.visibleCustomizer);
            case 3:
              _context53.next = 5;
              return _this.renderDesign();
            case 5:
              _this.fireItemsChange();
              _context53.next = 9;
              break;
            case 8:
              throw 'Called add item text but no viewer or viewer not ready';
            case 9:
            case "end":
              return _context53.stop();
          }
        }, _callee52);
      }));
      return function (_x39, _x40) {
        return _ref55.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemImageFromFile", /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee53(guid, file, progress) {
        var image;
        return _regeneratorRuntime().wrap(function _callee53$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (!_this.viewer) {
                _context54.next = 9;
                break;
              }
              _context54.next = 3;
              return _this.createImage(file, progress);
            case 3:
              image = _context54.sent;
              _context54.next = 6;
              return _this.setItemImage(guid, image.imageID);
            case 6:
              _this.fireItemsChange();
              _context54.next = 10;
              break;
            case 9:
              throw 'Called set item image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context54.stop();
          }
        }, _callee53);
      }));
      return function (_x41, _x42, _x43) {
        return _ref56.apply(this, arguments);
      };
    }());
    // For preview only!!
    _defineProperty(this, "setItemImageFromBase64", /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee54(guid, base64) {
        var image;
        return _regeneratorRuntime().wrap(function _callee54$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              if (!_this.viewer) {
                _context55.next = 9;
                break;
              }
              image = new MPlaza.Image();
              image.set('imageID', -1);
              image.set('previewUrl', base64);
              _context55.next = 6;
              return _this.viewer.setDesignItemImage(guid, image, _this.visibleCustomizer);
            case 6:
              _this.fireItemsChange();
              _context55.next = 10;
              break;
            case 9:
              throw 'Called set item image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context55.stop();
          }
        }, _callee54);
      }));
      return function (_x44, _x45) {
        return _ref57.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemImage", /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee57(guid, id) {
        return _regeneratorRuntime().wrap(function _callee57$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              return _context58.abrupt("return", new Promise(/*#__PURE__*/function () {
                var _ref59 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee56(resolve, reject) {
                  var image;
                  return _regeneratorRuntime().wrap(function _callee56$(_context57) {
                    while (1) switch (_context57.prev = _context57.next) {
                      case 0:
                        if (!_this.viewer) {
                          _context57.next = 6;
                          break;
                        }
                        image = new MPlaza.Image();
                        image.set('imageID', id);
                        image.fetch({
                          success: function () {
                            var _success2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee55(model, response, opts) {
                              return _regeneratorRuntime().wrap(function _callee55$(_context56) {
                                while (1) switch (_context56.prev = _context56.next) {
                                  case 0:
                                    _context56.next = 2;
                                    return _this.viewer.setDesignItemImage(guid, image, _this.visibleCustomizer);
                                  case 2:
                                    _this.fireItemsChange();
                                    resolve();
                                  case 4:
                                  case "end":
                                    return _context56.stop();
                                }
                              }, _callee55);
                            }));
                            function success(_x50, _x51, _x52) {
                              return _success2.apply(this, arguments);
                            }
                            return success;
                          }(),
                          error: function error(model, response, opts) {
                            return null;
                          }
                        });
                        _context57.next = 7;
                        break;
                      case 6:
                        throw 'Called set item image but no viewer or viewer not ready';
                      case 7:
                      case "end":
                        return _context57.stop();
                    }
                  }, _callee56);
                }));
                return function (_x48, _x49) {
                  return _ref59.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context58.stop();
          }
        }, _callee57);
      }));
      return function (_x46, _x47) {
        return _ref58.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMacroCategories", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
      var _this$product;
      var macroCategories, _iterator7, _step7, macroCategory;
      return _regeneratorRuntime().wrap(function _callee58$(_context59) {
        while (1) switch (_context59.prev = _context59.next) {
          case 0:
            _context59.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('imagemacrocategories/', {
              params: {
                productID: (_this$product = _this.product) === null || _this$product === void 0 ? void 0 : _this$product.id
              }
            });
          case 2:
            macroCategories = _context59.sent.data;
            macroCategories = macroCategories.filter(function (x) {
              return x.hasImages;
            });
            _iterator7 = _createForOfIteratorHelper(macroCategories);
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                macroCategory = _step7.value;
                macroCategory.categories = macroCategory.categories.filter(function (x) {
                  return x.hasImages;
                });
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            return _context59.abrupt("return", macroCategories);
          case 7:
          case "end":
            return _context59.stop();
        }
      }, _callee58);
    })));
    _defineProperty(this, "getImages", /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee59(categoryId) {
        var _this$product2;
        var images;
        return _regeneratorRuntime().wrap(function _callee59$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('images', {
                params: {
                  type: 'lib',
                  c: categoryId,
                  productID: (_this$product2 = _this.product) === null || _this$product2 === void 0 ? void 0 : _this$product2.id
                }
              });
            case 2:
              images = _context60.sent.data;
              return _context60.abrupt("return", images);
            case 4:
            case "end":
              return _context60.stop();
          }
        }, _callee59);
      }));
      return function (_x53) {
        return _ref61.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getPDF", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
      var _this$zkScene10, _this$product3;
      var pdfScreenshotCamera, data, items, areas, selectedOptions, params, pdf;
      return _regeneratorRuntime().wrap(function _callee60$(_context61) {
        while (1) switch (_context61.prev = _context61.next) {
          case 0:
            pdfScreenshotCamera = (_this$zkScene10 = _this.zkScene) === null || _this$zkScene10 === void 0 ? void 0 : _this$zkScene10.get('cameraLocations').find(function (x) {
              var _x$get2;
              return ((_x$get2 = x.get('name')) === null || _x$get2 === void 0 ? void 0 : _x$get2.toLowerCase()) === 'pdf_screenshot_camera';
            });
            _context61.next = 3;
            return _this.getScreenshot(2048, 2048, false, null, 0, pdfScreenshotCamera);
          case 3:
            data = _context61.sent;
            items = _this.getDesignItemsInfo();
            areas = (_this$product3 = _this.product) === null || _this$product3 === void 0 ? void 0 : _this$product3.areas.filter(function (x) {
              return _this.isAreaVisible(x.id);
            }).map(function (x) {
              return {
                name: x.name,
                textItems: items.filter(function (i) {
                  return i.areaId == x.id && i.type === ___WEBPACK_IMPORTED_MODULE_2__.ItemType.Text;
                })
              };
            }).filter(function (x) {
              return x.textItems.length > 0;
            });
            selectedOptions = _this.platformAttributesSelection.filter(function (x) {
              return x.attributeIsEnabled && x.attributeIsEnabled;
            }).map(function (_ref63) {
              var attributeLabel = _ref63.attributeLabel,
                attributeCode = _ref63.attributeCode,
                optionCode = _ref63.optionCode,
                optionLabel = _ref63.optionLabel;
              return {
                attributeLabel: attributeLabel,
                attributeCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attributeCode) ? attributeCode : '',
                optionLabel: optionLabel,
                optionCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(optionCode) ? optionCode : ''
              };
            });
            params = {
              environment: 2,
              productName: _this.zkProduct.get('name'),
              previewImage: data,
              sides: [],
              areas: areas,
              selectedOptions: selectedOptions
            };
            _context61.next = 10;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'previewdesigns/pdf', params, {
              transformResponse: function transformResponse(res) {
                return res;
              },
              responseType: 'text'
            });
          case 10:
            pdf = _context61.sent.data.replace(/"/g, '');
            return _context61.abrupt("return", pdf);
          case 12:
          case "end":
            return _context61.stop();
        }
      }, _callee60);
    })));
    _defineProperty(this, "rewriteShareUrl", function (url) {
      var path = url.split('/SharedPreview')[1];
      if (_this.shareUrlPrefix) {
        return _this.shareUrlPrefix + path;
      }
      if (!_this.isShoppingPreview && document.referrer && _this.settings.referrerID === 2) {
        var regex = /(apps\/configurator\/)([\s\S]*)/gm;
        var firstPart = document.referrer.replace(regex, '$1');
        if (!firstPart.endsWith('/')) firstPart += '/';
        return firstPart + path;
      }
      return url;
    });
    _defineProperty(this, "getShareCompositionUrl", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
      var _this$composition$get;
      var isDraft, docID, result;
      return _regeneratorRuntime().wrap(function _callee61$(_context62) {
        while (1) switch (_context62.prev = _context62.next) {
          case 0:
            // salvo (e riassegno dopo la creazione dello share url) l'id , per evitare problemi in caso di add to cart e edit
            // in questo modo ogni composizione condivisa è sempre diversa da quella di partenza
            isDraft = (_this$composition$get = _this.composition.get('isDraft')) !== null && _this$composition$get !== void 0 ? _this$composition$get : false;
            _this.composition.set('isDraft', false);
            _context62.next = 4;
            return _this.saveCompositionCopy(true);
          case 4:
            docID = _context62.sent;
            _this.composition.set('isDraft', isDraft);
            _context62.next = 8;
            return _this.integration.getSharedCompositionUrl(docID);
          case 8:
            result = _context62.sent;
            return _context62.abrupt("return", result.url);
          case 10:
          case "end":
            return _context62.stop();
        }
      }, _callee61);
    })));
    _defineProperty(this, "saveCompositionCopy", /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee62(isSharing) {
        var docId, designDocId, currentTemplate, newCompositionDocId;
        return _regeneratorRuntime().wrap(function _callee62$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              docId = null;
              designDocId = null;
              currentTemplate = _this.zkCurrentTemplate;
              if (currentTemplate) {
                designDocId = currentTemplate.get('docID');
                currentTemplate.set('docID', null);
              }
              docId = _this.composition.get('docID');
              _this.composition.set('docID', null);
              _this.composition.set('designDocID', null);
              _context63.next = 9;
              return _this.saveComposition(undefined, undefined, isSharing);
            case 9:
              newCompositionDocId = _this.composition.get('docID');
              _this.composition.set('docID', docId);
              _this.composition.set('designDocID', designDocId);
              if (currentTemplate) currentTemplate.set('docID', designDocId);
              return _context63.abrupt("return", newCompositionDocId);
            case 14:
            case "end":
              return _context63.stop();
          }
        }, _callee62);
      }));
      return function (_x54) {
        return _ref65.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getOnlineScreenshot", /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee63(width, height, legacyScreenshot, backgroundColor) {
        var padding,
          preview,
          originalUrl,
          rewrittenUrl,
          _args64 = arguments;
        return _regeneratorRuntime().wrap(function _callee63$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              padding = _args64.length > 4 && _args64[4] !== undefined ? _args64[4] : 30;
              _context64.next = 3;
              return _this.getScreenshot(width, height, legacyScreenshot, backgroundColor, padding);
            case 3:
              preview = _context64.sent;
              _context64.next = 6;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'designs/save-share-preview', {
                preview: preview
              });
            case 6:
              originalUrl = _context64.sent.data.url;
              rewrittenUrl = _this.rewriteShareUrl(originalUrl);
              return _context64.abrupt("return", {
                originalUrl: originalUrl,
                rewrittenUrl: rewrittenUrl
              });
            case 9:
            case "end":
              return _context64.stop();
          }
        }, _callee63);
      }));
      return function (_x55, _x56, _x57, _x58) {
        return _ref66.apply(this, arguments);
      };
    }());
    // AR - Augmented Reality
    _defineProperty(this, "isSceneArOnTheFly", function () {
      var _this$zkScene11;
      if (_this.viewer) return (_this$zkScene11 = _this.zkScene) === null || _this$zkScene11 === void 0 ? void 0 : _this$zkScene11.getAROnTheFly();
      return false;
    });
    _defineProperty(this, "isArDeviceCompliant", function () {
      return _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_AR_DEVICE_COMPLIANT;
    });
    _defineProperty(this, "isAndroidOrIOS", function () {
      return _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID || _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS;
    });
    _defineProperty(this, "isAndroid", _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID);
    _defineProperty(this, "isIOS", _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS);
    _defineProperty(this, "buildModelViewerUrl", function (fileInfos) {
      var _getARAnchor;
      var url = Zakeke.config.modelViewerPage;
      var link = new URL(url);
      var search = '';
      var _iterator8 = _createForOfIteratorHelper(fileInfos),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var file = _step8.value;
          if (file.format && file.arFileUrl) {
            var encodedUrl = encodeURIComponent(file.arFileUrl);
            var searchFile = '';
            switch (file.format) {
              case 'gltf':
              case 'glb':
                searchFile = 'gltf=' + encodedUrl;
                break;
              case 'usdz':
                searchFile = 'usdz=' + encodedUrl;
                break;
              case 'png':
                searchFile = 'poster=' + encodedUrl;
                break;
            }
            if (searchFile) search += (search ? '&' : '') + searchFile;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      search += '&arScale=' + (_this.zkScene.getARScale() ? 1 : 0);
      search += '&arAnchor=' + ((_getARAnchor = _this.zkScene.getARAnchor()) !== null && _getARAnchor !== void 0 ? _getARAnchor : '');
      link.search += search;
      var pageUrl = link.toString();
      return pageUrl;
    });
    _defineProperty(this, "isSceneArEnabled", function () {
      if (_this.zkScene) return _this.zkScene.getAREnabled() || false;
      return false;
    });
    _defineProperty(this, "getPregeneratedARUrl", function (fileType) {
      var _this$zkScene12, _this$zkScene12$get, _this$zkScene12$get$f;
      return (_this$zkScene12 = _this.zkScene) === null || _this$zkScene12 === void 0 ? void 0 : (_this$zkScene12$get = _this$zkScene12.get('arFiles')) === null || _this$zkScene12$get === void 0 ? void 0 : (_this$zkScene12$get$f = _this$zkScene12$get.find(function (x) {
        return x.get('fileType') == fileType;
      })) === null || _this$zkScene12$get$f === void 0 ? void 0 : _this$zkScene12$get$f.get('url');
    });
    _defineProperty(this, "getQrCodeArUrl", /*#__PURE__*/function () {
      var _ref67 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee64(device) {
        var _this$zkProduct$get, _this$zkProduct4;
        var fileInfos, isCoutie, sceneCode, url, glb, usdz;
        return _regeneratorRuntime().wrap(function _callee64$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              fileInfos = []; // HOTFIX for Coutie while RapidCompact resolves the issue with iOS AR
              isCoutie = _this.settings.userID === 271265;
              sceneCode = _this.isDAMViewer ? (_this$zkProduct$get = (_this$zkProduct4 = _this.zkProduct) === null || _this$zkProduct4 === void 0 ? void 0 : _this$zkProduct4.get('code')) !== null && _this$zkProduct$get !== void 0 ? _this$zkProduct$get : undefined : _this.selection.getCompositionHashCode();
              if (!(device == 'Android' || device == 'iOS' && isCoutie)) {
                _context65.next = 13;
                break;
              }
              _context65.t0 = _this.getPregeneratedARUrl('glb');
              if (_context65.t0) {
                _context65.next = 9;
                break;
              }
              _context65.next = 8;
              return _this.viewer.exportSceneToRemoteGLBAsync(_this.zkScene.get('sceneID'), sceneCode, false);
            case 8:
              _context65.t0 = _context65.sent;
            case 9:
              url = _context65.t0;
              if (url) fileInfos = [{
                format: 'gltf',
                arFileUrl: url
              }];
              _context65.next = 22;
              break;
            case 13:
              glb = _this.getPregeneratedARUrl('glb');
              usdz = _this.getPregeneratedARUrl('usdz');
              if (!(glb && usdz)) {
                _context65.next = 19;
                break;
              }
              fileInfos = [{
                format: 'glb',
                arFileUrl: glb
              }, {
                format: 'usdz',
                arFileUrl: usdz
              }];
              _context65.next = 22;
              break;
            case 19:
              _context65.next = 21;
              return _this.viewer.exportSceneToARAsync(_this.zkScene.get('sceneID'), sceneCode);
            case 21:
              fileInfos = _context65.sent;
            case 22:
              if (!(fileInfos.length == 0)) {
                _context65.next = 24;
                break;
              }
              return _context65.abrupt("return", '');
            case 24:
              if (_this.isDAMViewer) {
                _this.makeDAMAnalyticsView(_models__WEBPACK_IMPORTED_MODULE_11__.DAMViewerAnalyticsEventType.ViewArProdutc);
              }
              return _context65.abrupt("return", _this.buildModelViewerUrl(fileInfos));
            case 26:
            case "end":
              return _context65.stop();
          }
        }, _callee64);
      }));
      return function (_x59) {
        return _ref67.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMobileArUrl", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
      var _this$zkProduct$get2, _this$zkProduct5;
      var sceneCode, url, isCoutie;
      return _regeneratorRuntime().wrap(function _callee65$(_context66) {
        while (1) switch (_context66.prev = _context66.next) {
          case 0:
            sceneCode = _this.isDAMViewer ? (_this$zkProduct$get2 = (_this$zkProduct5 = _this.zkProduct) === null || _this$zkProduct5 === void 0 ? void 0 : _this$zkProduct5.get('code')) !== null && _this$zkProduct$get2 !== void 0 ? _this$zkProduct$get2 : undefined : _this.selection.getCompositionHashCode();
            url = null; // HOTFIX for Coutie while RapidCompact resolves the issue with iOS AR
            isCoutie = _this.settings.userID === 271265;
            _context66.prev = 3;
            _context66.next = 6;
            return document.requestStorageAccess();
          case 6:
            _context66.next = 11;
            break;
          case 8:
            _context66.prev = 8;
            _context66.t0 = _context66["catch"](3);
            console.error('Storage access denied');
          case 11:
            if (!_this.isSceneArOnTheFly()) {
              _context66.next = 17;
              break;
            }
            _context66.next = 14;
            return _this.getMobileLocalArUrl();
          case 14:
            return _context66.abrupt("return", url = _context66.sent);
          case 17:
            if (!_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
              _context66.next = 30;
              break;
            }
            if (!(_this.getPregeneratedARUrl(isCoutie ? 'glb' : 'usdz') || isCoutie)) {
              _context66.next = 24;
              break;
            }
            _context66.next = 21;
            return _this.viewer.exportSceneToRemoteGLBAsync(_this.zkScene.get('sceneID'), sceneCode, false);
          case 21:
            _context66.t1 = _context66.sent;
            _context66.next = 27;
            break;
          case 24:
            _context66.next = 26;
            return _this.viewer.exportSceneToUsdzAsync(_this.zkScene.get('sceneID'), sceneCode, false);
          case 26:
            _context66.t1 = _context66.sent;
          case 27:
            url = _context66.t1;
            _context66.next = 36;
            break;
          case 30:
            _context66.t2 = _this.getPregeneratedARUrl('glb');
            if (_context66.t2) {
              _context66.next = 35;
              break;
            }
            _context66.next = 34;
            return _this.viewer.exportSceneToRemoteGLBAsync(_this.zkScene.get('sceneID'), sceneCode, false);
          case 34:
            _context66.t2 = _context66.sent;
          case 35:
            url = _context66.t2;
          case 36:
            if (_this.isDAMViewer) {
              _this.makeDAMAnalyticsView(_models__WEBPACK_IMPORTED_MODULE_11__.DAMViewerAnalyticsEventType.ViewArProdutc);
            }
            return _context66.abrupt("return", url);
          case 38:
          case "end":
            return _context66.stop();
        }
      }, _callee65, null, [[3, 8]]);
    })));
    _defineProperty(this, "getMobileLocalArUrl", function () {
      return new Promise(function (resolve, reject) {
        if (_this.zkScene && _this.viewer) {
          var fileId = _this.zkScene.getSceneID();
          if (!fileId) {
            reject('Scene ID is missing.');
            return;
          }
          _this.viewer.getSceneRootUrl().then(/*#__PURE__*/function () {
            var _ref69 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee66(rootUrl) {
              var url;
              return _regeneratorRuntime().wrap(function _callee66$(_context67) {
                while (1) switch (_context67.prev = _context67.next) {
                  case 0:
                    if (rootUrl) {
                      _context67.next = 3;
                      break;
                    }
                    reject('Root URL is missing.');
                    return _context67.abrupt("return");
                  case 3:
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                      _context67.next = 10;
                      break;
                    }
                    _context67.next = 6;
                    return _this.viewer.exportSceneToLocalUSDZAsync()["catch"](function (ex) {
                      console.error('Failed exporting scene to usdz', ex);
                      return null;
                    });
                  case 6:
                    url = _context67.sent;
                    if (!url) {
                      reject('Failed to export scene to USDZ.');
                    } else {
                      resolve(url);
                    }
                    _context67.next = 11;
                    break;
                  case 10:
                    _this.viewer.saveGlbOnDatabaseAsync(fileId).then(function (uploadedModelUrl) {
                      // Base AR file URL
                      var arFileUrl = Zakeke.config.onFlyArPage;
                      var link = new URL(arFileUrl);

                      // Append query parameters
                      var search = "?uploadedModelUrl=".concat(uploadedModelUrl);
                      search += "&rootUrl=".concat(encodeURIComponent(rootUrl));
                      search += "&productId=".concat(_this.product.id);
                      search += "&environment=".concat(_this.product.environment);
                      search += "&token=".concat(_this.token);
                      if (_this.zkScene.getARAnchor()) {
                        search += "&arAnchor=".concat(_this.zkScene.getARAnchor());
                      }
                      link.search += search;
                      var pageUrl = link.toString();

                      // Resolve with the final URL
                      resolve(pageUrl);
                    })["catch"](function (ex) {
                      console.error('Failed saving glb on database', ex);
                      reject(ex);
                    });
                  case 11:
                  case "end":
                    return _context67.stop();
                }
              }, _callee66);
            }));
            return function (_x60) {
              return _ref69.apply(this, arguments);
            };
          }())["catch"](function (ex) {
            console.error('Failed to get scene root URL', ex);
            reject(ex);
          });
        } else {
          reject('Viewer or Scene is missing.');
        }
      });
    });
    _defineProperty(this, "openArMobile", function (url) {
      // HOTFIX for Coutie while RapidCompact resolves the issue with iOS AR
      var isCoutie = _this.settings.userID === 271265;
      if (_this.viewer && _this.zkScene) {
        if (_this.isSceneArOnTheFly() && _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) {
          console.log('sono openArMobile e sono su android', url);
          window.open(url, '_blank');
        } else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
          if (url && !_this.zkScene.getARScale()) url += '#allowsContentScaling=0';
          if (isCoutie) {
            var fileInfos = [{
              format: 'glb',
              arFileUrl: url
            }];
            var previewUrl = _this.buildModelViewerUrl(fileInfos);
            window.open(previewUrl, '_blank');
            return;
          }
          var anchor = document.createElement('a');
          anchor.setAttribute('rel', 'ar');
          anchor.setAttribute('href', url);
          anchor.appendChild(document.createElement('img'));
          anchor.click();
        } else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) {
          _zakeke_zakeke_3d_core__WEBPACK_IMPORTED_MODULE_0__.AndroidAR.openSceneViewer(url, function () {
            alert('Device not supported.');
          }, _this.zkScene.getARScale(), _this.zkScene.getARAnchor());
        }
      }
    });
    _defineProperty(this, "registerView", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
      return _regeneratorRuntime().wrap(function _callee67$(_context68) {
        while (1) switch (_context68.prev = _context68.next) {
          case 0:
            if (!(!_this.zkProduct || _this.isShoppingPreview)) {
              _context68.next = 2;
              break;
            }
            return _context68.abrupt("return");
          case 2:
            _context68.prev = 2;
            _context68.next = 5;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'viewscount/addview', {
              productID: _this.zkProduct.get('modelID'),
              environment: _this.zkProduct.get('environment'),
              ecommerceID: _this.settings.ecommerceID
            });
          case 5:
            _context68.next = 10;
            break;
          case 7:
            _context68.prev = 7;
            _context68.t0 = _context68["catch"](2);
            console.error('Failed registering view', _context68.t0);
          case 10:
          case "end":
            return _context68.stop();
        }
      }, _callee67, null, [[2, 7]]);
    })));
    // Manipulate scene
    _defineProperty(this, "getMeshIDbyName", function (name) {
      var _this$viewer, _this$viewer$getMeshB;
      return (_this$viewer = _this.viewer) === null || _this$viewer === void 0 ? void 0 : (_this$viewer$getMeshB = _this$viewer.getMeshByName(name)) === null || _this$viewer$getMeshB === void 0 ? void 0 : _this$viewer$getMeshB.id;
    });
    /**
     * Hide a mesh and its children and save the state
     * @param meshId The mesh and childs to hide
     */
    _defineProperty(this, "hideMeshAndSaveState", function (meshId) {
      if (_this.viewer.scene) {
        var rootMesh = _this.viewer.getMeshByID(meshId);

        // Add mesh and all submesh visibility to previousMeshVisibileStates
        if (rootMesh) {
          var meshes = [rootMesh].concat(_toConsumableArray(rootMesh.getChildMeshes()));
          var _iterator9 = _createForOfIteratorHelper(meshes),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var mesh = _step9.value;
              _this.previousMeshesVisibleStates[mesh.id] = mesh.isVisible;
              mesh.isVisible = false;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
          _this.viewer.setRenderingNeeded();
        }
      }
    });
    /**
     * Restore a mesh visibility state from a previous saved one (see hideMeshAndSaveState)
     * @param meshId The mesh and childs to show
     */
    _defineProperty(this, "restoreMeshVisibility", function (meshId) {
      if (_this.viewer.scene) {
        var rootMesh = _this.viewer.getMeshByID(meshId);

        // Add mesh and all submesh visibility to previousMeshVisibileStates
        if (rootMesh && _this.previousMeshesVisibleStates[rootMesh.id] !== undefined) {
          var meshes = [rootMesh].concat(_toConsumableArray(rootMesh.getChildMeshes()));
          var _iterator10 = _createForOfIteratorHelper(meshes),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var mesh = _step10.value;
              mesh.isVisible = _this.previousMeshesVisibleStates[mesh.id];
              delete _this.previousMeshesVisibleStates[mesh.id];
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          _this.viewer.setRenderingNeeded();
        }
      }
    });
    /**
     * Change opacity for a specific mesh
     * @param meshId The mesh to change the opacity
     * @param opacity The opacity to set
     */
    _defineProperty(this, "setMeshDesignVisibility", function (meshId, visible) {
      if (_this.viewer) {
        _this.viewer.setDesignVisibility(meshId, visible);
        _this.viewer.setRenderingNeeded();
      }
    });
    // Events
    _defineProperty(this, "addFocusAttributesListener", function (listenerFunction) {
      if (_this.viewer) _this.viewer.addFocusAttributesListener(listenerFunction);
    });
    _defineProperty(this, "clearListeners", function () {
      if (_this.viewer) _this.viewer.clearListeners();
    });
    _defineProperty(this, "setCameraLocked", function (isBlocked) {
      return _this.viewer.setCameraLocked(isBlocked);
    });
    _defineProperty(this, "isSceneTryOnEnabled", function () {
      var _this$zkScene$getTryO;
      if (_this.viewer) if (_this.zkScene) console.log(_this.zkScene.getTryOnEnabled());
      if (_this.viewer) if (_this.zkScene) return (_this$zkScene$getTryO = _this.zkScene.getTryOnEnabled()) !== null && _this$zkScene$getTryO !== void 0 ? _this$zkScene$getTryO : false;
      return false;
    });
    _defineProperty(this, "getTryOnUrl", function (tryOnUrl) {
      return new Promise(function (resolve) {
        if (_this.zkScene && _this.viewer) {
          var fileId = _this.zkScene.getSceneID();
          _this.viewer.getSceneRootUrl().then(function (rootUrl) {
            if (!rootUrl) return;
            var attachmentPoint = 'noseBridge';

            // Salvo le mesh su IndexedDB
            _this.viewer.saveVisibleMeshesOnDatabaseAsync(fileId).then(function () {
              var url = tryOnUrl !== null && tryOnUrl !== void 0 ? tryOnUrl : 'https://zakekecdn.blob.core.windows.net/cdn/c/tryon/index.html';
              var link = new URL(url);
              var search = 'id=' + fileId;
              search += '&rootUrl=' + encodeURIComponent(rootUrl);
              search += '&attachmentPoint=' + attachmentPoint;
              search += '&productId=' + _this.zkProduct.get('modelID');
              search += '&environment=' + _this.zkProduct.get('environment');
              search += '&token=' + _this.token;
              link.search += search;
              var pageUrl = link.toString();
              resolve(pageUrl);
            });
          });
        }
      });
    });
    _defineProperty(this, "saveComposition", /*#__PURE__*/function () {
      var _ref71 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee68(customPreviewSize, legacyScreenshot, isSharing) {
        var _this$zkScene13, _customPreviewSize$cu, _customPreviewSize$cu2;
        var buyScreenshotCamera, data, design, designItems, itemsNotPlaceholders, nonStaticElementsCount;
        return _regeneratorRuntime().wrap(function _callee68$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              console.log('Saving...');
              buyScreenshotCamera = (_this$zkScene13 = _this.zkScene) === null || _this$zkScene13 === void 0 ? void 0 : _this$zkScene13.get('cameraLocations').find(function (x) {
                var _x$get3;
                return ((_x$get3 = x.get('name')) === null || _x$get3 === void 0 ? void 0 : _x$get3.toLowerCase()) === 'buy_screenshot_camera';
              });
              if (!buyScreenshotCamera) _this.viewer.restoreCameraState();
              _context69.next = 5;
              return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            case 5:
              _context69.next = 7;
              return _this.viewer.getSceneContentScreenshotAsync((_customPreviewSize$cu = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewHeight) !== null && _customPreviewSize$cu !== void 0 ? _customPreviewSize$cu : _this.previewWidth, (_customPreviewSize$cu2 = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewWidth) !== null && _customPreviewSize$cu2 !== void 0 ? _customPreviewSize$cu2 : _this.previewHeight, 0, _this.zkCurrentTemplate, legacyScreenshot, buyScreenshotCamera);
            case 7:
              data = _context69.sent;
              if (_this.pdSettings) _this.composition.set('pdSettings', _this.pdSettings);
              _this.composition.set('previewImageData', data);

              // Save composition
              if (!(!_this.composition.get('isTemplate') && _this.zkCurrentTemplate)) {
                _context69.next = 24;
                break;
              }
              design = _this.zkCurrentTemplate;
              designItems = design.get('designItems');
              itemsNotPlaceholders = designItems.filter(function (designItem) {
                return !JSON.parse(designItem.get('json'))[1].data.isTemplateElement;
              });
              itemsNotPlaceholders.forEach(function (item) {
                if (item.get('areas').length > 0 && !_this.isAreaVisible(item.get('areas').at(0).get('sideID'))) designItems.remove(item);
              });
              nonStaticElementsCount = designItems === null || designItems === void 0 ? void 0 : designItems.toArray().map(function (designItem) {
                return !designItem.get('constraints') || designItem.get('constraints').get('canResize') || designItem.get('constraints').get('canMove') || designItem.get('constraints').get('canDelete') || designItem.get('constraints').get('canRotate') || designItem.get('constraints').get('canEdit') || designItem.get('constraints').get('isPrintable')
                //  && designItem.get('areas').length > 0 &&
                // this.isAreaVisible(designItem.get('areas').at(0).get('sideID'))
                ;
              }).filter(function (x) {
                return x;
              }).length;
              if (!(nonStaticElementsCount > 0)) {
                _context69.next = 21;
                break;
              }
              _context69.next = 19;
              return _this.saveDesignBackbone(isSharing);
            case 19:
              _context69.next = 22;
              break;
            case 21:
              _this.composition.set('designDocID', null);
            case 22:
              _context69.next = 25;
              break;
            case 24:
              _this.composition.set('designDocID', null);
            case 25:
              _context69.next = 27;
              return _this.saveCompositionBackbone();
            case 27:
              console.log('Composition saved!');
            case 28:
            case "end":
              return _context69.stop();
          }
        }, _callee68);
      }));
      return function (_x61, _x62, _x63) {
        return _ref71.apply(this, arguments);
      };
    }());
    _defineProperty(this, "bootstrapComposition", /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee69(composition) {
        return _regeneratorRuntime().wrap(function _callee69$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _this.selection = Zakeke.ComposerSelection.CreateComposerSelection(_this.zkProduct);
              _this.composition = composition;
              _context70.next = 4;
              return _this.internalLoadComposition(_this.composition.id);
            case 4:
              if (!_this.currentCompositionInfo) _this.currentCompositionInfo = {
                compositionId: '',
                compositionName: '',
                compositionTags: []
              };
              _this.currentCompositionInfo.compositionId = _this.compositionId;
              _this.currentCompositionInfo.compositionName = _this.composition.get('name');
              _this.currentCompositionInfo.compositionTags = _this.composition.get('tags');
            case 8:
            case "end":
              return _context70.stop();
          }
        }, _callee69);
      }));
      return function (_x64) {
        return _ref72.apply(this, arguments);
      };
    }());
    _defineProperty(this, "loadSavedComposition", /*#__PURE__*/function () {
      var _ref73 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee70(docID) {
        var _this$savedCompositio;
        var composition, compositionModel;
        return _regeneratorRuntime().wrap(function _callee70$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              composition = (_this$savedCompositio = _this.savedCompositions) === null || _this$savedCompositio === void 0 ? void 0 : _this$savedCompositio.find(function (x) {
                return x.docID == docID;
              });
              compositionModel = new MPlaza.Composition(composition);
              if (!composition) {
                _context71.next = 5;
                break;
              }
              _context71.next = 5;
              return _this.bootstrapComposition(new MPlaza.Composition(composition));
            case 5:
              _this.selection.setupOnComposition(compositionModel);
              _context71.next = 8;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 8:
              _this.buildStructure();
              _this.updatePrice();
              _this.selection.getAllAttributeSelections().forEach(function (attributeSelection) {
                var selectionOption = attributeSelection.get('options').find(function (x) {
                  return x.get('selected');
                });

                // Change platform selection
                var platformSelection = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attributeSelection.get('attributeCode'));
                });
                if (platformSelection && selectionOption) {
                  platformSelection.optionCode = selectionOption.get('optionCode');
                  platformSelection.optionLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(selectionOption.get('name'));
                }
                console.log({
                  platformSelection: platformSelection
                });
              });
            case 11:
            case "end":
              return _context71.stop();
          }
        }, _callee70);
      }));
      return function (_x65) {
        return _ref73.apply(this, arguments);
      };
    }());
    _defineProperty(this, "updateSavedCompositions", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
      var savedCompositions, themeCompositions;
      return _regeneratorRuntime().wrap(function _callee71$(_context72) {
        while (1) switch (_context72.prev = _context72.next) {
          case 0:
            _context72.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "compositiondocs/product/".concat(_this.zkProduct.get('modelID')), {
              params: {
                draft: true
              }
            });
          case 2:
            savedCompositions = _context72.sent.data;
            _this.savedCompositions = savedCompositions;
            if (savedCompositions) {
              themeCompositions = _this.themeCompositionsFromSavedCompositions(savedCompositions);
              _this.themeCompositions = themeCompositions;
            }
            _this.trigger('change');
          case 6:
          case "end":
            return _context72.stop();
        }
      }, _callee71);
    })));
    _defineProperty(this, "themeCompositionsFromSavedCompositions", function (compositions) {
      var themeCompositions = compositions.map(function (composition) {
        return {
          name: composition.name,
          docID: composition.docID,
          previewImageUrl: composition.previewImageUrl,
          tags: composition.tags
        };
      });
      return themeCompositions;
    });
    _defineProperty(this, "saveDraftsComposition", /*#__PURE__*/function () {
      var _ref75 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee72(name, tags, isCopy) {
        return _regeneratorRuntime().wrap(function _callee72$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _this.composition.set('name', name);
              _this.composition.set('tags', tags);
              _this.composition.set('isDraft', true);
              if (!isCopy) {
                _context73.next = 8;
                break;
              }
              _context73.next = 6;
              return _this.saveCompositionCopy();
            case 6:
              _context73.next = 10;
              break;
            case 8:
              _context73.next = 10;
              return _this.saveComposition(undefined);
            case 10:
              return _context73.abrupt("return", _this.updateSavedCompositions());
            case 11:
            case "end":
              return _context73.stop();
          }
        }, _callee72);
      }));
      return function (_x66, _x67, _x68) {
        return _ref75.apply(this, arguments);
      };
    }());
    _defineProperty(this, "deleteSavedComposition", /*#__PURE__*/function () {
      var _ref76 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee73(docId) {
        return _regeneratorRuntime().wrap(function _callee73$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi["delete"](Zakeke.config.baseApiUrl + "compositiondocs/".concat(docId));
            case 2:
              _this.updateSavedCompositions();
            case 3:
            case "end":
              return _context74.stop();
          }
        }, _callee73);
      }));
      return function (_x69) {
        return _ref76.apply(this, arguments);
      };
    }());
    _defineProperty(this, "applyTemplate", /*#__PURE__*/function () {
      var _ref77 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee74(templateGroupCompositionId) {
        var result, compositionItems, compositionItemsFromTemplate, newCompositionItems;
        return _regeneratorRuntime().wrap(function _callee74$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              _context75.prev = 0;
              _context75.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('proxycompositions/' + templateGroupCompositionId, {
                params: {
                  template: true
                }
              });
            case 3:
              _context75.next = 5;
              return _context75.sent.data;
            case 5:
              result = _context75.sent;
              compositionItems = _this.composition.get('compositionItems');
              compositionItemsFromTemplate = new MPlaza.CompositionItems(result.compositionItems);
              newCompositionItems = new MPlaza.CompositionItems();
              compositionItems.toArray().forEach(function (currentCompositionItem) {
                var templateCompositionItem = compositionItemsFromTemplate.find(function (compositionItem) {
                  return compositionItem.get('attributeID') === currentCompositionItem.get('attributeID');
                });
                newCompositionItems.add(templateCompositionItem !== null && templateCompositionItem !== void 0 ? templateCompositionItem : currentCompositionItem);
              });
              _this.composition.set('compositionItems', newCompositionItems);

              // await this.bootstrapComposition(this.composition);
              _this.selection.setupOnComposition(_this.composition);
              _context75.next = 14;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 14:
              _this.buildStructure();
              _this.updatePrice();
              _this.selection.getAllAttributeSelections().forEach(function (attributeSelection) {
                var selectionOption = attributeSelection.get('options').find(function (x) {
                  return x.get('selected');
                });

                // Change platform selection
                var platformSelection = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attributeSelection.get('attributeCode'));
                });
                if (platformSelection && selectionOption) {
                  platformSelection.optionCode = selectionOption.get('optionCode');
                  platformSelection.optionLabel = _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(selectionOption.get('name'));
                }
                console.log({
                  platformSelection: platformSelection
                });
              });
              _context75.next = 22;
              break;
            case 19:
              _context75.prev = 19;
              _context75.t0 = _context75["catch"](0);
              console.error('Error applying template: ', _context75.t0);
            case 22:
            case "end":
              return _context75.stop();
          }
        }, _callee74, null, [[0, 19]]);
      }));
      return function (_x70) {
        return _ref77.apply(this, arguments);
      };
    }());
    _defineProperty(this, "configureByAI", /*#__PURE__*/function () {
      var _ref78 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee75(text) {
        var response, _iterator11, _step11, _loop7;
        return _regeneratorRuntime().wrap(function _callee75$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              _context77.prev = 0;
              _context77.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('ai/configuration-by-prompt', {
                params: {
                  productId: _this.zkProduct.get('modelID'),
                  prompt: text
                }
              });
            case 3:
              response = _context77.sent.data;
              // Select all the options
              _iterator11 = _createForOfIteratorHelper(response);
              _context77.prev = 5;
              _loop7 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop7() {
                var option, attribute, optionToSelect;
                return _regeneratorRuntime().wrap(function _loop7$(_context76) {
                  while (1) switch (_context76.prev = _context76.next) {
                    case 0:
                      option = _step11.value;
                      attribute = _this.zkProduct.get('attributes').find(function (x) {
                        return x.get('name') == option.attributeName;
                      });
                      if (attribute) {
                        optionToSelect = attribute.get('options').find(function (x) {
                          return x.get('name') == option.optionName;
                        });
                        if (optionToSelect) {
                          _this.selectOption(optionToSelect.get('optionID'));
                        }
                      }
                    case 3:
                    case "end":
                      return _context76.stop();
                  }
                }, _loop7);
              });
              _iterator11.s();
            case 8:
              if ((_step11 = _iterator11.n()).done) {
                _context77.next = 12;
                break;
              }
              return _context77.delegateYield(_loop7(), "t0", 10);
            case 10:
              _context77.next = 8;
              break;
            case 12:
              _context77.next = 17;
              break;
            case 14:
              _context77.prev = 14;
              _context77.t1 = _context77["catch"](5);
              _iterator11.e(_context77.t1);
            case 17:
              _context77.prev = 17;
              _iterator11.f();
              return _context77.finish(17);
            case 20:
              _context77.next = 25;
              break;
            case 22:
              _context77.prev = 22;
              _context77.t2 = _context77["catch"](0);
              console.error(_context77.t2);
            case 25:
            case "end":
              return _context77.stop();
          }
        }, _callee75, null, [[0, 22], [5, 14, 17, 20]]);
      }));
      return function (_x71) {
        return _ref78.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getTryOnProvidersList", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
      var providersMapping;
      return _regeneratorRuntime().wrap(function _callee76$(_context78) {
        while (1) switch (_context78.prev = _context78.next) {
          case 0:
            if (!_this.tryOnProvidersSettings) {
              _context78.next = 2;
              break;
            }
            return _context78.abrupt("return", _this.tryOnProvidersSettings);
          case 2:
            _context78.next = 4;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.tryOnApiUrl + "tryonprovider/list");
          case 4:
            providersMapping = _context78.sent;
            return _context78.abrupt("return", _this.tryOnProvidersSettings = providersMapping.data);
          case 6:
          case "end":
            return _context78.stop();
        }
      }, _callee76);
    })));
    _defineProperty(this, "getTryOnProductInfo", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
      var _this$internalProduct;
      var productID, productInfo;
      return _regeneratorRuntime().wrap(function _callee77$(_context79) {
        while (1) switch (_context79.prev = _context79.next) {
          case 0:
            productID = (_this$internalProduct = _this.internalProduct) === null || _this$internalProduct === void 0 ? void 0 : _this$internalProduct.get('modelID');
            if (productID) {
              _context79.next = 3;
              break;
            }
            return _context79.abrupt("return", null);
          case 3:
            if (!(_this.tryOnProductSettings && _this.tryOnProductSettings.productID === productID)) {
              _context79.next = 5;
              break;
            }
            return _context79.abrupt("return", _this.tryOnProductSettings);
          case 5:
            _context79.next = 7;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.tryOnApiUrl + "tryonproduct/".concat(productID));
          case 7:
            productInfo = _context79.sent;
            _this.tryOnProductSettings = productInfo.data;
            return _context79.abrupt("return", _this.tryOnProductSettings);
          case 10:
          case "end":
            return _context79.stop();
        }
      }, _callee77);
    })));
    _defineProperty(this, "getMessagesByProductCode", /*#__PURE__*/function () {
      var _ref81 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee78(productCode) {
        var query, response, result;
        return _regeneratorRuntime().wrap(function _callee78$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              console.log('query', productCode);
              query = {
                name: 'messagesByProduct',
                query: "query getEventMessagesByProduct($productGlobalCode: String!){\n\t\t\t\t\t\t\tmessagesByProduct(productGlobalCode: $productGlobalCode){\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\teventGlobalID\n\t\t\t\t\t\t\t\tmessageId\n\t\t\t\t\t\t\t\tmessageText\n\t\t\t\t\t\t\t\teventName\n\t\t\t\t\t\t\t\teventId\n\t\t\t\t\t\t\t\tcloseable\n\t\t\t\t\t\t\t\tvisible\n\t\t\t\t\t\t\t\taddToCartDisabledValue\n\t\t\t\t\t\t\t\tenableCheckForSellerImagesValue\n\t\t\t\t\t\t\t\tenableAdditionalMessage\n\t\t\t\t\t\t\t\tadditionalMessage\n\t\t\t\t\t\t\t\teventMessageId\n\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\ttitleSingleMessage\n\t\t\t\t\t\t\t\tinfoLink\n\t\t\t\t\t\t\t\tdefaultMessage\n\t\t\t\t\t\t\t\tvisibleOnlyOnApi\n\t\t\t\t\t\t\t\taddToCartLabel\n\t\t\t\t\t\t\t\tvisibleLowQualityInfoText\n\t\t\t\t\t\t\t\tdefaultAdditionalMessageText\n\t\t\t\t\t\t\t\twarningText\n\t\t\t\t\t\t\t\tonDeleteWarningText\n\t\t\t\t\t\t\t\tisDefault\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}",
                variables: {
                  productGlobalCode: 'guid://Zakeke/Model/' + productCode
                }
              };
              _context80.next = 4;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.graphqlUrl, query);
            case 4:
              response = _context80.sent;
              result = null;
              if (response && response.data && response.data.data.messagesByProduct) {
                result = response.data.data.messagesByProduct.map(function (message) {
                  return {
                    eventID: message.eventId,
                    description: message.messageText,
                    closeable: message.closeable,
                    visible: message.visible,
                    addToCartDisabledIfVisible: message.addToCartDisabledValue,
                    additionalData: message.additionalMessage,
                    enableCheckForSellerImages: message.enableCheckForSellerImagesValue,
                    isDefault: message.isDefault
                  };
                }).map(function (message) {
                  return ___WEBPACK_IMPORTED_MODULE_2__.EventMessage.fromMessage(message);
                });
              }
              return _context80.abrupt("return", result);
            case 8:
            case "end":
              return _context80.stop();
          }
        }, _callee78);
      }));
      return function (_x72) {
        return _ref81.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getTryOnSellerInfo", /*#__PURE__*/function () {
      var _ref82 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee79(typeID, providerID) {
        var sellerInfo;
        return _regeneratorRuntime().wrap(function _callee79$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              if (_this.settings) {
                _context81.next = 2;
                break;
              }
              return _context81.abrupt("return", null);
            case 2:
              if (!_this.tryOnSellerSettings) {
                _context81.next = 4;
                break;
              }
              return _context81.abrupt("return", _this.tryOnSellerSettings);
            case 4:
              _context81.next = 6;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.tryOnApiUrl + 'tryoncustomer/' + '?typeID=' + typeID.toString() + '&providerID=' + providerID.toString());
            case 6:
              sellerInfo = _context81.sent;
              _this.tryOnSellerSettings = sellerInfo.data;
              return _context81.abrupt("return", _this.tryOnSellerSettings);
            case 9:
            case "end":
              return _context81.stop();
          }
        }, _callee79);
      }));
      return function (_x73, _x74) {
        return _ref82.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setPDDistance", function (distance) {
      _this.pdSettings = distance;
    });
    _defineProperty(this, "pdDistance", function () {
      return _this.pdSettings;
    });
    _defineProperty(this, "exportTryOnMeshToGlb", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
      var tryOnMesh;
      return _regeneratorRuntime().wrap(function _callee80$(_context82) {
        while (1) switch (_context82.prev = _context82.next) {
          case 0:
            if (_this.zkScene) {
              _context82.next = 2;
              break;
            }
            return _context82.abrupt("return", null);
          case 2:
            if (_this.viewer) {
              _context82.next = 4;
              break;
            }
            return _context82.abrupt("return", null);
          case 4:
            tryOnMesh = _this.viewer.getTryOnMeshVisible();
            if (tryOnMesh) {
              _context82.next = 7;
              break;
            }
            return _context82.abrupt("return", null);
          case 7:
            return _context82.abrupt("return", _this.viewer.exportMeshToGLBBlob(tryOnMesh.id));
          case 8:
          case "end":
            return _context82.stop();
        }
      }, _callee80);
    })));
    _defineProperty(this, "getTryOnSettings", function () {
      if (_this.zkScene) return _this.zkScene.getTryOnSettings();
      return undefined;
    });
    _defineProperty(this, "getDeepARDesktopIframeUrl", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
      var finalUrl, blob, formData, glbModel, randomString, response, data, url, settings, queryParams;
      return _regeneratorRuntime().wrap(function _callee81$(_context83) {
        while (1) switch (_context83.prev = _context83.next) {
          case 0:
            finalUrl = '';
            _context83.prev = 1;
            _context83.next = 4;
            return _this.exportTryOnMeshToGlb();
          case 4:
            blob = _context83.sent;
            formData = new FormData();
            _context83.next = 8;
            return blob.arrayBuffer();
          case 8:
            glbModel = _context83.sent;
            randomString = Math.random().toString(36).substring(7);
            formData.append('blob', new Blob([glbModel]), "model_".concat(randomString, ".glb"));
            _context83.next = 13;
            return fetch(Zakeke.config.baseApiUrl + 'tryonassetupload/asset-upload', {
              method: 'POST',
              body: formData,
              headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + window['token']
              }
            });
          case 13:
            response = _context83.sent;
            if (!response.ok) {
              _context83.next = 26;
              break;
            }
            _context83.next = 17;
            return response.json();
          case 17:
            data = _context83.sent;
            url = data; // Costruisco i parametri di query una volta caricato il modello
            settings = _this.tryOnMeshVisibleSettings || ___WEBPACK_IMPORTED_MODULE_2__.DefaultDeepARFineTuningSettings;
            console.log('settings da getDeepARUrl ', settings);
            queryParams = new URLSearchParams({
              positionX: settings.position.x.toString(),
              positionY: settings.position.y.toString(),
              positionZ: settings.position.z.toString(),
              scale: settings.scale.toString(),
              environment: settings.environment.toString()
            });
            finalUrl = "".concat(url, "&").concat(queryParams.toString(), "&isDesktopDeepARUrl=true");
            console.log('>>>>>>>>> finalUrl2', finalUrl);
            _context83.next = 27;
            break;
          case 26:
            console.error('Error uploading model', response);
          case 27:
            _context83.next = 32;
            break;
          case 29:
            _context83.prev = 29;
            _context83.t0 = _context83["catch"](1);
            console.error('Error uploading model', _context83.t0);
          case 32:
            return _context83.abrupt("return", finalUrl);
          case 33:
          case "end":
            return _context83.stop();
        }
      }, _callee81, null, [[1, 29]]);
    })));
    _defineProperty(this, "tryOnCountView", /*#__PURE__*/function () {
      var _ref85 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee82(sellerID, providerID, modeChosen) {
        return _regeneratorRuntime().wrap(function _callee82$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              _context84.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.tryOnApiUrl + 'tryoncount/view', {
                sellerID: sellerID,
                providerID: providerID,
                mode: modeChosen
              });
            case 2:
            case "end":
              return _context84.stop();
          }
        }, _callee82);
      }));
      return function (_x75, _x76, _x77) {
        return _ref85.apply(this, arguments);
      };
    }());
    /**
     * Ottiene le restrizioni sul printing method (che nel caso di un prodotto configuratore 3D c'è sempre ed è 1 solo).
     * @remarks
     * Se non ci sono restrizioni, ritorna quelle di default
     * @returns
     * Le restrizioni sul printing method o quelle di default
     */
    _defineProperty(this, "getPrintingMethodsRestrictions", function () {
      var defaultColor = {
        colorCode: '#000000',
        isDefault: true
      };
      var restrictions = {
        allowedBold: true,
        allowedItalic: true,
        allowedCurved: true,
        disableTextColors: false,
        textColors: [defaultColor],
        defaultColor: '#000000',
        isPDFPreviewEnabled: true
      };
      if (_this.zkProduct && _this.zkProduct.get('printTypes').length > 0) {
        var printType = _this.zkProduct.get('printTypes').at(0);
        var printRestrictions = printType.get('printTypeRestrictions');
        if (printRestrictions) {
          var _printRestrictions$ge, _printRestrictions$ge2, _printRestrictions$ge3, _printRestrictions$ge4, _printRestrictions$ge5, _printRestrictions$ge6, _printRestrictions$ge7, _printRestrictions$ge8;
          defaultColor = _objectSpread(_objectSpread({}, defaultColor), {}, {
            colorCode: (_printRestrictions$ge = printRestrictions.get('defaultColor')) !== null && _printRestrictions$ge !== void 0 ? _printRestrictions$ge : '#000000'
          });
          var textColors = (_printRestrictions$ge2 = printRestrictions.get('textColors')) !== null && _printRestrictions$ge2 !== void 0 ? _printRestrictions$ge2 : [];
          if (!textColors.find(function (color) {
            return color.colorCode === defaultColor.colorCode;
          })) textColors.push(defaultColor);
          restrictions = {
            allowedBold: (_printRestrictions$ge3 = printRestrictions.get('allowBold')) !== null && _printRestrictions$ge3 !== void 0 ? _printRestrictions$ge3 : true,
            allowedItalic: (_printRestrictions$ge4 = printRestrictions.get('allowItalic')) !== null && _printRestrictions$ge4 !== void 0 ? _printRestrictions$ge4 : true,
            allowedCurved: (_printRestrictions$ge5 = printRestrictions.get('curvedText')) !== null && _printRestrictions$ge5 !== void 0 ? _printRestrictions$ge5 : true,
            disableTextColors: (_printRestrictions$ge6 = printRestrictions.get('disableTextColors')) !== null && _printRestrictions$ge6 !== void 0 ? _printRestrictions$ge6 : false,
            textColors: textColors,
            defaultColor: (_printRestrictions$ge7 = printRestrictions.get('defaultColor')) !== null && _printRestrictions$ge7 !== void 0 ? _printRestrictions$ge7 : '#000000',
            isPDFPreviewEnabled: (_printRestrictions$ge8 = printRestrictions.get('canPreviewDesignsPDF')) !== null && _printRestrictions$ge8 !== void 0 ? _printRestrictions$ge8 : true
          };
        }
      }
      return restrictions;
    });
    _defineProperty(this, "setMouseWheelZoomEnabled", function (enabled) {
      _this.viewer.setMouseWheelInputEnabled(enabled);
    });
    _defineProperty(this, "setCameraPinchingZoom", function (toggle) {
      _this.viewer.setCameraPinchingZoom(toggle);
    });
    if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
      this.previewHeight = 512;
      this.previewWidth = 512;
    }
  }
  _createClass(ZakekeEnvironment, [{
    key: "internalProduct",
    get: function get() {
      return this.zkProduct;
    }
  }, {
    key: "internalScene",
    get: function get() {
      return this.zkScene;
    }
  }, {
    key: "internalCurrentTemplate",
    get: function get() {
      return this.zkCurrentTemplate;
    }
  }, {
    key: "isFullscreenMode",
    get: function get() {
      var doc = document;
      return Boolean(doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement);
    }
  }, {
    key: "userSettings",
    get: function get() {
      return this.settings;
    }
  }, {
    key: "isViewerReady",
    get: function get() {
      return !!this.viewer;
    }
  }, {
    key: "isShoppingPreview",
    get: function get() {
      return this.isViewerMode || this.platform.toLowerCase() == 'preview';
    }
  }, {
    key: "makeDAMAnalyticsView",
    value: function () {
      var _makeDAMAnalyticsView = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee83(type) {
        var _this$settings;
        var body;
        return _regeneratorRuntime().wrap(function _callee83$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              body = {
                modelCode: this.productCode || '',
                userId: ((_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : _this$settings.userID) || 0,
                eventType: type
              };
              return _context85.abrupt("return", axios__WEBPACK_IMPORTED_MODULE_12__["default"].post(Zakeke.config.damSettings.analyticsUrl, body));
            case 2:
            case "end":
              return _context85.stop();
          }
        }, _callee83, this);
      }));
      function makeDAMAnalyticsView(_x78) {
        return _makeDAMAnalyticsView.apply(this, arguments);
      }
      return makeDAMAnalyticsView;
    }()
  }, {
    key: "addHotjarScript",
    value: function addHotjarScript(siteID) {
      if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== 'preview') {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = "(function(h,o,t,j,a,r){\n                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n                    h._hjSettings={hjid:".concat(siteID, ",hjsv:6};\n                    a=o.getElementsByTagName('head')[0];\n                    r=o.createElement('script');r.async=1;\n                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n                    a.appendChild(r);\n                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }, {
    key: "addGoogleTagManagerID",
    value: function addGoogleTagManagerID(siteID) {
      if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== 'preview') {
        var head = document.querySelector('head');
        if (head) {
          head.append('<script>' + "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n\t\t\t\tnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n\t\t\t\tj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n\t\t\t\t'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n\t\t\t\t})(window,document,'script','dataLayer','".concat(siteID, "')") + '</script>');
        }
        var noscript = document.createElement('noscript');
        var iframe = document.createElement('iframe');
        iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(siteID);
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.cssText = 'display:none;visibility:hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
      }
    }
  }, {
    key: "setQuantity",
    value: function setQuantity(quantity) {
      // Adapt quantity to rules
      var quantityRule = this.zkProduct.get('quantityRule');
      if (quantityRule) {
        var min = quantityRule.get('minQuantity');
        var max = quantityRule.get('maxQuantity');
        var step = quantityRule.get('step');
        if (min && quantity < min) quantity = min;
        if (max && quantity > max) quantity = max;
        if (step) {
          quantity = Math.round(quantity / step) * step;
          if (quantity < step) quantity = step;
        }
      }
      this.quantity = quantity;
      this.trigger('change');
      this.updatePrice();
    }
  }, {
    key: "createStep",
    value: function createStep(zkStep, groupSelection) {
      var _zkStep$get,
        _zkStep$get2,
        _this2 = this;
      var step = new _models__WEBPACK_IMPORTED_MODULE_11__.Step();
      step.id = zkStep.get('stepID');
      step.guid = zkStep.get('stepGuid');
      step.name = (_zkStep$get = zkStep.get('name')) !== null && _zkStep$get !== void 0 ? _zkStep$get : '';
      step.cameraLocationID = (_zkStep$get2 = zkStep.get('cameraLocationID')) !== null && _zkStep$get2 !== void 0 ? _zkStep$get2 : null;
      step.displayOrder = zkStep.get('displayOrder');

      // The attributes in a step must have the group ID too or the group selection will be empty
      var _loop8 = function _loop8() {
        var zakekeAttribute = _this2.zkProduct.get('attributes').at(i);
        var attributeSelection = groupSelection.get('attributes').find(function (attr) {
          return attr.get('attributeID') == zakekeAttribute.get('attributeID');
        });
        if (attributeSelection && zakekeAttribute.get('stepID') == zkStep.get('stepID')) {
          var attribute = _this2.createAttributeFromSelection(attributeSelection);
          step.attributes.push(attribute);
        }
      };
      for (var i = 0; i < this.zkProduct.get('attributes').length; i++) {
        _loop8();
      }
      step.attributes.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });

      // Template groups
      var _loop9 = function _loop9() {
        var zakekeTemplateGroup = _this2.zkProduct.get('templateGroups').at(k);
        var templateGroupSelection = groupSelection.get('templateGroups').find(function (templGr) {
          return templGr.get('templateGroupID') == zakekeTemplateGroup.get('templateGroupID');
        });
        if (templateGroupSelection && zakekeTemplateGroup.get('stepID') == zkStep.get('stepID')) {
          var templateGroup = _this2.createTemplateGroupFromSelection(templateGroupSelection);
          step.templateGroups.push(templateGroup);
        }
      };
      for (var k = 0; k < this.zkProduct.get('templateGroups').length; k++) {
        _loop9();
      }
      step.templateGroups.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return step;
    }
  }, {
    key: "selectOptionsbyPrompt",
    value: function () {
      var _selectOptionsbyPrompt = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee84(prompt) {
        var _this$product4,
          _this3 = this;
        var response, _iterator12, _step12, _loop10;
        return _regeneratorRuntime().wrap(function _callee84$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              if (prompt) {
                _context87.next = 2;
                break;
              }
              throw new Error('Invalid prompt');
            case 2:
              _context87.next = 4;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + 'ai/configuration-by-prompt', {
                params: {
                  productId: (_this$product4 = this.product) === null || _this$product4 === void 0 ? void 0 : _this$product4.id
                }
              });
            case 4:
              response = _context87.sent.data;
              _iterator12 = _createForOfIteratorHelper(response);
              _context87.prev = 6;
              _loop10 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop10() {
                var _this3$groups$flatMap;
                var _step12$value, attributeName, optionName, optionId;
                return _regeneratorRuntime().wrap(function _loop10$(_context86) {
                  while (1) switch (_context86.prev = _context86.next) {
                    case 0:
                      _step12$value = _slicedToArray(_step12.value, 2), attributeName = _step12$value[0], optionName = _step12$value[1];
                      optionId = (_this3$groups$flatMap = _this3.groups.flatMap(function (x) {
                        return x.attributes;
                      }).find(function (x) {
                        return x.name === attributeName;
                      })) === null || _this3$groups$flatMap === void 0 ? void 0 : _this3$groups$flatMap.options.find(function (x) {
                        return x.name === optionName;
                      });
                      if (optionId) {
                        _this3.selectOption(optionId.id);
                      }
                    case 3:
                    case "end":
                      return _context86.stop();
                  }
                }, _loop10);
              });
              _iterator12.s();
            case 9:
              if ((_step12 = _iterator12.n()).done) {
                _context87.next = 13;
                break;
              }
              return _context87.delegateYield(_loop10(), "t0", 11);
            case 11:
              _context87.next = 9;
              break;
            case 13:
              _context87.next = 18;
              break;
            case 15:
              _context87.prev = 15;
              _context87.t1 = _context87["catch"](6);
              _iterator12.e(_context87.t1);
            case 18:
              _context87.prev = 18;
              _iterator12.f();
              return _context87.finish(18);
            case 21:
            case "end":
              return _context87.stop();
          }
        }, _callee84, this, [[6, 15, 18, 21]]);
      }));
      function selectOptionsbyPrompt(_x79) {
        return _selectOptionsbyPrompt.apply(this, arguments);
      }
      return selectOptionsbyPrompt;
    }()
  }, {
    key: "setCamera",
    value: function setCamera(cameraLocationId, onlyAngleOfView, animate) {
      this.viewer.setCameraLocation(cameraLocationId, onlyAngleOfView, animate);
      this.lastCameraLocation = cameraLocationId;
    }
  }, {
    key: "getCameraByName",
    value: function getCameraByName(name) {
      var _this$zkScene14;
      var location = (_this$zkScene14 = this.zkScene) === null || _this$zkScene14 === void 0 ? void 0 : _this$zkScene14.get('cameraLocations').find(function (x) {
        return x.get('name') == name;
      });
      return location;
    }
  }, {
    key: "setCameraLocation",
    value: function setCameraLocation(name) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var location = this.getCameraByName(name);
      if (!location) throw new Error("Camera with name ".concat(name, " does not exists."));
      this.viewer.setCameraLocation(location.get('locationID'), false, animate);
      this.lastCameraLocation = location.get('locationID');
    }
  }, {
    key: "getDesignItemsInfo",
    value: function getDesignItemsInfo() {
      var items = [];
      if (this.viewer) {
        var _this$viewer$getDesig, _this$viewer$getDesig2;
        items = (_this$viewer$getDesig = (_this$viewer$getDesig2 = this.viewer.getDesignItemsInfo()) === null || _this$viewer$getDesig2 === void 0 ? void 0 : _this$viewer$getDesig2.map(function (item) {
          return item instanceof MPlaza.ImageItemInfo ? new _models__WEBPACK_IMPORTED_MODULE_11__.ImageItem(item) : new _models__WEBPACK_IMPORTED_MODULE_11__.TextItem(item);
        })) !== null && _this$viewer$getDesig !== void 0 ? _this$viewer$getDesig : [];
      }
      return items;
    }
  }, {
    key: "isAreaVisible",
    value: function isAreaVisible(areaId) {
      // Get the mesh side
      // in this case areaId is sideId
      var meshSides = this.zkProduct.get('scenes').at(0).get('meshSides').filter(function (x) {
        return x.get('sideID') == areaId;
      });
      var _iterator13 = _createForOfIteratorHelper(meshSides),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var meshSide = _step13.value;
          var meshId = meshSide.get('meshID');
          if (meshId) {
            var mesh = this.viewer.scene.getMeshByID(meshId);
            if (mesh && mesh.isVisible) return true;
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      return false;
    }
  }, {
    key: "addItemText",
    value: function () {
      var _addItemText = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee85(settings, areaId) {
        var font;
        return _regeneratorRuntime().wrap(function _callee85$(_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              if (!this.viewer) {
                _context88.next = 12;
                break;
              }
              // First download the font
              font = this.fonts.find(function (x) {
                return x.name === settings.fontFamily;
              });
              if (!font) {
                _context88.next = 9;
                break;
              }
              _context88.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font])["catch"](function (e) {
                console.error('Error loading font', e, font);
              });
            case 5:
              this.viewer.addDesignItemText(_objectSpread(_objectSpread({}, settings), {}, {
                content: settings.text
              }), areaId, this.visibleCustomizer);
              this.renderDesign();
              _context88.next = 10;
              break;
            case 9:
              console.warn("No font found for ".concat(settings.fontFamily));
            case 10:
              _context88.next = 13;
              break;
            case 12:
              throw 'Called add item text but no viewer or viewer not ready';
            case 13:
            case "end":
              return _context88.stop();
          }
        }, _callee85, this);
      }));
      function addItemText(_x80, _x81) {
        return _addItemText.apply(this, arguments);
      }
      return addItemText;
    }()
  }, {
    key: "fullyLoadFont",
    value: function () {
      var _fullyLoadFont = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee86(font) {
        var fontFamily;
        return _regeneratorRuntime().wrap(function _callee86$(_context89) {
          while (1) switch (_context89.prev = _context89.next) {
            case 0:
              if (!(typeof font === 'string')) {
                _context89.next = 12;
                break;
              }
              fontFamily = this.fonts.find(function (x) {
                return x.name === font;
              });
              if (!fontFamily) {
                _context89.next = 9;
                break;
              }
              if (fontFamily.fullLoaded) {
                _context89.next = 6;
                break;
              }
              _context89.next = 6;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([fontFamily]);
            case 6:
              return _context89.abrupt("return", fontFamily);
            case 9:
              return _context89.abrupt("return", this.fonts[0]);
            case 10:
              _context89.next = 16;
              break;
            case 12:
              if (font.fullLoaded) {
                _context89.next = 15;
                break;
              }
              _context89.next = 15;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font]);
            case 15:
              return _context89.abrupt("return", font);
            case 16:
            case "end":
              return _context89.stop();
          }
        }, _callee86, this);
      }));
      function fullyLoadFont(_x82) {
        return _fullyLoadFont.apply(this, arguments);
      }
      return fullyLoadFont;
    }()
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(meshID) {
      this.viewer.setCameraPivot(meshID);
    }
  }, {
    key: "resetCameraPivot",
    value: function resetCameraPivot() {
      this.viewer.setCameraPivot(null);
    }
  }, {
    key: "setCameraZoomEnabled",
    value: function setCameraZoomEnabled(enabled) {
      this.viewer.setCameraZoomEnabled(enabled);
    }
  }, {
    key: "setCameraByName",
    value: function setCameraByName(name, onlyAngleOfView, animate) {
      if (this.zkScene) {
        var location = this.zkScene.get('cameraLocations').find(function (x) {
          return x.get('name') == name;
        });
        if (location) this.viewer.setCameraLocation(location.get('locationID'), onlyAngleOfView, animate);
      }
    }
  }, {
    key: "findObjectByName",
    value: function findObjectByName(name) {
      if (this.viewer && this.viewer.scene) return this.viewer.scene.meshes.find(function (x) {
        return x.name == name;
      });else return null;
    }
  }, {
    key: "hightlightGroup",
    value: function hightlightGroup(groupId) {
      var _this$viewer2;
      (_this$viewer2 = this.viewer) === null || _this$viewer2 === void 0 ? void 0 : _this$viewer2.highlightGroupByID(groupId);
    }
  }, {
    key: "highlightAttribute",
    value: function highlightAttribute(attributeId) {
      var _this$viewer3;
      (_this$viewer3 = this.viewer) === null || _this$viewer3 === void 0 ? void 0 : _this$viewer3.highlightAttributeByID(attributeId);
    }
  }, {
    key: "hasVTryOnEnabled",
    get: function get() {
      if (!this.zkScene) return false;
      if (!this.tryOnSellerSettings) return false;
      if (this.tryOnSellerSettings.vtoState === ___WEBPACK_IMPORTED_MODULE_2__.SellerTryOnState.NotActive) return false;
      if (!this.tryOnProductSettings) return false;
      var settings = JSON.parse(this.tryOnProductSettings.settings);
      if (!settings.active) return false;
      if (!this.zkScene.getTryOnEnabled()) return false;
      if (!this.zkScene.getTryOnSettings()) return false;
      if (!this.zkScene.getTryOnSettings().typeSettings.active) return false;
      return true;
    }
  }, {
    key: "canUseTryOn",
    get: function get() {
      if (!this.tryOnSellerSettings) return false;
      if (this.tryOnSellerSettings.vtoState === ___WEBPACK_IMPORTED_MODULE_2__.SellerTryOnState.NotActive) return false;
      if (!this.tryOnProductSettings) return false;
      var settings = JSON.parse(this.tryOnProductSettings.settings);
      if (!settings.try_on) return false;
      if (!this.tryOnSellerSettings) return false;
      if (this.zkScene.getTryOnSettings() && this.zkScene.getTryOnSettings().typeSettings.try_on) return false;
      return true;
    }
  }, {
    key: "canUsePD",
    get: function get() {
      if (!this.tryOnSellerSettings) return false;
      if (this.tryOnSellerSettings.vtoState === ___WEBPACK_IMPORTED_MODULE_2__.SellerTryOnState.NotActive) return false;
      if (!this.tryOnProductSettings) return false;
      var settings = JSON.parse(this.tryOnProductSettings.settings);
      if (!settings.pd) return false;
      if (!this.tryOnSellerSettings) return false;
      if (this.zkScene.getTryOnSettings().typeSettings.pd) return false;
      return true;
    }
  }, {
    key: "isVisibleMeshShownForTryOn",
    get: function get() {
      var _this$viewer4;
      return (_this$viewer4 = this.viewer) === null || _this$viewer4 === void 0 ? void 0 : _this$viewer4.isTryOnMeshVisibleEnabledToShow();
    }
  }, {
    key: "isMandatoryPD",
    get: function get() {
      return this.isPupillaryDistanceMandatory;
    }
  }, {
    key: "isTryOnMeshVisible",
    get: function get() {
      var _this$viewer5;
      return ((_this$viewer5 = this.viewer) === null || _this$viewer5 === void 0 ? void 0 : _this$viewer5.getTryOnMeshVisible()) != null;
    }
  }, {
    key: "tryOnMeshVisibleSettings",
    get: function get() {
      if (this.isTryOnMeshVisible) {
        var _this$viewer7;
        try {
          var _this$viewer6;
          var finetuningData = (this === null || this === void 0 ? void 0 : (_this$viewer6 = this.viewer) === null || _this$viewer6 === void 0 ? void 0 : _this$viewer6.getDAMFineTuningData()) || undefined;
          if (finetuningData) return finetuningData;
        } catch (ex) {
          console.error('Error parsing DAM fine tuning data', ex);
        }
        var tryOnMesh = this === null || this === void 0 ? void 0 : (_this$viewer7 = this.viewer) === null || _this$viewer7 === void 0 ? void 0 : _this$viewer7.getTryOnFineTuningMeshVisible();
        if (tryOnMesh) {
          return this.viewer.getMeshFineTuningData(tryOnMesh) || undefined;
        }
      }
      return undefined;
    }
  }]);
  return ZakekeEnvironment;
}();

/***/ }),

/***/ "./src/exceptions.tsx":
/*!****************************!*\
  !*** ./src/exceptions.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Exception: () => (/* binding */ Exception),
/* harmony export */   NonSquarePixelException: () => (/* binding */ NonSquarePixelException),
/* harmony export */   ParametersParseFailException: () => (/* binding */ ParametersParseFailException),
/* harmony export */   UnsupportedPlatformException: () => (/* binding */ UnsupportedPlatformException),
/* harmony export */   UploadFailedExpection: () => (/* binding */ UploadFailedExpection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
// Exceptions
var Exception = /*#__PURE__*/_createClass(function Exception(message) {
  _classCallCheck(this, Exception);
  this.message = message;
});
var ParametersParseFailException = /*#__PURE__*/function (_Exception) {
  _inherits(ParametersParseFailException, _Exception);
  var _super = _createSuper(ParametersParseFailException);
  function ParametersParseFailException(parameter) {
    var _this;
    _classCallCheck(this, ParametersParseFailException);
    _this = _super.call(this, "Failed parsing parameters: " + parameter);
    _this.parameter = parameter;
    return _this;
  }
  return _createClass(ParametersParseFailException);
}(Exception);
var UnsupportedPlatformException = /*#__PURE__*/function (_Exception2) {
  _inherits(UnsupportedPlatformException, _Exception2);
  var _super2 = _createSuper(UnsupportedPlatformException);
  function UnsupportedPlatformException(platform) {
    var _this2;
    _classCallCheck(this, UnsupportedPlatformException);
    _this2 = _super2.call(this, "Platform " + platform.toString() + " not supported.");
    _this2.platform = platform;
    return _this2;
  }
  return _createClass(UnsupportedPlatformException);
}(Exception);
var UploadFailedExpection = /*#__PURE__*/function (_Exception3) {
  _inherits(UploadFailedExpection, _Exception3);
  var _super3 = _createSuper(UploadFailedExpection);
  function UploadFailedExpection() {
    _classCallCheck(this, UploadFailedExpection);
    return _super3.call(this, "Upload failed.");
  }
  return _createClass(UploadFailedExpection);
}(Exception);
var NonSquarePixelException = /*#__PURE__*/function (_Exception4) {
  _inherits(NonSquarePixelException, _Exception4);
  var _super4 = _createSuper(NonSquarePixelException);
  function NonSquarePixelException() {
    _classCallCheck(this, NonSquarePixelException);
    return _super4.call(this, "The image is not supported (non-square pixels)");
  }
  return _createClass(NonSquarePixelException);
}(Exception);

/***/ }),

/***/ "./src/fontsManager.ts":
/*!*****************************!*\
  !*** ./src/fontsManager.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   downloadFontsOfDesign: () => (/* binding */ downloadFontsOfDesign),
/* harmony export */   getParsedFileFromFont: () => (/* binding */ getParsedFileFromFont),
/* harmony export */   loadFonts: () => (/* binding */ loadFonts),
/* harmony export */   removeEmojisFromText: () => (/* binding */ removeEmojisFromText),
/* harmony export */   removeInvalidCharacters: () => (/* binding */ removeInvalidCharacters),
/* harmony export */   removeInvalidCharactersFromText: () => (/* binding */ removeInvalidCharactersFromText),
/* harmony export */   removeTextualEmojisFromText: () => (/* binding */ removeTextualEmojisFromText),
/* harmony export */   removeUnsupportedCharacters: () => (/* binding */ removeUnsupportedCharacters),
/* harmony export */   sanitizeString: () => (/* binding */ sanitizeString),
/* harmony export */   sanitizeText: () => (/* binding */ sanitizeText)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Download a list of font families so that are available for the browser
 *
 * @param fontFamilies List of font families to download
 * @returns A promise that resolves when all fonts are downloaded
 */
function loadFonts(_x) {
  return _loadFonts.apply(this, arguments);
}

/**
 * Downlod all fonts used in a design
 *
 * @param design Design to load fonts for
 * @param downloadedFonts A list of downloaded fonts
 */
function _loadFonts() {
  _loadFonts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(fontFamilies) {
    return _regeneratorRuntime().wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", new Promise(function (resolve, reject) {
            WebFont.load({
              timeout: 200000,
              custom: {
                families: fontFamilies.map(function (x) {
                  return x.name + (x.variations && x.variations != '' ? ':' + x.variations : '');
                }),
                urls: fontFamilies.map(function (x) {
                  return x.cssUrl;
                })
              },
              active: function () {
                var _active = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var _iterator, _step, font, promises, _iterator2, _step2, _loop, _ret;
                  return _regeneratorRuntime().wrap(function _callee$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _iterator = _createForOfIteratorHelper(fontFamilies);
                        _context3.prev = 1;
                        _iterator.s();
                      case 3:
                        if ((_step = _iterator.n()).done) {
                          _context3.next = 30;
                          break;
                        }
                        font = _step.value;
                        promises = [];
                        _iterator2 = _createForOfIteratorHelper(font.faces);
                        _context3.prev = 7;
                        _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                          var face, _iterator3, _step3, _loop2;
                          return _regeneratorRuntime().wrap(function _loop$(_context2) {
                            while (1) switch (_context2.prev = _context2.next) {
                              case 0:
                                face = _step2.value;
                                if (!face.parsedFiles) {
                                  _context2.next = 3;
                                  break;
                                }
                                return _context2.abrupt("return", "continue");
                              case 3:
                                _iterator3 = _createForOfIteratorHelper(face.filesUrls);
                                _context2.prev = 4;
                                _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                                  var faceFile;
                                  return _regeneratorRuntime().wrap(function _loop2$(_context) {
                                    while (1) switch (_context.prev = _context.next) {
                                      case 0:
                                        faceFile = _step3.value;
                                        if (faceFile.toLowerCase().endsWith('.ttf') || faceFile.toLowerCase().endsWith('.otf')) {
                                          face.parsedFiles = face.parsedFiles || [];
                                          promises.push(opentype.load(faceFile).then(function (fontFile) {
                                            face.parsedFiles.push({
                                              url: faceFile,
                                              file: fontFile
                                            });
                                          }));
                                        }
                                      case 2:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }, _loop2);
                                });
                                _iterator3.s();
                              case 7:
                                if ((_step3 = _iterator3.n()).done) {
                                  _context2.next = 11;
                                  break;
                                }
                                return _context2.delegateYield(_loop2(), "t0", 9);
                              case 9:
                                _context2.next = 7;
                                break;
                              case 11:
                                _context2.next = 16;
                                break;
                              case 13:
                                _context2.prev = 13;
                                _context2.t1 = _context2["catch"](4);
                                _iterator3.e(_context2.t1);
                              case 16:
                                _context2.prev = 16;
                                _iterator3.f();
                                return _context2.finish(16);
                              case 19:
                              case "end":
                                return _context2.stop();
                            }
                          }, _loop, null, [[4, 13, 16, 19]]);
                        });
                        _iterator2.s();
                      case 10:
                        if ((_step2 = _iterator2.n()).done) {
                          _context3.next = 17;
                          break;
                        }
                        return _context3.delegateYield(_loop(), "t0", 12);
                      case 12:
                        _ret = _context3.t0;
                        if (!(_ret === "continue")) {
                          _context3.next = 15;
                          break;
                        }
                        return _context3.abrupt("continue", 15);
                      case 15:
                        _context3.next = 10;
                        break;
                      case 17:
                        _context3.next = 22;
                        break;
                      case 19:
                        _context3.prev = 19;
                        _context3.t1 = _context3["catch"](7);
                        _iterator2.e(_context3.t1);
                      case 22:
                        _context3.prev = 22;
                        _iterator2.f();
                        return _context3.finish(22);
                      case 25:
                        _context3.next = 27;
                        return Promise.allSettled(promises);
                      case 27:
                        font.fullLoaded = true;
                      case 28:
                        _context3.next = 3;
                        break;
                      case 30:
                        _context3.next = 35;
                        break;
                      case 32:
                        _context3.prev = 32;
                        _context3.t2 = _context3["catch"](1);
                        _iterator.e(_context3.t2);
                      case 35:
                        _context3.prev = 35;
                        _iterator.f();
                        return _context3.finish(35);
                      case 38:
                        resolve();
                      case 39:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee, null, [[1, 32, 35, 38], [7, 19, 22, 25]]);
                }));
                function active() {
                  return _active.apply(this, arguments);
                }
                return active;
              }(),
              inactive: function inactive() {
                reject();
              }
            });
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee2);
  }));
  return _loadFonts.apply(this, arguments);
}
function downloadFontsOfDesign(_x2, _x3) {
  return _downloadFontsOfDesign.apply(this, arguments);
}

/**
 * Remove invalid characters from the text.
 * Invalid characters include backspace (\x08) and null (\u0000) characters.
 *
 * @param text The text to remove invalid characters from
 * @returns The text without invalid characters
 */
function _downloadFontsOfDesign() {
  _downloadFontsOfDesign = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(design, downloadedFonts) {
    var fonts, _iterator4, _step4, item, data, attributes, fontFamily, fontFamilies;
    return _regeneratorRuntime().wrap(function _callee3$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          // Get all the fonts first
          fonts = [];
          _iterator4 = _createForOfIteratorHelper(design.get('designItems').models);
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              item = _step4.value;
              data = JSON.parse(item.get('json'));
              attributes = data[1]; //Get the global font family or from the first letter (in case of curved text)
              fontFamily = attributes.fontFamily || (attributes.children && attributes.children.length > 0 && attributes.children[0].length > 1 ? attributes.children[0][1].fontFamily : null);
              if (fontFamily) fonts.push(fontFamily.replace(/"/g, ''));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          fontFamilies = fonts.map(function (fontName) {
            return downloadedFonts.find(function (fontFamily) {
              return fontFamily.name == fontName;
            }) || null;
          }).filter(function (x) {
            return x != null;
          });
          if (!(fontFamilies.length > 0)) {
            _context5.next = 7;
            break;
          }
          _context5.next = 7;
          return loadFonts(fontFamilies)["catch"](function (e) {
            console.error('Error loading fonts', e, fontFamilies);
          });
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee3);
  }));
  return _downloadFontsOfDesign.apply(this, arguments);
}
function removeInvalidCharactersFromText(text) {
  var finder = /\x08|\u0000/g;
  return text.replace(finder, '');
}
/**
 * Remove unsupported characters from the text.
 * Unsupported characters include characters that cannot be displayed or processed correctly.
 * @param face The font to check character support
 * @param text The text to remove unsupported characters from
 * @returns The text without unsupported characters
 */
function sanitizeString(face, string) {
  return removeUnsupportedCharacters(removeEmojisFromText(removeTextualEmojisFromText(removeInvalidCharactersFromText(string))), face);
}
/**
 * Remove unsupported characters from the text and return a list of removed characters.
 * Unsupported characters include characters that cannot be displayed or processed correctly.
 * @param face The font to check character support
 * @param text The text to remove unsupported characters from
 * @returns The text without unsupported characters and a list of removed characters
 */
function sanitizeText(face, text) {
  var dirtyChars = [];
  var sanitizedText = sanitizeString(face, text);
  for (var i = 0; i < text.length; i++) {
    if (text[i] !== sanitizedText[i]) {
      dirtyChars.push(text[i]);
    }
  }
  return {
    sanitizedText: sanitizedText,
    dirtyChars: dirtyChars
  };
}

/**
 * Remove invalid characters from the text based on the font file.
 * Invalid characters include whitespace or characters that are not supported by the font.
 *
 * @param text The text to remove invalid characters from
 * @param fontFile The font file used to check character support
 * @returns The text without invalid characters
 */
function removeInvalidCharacters(text, fontFile) {
  return text.split('').filter(function (_char) {
    return _char.match(/\s/) || fontFile.charToGlyph(_char).unicode;
  }).join('');
}

/**
 * Get the parsed file from a font
 *
 * @param face The font to get the parsed file from
 * @returns The parsed file
 */
function getParsedFileFromFont(face) {
  return face.parsedFiles.find(function (faceFile) {
    return faceFile.url.toLowerCase().endsWith('.ttf') || faceFile.url.toLowerCase().endsWith('.otf');
  });
}
/**
 * Remove unsupported characters from the text.
 * Unsupported characters include characters that cannot be displayed or processed correctly.
 * @param text The text to remove unsupported characters from
 * @returns The text without unsupported characters
 */
function removeUnsupportedCharacters(text, currentFont) {
  if (!text || !currentFont.parsedFiles) return text;
  var file = getParsedFileFromFont(currentFont);
  if (!file || !file.file) return text;
  return removeInvalidCharacters(text, file.file);
}
/**
 * Remove textual emojis from the text.
 * Textual emojis include emojis that are made up of multiple characters.
 * @param text The text to remove textual emojis from
 * @returns The text without textual emojis
 */
function removeTextualEmojisFromText(text) {
  // https://github.com/mathiasbynens/emoji-regex file text.js
  // Updated to Unicode v12

  var finder = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F?|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  var filteredText = text;
  (text.match(finder) || []).forEach(function (x) {
    if (!/[0-9*#]/.test(x)) filteredText = filteredText.replace(x, '');
  });
  return filteredText;
}

/**
 * Remove emojis from the text.
 * @param text The text to remove emojis from
 * @returns The text without emojis
 */
function removeEmojisFromText(text) {
  // https://github.com/mathiasbynens/emoji-regex file index.js
  // Updated to Unicode v12

  var finder = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  var filteredText = text;
  (text.match(finder) || []).forEach(function (x) {
    if (!/[0-9*#]/.test(x)) filteredText = filteredText.replace(x, '');
  });
  return filteredText;
}

/***/ }),

/***/ "./src/helpers.tsx":
/*!*************************!*\
  !*** ./src/helpers.tsx ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Browser: () => (/* binding */ Browser),
/* harmony export */   IS_ANDROID: () => (/* binding */ IS_ANDROID),
/* harmony export */   IS_AR_DEVICE_COMPLIANT: () => (/* binding */ IS_AR_DEVICE_COMPLIANT),
/* harmony export */   IS_IOS: () => (/* binding */ IS_IOS),
/* harmony export */   Pagination: () => (/* binding */ Pagination),
/* harmony export */   StringHelper: () => (/* binding */ StringHelper),
/* harmony export */   T: () => (/* binding */ T),
/* harmony export */   ascComparator: () => (/* binding */ ascComparator),
/* harmony export */   compare: () => (/* binding */ compare),
/* harmony export */   copy: () => (/* binding */ copy),
/* harmony export */   dataURLtoFile: () => (/* binding */ dataURLtoFile),
/* harmony export */   getNavigatorQueryParams: () => (/* binding */ getNavigatorQueryParams),
/* harmony export */   getPlatformSettings: () => (/* binding */ getPlatformSettings),
/* harmony export */   hex2rgb: () => (/* binding */ hex2rgb),
/* harmony export */   hslToRgb: () => (/* binding */ hslToRgb),
/* harmony export */   hsvToRgb: () => (/* binding */ hsvToRgb),
/* harmony export */   hue2rgb: () => (/* binding */ hue2rgb),
/* harmony export */   iOS: () => (/* binding */ iOS),
/* harmony export */   isPlatformCode: () => (/* binding */ isPlatformCode),
/* harmony export */   isValidJSON: () => (/* binding */ isValidJSON),
/* harmony export */   matchCodes: () => (/* binding */ matchCodes),
/* harmony export */   rgb2hex: () => (/* binding */ rgb2hex),
/* harmony export */   rgbToHsl: () => (/* binding */ rgbToHsl),
/* harmony export */   rgbToHsv: () => (/* binding */ rgbToHsv),
/* harmony export */   sanitizeTextFromUnsupportedAndEmojiCharacters: () => (/* binding */ sanitizeTextFromUnsupportedAndEmojiCharacters),
/* harmony export */   sleep: () => (/* binding */ sleep),
/* harmony export */   uuid: () => (/* binding */ uuid)
/* harmony export */ });
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var T = /*#__PURE__*/function () {
  function T() {
    _classCallCheck(this, T);
  }
  _createClass(T, null, [{
    key: "_",
    value: function _(str, domain) {
      var _this$translations;
      if ((_this$translations = this.translations) !== null && _this$translations !== void 0 && _this$translations.statics) {
        var _this$translations2;
        var keys = Array.from((_this$translations2 = this.translations) === null || _this$translations2 === void 0 ? void 0 : _this$translations2.statics.keys());
        for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
          var key = _keys[_i];
          if (key.toLowerCase() === str.toLowerCase()) return this.translations.statics.get(key);
        }
      }
      var gt = window.gt;
      return gt ? gt.dgettext(domain, str) : str;
    }
  }, {
    key: "_d",
    value: function _d(str) {
      var _this$translations3;
      var string = str;
      if ((_this$translations3 = this.translations) !== null && _this$translations3 !== void 0 && _this$translations3.dynamics) {
        var _this$translations4;
        var keys = Array.from((_this$translations4 = this.translations) === null || _this$translations4 === void 0 ? void 0 : _this$translations4.dynamics.keys());
        for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
          var key = _keys2[_i2];
          if (key.toLowerCase() === str.toLowerCase()) {
            if (this.translations.dynamics.get(key)) string = this.translations.dynamics.get(key);
          }
        }
      }
      return string;
    }
  }]);
  return T;
}();
_defineProperty(T, "translations", null);
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}
var StringHelper = /*#__PURE__*/function () {
  function StringHelper() {
    _classCallCheck(this, StringHelper);
  }
  _createClass(StringHelper, null, [{
    key: "padLeft",
    value: function padLeft(str, width, _char) {
      var newStr = str.toString();
      for (var i = 0; i < width - newStr.length; i++) newStr = _char + newStr;
      return newStr;
    }
  }, {
    key: "padRight",
    value: function padRight(str, width, _char2) {
      var newStr = str.toString();
      for (var i = 0; i < width - newStr.length; i++) newStr = newStr + _char2;
      return newStr;
    }
  }, {
    key: "format",
    value: function format(str) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return args.reduce(function (prev, current, idx) {
        return prev.replace("{".concat(idx, "}"), current);
      }, str);
    }
  }, {
    key: "camelToSnake",
    value: function camelToSnake(o) {
      var newO = {},
        origKey,
        newKey,
        value;
      if (o instanceof Array) {
        newO = [];
        for (origKey in o) {
          value = o[origKey];
          if (_typeof(value) === 'object') {
            value = StringHelper.camelToSnake(value);
          }
          newO.push(value);
        }
      } else {
        newO = {};
        for (origKey in o) {
          if (o.hasOwnProperty(origKey)) {
            newKey = origKey.replace(/\.?([A-Z]+)/g, function (x, y) {
              return '_' + y.toLowerCase();
            }).replace(/^_/, '');
            value = o[origKey];
            if (value) if (value && value instanceof Array || value !== null && value.constructor === Object) {
              value = StringHelper.camelToSnake(value);
            }
            newO[newKey] = value;
          }
        }
      }
      return newO;
    }
  }, {
    key: "pascalToCamel",
    value: function pascalToCamel(o) {
      var newO = {},
        origKey,
        newKey,
        value;
      if (o instanceof Array) {
        newO = [];
        for (origKey in o) {
          value = o[origKey];
          if (_typeof(value) === 'object') {
            value = StringHelper.pascalToCamel(value);
          }
          newO.push(value);
        }
      } else {
        newO = {};
        for (origKey in o) {
          if (o.hasOwnProperty(origKey)) {
            newKey = origKey.replace(/^([A-Z])/g, function (x, y) {
              return y.toLowerCase();
            });
            value = o[origKey];
            if (value) if (value && value instanceof Array || value !== null && value.constructor === Object) {
              value = StringHelper.pascalToCamel(value);
            }
            newO[newKey] = value;
          }
        }
      }
      return newO;
    }
  }]);
  return StringHelper;
}();
var Browser = /*#__PURE__*/function () {
  function Browser() {
    _classCallCheck(this, Browser);
  }
  _createClass(Browser, null, [{
    key: "openWindow",
    value: function openWindow(url, width, height) {
      return window.open(url, 'width=' + width + ',height=' + height + ';menubar=no,location=no,status=no,toolbar=no');
    }
  }]);
  return Browser;
}();
var Pagination = /*#__PURE__*/function () {
  function Pagination() {
    _classCallCheck(this, Pagination);
  }
  _createClass(Pagination, null, [{
    key: "nextPage",
    value: function nextPage(headerLink) {
      var matches = /.*<(.*)>; rel="next".*/.exec(headerLink);
      if (!matches) {
        return null;
      }
      return matches[1];
    }
  }]);
  return Pagination;
}();
function hex2rgb(c) {
  var c = c.substring(1); // strip #
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = rgb >> 16 & 0xff; // extract red
  var g = rgb >> 8 & 0xff; // extract green
  var b = rgb >> 0 & 0xff; // extract blue

  return {
    r: r,
    g: g,
    b: b
  };
}
function rgb2hex(r, g, b) {
  return '#' + ('0' + parseInt(r).toString(16)).slice(-2) + ('0' + parseInt(g).toString(16)).slice(-2) + ('0' + parseInt(b).toString(16)).slice(-2);
}
function rgbToHsl(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, l];
}
function hslToRgb(h, s, l) {
  var r, g, b;
  if (s == 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [r * 255, g * 255, b * 255];
}
function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function rgbToHsv(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max == 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, v];
}
function hsvToRgb(h, s, v) {
  var r, g, b;
  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v, g = t, b = p;
      break;
    case 1:
      r = q, g = v, b = p;
      break;
    case 2:
      r = p, g = v, b = t;
      break;
    case 3:
      r = p, g = q, b = v;
      break;
    case 4:
      r = t, g = p, b = v;
      break;
    case 5:
      r = v, g = p, b = q;
      break;
  }
  return [r * 255, g * 255, b * 255];
}
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
function copy(obj) {
  if (!obj) {
    return obj;
  }
  var bObject, v, k;
  bObject = Array.isArray(obj) ? [] : {};
  for (k in obj) {
    v = obj[k];
    bObject[k] = _typeof(v) === 'object' ? copy(v) : v;
  }
  return bObject;
}
function compare(_obj1, _obj2) {
  if (!_obj1 || !_obj2) {
    return false;
  }
  var obj1 = copy(_obj1);
  var obj2 = copy(_obj2);

  // Special DIS case, where the code is a object with id and other parameters.
  // We need to expand it
  try {
    var idJson1 = JSON.parse(obj1.id);
    if (_typeof(idJson1) === 'object' && idJson1.id) {
      obj1 = idJson1;
      console.log('Code is a valid json with Id for obj1, use json instead', obj1, obj2);
    }
    var idJson2 = JSON.parse(obj2.id);
    if (_typeof(idJson2) === 'object' && idJson2.id) {
      obj2 = idJson2;
      console.log('Code is a valid json with Id for obj2, use json instead', obj1, obj2);
    }
  } catch (ex) {}

  // Remove dummy property
  delete obj1.zakekePlatform;
  delete obj2.zakekePlatform;
  delete obj1.label;
  delete obj2.label;
  delete obj1.isGlobal;
  delete obj2.isGlobal;
  if (Object.keys(obj1).length != Object.keys(obj2).length) return false;
  var v, k;
  var same = true;
  for (k in obj1) {
    v = obj1[k];
    if (typeof obj2[k] === 'undefined') same = false;
    if (v != obj2[k]) same = false;

    // Check if are valid json
    if (_typeof(v) === 'object' && _typeof(obj2[k]) === 'object') {
      same = compare(v, obj2[k]);
    }
    if (isValidJSON(v) || isValidJSON(obj2[k])) {
      try {
        var a = _typeof(v) === 'object' ? v : JSON.parse(v);
        var b = _typeof(obj2[k]) === 'object' ? obj2[k] : JSON.parse(obj2[k]);
        if (_typeof(a) == 'object' && _typeof(b) == 'object') same = compare(a, b);
      } catch (_unused) {}
    }
    if (!same) break;
  }
  return same;
}
function isValidJSON(code) {
  try {
    JSON.parse(code);
    return true;
  } catch (ex) {}
  return false;
}
function isPlatformCode(code) {
  var json = null;
  try {
    json = JSON.parse(code);
    return json.zakekePlatform;
  } catch (ex) {}
  return false;
}
function matchCodes(code1, code2) {
  if (isPlatformCode(code1) && isPlatformCode(code2)) return compare(JSON.parse(code1), JSON.parse(code2));else return code1 == code2;
}
function getPlatformSettings() {
  return CURRENT_REDUX_STORE.getState().platformSettings;
}
var IS_ANDROID = /android/i.test(navigator.userAgent);
var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_AR_DEVICE_COMPLIANT = function () {
  var tempAnchor = document.createElement('a');
  return Boolean(tempAnchor.relList && tempAnchor.relList.supports && tempAnchor.relList.supports('ar'));
}();
function uuid() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}
function sleep(_x) {
  return _sleep.apply(this, arguments);
}
function _sleep() {
  _sleep = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(ms) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            return setTimeout(resolve, ms);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}
function ascComparator(getProp) {
  // map(x => x) is for converting backbone objects in normal array
  return function (a, b) {
    var propA = getProp(a);
    var propB = getProp(b);
    if (propA < propB) return -1;
    if (propB < propA) return 1;
    return 0;
  };
}
function getNavigatorQueryParams() {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);
  return params;
}
var removeUnsupportedCharacters = function removeUnsupportedCharacters(item, value, fonts) {
  if (!value) return value;
  var font = fonts.find(function (x) {
    return x.name == item.fontFamily;
  });
  console.log('item', item);
  console.log('font', font);
  if (!font || !font.faces || font.faces.length == 0) return value;
  console.log('font.faces', font.faces);
  var file = font && getParsedFileFromFont(font, item);
  console.log('file in remove...', file);
  if (!file || !file.file) return value;
  return removeInvalidCharacters(value, file.file);
};
var getSelectedFontFace = function getSelectedFontFace(font, item) {
  var weight = 0;
  var face = null;
  weight = item.fontWeight.includes('normal') ? 400 : item.fontWeight.includes('bold') ? 700 : 400;
  face = font.faces.find(function (x) {
    return x.openTypeWeight == weight.toString() && x.style.toLowerCase() == (item.fontStyle && item.fontStyle.includes('italic') ? 'italic' : 'normal');
  }) || font.faces.find(function (x) {
    return x.openTypeWeight == '400' && x.style.toLowerCase() == 'normal';
  });
  if (!face) face = font.faces[0];
  return face;
};
var getParsedFileFromFont = function getParsedFileFromFont(font, item) {
  var face = getSelectedFontFace(font, item);
  if (face) return face.parsedFiles.find(function (faceFile) {
    return (faceFile.url.toLowerCase().endsWith('.ttf') || faceFile.url.toLowerCase().endsWith('.otf')) && faceFile.file != null;
  });
  return null;
};
var removeInvalidCharacters = function removeInvalidCharacters(text, fontFile) {
  console.log('fontFile', fontFile);
  return text.split('').filter(function (_char3) {
    // Preserva i caratteri di nuova linea e ritorno a capo (bug dove rimuoveva i caratteri di nuova linea)
    if (_char3 === '\n' || _char3 === '\r') return true;
    var glyph = fontFile.charToGlyph(_char3);
    console.log('char e glyph', _char3, glyph);

    // Se il glifo non ha un codice Unicode valido, scartalo
    if (!glyph.unicode) return false;

    // Se il glifo non ha una larghezza di avanzamento, scartalo
    if (glyph.advanceWidth === 0) return false;

    // Se il glifo è completamente vuoto (senza dimensioni), scartalo
    if (glyph.xMin === 0 && glyph.xMax === 0 && glyph.yMin === 0 && glyph.yMax === 0) return false;
    return true;
  }).join('');
};
var removeEmojisFromText = function removeEmojisFromText(text) {
  // https://github.com/mathiasbynens/emoji-regex file index.js
  // Updated to Unicode v12

  var finder = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  var filteredText = text;
  (text.match(finder) || []).forEach(function (x) {
    if (!/[0-9*#]/.test(x)) filteredText = filteredText.replace(x, '');
  });
  return filteredText;
};
var removeTextualEmojisFromText = function removeTextualEmojisFromText(text) {
  // https://github.com/mathiasbynens/emoji-regex file text.js
  // Updated to Unicode v12

  var finder = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F?|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
  var filteredText = text;
  (text.match(finder) || []).forEach(function (x) {
    if (!/[0-9*#]/.test(x)) filteredText = filteredText.replace(x, '');
  });
  return filteredText;
};
var removeInvalidCharactersFromText = function removeInvalidCharactersFromText(text) {
  //\x08 is backspace character
  //\u0000 is a null character
  var finder = /\x08|\u0000/g;
  return text.replace(finder, '');
};
var sanitizeTextFromUnsupportedAndEmojiCharacters = function sanitizeTextFromUnsupportedAndEmojiCharacters(item, text, fonts) {
  return removeUnsupportedCharacters(item, removeEmojisFromText(removeTextualEmojisFromText(removeInvalidCharactersFromText(text))), fonts);
};

/***/ }),

/***/ "./src/hooks/tryonContext.ts":
/*!***********************************!*\
  !*** ./src/hooks/tryonContext.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TryOnContext: () => (/* binding */ TryOnContext),
/* harmony export */   useZakekeTryOn: () => (/* binding */ useZakekeTryOn)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/tryon/tryOnModels */ "./src/components/tryon/tryOnModels.ts");


var TryOnContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  tryon: {},
  setTryon: function setTryon(tryon) {},
  tryOnPickedMode: _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_1__.TryOnMode.TryOn,
  setTryOnPickedMode: function setTryOnPickedMode(mode) {},
  tryOnVisibility: false,
  setTryOnVisibility: function setTryOnVisibility(visibility) {}
});
var useZakekeTryOn = function useZakekeTryOn() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(TryOnContext);
  if (!value) throw new Error('Invalid Zakeke TryOn state. Ensure you have wrapped your component with the ZakekeProvider component and you are not calling useZakekeTryOn outside of it.');
  return value;
};

/***/ }),

/***/ "./src/hooks/useZakeke.ts":
/*!********************************!*\
  !*** ./src/hooks/useZakeke.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   useZakeke: () => (/* binding */ useZakeke)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
/**
 * Use Zakeke hook
 * @module useZakeke
 */




/**
 * The entry point to use all Zakeke features
 * @returns {import("../state/providerValue").Zakeke} Contains all the data and methods to control a Zakeke configuration
 */
var useZakeke = function useZakeke() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_state_provider__WEBPACK_IMPORTED_MODULE_1__.context);
  if (!value) throw new Error('Invalid Zakeke state. Ensure you have wrapped your component with the ZakekeProvider component and you are not calling useZakeke outside of it.');
  return value;
};

/***/ }),

/***/ "./src/imageUploadTask.ts":
/*!********************************!*\
  !*** ./src/imageUploadTask.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ImageUploadTask)
/* harmony export */ });
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var defaultImageTaskOptions = {
  convertEpsToSvg: false,
  convertPdfToSvg: false,
  convertAiToSvg: false,
  IsPdfWithRasterAllowed: false
};
var ImageUploadTask = /*#__PURE__*/_createClass(function ImageUploadTask(culture, token) {
  var _this = this;
  var _options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultImageTaskOptions;
  _classCallCheck(this, ImageUploadTask);
  _defineProperty(this, "upload", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, onProgress) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), _this.options, onProgress);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "addPrintingOptions", function (printingOptions) {
    var options = _this.options;
    if (!printingOptions) return;
    var _iterator = _createForOfIteratorHelper(printingOptions.toArray()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var printingOption = _step.value;
        _this.options.convertEpsToSvg = !(printingOption.get('convertEpsToSvg') === false);
        _this.options.convertPdfToSvg = !(printingOption.get('convertPdfToSvg') === false);
        _this.options.convertAiToSvg = !(printingOption.get('convertAiToSvg') === false);
        _this.options.IsPdfWithRasterAllowed = !(printingOption.get('isPdfWithRasterAllowed') === false);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    _this.options = options;
  });
  _defineProperty(this, "uploadFileChunked", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(imageFile, mimeType, fileID, options, progressCallaback) {
      var status, taskID, responseTaskImage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);
          case 2:
            status = _context2.sent;
            if (!(status === 'OK')) {
              _context2.next = 21;
              break;
            }
            _context2.next = 6;
            return _this.createImageTask(fileID, options);
          case 6:
            taskID = _context2.sent;
            if (!(taskID !== -1)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 10;
            return _this.getImageFromTask(taskID);
          case 10:
            responseTaskImage = _context2.sent;
            if (!options.IsPreview) {
              _context2.next = 16;
              break;
            }
            if (!responseTaskImage) {
              _context2.next = 14;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.previewUrls);
          case 14:
            _context2.next = 18;
            break;
          case 16:
            if (!(responseTaskImage && responseTaskImage.images)) {
              _context2.next = 18;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.images);
          case 18:
            _context2.next = 21;
            break;
          case 20:
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.UploadFailedExpection();
          case 21:
            return _context2.abrupt("return", null);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4, _x5, _x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }());
  _defineProperty(this, "resumableUpload", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(imageFile, mimeType, fileID, progressCallback) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var headersRequest = {
                'Authorization': 'Bearer ' + _this.token,
                "Accept-Language": _this.culture
              };
              var r = new Resumable({
                target: Zakeke.config.baseImagesUploadApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function generateUniqueIdentifier() {
                  return fileID;
                },
                maxFiles: 1,
                testChunks: false,
                headers: headersRequest,
                query: {
                  'resumableType': mimeType
                },
                simultaneousUploads: 3
              });

              // Adding file
              r.addFile(imageFile);

              // Event Upload handlers
              r.on('fileError', function (file, message) {
                resolve('KO');
                console.error('fileError', file, message);
              });
              r.on('error', function (message, file) {
                resolve('KO');
                console.error('error', message, file);
              });
              r.on('progress', function () {
                var percentage = r.progress() * 100;
                if (progressCallback) progressCallback(percentage);
              });
              r.on('fileAdded', function (file, event) {
                r.upload();
              });
              r.on('complete', function () {
                resolve('OK');
              });
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x8, _x9, _x10, _x11) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "createImageTask", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(fileID, options) {
      var imageTask, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            imageTask = {
              'fileID': fileID,
              'options': options
            };
            _context4.next = 3;
            return _api__WEBPACK_IMPORTED_MODULE_0__.axiosApi.post(Zakeke.config.baseImagesUploadApiUrl + "imagetasks", imageTask);
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response ? response.data.taskID : -1);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x12, _x13) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getImageFromTask", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(taskID) {
      var times, response, _response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            times = 0;
          case 1:
            _context5.prev = 1;
            _context5.next = 4;
            return _api__WEBPACK_IMPORTED_MODULE_0__.axiosApi.get(Zakeke.config.baseImagesUploadApiUrl + "imagetasks/results/" + taskID);
          case 4:
            response = _context5.sent;
            if (!(response && response.data.state === 2)) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", response.data);
          case 9:
            if (!(response && response.data.state === 3)) {
              _context5.next = 11;
              break;
            }
            return _context5.abrupt("return", null);
          case 11:
            _context5.next = 20;
            break;
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](1);
            if (!(((_response = _context5.t0.response) === null || _response === void 0 ? void 0 : _response.status) == 406)) {
              _context5.next = 19;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.NonSquarePixelException();
          case 19:
            return _context5.abrupt("return", null);
          case 20:
            times++;
            if (!(times > 100)) {
              _context5.next = 23;
              break;
            }
            return _context5.abrupt("return", null);
          case 23:
            _context5.next = 25;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 25:
            _context5.next = 1;
            break;
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 13]]);
    }));
    return function (_x14) {
      return _ref5.apply(this, arguments);
    };
  }());
  this.culture = culture;
  this.token = token;
  this.options = _options;
});


/***/ }),

/***/ "./src/index.tsx":
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Attribute: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Attribute),
/* harmony export */   AttributeOptionShapeType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.AttributeOptionShapeType),
/* harmony export */   AttributeType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.AttributeType),
/* harmony export */   Camera: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Camera),
/* harmony export */   Composition: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Composition),
/* harmony export */   CompositionItem: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.CompositionItem),
/* harmony export */   DAMViewerAnalyticsEventType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DAMViewerAnalyticsEventType),
/* harmony export */   DefaultBanubaFineTuningSettings: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DefaultBanubaFineTuningSettings),
/* harmony export */   DefaultDeepARFineTuningSettings: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DefaultDeepARFineTuningSettings),
/* harmony export */   DefaultMazingFineTuningSettings: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.DefaultMazingFineTuningSettings),
/* harmony export */   EventMessage: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.EventMessage),
/* harmony export */   EventMessageType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.EventMessageType),
/* harmony export */   ExtensionFieldDataType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ExtensionFieldDataType),
/* harmony export */   Group: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Group),
/* harmony export */   ImageItem: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ImageItem),
/* harmony export */   ItemType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ItemType),
/* harmony export */   Option: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Option),
/* harmony export */   Platform: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Platform),
/* harmony export */   PlatformPriceType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.PlatformPriceType),
/* harmony export */   PlatformSettings: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.PlatformSettings),
/* harmony export */   Product: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Product),
/* harmony export */   ProductArea: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ProductArea),
/* harmony export */   ProductQuantityRule: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ProductQuantityRule),
/* harmony export */   PupillaryDistanceBaseProviderReceivedMessage: () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderReceivedMessage),
/* harmony export */   PupillaryDistanceBaseProviderResponseMessage: () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.PupillaryDistanceBaseProviderResponseMessage),
/* harmony export */   PupillaryDistanceView: () => (/* reexport safe */ _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__.PupillaryDistanceView),
/* harmony export */   Quote: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Quote),
/* harmony export */   QuoteRule: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.QuoteRule),
/* harmony export */   SellerSettings: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.SellerSettings),
/* harmony export */   SellerTryOnState: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.SellerTryOnState),
/* harmony export */   Step: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Step),
/* harmony export */   Template: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Template),
/* harmony export */   TemplateArea: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TemplateArea),
/* harmony export */   TemplateComposition: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TemplateComposition),
/* harmony export */   TemplateConstraints: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TemplateConstraints),
/* harmony export */   TextItem: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TextItem),
/* harmony export */   ThemeCategory: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ThemeCategory),
/* harmony export */   ThemeMacroCategory: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ThemeMacroCategory),
/* harmony export */   ThemeTemplateGroup: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ThemeTemplateGroup),
/* harmony export */   TryOnBaseProviderReceivedMessage: () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderReceivedMessage),
/* harmony export */   TryOnBaseProviderResponseMessage: () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnBaseProviderResponseMessage),
/* harmony export */   TryOnContext: () => (/* reexport safe */ _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_6__.TryOnContext),
/* harmony export */   TryOnFineTuningMazingEnvironment: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnFineTuningMazingEnvironment),
/* harmony export */   TryOnMode: () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.TryOnMode),
/* harmony export */   TryOnProvider: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnProvider),
/* harmony export */   TryOnSettingsType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnSettingsType),
/* harmony export */   TryOnType: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.TryOnType),
/* harmony export */   TryOnView: () => (/* reexport safe */ _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__.TryOnView),
/* harmony export */   User: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.User),
/* harmony export */   Variant: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.Variant),
/* harmony export */   ZakekeDesigner: () => (/* reexport safe */ _components_customizer__WEBPACK_IMPORTED_MODULE_0__.ZakekeDesigner),
/* harmony export */   ZakekeEnvironment: () => (/* reexport safe */ _environment__WEBPACK_IMPORTED_MODULE_4__.ZakekeEnvironment),
/* harmony export */   ZakekeEvent: () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_7__.ZakekeEvent),
/* harmony export */   ZakekeProvider: () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_8__.ZakekeProvider),
/* harmony export */   ZakekeTryOnViewer: () => (/* reexport safe */ _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__.ZakekeTryOnViewer),
/* harmony export */   ZakekeViewer: () => (/* reexport safe */ _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__.ZakekeViewer),
/* harmony export */   context: () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_8__.context),
/* harmony export */   parseJSON: () => (/* reexport safe */ _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__.parseJSON),
/* harmony export */   useInternalState: () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_8__.useInternalState),
/* harmony export */   useZakeke: () => (/* reexport safe */ _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_5__.useZakeke),
/* harmony export */   useZakekeTryOn: () => (/* reexport safe */ _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_6__.useZakekeTryOn)
/* harmony export */ });
/* harmony import */ var _components_customizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/customizer */ "./src/components/customizer.tsx");
/* harmony import */ var _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/sceneViewer */ "./src/components/sceneViewer.tsx");
/* harmony import */ var _components_tryon_tryOnModels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/tryon/tryOnModels */ "./src/components/tryon/tryOnModels.ts");
/* harmony import */ var _components_tryon_tryOnViewer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/tryon/tryOnViewer */ "./src/components/tryon/tryOnViewer.tsx");
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environment */ "./src/environment.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _hooks_tryonContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./hooks/tryonContext */ "./src/hooks/tryonContext.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./models */ "./src/models.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./state/provider */ "./src/state/provider.tsx");











/***/ }),

/***/ "./src/integrations/Integration.ts":
/*!*****************************************!*\
  !*** ./src/integrations/Integration.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PlatformAttributeSelection: () => (/* binding */ PlatformAttributeSelection)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var PlatformAttributeSelection = /*#__PURE__*/_createClass(function PlatformAttributeSelection(attributeCode, optionCode, attributeLabel, optionLabel, attributeIsEnabled, optionIsEnabled) {
  _classCallCheck(this, PlatformAttributeSelection);
  this.attributeCode = attributeCode;
  this.optionCode = optionCode;
  this.attributeLabel = attributeLabel;
  this.optionLabel = optionLabel;
  this.attributeIsEnabled = attributeIsEnabled;
  this.optionIsEnabled = optionIsEnabled;
});

/***/ }),

/***/ "./src/integrations/generic.ts":
/*!*************************************!*\
  !*** ./src/integrations/generic.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationGeneric)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["AddToCart"] = "AddToCart";
  MessageType["Price"] = "Price";
  MessageType["Close"] = "Close";
  MessageType["SharedComposition"] = "SharedComposition";
  return MessageType;
}(MessageType || {});
var MerchantIntegrationGeneric = /*#__PURE__*/function () {
  function MerchantIntegrationGeneric() {
    var _this = this;
    _classCallCheck(this, MerchantIntegrationGeneric);
    _defineProperty(this, "callbacks", new Map());
    _defineProperty(this, "messageIds", 0);
    _defineProperty(this, "pricingCalculator", null);
    window.addEventListener('message', function (event) {
      var eventType = event.data.zakekeMessageType;
      if (eventType === MessageType.Price || eventType === MessageType.SharedComposition) {
        var messageId = event.data.messageId;
        if (!_this.callbacks.has(messageId)) {
          return;
        }
        var callback = _this.callbacks.get(messageId);
        _this.callbacks["delete"](messageId);
        callback(event.data.message);
      }
    });
  }
  _createClass(MerchantIntegrationGeneric, [{
    key: "addToCart",
    value: function addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties, shopifyNFTPrice) {
      var designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
      if (designPrice !== 0) if (quantity > 1) designPrice = designPrice / quantity;
      designPrice += shopifyNFTPrice;
      window.parent.postMessage({
        zakekeMessageType: MessageType.AddToCart,
        message: {
          composition: composition.id,
          design: design === null || design === void 0 ? void 0 : design.id,
          preview: composition.get('previewImageUrl'),
          designPrice: designPrice,
          attributes: attributes,
          designItems: designItems,
          quantity: quantity,
          additionalProperties: additionalProperties
        }
      }, '*');
    }
  }, {
    key: "getPrice",
    value: function getPrice(composition, design, model, attributes, compositionPrice, isCustomPricingConfiguratorEnabled, isCustomPricingRuleBasedEnabled, quantity) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var messageId = _this2.messageIds++;
        _this2.callbacks.set(messageId, resolve);
        console.log('Calculating price...');
        var designPrice = _this2.pricingCalculator && design ? _this2.pricingCalculator.calculate(design, quantity) : 0;
        var conditions = _this2.pricingCalculator && design ? _this2.pricingCalculator.getMatchedConditions(design, quantity, true) : [];

        // Subscription does not contain custom price
        if (!isCustomPricingRuleBasedEnabled) {
          designPrice = 0;
          conditions = [];
        }
        if (!isCustomPricingConfiguratorEnabled) compositionPrice = 0;
        console.log('Calculated Zakeke price:');
        console.log('- Composition price: ' + compositionPrice);
        if (compositionPrice !== 0) if (quantity > 1) compositionPrice = compositionPrice / quantity;
        if (designPrice !== 0) if (quantity > 1) designPrice = designPrice / quantity;
        console.log('- Design price: ' + designPrice);
        window.parent.postMessage({
          zakekeMessageType: MessageType.Price,
          messageId: messageId,
          message: {
            attributes: attributes,
            compositionPrice: compositionPrice + designPrice,
            designPrice: designPrice,
            conditions: conditions,
            quantity: quantity
          }
        }, '*');
      });
    }
  }, {
    key: "getSharedCompositionUrl",
    value: function getSharedCompositionUrl(compositionDocID) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var messageId = _this3.messageIds++;
        _this3.callbacks.set(messageId, resolve);
        window.parent.postMessage({
          zakekeMessageType: MessageType.SharedComposition,
          messageId: messageId,
          message: {
            compositionDocID: compositionDocID
          }
        }, '*');
      });
    }
  }, {
    key: "close",
    value: function close() {
      window.parent.postMessage({
        zakekeMessageType: MessageType.Close
      }, '*');
    }
  }, {
    key: "setPricingCalculator",
    value: function setPricingCalculator(pricingCalculator) {
      this.pricingCalculator = pricingCalculator;
    }
  }]);
  return MerchantIntegrationGeneric;
}();


/***/ }),

/***/ "./src/integrations/helpers.ts":
/*!*************************************!*\
  !*** ./src/integrations/helpers.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   integrationFor: () => (/* binding */ integrationFor)
/* harmony export */ });
/* harmony import */ var _preview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./preview */ "./src/integrations/preview.ts");
/* harmony import */ var _generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./generic */ "./src/integrations/generic.ts");


function integrationFor(platform) {
  return new Promise(function (resolve, reject) {
    switch (platform) {
      case "preview":
        resolve(new _preview__WEBPACK_IMPORTED_MODULE_0__["default"]());
        break;
      default:
        resolve(new _generic__WEBPACK_IMPORTED_MODULE_1__["default"]());
    }
  });
}

/***/ }),

/***/ "./src/integrations/preview.ts":
/*!*************************************!*\
  !*** ./src/integrations/preview.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationPreview)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["Close"] = "Close";
  return MessageType;
}(MessageType || {});
var MerchantIntegrationPreview = /*#__PURE__*/function () {
  function MerchantIntegrationPreview() {
    _classCallCheck(this, MerchantIntegrationPreview);
  }
  _createClass(MerchantIntegrationPreview, [{
    key: "addToCart",
    value: function addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties) {
      // Not implemented
    }
  }, {
    key: "getPrice",
    value: function getPrice(composition, design, model, attributes, compositionPrice, isCustomPricingConfiguratorEnabled, isCustomPricingRuleBasedEnabled, quantity) {
      return new Promise(function (resolve, reject) {
        resolve({
          price: isCustomPricingConfiguratorEnabled ? compositionPrice : 0,
          isOutOfStock: false
        });
      });
    }
  }, {
    key: "getSharedCompositionUrl",
    value: function getSharedCompositionUrl(compositionDocID) {
      return new Promise(function (resolve, reject) {});
    }
  }, {
    key: "setPricingCalculator",
    value: function setPricingCalculator(pricingCalculator) {
      // Not implemented
    }
  }, {
    key: "close",
    value: function close() {
      window.parent.postMessage({
        zakekeMessageType: MessageType.Close
      }, '*');
    }
  }]);
  return MerchantIntegrationPreview;
}();


/***/ }),

/***/ "./src/models.ts":
/*!***********************!*\
  !*** ./src/models.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Attribute: () => (/* binding */ Attribute),
/* harmony export */   AttributeOptionShapeType: () => (/* binding */ AttributeOptionShapeType),
/* harmony export */   AttributeType: () => (/* binding */ AttributeType),
/* harmony export */   Camera: () => (/* binding */ Camera),
/* harmony export */   Composition: () => (/* binding */ Composition),
/* harmony export */   CompositionItem: () => (/* binding */ CompositionItem),
/* harmony export */   DAMViewerAnalyticsEventType: () => (/* binding */ DAMViewerAnalyticsEventType),
/* harmony export */   DefaultBanubaFineTuningSettings: () => (/* binding */ DefaultBanubaFineTuningSettings),
/* harmony export */   DefaultDeepARFineTuningSettings: () => (/* binding */ DefaultDeepARFineTuningSettings),
/* harmony export */   DefaultMazingFineTuningSettings: () => (/* binding */ DefaultMazingFineTuningSettings),
/* harmony export */   EventMessage: () => (/* binding */ EventMessage),
/* harmony export */   EventMessageType: () => (/* binding */ EventMessageType),
/* harmony export */   ExtensionFieldDataType: () => (/* binding */ ExtensionFieldDataType),
/* harmony export */   Group: () => (/* binding */ Group),
/* harmony export */   ImageItem: () => (/* binding */ ImageItem),
/* harmony export */   ItemType: () => (/* binding */ ItemType),
/* harmony export */   Option: () => (/* binding */ Option),
/* harmony export */   Platform: () => (/* binding */ Platform),
/* harmony export */   PlatformPriceType: () => (/* binding */ PlatformPriceType),
/* harmony export */   PlatformSettings: () => (/* binding */ PlatformSettings),
/* harmony export */   Product: () => (/* binding */ Product),
/* harmony export */   ProductArea: () => (/* binding */ ProductArea),
/* harmony export */   ProductQuantityRule: () => (/* binding */ ProductQuantityRule),
/* harmony export */   Quote: () => (/* binding */ Quote),
/* harmony export */   QuoteRule: () => (/* binding */ QuoteRule),
/* harmony export */   SellerSettings: () => (/* binding */ SellerSettings),
/* harmony export */   SellerTryOnState: () => (/* binding */ SellerTryOnState),
/* harmony export */   Step: () => (/* binding */ Step),
/* harmony export */   Template: () => (/* binding */ Template),
/* harmony export */   TemplateArea: () => (/* binding */ TemplateArea),
/* harmony export */   TemplateComposition: () => (/* binding */ TemplateComposition),
/* harmony export */   TemplateConstraints: () => (/* binding */ TemplateConstraints),
/* harmony export */   TextItem: () => (/* binding */ TextItem),
/* harmony export */   ThemeCategory: () => (/* binding */ ThemeCategory),
/* harmony export */   ThemeMacroCategory: () => (/* binding */ ThemeMacroCategory),
/* harmony export */   ThemeTemplateGroup: () => (/* binding */ ThemeTemplateGroup),
/* harmony export */   TryOnFineTuningMazingEnvironment: () => (/* binding */ TryOnFineTuningMazingEnvironment),
/* harmony export */   TryOnProvider: () => (/* binding */ TryOnProvider),
/* harmony export */   TryOnSettingsType: () => (/* binding */ TryOnSettingsType),
/* harmony export */   TryOnType: () => (/* binding */ TryOnType),
/* harmony export */   User: () => (/* binding */ User),
/* harmony export */   Variant: () => (/* binding */ Variant),
/* harmony export */   ZakekeEvent: () => (/* binding */ ZakekeEvent)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }


var Platform = /*#__PURE__*/function (Platform) {
  Platform[Platform["Magento1"] = 5] = "Magento1";
  Platform[Platform["Magento2"] = 1] = "Magento2";
  Platform[Platform["Shopify"] = 3] = "Shopify";
  Platform[Platform["WooCommerce"] = 2] = "WooCommerce";
  return Platform;
}({});
var PlatformPriceType = /*#__PURE__*/function (PlatformPriceType) {
  PlatformPriceType[PlatformPriceType["Standard"] = 0] = "Standard";
  PlatformPriceType[PlatformPriceType["Inline"] = 1] = "Inline";
  return PlatformPriceType;
}({});
var User = /*#__PURE__*/_createClass(function User(id, username, name) {
  _classCallCheck(this, User);
  this.id = id;
  this.username = username;
  this.name = name;
});
var ZakekeEnvironment = /*#__PURE__*/function (ZakekeEnvironment) {
  ZakekeEnvironment[ZakekeEnvironment["Customizer"] = 1] = "Customizer";
  ZakekeEnvironment[ZakekeEnvironment["Composer"] = 2] = "Composer";
  ZakekeEnvironment[ZakekeEnvironment["Viewer"] = 3] = "Viewer";
  return ZakekeEnvironment;
}(ZakekeEnvironment || {});
var TryOnType = /*#__PURE__*/function (TryOnType) {
  TryOnType[TryOnType["NotSelected"] = 0] = "NotSelected";
  TryOnType[TryOnType["Eyewear"] = 1] = "Eyewear";
  TryOnType[TryOnType["Scarves"] = 2] = "Scarves";
  TryOnType[TryOnType["Earrings"] = 3] = "Earrings";
  TryOnType[TryOnType["Headwear"] = 4] = "Headwear";
  TryOnType[TryOnType["Necklace"] = 5] = "Necklace";
  TryOnType[TryOnType["Shoes"] = 6] = "Shoes";
  TryOnType[TryOnType["Watches"] = 7] = "Watches";
  TryOnType[TryOnType["Bracelet"] = 8] = "Bracelet";
  return TryOnType;
}({});
var SellerTryOnState = /*#__PURE__*/function (SellerTryOnState) {
  SellerTryOnState[SellerTryOnState["NotActive"] = 0] = "NotActive";
  SellerTryOnState[SellerTryOnState["Active"] = 1] = "Active";
  return SellerTryOnState;
}({});
var TryOnProvider = /*#__PURE__*/function (TryOnProvider) {
  TryOnProvider[TryOnProvider["NotSelected"] = 0] = "NotSelected";
  TryOnProvider[TryOnProvider["Mazing"] = 1] = "Mazing";
  TryOnProvider[TryOnProvider["Banuba"] = 2] = "Banuba";
  TryOnProvider[TryOnProvider["DeepAR"] = 3] = "DeepAR";
  return TryOnProvider;
}({});
var TryOnSettingsType = /*#__PURE__*/function (TryOnSettingsType) {
  TryOnSettingsType["VirtualTryOn"] = "try_on";
  TryOnSettingsType["GlassPupillaryDistanceTool"] = "pd";
  TryOnSettingsType["StyleButton"] = "styleButton";
  return TryOnSettingsType;
}({});
var TryOnFineTuningMazingEnvironment = /*#__PURE__*/function (TryOnFineTuningMazingEnvironment) {
  TryOnFineTuningMazingEnvironment["Neutral"] = "neutral.hdr";
  TryOnFineTuningMazingEnvironment["Light"] = "light.hdr";
  TryOnFineTuningMazingEnvironment["Bright"] = "bright.hdr";
  TryOnFineTuningMazingEnvironment["Studio"] = "studio.hdr";
  TryOnFineTuningMazingEnvironment["Court"] = "court.hdr";
  TryOnFineTuningMazingEnvironment["Blurred_Studio"] = "startup.hdr";
  return TryOnFineTuningMazingEnvironment;
}({});
var DefaultMazingFineTuningSettings = {
  temple: false,
  environment: TryOnFineTuningMazingEnvironment.Neutral,
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  scale: 0
};
var DefaultBanubaFineTuningSettings = {
  rotation: {
    x: 0,
    y: 0,
    z: 0
  },
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  scale: 1
};
var DefaultDeepARFineTuningSettings = {
  rotation: {
    x: 0,
    y: 0,
    z: 0
  },
  position: {
    x: 0,
    y: 0,
    z: 0
  },
  scale: 1,
  environment: 'https://filescdn.zakeke.com/cdn/3d/assets/environments/deepAR_HDRs/Warehouse-with-lights_(intermediate)_new_512.hdr'
};
var Product = /*#__PURE__*/function () {
  function Product() {
    _classCallCheck(this, Product);
    _defineProperty(this, "areas", []);
    _defineProperty(this, "quantityRule", null);
    _defineProperty(this, "quoteRule", null);
    _defineProperty(this, "environment", null);
    _defineProperty(this, "isShowSecondScreenEnabled", false);
    _defineProperty(this, "isAiConfigurationEnabled", false);
    _defineProperty(this, "isOldViewer", false);
  }
  _createClass(Product, null, [{
    key: "fromProduct",
    value: function fromProduct(zkProduct) {
      var product = new Product();
      product.id = zkProduct.id;
      product.sku = zkProduct.get('code');
      product.name = zkProduct.get('name');
      product.previewUrl = zkProduct.get('largeImageUrl');
      product.quantityRule = zkProduct.get('quantityRule') ? ProductQuantityRule.fromQuantityRule(zkProduct.get('quantityRule')) : null;
      product.areas = zkProduct.get('colors').length > 0 ? zkProduct.get('colors').at(0).get('sides').map(function (side) {
        return ProductArea.fromSide(side);
      }) : [];
      product.quoteRule = zkProduct.get('quoteRule') ? new QuoteRule(zkProduct.get('quoteRule')) : null;
      product.environment = zkProduct.get('environment');
      product.isShowSecondScreenEnabled = zkProduct.get('isShowSecondScreenEnabled');
      product.isAiConfigurationEnabled = zkProduct.get('isAiConfigurationEnabled');
      product.isOldViewer = zkProduct.get('isOldViewer');
      return product;
    }
  }]);
  return Product;
}();
var QuoteRule = /*#__PURE__*/_createClass(function QuoteRule(quoteRule) {
  _classCallCheck(this, QuoteRule);
  this.quoteRuleID = quoteRule.quoteRuleID;
  this.name = quoteRule.name;
  this.sellerID = quoteRule.sellerID;
  this.formControlsData = quoteRule.formControlsData;
  this.isValidForAllProducts = quoteRule.isValidForAllProducts;
  this.allowAddToCart = quoteRule.allowAddToCart;
  this.products = quoteRule.products;
});
var Quote = /*#__PURE__*/_createClass(function Quote() {
  _classCallCheck(this, Quote);
  _defineProperty(this, "statusID", 1);
  _defineProperty(this, "quantity", 1);
  _defineProperty(this, "modelPrice", 0);
});
var ProductArea = /*#__PURE__*/function () {
  function ProductArea() {
    _classCallCheck(this, ProductArea);
  }
  _createClass(ProductArea, null, [{
    key: "fromSide",
    value: function fromSide(modelSide) {
      var area = new ProductArea();
      area.id = modelSide.id;
      area.name = modelSide.get('name');
      area.cameraLocationID = modelSide.get('cameraLocationID');
      return area;
    }
  }]);
  return ProductArea;
}();
var ProductQuantityRule = /*#__PURE__*/function () {
  function ProductQuantityRule() {
    _classCallCheck(this, ProductQuantityRule);
    _defineProperty(this, "minQuantity", null);
    _defineProperty(this, "maxQuantity", null);
    _defineProperty(this, "step", null);
  }
  _createClass(ProductQuantityRule, null, [{
    key: "fromQuantityRule",
    value: function fromQuantityRule(quantityRule) {
      if (!quantityRule) throw 'Invalid quantity rule';
      var rule = new ProductQuantityRule();
      rule.minQuantity = quantityRule.get('minQuantity');
      rule.maxQuantity = quantityRule.get('maxQuantity');
      rule.step = quantityRule.get('step');
      return rule;
    }
  }]);
  return ProductQuantityRule;
}();
var Variant = /*#__PURE__*/_createClass(function Variant(id, sku, name, price, metadata) {
  _classCallCheck(this, Variant);
  this.id = id;
  this.sku = sku;
  this.name = name;
  this.price = price;
  this.metadata = metadata;
});
var ZakekeEvent = /*#__PURE__*/_createClass(function ZakekeEvent(event, callback) {
  _classCallCheck(this, ZakekeEvent);
  this.event = event;
  this.callback = callback;
});
var TemplateConstraints = /*#__PURE__*/_createClass(function TemplateConstraints() {
  _classCallCheck(this, TemplateConstraints);
  _defineProperty(this, "isUserImageAllowed", true);
});
var TemplateArea = /*#__PURE__*/function () {
  function TemplateArea() {
    _classCallCheck(this, TemplateArea);
    _defineProperty(this, "id", -1);
    _defineProperty(this, "uploadRestrictions", new TemplateConstraints());
    _defineProperty(this, "disableSellerImages", false);
    _defineProperty(this, "canAddImage", true);
    _defineProperty(this, "canAddText", true);
  }
  _createClass(TemplateArea, null, [{
    key: "fromTemplateArea",
    value: function fromTemplateArea(zkSide) {
      var side = new TemplateArea();
      side.id = zkSide.get('sideID');
      side.disableSellerImages = zkSide.get('disableSellerImages');
      side.canAddImage = zkSide.get('canAddImage');
      side.canAddText = zkSide.get('canAddText');
      if (zkSide.get('uploadRestrictions')) side.uploadRestrictions = lodash__WEBPACK_IMPORTED_MODULE_0___default().mergeWith(new TemplateConstraints(), zkSide.get('uploadRestrictions'), function (a, b) {
        return b != undefined ? b : a;
      });
      return side;
    }
  }]);
  return TemplateArea;
}();
var Template = /*#__PURE__*/function () {
  function Template() {
    _classCallCheck(this, Template);
    _defineProperty(this, "id", -1);
    _defineProperty(this, "name", '');
    _defineProperty(this, "areas", []);
  }
  _createClass(Template, null, [{
    key: "fromTemplate",
    value: function fromTemplate(zkTemplate) {
      var template = new Template();
      template.id = zkTemplate.get('templateDesignID');
      template.name = zkTemplate.get('name');
      template.areas = zkTemplate.get('sides').map(function (x) {
        return TemplateArea.fromTemplateArea(x);
      });
      return template;
    }
  }]);
  return Template;
}();
var ItemType = /*#__PURE__*/function (ItemType) {
  ItemType[ItemType["Text"] = 0] = "Text";
  ItemType[ItemType["Image"] = 1] = "Image";
  return ItemType;
}({});
var TextItem = /*#__PURE__*/_createClass(function TextItem(item) {
  var _item$item$data$isTem;
  _classCallCheck(this, TextItem);
  _defineProperty(this, "constraints", null);
  _defineProperty(this, "index", 0);
  this.type = ItemType.Text;
  this.areaId = item.sideID;
  this.guid = item.itemGuid;
  this.name = item.designItem.get('name');
  this.text = item.text;
  this.strokeColor = item.strokeColor;
  this.strokeWidth = item.strokeWidth;
  this.fillColor = item.fillColor;
  this.fontFamily = item.fontFamily;
  this.fontSize = item.fontSize;
  this.fontWeight = item.fontWeight;
  this.fontStyle = item.fontStyle;
  this.fontStretch = item.fontStretch;
  this.justification = item.justification;
  this.isTextOnPath = item.isTextOnPath;
  this.isTemplateElement = (_item$item$data$isTem = item.item.data.isTemplateElement) !== null && _item$item$data$isTem !== void 0 ? _item$item$data$isTem : false;
  this.constraints = item.constraints;
  this.index = item.designItem.get('index');
});
var ImageItem = /*#__PURE__*/_createClass(function ImageItem(item) {
  _classCallCheck(this, ImageItem);
  _defineProperty(this, "constraints", null);
  _defineProperty(this, "index", 0);
  this.type = ItemType.Image;
  this.imageID = item.imageID;
  this.areaId = item.sideID;
  this.guid = item.itemGuid;
  this.name = item.designItem.get('name');
  this.url = item.url;
  this.deleted = !item.visible;
  this.constraints = item.constraints;
  this.index = item.designItem.get('index');
});
var PlatformSettings = /*#__PURE__*/function () {
  function PlatformSettings() {
    _classCallCheck(this, PlatformSettings);
    _defineProperty(this, "accessKey", '');
    _defineProperty(this, "accessSecret", '');
    _defineProperty(this, "adminPath", '');
    _defineProperty(this, "apiKey", '');
    _defineProperty(this, "apiSecret", '');
    _defineProperty(this, "currencyCode", 'EUR');
    _defineProperty(this, "currencyID", undefined);
    _defineProperty(this, "definitiveUrl", '');
    _defineProperty(this, "currencySymbol", '€');
    _defineProperty(this, "ecommerceID", -1);
    _defineProperty(this, "ecommerceName", -1);
    _defineProperty(this, "hasProductsApi", false);
    _defineProperty(this, "isMarketplace", false);
    _defineProperty(this, "remoteUrl", '');
    _defineProperty(this, "username", '');
    _defineProperty(this, "password", '');
    _defineProperty(this, "canCheckIsIntegrated", false);
    _defineProperty(this, "productsApi", '');
    _defineProperty(this, "salesChannelID", -1);
  }
  _createClass(PlatformSettings, [{
    key: "platform",
    get: function get() {
      return this.ecommerceID;
    }
  }], [{
    key: "fromData",
    value: function fromData(response) {
      if (!response) throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.Exception('Cannot create platform settings from null');
      var settings = new PlatformSettings();
      lodash__WEBPACK_IMPORTED_MODULE_0___default().assign(settings, response);
      return settings;
    }
  }]);
  return PlatformSettings;
}();
_defineProperty(PlatformSettings, "Empty", new PlatformSettings()); // Ajax DTO interfaces
/**
 * Represents an image.
 */
var EventMessage = /*#__PURE__*/function () {
  function EventMessage() {
    _classCallCheck(this, EventMessage);
    _defineProperty(this, "eventID", -1);
    _defineProperty(this, "description", '');
    _defineProperty(this, "closeable", false);
    _defineProperty(this, "visible", false);
    _defineProperty(this, "addToCartDisabledIfVisible", false);
    _defineProperty(this, "enableCheckForSellerImages", false);
    _defineProperty(this, "isDefault", false);
  }
  _createClass(EventMessage, null, [{
    key: "fromMessage",
    value: function fromMessage(message) {
      var eventMessage = new EventMessage();
      eventMessage.eventID = message.eventID;
      eventMessage.description = message.description;
      eventMessage.closeable = message.closeable;
      eventMessage.visible = message.visible;
      eventMessage.addToCartDisabledIfVisible = message.addToCartDisabledIfVisible;
      eventMessage.additionalData = message.additionalData !== '' && message.additionalData !== null ? JSON.parse(message.additionalData) : '';
      eventMessage.enableCheckForSellerImages = message.enableCheckForSellerImages;
      eventMessage.isDefault = message.isDefault;
      return eventMessage;
    }
  }]);
  return EventMessage;
}();
var EventMessageType = /*#__PURE__*/function (EventMessageType) {
  EventMessageType[EventMessageType["Undefined"] = -1] = "Undefined";
  EventMessageType[EventMessageType["ImageQualityWarning"] = 1] = "ImageQualityWarning";
  EventMessageType[EventMessageType["Welcome"] = 3] = "Welcome";
  EventMessageType[EventMessageType["AddToCart"] = 4] = "AddToCart";
  EventMessageType[EventMessageType["Copyright"] = 8] = "Copyright";
  return EventMessageType;
}({});
var Camera = /*#__PURE__*/function () {
  function Camera() {
    _classCallCheck(this, Camera);
    _defineProperty(this, "id", '');
    _defineProperty(this, "name", '');
  }
  _createClass(Camera, null, [{
    key: "fromZkCamera",
    value: function fromZkCamera(zkCamera) {
      var camera = new Camera();
      camera.id = zkCamera.get('locationID');
      camera.name = zkCamera.get('name');
      return camera;
    }
  }]);
  return Camera;
}();
var Group = /*#__PURE__*/_createClass(function Group() {
  _classCallCheck(this, Group);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "name", 'Group');
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "imageUrl", null);
  _defineProperty(this, "icon", null);
  _defineProperty(this, "attributes", []);
  _defineProperty(this, "steps", []);
  _defineProperty(this, "templateGroups", []);
  _defineProperty(this, "cameraLocationId", null);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "direction", 0);
  _defineProperty(this, "attributesAlwaysOpened", false);
});
var Step = /*#__PURE__*/_createClass(function Step() {
  _classCallCheck(this, Step);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "name", 'Step');
  _defineProperty(this, "cameraLocationID", null);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "attributes", []);
  _defineProperty(this, "templateGroups", []);
});
var AttributeType = /*#__PURE__*/function (AttributeType) {
  AttributeType[AttributeType["Select"] = 0] = "Select";
  AttributeType[AttributeType["Input"] = 1] = "Input";
  AttributeType[AttributeType["Colorpicker"] = 2] = "Colorpicker";
  return AttributeType;
}({});
var AttributeOptionShapeType = /*#__PURE__*/function (AttributeOptionShapeType) {
  AttributeOptionShapeType[AttributeOptionShapeType["Round"] = 1] = "Round";
  AttributeOptionShapeType[AttributeOptionShapeType["Square"] = 2] = "Square";
  return AttributeOptionShapeType;
}({});
var Attribute = /*#__PURE__*/_createClass(function Attribute() {
  _classCallCheck(this, Attribute);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "code", '');
  _defineProperty(this, "name", 'Attribute');
  _defineProperty(this, "description", '');
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "imageUrl", null);
  _defineProperty(this, "groupId", -1);
  _defineProperty(this, "stepId", -1);
  _defineProperty(this, "options", []);
  _defineProperty(this, "value", null);
  _defineProperty(this, "numberFormat", '');
  _defineProperty(this, "type", AttributeType.Select);
  _defineProperty(this, "optionShapeType", AttributeOptionShapeType.Round);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "hideOptionsLabel", false);
  _defineProperty(this, "cameraLocationId", null);
});
var Option = /*#__PURE__*/_createClass(function Option() {
  _classCallCheck(this, Option);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "guid", '');
  _defineProperty(this, "code", '');
  _defineProperty(this, "name", 'Option');
  _defineProperty(this, "description", '');
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "selected", false);
  _defineProperty(this, "imageUrl", null);
  _defineProperty(this, "displayOrder", 1);
  _defineProperty(this, "pricings", []);
});
var TemplateComposition = /*#__PURE__*/_createClass(function TemplateComposition() {
  _classCallCheck(this, TemplateComposition);
  _defineProperty(this, "compositionID", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "previewImageUrl", '');
});
var ThemeCategory = /*#__PURE__*/_createClass(function ThemeCategory() {
  _classCallCheck(this, ThemeCategory);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "composition", []);
});
var ThemeMacroCategory = /*#__PURE__*/_createClass(function ThemeMacroCategory() {
  _classCallCheck(this, ThemeMacroCategory);
  _defineProperty(this, "id", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "category", []);
});
var ThemeTemplateGroup = /*#__PURE__*/_createClass(function ThemeTemplateGroup() {
  _classCallCheck(this, ThemeTemplateGroup);
  _defineProperty(this, "templateGroupID", -1);
  _defineProperty(this, "name", '');
  _defineProperty(this, "groupID", -1);
  _defineProperty(this, "stepID", -1);
  _defineProperty(this, "displayOrder", -1);
  _defineProperty(this, "macroCategory", []);
});
var SellerSettings = /*#__PURE__*/function () {
  function SellerSettings() {
    _classCallCheck(this, SellerSettings);
    _defineProperty(this, "customizeButtonLabel", '');
    _defineProperty(this, "customizeButtonIconUrl", '');
    _defineProperty(this, "isCompositionRecapEnabled", false);
    _defineProperty(this, "isCompositionRecapVisibleFromStart", false);
    _defineProperty(this, "canUserCloseCompositionRecap", true);
    _defineProperty(this, "minimumFractionDigits", 1);
    _defineProperty(this, "priceInfoText", '');
    _defineProperty(this, "hidePrice", false);
    _defineProperty(this, "hotjarSiteID", null);
    _defineProperty(this, "googleTagManagerID", null);
    _defineProperty(this, "canSaveDraftComposition", false);
    _defineProperty(this, "canUndoRedo", false);
    _defineProperty(this, "shareType", null);
  }
  _createClass(SellerSettings, null, [{
    key: "fromSellerSettings",
    value: function fromSellerSettings(zkSellerSettings) {
      var sellerSettings = new SellerSettings();
      sellerSettings.customizeButtonLabel = zkSellerSettings.customizeButtonLabel;
      sellerSettings.customizeButtonIconUrl = zkSellerSettings.customizeButtonIconUrl;
      sellerSettings.isCompositionRecapEnabled = zkSellerSettings.isCompositionRecapEnabled;
      sellerSettings.isCompositionRecapVisibleFromStart = zkSellerSettings.isCompositionRecapVisibleFromStart;
      sellerSettings.canUserCloseCompositionRecap = zkSellerSettings.canUserCloseCompositionRecap;
      sellerSettings.minimumFractionDigits = zkSellerSettings.minimumFractionDigits;
      sellerSettings.priceInfoText = zkSellerSettings.priceInfoText;
      sellerSettings.hidePrice = zkSellerSettings.hidePrice;
      sellerSettings.hotjarSiteID = zkSellerSettings.hotjarSiteID;
      sellerSettings.googleTagManagerID = zkSellerSettings.googleTagManagerID;
      sellerSettings.canSaveDraftComposition = zkSellerSettings.canSaveDraftComposition;
      sellerSettings.canUndoRedo = zkSellerSettings.canUndoRedo;
      sellerSettings.shareType = zkSellerSettings.shareType;
      return sellerSettings;
    }
  }]);
  return SellerSettings;
}();
var CompositionItem = /*#__PURE__*/_createClass(function CompositionItem() {
  _classCallCheck(this, CompositionItem);
  _defineProperty(this, "attributeID", -1);
  _defineProperty(this, "attributeName", '');
  _defineProperty(this, "attributeCode", '');
  _defineProperty(this, "selectedOptionName", '');
  _defineProperty(this, "selectedOptionCode", '');
});
var Composition = /*#__PURE__*/function () {
  function Composition() {
    _classCallCheck(this, Composition);
    _defineProperty(this, "name", '');
    _defineProperty(this, "docID", '');
    _defineProperty(this, "compositionID", -1);
    _defineProperty(this, "compositionItems", []);
    _defineProperty(this, "previewImageUrl", '');
    _defineProperty(this, "designID", null);
    _defineProperty(this, "pdSettings", null);
    _defineProperty(this, "tags", []);
  }
  _createClass(Composition, null, [{
    key: "fromJSON",
    value: function fromJSON(json) {
      var composition = new Composition();
      lodash__WEBPACK_IMPORTED_MODULE_0___default().assign(composition, json);
      return composition;
    }
  }]);
  return Composition;
}();
var ExtensionFieldDataType = /*#__PURE__*/function (ExtensionFieldDataType) {
  ExtensionFieldDataType[ExtensionFieldDataType["Money"] = 1] = "Money";
  ExtensionFieldDataType[ExtensionFieldDataType["Integer"] = 2] = "Integer";
  ExtensionFieldDataType[ExtensionFieldDataType["Decimal"] = 3] = "Decimal";
  return ExtensionFieldDataType;
}({});

/**
 * Represents internal translations.
 */

/**
 * Represents translations.
 */

/**
 * Represents a static translation.
 */

/**
 * Represents a dynamic translation.
 */

/**
 * Represents a color restriction.
 */

/**
 * Represents custom preview size.
 */

/**
 * Represents draft compositions.
 */

/**
 @internal
 */

/**
 * Represents information about the current composition.
 */

/**
 * Represents a template category.
 */

/**
 * Represents a template macro category.
 */

/**
 @internal
 */

/**
 @internal
 */

/**
 * Represents the boot parameters for the Zakeke Configurator.
 */

var DAMViewerAnalyticsEventType = /*#__PURE__*/function (DAMViewerAnalyticsEventType) {
  DAMViewerAnalyticsEventType["ViewProduct"] = "VIEW_PRODUCT";
  DAMViewerAnalyticsEventType["ViewArProdutc"] = "VIEW_AR_PRODUCT";
  return DAMViewerAnalyticsEventType;
}({});

/***/ }),

/***/ "./src/state/boot.tsx":
/*!****************************!*\
  !*** ./src/state/boot.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .. */ "./src/index.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



// Handle boot when provider is ready
var Boot = function Boot(_ref) {
  var parameters = _ref.parameters,
    children = _ref.children;
  var internalState = (0,___WEBPACK_IMPORTED_MODULE_2__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(internalState);
  stateRef.current = internalState;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_1___default().useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    booted = _React$useState2[0],
    setBooted = _React$useState2[1];
  var boot = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(parameters) {
      var _stateRef$current, _stateRef$current2, _stateRef$current4, _stateRef$current6, _stateRef$current8, _stateRef$current9;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            (_stateRef$current = stateRef.current) === null || _stateRef$current === void 0 ? void 0 : _stateRef$current.dispatch({
              type: 'IS_SCENE_LOADING',
              isLoading: true
            });

            // Register to environment changes
            (_stateRef$current2 = stateRef.current) === null || _stateRef$current2 === void 0 ? void 0 : _stateRef$current2.state.environment.on('change', function () {
              var _stateRef$current3;
              return (_stateRef$current3 = stateRef.current) === null || _stateRef$current3 === void 0 ? void 0 : _stateRef$current3.dispatch({
                type: 'UPDATE'
              });
            });
            (_stateRef$current4 = stateRef.current) === null || _stateRef$current4 === void 0 ? void 0 : _stateRef$current4.state.environment.on('debugMode', function () {
              var _stateRef$current5;
              return (_stateRef$current5 = stateRef.current) === null || _stateRef$current5 === void 0 ? void 0 : _stateRef$current5.dispatch({
                type: 'DEBUG_MODE'
              });
            });
            (_stateRef$current6 = stateRef.current) === null || _stateRef$current6 === void 0 ? void 0 : _stateRef$current6.state.environment.on('viewer', function (v) {
              var _stateRef$current7;
              return (_stateRef$current7 = stateRef.current) === null || _stateRef$current7 === void 0 ? void 0 : _stateRef$current7.dispatch({
                type: 'VIEWER',
                value: v
              });
            });
            _context.next = 6;
            return (_stateRef$current8 = stateRef.current) === null || _stateRef$current8 === void 0 ? void 0 : _stateRef$current8.state.environment.boot(parameters);
          case 6:
            (_stateRef$current9 = stateRef.current) === null || _stateRef$current9 === void 0 ? void 0 : _stateRef$current9.dispatch({
              type: 'IS_SCENE_LOADING',
              isLoading: false
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var handleMessageReceived = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var _stateRef$current10;
      var _stateRef$current11;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (e.data.type == 'load' && !((_stateRef$current10 = stateRef.current) !== null && _stateRef$current10 !== void 0 && _stateRef$current10.state.parametersReceived)) {
              (_stateRef$current11 = stateRef.current) === null || _stateRef$current11 === void 0 ? void 0 : _stateRef$current11.dispatch({
                type: 'PARAMETERS_RECEIVED'
              });
              boot(e.data.parameters);
              window.parent.postMessage({
                zakekeType: 'loaded',
                message: {
                  integrationVersion: 2
                }
              }, '*');
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var query = qs__WEBPACK_IMPORTED_MODULE_0___default().parse(window.location.search);
    if (parameters) {
      console.log('Loading parameters from boot parameters prop...');
      boot(parameters);
    } else if (query && query.ecommerce && query.ecommerce == 'preview') {
      console.log('Loading parameters from query string...');
      boot(null);
    } else {
      console.log('Loading parameters from post message...');
      window.addEventListener('message', handleMessageReceived);
    }
    return function () {
      return window.removeEventListener('message', handleMessageReceived);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Boot);

/***/ }),

/***/ "./src/state/createProviderValue.ts":
/*!******************************************!*\
  !*** ./src/state/createProviderValue.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createProviderValue: () => (/* binding */ createProviderValue)
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var createProviderValue = function createProviderValue(state, dispatch) {
  if (!state.environment) throw new Error('Invalid Zakeke environment.');
  return {
    userSettings: state.environment.userSettings,
    price: state.environment.price,
    isOutOfStock: state.environment.isOutOfStock,
    currency: state.environment.currency,
    culture: state.environment.culture,
    quantity: state.environment.quantity,
    quantityRule: state.environment.quantityRule,
    internalProduct: state.environment.internalProduct,
    internalScene: state.environment.internalScene,
    internalCurrentTemplate: state.environment.internalCurrentTemplate,
    draftCompositions: state.environment.themeCompositions,
    currentAttributesSelection: state.environment.currentAttributesSelection,
    isSceneLoading: state.isSceneLoading,
    isAddToCartLoading: state.isAddToCartLoading,
    isInfoPointContentVisible: state.environment.isInfoPointContentVisible,
    fonts: state.environment.fonts,
    disableTextColors: state.environment.disableTextColors,
    defaultColor: state.environment.defaultColor,
    textColors: state.environment.textColors,
    groups: state.environment.groups,
    templates: state.environment.templates,
    loadedComposition: state.environment.loadedComposition,
    currentTemplate: state.environment.currentTemplate,
    isViewerReady: state.environment.isViewerReady,
    translations: state.environment.translations,
    items: state.environment.getDesignItemsInfo(),
    productName: state.environment.productName,
    productCode: state.environment.productCode,
    product: state.environment.product,
    cameras: state.environment.cameras,
    sellerSettings: state.environment.sellerSettings,
    eventMessages: state.environment.eventMessages,
    personalizedMessages: state.environment.personalizedMessages,
    visibleEventMessages: state.environment.visibleEventMessages,
    isAssetsLoading: state.environment.isAssetsLoading,
    additionalCustomProperties: state.environment.additionalCustomProperties,
    currentCompositionInfo: state.environment.currentCompositionInfo,
    nftSettings: state.environment.nftSettings,
    isAIEnabled: state.environment.isAIEnabled,
    useLegacyScreenshot: state.environment.useLegacyScreenshot,
    uiConfig: state.environment.uiConfig,
    animationsConfig: state.environment.animationsConfig,
    backgroundColor: state.environment.backgroundColor || '#f2f2f2',
    removeBackground: state.environment.removeBackground,
    deepARsceneGLBUrl: state.environment.deepARsceneGLBUrl,
    setMouseWheelZoomEnabled: state.environment.setMouseWheelZoomEnabled.bind(state.environment),
    setCameraPinchingZoom: state.environment.setCameraPinchingZoom.bind(state.environment),
    saveComposition: state.environment.saveComposition,
    loadComposition: state.environment.loadComposition,
    getPDF: state.environment.getPDF.bind(state.environment),
    fullyLoadFont: state.environment.fullyLoadFont.bind(state.environment),
    sanitizeString: state.environment.sanitizeString.bind(state.environment),
    getSanitationText: state.environment.getSanitationText.bind(state.environment),
    getOnlineScreenshot: state.environment.getOnlineScreenshot.bind(state.environment),
    reset: state.environment.reset.bind(state.environment),
    undo: state.environment.undo.bind(state.environment),
    redo: state.environment.redo.bind(state.environment),
    setCamera: state.environment.setCamera.bind(state.environment),
    setCameraByName: state.environment.setCameraByName.bind(state.environment),
    setCameraZoomEnabled: state.environment.setCameraZoomEnabled.bind(state.environment),
    resetCameraPivot: state.environment.resetCameraPivot.bind(state.environment),
    setCameraPivot: state.environment.setCameraPivot.bind(state.environment),
    setQuantity: state.environment.setQuantity.bind(state.environment),
    getImages: state.environment.getImages.bind(state.environment),
    openSecondScreen: state.environment.openSecondScreen.bind(state.environment),
    getMacroCategories: state.environment.getMacroCategories.bind(state.environment),
    createQuote: state.environment.createQuote,
    previewOnly__setItemImageFromBase64: function () {
      var _previewOnly__setItemImageFromBase = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(guid, base64) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch({
                type: 'SET_ITEM_IMAGE_FROM_BASE64',
                guid: guid,
                base64: base64
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function previewOnly__setItemImageFromBase64(_x, _x2) {
        return _previewOnly__setItemImageFromBase.apply(this, arguments);
      }
      return previewOnly__setItemImageFromBase64;
    }(),
    setItemImageFromFile: state.environment.setItemImageFromFile.bind(state.environment),
    addItemImage: state.environment.addItemImage.bind(state.environment),
    createImage: state.environment.createImage.bind(state.environment),
    createImageFromUrl: state.environment.createImageFromUrl.bind(state.environment),
    setItemImage: state.environment.setItemImage.bind(state.environment),
    setItemFontFamily: state.environment.setItemFontFamily.bind(state.environment),
    setItemColor: state.environment.setItemColor.bind(state.environment),
    setItemBold: state.environment.setItemBold.bind(state.environment),
    setItemItalic: state.environment.setItemItalic.bind(state.environment),
    setItemTextOnPath: state.environment.setItemTextOnPath.bind(state.environment),
    setItemText: state.environment.setItemText.bind(state.environment),
    addItemText: state.environment.addItemText.bind(state.environment),
    removeItem: state.environment.removeItem.bind(state.environment),
    isFullscreenMode: state.environment.isFullscreenMode,
    switchFullscreen: function switchFullscreen() {
      return dispatch({
        type: 'SWITCH_FULLSCREEN'
      });
    },
    zoomIn: function zoomIn() {
      return dispatch({
        type: 'ZOOM_IN'
      });
    },
    zoomOut: function zoomOut() {
      return dispatch({
        type: 'ZOOM_OUT'
      });
    },
    setHighlightSettings: function setHighlightSettings(settings) {
      return dispatch({
        type: 'SET_HIGHLIGHT_SETTINGS',
        settings: settings
      });
    },
    updateView: function updateView(adjustCamera) {
      return dispatch({
        type: 'UPDATE_VIEW',
        adjustCamera: adjustCamera
      });
    },
    hasExplodedMode: state.environment.hasExplodedMode,
    isExplodedMode: state.environment.isExplodedMode,
    setExplodedMode: function setExplodedMode(exploded) {
      return dispatch({
        type: 'SET_EXPLODED_MODE',
        exploded: exploded
      });
    },
    internalAppendViewer: function internalAppendViewer(container) {
      return dispatch({
        type: 'APPEND_VIEWER',
        container: container
      });
    },
    getPrintingMethodsRestrictions: state.environment.getPrintingMethodsRestrictions.bind(state.environment),
    designUpdate: function designUpdate() {
      return dispatch({
        type: 'DESIGN_UPDATE'
      });
    },
    selectOption: function selectOption(optionId) {
      return dispatch({
        type: 'SELECT_OPTION',
        optionId: optionId
      });
    },
    isAreaVisible: state.environment.isAreaVisible.bind(state.environment),
    setTemplate: function () {
      var _setTemplate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(templateId) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch({
                type: 'SET_TEMPLATE',
                templateId: templateId
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function setTemplate(_x3) {
        return _setTemplate.apply(this, arguments);
      }
      return setTemplate;
    }(),
    saveTemplate: state.environment.saveTemplate,
    addToCart: function () {
      var _addToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _state$environment;
        var _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                type: 'IS_ADD_TO_CART_LOADING',
                isLoading: true
              });
              _context3.next = 3;
              return (_state$environment = state.environment).addToCart.apply(_state$environment, _args3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }(),
    // save compositions
    loadSavedComposition: state.environment.loadSavedComposition,
    saveDraftsComposition: state.environment.saveDraftsComposition,
    deleteSavedComposition: state.environment.deleteSavedComposition,
    // Scene manipulation
    getMeshIDbyName: state.environment.getMeshIDbyName.bind(state.environment),
    hideMeshAndSaveState: state.environment.hideMeshAndSaveState.bind(state.environment),
    restoreMeshVisibility: state.environment.restoreMeshVisibility.bind(state.environment),
    setMeshDesignVisibility: state.environment.setMeshDesignVisibility.bind(state.environment),
    exportSceneToGlb: state.environment.exportSceneToGlb,
    // Events
    clearListeners: state.environment.clearListeners,
    addFocusAttributesListener: state.environment.addFocusAttributesListener,
    focusAttribute: state.environment.focusAttribute,
    // Highlight
    highlightGroup: state.environment.hightlightGroup.bind(state.environment),
    highlightAttribute: state.environment.highlightAttribute.bind(state.environment),
    // AR
    getQrCodeArUrl: state.environment.getQrCodeArUrl,
    getMobileArUrl: state.environment.getMobileArUrl,
    openArMobile: state.environment.openArMobile,
    isSceneArEnabled: state.environment.isSceneArEnabled,
    isArDeviceCompliant: state.environment.isArDeviceCompliant,
    IS_ANDROID: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_ANDROID,
    IS_IOS: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_IOS,
    setBackgroundColor: state.environment.setBackgroundColor.bind(state.environment),
    // TRY ON
    getTryOnUrl: state.environment.getTryOnUrl.bind(state.environment),
    isSceneTryOnEnabled: state.environment.isSceneTryOnEnabled.bind(state.environment),
    isVisibleMeshShownForTryOn: state.environment.isVisibleMeshShownForTryOn,
    hasVTryOnEnabled: state.environment.hasVTryOnEnabled,
    canUseTryOn: state.environment.canUseTryOn,
    canUsePD: state.environment.canUsePD,
    isTryOnMeshVisible: state.environment.isTryOnMeshVisible,
    isMandatoryPD: state.environment.isMandatoryPD,
    getTryOnSettings: state.environment.getTryOnSettings.bind(state.environment),
    setPDDistance: state.environment.setPDDistance.bind(state.environment),
    pdDistance: state.environment.pdDistance,
    exportTryOnMeshToGlb: state.environment.exportTryOnMeshToGlb.bind(state.environment),
    setCameraLocked: state.environment.setCameraLocked.bind(state.environment),
    getTemplateUploadRestrictictions: state.environment.getTemplateUploadRestrictictions.bind(state.environment),
    getShareCompositionUrl: state.environment.getShareCompositionUrl.bind(state.environment),
    // copyright message
    getCopyrightMessageAccepted: state.environment.getCopyrightMessageAccepted.bind(state.environment),
    setCopyrightMessageAccepted: state.environment.setCopyrightMessageAccepted.bind(state.environment),
    // nft form
    validationNFTEmail: state.environment.validationNFTEmail.bind(state.environment),
    validationNFTWalletAddress: state.environment.validationNFTWalletAddress.bind(state.environment),
    configureByAI: state.environment.configureByAI.bind(state.environment),
    templateMacroCategories: state.environment.templateMacroCategories,
    applyTemplate: state.environment.applyTemplate.bind(state.environment),
    getDeepARDesktopIframeUrl: state.environment.getDeepARDesktopIframeUrl.bind(state.environment)
  };
};

/***/ }),

/***/ "./src/state/provider.tsx":
/*!********************************!*\
  !*** ./src/state/provider.tsx ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZakekeProvider: () => (/* binding */ ZakekeProvider),
/* harmony export */   context: () => (/* binding */ context),
/* harmony export */   useInternalState: () => (/* binding */ useInternalState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _boot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./boot */ "./src/state/boot.tsx");
/* harmony import */ var _createProviderValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./createProviderValue */ "./src/state/createProviderValue.ts");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reducer */ "./src/state/reducer.ts");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);
var internalContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);

// Use zakeke hook
var useInternalState = function useInternalState() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(internalContext);
  if (!value) throw 'Corrupted Zakeke state';
  return value;
};

// ZakekeProvider
var ZakekeProvider = function ZakekeProvider(_ref) {
  var environment = _ref.environment,
    parameters = _ref.parameters,
    children = _ref.children;
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(_reducer__WEBPACK_IMPORTED_MODULE_3__.reducer, {
      environment: environment,
      sceneViewer: null,
      isAddToCartLoading: false,
      isSceneLoading: false,
      parametersReceived: false,
      isDebug: false,
      customizer: null
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];

  // Create the provider value exposed to developer
  var value = (0,_createProviderValue__WEBPACK_IMPORTED_MODULE_2__.createProviderValue)(state, dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(context.Provider, {
    value: value
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(internalContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_boot__WEBPACK_IMPORTED_MODULE_1__["default"], {
    parameters: parameters
  }, children)));
};


/***/ }),

/***/ "./src/state/reducer.ts":
/*!******************************!*\
  !*** ./src/state/reducer.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   reducer: () => (/* binding */ reducer)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

// Reducer
function reducer(prevState, action) {
  var newState = lodash__WEBPACK_IMPORTED_MODULE_0___default().clone(prevState);
  switch (action.type) {
    case 'BOOT_COMPLETED':
    case 'UPDATE':
      break;
    case 'DESIGN_UPDATE':
      newState.environment.renderDesign();
      break;
    case 'PARAMETERS_RECEIVED':
      newState.parametersReceived = true;
      break;
    case 'UPDATE_VIEW':
      newState.environment.updateView();
      break;
    case 'SWITCH_FULLSCREEN':
      newState.environment.switchFullscreen();
      break;
    case 'SELECT_OPTION':
      newState.environment.selectOption(action.optionId);
      break;
    case 'APPEND_VIEWER':
      newState.environment.appendViewer(action.container);
      break;
    case 'SET_HIGHLIGHT_SETTINGS':
      newState.environment.setHighlightSettings(action.settings);
    case 'IS_SCENE_LOADING':
      newState.isSceneLoading = action.isLoading;
      break;
    case 'IS_ADD_TO_CART_LOADING':
      newState.isAddToCartLoading = action.isLoading;
      break;
    case 'SET_TEMPLATE':
      newState.environment.setTemplate(action.templateId);
      break;
    case 'SET_ITEM_IMAGE_FROM_BASE64':
      newState.environment.setItemImageFromBase64(action.guid, action.base64);
      break;
    case 'SET_ITEM_IMAGE_FROM_FILE':
      newState.environment.setItemImageFromFile(action.guid, action.file);
      break;
    case 'ADD_ITEM_IMAGE':
      newState.environment.addItemImage(action.imageId, action.areaId);
      break;
    case 'SET_ITEM_IMAGE':
      newState.environment.setItemImage(action.guid, action.imageId);
      break;
    case 'SET_ITEM_FONT_FAMILY':
      newState.environment.setItemFontFamily(action.guid, action.fontFamily);
      break;
    case 'SET_ITEM_COLOR':
      newState.environment.setItemColor(action.guid, action.color);
      break;
    case 'SET_ITEM_BOLD':
      newState.environment.setItemBold(action.guid, action.bold);
      break;
    case 'SET_ITEM_ITALIC':
      newState.environment.setItemItalic(action.guid, action.italic);
      break;
    case 'SET_ITEM_TEXT_PATH':
      newState.environment.setItemTextOnPath(action.guid, action.areaId, action.value);
      break;
    case 'SET_ITEM_TEXT':
      newState.environment.setItemText(action.guid, action.text);
      break;
    case 'ADD_ITEM_TEXT':
      newState.environment.addItemText(action.settings, action.areaId);
      break;
    case 'REMOVE_ITEM':
      newState.environment.removeItem(action.guid);
      break;
    case 'ZOOM_IN':
      newState.environment.zoomIn();
      break;
    case 'ZOOM_OUT':
      newState.environment.zoomOut();
      break;
    case 'SET_EXPLODED_MODE':
      newState.environment.setExplodedMode(action.exploded);
      break;
    case 'DEBUG_MODE':
      console.log('Debug mode ', !newState.isDebug ? 'enabled' : 'disabled');
      newState.isDebug = !newState.isDebug;
      break;
    case 'VIEWER':
      console.log(action);
      newState.sceneViewer = action.value;
      break;
    case 'CUSTOMIZER':
      console.log(action);
      newState.customizer = action.customizer;
      newState.environment.visibleCustomizer = action.customizer;
      break;
    default:
      throw new Error("Invalid reducer action ".concat(action.type, "."));
  }
  return newState;
}

/***/ }),

/***/ "?4f7e":
/*!********************************!*\
  !*** ./util.inspect (ignored) ***!
  \********************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "styled-components":
/*!************************************!*\
  !*** external "styled-components" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.tsx");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});